export const airports = [
  {
    "iata": "UTK",
    "translations": [
      "Utirik Airport",
      "Utirik Airport",
      "Utirik Airport"
    ],
    "city": [
      "Utirik Island",
      "Utirik Island",
      "Utirik Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "OCA",
    "translations": [
      "Ocean Reef Club Airport",
      "Ocean Reef Club Airport",
      "Ocean Reef Club Airport"
    ],
    "city": [
      "Key Largo",
      "Key Largo",
      "Key Largo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CUX",
    "translations": [
      "Cuddihy Field",
      "Cuddihy Field",
      "Cuddihy Field"
    ],
    "city": [
      "Corpus Christi",
      "Corpus Christi",
      "Corpus Christi"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CSE",
    "translations": [
      "Crested Butte Airpark",
      "Crested Butte Airpark",
      "Crested Butte Airpark"
    ],
    "city": [
      "Crested Butte",
      "Crested Butte",
      "Crested Butte"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CUS",
    "translations": [
      "Columbus Airport",
      "Columbus Airport",
      "Columbus Airport"
    ],
    "city": [
      "Columbus",
      "Columbus",
      "Columbus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JCY",
    "translations": [
      "LBJ Ranch Airport",
      "LBJ Ranch Airport",
      "LBJ Ranch Airport"
    ],
    "city": [
      "Stonewall",
      "Stonewall",
      "Stonewall"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WLR",
    "translations": [
      "Loring Seaplane Base",
      "Loring Seaplane Base",
      "Loring Seaplane Base"
    ],
    "city": [
      "Loring",
      "Loring",
      "Loring"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NUP",
    "translations": [
      "Nunapitchuk Airport",
      "Nunapitchuk Airport",
      "Nunapitchuk Airport"
    ],
    "city": [
      "Nunapitchuk",
      "Nunapitchuk",
      "Nunapitchuk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PTC",
    "translations": [
      "Port Alice Seaplane Base",
      "Port Alice Seaplane Base",
      "Port Alice Seaplane Base"
    ],
    "city": [
      "Port Alice",
      "Port Alice",
      "Port Alice"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ICY",
    "translations": [
      "Icy Bay Airport",
      "Icy Bay Airport",
      "Icy Bay Airport"
    ],
    "city": [
      "Icy Bay",
      "Icy Bay",
      "Icy Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PPV",
    "translations": [
      "Port Protection Seaplane Base",
      "Port Protection Seaplane Base",
      "Port Protection Seaplane Base"
    ],
    "city": [
      "Port Protection",
      "Port Protection",
      "Port Protection"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KKK",
    "translations": [
      "Kalakaket Creek AS Airport",
      "Kalakaket Creek AS Airport",
      "Kalakaket Creek AS Airport"
    ],
    "city": [
      "Kalakaket Creek",
      "Kalakaket Creek",
      "Kalakaket Creek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MHS",
    "translations": [
      "Dunsmuir Muni-Mott Airport",
      "Dunsmuir Muni-Mott Airport",
      "Dunsmuir Muni-Mott Airport"
    ],
    "city": [
      "Dunsmuir",
      "Dunsmuir",
      "Dunsmuir"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NIR",
    "translations": [
      "Chase Field Industrial Airport",
      "Chase Field Industrial Airport",
      "Chase Field Industrial Airport"
    ],
    "city": [
      "Beeville",
      "Beeville",
      "Beeville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GCT",
    "translations": [
      "Grand Canyon Bar Ten Airstrip",
      "Grand Canyon Bar Ten Airstrip",
      "Grand Canyon Bar Ten Airstrip"
    ],
    "city": [
      "Littlefield",
      "Littlefield",
      "Littlefield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ELW",
    "translations": [
      "Ellamar Seaplane Base",
      "Ellamar Seaplane Base",
      "Ellamar Seaplane Base"
    ],
    "city": [
      "Ellamar",
      "Ellamar",
      "Ellamar"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LVD",
    "translations": [
      "Lime Village Airport",
      "Lime Village Airport",
      "Lime Village Airport"
    ],
    "city": [
      "Lime Village",
      "Lime Village",
      "Lime Village"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HGZ",
    "translations": [
      "Hog River Airport",
      "Hog River Airport",
      "Hog River Airport"
    ],
    "city": [
      "Hogatza",
      "Hogatza",
      "Hogatza"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OTN",
    "translations": [
      "Ed-Air Airport",
      "Ed-Air Airport",
      "Ed-Air Airport"
    ],
    "city": [
      "Oaktown",
      "Oaktown",
      "Oaktown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TLF",
    "translations": [
      "Telida Airport",
      "Telida Airport",
      "Telida Airport"
    ],
    "city": [
      "Telida",
      "Telida",
      "Telida"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BZT",
    "translations": [
      "Eagle Air Park",
      "Eagle Air Park",
      "Eagle Air Park"
    ],
    "city": [
      "Brazoria",
      "Brazoria",
      "Brazoria"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HBH",
    "translations": [
      "Entrance Island Seaplane Base",
      "Entrance Island Seaplane Base",
      "Entrance Island Seaplane Base"
    ],
    "city": [
      "Entrance Island",
      "Entrance Island",
      "Entrance Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FAK",
    "translations": [
      "False Island Seaplane Base",
      "False Island Seaplane Base",
      "False Island Seaplane Base"
    ],
    "city": [
      "False Island",
      "False Island",
      "False Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BYW",
    "translations": [
      "Blakely Island Airport",
      "Blakely Island Airport",
      "Blakely Island Airport"
    ],
    "city": [
      "Blakely Island",
      "Blakely Island",
      "Blakely Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DRF",
    "translations": [
      "Drift River Airport",
      "Drift River Airport",
      "Drift River Airport"
    ],
    "city": [
      "Kenai",
      "Kenai",
      "Kenai"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BDF",
    "translations": [
      "Rinkenberger Restricted Landing Area",
      "Rinkenberger Restricted Landing Area",
      "Rinkenberger Restricted Landing Area"
    ],
    "city": [
      "Bradford",
      "Bradford",
      "Bradford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TEH",
    "translations": [
      "Tetlin Airport",
      "Tetlin Airport",
      "Tetlin Airport"
    ],
    "city": [
      "Tetlin",
      "Tetlin",
      "Tetlin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VRS",
    "translations": [
      "Roy Otten Memorial Airfield",
      "Roy Otten Memorial Airfield",
      "Roy Otten Memorial Airfield"
    ],
    "city": [
      "Versailles",
      "Versailles",
      "Versailles"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GDH",
    "translations": [
      "Golden Horn Lodge Seaplane Base",
      "Golden Horn Lodge Seaplane Base",
      "Golden Horn Lodge Seaplane Base"
    ],
    "city": [
      "Golden Horn Lodge",
      "Golden Horn Lodge",
      "Golden Horn Lodge"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ATT",
    "translations": [
      "Atmautluak Airport",
      "Atmautluak Airport",
      "Atmautluak Airport"
    ],
    "city": [
      "Atmautluak",
      "Atmautluak",
      "Atmautluak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LIV",
    "translations": [
      "Livengood Camp Airport",
      "Livengood Camp Airport",
      "Livengood Camp Airport"
    ],
    "city": [
      "Livengood",
      "Livengood",
      "Livengood"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PDB",
    "translations": [
      "Pedro Bay Airport",
      "Pedro Bay Airport",
      "Pedro Bay Airport"
    ],
    "city": [
      "Pedro Bay",
      "Pedro Bay",
      "Pedro Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KOZ",
    "translations": [
      "Ouzinkie Airport",
      "Ouzinkie Airport",
      "Ouzinkie Airport"
    ],
    "city": [
      "Ouzinkie",
      "Ouzinkie",
      "Ouzinkie"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TNK",
    "translations": [
      "Tununak Airport",
      "Tununak Airport",
      "Tununak Airport"
    ],
    "city": [
      "Tununak",
      "Tununak",
      "Tununak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WHD",
    "translations": [
      "Hyder Seaplane Base",
      "Hyder Seaplane Base",
      "Hyder Seaplane Base"
    ],
    "city": [
      "Hyder",
      "Hyder",
      "Hyder"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MNT",
    "translations": [
      "Minto Al Wright Airport",
      "Minto Al Wright Airport",
      "Minto Al Wright Airport"
    ],
    "city": [
      "Minto",
      "Minto",
      "Minto"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TKI",
    "translations": [
      "Tokeen Seaplane Base",
      "Tokeen Seaplane Base",
      "Tokeen Seaplane Base"
    ],
    "city": [
      "Tokeen",
      "Tokeen",
      "Tokeen"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WKK",
    "translations": [
      "Aleknagik / New Airport",
      "Aleknagik / New Airport",
      "Aleknagik / New Airport"
    ],
    "city": [
      "Aleknagik",
      "Aleknagik",
      "Aleknagik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WFB",
    "translations": [
      "Ketchikan Harbor Seaplane Base",
      "Ketchikan Harbor Seaplane Base",
      "Ketchikan Harbor Seaplane Base"
    ],
    "city": [
      "Ketchikan",
      "Ketchikan",
      "Ketchikan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RFK",
    "translations": [
      "Rollang Field",
      "Rollang Field",
      "Rollang Field"
    ],
    "city": [
      "Rolling Fork",
      "Rolling Fork",
      "Rolling Fork"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NNK",
    "translations": [
      "Naknek Airport",
      "Naknek Airport",
      "Naknek Airport"
    ],
    "city": [
      "Naknek",
      "Naknek",
      "Naknek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BKF",
    "translations": [
      "Lake Brooks Seaplane Base",
      "Lake Brooks Seaplane Base",
      "Lake Brooks Seaplane Base"
    ],
    "city": [
      "Katmai National Park",
      "Katmai National Park",
      "Katmai National Park"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BCS",
    "translations": [
      "Southern Seaplane Airport",
      "Southern Seaplane Airport",
      "Southern Seaplane Airport"
    ],
    "city": [
      "Belle Chasse",
      "Belle Chasse",
      "Belle Chasse"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MMN",
    "translations": [
      "Minute Man Air Field",
      "Minute Man Air Field",
      "Minute Man Air Field"
    ],
    "city": [
      "Stow",
      "Stow",
      "Stow"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SPQ",
    "translations": [
      "Catalina Air-Sea Terminal Heliport",
      "Catalina Air-Sea Terminal Heliport",
      "Catalina Air-Sea Terminal Heliport"
    ],
    "city": [
      "San Pedro",
      "San Pedro",
      "San Pedro"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TSS",
    "translations": [
      "East 34th Street Heliport",
      "East 34th Street Heliport",
      "East 34th Street Heliport"
    ],
    "city": [
      "New York",
      "New York",
      "New York"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NYS",
    "translations": [
      "New York Skyports Inc Seaplane Base",
      "New York Skyports Inc Seaplane Base",
      "New York Skyports Inc Seaplane Base"
    ],
    "city": [
      "New York",
      "New York",
      "New York"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BWL",
    "translations": [
      "Earl Henry Airport",
      "Earl Henry Airport",
      "Earl Henry Airport"
    ],
    "city": [
      "Blackwell",
      "Blackwell",
      "Blackwell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WYB",
    "translations": [
      "Yes Bay Lodge Seaplane Base",
      "Yes Bay Lodge Seaplane Base",
      "Yes Bay Lodge Seaplane Base"
    ],
    "city": [
      "Yes Bay",
      "Yes Bay",
      "Yes Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CWS",
    "translations": [
      "Center Island Airport",
      "Center Island Airport",
      "Center Island Airport"
    ],
    "city": [
      "Center Island",
      "Center Island",
      "Center Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TEK",
    "translations": [
      "Tatitlek Airport",
      "Tatitlek Airport",
      "Tatitlek Airport"
    ],
    "city": [
      "Tatitlek",
      "Tatitlek",
      "Tatitlek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DUF",
    "translations": [
      "Pine Island Airport",
      "Pine Island Airport",
      "Pine Island Airport"
    ],
    "city": [
      "Corolla",
      "Corolla",
      "Corolla"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SSW",
    "translations": [
      "Stuart Island Airpark",
      "Stuart Island Airpark",
      "Stuart Island Airpark"
    ],
    "city": [
      "Friday Harbor",
      "Friday Harbor",
      "Friday Harbor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FOB",
    "translations": [
      "Fort Bragg Airport",
      "Fort Bragg Airport",
      "Fort Bragg Airport"
    ],
    "city": [
      "Fort Bragg",
      "Fort Bragg",
      "Fort Bragg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PUL",
    "translations": [
      "Port of Poulsbo Marina Moorage Seaplane Base",
      "Port of Poulsbo Marina Moorage Seaplane Base",
      "Port of Poulsbo Marina Moorage Seaplane Base"
    ],
    "city": [
      "Poulsbo",
      "Poulsbo",
      "Poulsbo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CCD",
    "translations": [
      "Century City Heliport",
      "Century City Heliport",
      "Century City Heliport"
    ],
    "city": [
      "Los Angeles",
      "Los Angeles",
      "Los Angeles"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WMK",
    "translations": [
      "Meyers Chuck Seaplane Base",
      "Meyers Chuck Seaplane Base",
      "Meyers Chuck Seaplane Base"
    ],
    "city": [
      "Meyers Chuck",
      "Meyers Chuck",
      "Meyers Chuck"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AXB",
    "translations": [
      "Maxson Airfield",
      "Maxson Airfield",
      "Maxson Airfield"
    ],
    "city": [
      "Alexandria Bay",
      "Alexandria Bay",
      "Alexandria Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "REE",
    "translations": [
      "Reese Airpark",
      "Reese Airpark",
      "Reese Airpark"
    ],
    "city": [
      "Lubbock",
      "Lubbock",
      "Lubbock"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WDN",
    "translations": [
      "Waldron Airstrip",
      "Waldron Airstrip",
      "Waldron Airstrip"
    ],
    "city": [
      "Eastsound",
      "Eastsound",
      "Eastsound"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WWP",
    "translations": [
      "Whale Pass Seaplane Float Harbor Facility",
      "Whale Pass Seaplane Float Harbor Facility",
      "Whale Pass Seaplane Float Harbor Facility"
    ],
    "city": [
      "Whale Pass",
      "Whale Pass",
      "Whale Pass"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CHU",
    "translations": [
      "Chuathbaluk Airport",
      "Chuathbaluk Airport",
      "Chuathbaluk Airport"
    ],
    "city": [
      "Chuathbaluk",
      "Chuathbaluk",
      "Chuathbaluk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UGS",
    "translations": [
      "Ugashik Airport",
      "Ugashik Airport",
      "Ugashik Airport"
    ],
    "city": [
      "Ugashik",
      "Ugashik",
      "Ugashik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JID",
    "translations": [
      "Recreation and Conference Center Heliport",
      "Recreation and Conference Center Heliport",
      "Recreation and Conference Center Heliport"
    ],
    "city": [
      "City of Industry",
      "City of Industry",
      "City of Industry"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PSQ",
    "translations": [
      "Philadelphia Seaplane Base",
      "Philadelphia Seaplane Base",
      "Philadelphia Seaplane Base"
    ],
    "city": [
      "Essington",
      "Essington",
      "Essington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KLL",
    "translations": [
      "Levelock Airport",
      "Levelock Airport",
      "Levelock Airport"
    ],
    "city": [
      "Levelock",
      "Levelock",
      "Levelock"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SGW",
    "translations": [
      "Saginaw Seaplane Base",
      "Saginaw Seaplane Base",
      "Saginaw Seaplane Base"
    ],
    "city": [
      "Saginaw Bay",
      "Saginaw Bay",
      "Saginaw Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WTL",
    "translations": [
      "Tuntutuliak Airport",
      "Tuntutuliak Airport",
      "Tuntutuliak Airport"
    ],
    "city": [
      "Tuntutuliak",
      "Tuntutuliak",
      "Tuntutuliak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TWA",
    "translations": [
      "Twin Hills Airport",
      "Twin Hills Airport",
      "Twin Hills Airport"
    ],
    "city": [
      "Twin Hills",
      "Twin Hills",
      "Twin Hills"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KCQ",
    "translations": [
      "Chignik Lake Airport",
      "Chignik Lake Airport",
      "Chignik Lake Airport"
    ],
    "city": [
      "Chignik Lake",
      "Chignik Lake",
      "Chignik Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AAD",
    "translations": [
      "Adado Airport",
      "Adado Airport",
      "Adado Airport"
    ],
    "city": [
      "Adado",
      "Adado",
      "Adado"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "ABP",
    "translations": [
      "Atkamba Airport",
      "Atkamba Airport",
      "Atkamba Airport"
    ],
    "city": [
      "Atkamba Mission",
      "Atkamba Mission",
      "Atkamba Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "ACM",
    "translations": [
      "Arica Airport",
      "Arica Airport",
      "Arica Airport"
    ],
    "city": [
      "Arica",
      "Arica",
      "Arica"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ADV",
    "translations": [
      "El Daein Airport",
      "El Daein Airport",
      "El Daein Airport"
    ],
    "city": [
      "El Daein",
      "El Daein",
      "El Daein"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "AEE",
    "translations": [
      "Adareil Airport",
      "Adareil Airport",
      "Adareil Airport"
    ],
    "city": [
      "Adar",
      "Adar",
      "Adar"
    ],
    "country": [
      "SS",
      "SS",
      "SS"
    ]
  },
  {
    "iata": "AEQ",
    "translations": [
      "Ar Horqin Airport",
      "Ar Horqin Airport",
      "Ar Horqin Airport"
    ],
    "city": [
      "Chifeng",
      "Chifeng",
      "Chifeng"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "AFK",
    "translations": [
      "Kondavattavana Tank Seaplane Base",
      "Kondavattavana Tank Seaplane Base",
      "Kondavattavana Tank Seaplane Base"
    ],
    "city": [
      "Ampara",
      "Ampara",
      "Ampara"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "AFT",
    "translations": [
      "Afutara Aerodrome",
      "Afutara Aerodrome",
      "Afutara Aerodrome"
    ],
    "city": [
      "Bila",
      "Bila",
      "Bila"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "RNA",
    "translations": [
      "Ulawa Airport",
      "Ulawa Airport",
      "Ulawa Airport"
    ],
    "city": [
      "Arona",
      "Arona",
      "Arona"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "ATD",
    "translations": [
      "Uru Harbour Airport",
      "Uru Harbour Airport",
      "Uru Harbour Airport"
    ],
    "city": [
      "Atoifi",
      "Atoifi",
      "Atoifi"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "VEV",
    "translations": [
      "Barakoma Airport",
      "Barakoma Airport",
      "Barakoma Airport"
    ],
    "city": [
      "Barakoma",
      "Barakoma",
      "Barakoma"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "BPF",
    "translations": [
      "Batuna Aerodrome",
      "Batuna Aerodrome",
      "Batuna Aerodrome"
    ],
    "city": [
      "Batuna Mission Station",
      "Batuna Mission Station",
      "Batuna Mission Station"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "GEF",
    "translations": [
      "Geva Airport",
      "Geva Airport",
      "Geva Airport"
    ],
    "city": [
      "Liangia",
      "Liangia",
      "Liangia"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "AGG",
    "translations": [
      "Angoram Airport",
      "Angoram Airport",
      "Angoram Airport"
    ],
    "city": [
      "Angoram",
      "Angoram",
      "Angoram"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AKS",
    "translations": [
      "Gwaunaru'u Airport",
      "Gwaunaru'u Airport",
      "Gwaunaru'u Airport"
    ],
    "city": [
      "Auki",
      "Auki",
      "Auki"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "BNY",
    "translations": [
      "Bellona/Anua Airport",
      "Bellona/Anua Airport",
      "Bellona/Anua Airport"
    ],
    "city": [
      "Anua",
      "Anua",
      "Anua"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "CHY",
    "translations": [
      "Choiseul Bay Airport",
      "Choiseul Bay Airport",
      "Choiseul Bay Airport"
    ],
    "city": [
      "Choiseul Bay",
      "Choiseul Bay",
      "Choiseul Bay"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "BAS",
    "translations": [
      "Ballalae Airport",
      "Ballalae Airport",
      "Ballalae Airport"
    ],
    "city": [
      "Ballalae",
      "Ballalae",
      "Ballalae"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "FRE",
    "translations": [
      "Fera/Maringe Airport",
      "Fera/Maringe Airport",
      "Fera/Maringe Airport"
    ],
    "city": [
      "Fera Island",
      "Fera Island",
      "Fera Island"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "HIR",
    "translations": [
      "Honiara International Airport",
      "Honiara International Airport",
      "Honiara International Airport"
    ],
    "city": [
      "Honiara",
      "Honiara",
      "Honiara"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "MBU",
    "translations": [
      "Babanakira Airport",
      "Babanakira Airport",
      "Babanakira Airport"
    ],
    "city": [
      "Mbambanakira",
      "Mbambanakira",
      "Mbambanakira"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "AVU",
    "translations": [
      "Avu Avu Airport",
      "Avu Avu Airport",
      "Avu Avu Airport"
    ],
    "city": [
      "Avu Avu",
      "Avu Avu",
      "Avu Avu"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "IRA",
    "translations": [
      "Ngorangora Airport",
      "Ngorangora Airport",
      "Ngorangora Airport"
    ],
    "city": [
      "Kirakira",
      "Kirakira",
      "Kirakira"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "SCZ",
    "translations": [
      "Santa Cruz/Graciosa Bay/Luova Airport",
      "Santa Cruz/Graciosa Bay/Luova Airport",
      "Santa Cruz/Graciosa Bay/Luova Airport"
    ],
    "city": [
      "Santa Cruz/Graciosa Bay/Luova",
      "Santa Cruz/Graciosa Bay/Luova",
      "Santa Cruz/Graciosa Bay/Luova"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "MUA",
    "translations": [
      "Munda Airport",
      "Munda Airport",
      "Munda Airport"
    ],
    "city": [
      "Munda",
      "Munda",
      "Munda"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "GZO",
    "translations": [
      "Nusatupe Airport",
      "Nusatupe Airport",
      "Nusatupe Airport"
    ],
    "city": [
      "Gizo",
      "Gizo",
      "Gizo"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "MNY",
    "translations": [
      "Mono Airport",
      "Mono Airport",
      "Mono Airport"
    ],
    "city": [
      "Stirling Island",
      "Stirling Island",
      "Stirling Island"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "PRS",
    "translations": [
      "Parasi Airport",
      "Parasi Airport",
      "Parasi Airport"
    ],
    "city": [
      "Parasi",
      "Parasi",
      "Parasi"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "RNL",
    "translations": [
      "Rennell/Tingoa Airport",
      "Rennell/Tingoa Airport",
      "Rennell/Tingoa Airport"
    ],
    "city": [
      "Rennell Island",
      "Rennell Island",
      "Rennell Island"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "EGM",
    "translations": [
      "Sege Airport",
      "Sege Airport",
      "Sege Airport"
    ],
    "city": [
      "Sege",
      "Sege",
      "Sege"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "NNB",
    "translations": [
      "Santa Ana Airport",
      "Santa Ana Airport",
      "Santa Ana Airport"
    ],
    "city": [
      "Santa Ana Island",
      "Santa Ana Island",
      "Santa Ana Island"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "RUS",
    "translations": [
      "Marau Airport",
      "Marau Airport",
      "Marau Airport"
    ],
    "city": [
      "Marau",
      "Marau",
      "Marau"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "VAO",
    "translations": [
      "Suavanao Airport",
      "Suavanao Airport",
      "Suavanao Airport"
    ],
    "city": [
      "Suavanao",
      "Suavanao",
      "Suavanao"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "XYA",
    "translations": [
      "Yandina Airport",
      "Yandina Airport",
      "Yandina Airport"
    ],
    "city": [
      "Yandina",
      "Yandina",
      "Yandina"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "AGK",
    "translations": [
      "Kagua Airport",
      "Kagua Airport",
      "Kagua Airport"
    ],
    "city": [
      "Kagua",
      "Kagua",
      "Kagua"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KGE",
    "translations": [
      "Kaghau Airport",
      "Kaghau Airport",
      "Kaghau Airport"
    ],
    "city": [
      "Kagau Island",
      "Kagau Island",
      "Kagau Island"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "KUE",
    "translations": [
      "Kukudu Airport",
      "Kukudu Airport",
      "Kukudu Airport"
    ],
    "city": [
      "Kolombangara Island",
      "Kolombangara Island",
      "Kolombangara Island"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "KWS",
    "translations": [
      "Kwailabesi Airport",
      "Kwailabesi Airport",
      "Kwailabesi Airport"
    ],
    "city": [
      "Kwailabesi",
      "Kwailabesi",
      "Kwailabesi"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "LLM",
    "translations": [
      "Lomlom Airport",
      "Lomlom Airport",
      "Lomlom Airport"
    ],
    "city": [
      "Lomlom",
      "Lomlom",
      "Lomlom"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "NAZ",
    "translations": [
      "Nana Airport",
      "Nana Airport",
      "Nana Airport"
    ],
    "city": [
      "Star Harbor",
      "Star Harbor",
      "Star Harbor"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "MHM",
    "translations": [
      "Manaoba Airport",
      "Manaoba Airport",
      "Manaoba Airport"
    ],
    "city": [
      "Manaoba",
      "Manaoba",
      "Manaoba"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "GTA",
    "translations": [
      "Gatokae Aerodrome",
      "Gatokae Aerodrome",
      "Gatokae Aerodrome"
    ],
    "city": [
      "Gatokae",
      "Gatokae",
      "Gatokae"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "RIN",
    "translations": [
      "Ringi Cove Airport",
      "Ringi Cove Airport",
      "Ringi Cove Airport"
    ],
    "city": [
      "Ringi Cove",
      "Ringi Cove",
      "Ringi Cove"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "RBV",
    "translations": [
      "Ramata Airport",
      "Ramata Airport",
      "Ramata Airport"
    ],
    "city": [
      "Ramata",
      "Ramata",
      "Ramata"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "TLG",
    "translations": [
      "Tulaghi Heliport",
      "Tulaghi Heliport",
      "Tulaghi Heliport"
    ],
    "city": [
      "Tulaghi Island",
      "Tulaghi Island",
      "Tulaghi Island"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "AHY",
    "translations": [
      "Ambatolhy Airport",
      "Ambatolhy Airport",
      "Ambatolhy Airport"
    ],
    "city": [
      "Ambatolahy",
      "Ambatolahy",
      "Ambatolahy"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "AIC",
    "translations": [
      "Ailinglaplap Airok Airport",
      "Ailinglaplap Airok Airport",
      "Ailinglaplap Airok Airport"
    ],
    "city": [
      "Bigatyelang Island",
      "Bigatyelang Island",
      "Bigatyelang Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "CEX",
    "translations": [
      "Chena Hot Springs Airport",
      "Chena Hot Springs Airport",
      "Chena Hot Springs Airport"
    ],
    "city": [
      "Chena Hot Springs",
      "Chena Hot Springs",
      "Chena Hot Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SOL",
    "translations": [
      "Solomon State Field",
      "Solomon State Field",
      "Solomon State Field"
    ],
    "city": [
      "Solomon",
      "Solomon",
      "Solomon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HED",
    "translations": [
      "Herendeen Bay Airport",
      "Herendeen Bay Airport",
      "Herendeen Bay Airport"
    ],
    "city": [
      "Herendeen Bay",
      "Herendeen Bay",
      "Herendeen Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TWE",
    "translations": [
      "Taylor Airport",
      "Taylor Airport",
      "Taylor Airport"
    ],
    "city": [
      "Taylor",
      "Taylor",
      "Taylor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KTH",
    "translations": [
      "Tikchik Lodge Seaplane Base",
      "Tikchik Lodge Seaplane Base",
      "Tikchik Lodge Seaplane Base"
    ],
    "city": [
      "Tikchik",
      "Tikchik",
      "Tikchik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NKI",
    "translations": [
      "Naukati Bay Seaplane Base",
      "Naukati Bay Seaplane Base",
      "Naukati Bay Seaplane Base"
    ],
    "city": [
      "Tuxekan Island",
      "Tuxekan Island",
      "Tuxekan Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CDL",
    "translations": [
      "Candle 2 Airport",
      "Candle 2 Airport",
      "Candle 2 Airport"
    ],
    "city": [
      "Candle",
      "Candle",
      "Candle"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AOS",
    "translations": [
      "Amook Bay Seaplane Base",
      "Amook Bay Seaplane Base",
      "Amook Bay Seaplane Base"
    ],
    "city": [
      "Amook Bay",
      "Amook Bay",
      "Amook Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BSW",
    "translations": [
      "Boswell Bay Airport",
      "Boswell Bay Airport",
      "Boswell Bay Airport"
    ],
    "city": [
      "Boswell Bay",
      "Boswell Bay",
      "Boswell Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AKM",
    "translations": [
      "Zakuoma Airport",
      "Zakuoma Airport",
      "Zakuoma Airport"
    ],
    "city": [
      "ZaKouma",
      "ZaKouma",
      "ZaKouma"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "ALZ",
    "translations": [
      "Alitak Seaplane Base",
      "Alitak Seaplane Base",
      "Alitak Seaplane Base"
    ],
    "city": [
      "Lazy Bay",
      "Lazy Bay",
      "Lazy Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "YUK",
    "translations": [
      "Syunik Airport",
      "Syunik Airport",
      "Syunik Airport"
    ],
    "city": [
      "Kapan",
      "Kapan",
      "Kapan"
    ],
    "country": [
      "AM",
      "AM",
      "AM"
    ]
  },
  {
    "iata": "AME",
    "translations": [
      "Alto Molocue Airport",
      "Alto Molocue Airport",
      "Alto Molocue Airport"
    ],
    "city": [
      "Alto Molocue",
      "Alto Molocue",
      "Alto Molocue"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "AMY",
    "translations": [
      "Ambatomainty Airport",
      "Ambatomainty Airport",
      "Ambatomainty Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "INU",
    "translations": [
      "Nauru International Airport",
      "Nauru International Airport",
      "Nauru International Airport"
    ],
    "city": [
      "Yaren District",
      "Yaren District",
      "Yaren District"
    ],
    "country": [
      "NR",
      "NR",
      "NR"
    ]
  },
  {
    "iata": "ANZ",
    "translations": [
      "Angus Downs Airport",
      "Angus Downs Airport",
      "Angus Downs Airport"
    ],
    "city": [
      "Angus Downs Station",
      "Angus Downs Station",
      "Angus Downs Station"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CTV",
    "translations": [
      "Catoca Airport",
      "Catoca Airport",
      "Catoca Airport"
    ],
    "city": [
      "Saurimo",
      "Saurimo",
      "Saurimo"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "ANL",
    "translations": [
      "Andulo Airport",
      "Andulo Airport",
      "Andulo Airport"
    ],
    "city": [
      "Andulo",
      "Andulo",
      "Andulo"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "CNZ",
    "translations": [
      "Cangamba Airport",
      "Cangamba Airport",
      "Cangamba Airport"
    ],
    "city": [
      "Cangamba",
      "Cangamba",
      "Cangamba"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "DRC",
    "translations": [
      "Dirico Airport",
      "Dirico Airport",
      "Dirico Airport"
    ],
    "city": [
      "Dirico",
      "Dirico",
      "Dirico"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "NDF",
    "translations": [
      "N'dalatando Airport",
      "N'dalatando Airport",
      "N'dalatando Airport"
    ],
    "city": [
      "N'dalatando",
      "N'dalatando",
      "N'dalatando"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "AOB",
    "translations": [
      "Annanberg Airport",
      "Annanberg Airport",
      "Annanberg Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AOD",
    "translations": [
      "Abou-Deïa Airport",
      "Abou-Deïa Airport",
      "Abou-Deïa Airport"
    ],
    "city": [
      "Abou-Deïa",
      "Abou-Deïa",
      "Abou-Deïa"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "APP",
    "translations": [
      "Asapa Airport",
      "Asapa Airport",
      "Asapa Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AQY",
    "translations": [
      "Girdwood-Alyeska Airport",
      "Girdwood-Alyeska Airport",
      "Girdwood-Alyeska Airport"
    ],
    "city": [
      "Girdwood",
      "Girdwood",
      "Girdwood"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "QRF",
    "translations": [
      "Bragado Airport",
      "Bragado Airport",
      "Bragado Airport"
    ],
    "city": [
      "Bragado",
      "Bragado",
      "Bragado"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "CVI",
    "translations": [
      "Caleta Olivia Airport",
      "Caleta Olivia Airport",
      "Caleta Olivia Airport"
    ],
    "city": [
      "Caleta Olivia",
      "Caleta Olivia",
      "Caleta Olivia"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "CNT",
    "translations": [
      "Charata Airport",
      "Charata Airport",
      "Charata Airport"
    ],
    "city": [
      "Charata",
      "Charata",
      "Charata"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "VGS",
    "translations": [
      "General Villegas Airport",
      "General Villegas Airport",
      "General Villegas Airport"
    ],
    "city": [
      "General Villegas",
      "General Villegas",
      "General Villegas"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "LMD",
    "translations": [
      "Los Menucos Airport",
      "Los Menucos Airport",
      "Los Menucos Airport"
    ],
    "city": [
      "Los Menucos",
      "Los Menucos",
      "Los Menucos"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "VCF",
    "translations": [
      "Valcheta Airport",
      "Valcheta Airport",
      "Valcheta Airport"
    ],
    "city": [
      "Valcheta",
      "Valcheta",
      "Valcheta"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "CPG",
    "translations": [
      "Carmen de Patagones Airport",
      "Carmen de Patagones Airport",
      "Carmen de Patagones Airport"
    ],
    "city": [
      "Carmen de Patagones",
      "Carmen de Patagones",
      "Carmen de Patagones"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "ARP",
    "translations": [
      "Aragip Airport",
      "Aragip Airport",
      "Aragip Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "ASZ",
    "translations": [
      "Asirim Airport",
      "Asirim Airport",
      "Asirim Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LYT",
    "translations": [
      "Lady Elliot Island Airstrip",
      "Lady Elliot Island Airstrip",
      "Lady Elliot Island Airstrip"
    ],
    "city": [
      "Lady Elliot Island",
      "Lady Elliot Island",
      "Lady Elliot Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GYZ",
    "translations": [
      "Gruyere Airport",
      "Gruyere Airport",
      "Gruyere Airport"
    ],
    "city": [
      "Cosmo Newbery",
      "Cosmo Newbery",
      "Cosmo Newbery"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AGW",
    "translations": [
      "Agnew Airport",
      "Agnew Airport",
      "Agnew Airport"
    ],
    "city": [
      "Agnew",
      "Agnew",
      "Agnew"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AYD",
    "translations": [
      "Alroy Downs Airport",
      "Alroy Downs Airport",
      "Alroy Downs Airport"
    ],
    "city": [
      "Alroy Downs",
      "Alroy Downs",
      "Alroy Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BYX",
    "translations": [
      "Baniyala Airport",
      "Baniyala Airport",
      "Baniyala Airport"
    ],
    "city": [
      "Baniyala",
      "Baniyala",
      "Baniyala"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "COB",
    "translations": [
      "Coolibah Airport",
      "Coolibah Airport",
      "Coolibah Airport"
    ],
    "city": [
      "Coolibah",
      "Coolibah",
      "Coolibah"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CRJ",
    "translations": [
      "Coorabie Airport",
      "Coorabie Airport",
      "Coorabie Airport"
    ],
    "city": [
      "Coorabie",
      "Coorabie",
      "Coorabie"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CRY",
    "translations": [
      "Carlton Hill Airport",
      "Carlton Hill Airport",
      "Carlton Hill Airport"
    ],
    "city": [
      "Carlton Hill",
      "Carlton Hill",
      "Carlton Hill"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CSD",
    "translations": [
      "Cresswell Downs Airport",
      "Cresswell Downs Airport",
      "Cresswell Downs Airport"
    ],
    "city": [
      "Cresswell Downs",
      "Cresswell Downs",
      "Cresswell Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DYM",
    "translations": [
      "Diamantina Lakes Airport",
      "Diamantina Lakes Airport",
      "Diamantina Lakes Airport"
    ],
    "city": [
      "Diamantina Lakes",
      "Diamantina Lakes",
      "Diamantina Lakes"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HIS",
    "translations": [
      "Hayman Island Resort Seaplane Base",
      "Hayman Island Resort Seaplane Base",
      "Hayman Island Resort Seaplane Base"
    ],
    "city": [
      "Hayman Island",
      "Hayman Island",
      "Hayman Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HLV",
    "translations": [
      "Helenvale Airport",
      "Helenvale Airport",
      "Helenvale Airport"
    ],
    "city": [
      "Helenvale",
      "Helenvale",
      "Helenvale"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KBD",
    "translations": [
      "Kimberley Downs Airport",
      "Kimberley Downs Airport",
      "Kimberley Downs Airport"
    ],
    "city": [
      "Kimberley Downs",
      "Kimberley Downs",
      "Kimberley Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KGR",
    "translations": [
      "Kulgera Airport",
      "Kulgera Airport",
      "Kulgera Airport"
    ],
    "city": [
      "Ghan",
      "Ghan",
      "Ghan"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PEP",
    "translations": [
      "Peppimenarti Airport",
      "Peppimenarti Airport",
      "Peppimenarti Airport"
    ],
    "city": [
      "Peppimenarti",
      "Peppimenarti",
      "Peppimenarti"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RDA",
    "translations": [
      "Rockhampton Downs Airport",
      "Rockhampton Downs Airport",
      "Rockhampton Downs Airport"
    ],
    "city": [
      "Rockhampton Downs",
      "Rockhampton Downs",
      "Rockhampton Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SSK",
    "translations": [
      "Sturt Creek Airport",
      "Sturt Creek Airport",
      "Sturt Creek Airport"
    ],
    "city": [
      "Sturt Creek",
      "Sturt Creek",
      "Sturt Creek"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SWB",
    "translations": [
      "Shaw River Airport",
      "Shaw River Airport",
      "Shaw River Airport"
    ],
    "city": [
      "Shaw River",
      "Shaw River",
      "Shaw River"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TWP",
    "translations": [
      "Torwood Airport",
      "Torwood Airport",
      "Torwood Airport"
    ],
    "city": [
      "Torwood",
      "Torwood",
      "Torwood"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ZVG",
    "translations": [
      "Springvale Airport",
      "Springvale Airport",
      "Springvale Airport"
    ],
    "city": [
      "Springvale",
      "Springvale",
      "Springvale"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AWR",
    "translations": [
      "Awar Airport (unusable)",
      "Awar Airport (unusable)",
      "Awar Airport (unusable)"
    ],
    "city": [
      "Awar",
      "Awar",
      "Awar"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AXF",
    "translations": [
      "Alxa Left Banner Bayanhot Airport",
      "Alxa Left Banner Bayanhot Airport",
      "Alxa Left Banner Bayanhot Airport"
    ],
    "city": [
      "Bayanhot",
      "Bayanhot",
      "Bayanhot"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "AXO",
    "translations": [
      "Pantar Kabir Airport",
      "Pantar Kabir Airport",
      "Pantar Kabir Airport"
    ],
    "city": [
      "Kabir",
      "Kabir",
      "Kabir"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "AMF",
    "translations": [
      "Ama Airport",
      "Ama Airport",
      "Ama Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "UAE",
    "translations": [
      "Mount Aue Airport",
      "Mount Aue Airport",
      "Mount Aue Airport"
    ],
    "city": [
      "Aue",
      "Aue",
      "Aue"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AFR",
    "translations": [
      "Afore Airstrip",
      "Afore Airstrip",
      "Afore Airstrip"
    ],
    "city": [
      "Afore",
      "Afore",
      "Afore"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AUP",
    "translations": [
      "Agaun Airport",
      "Agaun Airport",
      "Agaun Airport"
    ],
    "city": [
      "Agaun",
      "Agaun",
      "Agaun"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "ATP",
    "translations": [
      "Aitape Airport",
      "Aitape Airport",
      "Aitape Airport"
    ],
    "city": [
      "Aitape",
      "Aitape",
      "Aitape"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AIH",
    "translations": [
      "Aiambak Airport",
      "Aiambak Airport",
      "Aiambak Airport"
    ],
    "city": [
      "Aiambak",
      "Aiambak",
      "Aiambak"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AMU",
    "translations": [
      "Amanab Airport",
      "Amanab Airport",
      "Amanab Airport"
    ],
    "city": [
      "Amanab",
      "Amanab",
      "Amanab"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "ADC",
    "translations": [
      "Andakombe Airport",
      "Andakombe Airport",
      "Andakombe Airport"
    ],
    "city": [
      "Andekombe",
      "Andekombe",
      "Andekombe"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AIE",
    "translations": [
      "Aiome Airport",
      "Aiome Airport",
      "Aiome Airport"
    ],
    "city": [
      "Aiome",
      "Aiome",
      "Aiome"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KPM",
    "translations": [
      "Kompiam Airport",
      "Kompiam Airport",
      "Kompiam Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AUJ",
    "translations": [
      "Ambunti Airport",
      "Ambunti Airport",
      "Ambunti Airport"
    ],
    "city": [
      "Ambunti",
      "Ambunti",
      "Ambunti"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AWB",
    "translations": [
      "Awaba Airport",
      "Awaba Airport",
      "Awaba Airport"
    ],
    "city": [
      "Awaba",
      "Awaba",
      "Awaba"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AEK",
    "translations": [
      "Aseki Airport",
      "Aseki Airport",
      "Aseki Airport"
    ],
    "city": [
      "Aseki",
      "Aseki",
      "Aseki"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AYU",
    "translations": [
      "Aiyura Airport",
      "Aiyura Airport",
      "Aiyura Airport"
    ],
    "city": [
      "Aiyura Valley",
      "Aiyura Valley",
      "Aiyura Valley"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "VMU",
    "translations": [
      "Baimuru Airport",
      "Baimuru Airport",
      "Baimuru Airport"
    ],
    "city": [
      "Baimuru",
      "Baimuru",
      "Baimuru"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BCP",
    "translations": [
      "Bambu Airport",
      "Bambu Airport",
      "Bambu Airport"
    ],
    "city": [
      "Bambu",
      "Bambu",
      "Bambu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BNM",
    "translations": [
      "Bodinumu Airport",
      "Bodinumu Airport",
      "Bodinumu Airport"
    ],
    "city": [
      "Bodinumu",
      "Bodinumu",
      "Bodinumu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BMZ",
    "translations": [
      "Bamu Airport",
      "Bamu Airport",
      "Bamu Airport"
    ],
    "city": [
      "Bamu",
      "Bamu",
      "Bamu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BDZ",
    "translations": [
      "Baindoung Airport",
      "Baindoung Airport",
      "Baindoung Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BSP",
    "translations": [
      "Bensbach Airport",
      "Bensbach Airport",
      "Bensbach Airport"
    ],
    "city": [
      "Bensbach",
      "Bensbach",
      "Bensbach"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BWP",
    "translations": [
      "Bewani Airport",
      "Bewani Airport",
      "Bewani Airport"
    ],
    "city": [
      "Bewani",
      "Bewani",
      "Bewani"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BUA",
    "translations": [
      "Buka Airport",
      "Buka Airport",
      "Buka Airport"
    ],
    "city": [
      "Buka Island",
      "Buka Island",
      "Buka Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BAA",
    "translations": [
      "Bialla Airport",
      "Bialla Airport",
      "Bialla Airport"
    ],
    "city": [
      "Bialla, Matalilu, Ewase",
      "Bialla, Matalilu, Ewase",
      "Bialla, Matalilu, Ewase"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "OPU",
    "translations": [
      "Balimo Airport",
      "Balimo Airport",
      "Balimo Airport"
    ],
    "city": [
      "Balimo",
      "Balimo",
      "Balimo"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BMH",
    "translations": [
      "Bomai Airport",
      "Bomai Airport",
      "Bomai Airport"
    ],
    "city": [
      "Bomai",
      "Bomai",
      "Bomai"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BPD",
    "translations": [
      "Bapi Airstrip",
      "Bapi Airstrip",
      "Bapi Airstrip"
    ],
    "city": [
      "Bapi",
      "Bapi",
      "Bapi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BPK",
    "translations": [
      "Biangabip Airport",
      "Biangabip Airport",
      "Biangabip Airport"
    ],
    "city": [
      "Biangabip",
      "Biangabip",
      "Biangabip"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BRP",
    "translations": [
      "Biaru Airport",
      "Biaru Airport",
      "Biaru Airport"
    ],
    "city": [
      "Biaru",
      "Biaru",
      "Biaru"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BUL",
    "translations": [
      "Bulolo Airport",
      "Bulolo Airport",
      "Bulolo Airport"
    ],
    "city": [
      "Bulolo",
      "Bulolo",
      "Bulolo"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "XBN",
    "translations": [
      "Biniguni Airport",
      "Biniguni Airport",
      "Biniguni Airport"
    ],
    "city": [
      "Biniguni",
      "Biniguni",
      "Biniguni"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "CVB",
    "translations": [
      "Chungribu Airport",
      "Chungribu Airport",
      "Chungribu Airport"
    ],
    "city": [
      "Chungribu",
      "Chungribu",
      "Chungribu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "CGC",
    "translations": [
      "Cape Gloucester Airport",
      "Cape Gloucester Airport",
      "Cape Gloucester Airport"
    ],
    "city": [
      "Cape Gloucester",
      "Cape Gloucester",
      "Cape Gloucester"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "CMU",
    "translations": [
      "Chimbu Airport",
      "Chimbu Airport",
      "Chimbu Airport"
    ],
    "city": [
      "Kundiawa",
      "Kundiawa",
      "Kundiawa"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SQT",
    "translations": [
      "China Strait Airstrip",
      "China Strait Airstrip",
      "China Strait Airstrip"
    ],
    "city": [
      "Samarai Island",
      "Samarai Island",
      "Samarai Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "DBP",
    "translations": [
      "Debepare Airport",
      "Debepare Airport",
      "Debepare Airport"
    ],
    "city": [
      "Debepare",
      "Debepare",
      "Debepare"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "DER",
    "translations": [
      "Derim Airport",
      "Derim Airport",
      "Derim Airport"
    ],
    "city": [
      "Derim",
      "Derim",
      "Derim"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BNT",
    "translations": [
      "Bundi Airport",
      "Bundi Airport",
      "Bundi Airport"
    ],
    "city": [
      "Bundi",
      "Bundi",
      "Bundi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MDM",
    "translations": [
      "Munduku Airport",
      "Munduku Airport",
      "Munduku Airport"
    ],
    "city": [
      "Munduku",
      "Munduku",
      "Munduku"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KPF",
    "translations": [
      "Kondobol Airport",
      "Kondobol Airport",
      "Kondobol Airport"
    ],
    "city": [
      "Kondobol",
      "Kondobol",
      "Kondobol"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "DNU",
    "translations": [
      "Dinangat Airport",
      "Dinangat Airport",
      "Dinangat Airport"
    ],
    "city": [
      "Dinangat",
      "Dinangat",
      "Dinangat"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "DOI",
    "translations": [
      "Doini Airport",
      "Doini Airport",
      "Doini Airport"
    ],
    "city": [
      "Castori Islets",
      "Castori Islets",
      "Castori Islets"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "DOO",
    "translations": [
      "Dorobisoro Airport",
      "Dorobisoro Airport",
      "Dorobisoro Airport"
    ],
    "city": [
      "Dorobisoro",
      "Dorobisoro",
      "Dorobisoro"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "DAU",
    "translations": [
      "Daru Airport",
      "Daru Airport",
      "Daru Airport"
    ],
    "city": [
      "Daru",
      "Daru",
      "Daru"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KRU",
    "translations": [
      "Kerau Airport",
      "Kerau Airport",
      "Kerau Airport"
    ],
    "city": [
      "Gunim",
      "Gunim",
      "Gunim"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "EMS",
    "translations": [
      "Embessa Airport",
      "Embessa Airport",
      "Embessa Airport"
    ],
    "city": [
      "Embessa",
      "Embessa",
      "Embessa"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "XYR",
    "translations": [
      "Edwaki Airport",
      "Edwaki Airport",
      "Edwaki Airport"
    ],
    "city": [
      "Yellow River Mission",
      "Yellow River Mission",
      "Yellow River Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "EMI",
    "translations": [
      "Emirau Airport",
      "Emirau Airport",
      "Emirau Airport"
    ],
    "city": [
      "Emirau Island",
      "Emirau Island",
      "Emirau Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "EFG",
    "translations": [
      "Efogi Airport",
      "Efogi Airport",
      "Efogi Airport"
    ],
    "city": [
      "Efogi",
      "Efogi",
      "Efogi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MHY",
    "translations": [
      "Morehead Airport",
      "Morehead Airport",
      "Morehead Airport"
    ],
    "city": [
      "Morehead",
      "Morehead",
      "Morehead"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "EPT",
    "translations": [
      "Eliptamin Airport",
      "Eliptamin Airport",
      "Eliptamin Airport"
    ],
    "city": [
      "Eliptamin",
      "Eliptamin",
      "Eliptamin"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "EGA",
    "translations": [
      "Engati Airstrip",
      "Engati Airstrip",
      "Engati Airstrip"
    ],
    "city": [
      "Engati",
      "Engati",
      "Engati"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "EMO",
    "translations": [
      "Emo River Airstrip",
      "Emo River Airstrip",
      "Emo River Airstrip"
    ],
    "city": [
      "Emo Mission",
      "Emo Mission",
      "Emo Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "ERU",
    "translations": [
      "Erume Airport",
      "Erume Airport",
      "Erume Airport"
    ],
    "city": [
      "Erume",
      "Erume",
      "Erume"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MFZ",
    "translations": [
      "Meselia Airport",
      "Meselia Airport",
      "Meselia Airport"
    ],
    "city": [
      "Demgulu",
      "Demgulu",
      "Demgulu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BOT",
    "translations": [
      "Bosset Airport",
      "Bosset Airport",
      "Bosset Airport"
    ],
    "city": [
      "Bosset",
      "Bosset",
      "Bosset"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "ERE",
    "translations": [
      "Erave Airport",
      "Erave Airport",
      "Erave Airport"
    ],
    "city": [
      "Erave",
      "Erave",
      "Erave"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SWE",
    "translations": [
      "Siwea Airport",
      "Siwea Airport",
      "Siwea Airport"
    ],
    "city": [
      "Siwea",
      "Siwea",
      "Siwea"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "FNE",
    "translations": [
      "Fane Airport",
      "Fane Airport",
      "Fane Airport"
    ],
    "city": [
      "Fane Mission",
      "Fane Mission",
      "Fane Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "FRQ",
    "translations": [
      "Feramin Airport",
      "Feramin Airport",
      "Feramin Airport"
    ],
    "city": [
      "Feramin",
      "Feramin",
      "Feramin"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "FIN",
    "translations": [
      "Finschhafen Airport",
      "Finschhafen Airport",
      "Finschhafen Airport"
    ],
    "city": [
      "Buki",
      "Buki",
      "Buki"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "FAQ",
    "translations": [
      "Frieda River Airport",
      "Frieda River Airport",
      "Frieda River Airport"
    ],
    "city": [
      "Frieda River",
      "Frieda River",
      "Frieda River"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "FUM",
    "translations": [
      "Fuma Airport",
      "Fuma Airport",
      "Fuma Airport"
    ],
    "city": [
      "Fuma",
      "Fuma",
      "Fuma"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GKA",
    "translations": [
      "Goroka Airport",
      "Goroka Airport",
      "Goroka Airport"
    ],
    "city": [
      "Goronka",
      "Goronka",
      "Goronka"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GEW",
    "translations": [
      "Gewoia Airport",
      "Gewoia Airport",
      "Gewoia Airport"
    ],
    "city": [
      "Gewoia",
      "Gewoia",
      "Gewoia"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GUG",
    "translations": [
      "Guari Airport",
      "Guari Airport",
      "Guari Airport"
    ],
    "city": [
      "Guari",
      "Guari",
      "Guari"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GRL",
    "translations": [
      "Garasa Airport",
      "Garasa Airport",
      "Garasa Airport"
    ],
    "city": [
      "Au",
      "Au",
      "Au"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GAR",
    "translations": [
      "Garaina Airport",
      "Garaina Airport",
      "Garaina Airport"
    ],
    "city": [
      "Garaina",
      "Garaina",
      "Garaina"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GAZ",
    "translations": [
      "Guasopa Airport",
      "Guasopa Airport",
      "Guasopa Airport"
    ],
    "city": [
      "Woodlark (Muyua) Island",
      "Woodlark (Muyua) Island",
      "Woodlark (Muyua) Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GOE",
    "translations": [
      "Gonaili Airport",
      "Gonaili Airport",
      "Gonaili Airport"
    ],
    "city": [
      "Gonaili",
      "Gonaili",
      "Gonaili"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GUR",
    "translations": [
      "Gurney Airport",
      "Gurney Airport",
      "Gurney Airport"
    ],
    "city": [
      "Gurney",
      "Gurney",
      "Gurney"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GAP",
    "translations": [
      "Gusap Airport",
      "Gusap Airport",
      "Gusap Airport"
    ],
    "city": [
      "Gusap",
      "Gusap",
      "Gusap"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PNP",
    "translations": [
      "Girua Airport",
      "Girua Airport",
      "Girua Airport"
    ],
    "city": [
      "Popondetta",
      "Popondetta",
      "Popondetta"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GBC",
    "translations": [
      "Gasuke Airport",
      "Gasuke Airport",
      "Gasuke Airport"
    ],
    "city": [
      "Gasuke",
      "Gasuke",
      "Gasuke"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GMI",
    "translations": [
      "Gasmata Island Airport",
      "Gasmata Island Airport",
      "Gasmata Island Airport"
    ],
    "city": [
      "Gasmata Island",
      "Gasmata Island",
      "Gasmata Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AKG",
    "translations": [
      "Anguganak Airport",
      "Anguganak Airport",
      "Anguganak Airport"
    ],
    "city": [
      "Anguganak",
      "Anguganak",
      "Anguganak"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GVI",
    "translations": [
      "Green River Airport",
      "Green River Airport",
      "Green River Airport"
    ],
    "city": [
      "Green River",
      "Green River",
      "Green River"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GOC",
    "translations": [
      "Gora Airstrip",
      "Gora Airstrip",
      "Gora Airstrip"
    ],
    "city": [
      "Gora",
      "Gora",
      "Gora"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "HBD",
    "translations": [
      "Habi Airport",
      "Habi Airport",
      "Habi Airport"
    ],
    "city": [
      "Habi",
      "Habi",
      "Habi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "HNI",
    "translations": [
      "Heiweni Airport",
      "Heiweni Airport",
      "Heiweni Airport"
    ],
    "city": [
      "Heiweni",
      "Heiweni",
      "Heiweni"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "HYF",
    "translations": [
      "Hayfields Airport",
      "Hayfields Airport",
      "Hayfields Airport"
    ],
    "city": [
      "Bainyik",
      "Bainyik",
      "Bainyik"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "HNN",
    "translations": [
      "Honinabi Airport",
      "Honinabi Airport",
      "Honinabi Airport"
    ],
    "city": [
      "Honinabi",
      "Honinabi",
      "Honinabi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "HKN",
    "translations": [
      "Hoskins Airport",
      "Hoskins Airport",
      "Hoskins Airport"
    ],
    "city": [
      "Kimbe",
      "Kimbe",
      "Kimbe"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "HIT",
    "translations": [
      "Haivaro Airport",
      "Haivaro Airport",
      "Haivaro Airport"
    ],
    "city": [
      "Haivaro",
      "Haivaro",
      "Haivaro"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "HWA",
    "translations": [
      "Hawabango Airport",
      "Hawabango Airport",
      "Hawabango Airport"
    ],
    "city": [
      "Hawabango",
      "Hawabango",
      "Hawabango"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "IIS",
    "translations": [
      "Nissan Island Airport",
      "Nissan Island Airport",
      "Nissan Island Airport"
    ],
    "city": [
      "Nissan Island",
      "Nissan Island",
      "Nissan Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "IDN",
    "translations": [
      "Indagen Airport",
      "Indagen Airport",
      "Indagen Airport"
    ],
    "city": [
      "Indagen",
      "Indagen",
      "Indagen"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "IMN",
    "translations": [
      "Imane Airport",
      "Imane Airport",
      "Imane Airport"
    ],
    "city": [
      "Imane",
      "Imane",
      "Imane"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KGM",
    "translations": [
      "Kungim Airport",
      "Kungim Airport",
      "Kungim Airport"
    ],
    "city": [
      "Kungim",
      "Kungim",
      "Kungim"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "IMD",
    "translations": [
      "Imonda Airport",
      "Imonda Airport",
      "Imonda Airport"
    ],
    "city": [
      "Imonda",
      "Imonda",
      "Imonda"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KIE",
    "translations": [
      "Aropa Airport",
      "Aropa Airport",
      "Aropa Airport"
    ],
    "city": [
      "Kieta",
      "Kieta",
      "Kieta"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "IAL",
    "translations": [
      "Ialibu Airport",
      "Ialibu Airport",
      "Ialibu Airport"
    ],
    "city": [
      "Ialibu",
      "Ialibu",
      "Ialibu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WSA",
    "translations": [
      "Wasua Airport",
      "Wasua Airport",
      "Wasua Airport"
    ],
    "city": [
      "Wasua",
      "Wasua",
      "Wasua"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WIU",
    "translations": [
      "Witu Airport",
      "Witu Airport",
      "Witu Airport"
    ],
    "city": [
      "Garove Island",
      "Garove Island",
      "Garove Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MPX",
    "translations": [
      "Miyanmin Airport",
      "Miyanmin Airport",
      "Miyanmin Airport"
    ],
    "city": [
      "Miyanmin",
      "Miyanmin",
      "Miyanmin"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KGH",
    "translations": [
      "Yongai Airport",
      "Yongai Airport",
      "Yongai Airport"
    ],
    "city": [
      "Yongai",
      "Yongai",
      "Yongai"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "JOP",
    "translations": [
      "Josephstaal Airport",
      "Josephstaal Airport",
      "Josephstaal Airport"
    ],
    "city": [
      "Josephstaal",
      "Josephstaal",
      "Josephstaal"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LSA",
    "translations": [
      "Losuia Airport",
      "Losuia Airport",
      "Losuia Airport"
    ],
    "city": [
      "Losuia",
      "Losuia",
      "Losuia"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KBM",
    "translations": [
      "Kabwum",
      "Kabwum",
      "Kabwum"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KDR",
    "translations": [
      "Kandrian Airport",
      "Kandrian Airport",
      "Kandrian Airport"
    ],
    "city": [
      "Kandrian",
      "Kandrian",
      "Kandrian"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KMF",
    "translations": [
      "Kamina Airport",
      "Kamina Airport",
      "Kamina Airport"
    ],
    "city": [
      "Hoieti",
      "Hoieti",
      "Hoieti"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KPA",
    "translations": [
      "Kopiago Airport",
      "Kopiago Airport",
      "Kopiago Airport"
    ],
    "city": [
      "Kopiago",
      "Kopiago",
      "Kopiago"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KAQ",
    "translations": [
      "Kamulai Airport",
      "Kamulai Airport",
      "Kamulai Airport"
    ],
    "city": [
      "Kamulai Mission",
      "Kamulai Mission",
      "Kamulai Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "UNG",
    "translations": [
      "Kiunga Airport",
      "Kiunga Airport",
      "Kiunga Airport"
    ],
    "city": [
      "Kiunga",
      "Kiunga",
      "Kiunga"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KNE",
    "translations": [
      "Kanainj Airport",
      "Kanainj Airport",
      "Kanainj Airport"
    ],
    "city": [
      "Kanainj",
      "Kanainj",
      "Kanainj"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KRI",
    "translations": [
      "Kikori Airport",
      "Kikori Airport",
      "Kikori Airport"
    ],
    "city": [
      "Kikori",
      "Kikori",
      "Kikori"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KMA",
    "translations": [
      "Kerema Airport",
      "Kerema Airport",
      "Kerema Airport"
    ],
    "city": [
      "Kerema",
      "Kerema",
      "Kerema"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KKD",
    "translations": [
      "Kokoda Airport",
      "Kokoda Airport",
      "Kokoda Airport"
    ],
    "city": [
      "Kokoda",
      "Kokoda",
      "Kokoda"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KGW",
    "translations": [
      "Kagi Airport",
      "Kagi Airport",
      "Kagi Airport"
    ],
    "city": [
      "Kagi",
      "Kagi",
      "Kagi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KRX",
    "translations": [
      "Kar Kar Airport",
      "Kar Kar Airport",
      "Kar Kar Airport"
    ],
    "city": [
      "Kar Kar Island",
      "Kar Kar Island",
      "Kar Kar Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KZF",
    "translations": [
      "Kaintiba Airport",
      "Kaintiba Airport",
      "Kaintiba Airport"
    ],
    "city": [
      "Kaintiba",
      "Kaintiba",
      "Kaintiba"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KUQ",
    "translations": [
      "Kuri Airport",
      "Kuri Airport",
      "Kuri Airport"
    ],
    "city": [
      "Kuri",
      "Kuri",
      "Kuri"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KVG",
    "translations": [
      "Kavieng Airport",
      "Kavieng Airport",
      "Kavieng Airport"
    ],
    "city": [
      "Kavieng",
      "Kavieng",
      "Kavieng"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KWO",
    "translations": [
      "Kawito Airport",
      "Kawito Airport",
      "Kawito Airport"
    ],
    "city": [
      "Kawito",
      "Kawito",
      "Kawito"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LNV",
    "translations": [
      "Londolovit Airport",
      "Londolovit Airport",
      "Londolovit Airport"
    ],
    "city": [
      "Londolovit",
      "Londolovit",
      "Londolovit"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LAB",
    "translations": [
      "Lab Lab Airport",
      "Lab Lab Airport",
      "Lab Lab Airport"
    ],
    "city": [
      "Lab Lab Mission",
      "Lab Lab Mission",
      "Lab Lab Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KEG",
    "translations": [
      "Keglsugl Airport",
      "Keglsugl Airport",
      "Keglsugl Airport"
    ],
    "city": [
      "Denglagu Mission",
      "Denglagu Mission",
      "Denglagu Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KII",
    "translations": [
      "Kibuli Airstrip",
      "Kibuli Airstrip",
      "Kibuli Airstrip"
    ],
    "city": [
      "Kibuli",
      "Kibuli",
      "Kibuli"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LGN",
    "translations": [
      "Linga Linga Airport",
      "Linga Linga Airport",
      "Linga Linga Airport"
    ],
    "city": [
      "Linga Linga",
      "Linga Linga",
      "Linga Linga"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LNM",
    "translations": [
      "Langimar Airport",
      "Langimar Airport",
      "Langimar Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LWI",
    "translations": [
      "Lowai Airport",
      "Lowai Airport",
      "Lowai Airport"
    ],
    "city": [
      "Lowai",
      "Lowai",
      "Lowai"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LPN",
    "translations": [
      "Leron Plains Airport",
      "Leron Plains Airport",
      "Leron Plains Airport"
    ],
    "city": [
      "Leron Plains",
      "Leron Plains",
      "Leron Plains"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LNG",
    "translations": [
      "Lese Airport",
      "Lese Airport",
      "Lese Airport"
    ],
    "city": [
      "Lese",
      "Lese",
      "Lese"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LNC",
    "translations": [
      "Lengbati Airport",
      "Lengbati Airport",
      "Lengbati Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LMI",
    "translations": [
      "Lumi Airport",
      "Lumi Airport",
      "Lumi Airport"
    ],
    "city": [
      "Lumi",
      "Lumi",
      "Lumi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LSJ",
    "translations": [
      "Long Island Airport",
      "Long Island Airport",
      "Long Island Airport"
    ],
    "city": [
      "Long Island",
      "Long Island",
      "Long Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AYM",
    "translations": [
      "Yas Island Seaplane Base",
      "Yas Island Seaplane Base",
      "Yas Island Seaplane Base"
    ],
    "city": [
      "Abu Dhabi",
      "Abu Dhabi",
      "Abu Dhabi"
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "MRM",
    "translations": [
      "Manari Airport",
      "Manari Airport",
      "Manari Airport"
    ],
    "city": [
      "Manari",
      "Manari",
      "Manari"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "OBM",
    "translations": [
      "Morobe Airport",
      "Morobe Airport",
      "Morobe Airport"
    ],
    "city": [
      "Morobe",
      "Morobe",
      "Morobe"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MYX",
    "translations": [
      "Menyamya Airport",
      "Menyamya Airport",
      "Menyamya Airport"
    ],
    "city": [
      "Menyamya",
      "Menyamya",
      "Menyamya"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MAG",
    "translations": [
      "Madang Airport",
      "Madang Airport",
      "Madang Airport"
    ],
    "city": [
      "Madang",
      "Madang",
      "Madang"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "HGU",
    "translations": [
      "Mount Hagen Kagamuga Airport",
      "Mount Hagen Kagamuga Airport",
      "Mount Hagen Kagamuga Airport"
    ],
    "city": [
      "Mount Hagen",
      "Mount Hagen",
      "Mount Hagen"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MXK",
    "translations": [
      "Mindik Airport",
      "Mindik Airport",
      "Mindik Airport"
    ],
    "city": [
      "Mindik",
      "Mindik",
      "Mindik"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MPG",
    "translations": [
      "Makini Airport",
      "Makini Airport",
      "Makini Airport"
    ],
    "city": [
      "Makini",
      "Makini",
      "Makini"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GUV",
    "translations": [
      "Mougulu Airport",
      "Mougulu Airport",
      "Mougulu Airport"
    ],
    "city": [
      "Mougulu",
      "Mougulu",
      "Mougulu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MDU",
    "translations": [
      "Mendi Airport",
      "Mendi Airport",
      "Mendi Airport"
    ],
    "city": [
      "Mendi",
      "Mendi",
      "Mendi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MAS",
    "translations": [
      "Momote Airport",
      "Momote Airport",
      "Momote Airport"
    ],
    "city": [
      "Manus Island",
      "Manus Island",
      "Manus Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MLQ",
    "translations": [
      "Malalaua Airport",
      "Malalaua Airport",
      "Malalaua Airport"
    ],
    "city": [
      "Malalaua",
      "Malalaua",
      "Malalaua"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MQO",
    "translations": [
      "Malam Airport",
      "Malam Airport",
      "Malam Airport"
    ],
    "city": [
      "Malam",
      "Malam",
      "Malam"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MXH",
    "translations": [
      "Moro Airport",
      "Moro Airport",
      "Moro Airport"
    ],
    "city": [
      "Moro",
      "Moro",
      "Moro"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MIS",
    "translations": [
      "Misima Island Airport",
      "Misima Island Airport",
      "Misima Island Airport"
    ],
    "city": [
      "Misima Island",
      "Misima Island",
      "Misima Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MKN",
    "translations": [
      "Malekolon Airport",
      "Malekolon Airport",
      "Malekolon Airport"
    ],
    "city": [
      "Babase Island",
      "Babase Island",
      "Babase Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MWG",
    "translations": [
      "Marawaka Airport",
      "Marawaka Airport",
      "Marawaka Airport"
    ],
    "city": [
      "Marawaka",
      "Marawaka",
      "Marawaka"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MPU",
    "translations": [
      "Mapua(Mabua) Airport",
      "Mapua(Mabua) Airport",
      "Mapua(Mabua) Airport"
    ],
    "city": [
      "Tatau Island",
      "Tatau Island",
      "Tatau Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "NKN",
    "translations": [
      "Nankina Airport",
      "Nankina Airport",
      "Nankina Airport"
    ],
    "city": [
      "Gwarawon",
      "Gwarawon",
      "Gwarawon"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KEX",
    "translations": [
      "Kanabea Airport",
      "Kanabea Airport",
      "Kanabea Airport"
    ],
    "city": [
      "Kanabea",
      "Kanabea",
      "Kanabea"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "NDN",
    "translations": [
      "Nadunumu Airport",
      "Nadunumu Airport",
      "Nadunumu Airport"
    ],
    "city": [
      "Nadunumu",
      "Nadunumu",
      "Nadunumu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AUI",
    "translations": [
      "Aua Island Airport",
      "Aua Island Airport",
      "Aua Island Airport"
    ],
    "city": [
      "Aua Island",
      "Aua Island",
      "Aua Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GBF",
    "translations": [
      "Negarbo(Negabo) Airport",
      "Negarbo(Negabo) Airport",
      "Negarbo(Negabo) Airport"
    ],
    "city": [
      "Negarbo",
      "Negarbo",
      "Negarbo"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MFO",
    "translations": [
      "Manguna Airport",
      "Manguna Airport",
      "Manguna Airport"
    ],
    "city": [
      "Manguna",
      "Manguna",
      "Manguna"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "NUG",
    "translations": [
      "Nuguria Airstrip",
      "Nuguria Airstrip",
      "Nuguria Airstrip"
    ],
    "city": [
      "Nuguria Island",
      "Nuguria Island",
      "Nuguria Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "NDI",
    "translations": [
      "Namudi Airport",
      "Namudi Airport",
      "Namudi Airport"
    ],
    "city": [
      "Namudi",
      "Namudi",
      "Namudi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KSB",
    "translations": [
      "Kasonombe Airport",
      "Kasonombe Airport",
      "Kasonombe Airport"
    ],
    "city": [
      "Kasonombe",
      "Kasonombe",
      "Kasonombe"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KDP",
    "translations": [
      "Kandep Airport",
      "Kandep Airport",
      "Kandep Airport"
    ],
    "city": [
      "Kandep",
      "Kandep",
      "Kandep"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "NMN",
    "translations": [
      "Nomane Airport",
      "Nomane Airport",
      "Nomane Airport"
    ],
    "city": [
      "Namane",
      "Namane",
      "Namane"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BXZ",
    "translations": [
      "Bunsil Airport",
      "Bunsil Airport",
      "Bunsil Airport"
    ],
    "city": [
      "Bunsil - Umboi Island",
      "Bunsil - Umboi Island",
      "Bunsil - Umboi Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "UKU",
    "translations": [
      "Nuku Airport",
      "Nuku Airport",
      "Nuku Airport"
    ],
    "city": [
      "Nuku",
      "Nuku",
      "Nuku"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "ATN",
    "translations": [
      "Namatanai Airport",
      "Namatanai Airport",
      "Namatanai Airport"
    ],
    "city": [
      "Namatanai",
      "Namatanai",
      "Namatanai"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "NBA",
    "translations": [
      "Nambaiyufa Airport",
      "Nambaiyufa Airport",
      "Nambaiyufa Airport"
    ],
    "city": [
      "Nambaiyufa",
      "Nambaiyufa",
      "Nambaiyufa"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LAE",
    "translations": [
      "Nadzab Airport",
      "Nadzab Airport",
      "Nadzab Airport"
    ],
    "city": [
      "Lae",
      "Lae",
      "Lae"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "OBX",
    "translations": [
      "Obo Airport",
      "Obo Airport",
      "Obo Airport"
    ],
    "city": [
      "Obo",
      "Obo",
      "Obo"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KGB",
    "translations": [
      "Konge Airport",
      "Konge Airport",
      "Konge Airport"
    ],
    "city": [
      "Konge",
      "Konge",
      "Konge"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "OKV",
    "translations": [
      "Okao Airport",
      "Okao Airport",
      "Okao Airport"
    ],
    "city": [
      "Okao",
      "Okao",
      "Okao"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "OGE",
    "translations": [
      "Ogeranang Airport",
      "Ogeranang Airport",
      "Ogeranang Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "OKP",
    "translations": [
      "Oksapmin Airport",
      "Oksapmin Airport",
      "Oksapmin Airport"
    ],
    "city": [
      "Oksapmin",
      "Oksapmin",
      "Oksapmin"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "HOC",
    "translations": [
      "Komako Airport",
      "Komako Airport",
      "Komako Airport"
    ],
    "city": [
      "Komako",
      "Komako",
      "Komako"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KQL",
    "translations": [
      "Kol Airport",
      "Kol Airport",
      "Kol Airport"
    ],
    "city": [
      "Kol",
      "Kol",
      "Kol"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "OSE",
    "translations": [
      "Omora Airport",
      "Omora Airport",
      "Omora Airport"
    ],
    "city": [
      "Omora",
      "Omora",
      "Omora"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KOM",
    "translations": [
      "Komo-Manda Airport",
      "Komo-Manda Airport",
      "Komo-Manda Airport"
    ],
    "city": [
      "Komo",
      "Komo",
      "Komo"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KSP",
    "translations": [
      "Kosipe Airport",
      "Kosipe Airport",
      "Kosipe Airport"
    ],
    "city": [
      "Kosipe Mission",
      "Kosipe Mission",
      "Kosipe Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KCJ",
    "translations": [
      "Komaio Airport",
      "Komaio Airport",
      "Komaio Airport"
    ],
    "city": [
      "Komaio",
      "Komaio",
      "Komaio"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "OLQ",
    "translations": [
      "Olsobip Airport",
      "Olsobip Airport",
      "Olsobip Airport"
    ],
    "city": [
      "Olsobip",
      "Olsobip",
      "Olsobip"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KDE",
    "translations": [
      "Koroba Airport",
      "Koroba Airport",
      "Koroba Airport"
    ],
    "city": [
      "Koroba",
      "Koroba",
      "Koroba"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "OPB",
    "translations": [
      "Open Bay Airport",
      "Open Bay Airport",
      "Open Bay Airport"
    ],
    "city": [
      "Maitanakunai",
      "Maitanakunai",
      "Maitanakunai"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PLE",
    "translations": [
      "Paiela Airport",
      "Paiela Airport",
      "Paiela Airport"
    ],
    "city": [
      "Paiela",
      "Paiela",
      "Paiela"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PGB",
    "translations": [
      "Pangoa Airport",
      "Pangoa Airport",
      "Pangoa Airport"
    ],
    "city": [
      "Pangoa",
      "Pangoa",
      "Pangoa"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PDI",
    "translations": [
      "Pindiu Airport",
      "Pindiu Airport",
      "Pindiu Airport"
    ],
    "city": [
      "Pindiu",
      "Pindiu",
      "Pindiu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "APR",
    "translations": [
      "April River Airport",
      "April River Airport",
      "April River Airport"
    ],
    "city": [
      "April River",
      "April River",
      "April River"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PGN",
    "translations": [
      "Pangia Airport",
      "Pangia Airport",
      "Pangia Airport"
    ],
    "city": [
      "Pangia",
      "Pangia",
      "Pangia"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PMP",
    "translations": [
      "Pimaga Airport",
      "Pimaga Airport",
      "Pimaga Airport"
    ],
    "city": [
      "Pimaga",
      "Pimaga",
      "Pimaga"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MPF",
    "translations": [
      "Mapoda Airport",
      "Mapoda Airport",
      "Mapoda Airport"
    ],
    "city": [
      "Mapoda",
      "Mapoda",
      "Mapoda"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PMN",
    "translations": [
      "Pumani Airport",
      "Pumani Airport",
      "Pumani Airport"
    ],
    "city": [
      "Pumani",
      "Pumani",
      "Pumani"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WLU",
    "translations": [
      "Walluanda Airport",
      "Walluanda Airport",
      "Walluanda Airport"
    ],
    "city": [
      "Puri",
      "Puri",
      "Puri"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "POM",
    "translations": [
      "Port Moresby Jacksons International Airport",
      "Port Moresby Jacksons International Airport",
      "Port Moresby Jacksons International Airport"
    ],
    "city": [
      "Port Moresby",
      "Port Moresby",
      "Port Moresby"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KRJ",
    "translations": [
      "Karawari Airstrip",
      "Karawari Airstrip",
      "Karawari Airstrip"
    ],
    "city": [
      "Amboin",
      "Amboin",
      "Amboin"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TLP",
    "translations": [
      "Tumolbil Airport",
      "Tumolbil Airport",
      "Tumolbil Airport"
    ],
    "city": [
      "Tumolbil",
      "Tumolbil",
      "Tumolbil"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SPH",
    "translations": [
      "Sopu Airport",
      "Sopu Airport",
      "Sopu Airport"
    ],
    "city": [
      "Sopu",
      "Sopu",
      "Sopu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "ONB",
    "translations": [
      "Ononge Airport",
      "Ononge Airport",
      "Ononge Airport"
    ],
    "city": [
      "Onange Mission",
      "Onange Mission",
      "Onange Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SXA",
    "translations": [
      "Sialum Airport",
      "Sialum Airport",
      "Sialum Airport"
    ],
    "city": [
      "Sialum",
      "Sialum",
      "Sialum"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KIQ",
    "translations": [
      "Kira Airport",
      "Kira Airport",
      "Kira Airport"
    ],
    "city": [
      "Kira",
      "Kira",
      "Kira"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "RBP",
    "translations": [
      "Raba Raba Airport",
      "Raba Raba Airport",
      "Raba Raba Airport"
    ],
    "city": [
      "Rabaraba",
      "Rabaraba",
      "Rabaraba"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "RMN",
    "translations": [
      "Rumginae Airport",
      "Rumginae Airport",
      "Rumginae Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KMR",
    "translations": [
      "Karimui Airport",
      "Karimui Airport",
      "Karimui Airport"
    ],
    "city": [
      "Karimui",
      "Karimui",
      "Karimui"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "RKU",
    "translations": [
      "Kairuku Airport",
      "Kairuku Airport",
      "Kairuku Airport"
    ],
    "city": [
      "Yule Island",
      "Yule Island",
      "Yule Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MWI",
    "translations": [
      "Maramuni Airport",
      "Maramuni Airport",
      "Maramuni Airport"
    ],
    "city": [
      "Maramuni",
      "Maramuni",
      "Maramuni"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KOR",
    "translations": [
      "Kakoro(Koroko) Airstrip",
      "Kakoro(Koroko) Airstrip",
      "Kakoro(Koroko) Airstrip"
    ],
    "city": [
      "Kakoro",
      "Kakoro",
      "Kakoro"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MRH",
    "translations": [
      "May River Airstrip",
      "May River Airstrip",
      "May River Airstrip"
    ],
    "city": [
      "May River",
      "May River",
      "May River"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SBE",
    "translations": [
      "Suabi Airport",
      "Suabi Airport",
      "Suabi Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SDI",
    "translations": [
      "Saidor Airport",
      "Saidor Airport",
      "Saidor Airport"
    ],
    "city": [
      "Saidor",
      "Saidor",
      "Saidor"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "NIS",
    "translations": [
      "Simberi Airport",
      "Simberi Airport",
      "Simberi Airport"
    ],
    "city": [
      "Simberi Island",
      "Simberi Island",
      "Simberi Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SFU",
    "translations": [
      "Safia Airport",
      "Safia Airport",
      "Safia Airport"
    ],
    "city": [
      "Safia",
      "Safia",
      "Safia"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SIL",
    "translations": [
      "Sila Airport",
      "Sila Airport",
      "Sila Airport"
    ],
    "city": [
      "Sila Mission",
      "Sila Mission",
      "Sila Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SBV",
    "translations": [
      "Sabah Airport",
      "Sabah Airport",
      "Sabah Airport"
    ],
    "city": [
      "Sabah",
      "Sabah",
      "Sabah"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SIM",
    "translations": [
      "Simbai Airport",
      "Simbai Airport",
      "Simbai Airport"
    ],
    "city": [
      "Simbai",
      "Simbai",
      "Simbai"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SGK",
    "translations": [
      "Sengapi Airstrip",
      "Sengapi Airstrip",
      "Sengapi Airstrip"
    ],
    "city": [
      "Sengapi",
      "Sengapi",
      "Sengapi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SXH",
    "translations": [
      "Sehulea Airport",
      "Sehulea Airport",
      "Sehulea Airport"
    ],
    "city": [
      "Sehulea",
      "Sehulea",
      "Sehulea"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SBC",
    "translations": [
      "Selbang Airport",
      "Selbang Airport",
      "Selbang Airport"
    ],
    "city": [
      "Selbang",
      "Selbang",
      "Selbang"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SMH",
    "translations": [
      "Sapmanga Airport",
      "Sapmanga Airport",
      "Sapmanga Airport"
    ],
    "city": [
      "Sapmanga",
      "Sapmanga",
      "Sapmanga"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SPV",
    "translations": [
      "Sepik Plains Airport",
      "Sepik Plains Airport",
      "Sepik Plains Airport"
    ],
    "city": [
      "Sepik Plains",
      "Sepik Plains",
      "Sepik Plains"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TDS",
    "translations": [
      "Sasereme Airport",
      "Sasereme Airport",
      "Sasereme Airport"
    ],
    "city": [
      "Sasereme",
      "Sasereme",
      "Sasereme"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SKC",
    "translations": [
      "Suki Airport",
      "Suki Airport",
      "Suki Airport"
    ],
    "city": [
      "Suki",
      "Suki",
      "Suki"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SXW",
    "translations": [
      "Sauren Airport",
      "Sauren Airport",
      "Sauren Airport"
    ],
    "city": [
      "Sauren",
      "Sauren",
      "Sauren"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SWG",
    "translations": [
      "Satwag Airport",
      "Satwag Airport",
      "Satwag Airport"
    ],
    "city": [
      "Satwag",
      "Satwag",
      "Satwag"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MBV",
    "translations": [
      "Masa Airport",
      "Masa Airport",
      "Masa Airport"
    ],
    "city": [
      "Masa",
      "Masa",
      "Masa"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TIZ",
    "translations": [
      "Tari Airport",
      "Tari Airport",
      "Tari Airport"
    ],
    "city": [
      "Tari",
      "Tari",
      "Tari"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TBG",
    "translations": [
      "Tabubil Airport",
      "Tabubil Airport",
      "Tabubil Airport"
    ],
    "city": [
      "Tabubil",
      "Tabubil",
      "Tabubil"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TFM",
    "translations": [
      "Telefomin Airport",
      "Telefomin Airport",
      "Telefomin Airport"
    ],
    "city": [
      "Telefomin",
      "Telefomin",
      "Telefomin"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TDB",
    "translations": [
      "Tetebedi Airport",
      "Tetebedi Airport",
      "Tetebedi Airport"
    ],
    "city": [
      "Tetebedi",
      "Tetebedi",
      "Tetebedi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TGL",
    "translations": [
      "Tagula Airport",
      "Tagula Airport",
      "Tagula Airport"
    ],
    "city": [
      "Sudest Island",
      "Sudest Island",
      "Sudest Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TFB",
    "translations": [
      "Tifalmin Airport",
      "Tifalmin Airport",
      "Tifalmin Airport"
    ],
    "city": [
      "Tifalmin",
      "Tifalmin",
      "Tifalmin"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TPI",
    "translations": [
      "Tapini Airport",
      "Tapini Airport",
      "Tapini Airport"
    ],
    "city": [
      "Tapini",
      "Tapini",
      "Tapini"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "RAB",
    "translations": [
      "Tokua Airport",
      "Tokua Airport",
      "Tokua Airport"
    ],
    "city": [
      "Kokopo",
      "Kokopo",
      "Kokopo"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TKW",
    "translations": [
      "Tekin Airport",
      "Tekin Airport",
      "Tekin Airport"
    ],
    "city": [
      "Tekin",
      "Tekin",
      "Tekin"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KDQ",
    "translations": [
      "Kamberatoro Airport",
      "Kamberatoro Airport",
      "Kamberatoro Airport"
    ],
    "city": [
      "Kamberatoro Mission",
      "Kamberatoro Mission",
      "Kamberatoro Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TEP",
    "translations": [
      "Tep Tep Airport",
      "Tep Tep Airport",
      "Tep Tep Airport"
    ],
    "city": [
      "Teptep",
      "Teptep",
      "Teptep"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TBQ",
    "translations": [
      "Tarabo Airport",
      "Tarabo Airport",
      "Tarabo Airport"
    ],
    "city": [
      "Tarabo",
      "Tarabo",
      "Tarabo"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TSW",
    "translations": [
      "Tsewi Airport",
      "Tsewi Airport",
      "Tsewi Airport"
    ],
    "city": [
      "Tsewi",
      "Tsewi",
      "Tsewi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TRJ",
    "translations": [
      "Tarakbits Airport",
      "Tarakbits Airport",
      "Tarakbits Airport"
    ],
    "city": [
      "Tarakbits",
      "Tarakbits",
      "Tarakbits"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TFI",
    "translations": [
      "Tufi Airport",
      "Tufi Airport",
      "Tufi Airport"
    ],
    "city": [
      "Tufi",
      "Tufi",
      "Tufi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TBE",
    "translations": [
      "Timbunke Airport",
      "Timbunke Airport",
      "Timbunke Airport"
    ],
    "city": [
      "Timbunke",
      "Timbunke",
      "Timbunke"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TWY",
    "translations": [
      "Tawa Airport",
      "Tawa Airport",
      "Tawa Airport"
    ],
    "city": [
      "Tawa",
      "Tawa",
      "Tawa"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TEO",
    "translations": [
      "Terapo Airport",
      "Terapo Airport",
      "Terapo Airport"
    ],
    "city": [
      "Terapo Mission",
      "Terapo Mission",
      "Terapo Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TKB",
    "translations": [
      "Tekadu Airport",
      "Tekadu Airport",
      "Tekadu Airport"
    ],
    "city": [
      "Tekadu",
      "Tekadu",
      "Tekadu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "UMC",
    "translations": [
      "Umba Airport",
      "Umba Airport",
      "Umba Airport"
    ],
    "city": [
      "Umba",
      "Umba",
      "Umba"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "URU",
    "translations": [
      "Uroubi Airport",
      "Uroubi Airport",
      "Uroubi Airport"
    ],
    "city": [
      "Uroubi",
      "Uroubi",
      "Uroubi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "UBI",
    "translations": [
      "Buin Airport",
      "Buin Airport",
      "Buin Airport"
    ],
    "city": [
      "Buin",
      "Buin",
      "Buin"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AUV",
    "translations": [
      "Aumo Airport",
      "Aumo Airport",
      "Aumo Airport"
    ],
    "city": [
      "Aumo",
      "Aumo",
      "Aumo"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GLP",
    "translations": [
      "Gulgubip Airport",
      "Gulgubip Airport",
      "Gulgubip Airport"
    ],
    "city": [
      "Gulgubip",
      "Gulgubip",
      "Gulgubip"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "UPR",
    "translations": [
      "Upiara Airport",
      "Upiara Airport",
      "Upiara Airport"
    ],
    "city": [
      "Upiara",
      "Upiara",
      "Upiara"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KUX",
    "translations": [
      "Kuyol Airport",
      "Kuyol Airport",
      "Kuyol Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "UVO",
    "translations": [
      "Uvol Airport",
      "Uvol Airport",
      "Uvol Airport"
    ],
    "city": [
      "Uvol",
      "Uvol",
      "Uvol"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TLW",
    "translations": [
      "Talasea Airport",
      "Talasea Airport",
      "Talasea Airport"
    ],
    "city": [
      "Talasea",
      "Talasea",
      "Talasea"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TCJ",
    "translations": [
      "Torembi Airport",
      "Torembi Airport",
      "Torembi Airport"
    ],
    "city": [
      "Torembi",
      "Torembi",
      "Torembi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "VAI",
    "translations": [
      "Vanimo Airport",
      "Vanimo Airport",
      "Vanimo Airport"
    ],
    "city": [
      "Vanimo",
      "Vanimo",
      "Vanimo"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TON",
    "translations": [
      "Tonu Airport",
      "Tonu Airport",
      "Tonu Airport"
    ],
    "city": [
      "Tonu",
      "Tonu",
      "Tonu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WUV",
    "translations": [
      "Wuvulu Island Airport",
      "Wuvulu Island Airport",
      "Wuvulu Island Airport"
    ],
    "city": [
      "Wuvulu Island",
      "Wuvulu Island",
      "Wuvulu Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WAO",
    "translations": [
      "Wabo Airport",
      "Wabo Airport",
      "Wabo Airport"
    ],
    "city": [
      "Wabo",
      "Wabo",
      "Wabo"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WTT",
    "translations": [
      "Wantoat Airport",
      "Wantoat Airport",
      "Wantoat Airport"
    ],
    "city": [
      "Wantoat",
      "Wantoat",
      "Wantoat"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WBM",
    "translations": [
      "Wapenamanda Airport",
      "Wapenamanda Airport",
      "Wapenamanda Airport"
    ],
    "city": [
      "Wapenamanda",
      "Wapenamanda",
      "Wapenamanda"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WAJ",
    "translations": [
      "Wawoi Falls Airport",
      "Wawoi Falls Airport",
      "Wawoi Falls Airport"
    ],
    "city": [
      "Wavoi Falls",
      "Wavoi Falls",
      "Wavoi Falls"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AGL",
    "translations": [
      "Wanigela Airport",
      "Wanigela Airport",
      "Wanigela Airport"
    ],
    "city": [
      "Wanigela",
      "Wanigela",
      "Wanigela"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WNU",
    "translations": [
      "Wanuma Airport",
      "Wanuma Airport",
      "Wanuma Airport"
    ],
    "city": [
      "Wanuma",
      "Wanuma",
      "Wanuma"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WBC",
    "translations": [
      "Wapolu Airport",
      "Wapolu Airport",
      "Wapolu Airport"
    ],
    "city": [
      "Wapolu",
      "Wapolu",
      "Wapolu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WWK",
    "translations": [
      "Wewak International Airport",
      "Wewak International Airport",
      "Wewak International Airport"
    ],
    "city": [
      "Wewak",
      "Wewak",
      "Wewak"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WOA",
    "translations": [
      "Wonenara Airport",
      "Wonenara Airport",
      "Wonenara Airport"
    ],
    "city": [
      "Wonenara",
      "Wonenara",
      "Wonenara"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WKN",
    "translations": [
      "Wakunai Airport",
      "Wakunai Airport",
      "Wakunai Airport"
    ],
    "city": [
      "Wakunai",
      "Wakunai",
      "Wakunai"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WSU",
    "translations": [
      "Wasu Airport",
      "Wasu Airport",
      "Wasu Airport"
    ],
    "city": [
      "Wasu",
      "Wasu",
      "Wasu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WTP",
    "translations": [
      "Woitape Airport",
      "Woitape Airport",
      "Woitape Airport"
    ],
    "city": [
      "Fatima Mission",
      "Fatima Mission",
      "Fatima Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WUG",
    "translations": [
      "Wau Airport",
      "Wau Airport",
      "Wau Airport"
    ],
    "city": [
      "Wau",
      "Wau",
      "Wau"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "YVD",
    "translations": [
      "Yeva Airport",
      "Yeva Airport",
      "Yeva Airport"
    ],
    "city": [
      "Yeva",
      "Yeva",
      "Yeva"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SMJ",
    "translations": [
      "Sim Airport",
      "Sim Airport",
      "Sim Airport"
    ],
    "city": [
      "Sim",
      "Sim",
      "Sim"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TLO",
    "translations": [
      "Tol Airport",
      "Tol Airport",
      "Tol Airport"
    ],
    "city": [
      "Tol",
      "Tol",
      "Tol"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WPM",
    "translations": [
      "Wipim Airport",
      "Wipim Airport",
      "Wipim Airport"
    ],
    "city": [
      "Wipim",
      "Wipim",
      "Wipim"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WEP",
    "translations": [
      "Weam Airport",
      "Weam Airport",
      "Weam Airport"
    ],
    "city": [
      "Weam",
      "Weam",
      "Weam"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AYY",
    "translations": [
      "Arugam Bay SPB",
      "Arugam Bay SPB",
      "Arugam Bay SPB"
    ],
    "city": [
      "Pottuvil",
      "Pottuvil",
      "Pottuvil"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "KYX",
    "translations": [
      "Yalumet Airport",
      "Yalumet Airport",
      "Yalumet Airport"
    ],
    "city": [
      "Yalumet",
      "Yalumet",
      "Yalumet"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "YEQ",
    "translations": [
      "Yenkis(Yankisa) Airport",
      "Yenkis(Yankisa) Airport",
      "Yenkis(Yankisa) Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TCK",
    "translations": [
      "Tinboli Airport",
      "Tinboli Airport",
      "Tinboli Airport"
    ],
    "city": [
      "Tinboli",
      "Tinboli",
      "Tinboli"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LNF",
    "translations": [
      "Munbil Airport",
      "Munbil Airport",
      "Munbil Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "RAX",
    "translations": [
      "Oram Airport",
      "Oram Airport",
      "Oram Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KPE",
    "translations": [
      "Yapsiei Airport",
      "Yapsiei Airport",
      "Yapsiei Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KSX",
    "translations": [
      "Yasuru Airport",
      "Yasuru Airport",
      "Yasuru Airport"
    ],
    "city": [
      "Yasuru",
      "Yasuru",
      "Yasuru"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "ZEN",
    "translations": [
      "Zenag Airport",
      "Zenag Airport",
      "Zenag Airport"
    ],
    "city": [
      "Zenag",
      "Zenag",
      "Zenag"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SWR",
    "translations": [
      "Silur Airport",
      "Silur Airport",
      "Silur Airport"
    ],
    "city": [
      "Silur Mission",
      "Silur Mission",
      "Silur Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WUM",
    "translations": [
      "Wasum Airport",
      "Wasum Airport",
      "Wasum Airport"
    ],
    "city": [
      "Wasum",
      "Wasum",
      "Wasum"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SIZ",
    "translations": [
      "Sissano Airport",
      "Sissano Airport",
      "Sissano Airport"
    ],
    "city": [
      "Sissano",
      "Sissano",
      "Sissano"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "OSG",
    "translations": [
      "Ossima Airport",
      "Ossima Airport",
      "Ossima Airport"
    ],
    "city": [
      "Ossima",
      "Ossima",
      "Ossima"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "ZXT",
    "translations": [
      "Zabrat Airport",
      "Zabrat Airport",
      "Zabrat Airport"
    ],
    "city": [
      "Zabrat",
      "Zabrat",
      "Zabrat"
    ],
    "country": [
      "AZ",
      "AZ",
      "AZ"
    ]
  },
  {
    "iata": "HAE",
    "translations": [
      "Lava Falls Heliport",
      "Lava Falls Heliport",
      "Lava Falls Heliport"
    ],
    "city": [
      "Supai Village",
      "Supai Village",
      "Supai Village"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AZB",
    "translations": [
      "Amazon Bay Airport",
      "Amazon Bay Airport",
      "Amazon Bay Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BAJ",
    "translations": [
      "Bali Airport",
      "Bali Airport",
      "Bali Airport"
    ],
    "city": [
      "Unea Island",
      "Unea Island",
      "Unea Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BCW",
    "translations": [
      "Benguera Island Airport",
      "Benguera Island Airport",
      "Benguera Island Airport"
    ],
    "city": [
      "Benguera Island",
      "Benguera Island",
      "Benguera Island"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "BCZ",
    "translations": [
      "Milyakburra Airport",
      "Milyakburra Airport",
      "Milyakburra Airport"
    ],
    "city": [
      "Bickerton Island",
      "Bickerton Island",
      "Bickerton Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "JAM",
    "translations": [
      "Bezmer Air Base",
      "Bezmer Air Base",
      "Bezmer Air Base"
    ],
    "city": [
      "Bezmer",
      "Bezmer",
      "Bezmer"
    ],
    "country": [
      "BG",
      "BG",
      "BG"
    ]
  },
  {
    "iata": "JEG",
    "translations": [
      "Aasiaat Airport",
      "Aasiaat Airport",
      "Aasiaat Airport"
    ],
    "city": [
      "Aasiaat",
      "Aasiaat",
      "Aasiaat"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "AOQ",
    "translations": [
      "Aappilattoq Heliport",
      "Aappilattoq Heliport",
      "Aappilattoq Heliport"
    ],
    "city": [
      "Aappilattoq",
      "Aappilattoq",
      "Aappilattoq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "AGM",
    "translations": [
      "Tasiilaq Heliport",
      "Tasiilaq Heliport",
      "Tasiilaq Heliport"
    ],
    "city": [
      "Tasiilaq",
      "Tasiilaq",
      "Tasiilaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "LLU",
    "translations": [
      "Alluitsup Paa Heliport",
      "Alluitsup Paa Heliport",
      "Alluitsup Paa Heliport"
    ],
    "city": [
      "Alluitsup Paa",
      "Alluitsup Paa",
      "Alluitsup Paa"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "QUV",
    "translations": [
      "Aappilattoq Heliport",
      "Aappilattoq Heliport",
      "Aappilattoq Heliport"
    ],
    "city": [
      "Aappilattoq",
      "Aappilattoq",
      "Aappilattoq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JRK",
    "translations": [
      "Arsuk Heliport",
      "Arsuk Heliport",
      "Arsuk Heliport"
    ],
    "city": [
      "Arsuk",
      "Arsuk",
      "Arsuk"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "QUW",
    "translations": [
      "Ammassivik Heliport",
      "Ammassivik Heliport",
      "Ammassivik Heliport"
    ],
    "city": [
      "Ammassivik",
      "Ammassivik",
      "Ammassivik"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "QGQ",
    "translations": [
      "Attu Heliport",
      "Attu Heliport",
      "Attu Heliport"
    ],
    "city": [
      "Attu",
      "Attu",
      "Attu"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "UAK",
    "translations": [
      "Narsarsuaq Airport",
      "Narsarsuaq Airport",
      "Narsarsuaq Airport"
    ],
    "city": [
      "Narsarsuaq",
      "Narsarsuaq",
      "Narsarsuaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JCH",
    "translations": [
      "Qasigiannguit Heliport",
      "Qasigiannguit Heliport",
      "Qasigiannguit Heliport"
    ],
    "city": [
      "Qasigiannguit",
      "Qasigiannguit",
      "Qasigiannguit"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "CNP",
    "translations": [
      "Neerlerit Inaat Airport",
      "Neerlerit Inaat Airport",
      "Neerlerit Inaat Airport"
    ],
    "city": [
      "Neerlerit Inaat",
      "Neerlerit Inaat",
      "Neerlerit Inaat"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "QFG",
    "translations": [
      "Eqalugaarsuit Heliport",
      "Eqalugaarsuit Heliport",
      "Eqalugaarsuit Heliport"
    ],
    "city": [
      "Eqalugaarsuit",
      "Eqalugaarsuit",
      "Eqalugaarsuit"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "QFN",
    "translations": [
      "Narsarmijit Heliport",
      "Narsarmijit Heliport",
      "Narsarmijit Heliport"
    ],
    "city": [
      "Narsarmijit",
      "Narsarmijit",
      "Narsarmijit"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JGR",
    "translations": [
      "Kangilinnguit Heliport",
      "Kangilinnguit Heliport",
      "Kangilinnguit Heliport"
    ],
    "city": [
      "Kangilinnguit",
      "Kangilinnguit",
      "Kangilinnguit"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "GOH",
    "translations": [
      "Nuuk Airport",
      "Nuuk Airport",
      "Nuuk Airport"
    ],
    "city": [
      "Nuuk",
      "Nuuk",
      "Nuuk"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JGO",
    "translations": [
      "Qeqertarsuaq Heliport",
      "Qeqertarsuaq Heliport",
      "Qeqertarsuaq Heliport"
    ],
    "city": [
      "Qeqertarsuaq",
      "Qeqertarsuaq",
      "Qeqertarsuaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "IKE",
    "translations": [
      "Ikerasak Heliport",
      "Ikerasak Heliport",
      "Ikerasak Heliport"
    ],
    "city": [
      "Ikerasak",
      "Ikerasak",
      "Ikerasak"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "QFI",
    "translations": [
      "Iginniarfik Heliport",
      "Iginniarfik Heliport",
      "Iginniarfik Heliport"
    ],
    "city": [
      "Iginniarfik",
      "Iginniarfik",
      "Iginniarfik"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "QRY",
    "translations": [
      "Ikerassaarsuk Heliport",
      "Ikerassaarsuk Heliport",
      "Ikerassaarsuk Heliport"
    ],
    "city": [
      "Ikerassaarsuk",
      "Ikerassaarsuk",
      "Ikerassaarsuk"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "XIQ",
    "translations": [
      "Ilimanaq Heliport",
      "Ilimanaq Heliport",
      "Ilimanaq Heliport"
    ],
    "city": [
      "Ilimanaq",
      "Ilimanaq",
      "Ilimanaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "IUI",
    "translations": [
      "Innarsuit Heliport",
      "Innarsuit Heliport",
      "Innarsuit Heliport"
    ],
    "city": [
      "Innarsuit",
      "Innarsuit",
      "Innarsuit"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "IOQ",
    "translations": [
      "Isortoq Heliport",
      "Isortoq Heliport",
      "Isortoq Heliport"
    ],
    "city": [
      "Isortoq",
      "Isortoq",
      "Isortoq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "QJI",
    "translations": [
      "Ikamiut Heliport",
      "Ikamiut Heliport",
      "Ikamiut Heliport"
    ],
    "city": [
      "Ikamiut",
      "Ikamiut",
      "Ikamiut"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JJU",
    "translations": [
      "Qaqortoq Heliport",
      "Qaqortoq Heliport",
      "Qaqortoq Heliport"
    ],
    "city": [
      "Qaqortoq",
      "Qaqortoq",
      "Qaqortoq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JAV",
    "translations": [
      "Ilulissat Airport",
      "Ilulissat Airport",
      "Ilulissat Airport"
    ],
    "city": [
      "Ilulissat",
      "Ilulissat",
      "Ilulissat"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "QPW",
    "translations": [
      "Kangaatsiaq Heliport",
      "Kangaatsiaq Heliport",
      "Kangaatsiaq Heliport"
    ],
    "city": [
      "Kangaatsiaq",
      "Kangaatsiaq",
      "Kangaatsiaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "KUS",
    "translations": [
      "Kulusuk Airport",
      "Kulusuk Airport",
      "Kulusuk Airport"
    ],
    "city": [
      "Kulusuk",
      "Kulusuk",
      "Kulusuk"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "KUZ",
    "translations": [
      "Kuummiut Heliport",
      "Kuummiut Heliport",
      "Kuummiut Heliport"
    ],
    "city": [
      "Kuummiut",
      "Kuummiut",
      "Kuummiut"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "KHQ",
    "translations": [
      "Kullorsuaq Heliport",
      "Kullorsuaq Heliport",
      "Kullorsuaq Heliport"
    ],
    "city": [
      "Kullorsuaq",
      "Kullorsuaq",
      "Kullorsuaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "KGQ",
    "translations": [
      "Kangersuatsiaq Heliport",
      "Kangersuatsiaq Heliport",
      "Kangersuatsiaq Heliport"
    ],
    "city": [
      "Kangersuatsiaq",
      "Kangersuatsiaq",
      "Kangersuatsiaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "QJE",
    "translations": [
      "Kitsissuarsuit Heliport",
      "Kitsissuarsuit Heliport",
      "Kitsissuarsuit Heliport"
    ],
    "city": [
      "Kitsissuarsuit",
      "Kitsissuarsuit",
      "Kitsissuarsuit"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "IOT",
    "translations": [
      "Illorsuit Heliport",
      "Illorsuit Heliport",
      "Illorsuit Heliport"
    ],
    "city": [
      "Illorsuit",
      "Illorsuit",
      "Illorsuit"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JSU",
    "translations": [
      "Maniitsoq Airport",
      "Maniitsoq Airport",
      "Maniitsoq Airport"
    ],
    "city": [
      "Maniitsoq",
      "Maniitsoq",
      "Maniitsoq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JNN",
    "translations": [
      "Nanortalik Heliport",
      "Nanortalik Heliport",
      "Nanortalik Heliport"
    ],
    "city": [
      "Nanortalik",
      "Nanortalik",
      "Nanortalik"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JUU",
    "translations": [
      "Nuugaatsiaq Heliport",
      "Nuugaatsiaq Heliport",
      "Nuugaatsiaq Heliport"
    ],
    "city": [
      "Nuugaatsiaq",
      "Nuugaatsiaq",
      "Nuugaatsiaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JNS",
    "translations": [
      "Narsaq Heliport",
      "Narsaq Heliport",
      "Narsaq Heliport"
    ],
    "city": [
      "Narsaq",
      "Narsaq",
      "Narsaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "NIQ",
    "translations": [
      "Niaqornat Heliport",
      "Niaqornat Heliport",
      "Niaqornat Heliport"
    ],
    "city": [
      "Niaqornat",
      "Niaqornat",
      "Niaqornat"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "NSQ",
    "translations": [
      "Nuussuaq Heliport",
      "Nuussuaq Heliport",
      "Nuussuaq Heliport"
    ],
    "city": [
      "Nuussuaq",
      "Nuussuaq",
      "Nuussuaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JFR",
    "translations": [
      "Paamiut Airport",
      "Paamiut Airport",
      "Paamiut Airport"
    ],
    "city": [
      "Paamiut",
      "Paamiut",
      "Paamiut"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "PQT",
    "translations": [
      "Qeqertaq Heliport",
      "Qeqertaq Heliport",
      "Qeqertaq Heliport"
    ],
    "city": [
      "Qeqertaq",
      "Qeqertaq",
      "Qeqertaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "NAQ",
    "translations": [
      "Qaanaaq Airport",
      "Qaanaaq Airport",
      "Qaanaaq Airport"
    ],
    "city": [
      "Qaanaaq",
      "Qaanaaq",
      "Qaanaaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "QJH",
    "translations": [
      "Qassimiut Heliport",
      "Qassimiut Heliport",
      "Qassimiut Heliport"
    ],
    "city": [
      "Qassimiut",
      "Qassimiut",
      "Qassimiut"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "OBY",
    "translations": [
      "Ittoqqortoormiit Heliport",
      "Ittoqqortoormiit Heliport",
      "Ittoqqortoormiit Heliport"
    ],
    "city": [
      "Ittoqqortoormiit",
      "Ittoqqortoormiit",
      "Ittoqqortoormiit"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "SFJ",
    "translations": [
      "Kangerlussuaq Airport",
      "Kangerlussuaq Airport",
      "Kangerlussuaq Airport"
    ],
    "city": [
      "Kangerlussuaq",
      "Kangerlussuaq",
      "Kangerlussuaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "SGG",
    "translations": [
      "Sermiligaaq Heliport",
      "Sermiligaaq Heliport",
      "Sermiligaaq Heliport"
    ],
    "city": [
      "Sermiligaaq",
      "Sermiligaaq",
      "Sermiligaaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "SRK",
    "translations": [
      "Siorapaluk Heliport",
      "Siorapaluk Heliport",
      "Siorapaluk Heliport"
    ],
    "city": [
      "Siorapaluk",
      "Siorapaluk",
      "Siorapaluk"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "QOQ",
    "translations": [
      "Saarloq Heliport",
      "Saarloq Heliport",
      "Saarloq Heliport"
    ],
    "city": [
      "Saarloq",
      "Saarloq",
      "Saarloq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JHS",
    "translations": [
      "Sisimiut Airport",
      "Sisimiut Airport",
      "Sisimiut Airport"
    ],
    "city": [
      "Sisimiut",
      "Sisimiut",
      "Sisimiut"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "SAE",
    "translations": [
      "Saattut Heliport",
      "Saattut Heliport",
      "Saattut Heliport"
    ],
    "city": [
      "Saattut",
      "Saattut",
      "Saattut"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "SVR",
    "translations": [
      "Savissivik Heliport",
      "Savissivik Heliport",
      "Savissivik Heliport"
    ],
    "city": [
      "Savissivik",
      "Savissivik",
      "Savissivik"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "TQA",
    "translations": [
      "Tasiusaq Heliport",
      "Tasiusaq Heliport",
      "Tasiusaq Heliport"
    ],
    "city": [
      "Tasiusaq",
      "Tasiusaq",
      "Tasiusaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "THU",
    "translations": [
      "Pituffik Space Base",
      "Pituffik Space Base",
      "Pituffik Space Base"
    ],
    "city": [
      "Pituffik",
      "Pituffik",
      "Pituffik"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "TQI",
    "translations": [
      "Tiniteqilaaq Heliport",
      "Tiniteqilaaq Heliport",
      "Tiniteqilaaq Heliport"
    ],
    "city": [
      "Tiniteqilaaq",
      "Tiniteqilaaq",
      "Tiniteqilaaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "XEQ",
    "translations": [
      "Tasiusaq Heliport",
      "Tasiusaq Heliport",
      "Tasiusaq Heliport"
    ],
    "city": [
      "Tasiusak",
      "Tasiusak",
      "Tasiusak"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JUV",
    "translations": [
      "Upernavik Airport",
      "Upernavik Airport",
      "Upernavik Airport"
    ],
    "city": [
      "Upernavik",
      "Upernavik",
      "Upernavik"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "UMD",
    "translations": [
      "Uummannaq Heliport",
      "Uummannaq Heliport",
      "Uummannaq Heliport"
    ],
    "city": [
      "Uummannaq",
      "Uummannaq",
      "Uummannaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JQA",
    "translations": [
      "Qaarsut Airport",
      "Qaarsut Airport",
      "Qaarsut Airport"
    ],
    "city": [
      "Uummannaq",
      "Uummannaq",
      "Uummannaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "JUK",
    "translations": [
      "Ukkusissat Heliport",
      "Ukkusissat Heliport",
      "Ukkusissat Heliport"
    ],
    "city": [
      "Ukkusissat",
      "Ukkusissat",
      "Ukkusissat"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "BHL",
    "translations": [
      "Bahía de los Ángeles Airport",
      "Bahía de los Ángeles Airport",
      "Bahía de los Ángeles Airport"
    ],
    "city": [
      "Ensenada",
      "Ensenada",
      "Ensenada"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "BHT",
    "translations": [
      "Brighton Downs Airport",
      "Brighton Downs Airport",
      "Brighton Downs Airport"
    ],
    "city": [
      "Brighton Downs",
      "Brighton Downs",
      "Brighton Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AEY",
    "translations": [
      "Akureyri Airport",
      "Akureyri Airport",
      "Akureyri Airport"
    ],
    "city": [
      "Akureyri",
      "Akureyri",
      "Akureyri"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "BIU",
    "translations": [
      "Bildudalur Airport",
      "Bildudalur Airport",
      "Bildudalur Airport"
    ],
    "city": [
      "Bildudalur",
      "Bildudalur",
      "Bildudalur"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "BGJ",
    "translations": [
      "Borgarfjörður eystri Airport",
      "Borgarfjörður eystri Airport",
      "Borgarfjörður eystri Airport"
    ],
    "city": [
      "Borgarfjörður eystri",
      "Borgarfjörður eystri",
      "Borgarfjörður eystri"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "BJD",
    "translations": [
      "Bakkafjörður Airport",
      "Bakkafjörður Airport",
      "Bakkafjörður Airport"
    ],
    "city": [
      "Bakkafjörður",
      "Bakkafjörður",
      "Bakkafjörður"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "BLO",
    "translations": [
      "Blönduós Airport",
      "Blönduós Airport",
      "Blönduós Airport"
    ],
    "city": [
      "Blönduós",
      "Blönduós",
      "Blönduós"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "BXV",
    "translations": [
      "Breiðdalsvík Airport",
      "Breiðdalsvík Airport",
      "Breiðdalsvík Airport"
    ],
    "city": [
      "Breiðdalsvík",
      "Breiðdalsvík",
      "Breiðdalsvík"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "DJU",
    "translations": [
      "Djúpivogur Airport",
      "Djúpivogur Airport",
      "Djúpivogur Airport"
    ],
    "city": [
      "Djúpivogur",
      "Djúpivogur",
      "Djúpivogur"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "EGS",
    "translations": [
      "Egilsstaðir Airport",
      "Egilsstaðir Airport",
      "Egilsstaðir Airport"
    ],
    "city": [
      "Egilsstaðir",
      "Egilsstaðir",
      "Egilsstaðir"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "FAS",
    "translations": [
      "Fáskrúðsfjörður Airport",
      "Fáskrúðsfjörður Airport",
      "Fáskrúðsfjörður Airport"
    ],
    "city": [
      "Fáskrúðsfjörður",
      "Fáskrúðsfjörður",
      "Fáskrúðsfjörður"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "FAG",
    "translations": [
      "Fagurhólsmýri Airport",
      "Fagurhólsmýri Airport",
      "Fagurhólsmýri Airport"
    ],
    "city": [
      "Fagurhólsmýri",
      "Fagurhólsmýri",
      "Fagurhólsmýri"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "GUU",
    "translations": [
      "Grundarfjörður Airport",
      "Grundarfjörður Airport",
      "Grundarfjörður Airport"
    ],
    "city": [
      "Grundarfjörður",
      "Grundarfjörður",
      "Grundarfjörður"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "GJR",
    "translations": [
      "Gjögur Airport",
      "Gjögur Airport",
      "Gjögur Airport"
    ],
    "city": [
      "Gjögur",
      "Gjögur",
      "Gjögur"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "GRY",
    "translations": [
      "Grímsey Airport",
      "Grímsey Airport",
      "Grímsey Airport"
    ],
    "city": [
      "Grímsey",
      "Grímsey",
      "Grímsey"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "HVK",
    "translations": [
      "Hólmavík Airport",
      "Hólmavík Airport",
      "Hólmavík Airport"
    ],
    "city": [
      "Hólmavík",
      "Hólmavík",
      "Hólmavík"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "HFN",
    "translations": [
      "Hornafjörður Airport",
      "Hornafjörður Airport",
      "Hornafjörður Airport"
    ],
    "city": [
      "Höfn",
      "Höfn",
      "Höfn"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "FLI",
    "translations": [
      "Holt Airport",
      "Holt Airport",
      "Holt Airport"
    ],
    "city": [
      "Flateyri",
      "Flateyri",
      "Flateyri"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "HZK",
    "translations": [
      "Húsavík Airport",
      "Húsavík Airport",
      "Húsavík Airport"
    ],
    "city": [
      "Húsavík",
      "Húsavík",
      "Húsavík"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "HLO",
    "translations": [
      "Ingjaldssanður Airport",
      "Ingjaldssanður Airport",
      "Ingjaldssanður Airport"
    ],
    "city": [
      "Onundarfjörður",
      "Onundarfjörður",
      "Onundarfjörður"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "IFJ",
    "translations": [
      "Ísafjörður Airport",
      "Ísafjörður Airport",
      "Ísafjörður Airport"
    ],
    "city": [
      "Ísafjörður",
      "Ísafjörður",
      "Ísafjörður"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "KEF",
    "translations": [
      "Keflavik International Airport",
      "Keflavik International Airport",
      "Keflavik International Airport"
    ],
    "city": [
      "Reykjavík",
      "Reykjavík",
      "Reykjavík"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "OPA",
    "translations": [
      "Kópasker Airport",
      "Kópasker Airport",
      "Kópasker Airport"
    ],
    "city": [
      "Kópasker",
      "Kópasker",
      "Kópasker"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "SAK",
    "translations": [
      "Sauðárkrókur Airport",
      "Sauðárkrókur Airport",
      "Sauðárkrókur Airport"
    ],
    "city": [
      "Sauðárkrókur",
      "Sauðárkrókur",
      "Sauðárkrókur"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "NOR",
    "translations": [
      "Norðfjörður Airport",
      "Norðfjörður Airport",
      "Norðfjörður Airport"
    ],
    "city": [
      "Norðfjörður",
      "Norðfjörður",
      "Norðfjörður"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "OFJ",
    "translations": [
      "Ólafsfjörður Airport",
      "Ólafsfjörður Airport",
      "Ólafsfjörður Airport"
    ],
    "city": [
      "Ólafsfjörður",
      "Ólafsfjörður",
      "Ólafsfjörður"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "PFJ",
    "translations": [
      "Patreksfjörður Airport",
      "Patreksfjörður Airport",
      "Patreksfjörður Airport"
    ],
    "city": [
      "Patreksfjörður",
      "Patreksfjörður",
      "Patreksfjörður"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "RHA",
    "translations": [
      "Reykhólar Airport",
      "Reykhólar Airport",
      "Reykhólar Airport"
    ],
    "city": [
      "Reykhólar",
      "Reykhólar",
      "Reykhólar"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "OLI",
    "translations": [
      "Rif Airport",
      "Rif Airport",
      "Rif Airport"
    ],
    "city": [
      "Rif",
      "Rif",
      "Rif"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "RFN",
    "translations": [
      "Raufarhöfn Airport",
      "Raufarhöfn Airport",
      "Raufarhöfn Airport"
    ],
    "city": [
      "Raufarhöfn",
      "Raufarhöfn",
      "Raufarhöfn"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "RKV",
    "translations": [
      "Reykjavík Domestic Airport",
      "Reykjavík Domestic Airport",
      "Reykjavík Domestic Airport"
    ],
    "city": [
      "Reykjavík",
      "Reykjavík",
      "Reykjavík"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "MVA",
    "translations": [
      "Reykjahlíð Airport",
      "Reykjahlíð Airport",
      "Reykjahlíð Airport"
    ],
    "city": [
      "Myvatn",
      "Myvatn",
      "Myvatn"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "SIJ",
    "translations": [
      "Siglufjörður Airport",
      "Siglufjörður Airport",
      "Siglufjörður Airport"
    ],
    "city": [
      "Siglufjörður",
      "Siglufjörður",
      "Siglufjörður"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "SYK",
    "translations": [
      "Stykkishólmur Airport",
      "Stykkishólmur Airport",
      "Stykkishólmur Airport"
    ],
    "city": [
      "Stykkishólmur",
      "Stykkishólmur",
      "Stykkishólmur"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "TEY",
    "translations": [
      "Þingeyri Airport",
      "Þingeyri Airport",
      "Þingeyri Airport"
    ],
    "city": [
      "Þingeyri",
      "Þingeyri",
      "Þingeyri"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "THO",
    "translations": [
      "Þórshöfn Airport",
      "Þórshöfn Airport",
      "Þórshöfn Airport"
    ],
    "city": [
      "Þórshöfn",
      "Þórshöfn",
      "Þórshöfn"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "VEY",
    "translations": [
      "Vestmannaeyjar Airport",
      "Vestmannaeyjar Airport",
      "Vestmannaeyjar Airport"
    ],
    "city": [
      "Vestmannaeyjar",
      "Vestmannaeyjar",
      "Vestmannaeyjar"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "VPN",
    "translations": [
      "Vopnafjörður Airport",
      "Vopnafjörður Airport",
      "Vopnafjörður Airport"
    ],
    "city": [
      "Vopnafjörður",
      "Vopnafjörður",
      "Vopnafjörður"
    ],
    "country": [
      "IS",
      "IS",
      "IS"
    ]
  },
  {
    "iata": "BJE",
    "translations": [
      "Baleela Airport",
      "Baleela Airport",
      "Baleela Airport"
    ],
    "city": [
      "Baleela Base Camp",
      "Baleela Base Camp",
      "Baleela Base Camp"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "BJQ",
    "translations": [
      "Bahja Airport",
      "Bahja Airport",
      "Bahja Airport"
    ],
    "city": [
      "Bahja",
      "Bahja",
      "Bahja"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "BJT",
    "translations": [
      "Bentota River Waterdrome",
      "Bentota River Waterdrome",
      "Bentota River Waterdrome"
    ],
    "city": [
      "Bentota",
      "Bentota",
      "Bentota"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "PRN",
    "translations": [
      "Priština Adem Jashari International Airport",
      "Priština Adem Jashari International Airport",
      "Priština Adem Jashari International Airport"
    ],
    "city": [
      "Prishtina",
      "Prishtina",
      "Prishtina"
    ],
    "country": [
      "XK",
      "XK",
      "XK"
    ]
  },
  {
    "iata": "BMQ",
    "translations": [
      "Bamburi Airport",
      "Bamburi Airport",
      "Bamburi Airport"
    ],
    "city": [
      "Bamburi",
      "Bamburi",
      "Bamburi"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "BNF",
    "translations": [
      "Baranof Warm Springs Float and Seaplane Base",
      "Baranof Warm Springs Float and Seaplane Base",
      "Baranof Warm Springs Float and Seaplane Base"
    ],
    "city": [
      "Baranof",
      "Baranof",
      "Baranof"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BNV",
    "translations": [
      "Boana Airport",
      "Boana Airport",
      "Boana Airport"
    ],
    "city": [
      "Boana",
      "Boana",
      "Boana"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BVL",
    "translations": [
      "Baures Airport",
      "Baures Airport",
      "Baures Airport"
    ],
    "city": [
      "Baures",
      "Baures",
      "Baures"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "BOV",
    "translations": [
      "Boang Airport",
      "Boang Airport",
      "Boang Airport"
    ],
    "city": [
      "Boang Island",
      "Boang Island",
      "Boang Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BQV",
    "translations": [
      "Bartlett Cove Seaplane Base",
      "Bartlett Cove Seaplane Base",
      "Bartlett Cove Seaplane Base"
    ],
    "city": [
      "Gustavus",
      "Gustavus",
      "Gustavus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CJZ",
    "translations": [
      "Pedro Vieira Moreira Airport",
      "Pedro Vieira Moreira Airport",
      "Pedro Vieira Moreira Airport"
    ],
    "city": [
      "Cajazeiras",
      "Cajazeiras",
      "Cajazeiras"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "VDC",
    "translations": [
      "Glauber de Andrade Rocha Airport",
      "Glauber de Andrade Rocha Airport",
      "Glauber de Andrade Rocha Airport"
    ],
    "city": [
      "Vitória da Conquista",
      "Vitória da Conquista",
      "Vitória da Conquista"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "AAI",
    "translations": [
      "Arraias Airport",
      "Arraias Airport",
      "Arraias Airport"
    ],
    "city": [
      "Arraias",
      "Arraias",
      "Arraias"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ITN",
    "translations": [
      "Tertuliano Guedes de Pinho Airport",
      "Tertuliano Guedes de Pinho Airport",
      "Tertuliano Guedes de Pinho Airport"
    ],
    "city": [
      "Itabuna",
      "Itabuna",
      "Itabuna"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "LEP",
    "translations": [
      "Leopoldina Airport",
      "Leopoldina Airport",
      "Leopoldina Airport"
    ],
    "city": [
      "Leopoldina",
      "Leopoldina",
      "Leopoldina"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CPU",
    "translations": [
      "Cururupu Airport",
      "Cururupu Airport",
      "Cururupu Airport"
    ],
    "city": [
      "Cururupu",
      "Cururupu",
      "Cururupu"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CTQ",
    "translations": [
      "Santa Vitória do Palmar Airport",
      "Santa Vitória do Palmar Airport",
      "Santa Vitória do Palmar Airport"
    ],
    "city": [
      "Santa Vitória do Palmar",
      "Santa Vitória do Palmar",
      "Santa Vitória do Palmar"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "APY",
    "translations": [
      "Alto Parnaíba Airport",
      "Alto Parnaíba Airport",
      "Alto Parnaíba Airport"
    ],
    "city": [
      "Alto Parnaíba",
      "Alto Parnaíba",
      "Alto Parnaíba"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JRN",
    "translations": [
      "Juruena Airport",
      "Juruena Airport",
      "Juruena Airport"
    ],
    "city": [
      "Juruena",
      "Juruena",
      "Juruena"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "STZ",
    "translations": [
      "Santa Terezinha Airport",
      "Santa Terezinha Airport",
      "Santa Terezinha Airport"
    ],
    "city": [
      "Santa Terezinha",
      "Santa Terezinha",
      "Santa Terezinha"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MTG",
    "translations": [
      "Vila Bela da Santíssima Trindade Airport",
      "Vila Bela da Santíssima Trindade Airport",
      "Vila Bela da Santíssima Trindade Airport"
    ],
    "city": [
      "Vila Bela Da Santíssima Trindade",
      "Vila Bela Da Santíssima Trindade",
      "Vila Bela Da Santíssima Trindade"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ALT",
    "translations": [
      "Alenquer Municipal Airport",
      "Alenquer Municipal Airport",
      "Alenquer Municipal Airport"
    ],
    "city": [
      "Alenquer",
      "Alenquer",
      "Alenquer"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "NSB",
    "translations": [
      "Bimini North Seaplane Base",
      "Bimini North Seaplane Base",
      "Bimini North Seaplane Base"
    ],
    "city": [
      "Bimini",
      "Bimini",
      "Bimini"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "BSV",
    "translations": [
      "Besakoa Airport",
      "Besakoa Airport",
      "Besakoa Airport"
    ],
    "city": [
      "Besakoa",
      "Besakoa",
      "Besakoa"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "BTZ",
    "translations": [
      "Betong International Airport",
      "Betong International Airport",
      "Betong International Airport"
    ],
    "city": [
      "Betong",
      "Betong",
      "Betong"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "HUK",
    "translations": [
      "Hukuntsi Airport",
      "Hukuntsi Airport",
      "Hukuntsi Airport"
    ],
    "city": [
      "Hukuntsi",
      "Hukuntsi",
      "Hukuntsi"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "BWJ",
    "translations": [
      "Bawan Airport",
      "Bawan Airport",
      "Bawan Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BXL",
    "translations": [
      "Blue Lagoon Seaplane Base",
      "Blue Lagoon Seaplane Base",
      "Blue Lagoon Seaplane Base"
    ],
    "city": [
      "Nanuya Lailai Island",
      "Nanuya Lailai Island",
      "Nanuya Lailai Island"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "TXC",
    "translations": [
      "Orsha Airport - Balbasovo Air Base",
      "Orsha Airport - Balbasovo Air Base",
      "Orsha Airport - Balbasovo Air Base"
    ],
    "city": [
      "Orsha",
      "Orsha",
      "Orsha"
    ],
    "country": [
      "BY",
      "BY",
      "BY"
    ]
  },
  {
    "iata": "BYA",
    "translations": [
      "Boundary Airport",
      "Boundary Airport",
      "Boundary Airport"
    ],
    "city": [
      "Boundary",
      "Boundary",
      "Boundary"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BYL",
    "translations": [
      "Bella Yella Airport",
      "Bella Yella Airport",
      "Bella Yella Airport"
    ],
    "city": [
      "Beliyela",
      "Beliyela",
      "Beliyela"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "BYV",
    "translations": [
      "Beira Lake Seaplane Base",
      "Beira Lake Seaplane Base",
      "Beira Lake Seaplane Base"
    ],
    "city": [
      "Colombo",
      "Colombo",
      "Colombo"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "BCV",
    "translations": [
      "Hector Silva Airstrip",
      "Hector Silva Airstrip",
      "Hector Silva Airstrip"
    ],
    "city": [
      "Belmopan",
      "Belmopan",
      "Belmopan"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "BGK",
    "translations": [
      "Big Creek Airport",
      "Big Creek Airport",
      "Big Creek Airport"
    ],
    "city": [
      "Big Creek",
      "Big Creek",
      "Big Creek"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "CUK",
    "translations": [
      "Caye Caulker Airport",
      "Caye Caulker Airport",
      "Caye Caulker Airport"
    ],
    "city": [
      "Caye Caulker",
      "Caye Caulker",
      "Caye Caulker"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "CYC",
    "translations": [
      "Caye Chapel Airport",
      "Caye Chapel Airport",
      "Caye Chapel Airport"
    ],
    "city": [
      "Caye Chapel",
      "Caye Chapel",
      "Caye Chapel"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "CZH",
    "translations": [
      "Corozal Airport",
      "Corozal Airport",
      "Corozal Airport"
    ],
    "city": [
      "Corozal",
      "Corozal",
      "Corozal"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "DGA",
    "translations": [
      "Dangriga Airport",
      "Dangriga Airport",
      "Dangriga Airport"
    ],
    "city": [
      "Dangriga",
      "Dangriga",
      "Dangriga"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "INB",
    "translations": [
      "Independence Airport",
      "Independence Airport",
      "Independence Airport"
    ],
    "city": [
      "Independence",
      "Independence",
      "Independence"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "MDB",
    "translations": [
      "Melinda Airport",
      "Melinda Airport",
      "Melinda Airport"
    ],
    "city": [
      "Melinda",
      "Melinda",
      "Melinda"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "ORZ",
    "translations": [
      "H.E Alfredo Martinez (Tower Hill) Airstrip",
      "H.E Alfredo Martinez (Tower Hill) Airstrip",
      "H.E Alfredo Martinez (Tower Hill) Airstrip"
    ],
    "city": [
      "Orange Walk",
      "Orange Walk",
      "Orange Walk"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "PND",
    "translations": [
      "Punta Gorda Airport",
      "Punta Gorda Airport",
      "Punta Gorda Airport"
    ],
    "city": [
      "Punta Gorda",
      "Punta Gorda",
      "Punta Gorda"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "SJX",
    "translations": [
      "Sartaneja Airport",
      "Sartaneja Airport",
      "Sartaneja Airport"
    ],
    "city": [
      "Sartaneja",
      "Sartaneja",
      "Sartaneja"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "SPR",
    "translations": [
      "John Greif II Airport",
      "John Greif II Airport",
      "John Greif II Airport"
    ],
    "city": [
      "San Pedro",
      "San Pedro",
      "San Pedro"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "SQS",
    "translations": [
      "Matthew Spain Airport",
      "Matthew Spain Airport",
      "Matthew Spain Airport"
    ],
    "city": [
      "Spanish Lookout",
      "Spanish Lookout",
      "Spanish Lookout"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "STU",
    "translations": [
      "Santa Cruz Airport",
      "Santa Cruz Airport",
      "Santa Cruz Airport"
    ],
    "city": [
      "Santa Cruz",
      "Santa Cruz",
      "Santa Cruz"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "SVK",
    "translations": [
      "Silver Creek Airport",
      "Silver Creek Airport",
      "Silver Creek Airport"
    ],
    "city": [
      "Silver Creek",
      "Silver Creek",
      "Silver Creek"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "TZA",
    "translations": [
      "Sir Barry Bowen Municipal Airport",
      "Sir Barry Bowen Municipal Airport",
      "Sir Barry Bowen Municipal Airport"
    ],
    "city": [
      "Belize City",
      "Belize City",
      "Belize City"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "BZB",
    "translations": [
      "Bazaruto Island Airport",
      "Bazaruto Island Airport",
      "Bazaruto Island Airport"
    ],
    "city": [
      "Bazaruto Island",
      "Bazaruto Island",
      "Bazaruto Island"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "BZM",
    "translations": [
      "Bemolanga Airport",
      "Bemolanga Airport",
      "Bemolanga Airport"
    ],
    "city": [
      "Bemolanga",
      "Bemolanga",
      "Bemolanga"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "PFM",
    "translations": [
      "Primrose Airport",
      "Primrose Airport",
      "Primrose Airport"
    ],
    "city": [
      "Primrose",
      "Primrose",
      "Primrose"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSV",
    "translations": [
      "Saglek Airport",
      "Saglek Airport",
      "Saglek Airport"
    ],
    "city": [
      "Saglek",
      "Saglek",
      "Saglek"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRR",
    "translations": [
      "Stuart Island Airstrip",
      "Stuart Island Airstrip",
      "Stuart Island Airstrip"
    ],
    "city": [
      "Big Bay",
      "Big Bay",
      "Big Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMV",
    "translations": [
      "Mary River Aerodrome",
      "Mary River Aerodrome",
      "Mary River Aerodrome"
    ],
    "city": [
      "Mary River",
      "Mary River",
      "Mary River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHC",
    "translations": [
      "Hakai Passage Water Aerodrome",
      "Hakai Passage Water Aerodrome",
      "Hakai Passage Water Aerodrome"
    ],
    "city": [
      "Hecate Island",
      "Hecate Island",
      "Hecate Island"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMF",
    "translations": [
      "Montague Harbour Seaplane Base",
      "Montague Harbour Seaplane Base",
      "Montague Harbour Seaplane Base"
    ],
    "city": [
      "Galiano Island",
      "Galiano Island",
      "Galiano Island"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "PYS",
    "translations": [
      "Paradise Skypark Airport",
      "Paradise Skypark Airport",
      "Paradise Skypark Airport"
    ],
    "city": [
      "Paradise",
      "Paradise",
      "Paradise"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "YBW",
    "translations": [
      "Bedwell Harbour Seaplane Base",
      "Bedwell Harbour Seaplane Base",
      "Bedwell Harbour Seaplane Base"
    ],
    "city": [
      "Bedwell Harbour",
      "Bedwell Harbour",
      "Bedwell Harbour"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTP",
    "translations": [
      "Tofino Harbour Seaplane Base",
      "Tofino Harbour Seaplane Base",
      "Tofino Harbour Seaplane Base"
    ],
    "city": [
      "Tofino",
      "Tofino",
      "Tofino"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CBA",
    "translations": [
      "Alpine Heliport",
      "Alpine Heliport",
      "Alpine Heliport"
    ],
    "city": [
      "West Kelowna",
      "West Kelowna",
      "West Kelowna"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZNA",
    "translations": [
      "Nanaimo Harbour Water Aerodrome",
      "Nanaimo Harbour Water Aerodrome",
      "Nanaimo Harbour Water Aerodrome"
    ],
    "city": [
      "Nanaimo",
      "Nanaimo",
      "Nanaimo"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZZ",
    "translations": [
      "Trail Regional Airport",
      "Trail Regional Airport",
      "Trail Regional Airport"
    ],
    "city": [
      "Trail",
      "Trail",
      "Trail"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMB",
    "translations": [
      "Merritt Airport",
      "Merritt Airport",
      "Merritt Airport"
    ],
    "city": [
      "Merritt",
      "Merritt",
      "Merritt"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHH",
    "translations": [
      "Campbell River Seaplane Base",
      "Campbell River Seaplane Base",
      "Campbell River Seaplane Base"
    ],
    "city": [
      "Campbell River",
      "Campbell River",
      "Campbell River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YWS",
    "translations": [
      "Whistler/Green Lake Water Aerodrome",
      "Whistler/Green Lake Water Aerodrome",
      "Whistler/Green Lake Water Aerodrome"
    ],
    "city": [
      "Whistler",
      "Whistler",
      "Whistler"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBF",
    "translations": [
      "Bamfield Seaplane Base",
      "Bamfield Seaplane Base",
      "Bamfield Seaplane Base"
    ],
    "city": [
      "Bamfield",
      "Bamfield",
      "Bamfield"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YIG",
    "translations": [
      "Big Bay Seaplane Base",
      "Big Bay Seaplane Base",
      "Big Bay Seaplane Base"
    ],
    "city": [
      "Stuart Island",
      "Stuart Island",
      "Stuart Island"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CJH",
    "translations": [
      "Chilko Lake (Tsylos Park Lodge) Airport",
      "Chilko Lake (Tsylos Park Lodge) Airport",
      "Chilko Lake (Tsylos Park Lodge) Airport"
    ],
    "city": [
      "Chilko Lake",
      "Chilko Lake",
      "Chilko Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPT",
    "translations": [
      "Pender Harbour Seaplane Base",
      "Pender Harbour Seaplane Base",
      "Pender Harbour Seaplane Base"
    ],
    "city": [
      "Sunshine Coast",
      "Sunshine Coast",
      "Sunshine Coast"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZOF",
    "translations": [
      "Ocean Falls Seaplane Base",
      "Ocean Falls Seaplane Base",
      "Ocean Falls Seaplane Base"
    ],
    "city": [
      "Ocean Falls",
      "Ocean Falls",
      "Ocean Falls"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCA",
    "translations": [
      "Courtenay Airpark",
      "Courtenay Airpark",
      "Courtenay Airpark"
    ],
    "city": [
      "Courtenay",
      "Courtenay",
      "Courtenay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CFQ",
    "translations": [
      "Creston Valley Regional Airport - Art Sutcliffe Field",
      "Creston Valley Regional Airport - Art Sutcliffe Field",
      "Creston Valley Regional Airport - Art Sutcliffe Field"
    ],
    "city": [
      "Creston",
      "Creston",
      "Creston"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YAA",
    "translations": [
      "Anahim Lake Airport",
      "Anahim Lake Airport",
      "Anahim Lake Airport"
    ],
    "city": [
      "Anahim Lake",
      "Anahim Lake",
      "Anahim Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "DGF",
    "translations": [
      "Douglas Lake Airport",
      "Douglas Lake Airport",
      "Douglas Lake Airport"
    ],
    "city": [
      "Douglas Lake",
      "Douglas Lake",
      "Douglas Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "JHL",
    "translations": [
      "Fort MacKay/Albian Aerodrome",
      "Fort MacKay/Albian Aerodrome",
      "Fort MacKay/Albian Aerodrome"
    ],
    "city": [
      "Albian Village",
      "Albian Village",
      "Albian Village"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZTS",
    "translations": [
      "Tahsis Seaplane Base",
      "Tahsis Seaplane Base",
      "Tahsis Seaplane Base"
    ],
    "city": [
      "Tahsis",
      "Tahsis",
      "Tahsis"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "DUQ",
    "translations": [
      "Duncan Airport",
      "Duncan Airport",
      "Duncan Airport"
    ],
    "city": [
      "Duncan",
      "Duncan",
      "Duncan"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHS",
    "translations": [
      "Sechelt-Gibsons Airport",
      "Sechelt-Gibsons Airport",
      "Sechelt-Gibsons Airport"
    ],
    "city": [
      "Sechelt",
      "Sechelt",
      "Sechelt"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YKK",
    "translations": [
      "Kitkatla Seaplane Base",
      "Kitkatla Seaplane Base",
      "Kitkatla Seaplane Base"
    ],
    "city": [
      "Kitkatla",
      "Kitkatla",
      "Kitkatla"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZQS",
    "translations": [
      "Queen Charlotte City Seaplane Base",
      "Queen Charlotte City Seaplane Base",
      "Queen Charlotte City Seaplane Base"
    ],
    "city": [
      "Queen Charlotte",
      "Queen Charlotte",
      "Queen Charlotte"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "WPL",
    "translations": [
      "Powell Lake Seaplane Base",
      "Powell Lake Seaplane Base",
      "Powell Lake Seaplane Base"
    ],
    "city": [
      "Powell River",
      "Powell River",
      "Powell River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XQU",
    "translations": [
      "Qualicum Beach Airport",
      "Qualicum Beach Airport",
      "Qualicum Beach Airport"
    ],
    "city": [
      "Qualicum Beach",
      "Qualicum Beach",
      "Qualicum Beach"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMP",
    "translations": [
      "Port McNeill Airport",
      "Port McNeill Airport",
      "Port McNeill Airport"
    ],
    "city": [
      "Port McNeill",
      "Port McNeill",
      "Port McNeill"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRN",
    "translations": [
      "Rivers Inlet Seaplane Base",
      "Rivers Inlet Seaplane Base",
      "Rivers Inlet Seaplane Base"
    ],
    "city": [
      "Rivers Inlet",
      "Rivers Inlet",
      "Rivers Inlet"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTG",
    "translations": [
      "Sullivan Bay Seaplane Base",
      "Sullivan Bay Seaplane Base",
      "Sullivan Bay Seaplane Base"
    ],
    "city": [
      "Sullivan Bay",
      "Sullivan Bay",
      "Sullivan Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMU",
    "translations": [
      "Mansons Landing Seaplane Base",
      "Mansons Landing Seaplane Base",
      "Mansons Landing Seaplane Base"
    ],
    "city": [
      "Mansons Landing",
      "Mansons Landing",
      "Mansons Landing"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YAV",
    "translations": [
      "Mayne Island Seaplane Base",
      "Mayne Island Seaplane Base",
      "Mayne Island Seaplane Base"
    ],
    "city": [
      "Miners Bay",
      "Miners Bay",
      "Miners Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSX",
    "translations": [
      "Bella Bella/Shearwater Seaplane Base",
      "Bella Bella/Shearwater Seaplane Base",
      "Bella Bella/Shearwater Seaplane Base"
    ],
    "city": [
      "Bella Bella",
      "Bella Bella",
      "Bella Bella"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGG",
    "translations": [
      "Ganges Seaplane Base",
      "Ganges Seaplane Base",
      "Ganges Seaplane Base"
    ],
    "city": [
      "Salt Spring Island",
      "Salt Spring Island",
      "Salt Spring Island"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTB",
    "translations": [
      "Hartley Bay Seaplane Base",
      "Hartley Bay Seaplane Base",
      "Hartley Bay Seaplane Base"
    ],
    "city": [
      "Hartley Bay",
      "Hartley Bay",
      "Hartley Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZA",
    "translations": [
      "Cache Creek-Ashcroft Regional Airport",
      "Cache Creek-Ashcroft Regional Airport",
      "Cache Creek-Ashcroft Regional Airport"
    ],
    "city": [
      "Cache Creek",
      "Cache Creek",
      "Cache Creek"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZEL",
    "translations": [
      "Bella Bella (Campbell Island) Airport",
      "Bella Bella (Campbell Island) Airport",
      "Bella Bella (Campbell Island) Airport"
    ],
    "city": [
      "Bella Bella",
      "Bella Bella",
      "Bella Bella"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CBC",
    "translations": [
      "Cherrabun Airport",
      "Cherrabun Airport",
      "Cherrabun Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YPB",
    "translations": [
      "Alberni Valley Regional Airport",
      "Alberni Valley Regional Airport",
      "Alberni Valley Regional Airport"
    ],
    "city": [
      "Port Alberni",
      "Port Alberni",
      "Port Alberni"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBO",
    "translations": [
      "Bob Quinn Lake Airport",
      "Bob Quinn Lake Airport",
      "Bob Quinn Lake Airport"
    ],
    "city": [
      "Bob Quinn Lake",
      "Bob Quinn Lake",
      "Bob Quinn Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "TNS",
    "translations": [
      "Tungsten (Cantung) Airport",
      "Tungsten (Cantung) Airport",
      "Tungsten (Cantung) Airport"
    ],
    "city": [
      "Tungsten",
      "Tungsten",
      "Tungsten"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "TUX",
    "translations": [
      "Tumbler Ridge Airport",
      "Tumbler Ridge Airport",
      "Tumbler Ridge Airport"
    ],
    "city": [
      "Tumbler Ridge",
      "Tumbler Ridge",
      "Tumbler Ridge"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YWM",
    "translations": [
      "Williams Harbour Airport",
      "Williams Harbour Airport",
      "Williams Harbour Airport"
    ],
    "city": [
      "Williams Harbour",
      "Williams Harbour",
      "Williams Harbour"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSO",
    "translations": [
      "Postville Airport",
      "Postville Airport",
      "Postville Airport"
    ],
    "city": [
      "Postville",
      "Postville",
      "Postville"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBI",
    "translations": [
      "Black Tickle Airport",
      "Black Tickle Airport",
      "Black Tickle Airport"
    ],
    "city": [
      "Black Tickle",
      "Black Tickle",
      "Black Tickle"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHG",
    "translations": [
      "Charlottetown Airport",
      "Charlottetown Airport",
      "Charlottetown Airport"
    ],
    "city": [
      "Charlottetown",
      "Charlottetown",
      "Charlottetown"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YFX",
    "translations": [
      "St. Lewis (Fox Harbour) Airport",
      "St. Lewis (Fox Harbour) Airport",
      "St. Lewis (Fox Harbour) Airport"
    ],
    "city": [
      "St. Lewis",
      "St. Lewis",
      "St. Lewis"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHA",
    "translations": [
      "Port Hope Simpson Airport",
      "Port Hope Simpson Airport",
      "Port Hope Simpson Airport"
    ],
    "city": [
      "Port Hope Simpson",
      "Port Hope Simpson",
      "Port Hope Simpson"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRG",
    "translations": [
      "Rigolet Airport",
      "Rigolet Airport",
      "Rigolet Airport"
    ],
    "city": [
      "Rigolet",
      "Rigolet",
      "Rigolet"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "KGN",
    "translations": [
      "Kasongo-Lunda Airport",
      "Kasongo-Lunda Airport",
      "Kasongo-Lunda Airport"
    ],
    "city": [
      "Kasongo-Lunda",
      "Kasongo-Lunda",
      "Kasongo-Lunda"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "DVK",
    "translations": [
      "Diavik Airport",
      "Diavik Airport",
      "Diavik Airport"
    ],
    "city": [
      "Diavik",
      "Diavik",
      "Diavik"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "JOJ",
    "translations": [
      "Doris Lake",
      "Doris Lake",
      "Doris Lake"
    ],
    "city": [
      "Hope Bay",
      "Hope Bay",
      "Hope Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZFW",
    "translations": [
      "Fairview Airport",
      "Fairview Airport",
      "Fairview Airport"
    ],
    "city": [
      "Fairview",
      "Fairview",
      "Fairview"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YJP",
    "translations": [
      "Jasper-Hinton Airport",
      "Jasper-Hinton Airport",
      "Jasper-Hinton Airport"
    ],
    "city": [
      "Hinton",
      "Hinton",
      "Hinton"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLE",
    "translations": [
      "Whatì Airport",
      "Whatì Airport",
      "Whatì Airport"
    ],
    "city": [
      "Whatì",
      "Whatì",
      "Whatì"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDC",
    "translations": [
      "Drayton Valley Industrial Airport",
      "Drayton Valley Industrial Airport",
      "Drayton Valley Industrial Airport"
    ],
    "city": [
      "Drayton Valley",
      "Drayton Valley",
      "Drayton Valley"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "NML",
    "translations": [
      "Fort McMurray / Mildred Lake Airport",
      "Fort McMurray / Mildred Lake Airport",
      "Fort McMurray / Mildred Lake Airport"
    ],
    "city": [
      "Fort McMurray",
      "Fort McMurray",
      "Fort McMurray"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CFM",
    "translations": [
      "Conklin (Leismer) Airport",
      "Conklin (Leismer) Airport",
      "Conklin (Leismer) Airport"
    ],
    "city": [
      "Conklin",
      "Conklin",
      "Conklin"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "KWD",
    "translations": [
      "Kavadja Airport",
      "Kavadja Airport",
      "Kavadja Airport"
    ],
    "city": [
      "Kavadja",
      "Kavadja",
      "Kavadja"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "GSL",
    "translations": [
      "Taltheilei Narrows Airport",
      "Taltheilei Narrows Airport",
      "Taltheilei Narrows Airport"
    ],
    "city": [
      "Taltheilei Narrows",
      "Taltheilei Narrows",
      "Taltheilei Narrows"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XMP",
    "translations": [
      "Macmillan Pass Airport",
      "Macmillan Pass Airport",
      "Macmillan Pass Airport"
    ],
    "city": [
      "Macmillan Pass",
      "Macmillan Pass",
      "Macmillan Pass"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "DAS",
    "translations": [
      "Great Bear Lake Airport",
      "Great Bear Lake Airport",
      "Great Bear Lake Airport"
    ],
    "city": [
      "Great Bear Lake",
      "Great Bear Lake",
      "Great Bear Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YFI",
    "translations": [
      "Fort Mackay / Firebag",
      "Fort Mackay / Firebag",
      "Fort Mackay / Firebag"
    ],
    "city": [
      "Suncor Energy Site",
      "Suncor Energy Site",
      "Suncor Energy Site"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YOE",
    "translations": [
      "Donnelly Airport",
      "Donnelly Airport",
      "Donnelly Airport"
    ],
    "city": [
      "Donnelly",
      "Donnelly",
      "Donnelly"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "TIL",
    "translations": [
      "Cheadle Airport",
      "Cheadle Airport",
      "Cheadle Airport"
    ],
    "city": [
      "Cheadle",
      "Cheadle",
      "Cheadle"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "OKG",
    "translations": [
      "Okoyo Airport",
      "Okoyo Airport",
      "Okoyo Airport"
    ],
    "city": [
      "Okoyo",
      "Okoyo",
      "Okoyo"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "CGA",
    "translations": [
      "Craig Seaplane Base",
      "Craig Seaplane Base",
      "Craig Seaplane Base"
    ],
    "city": [
      "Craig",
      "Craig",
      "Craig"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CGG",
    "translations": [
      "Casiguran Airport",
      "Casiguran Airport",
      "Casiguran Airport"
    ],
    "city": [
      "Casiguran",
      "Casiguran",
      "Casiguran"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "GHK",
    "translations": [
      "Gahcho Kue",
      "Gahcho Kue",
      "Gahcho Kue"
    ],
    "city": [
      "Kennedy Lake",
      "Kennedy Lake",
      "Kennedy Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CHP",
    "translations": [
      "Circle Hot Springs Airport",
      "Circle Hot Springs Airport",
      "Circle Hot Springs Airport"
    ],
    "city": [
      "Circle Hot Springs",
      "Circle Hot Springs",
      "Circle Hot Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CIV",
    "translations": [
      "Chomley Seaplane Base",
      "Chomley Seaplane Base",
      "Chomley Seaplane Base"
    ],
    "city": [
      "Chomley",
      "Chomley",
      "Chomley"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LRQ",
    "translations": [
      "Laurie River Airport",
      "Laurie River Airport",
      "Laurie River Airport"
    ],
    "city": [
      "Laurie River",
      "Laurie River",
      "Laurie River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDJ",
    "translations": [
      "Hatchet Lake Airport",
      "Hatchet Lake Airport",
      "Hatchet Lake Airport"
    ],
    "city": [
      "Hatchet Lake",
      "Hatchet Lake",
      "Hatchet Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDU",
    "translations": [
      "Kasba Lake Airport",
      "Kasba Lake Airport",
      "Kasba Lake Airport"
    ],
    "city": [
      "Kasba Lake",
      "Kasba Lake",
      "Kasba Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YFL",
    "translations": [
      "Fort Reliance Seaplane Base",
      "Fort Reliance Seaplane Base",
      "Fort Reliance Seaplane Base"
    ],
    "city": [
      "Fort Reliance",
      "Fort Reliance",
      "Fort Reliance"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XCL",
    "translations": [
      "Cluff Lake Airport",
      "Cluff Lake Airport",
      "Cluff Lake Airport"
    ],
    "city": [
      "Cluff Lake",
      "Cluff Lake",
      "Cluff Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YKE",
    "translations": [
      "Knee Lake Airport",
      "Knee Lake Airport",
      "Knee Lake Airport"
    ],
    "city": [
      "Knee Lake",
      "Knee Lake",
      "Knee Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "SUR",
    "translations": [
      "Summer Beaver Airport",
      "Summer Beaver Airport",
      "Summer Beaver Airport"
    ],
    "city": [
      "Summer Beaver",
      "Summer Beaver",
      "Summer Beaver"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CKD",
    "translations": [
      "Crooked Creek Airport",
      "Crooked Creek Airport",
      "Crooked Creek Airport"
    ],
    "city": [
      "Crooked Creek",
      "Crooked Creek",
      "Crooked Creek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "YTT",
    "translations": [
      "Tisdale Airport",
      "Tisdale Airport",
      "Tisdale Airport"
    ],
    "city": [
      "Tisdale",
      "Tisdale",
      "Tisdale"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YAX",
    "translations": [
      "Wapekeka Airport",
      "Wapekeka Airport",
      "Wapekeka Airport"
    ],
    "city": [
      "Angling Lake",
      "Angling Lake",
      "Angling Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "WNN",
    "translations": [
      "Wunnumin Lake Airport",
      "Wunnumin Lake Airport",
      "Wunnumin Lake Airport"
    ],
    "city": [
      "Wunnumin Lake",
      "Wunnumin Lake",
      "Wunnumin Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBS",
    "translations": [
      "Opapimiskan Lake Airport",
      "Opapimiskan Lake Airport",
      "Opapimiskan Lake Airport"
    ],
    "city": [
      "Opapimiskan Lake",
      "Opapimiskan Lake",
      "Opapimiskan Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YNO",
    "translations": [
      "North Spirit Lake Airport",
      "North Spirit Lake Airport",
      "North Spirit Lake Airport"
    ],
    "city": [
      "North Spirit Lake",
      "North Spirit Lake",
      "North Spirit Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CKR",
    "translations": [
      "Crane Island Airstrip",
      "Crane Island Airstrip",
      "Crane Island Airstrip"
    ],
    "city": [
      "Crane Island",
      "Crane Island",
      "Crane Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CKU",
    "translations": [
      "Cordova Municipal Airport",
      "Cordova Municipal Airport",
      "Cordova Municipal Airport"
    ],
    "city": [
      "Cordova",
      "Cordova",
      "Cordova"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "YDW",
    "translations": [
      "North of Sixty Airport",
      "North of Sixty Airport",
      "North of Sixty Airport"
    ],
    "city": [
      "Obre Lake",
      "Obre Lake",
      "Obre Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CKX",
    "translations": [
      "Chicken Airport",
      "Chicken Airport",
      "Chicken Airport"
    ],
    "city": [
      "Chicken",
      "Chicken",
      "Chicken"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CMT",
    "translations": [
      "New Cametá Airport",
      "New Cametá Airport",
      "New Cametá Airport"
    ],
    "city": [
      "Cametá",
      "Cametá",
      "Cametá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CMZ",
    "translations": [
      "Caia Airport",
      "Caia Airport",
      "Caia Airport"
    ],
    "city": [
      "Caia",
      "Caia",
      "Caia"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "TVS",
    "translations": [
      "Tangshan Sannühe Airport",
      "Tangshan Sannühe Airport",
      "Tangshan Sannühe Airport"
    ],
    "city": [
      "Tangshan (Fengrun)",
      "Tangshan (Fengrun)",
      "Tangshan (Fengrun)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ZKL",
    "translations": [
      "Zigong Fengming Airport",
      "Zigong Fengming Airport",
      "Zigong Fengming Airport"
    ],
    "city": [
      "Zigong (Gongjing)",
      "Zigong (Gongjing)",
      "Zigong (Gongjing)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "BZX",
    "translations": [
      "Bazhong Enyang Airport",
      "Bazhong Enyang Airport",
      "Bazhong Enyang Airport"
    ],
    "city": [
      "Bazhong (Enyang)",
      "Bazhong (Enyang)",
      "Bazhong (Enyang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DFA",
    "translations": [
      "Shangluo Airport",
      "Shangluo Airport",
      "Shangluo Airport"
    ],
    "city": [
      "Shangluo (Danfeng)",
      "Shangluo (Danfeng)",
      "Shangluo (Danfeng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HSC",
    "translations": [
      "Shaoguan Danxia Airport",
      "Shaoguan Danxia Airport",
      "Shaoguan Danxia Airport"
    ],
    "city": [
      "Shaoguan",
      "Shaoguan",
      "Shaoguan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JGS",
    "translations": [
      "Jinggangshan Airport",
      "Jinggangshan Airport",
      "Jinggangshan Airport"
    ],
    "city": [
      "Ji'an",
      "Ji'an",
      "Ji'an"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DWS",
    "translations": [
      "Morin Dawa Banner Airport",
      "Morin Dawa Banner Airport",
      "Morin Dawa Banner Airport"
    ],
    "city": [
      "Hulunbuir",
      "Hulunbuir",
      "Hulunbuir"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LCT",
    "translations": [
      "Shijiazhuang Luancheng Airport",
      "Shijiazhuang Luancheng Airport",
      "Shijiazhuang Luancheng Airport"
    ],
    "city": [
      "Shijiazhuang",
      "Shijiazhuang",
      "Shijiazhuang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WHN",
    "translations": [
      "Wuhan Hannan Municipal Airport",
      "Wuhan Hannan Municipal Airport",
      "Wuhan Hannan Municipal Airport"
    ],
    "city": [
      "Wuhan (Hannan)",
      "Wuhan (Hannan)",
      "Wuhan (Hannan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NAY",
    "translations": [
      "Beijing Nanjiao Airport",
      "Beijing Nanjiao Airport",
      "Beijing Nanjiao Airport"
    ],
    "city": [
      "Beijing",
      "Beijing",
      "Beijing"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "PFA",
    "translations": [
      "Harbin Pingfang Airport",
      "Harbin Pingfang Airport",
      "Harbin Pingfang Airport"
    ],
    "city": [
      "Harbin",
      "Harbin",
      "Harbin"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "PNJ",
    "translations": [
      "Penglai Shahekou Airport",
      "Penglai Shahekou Airport",
      "Penglai Shahekou Airport"
    ],
    "city": [
      "Yantai",
      "Yantai",
      "Yantai"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CBZ",
    "translations": [
      "Binzhou Dagao General Aviation Airport",
      "Binzhou Dagao General Aviation Airport",
      "Binzhou Dagao General Aviation Airport"
    ],
    "city": [
      "Binzhou",
      "Binzhou",
      "Binzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DDR",
    "translations": [
      "Rikaze Dingri Airport",
      "Rikaze Dingri Airport",
      "Rikaze Dingri Airport"
    ],
    "city": [
      "Xigazê (Dingri)",
      "Xigazê (Dingri)",
      "Xigazê (Dingri)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HQL",
    "translations": [
      "Tashikuergan Hongqilafu Airport",
      "Tashikuergan Hongqilafu Airport",
      "Tashikuergan Hongqilafu Airport"
    ],
    "city": [
      "Tashikuergan",
      "Tashikuergan",
      "Tashikuergan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HEW",
    "translations": [
      "Dongyang Hengdian General Airport",
      "Dongyang Hengdian General Airport",
      "Dongyang Hengdian General Airport"
    ],
    "city": [
      "Jinhua (Dongyang)",
      "Jinhua (Dongyang)",
      "Jinhua (Dongyang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JDE",
    "translations": [
      "Jiande Qiandaohu General Airport",
      "Jiande Qiandaohu General Airport",
      "Jiande Qiandaohu General Airport"
    ],
    "city": [
      "Hangzhou",
      "Hangzhou",
      "Hangzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HLJ",
    "translations": [
      "Zhaodong Beidahuang General Airport",
      "Zhaodong Beidahuang General Airport",
      "Zhaodong Beidahuang General Airport"
    ],
    "city": [
      "Suihua",
      "Suihua",
      "Suihua"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TYC",
    "translations": [
      "Taiyuan Yaocheng Airport",
      "Taiyuan Yaocheng Airport",
      "Taiyuan Yaocheng Airport"
    ],
    "city": [
      "Taiyuan",
      "Taiyuan",
      "Taiyuan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WRH",
    "translations": [
      "Orku Baikouquan Airport (under construction)",
      "Orku Baikouquan Airport (under construction)",
      "Orku Baikouquan Airport (under construction)"
    ],
    "city": [
      "Urhu",
      "Urhu",
      "Urhu"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JRJ",
    "translations": [
      "Ganzhou Ruijin Airport",
      "Ganzhou Ruijin Airport",
      "Ganzhou Ruijin Airport"
    ],
    "city": [
      "Ganzhou",
      "Ganzhou",
      "Ganzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "APJ",
    "translations": [
      "Ali Pulan Airport",
      "Ali Pulan Airport",
      "Ali Pulan Airport"
    ],
    "city": [
      "Burang Town",
      "Burang Town",
      "Burang Town"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ZFL",
    "translations": [
      "Zhaosu Tianma Airport",
      "Zhaosu Tianma Airport",
      "Zhaosu Tianma Airport"
    ],
    "city": [
      "Zhaosu",
      "Zhaosu",
      "Zhaosu"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YEH",
    "translations": [
      "Yinchuan Yueyahu Airport",
      "Yinchuan Yueyahu Airport",
      "Yinchuan Yueyahu Airport"
    ],
    "city": [
      "Yinchuan",
      "Yinchuan",
      "Yinchuan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LCS",
    "translations": [
      "Longchuan Guangsong Airport",
      "Longchuan Guangsong Airport",
      "Longchuan Guangsong Airport"
    ],
    "city": [
      "Dehong (Longchuan)",
      "Dehong (Longchuan)",
      "Dehong (Longchuan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LFH",
    "translations": [
      "Lanping Fenghua General Airport",
      "Lanping Fenghua General Airport",
      "Lanping Fenghua General Airport"
    ],
    "city": [
      "Lanping Bai",
      "Lanping Bai",
      "Lanping Bai"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ZGN",
    "translations": [
      "Zhongshan Ferry Port",
      "Zhongshan Ferry Port",
      "Zhongshan Ferry Port"
    ],
    "city": [
      "Zhongshan",
      "Zhongshan",
      "Zhongshan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "BZJ",
    "translations": [
      "Bozhou Airport (under construction)",
      "Bozhou Airport (under construction)",
      "Bozhou Airport (under construction)"
    ],
    "city": [
      "Bozhou",
      "Bozhou",
      "Bozhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "BKV",
    "translations": [
      "Bailing Airport",
      "Bailing Airport",
      "Bailing Airport"
    ],
    "city": [
      "Bailingmiao",
      "Bailingmiao",
      "Bailingmiao"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HJB",
    "translations": [
      "Hejing Bayinbuluke Airport",
      "Hejing Bayinbuluke Airport",
      "Hejing Bayinbuluke Airport"
    ],
    "city": [
      "Hejing",
      "Hejing",
      "Hejing"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "OTQ",
    "translations": [
      "Otog Front Banner Oljoq Airport",
      "Otog Front Banner Oljoq Airport",
      "Otog Front Banner Oljoq Airport"
    ],
    "city": [
      "Otog Front Banner",
      "Otog Front Banner",
      "Otog Front Banner"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JBK",
    "translations": [
      "Qitai Jiangbulake Airport",
      "Qitai Jiangbulake Airport",
      "Qitai Jiangbulake Airport"
    ],
    "city": [
      "Qitai",
      "Qitai",
      "Qitai"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LIJ",
    "translations": [
      "Lishui Airport",
      "Lishui Airport",
      "Lishui Airport"
    ],
    "city": [
      "Lishui (Liandu)",
      "Lishui (Liandu)",
      "Lishui (Liandu)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YHJ",
    "translations": [
      "Nanchang Yaohu Airport",
      "Nanchang Yaohu Airport",
      "Nanchang Yaohu Airport"
    ],
    "city": [
      "Nanchang",
      "Nanchang",
      "Nanchang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "OTO",
    "translations": [
      "Otog Banner Wulan Airport",
      "Otog Banner Wulan Airport",
      "Otog Banner Wulan Airport"
    ],
    "city": [
      "Wulan",
      "Wulan",
      "Wulan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "BFY",
    "translations": [
      "Bengbu Tenghu Airport (U.C.)",
      "Bengbu Tenghu Airport (U.C.)",
      "Bengbu Tenghu Airport (U.C.)"
    ],
    "city": [
      "Bengbu",
      "Bengbu",
      "Bengbu"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "XBE",
    "translations": [
      "Bearskin Lake Airport",
      "Bearskin Lake Airport",
      "Bearskin Lake Airport"
    ],
    "city": [
      "Bearskin Lake",
      "Bearskin Lake",
      "Bearskin Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YNP",
    "translations": [
      "Natuashish Airport",
      "Natuashish Airport",
      "Natuashish Airport"
    ],
    "city": [
      "Natuashish",
      "Natuashish",
      "Natuashish"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YWR",
    "translations": [
      "White River Seaplane Base",
      "White River Seaplane Base",
      "White River Seaplane Base"
    ],
    "city": [
      "White River",
      "White River",
      "White River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPD",
    "translations": [
      "Parry Sound Area Municipal Airport",
      "Parry Sound Area Municipal Airport",
      "Parry Sound Area Municipal Airport"
    ],
    "city": [
      "Parry Sound",
      "Parry Sound",
      "Parry Sound"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XBR",
    "translations": [
      "Brockville - Thousand Islands Regional Tackaberry Airport",
      "Brockville - Thousand Islands Regional Tackaberry Airport",
      "Brockville - Thousand Islands Regional Tackaberry Airport"
    ],
    "city": [
      "Brockville",
      "Brockville",
      "Brockville"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "KIF",
    "translations": [
      "Kingfisher Lake Airport",
      "Kingfisher Lake Airport",
      "Kingfisher Lake Airport"
    ],
    "city": [
      "Kingfisher Lake",
      "Kingfisher Lake",
      "Kingfisher Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "LCR",
    "translations": [
      "Virgilio Barco Vargas (La Chorrera) Airport",
      "Virgilio Barco Vargas (La Chorrera) Airport",
      "Virgilio Barco Vargas (La Chorrera) Airport"
    ],
    "city": [
      "La Chorrera",
      "La Chorrera",
      "La Chorrera"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "YEB",
    "translations": [
      "Bar River Airport",
      "Bar River Airport",
      "Bar River Airport"
    ],
    "city": [
      "Echo Bay",
      "Echo Bay",
      "Echo Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CPI",
    "translations": [
      "Cape Orford Airport",
      "Cape Orford Airport",
      "Cape Orford Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "YSI",
    "translations": [
      "Parry Sound/Frying Pan Island-Sans Souci Seaplane Base",
      "Parry Sound/Frying Pan Island-Sans Souci Seaplane Base",
      "Parry Sound/Frying Pan Island-Sans Souci Seaplane Base"
    ],
    "city": [
      "Frying Pan Island",
      "Frying Pan Island",
      "Frying Pan Island"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "KEW",
    "translations": [
      "Keewaywin Airport",
      "Keewaywin Airport",
      "Keewaywin Airport"
    ],
    "city": [
      "Keewaywin",
      "Keewaywin",
      "Keewaywin"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ACO",
    "translations": [
      "Cóbano Airport",
      "Cóbano Airport",
      "Cóbano Airport"
    ],
    "city": [
      "Cóbano",
      "Cóbano",
      "Cóbano"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "KFM",
    "translations": [
      "Kirby Lake Airport",
      "Kirby Lake Airport",
      "Kirby Lake Airport"
    ],
    "city": [
      "Kirby Lake",
      "Kirby Lake",
      "Kirby Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSA",
    "translations": [
      "Sable Island Landing Strip",
      "Sable Island Landing Strip",
      "Sable Island Landing Strip"
    ],
    "city": [
      "Sable Island",
      "Sable Island",
      "Sable Island"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLS",
    "translations": [
      "Lebel-sur-Quevillon Airport",
      "Lebel-sur-Quevillon Airport",
      "Lebel-sur-Quevillon Airport"
    ],
    "city": [
      "Lebel-sur-Quévillon",
      "Lebel-sur-Quévillon",
      "Lebel-sur-Quévillon"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YNX",
    "translations": [
      "Snap Lake Airport",
      "Snap Lake Airport",
      "Snap Lake Airport"
    ],
    "city": [
      "Snap Lake Mine",
      "Snap Lake Mine",
      "Snap Lake Mine"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "SSQ",
    "translations": [
      "La Sarre Airport",
      "La Sarre Airport",
      "La Sarre Airport"
    ],
    "city": [
      "La Sarre",
      "La Sarre",
      "La Sarre"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YKU",
    "translations": [
      "Chisasibi Airport",
      "Chisasibi Airport",
      "Chisasibi Airport"
    ],
    "city": [
      "Chisasibi",
      "Chisasibi",
      "Chisasibi"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZTB",
    "translations": [
      "Tête-à-la-Baleine Airport",
      "Tête-à-la-Baleine Airport",
      "Tête-à-la-Baleine Airport"
    ],
    "city": [
      "Tête-à-la-Baleine",
      "Tête-à-la-Baleine",
      "Tête-à-la-Baleine"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZKG",
    "translations": [
      "Kégashka Airport",
      "Kégashka Airport",
      "Kégashka Airport"
    ],
    "city": [
      "Côte-Nord-du-Golfe-du-Saint-Laurent",
      "Côte-Nord-du-Golfe-du-Saint-Laurent",
      "Côte-Nord-du-Golfe-du-Saint-Laurent"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YWQ",
    "translations": [
      "Chute-Des-Passes/Lac Margane Seaplane Base",
      "Chute-Des-Passes/Lac Margane Seaplane Base",
      "Chute-Des-Passes/Lac Margane Seaplane Base"
    ],
    "city": [
      "Chutes-des-Passes",
      "Chutes-des-Passes",
      "Chutes-des-Passes"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CTP",
    "translations": [
      "Carutapera Airport",
      "Carutapera Airport",
      "Carutapera Airport"
    ],
    "city": [
      "Carutapera",
      "Carutapera",
      "Carutapera"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "YAU",
    "translations": [
      "Donaldson Airport",
      "Donaldson Airport",
      "Donaldson Airport"
    ],
    "city": [
      "Kattiniq",
      "Kattiniq",
      "Kattiniq"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZGS",
    "translations": [
      "La Romaine Airport",
      "La Romaine Airport",
      "La Romaine Airport"
    ],
    "city": [
      "Le Golfe-du-Saint-Laurent",
      "Le Golfe-du-Saint-Laurent",
      "Le Golfe-du-Saint-Laurent"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YFG",
    "translations": [
      "Fontanges Airport",
      "Fontanges Airport",
      "Fontanges Airport"
    ],
    "city": [
      "Fontanges",
      "Fontanges",
      "Fontanges"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZLT",
    "translations": [
      "La Tabatière Airport",
      "La Tabatière Airport",
      "La Tabatière Airport"
    ],
    "city": [
      "La Tabatière",
      "La Tabatière",
      "La Tabatière"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CUJ",
    "translations": [
      "Culion Airport",
      "Culion Airport",
      "Culion Airport"
    ],
    "city": [
      "Culion",
      "Culion",
      "Culion"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "CVL",
    "translations": [
      "Cape Vogel Airport",
      "Cape Vogel Airport",
      "Cape Vogel Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "CXC",
    "translations": [
      "Chitina Airport",
      "Chitina Airport",
      "Chitina Airport"
    ],
    "city": [
      "Chitina",
      "Chitina",
      "Chitina"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "YAB",
    "translations": [
      "Arctic Bay Airport",
      "Arctic Bay Airport",
      "Arctic Bay Airport"
    ],
    "city": [
      "Arctic Bay",
      "Arctic Bay",
      "Arctic Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YAC",
    "translations": [
      "Cat Lake Airport",
      "Cat Lake Airport",
      "Cat Lake Airport"
    ],
    "city": [
      "Cat Lake",
      "Cat Lake",
      "Cat Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YAR",
    "translations": [
      "La Grande-3 Airport",
      "La Grande-3 Airport",
      "La Grande-3 Airport"
    ],
    "city": [
      "La Grande-3",
      "La Grande-3",
      "La Grande-3"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YAG",
    "translations": [
      "Fort Frances Municipal Airport",
      "Fort Frances Municipal Airport",
      "Fort Frances Municipal Airport"
    ],
    "city": [
      "Fort Frances",
      "Fort Frances",
      "Fort Frances"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YAH",
    "translations": [
      "La Grande-4 Airport",
      "La Grande-4 Airport",
      "La Grande-4 Airport"
    ],
    "city": [
      "La Grande-4",
      "La Grande-4",
      "La Grande-4"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YAL",
    "translations": [
      "Alert Bay Airport",
      "Alert Bay Airport",
      "Alert Bay Airport"
    ],
    "city": [
      "Alert Bay",
      "Alert Bay",
      "Alert Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YAM",
    "translations": [
      "Sault Ste Marie Airport",
      "Sault Ste Marie Airport",
      "Sault Ste Marie Airport"
    ],
    "city": [
      "Sault Ste Marie",
      "Sault Ste Marie",
      "Sault Ste Marie"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XKS",
    "translations": [
      "Kasabonika Airport",
      "Kasabonika Airport",
      "Kasabonika Airport"
    ],
    "city": [
      "Kasabonika",
      "Kasabonika",
      "Kasabonika"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YKG",
    "translations": [
      "Kangirsuk Airport",
      "Kangirsuk Airport",
      "Kangirsuk Airport"
    ],
    "city": [
      "Kangirsuk",
      "Kangirsuk",
      "Kangirsuk"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YAT",
    "translations": [
      "Attawapiskat Airport",
      "Attawapiskat Airport",
      "Attawapiskat Airport"
    ],
    "city": [
      "Attawapiskat",
      "Attawapiskat",
      "Attawapiskat"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YAY",
    "translations": [
      "St. Anthony Airport",
      "St. Anthony Airport",
      "St. Anthony Airport"
    ],
    "city": [
      "St. Anthony",
      "St. Anthony",
      "St. Anthony"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YAZ",
    "translations": [
      "Tofino / Long Beach Airport",
      "Tofino / Long Beach Airport",
      "Tofino / Long Beach Airport"
    ],
    "city": [
      "Tofino",
      "Tofino",
      "Tofino"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBA",
    "translations": [
      "Banff Airport",
      "Banff Airport",
      "Banff Airport"
    ],
    "city": [
      "Banff",
      "Banff",
      "Banff"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBB",
    "translations": [
      "Kugaaruk Airport",
      "Kugaaruk Airport",
      "Kugaaruk Airport"
    ],
    "city": [
      "Kugaaruk",
      "Kugaaruk",
      "Kugaaruk"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBC",
    "translations": [
      "Baie-Comeau Airport",
      "Baie-Comeau Airport",
      "Baie-Comeau Airport"
    ],
    "city": [
      "Baie-Comeau",
      "Baie-Comeau",
      "Baie-Comeau"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "QBC",
    "translations": [
      "Bella Coola Airport",
      "Bella Coola Airport",
      "Bella Coola Airport"
    ],
    "city": [
      "Bella Coola",
      "Bella Coola",
      "Bella Coola"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBE",
    "translations": [
      "Uranium City Airport",
      "Uranium City Airport",
      "Uranium City Airport"
    ],
    "city": [
      "Uranium City",
      "Uranium City",
      "Uranium City"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBY",
    "translations": [
      "Bonnyville Airport",
      "Bonnyville Airport",
      "Bonnyville Airport"
    ],
    "city": [
      "Bonnyville",
      "Bonnyville",
      "Bonnyville"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBG",
    "translations": [
      "CFB Bagotville / Saguenay-Bagotville Airport",
      "CFB Bagotville / Saguenay-Bagotville Airport",
      "CFB Bagotville / Saguenay-Bagotville Airport"
    ],
    "city": [
      "La Baie",
      "La Baie",
      "La Baie"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBK",
    "translations": [
      "Baker Lake Airport",
      "Baker Lake Airport",
      "Baker Lake Airport"
    ],
    "city": [
      "Baker Lake",
      "Baker Lake",
      "Baker Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBL",
    "translations": [
      "Campbell River Airport",
      "Campbell River Airport",
      "Campbell River Airport"
    ],
    "city": [
      "Campbell River",
      "Campbell River",
      "Campbell River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XTL",
    "translations": [
      "Tadoule Lake Airport",
      "Tadoule Lake Airport",
      "Tadoule Lake Airport"
    ],
    "city": [
      "Tadoule Lake",
      "Tadoule Lake",
      "Tadoule Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBR",
    "translations": [
      "Brandon Municipal Airport",
      "Brandon Municipal Airport",
      "Brandon Municipal Airport"
    ],
    "city": [
      "Brandon",
      "Brandon",
      "Brandon"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBT",
    "translations": [
      "Brochet Airport",
      "Brochet Airport",
      "Brochet Airport"
    ],
    "city": [
      "Brochet",
      "Brochet",
      "Brochet"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBV",
    "translations": [
      "Berens River Airport",
      "Berens River Airport",
      "Berens River Airport"
    ],
    "city": [
      "Berens River",
      "Berens River",
      "Berens River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YBX",
    "translations": [
      "Lourdes-de-Blanc-Sablon Airport",
      "Lourdes-de-Blanc-Sablon Airport",
      "Lourdes-de-Blanc-Sablon Airport"
    ],
    "city": [
      "Blanc-Sablon",
      "Blanc-Sablon",
      "Blanc-Sablon"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRF",
    "translations": [
      "Cartwright Airport",
      "Cartwright Airport",
      "Cartwright Airport"
    ],
    "city": [
      "Cartwright",
      "Cartwright",
      "Cartwright"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCB",
    "translations": [
      "Cambridge Bay Airport",
      "Cambridge Bay Airport",
      "Cambridge Bay Airport"
    ],
    "city": [
      "Cambridge Bay",
      "Cambridge Bay",
      "Cambridge Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCC",
    "translations": [
      "Cornwall Regional Airport",
      "Cornwall Regional Airport",
      "Cornwall Regional Airport"
    ],
    "city": [
      "Cornwall",
      "Cornwall",
      "Cornwall"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCD",
    "translations": [
      "Nanaimo Airport",
      "Nanaimo Airport",
      "Nanaimo Airport"
    ],
    "city": [
      "Nanaimo",
      "Nanaimo",
      "Nanaimo"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCE",
    "translations": [
      "Centralia / James T. Field Memorial Aerodrome",
      "Centralia / James T. Field Memorial Aerodrome",
      "Centralia / James T. Field Memorial Aerodrome"
    ],
    "city": [
      "Huron Park",
      "Huron Park",
      "Huron Park"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCG",
    "translations": [
      "Castlegar/West Kootenay Regional Airport",
      "Castlegar/West Kootenay Regional Airport",
      "Castlegar/West Kootenay Regional Airport"
    ],
    "city": [
      "Castlegar",
      "Castlegar",
      "Castlegar"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCH",
    "translations": [
      "Miramichi Airport",
      "Miramichi Airport",
      "Miramichi Airport"
    ],
    "city": [
      "Miramichi",
      "Miramichi",
      "Miramichi"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XCM",
    "translations": [
      "Chatham Kent Airport",
      "Chatham Kent Airport",
      "Chatham Kent Airport"
    ],
    "city": [
      "Chatham-Kent",
      "Chatham-Kent",
      "Chatham-Kent"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCL",
    "translations": [
      "Charlo Airport",
      "Charlo Airport",
      "Charlo Airport"
    ],
    "city": [
      "Charlo",
      "Charlo",
      "Charlo"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCN",
    "translations": [
      "Cochrane Airport",
      "Cochrane Airport",
      "Cochrane Airport"
    ],
    "city": [
      "Cochrane",
      "Cochrane",
      "Cochrane"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCO",
    "translations": [
      "Kugluktuk Airport",
      "Kugluktuk Airport",
      "Kugluktuk Airport"
    ],
    "city": [
      "Kugluktuk",
      "Kugluktuk",
      "Kugluktuk"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCQ",
    "translations": [
      "Chetwynd Airport",
      "Chetwynd Airport",
      "Chetwynd Airport"
    ],
    "city": [
      "Chetwynd",
      "Chetwynd",
      "Chetwynd"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCR",
    "translations": [
      "Cross Lake (Charlie Sinclair Memorial) Airport",
      "Cross Lake (Charlie Sinclair Memorial) Airport",
      "Cross Lake (Charlie Sinclair Memorial) Airport"
    ],
    "city": [
      "Cross Lake",
      "Cross Lake",
      "Cross Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCS",
    "translations": [
      "Chesterfield Inlet Airport",
      "Chesterfield Inlet Airport",
      "Chesterfield Inlet Airport"
    ],
    "city": [
      "Chesterfield Inlet",
      "Chesterfield Inlet",
      "Chesterfield Inlet"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCT",
    "translations": [
      "Coronation Airport",
      "Coronation Airport",
      "Coronation Airport"
    ],
    "city": [
      "Coronation",
      "Coronation",
      "Coronation"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCW",
    "translations": [
      "Chilliwack Airport",
      "Chilliwack Airport",
      "Chilliwack Airport"
    ],
    "city": [
      "Chilliwack",
      "Chilliwack",
      "Chilliwack"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCY",
    "translations": [
      "Clyde River Airport",
      "Clyde River Airport",
      "Clyde River Airport"
    ],
    "city": [
      "Clyde River",
      "Clyde River",
      "Clyde River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCZ",
    "translations": [
      "Fairmont Hot Springs Airport",
      "Fairmont Hot Springs Airport",
      "Fairmont Hot Springs Airport"
    ],
    "city": [
      "Fairmont Hot Springs",
      "Fairmont Hot Springs",
      "Fairmont Hot Springs"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDA",
    "translations": [
      "Dawson City Airport",
      "Dawson City Airport",
      "Dawson City Airport"
    ],
    "city": [
      "Dawson City",
      "Dawson City",
      "Dawson City"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDB",
    "translations": [
      "Burwash Airport",
      "Burwash Airport",
      "Burwash Airport"
    ],
    "city": [
      "Burwash Landing",
      "Burwash Landing",
      "Burwash Landing"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDF",
    "translations": [
      "Deer Lake Airport",
      "Deer Lake Airport",
      "Deer Lake Airport"
    ],
    "city": [
      "Deer Lake",
      "Deer Lake",
      "Deer Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDL",
    "translations": [
      "Dease Lake Airport",
      "Dease Lake Airport",
      "Dease Lake Airport"
    ],
    "city": [
      "Dease Lake",
      "Dease Lake",
      "Dease Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XRR",
    "translations": [
      "Ross River Airport",
      "Ross River Airport",
      "Ross River Airport"
    ],
    "city": [
      "Ross River",
      "Ross River",
      "Ross River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDN",
    "translations": [
      "Dauphin Barker Airport",
      "Dauphin Barker Airport",
      "Dauphin Barker Airport"
    ],
    "city": [
      "Dauphin",
      "Dauphin",
      "Dauphin"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDO",
    "translations": [
      "Dolbeau-Saint-Felicien Airport",
      "Dolbeau-Saint-Felicien Airport",
      "Dolbeau-Saint-Felicien Airport"
    ],
    "city": [
      "Dolbeau-Saint-Felicien",
      "Dolbeau-Saint-Felicien",
      "Dolbeau-Saint-Felicien"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDP",
    "translations": [
      "Nain Airport",
      "Nain Airport",
      "Nain Airport"
    ],
    "city": [
      "Nain",
      "Nain",
      "Nain"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDQ",
    "translations": [
      "Dawson Creek Airport",
      "Dawson Creek Airport",
      "Dawson Creek Airport"
    ],
    "city": [
      "Dawson Creek",
      "Dawson Creek",
      "Dawson Creek"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YEG",
    "translations": [
      "Edmonton International Airport",
      "Edmonton International Airport",
      "Edmonton International Airport"
    ],
    "city": [
      "Edmonton",
      "Edmonton",
      "Edmonton"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YEK",
    "translations": [
      "Arviat Airport",
      "Arviat Airport",
      "Arviat Airport"
    ],
    "city": [
      "Arviat",
      "Arviat",
      "Arviat"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YEL",
    "translations": [
      "Elliot Lake Municipal Airport",
      "Elliot Lake Municipal Airport",
      "Elliot Lake Municipal Airport"
    ],
    "city": [
      "Elliot Lake",
      "Elliot Lake",
      "Elliot Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YEM",
    "translations": [
      "Manitoulin East Municipal Airport",
      "Manitoulin East Municipal Airport",
      "Manitoulin East Municipal Airport"
    ],
    "city": [
      "Sheguiandah",
      "Sheguiandah",
      "Sheguiandah"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YEN",
    "translations": [
      "Estevan Airport",
      "Estevan Airport",
      "Estevan Airport"
    ],
    "city": [
      "Estevan",
      "Estevan",
      "Estevan"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YER",
    "translations": [
      "Fort Severn Airport",
      "Fort Severn Airport",
      "Fort Severn Airport"
    ],
    "city": [
      "Fort Severn",
      "Fort Severn",
      "Fort Severn"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YET",
    "translations": [
      "Edson Airport",
      "Edson Airport",
      "Edson Airport"
    ],
    "city": [
      "Edson",
      "Edson",
      "Edson"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YEU",
    "translations": [
      "Eureka Airport",
      "Eureka Airport",
      "Eureka Airport"
    ],
    "city": [
      "Eureka",
      "Eureka",
      "Eureka"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YEV",
    "translations": [
      "Inuvik Mike Zubko Airport",
      "Inuvik Mike Zubko Airport",
      "Inuvik Mike Zubko Airport"
    ],
    "city": [
      "Inuvik",
      "Inuvik",
      "Inuvik"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YEY",
    "translations": [
      "Amos/Magny Airport",
      "Amos/Magny Airport",
      "Amos/Magny Airport"
    ],
    "city": [
      "Amos",
      "Amos",
      "Amos"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YFA",
    "translations": [
      "Fort Albany Airport",
      "Fort Albany Airport",
      "Fort Albany Airport"
    ],
    "city": [
      "Fort Albany",
      "Fort Albany",
      "Fort Albany"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YFB",
    "translations": [
      "Iqaluit Airport",
      "Iqaluit Airport",
      "Iqaluit Airport"
    ],
    "city": [
      "Iqaluit",
      "Iqaluit",
      "Iqaluit"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YFC",
    "translations": [
      "Fredericton Airport",
      "Fredericton Airport",
      "Fredericton Airport"
    ],
    "city": [
      "Fredericton",
      "Fredericton",
      "Fredericton"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YFE",
    "translations": [
      "Forestville Airport",
      "Forestville Airport",
      "Forestville Airport"
    ],
    "city": [
      "Forestville",
      "Forestville",
      "Forestville"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YFH",
    "translations": [
      "Fort Hope Airport",
      "Fort Hope Airport",
      "Fort Hope Airport"
    ],
    "city": [
      "Fort Hope",
      "Fort Hope",
      "Fort Hope"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTM",
    "translations": [
      "Mont-Tremblant International Airport",
      "Mont-Tremblant International Airport",
      "Mont-Tremblant International Airport"
    ],
    "city": [
      "La Macaza",
      "La Macaza",
      "La Macaza"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YFO",
    "translations": [
      "Flin Flon Airport",
      "Flin Flon Airport",
      "Flin Flon Airport"
    ],
    "city": [
      "Flin Flon",
      "Flin Flon",
      "Flin Flon"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YFR",
    "translations": [
      "Fort Resolution Airport",
      "Fort Resolution Airport",
      "Fort Resolution Airport"
    ],
    "city": [
      "Fort Resolution",
      "Fort Resolution",
      "Fort Resolution"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YFS",
    "translations": [
      "Fort Simpson Airport",
      "Fort Simpson Airport",
      "Fort Simpson Airport"
    ],
    "city": [
      "Fort Simpson",
      "Fort Simpson",
      "Fort Simpson"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMN",
    "translations": [
      "Makkovik Airport",
      "Makkovik Airport",
      "Makkovik Airport"
    ],
    "city": [
      "Makkovik",
      "Makkovik",
      "Makkovik"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGB",
    "translations": [
      "Texada Gillies Bay Airport",
      "Texada Gillies Bay Airport",
      "Texada Gillies Bay Airport"
    ],
    "city": [
      "Texada",
      "Texada",
      "Texada"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGH",
    "translations": [
      "Fort Good Hope Airport",
      "Fort Good Hope Airport",
      "Fort Good Hope Airport"
    ],
    "city": [
      "Fort Good Hope",
      "Fort Good Hope",
      "Fort Good Hope"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGK",
    "translations": [
      "Kingston Norman Rogers Airport",
      "Kingston Norman Rogers Airport",
      "Kingston Norman Rogers Airport"
    ],
    "city": [
      "Kingston",
      "Kingston",
      "Kingston"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGL",
    "translations": [
      "La Grande Rivière Airport",
      "La Grande Rivière Airport",
      "La Grande Rivière Airport"
    ],
    "city": [
      "La Grande Rivière",
      "La Grande Rivière",
      "La Grande Rivière"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGM",
    "translations": [
      "Gimli Industrial Park Airport",
      "Gimli Industrial Park Airport",
      "Gimli Industrial Park Airport"
    ],
    "city": [
      "Gimli",
      "Gimli",
      "Gimli"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGO",
    "translations": [
      "Gods Lake Narrows Airport",
      "Gods Lake Narrows Airport",
      "Gods Lake Narrows Airport"
    ],
    "city": [
      "Gods Lake Narrows",
      "Gods Lake Narrows",
      "Gods Lake Narrows"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGP",
    "translations": [
      "Michel-Pouliot Gaspé Airport",
      "Michel-Pouliot Gaspé Airport",
      "Michel-Pouliot Gaspé Airport"
    ],
    "city": [
      "Gaspé",
      "Gaspé",
      "Gaspé"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGQ",
    "translations": [
      "Geraldton Greenstone Regional Airport",
      "Geraldton Greenstone Regional Airport",
      "Geraldton Greenstone Regional Airport"
    ],
    "city": [
      "Geraldton",
      "Geraldton",
      "Geraldton"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGR",
    "translations": [
      "Îles-de-la-Madeleine Airport",
      "Îles-de-la-Madeleine Airport",
      "Îles-de-la-Madeleine Airport"
    ],
    "city": [
      "Les Îles-de-la-Madeleine",
      "Les Îles-de-la-Madeleine",
      "Les Îles-de-la-Madeleine"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGT",
    "translations": [
      "Igloolik Airport",
      "Igloolik Airport",
      "Igloolik Airport"
    ],
    "city": [
      "Igloolik",
      "Igloolik",
      "Igloolik"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGV",
    "translations": [
      "Havre-Saint-Pierre Airport",
      "Havre-Saint-Pierre Airport",
      "Havre-Saint-Pierre Airport"
    ],
    "city": [
      "Havre-Saint-Pierre",
      "Havre-Saint-Pierre",
      "Havre-Saint-Pierre"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGW",
    "translations": [
      "Kuujjuarapik Airport",
      "Kuujjuarapik Airport",
      "Kuujjuarapik Airport"
    ],
    "city": [
      "Kuujjuarapik",
      "Kuujjuarapik",
      "Kuujjuarapik"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGX",
    "translations": [
      "Gillam Airport",
      "Gillam Airport",
      "Gillam Airport"
    ],
    "city": [
      "Gillam",
      "Gillam",
      "Gillam"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YGZ",
    "translations": [
      "Grise Fiord Airport",
      "Grise Fiord Airport",
      "Grise Fiord Airport"
    ],
    "city": [
      "Grise Fiord",
      "Grise Fiord",
      "Grise Fiord"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQC",
    "translations": [
      "Quaqtaq Airport",
      "Quaqtaq Airport",
      "Quaqtaq Airport"
    ],
    "city": [
      "Quaqtaq",
      "Quaqtaq",
      "Quaqtaq"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHB",
    "translations": [
      "Hudson Bay Airport",
      "Hudson Bay Airport",
      "Hudson Bay Airport"
    ],
    "city": [
      "Hudson Bay",
      "Hudson Bay",
      "Hudson Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CXH",
    "translations": [
      "Vancouver Harbour Water Aerodrome",
      "Vancouver Harbour Water Aerodrome",
      "Vancouver Harbour Water Aerodrome"
    ],
    "city": [
      "Vancouver",
      "Vancouver",
      "Vancouver"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHD",
    "translations": [
      "Dryden Regional Airport",
      "Dryden Regional Airport",
      "Dryden Regional Airport"
    ],
    "city": [
      "Dryden",
      "Dryden",
      "Dryden"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHE",
    "translations": [
      "Hope Airport / FVRD Regional Airpark",
      "Hope Airport / FVRD Regional Airpark",
      "Hope Airport / FVRD Regional Airpark"
    ],
    "city": [
      "Hope",
      "Hope",
      "Hope"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHF",
    "translations": [
      "Hearst René Fontaine Municipal Airport",
      "Hearst René Fontaine Municipal Airport",
      "Hearst René Fontaine Municipal Airport"
    ],
    "city": [
      "Hearst",
      "Hearst",
      "Hearst"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YNS",
    "translations": [
      "Nemiscau Airport",
      "Nemiscau Airport",
      "Nemiscau Airport"
    ],
    "city": [
      "Nemiscau",
      "Nemiscau",
      "Nemiscau"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHI",
    "translations": [
      "Ulukhaktok Holman Airport",
      "Ulukhaktok Holman Airport",
      "Ulukhaktok Holman Airport"
    ],
    "city": [
      "Ulukhaktok",
      "Ulukhaktok",
      "Ulukhaktok"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHK",
    "translations": [
      "Gjoa Haven Airport",
      "Gjoa Haven Airport",
      "Gjoa Haven Airport"
    ],
    "city": [
      "Gjoa Haven",
      "Gjoa Haven",
      "Gjoa Haven"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHM",
    "translations": [
      "John C. Munro Hamilton International Airport",
      "John C. Munro Hamilton International Airport",
      "John C. Munro Hamilton International Airport"
    ],
    "city": [
      "Hamilton",
      "Hamilton",
      "Hamilton"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHN",
    "translations": [
      "Hornepayne Municipal Airport",
      "Hornepayne Municipal Airport",
      "Hornepayne Municipal Airport"
    ],
    "city": [
      "Hornepayne",
      "Hornepayne",
      "Hornepayne"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHO",
    "translations": [
      "Hopedale Airport",
      "Hopedale Airport",
      "Hopedale Airport"
    ],
    "city": [
      "Hopedale",
      "Hopedale",
      "Hopedale"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHP",
    "translations": [
      "Poplar Hill Airport",
      "Poplar Hill Airport",
      "Poplar Hill Airport"
    ],
    "city": [
      "Poplar Hill",
      "Poplar Hill",
      "Poplar Hill"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHR",
    "translations": [
      "Chevery Airport",
      "Chevery Airport",
      "Chevery Airport"
    ],
    "city": [
      "Chevery",
      "Chevery",
      "Chevery"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHT",
    "translations": [
      "Haines Junction Airport",
      "Haines Junction Airport",
      "Haines Junction Airport"
    ],
    "city": [
      "Haines Junction",
      "Haines Junction",
      "Haines Junction"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHU",
    "translations": [
      "Montréal / Saint-Hubert Metropolitan Airport",
      "Montréal / Saint-Hubert Metropolitan Airport",
      "Montréal / Saint-Hubert Metropolitan Airport"
    ],
    "city": [
      "Montréal",
      "Montréal",
      "Montréal"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHY",
    "translations": [
      "Hay River / Merlyn Carter Airport",
      "Hay River / Merlyn Carter Airport",
      "Hay River / Merlyn Carter Airport"
    ],
    "city": [
      "Hay River",
      "Hay River",
      "Hay River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YHZ",
    "translations": [
      "Halifax / Stanfield International Airport",
      "Halifax / Stanfield International Airport",
      "Halifax / Stanfield International Airport"
    ],
    "city": [
      "Halifax",
      "Halifax",
      "Halifax"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YIB",
    "translations": [
      "Atikokan Municipal Airport",
      "Atikokan Municipal Airport",
      "Atikokan Municipal Airport"
    ],
    "city": [
      "Atikokan",
      "Atikokan",
      "Atikokan"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDG",
    "translations": [
      "Digby / Annapolis Regional Airport",
      "Digby / Annapolis Regional Airport",
      "Digby / Annapolis Regional Airport"
    ],
    "city": [
      "Digby",
      "Digby",
      "Digby"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YIF",
    "translations": [
      "St Augustin Airport",
      "St Augustin Airport",
      "St Augustin Airport"
    ],
    "city": [
      "St-Augustin",
      "St-Augustin",
      "St-Augustin"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YIK",
    "translations": [
      "Ivujivik Airport",
      "Ivujivik Airport",
      "Ivujivik Airport"
    ],
    "city": [
      "Ivujivik",
      "Ivujivik",
      "Ivujivik"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YIO",
    "translations": [
      "Pond Inlet Airport",
      "Pond Inlet Airport",
      "Pond Inlet Airport"
    ],
    "city": [
      "Pond Inlet",
      "Pond Inlet",
      "Pond Inlet"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YIV",
    "translations": [
      "Island Lake Airport",
      "Island Lake Airport",
      "Island Lake Airport"
    ],
    "city": [
      "Island Lake",
      "Island Lake",
      "Island Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YJA",
    "translations": [
      "Jasper Airport",
      "Jasper Airport",
      "Jasper Airport"
    ],
    "city": [
      "Jasper",
      "Jasper",
      "Jasper"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YJF",
    "translations": [
      "Fort Liard Airport",
      "Fort Liard Airport",
      "Fort Liard Airport"
    ],
    "city": [
      "Fort Liard",
      "Fort Liard",
      "Fort Liard"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YJN",
    "translations": [
      "St Jean Airport",
      "St Jean Airport",
      "St Jean Airport"
    ],
    "city": [
      "St Jean",
      "St Jean",
      "St Jean"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YJT",
    "translations": [
      "Dymond Airport",
      "Dymond Airport",
      "Dymond Airport"
    ],
    "city": [
      "Stephenville",
      "Stephenville",
      "Stephenville"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YKA",
    "translations": [
      "Kamloops John Moose Fulton Field Regional Airport",
      "Kamloops John Moose Fulton Field Regional Airport",
      "Kamloops John Moose Fulton Field Regional Airport"
    ],
    "city": [
      "Kamloops",
      "Kamloops",
      "Kamloops"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YKC",
    "translations": [
      "Collins Bay Airport",
      "Collins Bay Airport",
      "Collins Bay Airport"
    ],
    "city": [
      "Collins Bay",
      "Collins Bay",
      "Collins Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "LAK",
    "translations": [
      "Aklavik/Freddie Carmichael Airport",
      "Aklavik/Freddie Carmichael Airport",
      "Aklavik/Freddie Carmichael Airport"
    ],
    "city": [
      "Aklavik",
      "Aklavik",
      "Aklavik"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YKF",
    "translations": [
      "Region of Waterloo International Airport",
      "Region of Waterloo International Airport",
      "Region of Waterloo International Airport"
    ],
    "city": [
      "Breslau",
      "Breslau",
      "Breslau"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YWB",
    "translations": [
      "Kangiqsujuaq (Wakeham Bay) Airport",
      "Kangiqsujuaq (Wakeham Bay) Airport",
      "Kangiqsujuaq (Wakeham Bay) Airport"
    ],
    "city": [
      "Kangiqsujuaq",
      "Kangiqsujuaq",
      "Kangiqsujuaq"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YKJ",
    "translations": [
      "Key Lake Airport",
      "Key Lake Airport",
      "Key Lake Airport"
    ],
    "city": [
      "Key Lake",
      "Key Lake",
      "Key Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YKL",
    "translations": [
      "Schefferville Airport",
      "Schefferville Airport",
      "Schefferville Airport"
    ],
    "city": [
      "Schefferville",
      "Schefferville",
      "Schefferville"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YKD",
    "translations": [
      "Kincardine Municipal Airport",
      "Kincardine Municipal Airport",
      "Kincardine Municipal Airport"
    ],
    "city": [
      "Kincardine",
      "Kincardine",
      "Kincardine"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "AKV",
    "translations": [
      "Akulivik Airport",
      "Akulivik Airport",
      "Akulivik Airport"
    ],
    "city": [
      "Akulivik",
      "Akulivik",
      "Akulivik"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YOG",
    "translations": [
      "Ogoki Post Airport",
      "Ogoki Post Airport",
      "Ogoki Post Airport"
    ],
    "city": [
      "Ogoki Post",
      "Ogoki Post",
      "Ogoki Post"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YKQ",
    "translations": [
      "Waskaganish Airport",
      "Waskaganish Airport",
      "Waskaganish Airport"
    ],
    "city": [
      "Waskaganish",
      "Waskaganish",
      "Waskaganish"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YKX",
    "translations": [
      "Kirkland Lake Airport",
      "Kirkland Lake Airport",
      "Kirkland Lake Airport"
    ],
    "city": [
      "Kirkland Lake",
      "Kirkland Lake",
      "Kirkland Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YKY",
    "translations": [
      "Kindersley Airport",
      "Kindersley Airport",
      "Kindersley Airport"
    ],
    "city": [
      "Kindersley",
      "Kindersley",
      "Kindersley"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPJ",
    "translations": [
      "Aupaluk Airport",
      "Aupaluk Airport",
      "Aupaluk Airport"
    ],
    "city": [
      "Aupaluk",
      "Aupaluk",
      "Aupaluk"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLB",
    "translations": [
      "Lac La Biche Airport",
      "Lac La Biche Airport",
      "Lac La Biche Airport"
    ],
    "city": [
      "Lac La Biche",
      "Lac La Biche",
      "Lac La Biche"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLC",
    "translations": [
      "Kimmirut Airport",
      "Kimmirut Airport",
      "Kimmirut Airport"
    ],
    "city": [
      "Kimmirut",
      "Kimmirut",
      "Kimmirut"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLD",
    "translations": [
      "Chapleau Airport",
      "Chapleau Airport",
      "Chapleau Airport"
    ],
    "city": [
      "Chapleau",
      "Chapleau",
      "Chapleau"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLH",
    "translations": [
      "Lansdowne House Airport",
      "Lansdowne House Airport",
      "Lansdowne House Airport"
    ],
    "city": [
      "Lansdowne House",
      "Lansdowne House",
      "Lansdowne House"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLJ",
    "translations": [
      "Meadow Lake Airport",
      "Meadow Lake Airport",
      "Meadow Lake Airport"
    ],
    "city": [
      "Meadow Lake",
      "Meadow Lake",
      "Meadow Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSG",
    "translations": [
      "Lutselk'e Airport",
      "Lutselk'e Airport",
      "Lutselk'e Airport"
    ],
    "city": [
      "Lutselk'e",
      "Lutselk'e",
      "Lutselk'e"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLL",
    "translations": [
      "Lloydminster Airport",
      "Lloydminster Airport",
      "Lloydminster Airport"
    ],
    "city": [
      "Lloydminster",
      "Lloydminster",
      "Lloydminster"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLQ",
    "translations": [
      "La Tuque Airport",
      "La Tuque Airport",
      "La Tuque Airport"
    ],
    "city": [
      "La Tuque",
      "La Tuque",
      "La Tuque"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLR",
    "translations": [
      "Leaf Rapids Airport",
      "Leaf Rapids Airport",
      "Leaf Rapids Airport"
    ],
    "city": [
      "Leaf Rapids",
      "Leaf Rapids",
      "Leaf Rapids"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLK",
    "translations": [
      "Barrie-Lake Simcoe Regional Airport",
      "Barrie-Lake Simcoe Regional Airport",
      "Barrie-Lake Simcoe Regional Airport"
    ],
    "city": [
      "Barrie",
      "Barrie",
      "Barrie"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLT",
    "translations": [
      "Alert Airport",
      "Alert Airport",
      "Alert Airport"
    ],
    "city": [
      "Alert",
      "Alert",
      "Alert"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XGR",
    "translations": [
      "Kangiqsualujjuaq (Georges River) Airport",
      "Kangiqsualujjuaq (Georges River) Airport",
      "Kangiqsualujjuaq (Georges River) Airport"
    ],
    "city": [
      "Kangiqsualujjuaq",
      "Kangiqsualujjuaq",
      "Kangiqsualujjuaq"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLW",
    "translations": [
      "Kelowna International Airport",
      "Kelowna International Airport",
      "Kelowna International Airport"
    ],
    "city": [
      "Kelowna",
      "Kelowna",
      "Kelowna"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CYM",
    "translations": [
      "Chatham Seaplane Base",
      "Chatham Seaplane Base",
      "Chatham Seaplane Base"
    ],
    "city": [
      "Chatham",
      "Chatham",
      "Chatham"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "YMA",
    "translations": [
      "Mayo Airport",
      "Mayo Airport",
      "Mayo Airport"
    ],
    "city": [
      "Mayo",
      "Mayo",
      "Mayo"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YME",
    "translations": [
      "Matane Airport",
      "Matane Airport",
      "Matane Airport"
    ],
    "city": [
      "Matane",
      "Matane",
      "Matane"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMG",
    "translations": [
      "Manitouwadge Airport",
      "Manitouwadge Airport",
      "Manitouwadge Airport"
    ],
    "city": [
      "Manitouwadge",
      "Manitouwadge",
      "Manitouwadge"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMH",
    "translations": [
      "Mary's Harbour Airport",
      "Mary's Harbour Airport",
      "Mary's Harbour Airport"
    ],
    "city": [
      "Mary's Harbour",
      "Mary's Harbour",
      "Mary's Harbour"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMJ",
    "translations": [
      "Moose Jaw Air Vice Marshal C. M. McEwen Airport",
      "Moose Jaw Air Vice Marshal C. M. McEwen Airport",
      "Moose Jaw Air Vice Marshal C. M. McEwen Airport"
    ],
    "city": [
      "Moose Jaw",
      "Moose Jaw",
      "Moose Jaw"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YML",
    "translations": [
      "Charlevoix Airport",
      "Charlevoix Airport",
      "Charlevoix Airport"
    ],
    "city": [
      "Charlevoix",
      "Charlevoix",
      "Charlevoix"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMM",
    "translations": [
      "Fort McMurray Airport",
      "Fort McMurray Airport",
      "Fort McMurray Airport"
    ],
    "city": [
      "Fort McMurray",
      "Fort McMurray",
      "Fort McMurray"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMO",
    "translations": [
      "Moosonee Airport",
      "Moosonee Airport",
      "Moosonee Airport"
    ],
    "city": [
      "Moosonee",
      "Moosonee",
      "Moosonee"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMT",
    "translations": [
      "Chapais Airport",
      "Chapais Airport",
      "Chapais Airport"
    ],
    "city": [
      "Chibougamau",
      "Chibougamau",
      "Chibougamau"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YUD",
    "translations": [
      "Umiujaq Airport",
      "Umiujaq Airport",
      "Umiujaq Airport"
    ],
    "city": [
      "Umiujaq",
      "Umiujaq",
      "Umiujaq"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMW",
    "translations": [
      "Maniwaki Airport",
      "Maniwaki Airport",
      "Maniwaki Airport"
    ],
    "city": [
      "Messines",
      "Messines",
      "Messines"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YMX",
    "translations": [
      "Montreal International (Mirabel) Airport",
      "Montreal International (Mirabel) Airport",
      "Montreal International (Mirabel) Airport"
    ],
    "city": [
      "Montréal",
      "Montréal",
      "Montréal"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YNA",
    "translations": [
      "Natashquan Airport",
      "Natashquan Airport",
      "Natashquan Airport"
    ],
    "city": [
      "Natashquan",
      "Natashquan",
      "Natashquan"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YNC",
    "translations": [
      "Wemindji Airport",
      "Wemindji Airport",
      "Wemindji Airport"
    ],
    "city": [
      "Wemindji",
      "Wemindji",
      "Wemindji"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YND",
    "translations": [
      "Ottawa / Gatineau Airport",
      "Ottawa / Gatineau Airport",
      "Ottawa / Gatineau Airport"
    ],
    "city": [
      "Gatineau",
      "Gatineau",
      "Gatineau"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YNE",
    "translations": [
      "Norway House Airport",
      "Norway House Airport",
      "Norway House Airport"
    ],
    "city": [
      "Norway House",
      "Norway House",
      "Norway House"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YNH",
    "translations": [
      "Hudson's Hope Airport",
      "Hudson's Hope Airport",
      "Hudson's Hope Airport"
    ],
    "city": [
      "Hudson's Hope",
      "Hudson's Hope",
      "Hudson's Hope"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YLY",
    "translations": [
      "Langley Airport",
      "Langley Airport",
      "Langley Airport"
    ],
    "city": [
      "Langley",
      "Langley",
      "Langley"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YNL",
    "translations": [
      "Points North Landing Airport",
      "Points North Landing Airport",
      "Points North Landing Airport"
    ],
    "city": [
      "Points North Landing",
      "Points North Landing",
      "Points North Landing"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YNM",
    "translations": [
      "Matagami Airport",
      "Matagami Airport",
      "Matagami Airport"
    ],
    "city": [
      "Matagami",
      "Matagami",
      "Matagami"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "HZP",
    "translations": [
      "Fort Mackay / Horizon Airport",
      "Fort Mackay / Horizon Airport",
      "Fort Mackay / Horizon Airport"
    ],
    "city": [
      "Fort Mackay",
      "Fort Mackay",
      "Fort Mackay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YOA",
    "translations": [
      "Ekati Airport",
      "Ekati Airport",
      "Ekati Airport"
    ],
    "city": [
      "Ekati",
      "Ekati",
      "Ekati"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YOC",
    "translations": [
      "Old Crow Airport",
      "Old Crow Airport",
      "Old Crow Airport"
    ],
    "city": [
      "Old Crow",
      "Old Crow",
      "Old Crow"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YOD",
    "translations": [
      "CFB Cold Lake",
      "CFB Cold Lake",
      "CFB Cold Lake"
    ],
    "city": [
      "Cold Lake",
      "Cold Lake",
      "Cold Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YOH",
    "translations": [
      "Oxford House Airport",
      "Oxford House Airport",
      "Oxford House Airport"
    ],
    "city": [
      "Oxford House",
      "Oxford House",
      "Oxford House"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YOJ",
    "translations": [
      "High Level Airport",
      "High Level Airport",
      "High Level Airport"
    ],
    "city": [
      "High Level",
      "High Level",
      "High Level"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YOO",
    "translations": [
      "Oshawa Executive Airport",
      "Oshawa Executive Airport",
      "Oshawa Executive Airport"
    ],
    "city": [
      "Oshawa",
      "Oshawa",
      "Oshawa"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YOP",
    "translations": [
      "Rainbow Lake Airport",
      "Rainbow Lake Airport",
      "Rainbow Lake Airport"
    ],
    "city": [
      "Rainbow Lake",
      "Rainbow Lake",
      "Rainbow Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YOS",
    "translations": [
      "Owen Sound / Billy Bishop Regional Airport",
      "Owen Sound / Billy Bishop Regional Airport",
      "Owen Sound / Billy Bishop Regional Airport"
    ],
    "city": [
      "Owen Sound",
      "Owen Sound",
      "Owen Sound"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YOW",
    "translations": [
      "Ottawa Macdonald-Cartier International Airport",
      "Ottawa Macdonald-Cartier International Airport",
      "Ottawa Macdonald-Cartier International Airport"
    ],
    "city": [
      "Ottawa",
      "Ottawa",
      "Ottawa"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPA",
    "translations": [
      "Prince Albert Glass Field",
      "Prince Albert Glass Field",
      "Prince Albert Glass Field"
    ],
    "city": [
      "Prince Albert",
      "Prince Albert",
      "Prince Albert"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPC",
    "translations": [
      "Paulatuk (Nora Aliqatchialuk Ruben) Airport",
      "Paulatuk (Nora Aliqatchialuk Ruben) Airport",
      "Paulatuk (Nora Aliqatchialuk Ruben) Airport"
    ],
    "city": [
      "Paulatuk",
      "Paulatuk",
      "Paulatuk"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPS",
    "translations": [
      "Port Hawkesbury Airport",
      "Port Hawkesbury Airport",
      "Port Hawkesbury Airport"
    ],
    "city": [
      "Port Hawkesbury",
      "Port Hawkesbury",
      "Port Hawkesbury"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPE",
    "translations": [
      "Peace River Airport",
      "Peace River Airport",
      "Peace River Airport"
    ],
    "city": [
      "Peace River",
      "Peace River",
      "Peace River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPG",
    "translations": [
      "Portage-la-Prairie / Southport Airport",
      "Portage-la-Prairie / Southport Airport",
      "Portage-la-Prairie / Southport Airport"
    ],
    "city": [
      "Portage la Prairie",
      "Portage la Prairie",
      "Portage la Prairie"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPH",
    "translations": [
      "Inukjuak Airport",
      "Inukjuak Airport",
      "Inukjuak Airport"
    ],
    "city": [
      "Inukjuak",
      "Inukjuak",
      "Inukjuak"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPL",
    "translations": [
      "Pickle Lake Airport",
      "Pickle Lake Airport",
      "Pickle Lake Airport"
    ],
    "city": [
      "Pickle Lake",
      "Pickle Lake",
      "Pickle Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPM",
    "translations": [
      "Pikangikum Airport",
      "Pikangikum Airport",
      "Pikangikum Airport"
    ],
    "city": [
      "Pikangikum",
      "Pikangikum",
      "Pikangikum"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPN",
    "translations": [
      "Port-Menier Airport",
      "Port-Menier Airport",
      "Port-Menier Airport"
    ],
    "city": [
      "Port-Menier",
      "Port-Menier",
      "Port-Menier"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPO",
    "translations": [
      "Peawanuck Airport",
      "Peawanuck Airport",
      "Peawanuck Airport"
    ],
    "city": [
      "Peawanuck",
      "Peawanuck",
      "Peawanuck"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPQ",
    "translations": [
      "Peterborough Municipal Airport",
      "Peterborough Municipal Airport",
      "Peterborough Municipal Airport"
    ],
    "city": [
      "Peterborough",
      "Peterborough",
      "Peterborough"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPR",
    "translations": [
      "Prince Rupert Airport",
      "Prince Rupert Airport",
      "Prince Rupert Airport"
    ],
    "city": [
      "Prince Rupert",
      "Prince Rupert",
      "Prince Rupert"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPW",
    "translations": [
      "Powell River Airport",
      "Powell River Airport",
      "Powell River Airport"
    ],
    "city": [
      "Powell River",
      "Powell River",
      "Powell River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPX",
    "translations": [
      "Puvirnituq Airport",
      "Puvirnituq Airport",
      "Puvirnituq Airport"
    ],
    "city": [
      "Puvirnituq",
      "Puvirnituq",
      "Puvirnituq"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPY",
    "translations": [
      "Fort Chipewyan Airport",
      "Fort Chipewyan Airport",
      "Fort Chipewyan Airport"
    ],
    "city": [
      "Fort Chipewyan",
      "Fort Chipewyan",
      "Fort Chipewyan"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YPZ",
    "translations": [
      "Burns Lake Airport",
      "Burns Lake Airport",
      "Burns Lake Airport"
    ],
    "city": [
      "Burns Lake",
      "Burns Lake",
      "Burns Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQA",
    "translations": [
      "Muskoka Airport",
      "Muskoka Airport",
      "Muskoka Airport"
    ],
    "city": [
      "Gravenhurst",
      "Gravenhurst",
      "Gravenhurst"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQB",
    "translations": [
      "Quebec Jean Lesage International Airport",
      "Quebec Jean Lesage International Airport",
      "Quebec Jean Lesage International Airport"
    ],
    "city": [
      "Quebec",
      "Quebec",
      "Quebec"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQD",
    "translations": [
      "The Pas Airport",
      "The Pas Airport",
      "The Pas Airport"
    ],
    "city": [
      "The Pas",
      "The Pas",
      "The Pas"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQF",
    "translations": [
      "Red Deer Regional Airport",
      "Red Deer Regional Airport",
      "Red Deer Regional Airport"
    ],
    "city": [
      "Springbrook",
      "Springbrook",
      "Springbrook"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQG",
    "translations": [
      "Windsor Airport",
      "Windsor Airport",
      "Windsor Airport"
    ],
    "city": [
      "Windsor",
      "Windsor",
      "Windsor"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQH",
    "translations": [
      "Watson Lake Airport",
      "Watson Lake Airport",
      "Watson Lake Airport"
    ],
    "city": [
      "Watson Lake",
      "Watson Lake",
      "Watson Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQI",
    "translations": [
      "Yarmouth Airport",
      "Yarmouth Airport",
      "Yarmouth Airport"
    ],
    "city": [
      "Yarmouth",
      "Yarmouth",
      "Yarmouth"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQK",
    "translations": [
      "Kenora Airport",
      "Kenora Airport",
      "Kenora Airport"
    ],
    "city": [
      "Kenora",
      "Kenora",
      "Kenora"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQL",
    "translations": [
      "Lethbridge County Airport",
      "Lethbridge County Airport",
      "Lethbridge County Airport"
    ],
    "city": [
      "Lethbridge",
      "Lethbridge",
      "Lethbridge"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQM",
    "translations": [
      "Greater Moncton Roméo LeBlanc International Airport",
      "Greater Moncton Roméo LeBlanc International Airport",
      "Greater Moncton Roméo LeBlanc International Airport"
    ],
    "city": [
      "Moncton",
      "Moncton",
      "Moncton"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQN",
    "translations": [
      "Nakina Airport",
      "Nakina Airport",
      "Nakina Airport"
    ],
    "city": [
      "Nakina",
      "Nakina",
      "Nakina"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQQ",
    "translations": [
      "Comox Valley Airport / CFB Comox",
      "Comox Valley Airport / CFB Comox",
      "Comox Valley Airport / CFB Comox"
    ],
    "city": [
      "Comox",
      "Comox",
      "Comox"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQR",
    "translations": [
      "Regina International Airport",
      "Regina International Airport",
      "Regina International Airport"
    ],
    "city": [
      "Regina",
      "Regina",
      "Regina"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQS",
    "translations": [
      "St Thomas Municipal Airport",
      "St Thomas Municipal Airport",
      "St Thomas Municipal Airport"
    ],
    "city": [
      "St Thomas",
      "St Thomas",
      "St Thomas"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQT",
    "translations": [
      "Thunder Bay Airport",
      "Thunder Bay Airport",
      "Thunder Bay Airport"
    ],
    "city": [
      "Thunder Bay",
      "Thunder Bay",
      "Thunder Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQU",
    "translations": [
      "Grande Prairie Airport",
      "Grande Prairie Airport",
      "Grande Prairie Airport"
    ],
    "city": [
      "Grande Prairie",
      "Grande Prairie",
      "Grande Prairie"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQV",
    "translations": [
      "Yorkton Municipal Airport",
      "Yorkton Municipal Airport",
      "Yorkton Municipal Airport"
    ],
    "city": [
      "Yorkton",
      "Yorkton",
      "Yorkton"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQW",
    "translations": [
      "North Battleford Airport",
      "North Battleford Airport",
      "North Battleford Airport"
    ],
    "city": [
      "North Battleford",
      "North Battleford",
      "North Battleford"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQX",
    "translations": [
      "Gander International Airport / CFB Gander",
      "Gander International Airport / CFB Gander",
      "Gander International Airport / CFB Gander"
    ],
    "city": [
      "Gander",
      "Gander",
      "Gander"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQY",
    "translations": [
      "Sydney / J.A. Douglas McCurdy Airport",
      "Sydney / J.A. Douglas McCurdy Airport",
      "Sydney / J.A. Douglas McCurdy Airport"
    ],
    "city": [
      "Sydney",
      "Sydney",
      "Sydney"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YQZ",
    "translations": [
      "Quesnel Airport",
      "Quesnel Airport",
      "Quesnel Airport"
    ],
    "city": [
      "Quesnel",
      "Quesnel",
      "Quesnel"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRA",
    "translations": [
      "Rae Lakes Airport",
      "Rae Lakes Airport",
      "Rae Lakes Airport"
    ],
    "city": [
      "Gamètì",
      "Gamètì",
      "Gamètì"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRB",
    "translations": [
      "Resolute Bay Airport",
      "Resolute Bay Airport",
      "Resolute Bay Airport"
    ],
    "city": [
      "Resolute Bay",
      "Resolute Bay",
      "Resolute Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRI",
    "translations": [
      "Rivière-du-Loup Airport",
      "Rivière-du-Loup Airport",
      "Rivière-du-Loup Airport"
    ],
    "city": [
      "Rivière-du-Loup",
      "Rivière-du-Loup",
      "Rivière-du-Loup"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRJ",
    "translations": [
      "Roberval Airport",
      "Roberval Airport",
      "Roberval Airport"
    ],
    "city": [
      "Roberval",
      "Roberval",
      "Roberval"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRL",
    "translations": [
      "Red Lake Airport",
      "Red Lake Airport",
      "Red Lake Airport"
    ],
    "city": [
      "Red Lake",
      "Red Lake",
      "Red Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRM",
    "translations": [
      "Rocky Mountain House Airport",
      "Rocky Mountain House Airport",
      "Rocky Mountain House Airport"
    ],
    "city": [
      "Rocky Mountain House",
      "Rocky Mountain House",
      "Rocky Mountain House"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRO",
    "translations": [
      "Ottawa / Rockcliffe Airport",
      "Ottawa / Rockcliffe Airport",
      "Ottawa / Rockcliffe Airport"
    ],
    "city": [
      "Ottawa",
      "Ottawa",
      "Ottawa"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRQ",
    "translations": [
      "Trois-Rivières Airport",
      "Trois-Rivières Airport",
      "Trois-Rivières Airport"
    ],
    "city": [
      "Trois-Rivières",
      "Trois-Rivières",
      "Trois-Rivières"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRS",
    "translations": [
      "Red Sucker Lake Airport",
      "Red Sucker Lake Airport",
      "Red Sucker Lake Airport"
    ],
    "city": [
      "Red Sucker Lake",
      "Red Sucker Lake",
      "Red Sucker Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRT",
    "translations": [
      "Rankin Inlet Airport",
      "Rankin Inlet Airport",
      "Rankin Inlet Airport"
    ],
    "city": [
      "Rankin Inlet",
      "Rankin Inlet",
      "Rankin Inlet"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRV",
    "translations": [
      "Revelstoke Airport",
      "Revelstoke Airport",
      "Revelstoke Airport"
    ],
    "city": [
      "Revelstoke",
      "Revelstoke",
      "Revelstoke"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSB",
    "translations": [
      "Sudbury Airport",
      "Sudbury Airport",
      "Sudbury Airport"
    ],
    "city": [
      "Sudbury",
      "Sudbury",
      "Sudbury"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSC",
    "translations": [
      "Sherbrooke Airport",
      "Sherbrooke Airport",
      "Sherbrooke Airport"
    ],
    "city": [
      "Sherbrooke",
      "Sherbrooke",
      "Sherbrooke"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSD",
    "translations": [
      "Canadian Forces Base Suffield Heliport",
      "Canadian Forces Base Suffield Heliport",
      "Canadian Forces Base Suffield Heliport"
    ],
    "city": [
      "Ralston",
      "Ralston",
      "Ralston"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSE",
    "translations": [
      "Squamish Airport",
      "Squamish Airport",
      "Squamish Airport"
    ],
    "city": [
      "Squamish",
      "Squamish",
      "Squamish"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSF",
    "translations": [
      "Stony Rapids Airport",
      "Stony Rapids Airport",
      "Stony Rapids Airport"
    ],
    "city": [
      "Stony Rapids",
      "Stony Rapids",
      "Stony Rapids"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSH",
    "translations": [
      "Smiths Falls-Montague (Russ Beach) Airport",
      "Smiths Falls-Montague (Russ Beach) Airport",
      "Smiths Falls-Montague (Russ Beach) Airport"
    ],
    "city": [
      "Smiths Falls",
      "Smiths Falls",
      "Smiths Falls"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSJ",
    "translations": [
      "Saint John Airport",
      "Saint John Airport",
      "Saint John Airport"
    ],
    "city": [
      "Saint John",
      "Saint John",
      "Saint John"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSK",
    "translations": [
      "Sanikiluaq Airport",
      "Sanikiluaq Airport",
      "Sanikiluaq Airport"
    ],
    "city": [
      "Sanikiluaq",
      "Sanikiluaq",
      "Sanikiluaq"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSL",
    "translations": [
      "Saint-Léonard Airport",
      "Saint-Léonard Airport",
      "Saint-Léonard Airport"
    ],
    "city": [
      "Saint-Léonard",
      "Saint-Léonard",
      "Saint-Léonard"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSM",
    "translations": [
      "Fort Smith Airport",
      "Fort Smith Airport",
      "Fort Smith Airport"
    ],
    "city": [
      "Fort Smith",
      "Fort Smith",
      "Fort Smith"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCM",
    "translations": [
      "Niagara District Airport",
      "Niagara District Airport",
      "Niagara District Airport"
    ],
    "city": [
      "Niagara-on-the-Lake",
      "Niagara-on-the-Lake",
      "Niagara-on-the-Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSP",
    "translations": [
      "Marathon Airport",
      "Marathon Airport",
      "Marathon Airport"
    ],
    "city": [
      "Marathon",
      "Marathon",
      "Marathon"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YST",
    "translations": [
      "St. Theresa Point Airport",
      "St. Theresa Point Airport",
      "St. Theresa Point Airport"
    ],
    "city": [
      "St. Theresa Point",
      "St. Theresa Point",
      "St. Theresa Point"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSU",
    "translations": [
      "Summerside Airport",
      "Summerside Airport",
      "Summerside Airport"
    ],
    "city": [
      "Slemon Park",
      "Slemon Park",
      "Slemon Park"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSY",
    "translations": [
      "Sachs Harbour (David Nasogaluak Jr. Saaryuaq) Airport",
      "Sachs Harbour (David Nasogaluak Jr. Saaryuaq) Airport",
      "Sachs Harbour (David Nasogaluak Jr. Saaryuaq) Airport"
    ],
    "city": [
      "Sachs Harbour",
      "Sachs Harbour",
      "Sachs Harbour"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTA",
    "translations": [
      "Pembroke Airport",
      "Pembroke Airport",
      "Pembroke Airport"
    ],
    "city": [
      "Pembroke",
      "Pembroke",
      "Pembroke"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTE",
    "translations": [
      "Cape Dorset Airport",
      "Cape Dorset Airport",
      "Cape Dorset Airport"
    ],
    "city": [
      "Kinngait",
      "Kinngait",
      "Kinngait"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTF",
    "translations": [
      "Alma Airport",
      "Alma Airport",
      "Alma Airport"
    ],
    "city": [
      "Alma",
      "Alma",
      "Alma"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTH",
    "translations": [
      "Thompson Airport",
      "Thompson Airport",
      "Thompson Airport"
    ],
    "city": [
      "Thompson",
      "Thompson",
      "Thompson"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTL",
    "translations": [
      "Big Trout Lake Airport",
      "Big Trout Lake Airport",
      "Big Trout Lake Airport"
    ],
    "city": [
      "Big Trout Lake",
      "Big Trout Lake",
      "Big Trout Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTQ",
    "translations": [
      "Tasiujaq Airport",
      "Tasiujaq Airport",
      "Tasiujaq Airport"
    ],
    "city": [
      "Tasiujaq",
      "Tasiujaq",
      "Tasiujaq"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTR",
    "translations": [
      "CFB Trenton",
      "CFB Trenton",
      "CFB Trenton"
    ],
    "city": [
      "Trenton",
      "Trenton",
      "Trenton"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTS",
    "translations": [
      "Timmins/Victor M. Power",
      "Timmins/Victor M. Power",
      "Timmins/Victor M. Power"
    ],
    "city": [
      "Timmins",
      "Timmins",
      "Timmins"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTZ",
    "translations": [
      "Billy Bishop Toronto City Centre Airport",
      "Billy Bishop Toronto City Centre Airport",
      "Billy Bishop Toronto City Centre Airport"
    ],
    "city": [
      "Toronto",
      "Toronto",
      "Toronto"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YUB",
    "translations": [
      "Tuktoyaktuk / James Gruben Airport",
      "Tuktoyaktuk / James Gruben Airport",
      "Tuktoyaktuk / James Gruben Airport"
    ],
    "city": [
      "Tuktoyaktuk",
      "Tuktoyaktuk",
      "Tuktoyaktuk"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YUL",
    "translations": [
      "Montreal / Pierre Elliott Trudeau International Airport",
      "Montreal / Pierre Elliott Trudeau International Airport",
      "Montreal / Pierre Elliott Trudeau International Airport"
    ],
    "city": [
      "Montréal",
      "Montréal",
      "Montréal"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YUT",
    "translations": [
      "Naujaat Airport",
      "Naujaat Airport",
      "Naujaat Airport"
    ],
    "city": [
      "Repulse Bay",
      "Repulse Bay",
      "Repulse Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YUX",
    "translations": [
      "Hall Beach Airport",
      "Hall Beach Airport",
      "Hall Beach Airport"
    ],
    "city": [
      "Sanirajak",
      "Sanirajak",
      "Sanirajak"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YUY",
    "translations": [
      "Rouyn Noranda Airport",
      "Rouyn Noranda Airport",
      "Rouyn Noranda Airport"
    ],
    "city": [
      "Rouyn-Noranda",
      "Rouyn-Noranda",
      "Rouyn-Noranda"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YVB",
    "translations": [
      "Bonaventure Airport",
      "Bonaventure Airport",
      "Bonaventure Airport"
    ],
    "city": [
      "Bonaventure",
      "Bonaventure",
      "Bonaventure"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YVC",
    "translations": [
      "La Ronge Airport",
      "La Ronge Airport",
      "La Ronge Airport"
    ],
    "city": [
      "La Ronge",
      "La Ronge",
      "La Ronge"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YVG",
    "translations": [
      "Vermilion Airport",
      "Vermilion Airport",
      "Vermilion Airport"
    ],
    "city": [
      "Vermilion",
      "Vermilion",
      "Vermilion"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YVE",
    "translations": [
      "Vernon Regional Airport",
      "Vernon Regional Airport",
      "Vernon Regional Airport"
    ],
    "city": [
      "Vernon",
      "Vernon",
      "Vernon"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YCK",
    "translations": [
      "Tommy Kochon Airport",
      "Tommy Kochon Airport",
      "Tommy Kochon Airport"
    ],
    "city": [
      "Colville Lake",
      "Colville Lake",
      "Colville Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YVM",
    "translations": [
      "Qikiqtarjuaq Airport",
      "Qikiqtarjuaq Airport",
      "Qikiqtarjuaq Airport"
    ],
    "city": [
      "Qikiqtarjuaq",
      "Qikiqtarjuaq",
      "Qikiqtarjuaq"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YVO",
    "translations": [
      "Val-d'Or Airport",
      "Val-d'Or Airport",
      "Val-d'Or Airport"
    ],
    "city": [
      "Val-d'Or",
      "Val-d'Or",
      "Val-d'Or"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YVP",
    "translations": [
      "Kuujjuaq Airport",
      "Kuujjuaq Airport",
      "Kuujjuaq Airport"
    ],
    "city": [
      "Kuujjuaq",
      "Kuujjuaq",
      "Kuujjuaq"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YVQ",
    "translations": [
      "Norman Wells Airport",
      "Norman Wells Airport",
      "Norman Wells Airport"
    ],
    "city": [
      "Norman Wells",
      "Norman Wells",
      "Norman Wells"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YVR",
    "translations": [
      "Vancouver International Airport",
      "Vancouver International Airport",
      "Vancouver International Airport"
    ],
    "city": [
      "Vancouver",
      "Vancouver",
      "Vancouver"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YVT",
    "translations": [
      "Buffalo Narrows Airport",
      "Buffalo Narrows Airport",
      "Buffalo Narrows Airport"
    ],
    "city": [
      "Buffalo Narrows",
      "Buffalo Narrows",
      "Buffalo Narrows"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YVV",
    "translations": [
      "Wiarton Airport",
      "Wiarton Airport",
      "Wiarton Airport"
    ],
    "city": [
      "Wiarton",
      "Wiarton",
      "Wiarton"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YVZ",
    "translations": [
      "Deer Lake Airport",
      "Deer Lake Airport",
      "Deer Lake Airport"
    ],
    "city": [
      "Deer Lake",
      "Deer Lake",
      "Deer Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YWA",
    "translations": [
      "Petawawa Heliport",
      "Petawawa Heliport",
      "Petawawa Heliport"
    ],
    "city": [
      "Petawawa",
      "Petawawa",
      "Petawawa"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YFJ",
    "translations": [
      "Wekweètì Airport",
      "Wekweètì Airport",
      "Wekweètì Airport"
    ],
    "city": [
      "Wekweètì",
      "Wekweètì",
      "Wekweètì"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YWG",
    "translations": [
      "Winnipeg / James Armstrong Richardson International Airport",
      "Winnipeg / James Armstrong Richardson International Airport",
      "Winnipeg / James Armstrong Richardson International Airport"
    ],
    "city": [
      "Winnipeg",
      "Winnipeg",
      "Winnipeg"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YWH",
    "translations": [
      "Victoria Harbour Seaplane Base",
      "Victoria Harbour Seaplane Base",
      "Victoria Harbour Seaplane Base"
    ],
    "city": [
      "Victoria",
      "Victoria",
      "Victoria"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YWJ",
    "translations": [
      "Déline Airport",
      "Déline Airport",
      "Déline Airport"
    ],
    "city": [
      "Déline",
      "Déline",
      "Déline"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YWK",
    "translations": [
      "Wabush Airport",
      "Wabush Airport",
      "Wabush Airport"
    ],
    "city": [
      "Wabush",
      "Wabush",
      "Wabush"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YWL",
    "translations": [
      "Williams Lake Airport",
      "Williams Lake Airport",
      "Williams Lake Airport"
    ],
    "city": [
      "Williams Lake",
      "Williams Lake",
      "Williams Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YWP",
    "translations": [
      "Webequie Airport",
      "Webequie Airport",
      "Webequie Airport"
    ],
    "city": [
      "Webequie",
      "Webequie",
      "Webequie"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YWY",
    "translations": [
      "Wrigley Airport",
      "Wrigley Airport",
      "Wrigley Airport"
    ],
    "city": [
      "Wrigley",
      "Wrigley",
      "Wrigley"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXC",
    "translations": [
      "Cranbrook/Canadian Rockies International Airport",
      "Cranbrook/Canadian Rockies International Airport",
      "Cranbrook/Canadian Rockies International Airport"
    ],
    "city": [
      "Cranbrook",
      "Cranbrook",
      "Cranbrook"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXE",
    "translations": [
      "Saskatoon John G. Diefenbaker International Airport",
      "Saskatoon John G. Diefenbaker International Airport",
      "Saskatoon John G. Diefenbaker International Airport"
    ],
    "city": [
      "Saskatoon",
      "Saskatoon",
      "Saskatoon"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXH",
    "translations": [
      "Medicine Hat Regional Airport",
      "Medicine Hat Regional Airport",
      "Medicine Hat Regional Airport"
    ],
    "city": [
      "Medicine Hat",
      "Medicine Hat",
      "Medicine Hat"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXJ",
    "translations": [
      "Fort St John / North Peace Regional Airport",
      "Fort St John / North Peace Regional Airport",
      "Fort St John / North Peace Regional Airport"
    ],
    "city": [
      "Fort Saint John",
      "Fort Saint John",
      "Fort Saint John"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXK",
    "translations": [
      "Rimouski Airport",
      "Rimouski Airport",
      "Rimouski Airport"
    ],
    "city": [
      "Rimouski",
      "Rimouski",
      "Rimouski"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXL",
    "translations": [
      "Sioux Lookout Airport",
      "Sioux Lookout Airport",
      "Sioux Lookout Airport"
    ],
    "city": [
      "Sioux Lookout",
      "Sioux Lookout",
      "Sioux Lookout"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXN",
    "translations": [
      "Whale Cove Airport",
      "Whale Cove Airport",
      "Whale Cove Airport"
    ],
    "city": [
      "Whale Cove",
      "Whale Cove",
      "Whale Cove"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXP",
    "translations": [
      "Pangnirtung Airport",
      "Pangnirtung Airport",
      "Pangnirtung Airport"
    ],
    "city": [
      "Pangnirtung",
      "Pangnirtung",
      "Pangnirtung"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXQ",
    "translations": [
      "Beaver Creek Airport",
      "Beaver Creek Airport",
      "Beaver Creek Airport"
    ],
    "city": [
      "Beaver Creek",
      "Beaver Creek",
      "Beaver Creek"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXR",
    "translations": [
      "Earlton (Timiskaming Regional) Airport",
      "Earlton (Timiskaming Regional) Airport",
      "Earlton (Timiskaming Regional) Airport"
    ],
    "city": [
      "Earlton",
      "Earlton",
      "Earlton"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXS",
    "translations": [
      "Prince George Airport",
      "Prince George Airport",
      "Prince George Airport"
    ],
    "city": [
      "Prince George",
      "Prince George",
      "Prince George"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXT",
    "translations": [
      "Northwest Regional Airport Terrace-Kitimat",
      "Northwest Regional Airport Terrace-Kitimat",
      "Northwest Regional Airport Terrace-Kitimat"
    ],
    "city": [
      "Terrace",
      "Terrace",
      "Terrace"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXU",
    "translations": [
      "London Airport",
      "London Airport",
      "London Airport"
    ],
    "city": [
      "London",
      "London",
      "London"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXX",
    "translations": [
      "Abbotsford International Airport",
      "Abbotsford International Airport",
      "Abbotsford International Airport"
    ],
    "city": [
      "Abbotsford",
      "Abbotsford",
      "Abbotsford"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXY",
    "translations": [
      "Whitehorse / Erik Nielsen International Airport",
      "Whitehorse / Erik Nielsen International Airport",
      "Whitehorse / Erik Nielsen International Airport"
    ],
    "city": [
      "Whitehorse",
      "Whitehorse",
      "Whitehorse"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YXZ",
    "translations": [
      "Wawa Airport",
      "Wawa Airport",
      "Wawa Airport"
    ],
    "city": [
      "Wawa",
      "Wawa",
      "Wawa"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYB",
    "translations": [
      "North Bay Jack Garland Airport",
      "North Bay Jack Garland Airport",
      "North Bay Jack Garland Airport"
    ],
    "city": [
      "North Bay",
      "North Bay",
      "North Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYC",
    "translations": [
      "Calgary International Airport",
      "Calgary International Airport",
      "Calgary International Airport"
    ],
    "city": [
      "Calgary",
      "Calgary",
      "Calgary"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYD",
    "translations": [
      "Smithers Airport",
      "Smithers Airport",
      "Smithers Airport"
    ],
    "city": [
      "Smithers",
      "Smithers",
      "Smithers"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYE",
    "translations": [
      "Fort Nelson Airport",
      "Fort Nelson Airport",
      "Fort Nelson Airport"
    ],
    "city": [
      "Fort Nelson",
      "Fort Nelson",
      "Fort Nelson"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYF",
    "translations": [
      "Penticton Airport",
      "Penticton Airport",
      "Penticton Airport"
    ],
    "city": [
      "Penticton",
      "Penticton",
      "Penticton"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYG",
    "translations": [
      "Charlottetown Airport",
      "Charlottetown Airport",
      "Charlottetown Airport"
    ],
    "city": [
      "Charlottetown",
      "Charlottetown",
      "Charlottetown"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYH",
    "translations": [
      "Taloyoak Airport",
      "Taloyoak Airport",
      "Taloyoak Airport"
    ],
    "city": [
      "Taloyoak",
      "Taloyoak",
      "Taloyoak"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYJ",
    "translations": [
      "Victoria International Airport",
      "Victoria International Airport",
      "Victoria International Airport"
    ],
    "city": [
      "Victoria",
      "Victoria",
      "Victoria"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYL",
    "translations": [
      "Lynn Lake Airport",
      "Lynn Lake Airport",
      "Lynn Lake Airport"
    ],
    "city": [
      "Lynn Lake",
      "Lynn Lake",
      "Lynn Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYM",
    "translations": [
      "Cowley Airport",
      "Cowley Airport",
      "Cowley Airport"
    ],
    "city": [
      "Cowley",
      "Cowley",
      "Cowley"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYN",
    "translations": [
      "Swift Current Airport",
      "Swift Current Airport",
      "Swift Current Airport"
    ],
    "city": [
      "Swift Current",
      "Swift Current",
      "Swift Current"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYQ",
    "translations": [
      "Churchill Airport",
      "Churchill Airport",
      "Churchill Airport"
    ],
    "city": [
      "Churchill",
      "Churchill",
      "Churchill"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYR",
    "translations": [
      "Goose Bay Airport",
      "Goose Bay Airport",
      "Goose Bay Airport"
    ],
    "city": [
      "Goose Bay",
      "Goose Bay",
      "Goose Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYT",
    "translations": [
      "St. John's International Airport",
      "St. John's International Airport",
      "St. John's International Airport"
    ],
    "city": [
      "St. John's",
      "St. John's",
      "St. John's"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYU",
    "translations": [
      "Kapuskasing Airport",
      "Kapuskasing Airport",
      "Kapuskasing Airport"
    ],
    "city": [
      "Kapuskasing",
      "Kapuskasing",
      "Kapuskasing"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYW",
    "translations": [
      "Armstrong Airport",
      "Armstrong Airport",
      "Armstrong Airport"
    ],
    "city": [
      "Armstrong",
      "Armstrong",
      "Armstrong"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYY",
    "translations": [
      "Mont Joli Airport",
      "Mont Joli Airport",
      "Mont Joli Airport"
    ],
    "city": [
      "Mont-Joli",
      "Mont-Joli",
      "Mont-Joli"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YYZ",
    "translations": [
      "Toronto Lester B. Pearson International Airport",
      "Toronto Lester B. Pearson International Airport",
      "Toronto Lester B. Pearson International Airport"
    ],
    "city": [
      "Toronto",
      "Toronto",
      "Toronto"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZE",
    "translations": [
      "Gore Bay Manitoulin Airport",
      "Gore Bay Manitoulin Airport",
      "Gore Bay Manitoulin Airport"
    ],
    "city": [
      "Gore Bay",
      "Gore Bay",
      "Gore Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZF",
    "translations": [
      "Yellowknife International Airport",
      "Yellowknife International Airport",
      "Yellowknife International Airport"
    ],
    "city": [
      "Yellowknife",
      "Yellowknife",
      "Yellowknife"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZG",
    "translations": [
      "Salluit Airport",
      "Salluit Airport",
      "Salluit Airport"
    ],
    "city": [
      "Salluit",
      "Salluit",
      "Salluit"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZH",
    "translations": [
      "Slave Lake Airport",
      "Slave Lake Airport",
      "Slave Lake Airport"
    ],
    "city": [
      "Slave Lake",
      "Slave Lake",
      "Slave Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZP",
    "translations": [
      "Sandspit Airport",
      "Sandspit Airport",
      "Sandspit Airport"
    ],
    "city": [
      "Sandspit",
      "Sandspit",
      "Sandspit"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZR",
    "translations": [
      "Chris Hadfield Airport",
      "Chris Hadfield Airport",
      "Chris Hadfield Airport"
    ],
    "city": [
      "Sarnia",
      "Sarnia",
      "Sarnia"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZS",
    "translations": [
      "Coral Harbour Airport",
      "Coral Harbour Airport",
      "Coral Harbour Airport"
    ],
    "city": [
      "Coral Harbour",
      "Coral Harbour",
      "Coral Harbour"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZT",
    "translations": [
      "Port Hardy Airport",
      "Port Hardy Airport",
      "Port Hardy Airport"
    ],
    "city": [
      "Port Hardy",
      "Port Hardy",
      "Port Hardy"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZU",
    "translations": [
      "Whitecourt Airport",
      "Whitecourt Airport",
      "Whitecourt Airport"
    ],
    "city": [
      "Whitecourt",
      "Whitecourt",
      "Whitecourt"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZV",
    "translations": [
      "Sept-Îles Airport",
      "Sept-Îles Airport",
      "Sept-Îles Airport"
    ],
    "city": [
      "Sept-Îles",
      "Sept-Îles",
      "Sept-Îles"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZW",
    "translations": [
      "Teslin Airport",
      "Teslin Airport",
      "Teslin Airport"
    ],
    "city": [
      "Teslin",
      "Teslin",
      "Teslin"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YZX",
    "translations": [
      "CFB Greenwood",
      "CFB Greenwood",
      "CFB Greenwood"
    ],
    "city": [
      "Greenwood",
      "Greenwood",
      "Greenwood"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZAC",
    "translations": [
      "York Landing Airport",
      "York Landing Airport",
      "York Landing Airport"
    ],
    "city": [
      "York Landing",
      "York Landing",
      "York Landing"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YSN",
    "translations": [
      "Shuswap Regional Airport",
      "Shuswap Regional Airport",
      "Shuswap Regional Airport"
    ],
    "city": [
      "Salmon Arm",
      "Salmon Arm",
      "Salmon Arm"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDT",
    "translations": [
      "Boundary Bay Airport",
      "Boundary Bay Airport",
      "Boundary Bay Airport"
    ],
    "city": [
      "Delta",
      "Delta",
      "Delta"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ILF",
    "translations": [
      "Ilford Airport",
      "Ilford Airport",
      "Ilford Airport"
    ],
    "city": [
      "Ilford",
      "Ilford",
      "Ilford"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZBF",
    "translations": [
      "Bathurst Airport",
      "Bathurst Airport",
      "Bathurst Airport"
    ],
    "city": [
      "South Tetagouche",
      "South Tetagouche",
      "South Tetagouche"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZBM",
    "translations": [
      "Bromont (Roland Désourdy) Airport",
      "Bromont (Roland Désourdy) Airport",
      "Bromont (Roland Désourdy) Airport"
    ],
    "city": [
      "Bromont",
      "Bromont",
      "Bromont"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "KES",
    "translations": [
      "Kelsey Airport",
      "Kelsey Airport",
      "Kelsey Airport"
    ],
    "city": [
      "Kelsey",
      "Kelsey",
      "Kelsey"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZEM",
    "translations": [
      "Eastmain River Airport",
      "Eastmain River Airport",
      "Eastmain River Airport"
    ],
    "city": [
      "Eastmain River",
      "Eastmain River",
      "Eastmain River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZFA",
    "translations": [
      "Faro Airport",
      "Faro Airport",
      "Faro Airport"
    ],
    "city": [
      "Faro",
      "Faro",
      "Faro"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZFD",
    "translations": [
      "Fond-du-Lac Airport",
      "Fond-du-Lac Airport",
      "Fond-du-Lac Airport"
    ],
    "city": [
      "Fond-du-Lac",
      "Fond-du-Lac",
      "Fond-du-Lac"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XPK",
    "translations": [
      "Pukatawagan Airport",
      "Pukatawagan Airport",
      "Pukatawagan Airport"
    ],
    "city": [
      "Pukatawagan",
      "Pukatawagan",
      "Pukatawagan"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZFM",
    "translations": [
      "Fort Mcpherson Airport",
      "Fort Mcpherson Airport",
      "Fort Mcpherson Airport"
    ],
    "city": [
      "Fort Mcpherson",
      "Fort Mcpherson",
      "Fort Mcpherson"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZFN",
    "translations": [
      "Tulita Airport",
      "Tulita Airport",
      "Tulita Airport"
    ],
    "city": [
      "Tulita",
      "Tulita",
      "Tulita"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZGF",
    "translations": [
      "Grand Forks Airport",
      "Grand Forks Airport",
      "Grand Forks Airport"
    ],
    "city": [
      "Grand Forks",
      "Grand Forks",
      "Grand Forks"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZGI",
    "translations": [
      "Gods River Airport",
      "Gods River Airport",
      "Gods River Airport"
    ],
    "city": [
      "Gods River",
      "Gods River",
      "Gods River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZGR",
    "translations": [
      "Little Grand Rapids Airport",
      "Little Grand Rapids Airport",
      "Little Grand Rapids Airport"
    ],
    "city": [
      "Little Grand Rapids",
      "Little Grand Rapids",
      "Little Grand Rapids"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZHP",
    "translations": [
      "High Prairie Airport",
      "High Prairie Airport",
      "High Prairie Airport"
    ],
    "city": [
      "High Prairie",
      "High Prairie",
      "High Prairie"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CZJ",
    "translations": [
      "Corazón de Jesús Airport",
      "Corazón de Jesús Airport",
      "Corazón de Jesús Airport"
    ],
    "city": [
      "Tupile",
      "Tupile",
      "Tupile"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "ZJG",
    "translations": [
      "Jenpeg Airport",
      "Jenpeg Airport",
      "Jenpeg Airport"
    ],
    "city": [
      "Jenpeg",
      "Jenpeg",
      "Jenpeg"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZJN",
    "translations": [
      "Swan River Airport",
      "Swan River Airport",
      "Swan River Airport"
    ],
    "city": [
      "Swan River",
      "Swan River",
      "Swan River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZKE",
    "translations": [
      "Kashechewan Airport",
      "Kashechewan Airport",
      "Kashechewan Airport"
    ],
    "city": [
      "Kashechewan",
      "Kashechewan",
      "Kashechewan"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YTD",
    "translations": [
      "Thicket Portage Airport",
      "Thicket Portage Airport",
      "Thicket Portage Airport"
    ],
    "city": [
      "Thicket Portage",
      "Thicket Portage",
      "Thicket Portage"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "MSA",
    "translations": [
      "Muskrat Dam Airport",
      "Muskrat Dam Airport",
      "Muskrat Dam Airport"
    ],
    "city": [
      "Muskrat Dam",
      "Muskrat Dam",
      "Muskrat Dam"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZMH",
    "translations": [
      "South Cariboo Region / 108 Mile Airport",
      "South Cariboo Region / 108 Mile Airport",
      "South Cariboo Region / 108 Mile Airport"
    ],
    "city": [
      "108 Mile",
      "108 Mile",
      "108 Mile"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "PIW",
    "translations": [
      "Pikwitonei Airport",
      "Pikwitonei Airport",
      "Pikwitonei Airport"
    ],
    "city": [
      "Pikwitonei",
      "Pikwitonei",
      "Pikwitonei"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZMT",
    "translations": [
      "Masset Airport",
      "Masset Airport",
      "Masset Airport"
    ],
    "city": [
      "Masset",
      "Masset",
      "Masset"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CZN",
    "translations": [
      "Chisana Airport",
      "Chisana Airport",
      "Chisana Airport"
    ],
    "city": [
      "Chisana",
      "Chisana",
      "Chisana"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "XPP",
    "translations": [
      "Poplar River Airport",
      "Poplar River Airport",
      "Poplar River Airport"
    ],
    "city": [
      "Poplar River",
      "Poplar River",
      "Poplar River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CZO",
    "translations": [
      "Chistochina Airport",
      "Chistochina Airport",
      "Chistochina Airport"
    ],
    "city": [
      "Chistochina",
      "Chistochina",
      "Chistochina"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ZPB",
    "translations": [
      "Sachigo Lake Airport",
      "Sachigo Lake Airport",
      "Sachigo Lake Airport"
    ],
    "city": [
      "Sachigo Lake",
      "Sachigo Lake",
      "Sachigo Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "WPC",
    "translations": [
      "Pincher Creek Airport",
      "Pincher Creek Airport",
      "Pincher Creek Airport"
    ],
    "city": [
      "Pincher Creek",
      "Pincher Creek",
      "Pincher Creek"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZPO",
    "translations": [
      "Pinehouse Lake Airport",
      "Pinehouse Lake Airport",
      "Pinehouse Lake Airport"
    ],
    "city": [
      "Pinehouse Lake",
      "Pinehouse Lake",
      "Pinehouse Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZRJ",
    "translations": [
      "Round Lake (Weagamow Lake) Airport",
      "Round Lake (Weagamow Lake) Airport",
      "Round Lake (Weagamow Lake) Airport"
    ],
    "city": [
      "Round Lake",
      "Round Lake",
      "Round Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZSJ",
    "translations": [
      "Sandy Lake Airport",
      "Sandy Lake Airport",
      "Sandy Lake Airport"
    ],
    "city": [
      "Sandy Lake",
      "Sandy Lake",
      "Sandy Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XSI",
    "translations": [
      "South Indian Lake Airport",
      "South Indian Lake Airport",
      "South Indian Lake Airport"
    ],
    "city": [
      "South Indian Lake",
      "South Indian Lake",
      "South Indian Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZST",
    "translations": [
      "Stewart Airport",
      "Stewart Airport",
      "Stewart Airport"
    ],
    "city": [
      "Stewart",
      "Stewart",
      "Stewart"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZSW",
    "translations": [
      "Prince Rupert/Seal Cove Seaplane Base",
      "Prince Rupert/Seal Cove Seaplane Base",
      "Prince Rupert/Seal Cove Seaplane Base"
    ],
    "city": [
      "Prince Rupert",
      "Prince Rupert",
      "Prince Rupert"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YDV",
    "translations": [
      "Bloodvein River Airport",
      "Bloodvein River Airport",
      "Bloodvein River Airport"
    ],
    "city": [
      "Bloodvein River",
      "Bloodvein River",
      "Bloodvein River"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZTM",
    "translations": [
      "Shamattawa Airport",
      "Shamattawa Airport",
      "Shamattawa Airport"
    ],
    "city": [
      "Shamattawa",
      "Shamattawa",
      "Shamattawa"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZUC",
    "translations": [
      "Ignace Municipal Airport",
      "Ignace Municipal Airport",
      "Ignace Municipal Airport"
    ],
    "city": [
      "Ignace",
      "Ignace",
      "Ignace"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZUM",
    "translations": [
      "Churchill Falls Airport",
      "Churchill Falls Airport",
      "Churchill Falls Airport"
    ],
    "city": [
      "Churchill Falls",
      "Churchill Falls",
      "Churchill Falls"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XLB",
    "translations": [
      "Lac Brochet Airport",
      "Lac Brochet Airport",
      "Lac Brochet Airport"
    ],
    "city": [
      "Lac Brochet",
      "Lac Brochet",
      "Lac Brochet"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ZWL",
    "translations": [
      "Wollaston Lake Airport",
      "Wollaston Lake Airport",
      "Wollaston Lake Airport"
    ],
    "city": [
      "Wollaston Lake",
      "Wollaston Lake",
      "Wollaston Lake"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "IUA",
    "translations": [
      "Canandaigua Airport",
      "Canandaigua Airport",
      "Canandaigua Airport"
    ],
    "city": [
      "Ontario County IDA",
      "Ontario County IDA",
      "Ontario County IDA"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DJN",
    "translations": [
      "Delta Junction Airport",
      "Delta Junction Airport",
      "Delta Junction Airport"
    ],
    "city": [
      "Delta Junction",
      "Delta Junction",
      "Delta Junction"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MQV",
    "translations": [
      "Mostaganem Airport",
      "Mostaganem Airport",
      "Mostaganem Airport"
    ],
    "city": [
      "Sayada",
      "Sayada",
      "Sayada"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "BUJ",
    "translations": [
      "Bou Saada Airport",
      "Bou Saada Airport",
      "Bou Saada Airport"
    ],
    "city": [
      "Ouled Sidi Brahim",
      "Ouled Sidi Brahim",
      "Ouled Sidi Brahim"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "BJA",
    "translations": [
      "Soummam–Abane Ramdane Airport",
      "Soummam–Abane Ramdane Airport",
      "Soummam–Abane Ramdane Airport"
    ],
    "city": [
      "Béjaïa",
      "Béjaïa",
      "Béjaïa"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "ALG",
    "translations": [
      "Houari Boumediene Airport",
      "Houari Boumediene Airport",
      "Houari Boumediene Airport"
    ],
    "city": [
      "Algiers",
      "Algiers",
      "Algiers"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "DJG",
    "translations": [
      "Djanet Inedbirene Airport",
      "Djanet Inedbirene Airport",
      "Djanet Inedbirene Airport"
    ],
    "city": [
      "Djanet",
      "Djanet",
      "Djanet"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "VVZ",
    "translations": [
      "Illizi Takhamalt Airport",
      "Illizi Takhamalt Airport",
      "Illizi Takhamalt Airport"
    ],
    "city": [
      "Illizi",
      "Illizi",
      "Illizi"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "QSF",
    "translations": [
      "Ain Arnat Airport",
      "Ain Arnat Airport",
      "Ain Arnat Airport"
    ],
    "city": [
      "Sétif",
      "Sétif",
      "Sétif"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "TMR",
    "translations": [
      "Aguenar – Hadj Bey Akhamok Airport",
      "Aguenar – Hadj Bey Akhamok Airport",
      "Aguenar – Hadj Bey Akhamok Airport"
    ],
    "city": [
      "Tamanrasset",
      "Tamanrasset",
      "Tamanrasset"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "GJL",
    "translations": [
      "Jijel Ferhat Abbas Airport",
      "Jijel Ferhat Abbas Airport",
      "Jijel Ferhat Abbas Airport"
    ],
    "city": [
      "Tahir",
      "Tahir",
      "Tahir"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "MZW",
    "translations": [
      "Mecheria Airport",
      "Mecheria Airport",
      "Mecheria Airport"
    ],
    "city": [
      "Mecheria",
      "Mecheria",
      "Mecheria"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "AAE",
    "translations": [
      "Annaba Rabah Bitat Airport",
      "Annaba Rabah Bitat Airport",
      "Annaba Rabah Bitat Airport"
    ],
    "city": [
      "Annaba",
      "Annaba",
      "Annaba"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "CZL",
    "translations": [
      "Mohamed Boudiaf International Airport",
      "Mohamed Boudiaf International Airport",
      "Mohamed Boudiaf International Airport"
    ],
    "city": [
      "Constantine",
      "Constantine",
      "Constantine"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "QMH",
    "translations": [
      "Oum El Bouaghi Air Base",
      "Oum El Bouaghi Air Base",
      "Oum El Bouaghi Air Base"
    ],
    "city": [
      "Oum El Bouaghi",
      "Oum El Bouaghi",
      "Oum El Bouaghi"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "TEE",
    "translations": [
      "Cheikh Larbi Tébessi Airport",
      "Cheikh Larbi Tébessi Airport",
      "Cheikh Larbi Tébessi Airport"
    ],
    "city": [
      "Tébessi",
      "Tébessi",
      "Tébessi"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "BLJ",
    "translations": [
      "Batna Mostefa Ben Boulaid Airport",
      "Batna Mostefa Ben Boulaid Airport",
      "Batna Mostefa Ben Boulaid Airport"
    ],
    "city": [
      "Batna",
      "Batna",
      "Batna"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "DAF",
    "translations": [
      "Daup Airport",
      "Daup Airport",
      "Daup Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "HRM",
    "translations": [
      "Hassi R'Mel Airport",
      "Hassi R'Mel Airport",
      "Hassi R'Mel Airport"
    ],
    "city": [
      "Hassi R'Mel",
      "Hassi R'Mel",
      "Hassi R'Mel"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "DAH",
    "translations": [
      "Dathina Airport",
      "Dathina Airport",
      "Dathina Airport"
    ],
    "city": [
      "Dathina",
      "Dathina",
      "Dathina"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "DAO",
    "translations": [
      "Dabo Airport",
      "Dabo Airport",
      "Dabo Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TID",
    "translations": [
      "Abdelhafid Boussouf Bou Chekif Airport",
      "Abdelhafid Boussouf Bou Chekif Airport",
      "Abdelhafid Boussouf Bou Chekif Airport"
    ],
    "city": [
      "Tiaret",
      "Tiaret",
      "Tiaret"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "TIN",
    "translations": [
      "Tindouf Airport",
      "Tindouf Airport",
      "Tindouf Airport"
    ],
    "city": [
      "Tindouf",
      "Tindouf",
      "Tindouf"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "CFK",
    "translations": [
      "Chlef Aboubakr Belkaid International Airport",
      "Chlef Aboubakr Belkaid International Airport",
      "Chlef Aboubakr Belkaid International Airport"
    ],
    "city": [
      "Chlef",
      "Chlef",
      "Chlef"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "TAF",
    "translations": [
      "Oran Tafraoui Airport",
      "Oran Tafraoui Airport",
      "Oran Tafraoui Airport"
    ],
    "city": [
      "Tafraoui",
      "Tafraoui",
      "Tafraoui"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "TLM",
    "translations": [
      "Zenata – Messali El Hadj Airport",
      "Zenata – Messali El Hadj Airport",
      "Zenata – Messali El Hadj Airport"
    ],
    "city": [
      "Zenata",
      "Zenata",
      "Zenata"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "ORN",
    "translations": [
      "Oran Es-Sénia (Ahmed Ben Bella) International Airport",
      "Oran Es-Sénia (Ahmed Ben Bella) International Airport",
      "Oran Es-Sénia (Ahmed Ben Bella) International Airport"
    ],
    "city": [
      "Es-Sénia",
      "Es-Sénia",
      "Es-Sénia"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "CBH",
    "translations": [
      "Béchar Boudghene Ben Ali Lotfi Airport",
      "Béchar Boudghene Ben Ali Lotfi Airport",
      "Béchar Boudghene Ben Ali Lotfi Airport"
    ],
    "city": [
      "Béchar",
      "Béchar",
      "Béchar"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "BFW",
    "translations": [
      "Sidi Bel Abbes Airport",
      "Sidi Bel Abbes Airport",
      "Sidi Bel Abbes Airport"
    ],
    "city": [
      "Sidi Bel Abbès",
      "Sidi Bel Abbès",
      "Sidi Bel Abbès"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "MUW",
    "translations": [
      "Ghriss Airport",
      "Ghriss Airport",
      "Ghriss Airport"
    ],
    "city": [
      "Ghriss",
      "Ghriss",
      "Ghriss"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "EBH",
    "translations": [
      "El Bayadh Airport",
      "El Bayadh Airport",
      "El Bayadh Airport"
    ],
    "city": [
      "El Bayadh",
      "El Bayadh",
      "El Bayadh"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "INF",
    "translations": [
      "In Guezzam Airport",
      "In Guezzam Airport",
      "In Guezzam Airport"
    ],
    "city": [
      "In Guezzam",
      "In Guezzam",
      "In Guezzam"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "BMW",
    "translations": [
      "Bordj Badji Mokhtar Airport",
      "Bordj Badji Mokhtar Airport",
      "Bordj Badji Mokhtar Airport"
    ],
    "city": [
      "Bordj Badji Mokhtar",
      "Bordj Badji Mokhtar",
      "Bordj Badji Mokhtar"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "AZR",
    "translations": [
      "Touat Cheikh Sidi Mohamed Belkebir Airport",
      "Touat Cheikh Sidi Mohamed Belkebir Airport",
      "Touat Cheikh Sidi Mohamed Belkebir Airport"
    ],
    "city": [
      "Adrar",
      "Adrar",
      "Adrar"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "BSK",
    "translations": [
      "Biskra - Mohamed Khider Airport",
      "Biskra - Mohamed Khider Airport",
      "Biskra - Mohamed Khider Airport"
    ],
    "city": [
      "Biskra",
      "Biskra",
      "Biskra"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "ELG",
    "translations": [
      "El Golea Airport",
      "El Golea Airport",
      "El Golea Airport"
    ],
    "city": [
      "El Menia",
      "El Menia",
      "El Menia"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "GHA",
    "translations": [
      "Noumérat - Moufdi Zakaria Airport",
      "Noumérat - Moufdi Zakaria Airport",
      "Noumérat - Moufdi Zakaria Airport"
    ],
    "city": [
      "El Atteuf",
      "El Atteuf",
      "El Atteuf"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "HME",
    "translations": [
      "Hassi Messaoud-Oued Irara Krim Belkacem Airport",
      "Hassi Messaoud-Oued Irara Krim Belkacem Airport",
      "Hassi Messaoud-Oued Irara Krim Belkacem Airport"
    ],
    "city": [
      "Hassi Messaoud",
      "Hassi Messaoud",
      "Hassi Messaoud"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "INZ",
    "translations": [
      "In Salah Airport",
      "In Salah Airport",
      "In Salah Airport"
    ],
    "city": [
      "In Salah",
      "In Salah",
      "In Salah"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "TGR",
    "translations": [
      "Touggourt Sidi Madhi Airport",
      "Touggourt Sidi Madhi Airport",
      "Touggourt Sidi Madhi Airport"
    ],
    "city": [
      "Touggourt",
      "Touggourt",
      "Touggourt"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "LOO",
    "translations": [
      "Laghouat - Molay Ahmed Medeghri Airport",
      "Laghouat - Molay Ahmed Medeghri Airport",
      "Laghouat - Molay Ahmed Medeghri Airport"
    ],
    "city": [
      "Laghouat",
      "Laghouat",
      "Laghouat"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "ELU",
    "translations": [
      "Guemar Airport - مطار قمار بالوادي",
      "Guemar Airport - مطار قمار بالوادي",
      "Guemar Airport - مطار قمار بالوادي"
    ],
    "city": [
      "Guemar",
      "Guemar",
      "Guemar"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "TMX",
    "translations": [
      "Timimoun Airport",
      "Timimoun Airport",
      "Timimoun Airport"
    ],
    "city": [
      "Timimoun",
      "Timimoun",
      "Timimoun"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "OGX",
    "translations": [
      "Ain Beida Airport",
      "Ain Beida Airport",
      "Ain Beida Airport"
    ],
    "city": [
      "Ouargla",
      "Ouargla",
      "Ouargla"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "IAM",
    "translations": [
      "Zarzaitine - In Aménas Airport",
      "Zarzaitine - In Aménas Airport",
      "Zarzaitine - In Aménas Airport"
    ],
    "city": [
      "In Aménas",
      "In Aménas",
      "In Aménas"
    ],
    "country": [
      "DZ",
      "DZ",
      "DZ"
    ]
  },
  {
    "iata": "COO",
    "translations": [
      "Cadjehoun Airport",
      "Cadjehoun Airport",
      "Cadjehoun Airport"
    ],
    "city": [
      "Cotonou",
      "Cotonou",
      "Cotonou"
    ],
    "country": [
      "BJ",
      "BJ",
      "BJ"
    ]
  },
  {
    "iata": "DJA",
    "translations": [
      "Djougou Airport",
      "Djougou Airport",
      "Djougou Airport"
    ],
    "city": [
      "Djougou",
      "Djougou",
      "Djougou"
    ],
    "country": [
      "BJ",
      "BJ",
      "BJ"
    ]
  },
  {
    "iata": "KDC",
    "translations": [
      "Kandi Airport",
      "Kandi Airport",
      "Kandi Airport"
    ],
    "city": [
      "Kandi",
      "Kandi",
      "Kandi"
    ],
    "country": [
      "BJ",
      "BJ",
      "BJ"
    ]
  },
  {
    "iata": "NAE",
    "translations": [
      "Natitingou Airport",
      "Natitingou Airport",
      "Natitingou Airport"
    ],
    "city": [
      "Natitingou",
      "Natitingou",
      "Natitingou"
    ],
    "country": [
      "BJ",
      "BJ",
      "BJ"
    ]
  },
  {
    "iata": "PKO",
    "translations": [
      "Parakou Airport",
      "Parakou Airport",
      "Parakou Airport"
    ],
    "city": [
      "Parakou",
      "Parakou",
      "Parakou"
    ],
    "country": [
      "BJ",
      "BJ",
      "BJ"
    ]
  },
  {
    "iata": "SVF",
    "translations": [
      "Savé Airport",
      "Savé Airport",
      "Savé Airport"
    ],
    "city": [
      "Savé",
      "Savé",
      "Savé"
    ],
    "country": [
      "BJ",
      "BJ",
      "BJ"
    ]
  },
  {
    "iata": "DBK",
    "translations": [
      "Dutch Bay SPB",
      "Dutch Bay SPB",
      "Dutch Bay SPB"
    ],
    "city": [
      "Kalpitiya Island",
      "Kalpitiya Island",
      "Kalpitiya Island"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "DBU",
    "translations": [
      "Dambulu Oya Tank Seaplane Base",
      "Dambulu Oya Tank Seaplane Base",
      "Dambulu Oya Tank Seaplane Base"
    ],
    "city": [
      "Dambulla",
      "Dambulla",
      "Dambulla"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "DCG",
    "translations": [
      "Dubai Creek SPB",
      "Dubai Creek SPB",
      "Dubai Creek SPB"
    ],
    "city": [
      "Dubai",
      "Dubai",
      "Dubai"
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "DCK",
    "translations": [
      "Dahl Creek Airport",
      "Dahl Creek Airport",
      "Dahl Creek Airport"
    ],
    "city": [
      "Dahl Creek",
      "Dahl Creek",
      "Dahl Creek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DDM",
    "translations": [
      "Dodoima Airport",
      "Dodoima Airport",
      "Dodoima Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "DEQ",
    "translations": [
      "Deqing Moganshan Airport",
      "Deqing Moganshan Airport",
      "Deqing Moganshan Airport"
    ],
    "city": [
      "Huzhou",
      "Huzhou",
      "Huzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DEX",
    "translations": [
      "Nop Goliat Dekai Airport",
      "Nop Goliat Dekai Airport",
      "Nop Goliat Dekai Airport"
    ],
    "city": [
      "Dekai",
      "Dekai",
      "Dekai"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "XKY",
    "translations": [
      "Kaya Airport",
      "Kaya Airport",
      "Kaya Airport"
    ],
    "city": [
      "Kaya",
      "Kaya",
      "Kaya"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "OUG",
    "translations": [
      "Ouahigouya Airport",
      "Ouahigouya Airport",
      "Ouahigouya Airport"
    ],
    "city": [
      "Ouahigouya",
      "Ouahigouya",
      "Ouahigouya"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "XDJ",
    "translations": [
      "Djibo Airport",
      "Djibo Airport",
      "Djibo Airport"
    ],
    "city": [
      "Djibo",
      "Djibo",
      "Djibo"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "XLU",
    "translations": [
      "Leo Airport",
      "Leo Airport",
      "Leo Airport"
    ],
    "city": [
      "Leo",
      "Leo",
      "Leo"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "PUP",
    "translations": [
      "Po Airport",
      "Po Airport",
      "Po Airport"
    ],
    "city": [
      "Po",
      "Po",
      "Po"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "XBO",
    "translations": [
      "Boulsa Airport",
      "Boulsa Airport",
      "Boulsa Airport"
    ],
    "city": [
      "Boulsa",
      "Boulsa",
      "Boulsa"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "XBG",
    "translations": [
      "Bogande Airport",
      "Bogande Airport",
      "Bogande Airport"
    ],
    "city": [
      "Bogande",
      "Bogande",
      "Bogande"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "DIP",
    "translations": [
      "Diapaga Airport",
      "Diapaga Airport",
      "Diapaga Airport"
    ],
    "city": [
      "Diapaga",
      "Diapaga",
      "Diapaga"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "DOR",
    "translations": [
      "Dori Airport",
      "Dori Airport",
      "Dori Airport"
    ],
    "city": [
      "Dori",
      "Dori",
      "Dori"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "FNG",
    "translations": [
      "Fada N'gourma Airport",
      "Fada N'gourma Airport",
      "Fada N'gourma Airport"
    ],
    "city": [
      "Fada N'gourma",
      "Fada N'gourma",
      "Fada N'gourma"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "XGG",
    "translations": [
      "Gorom-Gorom Airport",
      "Gorom-Gorom Airport",
      "Gorom-Gorom Airport"
    ],
    "city": [
      "Gorom-Gorom",
      "Gorom-Gorom",
      "Gorom-Gorom"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "XKA",
    "translations": [
      "Kantchari Airport",
      "Kantchari Airport",
      "Kantchari Airport"
    ],
    "city": [
      "Kantchari",
      "Kantchari",
      "Kantchari"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "TMQ",
    "translations": [
      "Tambao Airport",
      "Tambao Airport",
      "Tambao Airport"
    ],
    "city": [
      "Tambao",
      "Tambao",
      "Tambao"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "XPA",
    "translations": [
      "Pama Airport",
      "Pama Airport",
      "Pama Airport"
    ],
    "city": [
      "Pama",
      "Pama",
      "Pama"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "ARL",
    "translations": [
      "Arly Airport",
      "Arly Airport",
      "Arly Airport"
    ],
    "city": [
      "Arly",
      "Arly",
      "Arly"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "XSE",
    "translations": [
      "Sebba Airport",
      "Sebba Airport",
      "Sebba Airport"
    ],
    "city": [
      "Sebba",
      "Sebba",
      "Sebba"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "TEG",
    "translations": [
      "Tenkodogo Airport",
      "Tenkodogo Airport",
      "Tenkodogo Airport"
    ],
    "city": [
      "Tenkodogo",
      "Tenkodogo",
      "Tenkodogo"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "XZA",
    "translations": [
      "Zabré Airport",
      "Zabré Airport",
      "Zabré Airport"
    ],
    "city": [
      "Zabré",
      "Zabré",
      "Zabré"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "OUA",
    "translations": [
      "Ouagadougou Airport",
      "Ouagadougou Airport",
      "Ouagadougou Airport"
    ],
    "city": [
      "Ouagadougou",
      "Ouagadougou",
      "Ouagadougou"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "BNR",
    "translations": [
      "Banfora Airport",
      "Banfora Airport",
      "Banfora Airport"
    ],
    "city": [
      "Banfora",
      "Banfora",
      "Banfora"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "DGU",
    "translations": [
      "Dedougou Airport",
      "Dedougou Airport",
      "Dedougou Airport"
    ],
    "city": [
      "Dedougou",
      "Dedougou",
      "Dedougou"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "XGA",
    "translations": [
      "Gaoua Airport",
      "Gaoua Airport",
      "Gaoua Airport"
    ],
    "city": [
      "Gaoua",
      "Gaoua",
      "Gaoua"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "XNU",
    "translations": [
      "Nouna Airport",
      "Nouna Airport",
      "Nouna Airport"
    ],
    "city": [
      "Nouna",
      "Nouna",
      "Nouna"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "BOY",
    "translations": [
      "Bobo Dioulasso Airport",
      "Bobo Dioulasso Airport",
      "Bobo Dioulasso Airport"
    ],
    "city": [
      "Bobo Dioulasso",
      "Bobo Dioulasso",
      "Bobo Dioulasso"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "TUQ",
    "translations": [
      "Tougan Airport",
      "Tougan Airport",
      "Tougan Airport"
    ],
    "city": [
      "Tougan",
      "Tougan",
      "Tougan"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "XDE",
    "translations": [
      "Diebougou Airport",
      "Diebougou Airport",
      "Diebougou Airport"
    ],
    "city": [
      "Diebougou",
      "Diebougou",
      "Diebougou"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "XAR",
    "translations": [
      "Aribinda Airport",
      "Aribinda Airport",
      "Aribinda Airport"
    ],
    "city": [
      "Aribinda",
      "Aribinda",
      "Aribinda"
    ],
    "country": [
      "BF",
      "BF",
      "BF"
    ]
  },
  {
    "iata": "ACC",
    "translations": [
      "Kotoka International Airport",
      "Kotoka International Airport",
      "Kotoka International Airport"
    ],
    "city": [
      "Accra",
      "Accra",
      "Accra"
    ],
    "country": [
      "GH",
      "GH",
      "GH"
    ]
  },
  {
    "iata": "TML",
    "translations": [
      "Tamale Airport",
      "Tamale Airport",
      "Tamale Airport"
    ],
    "city": [
      "Tamale",
      "Tamale",
      "Tamale"
    ],
    "country": [
      "GH",
      "GH",
      "GH"
    ]
  },
  {
    "iata": "WZA",
    "translations": [
      "Wa Airport",
      "Wa Airport",
      "Wa Airport"
    ],
    "city": [
      "Wa",
      "Wa",
      "Wa"
    ],
    "country": [
      "GH",
      "GH",
      "GH"
    ]
  },
  {
    "iata": "DGM",
    "translations": [
      "Dandugama Seaplane Base",
      "Dandugama Seaplane Base",
      "Dandugama Seaplane Base"
    ],
    "city": [
      "Colombo",
      "Colombo",
      "Colombo"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "KMS",
    "translations": [
      "Kumasi Airport",
      "Kumasi Airport",
      "Kumasi Airport"
    ],
    "city": [
      "Kumasi",
      "Kumasi",
      "Kumasi"
    ],
    "country": [
      "GH",
      "GH",
      "GH"
    ]
  },
  {
    "iata": "NYI",
    "translations": [
      "Sunyani Airport",
      "Sunyani Airport",
      "Sunyani Airport"
    ],
    "city": [
      "Sunyani",
      "Sunyani",
      "Sunyani"
    ],
    "country": [
      "GH",
      "GH",
      "GH"
    ]
  },
  {
    "iata": "TKD",
    "translations": [
      "Takoradi Airport",
      "Takoradi Airport",
      "Takoradi Airport"
    ],
    "city": [
      "Sekondi-Takoradi",
      "Sekondi-Takoradi",
      "Sekondi-Takoradi"
    ],
    "country": [
      "GH",
      "GH",
      "GH"
    ]
  },
  {
    "iata": "DHB",
    "translations": [
      "Deer Harbor SPB",
      "Deer Harbor SPB",
      "Deer Harbor SPB"
    ],
    "city": [
      "Deer Harbor",
      "Deer Harbor",
      "Deer Harbor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DHG",
    "translations": [
      "Dalnegorsk Airport",
      "Dalnegorsk Airport",
      "Dalnegorsk Airport"
    ],
    "city": [
      "Dalnegorsk",
      "Dalnegorsk",
      "Dalnegorsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "DHL",
    "translations": [
      "Ad-Dali Airport",
      "Ad-Dali Airport",
      "Ad-Dali Airport"
    ],
    "city": [
      "Ad-Dali",
      "Ad-Dali",
      "Ad-Dali"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "ABO",
    "translations": [
      "Aboisso Airport",
      "Aboisso Airport",
      "Aboisso Airport"
    ],
    "city": [
      "Aboisso",
      "Aboisso",
      "Aboisso"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "ABJ",
    "translations": [
      "Félix-Houphouët-Boigny International Airport",
      "Félix-Houphouët-Boigny International Airport",
      "Félix-Houphouët-Boigny International Airport"
    ],
    "city": [
      "Abidjan",
      "Abidjan",
      "Abidjan"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "OGO",
    "translations": [
      "Abengourou Airport",
      "Abengourou Airport",
      "Abengourou Airport"
    ],
    "city": [
      "Abengourou",
      "Abengourou",
      "Abengourou"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "BXI",
    "translations": [
      "Boundiali Airport",
      "Boundiali Airport",
      "Boundiali Airport"
    ],
    "city": [
      "Boundiali",
      "Boundiali",
      "Boundiali"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "BYK",
    "translations": [
      "Bouaké Airport",
      "Bouaké Airport",
      "Bouaké Airport"
    ],
    "city": [
      "Bouaké",
      "Bouaké",
      "Bouaké"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "BQO",
    "translations": [
      "Bouna Airport",
      "Bouna Airport",
      "Bouna Airport"
    ],
    "city": [
      "Bouna",
      "Bouna",
      "Bouna"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "BDK",
    "translations": [
      "Soko Airport",
      "Soko Airport",
      "Soko Airport"
    ],
    "city": [
      "Bondoukou",
      "Bondoukou",
      "Bondoukou"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "DIM",
    "translations": [
      "Dimbokro Airport",
      "Dimbokro Airport",
      "Dimbokro Airport"
    ],
    "city": [
      "Dimbokro",
      "Dimbokro",
      "Dimbokro"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "DJO",
    "translations": [
      "Daloa Airport",
      "Daloa Airport",
      "Daloa Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "GGN",
    "translations": [
      "Gagnoa Airport",
      "Gagnoa Airport",
      "Gagnoa Airport"
    ],
    "city": [
      "Gagnoa",
      "Gagnoa",
      "Gagnoa"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "GGO",
    "translations": [
      "Guiglo Airport",
      "Guiglo Airport",
      "Guiglo Airport"
    ],
    "city": [
      "Guiglo",
      "Guiglo",
      "Guiglo"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "BBV",
    "translations": [
      "Nero-Mer Airport",
      "Nero-Mer Airport",
      "Nero-Mer Airport"
    ],
    "city": [
      "Grand-Béréby",
      "Grand-Béréby",
      "Grand-Béréby"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "HGO",
    "translations": [
      "Korhogo Airport",
      "Korhogo Airport",
      "Korhogo Airport"
    ],
    "city": [
      "Korhogo",
      "Korhogo",
      "Korhogo"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "MJC",
    "translations": [
      "Man Airport",
      "Man Airport",
      "Man Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "KEO",
    "translations": [
      "Odienne Airport",
      "Odienne Airport",
      "Odienne Airport"
    ],
    "city": [
      "Odienne",
      "Odienne",
      "Odienne"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "OFI",
    "translations": [
      "Ouango Fitini Airport",
      "Ouango Fitini Airport",
      "Ouango Fitini Airport"
    ],
    "city": [
      "Ouango Fitini",
      "Ouango Fitini",
      "Ouango Fitini"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "SEO",
    "translations": [
      "Séguéla Airport",
      "Séguéla Airport",
      "Séguéla Airport"
    ],
    "city": [
      "Séguéla",
      "Séguéla",
      "Séguéla"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "SPY",
    "translations": [
      "San Pedro Airport",
      "San Pedro Airport",
      "San Pedro Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "ZSS",
    "translations": [
      "Sassandra Airport",
      "Sassandra Airport",
      "Sassandra Airport"
    ],
    "city": [
      "Sassandra",
      "Sassandra",
      "Sassandra"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "TXU",
    "translations": [
      "Tabou Airport",
      "Tabou Airport",
      "Tabou Airport"
    ],
    "city": [
      "Tabou",
      "Tabou",
      "Tabou"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "TOZ",
    "translations": [
      "Mahana Airport",
      "Mahana Airport",
      "Mahana Airport"
    ],
    "city": [
      "Touba",
      "Touba",
      "Touba"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "DIW",
    "translations": [
      "Mawella Lagoon Seaplane Base",
      "Mawella Lagoon Seaplane Base",
      "Mawella Lagoon Seaplane Base"
    ],
    "city": [
      "Dickwella",
      "Dickwella",
      "Dickwella"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "ASK",
    "translations": [
      "Yamoussoukro Airport",
      "Yamoussoukro Airport",
      "Yamoussoukro Airport"
    ],
    "city": [
      "Yamoussoukro",
      "Yamoussoukro",
      "Yamoussoukro"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "DLR",
    "translations": [
      "Dalnerechensk Airport",
      "Dalnerechensk Airport",
      "Dalnerechensk Airport"
    ],
    "city": [
      "Dalnerechensk",
      "Dalnerechensk",
      "Dalnerechensk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "DIO",
    "translations": [
      "Diomede Heliport",
      "Diomede Heliport",
      "Diomede Heliport"
    ],
    "city": [
      "Diomede",
      "Diomede",
      "Diomede"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DKA",
    "translations": [
      "Katsina Airport",
      "Katsina Airport",
      "Katsina Airport"
    ],
    "city": [
      "Katsina",
      "Katsina",
      "Katsina"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "ABV",
    "translations": [
      "Nnamdi Azikiwe International Airport",
      "Nnamdi Azikiwe International Airport",
      "Nnamdi Azikiwe International Airport"
    ],
    "city": [
      "Abuja",
      "Abuja",
      "Abuja"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "QUO",
    "translations": [
      "Akwa Ibom International Airport",
      "Akwa Ibom International Airport",
      "Akwa Ibom International Airport"
    ],
    "city": [
      "Uyo",
      "Uyo",
      "Uyo"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "AKR",
    "translations": [
      "Akure Airport",
      "Akure Airport",
      "Akure Airport"
    ],
    "city": [
      "Akure",
      "Akure",
      "Akure"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "ABB",
    "translations": [
      "Asaba International Airport",
      "Asaba International Airport",
      "Asaba International Airport"
    ],
    "city": [
      "Asaba",
      "Asaba",
      "Asaba"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "BCU",
    "translations": [
      "Sir Abubakar Tafawa Balewa International Airport",
      "Sir Abubakar Tafawa Balewa International Airport",
      "Sir Abubakar Tafawa Balewa International Airport"
    ],
    "city": [
      "Bauchi",
      "Bauchi",
      "Bauchi"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "BNI",
    "translations": [
      "Benin Airport",
      "Benin Airport",
      "Benin Airport"
    ],
    "city": [
      "Benin",
      "Benin",
      "Benin"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "CBQ",
    "translations": [
      "Margaret Ekpo International Airport",
      "Margaret Ekpo International Airport",
      "Margaret Ekpo International Airport"
    ],
    "city": [
      "Calabar",
      "Calabar",
      "Calabar"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "ENU",
    "translations": [
      "Akanu Ibiam International Airport",
      "Akanu Ibiam International Airport",
      "Akanu Ibiam International Airport"
    ],
    "city": [
      "Enegu",
      "Enegu",
      "Enegu"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "GMO",
    "translations": [
      "Gombe Lawanti International Airport",
      "Gombe Lawanti International Airport",
      "Gombe Lawanti International Airport"
    ],
    "city": [
      "Gombe",
      "Gombe",
      "Gombe"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "IBA",
    "translations": [
      "Ibadan Airport",
      "Ibadan Airport",
      "Ibadan Airport"
    ],
    "city": [
      "Ibadan",
      "Ibadan",
      "Ibadan"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "ILR",
    "translations": [
      "Ilorin International Airport",
      "Ilorin International Airport",
      "Ilorin International Airport"
    ],
    "city": [
      "Ilorin",
      "Ilorin",
      "Ilorin"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "QOW",
    "translations": [
      "Sam Mbakwe International Airport",
      "Sam Mbakwe International Airport",
      "Sam Mbakwe International Airport"
    ],
    "city": [
      "Owerri",
      "Owerri",
      "Owerri"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "JOS",
    "translations": [
      "Yakubu Gowon Airport",
      "Yakubu Gowon Airport",
      "Yakubu Gowon Airport"
    ],
    "city": [
      "Jos",
      "Jos",
      "Jos"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "KAD",
    "translations": [
      "Kaduna Airport",
      "Kaduna Airport",
      "Kaduna Airport"
    ],
    "city": [
      "Kaduna",
      "Kaduna",
      "Kaduna"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "KAN",
    "translations": [
      "Mallam Aminu International Airport",
      "Mallam Aminu International Airport",
      "Mallam Aminu International Airport"
    ],
    "city": [
      "Kano",
      "Kano",
      "Kano"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "MIU",
    "translations": [
      "Maiduguri International Airport",
      "Maiduguri International Airport",
      "Maiduguri International Airport"
    ],
    "city": [
      "Maiduguri",
      "Maiduguri",
      "Maiduguri"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "MDI",
    "translations": [
      "Makurdi Airport",
      "Makurdi Airport",
      "Makurdi Airport"
    ],
    "city": [
      "Makurdi",
      "Makurdi",
      "Makurdi"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "LOS",
    "translations": [
      "Murtala Muhammed International Airport",
      "Murtala Muhammed International Airport",
      "Murtala Muhammed International Airport"
    ],
    "city": [
      "Lagos",
      "Lagos",
      "Lagos"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "MXJ",
    "translations": [
      "Minna Airport",
      "Minna Airport",
      "Minna Airport"
    ],
    "city": [
      "Minna",
      "Minna",
      "Minna"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "PHC",
    "translations": [
      "Port Harcourt International Airport",
      "Port Harcourt International Airport",
      "Port Harcourt International Airport"
    ],
    "city": [
      "Port Harcourt",
      "Port Harcourt",
      "Port Harcourt"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "SKO",
    "translations": [
      "Sadiq Abubakar III International Airport",
      "Sadiq Abubakar III International Airport",
      "Sadiq Abubakar III International Airport"
    ],
    "city": [
      "Sokoto",
      "Sokoto",
      "Sokoto"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "QRW",
    "translations": [
      "Warri Airport",
      "Warri Airport",
      "Warri Airport"
    ],
    "city": [
      "Okpe",
      "Okpe",
      "Okpe"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "YOL",
    "translations": [
      "Yola Airport",
      "Yola Airport",
      "Yola Airport"
    ],
    "city": [
      "Yola",
      "Yola",
      "Yola"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "ZAR",
    "translations": [
      "Zaria Airport",
      "Zaria Airport",
      "Zaria Airport"
    ],
    "city": [
      "Zaria",
      "Zaria",
      "Zaria"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "DPT",
    "translations": [
      "Deputatskiy Airport",
      "Deputatskiy Airport",
      "Deputatskiy Airport"
    ],
    "city": [
      "Deputatskiy",
      "Deputatskiy",
      "Deputatskiy"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "MFQ",
    "translations": [
      "Maradi Airport",
      "Maradi Airport",
      "Maradi Airport"
    ],
    "city": [
      "Maradi",
      "Maradi",
      "Maradi"
    ],
    "country": [
      "NE",
      "NE",
      "NE"
    ]
  },
  {
    "iata": "NIM",
    "translations": [
      "Diori Hamani International Airport",
      "Diori Hamani International Airport",
      "Diori Hamani International Airport"
    ],
    "city": [
      "Niamey",
      "Niamey",
      "Niamey"
    ],
    "country": [
      "NE",
      "NE",
      "NE"
    ]
  },
  {
    "iata": "THZ",
    "translations": [
      "Tahoua Airport",
      "Tahoua Airport",
      "Tahoua Airport"
    ],
    "city": [
      "Tahoua",
      "Tahoua",
      "Tahoua"
    ],
    "country": [
      "NE",
      "NE",
      "NE"
    ]
  },
  {
    "iata": "AJY",
    "translations": [
      "Mano Dayak International Airport",
      "Mano Dayak International Airport",
      "Mano Dayak International Airport"
    ],
    "city": [
      "Agadez",
      "Agadez",
      "Agadez"
    ],
    "country": [
      "NE",
      "NE",
      "NE"
    ]
  },
  {
    "iata": "RLT",
    "translations": [
      "Arlit Airport",
      "Arlit Airport",
      "Arlit Airport"
    ],
    "city": [
      "Arlit",
      "Arlit",
      "Arlit"
    ],
    "country": [
      "NE",
      "NE",
      "NE"
    ]
  },
  {
    "iata": "ZND",
    "translations": [
      "Zinder Airport",
      "Zinder Airport",
      "Zinder Airport"
    ],
    "city": [
      "Zinder",
      "Zinder",
      "Zinder"
    ],
    "country": [
      "NE",
      "NE",
      "NE"
    ]
  },
  {
    "iata": "DSG",
    "translations": [
      "Dilasag Airport",
      "Dilasag Airport",
      "Dilasag Airport"
    ],
    "city": [
      "Dilasag",
      "Dilasag",
      "Dilasag"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "TBJ",
    "translations": [
      "Tabarka-Aïn Draham International Airport",
      "Tabarka-Aïn Draham International Airport",
      "Tabarka-Aïn Draham International Airport"
    ],
    "city": [
      "Tabarka",
      "Tabarka",
      "Tabarka"
    ],
    "country": [
      "TN",
      "TN",
      "TN"
    ]
  },
  {
    "iata": "MIR",
    "translations": [
      "Monastir Habib Bourguiba International Airport",
      "Monastir Habib Bourguiba International Airport",
      "Monastir Habib Bourguiba International Airport"
    ],
    "city": [
      "Monastir",
      "Monastir",
      "Monastir"
    ],
    "country": [
      "TN",
      "TN",
      "TN"
    ]
  },
  {
    "iata": "NBE",
    "translations": [
      "Enfidha - Hammamet International Airport",
      "Enfidha - Hammamet International Airport",
      "Enfidha - Hammamet International Airport"
    ],
    "city": [
      "Enfidha",
      "Enfidha",
      "Enfidha"
    ],
    "country": [
      "TN",
      "TN",
      "TN"
    ]
  },
  {
    "iata": "TUN",
    "translations": [
      "Tunis Carthage International Airport",
      "Tunis Carthage International Airport",
      "Tunis Carthage International Airport"
    ],
    "city": [
      "Tunis",
      "Tunis",
      "Tunis"
    ],
    "country": [
      "TN",
      "TN",
      "TN"
    ]
  },
  {
    "iata": "GAF",
    "translations": [
      "Gafsa Ksar International Airport",
      "Gafsa Ksar International Airport",
      "Gafsa Ksar International Airport"
    ],
    "city": [
      "Gafsa",
      "Gafsa",
      "Gafsa"
    ],
    "country": [
      "TN",
      "TN",
      "TN"
    ]
  },
  {
    "iata": "GAE",
    "translations": [
      "Gabès Matmata International Airport",
      "Gabès Matmata International Airport",
      "Gabès Matmata International Airport"
    ],
    "city": [
      "Gabès",
      "Gabès",
      "Gabès"
    ],
    "country": [
      "TN",
      "TN",
      "TN"
    ]
  },
  {
    "iata": "DJE",
    "translations": [
      "Djerba Zarzis International Airport",
      "Djerba Zarzis International Airport",
      "Djerba Zarzis International Airport"
    ],
    "city": [
      "Mellita",
      "Mellita",
      "Mellita"
    ],
    "country": [
      "TN",
      "TN",
      "TN"
    ]
  },
  {
    "iata": "EBM",
    "translations": [
      "El Borma Airport",
      "El Borma Airport",
      "El Borma Airport"
    ],
    "city": [
      "El Borma",
      "El Borma",
      "El Borma"
    ],
    "country": [
      "TN",
      "TN",
      "TN"
    ]
  },
  {
    "iata": "SFA",
    "translations": [
      "Sfax Thyna International Airport",
      "Sfax Thyna International Airport",
      "Sfax Thyna International Airport"
    ],
    "city": [
      "Sfax",
      "Sfax",
      "Sfax"
    ],
    "country": [
      "TN",
      "TN",
      "TN"
    ]
  },
  {
    "iata": "TOE",
    "translations": [
      "Tozeur Nefta International Airport",
      "Tozeur Nefta International Airport",
      "Tozeur Nefta International Airport"
    ],
    "city": [
      "Tozeur",
      "Tozeur",
      "Tozeur"
    ],
    "country": [
      "TN",
      "TN",
      "TN"
    ]
  },
  {
    "iata": "DVD",
    "translations": [
      "Andavadoaka Airport",
      "Andavadoaka Airport",
      "Andavadoaka Airport"
    ],
    "city": [
      "Andavadoaka",
      "Andavadoaka",
      "Andavadoaka"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "DWO",
    "translations": [
      "Diyawanna Oya Seaplane Base",
      "Diyawanna Oya Seaplane Base",
      "Diyawanna Oya Seaplane Base"
    ],
    "city": [
      "Sri Jayawardenepura Kotte",
      "Sri Jayawardenepura Kotte",
      "Sri Jayawardenepura Kotte"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "LRL",
    "translations": [
      "Niamtougou International Airport",
      "Niamtougou International Airport",
      "Niamtougou International Airport"
    ],
    "city": [
      "Niamtougou",
      "Niamtougou",
      "Niamtougou"
    ],
    "country": [
      "TG",
      "TG",
      "TG"
    ]
  },
  {
    "iata": "LFW",
    "translations": [
      "Lomé–Tokoin International Airport",
      "Lomé–Tokoin International Airport",
      "Lomé–Tokoin International Airport"
    ],
    "city": [
      "Lomé",
      "Lomé",
      "Lomé"
    ],
    "country": [
      "TG",
      "TG",
      "TG"
    ]
  },
  {
    "iata": "EAL",
    "translations": [
      "Elenak Airport",
      "Elenak Airport",
      "Elenak Airport"
    ],
    "city": [
      "Mejato Island",
      "Mejato Island",
      "Mejato Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "ANR",
    "translations": [
      "Antwerp International Airport (Deurne)",
      "Antwerp International Airport (Deurne)",
      "Antwerp International Airport (Deurne)"
    ],
    "city": [
      "Antwerp",
      "Antwerp",
      "Antwerp"
    ],
    "country": [
      "BE",
      "BE",
      "BE"
    ]
  },
  {
    "iata": "BRU",
    "translations": [
      "Brussels Airport",
      "Brussels Airport",
      "Brussels Airport"
    ],
    "city": [
      "Zaventem",
      "Zaventem",
      "Zaventem"
    ],
    "country": [
      "BE",
      "BE",
      "BE"
    ]
  },
  {
    "iata": "CRL",
    "translations": [
      "Brussels South Charleroi Airport",
      "Brussels South Charleroi Airport",
      "Brussels South Charleroi Airport"
    ],
    "city": [
      "Charleroi",
      "Charleroi",
      "Charleroi"
    ],
    "country": [
      "BE",
      "BE",
      "BE"
    ]
  },
  {
    "iata": "GNE",
    "translations": [
      "Ghent/Industry Zone Heliport",
      "Ghent/Industry Zone Heliport",
      "Ghent/Industry Zone Heliport"
    ],
    "city": [
      "Gent",
      "Gent",
      "Gent"
    ],
    "country": [
      "BE",
      "BE",
      "BE"
    ]
  },
  {
    "iata": "KJK",
    "translations": [
      "Flanders International Airport Kortrijk-Wevelgem",
      "Flanders International Airport Kortrijk-Wevelgem",
      "Flanders International Airport Kortrijk-Wevelgem"
    ],
    "city": [
      "Wevelgem",
      "Wevelgem",
      "Wevelgem"
    ],
    "country": [
      "BE",
      "BE",
      "BE"
    ]
  },
  {
    "iata": "LGG",
    "translations": [
      "Liège Airport",
      "Liège Airport",
      "Liège Airport"
    ],
    "city": [
      "Grâce-Hollogne",
      "Grâce-Hollogne",
      "Grâce-Hollogne"
    ],
    "country": [
      "BE",
      "BE",
      "BE"
    ]
  },
  {
    "iata": "EBO",
    "translations": [
      "Ebon Airport",
      "Ebon Airport",
      "Ebon Airport"
    ],
    "city": [
      "Ebon Atoll",
      "Ebon Atoll",
      "Ebon Atoll"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "OST",
    "translations": [
      "Oostende-Brugge International Airport",
      "Oostende-Brugge International Airport",
      "Oostende-Brugge International Airport"
    ],
    "city": [
      "Oostende",
      "Oostende",
      "Oostende"
    ],
    "country": [
      "BE",
      "BE",
      "BE"
    ]
  },
  {
    "iata": "OBL",
    "translations": [
      "Oostmalle Airfield",
      "Oostmalle Airfield",
      "Oostmalle Airfield"
    ],
    "city": [
      "Zoersel",
      "Zoersel",
      "Zoersel"
    ],
    "country": [
      "BE",
      "BE",
      "BE"
    ]
  },
  {
    "iata": "MZD",
    "translations": [
      "Méndez Airport",
      "Méndez Airport",
      "Méndez Airport"
    ],
    "city": [
      "Santiago de Méndez",
      "Santiago de Méndez",
      "Santiago de Méndez"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "EDA",
    "translations": [
      "Edna Bay Seaplane Base",
      "Edna Bay Seaplane Base",
      "Edna Bay Seaplane Base"
    ],
    "city": [
      "Edna Bay",
      "Edna Bay",
      "Edna Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AOC",
    "translations": [
      "Leipzig–Altenburg Airport",
      "Leipzig–Altenburg Airport",
      "Leipzig–Altenburg Airport"
    ],
    "city": [
      "Nobitz",
      "Nobitz",
      "Nobitz"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "HDF",
    "translations": [
      "Heringsdorf Airport",
      "Heringsdorf Airport",
      "Heringsdorf Airport"
    ],
    "city": [
      "Zirchow",
      "Zirchow",
      "Zirchow"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "IES",
    "translations": [
      "Riesa-Göhlis Airport",
      "Riesa-Göhlis Airport",
      "Riesa-Göhlis Airport"
    ],
    "city": [
      "Riesa",
      "Riesa",
      "Riesa"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "REB",
    "translations": [
      "Müritz Airpark",
      "Müritz Airpark",
      "Müritz Airpark"
    ],
    "city": [
      "Lärz",
      "Lärz",
      "Lärz"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "CSO",
    "translations": [
      "Cochstedt Airport",
      "Cochstedt Airport",
      "Cochstedt Airport"
    ],
    "city": [
      "Hecklingen",
      "Hecklingen",
      "Hecklingen"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "BBH",
    "translations": [
      "Stralsund-Barth Airport",
      "Stralsund-Barth Airport",
      "Stralsund-Barth Airport"
    ],
    "city": [
      "Barth",
      "Barth",
      "Barth"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "FNB",
    "translations": [
      "Neubrandenburg Trollenhagen Airport",
      "Neubrandenburg Trollenhagen Airport",
      "Neubrandenburg Trollenhagen Airport"
    ],
    "city": [
      "Trollenhagen",
      "Trollenhagen",
      "Trollenhagen"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "GTI",
    "translations": [
      "Rügen Airport",
      "Rügen Airport",
      "Rügen Airport"
    ],
    "city": [
      "Dreschvitz",
      "Dreschvitz",
      "Dreschvitz"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "KOQ",
    "translations": [
      "Köthen Airport",
      "Köthen Airport",
      "Köthen Airport"
    ],
    "city": [
      "Köthen (Anhalt)",
      "Köthen (Anhalt)",
      "Köthen (Anhalt)"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "PEF",
    "translations": [
      "Peenemünde Airport",
      "Peenemünde Airport",
      "Peenemünde Airport"
    ],
    "city": [
      "Peenemünde",
      "Peenemünde",
      "Peenemünde"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "BER",
    "translations": [
      "Berlin Brandenburg Airport",
      "Berlin Brandenburg Airport",
      "Berlin Brandenburg Airport"
    ],
    "city": [
      "Berlin",
      "Berlin",
      "Berlin"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "DRS",
    "translations": [
      "Dresden Airport",
      "Dresden Airport",
      "Dresden Airport"
    ],
    "city": [
      "Dresden",
      "Dresden",
      "Dresden"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "ERF",
    "translations": [
      "Erfurt-Weimar Airport",
      "Erfurt-Weimar Airport",
      "Erfurt-Weimar Airport"
    ],
    "city": [
      "Erfurt",
      "Erfurt",
      "Erfurt"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "FRA",
    "translations": [
      "Frankfurt Airport",
      "Frankfurt Airport",
      "Frankfurt Airport"
    ],
    "city": [
      "Frankfurt am Main",
      "Frankfurt am Main",
      "Frankfurt am Main"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "FMO",
    "translations": [
      "Münster Osnabrück Airport",
      "Münster Osnabrück Airport",
      "Münster Osnabrück Airport"
    ],
    "city": [
      "Greven",
      "Greven",
      "Greven"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "HAM",
    "translations": [
      "Hamburg Helmut Schmidt Airport",
      "Hamburg Helmut Schmidt Airport",
      "Hamburg Helmut Schmidt Airport"
    ],
    "city": [
      "Hamburg",
      "Hamburg",
      "Hamburg"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "CGN",
    "translations": [
      "Cologne Bonn Airport",
      "Cologne Bonn Airport",
      "Cologne Bonn Airport"
    ],
    "city": [
      "Köln (Cologne)",
      "Köln (Cologne)",
      "Köln (Cologne)"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "DUS",
    "translations": [
      "Düsseldorf Airport",
      "Düsseldorf Airport",
      "Düsseldorf Airport"
    ],
    "city": [
      "Düsseldorf",
      "Düsseldorf",
      "Düsseldorf"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "MUC",
    "translations": [
      "Munich Airport",
      "Munich Airport",
      "Munich Airport"
    ],
    "city": [
      "Munich",
      "Munich",
      "Munich"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "NUE",
    "translations": [
      "Nuremberg Airport",
      "Nuremberg Airport",
      "Nuremberg Airport"
    ],
    "city": [
      "Nuremberg",
      "Nuremberg",
      "Nuremberg"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "LEJ",
    "translations": [
      "Leipzig/Halle Airport",
      "Leipzig/Halle Airport",
      "Leipzig/Halle Airport"
    ],
    "city": [
      "Schkeuditz",
      "Schkeuditz",
      "Schkeuditz"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "SCN",
    "translations": [
      "Saarbrücken Airport",
      "Saarbrücken Airport",
      "Saarbrücken Airport"
    ],
    "city": [
      "Saarbrücken",
      "Saarbrücken",
      "Saarbrücken"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "STR",
    "translations": [
      "Stuttgart Airport",
      "Stuttgart Airport",
      "Stuttgart Airport"
    ],
    "city": [
      "Stuttgart",
      "Stuttgart",
      "Stuttgart"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "HAJ",
    "translations": [
      "Hannover Airport",
      "Hannover Airport",
      "Hannover Airport"
    ],
    "city": [
      "Hannover",
      "Hannover",
      "Hannover"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "BRE",
    "translations": [
      "Bremen Airport",
      "Bremen Airport",
      "Bremen Airport"
    ],
    "city": [
      "Bremen",
      "Bremen",
      "Bremen"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "HHN",
    "translations": [
      "Frankfurt-Hahn Airport",
      "Frankfurt-Hahn Airport",
      "Frankfurt-Hahn Airport"
    ],
    "city": [
      "Frankfurt am Main (Lautzenhausen)",
      "Frankfurt am Main (Lautzenhausen)",
      "Frankfurt am Main (Lautzenhausen)"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "MHG",
    "translations": [
      "Mannheim-City Airport",
      "Mannheim-City Airport",
      "Mannheim-City Airport"
    ],
    "city": [
      "Mannheim",
      "Mannheim",
      "Mannheim"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "EIB",
    "translations": [
      "Eisenach-Kindel Airport",
      "Eisenach-Kindel Airport",
      "Eisenach-Kindel Airport"
    ],
    "city": [
      "Hörselberg-Hainich",
      "Hörselberg-Hainich",
      "Hörselberg-Hainich"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "ZOE",
    "translations": [
      "Ludwigshafen Accident Hospital Heliport",
      "Ludwigshafen Accident Hospital Heliport",
      "Ludwigshafen Accident Hospital Heliport"
    ],
    "city": [
      "Ludwigshafen am Rhein",
      "Ludwigshafen am Rhein",
      "Ludwigshafen am Rhein"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "SGE",
    "translations": [
      "Siegerland Airport",
      "Siegerland Airport",
      "Siegerland Airport"
    ],
    "city": [
      "Burbach",
      "Burbach",
      "Burbach"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "IZE",
    "translations": [
      "Itzehoe Hungriger Wolf Airfield",
      "Itzehoe Hungriger Wolf Airfield",
      "Itzehoe Hungriger Wolf Airfield"
    ],
    "city": [
      "Hohenlockstedt",
      "Hohenlockstedt",
      "Hohenlockstedt"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "XFW",
    "translations": [
      "Hamburg-Finkenwerder Airport",
      "Hamburg-Finkenwerder Airport",
      "Hamburg-Finkenwerder Airport"
    ],
    "city": [
      "Hamburg",
      "Hamburg",
      "Hamburg"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "KEL",
    "translations": [
      "Kiel-Holtenau Airport",
      "Kiel-Holtenau Airport",
      "Kiel-Holtenau Airport"
    ],
    "city": [
      "Kiel",
      "Kiel",
      "Kiel"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "LBC",
    "translations": [
      "Lübeck Blankensee Airport",
      "Lübeck Blankensee Airport",
      "Lübeck Blankensee Airport"
    ],
    "city": [
      "Lübeck",
      "Lübeck",
      "Lübeck"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "EUM",
    "translations": [
      "Neumünster Airport",
      "Neumünster Airport",
      "Neumünster Airport"
    ],
    "city": [
      "Neumünster",
      "Neumünster",
      "Neumünster"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "FMM",
    "translations": [
      "Memmingen Allgau Airport",
      "Memmingen Allgau Airport",
      "Memmingen Allgau Airport"
    ],
    "city": [
      "Memmingen",
      "Memmingen",
      "Memmingen"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "AAH",
    "translations": [
      "Aachen-Merzbrück Airport",
      "Aachen-Merzbrück Airport",
      "Aachen-Merzbrück Airport"
    ],
    "city": [
      "Aachen",
      "Aachen",
      "Aachen"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "ESS",
    "translations": [
      "Essen-Mülheim Airport",
      "Essen-Mülheim Airport",
      "Essen-Mülheim Airport"
    ],
    "city": [
      "Essen",
      "Essen",
      "Essen"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "BFE",
    "translations": [
      "Bielefeld Airport",
      "Bielefeld Airport",
      "Bielefeld Airport"
    ],
    "city": [
      "Bielefeld",
      "Bielefeld",
      "Bielefeld"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "MGL",
    "translations": [
      "Mönchengladbach Airport",
      "Mönchengladbach Airport",
      "Mönchengladbach Airport"
    ],
    "city": [
      "Mönchengladbach",
      "Mönchengladbach",
      "Mönchengladbach"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "PAD",
    "translations": [
      "Paderborn Lippstadt Airport",
      "Paderborn Lippstadt Airport",
      "Paderborn Lippstadt Airport"
    ],
    "city": [
      "Büren",
      "Büren",
      "Büren"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "NRN",
    "translations": [
      "Weeze Airport",
      "Weeze Airport",
      "Weeze Airport"
    ],
    "city": [
      "Weeze",
      "Weeze",
      "Weeze"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "DTM",
    "translations": [
      "Dortmund Airport",
      "Dortmund Airport",
      "Dortmund Airport"
    ],
    "city": [
      "Dortmund",
      "Dortmund",
      "Dortmund"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "AGB",
    "translations": [
      "Augsburg Airport",
      "Augsburg Airport",
      "Augsburg Airport"
    ],
    "city": [
      "Augsburg",
      "Augsburg",
      "Augsburg"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "OBF",
    "translations": [
      "Oberpfaffenhofen Airport",
      "Oberpfaffenhofen Airport",
      "Oberpfaffenhofen Airport"
    ],
    "city": [
      "Weßling",
      "Weßling",
      "Weßling"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "RBM",
    "translations": [
      "Straubing Airport",
      "Straubing Airport",
      "Straubing Airport"
    ],
    "city": [
      "Atting",
      "Atting",
      "Atting"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "FDH",
    "translations": [
      "Friedrichshafen Airport",
      "Friedrichshafen Airport",
      "Friedrichshafen Airport"
    ],
    "city": [
      "Friedrichshafen",
      "Friedrichshafen",
      "Friedrichshafen"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "BYU",
    "translations": [
      "Bayreuth Airport",
      "Bayreuth Airport",
      "Bayreuth Airport"
    ],
    "city": [
      "Bindlach",
      "Bindlach",
      "Bindlach"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "URD",
    "translations": [
      "Burg Feuerstein Airport",
      "Burg Feuerstein Airport",
      "Burg Feuerstein Airport"
    ],
    "city": [
      "Ebermannstadt",
      "Ebermannstadt",
      "Ebermannstadt"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "GHF",
    "translations": [
      "Giebelstadt Airport",
      "Giebelstadt Airport",
      "Giebelstadt Airport"
    ],
    "city": [
      "Giebelstadt",
      "Giebelstadt",
      "Giebelstadt"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "HOQ",
    "translations": [
      "Hof-Plauen Airport",
      "Hof-Plauen Airport",
      "Hof-Plauen Airport"
    ],
    "city": [
      "Hof",
      "Hof",
      "Hof"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "BBJ",
    "translations": [
      "Bitburg Airport",
      "Bitburg Airport",
      "Bitburg Airport"
    ],
    "city": [
      "Bitburg",
      "Bitburg",
      "Bitburg"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "ZQW",
    "translations": [
      "Zweibrücken Airport",
      "Zweibrücken Airport",
      "Zweibrücken Airport"
    ],
    "city": [
      "Zweibrücken",
      "Zweibrücken",
      "Zweibrücken"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "FKB",
    "translations": [
      "Karlsruhe Baden-Baden Airport",
      "Karlsruhe Baden-Baden Airport",
      "Karlsruhe Baden-Baden Airport"
    ],
    "city": [
      "Rheinmünster",
      "Rheinmünster",
      "Rheinmünster"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "LHA",
    "translations": [
      "Lahr Airport",
      "Lahr Airport",
      "Lahr Airport"
    ],
    "city": [
      "Lahr/Schwarzwald",
      "Lahr/Schwarzwald",
      "Lahr/Schwarzwald"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "BWE",
    "translations": [
      "Braunschweig-Wolfsburg Airport",
      "Braunschweig-Wolfsburg Airport",
      "Braunschweig-Wolfsburg Airport"
    ],
    "city": [
      "Braunschweig",
      "Braunschweig",
      "Braunschweig"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "KSF",
    "translations": [
      "Kassel Airport",
      "Kassel Airport",
      "Kassel Airport"
    ],
    "city": [
      "Calden",
      "Calden",
      "Calden"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "EME",
    "translations": [
      "Emden Airport",
      "Emden Airport",
      "Emden Airport"
    ],
    "city": [
      "Emden",
      "Emden",
      "Emden"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "AGE",
    "translations": [
      "Wangerooge Airport",
      "Wangerooge Airport",
      "Wangerooge Airport"
    ],
    "city": [
      "Wangerooge",
      "Wangerooge",
      "Wangerooge"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "WVN",
    "translations": [
      "JadeWeser Airport",
      "JadeWeser Airport",
      "JadeWeser Airport"
    ],
    "city": [
      "Wilhelmshaven",
      "Wilhelmshaven",
      "Wilhelmshaven"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "JUI",
    "translations": [
      "Juist Airport",
      "Juist Airport",
      "Juist Airport"
    ],
    "city": [
      "Juist",
      "Juist",
      "Juist"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "LGO",
    "translations": [
      "Langeoog Airport",
      "Langeoog Airport",
      "Langeoog Airport"
    ],
    "city": [
      "Langeoog",
      "Langeoog",
      "Langeoog"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "BMK",
    "translations": [
      "Borkum Airport",
      "Borkum Airport",
      "Borkum Airport"
    ],
    "city": [
      "Borkum",
      "Borkum",
      "Borkum"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "NOD",
    "translations": [
      "Norden-Norddeich Airport",
      "Norden-Norddeich Airport",
      "Norden-Norddeich Airport"
    ],
    "city": [
      "Norddeich",
      "Norddeich",
      "Norddeich"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "VAC",
    "translations": [
      "Varrelbusch Airfield",
      "Varrelbusch Airfield",
      "Varrelbusch Airfield"
    ],
    "city": [
      "Cloppenburg",
      "Cloppenburg",
      "Cloppenburg"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "NRD",
    "translations": [
      "Norderney Airport",
      "Norderney Airport",
      "Norderney Airport"
    ],
    "city": [
      "Norderney",
      "Norderney",
      "Norderney"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "BMR",
    "translations": [
      "Baltrum Airport",
      "Baltrum Airport",
      "Baltrum Airport"
    ],
    "city": [
      "Baltrum",
      "Baltrum",
      "Baltrum"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "HEI",
    "translations": [
      "Heide-Büsum Airport",
      "Heide-Büsum Airport",
      "Heide-Büsum Airport"
    ],
    "city": [
      "Oesterdeichstrich",
      "Oesterdeichstrich",
      "Oesterdeichstrich"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "FLF",
    "translations": [
      "Flensburg-Schäferhaus Airport",
      "Flensburg-Schäferhaus Airport",
      "Flensburg-Schäferhaus Airport"
    ],
    "city": [
      "Flensburg",
      "Flensburg",
      "Flensburg"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "HGL",
    "translations": [
      "Helgoland-Düne Airport",
      "Helgoland-Düne Airport",
      "Helgoland-Düne Airport"
    ],
    "city": [
      "Helgoland",
      "Helgoland",
      "Helgoland"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "QHU",
    "translations": [
      "Husum-Schwesing Airport",
      "Husum-Schwesing Airport",
      "Husum-Schwesing Airport"
    ],
    "city": [
      "Husum",
      "Husum",
      "Husum"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "PSH",
    "translations": [
      "Sankt Peter-Ording Airport",
      "Sankt Peter-Ording Airport",
      "Sankt Peter-Ording Airport"
    ],
    "city": [
      "Sankt Peter-Ording",
      "Sankt Peter-Ording",
      "Sankt Peter-Ording"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "GWT",
    "translations": [
      "Westerland Sylt Airport",
      "Westerland Sylt Airport",
      "Westerland Sylt Airport"
    ],
    "city": [
      "Sylt",
      "Sylt",
      "Sylt"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "OHR",
    "translations": [
      "Wyk auf Föhr Airport",
      "Wyk auf Föhr Airport",
      "Wyk auf Föhr Airport"
    ],
    "city": [
      "Wyk auf Föhr",
      "Wyk auf Föhr",
      "Wyk auf Föhr"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "CHE",
    "translations": [
      "Tallinn Linnahall Heliport",
      "Tallinn Linnahall Heliport",
      "Tallinn Linnahall Heliport"
    ],
    "city": [
      "Tallinn",
      "Tallinn",
      "Tallinn"
    ],
    "country": [
      "EE",
      "EE",
      "EE"
    ]
  },
  {
    "iata": "KDL",
    "translations": [
      "Kärdla Airport",
      "Kärdla Airport",
      "Kärdla Airport"
    ],
    "city": [
      "Kärdla",
      "Kärdla",
      "Kärdla"
    ],
    "country": [
      "EE",
      "EE",
      "EE"
    ]
  },
  {
    "iata": "URE",
    "translations": [
      "Kuressaare Airport",
      "Kuressaare Airport",
      "Kuressaare Airport"
    ],
    "city": [
      "Kuressaare",
      "Kuressaare",
      "Kuressaare"
    ],
    "country": [
      "EE",
      "EE",
      "EE"
    ]
  },
  {
    "iata": "EPU",
    "translations": [
      "Pärnu Airport",
      "Pärnu Airport",
      "Pärnu Airport"
    ],
    "city": [
      "Pärnu",
      "Pärnu",
      "Pärnu"
    ],
    "country": [
      "EE",
      "EE",
      "EE"
    ]
  },
  {
    "iata": "EES",
    "translations": [
      "Berenice International Airport / Banas Cape Air Base",
      "Berenice International Airport / Banas Cape Air Base",
      "Berenice International Airport / Banas Cape Air Base"
    ],
    "city": [
      "Berenice Troglodytica",
      "Berenice Troglodytica",
      "Berenice Troglodytica"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "TLL",
    "translations": [
      "Lennart Meri Tallinn Airport",
      "Lennart Meri Tallinn Airport",
      "Lennart Meri Tallinn Airport"
    ],
    "city": [
      "Tallinn",
      "Tallinn",
      "Tallinn"
    ],
    "country": [
      "EE",
      "EE",
      "EE"
    ]
  },
  {
    "iata": "TAY",
    "translations": [
      "Tartu Airport",
      "Tartu Airport",
      "Tartu Airport"
    ],
    "city": [
      "Reola",
      "Reola",
      "Reola"
    ],
    "country": [
      "EE",
      "EE",
      "EE"
    ]
  },
  {
    "iata": "ENF",
    "translations": [
      "Enontekio Airport",
      "Enontekio Airport",
      "Enontekio Airport"
    ],
    "city": [
      "Enontekio",
      "Enontekio",
      "Enontekio"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "KEV",
    "translations": [
      "Halli Airport",
      "Halli Airport",
      "Halli Airport"
    ],
    "city": [
      "Jämsä",
      "Jämsä",
      "Jämsä"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "HEN",
    "translations": [
      "Hernesaari Heliport",
      "Hernesaari Heliport",
      "Hernesaari Heliport"
    ],
    "city": [
      "Helsinki",
      "Helsinki",
      "Helsinki"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "HEL",
    "translations": [
      "Helsinki Vantaa Airport",
      "Helsinki Vantaa Airport",
      "Helsinki Vantaa Airport"
    ],
    "city": [
      "Helsinki (Vantaa)",
      "Helsinki (Vantaa)",
      "Helsinki (Vantaa)"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "HYV",
    "translations": [
      "Hyvinkää Airfield",
      "Hyvinkää Airfield",
      "Hyvinkää Airfield"
    ],
    "city": [
      "Hyvinkää",
      "Hyvinkää",
      "Hyvinkää"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "KTQ",
    "translations": [
      "Kitee Airport",
      "Kitee Airport",
      "Kitee Airport"
    ],
    "city": [
      "Kitee",
      "Kitee",
      "Kitee"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "IVL",
    "translations": [
      "Ivalo Airport",
      "Ivalo Airport",
      "Ivalo Airport"
    ],
    "city": [
      "Ivalo",
      "Ivalo",
      "Ivalo"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "JOE",
    "translations": [
      "Joensuu Airport",
      "Joensuu Airport",
      "Joensuu Airport"
    ],
    "city": [
      "Joensuu",
      "Joensuu",
      "Joensuu"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "JYV",
    "translations": [
      "Jyväskylä Airport",
      "Jyväskylä Airport",
      "Jyväskylä Airport"
    ],
    "city": [
      "Jyväskylän Maalaiskunta",
      "Jyväskylän Maalaiskunta",
      "Jyväskylän Maalaiskunta"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "KAU",
    "translations": [
      "Kauhava Airfield",
      "Kauhava Airfield",
      "Kauhava Airfield"
    ],
    "city": [
      "Kauhava",
      "Kauhava",
      "Kauhava"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "KEM",
    "translations": [
      "Kemi-Tornio Airport",
      "Kemi-Tornio Airport",
      "Kemi-Tornio Airport"
    ],
    "city": [
      "Kemi / Tornio",
      "Kemi / Tornio",
      "Kemi / Tornio"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "KAJ",
    "translations": [
      "Kajaani Airport",
      "Kajaani Airport",
      "Kajaani Airport"
    ],
    "city": [
      "Kajaani",
      "Kajaani",
      "Kajaani"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "KHJ",
    "translations": [
      "Kauhajoki Airfield",
      "Kauhajoki Airfield",
      "Kauhajoki Airfield"
    ],
    "city": [
      "Kauhajoki",
      "Kauhajoki",
      "Kauhajoki"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "KOK",
    "translations": [
      "Kokkola-Pietarsaari Airport",
      "Kokkola-Pietarsaari Airport",
      "Kokkola-Pietarsaari Airport"
    ],
    "city": [
      "Kokkola / Kruunupyy",
      "Kokkola / Kruunupyy",
      "Kokkola / Kruunupyy"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "KAO",
    "translations": [
      "Kuusamo Airport",
      "Kuusamo Airport",
      "Kuusamo Airport"
    ],
    "city": [
      "Kuusamo",
      "Kuusamo",
      "Kuusamo"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "KTT",
    "translations": [
      "Kittilä Airport",
      "Kittilä Airport",
      "Kittilä Airport"
    ],
    "city": [
      "Kittilä",
      "Kittilä",
      "Kittilä"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "KUO",
    "translations": [
      "Kuopio Airport",
      "Kuopio Airport",
      "Kuopio Airport"
    ],
    "city": [
      "Kuopio / Siilinjärvi",
      "Kuopio / Siilinjärvi",
      "Kuopio / Siilinjärvi"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "LPP",
    "translations": [
      "Lappeenranta Airport",
      "Lappeenranta Airport",
      "Lappeenranta Airport"
    ],
    "city": [
      "Lappeenranta",
      "Lappeenranta",
      "Lappeenranta"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "MHQ",
    "translations": [
      "Mariehamn Airport",
      "Mariehamn Airport",
      "Mariehamn Airport"
    ],
    "city": [
      "Mariehamn",
      "Mariehamn",
      "Mariehamn"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "MIK",
    "translations": [
      "Mikkeli Airport",
      "Mikkeli Airport",
      "Mikkeli Airport"
    ],
    "city": [
      "Mikkeli",
      "Mikkeli",
      "Mikkeli"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "OUL",
    "translations": [
      "Oulu Airport",
      "Oulu Airport",
      "Oulu Airport"
    ],
    "city": [
      "Oulu / Oulunsalo",
      "Oulu / Oulunsalo",
      "Oulu / Oulunsalo"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "POR",
    "translations": [
      "Pori Airport",
      "Pori Airport",
      "Pori Airport"
    ],
    "city": [
      "Pori",
      "Pori",
      "Pori"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "RVN",
    "translations": [
      "Rovaniemi Airport",
      "Rovaniemi Airport",
      "Rovaniemi Airport"
    ],
    "city": [
      "Rovaniemi",
      "Rovaniemi",
      "Rovaniemi"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "SVL",
    "translations": [
      "Savonlinna Airport",
      "Savonlinna Airport",
      "Savonlinna Airport"
    ],
    "city": [
      "Savonlinna",
      "Savonlinna",
      "Savonlinna"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "SJY",
    "translations": [
      "Seinäjoki Airport",
      "Seinäjoki Airport",
      "Seinäjoki Airport"
    ],
    "city": [
      "Seinäjoki / Ilmajoki",
      "Seinäjoki / Ilmajoki",
      "Seinäjoki / Ilmajoki"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "SOT",
    "translations": [
      "Sodankyla Airport",
      "Sodankyla Airport",
      "Sodankyla Airport"
    ],
    "city": [
      "Sodankyla",
      "Sodankyla",
      "Sodankyla"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "TMP",
    "translations": [
      "Tampere-Pirkkala Airport",
      "Tampere-Pirkkala Airport",
      "Tampere-Pirkkala Airport"
    ],
    "city": [
      "Tampere / Pirkkala",
      "Tampere / Pirkkala",
      "Tampere / Pirkkala"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "TKU",
    "translations": [
      "Turku Airport",
      "Turku Airport",
      "Turku Airport"
    ],
    "city": [
      "Turku",
      "Turku",
      "Turku"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "UTI",
    "translations": [
      "Utti Air Base",
      "Utti Air Base",
      "Utti Air Base"
    ],
    "city": [
      "Utti / Valkeala",
      "Utti / Valkeala",
      "Utti / Valkeala"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "VAA",
    "translations": [
      "Vaasa Airport",
      "Vaasa Airport",
      "Vaasa Airport"
    ],
    "city": [
      "Vaasa",
      "Vaasa",
      "Vaasa"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "VRK",
    "translations": [
      "Varkaus Airport",
      "Varkaus Airport",
      "Varkaus Airport"
    ],
    "city": [
      "Varkaus / Joroinen",
      "Varkaus / Joroinen",
      "Varkaus / Joroinen"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "YLI",
    "translations": [
      "Ylivieska Airfield",
      "Ylivieska Airfield",
      "Ylivieska Airfield"
    ],
    "city": [
      "Ylivieska",
      "Ylivieska",
      "Ylivieska"
    ],
    "country": [
      "FI",
      "FI",
      "FI"
    ]
  },
  {
    "iata": "TFR",
    "translations": [
      "Katameya Air Base",
      "Katameya Air Base",
      "Katameya Air Base"
    ],
    "city": [
      "New Cairo",
      "New Cairo",
      "New Cairo"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "AUE",
    "translations": [
      "Abu Rudeis Airport",
      "Abu Rudeis Airport",
      "Abu Rudeis Airport"
    ],
    "city": [
      "Ras Abu Rudeis",
      "Ras Abu Rudeis",
      "Ras Abu Rudeis"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "BFS",
    "translations": [
      "Belfast International Airport",
      "Belfast International Airport",
      "Belfast International Airport"
    ],
    "city": [
      "Belfast",
      "Belfast",
      "Belfast"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "ENK",
    "translations": [
      "Enniskillen/St Angelo Airport",
      "Enniskillen/St Angelo Airport",
      "Enniskillen/St Angelo Airport"
    ],
    "city": [
      "Enniskillen, Fermanagh and Omagh",
      "Enniskillen, Fermanagh and Omagh",
      "Enniskillen, Fermanagh and Omagh"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BHD",
    "translations": [
      "George Best Belfast City Airport",
      "George Best Belfast City Airport",
      "George Best Belfast City Airport"
    ],
    "city": [
      "Belfast",
      "Belfast",
      "Belfast"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "LDY",
    "translations": [
      "City of Derry Airport",
      "City of Derry Airport",
      "City of Derry Airport"
    ],
    "city": [
      "Derry",
      "Derry",
      "Derry"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BHX",
    "translations": [
      "Birmingham Airport",
      "Birmingham Airport",
      "Birmingham Airport"
    ],
    "city": [
      "Birmingham, West Midlands",
      "Birmingham, West Midlands",
      "Birmingham, West Midlands"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "CVT",
    "translations": [
      "Coventry Airport",
      "Coventry Airport",
      "Coventry Airport"
    ],
    "city": [
      "Coventry, West Midlands",
      "Coventry, West Midlands",
      "Coventry, West Midlands"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "GLO",
    "translations": [
      "Gloucestershire Airport",
      "Gloucestershire Airport",
      "Gloucestershire Airport"
    ],
    "city": [
      "Staverton",
      "Staverton",
      "Staverton"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "ORM",
    "translations": [
      "Sywell Aerodrome",
      "Sywell Aerodrome",
      "Sywell Aerodrome"
    ],
    "city": [
      "Northampton, Northamptonshire",
      "Northampton, Northamptonshire",
      "Northampton, Northamptonshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "NQT",
    "translations": [
      "Nottingham City Airport",
      "Nottingham City Airport",
      "Nottingham City Airport"
    ],
    "city": [
      "Nottingham",
      "Nottingham",
      "Nottingham"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "GBA",
    "translations": [
      "Cotswold Airport",
      "Cotswold Airport",
      "Cotswold Airport"
    ],
    "city": [
      "Cirencester, Gloucestershire",
      "Cirencester, Gloucestershire",
      "Cirencester, Gloucestershire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "MAN",
    "translations": [
      "Manchester Airport",
      "Manchester Airport",
      "Manchester Airport"
    ],
    "city": [
      "Manchester, Greater Manchester",
      "Manchester, Greater Manchester",
      "Manchester, Greater Manchester"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "UPV",
    "translations": [
      "Upavon Aerodrome",
      "Upavon Aerodrome",
      "Upavon Aerodrome"
    ],
    "city": [
      "Pewsey, Wiltshire",
      "Pewsey, Wiltshire",
      "Pewsey, Wiltshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "YEO",
    "translations": [
      "RNAS Yeovilton",
      "RNAS Yeovilton",
      "RNAS Yeovilton"
    ],
    "city": [
      "Yeovil, Somerset",
      "Yeovil, Somerset",
      "Yeovil, Somerset"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "CAL",
    "translations": [
      "Campbeltown Airport",
      "Campbeltown Airport",
      "Campbeltown Airport"
    ],
    "city": [
      "Campbeltown",
      "Campbeltown",
      "Campbeltown"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "EOI",
    "translations": [
      "Eday Airport",
      "Eday Airport",
      "Eday Airport"
    ],
    "city": [
      "Eday",
      "Eday",
      "Eday"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "FIE",
    "translations": [
      "Fair Isle Airport",
      "Fair Isle Airport",
      "Fair Isle Airport"
    ],
    "city": [
      "Fair Isle",
      "Fair Isle",
      "Fair Isle"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "WHS",
    "translations": [
      "Whalsay Airstrip",
      "Whalsay Airstrip",
      "Whalsay Airstrip"
    ],
    "city": [
      "Whalsay, Shetlands",
      "Whalsay, Shetlands",
      "Whalsay, Shetlands"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "SKL",
    "translations": [
      "Broadford Airstrip",
      "Broadford Airstrip",
      "Broadford Airstrip"
    ],
    "city": [
      "Ashaig",
      "Ashaig",
      "Ashaig"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "COL",
    "translations": [
      "Coll Airport",
      "Coll Airport",
      "Coll Airport"
    ],
    "city": [
      "Coll Island",
      "Coll Island",
      "Coll Island"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "NRL",
    "translations": [
      "North Ronaldsay Airport",
      "North Ronaldsay Airport",
      "North Ronaldsay Airport"
    ],
    "city": [
      "North Ronaldsay",
      "North Ronaldsay",
      "North Ronaldsay"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "OBN",
    "translations": [
      "Oban Airport",
      "Oban Airport",
      "Oban Airport"
    ],
    "city": [
      "North Connel",
      "North Connel",
      "North Connel"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "PPW",
    "translations": [
      "Papa Westray Airport",
      "Papa Westray Airport",
      "Papa Westray Airport"
    ],
    "city": [
      "Papa Westray",
      "Papa Westray",
      "Papa Westray"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "SOY",
    "translations": [
      "Stronsay Airport",
      "Stronsay Airport",
      "Stronsay Airport"
    ],
    "city": [
      "Stronsay",
      "Stronsay",
      "Stronsay"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "NDY",
    "translations": [
      "Sanday Airport",
      "Sanday Airport",
      "Sanday Airport"
    ],
    "city": [
      "Sanday",
      "Sanday",
      "Sanday"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "LWK",
    "translations": [
      "Lerwick / Tingwall Airport",
      "Lerwick / Tingwall Airport",
      "Lerwick / Tingwall Airport"
    ],
    "city": [
      "Lerwick, Shetland Islands",
      "Lerwick, Shetland Islands",
      "Lerwick, Shetland Islands"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "WRY",
    "translations": [
      "Westray Airport",
      "Westray Airport",
      "Westray Airport"
    ],
    "city": [
      "Westray",
      "Westray",
      "Westray"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "CSA",
    "translations": [
      "Colonsay Airstrip",
      "Colonsay Airstrip",
      "Colonsay Airstrip"
    ],
    "city": [
      "Colonsay",
      "Colonsay",
      "Colonsay"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "HAW",
    "translations": [
      "Haverfordwest Airport",
      "Haverfordwest Airport",
      "Haverfordwest Airport"
    ],
    "city": [
      "Haverfordwest",
      "Haverfordwest",
      "Haverfordwest"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "CWL",
    "translations": [
      "Cardiff International Airport",
      "Cardiff International Airport",
      "Cardiff International Airport"
    ],
    "city": [
      "Cardiff",
      "Cardiff",
      "Cardiff"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "SWS",
    "translations": [
      "Swansea Airport",
      "Swansea Airport",
      "Swansea Airport"
    ],
    "city": [
      "Swansea",
      "Swansea",
      "Swansea"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BRS",
    "translations": [
      "Bristol Airport",
      "Bristol Airport",
      "Bristol Airport"
    ],
    "city": [
      "Bristol",
      "Bristol",
      "Bristol"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "LPL",
    "translations": [
      "Liverpool John Lennon Airport",
      "Liverpool John Lennon Airport",
      "Liverpool John Lennon Airport"
    ],
    "city": [
      "Liverpool",
      "Liverpool",
      "Liverpool"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "LTN",
    "translations": [
      "London Luton Airport",
      "London Luton Airport",
      "London Luton Airport"
    ],
    "city": [
      "Luton, Bedfordshire",
      "Luton, Bedfordshire",
      "Luton, Bedfordshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "LEQ",
    "translations": [
      "Land's End Airport",
      "Land's End Airport",
      "Land's End Airport"
    ],
    "city": [
      "Land's End, Cornwall",
      "Land's End, Cornwall",
      "Land's End, Cornwall"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "ISC",
    "translations": [
      "St. Mary's Airport",
      "St. Mary's Airport",
      "St. Mary's Airport"
    ],
    "city": [
      "St. Mary's, Isles of Scilly",
      "St. Mary's, Isles of Scilly",
      "St. Mary's, Isles of Scilly"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BOH",
    "translations": [
      "Bournemouth Airport",
      "Bournemouth Airport",
      "Bournemouth Airport"
    ],
    "city": [
      "Bournemouth",
      "Bournemouth",
      "Bournemouth"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "SOU",
    "translations": [
      "Southampton Airport",
      "Southampton Airport",
      "Southampton Airport"
    ],
    "city": [
      "Southampton",
      "Southampton",
      "Southampton"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BBP",
    "translations": [
      "Bembridge Airport",
      "Bembridge Airport",
      "Bembridge Airport"
    ],
    "city": [
      "Bembridge, Isle of Wight",
      "Bembridge, Isle of Wight",
      "Bembridge, Isle of Wight"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "NQY",
    "translations": [
      "Cornwall Airport Newquay",
      "Cornwall Airport Newquay",
      "Cornwall Airport Newquay"
    ],
    "city": [
      "Newquay",
      "Newquay",
      "Newquay"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "QUG",
    "translations": [
      "Goodwood Aerodrome",
      "Goodwood Aerodrome",
      "Goodwood Aerodrome"
    ],
    "city": [
      "Chichester, West Sussex",
      "Chichester, West Sussex",
      "Chichester, West Sussex"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "ACI",
    "translations": [
      "Alderney Airport",
      "Alderney Airport",
      "Alderney Airport"
    ],
    "city": [
      "Saint Anne",
      "Saint Anne",
      "Saint Anne"
    ],
    "country": [
      "GG",
      "GG",
      "GG"
    ]
  },
  {
    "iata": "GCI",
    "translations": [
      "Guernsey Airport",
      "Guernsey Airport",
      "Guernsey Airport"
    ],
    "city": [
      "Saint Peter Port",
      "Saint Peter Port",
      "Saint Peter Port"
    ],
    "country": [
      "GG",
      "GG",
      "GG"
    ]
  },
  {
    "iata": "JER",
    "translations": [
      "Jersey Airport",
      "Jersey Airport",
      "Jersey Airport"
    ],
    "city": [
      "Saint Helier",
      "Saint Helier",
      "Saint Helier"
    ],
    "country": [
      "JE",
      "JE",
      "JE"
    ]
  },
  {
    "iata": "ESH",
    "translations": [
      "Brighton City Airport",
      "Brighton City Airport",
      "Brighton City Airport"
    ],
    "city": [
      "Brighton, East Sussex",
      "Brighton, East Sussex",
      "Brighton, East Sussex"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BQH",
    "translations": [
      "London Biggin Hill Airport",
      "London Biggin Hill Airport",
      "London Biggin Hill Airport"
    ],
    "city": [
      "London",
      "London",
      "London"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "LGW",
    "translations": [
      "London Gatwick Airport",
      "London Gatwick Airport",
      "London Gatwick Airport"
    ],
    "city": [
      "London",
      "London",
      "London"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "LCY",
    "translations": [
      "London City Airport",
      "London City Airport",
      "London City Airport"
    ],
    "city": [
      "London",
      "London",
      "London"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "FAB",
    "translations": [
      "Farnborough Airport",
      "Farnborough Airport",
      "Farnborough Airport"
    ],
    "city": [
      "Farnborough, Hampshire",
      "Farnborough, Hampshire",
      "Farnborough, Hampshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BBS",
    "translations": [
      "Blackbushe Airport",
      "Blackbushe Airport",
      "Blackbushe Airport"
    ],
    "city": [
      "Camberley, Surrey",
      "Camberley, Surrey",
      "Camberley, Surrey"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "LHR",
    "translations": [
      "London Heathrow Airport",
      "London Heathrow Airport",
      "London Heathrow Airport"
    ],
    "city": [
      "London",
      "London",
      "London"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "SEN",
    "translations": [
      "London Southend Airport",
      "London Southend Airport",
      "London Southend Airport"
    ],
    "city": [
      "Southend-on-Sea, Essex",
      "Southend-on-Sea, Essex",
      "Southend-on-Sea, Essex"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "LYX",
    "translations": [
      "Lydd London Ashford Airport",
      "Lydd London Ashford Airport",
      "Lydd London Ashford Airport"
    ],
    "city": [
      "Romney Marsh, Kent",
      "Romney Marsh, Kent",
      "Romney Marsh, Kent"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "CAX",
    "translations": [
      "Carlisle Lake District Airport",
      "Carlisle Lake District Airport",
      "Carlisle Lake District Airport"
    ],
    "city": [
      "Carlisle, Cumbria",
      "Carlisle, Cumbria",
      "Carlisle, Cumbria"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BLK",
    "translations": [
      "Blackpool Airport",
      "Blackpool Airport",
      "Blackpool Airport"
    ],
    "city": [
      "Blackpool",
      "Blackpool",
      "Blackpool"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "HUY",
    "translations": [
      "Humberside Airport",
      "Humberside Airport",
      "Humberside Airport"
    ],
    "city": [
      "Grimsby, Lincolnshire",
      "Grimsby, Lincolnshire",
      "Grimsby, Lincolnshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BWF",
    "translations": [
      "Barrow Walney Island Airport",
      "Barrow Walney Island Airport",
      "Barrow Walney Island Airport"
    ],
    "city": [
      "Barrow-in-Furness",
      "Barrow-in-Furness",
      "Barrow-in-Furness"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "LBA",
    "translations": [
      "Leeds Bradford Airport",
      "Leeds Bradford Airport",
      "Leeds Bradford Airport"
    ],
    "city": [
      "Leeds, West Yorkshire",
      "Leeds, West Yorkshire",
      "Leeds, West Yorkshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "WRT",
    "translations": [
      "Warton Aerodrome",
      "Warton Aerodrome",
      "Warton Aerodrome"
    ],
    "city": [
      "Warton",
      "Warton",
      "Warton"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "CEG",
    "translations": [
      "Hawarden Airport",
      "Hawarden Airport",
      "Hawarden Airport"
    ],
    "city": [
      "Broughton",
      "Broughton",
      "Broughton"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "IOM",
    "translations": [
      "Isle of Man Airport",
      "Isle of Man Airport",
      "Isle of Man Airport"
    ],
    "city": [
      "Castletown",
      "Castletown",
      "Castletown"
    ],
    "country": [
      "IM",
      "IM",
      "IM"
    ]
  },
  {
    "iata": "NCL",
    "translations": [
      "Newcastle International Airport",
      "Newcastle International Airport",
      "Newcastle International Airport"
    ],
    "city": [
      "Newcastle upon Tyne, Tyne and Wear",
      "Newcastle upon Tyne, Tyne and Wear",
      "Newcastle upon Tyne, Tyne and Wear"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "MME",
    "translations": [
      "Teesside International Airport",
      "Teesside International Airport",
      "Teesside International Airport"
    ],
    "city": [
      "Darlington, Durham",
      "Darlington, Durham",
      "Darlington, Durham"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "EMA",
    "translations": [
      "East Midlands Airport",
      "East Midlands Airport",
      "East Midlands Airport"
    ],
    "city": [
      "Nottingham",
      "Nottingham",
      "Nottingham"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "VLY",
    "translations": [
      "Anglesey Airport",
      "Anglesey Airport",
      "Anglesey Airport"
    ],
    "city": [
      "Angelsey",
      "Angelsey",
      "Angelsey"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "KOI",
    "translations": [
      "Kirkwall Airport",
      "Kirkwall Airport",
      "Kirkwall Airport"
    ],
    "city": [
      "Orkney Islands",
      "Orkney Islands",
      "Orkney Islands"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "LSI",
    "translations": [
      "Sumburgh Airport",
      "Sumburgh Airport",
      "Sumburgh Airport"
    ],
    "city": [
      "Lerwick, Shetland",
      "Lerwick, Shetland",
      "Lerwick, Shetland"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "WIC",
    "translations": [
      "Wick John O'Groats Airport",
      "Wick John O'Groats Airport",
      "Wick John O'Groats Airport"
    ],
    "city": [
      "Wick",
      "Wick",
      "Wick"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "ABZ",
    "translations": [
      "Aberdeen International Airport",
      "Aberdeen International Airport",
      "Aberdeen International Airport"
    ],
    "city": [
      "Aberdeen",
      "Aberdeen",
      "Aberdeen"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "INV",
    "translations": [
      "Inverness Airport",
      "Inverness Airport",
      "Inverness Airport"
    ],
    "city": [
      "Inverness",
      "Inverness",
      "Inverness"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "GLA",
    "translations": [
      "Glasgow Airport",
      "Glasgow Airport",
      "Glasgow Airport"
    ],
    "city": [
      "Glasgow",
      "Glasgow",
      "Glasgow"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "EDI",
    "translations": [
      "Edinburgh Airport",
      "Edinburgh Airport",
      "Edinburgh Airport"
    ],
    "city": [
      "Edinburgh",
      "Edinburgh",
      "Edinburgh"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "ILY",
    "translations": [
      "Islay Airport",
      "Islay Airport",
      "Islay Airport"
    ],
    "city": [
      "Isle of Islay, Argyll and Bute",
      "Isle of Islay, Argyll and Bute",
      "Isle of Islay, Argyll and Bute"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "PIK",
    "translations": [
      "Glasgow Prestwick Airport",
      "Glasgow Prestwick Airport",
      "Glasgow Prestwick Airport"
    ],
    "city": [
      "Prestwick, South Ayrshire",
      "Prestwick, South Ayrshire",
      "Prestwick, South Ayrshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BEB",
    "translations": [
      "Benbecula Airport",
      "Benbecula Airport",
      "Benbecula Airport"
    ],
    "city": [
      "Balivanich",
      "Balivanich",
      "Balivanich"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "DND",
    "translations": [
      "Dundee Airport",
      "Dundee Airport",
      "Dundee Airport"
    ],
    "city": [
      "Dundee",
      "Dundee",
      "Dundee"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "SYY",
    "translations": [
      "Stornoway Airport",
      "Stornoway Airport",
      "Stornoway Airport"
    ],
    "city": [
      "Stornoway, Western Isles",
      "Stornoway, Western Isles",
      "Stornoway, Western Isles"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BRR",
    "translations": [
      "Barra Airport",
      "Barra Airport",
      "Barra Airport"
    ],
    "city": [
      "Eoligarry",
      "Eoligarry",
      "Eoligarry"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "PSL",
    "translations": [
      "Perth/Scone Airport",
      "Perth/Scone Airport",
      "Perth/Scone Airport"
    ],
    "city": [
      "Perth",
      "Perth",
      "Perth"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "TRE",
    "translations": [
      "Tiree Airport",
      "Tiree Airport",
      "Tiree Airport"
    ],
    "city": [
      "Balemartine",
      "Balemartine",
      "Balemartine"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "ADX",
    "translations": [
      "Leuchars Station Airfield",
      "Leuchars Station Airfield",
      "Leuchars Station Airfield"
    ],
    "city": [
      "Leuchars, Fife",
      "Leuchars, Fife",
      "Leuchars, Fife"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "LMO",
    "translations": [
      "RAF Lossiemouth",
      "RAF Lossiemouth",
      "RAF Lossiemouth"
    ],
    "city": [
      "Lossiemouth",
      "Lossiemouth",
      "Lossiemouth"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "CBG",
    "translations": [
      "Cambridge City Airport",
      "Cambridge City Airport",
      "Cambridge City Airport"
    ],
    "city": [
      "Cambridge, Cambridgeshire",
      "Cambridge, Cambridgeshire",
      "Cambridge, Cambridgeshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "NWI",
    "translations": [
      "Norwich Airport",
      "Norwich Airport",
      "Norwich Airport"
    ],
    "city": [
      "Norwich, Norfolk",
      "Norwich, Norfolk",
      "Norwich, Norfolk"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "STN",
    "translations": [
      "London Stansted Airport",
      "London Stansted Airport",
      "London Stansted Airport"
    ],
    "city": [
      "London",
      "London",
      "London"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "HYC",
    "translations": [
      "Wycombe Air Park",
      "Wycombe Air Park",
      "Wycombe Air Park"
    ],
    "city": [
      "Marlow, Buckinghamshire",
      "Marlow, Buckinghamshire",
      "Marlow, Buckinghamshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "EXT",
    "translations": [
      "Exeter International Airport",
      "Exeter International Airport",
      "Exeter International Airport"
    ],
    "city": [
      "Exeter, Devon",
      "Exeter, Devon",
      "Exeter, Devon"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "OXF",
    "translations": [
      "London Oxford Airport",
      "London Oxford Airport",
      "London Oxford Airport"
    ],
    "city": [
      "Kidlington, Oxfordshire",
      "Kidlington, Oxfordshire",
      "Kidlington, Oxfordshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "RCS",
    "translations": [
      "Rochester Airport",
      "Rochester Airport",
      "Rochester Airport"
    ],
    "city": [
      "Rochester, Kent",
      "Rochester, Kent",
      "Rochester, Kent"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BEX",
    "translations": [
      "RAF Benson",
      "RAF Benson",
      "RAF Benson"
    ],
    "city": [
      "Wallingford, Oxfordshire",
      "Wallingford, Oxfordshire",
      "Wallingford, Oxfordshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "LKZ",
    "translations": [
      "RAF Lakenheath",
      "RAF Lakenheath",
      "RAF Lakenheath"
    ],
    "city": [
      "Brandon, Suffolk",
      "Brandon, Suffolk",
      "Brandon, Suffolk"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "MHZ",
    "translations": [
      "RAF Mildenhall",
      "RAF Mildenhall",
      "RAF Mildenhall"
    ],
    "city": [
      "Bury Saint Edmunds, Suffolk",
      "Bury Saint Edmunds, Suffolk",
      "Bury Saint Edmunds, Suffolk"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "FFD",
    "translations": [
      "RAF Fairford",
      "RAF Fairford",
      "RAF Fairford"
    ],
    "city": [
      "Fairford, Gloucestershire",
      "Fairford, Gloucestershire",
      "Fairford, Gloucestershire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BZZ",
    "translations": [
      "RAF Brize Norton",
      "RAF Brize Norton",
      "RAF Brize Norton"
    ],
    "city": [
      "Carterton, Oxfordshire",
      "Carterton, Oxfordshire",
      "Carterton, Oxfordshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "ODH",
    "translations": [
      "RAF Odiham",
      "RAF Odiham",
      "RAF Odiham"
    ],
    "city": [
      "Hook, Hampshire",
      "Hook, Hampshire",
      "Hook, Hampshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "NHT",
    "translations": [
      "RAF Northolt",
      "RAF Northolt",
      "RAF Northolt"
    ],
    "city": [
      "London",
      "London",
      "London"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "QCY",
    "translations": [
      "RAF Coningsby",
      "RAF Coningsby",
      "RAF Coningsby"
    ],
    "city": [
      "Lincoln, Lincolnshire",
      "Lincoln, Lincolnshire",
      "Lincoln, Lincolnshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "BEQ",
    "translations": [
      "RAF Honington",
      "RAF Honington",
      "RAF Honington"
    ],
    "city": [
      "Bury Saint Edmunds, Suffolk",
      "Bury Saint Edmunds, Suffolk",
      "Bury Saint Edmunds, Suffolk"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "WTN",
    "translations": [
      "RAF Waddington",
      "RAF Waddington",
      "RAF Waddington"
    ],
    "city": [
      "Lincoln, Lincolnshire",
      "Lincoln, Lincolnshire",
      "Lincoln, Lincolnshire"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "KNF",
    "translations": [
      "RAF Marham",
      "RAF Marham",
      "RAF Marham"
    ],
    "city": [
      "King's Lynn, Norfolk",
      "King's Lynn, Norfolk",
      "King's Lynn, Norfolk"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "MPN",
    "translations": [
      "Mount Pleasant Airport",
      "Mount Pleasant Airport",
      "Mount Pleasant Airport"
    ],
    "city": [
      "Mount Pleasant",
      "Mount Pleasant",
      "Mount Pleasant"
    ],
    "country": [
      "FK",
      "FK",
      "FK"
    ]
  },
  {
    "iata": "AMS",
    "translations": [
      "Amsterdam Airport Schiphol",
      "Amsterdam Airport Schiphol",
      "Amsterdam Airport Schiphol"
    ],
    "city": [
      "Amsterdam",
      "Amsterdam",
      "Amsterdam"
    ],
    "country": [
      "NL",
      "NL",
      "NL"
    ]
  },
  {
    "iata": "MST",
    "translations": [
      "Maastricht Aachen Airport",
      "Maastricht Aachen Airport",
      "Maastricht Aachen Airport"
    ],
    "city": [
      "Maastricht",
      "Maastricht",
      "Maastricht"
    ],
    "country": [
      "NL",
      "NL",
      "NL"
    ]
  },
  {
    "iata": "EIN",
    "translations": [
      "Eindhoven Airport",
      "Eindhoven Airport",
      "Eindhoven Airport"
    ],
    "city": [
      "Eindhoven",
      "Eindhoven",
      "Eindhoven"
    ],
    "country": [
      "NL",
      "NL",
      "NL"
    ]
  },
  {
    "iata": "GRQ",
    "translations": [
      "Groningen Airport Eelde",
      "Groningen Airport Eelde",
      "Groningen Airport Eelde"
    ],
    "city": [
      "Groningen",
      "Groningen",
      "Groningen"
    ],
    "country": [
      "NL",
      "NL",
      "NL"
    ]
  },
  {
    "iata": "GLZ",
    "translations": [
      "Gilze Rijen Air Base",
      "Gilze Rijen Air Base",
      "Gilze Rijen Air Base"
    ],
    "city": [
      "Rijen",
      "Rijen",
      "Rijen"
    ],
    "country": [
      "NL",
      "NL",
      "NL"
    ]
  },
  {
    "iata": "DHR",
    "translations": [
      "De Kooy Airfield / Den Helder Naval Air Station",
      "De Kooy Airfield / Den Helder Naval Air Station",
      "De Kooy Airfield / Den Helder Naval Air Station"
    ],
    "city": [
      "Den Helder",
      "Den Helder",
      "Den Helder"
    ],
    "country": [
      "NL",
      "NL",
      "NL"
    ]
  },
  {
    "iata": "LEY",
    "translations": [
      "Lelystad Airport",
      "Lelystad Airport",
      "Lelystad Airport"
    ],
    "city": [
      "Lelystad",
      "Lelystad",
      "Lelystad"
    ],
    "country": [
      "NL",
      "NL",
      "NL"
    ]
  },
  {
    "iata": "LWR",
    "translations": [
      "Leeuwarden Air Base",
      "Leeuwarden Air Base",
      "Leeuwarden Air Base"
    ],
    "city": [
      "Leeuwarden",
      "Leeuwarden",
      "Leeuwarden"
    ],
    "country": [
      "NL",
      "NL",
      "NL"
    ]
  },
  {
    "iata": "RTM",
    "translations": [
      "Rotterdam The Hague Airport",
      "Rotterdam The Hague Airport",
      "Rotterdam The Hague Airport"
    ],
    "city": [
      "Rotterdam",
      "Rotterdam",
      "Rotterdam"
    ],
    "country": [
      "NL",
      "NL",
      "NL"
    ]
  },
  {
    "iata": "ENS",
    "translations": [
      "Twente Airport",
      "Twente Airport",
      "Twente Airport"
    ],
    "city": [
      "Enschede",
      "Enschede",
      "Enschede"
    ],
    "country": [
      "NL",
      "NL",
      "NL"
    ]
  },
  {
    "iata": "UDE",
    "translations": [
      "Volkel Air Base",
      "Volkel Air Base",
      "Volkel Air Base"
    ],
    "city": [
      "Uden",
      "Uden",
      "Uden"
    ],
    "country": [
      "NL",
      "NL",
      "NL"
    ]
  },
  {
    "iata": "WOE",
    "translations": [
      "Woensdrecht Air Base",
      "Woensdrecht Air Base",
      "Woensdrecht Air Base"
    ],
    "city": [
      "Hoogerheide",
      "Hoogerheide",
      "Hoogerheide"
    ],
    "country": [
      "NL",
      "NL",
      "NL"
    ]
  },
  {
    "iata": "BYT",
    "translations": [
      "Bantry Aerodrome",
      "Bantry Aerodrome",
      "Bantry Aerodrome"
    ],
    "city": [
      "Bantry",
      "Bantry",
      "Bantry"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "BLY",
    "translations": [
      "Belmullet Aerodrome",
      "Belmullet Aerodrome",
      "Belmullet Aerodrome"
    ],
    "city": [
      "Belmullet",
      "Belmullet",
      "Belmullet"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "NNR",
    "translations": [
      "Connemara Regional Airport",
      "Connemara Regional Airport",
      "Connemara Regional Airport"
    ],
    "city": [
      "Inverin",
      "Inverin",
      "Inverin"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "ORK",
    "translations": [
      "Cork Airport",
      "Cork Airport",
      "Cork Airport"
    ],
    "city": [
      "Cork",
      "Cork",
      "Cork"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "CFN",
    "translations": [
      "Donegal Airport",
      "Donegal Airport",
      "Donegal Airport"
    ],
    "city": [
      "Donegal",
      "Donegal",
      "Donegal"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "DUB",
    "translations": [
      "Dublin Airport",
      "Dublin Airport",
      "Dublin Airport"
    ],
    "city": [
      "Dublin",
      "Dublin",
      "Dublin"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "IOR",
    "translations": [
      "Inishmore Aerodrome",
      "Inishmore Aerodrome",
      "Inishmore Aerodrome"
    ],
    "city": [
      "Inis Mór",
      "Inis Mór",
      "Inis Mór"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "INQ",
    "translations": [
      "Inisheer Aerodrome",
      "Inisheer Aerodrome",
      "Inisheer Aerodrome"
    ],
    "city": [
      "Inis Oírr",
      "Inis Oírr",
      "Inis Oírr"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "KKY",
    "translations": [
      "Kilkenny Airport",
      "Kilkenny Airport",
      "Kilkenny Airport"
    ],
    "city": [
      "Kilkenny",
      "Kilkenny",
      "Kilkenny"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "NOC",
    "translations": [
      "Ireland West Knock Airport",
      "Ireland West Knock Airport",
      "Ireland West Knock Airport"
    ],
    "city": [
      "Charlestown",
      "Charlestown",
      "Charlestown"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "KIR",
    "translations": [
      "Kerry Airport",
      "Kerry Airport",
      "Kerry Airport"
    ],
    "city": [
      "Farranfore",
      "Farranfore",
      "Farranfore"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "IIA",
    "translations": [
      "Inishmaan Aerodrome",
      "Inishmaan Aerodrome",
      "Inishmaan Aerodrome"
    ],
    "city": [
      "Inis Meáin",
      "Inis Meáin",
      "Inis Meáin"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "SNN",
    "translations": [
      "Shannon Airport",
      "Shannon Airport",
      "Shannon Airport"
    ],
    "city": [
      "Shannon",
      "Shannon",
      "Shannon"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "SXL",
    "translations": [
      "Sligo Airport",
      "Sligo Airport",
      "Sligo Airport"
    ],
    "city": [
      "Sligo",
      "Sligo",
      "Sligo"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "WAT",
    "translations": [
      "Waterford Airport",
      "Waterford Airport",
      "Waterford Airport"
    ],
    "city": [
      "Waterford",
      "Waterford",
      "Waterford"
    ],
    "country": [
      "IE",
      "IE",
      "IE"
    ]
  },
  {
    "iata": "EJN",
    "translations": [
      "Ejin Banner Taolai Airport",
      "Ejin Banner Taolai Airport",
      "Ejin Banner Taolai Airport"
    ],
    "city": [
      "Ejin Banner",
      "Ejin Banner",
      "Ejin Banner"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "EJT",
    "translations": [
      "Enejit Airport",
      "Enejit Airport",
      "Enejit Airport"
    ],
    "city": [
      "Enejit Island",
      "Enejit Island",
      "Enejit Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "AAR",
    "translations": [
      "Aarhus Airport",
      "Aarhus Airport",
      "Aarhus Airport"
    ],
    "city": [
      "Aarhus",
      "Aarhus",
      "Aarhus"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "BLL",
    "translations": [
      "Billund Airport",
      "Billund Airport",
      "Billund Airport"
    ],
    "city": [
      "Billund",
      "Billund",
      "Billund"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "CPH",
    "translations": [
      "Copenhagen Kastrup Airport",
      "Copenhagen Kastrup Airport",
      "Copenhagen Kastrup Airport"
    ],
    "city": [
      "Copenhagen",
      "Copenhagen",
      "Copenhagen"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "EBJ",
    "translations": [
      "Esbjerg Airport",
      "Esbjerg Airport",
      "Esbjerg Airport"
    ],
    "city": [
      "Esbjerg",
      "Esbjerg",
      "Esbjerg"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "KRP",
    "translations": [
      "Midtjyllands Airport / Air Base Karup",
      "Midtjyllands Airport / Air Base Karup",
      "Midtjyllands Airport / Air Base Karup"
    ],
    "city": [
      "Karup",
      "Karup",
      "Karup"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "BYR",
    "translations": [
      "Læsø Airport",
      "Læsø Airport",
      "Læsø Airport"
    ],
    "city": [
      "Læsø",
      "Læsø",
      "Læsø"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "MRW",
    "translations": [
      "Lolland Falster Maribo Airport",
      "Lolland Falster Maribo Airport",
      "Lolland Falster Maribo Airport"
    ],
    "city": [
      "Rødby",
      "Rødby",
      "Rødby"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "ODE",
    "translations": [
      "Odense Hans Christian Andersen Airport",
      "Odense Hans Christian Andersen Airport",
      "Odense Hans Christian Andersen Airport"
    ],
    "city": [
      "Odense",
      "Odense",
      "Odense"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "RKE",
    "translations": [
      "Copenhagen Roskilde Airport",
      "Copenhagen Roskilde Airport",
      "Copenhagen Roskilde Airport"
    ],
    "city": [
      "Roskilde",
      "Roskilde",
      "Roskilde"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "RNN",
    "translations": [
      "Bornholm Airport",
      "Bornholm Airport",
      "Bornholm Airport"
    ],
    "city": [
      "Rønne",
      "Rønne",
      "Rønne"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "SGD",
    "translations": [
      "Sønderborg Airport",
      "Sønderborg Airport",
      "Sønderborg Airport"
    ],
    "city": [
      "Sønderborg",
      "Sønderborg",
      "Sønderborg"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "CNL",
    "translations": [
      "Sindal Airport",
      "Sindal Airport",
      "Sindal Airport"
    ],
    "city": [
      "Sindal",
      "Sindal",
      "Sindal"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "SKS",
    "translations": [
      "Skrydstrup Air Base",
      "Skrydstrup Air Base",
      "Skrydstrup Air Base"
    ],
    "city": [
      "Vojens",
      "Vojens",
      "Vojens"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "SQW",
    "translations": [
      "Skive Airport",
      "Skive Airport",
      "Skive Airport"
    ],
    "city": [
      "Skive",
      "Skive",
      "Skive"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "TED",
    "translations": [
      "Thisted Airport",
      "Thisted Airport",
      "Thisted Airport"
    ],
    "city": [
      "Thisted",
      "Thisted",
      "Thisted"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "FAE",
    "translations": [
      "Vágar Airport",
      "Vágar Airport",
      "Vágar Airport"
    ],
    "city": [
      "Vágar",
      "Vágar",
      "Vágar"
    ],
    "country": [
      "FO",
      "FO",
      "FO"
    ]
  },
  {
    "iata": "STA",
    "translations": [
      "Stauning Vestjylland  Airport",
      "Stauning Vestjylland  Airport",
      "Stauning Vestjylland  Airport"
    ],
    "city": [
      "Skjern",
      "Skjern",
      "Skjern"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "AAL",
    "translations": [
      "Aalborg Airport",
      "Aalborg Airport",
      "Aalborg Airport"
    ],
    "city": [
      "Aalborg",
      "Aalborg",
      "Aalborg"
    ],
    "country": [
      "DK",
      "DK",
      "DK"
    ]
  },
  {
    "iata": "LUX",
    "translations": [
      "Luxembourg-Findel International Airport",
      "Luxembourg-Findel International Airport",
      "Luxembourg-Findel International Airport"
    ],
    "city": [
      "Luxembourg",
      "Luxembourg",
      "Luxembourg"
    ],
    "country": [
      "LU",
      "LU",
      "LU"
    ]
  },
  {
    "iata": "EMR",
    "translations": [
      "El Mirador Heliport",
      "El Mirador Heliport",
      "El Mirador Heliport"
    ],
    "city": [
      "El Mirador",
      "El Mirador",
      "El Mirador"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "AES",
    "translations": [
      "Ålesund Airport, Vigra",
      "Ålesund Airport, Vigra",
      "Ålesund Airport, Vigra"
    ],
    "city": [
      "Ålesund",
      "Ålesund",
      "Ålesund"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "ANX",
    "translations": [
      "Andøya Airport, Andenes",
      "Andøya Airport, Andenes",
      "Andøya Airport, Andenes"
    ],
    "city": [
      "Andenes",
      "Andenes",
      "Andenes"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "ALF",
    "translations": [
      "Alta Airport",
      "Alta Airport",
      "Alta Airport"
    ],
    "city": [
      "Alta",
      "Alta",
      "Alta"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "FDE",
    "translations": [
      "Førde Airport, Bringeland",
      "Førde Airport, Bringeland",
      "Førde Airport, Bringeland"
    ],
    "city": [
      "Førde",
      "Førde",
      "Førde"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "BNN",
    "translations": [
      "Brønnøysund Airport, Brønnøy",
      "Brønnøysund Airport, Brønnøy",
      "Brønnøysund Airport, Brønnøy"
    ],
    "city": [
      "Brønnøy",
      "Brønnøy",
      "Brønnøy"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "BOO",
    "translations": [
      "Bodø Airport",
      "Bodø Airport",
      "Bodø Airport"
    ],
    "city": [
      "Bodø",
      "Bodø",
      "Bodø"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "BGO",
    "translations": [
      "Bergen Airport, Flesland",
      "Bergen Airport, Flesland",
      "Bergen Airport, Flesland"
    ],
    "city": [
      "Bergen",
      "Bergen",
      "Bergen"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "BJF",
    "translations": [
      "Båtsfjord Airport",
      "Båtsfjord Airport",
      "Båtsfjord Airport"
    ],
    "city": [
      "Båtsfjord",
      "Båtsfjord",
      "Båtsfjord"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "BVG",
    "translations": [
      "Berlevåg Airport",
      "Berlevåg Airport",
      "Berlevåg Airport"
    ],
    "city": [
      "Berlevåg",
      "Berlevåg",
      "Berlevåg"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "KRS",
    "translations": [
      "Kristiansand Airport, Kjevik",
      "Kristiansand Airport, Kjevik",
      "Kristiansand Airport, Kjevik"
    ],
    "city": [
      "Kjevik",
      "Kjevik",
      "Kjevik"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "BDU",
    "translations": [
      "Bardufoss Airport",
      "Bardufoss Airport",
      "Bardufoss Airport"
    ],
    "city": [
      "Målselv",
      "Målselv",
      "Målselv"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "EVE",
    "translations": [
      "Harstad/Narvik Airport, Evenes",
      "Harstad/Narvik Airport, Evenes",
      "Harstad/Narvik Airport, Evenes"
    ],
    "city": [
      "Evenes",
      "Evenes",
      "Evenes"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "FRO",
    "translations": [
      "Florø Airport",
      "Florø Airport",
      "Florø Airport"
    ],
    "city": [
      "Florø",
      "Florø",
      "Florø"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "OSL",
    "translations": [
      "Oslo Airport, Gardermoen",
      "Oslo Airport, Gardermoen",
      "Oslo Airport, Gardermoen"
    ],
    "city": [
      "Oslo (Gardermoen)",
      "Oslo (Gardermoen)",
      "Oslo (Gardermoen)"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "HMR",
    "translations": [
      "Hamar Lufthavn, Stavsberg",
      "Hamar Lufthavn, Stavsberg",
      "Hamar Lufthavn, Stavsberg"
    ],
    "city": [
      "Hamar",
      "Hamar",
      "Hamar"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "HAU",
    "translations": [
      "Haugesund Airport, Karmøy",
      "Haugesund Airport, Karmøy",
      "Haugesund Airport, Karmøy"
    ],
    "city": [
      "Karmøy",
      "Karmøy",
      "Karmøy"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "HFT",
    "translations": [
      "Hammerfest Airport",
      "Hammerfest Airport",
      "Hammerfest Airport"
    ],
    "city": [
      "Hammerfest",
      "Hammerfest",
      "Hammerfest"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "HAA",
    "translations": [
      "Hasvik Airport",
      "Hasvik Airport",
      "Hasvik Airport"
    ],
    "city": [
      "Hasvik",
      "Hasvik",
      "Hasvik"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "HVG",
    "translations": [
      "Honningsvåg Airport, Valan",
      "Honningsvåg Airport, Valan",
      "Honningsvåg Airport, Valan"
    ],
    "city": [
      "Honningsvåg",
      "Honningsvåg",
      "Honningsvåg"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "KSU",
    "translations": [
      "Kristiansund Airport, Kvernberget",
      "Kristiansund Airport, Kvernberget",
      "Kristiansund Airport, Kvernberget"
    ],
    "city": [
      "Kvernberget",
      "Kvernberget",
      "Kvernberget"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "GLL",
    "translations": [
      "Gol Airport",
      "Gol Airport",
      "Gol Airport"
    ],
    "city": [
      "Klanten flyplass",
      "Klanten flyplass",
      "Klanten flyplass"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "KKN",
    "translations": [
      "Kirkenes Airport, Høybuktmoen",
      "Kirkenes Airport, Høybuktmoen",
      "Kirkenes Airport, Høybuktmoen"
    ],
    "city": [
      "Kirkenes",
      "Kirkenes",
      "Kirkenes"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "LKN",
    "translations": [
      "Leknes Airport",
      "Leknes Airport",
      "Leknes Airport"
    ],
    "city": [
      "Leknes",
      "Leknes",
      "Leknes"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "MEH",
    "translations": [
      "Mehamn Airport",
      "Mehamn Airport",
      "Mehamn Airport"
    ],
    "city": [
      "Mehamn",
      "Mehamn",
      "Mehamn"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "MOL",
    "translations": [
      "Molde Airport, Årø",
      "Molde Airport, Årø",
      "Molde Airport, Årø"
    ],
    "city": [
      "Årø",
      "Årø",
      "Årø"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "MJF",
    "translations": [
      "Mosjøen Airport, Kjærstad",
      "Mosjøen Airport, Kjærstad",
      "Mosjøen Airport, Kjærstad"
    ],
    "city": [
      "Mosjøen",
      "Mosjøen",
      "Mosjøen"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "LKL",
    "translations": [
      "Lakselv Airport, Banak",
      "Lakselv Airport, Banak",
      "Lakselv Airport, Banak"
    ],
    "city": [
      "Lakselv",
      "Lakselv",
      "Lakselv"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "OSY",
    "translations": [
      "Namsos Airport",
      "Namsos Airport",
      "Namsos Airport"
    ],
    "city": [
      "Namsos",
      "Namsos",
      "Namsos"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "NTB",
    "translations": [
      "Notodden Airport",
      "Notodden Airport",
      "Notodden Airport"
    ],
    "city": [
      "Notodden",
      "Notodden",
      "Notodden"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "OLA",
    "translations": [
      "Ørland Airport",
      "Ørland Airport",
      "Ørland Airport"
    ],
    "city": [
      "Ørland",
      "Ørland",
      "Ørland"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "HOV",
    "translations": [
      "Ørsta-Volda Airport, Hovden",
      "Ørsta-Volda Airport, Hovden",
      "Ørsta-Volda Airport, Hovden"
    ],
    "city": [
      "Ørsta",
      "Ørsta",
      "Ørsta"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "MQN",
    "translations": [
      "Mo i Rana Airport, Røssvoll",
      "Mo i Rana Airport, Røssvoll",
      "Mo i Rana Airport, Røssvoll"
    ],
    "city": [
      "Mo i Rana",
      "Mo i Rana",
      "Mo i Rana"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "RVK",
    "translations": [
      "Rørvik Airport, Ryum",
      "Rørvik Airport, Ryum",
      "Rørvik Airport, Ryum"
    ],
    "city": [
      "Rørvik",
      "Rørvik",
      "Rørvik"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "RRS",
    "translations": [
      "Røros Airport",
      "Røros Airport",
      "Røros Airport"
    ],
    "city": [
      "Røros",
      "Røros",
      "Røros"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "RET",
    "translations": [
      "Røst Airport",
      "Røst Airport",
      "Røst Airport"
    ],
    "city": [
      "Røst",
      "Røst",
      "Røst"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "LYR",
    "translations": [
      "Svalbard Airport, Longyear",
      "Svalbard Airport, Longyear",
      "Svalbard Airport, Longyear"
    ],
    "city": [
      "Longyearbyen",
      "Longyearbyen",
      "Longyearbyen"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "SDN",
    "translations": [
      "Sandane Airport, Anda",
      "Sandane Airport, Anda",
      "Sandane Airport, Anda"
    ],
    "city": [
      "Sandane",
      "Sandane",
      "Sandane"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "SOG",
    "translations": [
      "Sogndal Airport, Haukåsen",
      "Sogndal Airport, Haukåsen",
      "Sogndal Airport, Haukåsen"
    ],
    "city": [
      "Sogndal",
      "Sogndal",
      "Sogndal"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "SVJ",
    "translations": [
      "Svolvær Airport, Helle",
      "Svolvær Airport, Helle",
      "Svolvær Airport, Helle"
    ],
    "city": [
      "Svolvær",
      "Svolvær",
      "Svolvær"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "SKN",
    "translations": [
      "Stokmarknes Airport, Skagen",
      "Stokmarknes Airport, Skagen",
      "Stokmarknes Airport, Skagen"
    ],
    "city": [
      "Hadsel",
      "Hadsel",
      "Hadsel"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "SRP",
    "translations": [
      "Stord Airport, Sørstokken",
      "Stord Airport, Sørstokken",
      "Stord Airport, Sørstokken"
    ],
    "city": [
      "Leirvik",
      "Leirvik",
      "Leirvik"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "SOJ",
    "translations": [
      "Sørkjosen Airport",
      "Sørkjosen Airport",
      "Sørkjosen Airport"
    ],
    "city": [
      "Sørkjosen",
      "Sørkjosen",
      "Sørkjosen"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "VAW",
    "translations": [
      "Vardø Airport, Svartnes",
      "Vardø Airport, Svartnes",
      "Vardø Airport, Svartnes"
    ],
    "city": [
      "Vardø",
      "Vardø",
      "Vardø"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "SSJ",
    "translations": [
      "Sandnessjøen Airport, Stokka",
      "Sandnessjøen Airport, Stokka",
      "Sandnessjøen Airport, Stokka"
    ],
    "city": [
      "Alstahaug",
      "Alstahaug",
      "Alstahaug"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "TOS",
    "translations": [
      "Tromsø Airport, Langnes",
      "Tromsø Airport, Langnes",
      "Tromsø Airport, Langnes"
    ],
    "city": [
      "Tromsø",
      "Tromsø",
      "Tromsø"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "TRF",
    "translations": [
      "Sandefjord Airport, Torp",
      "Sandefjord Airport, Torp",
      "Sandefjord Airport, Torp"
    ],
    "city": [
      "Torp",
      "Torp",
      "Torp"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "TRD",
    "translations": [
      "Trondheim Airport, Værnes",
      "Trondheim Airport, Værnes",
      "Trondheim Airport, Værnes"
    ],
    "city": [
      "Trondheim",
      "Trondheim",
      "Trondheim"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "VDS",
    "translations": [
      "Vadsø Airport",
      "Vadsø Airport",
      "Vadsø Airport"
    ],
    "city": [
      "Vadsø",
      "Vadsø",
      "Vadsø"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "VRY",
    "translations": [
      "Værøy Heliport",
      "Værøy Heliport",
      "Værøy Heliport"
    ],
    "city": [
      "Værøy",
      "Værøy",
      "Værøy"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "SVG",
    "translations": [
      "Stavanger Airport, Sola",
      "Stavanger Airport, Sola",
      "Stavanger Airport, Sola"
    ],
    "city": [
      "Stavanger",
      "Stavanger",
      "Stavanger"
    ],
    "country": [
      "NO",
      "NO",
      "NO"
    ]
  },
  {
    "iata": "BZG",
    "translations": [
      "Bydgoszcz Ignacy Jan Paderewski Airport",
      "Bydgoszcz Ignacy Jan Paderewski Airport",
      "Bydgoszcz Ignacy Jan Paderewski Airport"
    ],
    "city": [
      "Bydgoszcz",
      "Bydgoszcz",
      "Bydgoszcz"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "GDN",
    "translations": [
      "Gdańsk Lech Wałęsa Airport",
      "Gdańsk Lech Wałęsa Airport",
      "Gdańsk Lech Wałęsa Airport"
    ],
    "city": [
      "Gdańsk",
      "Gdańsk",
      "Gdańsk"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "KRK",
    "translations": [
      "Kraków John Paul II International Airport",
      "Kraków John Paul II International Airport",
      "Kraków John Paul II International Airport"
    ],
    "city": [
      "Balice",
      "Balice",
      "Balice"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "KTW",
    "translations": [
      "Katowice Wojciech Korfanty International Airport",
      "Katowice Wojciech Korfanty International Airport",
      "Katowice Wojciech Korfanty International Airport"
    ],
    "city": [
      "Katowice",
      "Katowice",
      "Katowice"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "LUZ",
    "translations": [
      "Lublin Airport",
      "Lublin Airport",
      "Lublin Airport"
    ],
    "city": [
      "Lublin",
      "Lublin",
      "Lublin"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "LCJ",
    "translations": [
      "Łódź Władysław Reymont Airport",
      "Łódź Władysław Reymont Airport",
      "Łódź Władysław Reymont Airport"
    ],
    "city": [
      "Łódź",
      "Łódź",
      "Łódź"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "WMI",
    "translations": [
      "Modlin Airport",
      "Modlin Airport",
      "Modlin Airport"
    ],
    "city": [
      "Nowy Dwór Mazowiecki",
      "Nowy Dwór Mazowiecki",
      "Nowy Dwór Mazowiecki"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "POZ",
    "translations": [
      "Poznań-Ławica Airport",
      "Poznań-Ławica Airport",
      "Poznań-Ławica Airport"
    ],
    "city": [
      "Poznań",
      "Poznań",
      "Poznań"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "RDO",
    "translations": [
      "Warsaw Radom Airport",
      "Warsaw Radom Airport",
      "Warsaw Radom Airport"
    ],
    "city": [
      "Radom",
      "Radom",
      "Radom"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "RZE",
    "translations": [
      "Rzeszów-Jasionka Airport",
      "Rzeszów-Jasionka Airport",
      "Rzeszów-Jasionka Airport"
    ],
    "city": [
      "Jasionka",
      "Jasionka",
      "Jasionka"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "SZZ",
    "translations": [
      "Solidarity Szczecin–Goleniów Airport",
      "Solidarity Szczecin–Goleniów Airport",
      "Solidarity Szczecin–Goleniów Airport"
    ],
    "city": [
      "Glewice",
      "Glewice",
      "Glewice"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "SZY",
    "translations": [
      "Olsztyn-Mazury Airport",
      "Olsztyn-Mazury Airport",
      "Olsztyn-Mazury Airport"
    ],
    "city": [
      "Szymany",
      "Szymany",
      "Szymany"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "WAW",
    "translations": [
      "Warsaw Chopin Airport",
      "Warsaw Chopin Airport",
      "Warsaw Chopin Airport"
    ],
    "city": [
      "Warsaw",
      "Warsaw",
      "Warsaw"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "WRO",
    "translations": [
      "Copernicus Wrocław Airport",
      "Copernicus Wrocław Airport",
      "Copernicus Wrocław Airport"
    ],
    "city": [
      "Wrocław",
      "Wrocław",
      "Wrocław"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "IEG",
    "translations": [
      "Zielona Góra-Babimost Airport",
      "Zielona Góra-Babimost Airport",
      "Zielona Góra-Babimost Airport"
    ],
    "city": [
      "Nowe Kramsko",
      "Nowe Kramsko",
      "Nowe Kramsko"
    ],
    "country": [
      "PL",
      "PL",
      "PL"
    ]
  },
  {
    "iata": "ERT",
    "translations": [
      "Erdenet Airport",
      "Erdenet Airport",
      "Erdenet Airport"
    ],
    "city": [
      "Erdenet",
      "Erdenet",
      "Erdenet"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "RNB",
    "translations": [
      "Ronneby Airport",
      "Ronneby Airport",
      "Ronneby Airport"
    ],
    "city": [
      "Ronneby",
      "Ronneby",
      "Ronneby"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "GOT",
    "translations": [
      "Göteborg Landvetter Airport",
      "Göteborg Landvetter Airport",
      "Göteborg Landvetter Airport"
    ],
    "city": [
      "Göteborg",
      "Göteborg",
      "Göteborg"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "JKG",
    "translations": [
      "Jönköping Airport",
      "Jönköping Airport",
      "Jönköping Airport"
    ],
    "city": [
      "Jönköping",
      "Jönköping",
      "Jönköping"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "LDK",
    "translations": [
      "Lidköping-Hovby Airport",
      "Lidköping-Hovby Airport",
      "Lidköping-Hovby Airport"
    ],
    "city": [
      "Lidköping",
      "Lidköping",
      "Lidköping"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "GSE",
    "translations": [
      "Säve Airport",
      "Säve Airport",
      "Säve Airport"
    ],
    "city": [
      "Göteborg",
      "Göteborg",
      "Göteborg"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "KVB",
    "translations": [
      "Skövde Airport",
      "Skövde Airport",
      "Skövde Airport"
    ],
    "city": [
      "Skövde",
      "Skövde",
      "Skövde"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "THN",
    "translations": [
      "Trollhättan-Vänersborg Airport",
      "Trollhättan-Vänersborg Airport",
      "Trollhättan-Vänersborg Airport"
    ],
    "city": [
      "Trollhättan",
      "Trollhättan",
      "Trollhättan"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "KSK",
    "translations": [
      "Karlskoga Airport",
      "Karlskoga Airport",
      "Karlskoga Airport"
    ],
    "city": [
      "Karlskoga",
      "Karlskoga",
      "Karlskoga"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "MXX",
    "translations": [
      "Mora Airport",
      "Mora Airport",
      "Mora Airport"
    ],
    "city": [
      "Mora",
      "Mora",
      "Mora"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "NYO",
    "translations": [
      "Stockholm Skavsta Airport",
      "Stockholm Skavsta Airport",
      "Stockholm Skavsta Airport"
    ],
    "city": [
      "Nyköping",
      "Nyköping",
      "Nyköping"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "SCR",
    "translations": [
      "Scandinavian Mountains Airport",
      "Scandinavian Mountains Airport",
      "Scandinavian Mountains Airport"
    ],
    "city": [
      "Malung-Sälen",
      "Malung-Sälen",
      "Malung-Sälen"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "KID",
    "translations": [
      "Kristianstad Airport",
      "Kristianstad Airport",
      "Kristianstad Airport"
    ],
    "city": [
      "Kristianstad",
      "Kristianstad",
      "Kristianstad"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "OSK",
    "translations": [
      "Oskarshamn Airport",
      "Oskarshamn Airport",
      "Oskarshamn Airport"
    ],
    "city": [
      "Oskarshamn",
      "Oskarshamn",
      "Oskarshamn"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "KLR",
    "translations": [
      "Kalmar Airport",
      "Kalmar Airport",
      "Kalmar Airport"
    ],
    "city": [
      "Kalmar",
      "Kalmar",
      "Kalmar"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "MMX",
    "translations": [
      "Malmö Sturup Airport",
      "Malmö Sturup Airport",
      "Malmö Sturup Airport"
    ],
    "city": [
      "Malmö",
      "Malmö",
      "Malmö"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "HAD",
    "translations": [
      "Halmstad Airport",
      "Halmstad Airport",
      "Halmstad Airport"
    ],
    "city": [
      "Halmstad",
      "Halmstad",
      "Halmstad"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "VXO",
    "translations": [
      "Växjö Kronoberg Airport",
      "Växjö Kronoberg Airport",
      "Växjö Kronoberg Airport"
    ],
    "city": [
      "Växjö",
      "Växjö",
      "Växjö"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "EVG",
    "translations": [
      "Sveg Airport",
      "Sveg Airport",
      "Sveg Airport"
    ],
    "city": [
      "Sveg",
      "Sveg",
      "Sveg"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "GEV",
    "translations": [
      "Gällivare Airport",
      "Gällivare Airport",
      "Gällivare Airport"
    ],
    "city": [
      "Gällivare",
      "Gällivare",
      "Gällivare"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "KRF",
    "translations": [
      "Kramfors-Sollefteå Höga Kusten Airport",
      "Kramfors-Sollefteå Höga Kusten Airport",
      "Kramfors-Sollefteå Höga Kusten Airport"
    ],
    "city": [
      "Nyland",
      "Nyland",
      "Nyland"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "LYC",
    "translations": [
      "Lycksele Airport",
      "Lycksele Airport",
      "Lycksele Airport"
    ],
    "city": [
      "Lycksele",
      "Lycksele",
      "Lycksele"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "SDL",
    "translations": [
      "Sundsvall-Härnösand Airport",
      "Sundsvall-Härnösand Airport",
      "Sundsvall-Härnösand Airport"
    ],
    "city": [
      "Sundsvall/ Härnösand",
      "Sundsvall/ Härnösand",
      "Sundsvall/ Härnösand"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "OER",
    "translations": [
      "Örnsköldsvik Airport",
      "Örnsköldsvik Airport",
      "Örnsköldsvik Airport"
    ],
    "city": [
      "Örnsköldsvik",
      "Örnsköldsvik",
      "Örnsköldsvik"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "KRN",
    "translations": [
      "Kiruna Airport",
      "Kiruna Airport",
      "Kiruna Airport"
    ],
    "city": [
      "Kiruna",
      "Kiruna",
      "Kiruna"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "SFT",
    "translations": [
      "Skellefteå Airport",
      "Skellefteå Airport",
      "Skellefteå Airport"
    ],
    "city": [
      "Skellefteå",
      "Skellefteå",
      "Skellefteå"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "UME",
    "translations": [
      "Umeå Airport",
      "Umeå Airport",
      "Umeå Airport"
    ],
    "city": [
      "Umeå",
      "Umeå",
      "Umeå"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "VHM",
    "translations": [
      "Vilhelmina South Lapland Airport",
      "Vilhelmina South Lapland Airport",
      "Vilhelmina South Lapland Airport"
    ],
    "city": [
      "Vilhelmina",
      "Vilhelmina",
      "Vilhelmina"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "AJR",
    "translations": [
      "Arvidsjaur Airport",
      "Arvidsjaur Airport",
      "Arvidsjaur Airport"
    ],
    "city": [
      "Arvidsjaur",
      "Arvidsjaur",
      "Arvidsjaur"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "SOO",
    "translations": [
      "Söderhamn Airport",
      "Söderhamn Airport",
      "Söderhamn Airport"
    ],
    "city": [
      "Söderhamn",
      "Söderhamn",
      "Söderhamn"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "OSD",
    "translations": [
      "Åre Östersund Airport",
      "Åre Östersund Airport",
      "Åre Östersund Airport"
    ],
    "city": [
      "Östersund",
      "Östersund",
      "Östersund"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "ORB",
    "translations": [
      "Örebro Airport",
      "Örebro Airport",
      "Örebro Airport"
    ],
    "city": [
      "Örebro",
      "Örebro",
      "Örebro"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "HFS",
    "translations": [
      "Hagfors Airport",
      "Hagfors Airport",
      "Hagfors Airport"
    ],
    "city": [
      "Råda",
      "Råda",
      "Råda"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "KSD",
    "translations": [
      "Karlstad Airport",
      "Karlstad Airport",
      "Karlstad Airport"
    ],
    "city": [
      "Karlstad",
      "Karlstad",
      "Karlstad"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "VST",
    "translations": [
      "Stockholm Västerås Airport",
      "Stockholm Västerås Airport",
      "Stockholm Västerås Airport"
    ],
    "city": [
      "Stockholm / Västerås",
      "Stockholm / Västerås",
      "Stockholm / Västerås"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "LLA",
    "translations": [
      "Luleå Airport",
      "Luleå Airport",
      "Luleå Airport"
    ],
    "city": [
      "Luleå",
      "Luleå",
      "Luleå"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "ARN",
    "translations": [
      "Stockholm-Arlanda Airport",
      "Stockholm-Arlanda Airport",
      "Stockholm-Arlanda Airport"
    ],
    "city": [
      "Stockholm",
      "Stockholm",
      "Stockholm"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "BMA",
    "translations": [
      "Stockholm-Bromma Airport",
      "Stockholm-Bromma Airport",
      "Stockholm-Bromma Airport"
    ],
    "city": [
      "Stockholm",
      "Stockholm",
      "Stockholm"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "BLE",
    "translations": [
      "Dala Airport",
      "Dala Airport",
      "Dala Airport"
    ],
    "city": [
      "Borlange",
      "Borlange",
      "Borlange"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "HLF",
    "translations": [
      "Hultsfred Airport",
      "Hultsfred Airport",
      "Hultsfred Airport"
    ],
    "city": [
      "Hultsfred",
      "Hultsfred",
      "Hultsfred"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "GVX",
    "translations": [
      "Gävle Sandviken Airport",
      "Gävle Sandviken Airport",
      "Gävle Sandviken Airport"
    ],
    "city": [
      "Gävle / Sandviken",
      "Gävle / Sandviken",
      "Gävle / Sandviken"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "LPI",
    "translations": [
      "Linköping City Airport",
      "Linköping City Airport",
      "Linköping City Airport"
    ],
    "city": [
      "Linköping",
      "Linköping",
      "Linköping"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "NRK",
    "translations": [
      "Norrköping Airport",
      "Norrköping Airport",
      "Norrköping Airport"
    ],
    "city": [
      "Norrköping",
      "Norrköping",
      "Norrköping"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "TYF",
    "translations": [
      "Torsby Airport",
      "Torsby Airport",
      "Torsby Airport"
    ],
    "city": [
      "Torsby",
      "Torsby",
      "Torsby"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "EKT",
    "translations": [
      "Eskilstuna Airport",
      "Eskilstuna Airport",
      "Eskilstuna Airport"
    ],
    "city": [
      "Eskilstuna",
      "Eskilstuna",
      "Eskilstuna"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "VBY",
    "translations": [
      "Visby Airport",
      "Visby Airport",
      "Visby Airport"
    ],
    "city": [
      "Visby",
      "Visby",
      "Visby"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "VVK",
    "translations": [
      "Västervik Airport",
      "Västervik Airport",
      "Västervik Airport"
    ],
    "city": [
      "Västervik",
      "Västervik",
      "Västervik"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "AGH",
    "translations": [
      "Ängelholm-Helsingborg Airport",
      "Ängelholm-Helsingborg Airport",
      "Ängelholm-Helsingborg Airport"
    ],
    "city": [
      "Ängelholm",
      "Ängelholm",
      "Ängelholm"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "SQO",
    "translations": [
      "Storuman Airport",
      "Storuman Airport",
      "Storuman Airport"
    ],
    "city": [
      "Storuman",
      "Storuman",
      "Storuman"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "IDB",
    "translations": [
      "Idre Airport",
      "Idre Airport",
      "Idre Airport"
    ],
    "city": [
      "Idre",
      "Idre",
      "Idre"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "PJA",
    "translations": [
      "Pajala Airport",
      "Pajala Airport",
      "Pajala Airport"
    ],
    "city": [
      "Pajala",
      "Pajala",
      "Pajala"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "HMV",
    "translations": [
      "Hemavan Airport",
      "Hemavan Airport",
      "Hemavan Airport"
    ],
    "city": [
      "Hemavan",
      "Hemavan",
      "Hemavan"
    ],
    "country": [
      "SE",
      "SE",
      "SE"
    ]
  },
  {
    "iata": "GLC",
    "translations": [
      "Geladi Airport",
      "Geladi Airport",
      "Geladi Airport"
    ],
    "city": [
      "Geladi",
      "Geladi",
      "Geladi"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "SHC",
    "translations": [
      "Shire Inda Selassie Airport",
      "Shire Inda Selassie Airport",
      "Shire Inda Selassie Airport"
    ],
    "city": [
      "Shire Inda Selassie",
      "Shire Inda Selassie",
      "Shire Inda Selassie"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "SPM",
    "translations": [
      "Spangdahlem Air Base",
      "Spangdahlem Air Base",
      "Spangdahlem Air Base"
    ],
    "city": [
      "Trier",
      "Trier",
      "Trier"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "RMS",
    "translations": [
      "Ramstein Air Base",
      "Ramstein Air Base",
      "Ramstein Air Base"
    ],
    "city": [
      "Ramstein-Miesenbach",
      "Ramstein-Miesenbach",
      "Ramstein-Miesenbach"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "FRZ",
    "translations": [
      "Fritzlar Army Airfield",
      "Fritzlar Army Airfield",
      "Fritzlar Army Airfield"
    ],
    "city": [
      "Fritzlar",
      "Fritzlar",
      "Fritzlar"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "ILH",
    "translations": [
      "Illesheim Army Heliport",
      "Illesheim Army Heliport",
      "Illesheim Army Heliport"
    ],
    "city": [
      "Illesheim",
      "Illesheim",
      "Illesheim"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "KZG",
    "translations": [
      "Kitzingen Airfield",
      "Kitzingen Airfield",
      "Kitzingen Airfield"
    ],
    "city": [
      "Kitzingen",
      "Kitzingen",
      "Kitzingen"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "FCN",
    "translations": [
      "Sea-Airport Cuxhaven/Nordholz / Nordholz Naval Airbase",
      "Sea-Airport Cuxhaven/Nordholz / Nordholz Naval Airbase",
      "Sea-Airport Cuxhaven/Nordholz / Nordholz Naval Airbase"
    ],
    "city": [
      "Wurster Nordseeküste",
      "Wurster Nordseeküste",
      "Wurster Nordseeküste"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "GKE",
    "translations": [
      "Geilenkirchen Air Base",
      "Geilenkirchen Air Base",
      "Geilenkirchen Air Base"
    ],
    "city": [
      "Geilenkirchen",
      "Geilenkirchen",
      "Geilenkirchen"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "RLG",
    "translations": [
      "Rostock-Laage Airport",
      "Rostock-Laage Airport",
      "Rostock-Laage Airport"
    ],
    "city": [
      "Laage",
      "Laage",
      "Laage"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "WBG",
    "translations": [
      "Schleswig Air Base",
      "Schleswig Air Base",
      "Schleswig Air Base"
    ],
    "city": [
      "Jagel",
      "Jagel",
      "Jagel"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "WIE",
    "translations": [
      "Wiesbaden Army Airfield",
      "Wiesbaden Army Airfield",
      "Wiesbaden Army Airfield"
    ],
    "city": [
      "Wiesbaden",
      "Wiesbaden",
      "Wiesbaden"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "IGS",
    "translations": [
      "Ingolstadt Manching Airport",
      "Ingolstadt Manching Airport",
      "Ingolstadt Manching Airport"
    ],
    "city": [
      "Manching",
      "Manching",
      "Manching"
    ],
    "country": [
      "Germany",
      "Allemagne",
      "Deutschland"
    ]
  },
  {
    "iata": "LPX",
    "translations": [
      "Liepāja International Airport",
      "Liepāja International Airport",
      "Liepāja International Airport"
    ],
    "city": [
      "Liepāja",
      "Liepāja",
      "Liepāja"
    ],
    "country": [
      "LV",
      "LV",
      "LV"
    ]
  },
  {
    "iata": "RIX",
    "translations": [
      "Riga International Airport",
      "Riga International Airport",
      "Riga International Airport"
    ],
    "city": [
      "Riga",
      "Riga",
      "Riga"
    ],
    "country": [
      "LV",
      "LV",
      "LV"
    ]
  },
  {
    "iata": "VNT",
    "translations": [
      "Ventspils International Airport",
      "Ventspils International Airport",
      "Ventspils International Airport"
    ],
    "city": [
      "Ventspils",
      "Ventspils",
      "Ventspils"
    ],
    "country": [
      "LV",
      "LV",
      "LV"
    ]
  },
  {
    "iata": "EXI",
    "translations": [
      "Excursion Inlet Seaplane Base",
      "Excursion Inlet Seaplane Base",
      "Excursion Inlet Seaplane Base"
    ],
    "city": [
      "Excursion Inlet",
      "Excursion Inlet",
      "Excursion Inlet"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KUN",
    "translations": [
      "Kaunas International Airport",
      "Kaunas International Airport",
      "Kaunas International Airport"
    ],
    "city": [
      "Kaunas",
      "Kaunas",
      "Kaunas"
    ],
    "country": [
      "LT",
      "LT",
      "LT"
    ]
  },
  {
    "iata": "PLQ",
    "translations": [
      "Palanga International Airport",
      "Palanga International Airport",
      "Palanga International Airport"
    ],
    "city": [
      "Palanga",
      "Palanga",
      "Palanga"
    ],
    "country": [
      "LT",
      "LT",
      "LT"
    ]
  },
  {
    "iata": "PNV",
    "translations": [
      "Panevėžys Air Base",
      "Panevėžys Air Base",
      "Panevėžys Air Base"
    ],
    "city": [
      "Panevėžys",
      "Panevėžys",
      "Panevėžys"
    ],
    "country": [
      "LT",
      "LT",
      "LT"
    ]
  },
  {
    "iata": "SQQ",
    "translations": [
      "Šiauliai International Airport",
      "Šiauliai International Airport",
      "Šiauliai International Airport"
    ],
    "city": [
      "Šiauliai",
      "Šiauliai",
      "Šiauliai"
    ],
    "country": [
      "LT",
      "LT",
      "LT"
    ]
  },
  {
    "iata": "VNO",
    "translations": [
      "Vilnius International Airport",
      "Vilnius International Airport",
      "Vilnius International Airport"
    ],
    "city": [
      "Vilnius",
      "Vilnius",
      "Vilnius"
    ],
    "country": [
      "LT",
      "LT",
      "LT"
    ]
  },
  {
    "iata": "RGR",
    "translations": [
      "Ranger Municipal Airport",
      "Ranger Municipal Airport",
      "Ranger Municipal Airport"
    ],
    "city": [
      "Ranger",
      "Ranger",
      "Ranger"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ALJ",
    "translations": [
      "Alexander Bay Airport",
      "Alexander Bay Airport",
      "Alexander Bay Airport"
    ],
    "city": [
      "Alexander Bay",
      "Alexander Bay",
      "Alexander Bay"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "AGZ",
    "translations": [
      "Aggeneys Airport",
      "Aggeneys Airport",
      "Aggeneys Airport"
    ],
    "city": [
      "Aggeneys",
      "Aggeneys",
      "Aggeneys"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "ADY",
    "translations": [
      "Alldays Airport",
      "Alldays Airport",
      "Alldays Airport"
    ],
    "city": [
      "Alldays",
      "Alldays",
      "Alldays"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "BIY",
    "translations": [
      "Bisho Airport",
      "Bisho Airport",
      "Bisho Airport"
    ],
    "city": [
      "Bisho",
      "Bisho",
      "Bisho"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "BFN",
    "translations": [
      "Bram Fischer International Airport",
      "Bram Fischer International Airport",
      "Bram Fischer International Airport"
    ],
    "city": [
      "Bloemfontain",
      "Bloemfontain",
      "Bloemfontain"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "UTE",
    "translations": [
      "Bultfontein Airport",
      "Bultfontein Airport",
      "Bultfontein Airport"
    ],
    "city": [
      "Bultfontein",
      "Bultfontein",
      "Bultfontein"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "ASS",
    "translations": [
      "Arathusa Safari Lodge Airport",
      "Arathusa Safari Lodge Airport",
      "Arathusa Safari Lodge Airport"
    ],
    "city": [
      "Arathusa",
      "Arathusa",
      "Arathusa"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "CDO",
    "translations": [
      "Cradock Airport",
      "Cradock Airport",
      "Cradock Airport"
    ],
    "city": [
      "Cradock",
      "Cradock",
      "Cradock"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "CPT",
    "translations": [
      "Cape Town International Airport",
      "Cape Town International Airport",
      "Cape Town International Airport"
    ],
    "city": [
      "Cape Town",
      "Cape Town",
      "Cape Town"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "DUK",
    "translations": [
      "Mubatuba Airport",
      "Mubatuba Airport",
      "Mubatuba Airport"
    ],
    "city": [
      "Mubatuba",
      "Mubatuba",
      "Mubatuba"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "PZL",
    "translations": [
      "Zulu Inyala Airport",
      "Zulu Inyala Airport",
      "Zulu Inyala Airport"
    ],
    "city": [
      "Phinda",
      "Phinda",
      "Phinda"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "ELS",
    "translations": [
      "King Phalo Airport",
      "King Phalo Airport",
      "King Phalo Airport"
    ],
    "city": [
      "East London",
      "East London",
      "East London"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "EMG",
    "translations": [
      "Empangeni Airport",
      "Empangeni Airport",
      "Empangeni Airport"
    ],
    "city": [
      "Empangeni",
      "Empangeni",
      "Empangeni"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "ELL",
    "translations": [
      "Ellisras Matimba Airport",
      "Ellisras Matimba Airport",
      "Ellisras Matimba Airport"
    ],
    "city": [
      "Ellisras",
      "Ellisras",
      "Ellisras"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "FCB",
    "translations": [
      "Ficksburg Sentraoes Airport",
      "Ficksburg Sentraoes Airport",
      "Ficksburg Sentraoes Airport"
    ],
    "city": [
      "Ficksburg",
      "Ficksburg",
      "Ficksburg"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "GCJ",
    "translations": [
      "Grand Central Airport",
      "Grand Central Airport",
      "Grand Central Airport"
    ],
    "city": [
      "Midrand",
      "Midrand",
      "Midrand"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "GRJ",
    "translations": [
      "George Airport",
      "George Airport",
      "George Airport"
    ],
    "city": [
      "George",
      "George",
      "George"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "GIY",
    "translations": [
      "Giyani Airport",
      "Giyani Airport",
      "Giyani Airport"
    ],
    "city": [
      "Giyani",
      "Giyani",
      "Giyani"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "QRA",
    "translations": [
      "Rand Airport",
      "Rand Airport",
      "Rand Airport"
    ],
    "city": [
      "Johannesburg",
      "Johannesburg",
      "Johannesburg"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "HLW",
    "translations": [
      "Hluhluwe Airport",
      "Hluhluwe Airport",
      "Hluhluwe Airport"
    ],
    "city": [
      "Hluhluwe",
      "Hluhluwe",
      "Hluhluwe"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "HRS",
    "translations": [
      "Harrismith Airport",
      "Harrismith Airport",
      "Harrismith Airport"
    ],
    "city": [
      "Harrismith",
      "Harrismith",
      "Harrismith"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "HDS",
    "translations": [
      "Hoedspruit Air Force Base Airport",
      "Hoedspruit Air Force Base Airport",
      "Hoedspruit Air Force Base Airport"
    ],
    "city": [
      "Hoedspruit",
      "Hoedspruit",
      "Hoedspruit"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "KXE",
    "translations": [
      "P C Pelser Airport",
      "P C Pelser Airport",
      "P C Pelser Airport"
    ],
    "city": [
      "Klerksdorp",
      "Klerksdorp",
      "Klerksdorp"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "KIM",
    "translations": [
      "Kimberley Airport",
      "Kimberley Airport",
      "Kimberley Airport"
    ],
    "city": [
      "Kimberley",
      "Kimberley",
      "Kimberley"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "MQP",
    "translations": [
      "Kruger Mpumalanga International Airport",
      "Kruger Mpumalanga International Airport",
      "Kruger Mpumalanga International Airport"
    ],
    "city": [
      "Mpumalanga",
      "Mpumalanga",
      "Mpumalanga"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "KOF",
    "translations": [
      "Komatipoort Airport",
      "Komatipoort Airport",
      "Komatipoort Airport"
    ],
    "city": [
      "Komatipoort",
      "Komatipoort",
      "Komatipoort"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "KMH",
    "translations": [
      "Johan Pienaar Airport",
      "Johan Pienaar Airport",
      "Johan Pienaar Airport"
    ],
    "city": [
      "Kuruman",
      "Kuruman",
      "Kuruman"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "KLZ",
    "translations": [
      "Kleinsee Airport",
      "Kleinsee Airport",
      "Kleinsee Airport"
    ],
    "city": [
      "Kleinsee",
      "Kleinsee",
      "Kleinsee"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "HLA",
    "translations": [
      "Lanseria International Airport",
      "Lanseria International Airport",
      "Lanseria International Airport"
    ],
    "city": [
      "Johannesburg",
      "Johannesburg",
      "Johannesburg"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "LMR",
    "translations": [
      "Lime Acres Finsch Mine Airport",
      "Lime Acres Finsch Mine Airport",
      "Lime Acres Finsch Mine Airport"
    ],
    "city": [
      "Lime Acres",
      "Lime Acres",
      "Lime Acres"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "LDZ",
    "translations": [
      "Londolozi Airport",
      "Londolozi Airport",
      "Londolozi Airport"
    ],
    "city": [
      "Londolozi",
      "Londolozi",
      "Londolozi"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "DUR",
    "translations": [
      "King Shaka International Airport",
      "King Shaka International Airport",
      "King Shaka International Airport"
    ],
    "city": [
      "Durban",
      "Durban",
      "Durban"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "LCD",
    "translations": [
      "Louis Trichardt Airport",
      "Louis Trichardt Airport",
      "Louis Trichardt Airport"
    ],
    "city": [
      "Louis Trichardt",
      "Louis Trichardt",
      "Louis Trichardt"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "SDB",
    "translations": [
      "Langebaanweg Airport",
      "Langebaanweg Airport",
      "Langebaanweg Airport"
    ],
    "city": [
      "Langebaanweg",
      "Langebaanweg",
      "Langebaanweg"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "LAY",
    "translations": [
      "Ladysmith Airport",
      "Ladysmith Airport",
      "Ladysmith Airport"
    ],
    "city": [
      "Ladysmith",
      "Ladysmith",
      "Ladysmith"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "AAM",
    "translations": [
      "Malamala Airport",
      "Malamala Airport",
      "Malamala Airport"
    ],
    "city": [
      "Malamala",
      "Malamala",
      "Malamala"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "MGH",
    "translations": [
      "Margate Airport",
      "Margate Airport",
      "Margate Airport"
    ],
    "city": [
      "Margate",
      "Margate",
      "Margate"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "MEZ",
    "translations": [
      "Musina(Messina) Airport",
      "Musina(Messina) Airport",
      "Musina(Messina) Airport"
    ],
    "city": [
      "Musina",
      "Musina",
      "Musina"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "MBD",
    "translations": [
      "Mmabatho International Airport",
      "Mmabatho International Airport",
      "Mmabatho International Airport"
    ],
    "city": [
      "Mafeking",
      "Mafeking",
      "Mafeking"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "LLE",
    "translations": [
      "Malelane Airport",
      "Malelane Airport",
      "Malelane Airport"
    ],
    "city": [
      "Malelane",
      "Malelane",
      "Malelane"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "MZY",
    "translations": [
      "Mossel Bay Airport",
      "Mossel Bay Airport",
      "Mossel Bay Airport"
    ],
    "city": [
      "Mossel Bay",
      "Mossel Bay",
      "Mossel Bay"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "MZQ",
    "translations": [
      "Mkuze Airport",
      "Mkuze Airport",
      "Mkuze Airport"
    ],
    "city": [
      "Mkuze",
      "Mkuze",
      "Mkuze"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "NCS",
    "translations": [
      "Newcastle Airport",
      "Newcastle Airport",
      "Newcastle Airport"
    ],
    "city": [
      "Newcastle",
      "Newcastle",
      "Newcastle"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "NGL",
    "translations": [
      "Ngala Airport",
      "Ngala Airport",
      "Ngala Airport"
    ],
    "city": [
      "Ngala",
      "Ngala",
      "Ngala"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "NLP",
    "translations": [
      "Nelspruit Airport",
      "Nelspruit Airport",
      "Nelspruit Airport"
    ],
    "city": [
      "Nelspruit",
      "Nelspruit",
      "Nelspruit"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "OVG",
    "translations": [
      "Overberg Airport",
      "Overberg Airport",
      "Overberg Airport"
    ],
    "city": [
      "Overberg",
      "Overberg",
      "Overberg"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "OUH",
    "translations": [
      "Oudtshoorn Airport",
      "Oudtshoorn Airport",
      "Oudtshoorn Airport"
    ],
    "city": [
      "Oudtshoorn",
      "Oudtshoorn",
      "Oudtshoorn"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "JNB",
    "translations": [
      "O.R. Tambo International Airport",
      "O.R. Tambo International Airport",
      "O.R. Tambo International Airport"
    ],
    "city": [
      "Johannesburg",
      "Johannesburg",
      "Johannesburg"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "AFD",
    "translations": [
      "Port Alfred Airport",
      "Port Alfred Airport",
      "Port Alfred Airport"
    ],
    "city": [
      "Port Alfred",
      "Port Alfred",
      "Port Alfred"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "PLZ",
    "translations": [
      "Chief Dawid Stuurman International Airport",
      "Chief Dawid Stuurman International Airport",
      "Chief Dawid Stuurman International Airport"
    ],
    "city": [
      "Gqeberha (Port Elizabeth)",
      "Gqeberha (Port Elizabeth)",
      "Gqeberha (Port Elizabeth)"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "PBZ",
    "translations": [
      "Plettenberg Bay Airport",
      "Plettenberg Bay Airport",
      "Plettenberg Bay Airport"
    ],
    "city": [
      "Plettenberg Bay",
      "Plettenberg Bay",
      "Plettenberg Bay"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "PHW",
    "translations": [
      "Hendrik Van Eck Airport",
      "Hendrik Van Eck Airport",
      "Hendrik Van Eck Airport"
    ],
    "city": [
      "Phalaborwa",
      "Phalaborwa",
      "Phalaborwa"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "JOH",
    "translations": [
      "Port St Johns Airport",
      "Port St Johns Airport",
      "Port St Johns Airport"
    ],
    "city": [
      "Port St Johns",
      "Port St Johns",
      "Port St Johns"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "PRK",
    "translations": [
      "Prieska Airport",
      "Prieska Airport",
      "Prieska Airport"
    ],
    "city": [
      "Prieska",
      "Prieska",
      "Prieska"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "PZB",
    "translations": [
      "Pietermaritzburg Airport",
      "Pietermaritzburg Airport",
      "Pietermaritzburg Airport"
    ],
    "city": [
      "Pietermaritzburg",
      "Pietermaritzburg",
      "Pietermaritzburg"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "NTY",
    "translations": [
      "Pilanesberg International Airport",
      "Pilanesberg International Airport",
      "Pilanesberg International Airport"
    ],
    "city": [
      "Pilanesberg",
      "Pilanesberg",
      "Pilanesberg"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "PTG",
    "translations": [
      "Polokwane International Airport",
      "Polokwane International Airport",
      "Polokwane International Airport"
    ],
    "city": [
      "Polokwane",
      "Polokwane",
      "Polokwane"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "PCF",
    "translations": [
      "Potchefstroom Airport",
      "Potchefstroom Airport",
      "Potchefstroom Airport"
    ],
    "city": [
      "Potchefstroom",
      "Potchefstroom",
      "Potchefstroom"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "UTW",
    "translations": [
      "Queenstown Airport",
      "Queenstown Airport",
      "Queenstown Airport"
    ],
    "city": [
      "Queenstown",
      "Queenstown",
      "Queenstown"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "RCB",
    "translations": [
      "Richards Bay Airport",
      "Richards Bay Airport",
      "Richards Bay Airport"
    ],
    "city": [
      "Richards Bay",
      "Richards Bay",
      "Richards Bay"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "RVO",
    "translations": [
      "Reivilo Airport",
      "Reivilo Airport",
      "Reivilo Airport"
    ],
    "city": [
      "Reivilo",
      "Reivilo",
      "Reivilo"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "ROD",
    "translations": [
      "Robertson Airport",
      "Robertson Airport",
      "Robertson Airport"
    ],
    "city": [
      "Robertson",
      "Robertson",
      "Robertson"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "SBU",
    "translations": [
      "Springbok Airport",
      "Springbok Airport",
      "Springbok Airport"
    ],
    "city": [
      "Springbok",
      "Springbok",
      "Springbok"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "ZEC",
    "translations": [
      "Secunda Airport",
      "Secunda Airport",
      "Secunda Airport"
    ],
    "city": [
      "Secunda",
      "Secunda",
      "Secunda"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "GSS",
    "translations": [
      "Sabi Sabi Airport",
      "Sabi Sabi Airport",
      "Sabi Sabi Airport"
    ],
    "city": [
      "Belfast",
      "Belfast",
      "Belfast"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "SIS",
    "translations": [
      "Sishen Airport",
      "Sishen Airport",
      "Sishen Airport"
    ],
    "city": [
      "Sishen",
      "Sishen",
      "Sishen"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "SZK",
    "translations": [
      "Skukuza Airport",
      "Skukuza Airport",
      "Skukuza Airport"
    ],
    "city": [
      "Skukuza",
      "Skukuza",
      "Skukuza"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "THY",
    "translations": [
      "Thohoyandou Airport",
      "Thohoyandou Airport",
      "Thohoyandou Airport"
    ],
    "city": [
      "Thohoyandou",
      "Thohoyandou",
      "Thohoyandou"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "TCU",
    "translations": [
      "Thaba Nchu Tar Airport",
      "Thaba Nchu Tar Airport",
      "Thaba Nchu Tar Airport"
    ],
    "city": [
      "Homeward",
      "Homeward",
      "Homeward"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "LTA",
    "translations": [
      "Tzaneen Airport",
      "Tzaneen Airport",
      "Tzaneen Airport"
    ],
    "city": [
      "Tzaneen",
      "Tzaneen",
      "Tzaneen"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "ULD",
    "translations": [
      "Prince Mangosuthu Buthelezi Airport",
      "Prince Mangosuthu Buthelezi Airport",
      "Prince Mangosuthu Buthelezi Airport"
    ],
    "city": [
      "Ulundi",
      "Ulundi",
      "Ulundi"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "UTN",
    "translations": [
      "Pierre Van Ryneveld Airport",
      "Pierre Van Ryneveld Airport",
      "Pierre Van Ryneveld Airport"
    ],
    "city": [
      "Upington",
      "Upington",
      "Upington"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "ULX",
    "translations": [
      "Ulusaba Airport",
      "Ulusaba Airport",
      "Ulusaba Airport"
    ],
    "city": [
      "Ulusaba",
      "Ulusaba",
      "Ulusaba"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "UTT",
    "translations": [
      "K. D. Matanzima Airport",
      "K. D. Matanzima Airport",
      "K. D. Matanzima Airport"
    ],
    "city": [
      "Mthatha",
      "Mthatha",
      "Mthatha"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "VRU",
    "translations": [
      "Vryburg Airport",
      "Vryburg Airport",
      "Vryburg Airport"
    ],
    "city": [
      "Vyrburg",
      "Vyrburg",
      "Vyrburg"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "VIR",
    "translations": [
      "Virginia Airport",
      "Virginia Airport",
      "Virginia Airport"
    ],
    "city": [
      "Durban",
      "Durban",
      "Durban"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "VRE",
    "translations": [
      "Vredendal Airport",
      "Vredendal Airport",
      "Vredendal Airport"
    ],
    "city": [
      "Vredendal",
      "Vredendal",
      "Vredendal"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "VYD",
    "translations": [
      "Vryheid Airport",
      "Vryheid Airport",
      "Vryheid Airport"
    ],
    "city": [
      "Vryheid",
      "Vryheid",
      "Vryheid"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "PRY",
    "translations": [
      "Wonderboom Airport",
      "Wonderboom Airport",
      "Wonderboom Airport"
    ],
    "city": [
      "Pretoria",
      "Pretoria",
      "Pretoria"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "WKF",
    "translations": [
      "Waterkloof Air Force Base",
      "Waterkloof Air Force Base",
      "Waterkloof Air Force Base"
    ],
    "city": [
      "Pretoria",
      "Pretoria",
      "Pretoria"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "WEL",
    "translations": [
      "Welkom Airport",
      "Welkom Airport",
      "Welkom Airport"
    ],
    "city": [
      "Welkom",
      "Welkom",
      "Welkom"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "FRW",
    "translations": [
      "P G Matante Intl",
      "P G Matante Intl",
      "P G Matante Intl"
    ],
    "city": [
      "Francistown",
      "Francistown",
      "Francistown"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "GNZ",
    "translations": [
      "Ghanzi Airport",
      "Ghanzi Airport",
      "Ghanzi Airport"
    ],
    "city": [
      "Ghanzi",
      "Ghanzi",
      "Ghanzi"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "JWA",
    "translations": [
      "Jwaneng Airport",
      "Jwaneng Airport",
      "Jwaneng Airport"
    ],
    "city": [
      "Jwaneng",
      "Jwaneng",
      "Jwaneng"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "BBK",
    "translations": [
      "Kasane Airport",
      "Kasane Airport",
      "Kasane Airport"
    ],
    "city": [
      "Kasane",
      "Kasane",
      "Kasane"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "KHW",
    "translations": [
      "Khwai River Lodge Airport",
      "Khwai River Lodge Airport",
      "Khwai River Lodge Airport"
    ],
    "city": [
      "Khwai River Lodge",
      "Khwai River Lodge",
      "Khwai River Lodge"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "LOQ",
    "translations": [
      "Lobatse Airport",
      "Lobatse Airport",
      "Lobatse Airport"
    ],
    "city": [
      "Lobatse",
      "Lobatse",
      "Lobatse"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "MUB",
    "translations": [
      "Maun Airport",
      "Maun Airport",
      "Maun Airport"
    ],
    "city": [
      "Maun",
      "Maun",
      "Maun"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "ORP",
    "translations": [
      "Orapa Airport",
      "Orapa Airport",
      "Orapa Airport"
    ],
    "city": [
      "Orapa",
      "Orapa",
      "Orapa"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "GBE",
    "translations": [
      "Sir Seretse Khama International Airport",
      "Sir Seretse Khama International Airport",
      "Sir Seretse Khama International Airport"
    ],
    "city": [
      "Gaborone",
      "Gaborone",
      "Gaborone"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "SXN",
    "translations": [
      "Sua Pan Airport",
      "Sua Pan Airport",
      "Sua Pan Airport"
    ],
    "city": [
      "Sowa",
      "Sowa",
      "Sowa"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "PKW",
    "translations": [
      "Selebi Phikwe Airport",
      "Selebi Phikwe Airport",
      "Selebi Phikwe Airport"
    ],
    "city": [
      "Selebi Phikwe",
      "Selebi Phikwe",
      "Selebi Phikwe"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "SVT",
    "translations": [
      "Savuti Airport",
      "Savuti Airport",
      "Savuti Airport"
    ],
    "city": [
      "Savuti",
      "Savuti",
      "Savuti"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "SWX",
    "translations": [
      "Shakawe Airport",
      "Shakawe Airport",
      "Shakawe Airport"
    ],
    "city": [
      "Shakawe",
      "Shakawe",
      "Shakawe"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "TLD",
    "translations": [
      "Tuli Lodge Airport",
      "Tuli Lodge Airport",
      "Tuli Lodge Airport"
    ],
    "city": [
      "Tuli Lodge",
      "Tuli Lodge",
      "Tuli Lodge"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "TBY",
    "translations": [
      "Tshabong Airport",
      "Tshabong Airport",
      "Tshabong Airport"
    ],
    "city": [
      "Tshabong",
      "Tshabong",
      "Tshabong"
    ],
    "country": [
      "BW",
      "BW",
      "BW"
    ]
  },
  {
    "iata": "BZV",
    "translations": [
      "Maya-Maya Airport",
      "Maya-Maya Airport",
      "Maya-Maya Airport"
    ],
    "city": [
      "Brazzaville",
      "Brazzaville",
      "Brazzaville"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "DJM",
    "translations": [
      "Djambala Airport",
      "Djambala Airport",
      "Djambala Airport"
    ],
    "city": [
      "Djambala",
      "Djambala",
      "Djambala"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "KNJ",
    "translations": [
      "Kindamba Airport",
      "Kindamba Airport",
      "Kindamba Airport"
    ],
    "city": [
      "Kindamba",
      "Kindamba",
      "Kindamba"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "LCO",
    "translations": [
      "Lague Airport",
      "Lague Airport",
      "Lague Airport"
    ],
    "city": [
      "Lague",
      "Lague",
      "Lague"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "MUY",
    "translations": [
      "Mouyondzi Airport",
      "Mouyondzi Airport",
      "Mouyondzi Airport"
    ],
    "city": [
      "Mouyondzi",
      "Mouyondzi",
      "Mouyondzi"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "SIB",
    "translations": [
      "Sibiti Airport",
      "Sibiti Airport",
      "Sibiti Airport"
    ],
    "city": [
      "Sibiti",
      "Sibiti",
      "Sibiti"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "NKY",
    "translations": [
      "Yokangassi Airport",
      "Yokangassi Airport",
      "Yokangassi Airport"
    ],
    "city": [
      "Nkayi",
      "Nkayi",
      "Nkayi"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "ANJ",
    "translations": [
      "Zanaga Airport",
      "Zanaga Airport",
      "Zanaga Airport"
    ],
    "city": [
      "Zanaga",
      "Zanaga",
      "Zanaga"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "MSX",
    "translations": [
      "Mossendjo Airport",
      "Mossendjo Airport",
      "Mossendjo Airport"
    ],
    "city": [
      "Mossendjo",
      "Mossendjo",
      "Mossendjo"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "BOE",
    "translations": [
      "Boundji Airport",
      "Boundji Airport",
      "Boundji Airport"
    ],
    "city": [
      "Boundji",
      "Boundji",
      "Boundji"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "OLL",
    "translations": [
      "Oyo Ollombo Airport",
      "Oyo Ollombo Airport",
      "Oyo Ollombo Airport"
    ],
    "city": [
      "Oyo",
      "Oyo",
      "Oyo"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "EWO",
    "translations": [
      "Ewo Airport",
      "Ewo Airport",
      "Ewo Airport"
    ],
    "city": [
      "Ewo",
      "Ewo",
      "Ewo"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "GMM",
    "translations": [
      "Gamboma Airport",
      "Gamboma Airport",
      "Gamboma Airport"
    ],
    "city": [
      "Gamboma",
      "Gamboma",
      "Gamboma"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "ION",
    "translations": [
      "Impfondo Airport",
      "Impfondo Airport",
      "Impfondo Airport"
    ],
    "city": [
      "Impfondo",
      "Impfondo",
      "Impfondo"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "KEE",
    "translations": [
      "Kelle Airport",
      "Kelle Airport",
      "Kelle Airport"
    ],
    "city": [
      "Kelle",
      "Kelle",
      "Kelle"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "MKJ",
    "translations": [
      "Makoua Airport",
      "Makoua Airport",
      "Makoua Airport"
    ],
    "city": [
      "Makoua",
      "Makoua",
      "Makoua"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "FTX",
    "translations": [
      "Owando Airport",
      "Owando Airport",
      "Owando Airport"
    ],
    "city": [
      "Owando",
      "Owando",
      "Owando"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "SOE",
    "translations": [
      "Souanke Airport",
      "Souanke Airport",
      "Souanke Airport"
    ],
    "city": [
      "Souanke",
      "Souanke",
      "Souanke"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "BTB",
    "translations": [
      "Betou Airport",
      "Betou Airport",
      "Betou Airport"
    ],
    "city": [
      "Betou",
      "Betou",
      "Betou"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "OUE",
    "translations": [
      "Ouesso Airport",
      "Ouesso Airport",
      "Ouesso Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "KMK",
    "translations": [
      "Makabana Airport",
      "Makabana Airport",
      "Makabana Airport"
    ],
    "city": [
      "Makabana",
      "Makabana",
      "Makabana"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "DIS",
    "translations": [
      "Ngot Nzoungou Airport",
      "Ngot Nzoungou Airport",
      "Ngot Nzoungou Airport"
    ],
    "city": [
      "Dolisie",
      "Dolisie",
      "Dolisie"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "PNR",
    "translations": [
      "Antonio Agostinho-Neto International Airport",
      "Antonio Agostinho-Neto International Airport",
      "Antonio Agostinho-Neto International Airport"
    ],
    "city": [
      "Pointe Noire",
      "Pointe Noire",
      "Pointe Noire"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "MTS",
    "translations": [
      "Matsapha Airport",
      "Matsapha Airport",
      "Matsapha Airport"
    ],
    "city": [
      "Manzini",
      "Manzini",
      "Manzini"
    ],
    "country": [
      "SZ",
      "SZ",
      "SZ"
    ]
  },
  {
    "iata": "SHO",
    "translations": [
      "King Mswati III International Airport",
      "King Mswati III International Airport",
      "King Mswati III International Airport"
    ],
    "city": [
      "Mpaka",
      "Mpaka",
      "Mpaka"
    ],
    "country": [
      "SZ",
      "SZ",
      "SZ"
    ]
  },
  {
    "iata": "CRF",
    "translations": [
      "Carnot Airport",
      "Carnot Airport",
      "Carnot Airport"
    ],
    "city": [
      "Carnot",
      "Carnot",
      "Carnot"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "BGF",
    "translations": [
      "Bangui M'Poko International Airport",
      "Bangui M'Poko International Airport",
      "Bangui M'Poko International Airport"
    ],
    "city": [
      "Bangui",
      "Bangui",
      "Bangui"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "BGU",
    "translations": [
      "Bangassou Airport",
      "Bangassou Airport",
      "Bangassou Airport"
    ],
    "city": [
      "Bangassou",
      "Bangassou",
      "Bangassou"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "IRO",
    "translations": [
      "Birao Airport",
      "Birao Airport",
      "Birao Airport"
    ],
    "city": [
      "Birao",
      "Birao",
      "Birao"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "BBY",
    "translations": [
      "Bambari Airport",
      "Bambari Airport",
      "Bambari Airport"
    ],
    "city": [
      "Bambari",
      "Bambari",
      "Bambari"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "NDL",
    "translations": [
      "N'Délé Airport",
      "N'Délé Airport",
      "N'Délé Airport"
    ],
    "city": [
      "N'Délé",
      "N'Délé",
      "N'Délé"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "BOP",
    "translations": [
      "Bouar Airport",
      "Bouar Airport",
      "Bouar Airport"
    ],
    "city": [
      "Bouar",
      "Bouar",
      "Bouar"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "BIV",
    "translations": [
      "Bria Airport",
      "Bria Airport",
      "Bria Airport"
    ],
    "city": [
      "Bria",
      "Bria",
      "Bria"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "BSN",
    "translations": [
      "Bossangoa Airport",
      "Bossangoa Airport",
      "Bossangoa Airport"
    ],
    "city": [
      "Bossangoa",
      "Bossangoa",
      "Bossangoa"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "BBT",
    "translations": [
      "Berbérati Airport",
      "Berbérati Airport",
      "Berbérati Airport"
    ],
    "city": [
      "Berbérati",
      "Berbérati",
      "Berbérati"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "ODA",
    "translations": [
      "Ouadda Airport",
      "Ouadda Airport",
      "Ouadda Airport"
    ],
    "city": [
      "Ouadda",
      "Ouadda",
      "Ouadda"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "AIG",
    "translations": [
      "Yalinga Airport",
      "Yalinga Airport",
      "Yalinga Airport"
    ],
    "city": [
      "Yalinga",
      "Yalinga",
      "Yalinga"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "IMO",
    "translations": [
      "Zemio Airport",
      "Zemio Airport",
      "Zemio Airport"
    ],
    "city": [
      "Zemio",
      "Zemio",
      "Zemio"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "MKI",
    "translations": [
      "M'Boki Airport",
      "M'Boki Airport",
      "M'Boki Airport"
    ],
    "city": [
      "Mboki",
      "Mboki",
      "Mboki"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "BTG",
    "translations": [
      "Batangafo Airport",
      "Batangafo Airport",
      "Batangafo Airport"
    ],
    "city": [
      "Batangafo",
      "Batangafo",
      "Batangafo"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "GDI",
    "translations": [
      "Gordil Airport",
      "Gordil Airport",
      "Gordil Airport"
    ],
    "city": [
      "Melle",
      "Melle",
      "Melle"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "BMF",
    "translations": [
      "Bakouma Airport",
      "Bakouma Airport",
      "Bakouma Airport"
    ],
    "city": [
      "Bakouma",
      "Bakouma",
      "Bakouma"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "ODJ",
    "translations": [
      "Ouanda Djallé Airport",
      "Ouanda Djallé Airport",
      "Ouanda Djallé Airport"
    ],
    "city": [
      "Ouanda Djallé",
      "Ouanda Djallé",
      "Ouanda Djallé"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "RFA",
    "translations": [
      "Rafaï Airport",
      "Rafaï Airport",
      "Rafaï Airport"
    ],
    "city": [
      "Rafaï",
      "Rafaï",
      "Rafaï"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "BCF",
    "translations": [
      "Bouca Airport",
      "Bouca Airport",
      "Bouca Airport"
    ],
    "city": [
      "Bouca",
      "Bouca",
      "Bouca"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "BOZ",
    "translations": [
      "Bozoum Airport",
      "Bozoum Airport",
      "Bozoum Airport"
    ],
    "city": [
      "Bozoum",
      "Bozoum",
      "Bozoum"
    ],
    "country": [
      "CF",
      "CF",
      "CF"
    ]
  },
  {
    "iata": "NBN",
    "translations": [
      "Annobón Airport",
      "Annobón Airport",
      "Annobón Airport"
    ],
    "city": [
      "San Antonio de Palé",
      "San Antonio de Palé",
      "San Antonio de Palé"
    ],
    "country": [
      "GQ",
      "GQ",
      "GQ"
    ]
  },
  {
    "iata": "BSG",
    "translations": [
      "Bata Airport",
      "Bata Airport",
      "Bata Airport"
    ],
    "city": [
      "Bata",
      "Bata",
      "Bata"
    ],
    "country": [
      "GQ",
      "GQ",
      "GQ"
    ]
  },
  {
    "iata": "GEM",
    "translations": [
      "President Obiang Nguema International Airport",
      "President Obiang Nguema International Airport",
      "President Obiang Nguema International Airport"
    ],
    "city": [
      "Mengomeyén",
      "Mengomeyén",
      "Mengomeyén"
    ],
    "country": [
      "GQ",
      "GQ",
      "GQ"
    ]
  },
  {
    "iata": "SSG",
    "translations": [
      "Malabo Airport",
      "Malabo Airport",
      "Malabo Airport"
    ],
    "city": [
      "Malabo",
      "Malabo",
      "Malabo"
    ],
    "country": [
      "GQ",
      "GQ",
      "GQ"
    ]
  },
  {
    "iata": "ASI",
    "translations": [
      "RAF Ascension Island",
      "RAF Ascension Island",
      "RAF Ascension Island"
    ],
    "city": [
      "Cat Hill",
      "Cat Hill",
      "Cat Hill"
    ],
    "country": [
      "SH",
      "SH",
      "SH"
    ]
  },
  {
    "iata": "HLE",
    "translations": [
      "Saint Helena Airport",
      "Saint Helena Airport",
      "Saint Helena Airport"
    ],
    "city": [
      "Longwood",
      "Longwood",
      "Longwood"
    ],
    "country": [
      "SH",
      "SH",
      "SH"
    ]
  },
  {
    "iata": "MRU",
    "translations": [
      "Sir Seewoosagur Ramgoolam International Airport",
      "Sir Seewoosagur Ramgoolam International Airport",
      "Sir Seewoosagur Ramgoolam International Airport"
    ],
    "city": [
      "Plaine Magnien",
      "Plaine Magnien",
      "Plaine Magnien"
    ],
    "country": [
      "MU",
      "MU",
      "MU"
    ]
  },
  {
    "iata": "RRG",
    "translations": [
      "Sir Charles Gaetan Duval Airport",
      "Sir Charles Gaetan Duval Airport",
      "Sir Charles Gaetan Duval Airport"
    ],
    "city": [
      "Port Mathurin",
      "Port Mathurin",
      "Port Mathurin"
    ],
    "country": [
      "MU",
      "MU",
      "MU"
    ]
  },
  {
    "iata": "KVU",
    "translations": [
      "Korolevu Seaplane Base",
      "Korolevu Seaplane Base",
      "Korolevu Seaplane Base"
    ],
    "city": [
      "Korolevu",
      "Korolevu",
      "Korolevu"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "NKW",
    "translations": [
      "Diego Garcia Naval Support Facility",
      "Diego Garcia Naval Support Facility",
      "Diego Garcia Naval Support Facility"
    ],
    "city": [
      "Diego Garcia",
      "Diego Garcia",
      "Diego Garcia"
    ],
    "country": [
      "IO",
      "IO",
      "IO"
    ]
  },
  {
    "iata": "KBI",
    "translations": [
      "Kribi Airport",
      "Kribi Airport",
      "Kribi Airport"
    ],
    "city": [
      "Kribi",
      "Kribi",
      "Kribi"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "TKC",
    "translations": [
      "Tiko Airport",
      "Tiko Airport",
      "Tiko Airport"
    ],
    "city": [
      "Tiko",
      "Tiko",
      "Tiko"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "DLA",
    "translations": [
      "Douala International Airport",
      "Douala International Airport",
      "Douala International Airport"
    ],
    "city": [
      "Douala",
      "Douala",
      "Douala"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "MMF",
    "translations": [
      "Mamfe Airport",
      "Mamfe Airport",
      "Mamfe Airport"
    ],
    "city": [
      "Mamfe",
      "Mamfe",
      "Mamfe"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "BLC",
    "translations": [
      "Bali Airport",
      "Bali Airport",
      "Bali Airport"
    ],
    "city": [
      "Bali",
      "Bali",
      "Bali"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "KLE",
    "translations": [
      "Kaélé Airport",
      "Kaélé Airport",
      "Kaélé Airport"
    ],
    "city": [
      "Kaélé",
      "Kaélé",
      "Kaélé"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "OUR",
    "translations": [
      "Batouri Airport",
      "Batouri Airport",
      "Batouri Airport"
    ],
    "city": [
      "Batouri",
      "Batouri",
      "Batouri"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "GXX",
    "translations": [
      "Yagoua Airport",
      "Yagoua Airport",
      "Yagoua Airport"
    ],
    "city": [
      "Yagoua",
      "Yagoua",
      "Yagoua"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "MVR",
    "translations": [
      "Salak Airport",
      "Salak Airport",
      "Salak Airport"
    ],
    "city": [
      "Maroua",
      "Maroua",
      "Maroua"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "FOM",
    "translations": [
      "Foumban Nkounja Airport",
      "Foumban Nkounja Airport",
      "Foumban Nkounja Airport"
    ],
    "city": [
      "Foumban",
      "Foumban",
      "Foumban"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "NGE",
    "translations": [
      "N'Gaoundéré Airport",
      "N'Gaoundéré Airport",
      "N'Gaoundéré Airport"
    ],
    "city": [
      "N'Gaoundéré",
      "N'Gaoundéré",
      "N'Gaoundéré"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "BTA",
    "translations": [
      "Bertoua Airport",
      "Bertoua Airport",
      "Bertoua Airport"
    ],
    "city": [
      "Bertoua",
      "Bertoua",
      "Bertoua"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "GOU",
    "translations": [
      "Garoua International Airport",
      "Garoua International Airport",
      "Garoua International Airport"
    ],
    "city": [
      "Garoua",
      "Garoua",
      "Garoua"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "DSC",
    "translations": [
      "Dschang Airport",
      "Dschang Airport",
      "Dschang Airport"
    ],
    "city": [
      "Dschang",
      "Dschang",
      "Dschang"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "BFX",
    "translations": [
      "Bafoussam Airport",
      "Bafoussam Airport",
      "Bafoussam Airport"
    ],
    "city": [
      "Bafoussam",
      "Bafoussam",
      "Bafoussam"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "BPC",
    "translations": [
      "Bamenda Airport",
      "Bamenda Airport",
      "Bamenda Airport"
    ],
    "city": [
      "Bamenda",
      "Bamenda",
      "Bamenda"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "EBW",
    "translations": [
      "Ebolowa Airport",
      "Ebolowa Airport",
      "Ebolowa Airport"
    ],
    "city": [
      "Ebolowa",
      "Ebolowa",
      "Ebolowa"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "YAO",
    "translations": [
      "Yaoundé Airport",
      "Yaoundé Airport",
      "Yaoundé Airport"
    ],
    "city": [
      "Yaoundé",
      "Yaoundé",
      "Yaoundé"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "NSI",
    "translations": [
      "Yaoundé Nsimalen International Airport",
      "Yaoundé Nsimalen International Airport",
      "Yaoundé Nsimalen International Airport"
    ],
    "city": [
      "Yaoundé",
      "Yaoundé",
      "Yaoundé"
    ],
    "country": [
      "CM",
      "CM",
      "CM"
    ]
  },
  {
    "iata": "MMQ",
    "translations": [
      "Mbala Airport",
      "Mbala Airport",
      "Mbala Airport"
    ],
    "city": [
      "Mbala",
      "Mbala",
      "Mbala"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "CIP",
    "translations": [
      "Chipata Airport",
      "Chipata Airport",
      "Chipata Airport"
    ],
    "city": [
      "Chipata",
      "Chipata",
      "Chipata"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "CGX",
    "translations": [
      "Chunga Airstrip",
      "Chunga Airstrip",
      "Chunga Airstrip"
    ],
    "city": [
      "Chunga",
      "Chunga",
      "Chunga"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "JEK",
    "translations": [
      "Jeki Airport",
      "Jeki Airport",
      "Jeki Airport"
    ],
    "city": [
      "Jeki",
      "Jeki",
      "Jeki"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "CGJ",
    "translations": [
      "Kasompe Airport",
      "Kasompe Airport",
      "Kasompe Airport"
    ],
    "city": [
      "Chingola",
      "Chingola",
      "Chingola"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "KLB",
    "translations": [
      "Kalabo Airport",
      "Kalabo Airport",
      "Kalabo Airport"
    ],
    "city": [
      "Kalabo",
      "Kalabo",
      "Kalabo"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "KMZ",
    "translations": [
      "Kaoma Airport",
      "Kaoma Airport",
      "Kaoma Airport"
    ],
    "city": [
      "Kaoma",
      "Kaoma",
      "Kaoma"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "KAA",
    "translations": [
      "Kasama Airport",
      "Kasama Airport",
      "Kasama Airport"
    ],
    "city": [
      "Kasama",
      "Kasama",
      "Kasama"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "ZKB",
    "translations": [
      "Kasaba Bay Airport",
      "Kasaba Bay Airport",
      "Kasaba Bay Airport"
    ],
    "city": [
      "Kasaba Bay",
      "Kasaba Bay",
      "Kasaba Bay"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "LVI",
    "translations": [
      "Harry Mwanga Nkumbula International Airport",
      "Harry Mwanga Nkumbula International Airport",
      "Harry Mwanga Nkumbula International Airport"
    ],
    "city": [
      "Livingstone",
      "Livingstone",
      "Livingstone"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "LXU",
    "translations": [
      "Lukulu Airport",
      "Lukulu Airport",
      "Lukulu Airport"
    ],
    "city": [
      "Lukulu",
      "Lukulu",
      "Lukulu"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "LUN",
    "translations": [
      "Kenneth Kaunda International Airport",
      "Kenneth Kaunda International Airport",
      "Kenneth Kaunda International Airport"
    ],
    "city": [
      "Lusaka",
      "Lusaka",
      "Lusaka"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "MNS",
    "translations": [
      "Mansa Airport",
      "Mansa Airport",
      "Mansa Airport"
    ],
    "city": [
      "Mansa",
      "Mansa",
      "Mansa"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "MFU",
    "translations": [
      "Mfuwe Airport",
      "Mfuwe Airport",
      "Mfuwe Airport"
    ],
    "city": [
      "Mfuwe",
      "Mfuwe",
      "Mfuwe"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "MNR",
    "translations": [
      "Mongu Airport",
      "Mongu Airport",
      "Mongu Airport"
    ],
    "city": [
      "Mongu",
      "Mongu",
      "Mongu"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "ZGM",
    "translations": [
      "Ngoma Airport",
      "Ngoma Airport",
      "Ngoma Airport"
    ],
    "city": [
      "Ngoma",
      "Ngoma",
      "Ngoma"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "RYL",
    "translations": [
      "Royal Zambezi Lodge Airstrip",
      "Royal Zambezi Lodge Airstrip",
      "Royal Zambezi Lodge Airstrip"
    ],
    "city": [
      "Lower Zambezi River",
      "Lower Zambezi River",
      "Lower Zambezi River"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "NLA",
    "translations": [
      "Simon Mwansa Kapwepwe International Airport",
      "Simon Mwansa Kapwepwe International Airport",
      "Simon Mwansa Kapwepwe International Airport"
    ],
    "city": [
      "Ndola",
      "Ndola",
      "Ndola"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "SXG",
    "translations": [
      "Senanga Airport",
      "Senanga Airport",
      "Senanga Airport"
    ],
    "city": [
      "Senanga",
      "Senanga",
      "Senanga"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "KIW",
    "translations": [
      "Southdowns Airport",
      "Southdowns Airport",
      "Southdowns Airport"
    ],
    "city": [
      "Kitwe",
      "Kitwe",
      "Kitwe"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "SJQ",
    "translations": [
      "Sesheke Airport",
      "Sesheke Airport",
      "Sesheke Airport"
    ],
    "city": [
      "Sesheke",
      "Sesheke",
      "Sesheke"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "SLI",
    "translations": [
      "Solwesi Airport",
      "Solwesi Airport",
      "Solwesi Airport"
    ],
    "city": [
      "Solwesi",
      "Solwesi",
      "Solwesi"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "FLT",
    "translations": [
      "Flat Airport",
      "Flat Airport",
      "Flat Airport"
    ],
    "city": [
      "Flat",
      "Flat",
      "Flat"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BBZ",
    "translations": [
      "Zambezi Airport",
      "Zambezi Airport",
      "Zambezi Airport"
    ],
    "city": [
      "Zambezi",
      "Zambezi",
      "Zambezi"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "ULI",
    "translations": [
      "Ulithi Airport",
      "Ulithi Airport",
      "Ulithi Airport"
    ],
    "city": [
      "Falalop Island",
      "Falalop Island",
      "Falalop Island"
    ],
    "country": [
      "FM",
      "FM",
      "FM"
    ]
  },
  {
    "iata": "HAH",
    "translations": [
      "Prince Said Ibrahim International Airport",
      "Prince Said Ibrahim International Airport",
      "Prince Said Ibrahim International Airport"
    ],
    "city": [
      "Moroni",
      "Moroni",
      "Moroni"
    ],
    "country": [
      "KM",
      "KM",
      "KM"
    ]
  },
  {
    "iata": "NWA",
    "translations": [
      "Mohéli Bandar Es Eslam Airport",
      "Mohéli Bandar Es Eslam Airport",
      "Mohéli Bandar Es Eslam Airport"
    ],
    "city": [
      "Fomboni",
      "Fomboni",
      "Fomboni"
    ],
    "country": [
      "KM",
      "KM",
      "KM"
    ]
  },
  {
    "iata": "AJN",
    "translations": [
      "Ouani Airport",
      "Ouani Airport",
      "Ouani Airport"
    ],
    "city": [
      "Ouani",
      "Ouani",
      "Ouani"
    ],
    "country": [
      "KM",
      "KM",
      "KM"
    ]
  },
  {
    "iata": "DZA",
    "translations": [
      "Dzaoudzi Pamandzi International Airport",
      "Dzaoudzi Pamandzi International Airport",
      "Dzaoudzi Pamandzi International Airport"
    ],
    "city": [
      "Dzaoudzi",
      "Dzaoudzi",
      "Dzaoudzi"
    ],
    "country": [
      "YT",
      "YT",
      "YT"
    ]
  },
  {
    "iata": "RUN",
    "translations": [
      "Roland Garros Airport",
      "Roland Garros Airport",
      "Roland Garros Airport"
    ],
    "city": [
      "Sainte-Marie",
      "Sainte-Marie",
      "Sainte-Marie"
    ],
    "country": [
      "RE",
      "RE",
      "RE"
    ]
  },
  {
    "iata": "ZSE",
    "translations": [
      "Pierrefonds Airport",
      "Pierrefonds Airport",
      "Pierrefonds Airport"
    ],
    "city": [
      "Saint-Pierre",
      "Saint-Pierre",
      "Saint-Pierre"
    ],
    "country": [
      "RE",
      "RE",
      "RE"
    ]
  },
  {
    "iata": "OHB",
    "translations": [
      "Ambohibary Airport",
      "Ambohibary Airport",
      "Ambohibary Airport"
    ],
    "city": [
      "Moramanga",
      "Moramanga",
      "Moramanga"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WML",
    "translations": [
      "Malaimbandy Airport",
      "Malaimbandy Airport",
      "Malaimbandy Airport"
    ],
    "city": [
      "Malaimbandy",
      "Malaimbandy",
      "Malaimbandy"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "ATJ",
    "translations": [
      "Antsirabe Airport",
      "Antsirabe Airport",
      "Antsirabe Airport"
    ],
    "city": [
      "Antsirabe",
      "Antsirabe",
      "Antsirabe"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WAQ",
    "translations": [
      "Antsalova Airport",
      "Antsalova Airport",
      "Antsalova Airport"
    ],
    "city": [
      "Antsalova",
      "Antsalova",
      "Antsalova"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "VVB",
    "translations": [
      "Mahanoro Airport",
      "Mahanoro Airport",
      "Mahanoro Airport"
    ],
    "city": [
      "Mahanoro",
      "Mahanoro",
      "Mahanoro"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "TNR",
    "translations": [
      "Ivato Airport",
      "Ivato Airport",
      "Ivato Airport"
    ],
    "city": [
      "Antananarivo",
      "Antananarivo",
      "Antananarivo"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "JVA",
    "translations": [
      "Ankavandra Airport",
      "Ankavandra Airport",
      "Ankavandra Airport"
    ],
    "city": [
      "Ankavandra",
      "Ankavandra",
      "Ankavandra"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "BMD",
    "translations": [
      "Belo sur Tsiribihina Airport",
      "Belo sur Tsiribihina Airport",
      "Belo sur Tsiribihina Airport"
    ],
    "city": [
      "Belo sur Tsiribihina",
      "Belo sur Tsiribihina",
      "Belo sur Tsiribihina"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "ZVA",
    "translations": [
      "Miandrivazo Airport",
      "Miandrivazo Airport",
      "Miandrivazo Airport"
    ],
    "city": [
      "Miandrivazo",
      "Miandrivazo",
      "Miandrivazo"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "MXT",
    "translations": [
      "Maintirano Airport",
      "Maintirano Airport",
      "Maintirano Airport"
    ],
    "city": [
      "Maintirano",
      "Maintirano",
      "Maintirano"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "ILK",
    "translations": [
      "Atsinanana Airport",
      "Atsinanana Airport",
      "Atsinanana Airport"
    ],
    "city": [
      "Ilaka",
      "Ilaka",
      "Ilaka"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "TVA",
    "translations": [
      "Morafenobe Airport",
      "Morafenobe Airport",
      "Morafenobe Airport"
    ],
    "city": [
      "Morafenobe",
      "Morafenobe",
      "Morafenobe"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "SMS",
    "translations": [
      "Sainte Marie Airport",
      "Sainte Marie Airport",
      "Sainte Marie Airport"
    ],
    "city": [
      "Vohilava",
      "Vohilava",
      "Vohilava"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "TMM",
    "translations": [
      "Toamasina Ambalamanasy Airport",
      "Toamasina Ambalamanasy Airport",
      "Toamasina Ambalamanasy Airport"
    ],
    "city": [
      "Toamasina",
      "Toamasina",
      "Toamasina"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WTA",
    "translations": [
      "Tambohorano Airport",
      "Tambohorano Airport",
      "Tambohorano Airport"
    ],
    "city": [
      "Tambohorano",
      "Tambohorano",
      "Tambohorano"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "MOQ",
    "translations": [
      "Morondava Airport",
      "Morondava Airport",
      "Morondava Airport"
    ],
    "city": [
      "Morondava",
      "Morondava",
      "Morondava"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WTS",
    "translations": [
      "Tsiroanomandidy Airport",
      "Tsiroanomandidy Airport",
      "Tsiroanomandidy Airport"
    ],
    "city": [
      "Tsiroanomandidy",
      "Tsiroanomandidy",
      "Tsiroanomandidy"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "VAT",
    "translations": [
      "Vatomandry Airport",
      "Vatomandry Airport",
      "Vatomandry Airport"
    ],
    "city": [
      "Vatomandry",
      "Vatomandry",
      "Vatomandry"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WAM",
    "translations": [
      "Ambatondrazaka Airport",
      "Ambatondrazaka Airport",
      "Ambatondrazaka Airport"
    ],
    "city": [
      "Ambatondrazaka",
      "Ambatondrazaka",
      "Ambatondrazaka"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "DIE",
    "translations": [
      "Arrachart Airport",
      "Arrachart Airport",
      "Arrachart Airport"
    ],
    "city": [
      "Antisiranana",
      "Antisiranana",
      "Antisiranana"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WBE",
    "translations": [
      "Ankaizina Airport",
      "Ankaizina Airport",
      "Ankaizina Airport"
    ],
    "city": [
      "Bealanana",
      "Bealanana",
      "Bealanana"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WMR",
    "translations": [
      "Mananara Nord Airport",
      "Mananara Nord Airport",
      "Mananara Nord Airport"
    ],
    "city": [
      "Mananara Nord",
      "Mananara Nord",
      "Mananara Nord"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "ZWA",
    "translations": [
      "Andapa Airport",
      "Andapa Airport",
      "Andapa Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "AMB",
    "translations": [
      "Ambilobe Airport",
      "Ambilobe Airport",
      "Ambilobe Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WBD",
    "translations": [
      "Avaratra Airport",
      "Avaratra Airport",
      "Avaratra Airport"
    ],
    "city": [
      "Befandriana",
      "Befandriana",
      "Befandriana"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WPB",
    "translations": [
      "Port Bergé Airport",
      "Port Bergé Airport",
      "Port Bergé Airport"
    ],
    "city": [
      "Port Bergé",
      "Port Bergé",
      "Port Bergé"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "ANM",
    "translations": [
      "Antsirabe Airport",
      "Antsirabe Airport",
      "Antsirabe Airport"
    ],
    "city": [
      "Antsirabe",
      "Antsirabe",
      "Antsirabe"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "HVA",
    "translations": [
      "Analalava Airport",
      "Analalava Airport",
      "Analalava Airport"
    ],
    "city": [
      "Analalava",
      "Analalava",
      "Analalava"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "MJN",
    "translations": [
      "Amborovy Airport",
      "Amborovy Airport",
      "Amborovy Airport"
    ],
    "city": [
      "Mahajanga",
      "Mahajanga",
      "Mahajanga"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "NOS",
    "translations": [
      "Fascene Airport",
      "Fascene Airport",
      "Fascene Airport"
    ],
    "city": [
      "Nosy Be",
      "Nosy Be",
      "Nosy Be"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "DWB",
    "translations": [
      "Soalala Airport",
      "Soalala Airport",
      "Soalala Airport"
    ],
    "city": [
      "Soalala",
      "Soalala",
      "Soalala"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WMP",
    "translations": [
      "Mampikony Airport",
      "Mampikony Airport",
      "Mampikony Airport"
    ],
    "city": [
      "Mampikony",
      "Mampikony",
      "Mampikony"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "BPY",
    "translations": [
      "Besalampy Airport",
      "Besalampy Airport",
      "Besalampy Airport"
    ],
    "city": [
      "Besalampy",
      "Besalampy",
      "Besalampy"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WMN",
    "translations": [
      "Maroantsetra Airport",
      "Maroantsetra Airport",
      "Maroantsetra Airport"
    ],
    "city": [
      "Maroantsetra",
      "Maroantsetra",
      "Maroantsetra"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "SVB",
    "translations": [
      "Sambava Airport",
      "Sambava Airport",
      "Sambava Airport"
    ],
    "city": [
      "Sambava",
      "Sambava",
      "Sambava"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "TTS",
    "translations": [
      "Tsaratanana Airport",
      "Tsaratanana Airport",
      "Tsaratanana Airport"
    ],
    "city": [
      "Tsaratanana",
      "Tsaratanana",
      "Tsaratanana"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "VOH",
    "translations": [
      "Vohemar Airport",
      "Vohemar Airport",
      "Vohemar Airport"
    ],
    "city": [
      "Vohemar",
      "Vohemar",
      "Vohemar"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WAI",
    "translations": [
      "Ambalabe Airport",
      "Ambalabe Airport",
      "Ambalabe Airport"
    ],
    "city": [
      "Antsohihy",
      "Antsohihy",
      "Antsohihy"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WMA",
    "translations": [
      "Mandritsara Airport",
      "Mandritsara Airport",
      "Mandritsara Airport"
    ],
    "city": [
      "Mandritsara",
      "Mandritsara",
      "Mandritsara"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "IVA",
    "translations": [
      "Ampampamena Airport",
      "Ampampamena Airport",
      "Ampampamena Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WBO",
    "translations": [
      "Antsoa Airport",
      "Antsoa Airport",
      "Antsoa Airport"
    ],
    "city": [
      "Beroroha",
      "Beroroha",
      "Beroroha"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WMD",
    "translations": [
      "Mandabe Airport",
      "Mandabe Airport",
      "Mandabe Airport"
    ],
    "city": [
      "Mandabe",
      "Mandabe",
      "Mandabe"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "FTU",
    "translations": [
      "Tôlanaro Airport",
      "Tôlanaro Airport",
      "Tôlanaro Airport"
    ],
    "city": [
      "Tôlanaro",
      "Tôlanaro",
      "Tôlanaro"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WFI",
    "translations": [
      "Fianarantsoa Airport",
      "Fianarantsoa Airport",
      "Fianarantsoa Airport"
    ],
    "city": [
      "Fianarantsoa",
      "Fianarantsoa",
      "Fianarantsoa"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "RVA",
    "translations": [
      "Farafangana Airport",
      "Farafangana Airport",
      "Farafangana Airport"
    ],
    "city": [
      "Farafangana",
      "Farafangana",
      "Farafangana"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "IHO",
    "translations": [
      "Ihosy Airport",
      "Ihosy Airport",
      "Ihosy Airport"
    ],
    "city": [
      "Ihosy",
      "Ihosy",
      "Ihosy"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "MJA",
    "translations": [
      "Manja Airport",
      "Manja Airport",
      "Manja Airport"
    ],
    "city": [
      "Manja",
      "Manja",
      "Manja"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WVK",
    "translations": [
      "Manakara Airport",
      "Manakara Airport",
      "Manakara Airport"
    ],
    "city": [
      "Manakara",
      "Manakara",
      "Manakara"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "OVA",
    "translations": [
      "Bekily Airport",
      "Bekily Airport",
      "Bekily Airport"
    ],
    "city": [
      "Bekily",
      "Bekily",
      "Bekily"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "MNJ",
    "translations": [
      "Mananjary Airport",
      "Mananjary Airport",
      "Mananjary Airport"
    ],
    "city": [
      "Mananjary",
      "Mananjary",
      "Mananjary"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "TDV",
    "translations": [
      "Samangoky Airport",
      "Samangoky Airport",
      "Samangoky Airport"
    ],
    "city": [
      "Tanandava",
      "Tanandava",
      "Tanandava"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "MXM",
    "translations": [
      "Morombe Airport",
      "Morombe Airport",
      "Morombe Airport"
    ],
    "city": [
      "Morombe",
      "Morombe",
      "Morombe"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "TLE",
    "translations": [
      "Toliara Airport",
      "Toliara Airport",
      "Toliara Airport"
    ],
    "city": [
      "Toliara",
      "Toliara",
      "Toliara"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "VND",
    "translations": [
      "Vangaindrano Airport",
      "Vangaindrano Airport",
      "Vangaindrano Airport"
    ],
    "city": [
      "Vangaindrano",
      "Vangaindrano",
      "Vangaindrano"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "BKU",
    "translations": [
      "Betioky Airport",
      "Betioky Airport",
      "Betioky Airport"
    ],
    "city": [
      "Betioky",
      "Betioky",
      "Betioky"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "AMP",
    "translations": [
      "Ampanihy Airport",
      "Ampanihy Airport",
      "Ampanihy Airport"
    ],
    "city": [
      "Ampanihy",
      "Ampanihy",
      "Ampanihy"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "WAK",
    "translations": [
      "Ankazoabo Airport",
      "Ankazoabo Airport",
      "Ankazoabo Airport"
    ],
    "city": [
      "Ankazoabo",
      "Ankazoabo",
      "Ankazoabo"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "AZZ",
    "translations": [
      "Ambriz Airport",
      "Ambriz Airport",
      "Ambriz Airport"
    ],
    "city": [
      "Ambriz",
      "Ambriz",
      "Ambriz"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "SSY",
    "translations": [
      "Mbanza Congo Airport",
      "Mbanza Congo Airport",
      "Mbanza Congo Airport"
    ],
    "city": [
      "Mbanza Congo",
      "Mbanza Congo",
      "Mbanza Congo"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "BUG",
    "translations": [
      "Benguela Airport",
      "Benguela Airport",
      "Benguela Airport"
    ],
    "city": [
      "Benguela",
      "Benguela",
      "Benguela"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "NBJ",
    "translations": [
      "Dr. Antonio Agostinho Neto International Airport",
      "Dr. Antonio Agostinho Neto International Airport",
      "Dr. Antonio Agostinho Neto International Airport"
    ],
    "city": [
      "Luanda (Ícolo e Bengo)",
      "Luanda (Ícolo e Bengo)",
      "Luanda (Ícolo e Bengo)"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "GGC",
    "translations": [
      "Lumbala Airport",
      "Lumbala Airport",
      "Lumbala Airport"
    ],
    "city": [
      "Lumbala N'guimbo",
      "Lumbala N'guimbo",
      "Lumbala N'guimbo"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "CAB",
    "translations": [
      "Cabinda Airport",
      "Cabinda Airport",
      "Cabinda Airport"
    ],
    "city": [
      "Cabinda",
      "Cabinda",
      "Cabinda"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "CFF",
    "translations": [
      "Cafunfo Airport",
      "Cafunfo Airport",
      "Cafunfo Airport"
    ],
    "city": [
      "Cafunfo",
      "Cafunfo",
      "Cafunfo"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "PGI",
    "translations": [
      "Chitato Airport",
      "Chitato Airport",
      "Chitato Airport"
    ],
    "city": [
      "Chitato",
      "Chitato",
      "Chitato"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "KNP",
    "translations": [
      "Kapanda Airport",
      "Kapanda Airport",
      "Kapanda Airport"
    ],
    "city": [
      "Capanda",
      "Capanda",
      "Capanda"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "CBT",
    "translations": [
      "Catumbela Airport",
      "Catumbela Airport",
      "Catumbela Airport"
    ],
    "city": [
      "Catumbela",
      "Catumbela",
      "Catumbela"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "CTI",
    "translations": [
      "Cuito Cuanavale Airport",
      "Cuito Cuanavale Airport",
      "Cuito Cuanavale Airport"
    ],
    "city": [
      "Cuito Cuanavale",
      "Cuito Cuanavale",
      "Cuito Cuanavale"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "CXM",
    "translations": [
      "Camaxilo Airport",
      "Camaxilo Airport",
      "Camaxilo Airport"
    ],
    "city": [
      "Camaxilo",
      "Camaxilo",
      "Camaxilo"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "CAV",
    "translations": [
      "Cazombo Airport",
      "Cazombo Airport",
      "Cazombo Airport"
    ],
    "city": [
      "Cazombo",
      "Cazombo",
      "Cazombo"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "FND",
    "translations": [
      "Funadhoo Airport",
      "Funadhoo Airport",
      "Funadhoo Airport"
    ],
    "city": [
      "Funadhoo",
      "Funadhoo",
      "Funadhoo"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "DUE",
    "translations": [
      "Dundo Airport",
      "Dundo Airport",
      "Dundo Airport"
    ],
    "city": [
      "Chitato",
      "Chitato",
      "Chitato"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "VPE",
    "translations": [
      "Ngjiva Pereira Airport",
      "Ngjiva Pereira Airport",
      "Ngjiva Pereira Airport"
    ],
    "city": [
      "Ngiva",
      "Ngiva",
      "Ngiva"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "NOV",
    "translations": [
      "Albano Machado Airport",
      "Albano Machado Airport",
      "Albano Machado Airport"
    ],
    "city": [
      "Huambo",
      "Huambo",
      "Huambo"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "SVP",
    "translations": [
      "Kuito Airport",
      "Kuito Airport",
      "Kuito Airport"
    ],
    "city": [
      "Kuito",
      "Kuito",
      "Kuito"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "LLT",
    "translations": [
      "Lobito Airport",
      "Lobito Airport",
      "Lobito Airport"
    ],
    "city": [
      "Lobito",
      "Lobito",
      "Lobito"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "LBZ",
    "translations": [
      "Lucapa Airport",
      "Lucapa Airport",
      "Lucapa Airport"
    ],
    "city": [
      "Lucapa",
      "Lucapa",
      "Lucapa"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "LAD",
    "translations": [
      "Quatro de Fevereiro International Airport",
      "Quatro de Fevereiro International Airport",
      "Quatro de Fevereiro International Airport"
    ],
    "city": [
      "Luanda",
      "Luanda",
      "Luanda"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "LZM",
    "translations": [
      "Luzamba Airport",
      "Luzamba Airport",
      "Luzamba Airport"
    ],
    "city": [
      "Luzamba",
      "Luzamba",
      "Luzamba"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "MEG",
    "translations": [
      "Malanje Airport",
      "Malanje Airport",
      "Malanje Airport"
    ],
    "city": [
      "Malanje",
      "Malanje",
      "Malanje"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "SPP",
    "translations": [
      "Menongue Airport",
      "Menongue Airport",
      "Menongue Airport"
    ],
    "city": [
      "Menongue",
      "Menongue",
      "Menongue"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "MSZ",
    "translations": [
      "Welwitschia Mirabilis International Airport",
      "Welwitschia Mirabilis International Airport",
      "Welwitschia Mirabilis International Airport"
    ],
    "city": [
      "Moçâmedes",
      "Moçâmedes",
      "Moçâmedes"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "GXG",
    "translations": [
      "Negage Airport",
      "Negage Airport",
      "Negage Airport"
    ],
    "city": [
      "Negage",
      "Negage",
      "Negage"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "PBN",
    "translations": [
      "Porto Amboim Airport",
      "Porto Amboim Airport",
      "Porto Amboim Airport"
    ],
    "city": [
      "Port Amboim",
      "Port Amboim",
      "Port Amboim"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "VHC",
    "translations": [
      "Saurimo Airport",
      "Saurimo Airport",
      "Saurimo Airport"
    ],
    "city": [
      "Saurimo",
      "Saurimo",
      "Saurimo"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "SZA",
    "translations": [
      "Soyo Airport",
      "Soyo Airport",
      "Soyo Airport"
    ],
    "city": [
      "Soyo",
      "Soyo",
      "Soyo"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "NDD",
    "translations": [
      "Sumbe Airport",
      "Sumbe Airport",
      "Sumbe Airport"
    ],
    "city": [
      "Sumbe",
      "Sumbe",
      "Sumbe"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "UAL",
    "translations": [
      "Luau Airport",
      "Luau Airport",
      "Luau Airport"
    ],
    "city": [
      "Luau",
      "Luau",
      "Luau"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "SDD",
    "translations": [
      "Lubango Airport",
      "Lubango Airport",
      "Lubango Airport"
    ],
    "city": [
      "Lubango",
      "Lubango",
      "Lubango"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "LUO",
    "translations": [
      "Luena Airport",
      "Luena Airport",
      "Luena Airport"
    ],
    "city": [
      "Luena",
      "Luena",
      "Luena"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "UGO",
    "translations": [
      "Uige Airport",
      "Uige Airport",
      "Uige Airport"
    ],
    "city": [
      "Uige",
      "Uige",
      "Uige"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "CEO",
    "translations": [
      "Waco Kungo Airport",
      "Waco Kungo Airport",
      "Waco Kungo Airport"
    ],
    "city": [
      "Waco Kungo",
      "Waco Kungo",
      "Waco Kungo"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "XGN",
    "translations": [
      "Xangongo Airport",
      "Xangongo Airport",
      "Xangongo Airport"
    ],
    "city": [
      "Xangongo",
      "Xangongo",
      "Xangongo"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "ARZ",
    "translations": [
      "N'zeto Airport",
      "N'zeto Airport",
      "N'zeto Airport"
    ],
    "city": [
      "N'zeto",
      "N'zeto",
      "N'zeto"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "NZA",
    "translations": [
      "Nzagi Airport",
      "Nzagi Airport",
      "Nzagi Airport"
    ],
    "city": [
      "Nzagi",
      "Nzagi",
      "Nzagi"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "AKE",
    "translations": [
      "Akieni Airport",
      "Akieni Airport",
      "Akieni Airport"
    ],
    "city": [
      "Akieni",
      "Akieni",
      "Akieni"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "BGB",
    "translations": [
      "Booue Airport",
      "Booue Airport",
      "Booue Airport"
    ],
    "city": [
      "Booue",
      "Booue",
      "Booue"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "KDN",
    "translations": [
      "Ndende Airport",
      "Ndende Airport",
      "Ndende Airport"
    ],
    "city": [
      "Ndende",
      "Ndende",
      "Ndende"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "FOU",
    "translations": [
      "Fougamou Airport",
      "Fougamou Airport",
      "Fougamou Airport"
    ],
    "city": [
      "Fougamou",
      "Fougamou",
      "Fougamou"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "MBC",
    "translations": [
      "M'Bigou Airport",
      "M'Bigou Airport",
      "M'Bigou Airport"
    ],
    "city": [
      "M'Bigou",
      "M'Bigou",
      "M'Bigou"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "MGX",
    "translations": [
      "Moabi Airport",
      "Moabi Airport",
      "Moabi Airport"
    ],
    "city": [
      "Moabi",
      "Moabi",
      "Moabi"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "KDJ",
    "translations": [
      "Ville Airport",
      "Ville Airport",
      "Ville Airport"
    ],
    "city": [
      "N'Djolé",
      "N'Djolé",
      "N'Djolé"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "KOU",
    "translations": [
      "Koulamoutou Mabimbi Airport",
      "Koulamoutou Mabimbi Airport",
      "Koulamoutou Mabimbi Airport"
    ],
    "city": [
      "Koulamoutou",
      "Koulamoutou",
      "Koulamoutou"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "MJL",
    "translations": [
      "Mouilla Ville Airport",
      "Mouilla Ville Airport",
      "Mouilla Ville Airport"
    ],
    "city": [
      "Mouila",
      "Mouila",
      "Mouila"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "OYE",
    "translations": [
      "Oyem Airport",
      "Oyem Airport",
      "Oyem Airport"
    ],
    "city": [
      "Oyem",
      "Oyem",
      "Oyem"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "OKN",
    "translations": [
      "Okondja Airport",
      "Okondja Airport",
      "Okondja Airport"
    ],
    "city": [
      "Okondja",
      "Okondja",
      "Okondja"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "LBQ",
    "translations": [
      "Lambarene Airport",
      "Lambarene Airport",
      "Lambarene Airport"
    ],
    "city": [
      "Lambarene",
      "Lambarene",
      "Lambarene"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "MVX",
    "translations": [
      "Minvoul Airport",
      "Minvoul Airport",
      "Minvoul Airport"
    ],
    "city": [
      "Minvoul",
      "Minvoul",
      "Minvoul"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "AWE",
    "translations": [
      "Alowe Airport",
      "Alowe Airport",
      "Alowe Airport"
    ],
    "city": [
      "Wonga Wongué Presidential Reserve",
      "Wonga Wongué Presidential Reserve",
      "Wonga Wongué Presidential Reserve"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "BMM",
    "translations": [
      "Bitam Airport",
      "Bitam Airport",
      "Bitam Airport"
    ],
    "city": [
      "Bitam",
      "Bitam",
      "Bitam"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "MFF",
    "translations": [
      "Moanda Airport",
      "Moanda Airport",
      "Moanda Airport"
    ],
    "city": [
      "Moanda",
      "Moanda",
      "Moanda"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "MKB",
    "translations": [
      "Mekambo Airport",
      "Mekambo Airport",
      "Mekambo Airport"
    ],
    "city": [
      "Mekambo",
      "Mekambo",
      "Mekambo"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "POG",
    "translations": [
      "Port Gentil Airport",
      "Port Gentil Airport",
      "Port Gentil Airport"
    ],
    "city": [
      "Port Gentil",
      "Port Gentil",
      "Port Gentil"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "OMB",
    "translations": [
      "Omboue Hospital Airport",
      "Omboue Hospital Airport",
      "Omboue Hospital Airport"
    ],
    "city": [
      "Omboue",
      "Omboue",
      "Omboue"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "IGE",
    "translations": [
      "Tchongorove Airport",
      "Tchongorove Airport",
      "Tchongorove Airport"
    ],
    "city": [
      "Iguela",
      "Iguela",
      "Iguela"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "MKU",
    "translations": [
      "Makokou Airport",
      "Makokou Airport",
      "Makokou Airport"
    ],
    "city": [
      "Makokou",
      "Makokou",
      "Makokou"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "LBV",
    "translations": [
      "Libreville Leon M'ba International Airport",
      "Libreville Leon M'ba International Airport",
      "Libreville Leon M'ba International Airport"
    ],
    "city": [
      "Libreville",
      "Libreville",
      "Libreville"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "MZC",
    "translations": [
      "Mitzic Airport",
      "Mitzic Airport",
      "Mitzic Airport"
    ],
    "city": [
      "Mitzic",
      "Mitzic",
      "Mitzic"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "MVB",
    "translations": [
      "M'Vengue El Hadj Omar Bongo Ondimba International Airport",
      "M'Vengue El Hadj Omar Bongo Ondimba International Airport",
      "M'Vengue El Hadj Omar Bongo Ondimba International Airport"
    ],
    "city": [
      "Franceville",
      "Franceville",
      "Franceville"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "LTL",
    "translations": [
      "Lastourville Airport",
      "Lastourville Airport",
      "Lastourville Airport"
    ],
    "city": [
      "Lastourville",
      "Lastourville",
      "Lastourville"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "TCH",
    "translations": [
      "Tchibanga Airport",
      "Tchibanga Airport",
      "Tchibanga Airport"
    ],
    "city": [
      "Tchibanga",
      "Tchibanga",
      "Tchibanga"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "MYB",
    "translations": [
      "Mayumba Airport",
      "Mayumba Airport",
      "Mayumba Airport"
    ],
    "city": [
      "Mayumba",
      "Mayumba",
      "Mayumba"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "FOY",
    "translations": [
      "Foya Airport",
      "Foya Airport",
      "Foya Airport"
    ],
    "city": [
      "Foya",
      "Foya",
      "Foya"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "PCP",
    "translations": [
      "Principe Airport",
      "Principe Airport",
      "Principe Airport"
    ],
    "city": [
      "São Tomé & Príncipe",
      "São Tomé & Príncipe",
      "São Tomé & Príncipe"
    ],
    "country": [
      "ST",
      "ST",
      "ST"
    ]
  },
  {
    "iata": "TMS",
    "translations": [
      "São Tomé International Airport",
      "São Tomé International Airport",
      "São Tomé International Airport"
    ],
    "city": [
      "São Tomé",
      "São Tomé",
      "São Tomé"
    ],
    "country": [
      "ST",
      "ST",
      "ST"
    ]
  },
  {
    "iata": "ANO",
    "translations": [
      "Angoche Airport",
      "Angoche Airport",
      "Angoche Airport"
    ],
    "city": [
      "Angoche",
      "Angoche",
      "Angoche"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "BEW",
    "translations": [
      "Beira Airport",
      "Beira Airport",
      "Beira Airport"
    ],
    "city": [
      "Beira",
      "Beira",
      "Beira"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "FXO",
    "translations": [
      "Cuamba Airport",
      "Cuamba Airport",
      "Cuamba Airport"
    ],
    "city": [
      "Cuamba",
      "Cuamba",
      "Cuamba"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "VPY",
    "translations": [
      "Chimoio Airport",
      "Chimoio Airport",
      "Chimoio Airport"
    ],
    "city": [
      "Chimoio",
      "Chimoio",
      "Chimoio"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "IHC",
    "translations": [
      "Inhaca Airport",
      "Inhaca Airport",
      "Inhaca Airport"
    ],
    "city": [
      "Inhaca",
      "Inhaca",
      "Inhaca"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "IBO",
    "translations": [
      "Ibo Airport",
      "Ibo Airport",
      "Ibo Airport"
    ],
    "city": [
      "Ibo",
      "Ibo",
      "Ibo"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "INH",
    "translations": [
      "Inhambane Airport",
      "Inhambane Airport",
      "Inhambane Airport"
    ],
    "city": [
      "Inhambane",
      "Inhambane",
      "Inhambane"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "VXC",
    "translations": [
      "Lichinga Airport",
      "Lichinga Airport",
      "Lichinga Airport"
    ],
    "city": [
      "Lichinga",
      "Lichinga",
      "Lichinga"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "LFB",
    "translations": [
      "Lumbo Airport",
      "Lumbo Airport",
      "Lumbo Airport"
    ],
    "city": [
      "Lumbo",
      "Lumbo",
      "Lumbo"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "MPM",
    "translations": [
      "Maputo Airport",
      "Maputo Airport",
      "Maputo Airport"
    ],
    "city": [
      "Maputo",
      "Maputo",
      "Maputo"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "MUD",
    "translations": [
      "Mueda Airport",
      "Mueda Airport",
      "Mueda Airport"
    ],
    "city": [
      "Mueda",
      "Mueda",
      "Mueda"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "MZB",
    "translations": [
      "Mocímboa da Praia Airport",
      "Mocímboa da Praia Airport",
      "Mocímboa da Praia Airport"
    ],
    "city": [
      "Mocímboa da Praia",
      "Mocímboa da Praia",
      "Mocímboa da Praia"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "MNC",
    "translations": [
      "Nacala Airport",
      "Nacala Airport",
      "Nacala Airport"
    ],
    "city": [
      "Nacala",
      "Nacala",
      "Nacala"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "APL",
    "translations": [
      "Nampula Airport",
      "Nampula Airport",
      "Nampula Airport"
    ],
    "city": [
      "Nampula",
      "Nampula",
      "Nampula"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "POL",
    "translations": [
      "Pemba Airport",
      "Pemba Airport",
      "Pemba Airport"
    ],
    "city": [
      "Pemba",
      "Pemba",
      "Pemba"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "PDD",
    "translations": [
      "Ponta do Ouro Airport",
      "Ponta do Ouro Airport",
      "Ponta do Ouro Airport"
    ],
    "city": [
      "Ponta do Ouro",
      "Ponta do Ouro",
      "Ponta do Ouro"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "UEL",
    "translations": [
      "Quelimane Airport",
      "Quelimane Airport",
      "Quelimane Airport"
    ],
    "city": [
      "Quelimane",
      "Quelimane",
      "Quelimane"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "TET",
    "translations": [
      "Chingozi Airport",
      "Chingozi Airport",
      "Chingozi Airport"
    ],
    "city": [
      "Tete",
      "Tete",
      "Tete"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "VNX",
    "translations": [
      "Vilankulo Airport",
      "Vilankulo Airport",
      "Vilankulo Airport"
    ],
    "city": [
      "Vilanculo",
      "Vilanculo",
      "Vilanculo"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "VJB",
    "translations": [
      "Xai-Xai Chongoene Airport",
      "Xai-Xai Chongoene Airport",
      "Xai-Xai Chongoene Airport"
    ],
    "city": [
      "Xai-Xai",
      "Xai-Xai",
      "Xai-Xai"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "DES",
    "translations": [
      "Desroches Airport",
      "Desroches Airport",
      "Desroches Airport"
    ],
    "city": [
      "Desroches Island",
      "Desroches Island",
      "Desroches Island"
    ],
    "country": [
      "SC",
      "SC",
      "SC"
    ]
  },
  {
    "iata": "SEZ",
    "translations": [
      "Seychelles International Airport",
      "Seychelles International Airport",
      "Seychelles International Airport"
    ],
    "city": [
      "Mahe Island",
      "Mahe Island",
      "Mahe Island"
    ],
    "country": [
      "SC",
      "SC",
      "SC"
    ]
  },
  {
    "iata": "FSL",
    "translations": [
      "Fossil Downs Airport",
      "Fossil Downs Airport",
      "Fossil Downs Airport"
    ],
    "city": [
      "Fossil Downs Station",
      "Fossil Downs Station",
      "Fossil Downs Station"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PRI",
    "translations": [
      "Praslin Island Airport",
      "Praslin Island Airport",
      "Praslin Island Airport"
    ],
    "city": [
      "Praslin Island",
      "Praslin Island",
      "Praslin Island"
    ],
    "country": [
      "SC",
      "SC",
      "SC"
    ]
  },
  {
    "iata": "BDI",
    "translations": [
      "Bird Island Airport",
      "Bird Island Airport",
      "Bird Island Airport"
    ],
    "city": [
      "Bird Island",
      "Bird Island",
      "Bird Island"
    ],
    "country": [
      "SC",
      "SC",
      "SC"
    ]
  },
  {
    "iata": "DEI",
    "translations": [
      "Denis Island Airport",
      "Denis Island Airport",
      "Denis Island Airport"
    ],
    "city": [
      "Denis Island",
      "Denis Island",
      "Denis Island"
    ],
    "country": [
      "SC",
      "SC",
      "SC"
    ]
  },
  {
    "iata": "FRK",
    "translations": [
      "Frégate Island Airport (UNUSABLE)",
      "Frégate Island Airport (UNUSABLE)",
      "Frégate Island Airport (UNUSABLE)"
    ],
    "city": [
      "Frégate Island",
      "Frégate Island",
      "Frégate Island"
    ],
    "country": [
      "SC",
      "SC",
      "SC"
    ]
  },
  {
    "iata": "SRH",
    "translations": [
      "Sarh Airport",
      "Sarh Airport",
      "Sarh Airport"
    ],
    "city": [
      "Sarh",
      "Sarh",
      "Sarh"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "OGR",
    "translations": [
      "Bongor Airport",
      "Bongor Airport",
      "Bongor Airport"
    ],
    "city": [
      "Bongor",
      "Bongor",
      "Bongor"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "AEH",
    "translations": [
      "Abeche Airport",
      "Abeche Airport",
      "Abeche Airport"
    ],
    "city": [
      "Abeche",
      "Abeche",
      "Abeche"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "MQQ",
    "translations": [
      "Moundou Airport",
      "Moundou Airport",
      "Moundou Airport"
    ],
    "city": [
      "Moundou",
      "Moundou",
      "Moundou"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "LTC",
    "translations": [
      "Lai Airport",
      "Lai Airport",
      "Lai Airport"
    ],
    "city": [
      "Lai",
      "Lai",
      "Lai"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "ATV",
    "translations": [
      "Ati Airport",
      "Ati Airport",
      "Ati Airport"
    ],
    "city": [
      "Ati",
      "Ati",
      "Ati"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "NDJ",
    "translations": [
      "N'Djamena International Airport",
      "N'Djamena International Airport",
      "N'Djamena International Airport"
    ],
    "city": [
      "N'Djamena",
      "N'Djamena",
      "N'Djamena"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "BKR",
    "translations": [
      "Bokoro Airport",
      "Bokoro Airport",
      "Bokoro Airport"
    ],
    "city": [
      "Bokoro",
      "Bokoro",
      "Bokoro"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "OTC",
    "translations": [
      "Bol-Berim Airport",
      "Bol-Berim Airport",
      "Bol-Berim Airport"
    ],
    "city": [
      "Bol",
      "Bol",
      "Bol"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "MVO",
    "translations": [
      "Mongo Airport",
      "Mongo Airport",
      "Mongo Airport"
    ],
    "city": [
      "Mongo",
      "Mongo",
      "Mongo"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "AMC",
    "translations": [
      "Am Timan Airport",
      "Am Timan Airport",
      "Am Timan Airport"
    ],
    "city": [
      "Am Timan",
      "Am Timan",
      "Am Timan"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "PLF",
    "translations": [
      "Pala Airport",
      "Pala Airport",
      "Pala Airport"
    ],
    "city": [
      "Pala",
      "Pala",
      "Pala"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "OUT",
    "translations": [
      "Bousso Airport",
      "Bousso Airport",
      "Bousso Airport"
    ],
    "city": [
      "Bousso",
      "Bousso",
      "Bousso"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "AMO",
    "translations": [
      "Mao Airport",
      "Mao Airport",
      "Mao Airport"
    ],
    "city": [
      "Mao",
      "Mao",
      "Mao"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "FYT",
    "translations": [
      "Faya-Largeau Airport",
      "Faya-Largeau Airport",
      "Faya-Largeau Airport"
    ],
    "city": [
      "Faya-Largeau",
      "Faya-Largeau",
      "Faya-Largeau"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "FUB",
    "translations": [
      "Fulleborn Airport",
      "Fulleborn Airport",
      "Fulleborn Airport"
    ],
    "city": [
      "Fulleborn",
      "Fulleborn",
      "Fulleborn"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BZH",
    "translations": [
      "Bumi Hills Airport",
      "Bumi Hills Airport",
      "Bumi Hills Airport"
    ],
    "city": [
      "Bumi",
      "Bumi",
      "Bumi"
    ],
    "country": [
      "ZW",
      "ZW",
      "ZW"
    ]
  },
  {
    "iata": "BUQ",
    "translations": [
      "Joshua Mqabuko Nkomo International Airport",
      "Joshua Mqabuko Nkomo International Airport",
      "Joshua Mqabuko Nkomo International Airport"
    ],
    "city": [
      "Bulawayo",
      "Bulawayo",
      "Bulawayo"
    ],
    "country": [
      "ZW",
      "ZW",
      "ZW"
    ]
  },
  {
    "iata": "CHJ",
    "translations": [
      "Chipinge Airport",
      "Chipinge Airport",
      "Chipinge Airport"
    ],
    "city": [
      "Chipinge",
      "Chipinge",
      "Chipinge"
    ],
    "country": [
      "ZW",
      "ZW",
      "ZW"
    ]
  },
  {
    "iata": "BFO",
    "translations": [
      "Buffalo Range Airport",
      "Buffalo Range Airport",
      "Buffalo Range Airport"
    ],
    "city": [
      "Chiredzi",
      "Chiredzi",
      "Chiredzi"
    ],
    "country": [
      "ZW",
      "ZW",
      "ZW"
    ]
  },
  {
    "iata": "VFA",
    "translations": [
      "Victoria Falls International Airport",
      "Victoria Falls International Airport",
      "Victoria Falls International Airport"
    ],
    "city": [
      "Victoria Falls",
      "Victoria Falls",
      "Victoria Falls"
    ],
    "country": [
      "ZW",
      "ZW",
      "ZW"
    ]
  },
  {
    "iata": "HRE",
    "translations": [
      "Robert Gabriel Mugabe International Airport",
      "Robert Gabriel Mugabe International Airport",
      "Robert Gabriel Mugabe International Airport"
    ],
    "city": [
      "Harare",
      "Harare",
      "Harare"
    ],
    "country": [
      "ZW",
      "ZW",
      "ZW"
    ]
  },
  {
    "iata": "KAB",
    "translations": [
      "Kariba International Airport",
      "Kariba International Airport",
      "Kariba International Airport"
    ],
    "city": [
      "Kariba",
      "Kariba",
      "Kariba"
    ],
    "country": [
      "ZW",
      "ZW",
      "ZW"
    ]
  },
  {
    "iata": "MJW",
    "translations": [
      "Mahenye Airport",
      "Mahenye Airport",
      "Mahenye Airport"
    ],
    "city": [
      "Gonarezhou National Park",
      "Gonarezhou National Park",
      "Gonarezhou National Park"
    ],
    "country": [
      "ZW",
      "ZW",
      "ZW"
    ]
  },
  {
    "iata": "UTA",
    "translations": [
      "Mutare Airport",
      "Mutare Airport",
      "Mutare Airport"
    ],
    "city": [
      "Mutare",
      "Mutare",
      "Mutare"
    ],
    "country": [
      "ZW",
      "ZW",
      "ZW"
    ]
  },
  {
    "iata": "MVZ",
    "translations": [
      "Masvingo International Airport",
      "Masvingo International Airport",
      "Masvingo International Airport"
    ],
    "city": [
      "Masvingo",
      "Masvingo",
      "Masvingo"
    ],
    "country": [
      "ZW",
      "ZW",
      "ZW"
    ]
  },
  {
    "iata": "GWE",
    "translations": [
      "Gweru - Thornhill Air Base",
      "Gweru - Thornhill Air Base",
      "Gweru - Thornhill Air Base"
    ],
    "city": [
      "Gweru",
      "Gweru",
      "Gweru"
    ],
    "country": [
      "ZW",
      "ZW",
      "ZW"
    ]
  },
  {
    "iata": "HWN",
    "translations": [
      "Hwange National Park Airport",
      "Hwange National Park Airport",
      "Hwange National Park Airport"
    ],
    "city": [
      "Gwayi River Farms",
      "Gwayi River Farms",
      "Gwayi River Farms"
    ],
    "country": [
      "ZW",
      "ZW",
      "ZW"
    ]
  },
  {
    "iata": "WKI",
    "translations": [
      "Hwange (Town) Airport",
      "Hwange (Town) Airport",
      "Hwange (Town) Airport"
    ],
    "city": [
      "Hwange",
      "Hwange",
      "Hwange"
    ],
    "country": [
      "ZW",
      "ZW",
      "ZW"
    ]
  },
  {
    "iata": "CEH",
    "translations": [
      "Chelinda Malawi Airport",
      "Chelinda Malawi Airport",
      "Chelinda Malawi Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "MW",
      "MW",
      "MW"
    ]
  },
  {
    "iata": "BLZ",
    "translations": [
      "Chileka International Airport",
      "Chileka International Airport",
      "Chileka International Airport"
    ],
    "city": [
      "Blantyre",
      "Blantyre",
      "Blantyre"
    ],
    "country": [
      "MW",
      "MW",
      "MW"
    ]
  },
  {
    "iata": "CMK",
    "translations": [
      "Club Makokola Airport",
      "Club Makokola Airport",
      "Club Makokola Airport"
    ],
    "city": [
      "Club Makokola",
      "Club Makokola",
      "Club Makokola"
    ],
    "country": [
      "MW",
      "MW",
      "MW"
    ]
  },
  {
    "iata": "DWA",
    "translations": [
      "Dwangwa Airport",
      "Dwangwa Airport",
      "Dwangwa Airport"
    ],
    "city": [
      "Dwangwa",
      "Dwangwa",
      "Dwangwa"
    ],
    "country": [
      "MW",
      "MW",
      "MW"
    ]
  },
  {
    "iata": "KGJ",
    "translations": [
      "Karonga Airport",
      "Karonga Airport",
      "Karonga Airport"
    ],
    "city": [
      "Karonga",
      "Karonga",
      "Karonga"
    ],
    "country": [
      "MW",
      "MW",
      "MW"
    ]
  },
  {
    "iata": "KBQ",
    "translations": [
      "Kasungu Airport",
      "Kasungu Airport",
      "Kasungu Airport"
    ],
    "city": [
      "Kasungu",
      "Kasungu",
      "Kasungu"
    ],
    "country": [
      "MW",
      "MW",
      "MW"
    ]
  },
  {
    "iata": "LLW",
    "translations": [
      "Kamuzu International Airport",
      "Kamuzu International Airport",
      "Kamuzu International Airport"
    ],
    "city": [
      "Lumbadzi",
      "Lumbadzi",
      "Lumbadzi"
    ],
    "country": [
      "MW",
      "MW",
      "MW"
    ]
  },
  {
    "iata": "LIX",
    "translations": [
      "Likoma Island Airport",
      "Likoma Island Airport",
      "Likoma Island Airport"
    ],
    "city": [
      "Likoma Island",
      "Likoma Island",
      "Likoma Island"
    ],
    "country": [
      "MW",
      "MW",
      "MW"
    ]
  },
  {
    "iata": "MYZ",
    "translations": [
      "Monkey Bay Airport",
      "Monkey Bay Airport",
      "Monkey Bay Airport"
    ],
    "city": [
      "Monkey Bay",
      "Monkey Bay",
      "Monkey Bay"
    ],
    "country": [
      "MW",
      "MW",
      "MW"
    ]
  },
  {
    "iata": "LMB",
    "translations": [
      "Salima Airport",
      "Salima Airport",
      "Salima Airport"
    ],
    "city": [
      "Salima",
      "Salima",
      "Salima"
    ],
    "country": [
      "MW",
      "MW",
      "MW"
    ]
  },
  {
    "iata": "ZZU",
    "translations": [
      "Mzuzu Airport",
      "Mzuzu Airport",
      "Mzuzu Airport"
    ],
    "city": [
      "Mzuzu",
      "Mzuzu",
      "Mzuzu"
    ],
    "country": [
      "MW",
      "MW",
      "MW"
    ]
  },
  {
    "iata": "LEF",
    "translations": [
      "Lebakeng Airport",
      "Lebakeng Airport",
      "Lebakeng Airport"
    ],
    "city": [
      "Lebakeng",
      "Lebakeng",
      "Lebakeng"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "LRB",
    "translations": [
      "Leribe Airport",
      "Leribe Airport",
      "Leribe Airport"
    ],
    "city": [
      "Leribe",
      "Leribe",
      "Leribe"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "LES",
    "translations": [
      "Lesobeng Airport",
      "Lesobeng Airport",
      "Lesobeng Airport"
    ],
    "city": [
      "Lesobeng",
      "Lesobeng",
      "Lesobeng"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "MSG",
    "translations": [
      "Matsaile Airport",
      "Matsaile Airport",
      "Matsaile Airport"
    ],
    "city": [
      "Matsaile",
      "Matsaile",
      "Matsaile"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "MFC",
    "translations": [
      "Mafeteng Airport",
      "Mafeteng Airport",
      "Mafeteng Airport"
    ],
    "city": [
      "Mafeteng",
      "Mafeteng",
      "Mafeteng"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "MKH",
    "translations": [
      "Mokhotlong Airport",
      "Mokhotlong Airport",
      "Mokhotlong Airport"
    ],
    "city": [
      "Mokhotlong",
      "Mokhotlong",
      "Mokhotlong"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "MSU",
    "translations": [
      "Moshoeshoe I International Airport",
      "Moshoeshoe I International Airport",
      "Moshoeshoe I International Airport"
    ],
    "city": [
      "Mazenod",
      "Mazenod",
      "Mazenod"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "NKU",
    "translations": [
      "Nkaus Airport",
      "Nkaus Airport",
      "Nkaus Airport"
    ],
    "city": [
      "Nkaus",
      "Nkaus",
      "Nkaus"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "PEL",
    "translations": [
      "Pelaneng Airport",
      "Pelaneng Airport",
      "Pelaneng Airport"
    ],
    "city": [
      "Pelaneng",
      "Pelaneng",
      "Pelaneng"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "UTG",
    "translations": [
      "Quthing Airport",
      "Quthing Airport",
      "Quthing Airport"
    ],
    "city": [
      "Quthing",
      "Quthing",
      "Quthing"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "UNE",
    "translations": [
      "Qacha's Nek Airport",
      "Qacha's Nek Airport",
      "Qacha's Nek Airport"
    ],
    "city": [
      "Qacha's Nek",
      "Qacha's Nek",
      "Qacha's Nek"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "SHK",
    "translations": [
      "Sehonghong Airport",
      "Sehonghong Airport",
      "Sehonghong Airport"
    ],
    "city": [
      "Sehonghong",
      "Sehonghong",
      "Sehonghong"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "SKQ",
    "translations": [
      "Sekakes Airport",
      "Sekakes Airport",
      "Sekakes Airport"
    ],
    "city": [
      "Sekakes",
      "Sekakes",
      "Sekakes"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "SOK",
    "translations": [
      "Semonkong Airport",
      "Semonkong Airport",
      "Semonkong Airport"
    ],
    "city": [
      "Semonkong",
      "Semonkong",
      "Semonkong"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "SHZ",
    "translations": [
      "Seshutes Airport",
      "Seshutes Airport",
      "Seshutes Airport"
    ],
    "city": [
      "Seshutes",
      "Seshutes",
      "Seshutes"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "THB",
    "translations": [
      "Thaba-Tseka Airport",
      "Thaba-Tseka Airport",
      "Thaba-Tseka Airport"
    ],
    "city": [
      "Thaba-Tseka",
      "Thaba-Tseka",
      "Thaba-Tseka"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "TKO",
    "translations": [
      "Tlokoeng Airport",
      "Tlokoeng Airport",
      "Tlokoeng Airport"
    ],
    "city": [
      "Tlokoeng",
      "Tlokoeng",
      "Tlokoeng"
    ],
    "country": [
      "LS",
      "LS",
      "LS"
    ]
  },
  {
    "iata": "AIW",
    "translations": [
      "Ai-Ais Airport",
      "Ai-Ais Airport",
      "Ai-Ais Airport"
    ],
    "city": [
      "Ai-Ais",
      "Ai-Ais",
      "Ai-Ais"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "ADI",
    "translations": [
      "Arandis Airport",
      "Arandis Airport",
      "Arandis Airport"
    ],
    "city": [
      "Arandis",
      "Arandis",
      "Arandis"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "GOG",
    "translations": [
      "Gobabis Airport",
      "Gobabis Airport",
      "Gobabis Airport"
    ],
    "city": [
      "Gobabis",
      "Gobabis",
      "Gobabis"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "GFY",
    "translations": [
      "Grootfontein Airport",
      "Grootfontein Airport",
      "Grootfontein Airport"
    ],
    "city": [
      "Grootfontein",
      "Grootfontein",
      "Grootfontein"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "HAL",
    "translations": [
      "Halali Airport",
      "Halali Airport",
      "Halali Airport"
    ],
    "city": [
      "Halali",
      "Halali",
      "Halali"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "KAS",
    "translations": [
      "Karasburg Airport",
      "Karasburg Airport",
      "Karasburg Airport"
    ],
    "city": [
      "Karasburg",
      "Karasburg",
      "Karasburg"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "MPA",
    "translations": [
      "Katima Mulilo Airport",
      "Katima Mulilo Airport",
      "Katima Mulilo Airport"
    ],
    "city": [
      "Mpacha",
      "Mpacha",
      "Mpacha"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "KMP",
    "translations": [
      "Keetmanshoop Airport",
      "Keetmanshoop Airport",
      "Keetmanshoop Airport"
    ],
    "city": [
      "Keetmanshoop",
      "Keetmanshoop",
      "Keetmanshoop"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "LHU",
    "translations": [
      "Lianshulu Lodge Airstrip",
      "Lianshulu Lodge Airstrip",
      "Lianshulu Lodge Airstrip"
    ],
    "city": [
      "Muneambuanas",
      "Muneambuanas",
      "Muneambuanas"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "LUD",
    "translations": [
      "Luderitz Airport",
      "Luderitz Airport",
      "Luderitz Airport"
    ],
    "city": [
      "Luderitz",
      "Luderitz",
      "Luderitz"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "MJO",
    "translations": [
      "Mount Etjo Airport",
      "Mount Etjo Airport",
      "Mount Etjo Airport"
    ],
    "city": [
      "Mount Etjo Safari Lodge",
      "Mount Etjo Safari Lodge",
      "Mount Etjo Safari Lodge"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "MQG",
    "translations": [
      "Midgard Airport",
      "Midgard Airport",
      "Midgard Airport"
    ],
    "city": [
      "Midgard",
      "Midgard",
      "Midgard"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "OKU",
    "translations": [
      "Mokuti Lodge Airport",
      "Mokuti Lodge Airport",
      "Mokuti Lodge Airport"
    ],
    "city": [
      "Mokuti Lodge",
      "Mokuti Lodge",
      "Mokuti Lodge"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "NNI",
    "translations": [
      "Namutoni Airport",
      "Namutoni Airport",
      "Namutoni Airport"
    ],
    "city": [
      "Namutoni",
      "Namutoni",
      "Namutoni"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "OGV",
    "translations": [
      "Ongava Lodge Airstrip",
      "Ongava Lodge Airstrip",
      "Ongava Lodge Airstrip"
    ],
    "city": [
      "Ombika",
      "Ombika",
      "Ombika"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "OND",
    "translations": [
      "Ondangwa Airport",
      "Ondangwa Airport",
      "Ondangwa Airport"
    ],
    "city": [
      "Ondangwa",
      "Ondangwa",
      "Ondangwa"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "OMG",
    "translations": [
      "Omega Airport",
      "Omega Airport",
      "Omega Airport"
    ],
    "city": [
      "Omega",
      "Omega",
      "Omega"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "OMD",
    "translations": [
      "Oranjemund Airport",
      "Oranjemund Airport",
      "Oranjemund Airport"
    ],
    "city": [
      "Oranjemund",
      "Oranjemund",
      "Oranjemund"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "OKF",
    "translations": [
      "Okaukuejo Airport",
      "Okaukuejo Airport",
      "Okaukuejo Airport"
    ],
    "city": [
      "Okaukuejo",
      "Okaukuejo",
      "Okaukuejo"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "OPW",
    "translations": [
      "Opuwa Airport",
      "Opuwa Airport",
      "Opuwa Airport"
    ],
    "city": [
      "Opuwa",
      "Opuwa",
      "Opuwa"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "OHI",
    "translations": [
      "Oshakati Airport",
      "Oshakati Airport",
      "Oshakati Airport"
    ],
    "city": [
      "Oshakati",
      "Oshakati",
      "Oshakati"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "OTJ",
    "translations": [
      "Otjiwarongo Airport",
      "Otjiwarongo Airport",
      "Otjiwarongo Airport"
    ],
    "city": [
      "Otjiwarongo",
      "Otjiwarongo",
      "Otjiwarongo"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "NDU",
    "translations": [
      "Rundu Airport",
      "Rundu Airport",
      "Rundu Airport"
    ],
    "city": [
      "Rundu",
      "Rundu",
      "Rundu"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "RHN",
    "translations": [
      "Skorpion Mine Airport",
      "Skorpion Mine Airport",
      "Skorpion Mine Airport"
    ],
    "city": [
      "Rosh Pinah",
      "Rosh Pinah",
      "Rosh Pinah"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "SWP",
    "translations": [
      "Swakopmund Municipal Aerodrome",
      "Swakopmund Municipal Aerodrome",
      "Swakopmund Municipal Aerodrome"
    ],
    "city": [
      "Swakopmund",
      "Swakopmund",
      "Swakopmund"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "SZM",
    "translations": [
      "Sesriem Airport",
      "Sesriem Airport",
      "Sesriem Airport"
    ],
    "city": [
      "Sesriem",
      "Sesriem",
      "Sesriem"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "TCY",
    "translations": [
      "Terrace Bay Airport",
      "Terrace Bay Airport",
      "Terrace Bay Airport"
    ],
    "city": [
      "Terrace Bay",
      "Terrace Bay",
      "Terrace Bay"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "TSB",
    "translations": [
      "Tsumeb Airport",
      "Tsumeb Airport",
      "Tsumeb Airport"
    ],
    "city": [
      "Tsumeb",
      "Tsumeb",
      "Tsumeb"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "WVB",
    "translations": [
      "Walvis Bay Airport",
      "Walvis Bay Airport",
      "Walvis Bay Airport"
    ],
    "city": [
      "Rooikop",
      "Rooikop",
      "Rooikop"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "ERS",
    "translations": [
      "Eros Airport",
      "Eros Airport",
      "Eros Airport"
    ],
    "city": [
      "Windhoek",
      "Windhoek",
      "Windhoek"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "WDH",
    "translations": [
      "Hosea Kutako International Airport",
      "Hosea Kutako International Airport",
      "Hosea Kutako International Airport"
    ],
    "city": [
      "Windhoek",
      "Windhoek",
      "Windhoek"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "FIH",
    "translations": [
      "Ndjili International Airport",
      "Ndjili International Airport",
      "Ndjili International Airport"
    ],
    "city": [
      "Kinshasa",
      "Kinshasa",
      "Kinshasa"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "NLO",
    "translations": [
      "Ndolo Airport",
      "Ndolo Airport",
      "Ndolo Airport"
    ],
    "city": [
      "N'dolo",
      "N'dolo",
      "N'dolo"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "MNB",
    "translations": [
      "Muanda Airport",
      "Muanda Airport",
      "Muanda Airport"
    ],
    "city": [
      "Muanda",
      "Muanda",
      "Muanda"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "BOA",
    "translations": [
      "Boma Airport",
      "Boma Airport",
      "Boma Airport"
    ],
    "city": [
      "Boma",
      "Boma",
      "Boma"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "LZI",
    "translations": [
      "Luozi Airport",
      "Luozi Airport",
      "Luozi Airport"
    ],
    "city": [
      "Luozi",
      "Luozi",
      "Luozi"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "MAT",
    "translations": [
      "Tshimpi Airport",
      "Tshimpi Airport",
      "Tshimpi Airport"
    ],
    "city": [
      "Matadi",
      "Matadi",
      "Matadi"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "NKL",
    "translations": [
      "N'Kolo-Fuma Airport",
      "N'Kolo-Fuma Airport",
      "N'Kolo-Fuma Airport"
    ],
    "city": [
      "N'Kolo-Fuma",
      "N'Kolo-Fuma",
      "N'Kolo-Fuma"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "INO",
    "translations": [
      "Inongo Airport",
      "Inongo Airport",
      "Inongo Airport"
    ],
    "city": [
      "Inongo",
      "Inongo",
      "Inongo"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "NIO",
    "translations": [
      "Nioki Airport",
      "Nioki Airport",
      "Nioki Airport"
    ],
    "city": [
      "Nioki",
      "Nioki",
      "Nioki"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "FDU",
    "translations": [
      "Bandundu Airport",
      "Bandundu Airport",
      "Bandundu Airport"
    ],
    "city": [
      "Bandundu",
      "Bandundu",
      "Bandundu"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KRZ",
    "translations": [
      "Kiri Airport",
      "Kiri Airport",
      "Kiri Airport"
    ],
    "city": [
      "Kiri",
      "Kiri",
      "Kiri"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KKW",
    "translations": [
      "Kikwit Airport",
      "Kikwit Airport",
      "Kikwit Airport"
    ],
    "city": [
      "Kikwit",
      "Kikwit",
      "Kikwit"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "IDF",
    "translations": [
      "Idiofa Airport",
      "Idiofa Airport",
      "Idiofa Airport"
    ],
    "city": [
      "Idiofa",
      "Idiofa",
      "Idiofa"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "MSM",
    "translations": [
      "Masi Manimba Airport",
      "Masi Manimba Airport",
      "Masi Manimba Airport"
    ],
    "city": [
      "Masi Manimba",
      "Masi Manimba",
      "Masi Manimba"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "MDK",
    "translations": [
      "Mbandaka Airport",
      "Mbandaka Airport",
      "Mbandaka Airport"
    ],
    "city": [
      "Mbandaka",
      "Mbandaka",
      "Mbandaka"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "BSU",
    "translations": [
      "Basankusu Airport",
      "Basankusu Airport",
      "Basankusu Airport"
    ],
    "city": [
      "Basankusu",
      "Basankusu",
      "Basankusu"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "LIE",
    "translations": [
      "Libenge Airport",
      "Libenge Airport",
      "Libenge Airport"
    ],
    "city": [
      "Libenge",
      "Libenge",
      "Libenge"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "BDT",
    "translations": [
      "Gbadolite Airport",
      "Gbadolite Airport",
      "Gbadolite Airport"
    ],
    "city": [
      "Gbadolite",
      "Gbadolite",
      "Gbadolite"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "GMA",
    "translations": [
      "Gemena Airport",
      "Gemena Airport",
      "Gemena Airport"
    ],
    "city": [
      "Gemena",
      "Gemena",
      "Gemena"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KLI",
    "translations": [
      "Kotakoli Airbase",
      "Kotakoli Airbase",
      "Kotakoli Airbase"
    ],
    "city": [
      "Kotakoli",
      "Kotakoli",
      "Kotakoli"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "BMB",
    "translations": [
      "Bumba Airport",
      "Bumba Airport",
      "Bumba Airport"
    ],
    "city": [
      "Bumba",
      "Bumba",
      "Bumba"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "LIQ",
    "translations": [
      "Lisala Airport",
      "Lisala Airport",
      "Lisala Airport"
    ],
    "city": [
      "Lisala",
      "Lisala",
      "Lisala"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "BNB",
    "translations": [
      "Boende Airport",
      "Boende Airport",
      "Boende Airport"
    ],
    "city": [
      "Boende",
      "Boende",
      "Boende"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "IKL",
    "translations": [
      "Ikela Airport",
      "Ikela Airport",
      "Ikela Airport"
    ],
    "city": [
      "Ikela",
      "Ikela",
      "Ikela"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "FKI",
    "translations": [
      "Bangoka International Airport",
      "Bangoka International Airport",
      "Bangoka International Airport"
    ],
    "city": [
      "Kisangani",
      "Kisangani",
      "Kisangani"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "YAN",
    "translations": [
      "Yangambi Airport",
      "Yangambi Airport",
      "Yangambi Airport"
    ],
    "city": [
      "Yangambi",
      "Yangambi",
      "Yangambi"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "IRP",
    "translations": [
      "Matari Airport",
      "Matari Airport",
      "Matari Airport"
    ],
    "city": [
      "Isiro",
      "Isiro",
      "Isiro"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "BUX",
    "translations": [
      "Bunia Airport",
      "Bunia Airport",
      "Bunia Airport"
    ],
    "city": [
      "Bunia",
      "Bunia",
      "Bunia"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "BZU",
    "translations": [
      "Buta Zega Airport",
      "Buta Zega Airport",
      "Buta Zega Airport"
    ],
    "city": [
      "Buta",
      "Buta",
      "Buta"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "BKY",
    "translations": [
      "Bukavu Kavumu Airport",
      "Bukavu Kavumu Airport",
      "Bukavu Kavumu Airport"
    ],
    "city": [
      "Kamakombe",
      "Kamakombe",
      "Kamakombe"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "RUE",
    "translations": [
      "Rughenda Airfield",
      "Rughenda Airfield",
      "Rughenda Airfield"
    ],
    "city": [
      "Butembo",
      "Butembo",
      "Butembo"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "GOM",
    "translations": [
      "Goma International Airport",
      "Goma International Airport",
      "Goma International Airport"
    ],
    "city": [
      "Goma",
      "Goma",
      "Goma"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "BNC",
    "translations": [
      "Beni Airport",
      "Beni Airport",
      "Beni Airport"
    ],
    "city": [
      "Beni",
      "Beni",
      "Beni"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KND",
    "translations": [
      "Kindu Airport",
      "Kindu Airport",
      "Kindu Airport"
    ],
    "city": [
      "Kindu",
      "Kindu",
      "Kindu"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KLY",
    "translations": [
      "Kinkungwa Airport",
      "Kinkungwa Airport",
      "Kinkungwa Airport"
    ],
    "city": [
      "Kalima",
      "Kalima",
      "Kalima"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "PUN",
    "translations": [
      "Punia Airport",
      "Punia Airport",
      "Punia Airport"
    ],
    "city": [
      "Punia",
      "Punia",
      "Punia"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "FBM",
    "translations": [
      "Lubumbashi International Airport",
      "Lubumbashi International Airport",
      "Lubumbashi International Airport"
    ],
    "city": [
      "Lubumbashi",
      "Lubumbashi",
      "Lubumbashi"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "PWO",
    "translations": [
      "Pweto Airport",
      "Pweto Airport",
      "Pweto Airport"
    ],
    "city": [
      "Pweto",
      "Pweto",
      "Pweto"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KEC",
    "translations": [
      "Kasenga Airport",
      "Kasenga Airport",
      "Kasenga Airport"
    ],
    "city": [
      "Kasenga",
      "Kasenga",
      "Kasenga"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KWZ",
    "translations": [
      "Kolwezi Airport",
      "Kolwezi Airport",
      "Kolwezi Airport"
    ],
    "city": [
      "Kolwezi",
      "Kolwezi",
      "Kolwezi"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "MNO",
    "translations": [
      "Manono Airport",
      "Manono Airport",
      "Manono Airport"
    ],
    "city": [
      "Manono",
      "Manono",
      "Manono"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "BDV",
    "translations": [
      "Moba Airport",
      "Moba Airport",
      "Moba Airport"
    ],
    "city": [
      "Moba",
      "Moba",
      "Moba"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "FMI",
    "translations": [
      "Kalemie Airport",
      "Kalemie Airport",
      "Kalemie Airport"
    ],
    "city": [
      "Kalemie",
      "Kalemie",
      "Kalemie"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KBO",
    "translations": [
      "Kabalo Airport",
      "Kabalo Airport",
      "Kabalo Airport"
    ],
    "city": [
      "Kabalo",
      "Kabalo",
      "Kabalo"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KOO",
    "translations": [
      "Kongolo Airport",
      "Kongolo Airport",
      "Kongolo Airport"
    ],
    "city": [
      "Kongolo",
      "Kongolo",
      "Kongolo"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KMN",
    "translations": [
      "Kamina City Airport",
      "Kamina City Airport",
      "Kamina City Airport"
    ],
    "city": [
      "Kamina",
      "Kamina",
      "Kamina"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KAP",
    "translations": [
      "Kapanga Airport",
      "Kapanga Airport",
      "Kapanga Airport"
    ],
    "city": [
      "Kapanga",
      "Kapanga",
      "Kapanga"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KNM",
    "translations": [
      "Kaniama Airport",
      "Kaniama Airport",
      "Kaniama Airport"
    ],
    "city": [
      "Kaniama",
      "Kaniama",
      "Kaniama"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KGA",
    "translations": [
      "Kananga Airport",
      "Kananga Airport",
      "Kananga Airport"
    ],
    "city": [
      "Kananga",
      "Kananga",
      "Kananga"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "LZA",
    "translations": [
      "Luiza Airport",
      "Luiza Airport",
      "Luiza Airport"
    ],
    "city": [
      "Luiza",
      "Luiza",
      "Luiza"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "TSH",
    "translations": [
      "Tshikapa Airport",
      "Tshikapa Airport",
      "Tshikapa Airport"
    ],
    "city": [
      "Tshikapa",
      "Tshikapa",
      "Tshikapa"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "LJA",
    "translations": [
      "Lodja Airport",
      "Lodja Airport",
      "Lodja Airport"
    ],
    "city": [
      "Lodja",
      "Lodja",
      "Lodja"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "LBO",
    "translations": [
      "Lusambo Airport",
      "Lusambo Airport",
      "Lusambo Airport"
    ],
    "city": [
      "Lusambo",
      "Lusambo",
      "Lusambo"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "MEW",
    "translations": [
      "Mweka Airport",
      "Mweka Airport",
      "Mweka Airport"
    ],
    "city": [
      "Mweka",
      "Mweka",
      "Mweka"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "BAN",
    "translations": [
      "Basongo Airport",
      "Basongo Airport",
      "Basongo Airport"
    ],
    "city": [
      "Basongo",
      "Basongo",
      "Basongo"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "PFR",
    "translations": [
      "Ilebo Airport",
      "Ilebo Airport",
      "Ilebo Airport"
    ],
    "city": [
      "Ilebo",
      "Ilebo",
      "Ilebo"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "MJM",
    "translations": [
      "Mbuji Mayi Airport",
      "Mbuji Mayi Airport",
      "Mbuji Mayi Airport"
    ],
    "city": [
      "Mbuji Mayi",
      "Mbuji Mayi",
      "Mbuji Mayi"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "KBN",
    "translations": [
      "Tunta Airport",
      "Tunta Airport",
      "Tunta Airport"
    ],
    "city": [
      "Kabinda",
      "Kabinda",
      "Kabinda"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "NKA",
    "translations": [
      "Nkan Airstrip",
      "Nkan Airstrip",
      "Nkan Airstrip"
    ],
    "city": [
      "Ntoum",
      "Ntoum",
      "Ntoum"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "GIM",
    "translations": [
      "Miele Mimbale Airport",
      "Miele Mimbale Airport",
      "Miele Mimbale Airport"
    ],
    "city": [
      "Miele Mimbale",
      "Miele Mimbale",
      "Miele Mimbale"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "GAX",
    "translations": [
      "Gamba Airport",
      "Gamba Airport",
      "Gamba Airport"
    ],
    "city": [
      "Gamba",
      "Gamba",
      "Gamba"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "BKO",
    "translations": [
      "Modibo Keita International Airport",
      "Modibo Keita International Airport",
      "Modibo Keita International Airport"
    ],
    "city": [
      "Bamako",
      "Bamako",
      "Bamako"
    ],
    "country": [
      "ML",
      "ML",
      "ML"
    ]
  },
  {
    "iata": "GUD",
    "translations": [
      "Goundam Airport",
      "Goundam Airport",
      "Goundam Airport"
    ],
    "city": [
      "Goundam",
      "Goundam",
      "Goundam"
    ],
    "country": [
      "ML",
      "ML",
      "ML"
    ]
  },
  {
    "iata": "GAQ",
    "translations": [
      "Gao Airport",
      "Gao Airport",
      "Gao Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "ML",
      "ML",
      "ML"
    ]
  },
  {
    "iata": "KNZ",
    "translations": [
      "Kenieba Airport",
      "Kenieba Airport",
      "Kenieba Airport"
    ],
    "city": [
      "Kenieba",
      "Kenieba",
      "Kenieba"
    ],
    "country": [
      "ML",
      "ML",
      "ML"
    ]
  },
  {
    "iata": "KTX",
    "translations": [
      "Koutiala Airport",
      "Koutiala Airport",
      "Koutiala Airport"
    ],
    "city": [
      "Koutiala",
      "Koutiala",
      "Koutiala"
    ],
    "country": [
      "ML",
      "ML",
      "ML"
    ]
  },
  {
    "iata": "KYS",
    "translations": [
      "Kayes Dag Dag Airport",
      "Kayes Dag Dag Airport",
      "Kayes Dag Dag Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "ML",
      "ML",
      "ML"
    ]
  },
  {
    "iata": "MZI",
    "translations": [
      "Mopti Ambodédjo International Airport",
      "Mopti Ambodédjo International Airport",
      "Mopti Ambodédjo International Airport"
    ],
    "city": [
      "Sévaré",
      "Sévaré",
      "Sévaré"
    ],
    "country": [
      "ML",
      "ML",
      "ML"
    ]
  },
  {
    "iata": "NRM",
    "translations": [
      "Nara Airport",
      "Nara Airport",
      "Nara Airport"
    ],
    "city": [
      "Nara",
      "Nara",
      "Nara"
    ],
    "country": [
      "ML",
      "ML",
      "ML"
    ]
  },
  {
    "iata": "NIX",
    "translations": [
      "Nioro du Sahel Airport",
      "Nioro du Sahel Airport",
      "Nioro du Sahel Airport"
    ],
    "city": [
      "Nioro du Sahel",
      "Nioro du Sahel",
      "Nioro du Sahel"
    ],
    "country": [
      "ML",
      "ML",
      "ML"
    ]
  },
  {
    "iata": "KSS",
    "translations": [
      "Sikasso Airport",
      "Sikasso Airport",
      "Sikasso Airport"
    ],
    "city": [
      "Sikasso",
      "Sikasso",
      "Sikasso"
    ],
    "country": [
      "ML",
      "ML",
      "ML"
    ]
  },
  {
    "iata": "TOM",
    "translations": [
      "Timbuktu Airport",
      "Timbuktu Airport",
      "Timbuktu Airport"
    ],
    "city": [
      "Timbuktu",
      "Timbuktu",
      "Timbuktu"
    ],
    "country": [
      "ML",
      "ML",
      "ML"
    ]
  },
  {
    "iata": "EYL",
    "translations": [
      "Yélimané Airport",
      "Yélimané Airport",
      "Yélimané Airport"
    ],
    "city": [
      "Yélimané",
      "Yélimané",
      "Yélimané"
    ],
    "country": [
      "ML",
      "ML",
      "ML"
    ]
  },
  {
    "iata": "PZE",
    "translations": [
      "Penzance Heliport",
      "Penzance Heliport",
      "Penzance Heliport"
    ],
    "city": [
      "Penzance, Cornwall",
      "Penzance, Cornwall",
      "Penzance, Cornwall"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "FLH",
    "translations": [
      "Flotta Isle Airstrip",
      "Flotta Isle Airstrip",
      "Flotta Isle Airstrip"
    ],
    "city": [
      "Flotta Isle",
      "Flotta Isle",
      "Flotta Isle"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "FOA",
    "translations": [
      "Foula Airfield",
      "Foula Airfield",
      "Foula Airfield"
    ],
    "city": [
      "Foula",
      "Foula",
      "Foula"
    ],
    "country": [
      "GB",
      "GB",
      "GB"
    ]
  },
  {
    "iata": "GBM",
    "translations": [
      "Garbaharey Airport",
      "Garbaharey Airport",
      "Garbaharey Airport"
    ],
    "city": [
      "Garbaharey",
      "Garbaharey",
      "Garbaharey"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "BJL",
    "translations": [
      "Banjul International Airport",
      "Banjul International Airport",
      "Banjul International Airport"
    ],
    "city": [
      "Yundum",
      "Yundum",
      "Yundum"
    ],
    "country": [
      "GM",
      "GM",
      "GM"
    ]
  },
  {
    "iata": "FUE",
    "translations": [
      "Fuerteventura Airport",
      "Fuerteventura Airport",
      "Fuerteventura Airport"
    ],
    "city": [
      "El Matorral",
      "El Matorral",
      "El Matorral"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "GMZ",
    "translations": [
      "La Gomera Airport",
      "La Gomera Airport",
      "La Gomera Airport"
    ],
    "city": [
      "Alajero, La Gomera Island",
      "Alajero, La Gomera Island",
      "Alajero, La Gomera Island"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "VDE",
    "translations": [
      "El Hierro Airport",
      "El Hierro Airport",
      "El Hierro Airport"
    ],
    "city": [
      "El Hierro Island",
      "El Hierro Island",
      "El Hierro Island"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "SPC",
    "translations": [
      "La Palma Airport",
      "La Palma Airport",
      "La Palma Airport"
    ],
    "city": [
      "Sta Cruz de la Palma, La Palma Island",
      "Sta Cruz de la Palma, La Palma Island",
      "Sta Cruz de la Palma, La Palma Island"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "LPA",
    "translations": [
      "Gran Canaria Airport",
      "Gran Canaria Airport",
      "Gran Canaria Airport"
    ],
    "city": [
      "Gran Canaria Island",
      "Gran Canaria Island",
      "Gran Canaria Island"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "ACE",
    "translations": [
      "César Manrique-Lanzarote Airport",
      "César Manrique-Lanzarote Airport",
      "César Manrique-Lanzarote Airport"
    ],
    "city": [
      "San Bartolomé",
      "San Bartolomé",
      "San Bartolomé"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "TFS",
    "translations": [
      "Tenerife Sur Airport",
      "Tenerife Sur Airport",
      "Tenerife Sur Airport"
    ],
    "city": [
      "Tenerife",
      "Tenerife",
      "Tenerife"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "GCV",
    "translations": [
      "Gravatai Airport",
      "Gravatai Airport",
      "Gravatai Airport"
    ],
    "city": [
      "Gravatai",
      "Gravatai",
      "Gravatai"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TFN",
    "translations": [
      "Tenerife Norte-Ciudad de La Laguna Airport",
      "Tenerife Norte-Ciudad de La Laguna Airport",
      "Tenerife Norte-Ciudad de La Laguna Airport"
    ],
    "city": [
      "Tenerife",
      "Tenerife",
      "Tenerife"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "JCU",
    "translations": [
      "Ceuta Heliport",
      "Ceuta Heliport",
      "Ceuta Heliport"
    ],
    "city": [
      "Ceuta",
      "Ceuta",
      "Ceuta"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "MLN",
    "translations": [
      "Melilla Airport",
      "Melilla Airport",
      "Melilla Airport"
    ],
    "city": [
      "Melilla",
      "Melilla",
      "Melilla"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "OYC",
    "translations": [
      "Camopi Airport",
      "Camopi Airport",
      "Camopi Airport"
    ],
    "city": [
      "Camopi",
      "Camopi",
      "Camopi"
    ],
    "country": [
      "GF",
      "GF",
      "GF"
    ]
  },
  {
    "iata": "KBS",
    "translations": [
      "Bo Airport",
      "Bo Airport",
      "Bo Airport"
    ],
    "city": [
      "Bo",
      "Bo",
      "Bo"
    ],
    "country": [
      "SL",
      "SL",
      "SL"
    ]
  },
  {
    "iata": "GBK",
    "translations": [
      "Gbangbatok Airport",
      "Gbangbatok Airport",
      "Gbangbatok Airport"
    ],
    "city": [
      "Gbangbatok",
      "Gbangbatok",
      "Gbangbatok"
    ],
    "country": [
      "SL",
      "SL",
      "SL"
    ]
  },
  {
    "iata": "HGS",
    "translations": [
      "Hastings Airport",
      "Hastings Airport",
      "Hastings Airport"
    ],
    "city": [
      "Freetown",
      "Freetown",
      "Freetown"
    ],
    "country": [
      "SL",
      "SL",
      "SL"
    ]
  },
  {
    "iata": "KBA",
    "translations": [
      "Kabala Airport",
      "Kabala Airport",
      "Kabala Airport"
    ],
    "city": [
      "Kabala",
      "Kabala",
      "Kabala"
    ],
    "country": [
      "SL",
      "SL",
      "SL"
    ]
  },
  {
    "iata": "KEN",
    "translations": [
      "Kenema Airport",
      "Kenema Airport",
      "Kenema Airport"
    ],
    "city": [
      "Kenema",
      "Kenema",
      "Kenema"
    ],
    "country": [
      "SL",
      "SL",
      "SL"
    ]
  },
  {
    "iata": "FNA",
    "translations": [
      "Lungi International Airport",
      "Lungi International Airport",
      "Lungi International Airport"
    ],
    "city": [
      "Freetown (Lungi-Town)",
      "Freetown (Lungi-Town)",
      "Freetown (Lungi-Town)"
    ],
    "country": [
      "SL",
      "SL",
      "SL"
    ]
  },
  {
    "iata": "WYE",
    "translations": [
      "Yengema Airport",
      "Yengema Airport",
      "Yengema Airport"
    ],
    "city": [
      "Yengema",
      "Yengema",
      "Yengema"
    ],
    "country": [
      "SL",
      "SL",
      "SL"
    ]
  },
  {
    "iata": "BQE",
    "translations": [
      "Bubaque Airport",
      "Bubaque Airport",
      "Bubaque Airport"
    ],
    "city": [
      "Bubaque",
      "Bubaque",
      "Bubaque"
    ],
    "country": [
      "GW",
      "GW",
      "GW"
    ]
  },
  {
    "iata": "OXB",
    "translations": [
      "Osvaldo Vieira International Airport",
      "Osvaldo Vieira International Airport",
      "Osvaldo Vieira International Airport"
    ],
    "city": [
      "Bissau",
      "Bissau",
      "Bissau"
    ],
    "country": [
      "GW",
      "GW",
      "GW"
    ]
  },
  {
    "iata": "GHE",
    "translations": [
      "Garachiné Airport",
      "Garachiné Airport",
      "Garachiné Airport"
    ],
    "city": [
      "Garachiné",
      "Garachiné",
      "Garachiné"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "QCU",
    "translations": [
      "Akunnaaq Heliport",
      "Akunnaaq Heliport",
      "Akunnaaq Heliport"
    ],
    "city": [
      "Akunnaaq",
      "Akunnaaq",
      "Akunnaaq"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "UCN",
    "translations": [
      "Buchanan Airport",
      "Buchanan Airport",
      "Buchanan Airport"
    ],
    "city": [
      "Buchanan",
      "Buchanan",
      "Buchanan"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "CPA",
    "translations": [
      "Cape Palmas Airport",
      "Cape Palmas Airport",
      "Cape Palmas Airport"
    ],
    "city": [
      "Harper",
      "Harper",
      "Harper"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "SNI",
    "translations": [
      "Greenville/Sinoe Airport",
      "Greenville/Sinoe Airport",
      "Greenville/Sinoe Airport"
    ],
    "city": [
      "Greenville",
      "Greenville",
      "Greenville"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "MLW",
    "translations": [
      "Spriggs Payne Airport",
      "Spriggs Payne Airport",
      "Spriggs Payne Airport"
    ],
    "city": [
      "Monrovia",
      "Monrovia",
      "Monrovia"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "NIA",
    "translations": [
      "Nimba Airport",
      "Nimba Airport",
      "Nimba Airport"
    ],
    "city": [
      "Nimba",
      "Nimba",
      "Nimba"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "ROB",
    "translations": [
      "Roberts International Airport",
      "Roberts International Airport",
      "Roberts International Airport"
    ],
    "city": [
      "Monrovia",
      "Monrovia",
      "Monrovia"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "SAZ",
    "translations": [
      "Sasstown Airport",
      "Sasstown Airport",
      "Sasstown Airport"
    ],
    "city": [
      "Sasstown",
      "Sasstown",
      "Sasstown"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "THC",
    "translations": [
      "Tchien Airport",
      "Tchien Airport",
      "Tchien Airport"
    ],
    "city": [
      "Zwedru",
      "Zwedru",
      "Zwedru"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "VOI",
    "translations": [
      "Voinjama Airport",
      "Voinjama Airport",
      "Voinjama Airport"
    ],
    "city": [
      "Voinjama",
      "Voinjama",
      "Voinjama"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "AGA",
    "translations": [
      "Al Massira Airport",
      "Al Massira Airport",
      "Al Massira Airport"
    ],
    "city": [
      "Agadir (Temsia)",
      "Agadir (Temsia)",
      "Agadir (Temsia)"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "TTA",
    "translations": [
      "Tan Tan Airport",
      "Tan Tan Airport",
      "Tan Tan Airport"
    ],
    "city": [
      "Tan Tan",
      "Tan Tan",
      "Tan Tan"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "OZG",
    "translations": [
      "Zagora Airport",
      "Zagora Airport",
      "Zagora Airport"
    ],
    "city": [
      "Zagora",
      "Zagora",
      "Zagora"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "UAR",
    "translations": [
      "Bouarfa Airport",
      "Bouarfa Airport",
      "Bouarfa Airport"
    ],
    "city": [
      "Bouarfa",
      "Bouarfa",
      "Bouarfa"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "FEZ",
    "translations": [
      "Fes Saïss International Airport",
      "Fes Saïss International Airport",
      "Fes Saïss International Airport"
    ],
    "city": [
      "Saïss",
      "Saïss",
      "Saïss"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "ERH",
    "translations": [
      "Moulay Ali Cherif Airport",
      "Moulay Ali Cherif Airport",
      "Moulay Ali Cherif Airport"
    ],
    "city": [
      "Errachidia",
      "Errachidia",
      "Errachidia"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "MEK",
    "translations": [
      "Bassatine Airport",
      "Bassatine Airport",
      "Bassatine Airport"
    ],
    "city": [
      "Meknes",
      "Meknes",
      "Meknes"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "OUD",
    "translations": [
      "Oujda Angads Airport",
      "Oujda Angads Airport",
      "Oujda Angads Airport"
    ],
    "city": [
      "Ahl Angad",
      "Ahl Angad",
      "Ahl Angad"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "SMW",
    "translations": [
      "Smara Airport",
      "Smara Airport",
      "Smara Airport"
    ],
    "city": [
      "Smara",
      "Smara",
      "Smara"
    ],
    "country": [
      "EH",
      "EH",
      "EH"
    ]
  },
  {
    "iata": "GMD",
    "translations": [
      "Ben Slimane Airport",
      "Ben Slimane Airport",
      "Ben Slimane Airport"
    ],
    "city": [
      "Ben Slimane",
      "Ben Slimane",
      "Ben Slimane"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "BEM",
    "translations": [
      "Beni Mellal Airport",
      "Beni Mellal Airport",
      "Beni Mellal Airport"
    ],
    "city": [
      "Oulad Yaich",
      "Oulad Yaich",
      "Oulad Yaich"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "RBA",
    "translations": [
      "Rabat-Salé Airport",
      "Rabat-Salé Airport",
      "Rabat-Salé Airport"
    ],
    "city": [
      "Rabat",
      "Rabat",
      "Rabat"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "VIL",
    "translations": [
      "Dakhla Airport",
      "Dakhla Airport",
      "Dakhla Airport"
    ],
    "city": [
      "Dakhla",
      "Dakhla",
      "Dakhla"
    ],
    "country": [
      "EH",
      "EH",
      "EH"
    ]
  },
  {
    "iata": "ESU",
    "translations": [
      "Essaouira-Mogador Airport",
      "Essaouira-Mogador Airport",
      "Essaouira-Mogador Airport"
    ],
    "city": [
      "Essaouira",
      "Essaouira",
      "Essaouira"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "EUN",
    "translations": [
      "Hassan I Airport",
      "Hassan I Airport",
      "Hassan I Airport"
    ],
    "city": [
      "El Aaiún",
      "El Aaiún",
      "El Aaiún"
    ],
    "country": [
      "EH",
      "EH",
      "EH"
    ]
  },
  {
    "iata": "CMN",
    "translations": [
      "Mohammed V International Airport",
      "Mohammed V International Airport",
      "Mohammed V International Airport"
    ],
    "city": [
      "Casablanca",
      "Casablanca",
      "Casablanca"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "NDR",
    "translations": [
      "Nador Al Aaroui International Airport",
      "Nador Al Aaroui International Airport",
      "Nador Al Aaroui International Airport"
    ],
    "city": [
      "Al Aaroui",
      "Al Aaroui",
      "Al Aaroui"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "RAK",
    "translations": [
      "Menara Airport",
      "Menara Airport",
      "Menara Airport"
    ],
    "city": [
      "Marrakech",
      "Marrakech",
      "Marrakech"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "NNA",
    "translations": [
      "Kenitra Air Base",
      "Kenitra Air Base",
      "Kenitra Air Base"
    ],
    "city": [
      "Kenitra",
      "Kenitra",
      "Kenitra"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "OZZ",
    "translations": [
      "Ouarzazate Airport",
      "Ouarzazate Airport",
      "Ouarzazate Airport"
    ],
    "city": [
      "Ouarzazate",
      "Ouarzazate",
      "Ouarzazate"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "AHU",
    "translations": [
      "Cherif Al Idrissi Airport",
      "Cherif Al Idrissi Airport",
      "Cherif Al Idrissi Airport"
    ],
    "city": [
      "Al Hoceima",
      "Al Hoceima",
      "Al Hoceima"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "TTU",
    "translations": [
      "Sania Ramel Airport",
      "Sania Ramel Airport",
      "Sania Ramel Airport"
    ],
    "city": [
      "Tétouan",
      "Tétouan",
      "Tétouan"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "TNG",
    "translations": [
      "Tangier Ibn Battuta Airport",
      "Tangier Ibn Battuta Airport",
      "Tangier Ibn Battuta Airport"
    ],
    "city": [
      "Tangier",
      "Tangier",
      "Tangier"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "GNU",
    "translations": [
      "Goodnews Airport",
      "Goodnews Airport",
      "Goodnews Airport"
    ],
    "city": [
      "Goodnews",
      "Goodnews",
      "Goodnews"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DSS",
    "translations": [
      "Blaise Diagne International Airport",
      "Blaise Diagne International Airport",
      "Blaise Diagne International Airport"
    ],
    "city": [
      "Dakar",
      "Dakar",
      "Dakar"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "KDA",
    "translations": [
      "Kolda Airport",
      "Kolda Airport",
      "Kolda Airport"
    ],
    "city": [
      "Kolda",
      "Kolda",
      "Kolda"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "ZIG",
    "translations": [
      "Ziguinchor Airport",
      "Ziguinchor Airport",
      "Ziguinchor Airport"
    ],
    "city": [
      "Ziguinchor",
      "Ziguinchor",
      "Ziguinchor"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "CSK",
    "translations": [
      "Cap Skirring Airport",
      "Cap Skirring Airport",
      "Cap Skirring Airport"
    ],
    "city": [
      "Cap Skirring",
      "Cap Skirring",
      "Cap Skirring"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "KLC",
    "translations": [
      "Kaolack Airport",
      "Kaolack Airport",
      "Kaolack Airport"
    ],
    "city": [
      "Kaolack",
      "Kaolack",
      "Kaolack"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "DKR",
    "translations": [
      "Léopold Sédar Senghor International Airport",
      "Léopold Sédar Senghor International Airport",
      "Léopold Sédar Senghor International Airport"
    ],
    "city": [
      "Dakar",
      "Dakar",
      "Dakar"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "MAX",
    "translations": [
      "Ouro Sogui Airport",
      "Ouro Sogui Airport",
      "Ouro Sogui Airport"
    ],
    "city": [
      "Ouro Sogui",
      "Ouro Sogui",
      "Ouro Sogui"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "POD",
    "translations": [
      "Podor Airport",
      "Podor Airport",
      "Podor Airport"
    ],
    "city": [
      "Podor",
      "Podor",
      "Podor"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "RDT",
    "translations": [
      "Richard Toll Airport",
      "Richard Toll Airport",
      "Richard Toll Airport"
    ],
    "city": [
      "Richard Toll",
      "Richard Toll",
      "Richard Toll"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "XLS",
    "translations": [
      "Saint Louis Airport",
      "Saint Louis Airport",
      "Saint Louis Airport"
    ],
    "city": [
      "Saint Louis",
      "Saint Louis",
      "Saint Louis"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "BXE",
    "translations": [
      "Bakel Airport",
      "Bakel Airport",
      "Bakel Airport"
    ],
    "city": [
      "Bakel",
      "Bakel",
      "Bakel"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "KGG",
    "translations": [
      "Kédougou Airport",
      "Kédougou Airport",
      "Kédougou Airport"
    ],
    "city": [
      "Kédougou",
      "Kédougou",
      "Kédougou"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "SMY",
    "translations": [
      "Simenti Airport",
      "Simenti Airport",
      "Simenti Airport"
    ],
    "city": [
      "Simenti",
      "Simenti",
      "Simenti"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "TUD",
    "translations": [
      "Tambacounda Airport",
      "Tambacounda Airport",
      "Tambacounda Airport"
    ],
    "city": [
      "Tambacounda",
      "Tambacounda",
      "Tambacounda"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "AEO",
    "translations": [
      "Aioun el Atrouss Airport",
      "Aioun el Atrouss Airport",
      "Aioun el Atrouss Airport"
    ],
    "city": [
      "Aioun El Atrouss",
      "Aioun El Atrouss",
      "Aioun El Atrouss"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "OTL",
    "translations": [
      "Boutilimit Airport",
      "Boutilimit Airport",
      "Boutilimit Airport"
    ],
    "city": [
      "Boutilimit",
      "Boutilimit",
      "Boutilimit"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "THI",
    "translations": [
      "Tichitt Airport",
      "Tichitt Airport",
      "Tichitt Airport"
    ],
    "city": [
      "Tichitt",
      "Tichitt",
      "Tichitt"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "TIY",
    "translations": [
      "Tidjikja Airport",
      "Tidjikja Airport",
      "Tidjikja Airport"
    ],
    "city": [
      "Tidjikja",
      "Tidjikja",
      "Tidjikja"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "BGH",
    "translations": [
      "Abbaye Airport",
      "Abbaye Airport",
      "Abbaye Airport"
    ],
    "city": [
      "Boghe",
      "Boghe",
      "Boghe"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "KFA",
    "translations": [
      "Kiffa Airport",
      "Kiffa Airport",
      "Kiffa Airport"
    ],
    "city": [
      "Kiffa",
      "Kiffa",
      "Kiffa"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "TMD",
    "translations": [
      "Timbedra Airport",
      "Timbedra Airport",
      "Timbedra Airport"
    ],
    "city": [
      "Timbedra",
      "Timbedra",
      "Timbedra"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "EMN",
    "translations": [
      "Néma Airport",
      "Néma Airport",
      "Néma Airport"
    ],
    "city": [
      "Néma",
      "Néma",
      "Néma"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "AJJ",
    "translations": [
      "Akjoujt Airport",
      "Akjoujt Airport",
      "Akjoujt Airport"
    ],
    "city": [
      "Akjoujt",
      "Akjoujt",
      "Akjoujt"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "KED",
    "translations": [
      "Kaédi Airport",
      "Kaédi Airport",
      "Kaédi Airport"
    ],
    "city": [
      "Kaédi",
      "Kaédi",
      "Kaédi"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "MOM",
    "translations": [
      "Letfotar Airport",
      "Letfotar Airport",
      "Letfotar Airport"
    ],
    "city": [
      "Moudjeria",
      "Moudjeria",
      "Moudjeria"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "NKC",
    "translations": [
      "Nouakchott–Oumtounsy International Airport",
      "Nouakchott–Oumtounsy International Airport",
      "Nouakchott–Oumtounsy International Airport"
    ],
    "city": [
      "Nouakchott",
      "Nouakchott",
      "Nouakchott"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "SEY",
    "translations": [
      "Sélibaby Airport",
      "Sélibaby Airport",
      "Sélibaby Airport"
    ],
    "city": [
      "Sélibaby",
      "Sélibaby",
      "Sélibaby"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "THT",
    "translations": [
      "Tamchakett Airport",
      "Tamchakett Airport",
      "Tamchakett Airport"
    ],
    "city": [
      "Tamchakett",
      "Tamchakett",
      "Tamchakett"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "ATR",
    "translations": [
      "Atar International Airport",
      "Atar International Airport",
      "Atar International Airport"
    ],
    "city": [
      "Atar",
      "Atar",
      "Atar"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "FGD",
    "translations": [
      "Fderik Airport",
      "Fderik Airport",
      "Fderik Airport"
    ],
    "city": [
      "Fderik",
      "Fderik",
      "Fderik"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "NDB",
    "translations": [
      "Nouadhibou International Airport",
      "Nouadhibou International Airport",
      "Nouadhibou International Airport"
    ],
    "city": [
      "Nouadhibou",
      "Nouadhibou",
      "Nouadhibou"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "OUZ",
    "translations": [
      "Tazadit Airport",
      "Tazadit Airport",
      "Tazadit Airport"
    ],
    "city": [
      "Zouérate",
      "Zouérate",
      "Zouérate"
    ],
    "country": [
      "MR",
      "MR",
      "MR"
    ]
  },
  {
    "iata": "GRC",
    "translations": [
      "Grand Cess Airport",
      "Grand Cess Airport",
      "Grand Cess Airport"
    ],
    "city": [
      "Grand Cess",
      "Grand Cess",
      "Grand Cess"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "CIQ",
    "translations": [
      "Chiquimula Airport",
      "Chiquimula Airport",
      "Chiquimula Airport"
    ],
    "city": [
      "Chiquimula",
      "Chiquimula",
      "Chiquimula"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "DON",
    "translations": [
      "Dos Lagunas Airport",
      "Dos Lagunas Airport",
      "Dos Lagunas Airport"
    ],
    "city": [
      "Dos Lagunas",
      "Dos Lagunas",
      "Dos Lagunas"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "ENJ",
    "translations": [
      "El Naranjo Airport",
      "El Naranjo Airport",
      "El Naranjo Airport"
    ],
    "city": [
      "El Naranjo",
      "El Naranjo",
      "El Naranjo"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "PCG",
    "translations": [
      "Paso Caballos Airport",
      "Paso Caballos Airport",
      "Paso Caballos Airport"
    ],
    "city": [
      "Paso Caballos",
      "Paso Caballos",
      "Paso Caballos"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "UAX",
    "translations": [
      "Uaxactun Airport",
      "Uaxactun Airport",
      "Uaxactun Airport"
    ],
    "city": [
      "Uaxactun",
      "Uaxactun",
      "Uaxactun"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "CKY",
    "translations": [
      "Conakry International Airport",
      "Conakry International Airport",
      "Conakry International Airport"
    ],
    "city": [
      "Conakry",
      "Conakry",
      "Conakry"
    ],
    "country": [
      "GN",
      "GN",
      "GN"
    ]
  },
  {
    "iata": "GUE",
    "translations": [
      "Guriaso (Keraso) Airport",
      "Guriaso (Keraso) Airport",
      "Guriaso (Keraso) Airport"
    ],
    "city": [
      "Guriaso",
      "Guriaso",
      "Guriaso"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "FIG",
    "translations": [
      "Fria Airport",
      "Fria Airport",
      "Fria Airport"
    ],
    "city": [
      "Fria",
      "Fria",
      "Fria"
    ],
    "country": [
      "GN",
      "GN",
      "GN"
    ]
  },
  {
    "iata": "FAA",
    "translations": [
      "Faranah Airport",
      "Faranah Airport",
      "Faranah Airport"
    ],
    "city": [
      "Faranah",
      "Faranah",
      "Faranah"
    ],
    "country": [
      "GN",
      "GN",
      "GN"
    ]
  },
  {
    "iata": "KSI",
    "translations": [
      "Kissidougou Airport",
      "Kissidougou Airport",
      "Kissidougou Airport"
    ],
    "city": [
      "Kissidougou",
      "Kissidougou",
      "Kissidougou"
    ],
    "country": [
      "GN",
      "GN",
      "GN"
    ]
  },
  {
    "iata": "LEK",
    "translations": [
      "Tata Airport",
      "Tata Airport",
      "Tata Airport"
    ],
    "city": [
      "Labé",
      "Labé",
      "Labé"
    ],
    "country": [
      "GN",
      "GN",
      "GN"
    ]
  },
  {
    "iata": "MCA",
    "translations": [
      "Macenta Airport",
      "Macenta Airport",
      "Macenta Airport"
    ],
    "city": [
      "Macenta",
      "Macenta",
      "Macenta"
    ],
    "country": [
      "GN",
      "GN",
      "GN"
    ]
  },
  {
    "iata": "NZE",
    "translations": [
      "Nzérékoré Airport",
      "Nzérékoré Airport",
      "Nzérékoré Airport"
    ],
    "city": [
      "Nzérékoré",
      "Nzérékoré",
      "Nzérékoré"
    ],
    "country": [
      "GN",
      "GN",
      "GN"
    ]
  },
  {
    "iata": "BKJ",
    "translations": [
      "Boké Baralande Airport",
      "Boké Baralande Airport",
      "Boké Baralande Airport"
    ],
    "city": [
      "Boké",
      "Boké",
      "Boké"
    ],
    "country": [
      "GN",
      "GN",
      "GN"
    ]
  },
  {
    "iata": "SBI",
    "translations": [
      "Sambailo Airport",
      "Sambailo Airport",
      "Sambailo Airport"
    ],
    "city": [
      "Koundara",
      "Koundara",
      "Koundara"
    ],
    "country": [
      "GN",
      "GN",
      "GN"
    ]
  },
  {
    "iata": "GII",
    "translations": [
      "Siguiri Airport",
      "Siguiri Airport",
      "Siguiri Airport"
    ],
    "city": [
      "Siguiri",
      "Siguiri",
      "Siguiri"
    ],
    "country": [
      "GN",
      "GN",
      "GN"
    ]
  },
  {
    "iata": "SID",
    "translations": [
      "Amílcar Cabral International Airport",
      "Amílcar Cabral International Airport",
      "Amílcar Cabral International Airport"
    ],
    "city": [
      "Espargos",
      "Espargos",
      "Espargos"
    ],
    "country": [
      "CV",
      "CV",
      "CV"
    ]
  },
  {
    "iata": "NTO",
    "translations": [
      "Agostinho Neto Airport",
      "Agostinho Neto Airport",
      "Agostinho Neto Airport"
    ],
    "city": [
      "Ponta do Sol",
      "Ponta do Sol",
      "Ponta do Sol"
    ],
    "country": [
      "CV",
      "CV",
      "CV"
    ]
  },
  {
    "iata": "BVC",
    "translations": [
      "Rabil Airport",
      "Rabil Airport",
      "Rabil Airport"
    ],
    "city": [
      "Rabil",
      "Rabil",
      "Rabil"
    ],
    "country": [
      "CV",
      "CV",
      "CV"
    ]
  },
  {
    "iata": "MMO",
    "translations": [
      "Maio Airport",
      "Maio Airport",
      "Maio Airport"
    ],
    "city": [
      "Vila do Maio",
      "Vila do Maio",
      "Vila do Maio"
    ],
    "country": [
      "CV",
      "CV",
      "CV"
    ]
  },
  {
    "iata": "MTI",
    "translations": [
      "Mosteiros Airport",
      "Mosteiros Airport",
      "Mosteiros Airport"
    ],
    "city": [
      "Vila do Mosteiros",
      "Vila do Mosteiros",
      "Vila do Mosteiros"
    ],
    "country": [
      "CV",
      "CV",
      "CV"
    ]
  },
  {
    "iata": "RAI",
    "translations": [
      "Nelson Mandela International Airport",
      "Nelson Mandela International Airport",
      "Nelson Mandela International Airport"
    ],
    "city": [
      "Praia",
      "Praia",
      "Praia"
    ],
    "country": [
      "CV",
      "CV",
      "CV"
    ]
  },
  {
    "iata": "SFL",
    "translations": [
      "São Filipe Airport",
      "São Filipe Airport",
      "São Filipe Airport"
    ],
    "city": [
      "São Filipe",
      "São Filipe",
      "São Filipe"
    ],
    "country": [
      "CV",
      "CV",
      "CV"
    ]
  },
  {
    "iata": "SNE",
    "translations": [
      "Preguiça Airport",
      "Preguiça Airport",
      "Preguiça Airport"
    ],
    "city": [
      "Preguiça",
      "Preguiça",
      "Preguiça"
    ],
    "country": [
      "CV",
      "CV",
      "CV"
    ]
  },
  {
    "iata": "VXE",
    "translations": [
      "São Pedro Airport",
      "São Pedro Airport",
      "São Pedro Airport"
    ],
    "city": [
      "São Pedro",
      "São Pedro",
      "São Pedro"
    ],
    "country": [
      "CV",
      "CV",
      "CV"
    ]
  },
  {
    "iata": "KNN",
    "translations": [
      "Kankan Airport",
      "Kankan Airport",
      "Kankan Airport"
    ],
    "city": [
      "Kankan",
      "Kankan",
      "Kankan"
    ],
    "country": [
      "GN",
      "GN",
      "GN"
    ]
  },
  {
    "iata": "BCG",
    "translations": [
      "Bemichi Airport",
      "Bemichi Airport",
      "Bemichi Airport"
    ],
    "city": [
      "Kumaka",
      "Kumaka",
      "Kumaka"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "BTO",
    "translations": [
      "Botopasi Airport",
      "Botopasi Airport",
      "Botopasi Airport"
    ],
    "city": [
      "Botopasi",
      "Botopasi",
      "Botopasi"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "DOE",
    "translations": [
      "Djumu-Djomoe Airport",
      "Djumu-Djomoe Airport",
      "Djumu-Djomoe Airport"
    ],
    "city": [
      "Djumu-Djomoe",
      "Djumu-Djomoe",
      "Djumu-Djomoe"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "ADD",
    "translations": [
      "Addis Ababa Bole International Airport",
      "Addis Ababa Bole International Airport",
      "Addis Ababa Bole International Airport"
    ],
    "city": [
      "Addis Ababa",
      "Addis Ababa",
      "Addis Ababa"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "AMH",
    "translations": [
      "Arba Minch Airport",
      "Arba Minch Airport",
      "Arba Minch Airport"
    ],
    "city": [
      "Arba Minch",
      "Arba Minch",
      "Arba Minch"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "AXU",
    "translations": [
      "Axum Airport",
      "Axum Airport",
      "Axum Airport"
    ],
    "city": [
      "Axum",
      "Axum",
      "Axum"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "BCO",
    "translations": [
      "Baco Airport",
      "Baco Airport",
      "Baco Airport"
    ],
    "city": [
      "Baco",
      "Baco",
      "Baco"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "BJR",
    "translations": [
      "Bahir Dar Airport",
      "Bahir Dar Airport",
      "Bahir Dar Airport"
    ],
    "city": [
      "Bahir Dar",
      "Bahir Dar",
      "Bahir Dar"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "BEI",
    "translations": [
      "Beica Airport",
      "Beica Airport",
      "Beica Airport"
    ],
    "city": [
      "Beica",
      "Beica",
      "Beica"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "DSE",
    "translations": [
      "Kombolcha Airport",
      "Kombolcha Airport",
      "Kombolcha Airport"
    ],
    "city": [
      "Dessie",
      "Dessie",
      "Dessie"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "DEM",
    "translations": [
      "Dembidollo Airport",
      "Dembidollo Airport",
      "Dembidollo Airport"
    ],
    "city": [
      "Dembidollo",
      "Dembidollo",
      "Dembidollo"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "DBM",
    "translations": [
      "Debre Markos Airport",
      "Debre Markos Airport",
      "Debre Markos Airport"
    ],
    "city": [
      "Debre Markos",
      "Debre Markos",
      "Debre Markos"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "DIR",
    "translations": [
      "Aba Tenna Dejazmach Yilma International Airport",
      "Aba Tenna Dejazmach Yilma International Airport",
      "Aba Tenna Dejazmach Yilma International Airport"
    ],
    "city": [
      "Dire Dawa",
      "Dire Dawa",
      "Dire Dawa"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "DBT",
    "translations": [
      "Debre Tabor Airport",
      "Debre Tabor Airport",
      "Debre Tabor Airport"
    ],
    "city": [
      "Debre Tabor",
      "Debre Tabor",
      "Debre Tabor"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "FNH",
    "translations": [
      "Fincha Airport",
      "Fincha Airport",
      "Fincha Airport"
    ],
    "city": [
      "Fincha",
      "Fincha",
      "Fincha"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "GOB",
    "translations": [
      "Robe Airport",
      "Robe Airport",
      "Robe Airport"
    ],
    "city": [
      "Goba",
      "Goba",
      "Goba"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "GNN",
    "translations": [
      "Ghinnir Airport",
      "Ghinnir Airport",
      "Ghinnir Airport"
    ],
    "city": [
      "Ghinnir",
      "Ghinnir",
      "Ghinnir"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "GMB",
    "translations": [
      "Gambela Airport",
      "Gambela Airport",
      "Gambela Airport"
    ],
    "city": [
      "Gambela",
      "Gambela",
      "Gambela"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "GDQ",
    "translations": [
      "Gondar Airport",
      "Gondar Airport",
      "Gondar Airport"
    ],
    "city": [
      "Azezo",
      "Azezo",
      "Azezo"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "GDE",
    "translations": [
      "Gode Airport",
      "Gode Airport",
      "Gode Airport"
    ],
    "city": [
      "Gode",
      "Gode",
      "Gode"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "GOR",
    "translations": [
      "Gore Airport",
      "Gore Airport",
      "Gore Airport"
    ],
    "city": [
      "Gore",
      "Gore",
      "Gore"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "QHR",
    "translations": [
      "Harar Meda Airport",
      "Harar Meda Airport",
      "Harar Meda Airport"
    ],
    "city": [
      "Debre Zeyit",
      "Debre Zeyit",
      "Debre Zeyit"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "HUE",
    "translations": [
      "Humera Airport",
      "Humera Airport",
      "Humera Airport"
    ],
    "city": [
      "Akwi",
      "Akwi",
      "Akwi"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "JIJ",
    "translations": [
      "Wilwal International Airport",
      "Wilwal International Airport",
      "Wilwal International Airport"
    ],
    "city": [
      "Jijiga",
      "Jijiga",
      "Jijiga"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "JIM",
    "translations": [
      "Jimma Airport",
      "Jimma Airport",
      "Jimma Airport"
    ],
    "city": [
      "Jimma",
      "Jimma",
      "Jimma"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "ABK",
    "translations": [
      "Kebri Dahar Airport",
      "Kebri Dahar Airport",
      "Kebri Dahar Airport"
    ],
    "city": [
      "Kebri Dahar",
      "Kebri Dahar",
      "Kebri Dahar"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "LFO",
    "translations": [
      "Kelafo East Airport",
      "Kelafo East Airport",
      "Kelafo East Airport"
    ],
    "city": [
      "Kelafo",
      "Kelafo",
      "Kelafo"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "AWA",
    "translations": [
      "Hawassa International Airport",
      "Hawassa International Airport",
      "Hawassa International Airport"
    ],
    "city": [
      "Hawassa",
      "Hawassa",
      "Hawassa"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "LLI",
    "translations": [
      "Lalibela Airport",
      "Lalibela Airport",
      "Lalibela Airport"
    ],
    "city": [
      "Girany Amba",
      "Girany Amba",
      "Girany Amba"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "MKS",
    "translations": [
      "Mekane Selam Airport",
      "Mekane Selam Airport",
      "Mekane Selam Airport"
    ],
    "city": [
      "Mekane Selam",
      "Mekane Selam",
      "Mekane Selam"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "MQX",
    "translations": [
      "Alula Aba Nega Airport",
      "Alula Aba Nega Airport",
      "Alula Aba Nega Airport"
    ],
    "city": [
      "Mekele",
      "Mekele",
      "Mekele"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "ETE",
    "translations": [
      "Metema Airport",
      "Metema Airport",
      "Metema Airport"
    ],
    "city": [
      "Metema",
      "Metema",
      "Metema"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "NDM",
    "translations": [
      "Mendi Airport",
      "Mendi Airport",
      "Mendi Airport"
    ],
    "city": [
      "Mendi",
      "Mendi",
      "Mendi"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "MUJ",
    "translations": [
      "Mui River Airport",
      "Mui River Airport",
      "Mui River Airport"
    ],
    "city": [
      "Omo National Park",
      "Omo National Park",
      "Omo National Park"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "MTF",
    "translations": [
      "Mizan Teferi Airport",
      "Mizan Teferi Airport",
      "Mizan Teferi Airport"
    ],
    "city": [
      "Mizan Teferi",
      "Mizan Teferi",
      "Mizan Teferi"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "EGL",
    "translations": [
      "Negele Airport",
      "Negele Airport",
      "Negele Airport"
    ],
    "city": [
      "Negele Borana",
      "Negele Borana",
      "Negele Borana"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "NEJ",
    "translations": [
      "Nejjo Airport",
      "Nejjo Airport",
      "Nejjo Airport"
    ],
    "city": [
      "Nejo",
      "Nejo",
      "Nejo"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "NEK",
    "translations": [
      "Nekemte Airport",
      "Nekemte Airport",
      "Nekemte Airport"
    ],
    "city": [
      "Nekemte",
      "Nekemte",
      "Nekemte"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "PWI",
    "translations": [
      "Beles Airport",
      "Beles Airport",
      "Beles Airport"
    ],
    "city": [
      "Pawe",
      "Pawe",
      "Pawe"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "SXU",
    "translations": [
      "Soddu Airport",
      "Soddu Airport",
      "Soddu Airport"
    ],
    "city": [
      "Soddu",
      "Soddu",
      "Soddu"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "SKR",
    "translations": [
      "Shakiso Airport",
      "Shakiso Airport",
      "Shakiso Airport"
    ],
    "city": [
      "Shakiso",
      "Shakiso",
      "Shakiso"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "HIL",
    "translations": [
      "Shilavo Airport",
      "Shilavo Airport",
      "Shilavo Airport"
    ],
    "city": [
      "Shilavo",
      "Shilavo",
      "Shilavo"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "SZE",
    "translations": [
      "Semera Airport",
      "Semera Airport",
      "Semera Airport"
    ],
    "city": [
      "Semera",
      "Semera",
      "Semera"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "ASO",
    "translations": [
      "Asosa Airport",
      "Asosa Airport",
      "Asosa Airport"
    ],
    "city": [
      "Asosa",
      "Asosa",
      "Asosa"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "TIE",
    "translations": [
      "Tippi Airport",
      "Tippi Airport",
      "Tippi Airport"
    ],
    "city": [
      "Tippi",
      "Tippi",
      "Tippi"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "WRA",
    "translations": [
      "Warder Airport",
      "Warder Airport",
      "Warder Airport"
    ],
    "city": [
      "Warder",
      "Warder",
      "Warder"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "HAZ",
    "translations": [
      "Hatzfeldhaven Airport",
      "Hatzfeldhaven Airport",
      "Hatzfeldhaven Airport"
    ],
    "city": [
      "Hatzfeldhaven",
      "Hatzfeldhaven",
      "Hatzfeldhaven"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BJM",
    "translations": [
      "Bujumbura Melchior Ndadaye International Airport",
      "Bujumbura Melchior Ndadaye International Airport",
      "Bujumbura Melchior Ndadaye International Airport"
    ],
    "city": [
      "Bujumbura",
      "Bujumbura",
      "Bujumbura"
    ],
    "country": [
      "BI",
      "BI",
      "BI"
    ]
  },
  {
    "iata": "GID",
    "translations": [
      "Gitega Airport",
      "Gitega Airport",
      "Gitega Airport"
    ],
    "city": [
      "Gitega",
      "Gitega",
      "Gitega"
    ],
    "country": [
      "BI",
      "BI",
      "BI"
    ]
  },
  {
    "iata": "KRE",
    "translations": [
      "Kirundo Airport",
      "Kirundo Airport",
      "Kirundo Airport"
    ],
    "city": [
      "Kirundo",
      "Kirundo",
      "Kirundo"
    ],
    "country": [
      "BI",
      "BI",
      "BI"
    ]
  },
  {
    "iata": "HBT",
    "translations": [
      "Hambantota Seaplane Base",
      "Hambantota Seaplane Base",
      "Hambantota Seaplane Base"
    ],
    "city": [
      "Hambantota",
      "Hambantota",
      "Hambantota"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "ALU",
    "translations": [
      "Alula Airport",
      "Alula Airport",
      "Alula Airport"
    ],
    "city": [
      "Alula",
      "Alula",
      "Alula"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "BIB",
    "translations": [
      "Baidoa Airport",
      "Baidoa Airport",
      "Baidoa Airport"
    ],
    "city": [
      "Baidoa",
      "Baidoa",
      "Baidoa"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "CXN",
    "translations": [
      "Candala Airport",
      "Candala Airport",
      "Candala Airport"
    ],
    "city": [
      "Candala",
      "Candala",
      "Candala"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "BSY",
    "translations": [
      "Baardheere Airport",
      "Baardheere Airport",
      "Baardheere Airport"
    ],
    "city": [
      "Baardheere",
      "Baardheere",
      "Baardheere"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "HCM",
    "translations": [
      "Eil Airport",
      "Eil Airport",
      "Eil Airport"
    ],
    "city": [
      "Eyl",
      "Eyl",
      "Eyl"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "BSA",
    "translations": [
      "Bosaso / Bender Qassim International Airport",
      "Bosaso / Bender Qassim International Airport",
      "Bosaso / Bender Qassim International Airport"
    ],
    "city": [
      "Bosaso",
      "Bosaso",
      "Bosaso"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "GSR",
    "translations": [
      "Gardo Airport",
      "Gardo Airport",
      "Gardo Airport"
    ],
    "city": [
      "Gardo",
      "Gardo",
      "Gardo"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "HGA",
    "translations": [
      "Egal International Airport",
      "Egal International Airport",
      "Egal International Airport"
    ],
    "city": [
      "Hargeisa",
      "Hargeisa",
      "Hargeisa"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "BBO",
    "translations": [
      "Berbera Airport",
      "Berbera Airport",
      "Berbera Airport"
    ],
    "city": [
      "Berbera",
      "Berbera",
      "Berbera"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "LGX",
    "translations": [
      "Lugh Ganane Airport",
      "Lugh Ganane Airport",
      "Lugh Ganane Airport"
    ],
    "city": [
      "Luuq",
      "Luuq",
      "Luuq"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "KMU",
    "translations": [
      "Kismayo Airport",
      "Kismayo Airport",
      "Kismayo Airport"
    ],
    "city": [
      "Kismayo",
      "Kismayo",
      "Kismayo"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "MGQ",
    "translations": [
      "Aden Adde International Airport",
      "Aden Adde International Airport",
      "Aden Adde International Airport"
    ],
    "city": [
      "Mogadishu",
      "Mogadishu",
      "Mogadishu"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "BLW",
    "translations": [
      "Beledweyne Airport",
      "Beledweyne Airport",
      "Beledweyne Airport"
    ],
    "city": [
      "Beledweyne",
      "Beledweyne",
      "Beledweyne"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "CMO",
    "translations": [
      "Hobyo Airport",
      "Hobyo Airport",
      "Hobyo Airport"
    ],
    "city": [
      "Hobyo",
      "Hobyo",
      "Hobyo"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "GLK",
    "translations": [
      "Galcaio Airport",
      "Galcaio Airport",
      "Galcaio Airport"
    ],
    "city": [
      "Galcaio",
      "Galcaio",
      "Galcaio"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "CMS",
    "translations": [
      "Iskushuban Airport",
      "Iskushuban Airport",
      "Iskushuban Airport"
    ],
    "city": [
      "Iskushuban",
      "Iskushuban",
      "Iskushuban"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "ERA",
    "translations": [
      "Erigavo Airport",
      "Erigavo Airport",
      "Erigavo Airport"
    ],
    "city": [
      "Erigavo",
      "Erigavo",
      "Erigavo"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "BUO",
    "translations": [
      "Burao Airport",
      "Burao Airport",
      "Burao Airport"
    ],
    "city": [
      "Burao",
      "Burao",
      "Burao"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "GGR",
    "translations": [
      "Garowe Airport",
      "Garowe Airport",
      "Garowe Airport"
    ],
    "city": [
      "Garowe",
      "Garowe",
      "Garowe"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "JIB",
    "translations": [
      "Djibouti-Ambouli Airport",
      "Djibouti-Ambouli Airport",
      "Djibouti-Ambouli Airport"
    ],
    "city": [
      "Djibouti City",
      "Djibouti City",
      "Djibouti City"
    ],
    "country": [
      "DJ",
      "DJ",
      "DJ"
    ]
  },
  {
    "iata": "AII",
    "translations": [
      "Ali-Sabieh Airport",
      "Ali-Sabieh Airport",
      "Ali-Sabieh Airport"
    ],
    "city": [
      "Ali-Sabieh",
      "Ali-Sabieh",
      "Ali-Sabieh"
    ],
    "country": [
      "DJ",
      "DJ",
      "DJ"
    ]
  },
  {
    "iata": "MHI",
    "translations": [
      "Moucha Airport",
      "Moucha Airport",
      "Moucha Airport"
    ],
    "city": [
      "Moucha Island",
      "Moucha Island",
      "Moucha Island"
    ],
    "country": [
      "DJ",
      "DJ",
      "DJ"
    ]
  },
  {
    "iata": "OBC",
    "translations": [
      "Obock Airport",
      "Obock Airport",
      "Obock Airport"
    ],
    "city": [
      "Obock",
      "Obock",
      "Obock"
    ],
    "country": [
      "DJ",
      "DJ",
      "DJ"
    ]
  },
  {
    "iata": "TDJ",
    "translations": [
      "Tadjoura Airport",
      "Tadjoura Airport",
      "Tadjoura Airport"
    ],
    "city": [
      "Tadjoura",
      "Tadjoura",
      "Tadjoura"
    ],
    "country": [
      "DJ",
      "DJ",
      "DJ"
    ]
  },
  {
    "iata": "EMY",
    "translations": [
      "El Minya Airport",
      "El Minya Airport",
      "El Minya Airport"
    ],
    "city": [
      "El Minya",
      "El Minya",
      "El Minya"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "RDL",
    "translations": [
      "Bardawil International Airport",
      "Bardawil International Airport",
      "Bardawil International Airport"
    ],
    "city": [
      "El Hassana",
      "El Hassana",
      "El Hassana"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "SQK",
    "translations": [
      "Sidi EL Barrani Airport",
      "Sidi EL Barrani Airport",
      "Sidi EL Barrani Airport"
    ],
    "city": [
      "Sidi El Barrani",
      "Sidi El Barrani",
      "Sidi El Barrani"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "DBB",
    "translations": [
      "El Alamein International Airport",
      "El Alamein International Airport",
      "El Alamein International Airport"
    ],
    "city": [
      "El Alamein",
      "El Alamein",
      "El Alamein"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "AAC",
    "translations": [
      "El Arish International Airport",
      "El Arish International Airport",
      "El Arish International Airport"
    ],
    "city": [
      "El Arish",
      "El Arish",
      "El Arish"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "ATZ",
    "translations": [
      "Asyut International Airport",
      "Asyut International Airport",
      "Asyut International Airport"
    ],
    "city": [
      "Asyut",
      "Asyut",
      "Asyut"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "HBE",
    "translations": [
      "Borj El Arab International Airport",
      "Borj El Arab International Airport",
      "Borj El Arab International Airport"
    ],
    "city": [
      "Alexandria",
      "Alexandria",
      "Alexandria"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "ABS",
    "translations": [
      "Abu Simbel Airport",
      "Abu Simbel Airport",
      "Abu Simbel Airport"
    ],
    "city": [
      "Abu Simbel",
      "Abu Simbel",
      "Abu Simbel"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "CAI",
    "translations": [
      "Cairo International Airport",
      "Cairo International Airport",
      "Cairo International Airport"
    ],
    "city": [
      "Cairo",
      "Cairo",
      "Cairo"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "CCE",
    "translations": [
      "Capital International Airport",
      "Capital International Airport",
      "Capital International Airport"
    ],
    "city": [
      "New Cairo",
      "New Cairo",
      "New Cairo"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "DAK",
    "translations": [
      "Ad Dakhla Airport",
      "Ad Dakhla Airport",
      "Ad Dakhla Airport"
    ],
    "city": [
      "Dakhla Oases",
      "Dakhla Oases",
      "Dakhla Oases"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "HRG",
    "translations": [
      "Hurghada International Airport",
      "Hurghada International Airport",
      "Hurghada International Airport"
    ],
    "city": [
      "Hurghada",
      "Hurghada",
      "Hurghada"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "EGH",
    "translations": [
      "El Jora Airport",
      "El Jora Airport",
      "El Jora Airport"
    ],
    "city": [
      "El Jora",
      "El Jora",
      "El Jora"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "UVL",
    "translations": [
      "El Kharja Airport",
      "El Kharja Airport",
      "El Kharja Airport"
    ],
    "city": [
      "Kharja Oases",
      "Kharja Oases",
      "Kharja Oases"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "LXR",
    "translations": [
      "Luxor International Airport",
      "Luxor International Airport",
      "Luxor International Airport"
    ],
    "city": [
      "Luxor",
      "Luxor",
      "Luxor"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "RMF",
    "translations": [
      "Marsa Alam International Airport",
      "Marsa Alam International Airport",
      "Marsa Alam International Airport"
    ],
    "city": [
      "Marsa Alam",
      "Marsa Alam",
      "Marsa Alam"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "MUH",
    "translations": [
      "Marsa Matruh International Airport",
      "Marsa Matruh International Airport",
      "Marsa Matruh International Airport"
    ],
    "city": [
      "Marsa Matruh",
      "Marsa Matruh",
      "Marsa Matruh"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "HEO",
    "translations": [
      "Haelogo Airport",
      "Haelogo Airport",
      "Haelogo Airport"
    ],
    "city": [
      "Haelogo",
      "Haelogo",
      "Haelogo"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GSQ",
    "translations": [
      "El Owainat East International Airport",
      "El Owainat East International Airport",
      "El Owainat East International Airport"
    ],
    "city": [
      "Sharq El Owainat",
      "Sharq El Owainat",
      "Sharq El Owainat"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "PSD",
    "translations": [
      "Port Said International Airport",
      "Port Said International Airport",
      "Port Said International Airport"
    ],
    "city": [
      "Port Said",
      "Port Said",
      "Port Said"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "SKV",
    "translations": [
      "Saint Catherine International Airport",
      "Saint Catherine International Airport",
      "Saint Catherine International Airport"
    ],
    "city": [
      "Saint Catherine",
      "Saint Catherine",
      "Saint Catherine"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "HMB",
    "translations": [
      "Sohag International Airport",
      "Sohag International Airport",
      "Sohag International Airport"
    ],
    "city": [
      "Suhaj",
      "Suhaj",
      "Suhaj"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "SSH",
    "translations": [
      "Sharm El Sheikh International Airport",
      "Sharm El Sheikh International Airport",
      "Sharm El Sheikh International Airport"
    ],
    "city": [
      "Sharm El Sheikh",
      "Sharm El Sheikh",
      "Sharm El Sheikh"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "ASW",
    "translations": [
      "Aswan International Airport",
      "Aswan International Airport",
      "Aswan International Airport"
    ],
    "city": [
      "Aswan",
      "Aswan",
      "Aswan"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "SEW",
    "translations": [
      "Siwa Oasis North Airport",
      "Siwa Oasis North Airport",
      "Siwa Oasis North Airport"
    ],
    "city": [
      "Siwa Oasis",
      "Siwa Oasis",
      "Siwa Oasis"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "SPX",
    "translations": [
      "Sphinx International Airport",
      "Sphinx International Airport",
      "Sphinx International Airport"
    ],
    "city": [
      "Al Jiza",
      "Al Jiza",
      "Al Jiza"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "TCP",
    "translations": [
      "Taba International Airport",
      "Taba International Airport",
      "Taba International Airport"
    ],
    "city": [
      "Taba",
      "Taba",
      "Taba"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "ELT",
    "translations": [
      "At Tur Airport",
      "At Tur Airport",
      "At Tur Airport"
    ],
    "city": [
      "At Tur",
      "At Tur",
      "At Tur"
    ],
    "country": [
      "EG",
      "EG",
      "EG"
    ]
  },
  {
    "iata": "HEY",
    "translations": [
      "Hanchey Army (Fort Rucker) Heliport",
      "Hanchey Army (Fort Rucker) Heliport",
      "Hanchey Army (Fort Rucker) Heliport"
    ],
    "city": [
      "Fort Rucker Ozark",
      "Fort Rucker Ozark",
      "Fort Rucker Ozark"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HGT",
    "translations": [
      "Tusi (Hunter Liggett) Army Heliport",
      "Tusi (Hunter Liggett) Army Heliport",
      "Tusi (Hunter Liggett) Army Heliport"
    ],
    "city": [
      "Jolon",
      "Jolon",
      "Jolon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ASM",
    "translations": [
      "Asmara International Airport",
      "Asmara International Airport",
      "Asmara International Airport"
    ],
    "city": [
      "Asmara",
      "Asmara",
      "Asmara"
    ],
    "country": [
      "ER",
      "ER",
      "ER"
    ]
  },
  {
    "iata": "MSW",
    "translations": [
      "Massawa International Airport",
      "Massawa International Airport",
      "Massawa International Airport"
    ],
    "city": [
      "Massawa",
      "Massawa",
      "Massawa"
    ],
    "country": [
      "ER",
      "ER",
      "ER"
    ]
  },
  {
    "iata": "ASA",
    "translations": [
      "Assab International Airport",
      "Assab International Airport",
      "Assab International Airport"
    ],
    "city": [
      "Assab",
      "Assab",
      "Assab"
    ],
    "country": [
      "ER",
      "ER",
      "ER"
    ]
  },
  {
    "iata": "TES",
    "translations": [
      "Tessenei Airport",
      "Tessenei Airport",
      "Tessenei Airport"
    ],
    "city": [
      "Tessenei",
      "Tessenei",
      "Tessenei"
    ],
    "country": [
      "ER",
      "ER",
      "ER"
    ]
  },
  {
    "iata": "HPV",
    "translations": [
      "Princeville Airport",
      "Princeville Airport",
      "Princeville Airport"
    ],
    "city": [
      "Hanalei",
      "Hanalei",
      "Hanalei"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WKL",
    "translations": [
      "Waikoloa Heliport",
      "Waikoloa Heliport",
      "Waikoloa Heliport"
    ],
    "city": [
      "Waikoloa Village",
      "Waikoloa Village",
      "Waikoloa Village"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JUB",
    "translations": [
      "Juba International Airport",
      "Juba International Airport",
      "Juba International Airport"
    ],
    "city": [
      "Juba",
      "Juba",
      "Juba"
    ],
    "country": [
      "SS",
      "SS",
      "SS"
    ]
  },
  {
    "iata": "ASV",
    "translations": [
      "Amboseli Airport",
      "Amboseli Airport",
      "Amboseli Airport"
    ],
    "city": [
      "Amboseli National Park",
      "Amboseli National Park",
      "Amboseli National Park"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "HKB",
    "translations": [
      "Healy Lake Airport",
      "Healy Lake Airport",
      "Healy Lake Airport"
    ],
    "city": [
      "Healy Lake",
      "Healy Lake",
      "Healy Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EDL",
    "translations": [
      "Eldoret International Airport",
      "Eldoret International Airport",
      "Eldoret International Airport"
    ],
    "city": [
      "Eldoret",
      "Eldoret",
      "Eldoret"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "EYS",
    "translations": [
      "Eliye Springs Airport",
      "Eliye Springs Airport",
      "Eliye Springs Airport"
    ],
    "city": [
      "Eliye Springs",
      "Eliye Springs",
      "Eliye Springs"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "KLK",
    "translations": [
      "Kalokol Airport",
      "Kalokol Airport",
      "Kalokol Airport"
    ],
    "city": [
      "Kalokol",
      "Kalokol",
      "Kalokol"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "GAS",
    "translations": [
      "Garissa Airport",
      "Garissa Airport",
      "Garissa Airport"
    ],
    "city": [
      "Garissa",
      "Garissa",
      "Garissa"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "HOA",
    "translations": [
      "Hola Airport",
      "Hola Airport",
      "Hola Airport"
    ],
    "city": [
      "Hola",
      "Hola",
      "Hola"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "NBO",
    "translations": [
      "Jomo Kenyatta International Airport",
      "Jomo Kenyatta International Airport",
      "Jomo Kenyatta International Airport"
    ],
    "city": [
      "Nairobi",
      "Nairobi",
      "Nairobi"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "KEU",
    "translations": [
      "Keekorok Airport",
      "Keekorok Airport",
      "Keekorok Airport"
    ],
    "city": [
      "Keekorok",
      "Keekorok",
      "Keekorok"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "GGM",
    "translations": [
      "Kakamega Airport",
      "Kakamega Airport",
      "Kakamega Airport"
    ],
    "city": [
      "Kakamega",
      "Kakamega",
      "Kakamega"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "KIS",
    "translations": [
      "Kisumu Airport",
      "Kisumu Airport",
      "Kisumu Airport"
    ],
    "city": [
      "Kisumu",
      "Kisumu",
      "Kisumu"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "ILU",
    "translations": [
      "Kilaguni Airport",
      "Kilaguni Airport",
      "Kilaguni Airport"
    ],
    "city": [
      "Kilaguni",
      "Kilaguni",
      "Kilaguni"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "KEY",
    "translations": [
      "Kericho Airport",
      "Kericho Airport",
      "Kericho Airport"
    ],
    "city": [
      "Kericho",
      "Kericho",
      "Kericho"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "KTL",
    "translations": [
      "Kitale Airport",
      "Kitale Airport",
      "Kitale Airport"
    ],
    "city": [
      "Kitale",
      "Kitale",
      "Kitale"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "LKG",
    "translations": [
      "Lokichogio Airport",
      "Lokichogio Airport",
      "Lokichogio Airport"
    ],
    "city": [
      "Lokichogio",
      "Lokichogio",
      "Lokichogio"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "LOK",
    "translations": [
      "Lodwar Airport",
      "Lodwar Airport",
      "Lodwar Airport"
    ],
    "city": [
      "Lodwar",
      "Lodwar",
      "Lodwar"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "LAU",
    "translations": [
      "Manda Airport",
      "Manda Airport",
      "Manda Airport"
    ],
    "city": [
      "Lamu",
      "Lamu",
      "Lamu"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "LOY",
    "translations": [
      "Loyengalani Airport",
      "Loyengalani Airport",
      "Loyengalani Airport"
    ],
    "city": [
      "Loyengalani",
      "Loyengalani",
      "Loyengalani"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "NDE",
    "translations": [
      "Mandera Airport",
      "Mandera Airport",
      "Mandera Airport"
    ],
    "city": [
      "Mandera",
      "Mandera",
      "Mandera"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "RBT",
    "translations": [
      "Marsabit Airport",
      "Marsabit Airport",
      "Marsabit Airport"
    ],
    "city": [
      "Marsabit",
      "Marsabit",
      "Marsabit"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "JJM",
    "translations": [
      "Mulika Lodge Airport",
      "Mulika Lodge Airport",
      "Mulika Lodge Airport"
    ],
    "city": [
      "Meru-Kinna",
      "Meru-Kinna",
      "Meru-Kinna"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "MYD",
    "translations": [
      "Malindi Airport",
      "Malindi Airport",
      "Malindi Airport"
    ],
    "city": [
      "Malindi",
      "Malindi",
      "Malindi"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "MBA",
    "translations": [
      "Moi International Airport",
      "Moi International Airport",
      "Moi International Airport"
    ],
    "city": [
      "Mombasa",
      "Mombasa",
      "Mombasa"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "MRE",
    "translations": [
      "Mara Serena Lodge Airstrip",
      "Mara Serena Lodge Airstrip",
      "Mara Serena Lodge Airstrip"
    ],
    "city": [
      "Masai Mara",
      "Masai Mara",
      "Masai Mara"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "OYL",
    "translations": [
      "Moyale Airport",
      "Moyale Airport",
      "Moyale Airport"
    ],
    "city": [
      "Moyale (Lower)",
      "Moyale (Lower)",
      "Moyale (Lower)"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "NYE",
    "translations": [
      "Nyeri Airport",
      "Nyeri Airport",
      "Nyeri Airport"
    ],
    "city": [
      "Nyeri",
      "Nyeri",
      "Nyeri"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "NUU",
    "translations": [
      "Nakuru Airport",
      "Nakuru Airport",
      "Nakuru Airport"
    ],
    "city": [
      "Nakuru",
      "Nakuru",
      "Nakuru"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "NYK",
    "translations": [
      "Nanyuki Airport",
      "Nanyuki Airport",
      "Nanyuki Airport"
    ],
    "city": [
      "Nanyuki",
      "Nanyuki",
      "Nanyuki"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "WIL",
    "translations": [
      "Nairobi Wilson Airport",
      "Nairobi Wilson Airport",
      "Nairobi Wilson Airport"
    ],
    "city": [
      "Nairobi",
      "Nairobi",
      "Nairobi"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "UAS",
    "translations": [
      "Samburu Airport",
      "Samburu Airport",
      "Samburu Airport"
    ],
    "city": [
      "Samburu",
      "Samburu",
      "Samburu"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "UKA",
    "translations": [
      "Ukunda Airstrip",
      "Ukunda Airstrip",
      "Ukunda Airstrip"
    ],
    "city": [
      "Ukunda",
      "Ukunda",
      "Ukunda"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "WJR",
    "translations": [
      "Wajir Airport",
      "Wajir Airport",
      "Wajir Airport"
    ],
    "city": [
      "Wajir",
      "Wajir",
      "Wajir"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "SRX",
    "translations": [
      "Sirt International Airport / Ghardabiya Airbase",
      "Sirt International Airport / Ghardabiya Airbase",
      "Sirt International Airport / Ghardabiya Airbase"
    ],
    "city": [
      "Sirt",
      "Sirt",
      "Sirt"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "GHT",
    "translations": [
      "Ghat Airport",
      "Ghat Airport",
      "Ghat Airport"
    ],
    "city": [
      "Ghat",
      "Ghat",
      "Ghat"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "AKF",
    "translations": [
      "Kufra Airport",
      "Kufra Airport",
      "Kufra Airport"
    ],
    "city": [
      "Kufra",
      "Kufra",
      "Kufra"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "BEN",
    "translations": [
      "Benina International Airport",
      "Benina International Airport",
      "Benina International Airport"
    ],
    "city": [
      "Benina",
      "Benina",
      "Benina"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "MJI",
    "translations": [
      "Mitiga International Airport",
      "Mitiga International Airport",
      "Mitiga International Airport"
    ],
    "city": [
      "Tripoli",
      "Tripoli",
      "Tripoli"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "LAQ",
    "translations": [
      "Al Abraq International Airport",
      "Al Abraq International Airport",
      "Al Abraq International Airport"
    ],
    "city": [
      "Al Albraq",
      "Al Albraq",
      "Al Albraq"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "SEB",
    "translations": [
      "Sabha Airport",
      "Sabha Airport",
      "Sabha Airport"
    ],
    "city": [
      "Sabha",
      "Sabha",
      "Sabha"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "LMQ",
    "translations": [
      "Marsa al Brega Airport",
      "Marsa al Brega Airport",
      "Marsa al Brega Airport"
    ],
    "city": [
      "Marsa al Brega",
      "Marsa al Brega",
      "Marsa al Brega"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "MRA",
    "translations": [
      "Misrata International Airport",
      "Misrata International Airport",
      "Misrata International Airport"
    ],
    "city": [
      "Misrata",
      "Misrata",
      "Misrata"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "NFR",
    "translations": [
      "Nafurah 1 Airport",
      "Nafurah 1 Airport",
      "Nafurah 1 Airport"
    ],
    "city": [
      "Nafurah 1",
      "Nafurah 1",
      "Nafurah 1"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "HUQ",
    "translations": [
      "Hon Airport",
      "Hon Airport",
      "Hon Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "LTD",
    "translations": [
      "Ghadames East Airport",
      "Ghadames East Airport",
      "Ghadames East Airport"
    ],
    "city": [
      "Ghadames",
      "Ghadames",
      "Ghadames"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "TOB",
    "translations": [
      "Tobruk International Airport",
      "Tobruk International Airport",
      "Tobruk International Airport"
    ],
    "city": [
      "Adam",
      "Adam",
      "Adam"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "QUB",
    "translations": [
      "Ubari Airport",
      "Ubari Airport",
      "Ubari Airport"
    ],
    "city": [
      "Ubari",
      "Ubari",
      "Ubari"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "ZIS",
    "translations": [
      "Alzintan Airport",
      "Alzintan Airport",
      "Alzintan Airport"
    ],
    "city": [
      "Zintan",
      "Zintan",
      "Zintan"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "WAX",
    "translations": [
      "Zuwarah International Airport",
      "Zuwarah International Airport",
      "Zuwarah International Airport"
    ],
    "city": [
      "Zuwarah",
      "Zuwarah",
      "Zuwarah"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "EDQ",
    "translations": [
      "Erandique Airport",
      "Erandique Airport",
      "Erandique Airport"
    ],
    "city": [
      "Erandique",
      "Erandique",
      "Erandique"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "HOO",
    "translations": [
      "Nhon Co Airfield",
      "Nhon Co Airfield",
      "Nhon Co Airfield"
    ],
    "city": [
      "Đăk R'Lấp",
      "Đăk R'Lấp",
      "Đăk R'Lấp"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "HRC",
    "translations": [
      "Sary Su Airport",
      "Sary Su Airport",
      "Sary Su Airport"
    ],
    "city": [
      "Zhayrem",
      "Zhayrem",
      "Zhayrem"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "GYI",
    "translations": [
      "Gisenyi Airport",
      "Gisenyi Airport",
      "Gisenyi Airport"
    ],
    "city": [
      "Gisenyi",
      "Gisenyi",
      "Gisenyi"
    ],
    "country": [
      "RW",
      "RW",
      "RW"
    ]
  },
  {
    "iata": "BTQ",
    "translations": [
      "Butare Airport",
      "Butare Airport",
      "Butare Airport"
    ],
    "city": [
      "Butare",
      "Butare",
      "Butare"
    ],
    "country": [
      "RW",
      "RW",
      "RW"
    ]
  },
  {
    "iata": "KGL",
    "translations": [
      "Kigali International Airport",
      "Kigali International Airport",
      "Kigali International Airport"
    ],
    "city": [
      "Kigali",
      "Kigali",
      "Kigali"
    ],
    "country": [
      "RW",
      "RW",
      "RW"
    ]
  },
  {
    "iata": "RHG",
    "translations": [
      "Ruhengeri Airport",
      "Ruhengeri Airport",
      "Ruhengeri Airport"
    ],
    "city": [
      "Ruhengeri",
      "Ruhengeri",
      "Ruhengeri"
    ],
    "country": [
      "RW",
      "RW",
      "RW"
    ]
  },
  {
    "iata": "KME",
    "translations": [
      "Kamembe Airport",
      "Kamembe Airport",
      "Kamembe Airport"
    ],
    "city": [
      "Kamembe",
      "Kamembe",
      "Kamembe"
    ],
    "country": [
      "RW",
      "RW",
      "RW"
    ]
  },
  {
    "iata": "ATB",
    "translations": [
      "Atbara Airport",
      "Atbara Airport",
      "Atbara Airport"
    ],
    "city": [
      "Atbara",
      "Atbara",
      "Atbara"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "EDB",
    "translations": [
      "Al Dabbah Airport",
      "Al Dabbah Airport",
      "Al Dabbah Airport"
    ],
    "city": [
      "Al Dabbah",
      "Al Dabbah",
      "Al Dabbah"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "DOG",
    "translations": [
      "Dongola Airport",
      "Dongola Airport",
      "Dongola Airport"
    ],
    "city": [
      "Dongola",
      "Dongola",
      "Dongola"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "RSS",
    "translations": [
      "Damazin Airport",
      "Damazin Airport",
      "Damazin Airport"
    ],
    "city": [
      "Ad Damazin",
      "Ad Damazin",
      "Ad Damazin"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "ELF",
    "translations": [
      "El Fasher Airport",
      "El Fasher Airport",
      "El Fasher Airport"
    ],
    "city": [
      "El Fasher",
      "El Fasher",
      "El Fasher"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "DNX",
    "translations": [
      "Galegu Airport",
      "Galegu Airport",
      "Galegu Airport"
    ],
    "city": [
      "Dinder",
      "Dinder",
      "Dinder"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "EGN",
    "translations": [
      "Geneina Airport",
      "Geneina Airport",
      "Geneina Airport"
    ],
    "city": [
      "Geneina",
      "Geneina",
      "Geneina"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "HEG",
    "translations": [
      "Heglig Airport",
      "Heglig Airport",
      "Heglig Airport"
    ],
    "city": [
      "Heglig Oilfield",
      "Heglig Oilfield",
      "Heglig Oilfield"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "HSJ",
    "translations": [
      "Zhengzhou Shangjie Airport",
      "Zhengzhou Shangjie Airport",
      "Zhengzhou Shangjie Airport"
    ],
    "city": [
      "Zhengzhou",
      "Zhengzhou",
      "Zhengzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "KSL",
    "translations": [
      "Kassala Airport",
      "Kassala Airport",
      "Kassala Airport"
    ],
    "city": [
      "Kassala",
      "Kassala",
      "Kassala"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "GBU",
    "translations": [
      "Khashm El Girba Airport",
      "Khashm El Girba Airport",
      "Khashm El Girba Airport"
    ],
    "city": [
      "Khashm El Girba",
      "Khashm El Girba",
      "Khashm El Girba"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "KDX",
    "translations": [
      "Kadugli Airport",
      "Kadugli Airport",
      "Kadugli Airport"
    ],
    "city": [
      "Kadugli",
      "Kadugli",
      "Kadugli"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "RBX",
    "translations": [
      "Rumbek Airport",
      "Rumbek Airport",
      "Rumbek Airport"
    ],
    "city": [
      "Rumbek",
      "Rumbek",
      "Rumbek"
    ],
    "country": [
      "SS",
      "SS",
      "SS"
    ]
  },
  {
    "iata": "MWE",
    "translations": [
      "Merowe Airport",
      "Merowe Airport",
      "Merowe Airport"
    ],
    "city": [
      "Merowe",
      "Merowe",
      "Merowe"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "NUD",
    "translations": [
      "En Nahud Airport",
      "En Nahud Airport",
      "En Nahud Airport"
    ],
    "city": [
      "En Nahud",
      "En Nahud",
      "En Nahud"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "UYL",
    "translations": [
      "Nyala Airport",
      "Nyala Airport",
      "Nyala Airport"
    ],
    "city": [
      "Nyala",
      "Nyala",
      "Nyala"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "NHF",
    "translations": [
      "New Halfa Airport",
      "New Halfa Airport",
      "New Halfa Airport"
    ],
    "city": [
      "New Halfa",
      "New Halfa",
      "New Halfa"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "EBD",
    "translations": [
      "El-Obeid Airport",
      "El-Obeid Airport",
      "El-Obeid Airport"
    ],
    "city": [
      "El-Obeid",
      "El-Obeid",
      "El-Obeid"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "PZU",
    "translations": [
      "Port Sudan New International Airport",
      "Port Sudan New International Airport",
      "Port Sudan New International Airport"
    ],
    "city": [
      "Port Sudan",
      "Port Sudan",
      "Port Sudan"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "KRT",
    "translations": [
      "Khartoum International Airport",
      "Khartoum International Airport",
      "Khartoum International Airport"
    ],
    "city": [
      "Khartoum",
      "Khartoum",
      "Khartoum"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "MAK",
    "translations": [
      "Malakal Airport",
      "Malakal Airport",
      "Malakal Airport"
    ],
    "city": [
      "Malakal",
      "Malakal",
      "Malakal"
    ],
    "country": [
      "SS",
      "SS",
      "SS"
    ]
  },
  {
    "iata": "WHF",
    "translations": [
      "Wadi Halfa Airport",
      "Wadi Halfa Airport",
      "Wadi Halfa Airport"
    ],
    "city": [
      "Wadi Halfa",
      "Wadi Halfa",
      "Wadi Halfa"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "WUU",
    "translations": [
      "Wau Airport",
      "Wau Airport",
      "Wau Airport"
    ],
    "city": [
      "Wau",
      "Wau",
      "Wau"
    ],
    "country": [
      "SS",
      "SS",
      "SS"
    ]
  },
  {
    "iata": "ZLX",
    "translations": [
      "Zalingei Airport",
      "Zalingei Airport",
      "Zalingei Airport"
    ],
    "city": [
      "Zalingei",
      "Zalingei",
      "Zalingei"
    ],
    "country": [
      "SD",
      "SD",
      "SD"
    ]
  },
  {
    "iata": "ARK",
    "translations": [
      "Arusha Airport",
      "Arusha Airport",
      "Arusha Airport"
    ],
    "city": [
      "Arusha",
      "Arusha",
      "Arusha"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "BKZ",
    "translations": [
      "Bukoba Airport",
      "Bukoba Airport",
      "Bukoba Airport"
    ],
    "city": [
      "Bukoba",
      "Bukoba",
      "Bukoba"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "DAR",
    "translations": [
      "Julius Nyerere International Airport",
      "Julius Nyerere International Airport",
      "Julius Nyerere International Airport"
    ],
    "city": [
      "Dar es Salaam",
      "Dar es Salaam",
      "Dar es Salaam"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "DOD",
    "translations": [
      "Dodoma Airport",
      "Dodoma Airport",
      "Dodoma Airport"
    ],
    "city": [
      "Dodoma",
      "Dodoma",
      "Dodoma"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "GTC",
    "translations": [
      "Chato/Geita Airport",
      "Chato/Geita Airport",
      "Chato/Geita Airport"
    ],
    "city": [
      "Chato District",
      "Chato District",
      "Chato District"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "GTZ",
    "translations": [
      "Kirawira B Aerodrome",
      "Kirawira B Aerodrome",
      "Kirawira B Aerodrome"
    ],
    "city": [
      "Grumeti Game Reserve",
      "Grumeti Game Reserve",
      "Grumeti Game Reserve"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "MBI",
    "translations": [
      "Songwe Airport",
      "Songwe Airport",
      "Songwe Airport"
    ],
    "city": [
      "Mbeya",
      "Mbeya",
      "Mbeya"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "IRI",
    "translations": [
      "Iringa Airport",
      "Iringa Airport",
      "Iringa Airport"
    ],
    "city": [
      "Nduli",
      "Nduli",
      "Nduli"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "TKQ",
    "translations": [
      "Kigoma Airport",
      "Kigoma Airport",
      "Kigoma Airport"
    ],
    "city": [
      "Kigoma",
      "Kigoma",
      "Kigoma"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "KIY",
    "translations": [
      "Kilwa Airport",
      "Kilwa Airport",
      "Kilwa Airport"
    ],
    "city": [
      "Kilwa Masoko",
      "Kilwa Masoko",
      "Kilwa Masoko"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "JRO",
    "translations": [
      "Kilimanjaro International Airport",
      "Kilimanjaro International Airport",
      "Kilimanjaro International Airport"
    ],
    "city": [
      "Arusha",
      "Arusha",
      "Arusha"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "LDI",
    "translations": [
      "Lindi Airport",
      "Lindi Airport",
      "Lindi Airport"
    ],
    "city": [
      "Lindi",
      "Lindi",
      "Lindi"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "LKY",
    "translations": [
      "Lake Manyara Airport",
      "Lake Manyara Airport",
      "Lake Manyara Airport"
    ],
    "city": [
      "Lake Manyara National Park",
      "Lake Manyara National Park",
      "Lake Manyara National Park"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "MFA",
    "translations": [
      "Mafia Airport",
      "Mafia Airport",
      "Mafia Airport"
    ],
    "city": [
      "Kilindoni",
      "Kilindoni",
      "Kilindoni"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "MWN",
    "translations": [
      "Mwadui Airport",
      "Mwadui Airport",
      "Mwadui Airport"
    ],
    "city": [
      "Mwadui",
      "Mwadui",
      "Mwadui"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "XMI",
    "translations": [
      "Masasi Airport",
      "Masasi Airport",
      "Masasi Airport"
    ],
    "city": [
      "Masasi",
      "Masasi",
      "Masasi"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "NPY",
    "translations": [
      "Mpanda Airport",
      "Mpanda Airport",
      "Mpanda Airport"
    ],
    "city": [
      "Mpanda",
      "Mpanda",
      "Mpanda"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "QSI",
    "translations": [
      "Moshi Airport",
      "Moshi Airport",
      "Moshi Airport"
    ],
    "city": [
      "Moshi",
      "Moshi",
      "Moshi"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "MYW",
    "translations": [
      "Mtwara Airport",
      "Mtwara Airport",
      "Mtwara Airport"
    ],
    "city": [
      "Mtwara",
      "Mtwara",
      "Mtwara"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "MUZ",
    "translations": [
      "Musoma Airport",
      "Musoma Airport",
      "Musoma Airport"
    ],
    "city": [
      "Musoma",
      "Musoma",
      "Musoma"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "MWZ",
    "translations": [
      "Mwanza Airport",
      "Mwanza Airport",
      "Mwanza Airport"
    ],
    "city": [
      "Mwanza",
      "Mwanza",
      "Mwanza"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "NCH",
    "translations": [
      "Nachingwea Airport",
      "Nachingwea Airport",
      "Nachingwea Airport"
    ],
    "city": [
      "Nachingwea",
      "Nachingwea",
      "Nachingwea"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "JOM",
    "translations": [
      "Njombe Airport",
      "Njombe Airport",
      "Njombe Airport"
    ],
    "city": [
      "Njombe",
      "Njombe",
      "Njombe"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "PMA",
    "translations": [
      "Pemba Airport",
      "Pemba Airport",
      "Pemba Airport"
    ],
    "city": [
      "Chake Chake",
      "Chake Chake",
      "Chake Chake"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "SEU",
    "translations": [
      "Seronera Airport",
      "Seronera Airport",
      "Seronera Airport"
    ],
    "city": [
      "Seronera",
      "Seronera",
      "Seronera"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "SGX",
    "translations": [
      "Songea Airport",
      "Songea Airport",
      "Songea Airport"
    ],
    "city": [
      "Songea",
      "Songea",
      "Songea"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "SUT",
    "translations": [
      "Sumbawanga Airport",
      "Sumbawanga Airport",
      "Sumbawanga Airport"
    ],
    "city": [
      "Sumbawanga",
      "Sumbawanga",
      "Sumbawanga"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "SHY",
    "translations": [
      "Shinyanga Airport",
      "Shinyanga Airport",
      "Shinyanga Airport"
    ],
    "city": [
      "Shinyanga",
      "Shinyanga",
      "Shinyanga"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "TBO",
    "translations": [
      "Tabora Airport",
      "Tabora Airport",
      "Tabora Airport"
    ],
    "city": [
      "Tabora",
      "Tabora",
      "Tabora"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "TGT",
    "translations": [
      "Tanga Airport",
      "Tanga Airport",
      "Tanga Airport"
    ],
    "city": [
      "Tanga",
      "Tanga",
      "Tanga"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "ZNZ",
    "translations": [
      "Abeid Amani Karume International Airport",
      "Abeid Amani Karume International Airport",
      "Abeid Amani Karume International Airport"
    ],
    "city": [
      "Zanzibar",
      "Zanzibar",
      "Zanzibar"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "RUA",
    "translations": [
      "Arua Airport",
      "Arua Airport",
      "Arua Airport"
    ],
    "city": [
      "Arua",
      "Arua",
      "Arua"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "EBB",
    "translations": [
      "Entebbe International Airport",
      "Entebbe International Airport",
      "Entebbe International Airport"
    ],
    "city": [
      "Kampala",
      "Kampala",
      "Kampala"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "ULU",
    "translations": [
      "Gulu Airport",
      "Gulu Airport",
      "Gulu Airport"
    ],
    "city": [
      "Gulu",
      "Gulu",
      "Gulu"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "JIN",
    "translations": [
      "Jinja Airport",
      "Jinja Airport",
      "Jinja Airport"
    ],
    "city": [
      "Jinja",
      "Jinja",
      "Jinja"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "KJJ",
    "translations": [
      "Kajjansi Airfield",
      "Kajjansi Airfield",
      "Kajjansi Airfield"
    ],
    "city": [
      "Kampala",
      "Kampala",
      "Kampala"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "KSE",
    "translations": [
      "Kasese Airport",
      "Kasese Airport",
      "Kasese Airport"
    ],
    "city": [
      "Kasese",
      "Kasese",
      "Kasese"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "MBQ",
    "translations": [
      "Mbarara Airport",
      "Mbarara Airport",
      "Mbarara Airport"
    ],
    "city": [
      "Mbarara",
      "Mbarara",
      "Mbarara"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "KCU",
    "translations": [
      "Masindi Airport",
      "Masindi Airport",
      "Masindi Airport"
    ],
    "city": [
      "Masindi",
      "Masindi",
      "Masindi"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "PAF",
    "translations": [
      "Kabalega Falls Airport",
      "Kabalega Falls Airport",
      "Kabalega Falls Airport"
    ],
    "city": [
      "Pakuba",
      "Pakuba",
      "Pakuba"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "SRT",
    "translations": [
      "Soroti Airport",
      "Soroti Airport",
      "Soroti Airport"
    ],
    "city": [
      "Soroti",
      "Soroti",
      "Soroti"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "TRY",
    "translations": [
      "Tororo Airport",
      "Tororo Airport",
      "Tororo Airport"
    ],
    "city": [
      "Tororo",
      "Tororo",
      "Tororo"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "HWI",
    "translations": [
      "Hawk Inlet Seaplane Base",
      "Hawk Inlet Seaplane Base",
      "Hawk Inlet Seaplane Base"
    ],
    "city": [
      "Hawk Inlet",
      "Hawk Inlet",
      "Hawk Inlet"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HYL",
    "translations": [
      "Hollis Clark Bay Seaplane Base",
      "Hollis Clark Bay Seaplane Base",
      "Hollis Clark Bay Seaplane Base"
    ],
    "city": [
      "Hollis",
      "Hollis",
      "Hollis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HZU",
    "translations": [
      "Chengdu Huaizhou Airport",
      "Chengdu Huaizhou Airport",
      "Chengdu Huaizhou Airport"
    ],
    "city": [
      "Chengdu (Jintang)",
      "Chengdu (Jintang)",
      "Chengdu (Jintang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "IBI",
    "translations": [
      "Iboki Airport",
      "Iboki Airport",
      "Iboki Airport"
    ],
    "city": [
      "Iboki",
      "Iboki",
      "Iboki"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "IBL",
    "translations": [
      "Indigo Bay Lodge Airport",
      "Indigo Bay Lodge Airport",
      "Indigo Bay Lodge Airport"
    ],
    "city": [
      "Bazaruto Island",
      "Bazaruto Island",
      "Bazaruto Island"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "LHB",
    "translations": [
      "tylekeonhacaibuzz",
      "tylekeonhacaibuzz",
      "tylekeonhacaibuzz"
    ],
    "city": [
      "hồ chí minh",
      "hồ chí minh",
      "hồ chí minh"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "ICO",
    "translations": [
      "Sicogon Airstrip",
      "Sicogon Airstrip",
      "Sicogon Airstrip"
    ],
    "city": [
      "Carles",
      "Carles",
      "Carles"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "PPJ",
    "translations": [
      "Pulau Panjang Airport",
      "Pulau Panjang Airport",
      "Pulau Panjang Airport"
    ],
    "city": [
      "Jakarta",
      "Jakarta",
      "Jakarta"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "ENG",
    "translations": [
      "Enggano Airport",
      "Enggano Airport",
      "Enggano Airport"
    ],
    "city": [
      "Enggano",
      "Enggano",
      "Enggano"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "GYO",
    "translations": [
      "Blangkejeren Airport",
      "Blangkejeren Airport",
      "Blangkejeren Airport"
    ],
    "city": [
      "Kabupaten Gayo Lues",
      "Kabupaten Gayo Lues",
      "Kabupaten Gayo Lues"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "DHX",
    "translations": [
      "Dhoho International Airport",
      "Dhoho International Airport",
      "Dhoho International Airport"
    ],
    "city": [
      "Kediri",
      "Kediri",
      "Kediri"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SKJ",
    "translations": [
      "Singkawang Airport",
      "Singkawang Airport",
      "Singkawang Airport"
    ],
    "city": [
      "Singkawang",
      "Singkawang",
      "Singkawang"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BJG",
    "translations": [
      "Kota Mobagu/Mopait Airport",
      "Kota Mobagu/Mopait Airport",
      "Kota Mobagu/Mopait Airport"
    ],
    "city": [
      "Kota Mobagu",
      "Kota Mobagu",
      "Kota Mobagu"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "AAS",
    "translations": [
      "Apalapsili Airport",
      "Apalapsili Airport",
      "Apalapsili Airport"
    ],
    "city": [
      "Apalapsili",
      "Apalapsili",
      "Apalapsili"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "AGD",
    "translations": [
      "Anggi Airport",
      "Anggi Airport",
      "Anggi Airport"
    ],
    "city": [
      "Anggi-Papua Island",
      "Anggi-Papua Island",
      "Anggi-Papua Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "AKQ",
    "translations": [
      "Astra Ksetra Airport",
      "Astra Ksetra Airport",
      "Astra Ksetra Airport"
    ],
    "city": [
      "Menggala",
      "Menggala",
      "Menggala"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "ELR",
    "translations": [
      "Elelim Airport",
      "Elelim Airport",
      "Elelim Airport"
    ],
    "city": [
      "Elelim",
      "Elelim",
      "Elelim"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "EWE",
    "translations": [
      "Ewer Asmat Airport",
      "Ewer Asmat Airport",
      "Ewer Asmat Airport"
    ],
    "city": [
      "Agats",
      "Agats",
      "Agats"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "GAV",
    "translations": [
      "Gag Island Airport",
      "Gag Island Airport",
      "Gag Island Airport"
    ],
    "city": [
      "Gag Island",
      "Gag Island",
      "Gag Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "IUL",
    "translations": [
      "Ilu Airport",
      "Ilu Airport",
      "Ilu Airport"
    ],
    "city": [
      "Ilu",
      "Ilu",
      "Ilu"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KOD",
    "translations": [
      "Kotabangun Airport",
      "Kotabangun Airport",
      "Kotabangun Airport"
    ],
    "city": [
      "Kotabangun-Borneo Island",
      "Kotabangun-Borneo Island",
      "Kotabangun-Borneo Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KRC",
    "translations": [
      "Departi Parbo Airport",
      "Departi Parbo Airport",
      "Departi Parbo Airport"
    ],
    "city": [
      "Sungai Penuh",
      "Sungai Penuh",
      "Sungai Penuh"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LLN",
    "translations": [
      "Kelila Airport",
      "Kelila Airport",
      "Kelila Airport"
    ],
    "city": [
      "Kelila",
      "Kelila",
      "Kelila"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MSI",
    "translations": [
      "Masalembo Airport",
      "Masalembo Airport",
      "Masalembo Airport"
    ],
    "city": [
      "Masalembo Island",
      "Masalembo Island",
      "Masalembo Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "NAF",
    "translations": [
      "Banaina Airport",
      "Banaina Airport",
      "Banaina Airport"
    ],
    "city": [
      "Banaina-Borneo Island",
      "Banaina-Borneo Island",
      "Banaina-Borneo Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "OBD",
    "translations": [
      "Obano Airport",
      "Obano Airport",
      "Obano Airport"
    ],
    "city": [
      "Obano",
      "Obano",
      "Obano"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "RKI",
    "translations": [
      "Mentawai Airport",
      "Mentawai Airport",
      "Mentawai Airport"
    ],
    "city": [
      "Sipura Island",
      "Sipura Island",
      "Sipura Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TMY",
    "translations": [
      "Tiom Airport",
      "Tiom Airport",
      "Tiom Airport"
    ],
    "city": [
      "Tiom-Papua Island",
      "Tiom-Papua Island",
      "Tiom-Papua Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "UGU",
    "translations": [
      "Bilogai-Sugapa Airport",
      "Bilogai-Sugapa Airport",
      "Bilogai-Sugapa Airport"
    ],
    "city": [
      "Sugapa",
      "Sugapa",
      "Sugapa"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "IMA",
    "translations": [
      "Iamalele Airport",
      "Iamalele Airport",
      "Iamalele Airport"
    ],
    "city": [
      "Iamalele, Fergusson Island",
      "Iamalele, Fergusson Island",
      "Iamalele, Fergusson Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "IMG",
    "translations": [
      "Inhaminga Airport",
      "Inhaminga Airport",
      "Inhaminga Airport"
    ],
    "city": [
      "Inhaminga",
      "Inhaminga",
      "Inhaminga"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "PYG",
    "translations": [
      "Pakyong Airport",
      "Pakyong Airport",
      "Pakyong Airport"
    ],
    "city": [
      "Pakyong",
      "Pakyong",
      "Pakyong"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "AYJ",
    "translations": [
      "Ayodhya Airport",
      "Ayodhya Airport",
      "Ayodhya Airport"
    ],
    "city": [
      "Faizabad",
      "Faizabad",
      "Faizabad"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "SDW",
    "translations": [
      "Sindhudurg Airport",
      "Sindhudurg Airport",
      "Sindhudurg Airport"
    ],
    "city": [
      "Chipi",
      "Chipi",
      "Chipi"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "NMI",
    "translations": [
      "Navi Mumbai International Airport",
      "Navi Mumbai International Airport",
      "Navi Mumbai International Airport"
    ],
    "city": [
      "Navi Mumbai",
      "Navi Mumbai",
      "Navi Mumbai"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "RQY",
    "translations": [
      "Rashtrakavi Kuvempu Airport",
      "Rashtrakavi Kuvempu Airport",
      "Rashtrakavi Kuvempu Airport"
    ],
    "city": [
      "Shimoga",
      "Shimoga",
      "Shimoga"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "HGI",
    "translations": [
      "Itanagar Donyi Polo Hollongi Airport",
      "Itanagar Donyi Polo Hollongi Airport",
      "Itanagar Donyi Polo Hollongi Airport"
    ],
    "city": [
      "Hollongi",
      "Hollongi",
      "Hollongi"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "UKE",
    "translations": [
      "Utkela Airport",
      "Utkela Airport",
      "Utkela Airport"
    ],
    "city": [
      "Bhawanipatna",
      "Bhawanipatna",
      "Bhawanipatna"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "AHA",
    "translations": [
      "Maa Mahamaya Airport",
      "Maa Mahamaya Airport",
      "Maa Mahamaya Airport"
    ],
    "city": [
      "Ambikapur",
      "Ambikapur",
      "Ambikapur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "JGB",
    "translations": [
      "Jagdalpur Airport",
      "Jagdalpur Airport",
      "Jagdalpur Airport"
    ],
    "city": [
      "Jagdalpur",
      "Jagdalpur",
      "Jagdalpur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "RJI",
    "translations": [
      "Rajouri Airport",
      "Rajouri Airport",
      "Rajouri Airport"
    ],
    "city": [
      "Rajouri",
      "Rajouri",
      "Rajouri"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "INE",
    "translations": [
      "Chinde Airport",
      "Chinde Airport",
      "Chinde Airport"
    ],
    "city": [
      "Chinde",
      "Chinde",
      "Chinde"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "IOK",
    "translations": [
      "Iokea Airport",
      "Iokea Airport",
      "Iokea Airport"
    ],
    "city": [
      "Iokea",
      "Iokea",
      "Iokea"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "IOP",
    "translations": [
      "Ioma Airport",
      "Ioma Airport",
      "Ioma Airport"
    ],
    "city": [
      "Ioma",
      "Ioma",
      "Ioma"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "IRU",
    "translations": [
      "Iranamadu Seaplane Base",
      "Iranamadu Seaplane Base",
      "Iranamadu Seaplane Base"
    ],
    "city": [
      "Iranamadu",
      "Iranamadu",
      "Iranamadu"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "ITK",
    "translations": [
      "Itokama Airport",
      "Itokama Airport",
      "Itokama Airport"
    ],
    "city": [
      "Itokama",
      "Itokama",
      "Itokama"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "IVI",
    "translations": [
      "Viveros Island Airport",
      "Viveros Island Airport",
      "Viveros Island Airport"
    ],
    "city": [
      "Isla Viveros",
      "Isla Viveros",
      "Isla Viveros"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "JIO",
    "translations": [
      "Jos Orno Imsula Airport",
      "Jos Orno Imsula Airport",
      "Jos Orno Imsula Airport"
    ],
    "city": [
      "Tiakur",
      "Tiakur",
      "Tiakur"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "JLA",
    "translations": [
      "Quartz Creek Airport",
      "Quartz Creek Airport",
      "Quartz Creek Airport"
    ],
    "city": [
      "Cooper Landing",
      "Cooper Landing",
      "Cooper Landing"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JMB",
    "translations": [
      "Jamba Airport",
      "Jamba Airport",
      "Jamba Airport"
    ],
    "city": [
      "Jamba",
      "Jamba",
      "Jamba"
    ],
    "country": [
      "AO",
      "AO",
      "AO"
    ]
  },
  {
    "iata": "JPN",
    "translations": [
      "Pentagon Army Heliport",
      "Pentagon Army Heliport",
      "Pentagon Army Heliport"
    ],
    "city": [
      "Washington DC",
      "Washington DC",
      "Washington DC"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JRA",
    "translations": [
      "West 30th Street Heliport",
      "West 30th Street Heliport",
      "West 30th Street Heliport"
    ],
    "city": [
      "New York",
      "New York",
      "New York"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JRB",
    "translations": [
      "Downtown Manhattan Heliport",
      "Downtown Manhattan Heliport",
      "Downtown Manhattan Heliport"
    ],
    "city": [
      "New York",
      "New York",
      "New York"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JUH",
    "translations": [
      "Chizhou Jiuhuashan Airport",
      "Chizhou Jiuhuashan Airport",
      "Chizhou Jiuhuashan Airport"
    ],
    "city": [
      "Chizhou",
      "Chizhou",
      "Chizhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "AMK",
    "translations": [
      "Animas Air Park",
      "Animas Air Park",
      "Animas Air Park"
    ],
    "city": [
      "Durango",
      "Durango",
      "Durango"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BDX",
    "translations": [
      "Broadus Airport",
      "Broadus Airport",
      "Broadus Airport"
    ],
    "city": [
      "Broadus",
      "Broadus",
      "Broadus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EUE",
    "translations": [
      "Eureka Airport",
      "Eureka Airport",
      "Eureka Airport"
    ],
    "city": [
      "Eureka",
      "Eureka",
      "Eureka"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KPT",
    "translations": [
      "Jackpot Airport/Hayden Field",
      "Jackpot Airport/Hayden Field",
      "Jackpot Airport/Hayden Field"
    ],
    "city": [
      "Jackpot",
      "Jackpot",
      "Jackpot"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RLA",
    "translations": [
      "Rolla Downtown Airport",
      "Rolla Downtown Airport",
      "Rolla Downtown Airport"
    ],
    "city": [
      "Rolla",
      "Rolla",
      "Rolla"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FID",
    "translations": [
      "Elizabeth Field",
      "Elizabeth Field",
      "Elizabeth Field"
    ],
    "city": [
      "Fishers Island",
      "Fishers Island",
      "Fishers Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HUD",
    "translations": [
      "Humboldt Municipal Airport",
      "Humboldt Municipal Airport",
      "Humboldt Municipal Airport"
    ],
    "city": [
      "Humboldt",
      "Humboldt",
      "Humboldt"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TWD",
    "translations": [
      "Jefferson County International Airport",
      "Jefferson County International Airport",
      "Jefferson County International Airport"
    ],
    "city": [
      "Port Townsend",
      "Port Townsend",
      "Port Townsend"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MVM",
    "translations": [
      "Kayenta Airport",
      "Kayenta Airport",
      "Kayenta Airport"
    ],
    "city": [
      "Kayenta",
      "Kayenta",
      "Kayenta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HCC",
    "translations": [
      "Columbia County Airport",
      "Columbia County Airport",
      "Columbia County Airport"
    ],
    "city": [
      "Hudson",
      "Hudson",
      "Hudson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AHD",
    "translations": [
      "Ardmore Downtown Executive Airport",
      "Ardmore Downtown Executive Airport",
      "Ardmore Downtown Executive Airport"
    ],
    "city": [
      "Ardmore",
      "Ardmore",
      "Ardmore"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GCW",
    "translations": [
      "Grand Canyon West Airport",
      "Grand Canyon West Airport",
      "Grand Canyon West Airport"
    ],
    "city": [
      "Peach Springs",
      "Peach Springs",
      "Peach Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CKE",
    "translations": [
      "Lampson Field",
      "Lampson Field",
      "Lampson Field"
    ],
    "city": [
      "Lakeport",
      "Lakeport",
      "Lakeport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ROF",
    "translations": [
      "Montague-Yreka Rohrer Field",
      "Montague-Yreka Rohrer Field",
      "Montague-Yreka Rohrer Field"
    ],
    "city": [
      "Montague",
      "Montague",
      "Montague"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CNE",
    "translations": [
      "Fremont County Airport",
      "Fremont County Airport",
      "Fremont County Airport"
    ],
    "city": [
      "Penrose",
      "Penrose",
      "Penrose"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RSX",
    "translations": [
      "Rouses Point Seaplane Base",
      "Rouses Point Seaplane Base",
      "Rouses Point Seaplane Base"
    ],
    "city": [
      "Rouses Point",
      "Rouses Point",
      "Rouses Point"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "COP",
    "translations": [
      "Cooperstown-Westville Airport",
      "Cooperstown-Westville Airport",
      "Cooperstown-Westville Airport"
    ],
    "city": [
      "Cooperstown",
      "Cooperstown",
      "Cooperstown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CIL",
    "translations": [
      "Council Airport",
      "Council Airport",
      "Council Airport"
    ],
    "city": [
      "Council",
      "Council",
      "Council"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NWH",
    "translations": [
      "Parlin Field",
      "Parlin Field",
      "Parlin Field"
    ],
    "city": [
      "Newport",
      "Newport",
      "Newport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IRB",
    "translations": [
      "Iraan Municipal Airport",
      "Iraan Municipal Airport",
      "Iraan Municipal Airport"
    ],
    "city": [
      "Iraan",
      "Iraan",
      "Iraan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ODM",
    "translations": [
      "Garrett County Airport",
      "Garrett County Airport",
      "Garrett County Airport"
    ],
    "city": [
      "Accident",
      "Accident",
      "Accident"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GNF",
    "translations": [
      "Gansner Field",
      "Gansner Field",
      "Gansner Field"
    ],
    "city": [
      "Quincy",
      "Quincy",
      "Quincy"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CHZ",
    "translations": [
      "Chiloquin State Airport",
      "Chiloquin State Airport",
      "Chiloquin State Airport"
    ],
    "city": [
      "Chiloquin",
      "Chiloquin",
      "Chiloquin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LTW",
    "translations": [
      "St. Mary's County Regional Airport",
      "St. Mary's County Regional Airport",
      "St. Mary's County Regional Airport"
    ],
    "city": [
      "California",
      "California",
      "California"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "USC",
    "translations": [
      "Union County, Troy Shelton Field",
      "Union County, Troy Shelton Field",
      "Union County, Troy Shelton Field"
    ],
    "city": [
      "Union",
      "Union",
      "Union"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AHF",
    "translations": [
      "Arapahoe Municipal Airport",
      "Arapahoe Municipal Airport",
      "Arapahoe Municipal Airport"
    ],
    "city": [
      "Arapahoe",
      "Arapahoe",
      "Arapahoe"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PCT",
    "translations": [
      "Princeton Airport",
      "Princeton Airport",
      "Princeton Airport"
    ],
    "city": [
      "Princeton/Rocky Hill",
      "Princeton/Rocky Hill",
      "Princeton/Rocky Hill"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CTO",
    "translations": [
      "Calverton Executive Airpark",
      "Calverton Executive Airpark",
      "Calverton Executive Airpark"
    ],
    "city": [
      "Calverton",
      "Calverton",
      "Calverton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NRI",
    "translations": [
      "Grand Lake Regional Airport",
      "Grand Lake Regional Airport",
      "Grand Lake Regional Airport"
    ],
    "city": [
      "Afton",
      "Afton",
      "Afton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GTP",
    "translations": [
      "Grants Pass Airport",
      "Grants Pass Airport",
      "Grants Pass Airport"
    ],
    "city": [
      "Grants Pass",
      "Grants Pass",
      "Grants Pass"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NLE",
    "translations": [
      "Jerry Tyler Memorial Airport",
      "Jerry Tyler Memorial Airport",
      "Jerry Tyler Memorial Airport"
    ],
    "city": [
      "Niles",
      "Niles",
      "Niles"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GCD",
    "translations": [
      "Grand Coulee Dam Airport",
      "Grand Coulee Dam Airport",
      "Grand Coulee Dam Airport"
    ],
    "city": [
      "Electric City",
      "Electric City",
      "Electric City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VLE",
    "translations": [
      "Valle Airport",
      "Valle Airport",
      "Valle Airport"
    ],
    "city": [
      "Grand Canyon",
      "Grand Canyon",
      "Grand Canyon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FPY",
    "translations": [
      "Perry-Foley Airport",
      "Perry-Foley Airport",
      "Perry-Foley Airport"
    ],
    "city": [
      "Perry",
      "Perry",
      "Perry"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NTJ",
    "translations": [
      "Manti-Ephraim Airport",
      "Manti-Ephraim Airport",
      "Manti-Ephraim Airport"
    ],
    "city": [
      "Manti",
      "Manti",
      "Manti"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SBO",
    "translations": [
      "Salina Gunnison Airport",
      "Salina Gunnison Airport",
      "Salina Gunnison Airport"
    ],
    "city": [
      "Salina",
      "Salina",
      "Salina"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JVI",
    "translations": [
      "Central Jersey Regional Airport",
      "Central Jersey Regional Airport",
      "Central Jersey Regional Airport"
    ],
    "city": [
      "Manville",
      "Manville",
      "Manville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UCE",
    "translations": [
      "Eunice Airport",
      "Eunice Airport",
      "Eunice Airport"
    ],
    "city": [
      "Eunice",
      "Eunice",
      "Eunice"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GOL",
    "translations": [
      "Gold Beach Municipal Airport",
      "Gold Beach Municipal Airport",
      "Gold Beach Municipal Airport"
    ],
    "city": [
      "Gold Beach",
      "Gold Beach",
      "Gold Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KKT",
    "translations": [
      "Kentland Municipal Airport",
      "Kentland Municipal Airport",
      "Kentland Municipal Airport"
    ],
    "city": [
      "Kentland",
      "Kentland",
      "Kentland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PRW",
    "translations": [
      "Prentice Airport",
      "Prentice Airport",
      "Prentice Airport"
    ],
    "city": [
      "Prentice",
      "Prentice",
      "Prentice"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EGP",
    "translations": [
      "Maverick County Memorial International Airport",
      "Maverick County Memorial International Airport",
      "Maverick County Memorial International Airport"
    ],
    "city": [
      "Eagle Pass",
      "Eagle Pass",
      "Eagle Pass"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BLD",
    "translations": [
      "Boulder City Municipal Airport",
      "Boulder City Municipal Airport",
      "Boulder City Municipal Airport"
    ],
    "city": [
      "Boulder City",
      "Boulder City",
      "Boulder City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MFH",
    "translations": [
      "Mesquite International Airport",
      "Mesquite International Airport",
      "Mesquite International Airport"
    ],
    "city": [
      "Mesquite",
      "Mesquite",
      "Mesquite"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ECA",
    "translations": [
      "Iosco County Airport",
      "Iosco County Airport",
      "Iosco County Airport"
    ],
    "city": [
      "East Tawas",
      "East Tawas",
      "East Tawas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FMU",
    "translations": [
      "Florence Municipal Airport",
      "Florence Municipal Airport",
      "Florence Municipal Airport"
    ],
    "city": [
      "Florence",
      "Florence",
      "Florence"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OTS",
    "translations": [
      "Anacortes Airport",
      "Anacortes Airport",
      "Anacortes Airport"
    ],
    "city": [
      "Anacortes",
      "Anacortes",
      "Anacortes"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ROL",
    "translations": [
      "Roosevelt Municipal Airport",
      "Roosevelt Municipal Airport",
      "Roosevelt Municipal Airport"
    ],
    "city": [
      "Roosevelt",
      "Roosevelt",
      "Roosevelt"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CTK",
    "translations": [
      "Canton Municipal Airport",
      "Canton Municipal Airport",
      "Canton Municipal Airport"
    ],
    "city": [
      "Canton",
      "Canton",
      "Canton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WPO",
    "translations": [
      "North Fork Valley Airport",
      "North Fork Valley Airport",
      "North Fork Valley Airport"
    ],
    "city": [
      "Paonia",
      "Paonia",
      "Paonia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ATE",
    "translations": [
      "Antlers Municipal Airport",
      "Antlers Municipal Airport",
      "Antlers Municipal Airport"
    ],
    "city": [
      "Antlers",
      "Antlers",
      "Antlers"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ASQ",
    "translations": [
      "Austin Airport",
      "Austin Airport",
      "Austin Airport"
    ],
    "city": [
      "Austin",
      "Austin",
      "Austin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AAF",
    "translations": [
      "Apalachicola Regional Airport",
      "Apalachicola Regional Airport",
      "Apalachicola Regional Airport"
    ],
    "city": [
      "Apalachicola",
      "Apalachicola",
      "Apalachicola"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ABE",
    "translations": [
      "Lehigh Valley International Airport",
      "Lehigh Valley International Airport",
      "Lehigh Valley International Airport"
    ],
    "city": [
      "Allentown",
      "Allentown",
      "Allentown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ABI",
    "translations": [
      "Abilene Regional Airport",
      "Abilene Regional Airport",
      "Abilene Regional Airport"
    ],
    "city": [
      "Abilene",
      "Abilene",
      "Abilene"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ABQ",
    "translations": [
      "Albuquerque International Sunport",
      "Albuquerque International Sunport",
      "Albuquerque International Sunport"
    ],
    "city": [
      "Albuquerque",
      "Albuquerque",
      "Albuquerque"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ABR",
    "translations": [
      "Aberdeen Regional Airport",
      "Aberdeen Regional Airport",
      "Aberdeen Regional Airport"
    ],
    "city": [
      "Aberdeen",
      "Aberdeen",
      "Aberdeen"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ABY",
    "translations": [
      "Southwest Georgia Regional Airport",
      "Southwest Georgia Regional Airport",
      "Southwest Georgia Regional Airport"
    ],
    "city": [
      "Albany",
      "Albany",
      "Albany"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ACB",
    "translations": [
      "Antrim County Airport",
      "Antrim County Airport",
      "Antrim County Airport"
    ],
    "city": [
      "Bellaire",
      "Bellaire",
      "Bellaire"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ACK",
    "translations": [
      "Nantucket Memorial Airport",
      "Nantucket Memorial Airport",
      "Nantucket Memorial Airport"
    ],
    "city": [
      "Nantucket",
      "Nantucket",
      "Nantucket"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ACT",
    "translations": [
      "Waco Regional Airport",
      "Waco Regional Airport",
      "Waco Regional Airport"
    ],
    "city": [
      "Waco",
      "Waco",
      "Waco"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ACV",
    "translations": [
      "California Redwood Coast-Humboldt County Airport",
      "California Redwood Coast-Humboldt County Airport",
      "California Redwood Coast-Humboldt County Airport"
    ],
    "city": [
      "Arcata/Eureka",
      "Arcata/Eureka",
      "Arcata/Eureka"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ACY",
    "translations": [
      "Atlantic City International Airport",
      "Atlantic City International Airport",
      "Atlantic City International Airport"
    ],
    "city": [
      "Atlantic City",
      "Atlantic City",
      "Atlantic City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ADG",
    "translations": [
      "Lenawee County Airport",
      "Lenawee County Airport",
      "Lenawee County Airport"
    ],
    "city": [
      "Adrian",
      "Adrian",
      "Adrian"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ADT",
    "translations": [
      "Ada Regional Airport",
      "Ada Regional Airport",
      "Ada Regional Airport"
    ],
    "city": [
      "Ada",
      "Ada",
      "Ada"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ADM",
    "translations": [
      "Ardmore Municipal Airport",
      "Ardmore Municipal Airport",
      "Ardmore Municipal Airport"
    ],
    "city": [
      "Ardmore",
      "Ardmore",
      "Ardmore"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ADS",
    "translations": [
      "Addison Airport",
      "Addison Airport",
      "Addison Airport"
    ],
    "city": [
      "Dallas",
      "Dallas",
      "Dallas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ADW",
    "translations": [
      "Joint Base Andrews",
      "Joint Base Andrews",
      "Joint Base Andrews"
    ],
    "city": [
      "Camp Springs",
      "Camp Springs",
      "Camp Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KAE",
    "translations": [
      "Kake Seaplane Base",
      "Kake Seaplane Base",
      "Kake Seaplane Base"
    ],
    "city": [
      "Kake",
      "Kake",
      "Kake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AEL",
    "translations": [
      "Albert Lea Municipal Airport",
      "Albert Lea Municipal Airport",
      "Albert Lea Municipal Airport"
    ],
    "city": [
      "Albert Lea",
      "Albert Lea",
      "Albert Lea"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AEX",
    "translations": [
      "Alexandria International Airport",
      "Alexandria International Airport",
      "Alexandria International Airport"
    ],
    "city": [
      "Alexandria",
      "Alexandria",
      "Alexandria"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KAF",
    "translations": [
      "Karato Airport",
      "Karato Airport",
      "Karato Airport"
    ],
    "city": [
      "Karato",
      "Karato",
      "Karato"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AFF",
    "translations": [
      "USAF Academy Airfield",
      "USAF Academy Airfield",
      "USAF Academy Airfield"
    ],
    "city": [
      "Colorado Springs",
      "Colorado Springs",
      "Colorado Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WSG",
    "translations": [
      "Washington County Airport",
      "Washington County Airport",
      "Washington County Airport"
    ],
    "city": [
      "Washington",
      "Washington",
      "Washington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AFN",
    "translations": [
      "Jaffrey Airfield Silver Ranch Airport",
      "Jaffrey Airfield Silver Ranch Airport",
      "Jaffrey Airfield Silver Ranch Airport"
    ],
    "city": [
      "Jaffrey",
      "Jaffrey",
      "Jaffrey"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AFO",
    "translations": [
      "Afton Municipal Airport",
      "Afton Municipal Airport",
      "Afton Municipal Airport"
    ],
    "city": [
      "Afton",
      "Afton",
      "Afton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AFW",
    "translations": [
      "Perot Field/Fort Worth Alliance Airport",
      "Perot Field/Fort Worth Alliance Airport",
      "Perot Field/Fort Worth Alliance Airport"
    ],
    "city": [
      "Fort Worth",
      "Fort Worth",
      "Fort Worth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AGC",
    "translations": [
      "Allegheny County Airport",
      "Allegheny County Airport",
      "Allegheny County Airport"
    ],
    "city": [
      "Pittsburgh",
      "Pittsburgh",
      "Pittsburgh"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AGO",
    "translations": [
      "Magnolia Municipal Airport / Ralph C Weiser Field",
      "Magnolia Municipal Airport / Ralph C Weiser Field",
      "Magnolia Municipal Airport / Ralph C Weiser Field"
    ],
    "city": [
      "Magnolia",
      "Magnolia",
      "Magnolia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AGS",
    "translations": [
      "Augusta Regional At Bush Field",
      "Augusta Regional At Bush Field",
      "Augusta Regional At Bush Field"
    ],
    "city": [
      "Augusta",
      "Augusta",
      "Augusta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AHC",
    "translations": [
      "Amedee Army Air Field",
      "Amedee Army Air Field",
      "Amedee Army Air Field"
    ],
    "city": [
      "Herlong",
      "Herlong",
      "Herlong"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AHH",
    "translations": [
      "Amery Municipal Airport",
      "Amery Municipal Airport",
      "Amery Municipal Airport"
    ],
    "city": [
      "Amery",
      "Amery",
      "Amery"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AHN",
    "translations": [
      "Athens Ben Epps Airport",
      "Athens Ben Epps Airport",
      "Athens Ben Epps Airport"
    ],
    "city": [
      "Athens",
      "Athens",
      "Athens"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AIA",
    "translations": [
      "Alliance Municipal Airport",
      "Alliance Municipal Airport",
      "Alliance Municipal Airport"
    ],
    "city": [
      "Alliance",
      "Alliance",
      "Alliance"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AID",
    "translations": [
      "Anderson Municipal Darlington Field",
      "Anderson Municipal Darlington Field",
      "Anderson Municipal Darlington Field"
    ],
    "city": [
      "Anderson",
      "Anderson",
      "Anderson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AIK",
    "translations": [
      "Aiken Regional Airport",
      "Aiken Regional Airport",
      "Aiken Regional Airport"
    ],
    "city": [
      "Aiken",
      "Aiken",
      "Aiken"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AIO",
    "translations": [
      "Atlantic Municipal Airport",
      "Atlantic Municipal Airport",
      "Atlantic Municipal Airport"
    ],
    "city": [
      "Atlantic",
      "Atlantic",
      "Atlantic"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AIV",
    "translations": [
      "George Downer Airport",
      "George Downer Airport",
      "George Downer Airport"
    ],
    "city": [
      "Aliceville",
      "Aliceville",
      "Aliceville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AIZ",
    "translations": [
      "Lee C Fine Memorial Airport",
      "Lee C Fine Memorial Airport",
      "Lee C Fine Memorial Airport"
    ],
    "city": [
      "Kaiser Lake Ozark",
      "Kaiser Lake Ozark",
      "Kaiser Lake Ozark"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KAK",
    "translations": [
      "Kar Airport",
      "Kar Airport",
      "Kar Airport"
    ],
    "city": [
      "Kar",
      "Kar",
      "Kar"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AKO",
    "translations": [
      "Colorado Plains Regional Airport",
      "Colorado Plains Regional Airport",
      "Colorado Plains Regional Airport"
    ],
    "city": [
      "Akron",
      "Akron",
      "Akron"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AKC",
    "translations": [
      "Akron Fulton International Airport",
      "Akron Fulton International Airport",
      "Akron Fulton International Airport"
    ],
    "city": [
      "Akron",
      "Akron",
      "Akron"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ALB",
    "translations": [
      "Albany International Airport",
      "Albany International Airport",
      "Albany International Airport"
    ],
    "city": [
      "Albany",
      "Albany",
      "Albany"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ALI",
    "translations": [
      "Alice International Airport",
      "Alice International Airport",
      "Alice International Airport"
    ],
    "city": [
      "Alice",
      "Alice",
      "Alice"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ALM",
    "translations": [
      "Alamogordo White Sands Regional Airport",
      "Alamogordo White Sands Regional Airport",
      "Alamogordo White Sands Regional Airport"
    ],
    "city": [
      "Alamogordo",
      "Alamogordo",
      "Alamogordo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ALN",
    "translations": [
      "St Louis Regional Airport",
      "St Louis Regional Airport",
      "St Louis Regional Airport"
    ],
    "city": [
      "Alton/St Louis",
      "Alton/St Louis",
      "Alton/St Louis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ALO",
    "translations": [
      "Waterloo Regional Airport",
      "Waterloo Regional Airport",
      "Waterloo Regional Airport"
    ],
    "city": [
      "Waterloo",
      "Waterloo",
      "Waterloo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ALS",
    "translations": [
      "San Luis Valley Regional Airport/Bergman Field",
      "San Luis Valley Regional Airport/Bergman Field",
      "San Luis Valley Regional Airport/Bergman Field"
    ],
    "city": [
      "Alamosa",
      "Alamosa",
      "Alamosa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ALW",
    "translations": [
      "Walla Walla Regional Airport",
      "Walla Walla Regional Airport",
      "Walla Walla Regional Airport"
    ],
    "city": [
      "Walla Walla",
      "Walla Walla",
      "Walla Walla"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ALX",
    "translations": [
      "Thomas C Russell Field",
      "Thomas C Russell Field",
      "Thomas C Russell Field"
    ],
    "city": [
      "Alexander City",
      "Alexander City",
      "Alexander City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AMA",
    "translations": [
      "Rick Husband Amarillo International Airport",
      "Rick Husband Amarillo International Airport",
      "Rick Husband Amarillo International Airport"
    ],
    "city": [
      "Amarillo",
      "Amarillo",
      "Amarillo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AMN",
    "translations": [
      "Gratiot Community Airport",
      "Gratiot Community Airport",
      "Gratiot Community Airport"
    ],
    "city": [
      "Alma",
      "Alma",
      "Alma"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AMW",
    "translations": [
      "Ames Municipal Airport",
      "Ames Municipal Airport",
      "Ames Municipal Airport"
    ],
    "city": [
      "Ames",
      "Ames",
      "Ames"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ANB",
    "translations": [
      "Anniston Regional Airport",
      "Anniston Regional Airport",
      "Anniston Regional Airport"
    ],
    "city": [
      "Anniston",
      "Anniston",
      "Anniston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AND",
    "translations": [
      "Anderson Regional Airport",
      "Anderson Regional Airport",
      "Anderson Regional Airport"
    ],
    "city": [
      "Anderson",
      "Anderson",
      "Anderson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SLT",
    "translations": [
      "Salida Airport - Harriet Alexander Field",
      "Salida Airport - Harriet Alexander Field",
      "Salida Airport - Harriet Alexander Field"
    ],
    "city": [
      "Salida",
      "Salida",
      "Salida"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ANP",
    "translations": [
      "Lee Airport",
      "Lee Airport",
      "Lee Airport"
    ],
    "city": [
      "Annapolis",
      "Annapolis",
      "Annapolis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ANQ",
    "translations": [
      "Tri State Steuben County Airport",
      "Tri State Steuben County Airport",
      "Tri State Steuben County Airport"
    ],
    "city": [
      "Angola",
      "Angola",
      "Angola"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ANW",
    "translations": [
      "Ainsworth Regional Airport",
      "Ainsworth Regional Airport",
      "Ainsworth Regional Airport"
    ],
    "city": [
      "Ainsworth",
      "Ainsworth",
      "Ainsworth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ANY",
    "translations": [
      "Anthony Municipal Airport",
      "Anthony Municipal Airport",
      "Anthony Municipal Airport"
    ],
    "city": [
      "Anthony",
      "Anthony",
      "Anthony"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AOH",
    "translations": [
      "Lima Allen County Airport",
      "Lima Allen County Airport",
      "Lima Allen County Airport"
    ],
    "city": [
      "Lima",
      "Lima",
      "Lima"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AOO",
    "translations": [
      "Altoona Blair County Airport",
      "Altoona Blair County Airport",
      "Altoona Blair County Airport"
    ],
    "city": [
      "Altoona",
      "Altoona",
      "Altoona"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "APA",
    "translations": [
      "Centennial Airport",
      "Centennial Airport",
      "Centennial Airport"
    ],
    "city": [
      "Denver",
      "Denver",
      "Denver"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "APC",
    "translations": [
      "Napa County Airport",
      "Napa County Airport",
      "Napa County Airport"
    ],
    "city": [
      "Napa",
      "Napa",
      "Napa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "APF",
    "translations": [
      "Naples Municipal Airport",
      "Naples Municipal Airport",
      "Naples Municipal Airport"
    ],
    "city": [
      "Naples",
      "Naples",
      "Naples"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "APG",
    "translations": [
      "Phillips Army Air Field",
      "Phillips Army Air Field",
      "Phillips Army Air Field"
    ],
    "city": [
      "Aberdeen",
      "Aberdeen",
      "Aberdeen"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "APH",
    "translations": [
      "Mary Walker LZ Airport",
      "Mary Walker LZ Airport",
      "Mary Walker LZ Airport"
    ],
    "city": [
      "Bowling Green",
      "Bowling Green",
      "Bowling Green"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "APN",
    "translations": [
      "Alpena County Regional Airport",
      "Alpena County Regional Airport",
      "Alpena County Regional Airport"
    ],
    "city": [
      "Alpena",
      "Alpena",
      "Alpena"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "APT",
    "translations": [
      "Marion County Airport - Brown Field",
      "Marion County Airport - Brown Field",
      "Marion County Airport - Brown Field"
    ],
    "city": [
      "Jasper",
      "Jasper",
      "Jasper"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "APV",
    "translations": [
      "Apple Valley Airport",
      "Apple Valley Airport",
      "Apple Valley Airport"
    ],
    "city": [
      "Apple Valley",
      "Apple Valley",
      "Apple Valley"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ARA",
    "translations": [
      "Acadiana Regional Airport",
      "Acadiana Regional Airport",
      "Acadiana Regional Airport"
    ],
    "city": [
      "New Iberia",
      "New Iberia",
      "New Iberia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ARB",
    "translations": [
      "Ann Arbor Municipal Airport",
      "Ann Arbor Municipal Airport",
      "Ann Arbor Municipal Airport"
    ],
    "city": [
      "Ann Arbor",
      "Ann Arbor",
      "Ann Arbor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ARG",
    "translations": [
      "Walnut Ridge Regional Airport",
      "Walnut Ridge Regional Airport",
      "Walnut Ridge Regional Airport"
    ],
    "city": [
      "Walnut Ridge",
      "Walnut Ridge",
      "Walnut Ridge"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WHT",
    "translations": [
      "Wharton Regional Airport",
      "Wharton Regional Airport",
      "Wharton Regional Airport"
    ],
    "city": [
      "Wharton",
      "Wharton",
      "Wharton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AUZ",
    "translations": [
      "Aurora Municipal Airport",
      "Aurora Municipal Airport",
      "Aurora Municipal Airport"
    ],
    "city": [
      "Chicago/Aurora",
      "Chicago/Aurora",
      "Chicago/Aurora"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ART",
    "translations": [
      "Watertown International Airport",
      "Watertown International Airport",
      "Watertown International Airport"
    ],
    "city": [
      "Watertown",
      "Watertown",
      "Watertown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ARV",
    "translations": [
      "Lakeland Airport Noble F Lee Memorial Field",
      "Lakeland Airport Noble F Lee Memorial Field",
      "Lakeland Airport Noble F Lee Memorial Field"
    ],
    "city": [
      "Woodruff",
      "Woodruff",
      "Woodruff"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BFT",
    "translations": [
      "Beaufort Executive Airport",
      "Beaufort Executive Airport",
      "Beaufort Executive Airport"
    ],
    "city": [
      "Beaufort",
      "Beaufort",
      "Beaufort"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ASE",
    "translations": [
      "Aspen-Pitkin County Airport (Sardy Field)",
      "Aspen-Pitkin County Airport (Sardy Field)",
      "Aspen-Pitkin County Airport (Sardy Field)"
    ],
    "city": [
      "Aspen",
      "Aspen",
      "Aspen"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SPZ",
    "translations": [
      "Springdale Municipal Airport",
      "Springdale Municipal Airport",
      "Springdale Municipal Airport"
    ],
    "city": [
      "Springdale",
      "Springdale",
      "Springdale"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ASH",
    "translations": [
      "Nashua Airport / Boire Field",
      "Nashua Airport / Boire Field",
      "Nashua Airport / Boire Field"
    ],
    "city": [
      "Nashua",
      "Nashua",
      "Nashua"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ASL",
    "translations": [
      "Harrison County Airport",
      "Harrison County Airport",
      "Harrison County Airport"
    ],
    "city": [
      "Marshall",
      "Marshall",
      "Marshall"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ASN",
    "translations": [
      "Talladega Municipal Airport",
      "Talladega Municipal Airport",
      "Talladega Municipal Airport"
    ],
    "city": [
      "Talladega",
      "Talladega",
      "Talladega"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AST",
    "translations": [
      "Astoria Regional Airport",
      "Astoria Regional Airport",
      "Astoria Regional Airport"
    ],
    "city": [
      "Astoria",
      "Astoria",
      "Astoria"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ASX",
    "translations": [
      "John F Kennedy Memorial Airport",
      "John F Kennedy Memorial Airport",
      "John F Kennedy Memorial Airport"
    ],
    "city": [
      "Ashland",
      "Ashland",
      "Ashland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ASY",
    "translations": [
      "Ashley Municipal Airport",
      "Ashley Municipal Airport",
      "Ashley Municipal Airport"
    ],
    "city": [
      "Ashley",
      "Ashley",
      "Ashley"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ATL",
    "translations": [
      "Hartsfield Jackson Atlanta International Airport",
      "Hartsfield Jackson Atlanta International Airport",
      "Hartsfield Jackson Atlanta International Airport"
    ],
    "city": [
      "Atlanta",
      "Atlanta",
      "Atlanta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ATS",
    "translations": [
      "Artesia Municipal Airport",
      "Artesia Municipal Airport",
      "Artesia Municipal Airport"
    ],
    "city": [
      "Artesia",
      "Artesia",
      "Artesia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ATW",
    "translations": [
      "Appleton International Airport",
      "Appleton International Airport",
      "Appleton International Airport"
    ],
    "city": [
      "Appleton",
      "Appleton",
      "Appleton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ATY",
    "translations": [
      "Watertown Regional Airport",
      "Watertown Regional Airport",
      "Watertown Regional Airport"
    ],
    "city": [
      "Watertown",
      "Watertown",
      "Watertown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AUG",
    "translations": [
      "Augusta State Airport",
      "Augusta State Airport",
      "Augusta State Airport"
    ],
    "city": [
      "Augusta",
      "Augusta",
      "Augusta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AUM",
    "translations": [
      "Austin Municipal Airport",
      "Austin Municipal Airport",
      "Austin Municipal Airport"
    ],
    "city": [
      "Austin",
      "Austin",
      "Austin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AUN",
    "translations": [
      "Auburn Municipal Airport",
      "Auburn Municipal Airport",
      "Auburn Municipal Airport"
    ],
    "city": [
      "Auburn",
      "Auburn",
      "Auburn"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AUO",
    "translations": [
      "Auburn University Regional Airport",
      "Auburn University Regional Airport",
      "Auburn University Regional Airport"
    ],
    "city": [
      "Auburn",
      "Auburn",
      "Auburn"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AUS",
    "translations": [
      "Austin Bergstrom International Airport",
      "Austin Bergstrom International Airport",
      "Austin Bergstrom International Airport"
    ],
    "city": [
      "Austin",
      "Austin",
      "Austin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AUW",
    "translations": [
      "Wausau Downtown Airport",
      "Wausau Downtown Airport",
      "Wausau Downtown Airport"
    ],
    "city": [
      "Wausau",
      "Wausau",
      "Wausau"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AVL",
    "translations": [
      "Asheville Regional Airport",
      "Asheville Regional Airport",
      "Asheville Regional Airport"
    ],
    "city": [
      "Asheville",
      "Asheville",
      "Asheville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AVO",
    "translations": [
      "Avon Park Executive Airport",
      "Avon Park Executive Airport",
      "Avon Park Executive Airport"
    ],
    "city": [
      "Avon Park",
      "Avon Park",
      "Avon Park"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AVP",
    "translations": [
      "Wilkes Barre Scranton International Airport",
      "Wilkes Barre Scranton International Airport",
      "Wilkes Barre Scranton International Airport"
    ],
    "city": [
      "Wilkes-Barre/Scranton",
      "Wilkes-Barre/Scranton",
      "Wilkes-Barre/Scranton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AVW",
    "translations": [
      "Marana Regional Airport",
      "Marana Regional Airport",
      "Marana Regional Airport"
    ],
    "city": [
      "Marana",
      "Marana",
      "Marana"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AVX",
    "translations": [
      "Catalina Airport",
      "Catalina Airport",
      "Catalina Airport"
    ],
    "city": [
      "Avalon",
      "Avalon",
      "Avalon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AWM",
    "translations": [
      "West Memphis Municipal Airport",
      "West Memphis Municipal Airport",
      "West Memphis Municipal Airport"
    ],
    "city": [
      "West Memphis",
      "West Memphis",
      "West Memphis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AXG",
    "translations": [
      "Algona Municipal Airport",
      "Algona Municipal Airport",
      "Algona Municipal Airport"
    ],
    "city": [
      "Algona",
      "Algona",
      "Algona"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AXN",
    "translations": [
      "Chandler Field",
      "Chandler Field",
      "Chandler Field"
    ],
    "city": [
      "Alexandria",
      "Alexandria",
      "Alexandria"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AXS",
    "translations": [
      "Altus Quartz Mountain Regional Airport",
      "Altus Quartz Mountain Regional Airport",
      "Altus Quartz Mountain Regional Airport"
    ],
    "city": [
      "Altus",
      "Altus",
      "Altus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AXV",
    "translations": [
      "Neil Armstrong Airport",
      "Neil Armstrong Airport",
      "Neil Armstrong Airport"
    ],
    "city": [
      "Wapakoneta",
      "Wapakoneta",
      "Wapakoneta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AXX",
    "translations": [
      "Angel Fire Airport",
      "Angel Fire Airport",
      "Angel Fire Airport"
    ],
    "city": [
      "Angel Fire",
      "Angel Fire",
      "Angel Fire"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AYS",
    "translations": [
      "Waycross Ware County Airport",
      "Waycross Ware County Airport",
      "Waycross Ware County Airport"
    ],
    "city": [
      "Waycross",
      "Waycross",
      "Waycross"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TUH",
    "translations": [
      "Arnold Air Force Base",
      "Arnold Air Force Base",
      "Arnold Air Force Base"
    ],
    "city": [
      "Manchester",
      "Manchester",
      "Manchester"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AZO",
    "translations": [
      "Kalamazoo Battle Creek International Airport",
      "Kalamazoo Battle Creek International Airport",
      "Kalamazoo Battle Creek International Airport"
    ],
    "city": [
      "Kalamazoo",
      "Kalamazoo",
      "Kalamazoo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BAB",
    "translations": [
      "Beale Air Force Base",
      "Beale Air Force Base",
      "Beale Air Force Base"
    ],
    "city": [
      "Beale Air Force Base",
      "Beale Air Force Base",
      "Beale Air Force Base"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BAD",
    "translations": [
      "Barksdale Air Force Base",
      "Barksdale Air Force Base",
      "Barksdale Air Force Base"
    ],
    "city": [
      "Bossier City",
      "Bossier City",
      "Bossier City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BAF",
    "translations": [
      "Westfield-Barnes Regional Airport",
      "Westfield-Barnes Regional Airport",
      "Westfield-Barnes Regional Airport"
    ],
    "city": [
      "Westfield",
      "Westfield",
      "Westfield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CLU",
    "translations": [
      "Columbus Municipal Airport",
      "Columbus Municipal Airport",
      "Columbus Municipal Airport"
    ],
    "city": [
      "Columbus",
      "Columbus",
      "Columbus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BAM",
    "translations": [
      "Battle Mountain Airport",
      "Battle Mountain Airport",
      "Battle Mountain Airport"
    ],
    "city": [
      "Battle Mountain",
      "Battle Mountain",
      "Battle Mountain"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BBB",
    "translations": [
      "Benson Municipal Airport",
      "Benson Municipal Airport",
      "Benson Municipal Airport"
    ],
    "city": [
      "Benson",
      "Benson",
      "Benson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BBD",
    "translations": [
      "Curtis Field",
      "Curtis Field",
      "Curtis Field"
    ],
    "city": [
      "Brady",
      "Brady",
      "Brady"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BKG",
    "translations": [
      "Branson Airport",
      "Branson Airport",
      "Branson Airport"
    ],
    "city": [
      "Branson",
      "Branson",
      "Branson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BTN",
    "translations": [
      "Marlboro County Jetport - H E Avent Field Airport",
      "Marlboro County Jetport - H E Avent Field Airport",
      "Marlboro County Jetport - H E Avent Field Airport"
    ],
    "city": [
      "Bennettsville",
      "Bennettsville",
      "Bennettsville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BBW",
    "translations": [
      "Broken Bow Municipal Airport",
      "Broken Bow Municipal Airport",
      "Broken Bow Municipal Airport"
    ],
    "city": [
      "Broken Bow",
      "Broken Bow",
      "Broken Bow"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BCB",
    "translations": [
      "Virginia Tech Montgomery Executive Airport",
      "Virginia Tech Montgomery Executive Airport",
      "Virginia Tech Montgomery Executive Airport"
    ],
    "city": [
      "Blacksburg",
      "Blacksburg",
      "Blacksburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BCE",
    "translations": [
      "Bryce Canyon Airport",
      "Bryce Canyon Airport",
      "Bryce Canyon Airport"
    ],
    "city": [
      "Bryce Canyon",
      "Bryce Canyon",
      "Bryce Canyon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BCT",
    "translations": [
      "Boca Raton Airport",
      "Boca Raton Airport",
      "Boca Raton Airport"
    ],
    "city": [
      "Boca Raton",
      "Boca Raton",
      "Boca Raton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BDE",
    "translations": [
      "Baudette International Airport",
      "Baudette International Airport",
      "Baudette International Airport"
    ],
    "city": [
      "Baudette",
      "Baudette",
      "Baudette"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BDG",
    "translations": [
      "Blanding Municipal Airport",
      "Blanding Municipal Airport",
      "Blanding Municipal Airport"
    ],
    "city": [
      "Blanding",
      "Blanding",
      "Blanding"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ILL",
    "translations": [
      "Willmar Municipal Airport John L Rice Field (2006)",
      "Willmar Municipal Airport John L Rice Field (2006)",
      "Willmar Municipal Airport John L Rice Field (2006)"
    ],
    "city": [
      "Willmar",
      "Willmar",
      "Willmar"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BDL",
    "translations": [
      "Bradley International Airport",
      "Bradley International Airport",
      "Bradley International Airport"
    ],
    "city": [
      "Hartford",
      "Hartford",
      "Hartford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BDR",
    "translations": [
      "Igor I Sikorsky Memorial Airport",
      "Igor I Sikorsky Memorial Airport",
      "Igor I Sikorsky Memorial Airport"
    ],
    "city": [
      "Bridgeport",
      "Bridgeport",
      "Bridgeport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WBU",
    "translations": [
      "Boulder Municipal Airport",
      "Boulder Municipal Airport",
      "Boulder Municipal Airport"
    ],
    "city": [
      "Boulder",
      "Boulder",
      "Boulder"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KBE",
    "translations": [
      "Bell Island Hot Springs Seaplane Base",
      "Bell Island Hot Springs Seaplane Base",
      "Bell Island Hot Springs Seaplane Base"
    ],
    "city": [
      "Bell Island",
      "Bell Island",
      "Bell Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BEC",
    "translations": [
      "Beech Factory Airport",
      "Beech Factory Airport",
      "Beech Factory Airport"
    ],
    "city": [
      "Wichita",
      "Wichita",
      "Wichita"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BED",
    "translations": [
      "Laurence G Hanscom Field",
      "Laurence G Hanscom Field",
      "Laurence G Hanscom Field"
    ],
    "city": [
      "Bedford",
      "Bedford",
      "Bedford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BEH",
    "translations": [
      "Southwest Michigan Regional Airport",
      "Southwest Michigan Regional Airport",
      "Southwest Michigan Regional Airport"
    ],
    "city": [
      "Benton Harbor",
      "Benton Harbor",
      "Benton Harbor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BFD",
    "translations": [
      "Bradford Regional Airport",
      "Bradford Regional Airport",
      "Bradford Regional Airport"
    ],
    "city": [
      "Bradford",
      "Bradford",
      "Bradford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BFF",
    "translations": [
      "Western Neb. Rgnl/William B. Heilig Airport",
      "Western Neb. Rgnl/William B. Heilig Airport",
      "Western Neb. Rgnl/William B. Heilig Airport"
    ],
    "city": [
      "Scottsbluff",
      "Scottsbluff",
      "Scottsbluff"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BFI",
    "translations": [
      "Boeing Field King County International Airport",
      "Boeing Field King County International Airport",
      "Boeing Field King County International Airport"
    ],
    "city": [
      "Seattle",
      "Seattle",
      "Seattle"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BFL",
    "translations": [
      "Meadows Field",
      "Meadows Field",
      "Meadows Field"
    ],
    "city": [
      "Bakersfield",
      "Bakersfield",
      "Bakersfield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BFM",
    "translations": [
      "Mobile Downtown Airport",
      "Mobile Downtown Airport",
      "Mobile Downtown Airport"
    ],
    "city": [
      "Mobile",
      "Mobile",
      "Mobile"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BFR",
    "translations": [
      "Virgil I Grissom Municipal Airport",
      "Virgil I Grissom Municipal Airport",
      "Virgil I Grissom Municipal Airport"
    ],
    "city": [
      "Bedford",
      "Bedford",
      "Bedford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BGD",
    "translations": [
      "Hutchinson County Airport",
      "Hutchinson County Airport",
      "Hutchinson County Airport"
    ],
    "city": [
      "Borger",
      "Borger",
      "Borger"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BGE",
    "translations": [
      "Decatur County Industrial Air Park",
      "Decatur County Industrial Air Park",
      "Decatur County Industrial Air Park"
    ],
    "city": [
      "Bainbridge",
      "Bainbridge",
      "Bainbridge"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BGM",
    "translations": [
      "Greater Binghamton/Edwin A Link field",
      "Greater Binghamton/Edwin A Link field",
      "Greater Binghamton/Edwin A Link field"
    ],
    "city": [
      "Binghamton",
      "Binghamton",
      "Binghamton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BGR",
    "translations": [
      "Bangor International Airport",
      "Bangor International Airport",
      "Bangor International Airport"
    ],
    "city": [
      "Bangor",
      "Bangor",
      "Bangor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KBH",
    "translations": [
      "Kahama Airstrip",
      "Kahama Airstrip",
      "Kahama Airstrip"
    ],
    "city": [
      "Kahama",
      "Kahama",
      "Kahama"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "BHB",
    "translations": [
      "Hancock County-Bar Harbor Airport",
      "Hancock County-Bar Harbor Airport",
      "Hancock County-Bar Harbor Airport"
    ],
    "city": [
      "Bar Harbor",
      "Bar Harbor",
      "Bar Harbor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BHM",
    "translations": [
      "Birmingham-Shuttlesworth International Airport",
      "Birmingham-Shuttlesworth International Airport",
      "Birmingham-Shuttlesworth International Airport"
    ],
    "city": [
      "Birmingham",
      "Birmingham",
      "Birmingham"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BID",
    "translations": [
      "Block Island State Airport",
      "Block Island State Airport",
      "Block Island State Airport"
    ],
    "city": [
      "Block Island",
      "Block Island",
      "Block Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BIE",
    "translations": [
      "Beatrice Municipal Airport",
      "Beatrice Municipal Airport",
      "Beatrice Municipal Airport"
    ],
    "city": [
      "Beatrice",
      "Beatrice",
      "Beatrice"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BIF",
    "translations": [
      "Biggs Army Air Field (Fort Bliss)",
      "Biggs Army Air Field (Fort Bliss)",
      "Biggs Army Air Field (Fort Bliss)"
    ],
    "city": [
      "Fort Bliss/El Paso",
      "Fort Bliss/El Paso",
      "Fort Bliss/El Paso"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BIH",
    "translations": [
      "Eastern Sierra Regional Airport",
      "Eastern Sierra Regional Airport",
      "Eastern Sierra Regional Airport"
    ],
    "city": [
      "Bishop",
      "Bishop",
      "Bishop"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BIL",
    "translations": [
      "Billings Logan International Airport",
      "Billings Logan International Airport",
      "Billings Logan International Airport"
    ],
    "city": [
      "Billings",
      "Billings",
      "Billings"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BIS",
    "translations": [
      "Bismarck Municipal Airport",
      "Bismarck Municipal Airport",
      "Bismarck Municipal Airport"
    ],
    "city": [
      "Bismarck",
      "Bismarck",
      "Bismarck"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BIX",
    "translations": [
      "Keesler Air Force Base",
      "Keesler Air Force Base",
      "Keesler Air Force Base"
    ],
    "city": [
      "Biloxi",
      "Biloxi",
      "Biloxi"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BJC",
    "translations": [
      "Rocky Mountain Metropolitan Airport",
      "Rocky Mountain Metropolitan Airport",
      "Rocky Mountain Metropolitan Airport"
    ],
    "city": [
      "Denver",
      "Denver",
      "Denver"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BJI",
    "translations": [
      "Bemidji Regional Airport",
      "Bemidji Regional Airport",
      "Bemidji Regional Airport"
    ],
    "city": [
      "Bemidji",
      "Bemidji",
      "Bemidji"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BJJ",
    "translations": [
      "Wayne County Airport",
      "Wayne County Airport",
      "Wayne County Airport"
    ],
    "city": [
      "Wooster",
      "Wooster",
      "Wooster"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BKD",
    "translations": [
      "Stephens County Airport",
      "Stephens County Airport",
      "Stephens County Airport"
    ],
    "city": [
      "Breckenridge",
      "Breckenridge",
      "Breckenridge"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BKE",
    "translations": [
      "Baker City Municipal Airport",
      "Baker City Municipal Airport",
      "Baker City Municipal Airport"
    ],
    "city": [
      "Baker City",
      "Baker City",
      "Baker City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BFK",
    "translations": [
      "Buckley Space Force Base",
      "Buckley Space Force Base",
      "Buckley Space Force Base"
    ],
    "city": [
      "Aurora",
      "Aurora",
      "Aurora"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BKL",
    "translations": [
      "Burke Lakefront Airport",
      "Burke Lakefront Airport",
      "Burke Lakefront Airport"
    ],
    "city": [
      "Cleveland",
      "Cleveland",
      "Cleveland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BKT",
    "translations": [
      "Allen C Perkinson Blackstone Army Air Field",
      "Allen C Perkinson Blackstone Army Air Field",
      "Allen C Perkinson Blackstone Army Air Field"
    ],
    "city": [
      "Blackstone",
      "Blackstone",
      "Blackstone"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BKW",
    "translations": [
      "Raleigh County Memorial Airport",
      "Raleigh County Memorial Airport",
      "Raleigh County Memorial Airport"
    ],
    "city": [
      "Beaver",
      "Beaver",
      "Beaver"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BKX",
    "translations": [
      "Brookings Regional Airport",
      "Brookings Regional Airport",
      "Brookings Regional Airport"
    ],
    "city": [
      "Brookings",
      "Brookings",
      "Brookings"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BLF",
    "translations": [
      "Mercer County Airport",
      "Mercer County Airport",
      "Mercer County Airport"
    ],
    "city": [
      "Bluefield",
      "Bluefield",
      "Bluefield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BLH",
    "translations": [
      "Blythe Airport",
      "Blythe Airport",
      "Blythe Airport"
    ],
    "city": [
      "Blythe",
      "Blythe",
      "Blythe"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BLI",
    "translations": [
      "Bellingham International Airport",
      "Bellingham International Airport",
      "Bellingham International Airport"
    ],
    "city": [
      "Bellingham",
      "Bellingham",
      "Bellingham"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BLM",
    "translations": [
      "Monmouth Executive Airport",
      "Monmouth Executive Airport",
      "Monmouth Executive Airport"
    ],
    "city": [
      "Belmar/Farmingdale",
      "Belmar/Farmingdale",
      "Belmar/Farmingdale"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BLU",
    "translations": [
      "Blue Canyon Nyack Airport",
      "Blue Canyon Nyack Airport",
      "Blue Canyon Nyack Airport"
    ],
    "city": [
      "Emigrant Gap",
      "Emigrant Gap",
      "Emigrant Gap"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BLV",
    "translations": [
      "Scott AFB/Midamerica Airport",
      "Scott AFB/Midamerica Airport",
      "Scott AFB/Midamerica Airport"
    ],
    "city": [
      "Belleville",
      "Belleville",
      "Belleville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BMC",
    "translations": [
      "Brigham City Regional Airport",
      "Brigham City Regional Airport",
      "Brigham City Regional Airport"
    ],
    "city": [
      "Brigham City",
      "Brigham City",
      "Brigham City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BMG",
    "translations": [
      "Monroe County Airport",
      "Monroe County Airport",
      "Monroe County Airport"
    ],
    "city": [
      "Bloomington",
      "Bloomington",
      "Bloomington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BMI",
    "translations": [
      "Central Illinois Regional Airport at Bloomington-Normal",
      "Central Illinois Regional Airport at Bloomington-Normal",
      "Central Illinois Regional Airport at Bloomington-Normal"
    ],
    "city": [
      "Bloomington/Normal",
      "Bloomington/Normal",
      "Bloomington/Normal"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BML",
    "translations": [
      "Berlin Regional Airport",
      "Berlin Regional Airport",
      "Berlin Regional Airport"
    ],
    "city": [
      "Berlin",
      "Berlin",
      "Berlin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BMT",
    "translations": [
      "Beaumont Municipal Airport",
      "Beaumont Municipal Airport",
      "Beaumont Municipal Airport"
    ],
    "city": [
      "Beaumont",
      "Beaumont",
      "Beaumont"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BNA",
    "translations": [
      "Nashville International Airport",
      "Nashville International Airport",
      "Nashville International Airport"
    ],
    "city": [
      "Nashville",
      "Nashville",
      "Nashville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BNG",
    "translations": [
      "Banning Municipal Airport",
      "Banning Municipal Airport",
      "Banning Municipal Airport"
    ],
    "city": [
      "Banning",
      "Banning",
      "Banning"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BNL",
    "translations": [
      "Barnwell Regional Airport",
      "Barnwell Regional Airport",
      "Barnwell Regional Airport"
    ],
    "city": [
      "Barnwell",
      "Barnwell",
      "Barnwell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BNO",
    "translations": [
      "Burns Municipal Airport",
      "Burns Municipal Airport",
      "Burns Municipal Airport"
    ],
    "city": [
      "Burns",
      "Burns",
      "Burns"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BNW",
    "translations": [
      "Boone Municipal Airport",
      "Boone Municipal Airport",
      "Boone Municipal Airport"
    ],
    "city": [
      "Boone",
      "Boone",
      "Boone"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BOI",
    "translations": [
      "Boise Air Terminal/Gowen Field",
      "Boise Air Terminal/Gowen Field",
      "Boise Air Terminal/Gowen Field"
    ],
    "city": [
      "Boise",
      "Boise",
      "Boise"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BOK",
    "translations": [
      "Brookings Airport",
      "Brookings Airport",
      "Brookings Airport"
    ],
    "city": [
      "Brookings",
      "Brookings",
      "Brookings"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BOS",
    "translations": [
      "Logan International Airport",
      "Logan International Airport",
      "Logan International Airport"
    ],
    "city": [
      "Boston",
      "Boston",
      "Boston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BOW",
    "translations": [
      "Bartow Executive Airport",
      "Bartow Executive Airport",
      "Bartow Executive Airport"
    ],
    "city": [
      "Bartow",
      "Bartow",
      "Bartow"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HCA",
    "translations": [
      "Big Spring Mc Mahon-Wrinkle Airport",
      "Big Spring Mc Mahon-Wrinkle Airport",
      "Big Spring Mc Mahon-Wrinkle Airport"
    ],
    "city": [
      "Big Spring",
      "Big Spring",
      "Big Spring"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BPI",
    "translations": [
      "Miley Memorial Field",
      "Miley Memorial Field",
      "Miley Memorial Field"
    ],
    "city": [
      "Big Piney",
      "Big Piney",
      "Big Piney"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WMH",
    "translations": [
      "Ozark Regional Airport",
      "Ozark Regional Airport",
      "Ozark Regional Airport"
    ],
    "city": [
      "Mountain Home",
      "Mountain Home",
      "Mountain Home"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BPT",
    "translations": [
      "Jack Brooks Regional Airport",
      "Jack Brooks Regional Airport",
      "Jack Brooks Regional Airport"
    ],
    "city": [
      "Beaumont/Port Arthur",
      "Beaumont/Port Arthur",
      "Beaumont/Port Arthur"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BQK",
    "translations": [
      "Brunswick Golden Isles Airport",
      "Brunswick Golden Isles Airport",
      "Brunswick Golden Isles Airport"
    ],
    "city": [
      "Brunswick",
      "Brunswick",
      "Brunswick"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BRD",
    "translations": [
      "Brainerd Lakes Regional Airport",
      "Brainerd Lakes Regional Airport",
      "Brainerd Lakes Regional Airport"
    ],
    "city": [
      "Brainerd",
      "Brainerd",
      "Brainerd"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BRL",
    "translations": [
      "Southeast Iowa Regional Airport",
      "Southeast Iowa Regional Airport",
      "Southeast Iowa Regional Airport"
    ],
    "city": [
      "Burlington",
      "Burlington",
      "Burlington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BRO",
    "translations": [
      "Brownsville South Padre Island International Airport",
      "Brownsville South Padre Island International Airport",
      "Brownsville South Padre Island International Airport"
    ],
    "city": [
      "Brownsville",
      "Brownsville",
      "Brownsville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BRY",
    "translations": [
      "Samuels Field",
      "Samuels Field",
      "Samuels Field"
    ],
    "city": [
      "Bardstown",
      "Bardstown",
      "Bardstown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KBT",
    "translations": [
      "Kaben Airport",
      "Kaben Airport",
      "Kaben Airport"
    ],
    "city": [
      "Kaben",
      "Kaben",
      "Kaben"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "BTF",
    "translations": [
      "Skypark Airport",
      "Skypark Airport",
      "Skypark Airport"
    ],
    "city": [
      "Bountiful",
      "Bountiful",
      "Bountiful"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BTL",
    "translations": [
      "Battle Creek Executive Airport at Kellogg Field",
      "Battle Creek Executive Airport at Kellogg Field",
      "Battle Creek Executive Airport at Kellogg Field"
    ],
    "city": [
      "Battle Creek",
      "Battle Creek",
      "Battle Creek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BTM",
    "translations": [
      "Bert Mooney Airport",
      "Bert Mooney Airport",
      "Bert Mooney Airport"
    ],
    "city": [
      "Butte",
      "Butte",
      "Butte"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TTO",
    "translations": [
      "Britton Municipal Airport",
      "Britton Municipal Airport",
      "Britton Municipal Airport"
    ],
    "city": [
      "Britton",
      "Britton",
      "Britton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BTP",
    "translations": [
      "Pittsburgh/Butler Regional Airport",
      "Pittsburgh/Butler Regional Airport",
      "Pittsburgh/Butler Regional Airport"
    ],
    "city": [
      "Butler",
      "Butler",
      "Butler"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BTR",
    "translations": [
      "Baton Rouge Metropolitan Airport",
      "Baton Rouge Metropolitan Airport",
      "Baton Rouge Metropolitan Airport"
    ],
    "city": [
      "Baton Rouge",
      "Baton Rouge",
      "Baton Rouge"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BTV",
    "translations": [
      "Burlington International Airport",
      "Burlington International Airport",
      "Burlington International Airport"
    ],
    "city": [
      "South Burlington",
      "South Burlington",
      "South Burlington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BTY",
    "translations": [
      "Beatty Airport",
      "Beatty Airport",
      "Beatty Airport"
    ],
    "city": [
      "Beatty",
      "Beatty",
      "Beatty"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BUB",
    "translations": [
      "Cram Field",
      "Cram Field",
      "Cram Field"
    ],
    "city": [
      "Burwell",
      "Burwell",
      "Burwell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BUF",
    "translations": [
      "Buffalo Niagara International Airport",
      "Buffalo Niagara International Airport",
      "Buffalo Niagara International Airport"
    ],
    "city": [
      "Buffalo",
      "Buffalo",
      "Buffalo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BUM",
    "translations": [
      "Butler Memorial Airport",
      "Butler Memorial Airport",
      "Butler Memorial Airport"
    ],
    "city": [
      "Butler",
      "Butler",
      "Butler"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BUR",
    "translations": [
      "Hollywood Burbank Airport",
      "Hollywood Burbank Airport",
      "Hollywood Burbank Airport"
    ],
    "city": [
      "Burbank",
      "Burbank",
      "Burbank"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BFP",
    "translations": [
      "Beaver County Airport",
      "Beaver County Airport",
      "Beaver County Airport"
    ],
    "city": [
      "Beaver Falls",
      "Beaver Falls",
      "Beaver Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BVO",
    "translations": [
      "Bartlesville Municipal Airport",
      "Bartlesville Municipal Airport",
      "Bartlesville Municipal Airport"
    ],
    "city": [
      "Bartlesville",
      "Bartlesville",
      "Bartlesville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MVW",
    "translations": [
      "Skagit Regional Airport",
      "Skagit Regional Airport",
      "Skagit Regional Airport"
    ],
    "city": [
      "Burlington",
      "Burlington",
      "Burlington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BVX",
    "translations": [
      "Batesville Regional Airport",
      "Batesville Regional Airport",
      "Batesville Regional Airport"
    ],
    "city": [
      "Batesville",
      "Batesville",
      "Batesville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BVY",
    "translations": [
      "Beverly Regional Airport",
      "Beverly Regional Airport",
      "Beverly Regional Airport"
    ],
    "city": [
      "Beverly / Danvers",
      "Beverly / Danvers",
      "Beverly / Danvers"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BWC",
    "translations": [
      "Brawley Municipal Airport",
      "Brawley Municipal Airport",
      "Brawley Municipal Airport"
    ],
    "city": [
      "Brawley",
      "Brawley",
      "Brawley"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BWD",
    "translations": [
      "Brownwood Regional Airport",
      "Brownwood Regional Airport",
      "Brownwood Regional Airport"
    ],
    "city": [
      "Brownwood",
      "Brownwood",
      "Brownwood"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BWG",
    "translations": [
      "Bowling Green Warren County Regional Airport",
      "Bowling Green Warren County Regional Airport",
      "Bowling Green Warren County Regional Airport"
    ],
    "city": [
      "Bowling Green",
      "Bowling Green",
      "Bowling Green"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BWI",
    "translations": [
      "Baltimore/Washington International Thurgood Marshall Airport",
      "Baltimore/Washington International Thurgood Marshall Airport",
      "Baltimore/Washington International Thurgood Marshall Airport"
    ],
    "city": [
      "Baltimore",
      "Baltimore",
      "Baltimore"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WAH",
    "translations": [
      "Harry Stern Airport",
      "Harry Stern Airport",
      "Harry Stern Airport"
    ],
    "city": [
      "Wahpeton",
      "Wahpeton",
      "Wahpeton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BWM",
    "translations": [
      "Bowman Regional Airport",
      "Bowman Regional Airport",
      "Bowman Regional Airport"
    ],
    "city": [
      "Bowman",
      "Bowman",
      "Bowman"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BXA",
    "translations": [
      "George R Carr Memorial Air Field",
      "George R Carr Memorial Air Field",
      "George R Carr Memorial Air Field"
    ],
    "city": [
      "Bogalusa",
      "Bogalusa",
      "Bogalusa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BXK",
    "translations": [
      "Buckeye Municipal Airport",
      "Buckeye Municipal Airport",
      "Buckeye Municipal Airport"
    ],
    "city": [
      "Buckeye",
      "Buckeye",
      "Buckeye"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NHZ",
    "translations": [
      "Brunswick Executive Airport",
      "Brunswick Executive Airport",
      "Brunswick Executive Airport"
    ],
    "city": [
      "Brunswick",
      "Brunswick",
      "Brunswick"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BYG",
    "translations": [
      "Johnson County Airport",
      "Johnson County Airport",
      "Johnson County Airport"
    ],
    "city": [
      "Buffalo",
      "Buffalo",
      "Buffalo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BYH",
    "translations": [
      "Arkansas International Airport",
      "Arkansas International Airport",
      "Arkansas International Airport"
    ],
    "city": [
      "Blytheville",
      "Blytheville",
      "Blytheville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BYI",
    "translations": [
      "Burley Municipal Airport",
      "Burley Municipal Airport",
      "Burley Municipal Airport"
    ],
    "city": [
      "Burley",
      "Burley",
      "Burley"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BYS",
    "translations": [
      "Bicycle Lake Army Air Field",
      "Bicycle Lake Army Air Field",
      "Bicycle Lake Army Air Field"
    ],
    "city": [
      "Fort Irwin/Barstow",
      "Fort Irwin/Barstow",
      "Fort Irwin/Barstow"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BBC",
    "translations": [
      "Bay City Regional Airport",
      "Bay City Regional Airport",
      "Bay City Regional Airport"
    ],
    "city": [
      "Bay City",
      "Bay City",
      "Bay City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BZN",
    "translations": [
      "Bozeman Yellowstone International Airport",
      "Bozeman Yellowstone International Airport",
      "Bozeman Yellowstone International Airport"
    ],
    "city": [
      "Bozeman",
      "Bozeman",
      "Bozeman"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "XES",
    "translations": [
      "Grand Geneva Resort Airport",
      "Grand Geneva Resort Airport",
      "Grand Geneva Resort Airport"
    ],
    "city": [
      "Lake Geneva",
      "Lake Geneva",
      "Lake Geneva"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PLY",
    "translations": [
      "Plymouth Municipal Airport",
      "Plymouth Municipal Airport",
      "Plymouth Municipal Airport"
    ],
    "city": [
      "Plymouth",
      "Plymouth",
      "Plymouth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CLG",
    "translations": [
      "New Coalinga Municipal Airport",
      "New Coalinga Municipal Airport",
      "New Coalinga Municipal Airport"
    ],
    "city": [
      "Coalinga",
      "Coalinga",
      "Coalinga"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CAD",
    "translations": [
      "Wexford County Airport",
      "Wexford County Airport",
      "Wexford County Airport"
    ],
    "city": [
      "Cadillac",
      "Cadillac",
      "Cadillac"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CAE",
    "translations": [
      "Columbia Metropolitan Airport",
      "Columbia Metropolitan Airport",
      "Columbia Metropolitan Airport"
    ],
    "city": [
      "Columbia",
      "Columbia",
      "Columbia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CIG",
    "translations": [
      "Craig Moffat Airport",
      "Craig Moffat Airport",
      "Craig Moffat Airport"
    ],
    "city": [
      "Craig",
      "Craig",
      "Craig"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CAK",
    "translations": [
      "Akron Canton Regional Airport",
      "Akron Canton Regional Airport",
      "Akron Canton Regional Airport"
    ],
    "city": [
      "Akron",
      "Akron",
      "Akron"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CAO",
    "translations": [
      "Clayton Municipal Airpark",
      "Clayton Municipal Airpark",
      "Clayton Municipal Airpark"
    ],
    "city": [
      "Clayton",
      "Clayton",
      "Clayton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CAR",
    "translations": [
      "Caribou Municipal Airport",
      "Caribou Municipal Airport",
      "Caribou Municipal Airport"
    ],
    "city": [
      "Caribou",
      "Caribou",
      "Caribou"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CBE",
    "translations": [
      "Greater Cumberland Regional Airport",
      "Greater Cumberland Regional Airport",
      "Greater Cumberland Regional Airport"
    ],
    "city": [
      "Wiley Ford",
      "Wiley Ford",
      "Wiley Ford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CBF",
    "translations": [
      "Council Bluffs Municipal Airport",
      "Council Bluffs Municipal Airport",
      "Council Bluffs Municipal Airport"
    ],
    "city": [
      "Council Bluffs",
      "Council Bluffs",
      "Council Bluffs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CBK",
    "translations": [
      "Shalz Field",
      "Shalz Field",
      "Shalz Field"
    ],
    "city": [
      "Colby",
      "Colby",
      "Colby"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CBM",
    "translations": [
      "Columbus Air Force Base",
      "Columbus Air Force Base",
      "Columbus Air Force Base"
    ],
    "city": [
      "Columbus",
      "Columbus",
      "Columbus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KCC",
    "translations": [
      "Coffman Cove Seaplane Base",
      "Coffman Cove Seaplane Base",
      "Coffman Cove Seaplane Base"
    ],
    "city": [
      "Coffman Cove",
      "Coffman Cove",
      "Coffman Cove"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CCB",
    "translations": [
      "Upland-Cable Airport",
      "Upland-Cable Airport",
      "Upland-Cable Airport"
    ],
    "city": [
      "Upland",
      "Upland",
      "Upland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CCR",
    "translations": [
      "Buchanan Field",
      "Buchanan Field",
      "Buchanan Field"
    ],
    "city": [
      "Concord",
      "Concord",
      "Concord"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CCY",
    "translations": [
      "Northeast Iowa Regional Airport",
      "Northeast Iowa Regional Airport",
      "Northeast Iowa Regional Airport"
    ],
    "city": [
      "Charles City",
      "Charles City",
      "Charles City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LLX",
    "translations": [
      "Caledonia County Airport",
      "Caledonia County Airport",
      "Caledonia County Airport"
    ],
    "city": [
      "Lyndonville",
      "Lyndonville",
      "Lyndonville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CDC",
    "translations": [
      "Cedar City Regional Airport",
      "Cedar City Regional Airport",
      "Cedar City Regional Airport"
    ],
    "city": [
      "Cedar City",
      "Cedar City",
      "Cedar City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CDH",
    "translations": [
      "Harrell Field",
      "Harrell Field",
      "Harrell Field"
    ],
    "city": [
      "Camden",
      "Camden",
      "Camden"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CDK",
    "translations": [
      "George T Lewis Airport",
      "George T Lewis Airport",
      "George T Lewis Airport"
    ],
    "city": [
      "Cedar Key",
      "Cedar Key",
      "Cedar Key"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CDN",
    "translations": [
      "Woodward Field",
      "Woodward Field",
      "Woodward Field"
    ],
    "city": [
      "Camden",
      "Camden",
      "Camden"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CDR",
    "translations": [
      "Chadron Municipal Airport",
      "Chadron Municipal Airport",
      "Chadron Municipal Airport"
    ],
    "city": [
      "Chadron",
      "Chadron",
      "Chadron"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CDS",
    "translations": [
      "Childress Municipal Airport",
      "Childress Municipal Airport",
      "Childress Municipal Airport"
    ],
    "city": [
      "Childress",
      "Childress",
      "Childress"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CDW",
    "translations": [
      "Essex County Airport",
      "Essex County Airport",
      "Essex County Airport"
    ],
    "city": [
      "Caldwell",
      "Caldwell",
      "Caldwell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CEA",
    "translations": [
      "Cessna Aircraft Field",
      "Cessna Aircraft Field",
      "Cessna Aircraft Field"
    ],
    "city": [
      "Wichita",
      "Wichita",
      "Wichita"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CEC",
    "translations": [
      "Jack Mc Namara Field Airport",
      "Jack Mc Namara Field Airport",
      "Jack Mc Namara Field Airport"
    ],
    "city": [
      "Crescent City",
      "Crescent City",
      "Crescent City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CEF",
    "translations": [
      "Westover Metropolitan Airport / Westover Air Reserve Base",
      "Westover Metropolitan Airport / Westover Air Reserve Base",
      "Westover Metropolitan Airport / Westover Air Reserve Base"
    ],
    "city": [
      "Chicopee",
      "Chicopee",
      "Chicopee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CEU",
    "translations": [
      "Oconee County Regional Airport",
      "Oconee County Regional Airport",
      "Oconee County Regional Airport"
    ],
    "city": [
      "Clemson",
      "Clemson",
      "Clemson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CEV",
    "translations": [
      "Mettel Field",
      "Mettel Field",
      "Mettel Field"
    ],
    "city": [
      "Connersville",
      "Connersville",
      "Connersville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CEW",
    "translations": [
      "Bob Sikes Airport",
      "Bob Sikes Airport",
      "Bob Sikes Airport"
    ],
    "city": [
      "Crestview",
      "Crestview",
      "Crestview"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CEY",
    "translations": [
      "Murray-Calloway County Airport Kyle-Oakley Field",
      "Murray-Calloway County Airport Kyle-Oakley Field",
      "Murray-Calloway County Airport Kyle-Oakley Field"
    ],
    "city": [
      "Murray",
      "Murray",
      "Murray"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CEZ",
    "translations": [
      "Cortez Municipal Airport",
      "Cortez Municipal Airport",
      "Cortez Municipal Airport"
    ],
    "city": [
      "Cortez",
      "Cortez",
      "Cortez"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CFD",
    "translations": [
      "Coulter Field",
      "Coulter Field",
      "Coulter Field"
    ],
    "city": [
      "Bryan",
      "Bryan",
      "Bryan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TZC",
    "translations": [
      "Tuscola Area Airport",
      "Tuscola Area Airport",
      "Tuscola Area Airport"
    ],
    "city": [
      "Caro",
      "Caro",
      "Caro"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CFT",
    "translations": [
      "Greenlee County Airport",
      "Greenlee County Airport",
      "Greenlee County Airport"
    ],
    "city": [
      "Clifton",
      "Clifton",
      "Clifton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CFV",
    "translations": [
      "Coffeyville Municipal Airport",
      "Coffeyville Municipal Airport",
      "Coffeyville Municipal Airport"
    ],
    "city": [
      "Coffeyville",
      "Coffeyville",
      "Coffeyville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CGE",
    "translations": [
      "Cambridge Dorchester Airport",
      "Cambridge Dorchester Airport",
      "Cambridge Dorchester Airport"
    ],
    "city": [
      "Cambridge",
      "Cambridge",
      "Cambridge"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CGF",
    "translations": [
      "Cuyahoga County Airport",
      "Cuyahoga County Airport",
      "Cuyahoga County Airport"
    ],
    "city": [
      "Cleveland",
      "Cleveland",
      "Cleveland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CGI",
    "translations": [
      "Cape Girardeau Regional Airport",
      "Cape Girardeau Regional Airport",
      "Cape Girardeau Regional Airport"
    ],
    "city": [
      "Cape Girardeau",
      "Cape Girardeau",
      "Cape Girardeau"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CGS",
    "translations": [
      "College Park Airport",
      "College Park Airport",
      "College Park Airport"
    ],
    "city": [
      "College Park",
      "College Park",
      "College Park"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CGZ",
    "translations": [
      "Casa Grande Municipal Airport",
      "Casa Grande Municipal Airport",
      "Casa Grande Municipal Airport"
    ],
    "city": [
      "Casa Grande",
      "Casa Grande",
      "Casa Grande"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CHA",
    "translations": [
      "Chattanooga Metropolitan Airport (Lovell Field)",
      "Chattanooga Metropolitan Airport (Lovell Field)",
      "Chattanooga Metropolitan Airport (Lovell Field)"
    ],
    "city": [
      "Chattanooga",
      "Chattanooga",
      "Chattanooga"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CHK",
    "translations": [
      "Chickasha Municipal Airport",
      "Chickasha Municipal Airport",
      "Chickasha Municipal Airport"
    ],
    "city": [
      "Chickasha",
      "Chickasha",
      "Chickasha"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CHO",
    "translations": [
      "Charlottesville Albemarle Airport",
      "Charlottesville Albemarle Airport",
      "Charlottesville Albemarle Airport"
    ],
    "city": [
      "Charlottesville",
      "Charlottesville",
      "Charlottesville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CHS",
    "translations": [
      "Charleston International Airport",
      "Charleston International Airport",
      "Charleston International Airport"
    ],
    "city": [
      "Charleston",
      "Charleston",
      "Charleston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CIC",
    "translations": [
      "Chico Regional Airport",
      "Chico Regional Airport",
      "Chico Regional Airport"
    ],
    "city": [
      "Chico",
      "Chico",
      "Chico"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CID",
    "translations": [
      "The Eastern Iowa Airport",
      "The Eastern Iowa Airport",
      "The Eastern Iowa Airport"
    ],
    "city": [
      "Cedar Rapids",
      "Cedar Rapids",
      "Cedar Rapids"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CIN",
    "translations": [
      "Arthur N Neu Airport",
      "Arthur N Neu Airport",
      "Arthur N Neu Airport"
    ],
    "city": [
      "Carroll",
      "Carroll",
      "Carroll"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CIR",
    "translations": [
      "Cairo Regional Airport",
      "Cairo Regional Airport",
      "Cairo Regional Airport"
    ],
    "city": [
      "Cairo",
      "Cairo",
      "Cairo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CIU",
    "translations": [
      "Chippewa County International Airport",
      "Chippewa County International Airport",
      "Chippewa County International Airport"
    ],
    "city": [
      "Kincheloe",
      "Kincheloe",
      "Kincheloe"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CKA",
    "translations": [
      "Kegelman AF Aux Field",
      "Kegelman AF Aux Field",
      "Kegelman AF Aux Field"
    ],
    "city": [
      "Cherokee",
      "Cherokee",
      "Cherokee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CKB",
    "translations": [
      "North Central West Virginia Airport",
      "North Central West Virginia Airport",
      "North Central West Virginia Airport"
    ],
    "city": [
      "Bridgeport",
      "Bridgeport",
      "Bridgeport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GRM",
    "translations": [
      "Grand Marais Cook County Airport",
      "Grand Marais Cook County Airport",
      "Grand Marais Cook County Airport"
    ],
    "city": [
      "Grand Marais",
      "Grand Marais",
      "Grand Marais"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CKM",
    "translations": [
      "Fletcher Field",
      "Fletcher Field",
      "Fletcher Field"
    ],
    "city": [
      "Clarksdale",
      "Clarksdale",
      "Clarksdale"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CKN",
    "translations": [
      "Crookston Municipal Kirkwood Field",
      "Crookston Municipal Kirkwood Field",
      "Crookston Municipal Kirkwood Field"
    ],
    "city": [
      "Crookston",
      "Crookston",
      "Crookston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CKV",
    "translations": [
      "Clarksville–Montgomery County Regional Airport",
      "Clarksville–Montgomery County Regional Airport",
      "Clarksville–Montgomery County Regional Airport"
    ],
    "city": [
      "Clarksville",
      "Clarksville",
      "Clarksville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KCL",
    "translations": [
      "Chignik Lagoon Airport",
      "Chignik Lagoon Airport",
      "Chignik Lagoon Airport"
    ],
    "city": [
      "Chignik Flats",
      "Chignik Flats",
      "Chignik Flats"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CLE",
    "translations": [
      "Cleveland Hopkins International Airport",
      "Cleveland Hopkins International Airport",
      "Cleveland Hopkins International Airport"
    ],
    "city": [
      "Cleveland",
      "Cleveland",
      "Cleveland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CLI",
    "translations": [
      "Clintonville Municipal Airport",
      "Clintonville Municipal Airport",
      "Clintonville Municipal Airport"
    ],
    "city": [
      "Clintonville",
      "Clintonville",
      "Clintonville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CLK",
    "translations": [
      "Clinton Regional Airport",
      "Clinton Regional Airport",
      "Clinton Regional Airport"
    ],
    "city": [
      "Clinton",
      "Clinton",
      "Clinton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CLL",
    "translations": [
      "Easterwood Field",
      "Easterwood Field",
      "Easterwood Field"
    ],
    "city": [
      "College Station",
      "College Station",
      "College Station"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CLM",
    "translations": [
      "William R Fairchild International Airport",
      "William R Fairchild International Airport",
      "William R Fairchild International Airport"
    ],
    "city": [
      "Port Angeles",
      "Port Angeles",
      "Port Angeles"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CLR",
    "translations": [
      "Cliff Hatfield Memorial Airport",
      "Cliff Hatfield Memorial Airport",
      "Cliff Hatfield Memorial Airport"
    ],
    "city": [
      "Calipatria",
      "Calipatria",
      "Calipatria"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CLS",
    "translations": [
      "Chehalis Centralia Airport",
      "Chehalis Centralia Airport",
      "Chehalis Centralia Airport"
    ],
    "city": [
      "Chehalis",
      "Chehalis",
      "Chehalis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CLT",
    "translations": [
      "Charlotte Douglas International Airport",
      "Charlotte Douglas International Airport",
      "Charlotte Douglas International Airport"
    ],
    "city": [
      "Charlotte",
      "Charlotte",
      "Charlotte"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CLW",
    "translations": [
      "Clearwater Air Park",
      "Clearwater Air Park",
      "Clearwater Air Park"
    ],
    "city": [
      "Clearwater",
      "Clearwater",
      "Clearwater"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CMH",
    "translations": [
      "John Glenn Columbus International Airport",
      "John Glenn Columbus International Airport",
      "John Glenn Columbus International Airport"
    ],
    "city": [
      "Columbus",
      "Columbus",
      "Columbus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CMI",
    "translations": [
      "University of Illinois Willard Airport",
      "University of Illinois Willard Airport",
      "University of Illinois Willard Airport"
    ],
    "city": [
      "Savoy",
      "Savoy",
      "Savoy"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CMX",
    "translations": [
      "Houghton County Memorial Airport",
      "Houghton County Memorial Airport",
      "Houghton County Memorial Airport"
    ],
    "city": [
      "Hancock",
      "Hancock",
      "Hancock"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CMY",
    "translations": [
      "Sparta Fort McCoy Airport",
      "Sparta Fort McCoy Airport",
      "Sparta Fort McCoy Airport"
    ],
    "city": [
      "Sparta",
      "Sparta",
      "Sparta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KCN",
    "translations": [
      "Chernofski Harbor Seaplane Base",
      "Chernofski Harbor Seaplane Base",
      "Chernofski Harbor Seaplane Base"
    ],
    "city": [
      "Chernofski Harbor",
      "Chernofski Harbor",
      "Chernofski Harbor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CNH",
    "translations": [
      "Claremont Municipal Airport",
      "Claremont Municipal Airport",
      "Claremont Municipal Airport"
    ],
    "city": [
      "Claremont",
      "Claremont",
      "Claremont"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CNK",
    "translations": [
      "Blosser Municipal Airport",
      "Blosser Municipal Airport",
      "Blosser Municipal Airport"
    ],
    "city": [
      "Concordia",
      "Concordia",
      "Concordia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CNM",
    "translations": [
      "Cavern City Air Terminal",
      "Cavern City Air Terminal",
      "Cavern City Air Terminal"
    ],
    "city": [
      "Carlsbad",
      "Carlsbad",
      "Carlsbad"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CNO",
    "translations": [
      "Chino Airport",
      "Chino Airport",
      "Chino Airport"
    ],
    "city": [
      "Chino",
      "Chino",
      "Chino"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CNU",
    "translations": [
      "Chanute Martin Johnson Airport",
      "Chanute Martin Johnson Airport",
      "Chanute Martin Johnson Airport"
    ],
    "city": [
      "Chanute",
      "Chanute",
      "Chanute"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CNW",
    "translations": [
      "TSTC Waco Airport",
      "TSTC Waco Airport",
      "TSTC Waco Airport"
    ],
    "city": [
      "Waco",
      "Waco",
      "Waco"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CNY",
    "translations": [
      "Canyonlands Regional Airport",
      "Canyonlands Regional Airport",
      "Canyonlands Regional Airport"
    ],
    "city": [
      "Moab",
      "Moab",
      "Moab"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "COD",
    "translations": [
      "Yellowstone Regional Airport",
      "Yellowstone Regional Airport",
      "Yellowstone Regional Airport"
    ],
    "city": [
      "Cody",
      "Cody",
      "Cody"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "COE",
    "translations": [
      "Coeur D'Alene Airport - Pappy Boyington Field",
      "Coeur D'Alene Airport - Pappy Boyington Field",
      "Coeur D'Alene Airport - Pappy Boyington Field"
    ],
    "city": [
      "Coeur d'Alene",
      "Coeur d'Alene",
      "Coeur d'Alene"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "COF",
    "translations": [
      "Patrick Space Force Base",
      "Patrick Space Force Base",
      "Patrick Space Force Base"
    ],
    "city": [
      "Cocoa Beach",
      "Cocoa Beach",
      "Cocoa Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "COI",
    "translations": [
      "Merritt Island Airport",
      "Merritt Island Airport",
      "Merritt Island Airport"
    ],
    "city": [
      "Merritt Island",
      "Merritt Island",
      "Merritt Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "COM",
    "translations": [
      "Coleman Municipal Airport",
      "Coleman Municipal Airport",
      "Coleman Municipal Airport"
    ],
    "city": [
      "Coleman",
      "Coleman",
      "Coleman"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CON",
    "translations": [
      "Concord Municipal Airport",
      "Concord Municipal Airport",
      "Concord Municipal Airport"
    ],
    "city": [
      "Concord",
      "Concord",
      "Concord"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "COS",
    "translations": [
      "City of Colorado Springs Municipal Airport",
      "City of Colorado Springs Municipal Airport",
      "City of Colorado Springs Municipal Airport"
    ],
    "city": [
      "Colorado Springs",
      "Colorado Springs",
      "Colorado Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "COT",
    "translations": [
      "Cotulla-La Salle County Airport",
      "Cotulla-La Salle County Airport",
      "Cotulla-La Salle County Airport"
    ],
    "city": [
      "Cotulla",
      "Cotulla",
      "Cotulla"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "COU",
    "translations": [
      "Columbia Regional Airport",
      "Columbia Regional Airport",
      "Columbia Regional Airport"
    ],
    "city": [
      "Columbia",
      "Columbia",
      "Columbia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CPM",
    "translations": [
      "Compton Woodley Airport",
      "Compton Woodley Airport",
      "Compton Woodley Airport"
    ],
    "city": [
      "Compton",
      "Compton",
      "Compton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CPR",
    "translations": [
      "Casper-Natrona County International Airport",
      "Casper-Natrona County International Airport",
      "Casper-Natrona County International Airport"
    ],
    "city": [
      "Casper",
      "Casper",
      "Casper"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CPS",
    "translations": [
      "St Louis Downtown Airport",
      "St Louis Downtown Airport",
      "St Louis Downtown Airport"
    ],
    "city": [
      "Cahokia/St Louis",
      "Cahokia/St Louis",
      "Cahokia/St Louis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HCW",
    "translations": [
      "Cheraw Municipal Airport/Lynch Bellinger Field",
      "Cheraw Municipal Airport/Lynch Bellinger Field",
      "Cheraw Municipal Airport/Lynch Bellinger Field"
    ],
    "city": [
      "Cheraw",
      "Cheraw",
      "Cheraw"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KCR",
    "translations": [
      "Colorado Creek Airport",
      "Colorado Creek Airport",
      "Colorado Creek Airport"
    ],
    "city": [
      "Colorado Creek",
      "Colorado Creek",
      "Colorado Creek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CRE",
    "translations": [
      "Grand Strand Airport",
      "Grand Strand Airport",
      "Grand Strand Airport"
    ],
    "city": [
      "North Myrtle Beach",
      "North Myrtle Beach",
      "North Myrtle Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CRG",
    "translations": [
      "Jacksonville Executive at Craig Airport",
      "Jacksonville Executive at Craig Airport",
      "Jacksonville Executive at Craig Airport"
    ],
    "city": [
      "Jacksonville",
      "Jacksonville",
      "Jacksonville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CRP",
    "translations": [
      "Corpus Christi International Airport",
      "Corpus Christi International Airport",
      "Corpus Christi International Airport"
    ],
    "city": [
      "Corpus Christi",
      "Corpus Christi",
      "Corpus Christi"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CLD",
    "translations": [
      "McClellan-Palomar Airport",
      "McClellan-Palomar Airport",
      "McClellan-Palomar Airport"
    ],
    "city": [
      "Carlsbad",
      "Carlsbad",
      "Carlsbad"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CRS",
    "translations": [
      "C David Campbell Field Corsicana Municipal Airport",
      "C David Campbell Field Corsicana Municipal Airport",
      "C David Campbell Field Corsicana Municipal Airport"
    ],
    "city": [
      "Corsicana",
      "Corsicana",
      "Corsicana"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CRT",
    "translations": [
      "Z M Jack Stell Field",
      "Z M Jack Stell Field",
      "Z M Jack Stell Field"
    ],
    "city": [
      "Crossett",
      "Crossett",
      "Crossett"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CRW",
    "translations": [
      "Yeager Airport",
      "Yeager Airport",
      "Yeager Airport"
    ],
    "city": [
      "Charleston",
      "Charleston",
      "Charleston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CRX",
    "translations": [
      "Roscoe Turner Airport",
      "Roscoe Turner Airport",
      "Roscoe Turner Airport"
    ],
    "city": [
      "Corinth",
      "Corinth",
      "Corinth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CSG",
    "translations": [
      "Columbus Metropolitan Airport",
      "Columbus Metropolitan Airport",
      "Columbus Metropolitan Airport"
    ],
    "city": [
      "Columbus",
      "Columbus",
      "Columbus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CSM",
    "translations": [
      "Clinton Sherman Airport",
      "Clinton Sherman Airport",
      "Clinton Sherman Airport"
    ],
    "city": [
      "Clinton",
      "Clinton",
      "Clinton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CSQ",
    "translations": [
      "Creston Municipal Airport",
      "Creston Municipal Airport",
      "Creston Municipal Airport"
    ],
    "city": [
      "Creston",
      "Creston",
      "Creston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CSV",
    "translations": [
      "Crossville Memorial Airport Whitson Field",
      "Crossville Memorial Airport Whitson Field",
      "Crossville Memorial Airport Whitson Field"
    ],
    "city": [
      "Crossville",
      "Crossville",
      "Crossville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CTB",
    "translations": [
      "Cut Bank International Airport",
      "Cut Bank International Airport",
      "Cut Bank International Airport"
    ],
    "city": [
      "Cut Bank",
      "Cut Bank",
      "Cut Bank"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CTY",
    "translations": [
      "Cross City Airport",
      "Cross City Airport",
      "Cross City Airport"
    ],
    "city": [
      "Cross City",
      "Cross City",
      "Cross City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CTZ",
    "translations": [
      "Sampson County Airport",
      "Sampson County Airport",
      "Sampson County Airport"
    ],
    "city": [
      "Clinton",
      "Clinton",
      "Clinton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CUB",
    "translations": [
      "Jim Hamilton L.B. Owens Airport",
      "Jim Hamilton L.B. Owens Airport",
      "Jim Hamilton L.B. Owens Airport"
    ],
    "city": [
      "Columbia",
      "Columbia",
      "Columbia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CUH",
    "translations": [
      "Cushing Municipal Airport",
      "Cushing Municipal Airport",
      "Cushing Municipal Airport"
    ],
    "city": [
      "Cushing",
      "Cushing",
      "Cushing"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CVG",
    "translations": [
      "Cincinnati Northern Kentucky International Airport",
      "Cincinnati Northern Kentucky International Airport",
      "Cincinnati Northern Kentucky International Airport"
    ],
    "city": [
      "Cincinnati / Covington",
      "Cincinnati / Covington",
      "Cincinnati / Covington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HLI",
    "translations": [
      "Hollister Municipal Airport",
      "Hollister Municipal Airport",
      "Hollister Municipal Airport"
    ],
    "city": [
      "Hollister",
      "Hollister",
      "Hollister"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CKK",
    "translations": [
      "Sharp County Regional Airport",
      "Sharp County Regional Airport",
      "Sharp County Regional Airport"
    ],
    "city": [
      "Ash Flat",
      "Ash Flat",
      "Ash Flat"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CVN",
    "translations": [
      "Clovis Municipal Airport",
      "Clovis Municipal Airport",
      "Clovis Municipal Airport"
    ],
    "city": [
      "Clovis",
      "Clovis",
      "Clovis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CVO",
    "translations": [
      "Corvallis Municipal Airport",
      "Corvallis Municipal Airport",
      "Corvallis Municipal Airport"
    ],
    "city": [
      "Corvallis",
      "Corvallis",
      "Corvallis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CVS",
    "translations": [
      "Cannon Air Force Base",
      "Cannon Air Force Base",
      "Cannon Air Force Base"
    ],
    "city": [
      "Clovis",
      "Clovis",
      "Clovis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CWA",
    "translations": [
      "Central Wisconsin Airport",
      "Central Wisconsin Airport",
      "Central Wisconsin Airport"
    ],
    "city": [
      "Mosinee",
      "Mosinee",
      "Mosinee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KIP",
    "translations": [
      "Kickapoo Downtown Airport",
      "Kickapoo Downtown Airport",
      "Kickapoo Downtown Airport"
    ],
    "city": [
      "Wichita Falls",
      "Wichita Falls",
      "Wichita Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CWF",
    "translations": [
      "Chennault International Airport",
      "Chennault International Airport",
      "Chennault International Airport"
    ],
    "city": [
      "Lake Charles",
      "Lake Charles",
      "Lake Charles"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CWI",
    "translations": [
      "Clinton Municipal Airport",
      "Clinton Municipal Airport",
      "Clinton Municipal Airport"
    ],
    "city": [
      "Clinton",
      "Clinton",
      "Clinton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CXL",
    "translations": [
      "Calexico International Airport",
      "Calexico International Airport",
      "Calexico International Airport"
    ],
    "city": [
      "Calexico",
      "Calexico",
      "Calexico"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CXO",
    "translations": [
      "Conroe-North Houston Regional Airport",
      "Conroe-North Houston Regional Airport",
      "Conroe-North Houston Regional Airport"
    ],
    "city": [
      "Houston",
      "Houston",
      "Houston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CSN",
    "translations": [
      "Carson Airport",
      "Carson Airport",
      "Carson Airport"
    ],
    "city": [
      "Carson City",
      "Carson City",
      "Carson City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HAR",
    "translations": [
      "Capital City Airport",
      "Capital City Airport",
      "Capital City Airport"
    ],
    "city": [
      "Harrisburg",
      "Harrisburg",
      "Harrisburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CYS",
    "translations": [
      "Cheyenne Regional Jerry Olson Field",
      "Cheyenne Regional Jerry Olson Field",
      "Cheyenne Regional Jerry Olson Field"
    ],
    "city": [
      "Cheyenne",
      "Cheyenne",
      "Cheyenne"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CZK",
    "translations": [
      "Cascade Locks State Airport",
      "Cascade Locks State Airport",
      "Cascade Locks State Airport"
    ],
    "city": [
      "Cascade Locks",
      "Cascade Locks",
      "Cascade Locks"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CZT",
    "translations": [
      "Dimmit County Airport",
      "Dimmit County Airport",
      "Dimmit County Airport"
    ],
    "city": [
      "Carrizo Springs",
      "Carrizo Springs",
      "Carrizo Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VEX",
    "translations": [
      "Tioga Municipal Airport",
      "Tioga Municipal Airport",
      "Tioga Municipal Airport"
    ],
    "city": [
      "Tioga",
      "Tioga",
      "Tioga"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DAA",
    "translations": [
      "Davison Army Air Field",
      "Davison Army Air Field",
      "Davison Army Air Field"
    ],
    "city": [
      "Fort Belvoir",
      "Fort Belvoir",
      "Fort Belvoir"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DAB",
    "translations": [
      "Daytona Beach International Airport",
      "Daytona Beach International Airport",
      "Daytona Beach International Airport"
    ],
    "city": [
      "Daytona Beach",
      "Daytona Beach",
      "Daytona Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DAG",
    "translations": [
      "Barstow Daggett Airport",
      "Barstow Daggett Airport",
      "Barstow Daggett Airport"
    ],
    "city": [
      "Daggett",
      "Daggett",
      "Daggett"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DAL",
    "translations": [
      "Dallas Love Field",
      "Dallas Love Field",
      "Dallas Love Field"
    ],
    "city": [
      "Dallas",
      "Dallas",
      "Dallas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DAN",
    "translations": [
      "Danville Regional Airport",
      "Danville Regional Airport",
      "Danville Regional Airport"
    ],
    "city": [
      "Danville",
      "Danville",
      "Danville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DAY",
    "translations": [
      "James M Cox Dayton International Airport",
      "James M Cox Dayton International Airport",
      "James M Cox Dayton International Airport"
    ],
    "city": [
      "Dayton",
      "Dayton",
      "Dayton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DBN",
    "translations": [
      "W H 'Bud' Barron Airport",
      "W H 'Bud' Barron Airport",
      "W H 'Bud' Barron Airport"
    ],
    "city": [
      "Dublin",
      "Dublin",
      "Dublin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DBQ",
    "translations": [
      "Dubuque Regional Airport",
      "Dubuque Regional Airport",
      "Dubuque Regional Airport"
    ],
    "city": [
      "Dubuque",
      "Dubuque",
      "Dubuque"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DCA",
    "translations": [
      "Ronald Reagan Washington National Airport",
      "Ronald Reagan Washington National Airport",
      "Ronald Reagan Washington National Airport"
    ],
    "city": [
      "Washington",
      "Washington",
      "Washington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DCU",
    "translations": [
      "Pryor Field Regional Airport",
      "Pryor Field Regional Airport",
      "Pryor Field Regional Airport"
    ],
    "city": [
      "Decatur",
      "Decatur",
      "Decatur"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DDC",
    "translations": [
      "Dodge City Regional Airport",
      "Dodge City Regional Airport",
      "Dodge City Regional Airport"
    ],
    "city": [
      "Dodge City",
      "Dodge City",
      "Dodge City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DEC",
    "translations": [
      "Decatur Airport",
      "Decatur Airport",
      "Decatur Airport"
    ],
    "city": [
      "Decatur",
      "Decatur",
      "Decatur"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DEH",
    "translations": [
      "Decorah Municipal Airport",
      "Decorah Municipal Airport",
      "Decorah Municipal Airport"
    ],
    "city": [
      "Decorah",
      "Decorah",
      "Decorah"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DEN",
    "translations": [
      "Denver International Airport",
      "Denver International Airport",
      "Denver International Airport"
    ],
    "city": [
      "Denver",
      "Denver",
      "Denver"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DET",
    "translations": [
      "Coleman A. Young Municipal Airport",
      "Coleman A. Young Municipal Airport",
      "Coleman A. Young Municipal Airport"
    ],
    "city": [
      "Detroit",
      "Detroit",
      "Detroit"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DFI",
    "translations": [
      "Defiance Memorial Airport",
      "Defiance Memorial Airport",
      "Defiance Memorial Airport"
    ],
    "city": [
      "Defiance",
      "Defiance",
      "Defiance"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DFW",
    "translations": [
      "Dallas Fort Worth International Airport",
      "Dallas Fort Worth International Airport",
      "Dallas Fort Worth International Airport"
    ],
    "city": [
      "Dallas-Fort Worth",
      "Dallas-Fort Worth",
      "Dallas-Fort Worth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DGL",
    "translations": [
      "Douglas Municipal Airport",
      "Douglas Municipal Airport",
      "Douglas Municipal Airport"
    ],
    "city": [
      "Douglas",
      "Douglas",
      "Douglas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DGW",
    "translations": [
      "Converse County Airport",
      "Converse County Airport",
      "Converse County Airport"
    ],
    "city": [
      "Douglas",
      "Douglas",
      "Douglas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DHN",
    "translations": [
      "Dothan Regional Airport",
      "Dothan Regional Airport",
      "Dothan Regional Airport"
    ],
    "city": [
      "Dothan",
      "Dothan",
      "Dothan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DHT",
    "translations": [
      "Dalhart Municipal Airport",
      "Dalhart Municipal Airport",
      "Dalhart Municipal Airport"
    ],
    "city": [
      "Dalhart",
      "Dalhart",
      "Dalhart"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DIK",
    "translations": [
      "Dickinson Theodore Roosevelt Regional Airport",
      "Dickinson Theodore Roosevelt Regional Airport",
      "Dickinson Theodore Roosevelt Regional Airport"
    ],
    "city": [
      "Dickinson",
      "Dickinson",
      "Dickinson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DKK",
    "translations": [
      "Chautauqua County-Dunkirk Airport",
      "Chautauqua County-Dunkirk Airport",
      "Chautauqua County-Dunkirk Airport"
    ],
    "city": [
      "Dunkirk",
      "Dunkirk",
      "Dunkirk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DLL",
    "translations": [
      "Dillon County Airport",
      "Dillon County Airport",
      "Dillon County Airport"
    ],
    "city": [
      "Dillon",
      "Dillon",
      "Dillon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DLF",
    "translations": [
      "Laughlin Air Force Base",
      "Laughlin Air Force Base",
      "Laughlin Air Force Base"
    ],
    "city": [
      "Del Rio",
      "Del Rio",
      "Del Rio"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DLH",
    "translations": [
      "Duluth International Airport",
      "Duluth International Airport",
      "Duluth International Airport"
    ],
    "city": [
      "Duluth",
      "Duluth",
      "Duluth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DLN",
    "translations": [
      "Dillon Airport",
      "Dillon Airport",
      "Dillon Airport"
    ],
    "city": [
      "Dillon",
      "Dillon",
      "Dillon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DLS",
    "translations": [
      "Columbia Gorge Regional Airport",
      "Columbia Gorge Regional Airport",
      "Columbia Gorge Regional Airport"
    ],
    "city": [
      "Dallesport / The Dalles",
      "Dallesport / The Dalles",
      "Dallesport / The Dalles"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DMA",
    "translations": [
      "Davis Monthan Air Force Base",
      "Davis Monthan Air Force Base",
      "Davis Monthan Air Force Base"
    ],
    "city": [
      "Tucson",
      "Tucson",
      "Tucson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DMN",
    "translations": [
      "Deming Municipal Airport",
      "Deming Municipal Airport",
      "Deming Municipal Airport"
    ],
    "city": [
      "Deming",
      "Deming",
      "Deming"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DMO",
    "translations": [
      "Sedalia Memorial Airport",
      "Sedalia Memorial Airport",
      "Sedalia Memorial Airport"
    ],
    "city": [
      "Sedalia",
      "Sedalia",
      "Sedalia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DNL",
    "translations": [
      "Daniel Field",
      "Daniel Field",
      "Daniel Field"
    ],
    "city": [
      "Augusta",
      "Augusta",
      "Augusta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DNN",
    "translations": [
      "Dalton Municipal Airport",
      "Dalton Municipal Airport",
      "Dalton Municipal Airport"
    ],
    "city": [
      "Dalton",
      "Dalton",
      "Dalton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DNS",
    "translations": [
      "Denison Municipal Airport",
      "Denison Municipal Airport",
      "Denison Municipal Airport"
    ],
    "city": [
      "Denison",
      "Denison",
      "Denison"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DNV",
    "translations": [
      "Vermilion Regional Airport",
      "Vermilion Regional Airport",
      "Vermilion Regional Airport"
    ],
    "city": [
      "Danville",
      "Danville",
      "Danville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DOV",
    "translations": [
      "Dover Air Force Base",
      "Dover Air Force Base",
      "Dover Air Force Base"
    ],
    "city": [
      "Dover",
      "Dover",
      "Dover"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DPA",
    "translations": [
      "Dupage Airport",
      "Dupage Airport",
      "Dupage Airport"
    ],
    "city": [
      "Chicago/West Chicago",
      "Chicago/West Chicago",
      "Chicago/West Chicago"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DPG",
    "translations": [
      "Michael AAF (Dugway Proving Ground) Airport",
      "Michael AAF (Dugway Proving Ground) Airport",
      "Michael AAF (Dugway Proving Ground) Airport"
    ],
    "city": [
      "Dugway Proving Ground",
      "Dugway Proving Ground",
      "Dugway Proving Ground"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DRA",
    "translations": [
      "Desert Rock Airport",
      "Desert Rock Airport",
      "Desert Rock Airport"
    ],
    "city": [
      "Mercury",
      "Mercury",
      "Mercury"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DRI",
    "translations": [
      "Beauregard Regional Airport",
      "Beauregard Regional Airport",
      "Beauregard Regional Airport"
    ],
    "city": [
      "DeRidder",
      "DeRidder",
      "DeRidder"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DRE",
    "translations": [
      "Drummond Island Airport",
      "Drummond Island Airport",
      "Drummond Island Airport"
    ],
    "city": [
      "Drummond Island",
      "Drummond Island",
      "Drummond Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DRO",
    "translations": [
      "Durango La Plata County Airport",
      "Durango La Plata County Airport",
      "Durango La Plata County Airport"
    ],
    "city": [
      "Durango",
      "Durango",
      "Durango"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DRT",
    "translations": [
      "Del Rio International Airport",
      "Del Rio International Airport",
      "Del Rio International Airport"
    ],
    "city": [
      "Del Rio",
      "Del Rio",
      "Del Rio"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KDS",
    "translations": [
      "Kamaran Downs Airport",
      "Kamaran Downs Airport",
      "Kamaran Downs Airport"
    ],
    "city": [
      "Kamaran Downs",
      "Kamaran Downs",
      "Kamaran Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DSM",
    "translations": [
      "Des Moines International Airport",
      "Des Moines International Airport",
      "Des Moines International Airport"
    ],
    "city": [
      "Des Moines",
      "Des Moines",
      "Des Moines"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DSV",
    "translations": [
      "Dansville Municipal Airport",
      "Dansville Municipal Airport",
      "Dansville Municipal Airport"
    ],
    "city": [
      "Dansville",
      "Dansville",
      "Dansville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DTA",
    "translations": [
      "Delta Municipal Airport",
      "Delta Municipal Airport",
      "Delta Municipal Airport"
    ],
    "city": [
      "Delta",
      "Delta",
      "Delta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DTL",
    "translations": [
      "Detroit Lakes Airport",
      "Detroit Lakes Airport",
      "Detroit Lakes Airport"
    ],
    "city": [
      "Detroit Lakes",
      "Detroit Lakes",
      "Detroit Lakes"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DTN",
    "translations": [
      "Shreveport Downtown Airport",
      "Shreveport Downtown Airport",
      "Shreveport Downtown Airport"
    ],
    "city": [
      "Shreveport",
      "Shreveport",
      "Shreveport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DSI",
    "translations": [
      "Destin Executive Airport",
      "Destin Executive Airport",
      "Destin Executive Airport"
    ],
    "city": [
      "Destin",
      "Destin",
      "Destin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DTW",
    "translations": [
      "Detroit Metropolitan Wayne County Airport",
      "Detroit Metropolitan Wayne County Airport",
      "Detroit Metropolitan Wayne County Airport"
    ],
    "city": [
      "Detroit",
      "Detroit",
      "Detroit"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DUA",
    "translations": [
      "Durant Regional Airport - Eaker Field",
      "Durant Regional Airport - Eaker Field",
      "Durant Regional Airport - Eaker Field"
    ],
    "city": [
      "Durant",
      "Durant",
      "Durant"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DUC",
    "translations": [
      "Halliburton Field",
      "Halliburton Field",
      "Halliburton Field"
    ],
    "city": [
      "Duncan",
      "Duncan",
      "Duncan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DUG",
    "translations": [
      "Bisbee Douglas International Airport",
      "Bisbee Douglas International Airport",
      "Bisbee Douglas International Airport"
    ],
    "city": [
      "Douglas Bisbee",
      "Douglas Bisbee",
      "Douglas Bisbee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DUJ",
    "translations": [
      "DuBois Regional Airport",
      "DuBois Regional Airport",
      "DuBois Regional Airport"
    ],
    "city": [
      "Dubois",
      "Dubois",
      "Dubois"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DVL",
    "translations": [
      "Devils Lake Regional Airport",
      "Devils Lake Regional Airport",
      "Devils Lake Regional Airport"
    ],
    "city": [
      "Devils Lake",
      "Devils Lake",
      "Devils Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DVN",
    "translations": [
      "Davenport Municipal Airport",
      "Davenport Municipal Airport",
      "Davenport Municipal Airport"
    ],
    "city": [
      "Davenport",
      "Davenport",
      "Davenport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NOT",
    "translations": [
      "Marin County Airport - Gnoss Field",
      "Marin County Airport - Gnoss Field",
      "Marin County Airport - Gnoss Field"
    ],
    "city": [
      "Novato",
      "Novato",
      "Novato"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NSL",
    "translations": [
      "Slayton Municipal Airport",
      "Slayton Municipal Airport",
      "Slayton Municipal Airport"
    ],
    "city": [
      "Slayton",
      "Slayton",
      "Slayton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DVT",
    "translations": [
      "Phoenix Deer Valley Airport",
      "Phoenix Deer Valley Airport",
      "Phoenix Deer Valley Airport"
    ],
    "city": [
      "Phoenix",
      "Phoenix",
      "Phoenix"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KDW",
    "translations": [
      "Victoria Reservoir Seaplane Base",
      "Victoria Reservoir Seaplane Base",
      "Victoria Reservoir Seaplane Base"
    ],
    "city": [
      "Kandy",
      "Kandy",
      "Kandy"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "DWH",
    "translations": [
      "David Wayne Hooks Memorial Airport",
      "David Wayne Hooks Memorial Airport",
      "David Wayne Hooks Memorial Airport"
    ],
    "city": [
      "Houston",
      "Houston",
      "Houston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DXR",
    "translations": [
      "Danbury Municipal Airport",
      "Danbury Municipal Airport",
      "Danbury Municipal Airport"
    ],
    "city": [
      "Danbury",
      "Danbury",
      "Danbury"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DYL",
    "translations": [
      "Doylestown Airport",
      "Doylestown Airport",
      "Doylestown Airport"
    ],
    "city": [
      "Doylestown",
      "Doylestown",
      "Doylestown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DYS",
    "translations": [
      "Dyess Air Force Base",
      "Dyess Air Force Base",
      "Dyess Air Force Base"
    ],
    "city": [
      "Abilene",
      "Abilene",
      "Abilene"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KDZ",
    "translations": [
      "Polgolla Reservoir Seaplane Base",
      "Polgolla Reservoir Seaplane Base",
      "Polgolla Reservoir Seaplane Base"
    ],
    "city": [
      "Kandy",
      "Kandy",
      "Kandy"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "LBN",
    "translations": [
      "Lake Baringo (Kampi Ya Samaki) Airport",
      "Lake Baringo (Kampi Ya Samaki) Airport",
      "Lake Baringo (Kampi Ya Samaki) Airport"
    ],
    "city": [
      "Lake Baringo",
      "Lake Baringo",
      "Lake Baringo"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "VPG",
    "translations": [
      "Vipingo Estate Airport",
      "Vipingo Estate Airport",
      "Vipingo Estate Airport"
    ],
    "city": [
      "Vipingo Estate",
      "Vipingo Estate",
      "Vipingo Estate"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "KTJ",
    "translations": [
      "Kichwa Tembo Airport",
      "Kichwa Tembo Airport",
      "Kichwa Tembo Airport"
    ],
    "city": [
      "Kichwa Tembo",
      "Kichwa Tembo",
      "Kichwa Tembo"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "OSJ",
    "translations": [
      "Ol Seki Airstrip",
      "Ol Seki Airstrip",
      "Ol Seki Airstrip"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "OLG",
    "translations": [
      "Olare Orok Airfield",
      "Olare Orok Airfield",
      "Olare Orok Airfield"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "HKR",
    "translations": [
      "Mara North Conservancy Airstrip",
      "Mara North Conservancy Airstrip",
      "Mara North Conservancy Airstrip"
    ],
    "city": [
      "Mara",
      "Mara",
      "Mara"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "ANA",
    "translations": [
      "Angama Airport",
      "Angama Airport",
      "Angama Airport"
    ],
    "city": [
      "Maasai Mara",
      "Maasai Mara",
      "Maasai Mara"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "MDR",
    "translations": [
      "Musiara Airstrip",
      "Musiara Airstrip",
      "Musiara Airstrip"
    ],
    "city": [
      "Musiara",
      "Musiara",
      "Musiara"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "OLX",
    "translations": [
      "Olkiombo Airport",
      "Olkiombo Airport",
      "Olkiombo Airport"
    ],
    "city": [
      "Olkiombo",
      "Olkiombo",
      "Olkiombo"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "KRV",
    "translations": [
      "Kerio Valley Airport",
      "Kerio Valley Airport",
      "Kerio Valley Airport"
    ],
    "city": [
      "Kimwarer",
      "Kimwarer",
      "Kimwarer"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "KIU",
    "translations": [
      "Kiunga Airport",
      "Kiunga Airport",
      "Kiunga Airport"
    ],
    "city": [
      "Kiunga",
      "Kiunga",
      "Kiunga"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "LBK",
    "translations": [
      "Liboi Airport",
      "Liboi Airport",
      "Liboi Airport"
    ],
    "city": [
      "Liboi",
      "Liboi",
      "Liboi"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "LKU",
    "translations": [
      "Lake Rudolf Airport",
      "Lake Rudolf Airport",
      "Lake Rudolf Airport"
    ],
    "city": [
      "Kalokol",
      "Kalokol",
      "Kalokol"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "MIF",
    "translations": [
      "Roy Hurd Memorial Airport",
      "Roy Hurd Memorial Airport",
      "Roy Hurd Memorial Airport"
    ],
    "city": [
      "Monahans",
      "Monahans",
      "Monahans"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CCG",
    "translations": [
      "Crane County Airport",
      "Crane County Airport",
      "Crane County Airport"
    ],
    "city": [
      "Crane",
      "Crane",
      "Crane"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ESO",
    "translations": [
      "Ohkay Owingeh Airport",
      "Ohkay Owingeh Airport",
      "Ohkay Owingeh Airport"
    ],
    "city": [
      "Espanola",
      "Espanola",
      "Espanola"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WTR",
    "translations": [
      "Whiteriver Airport",
      "Whiteriver Airport",
      "Whiteriver Airport"
    ],
    "city": [
      "Whiteriver",
      "Whiteriver",
      "Whiteriver"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ALE",
    "translations": [
      "Alpine Casparis Municipal Airport",
      "Alpine Casparis Municipal Airport",
      "Alpine Casparis Municipal Airport"
    ],
    "city": [
      "Alpine",
      "Alpine",
      "Alpine"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BGT",
    "translations": [
      "Bagdad Airport",
      "Bagdad Airport",
      "Bagdad Airport"
    ],
    "city": [
      "Bagdad",
      "Bagdad",
      "Bagdad"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EAN",
    "translations": [
      "Phifer Airfield",
      "Phifer Airfield",
      "Phifer Airfield"
    ],
    "city": [
      "Wheatland",
      "Wheatland",
      "Wheatland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EAR",
    "translations": [
      "Kearney Regional Airport",
      "Kearney Regional Airport",
      "Kearney Regional Airport"
    ],
    "city": [
      "Kearney",
      "Kearney",
      "Kearney"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EAT",
    "translations": [
      "Pangborn Memorial Airport",
      "Pangborn Memorial Airport",
      "Pangborn Memorial Airport"
    ],
    "city": [
      "Wenatchee",
      "Wenatchee",
      "Wenatchee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EAU",
    "translations": [
      "Chippewa Valley Regional Airport",
      "Chippewa Valley Regional Airport",
      "Chippewa Valley Regional Airport"
    ],
    "city": [
      "Eau Claire",
      "Eau Claire",
      "Eau Claire"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KEB",
    "translations": [
      "Nanwalek Airport",
      "Nanwalek Airport",
      "Nanwalek Airport"
    ],
    "city": [
      "Nanwalek",
      "Nanwalek",
      "Nanwalek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EBS",
    "translations": [
      "Webster City Municipal Airport",
      "Webster City Municipal Airport",
      "Webster City Municipal Airport"
    ],
    "city": [
      "Webster City",
      "Webster City",
      "Webster City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ECG",
    "translations": [
      "Elizabeth City Regional Airport & Coast Guard Air Station",
      "Elizabeth City Regional Airport & Coast Guard Air Station",
      "Elizabeth City Regional Airport & Coast Guard Air Station"
    ],
    "city": [
      "Elizabeth City",
      "Elizabeth City",
      "Elizabeth City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ECP",
    "translations": [
      "Northwest Florida Beaches International Airport",
      "Northwest Florida Beaches International Airport",
      "Northwest Florida Beaches International Airport"
    ],
    "city": [
      "Panama City Beach",
      "Panama City Beach",
      "Panama City Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ECS",
    "translations": [
      "Mondell Field",
      "Mondell Field",
      "Mondell Field"
    ],
    "city": [
      "Newcastle",
      "Newcastle",
      "Newcastle"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EDE",
    "translations": [
      "Northeastern Regional Airport",
      "Northeastern Regional Airport",
      "Northeastern Regional Airport"
    ],
    "city": [
      "Edenton",
      "Edenton",
      "Edenton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ETS",
    "translations": [
      "Enterprise Municipal Airport",
      "Enterprise Municipal Airport",
      "Enterprise Municipal Airport"
    ],
    "city": [
      "Enterprise",
      "Enterprise",
      "Enterprise"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EDW",
    "translations": [
      "Edwards Air Force Base",
      "Edwards Air Force Base",
      "Edwards Air Force Base"
    ],
    "city": [
      "Edwards",
      "Edwards",
      "Edwards"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EED",
    "translations": [
      "Needles Airport",
      "Needles Airport",
      "Needles Airport"
    ],
    "city": [
      "Needles",
      "Needles",
      "Needles"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EEN",
    "translations": [
      "Dillant Hopkins Airport",
      "Dillant Hopkins Airport",
      "Dillant Hopkins Airport"
    ],
    "city": [
      "Keene",
      "Keene",
      "Keene"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EFD",
    "translations": [
      "Ellington Airport",
      "Ellington Airport",
      "Ellington Airport"
    ],
    "city": [
      "Houston",
      "Houston",
      "Houston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EFK",
    "translations": [
      "Northeast Kingdom International Airport",
      "Northeast Kingdom International Airport",
      "Northeast Kingdom International Airport"
    ],
    "city": [
      "Newport",
      "Newport",
      "Newport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EFW",
    "translations": [
      "Jefferson Municipal Airport",
      "Jefferson Municipal Airport",
      "Jefferson Municipal Airport"
    ],
    "city": [
      "Jefferson",
      "Jefferson",
      "Jefferson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EGE",
    "translations": [
      "Eagle County Regional Airport",
      "Eagle County Regional Airport",
      "Eagle County Regional Airport"
    ],
    "city": [
      "Eagle",
      "Eagle",
      "Eagle"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EGI",
    "translations": [
      "Duke Field",
      "Duke Field",
      "Duke Field"
    ],
    "city": [
      "Crestview",
      "Crestview",
      "Crestview"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EGV",
    "translations": [
      "Eagle River Union Airport",
      "Eagle River Union Airport",
      "Eagle River Union Airport"
    ],
    "city": [
      "Eagle River",
      "Eagle River",
      "Eagle River"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KEK",
    "translations": [
      "Ekwok Airport",
      "Ekwok Airport",
      "Ekwok Airport"
    ],
    "city": [
      "Ekwok",
      "Ekwok",
      "Ekwok"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EKA",
    "translations": [
      "Murray Field",
      "Murray Field",
      "Murray Field"
    ],
    "city": [
      "Eureka",
      "Eureka",
      "Eureka"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EKI",
    "translations": [
      "Elkhart Municipal Airport",
      "Elkhart Municipal Airport",
      "Elkhart Municipal Airport"
    ],
    "city": [
      "Elkhart",
      "Elkhart",
      "Elkhart"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EKN",
    "translations": [
      "Elkins-Randolph County Regional Airport",
      "Elkins-Randolph County Regional Airport",
      "Elkins-Randolph County Regional Airport"
    ],
    "city": [
      "Elkins",
      "Elkins",
      "Elkins"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EKO",
    "translations": [
      "Elko Regional Airport",
      "Elko Regional Airport",
      "Elko Regional Airport"
    ],
    "city": [
      "Elko",
      "Elko",
      "Elko"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EKX",
    "translations": [
      "Addington Field / Elizabethtown Regional Airport",
      "Addington Field / Elizabethtown Regional Airport",
      "Addington Field / Elizabethtown Regional Airport"
    ],
    "city": [
      "Elizabethtown",
      "Elizabethtown",
      "Elizabethtown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ELA",
    "translations": [
      "Eagle Lake Airport",
      "Eagle Lake Airport",
      "Eagle Lake Airport"
    ],
    "city": [
      "Eagle Lake",
      "Eagle Lake",
      "Eagle Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ELD",
    "translations": [
      "South Arkansas Regional Airport at Goodwin Field",
      "South Arkansas Regional Airport at Goodwin Field",
      "South Arkansas Regional Airport at Goodwin Field"
    ],
    "city": [
      "El Dorado",
      "El Dorado",
      "El Dorado"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ELK",
    "translations": [
      "Elk City Regional Business Airport",
      "Elk City Regional Business Airport",
      "Elk City Regional Business Airport"
    ],
    "city": [
      "Elk City",
      "Elk City",
      "Elk City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ELM",
    "translations": [
      "Elmira Corning Regional Airport",
      "Elmira Corning Regional Airport",
      "Elmira Corning Regional Airport"
    ],
    "city": [
      "Elmira/Corning",
      "Elmira/Corning",
      "Elmira/Corning"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ELN",
    "translations": [
      "Bowers Field",
      "Bowers Field",
      "Bowers Field"
    ],
    "city": [
      "Ellensburg",
      "Ellensburg",
      "Ellensburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LYU",
    "translations": [
      "Ely Municipal Airport",
      "Ely Municipal Airport",
      "Ely Municipal Airport"
    ],
    "city": [
      "Ely",
      "Ely",
      "Ely"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ELP",
    "translations": [
      "El Paso International Airport",
      "El Paso International Airport",
      "El Paso International Airport"
    ],
    "city": [
      "El Paso",
      "El Paso",
      "El Paso"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ELY",
    "translations": [
      "Ely Airport Yelland Field",
      "Ely Airport Yelland Field",
      "Ely Airport Yelland Field"
    ],
    "city": [
      "Ely",
      "Ely",
      "Ely"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ELZ",
    "translations": [
      "Wellsville Municipal Airport - Tarantine Field",
      "Wellsville Municipal Airport - Tarantine Field",
      "Wellsville Municipal Airport - Tarantine Field"
    ],
    "city": [
      "Wellsville",
      "Wellsville",
      "Wellsville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EMM",
    "translations": [
      "Kemmerer Municipal Airport",
      "Kemmerer Municipal Airport",
      "Kemmerer Municipal Airport"
    ],
    "city": [
      "Kemmerer",
      "Kemmerer",
      "Kemmerer"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EMP",
    "translations": [
      "Emporia Municipal Airport",
      "Emporia Municipal Airport",
      "Emporia Municipal Airport"
    ],
    "city": [
      "Emporia",
      "Emporia",
      "Emporia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EMT",
    "translations": [
      "San Gabriel Valley Airport",
      "San Gabriel Valley Airport",
      "San Gabriel Valley Airport"
    ],
    "city": [
      "El Monte",
      "El Monte",
      "El Monte"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "END",
    "translations": [
      "Vance Air Force Base",
      "Vance Air Force Base",
      "Vance Air Force Base"
    ],
    "city": [
      "Enid",
      "Enid",
      "Enid"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ENL",
    "translations": [
      "Centralia Municipal Airport",
      "Centralia Municipal Airport",
      "Centralia Municipal Airport"
    ],
    "city": [
      "Centralia",
      "Centralia",
      "Centralia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ENV",
    "translations": [
      "Wendover Airport",
      "Wendover Airport",
      "Wendover Airport"
    ],
    "city": [
      "Wendover",
      "Wendover",
      "Wendover"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ENW",
    "translations": [
      "Kenosha Regional Airport",
      "Kenosha Regional Airport",
      "Kenosha Regional Airport"
    ],
    "city": [
      "Kenosha",
      "Kenosha",
      "Kenosha"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EOK",
    "translations": [
      "Keokuk Municipal Airport",
      "Keokuk Municipal Airport",
      "Keokuk Municipal Airport"
    ],
    "city": [
      "Keokuk",
      "Keokuk",
      "Keokuk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EOS",
    "translations": [
      "Neosho Hugh Robinson Airport",
      "Neosho Hugh Robinson Airport",
      "Neosho Hugh Robinson Airport"
    ],
    "city": [
      "Neosho",
      "Neosho",
      "Neosho"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EPH",
    "translations": [
      "Ephrata Municipal Airport",
      "Ephrata Municipal Airport",
      "Ephrata Municipal Airport"
    ],
    "city": [
      "Ephrata",
      "Ephrata",
      "Ephrata"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EDK",
    "translations": [
      "Captain Jack Thomas El Dorado Airport",
      "Captain Jack Thomas El Dorado Airport",
      "Captain Jack Thomas El Dorado Airport"
    ],
    "city": [
      "El Dorado",
      "El Dorado",
      "El Dorado"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ERI",
    "translations": [
      "Erie International Tom Ridge Field",
      "Erie International Tom Ridge Field",
      "Erie International Tom Ridge Field"
    ],
    "city": [
      "Erie",
      "Erie",
      "Erie"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ERR",
    "translations": [
      "Errol Airport",
      "Errol Airport",
      "Errol Airport"
    ],
    "city": [
      "Errol",
      "Errol",
      "Errol"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ERV",
    "translations": [
      "Kerrville / Kerr County Airport at Louis Schreiner Field",
      "Kerrville / Kerr County Airport at Louis Schreiner Field",
      "Kerrville / Kerr County Airport at Louis Schreiner Field"
    ],
    "city": [
      "Kerrville",
      "Kerrville",
      "Kerrville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ESC",
    "translations": [
      "Delta County Airport",
      "Delta County Airport",
      "Delta County Airport"
    ],
    "city": [
      "Escanaba",
      "Escanaba",
      "Escanaba"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ESF",
    "translations": [
      "Esler Army Airfield / Esler Regional Airport",
      "Esler Army Airfield / Esler Regional Airport",
      "Esler Army Airfield / Esler Regional Airport"
    ],
    "city": [
      "Alexandria",
      "Alexandria",
      "Alexandria"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ESN",
    "translations": [
      "Easton Airport / Newnam Field",
      "Easton Airport / Newnam Field",
      "Easton Airport / Newnam Field"
    ],
    "city": [
      "Easton",
      "Easton",
      "Easton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EST",
    "translations": [
      "Estherville Municipal Airport",
      "Estherville Municipal Airport",
      "Estherville Municipal Airport"
    ],
    "city": [
      "Estherville",
      "Estherville",
      "Estherville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ESW",
    "translations": [
      "Easton State Airport",
      "Easton State Airport",
      "Easton State Airport"
    ],
    "city": [
      "Easton",
      "Easton",
      "Easton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ETB",
    "translations": [
      "West Bend Municipal Airport",
      "West Bend Municipal Airport",
      "West Bend Municipal Airport"
    ],
    "city": [
      "West Bend",
      "West Bend",
      "West Bend"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ETN",
    "translations": [
      "Eastland Municipal Airport",
      "Eastland Municipal Airport",
      "Eastland Municipal Airport"
    ],
    "city": [
      "Eastland",
      "Eastland",
      "Eastland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EUF",
    "translations": [
      "Weedon Field",
      "Weedon Field",
      "Weedon Field"
    ],
    "city": [
      "Eufaula",
      "Eufaula",
      "Eufaula"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EUG",
    "translations": [
      "Mahlon Sweet Field",
      "Mahlon Sweet Field",
      "Mahlon Sweet Field"
    ],
    "city": [
      "Eugene",
      "Eugene",
      "Eugene"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EVM",
    "translations": [
      "Eveleth–Virginia Municipal Airport",
      "Eveleth–Virginia Municipal Airport",
      "Eveleth–Virginia Municipal Airport"
    ],
    "city": [
      "Eveleth",
      "Eveleth",
      "Eveleth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EVV",
    "translations": [
      "Evansville Regional Airport",
      "Evansville Regional Airport",
      "Evansville Regional Airport"
    ],
    "city": [
      "Evansville",
      "Evansville",
      "Evansville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EVW",
    "translations": [
      "Evanston-Uinta County Airport-Burns Field",
      "Evanston-Uinta County Airport-Burns Field",
      "Evanston-Uinta County Airport-Burns Field"
    ],
    "city": [
      "Evanston",
      "Evanston",
      "Evanston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EWB",
    "translations": [
      "New Bedford Regional Airport",
      "New Bedford Regional Airport",
      "New Bedford Regional Airport"
    ],
    "city": [
      "New Bedford",
      "New Bedford",
      "New Bedford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EWK",
    "translations": [
      "Newton City-County Airport",
      "Newton City-County Airport",
      "Newton City-County Airport"
    ],
    "city": [
      "Newton",
      "Newton",
      "Newton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EWN",
    "translations": [
      "Coastal Carolina Regional Airport",
      "Coastal Carolina Regional Airport",
      "Coastal Carolina Regional Airport"
    ],
    "city": [
      "New Bern",
      "New Bern",
      "New Bern"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EWR",
    "translations": [
      "Newark Liberty International Airport",
      "Newark Liberty International Airport",
      "Newark Liberty International Airport"
    ],
    "city": [
      "Newark",
      "Newark",
      "Newark"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EYW",
    "translations": [
      "Key West International Airport",
      "Key West International Airport",
      "Key West International Airport"
    ],
    "city": [
      "Key West",
      "Key West",
      "Key West"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KEZ",
    "translations": [
      "Kelani-Peliyagoda Seaplane Base",
      "Kelani-Peliyagoda Seaplane Base",
      "Kelani-Peliyagoda Seaplane Base"
    ],
    "city": [
      "Colombo",
      "Colombo",
      "Colombo"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "WIB",
    "translations": [
      "Wilbarger County Airport",
      "Wilbarger County Airport",
      "Wilbarger County Airport"
    ],
    "city": [
      "Vernon",
      "Vernon",
      "Vernon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RBK",
    "translations": [
      "French Valley Airport",
      "French Valley Airport",
      "French Valley Airport"
    ],
    "city": [
      "Murrieta",
      "Murrieta",
      "Murrieta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FAF",
    "translations": [
      "Felker Army Air Field",
      "Felker Army Air Field",
      "Felker Army Air Field"
    ],
    "city": [
      "Newport News (Fort Eustis)",
      "Newport News (Fort Eustis)",
      "Newport News (Fort Eustis)"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FAM",
    "translations": [
      "Farmington Regional Airport",
      "Farmington Regional Airport",
      "Farmington Regional Airport"
    ],
    "city": [
      "Farmington",
      "Farmington",
      "Farmington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FAR",
    "translations": [
      "Hector International Airport",
      "Hector International Airport",
      "Hector International Airport"
    ],
    "city": [
      "Fargo",
      "Fargo",
      "Fargo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FAT",
    "translations": [
      "Fresno Yosemite International Airport",
      "Fresno Yosemite International Airport",
      "Fresno Yosemite International Airport"
    ],
    "city": [
      "Fresno",
      "Fresno",
      "Fresno"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FAY",
    "translations": [
      "Fayetteville Regional Airport - Grannis Field",
      "Fayetteville Regional Airport - Grannis Field",
      "Fayetteville Regional Airport - Grannis Field"
    ],
    "city": [
      "Fayetteville",
      "Fayetteville",
      "Fayetteville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FBG",
    "translations": [
      "Simmons Army Air Field",
      "Simmons Army Air Field",
      "Simmons Army Air Field"
    ],
    "city": [
      "Fort Bragg",
      "Fort Bragg",
      "Fort Bragg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FBL",
    "translations": [
      "Faribault Municipal Airport-Liz Wall Strohfus Field",
      "Faribault Municipal Airport-Liz Wall Strohfus Field",
      "Faribault Municipal Airport-Liz Wall Strohfus Field"
    ],
    "city": [
      "Faribault",
      "Faribault",
      "Faribault"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FBR",
    "translations": [
      "Fort Bridger Airport",
      "Fort Bridger Airport",
      "Fort Bridger Airport"
    ],
    "city": [
      "Fort Bridger",
      "Fort Bridger",
      "Fort Bridger"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FBY",
    "translations": [
      "Fairbury Municipal Airport",
      "Fairbury Municipal Airport",
      "Fairbury Municipal Airport"
    ],
    "city": [
      "Fairbury",
      "Fairbury",
      "Fairbury"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FCH",
    "translations": [
      "Fresno Chandler Executive Airport",
      "Fresno Chandler Executive Airport",
      "Fresno Chandler Executive Airport"
    ],
    "city": [
      "Fresno",
      "Fresno",
      "Fresno"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FCM",
    "translations": [
      "Flying Cloud Airport",
      "Flying Cloud Airport",
      "Flying Cloud Airport"
    ],
    "city": [
      "Minneapolis",
      "Minneapolis",
      "Minneapolis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FCS",
    "translations": [
      "Butts AAF (Fort Carson) Air Field",
      "Butts AAF (Fort Carson) Air Field",
      "Butts AAF (Fort Carson) Air Field"
    ],
    "city": [
      "Fort Carson",
      "Fort Carson",
      "Fort Carson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FCY",
    "translations": [
      "Forrest City Municipal Airport",
      "Forrest City Municipal Airport",
      "Forrest City Municipal Airport"
    ],
    "city": [
      "Forrest City",
      "Forrest City",
      "Forrest City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FDK",
    "translations": [
      "Frederick Municipal Airport",
      "Frederick Municipal Airport",
      "Frederick Municipal Airport"
    ],
    "city": [
      "Frederick",
      "Frederick",
      "Frederick"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FDR",
    "translations": [
      "Frederick Regional Airport",
      "Frederick Regional Airport",
      "Frederick Regional Airport"
    ],
    "city": [
      "Frederick",
      "Frederick",
      "Frederick"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FDY",
    "translations": [
      "Findlay Airport",
      "Findlay Airport",
      "Findlay Airport"
    ],
    "city": [
      "Findlay",
      "Findlay",
      "Findlay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FEP",
    "translations": [
      "Albertus Airport",
      "Albertus Airport",
      "Albertus Airport"
    ],
    "city": [
      "Freeport",
      "Freeport",
      "Freeport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FET",
    "translations": [
      "Fremont Municipal Airport",
      "Fremont Municipal Airport",
      "Fremont Municipal Airport"
    ],
    "city": [
      "Fremont",
      "Fremont",
      "Fremont"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FFA",
    "translations": [
      "First Flight Airport",
      "First Flight Airport",
      "First Flight Airport"
    ],
    "city": [
      "Kill Devil Hills",
      "Kill Devil Hills",
      "Kill Devil Hills"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FFL",
    "translations": [
      "Fairfield Municipal Airport",
      "Fairfield Municipal Airport",
      "Fairfield Municipal Airport"
    ],
    "city": [
      "Fairfield",
      "Fairfield",
      "Fairfield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FFM",
    "translations": [
      "Fergus Falls Municipal Airport - Einar Mickelson Field",
      "Fergus Falls Municipal Airport - Einar Mickelson Field",
      "Fergus Falls Municipal Airport - Einar Mickelson Field"
    ],
    "city": [
      "Fergus Falls",
      "Fergus Falls",
      "Fergus Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FFO",
    "translations": [
      "Wright-Patterson Air Force Base",
      "Wright-Patterson Air Force Base",
      "Wright-Patterson Air Force Base"
    ],
    "city": [
      "Dayton",
      "Dayton",
      "Dayton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FFT",
    "translations": [
      "Capital City Airport",
      "Capital City Airport",
      "Capital City Airport"
    ],
    "city": [
      "Frankfort",
      "Frankfort",
      "Frankfort"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MSC",
    "translations": [
      "Falcon Field",
      "Falcon Field",
      "Falcon Field"
    ],
    "city": [
      "Mesa",
      "Mesa",
      "Mesa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FRD",
    "translations": [
      "Friday Harbor Airport",
      "Friday Harbor Airport",
      "Friday Harbor Airport"
    ],
    "city": [
      "Friday Harbor",
      "Friday Harbor",
      "Friday Harbor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FHU",
    "translations": [
      "Sierra Vista Municipal Airport / Libby Army Air Field",
      "Sierra Vista Municipal Airport / Libby Army Air Field",
      "Sierra Vista Municipal Airport / Libby Army Air Field"
    ],
    "city": [
      "Fort Huachuca / Sierra Vista",
      "Fort Huachuca / Sierra Vista",
      "Fort Huachuca / Sierra Vista"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FKL",
    "translations": [
      "Venango Regional Airport",
      "Venango Regional Airport",
      "Venango Regional Airport"
    ],
    "city": [
      "Franklin",
      "Franklin",
      "Franklin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FKN",
    "translations": [
      "Franklin Regional Airport",
      "Franklin Regional Airport",
      "Franklin Regional Airport"
    ],
    "city": [
      "Franklin",
      "Franklin",
      "Franklin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FLD",
    "translations": [
      "Fond du Lac County Airport",
      "Fond du Lac County Airport",
      "Fond du Lac County Airport"
    ],
    "city": [
      "Fond du Lac",
      "Fond du Lac",
      "Fond du Lac"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FLG",
    "translations": [
      "Flagstaff Pulliam International Airport",
      "Flagstaff Pulliam International Airport",
      "Flagstaff Pulliam International Airport"
    ],
    "city": [
      "Flagstaff",
      "Flagstaff",
      "Flagstaff"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FLL",
    "translations": [
      "Fort Lauderdale Hollywood International Airport",
      "Fort Lauderdale Hollywood International Airport",
      "Fort Lauderdale Hollywood International Airport"
    ],
    "city": [
      "Fort Lauderdale",
      "Fort Lauderdale",
      "Fort Lauderdale"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FLO",
    "translations": [
      "Florence Regional Airport",
      "Florence Regional Airport",
      "Florence Regional Airport"
    ],
    "city": [
      "Florence",
      "Florence",
      "Florence"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FLP",
    "translations": [
      "Marion County Regional Airport",
      "Marion County Regional Airport",
      "Marion County Regional Airport"
    ],
    "city": [
      "Flippin",
      "Flippin",
      "Flippin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FLV",
    "translations": [
      "Sherman Army Air Field",
      "Sherman Army Air Field",
      "Sherman Army Air Field"
    ],
    "city": [
      "Fort Leavenworth",
      "Fort Leavenworth",
      "Fort Leavenworth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FLX",
    "translations": [
      "Fallon Municipal Airport",
      "Fallon Municipal Airport",
      "Fallon Municipal Airport"
    ],
    "city": [
      "Fallon",
      "Fallon",
      "Fallon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FME",
    "translations": [
      "Tipton Airport",
      "Tipton Airport",
      "Tipton Airport"
    ],
    "city": [
      "Fort Meade(Odenton)",
      "Fort Meade(Odenton)",
      "Fort Meade(Odenton)"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FMH",
    "translations": [
      "Cape Cod Coast Guard Air Station",
      "Cape Cod Coast Guard Air Station",
      "Cape Cod Coast Guard Air Station"
    ],
    "city": [
      "Falmouth",
      "Falmouth",
      "Falmouth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FMN",
    "translations": [
      "Four Corners Regional Airport",
      "Four Corners Regional Airport",
      "Four Corners Regional Airport"
    ],
    "city": [
      "Farmington",
      "Farmington",
      "Farmington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FMY",
    "translations": [
      "Page Field",
      "Page Field",
      "Page Field"
    ],
    "city": [
      "Fort Myers",
      "Fort Myers",
      "Fort Myers"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FNL",
    "translations": [
      "Northern Colorado Regional Airport",
      "Northern Colorado Regional Airport",
      "Northern Colorado Regional Airport"
    ],
    "city": [
      "Loveland",
      "Loveland",
      "Loveland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FNT",
    "translations": [
      "Bishop International Airport",
      "Bishop International Airport",
      "Bishop International Airport"
    ],
    "city": [
      "Flint",
      "Flint",
      "Flint"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FOD",
    "translations": [
      "Fort Dodge Regional Airport",
      "Fort Dodge Regional Airport",
      "Fort Dodge Regional Airport"
    ],
    "city": [
      "Fort Dodge",
      "Fort Dodge",
      "Fort Dodge"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FOE",
    "translations": [
      "Topeka Regional Airport",
      "Topeka Regional Airport",
      "Topeka Regional Airport"
    ],
    "city": [
      "Topeka",
      "Topeka",
      "Topeka"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FOK",
    "translations": [
      "Francis S Gabreski Airport",
      "Francis S Gabreski Airport",
      "Francis S Gabreski Airport"
    ],
    "city": [
      "Westhampton Beach",
      "Westhampton Beach",
      "Westhampton Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FIL",
    "translations": [
      "Fillmore Municipal Airport",
      "Fillmore Municipal Airport",
      "Fillmore Municipal Airport"
    ],
    "city": [
      "Fillmore",
      "Fillmore",
      "Fillmore"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FPR",
    "translations": [
      "St Lucie County International Airport",
      "St Lucie County International Airport",
      "St Lucie County International Airport"
    ],
    "city": [
      "Fort Pierce",
      "Fort Pierce",
      "Fort Pierce"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FRG",
    "translations": [
      "Republic Airport",
      "Republic Airport",
      "Republic Airport"
    ],
    "city": [
      "Farmingdale",
      "Farmingdale",
      "Farmingdale"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FRH",
    "translations": [
      "French Lick Municipal Airport",
      "French Lick Municipal Airport",
      "French Lick Municipal Airport"
    ],
    "city": [
      "French Lick",
      "French Lick",
      "French Lick"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FRI",
    "translations": [
      "Marshall Army Air Field",
      "Marshall Army Air Field",
      "Marshall Army Air Field"
    ],
    "city": [
      "Fort Riley (Junction City)",
      "Fort Riley (Junction City)",
      "Fort Riley (Junction City)"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FRM",
    "translations": [
      "Fairmont Municipal Airport",
      "Fairmont Municipal Airport",
      "Fairmont Municipal Airport"
    ],
    "city": [
      "Fairmont",
      "Fairmont",
      "Fairmont"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FRR",
    "translations": [
      "Front Royal Warren County Airport",
      "Front Royal Warren County Airport",
      "Front Royal Warren County Airport"
    ],
    "city": [
      "Front Royal",
      "Front Royal",
      "Front Royal"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FSD",
    "translations": [
      "Sioux Falls Regional Airport / Joe Foss Field",
      "Sioux Falls Regional Airport / Joe Foss Field",
      "Sioux Falls Regional Airport / Joe Foss Field"
    ],
    "city": [
      "Sioux Falls",
      "Sioux Falls",
      "Sioux Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FSI",
    "translations": [
      "Henry Post Army Air Field",
      "Henry Post Army Air Field",
      "Henry Post Army Air Field"
    ],
    "city": [
      "Fort Sill",
      "Fort Sill",
      "Fort Sill"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FSK",
    "translations": [
      "Fort Scott Municipal Airport",
      "Fort Scott Municipal Airport",
      "Fort Scott Municipal Airport"
    ],
    "city": [
      "Fort Scott",
      "Fort Scott",
      "Fort Scott"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FSM",
    "translations": [
      "Fort Smith Regional Airport",
      "Fort Smith Regional Airport",
      "Fort Smith Regional Airport"
    ],
    "city": [
      "Fort Smith",
      "Fort Smith",
      "Fort Smith"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FST",
    "translations": [
      "Fort Stockton Pecos County Airport",
      "Fort Stockton Pecos County Airport",
      "Fort Stockton Pecos County Airport"
    ],
    "city": [
      "Fort Stockton",
      "Fort Stockton",
      "Fort Stockton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FSU",
    "translations": [
      "Fort Sumner Municipal Airport",
      "Fort Sumner Municipal Airport",
      "Fort Sumner Municipal Airport"
    ],
    "city": [
      "Fort Sumner",
      "Fort Sumner",
      "Fort Sumner"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FMS",
    "translations": [
      "Fort Madison Municipal Airport",
      "Fort Madison Municipal Airport",
      "Fort Madison Municipal Airport"
    ],
    "city": [
      "Fort Madison",
      "Fort Madison",
      "Fort Madison"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FTK",
    "translations": [
      "Godman Army Air Field",
      "Godman Army Air Field",
      "Godman Army Air Field"
    ],
    "city": [
      "Fort Knox",
      "Fort Knox",
      "Fort Knox"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FTW",
    "translations": [
      "Fort Worth Meacham International Airport",
      "Fort Worth Meacham International Airport",
      "Fort Worth Meacham International Airport"
    ],
    "city": [
      "Fort Worth",
      "Fort Worth",
      "Fort Worth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FTY",
    "translations": [
      "Fulton County Airport Brown Field",
      "Fulton County Airport Brown Field",
      "Fulton County Airport Brown Field"
    ],
    "city": [
      "Atlanta",
      "Atlanta",
      "Atlanta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FUL",
    "translations": [
      "Fullerton Municipal Airport",
      "Fullerton Municipal Airport",
      "Fullerton Municipal Airport"
    ],
    "city": [
      "Fullerton",
      "Fullerton",
      "Fullerton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WFK",
    "translations": [
      "Northern Aroostook Regional Airport",
      "Northern Aroostook Regional Airport",
      "Northern Aroostook Regional Airport"
    ],
    "city": [
      "Frenchville",
      "Frenchville",
      "Frenchville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FWA",
    "translations": [
      "Fort Wayne International Airport",
      "Fort Wayne International Airport",
      "Fort Wayne International Airport"
    ],
    "city": [
      "Fort Wayne",
      "Fort Wayne",
      "Fort Wayne"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FXE",
    "translations": [
      "Fort Lauderdale Executive Airport",
      "Fort Lauderdale Executive Airport",
      "Fort Lauderdale Executive Airport"
    ],
    "city": [
      "Fort Lauderdale",
      "Fort Lauderdale",
      "Fort Lauderdale"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FXY",
    "translations": [
      "Forest City Municipal Airport",
      "Forest City Municipal Airport",
      "Forest City Municipal Airport"
    ],
    "city": [
      "Forest City",
      "Forest City",
      "Forest City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FYM",
    "translations": [
      "Fayetteville Municipal Airport",
      "Fayetteville Municipal Airport",
      "Fayetteville Municipal Airport"
    ],
    "city": [
      "Fayetteville",
      "Fayetteville",
      "Fayetteville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FYV",
    "translations": [
      "Drake Field",
      "Drake Field",
      "Drake Field"
    ],
    "city": [
      "Fayetteville",
      "Fayetteville",
      "Fayetteville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GAB",
    "translations": [
      "Gabbs Airport",
      "Gabbs Airport",
      "Gabbs Airport"
    ],
    "city": [
      "Gabbs",
      "Gabbs",
      "Gabbs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GAD",
    "translations": [
      "Northeast Alabama Regional Airport",
      "Northeast Alabama Regional Airport",
      "Northeast Alabama Regional Airport"
    ],
    "city": [
      "Gadsden",
      "Gadsden",
      "Gadsden"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GAG",
    "translations": [
      "Gage Heibeck Airport",
      "Gage Heibeck Airport",
      "Gage Heibeck Airport"
    ],
    "city": [
      "Gage",
      "Gage",
      "Gage"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GAI",
    "translations": [
      "Montgomery County Airpark",
      "Montgomery County Airpark",
      "Montgomery County Airpark"
    ],
    "city": [
      "Gaithersburg",
      "Gaithersburg",
      "Gaithersburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GBD",
    "translations": [
      "Great Bend Municipal Airport",
      "Great Bend Municipal Airport",
      "Great Bend Municipal Airport"
    ],
    "city": [
      "Great Bend",
      "Great Bend",
      "Great Bend"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GBG",
    "translations": [
      "Galesburg Municipal Airport",
      "Galesburg Municipal Airport",
      "Galesburg Municipal Airport"
    ],
    "city": [
      "Galesburg",
      "Galesburg",
      "Galesburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GBR",
    "translations": [
      "Walter J. Koladza Airport",
      "Walter J. Koladza Airport",
      "Walter J. Koladza Airport"
    ],
    "city": [
      "Great Barrington",
      "Great Barrington",
      "Great Barrington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GCC",
    "translations": [
      "Northeast Wyoming Regional Airport",
      "Northeast Wyoming Regional Airport",
      "Northeast Wyoming Regional Airport"
    ],
    "city": [
      "Gillette",
      "Gillette",
      "Gillette"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JDA",
    "translations": [
      "Grant County Regional Airport / Ogilvie Field",
      "Grant County Regional Airport / Ogilvie Field",
      "Grant County Regional Airport / Ogilvie Field"
    ],
    "city": [
      "John Day",
      "John Day",
      "John Day"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GCK",
    "translations": [
      "Garden City Regional Airport",
      "Garden City Regional Airport",
      "Garden City Regional Airport"
    ],
    "city": [
      "Garden City",
      "Garden City",
      "Garden City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GCN",
    "translations": [
      "Grand Canyon National Park Airport",
      "Grand Canyon National Park Airport",
      "Grand Canyon National Park Airport"
    ],
    "city": [
      "Grand Canyon - Tusayan",
      "Grand Canyon - Tusayan",
      "Grand Canyon - Tusayan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GCY",
    "translations": [
      "Greeneville Municipal Airport",
      "Greeneville Municipal Airport",
      "Greeneville Municipal Airport"
    ],
    "city": [
      "Greeneville",
      "Greeneville",
      "Greeneville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GDM",
    "translations": [
      "Gardner Municipal Airport",
      "Gardner Municipal Airport",
      "Gardner Municipal Airport"
    ],
    "city": [
      "Gardner",
      "Gardner",
      "Gardner"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GDV",
    "translations": [
      "Dawson Community Airport",
      "Dawson Community Airport",
      "Dawson Community Airport"
    ],
    "city": [
      "Glendive",
      "Glendive",
      "Glendive"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GDW",
    "translations": [
      "Gladwin Zettel Memorial Airport",
      "Gladwin Zettel Memorial Airport",
      "Gladwin Zettel Memorial Airport"
    ],
    "city": [
      "Gladwin",
      "Gladwin",
      "Gladwin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GED",
    "translations": [
      "Delaware Coastal Airport",
      "Delaware Coastal Airport",
      "Delaware Coastal Airport"
    ],
    "city": [
      "Georgetown",
      "Georgetown",
      "Georgetown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GEG",
    "translations": [
      "Spokane International Airport",
      "Spokane International Airport",
      "Spokane International Airport"
    ],
    "city": [
      "Spokane",
      "Spokane",
      "Spokane"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GEY",
    "translations": [
      "South Big Horn County Airport",
      "South Big Horn County Airport",
      "South Big Horn County Airport"
    ],
    "city": [
      "Greybull",
      "Greybull",
      "Greybull"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GFA",
    "translations": [
      "Malmstrom Air Force Base",
      "Malmstrom Air Force Base",
      "Malmstrom Air Force Base"
    ],
    "city": [
      "Great Falls",
      "Great Falls",
      "Great Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GFD",
    "translations": [
      "Pope Field",
      "Pope Field",
      "Pope Field"
    ],
    "city": [
      "Greenfield",
      "Greenfield",
      "Greenfield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GFK",
    "translations": [
      "Grand Forks International Airport",
      "Grand Forks International Airport",
      "Grand Forks International Airport"
    ],
    "city": [
      "Grand Forks",
      "Grand Forks",
      "Grand Forks"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GFL",
    "translations": [
      "Floyd Bennett Memorial Airport",
      "Floyd Bennett Memorial Airport",
      "Floyd Bennett Memorial Airport"
    ],
    "city": [
      "Glens Falls",
      "Glens Falls",
      "Glens Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GGE",
    "translations": [
      "Georgetown County Airport",
      "Georgetown County Airport",
      "Georgetown County Airport"
    ],
    "city": [
      "Georgetown",
      "Georgetown",
      "Georgetown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GGG",
    "translations": [
      "East Texas Regional Airport",
      "East Texas Regional Airport",
      "East Texas Regional Airport"
    ],
    "city": [
      "Longview",
      "Longview",
      "Longview"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GGW",
    "translations": [
      "Glasgow Valley County Airport Wokal Field",
      "Glasgow Valley County Airport Wokal Field",
      "Glasgow Valley County Airport Wokal Field"
    ],
    "city": [
      "Glasgow",
      "Glasgow",
      "Glasgow"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GHM",
    "translations": [
      "Centerville Municipal Airport",
      "Centerville Municipal Airport",
      "Centerville Municipal Airport"
    ],
    "city": [
      "Centerville",
      "Centerville",
      "Centerville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IDH",
    "translations": [
      "Idaho County Airport",
      "Idaho County Airport",
      "Idaho County Airport"
    ],
    "city": [
      "Grangeville",
      "Grangeville",
      "Grangeville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GIF",
    "translations": [
      "Winter Haven Regional Airport - Gilbert Field",
      "Winter Haven Regional Airport - Gilbert Field",
      "Winter Haven Regional Airport - Gilbert Field"
    ],
    "city": [
      "Winter Haven",
      "Winter Haven",
      "Winter Haven"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GJT",
    "translations": [
      "Grand Junction Regional Airport",
      "Grand Junction Regional Airport",
      "Grand Junction Regional Airport"
    ],
    "city": [
      "Grand Junction",
      "Grand Junction",
      "Grand Junction"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MEJ",
    "translations": [
      "Port Meadville Airport",
      "Port Meadville Airport",
      "Port Meadville Airport"
    ],
    "city": [
      "Meadville",
      "Meadville",
      "Meadville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GKT",
    "translations": [
      "Gatlinburg-Pigeon Forge Airport",
      "Gatlinburg-Pigeon Forge Airport",
      "Gatlinburg-Pigeon Forge Airport"
    ],
    "city": [
      "Sevierville",
      "Sevierville",
      "Sevierville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GLD",
    "translations": [
      "Goodland Municipal Airport",
      "Goodland Municipal Airport",
      "Goodland Municipal Airport"
    ],
    "city": [
      "Goodland",
      "Goodland",
      "Goodland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GLE",
    "translations": [
      "Gainesville Municipal Airport",
      "Gainesville Municipal Airport",
      "Gainesville Municipal Airport"
    ],
    "city": [
      "Gainesville",
      "Gainesville",
      "Gainesville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GLH",
    "translations": [
      "Mid Delta Regional Airport",
      "Mid Delta Regional Airport",
      "Mid Delta Regional Airport"
    ],
    "city": [
      "Greenville",
      "Greenville",
      "Greenville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GLR",
    "translations": [
      "Gaylord Regional Airport",
      "Gaylord Regional Airport",
      "Gaylord Regional Airport"
    ],
    "city": [
      "Gaylord",
      "Gaylord",
      "Gaylord"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GLS",
    "translations": [
      "Scholes International At Galveston Airport",
      "Scholes International At Galveston Airport",
      "Scholes International At Galveston Airport"
    ],
    "city": [
      "Galveston",
      "Galveston",
      "Galveston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GLW",
    "translations": [
      "Glasgow Municipal Airport",
      "Glasgow Municipal Airport",
      "Glasgow Municipal Airport"
    ],
    "city": [
      "Glasgow",
      "Glasgow",
      "Glasgow"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GMU",
    "translations": [
      "Greenville Downtown Airport",
      "Greenville Downtown Airport",
      "Greenville Downtown Airport"
    ],
    "city": [
      "Greenville",
      "Greenville",
      "Greenville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GNG",
    "translations": [
      "Gooding Municipal Airport",
      "Gooding Municipal Airport",
      "Gooding Municipal Airport"
    ],
    "city": [
      "Gooding",
      "Gooding",
      "Gooding"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GNT",
    "translations": [
      "Grants-Milan Municipal Airport",
      "Grants-Milan Municipal Airport",
      "Grants-Milan Municipal Airport"
    ],
    "city": [
      "Grants",
      "Grants",
      "Grants"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GNV",
    "translations": [
      "Gainesville Regional Airport",
      "Gainesville Regional Airport",
      "Gainesville Regional Airport"
    ],
    "city": [
      "Gainesville",
      "Gainesville",
      "Gainesville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GOK",
    "translations": [
      "Guthrie-Edmond Regional Airport",
      "Guthrie-Edmond Regional Airport",
      "Guthrie-Edmond Regional Airport"
    ],
    "city": [
      "Guthrie",
      "Guthrie",
      "Guthrie"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GON",
    "translations": [
      "Groton New London Airport",
      "Groton New London Airport",
      "Groton New London Airport"
    ],
    "city": [
      "Groton",
      "Groton",
      "Groton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FCA",
    "translations": [
      "Glacier Park International Airport",
      "Glacier Park International Airport",
      "Glacier Park International Airport"
    ],
    "city": [
      "Kalispell",
      "Kalispell",
      "Kalispell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GPT",
    "translations": [
      "Gulfport Biloxi International Airport",
      "Gulfport Biloxi International Airport",
      "Gulfport Biloxi International Airport"
    ],
    "city": [
      "Gulfport",
      "Gulfport",
      "Gulfport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GPZ",
    "translations": [
      "Grand Rapids Itasca Co-Gordon Newstrom field",
      "Grand Rapids Itasca Co-Gordon Newstrom field",
      "Grand Rapids Itasca Co-Gordon Newstrom field"
    ],
    "city": [
      "Grand Rapids",
      "Grand Rapids",
      "Grand Rapids"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GQQ",
    "translations": [
      "Galion Municipal Airport",
      "Galion Municipal Airport",
      "Galion Municipal Airport"
    ],
    "city": [
      "Galion",
      "Galion",
      "Galion"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GRB",
    "translations": [
      "Austin Straubel International Airport",
      "Austin Straubel International Airport",
      "Austin Straubel International Airport"
    ],
    "city": [
      "Green Bay",
      "Green Bay",
      "Green Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GRD",
    "translations": [
      "Greenwood County Airport",
      "Greenwood County Airport",
      "Greenwood County Airport"
    ],
    "city": [
      "Greenwood",
      "Greenwood",
      "Greenwood"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GRE",
    "translations": [
      "Greenville Airport",
      "Greenville Airport",
      "Greenville Airport"
    ],
    "city": [
      "Greenville",
      "Greenville",
      "Greenville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GRF",
    "translations": [
      "Gray Army Air Field",
      "Gray Army Air Field",
      "Gray Army Air Field"
    ],
    "city": [
      "Fort Lewis/Tacoma",
      "Fort Lewis/Tacoma",
      "Fort Lewis/Tacoma"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GRI",
    "translations": [
      "Central Nebraska Regional Airport",
      "Central Nebraska Regional Airport",
      "Central Nebraska Regional Airport"
    ],
    "city": [
      "Grand Island",
      "Grand Island",
      "Grand Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GRK",
    "translations": [
      "Killeen Regional Airport / Robert Gray Army Airfield",
      "Killeen Regional Airport / Robert Gray Army Airfield",
      "Killeen Regional Airport / Robert Gray Army Airfield"
    ],
    "city": [
      "Fort Cavazos",
      "Fort Cavazos",
      "Fort Cavazos"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GRN",
    "translations": [
      "Gordon Municipal Airport",
      "Gordon Municipal Airport",
      "Gordon Municipal Airport"
    ],
    "city": [
      "Gordon",
      "Gordon",
      "Gordon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GRR",
    "translations": [
      "Gerald R. Ford International Airport",
      "Gerald R. Ford International Airport",
      "Gerald R. Ford International Airport"
    ],
    "city": [
      "Grand Rapids",
      "Grand Rapids",
      "Grand Rapids"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GSB",
    "translations": [
      "Seymour Johnson Air Force Base",
      "Seymour Johnson Air Force Base",
      "Seymour Johnson Air Force Base"
    ],
    "city": [
      "Goldsboro",
      "Goldsboro",
      "Goldsboro"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GSH",
    "translations": [
      "Goshen Municipal Airport",
      "Goshen Municipal Airport",
      "Goshen Municipal Airport"
    ],
    "city": [
      "Goshen",
      "Goshen",
      "Goshen"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GSO",
    "translations": [
      "Piedmont Triad International Airport",
      "Piedmont Triad International Airport",
      "Piedmont Triad International Airport"
    ],
    "city": [
      "Greensboro",
      "Greensboro",
      "Greensboro"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GSP",
    "translations": [
      "Greenville Spartanburg International Airport",
      "Greenville Spartanburg International Airport",
      "Greenville Spartanburg International Airport"
    ],
    "city": [
      "Greer",
      "Greer",
      "Greer"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GTF",
    "translations": [
      "Great Falls International Airport",
      "Great Falls International Airport",
      "Great Falls International Airport"
    ],
    "city": [
      "Great Falls",
      "Great Falls",
      "Great Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GTG",
    "translations": [
      "Grantsburg Municipal Airport",
      "Grantsburg Municipal Airport",
      "Grantsburg Municipal Airport"
    ],
    "city": [
      "Grantsburg",
      "Grantsburg",
      "Grantsburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GTR",
    "translations": [
      "Golden Triangle Regional Airport",
      "Golden Triangle Regional Airport",
      "Golden Triangle Regional Airport"
    ],
    "city": [
      "Columbus/W Point/Starkville",
      "Columbus/W Point/Starkville",
      "Columbus/W Point/Starkville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GUC",
    "translations": [
      "Gunnison Crested Butte Regional Airport",
      "Gunnison Crested Butte Regional Airport",
      "Gunnison Crested Butte Regional Airport"
    ],
    "city": [
      "Gunnison",
      "Gunnison",
      "Gunnison"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GUP",
    "translations": [
      "Gallup Municipal Airport",
      "Gallup Municipal Airport",
      "Gallup Municipal Airport"
    ],
    "city": [
      "Gallup",
      "Gallup",
      "Gallup"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GUS",
    "translations": [
      "Grissom Air Reserve Base",
      "Grissom Air Reserve Base",
      "Grissom Air Reserve Base"
    ],
    "city": [
      "Peru",
      "Peru",
      "Peru"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GUY",
    "translations": [
      "Guymon Municipal Airport",
      "Guymon Municipal Airport",
      "Guymon Municipal Airport"
    ],
    "city": [
      "Guymon",
      "Guymon",
      "Guymon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GVE",
    "translations": [
      "Gordonsville Municipal Airport",
      "Gordonsville Municipal Airport",
      "Gordonsville Municipal Airport"
    ],
    "city": [
      "Gordonsville",
      "Gordonsville",
      "Gordonsville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GVL",
    "translations": [
      "Lee Gilmer Memorial Airport",
      "Lee Gilmer Memorial Airport",
      "Lee Gilmer Memorial Airport"
    ],
    "city": [
      "Gainesville",
      "Gainesville",
      "Gainesville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GVT",
    "translations": [
      "Majors Airport",
      "Majors Airport",
      "Majors Airport"
    ],
    "city": [
      "Greenville",
      "Greenville",
      "Greenville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GWO",
    "translations": [
      "Greenwood–Leflore Airport",
      "Greenwood–Leflore Airport",
      "Greenwood–Leflore Airport"
    ],
    "city": [
      "Greenwood",
      "Greenwood",
      "Greenwood"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GWS",
    "translations": [
      "Glenwood Springs Municipal Airport",
      "Glenwood Springs Municipal Airport",
      "Glenwood Springs Municipal Airport"
    ],
    "city": [
      "Glenwood Springs",
      "Glenwood Springs",
      "Glenwood Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KGX",
    "translations": [
      "Grayling Airport",
      "Grayling Airport",
      "Grayling Airport"
    ],
    "city": [
      "Grayling",
      "Grayling",
      "Grayling"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GXY",
    "translations": [
      "Greeley–Weld County Airport",
      "Greeley–Weld County Airport",
      "Greeley–Weld County Airport"
    ],
    "city": [
      "Greeley",
      "Greeley",
      "Greeley"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GDC",
    "translations": [
      "Donaldson Field Airport",
      "Donaldson Field Airport",
      "Donaldson Field Airport"
    ],
    "city": [
      "Greenville",
      "Greenville",
      "Greenville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PNX",
    "translations": [
      "North Texas Regional Airport Perrin Field",
      "North Texas Regional Airport Perrin Field",
      "North Texas Regional Airport Perrin Field"
    ],
    "city": [
      "Denison",
      "Denison",
      "Denison"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GYR",
    "translations": [
      "Phoenix Goodyear Airport",
      "Phoenix Goodyear Airport",
      "Phoenix Goodyear Airport"
    ],
    "city": [
      "Goodyear",
      "Goodyear",
      "Goodyear"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GYY",
    "translations": [
      "Gary Chicago International Airport",
      "Gary Chicago International Airport",
      "Gary Chicago International Airport"
    ],
    "city": [
      "Gary",
      "Gary",
      "Gary"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KGZ",
    "translations": [
      "Glacier Creek Airport",
      "Glacier Creek Airport",
      "Glacier Creek Airport"
    ],
    "city": [
      "Glacier Creek",
      "Glacier Creek",
      "Glacier Creek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DSY",
    "translations": [
      "Dara Sakor International Airport",
      "Dara Sakor International Airport",
      "Dara Sakor International Airport"
    ],
    "city": [
      "Ta Noun",
      "Ta Noun",
      "Ta Noun"
    ],
    "country": [
      "KH",
      "KH",
      "KH"
    ]
  },
  {
    "iata": "HAB",
    "translations": [
      "Marion County Rankin Fite Airport",
      "Marion County Rankin Fite Airport",
      "Marion County Rankin Fite Airport"
    ],
    "city": [
      "Hamilton",
      "Hamilton",
      "Hamilton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HAF",
    "translations": [
      "Half Moon Bay Airport",
      "Half Moon Bay Airport",
      "Half Moon Bay Airport"
    ],
    "city": [
      "Half Moon Bay",
      "Half Moon Bay",
      "Half Moon Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HAI",
    "translations": [
      "Three Rivers Municipal Dr Haines Airport",
      "Three Rivers Municipal Dr Haines Airport",
      "Three Rivers Municipal Dr Haines Airport"
    ],
    "city": [
      "Three Rivers",
      "Three Rivers",
      "Three Rivers"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HAO",
    "translations": [
      "Butler Co Regional Airport - Hogan Field",
      "Butler Co Regional Airport - Hogan Field",
      "Butler Co Regional Airport - Hogan Field"
    ],
    "city": [
      "Hamilton",
      "Hamilton",
      "Hamilton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HBG",
    "translations": [
      "Hattiesburg Bobby L Chain Municipal Airport",
      "Hattiesburg Bobby L Chain Municipal Airport",
      "Hattiesburg Bobby L Chain Municipal Airport"
    ],
    "city": [
      "Hattiesburg",
      "Hattiesburg",
      "Hattiesburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HBR",
    "translations": [
      "Hobart Regional Airport",
      "Hobart Regional Airport",
      "Hobart Regional Airport"
    ],
    "city": [
      "Hobart",
      "Hobart",
      "Hobart"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HDE",
    "translations": [
      "Brewster Field",
      "Brewster Field",
      "Brewster Field"
    ],
    "city": [
      "Holdrege",
      "Holdrege",
      "Holdrege"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HDN",
    "translations": [
      "Yampa Valley Airport",
      "Yampa Valley Airport",
      "Yampa Valley Airport"
    ],
    "city": [
      "Hayden",
      "Hayden",
      "Hayden"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HEE",
    "translations": [
      "Thompson-Robbins Airport",
      "Thompson-Robbins Airport",
      "Thompson-Robbins Airport"
    ],
    "city": [
      "West Helena",
      "West Helena",
      "West Helena"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MNZ",
    "translations": [
      "Manassas Regional Airport/Harry P. Davis Field",
      "Manassas Regional Airport/Harry P. Davis Field",
      "Manassas Regional Airport/Harry P. Davis Field"
    ],
    "city": [
      "Manassas",
      "Manassas",
      "Manassas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HEZ",
    "translations": [
      "Natchez–Adams County Airport / Hardy-Anders Field",
      "Natchez–Adams County Airport / Hardy-Anders Field",
      "Natchez–Adams County Airport / Hardy-Anders Field"
    ],
    "city": [
      "Natchez",
      "Natchez",
      "Natchez"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HFD",
    "translations": [
      "Hartford Brainard Airport",
      "Hartford Brainard Airport",
      "Hartford Brainard Airport"
    ],
    "city": [
      "Hartford",
      "Hartford",
      "Hartford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HFF",
    "translations": [
      "Mackall Army Air Field",
      "Mackall Army Air Field",
      "Mackall Army Air Field"
    ],
    "city": [
      "Hoffman",
      "Hoffman",
      "Hoffman"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HGR",
    "translations": [
      "Hagerstown Regional Richard A Henson Field",
      "Hagerstown Regional Richard A Henson Field",
      "Hagerstown Regional Richard A Henson Field"
    ],
    "city": [
      "Hagerstown",
      "Hagerstown",
      "Hagerstown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HHR",
    "translations": [
      "Jack Northrop Field Hawthorne Municipal Airport",
      "Jack Northrop Field Hawthorne Municipal Airport",
      "Jack Northrop Field Hawthorne Municipal Airport"
    ],
    "city": [
      "Hawthorne",
      "Hawthorne",
      "Hawthorne"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HUJ",
    "translations": [
      "Stan Stamper Municipal Airport",
      "Stan Stamper Municipal Airport",
      "Stan Stamper Municipal Airport"
    ],
    "city": [
      "Hugo",
      "Hugo",
      "Hugo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HIB",
    "translations": [
      "Range Regional Airport",
      "Range Regional Airport",
      "Range Regional Airport"
    ],
    "city": [
      "Hibbing",
      "Hibbing",
      "Hibbing"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HIE",
    "translations": [
      "Mount Washington Regional Airport",
      "Mount Washington Regional Airport",
      "Mount Washington Regional Airport"
    ],
    "city": [
      "Whitefield",
      "Whitefield",
      "Whitefield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HIF",
    "translations": [
      "Hill Air Force Base",
      "Hill Air Force Base",
      "Hill Air Force Base"
    ],
    "city": [
      "Ogden",
      "Ogden",
      "Ogden"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HII",
    "translations": [
      "Lake Havasu City International Airport",
      "Lake Havasu City International Airport",
      "Lake Havasu City International Airport"
    ],
    "city": [
      "Lake Havasu City",
      "Lake Havasu City",
      "Lake Havasu City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HIO",
    "translations": [
      "Portland Hillsboro Airport",
      "Portland Hillsboro Airport",
      "Portland Hillsboro Airport"
    ],
    "city": [
      "Portland",
      "Portland",
      "Portland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HKA",
    "translations": [
      "Blytheville Municipal Airport",
      "Blytheville Municipal Airport",
      "Blytheville Municipal Airport"
    ],
    "city": [
      "Blytheville",
      "Blytheville",
      "Blytheville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HKS",
    "translations": [
      "Hawkins Field",
      "Hawkins Field",
      "Hawkins Field"
    ],
    "city": [
      "Jackson",
      "Jackson",
      "Jackson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HKY",
    "translations": [
      "Hickory Regional Airport",
      "Hickory Regional Airport",
      "Hickory Regional Airport"
    ],
    "city": [
      "Hickory",
      "Hickory",
      "Hickory"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HLB",
    "translations": [
      "Batesville Airport",
      "Batesville Airport",
      "Batesville Airport"
    ],
    "city": [
      "Batesville",
      "Batesville",
      "Batesville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HLC",
    "translations": [
      "Hill City Municipal Airport",
      "Hill City Municipal Airport",
      "Hill City Municipal Airport"
    ],
    "city": [
      "Hill City",
      "Hill City",
      "Hill City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HLG",
    "translations": [
      "Wheeling Ohio County Airport",
      "Wheeling Ohio County Airport",
      "Wheeling Ohio County Airport"
    ],
    "city": [
      "Wheeling",
      "Wheeling",
      "Wheeling"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HLN",
    "translations": [
      "Helena Regional Airport",
      "Helena Regional Airport",
      "Helena Regional Airport"
    ],
    "city": [
      "Helena",
      "Helena",
      "Helena"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HLR",
    "translations": [
      "Hood Army Air Field",
      "Hood Army Air Field",
      "Hood Army Air Field"
    ],
    "city": [
      "Fort Cavazos (Killeen)",
      "Fort Cavazos (Killeen)",
      "Fort Cavazos (Killeen)"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HMN",
    "translations": [
      "Holloman Air Force Base",
      "Holloman Air Force Base",
      "Holloman Air Force Base"
    ],
    "city": [
      "Alamogordo",
      "Alamogordo",
      "Alamogordo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HMT",
    "translations": [
      "Hemet Ryan Airport",
      "Hemet Ryan Airport",
      "Hemet Ryan Airport"
    ],
    "city": [
      "Hemet",
      "Hemet",
      "Hemet"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HNB",
    "translations": [
      "Huntingburg Airport",
      "Huntingburg Airport",
      "Huntingburg Airport"
    ],
    "city": [
      "Huntingburg",
      "Huntingburg",
      "Huntingburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HSH",
    "translations": [
      "Henderson Executive Airport",
      "Henderson Executive Airport",
      "Henderson Executive Airport"
    ],
    "city": [
      "Las Vegas",
      "Las Vegas",
      "Las Vegas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HOB",
    "translations": [
      "Lea County Regional Airport",
      "Lea County Regional Airport",
      "Lea County Regional Airport"
    ],
    "city": [
      "Hobbs",
      "Hobbs",
      "Hobbs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HON",
    "translations": [
      "Huron Regional Airport",
      "Huron Regional Airport",
      "Huron Regional Airport"
    ],
    "city": [
      "Huron",
      "Huron",
      "Huron"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HOP",
    "translations": [
      "Campbell Army Airfield (Fort Campbell)",
      "Campbell Army Airfield (Fort Campbell)",
      "Campbell Army Airfield (Fort Campbell)"
    ],
    "city": [
      "Fort Campbell",
      "Fort Campbell",
      "Fort Campbell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HOT",
    "translations": [
      "Memorial Field Airport",
      "Memorial Field Airport",
      "Memorial Field Airport"
    ],
    "city": [
      "Hot Springs",
      "Hot Springs",
      "Hot Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HOU",
    "translations": [
      "William P Hobby Airport",
      "William P Hobby Airport",
      "William P Hobby Airport"
    ],
    "city": [
      "Houston",
      "Houston",
      "Houston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HPN",
    "translations": [
      "Westchester County Airport",
      "Westchester County Airport",
      "Westchester County Airport"
    ],
    "city": [
      "White Plains",
      "White Plains",
      "White Plains"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HPT",
    "translations": [
      "Hampton Municipal Airport",
      "Hampton Municipal Airport",
      "Hampton Municipal Airport"
    ],
    "city": [
      "Hampton",
      "Hampton",
      "Hampton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HPY",
    "translations": [
      "Baytown Airport",
      "Baytown Airport",
      "Baytown Airport"
    ],
    "city": [
      "Baytown",
      "Baytown",
      "Baytown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HQM",
    "translations": [
      "Bowerman Airport",
      "Bowerman Airport",
      "Bowerman Airport"
    ],
    "city": [
      "Hoquiam",
      "Hoquiam",
      "Hoquiam"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HES",
    "translations": [
      "Hermiston Municipal Airport",
      "Hermiston Municipal Airport",
      "Hermiston Municipal Airport"
    ],
    "city": [
      "Hermiston",
      "Hermiston",
      "Hermiston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HRL",
    "translations": [
      "Valley International Airport",
      "Valley International Airport",
      "Valley International Airport"
    ],
    "city": [
      "Harlingen",
      "Harlingen",
      "Harlingen"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HRO",
    "translations": [
      "Boone County Airport",
      "Boone County Airport",
      "Boone County Airport"
    ],
    "city": [
      "Harrison",
      "Harrison",
      "Harrison"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HSB",
    "translations": [
      "Harrisburg-Raleigh Airport",
      "Harrisburg-Raleigh Airport",
      "Harrisburg-Raleigh Airport"
    ],
    "city": [
      "Harrisburg",
      "Harrisburg",
      "Harrisburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HNC",
    "translations": [
      "Billy Mitchell Airport",
      "Billy Mitchell Airport",
      "Billy Mitchell Airport"
    ],
    "city": [
      "Hatteras",
      "Hatteras",
      "Hatteras"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "THP",
    "translations": [
      "Hot Springs County Airport",
      "Hot Springs County Airport",
      "Hot Springs County Airport"
    ],
    "city": [
      "Thermopolis",
      "Thermopolis",
      "Thermopolis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HSI",
    "translations": [
      "Hastings Municipal Airport",
      "Hastings Municipal Airport",
      "Hastings Municipal Airport"
    ],
    "city": [
      "Hastings",
      "Hastings",
      "Hastings"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HSP",
    "translations": [
      "Ingalls Field",
      "Ingalls Field",
      "Ingalls Field"
    ],
    "city": [
      "Hot Springs",
      "Hot Springs",
      "Hot Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HST",
    "translations": [
      "Homestead ARB Airport",
      "Homestead ARB Airport",
      "Homestead ARB Airport"
    ],
    "city": [
      "Homestead",
      "Homestead",
      "Homestead"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HSV",
    "translations": [
      "Huntsville International Carl T Jones Field",
      "Huntsville International Carl T Jones Field",
      "Huntsville International Carl T Jones Field"
    ],
    "city": [
      "Huntsville",
      "Huntsville",
      "Huntsville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HTH",
    "translations": [
      "Hawthorne Industrial Airport",
      "Hawthorne Industrial Airport",
      "Hawthorne Industrial Airport"
    ],
    "city": [
      "Hawthorne",
      "Hawthorne",
      "Hawthorne"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HTL",
    "translations": [
      "Roscommon County - Blodgett Memorial Airport",
      "Roscommon County - Blodgett Memorial Airport",
      "Roscommon County - Blodgett Memorial Airport"
    ],
    "city": [
      "Houghton Lake",
      "Houghton Lake",
      "Houghton Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HTO",
    "translations": [
      "Town of East Hampton Airport",
      "Town of East Hampton Airport",
      "Town of East Hampton Airport"
    ],
    "city": [
      "East Hampton",
      "East Hampton",
      "East Hampton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HTS",
    "translations": [
      "Tri-State Airport / Milton J. Ferguson Field",
      "Tri-State Airport / Milton J. Ferguson Field",
      "Tri-State Airport / Milton J. Ferguson Field"
    ],
    "city": [
      "Huntington",
      "Huntington",
      "Huntington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HTW",
    "translations": [
      "Lawrence County Airpark",
      "Lawrence County Airpark",
      "Lawrence County Airpark"
    ],
    "city": [
      "South Point",
      "South Point",
      "South Point"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HUA",
    "translations": [
      "Redstone Army Air Field",
      "Redstone Army Air Field",
      "Redstone Army Air Field"
    ],
    "city": [
      "Redstone Arsnl Huntsville",
      "Redstone Arsnl Huntsville",
      "Redstone Arsnl Huntsville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HUF",
    "translations": [
      "Terre Haute Regional Airport, Hulman Field",
      "Terre Haute Regional Airport, Hulman Field",
      "Terre Haute Regional Airport, Hulman Field"
    ],
    "city": [
      "Terre Haute",
      "Terre Haute",
      "Terre Haute"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HUL",
    "translations": [
      "Houlton International Airport",
      "Houlton International Airport",
      "Houlton International Airport"
    ],
    "city": [
      "Houlton",
      "Houlton",
      "Houlton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HUM",
    "translations": [
      "Houma Terrebonne Airport",
      "Houma Terrebonne Airport",
      "Houma Terrebonne Airport"
    ],
    "city": [
      "Houma",
      "Houma",
      "Houma"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HUT",
    "translations": [
      "Hutchinson Municipal Airport",
      "Hutchinson Municipal Airport",
      "Hutchinson Municipal Airport"
    ],
    "city": [
      "Hutchinson",
      "Hutchinson",
      "Hutchinson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HVE",
    "translations": [
      "Hanksville Airport",
      "Hanksville Airport",
      "Hanksville Airport"
    ],
    "city": [
      "Hanksville",
      "Hanksville",
      "Hanksville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HVN",
    "translations": [
      "Tweed New Haven Airport",
      "Tweed New Haven Airport",
      "Tweed New Haven Airport"
    ],
    "city": [
      "New Haven",
      "New Haven",
      "New Haven"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HVR",
    "translations": [
      "Havre City County Airport",
      "Havre City County Airport",
      "Havre City County Airport"
    ],
    "city": [
      "Havre",
      "Havre",
      "Havre"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HVS",
    "translations": [
      "Hartsville Regional Airport",
      "Hartsville Regional Airport",
      "Hartsville Regional Airport"
    ],
    "city": [
      "Hartsville",
      "Hartsville",
      "Hartsville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HWD",
    "translations": [
      "Hayward Executive Airport",
      "Hayward Executive Airport",
      "Hayward Executive Airport"
    ],
    "city": [
      "Hayward",
      "Hayward",
      "Hayward"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HWO",
    "translations": [
      "North Perry Airport",
      "North Perry Airport",
      "North Perry Airport"
    ],
    "city": [
      "Hollywood",
      "Hollywood",
      "Hollywood"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WSH",
    "translations": [
      "Brookhaven Calabro Airport",
      "Brookhaven Calabro Airport",
      "Brookhaven Calabro Airport"
    ],
    "city": [
      "Shirley",
      "Shirley",
      "Shirley"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HHH",
    "translations": [
      "Hilton Head Airport",
      "Hilton Head Airport",
      "Hilton Head Airport"
    ],
    "city": [
      "Hilton Head Island",
      "Hilton Head Island",
      "Hilton Head Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HYA",
    "translations": [
      "Cape Cod Gateway Airport",
      "Cape Cod Gateway Airport",
      "Cape Cod Gateway Airport"
    ],
    "city": [
      "Hyannis",
      "Hyannis",
      "Hyannis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HYR",
    "translations": [
      "Sawyer County Airport",
      "Sawyer County Airport",
      "Sawyer County Airport"
    ],
    "city": [
      "Hayward",
      "Hayward",
      "Hayward"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HYS",
    "translations": [
      "Hays Regional Airport",
      "Hays Regional Airport",
      "Hays Regional Airport"
    ],
    "city": [
      "Hays",
      "Hays",
      "Hays"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HZL",
    "translations": [
      "Hazleton Municipal Airport",
      "Hazleton Municipal Airport",
      "Hazleton Municipal Airport"
    ],
    "city": [
      "Hazleton",
      "Hazleton",
      "Hazleton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JFN",
    "translations": [
      "Northeast Ohio Regional Airport",
      "Northeast Ohio Regional Airport",
      "Northeast Ohio Regional Airport"
    ],
    "city": [
      "Ashtabula",
      "Ashtabula",
      "Ashtabula"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IAB",
    "translations": [
      "McConnell Air Force Base",
      "McConnell Air Force Base",
      "McConnell Air Force Base"
    ],
    "city": [
      "Wichita",
      "Wichita",
      "Wichita"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IAD",
    "translations": [
      "Washington Dulles International Airport",
      "Washington Dulles International Airport",
      "Washington Dulles International Airport"
    ],
    "city": [
      "Dulles",
      "Dulles",
      "Dulles"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IAG",
    "translations": [
      "Niagara Falls International Airport",
      "Niagara Falls International Airport",
      "Niagara Falls International Airport"
    ],
    "city": [
      "Niagara Falls",
      "Niagara Falls",
      "Niagara Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IAH",
    "translations": [
      "George Bush Intercontinental Houston Airport",
      "George Bush Intercontinental Houston Airport",
      "George Bush Intercontinental Houston Airport"
    ],
    "city": [
      "Houston",
      "Houston",
      "Houston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KIB",
    "translations": [
      "Ivanof Bay Seaplane Base",
      "Ivanof Bay Seaplane Base",
      "Ivanof Bay Seaplane Base"
    ],
    "city": [
      "Ivanof Bay",
      "Ivanof Bay",
      "Ivanof Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ICL",
    "translations": [
      "Schenck Field",
      "Schenck Field",
      "Schenck Field"
    ],
    "city": [
      "Clarinda",
      "Clarinda",
      "Clarinda"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ICT",
    "translations": [
      "Wichita Eisenhower National Airport",
      "Wichita Eisenhower National Airport",
      "Wichita Eisenhower National Airport"
    ],
    "city": [
      "Wichita",
      "Wichita",
      "Wichita"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IDA",
    "translations": [
      "Idaho Falls Regional Airport",
      "Idaho Falls Regional Airport",
      "Idaho Falls Regional Airport"
    ],
    "city": [
      "Idaho Falls",
      "Idaho Falls",
      "Idaho Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IDG",
    "translations": [
      "Ida Grove Municipal Airport",
      "Ida Grove Municipal Airport",
      "Ida Grove Municipal Airport"
    ],
    "city": [
      "Ida Grove",
      "Ida Grove",
      "Ida Grove"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IDI",
    "translations": [
      "Indiana County–Jimmy Stewart Airport",
      "Indiana County–Jimmy Stewart Airport",
      "Indiana County–Jimmy Stewart Airport"
    ],
    "city": [
      "Indiana",
      "Indiana",
      "Indiana"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IDP",
    "translations": [
      "Independence Municipal Airport",
      "Independence Municipal Airport",
      "Independence Municipal Airport"
    ],
    "city": [
      "Independence",
      "Independence",
      "Independence"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "XPR",
    "translations": [
      "Pine Ridge Airport",
      "Pine Ridge Airport",
      "Pine Ridge Airport"
    ],
    "city": [
      "Pine Ridge",
      "Pine Ridge",
      "Pine Ridge"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IFA",
    "translations": [
      "Iowa Falls Municipal Airport",
      "Iowa Falls Municipal Airport",
      "Iowa Falls Municipal Airport"
    ],
    "city": [
      "Iowa Falls",
      "Iowa Falls",
      "Iowa Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IFP",
    "translations": [
      "Laughlin Bullhead International Airport",
      "Laughlin Bullhead International Airport",
      "Laughlin Bullhead International Airport"
    ],
    "city": [
      "Bullhead City",
      "Bullhead City",
      "Bullhead City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IGM",
    "translations": [
      "Kingman Airport",
      "Kingman Airport",
      "Kingman Airport"
    ],
    "city": [
      "Kingman",
      "Kingman",
      "Kingman"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IJX",
    "translations": [
      "Jacksonville Municipal Airport",
      "Jacksonville Municipal Airport",
      "Jacksonville Municipal Airport"
    ],
    "city": [
      "Jacksonville",
      "Jacksonville",
      "Jacksonville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IKK",
    "translations": [
      "Greater Kankakee Airport",
      "Greater Kankakee Airport",
      "Greater Kankakee Airport"
    ],
    "city": [
      "Kankakee",
      "Kankakee",
      "Kankakee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KIL",
    "translations": [
      "Kilwa Airport",
      "Kilwa Airport",
      "Kilwa Airport"
    ],
    "city": [
      "Kilwa",
      "Kilwa",
      "Kilwa"
    ],
    "country": [
      "CD",
      "CD",
      "CD"
    ]
  },
  {
    "iata": "ILE",
    "translations": [
      "Skylark Field",
      "Skylark Field",
      "Skylark Field"
    ],
    "city": [
      "Killeen",
      "Killeen",
      "Killeen"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ILG",
    "translations": [
      "Wilmington Airport",
      "Wilmington Airport",
      "Wilmington Airport"
    ],
    "city": [
      "Wilmington",
      "Wilmington",
      "Wilmington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ILM",
    "translations": [
      "Wilmington International Airport",
      "Wilmington International Airport",
      "Wilmington International Airport"
    ],
    "city": [
      "Wilmington",
      "Wilmington",
      "Wilmington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ILN",
    "translations": [
      "Wilmington Airpark",
      "Wilmington Airpark",
      "Wilmington Airpark"
    ],
    "city": [
      "Wilmington",
      "Wilmington",
      "Wilmington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IML",
    "translations": [
      "Imperial Municipal Airport",
      "Imperial Municipal Airport",
      "Imperial Municipal Airport"
    ],
    "city": [
      "Imperial",
      "Imperial",
      "Imperial"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IMM",
    "translations": [
      "Immokalee Regional Airport",
      "Immokalee Regional Airport",
      "Immokalee Regional Airport"
    ],
    "city": [
      "Immokalee",
      "Immokalee",
      "Immokalee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MDN",
    "translations": [
      "Madison Municipal Airport",
      "Madison Municipal Airport",
      "Madison Municipal Airport"
    ],
    "city": [
      "Madison",
      "Madison",
      "Madison"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IMT",
    "translations": [
      "Ford Airport",
      "Ford Airport",
      "Ford Airport"
    ],
    "city": [
      "Kingsford",
      "Kingsford",
      "Kingsford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IND",
    "translations": [
      "Indianapolis International Airport",
      "Indianapolis International Airport",
      "Indianapolis International Airport"
    ],
    "city": [
      "Indianapolis",
      "Indianapolis",
      "Indianapolis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "INK",
    "translations": [
      "Winkler County Airport",
      "Winkler County Airport",
      "Winkler County Airport"
    ],
    "city": [
      "Wink",
      "Wink",
      "Wink"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "INL",
    "translations": [
      "Falls International Airport",
      "Falls International Airport",
      "Falls International Airport"
    ],
    "city": [
      "International Falls",
      "International Falls",
      "International Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "INS",
    "translations": [
      "Creech Air Force Base",
      "Creech Air Force Base",
      "Creech Air Force Base"
    ],
    "city": [
      "Indian Springs",
      "Indian Springs",
      "Indian Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "INT",
    "translations": [
      "Smith Reynolds Airport",
      "Smith Reynolds Airport",
      "Smith Reynolds Airport"
    ],
    "city": [
      "Winston Salem",
      "Winston Salem",
      "Winston Salem"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "INW",
    "translations": [
      "Winslow Lindbergh Regional Airport",
      "Winslow Lindbergh Regional Airport",
      "Winslow Lindbergh Regional Airport"
    ],
    "city": [
      "Winslow",
      "Winslow",
      "Winslow"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IOW",
    "translations": [
      "Iowa City Municipal Airport",
      "Iowa City Municipal Airport",
      "Iowa City Municipal Airport"
    ],
    "city": [
      "Iowa City",
      "Iowa City",
      "Iowa City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IPL",
    "translations": [
      "Imperial County Airport",
      "Imperial County Airport",
      "Imperial County Airport"
    ],
    "city": [
      "Imperial",
      "Imperial",
      "Imperial"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IPT",
    "translations": [
      "Williamsport Regional Airport",
      "Williamsport Regional Airport",
      "Williamsport Regional Airport"
    ],
    "city": [
      "Williamsport",
      "Williamsport",
      "Williamsport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IRK",
    "translations": [
      "Kirksville Regional Airport",
      "Kirksville Regional Airport",
      "Kirksville Regional Airport"
    ],
    "city": [
      "Kirksville",
      "Kirksville",
      "Kirksville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IRS",
    "translations": [
      "Kirsch Municipal Airport",
      "Kirsch Municipal Airport",
      "Kirsch Municipal Airport"
    ],
    "city": [
      "Sturgis",
      "Sturgis",
      "Sturgis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ISM",
    "translations": [
      "Kissimmee Gateway Airport",
      "Kissimmee Gateway Airport",
      "Kissimmee Gateway Airport"
    ],
    "city": [
      "Orlando",
      "Orlando",
      "Orlando"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ISO",
    "translations": [
      "Kinston Regional Jetport At Stallings Field",
      "Kinston Regional Jetport At Stallings Field",
      "Kinston Regional Jetport At Stallings Field"
    ],
    "city": [
      "Kinston",
      "Kinston",
      "Kinston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ISP",
    "translations": [
      "Long Island Mac Arthur Airport",
      "Long Island Mac Arthur Airport",
      "Long Island Mac Arthur Airport"
    ],
    "city": [
      "Islip",
      "Islip",
      "Islip"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ISQ",
    "translations": [
      "Schoolcraft County Airport",
      "Schoolcraft County Airport",
      "Schoolcraft County Airport"
    ],
    "city": [
      "Manistique",
      "Manistique",
      "Manistique"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ISW",
    "translations": [
      "Alexander Field South Wood County Airport",
      "Alexander Field South Wood County Airport",
      "Alexander Field South Wood County Airport"
    ],
    "city": [
      "Wisconsin Rapids",
      "Wisconsin Rapids",
      "Wisconsin Rapids"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ITH",
    "translations": [
      "Ithaca Tompkins Regional Airport",
      "Ithaca Tompkins Regional Airport",
      "Ithaca Tompkins Regional Airport"
    ],
    "city": [
      "Ithaca",
      "Ithaca",
      "Ithaca"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AZA",
    "translations": [
      "Mesa Gateway Airport",
      "Mesa Gateway Airport",
      "Mesa Gateway Airport"
    ],
    "city": [
      "Mesa",
      "Mesa",
      "Mesa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IWD",
    "translations": [
      "Gogebic Iron County Airport",
      "Gogebic Iron County Airport",
      "Gogebic Iron County Airport"
    ],
    "city": [
      "Ironwood",
      "Ironwood",
      "Ironwood"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ISS",
    "translations": [
      "Wiscasset Airport",
      "Wiscasset Airport",
      "Wiscasset Airport"
    ],
    "city": [
      "Wiscasset",
      "Wiscasset",
      "Wiscasset"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IWS",
    "translations": [
      "West Houston Airport",
      "West Houston Airport",
      "West Houston Airport"
    ],
    "city": [
      "Houston",
      "Houston",
      "Houston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JCI",
    "translations": [
      "New Century AirCenter Airport",
      "New Century AirCenter Airport",
      "New Century AirCenter Airport"
    ],
    "city": [
      "New Century",
      "New Century",
      "New Century"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IYK",
    "translations": [
      "Inyokern Airport",
      "Inyokern Airport",
      "Inyokern Airport"
    ],
    "city": [
      "Inyokern",
      "Inyokern",
      "Inyokern"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SQA",
    "translations": [
      "Santa Ynez Airport",
      "Santa Ynez Airport",
      "Santa Ynez Airport"
    ],
    "city": [
      "Santa Ynez",
      "Santa Ynez",
      "Santa Ynez"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FRY",
    "translations": [
      "Eastern Slopes Regional Airport",
      "Eastern Slopes Regional Airport",
      "Eastern Slopes Regional Airport"
    ],
    "city": [
      "Fryeburg",
      "Fryeburg",
      "Fryeburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JAC",
    "translations": [
      "Jackson Hole Airport",
      "Jackson Hole Airport",
      "Jackson Hole Airport"
    ],
    "city": [
      "Jackson",
      "Jackson",
      "Jackson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JAN",
    "translations": [
      "Jackson-Medgar Wiley Evers International Airport",
      "Jackson-Medgar Wiley Evers International Airport",
      "Jackson-Medgar Wiley Evers International Airport"
    ],
    "city": [
      "Jackson",
      "Jackson",
      "Jackson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JAS",
    "translations": [
      "Jasper County Airport Bell Field",
      "Jasper County Airport Bell Field",
      "Jasper County Airport Bell Field"
    ],
    "city": [
      "Jasper",
      "Jasper",
      "Jasper"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JAX",
    "translations": [
      "Jacksonville International Airport",
      "Jacksonville International Airport",
      "Jacksonville International Airport"
    ],
    "city": [
      "Jacksonville",
      "Jacksonville",
      "Jacksonville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JBR",
    "translations": [
      "Jonesboro Municipal Airport",
      "Jonesboro Municipal Airport",
      "Jonesboro Municipal Airport"
    ],
    "city": [
      "Jonesboro",
      "Jonesboro",
      "Jonesboro"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JCT",
    "translations": [
      "Kimble County Airport",
      "Kimble County Airport",
      "Kimble County Airport"
    ],
    "city": [
      "Junction",
      "Junction",
      "Junction"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JDN",
    "translations": [
      "Jordan Airport",
      "Jordan Airport",
      "Jordan Airport"
    ],
    "city": [
      "Jordan",
      "Jordan",
      "Jordan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JEF",
    "translations": [
      "Jefferson City Memorial Airport",
      "Jefferson City Memorial Airport",
      "Jefferson City Memorial Airport"
    ],
    "city": [
      "Jefferson City",
      "Jefferson City",
      "Jefferson City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JFK",
    "translations": [
      "John F Kennedy International Airport",
      "John F Kennedy International Airport",
      "John F Kennedy International Airport"
    ],
    "city": [
      "New York",
      "New York",
      "New York"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JHW",
    "translations": [
      "Chautauqua County-Jamestown Airport",
      "Chautauqua County-Jamestown Airport",
      "Chautauqua County-Jamestown Airport"
    ],
    "city": [
      "Jamestown",
      "Jamestown",
      "Jamestown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GUF",
    "translations": [
      "Jack Edwards National Airport",
      "Jack Edwards National Airport",
      "Jack Edwards National Airport"
    ],
    "city": [
      "Gulf Shores",
      "Gulf Shores",
      "Gulf Shores"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JLN",
    "translations": [
      "Joplin Regional Airport",
      "Joplin Regional Airport",
      "Joplin Regional Airport"
    ],
    "city": [
      "Joplin",
      "Joplin",
      "Joplin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JMS",
    "translations": [
      "Jamestown Regional Airport",
      "Jamestown Regional Airport",
      "Jamestown Regional Airport"
    ],
    "city": [
      "Jamestown",
      "Jamestown",
      "Jamestown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JOT",
    "translations": [
      "Joliet Regional Airport",
      "Joliet Regional Airport",
      "Joliet Regional Airport"
    ],
    "city": [
      "Joliet",
      "Joliet",
      "Joliet"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "USA",
    "translations": [
      "Concord-Padgett Regional Airport",
      "Concord-Padgett Regional Airport",
      "Concord-Padgett Regional Airport"
    ],
    "city": [
      "Concord",
      "Concord",
      "Concord"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JKV",
    "translations": [
      "Cherokee County Airport",
      "Cherokee County Airport",
      "Cherokee County Airport"
    ],
    "city": [
      "Jacksonville",
      "Jacksonville",
      "Jacksonville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JST",
    "translations": [
      "John Murtha Johnstown Cambria County Airport",
      "John Murtha Johnstown Cambria County Airport",
      "John Murtha Johnstown Cambria County Airport"
    ],
    "city": [
      "Johnstown",
      "Johnstown",
      "Johnstown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JVL",
    "translations": [
      "Southern Wisconsin Regional Airport",
      "Southern Wisconsin Regional Airport",
      "Southern Wisconsin Regional Airport"
    ],
    "city": [
      "Janesville",
      "Janesville",
      "Janesville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KJX",
    "translations": [
      "Kuala Batu Airport",
      "Kuala Batu Airport",
      "Kuala Batu Airport"
    ],
    "city": [
      "Blangpidie",
      "Blangpidie",
      "Blangpidie"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "JXN",
    "translations": [
      "Jackson County Airport/Reynolds Field",
      "Jackson County Airport/Reynolds Field",
      "Jackson County Airport/Reynolds Field"
    ],
    "city": [
      "Jackson",
      "Jackson",
      "Jackson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OSB",
    "translations": [
      "Grand Glaize Osage Beach Airport",
      "Grand Glaize Osage Beach Airport",
      "Grand Glaize Osage Beach Airport"
    ],
    "city": [
      "Osage Beach",
      "Osage Beach",
      "Osage Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KKB",
    "translations": [
      "Kitoi Bay Seaplane Base",
      "Kitoi Bay Seaplane Base",
      "Kitoi Bay Seaplane Base"
    ],
    "city": [
      "Kitoi Bay",
      "Kitoi Bay",
      "Kitoi Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KIC",
    "translations": [
      "Mesa Del Rey Airport",
      "Mesa Del Rey Airport",
      "Mesa Del Rey Airport"
    ],
    "city": [
      "King City",
      "King City",
      "King City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KKL",
    "translations": [
      "Karluk Lake Seaplane Base",
      "Karluk Lake Seaplane Base",
      "Karluk Lake Seaplane Base"
    ],
    "city": [
      "Karluk Lake",
      "Karluk Lake",
      "Karluk Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KLS",
    "translations": [
      "Southwest Washington Regional Airport",
      "Southwest Washington Regional Airport",
      "Southwest Washington Regional Airport"
    ],
    "city": [
      "Kelso",
      "Kelso",
      "Kelso"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KNB",
    "translations": [
      "Kanab Municipal Airport",
      "Kanab Municipal Airport",
      "Kanab Municipal Airport"
    ],
    "city": [
      "Kanab",
      "Kanab",
      "Kanab"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KKU",
    "translations": [
      "Ekuk Airport",
      "Ekuk Airport",
      "Ekuk Airport"
    ],
    "city": [
      "Ekuk",
      "Ekuk",
      "Ekuk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DTH",
    "translations": [
      "Furnace Creek Airport",
      "Furnace Creek Airport",
      "Furnace Creek Airport"
    ],
    "city": [
      "Death Valley",
      "Death Valley",
      "Death Valley"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BXS",
    "translations": [
      "Borrego Valley Airport",
      "Borrego Valley Airport",
      "Borrego Valley Airport"
    ],
    "city": [
      "Borrego Springs",
      "Borrego Springs",
      "Borrego Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RBF",
    "translations": [
      "Big Bear City Airport",
      "Big Bear City Airport",
      "Big Bear City Airport"
    ],
    "city": [
      "Big Bear",
      "Big Bear",
      "Big Bear"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MYH",
    "translations": [
      "Marble Canyon Airport",
      "Marble Canyon Airport",
      "Marble Canyon Airport"
    ],
    "city": [
      "Marble Canyon",
      "Marble Canyon",
      "Marble Canyon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TRH",
    "translations": [
      "Trona Airport",
      "Trona Airport",
      "Trona Airport"
    ],
    "city": [
      "Trona",
      "Trona",
      "Trona"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LAA",
    "translations": [
      "Southeast Colorado Regional Airport",
      "Southeast Colorado Regional Airport",
      "Southeast Colorado Regional Airport"
    ],
    "city": [
      "Lamar",
      "Lamar",
      "Lamar"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LAF",
    "translations": [
      "Purdue University Airport",
      "Purdue University Airport",
      "Purdue University Airport"
    ],
    "city": [
      "West Lafayette",
      "West Lafayette",
      "West Lafayette"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LAL",
    "translations": [
      "Lakeland Linder International Airport",
      "Lakeland Linder International Airport",
      "Lakeland Linder International Airport"
    ],
    "city": [
      "Lakeland",
      "Lakeland",
      "Lakeland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LAM",
    "translations": [
      "Los Alamos Airport",
      "Los Alamos Airport",
      "Los Alamos Airport"
    ],
    "city": [
      "Los Alamos",
      "Los Alamos",
      "Los Alamos"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LAN",
    "translations": [
      "Capital City Airport",
      "Capital City Airport",
      "Capital City Airport"
    ],
    "city": [
      "Lansing",
      "Lansing",
      "Lansing"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LAR",
    "translations": [
      "Laramie Regional Airport",
      "Laramie Regional Airport",
      "Laramie Regional Airport"
    ],
    "city": [
      "Laramie",
      "Laramie",
      "Laramie"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LAS",
    "translations": [
      "Harry Reid International Airport",
      "Harry Reid International Airport",
      "Harry Reid International Airport"
    ],
    "city": [
      "Las Vegas",
      "Las Vegas",
      "Las Vegas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LAW",
    "translations": [
      "Lawton Fort Sill Regional Airport",
      "Lawton Fort Sill Regional Airport",
      "Lawton Fort Sill Regional Airport"
    ],
    "city": [
      "Lawton",
      "Lawton",
      "Lawton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LAX",
    "translations": [
      "Los Angeles International Airport",
      "Los Angeles International Airport",
      "Los Angeles International Airport"
    ],
    "city": [
      "Los Angeles",
      "Los Angeles",
      "Los Angeles"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LBB",
    "translations": [
      "Lubbock Preston Smith International Airport",
      "Lubbock Preston Smith International Airport",
      "Lubbock Preston Smith International Airport"
    ],
    "city": [
      "Lubbock",
      "Lubbock",
      "Lubbock"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LBE",
    "translations": [
      "Arnold Palmer Regional Airport",
      "Arnold Palmer Regional Airport",
      "Arnold Palmer Regional Airport"
    ],
    "city": [
      "Latrobe",
      "Latrobe",
      "Latrobe"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LBF",
    "translations": [
      "North Platte Regional Airport Lee Bird Field",
      "North Platte Regional Airport Lee Bird Field",
      "North Platte Regional Airport Lee Bird Field"
    ],
    "city": [
      "North Platte",
      "North Platte",
      "North Platte"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LBL",
    "translations": [
      "Liberal Mid-America Regional Airport",
      "Liberal Mid-America Regional Airport",
      "Liberal Mid-America Regional Airport"
    ],
    "city": [
      "Liberal",
      "Liberal",
      "Liberal"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LBT",
    "translations": [
      "Lumberton Regional Airport",
      "Lumberton Regional Airport",
      "Lumberton Regional Airport"
    ],
    "city": [
      "Lumberton",
      "Lumberton",
      "Lumberton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LJN",
    "translations": [
      "Texas Gulf Coast Regional Airport",
      "Texas Gulf Coast Regional Airport",
      "Texas Gulf Coast Regional Airport"
    ],
    "city": [
      "Angleton",
      "Angleton",
      "Angleton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LCH",
    "translations": [
      "Lake Charles Regional Airport",
      "Lake Charles Regional Airport",
      "Lake Charles Regional Airport"
    ],
    "city": [
      "Lake Charles",
      "Lake Charles",
      "Lake Charles"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LCI",
    "translations": [
      "Laconia Municipal Airport",
      "Laconia Municipal Airport",
      "Laconia Municipal Airport"
    ],
    "city": [
      "Laconia / Gilford",
      "Laconia / Gilford",
      "Laconia / Gilford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LCK",
    "translations": [
      "Rickenbacker International Airport",
      "Rickenbacker International Airport",
      "Rickenbacker International Airport"
    ],
    "city": [
      "Columbus",
      "Columbus",
      "Columbus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LCQ",
    "translations": [
      "Lake City Gateway Airport",
      "Lake City Gateway Airport",
      "Lake City Gateway Airport"
    ],
    "city": [
      "Lake City",
      "Lake City",
      "Lake City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LDJ",
    "translations": [
      "Linden Airport",
      "Linden Airport",
      "Linden Airport"
    ],
    "city": [
      "Linden",
      "Linden",
      "Linden"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LDM",
    "translations": [
      "Mason County Airport",
      "Mason County Airport",
      "Mason County Airport"
    ],
    "city": [
      "Ludington",
      "Ludington",
      "Ludington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LEB",
    "translations": [
      "Lebanon Municipal Airport",
      "Lebanon Municipal Airport",
      "Lebanon Municipal Airport"
    ],
    "city": [
      "Lebanon",
      "Lebanon",
      "Lebanon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LEE",
    "translations": [
      "Leesburg International Airport",
      "Leesburg International Airport",
      "Leesburg International Airport"
    ],
    "city": [
      "Leesburg",
      "Leesburg",
      "Leesburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LEM",
    "translations": [
      "Lemmon Municipal Airport",
      "Lemmon Municipal Airport",
      "Lemmon Municipal Airport"
    ],
    "city": [
      "Lemmon",
      "Lemmon",
      "Lemmon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LEW",
    "translations": [
      "Auburn Lewiston Municipal Airport",
      "Auburn Lewiston Municipal Airport",
      "Auburn Lewiston Municipal Airport"
    ],
    "city": [
      "Auburn/Lewiston",
      "Auburn/Lewiston",
      "Auburn/Lewiston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LEX",
    "translations": [
      "Blue Grass Airport",
      "Blue Grass Airport",
      "Blue Grass Airport"
    ],
    "city": [
      "Lexington",
      "Lexington",
      "Lexington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LFI",
    "translations": [
      "Langley Air Force Base",
      "Langley Air Force Base",
      "Langley Air Force Base"
    ],
    "city": [
      "Hampton",
      "Hampton",
      "Hampton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LFK",
    "translations": [
      "Angelina County Airport",
      "Angelina County Airport",
      "Angelina County Airport"
    ],
    "city": [
      "Lufkin",
      "Lufkin",
      "Lufkin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LFT",
    "translations": [
      "Lafayette Regional Airport",
      "Lafayette Regional Airport",
      "Lafayette Regional Airport"
    ],
    "city": [
      "Lafayette",
      "Lafayette",
      "Lafayette"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LGA",
    "translations": [
      "LaGuardia Airport",
      "LaGuardia Airport",
      "LaGuardia Airport"
    ],
    "city": [
      "New York",
      "New York",
      "New York"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LGB",
    "translations": [
      "Long Beach Airport (Daugherty Field)",
      "Long Beach Airport (Daugherty Field)",
      "Long Beach Airport (Daugherty Field)"
    ],
    "city": [
      "Long Beach",
      "Long Beach",
      "Long Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LGC",
    "translations": [
      "LaGrange Callaway Airport",
      "LaGrange Callaway Airport",
      "LaGrange Callaway Airport"
    ],
    "city": [
      "LaGrange",
      "LaGrange",
      "LaGrange"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LGD",
    "translations": [
      "La Grande/Union County Airport",
      "La Grande/Union County Airport",
      "La Grande/Union County Airport"
    ],
    "city": [
      "La Grande",
      "La Grande",
      "La Grande"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LGF",
    "translations": [
      "Laguna Army Airfield",
      "Laguna Army Airfield",
      "Laguna Army Airfield"
    ],
    "city": [
      "Yuma Proving Ground(Yuma)",
      "Yuma Proving Ground(Yuma)",
      "Yuma Proving Ground(Yuma)"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LGU",
    "translations": [
      "Logan-Cache Airport",
      "Logan-Cache Airport",
      "Logan-Cache Airport"
    ],
    "city": [
      "Logan",
      "Logan",
      "Logan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LHV",
    "translations": [
      "William T. Piper Memorial Airport",
      "William T. Piper Memorial Airport",
      "William T. Piper Memorial Airport"
    ],
    "city": [
      "Lock Haven",
      "Lock Haven",
      "Lock Haven"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LIY",
    "translations": [
      "MidCoast Regional Airport at Wright Army Airfield",
      "MidCoast Regional Airport at Wright Army Airfield",
      "MidCoast Regional Airport at Wright Army Airfield"
    ],
    "city": [
      "Hinesville",
      "Hinesville",
      "Hinesville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LFN",
    "translations": [
      "Triangle North Executive Airport",
      "Triangle North Executive Airport",
      "Triangle North Executive Airport"
    ],
    "city": [
      "Louisburg",
      "Louisburg",
      "Louisburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LIC",
    "translations": [
      "Limon Municipal Airport",
      "Limon Municipal Airport",
      "Limon Municipal Airport"
    ],
    "city": [
      "Limon",
      "Limon",
      "Limon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LIT",
    "translations": [
      "Bill & Hillary Clinton National Airport/Adams Field",
      "Bill & Hillary Clinton National Airport/Adams Field",
      "Bill & Hillary Clinton National Airport/Adams Field"
    ],
    "city": [
      "Little Rock",
      "Little Rock",
      "Little Rock"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LKP",
    "translations": [
      "Lake Placid Airport",
      "Lake Placid Airport",
      "Lake Placid Airport"
    ],
    "city": [
      "Lake Placid",
      "Lake Placid",
      "Lake Placid"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LOW",
    "translations": [
      "Louisa County Airport / Freeman Field",
      "Louisa County Airport / Freeman Field",
      "Louisa County Airport / Freeman Field"
    ],
    "city": [
      "Louisa",
      "Louisa",
      "Louisa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LKV",
    "translations": [
      "Lake County Airport",
      "Lake County Airport",
      "Lake County Airport"
    ],
    "city": [
      "Lakeview",
      "Lakeview",
      "Lakeview"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CHL",
    "translations": [
      "Challis Airport",
      "Challis Airport",
      "Challis Airport"
    ],
    "city": [
      "Challis",
      "Challis",
      "Challis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LMS",
    "translations": [
      "Louisville Winston County Airport",
      "Louisville Winston County Airport",
      "Louisville Winston County Airport"
    ],
    "city": [
      "Louisville",
      "Louisville",
      "Louisville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LMT",
    "translations": [
      "Crater Lake-Klamath Regional Airport",
      "Crater Lake-Klamath Regional Airport",
      "Crater Lake-Klamath Regional Airport"
    ],
    "city": [
      "Klamath Falls",
      "Klamath Falls",
      "Klamath Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LNA",
    "translations": [
      "Palm Beach County Park Airport",
      "Palm Beach County Park Airport",
      "Palm Beach County Park Airport"
    ],
    "city": [
      "West Palm Beach",
      "West Palm Beach",
      "West Palm Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LND",
    "translations": [
      "Hunt Field",
      "Hunt Field",
      "Hunt Field"
    ],
    "city": [
      "Lander",
      "Lander",
      "Lander"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LNK",
    "translations": [
      "Lincoln Airport",
      "Lincoln Airport",
      "Lincoln Airport"
    ],
    "city": [
      "Lincoln",
      "Lincoln",
      "Lincoln"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LNN",
    "translations": [
      "Lake County Executive Airport",
      "Lake County Executive Airport",
      "Lake County Executive Airport"
    ],
    "city": [
      "Willoughby",
      "Willoughby",
      "Willoughby"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LNP",
    "translations": [
      "Lonesome Pine Airport",
      "Lonesome Pine Airport",
      "Lonesome Pine Airport"
    ],
    "city": [
      "Wise",
      "Wise",
      "Wise"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LNR",
    "translations": [
      "Tri-County Regional Airport",
      "Tri-County Regional Airport",
      "Tri-County Regional Airport"
    ],
    "city": [
      "Spring Green",
      "Spring Green",
      "Spring Green"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LNS",
    "translations": [
      "Lancaster Airport",
      "Lancaster Airport",
      "Lancaster Airport"
    ],
    "city": [
      "Lancaster",
      "Lancaster",
      "Lancaster"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LOL",
    "translations": [
      "Derby Field",
      "Derby Field",
      "Derby Field"
    ],
    "city": [
      "Lovelock",
      "Lovelock",
      "Lovelock"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BBX",
    "translations": [
      "Wings Field",
      "Wings Field",
      "Wings Field"
    ],
    "city": [
      "Philadelphia",
      "Philadelphia",
      "Philadelphia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LOT",
    "translations": [
      "Lewis University Airport",
      "Lewis University Airport",
      "Lewis University Airport"
    ],
    "city": [
      "Chicago/Romeoville",
      "Chicago/Romeoville",
      "Chicago/Romeoville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LOU",
    "translations": [
      "Bowman Field",
      "Bowman Field",
      "Bowman Field"
    ],
    "city": [
      "Louisville",
      "Louisville",
      "Louisville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LOZ",
    "translations": [
      "London-Corbin Airport/Magee Field",
      "London-Corbin Airport/Magee Field",
      "London-Corbin Airport/Magee Field"
    ],
    "city": [
      "London",
      "London",
      "London"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LPC",
    "translations": [
      "Lompoc Airport",
      "Lompoc Airport",
      "Lompoc Airport"
    ],
    "city": [
      "Lompoc",
      "Lompoc",
      "Lompoc"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LQK",
    "translations": [
      "Pickens County Airport",
      "Pickens County Airport",
      "Pickens County Airport"
    ],
    "city": [
      "Pickens",
      "Pickens",
      "Pickens"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LRD",
    "translations": [
      "Laredo International Airport",
      "Laredo International Airport",
      "Laredo International Airport"
    ],
    "city": [
      "Laredo",
      "Laredo",
      "Laredo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LRF",
    "translations": [
      "Little Rock Air Force Base",
      "Little Rock Air Force Base",
      "Little Rock Air Force Base"
    ],
    "city": [
      "Jacksonville",
      "Jacksonville",
      "Jacksonville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LRJ",
    "translations": [
      "Le Mars Municipal Airport",
      "Le Mars Municipal Airport",
      "Le Mars Municipal Airport"
    ],
    "city": [
      "Le Mars",
      "Le Mars",
      "Le Mars"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LRU",
    "translations": [
      "Las Cruces International Airport",
      "Las Cruces International Airport",
      "Las Cruces International Airport"
    ],
    "city": [
      "Las Cruces",
      "Las Cruces",
      "Las Cruces"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LSB",
    "translations": [
      "Lordsburg Municipal Airport",
      "Lordsburg Municipal Airport",
      "Lordsburg Municipal Airport"
    ],
    "city": [
      "Lordsburg",
      "Lordsburg",
      "Lordsburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LSE",
    "translations": [
      "La Crosse Regional Airport",
      "La Crosse Regional Airport",
      "La Crosse Regional Airport"
    ],
    "city": [
      "La Crosse",
      "La Crosse",
      "La Crosse"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LSF",
    "translations": [
      "Lawson Army Air Field",
      "Lawson Army Air Field",
      "Lawson Army Air Field"
    ],
    "city": [
      "Fort Benning",
      "Fort Benning",
      "Fort Benning"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LSK",
    "translations": [
      "Lusk Municipal Airport",
      "Lusk Municipal Airport",
      "Lusk Municipal Airport"
    ],
    "city": [
      "Lusk",
      "Lusk",
      "Lusk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LSN",
    "translations": [
      "Los Banos Municipal Airport",
      "Los Banos Municipal Airport",
      "Los Banos Municipal Airport"
    ],
    "city": [
      "Los Banos",
      "Los Banos",
      "Los Banos"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LSV",
    "translations": [
      "Nellis Air Force Base",
      "Nellis Air Force Base",
      "Nellis Air Force Base"
    ],
    "city": [
      "Las Vegas",
      "Las Vegas",
      "Las Vegas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LTS",
    "translations": [
      "Altus Air Force Base",
      "Altus Air Force Base",
      "Altus Air Force Base"
    ],
    "city": [
      "Altus",
      "Altus",
      "Altus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LUF",
    "translations": [
      "Luke Air Force Base",
      "Luke Air Force Base",
      "Luke Air Force Base"
    ],
    "city": [
      "Glendale",
      "Glendale",
      "Glendale"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LUK",
    "translations": [
      "Cincinnati Municipal Airport Lunken Field",
      "Cincinnati Municipal Airport Lunken Field",
      "Cincinnati Municipal Airport Lunken Field"
    ],
    "city": [
      "Cincinnati",
      "Cincinnati",
      "Cincinnati"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LUL",
    "translations": [
      "Hesler Noble Field",
      "Hesler Noble Field",
      "Hesler Noble Field"
    ],
    "city": [
      "Laurel",
      "Laurel",
      "Laurel"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LVK",
    "translations": [
      "Livermore Municipal Airport",
      "Livermore Municipal Airport",
      "Livermore Municipal Airport"
    ],
    "city": [
      "Livermore",
      "Livermore",
      "Livermore"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LVL",
    "translations": [
      "Brunswick Municipal Airport",
      "Brunswick Municipal Airport",
      "Brunswick Municipal Airport"
    ],
    "city": [
      "Lawrenceville",
      "Lawrenceville",
      "Lawrenceville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LVM",
    "translations": [
      "Mission Field",
      "Mission Field",
      "Mission Field"
    ],
    "city": [
      "Livingston",
      "Livingston",
      "Livingston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LVS",
    "translations": [
      "Las Vegas Municipal Airport",
      "Las Vegas Municipal Airport",
      "Las Vegas Municipal Airport"
    ],
    "city": [
      "Las Vegas",
      "Las Vegas",
      "Las Vegas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LWB",
    "translations": [
      "Greenbrier Valley Airport",
      "Greenbrier Valley Airport",
      "Greenbrier Valley Airport"
    ],
    "city": [
      "Lewisburg",
      "Lewisburg",
      "Lewisburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LWC",
    "translations": [
      "Lawrence Municipal Airport",
      "Lawrence Municipal Airport",
      "Lawrence Municipal Airport"
    ],
    "city": [
      "Lawrence",
      "Lawrence",
      "Lawrence"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LWL",
    "translations": [
      "Wells Municipal Airport/Harriet Field",
      "Wells Municipal Airport/Harriet Field",
      "Wells Municipal Airport/Harriet Field"
    ],
    "city": [
      "Wells",
      "Wells",
      "Wells"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LWM",
    "translations": [
      "Lawrence Municipal Airport",
      "Lawrence Municipal Airport",
      "Lawrence Municipal Airport"
    ],
    "city": [
      "Lawrence",
      "Lawrence",
      "Lawrence"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LWS",
    "translations": [
      "Lewiston Nez Perce County Airport",
      "Lewiston Nez Perce County Airport",
      "Lewiston Nez Perce County Airport"
    ],
    "city": [
      "Lewiston",
      "Lewiston",
      "Lewiston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LWT",
    "translations": [
      "Lewistown Municipal Airport",
      "Lewistown Municipal Airport",
      "Lewistown Municipal Airport"
    ],
    "city": [
      "Lewistown",
      "Lewistown",
      "Lewistown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LWV",
    "translations": [
      "Lawrenceville Vincennes International Airport",
      "Lawrenceville Vincennes International Airport",
      "Lawrenceville Vincennes International Airport"
    ],
    "city": [
      "Lawrenceville",
      "Lawrenceville",
      "Lawrenceville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LXN",
    "translations": [
      "Jim Kelly Field",
      "Jim Kelly Field",
      "Jim Kelly Field"
    ],
    "city": [
      "Lexington",
      "Lexington",
      "Lexington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LXV",
    "translations": [
      "Lake County Airport",
      "Lake County Airport",
      "Lake County Airport"
    ],
    "city": [
      "Leadville",
      "Leadville",
      "Leadville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LYH",
    "translations": [
      "Lynchburg Regional Airport - Preston Glenn Field",
      "Lynchburg Regional Airport - Preston Glenn Field",
      "Lynchburg Regional Airport - Preston Glenn Field"
    ],
    "city": [
      "Lynchburg",
      "Lynchburg",
      "Lynchburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LYO",
    "translations": [
      "Lyons-Rice County Municipal Airport",
      "Lyons-Rice County Municipal Airport",
      "Lyons-Rice County Municipal Airport"
    ],
    "city": [
      "Lyons",
      "Lyons",
      "Lyons"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LZU",
    "translations": [
      "Gwinnett County Briscoe Field",
      "Gwinnett County Briscoe Field",
      "Gwinnett County Briscoe Field"
    ],
    "city": [
      "Lawrenceville",
      "Lawrenceville",
      "Lawrenceville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PCU",
    "translations": [
      "Poplarville Pearl River County Airport",
      "Poplarville Pearl River County Airport",
      "Poplarville Pearl River County Airport"
    ],
    "city": [
      "Poplarville",
      "Poplarville",
      "Poplarville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MLK",
    "translations": [
      "Malta Airport",
      "Malta Airport",
      "Malta Airport"
    ],
    "city": [
      "Malta",
      "Malta",
      "Malta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MAC",
    "translations": [
      "Macon Downtown Airport",
      "Macon Downtown Airport",
      "Macon Downtown Airport"
    ],
    "city": [
      "Macon",
      "Macon",
      "Macon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MAE",
    "translations": [
      "Madera Municipal Airport",
      "Madera Municipal Airport",
      "Madera Municipal Airport"
    ],
    "city": [
      "Madera",
      "Madera",
      "Madera"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MAF",
    "translations": [
      "Midland International Air and Space Port",
      "Midland International Air and Space Port",
      "Midland International Air and Space Port"
    ],
    "city": [
      "Midland",
      "Midland",
      "Midland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MAW",
    "translations": [
      "Malden Regional Airport",
      "Malden Regional Airport",
      "Malden Regional Airport"
    ],
    "city": [
      "Malden",
      "Malden",
      "Malden"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KMB",
    "translations": [
      "Koinambe Airport",
      "Koinambe Airport",
      "Koinambe Airport"
    ],
    "city": [
      "Konambe",
      "Konambe",
      "Konambe"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MBG",
    "translations": [
      "Mobridge Municipal Airport",
      "Mobridge Municipal Airport",
      "Mobridge Municipal Airport"
    ],
    "city": [
      "Mobridge",
      "Mobridge",
      "Mobridge"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MBL",
    "translations": [
      "Manistee County Blacker Airport",
      "Manistee County Blacker Airport",
      "Manistee County Blacker Airport"
    ],
    "city": [
      "Manistee",
      "Manistee",
      "Manistee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DXE",
    "translations": [
      "Bruce Campbell Field",
      "Bruce Campbell Field",
      "Bruce Campbell Field"
    ],
    "city": [
      "Madison",
      "Madison",
      "Madison"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MBS",
    "translations": [
      "MBS International Airport",
      "MBS International Airport",
      "MBS International Airport"
    ],
    "city": [
      "Freeland",
      "Freeland",
      "Freeland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MBY",
    "translations": [
      "Omar N Bradley Airport",
      "Omar N Bradley Airport",
      "Omar N Bradley Airport"
    ],
    "city": [
      "Moberly",
      "Moberly",
      "Moberly"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MCB",
    "translations": [
      "McComb-Pike County Airport / John E Lewis Field",
      "McComb-Pike County Airport / John E Lewis Field",
      "McComb-Pike County Airport / John E Lewis Field"
    ],
    "city": [
      "McComb",
      "McComb",
      "McComb"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MCC",
    "translations": [
      "McClellan Airfield",
      "McClellan Airfield",
      "McClellan Airfield"
    ],
    "city": [
      "Sacramento",
      "Sacramento",
      "Sacramento"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MCD",
    "translations": [
      "Mackinac Island Airport",
      "Mackinac Island Airport",
      "Mackinac Island Airport"
    ],
    "city": [
      "Mackinac Island",
      "Mackinac Island",
      "Mackinac Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MCE",
    "translations": [
      "Merced Regional Macready Field",
      "Merced Regional Macready Field",
      "Merced Regional Macready Field"
    ],
    "city": [
      "Merced",
      "Merced",
      "Merced"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MCF",
    "translations": [
      "MacDill Air Force Base",
      "MacDill Air Force Base",
      "MacDill Air Force Base"
    ],
    "city": [
      "Tampa",
      "Tampa",
      "Tampa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MCI",
    "translations": [
      "Kansas City International Airport",
      "Kansas City International Airport",
      "Kansas City International Airport"
    ],
    "city": [
      "Kansas City",
      "Kansas City",
      "Kansas City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MCK",
    "translations": [
      "McCook Ben Nelson Regional Airport",
      "McCook Ben Nelson Regional Airport",
      "McCook Ben Nelson Regional Airport"
    ],
    "city": [
      "McCook",
      "McCook",
      "McCook"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MCN",
    "translations": [
      "Middle Georgia Regional Airport",
      "Middle Georgia Regional Airport",
      "Middle Georgia Regional Airport"
    ],
    "city": [
      "Macon",
      "Macon",
      "Macon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MCO",
    "translations": [
      "Orlando International Airport",
      "Orlando International Airport",
      "Orlando International Airport"
    ],
    "city": [
      "Orlando",
      "Orlando",
      "Orlando"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MCW",
    "translations": [
      "Mason City Municipal Airport",
      "Mason City Municipal Airport",
      "Mason City Municipal Airport"
    ],
    "city": [
      "Mason City",
      "Mason City",
      "Mason City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MDA",
    "translations": [
      "Martindale Army Heliport",
      "Martindale Army Heliport",
      "Martindale Army Heliport"
    ],
    "city": [
      "San Antonio",
      "San Antonio",
      "San Antonio"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MDD",
    "translations": [
      "Midland Airpark",
      "Midland Airpark",
      "Midland Airpark"
    ],
    "city": [
      "Midland",
      "Midland",
      "Midland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MDH",
    "translations": [
      "Southern Illinois Airport",
      "Southern Illinois Airport",
      "Southern Illinois Airport"
    ],
    "city": [
      "Murphysboro",
      "Murphysboro",
      "Murphysboro"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "XMD",
    "translations": [
      "Madison Municipal Airport",
      "Madison Municipal Airport",
      "Madison Municipal Airport"
    ],
    "city": [
      "Madison",
      "Madison",
      "Madison"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MDT",
    "translations": [
      "Harrisburg International Airport",
      "Harrisburg International Airport",
      "Harrisburg International Airport"
    ],
    "city": [
      "Harrisburg",
      "Harrisburg",
      "Harrisburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MDW",
    "translations": [
      "Chicago Midway International Airport",
      "Chicago Midway International Airport",
      "Chicago Midway International Airport"
    ],
    "city": [
      "Chicago",
      "Chicago",
      "Chicago"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MDF",
    "translations": [
      "Taylor County Airport",
      "Taylor County Airport",
      "Taylor County Airport"
    ],
    "city": [
      "Medford",
      "Medford",
      "Medford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MXE",
    "translations": [
      "Laurinburg Maxton Airport",
      "Laurinburg Maxton Airport",
      "Laurinburg Maxton Airport"
    ],
    "city": [
      "Maxton",
      "Maxton",
      "Maxton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MEI",
    "translations": [
      "Key Field / Meridian Regional Airport",
      "Key Field / Meridian Regional Airport",
      "Key Field / Meridian Regional Airport"
    ],
    "city": [
      "Meridian",
      "Meridian",
      "Meridian"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MEM",
    "translations": [
      "Memphis International Airport",
      "Memphis International Airport",
      "Memphis International Airport"
    ],
    "city": [
      "Memphis",
      "Memphis",
      "Memphis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MER",
    "translations": [
      "Castle Airport",
      "Castle Airport",
      "Castle Airport"
    ],
    "city": [
      "Merced",
      "Merced",
      "Merced"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MEV",
    "translations": [
      "Minden-Tahoe Airport",
      "Minden-Tahoe Airport",
      "Minden-Tahoe Airport"
    ],
    "city": [
      "Minden",
      "Minden",
      "Minden"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UMZ",
    "translations": [
      "Mena Intermountain Municipal Airport",
      "Mena Intermountain Municipal Airport",
      "Mena Intermountain Municipal Airport"
    ],
    "city": [
      "Mena",
      "Mena",
      "Mena"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MFD",
    "translations": [
      "Mansfield Lahm Regional Airport",
      "Mansfield Lahm Regional Airport",
      "Mansfield Lahm Regional Airport"
    ],
    "city": [
      "Mansfield",
      "Mansfield",
      "Mansfield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MFE",
    "translations": [
      "McAllen Miller International Airport",
      "McAllen Miller International Airport",
      "McAllen Miller International Airport"
    ],
    "city": [
      "McAllen",
      "McAllen",
      "McAllen"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MFI",
    "translations": [
      "Marshfield Municipal Airport",
      "Marshfield Municipal Airport",
      "Marshfield Municipal Airport"
    ],
    "city": [
      "Marshfield",
      "Marshfield",
      "Marshfield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MFR",
    "translations": [
      "Rogue Valley International Medford Airport",
      "Rogue Valley International Medford Airport",
      "Rogue Valley International Medford Airport"
    ],
    "city": [
      "Medford",
      "Medford",
      "Medford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MFV",
    "translations": [
      "Accomack County Airport",
      "Accomack County Airport",
      "Accomack County Airport"
    ],
    "city": [
      "Melfa",
      "Melfa",
      "Melfa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MGC",
    "translations": [
      "Michigan City Municipal Airport",
      "Michigan City Municipal Airport",
      "Michigan City Municipal Airport"
    ],
    "city": [
      "Michigan City",
      "Michigan City",
      "Michigan City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MGE",
    "translations": [
      "Dobbins Air Reserve Base",
      "Dobbins Air Reserve Base",
      "Dobbins Air Reserve Base"
    ],
    "city": [
      "Marietta",
      "Marietta",
      "Marietta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MGJ",
    "translations": [
      "Orange County Airport",
      "Orange County Airport",
      "Orange County Airport"
    ],
    "city": [
      "Montgomery",
      "Montgomery",
      "Montgomery"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MGM",
    "translations": [
      "Montgomery Regional (Dannelly Field) Airport",
      "Montgomery Regional (Dannelly Field) Airport",
      "Montgomery Regional (Dannelly Field) Airport"
    ],
    "city": [
      "Montgomery",
      "Montgomery",
      "Montgomery"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MGR",
    "translations": [
      "Moultrie Municipal Airport",
      "Moultrie Municipal Airport",
      "Moultrie Municipal Airport"
    ],
    "city": [
      "Moultrie",
      "Moultrie",
      "Moultrie"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MGW",
    "translations": [
      "Morgantown Municipal Airport Walter L. (Bill) Hart Field",
      "Morgantown Municipal Airport Walter L. (Bill) Hart Field",
      "Morgantown Municipal Airport Walter L. (Bill) Hart Field"
    ],
    "city": [
      "Morgantown",
      "Morgantown",
      "Morgantown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MGY",
    "translations": [
      "Dayton-Wright Brothers Airport",
      "Dayton-Wright Brothers Airport",
      "Dayton-Wright Brothers Airport"
    ],
    "city": [
      "Dayton",
      "Dayton",
      "Dayton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MHE",
    "translations": [
      "Mitchell Municipal Airport",
      "Mitchell Municipal Airport",
      "Mitchell Municipal Airport"
    ],
    "city": [
      "Mitchell",
      "Mitchell",
      "Mitchell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MHK",
    "translations": [
      "Manhattan Regional Airport",
      "Manhattan Regional Airport",
      "Manhattan Regional Airport"
    ],
    "city": [
      "Manhattan",
      "Manhattan",
      "Manhattan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MHL",
    "translations": [
      "Marshall Memorial Municipal Airport",
      "Marshall Memorial Municipal Airport",
      "Marshall Memorial Municipal Airport"
    ],
    "city": [
      "Marshall",
      "Marshall",
      "Marshall"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MHR",
    "translations": [
      "Sacramento Mather Airport",
      "Sacramento Mather Airport",
      "Sacramento Mather Airport"
    ],
    "city": [
      "Sacramento",
      "Sacramento",
      "Sacramento"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MHT",
    "translations": [
      "Manchester-Boston Regional Airport",
      "Manchester-Boston Regional Airport",
      "Manchester-Boston Regional Airport"
    ],
    "city": [
      "Manchester",
      "Manchester",
      "Manchester"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MHV",
    "translations": [
      "Mojave Airport",
      "Mojave Airport",
      "Mojave Airport"
    ],
    "city": [
      "Mojave",
      "Mojave",
      "Mojave"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MIA",
    "translations": [
      "Miami International Airport",
      "Miami International Airport",
      "Miami International Airport"
    ],
    "city": [
      "Miami",
      "Miami",
      "Miami"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MIB",
    "translations": [
      "Minot Air Force Base",
      "Minot Air Force Base",
      "Minot Air Force Base"
    ],
    "city": [
      "Minot",
      "Minot",
      "Minot"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MIC",
    "translations": [
      "Crystal Airport",
      "Crystal Airport",
      "Crystal Airport"
    ],
    "city": [
      "Minneapolis",
      "Minneapolis",
      "Minneapolis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MIE",
    "translations": [
      "Delaware County Johnson Field",
      "Delaware County Johnson Field",
      "Delaware County Johnson Field"
    ],
    "city": [
      "Muncie",
      "Muncie",
      "Muncie"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MIO",
    "translations": [
      "Miami Municipal Airport",
      "Miami Municipal Airport",
      "Miami Municipal Airport"
    ],
    "city": [
      "Miami",
      "Miami",
      "Miami"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MIT",
    "translations": [
      "Shafter Airport - Minter Field",
      "Shafter Airport - Minter Field",
      "Shafter Airport - Minter Field"
    ],
    "city": [
      "Shafter",
      "Shafter",
      "Shafter"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MIV",
    "translations": [
      "Millville Municipal Airport",
      "Millville Municipal Airport",
      "Millville Municipal Airport"
    ],
    "city": [
      "Millville",
      "Millville",
      "Millville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MIW",
    "translations": [
      "Marshalltown Municipal Airport",
      "Marshalltown Municipal Airport",
      "Marshalltown Municipal Airport"
    ],
    "city": [
      "Marshalltown",
      "Marshalltown",
      "Marshalltown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MJQ",
    "translations": [
      "Jackson Municipal Airport",
      "Jackson Municipal Airport",
      "Jackson Municipal Airport"
    ],
    "city": [
      "Jackson",
      "Jackson",
      "Jackson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MJX",
    "translations": [
      "Ocean County Airport",
      "Ocean County Airport",
      "Ocean County Airport"
    ],
    "city": [
      "Toms River",
      "Toms River",
      "Toms River"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MKA",
    "translations": [
      "Miller Municipal Airport",
      "Miller Municipal Airport",
      "Miller Municipal Airport"
    ],
    "city": [
      "Miller",
      "Miller",
      "Miller"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MKC",
    "translations": [
      "Charles B. Wheeler Downtown Airport",
      "Charles B. Wheeler Downtown Airport",
      "Charles B. Wheeler Downtown Airport"
    ],
    "city": [
      "Kansas City",
      "Kansas City",
      "Kansas City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MKE",
    "translations": [
      "General Mitchell International Airport",
      "General Mitchell International Airport",
      "General Mitchell International Airport"
    ],
    "city": [
      "Milwaukee",
      "Milwaukee",
      "Milwaukee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MKG",
    "translations": [
      "Muskegon County Airport",
      "Muskegon County Airport",
      "Muskegon County Airport"
    ],
    "city": [
      "Muskegon",
      "Muskegon",
      "Muskegon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MKL",
    "translations": [
      "McKellar-Sipes Regional Airport",
      "McKellar-Sipes Regional Airport",
      "McKellar-Sipes Regional Airport"
    ],
    "city": [
      "Jackson",
      "Jackson",
      "Jackson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MKO",
    "translations": [
      "Muskogee-Davis Regional Airport",
      "Muskogee-Davis Regional Airport",
      "Muskogee-Davis Regional Airport"
    ],
    "city": [
      "Muskogee",
      "Muskogee",
      "Muskogee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MKT",
    "translations": [
      "Mankato Regional Airport",
      "Mankato Regional Airport",
      "Mankato Regional Airport"
    ],
    "city": [
      "Mankato",
      "Mankato",
      "Mankato"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MRK",
    "translations": [
      "Marco Island Executive Airport",
      "Marco Island Executive Airport",
      "Marco Island Executive Airport"
    ],
    "city": [
      "Marco Island",
      "Marco Island",
      "Marco Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MLB",
    "translations": [
      "Melbourne Orlando International Airport",
      "Melbourne Orlando International Airport",
      "Melbourne Orlando International Airport"
    ],
    "city": [
      "Melbourne",
      "Melbourne",
      "Melbourne"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MLC",
    "translations": [
      "Mc Alester Regional Airport",
      "Mc Alester Regional Airport",
      "Mc Alester Regional Airport"
    ],
    "city": [
      "Mc Alester",
      "Mc Alester",
      "Mc Alester"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MLD",
    "translations": [
      "Malad City Airport",
      "Malad City Airport",
      "Malad City Airport"
    ],
    "city": [
      "Malad City",
      "Malad City",
      "Malad City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MIQ",
    "translations": [
      "Millard Airport",
      "Millard Airport",
      "Millard Airport"
    ],
    "city": [
      "Omaha",
      "Omaha",
      "Omaha"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MLF",
    "translations": [
      "Milford Municipal-Ben and Judy Briscoe Field",
      "Milford Municipal-Ben and Judy Briscoe Field",
      "Milford Municipal-Ben and Judy Briscoe Field"
    ],
    "city": [
      "Milford",
      "Milford",
      "Milford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MLI",
    "translations": [
      "Quad City International Airport",
      "Quad City International Airport",
      "Quad City International Airport"
    ],
    "city": [
      "Moline",
      "Moline",
      "Moline"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MLJ",
    "translations": [
      "Baldwin County Regional Airport",
      "Baldwin County Regional Airport",
      "Baldwin County Regional Airport"
    ],
    "city": [
      "Milledgeville",
      "Milledgeville",
      "Milledgeville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MLS",
    "translations": [
      "Miles City Airport - Frank Wiley Field",
      "Miles City Airport - Frank Wiley Field",
      "Miles City Airport - Frank Wiley Field"
    ],
    "city": [
      "Miles City",
      "Miles City",
      "Miles City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MLT",
    "translations": [
      "Millinocket Municipal Airport",
      "Millinocket Municipal Airport",
      "Millinocket Municipal Airport"
    ],
    "city": [
      "Millinocket",
      "Millinocket",
      "Millinocket"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MLU",
    "translations": [
      "Monroe Regional Airport",
      "Monroe Regional Airport",
      "Monroe Regional Airport"
    ],
    "city": [
      "Monroe",
      "Monroe",
      "Monroe"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KMM",
    "translations": [
      "Kimaam Airport",
      "Kimaam Airport",
      "Kimaam Airport"
    ],
    "city": [
      "Kimaam",
      "Kimaam",
      "Kimaam"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MMH",
    "translations": [
      "Mammoth Yosemite Airport",
      "Mammoth Yosemite Airport",
      "Mammoth Yosemite Airport"
    ],
    "city": [
      "Mammoth Lakes",
      "Mammoth Lakes",
      "Mammoth Lakes"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MMI",
    "translations": [
      "McMinn County Airport",
      "McMinn County Airport",
      "McMinn County Airport"
    ],
    "city": [
      "Athens",
      "Athens",
      "Athens"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MML",
    "translations": [
      "Southwest Minnesota Regional Airport - Marshall/Ryan Field",
      "Southwest Minnesota Regional Airport - Marshall/Ryan Field",
      "Southwest Minnesota Regional Airport - Marshall/Ryan Field"
    ],
    "city": [
      "Marshall",
      "Marshall",
      "Marshall"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MMS",
    "translations": [
      "Selfs Airport",
      "Selfs Airport",
      "Selfs Airport"
    ],
    "city": [
      "Marks",
      "Marks",
      "Marks"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MMT",
    "translations": [
      "Mc Entire Joint National Guard Base",
      "Mc Entire Joint National Guard Base",
      "Mc Entire Joint National Guard Base"
    ],
    "city": [
      "Eastover",
      "Eastover",
      "Eastover"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MMU",
    "translations": [
      "Morristown Municipal Airport",
      "Morristown Municipal Airport",
      "Morristown Municipal Airport"
    ],
    "city": [
      "Morristown",
      "Morristown",
      "Morristown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MNM",
    "translations": [
      "Menominee–Marinette Twin County Airport",
      "Menominee–Marinette Twin County Airport",
      "Menominee–Marinette Twin County Airport"
    ],
    "city": [
      "Menominee",
      "Menominee",
      "Menominee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MNN",
    "translations": [
      "Marion Municipal Airport",
      "Marion Municipal Airport",
      "Marion Municipal Airport"
    ],
    "city": [
      "Marion",
      "Marion",
      "Marion"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MOB",
    "translations": [
      "Mobile Regional Airport",
      "Mobile Regional Airport",
      "Mobile Regional Airport"
    ],
    "city": [
      "Mobile",
      "Mobile",
      "Mobile"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MOD",
    "translations": [
      "Modesto City Co-Harry Sham Field",
      "Modesto City Co-Harry Sham Field",
      "Modesto City Co-Harry Sham Field"
    ],
    "city": [
      "Modesto",
      "Modesto",
      "Modesto"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MOP",
    "translations": [
      "Mount Pleasant Municipal Airport",
      "Mount Pleasant Municipal Airport",
      "Mount Pleasant Municipal Airport"
    ],
    "city": [
      "Mount Pleasant",
      "Mount Pleasant",
      "Mount Pleasant"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MOR",
    "translations": [
      "Morristown Regional Airport",
      "Morristown Regional Airport",
      "Morristown Regional Airport"
    ],
    "city": [
      "Morristown",
      "Morristown",
      "Morristown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MOT",
    "translations": [
      "Minot International Airport",
      "Minot International Airport",
      "Minot International Airport"
    ],
    "city": [
      "Minot",
      "Minot",
      "Minot"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MOX",
    "translations": [
      "Morris Municipal Airport Charlie Schmidt Field",
      "Morris Municipal Airport Charlie Schmidt Field",
      "Morris Municipal Airport Charlie Schmidt Field"
    ],
    "city": [
      "Morris",
      "Morris",
      "Morris"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RMY",
    "translations": [
      "Mariposa Yosemite Airport",
      "Mariposa Yosemite Airport",
      "Mariposa Yosemite Airport"
    ],
    "city": [
      "Mariposa",
      "Mariposa",
      "Mariposa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MPJ",
    "translations": [
      "Petit Jean Park Airport",
      "Petit Jean Park Airport",
      "Petit Jean Park Airport"
    ],
    "city": [
      "Morrilton",
      "Morrilton",
      "Morrilton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MPO",
    "translations": [
      "Pocono Mountains Municipal Airport",
      "Pocono Mountains Municipal Airport",
      "Pocono Mountains Municipal Airport"
    ],
    "city": [
      "Mount Pocono",
      "Mount Pocono",
      "Mount Pocono"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MPR",
    "translations": [
      "Mc Pherson Airport",
      "Mc Pherson Airport",
      "Mc Pherson Airport"
    ],
    "city": [
      "Mc Pherson",
      "Mc Pherson",
      "Mc Pherson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MPV",
    "translations": [
      "Edward F Knapp State Airport",
      "Edward F Knapp State Airport",
      "Edward F Knapp State Airport"
    ],
    "city": [
      "Barre/Montpelier",
      "Barre/Montpelier",
      "Barre/Montpelier"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MPZ",
    "translations": [
      "Mount Pleasant Municipal Airport",
      "Mount Pleasant Municipal Airport",
      "Mount Pleasant Municipal Airport"
    ],
    "city": [
      "Mount Pleasant",
      "Mount Pleasant",
      "Mount Pleasant"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MQB",
    "translations": [
      "Macomb Municipal Airport",
      "Macomb Municipal Airport",
      "Macomb Municipal Airport"
    ],
    "city": [
      "Macomb",
      "Macomb",
      "Macomb"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MEO",
    "translations": [
      "Dare County Regional Airport",
      "Dare County Regional Airport",
      "Dare County Regional Airport"
    ],
    "city": [
      "Manteo",
      "Manteo",
      "Manteo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CTH",
    "translations": [
      "Chester County G O Carlson Airport",
      "Chester County G O Carlson Airport",
      "Chester County G O Carlson Airport"
    ],
    "city": [
      "Coatesville",
      "Coatesville",
      "Coatesville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MQW",
    "translations": [
      "Telfair Wheeler Airport",
      "Telfair Wheeler Airport",
      "Telfair Wheeler Airport"
    ],
    "city": [
      "Mc Rae",
      "Mc Rae",
      "Mc Rae"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MQY",
    "translations": [
      "Smyrna Airport",
      "Smyrna Airport",
      "Smyrna Airport"
    ],
    "city": [
      "Smyrna",
      "Smyrna",
      "Smyrna"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MRB",
    "translations": [
      "Eastern WV Regional Airport/Shepherd Field",
      "Eastern WV Regional Airport/Shepherd Field",
      "Eastern WV Regional Airport/Shepherd Field"
    ],
    "city": [
      "Martinsburg",
      "Martinsburg",
      "Martinsburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MRC",
    "translations": [
      "Maury County Airport",
      "Maury County Airport",
      "Maury County Airport"
    ],
    "city": [
      "Columbia/Mount Pleasant",
      "Columbia/Mount Pleasant",
      "Columbia/Mount Pleasant"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MRF",
    "translations": [
      "Marfa Municipal Airport",
      "Marfa Municipal Airport",
      "Marfa Municipal Airport"
    ],
    "city": [
      "Marfa",
      "Marfa",
      "Marfa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MRN",
    "translations": [
      "Foothills Regional Airport",
      "Foothills Regional Airport",
      "Foothills Regional Airport"
    ],
    "city": [
      "Morganton",
      "Morganton",
      "Morganton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MRY",
    "translations": [
      "Monterey Peninsula Airport",
      "Monterey Peninsula Airport",
      "Monterey Peninsula Airport"
    ],
    "city": [
      "Monterey",
      "Monterey",
      "Monterey"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MSL",
    "translations": [
      "Northwest Alabama Regional Airport",
      "Northwest Alabama Regional Airport",
      "Northwest Alabama Regional Airport"
    ],
    "city": [
      "Muscle Shoals",
      "Muscle Shoals",
      "Muscle Shoals"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MSN",
    "translations": [
      "Dane County Regional Truax Field",
      "Dane County Regional Truax Field",
      "Dane County Regional Truax Field"
    ],
    "city": [
      "Madison",
      "Madison",
      "Madison"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MSO",
    "translations": [
      "Missoula International Airport",
      "Missoula International Airport",
      "Missoula International Airport"
    ],
    "city": [
      "Missoula",
      "Missoula",
      "Missoula"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MSP",
    "translations": [
      "Minneapolis–Saint Paul International Airport / Wold–Chamberlain Field",
      "Minneapolis–Saint Paul International Airport / Wold–Chamberlain Field",
      "Minneapolis–Saint Paul International Airport / Wold–Chamberlain Field"
    ],
    "city": [
      "Minneapolis",
      "Minneapolis",
      "Minneapolis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MSS",
    "translations": [
      "Massena International Airport Richards Field",
      "Massena International Airport Richards Field",
      "Massena International Airport Richards Field"
    ],
    "city": [
      "Massena",
      "Massena",
      "Massena"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MSV",
    "translations": [
      "Sullivan County International Airport",
      "Sullivan County International Airport",
      "Sullivan County International Airport"
    ],
    "city": [
      "Monticello",
      "Monticello",
      "Monticello"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MSY",
    "translations": [
      "Louis Armstrong New Orleans International Airport",
      "Louis Armstrong New Orleans International Airport",
      "Louis Armstrong New Orleans International Airport"
    ],
    "city": [
      "New Orleans",
      "New Orleans",
      "New Orleans"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MTC",
    "translations": [
      "Selfridge Air National Guard Base Airport",
      "Selfridge Air National Guard Base Airport",
      "Selfridge Air National Guard Base Airport"
    ],
    "city": [
      "Mount Clemens",
      "Mount Clemens",
      "Mount Clemens"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MTH",
    "translations": [
      "The Florida Keys Marathon Airport",
      "The Florida Keys Marathon Airport",
      "The Florida Keys Marathon Airport"
    ],
    "city": [
      "Marathon",
      "Marathon",
      "Marathon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MTJ",
    "translations": [
      "Montrose Regional Airport",
      "Montrose Regional Airport",
      "Montrose Regional Airport"
    ],
    "city": [
      "Montrose",
      "Montrose",
      "Montrose"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MTN",
    "translations": [
      "Martin State Airport",
      "Martin State Airport",
      "Martin State Airport"
    ],
    "city": [
      "Baltimore",
      "Baltimore",
      "Baltimore"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MTO",
    "translations": [
      "Coles County Memorial Airport",
      "Coles County Memorial Airport",
      "Coles County Memorial Airport"
    ],
    "city": [
      "Mattoon",
      "Mattoon",
      "Mattoon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MTP",
    "translations": [
      "Montauk Airport",
      "Montauk Airport",
      "Montauk Airport"
    ],
    "city": [
      "Montauk",
      "Montauk",
      "Montauk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MTW",
    "translations": [
      "Manitowoc County Airport",
      "Manitowoc County Airport",
      "Manitowoc County Airport"
    ],
    "city": [
      "Manitowoc",
      "Manitowoc",
      "Manitowoc"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MUI",
    "translations": [
      "Muir Army Air Field (Fort Indiantown Gap) Airport",
      "Muir Army Air Field (Fort Indiantown Gap) Airport",
      "Muir Army Air Field (Fort Indiantown Gap) Airport"
    ],
    "city": [
      "Fort Indiantown Gap(Annville)",
      "Fort Indiantown Gap(Annville)",
      "Fort Indiantown Gap(Annville)"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MUL",
    "translations": [
      "Spence Airport",
      "Spence Airport",
      "Spence Airport"
    ],
    "city": [
      "Moultrie",
      "Moultrie",
      "Moultrie"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MUO",
    "translations": [
      "Mountain Home Air Force Base",
      "Mountain Home Air Force Base",
      "Mountain Home Air Force Base"
    ],
    "city": [
      "Mountain Home",
      "Mountain Home",
      "Mountain Home"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MUT",
    "translations": [
      "Muscatine Municipal Airport",
      "Muscatine Municipal Airport",
      "Muscatine Municipal Airport"
    ],
    "city": [
      "Muscatine",
      "Muscatine",
      "Muscatine"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MVC",
    "translations": [
      "Monroe County Aeroplex Airport",
      "Monroe County Aeroplex Airport",
      "Monroe County Aeroplex Airport"
    ],
    "city": [
      "Monroeville",
      "Monroeville",
      "Monroeville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MVE",
    "translations": [
      "Montevideo Chippewa County Airport",
      "Montevideo Chippewa County Airport",
      "Montevideo Chippewa County Airport"
    ],
    "city": [
      "Montevideo",
      "Montevideo",
      "Montevideo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MVL",
    "translations": [
      "Morrisville-Stowe State Airport",
      "Morrisville-Stowe State Airport",
      "Morrisville-Stowe State Airport"
    ],
    "city": [
      "Morrisville",
      "Morrisville",
      "Morrisville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MVN",
    "translations": [
      "Mount Vernon Outland Airport",
      "Mount Vernon Outland Airport",
      "Mount Vernon Outland Airport"
    ],
    "city": [
      "Mount Vernon",
      "Mount Vernon",
      "Mount Vernon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MVY",
    "translations": [
      "Martha's Vineyard Airport",
      "Martha's Vineyard Airport",
      "Martha's Vineyard Airport"
    ],
    "city": [
      "Martha's Vineyard",
      "Martha's Vineyard",
      "Martha's Vineyard"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MWA",
    "translations": [
      "Veterans Airport of Southern Illinois",
      "Veterans Airport of Southern Illinois",
      "Veterans Airport of Southern Illinois"
    ],
    "city": [
      "Marion",
      "Marion",
      "Marion"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MWC",
    "translations": [
      "Lawrence J Timmerman Airport",
      "Lawrence J Timmerman Airport",
      "Lawrence J Timmerman Airport"
    ],
    "city": [
      "Milwaukee",
      "Milwaukee",
      "Milwaukee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MWH",
    "translations": [
      "Grant County International Airport",
      "Grant County International Airport",
      "Grant County International Airport"
    ],
    "city": [
      "Moses Lake",
      "Moses Lake",
      "Moses Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MWL",
    "translations": [
      "Mineral Wells Regional Airport",
      "Mineral Wells Regional Airport",
      "Mineral Wells Regional Airport"
    ],
    "city": [
      "Mineral Wells",
      "Mineral Wells",
      "Mineral Wells"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MWM",
    "translations": [
      "Windom Municipal Airport",
      "Windom Municipal Airport",
      "Windom Municipal Airport"
    ],
    "city": [
      "Windom",
      "Windom",
      "Windom"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MWO",
    "translations": [
      "Middletown Regional Airport",
      "Middletown Regional Airport",
      "Middletown Regional Airport"
    ],
    "city": [
      "Middletown",
      "Middletown",
      "Middletown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MXA",
    "translations": [
      "Manila Municipal Airport",
      "Manila Municipal Airport",
      "Manila Municipal Airport"
    ],
    "city": [
      "Manila",
      "Manila",
      "Manila"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MXF",
    "translations": [
      "Maxwell Air Force Base",
      "Maxwell Air Force Base",
      "Maxwell Air Force Base"
    ],
    "city": [
      "Montgomery",
      "Montgomery",
      "Montgomery"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MXO",
    "translations": [
      "Monticello Regional Airport",
      "Monticello Regional Airport",
      "Monticello Regional Airport"
    ],
    "city": [
      "Monticello",
      "Monticello",
      "Monticello"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KMY",
    "translations": [
      "Moser Bay Seaplane Base",
      "Moser Bay Seaplane Base",
      "Moser Bay Seaplane Base"
    ],
    "city": [
      "Moser Bay",
      "Moser Bay",
      "Moser Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MYF",
    "translations": [
      "Montgomery-Gibbs Executive Airport",
      "Montgomery-Gibbs Executive Airport",
      "Montgomery-Gibbs Executive Airport"
    ],
    "city": [
      "San Diego",
      "San Diego",
      "San Diego"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MYL",
    "translations": [
      "McCall Municipal Airport",
      "McCall Municipal Airport",
      "McCall Municipal Airport"
    ],
    "city": [
      "McCall",
      "McCall",
      "McCall"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MYR",
    "translations": [
      "Myrtle Beach International Airport",
      "Myrtle Beach International Airport",
      "Myrtle Beach International Airport"
    ],
    "city": [
      "Myrtle Beach",
      "Myrtle Beach",
      "Myrtle Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MYV",
    "translations": [
      "Yuba County Airport",
      "Yuba County Airport",
      "Yuba County Airport"
    ],
    "city": [
      "Marysville",
      "Marysville",
      "Marysville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MZJ",
    "translations": [
      "Pinal Airpark",
      "Pinal Airpark",
      "Pinal Airpark"
    ],
    "city": [
      "Marana",
      "Marana",
      "Marana"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MZZ",
    "translations": [
      "Marion Municipal Airport",
      "Marion Municipal Airport",
      "Marion Municipal Airport"
    ],
    "city": [
      "Marion",
      "Marion",
      "Marion"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CTX",
    "translations": [
      "Cortland County Chase Field",
      "Cortland County Chase Field",
      "Cortland County Chase Field"
    ],
    "city": [
      "Cortland",
      "Cortland",
      "Cortland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SXY",
    "translations": [
      "Sidney Municipal Airport",
      "Sidney Municipal Airport",
      "Sidney Municipal Airport"
    ],
    "city": [
      "Sidney",
      "Sidney",
      "Sidney"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ONH",
    "translations": [
      "Albert S Nader Regional Airport",
      "Albert S Nader Regional Airport",
      "Albert S Nader Regional Airport"
    ],
    "city": [
      "Oneonta",
      "Oneonta",
      "Oneonta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NBG",
    "translations": [
      "New Orleans NAS JRB/Alvin Callender Field",
      "New Orleans NAS JRB/Alvin Callender Field",
      "New Orleans NAS JRB/Alvin Callender Field"
    ],
    "city": [
      "New Orleans",
      "New Orleans",
      "New Orleans"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NHX",
    "translations": [
      "Naval Outlying Field Barin",
      "Naval Outlying Field Barin",
      "Naval Outlying Field Barin"
    ],
    "city": [
      "Foley",
      "Foley",
      "Foley"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DGN",
    "translations": [
      "Dahlgren Naval Surface Warfare Center Airport",
      "Dahlgren Naval Surface Warfare Center Airport",
      "Dahlgren Naval Surface Warfare Center Airport"
    ],
    "city": [
      "Dahlgren",
      "Dahlgren",
      "Dahlgren"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NEL",
    "translations": [
      "Lakehurst Maxfield Field Airport",
      "Lakehurst Maxfield Field Airport",
      "Lakehurst Maxfield Field Airport"
    ],
    "city": [
      "Lakehurst",
      "Lakehurst",
      "Lakehurst"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NEN",
    "translations": [
      "Whitehouse Naval Outlying Field",
      "Whitehouse Naval Outlying Field",
      "Whitehouse Naval Outlying Field"
    ],
    "city": [
      "Jacksonville",
      "Jacksonville",
      "Jacksonville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NEW",
    "translations": [
      "Lakefront Airport",
      "Lakefront Airport",
      "Lakefront Airport"
    ],
    "city": [
      "New Orleans",
      "New Orleans",
      "New Orleans"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NFL",
    "translations": [
      "Fallon Naval Air Station",
      "Fallon Naval Air Station",
      "Fallon Naval Air Station"
    ],
    "city": [
      "Fallon",
      "Fallon",
      "Fallon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FWH",
    "translations": [
      "NAS Fort Worth JRB / Carswell Field",
      "NAS Fort Worth JRB / Carswell Field",
      "NAS Fort Worth JRB / Carswell Field"
    ],
    "city": [
      "Fort Worth",
      "Fort Worth",
      "Fort Worth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NGP",
    "translations": [
      "Naval Air Station Corpus Christi Truax Field",
      "Naval Air Station Corpus Christi Truax Field",
      "Naval Air Station Corpus Christi Truax Field"
    ],
    "city": [
      "Corpus Christi",
      "Corpus Christi",
      "Corpus Christi"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NGU",
    "translations": [
      "Norfolk Naval Station (Chambers Field)",
      "Norfolk Naval Station (Chambers Field)",
      "Norfolk Naval Station (Chambers Field)"
    ],
    "city": [
      "Norfolk",
      "Norfolk",
      "Norfolk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NGW",
    "translations": [
      "Cabaniss Field Naval Outlying Landing Field",
      "Cabaniss Field Naval Outlying Landing Field",
      "Cabaniss Field Naval Outlying Landing Field"
    ],
    "city": [
      "Corpus Christi",
      "Corpus Christi",
      "Corpus Christi"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NHK",
    "translations": [
      "Patuxent River Naval Air Station (Trapnell Field)",
      "Patuxent River Naval Air Station (Trapnell Field)",
      "Patuxent River Naval Air Station (Trapnell Field)"
    ],
    "city": [
      "Patuxent River",
      "Patuxent River",
      "Patuxent River"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NIP",
    "translations": [
      "Jacksonville Naval Air Station (Towers Field)",
      "Jacksonville Naval Air Station (Towers Field)",
      "Jacksonville Naval Air Station (Towers Field)"
    ],
    "city": [
      "Jacksonville",
      "Jacksonville",
      "Jacksonville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NJK",
    "translations": [
      "El Centro NAF Airport (Vraciu Field)",
      "El Centro NAF Airport (Vraciu Field)",
      "El Centro NAF Airport (Vraciu Field)"
    ],
    "city": [
      "El Centro",
      "El Centro",
      "El Centro"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NKX",
    "translations": [
      "Miramar Marine Corps Air Station - Mitscher Field",
      "Miramar Marine Corps Air Station - Mitscher Field",
      "Miramar Marine Corps Air Station - Mitscher Field"
    ],
    "city": [
      "San Diego",
      "San Diego",
      "San Diego"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NLC",
    "translations": [
      "Lemoore Naval Air Station (Reeves Field) Airport",
      "Lemoore Naval Air Station (Reeves Field) Airport",
      "Lemoore Naval Air Station (Reeves Field) Airport"
    ],
    "city": [
      "Lemoore",
      "Lemoore",
      "Lemoore"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NPA",
    "translations": [
      "Naval Air Station Pensacola Forrest Sherman Field",
      "Naval Air Station Pensacola Forrest Sherman Field",
      "Naval Air Station Pensacola Forrest Sherman Field"
    ],
    "city": [
      "Pensacola",
      "Pensacola",
      "Pensacola"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NQA",
    "translations": [
      "Millington-Memphis Airport",
      "Millington-Memphis Airport",
      "Millington-Memphis Airport"
    ],
    "city": [
      "Millington",
      "Millington",
      "Millington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NQI",
    "translations": [
      "Kingsville Naval Air Station",
      "Kingsville Naval Air Station",
      "Kingsville Naval Air Station"
    ],
    "city": [
      "Kingsville",
      "Kingsville",
      "Kingsville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NQX",
    "translations": [
      "Naval Air Station Key West/Boca Chica Field",
      "Naval Air Station Key West/Boca Chica Field",
      "Naval Air Station Key West/Boca Chica Field"
    ],
    "city": [
      "Key West",
      "Key West",
      "Key West"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NRB",
    "translations": [
      "Naval Station Mayport / Admiral David L McDonald Field",
      "Naval Station Mayport / Admiral David L McDonald Field",
      "Naval Station Mayport / Admiral David L McDonald Field"
    ],
    "city": [
      "Jacksonville",
      "Jacksonville",
      "Jacksonville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NRS",
    "translations": [
      "Naval Outlying Field Imperial Beach (Ream Field)",
      "Naval Outlying Field Imperial Beach (Ream Field)",
      "Naval Outlying Field Imperial Beach (Ream Field)"
    ],
    "city": [
      "Imperial Beach",
      "Imperial Beach",
      "Imperial Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NSE",
    "translations": [
      "Whiting Field Naval Air Station - North",
      "Whiting Field Naval Air Station - North",
      "Whiting Field Naval Air Station - North"
    ],
    "city": [
      "Milton",
      "Milton",
      "Milton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NTD",
    "translations": [
      "Point Mugu Naval Air Station (Naval Base Ventura Co)",
      "Point Mugu Naval Air Station (Naval Base Ventura Co)",
      "Point Mugu Naval Air Station (Naval Base Ventura Co)"
    ],
    "city": [
      "Point Mugu",
      "Point Mugu",
      "Point Mugu"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NTU",
    "translations": [
      "Oceana Naval Air Station",
      "Oceana Naval Air Station",
      "Oceana Naval Air Station"
    ],
    "city": [
      "Virginia Beach",
      "Virginia Beach",
      "Virginia Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NUQ",
    "translations": [
      "Moffett Federal Airfield",
      "Moffett Federal Airfield",
      "Moffett Federal Airfield"
    ],
    "city": [
      "Mountain View",
      "Mountain View",
      "Mountain View"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NUW",
    "translations": [
      "Whidbey Island Naval Air Station (Ault Field)",
      "Whidbey Island Naval Air Station (Ault Field)",
      "Whidbey Island Naval Air Station (Ault Field)"
    ],
    "city": [
      "Oak Harbor",
      "Oak Harbor",
      "Oak Harbor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NVD",
    "translations": [
      "Nevada Municipal Airport",
      "Nevada Municipal Airport",
      "Nevada Municipal Airport"
    ],
    "city": [
      "Nevada",
      "Nevada",
      "Nevada"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NYG",
    "translations": [
      "Quantico Marine Corps Airfield / Turner Field",
      "Quantico Marine Corps Airfield / Turner Field",
      "Quantico Marine Corps Airfield / Turner Field"
    ],
    "city": [
      "Quantico",
      "Quantico",
      "Quantico"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "YUM",
    "translations": [
      "Yuma International Airport / Marine Corps Air Station Yuma",
      "Yuma International Airport / Marine Corps Air Station Yuma",
      "Yuma International Airport / Marine Corps Air Station Yuma"
    ],
    "city": [
      "Yuma",
      "Yuma",
      "Yuma"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NZY",
    "translations": [
      "North Island Naval Air Station-Halsey Field",
      "North Island Naval Air Station-Halsey Field",
      "North Island Naval Air Station-Halsey Field"
    ],
    "city": [
      "San Diego",
      "San Diego",
      "San Diego"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NVN",
    "translations": [
      "Nervino Airport",
      "Nervino Airport",
      "Nervino Airport"
    ],
    "city": [
      "Beckwourth",
      "Beckwourth",
      "Beckwourth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "COA",
    "translations": [
      "Columbia Airport",
      "Columbia Airport",
      "Columbia Airport"
    ],
    "city": [
      "Columbia",
      "Columbia",
      "Columbia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ODC",
    "translations": [
      "Oakdale Airport",
      "Oakdale Airport",
      "Oakdale Airport"
    ],
    "city": [
      "Oakdale",
      "Oakdale",
      "Oakdale"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EYR",
    "translations": [
      "Yerington Municipal Airport",
      "Yerington Municipal Airport",
      "Yerington Municipal Airport"
    ],
    "city": [
      "Yerington",
      "Yerington",
      "Yerington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OAJ",
    "translations": [
      "Albert J Ellis Airport",
      "Albert J Ellis Airport",
      "Albert J Ellis Airport"
    ],
    "city": [
      "Richlands",
      "Richlands",
      "Richlands"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OAK",
    "translations": [
      "San Francisco Bay Oakland International Airport",
      "San Francisco Bay Oakland International Airport",
      "San Francisco Bay Oakland International Airport"
    ],
    "city": [
      "Oakland",
      "Oakland",
      "Oakland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OAR",
    "translations": [
      "Marina Municipal Airport",
      "Marina Municipal Airport",
      "Marina Municipal Airport"
    ],
    "city": [
      "Marina",
      "Marina",
      "Marina"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OBE",
    "translations": [
      "Okeechobee County Airport",
      "Okeechobee County Airport",
      "Okeechobee County Airport"
    ],
    "city": [
      "Okeechobee",
      "Okeechobee",
      "Okeechobee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OCF",
    "translations": [
      "Ocala International Airport - Jim Taylor Field",
      "Ocala International Airport - Jim Taylor Field",
      "Ocala International Airport - Jim Taylor Field"
    ],
    "city": [
      "Ocala",
      "Ocala",
      "Ocala"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OCH",
    "translations": [
      "A L Mangham Jr. Regional Airport",
      "A L Mangham Jr. Regional Airport",
      "A L Mangham Jr. Regional Airport"
    ],
    "city": [
      "Nacogdoches",
      "Nacogdoches",
      "Nacogdoches"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OCW",
    "translations": [
      "Warren Field",
      "Warren Field",
      "Warren Field"
    ],
    "city": [
      "Washington",
      "Washington",
      "Washington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ODT",
    "translations": [
      "Odessa Schlemeyer Field",
      "Odessa Schlemeyer Field",
      "Odessa Schlemeyer Field"
    ],
    "city": [
      "Odessa",
      "Odessa",
      "Odessa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OEA",
    "translations": [
      "O'Neal Airport",
      "O'Neal Airport",
      "O'Neal Airport"
    ],
    "city": [
      "Lawrenceville",
      "Lawrenceville",
      "Lawrenceville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OEO",
    "translations": [
      "L O Simenstad Municipal Airport",
      "L O Simenstad Municipal Airport",
      "L O Simenstad Municipal Airport"
    ],
    "city": [
      "Osceola",
      "Osceola",
      "Osceola"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OFF",
    "translations": [
      "Offutt Air Force Base",
      "Offutt Air Force Base",
      "Offutt Air Force Base"
    ],
    "city": [
      "Omaha",
      "Omaha",
      "Omaha"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OFK",
    "translations": [
      "Karl Stefan Memorial Airport",
      "Karl Stefan Memorial Airport",
      "Karl Stefan Memorial Airport"
    ],
    "city": [
      "Norfolk",
      "Norfolk",
      "Norfolk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OGA",
    "translations": [
      "Ogallala Municipal Airport Searle Field",
      "Ogallala Municipal Airport Searle Field",
      "Ogallala Municipal Airport Searle Field"
    ],
    "city": [
      "Ogallala",
      "Ogallala",
      "Ogallala"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OGB",
    "translations": [
      "Orangeburg Municipal Airport",
      "Orangeburg Municipal Airport",
      "Orangeburg Municipal Airport"
    ],
    "city": [
      "Orangeburg",
      "Orangeburg",
      "Orangeburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OGD",
    "translations": [
      "Ogden Hinckley Airport",
      "Ogden Hinckley Airport",
      "Ogden Hinckley Airport"
    ],
    "city": [
      "Ogden",
      "Ogden",
      "Ogden"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OGS",
    "translations": [
      "Ogdensburg International Airport",
      "Ogdensburg International Airport",
      "Ogdensburg International Airport"
    ],
    "city": [
      "Ogdensburg",
      "Ogdensburg",
      "Ogdensburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OIC",
    "translations": [
      "Lt Warren Eaton Airport",
      "Lt Warren Eaton Airport",
      "Lt Warren Eaton Airport"
    ],
    "city": [
      "Norwich",
      "Norwich",
      "Norwich"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OJC",
    "translations": [
      "Johnson County Executive Airport",
      "Johnson County Executive Airport",
      "Johnson County Executive Airport"
    ],
    "city": [
      "Olathe",
      "Olathe",
      "Olathe"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OCN",
    "translations": [
      "Oceanside Municipal Airport",
      "Oceanside Municipal Airport",
      "Oceanside Municipal Airport"
    ],
    "city": [
      "Oceanside",
      "Oceanside",
      "Oceanside"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OKC",
    "translations": [
      "Will Rogers World Airport",
      "Will Rogers World Airport",
      "Will Rogers World Airport"
    ],
    "city": [
      "Oklahoma City",
      "Oklahoma City",
      "Oklahoma City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ODW",
    "translations": [
      "AJ Eisenberg Airport",
      "AJ Eisenberg Airport",
      "AJ Eisenberg Airport"
    ],
    "city": [
      "Oak Harbor",
      "Oak Harbor",
      "Oak Harbor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OKK",
    "translations": [
      "Kokomo Municipal Airport",
      "Kokomo Municipal Airport",
      "Kokomo Municipal Airport"
    ],
    "city": [
      "Kokomo",
      "Kokomo",
      "Kokomo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OKM",
    "translations": [
      "Okmulgee Regional Airport",
      "Okmulgee Regional Airport",
      "Okmulgee Regional Airport"
    ],
    "city": [
      "Okmulgee",
      "Okmulgee",
      "Okmulgee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OKS",
    "translations": [
      "Garden County Airport/King Rhiley Field",
      "Garden County Airport/King Rhiley Field",
      "Garden County Airport/King Rhiley Field"
    ],
    "city": [
      "Oshkosh",
      "Oshkosh",
      "Oshkosh"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WGO",
    "translations": [
      "Winchester Regional Airport",
      "Winchester Regional Airport",
      "Winchester Regional Airport"
    ],
    "city": [
      "Winchester",
      "Winchester",
      "Winchester"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OLD",
    "translations": [
      "Dewitt Field - Old Town Municipal Airport",
      "Dewitt Field - Old Town Municipal Airport",
      "Dewitt Field - Old Town Municipal Airport"
    ],
    "city": [
      "Old Town",
      "Old Town",
      "Old Town"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OLE",
    "translations": [
      "Cattaraugus County-Olean Airport",
      "Cattaraugus County-Olean Airport",
      "Cattaraugus County-Olean Airport"
    ],
    "city": [
      "Olean",
      "Olean",
      "Olean"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OLF",
    "translations": [
      "L M Clayton Airport",
      "L M Clayton Airport",
      "L M Clayton Airport"
    ],
    "city": [
      "Wolf Point",
      "Wolf Point",
      "Wolf Point"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OLM",
    "translations": [
      "Olympia Regional Airport",
      "Olympia Regional Airport",
      "Olympia Regional Airport"
    ],
    "city": [
      "Olympia",
      "Olympia",
      "Olympia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OLS",
    "translations": [
      "Nogales International Airport",
      "Nogales International Airport",
      "Nogales International Airport"
    ],
    "city": [
      "Nogales",
      "Nogales",
      "Nogales"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OLU",
    "translations": [
      "Columbus Municipal Airport",
      "Columbus Municipal Airport",
      "Columbus Municipal Airport"
    ],
    "city": [
      "Columbus",
      "Columbus",
      "Columbus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OLV",
    "translations": [
      "Olive Branch Airport",
      "Olive Branch Airport",
      "Olive Branch Airport"
    ],
    "city": [
      "Olive Branch",
      "Olive Branch",
      "Olive Branch"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OLY",
    "translations": [
      "Olney Noble Airport",
      "Olney Noble Airport",
      "Olney Noble Airport"
    ],
    "city": [
      "Olney-Noble",
      "Olney-Noble",
      "Olney-Noble"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OMA",
    "translations": [
      "Eppley Airfield",
      "Eppley Airfield",
      "Eppley Airfield"
    ],
    "city": [
      "Omaha",
      "Omaha",
      "Omaha"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OMK",
    "translations": [
      "Omak Airport",
      "Omak Airport",
      "Omak Airport"
    ],
    "city": [
      "Omak",
      "Omak",
      "Omak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ONA",
    "translations": [
      "Winona Municipal Airport Max Conrad Field",
      "Winona Municipal Airport Max Conrad Field",
      "Winona Municipal Airport Max Conrad Field"
    ],
    "city": [
      "Winona",
      "Winona",
      "Winona"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ONL",
    "translations": [
      "O'Neill Municipal Airport–John L Baker Field",
      "O'Neill Municipal Airport–John L Baker Field",
      "O'Neill Municipal Airport–John L Baker Field"
    ],
    "city": [
      "O'Neill",
      "O'Neill",
      "O'Neill"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ONM",
    "translations": [
      "Socorro Municipal Airport",
      "Socorro Municipal Airport",
      "Socorro Municipal Airport"
    ],
    "city": [
      "Socorro",
      "Socorro",
      "Socorro"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ONO",
    "translations": [
      "Ontario Municipal Airport",
      "Ontario Municipal Airport",
      "Ontario Municipal Airport"
    ],
    "city": [
      "Oregon",
      "Oregon",
      "Oregon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ONP",
    "translations": [
      "Newport Municipal Airport",
      "Newport Municipal Airport",
      "Newport Municipal Airport"
    ],
    "city": [
      "Newport",
      "Newport",
      "Newport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ONT",
    "translations": [
      "Ontario International Airport",
      "Ontario International Airport",
      "Ontario International Airport"
    ],
    "city": [
      "Ontario",
      "Ontario",
      "Ontario"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ONY",
    "translations": [
      "Olney Municipal Airport",
      "Olney Municipal Airport",
      "Olney Municipal Airport"
    ],
    "city": [
      "Olney",
      "Olney",
      "Olney"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OOA",
    "translations": [
      "Oskaloosa Municipal Airport",
      "Oskaloosa Municipal Airport",
      "Oskaloosa Municipal Airport"
    ],
    "city": [
      "Cedar",
      "Cedar",
      "Cedar"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OPF",
    "translations": [
      "Miami-Opa Locka Executive Airport",
      "Miami-Opa Locka Executive Airport",
      "Miami-Opa Locka Executive Airport"
    ],
    "city": [
      "Miami",
      "Miami",
      "Miami"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OPL",
    "translations": [
      "St Landry Parish Ahart Field",
      "St Landry Parish Ahart Field",
      "St Landry Parish Ahart Field"
    ],
    "city": [
      "Opelousas",
      "Opelousas",
      "Opelousas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NCO",
    "translations": [
      "Quonset State Airport",
      "Quonset State Airport",
      "Quonset State Airport"
    ],
    "city": [
      "North Kingstown",
      "North Kingstown",
      "North Kingstown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ORD",
    "translations": [
      "Chicago O'Hare International Airport",
      "Chicago O'Hare International Airport",
      "Chicago O'Hare International Airport"
    ],
    "city": [
      "Chicago",
      "Chicago",
      "Chicago"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ORF",
    "translations": [
      "Norfolk International Airport",
      "Norfolk International Airport",
      "Norfolk International Airport"
    ],
    "city": [
      "Norfolk",
      "Norfolk",
      "Norfolk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ORH",
    "translations": [
      "Worcester Regional Airport",
      "Worcester Regional Airport",
      "Worcester Regional Airport"
    ],
    "city": [
      "Worcester",
      "Worcester",
      "Worcester"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ORL",
    "translations": [
      "Orlando Executive Airport",
      "Orlando Executive Airport",
      "Orlando Executive Airport"
    ],
    "city": [
      "Orlando",
      "Orlando",
      "Orlando"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ESD",
    "translations": [
      "Orcas Island Airport",
      "Orcas Island Airport",
      "Orcas Island Airport"
    ],
    "city": [
      "Eastsound",
      "Eastsound",
      "Eastsound"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MPS",
    "translations": [
      "Mount Pleasant Regional Airport",
      "Mount Pleasant Regional Airport",
      "Mount Pleasant Regional Airport"
    ],
    "city": [
      "Mount Pleasant",
      "Mount Pleasant",
      "Mount Pleasant"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OSC",
    "translations": [
      "Oscoda Wurtsmith Airport",
      "Oscoda Wurtsmith Airport",
      "Oscoda Wurtsmith Airport"
    ],
    "city": [
      "Oscoda",
      "Oscoda",
      "Oscoda"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OSH",
    "translations": [
      "Wittman Regional Airport",
      "Wittman Regional Airport",
      "Wittman Regional Airport"
    ],
    "city": [
      "Oshkosh",
      "Oshkosh",
      "Oshkosh"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OSU",
    "translations": [
      "The Ohio State University Airport - Don Scott Field",
      "The Ohio State University Airport - Don Scott Field",
      "The Ohio State University Airport - Don Scott Field"
    ],
    "city": [
      "Columbus",
      "Columbus",
      "Columbus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OSX",
    "translations": [
      "Kosciusko Attala County Airport",
      "Kosciusko Attala County Airport",
      "Kosciusko Attala County Airport"
    ],
    "city": [
      "Kosciusko",
      "Kosciusko",
      "Kosciusko"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OTG",
    "translations": [
      "Worthington Municipal Airport",
      "Worthington Municipal Airport",
      "Worthington Municipal Airport"
    ],
    "city": [
      "Worthington",
      "Worthington",
      "Worthington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OTH",
    "translations": [
      "Southwest Oregon Regional Airport",
      "Southwest Oregon Regional Airport",
      "Southwest Oregon Regional Airport"
    ],
    "city": [
      "North Bend",
      "North Bend",
      "North Bend"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OTM",
    "translations": [
      "Ottumwa Regional Airport",
      "Ottumwa Regional Airport",
      "Ottumwa Regional Airport"
    ],
    "city": [
      "Ottumwa",
      "Ottumwa",
      "Ottumwa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OUN",
    "translations": [
      "University of Oklahoma Westheimer Airport",
      "University of Oklahoma Westheimer Airport",
      "University of Oklahoma Westheimer Airport"
    ],
    "city": [
      "Norman",
      "Norman",
      "Norman"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OVE",
    "translations": [
      "Oroville Municipal Airport",
      "Oroville Municipal Airport",
      "Oroville Municipal Airport"
    ],
    "city": [
      "Oroville",
      "Oroville",
      "Oroville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OWA",
    "translations": [
      "Owatonna Degner Regional Airport",
      "Owatonna Degner Regional Airport",
      "Owatonna Degner Regional Airport"
    ],
    "city": [
      "Owatonna",
      "Owatonna",
      "Owatonna"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OWB",
    "translations": [
      "Owensboro Daviess County Airport",
      "Owensboro Daviess County Airport",
      "Owensboro Daviess County Airport"
    ],
    "city": [
      "Owensboro",
      "Owensboro",
      "Owensboro"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OWD",
    "translations": [
      "Norwood Memorial Airport",
      "Norwood Memorial Airport",
      "Norwood Memorial Airport"
    ],
    "city": [
      "Norwood",
      "Norwood",
      "Norwood"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OWK",
    "translations": [
      "Central Maine/Norridgewock Airport",
      "Central Maine/Norridgewock Airport",
      "Central Maine/Norridgewock Airport"
    ],
    "city": [
      "Norridgewock",
      "Norridgewock",
      "Norridgewock"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OCE",
    "translations": [
      "Ocean City Municipal Airport",
      "Ocean City Municipal Airport",
      "Ocean City Municipal Airport"
    ],
    "city": [
      "Ocean City",
      "Ocean City",
      "Ocean City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OXC",
    "translations": [
      "Waterbury Oxford Airport",
      "Waterbury Oxford Airport",
      "Waterbury Oxford Airport"
    ],
    "city": [
      "Oxford",
      "Oxford",
      "Oxford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OXD",
    "translations": [
      "Miami University Airport",
      "Miami University Airport",
      "Miami University Airport"
    ],
    "city": [
      "Oxford",
      "Oxford",
      "Oxford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OXR",
    "translations": [
      "Oxnard Airport",
      "Oxnard Airport",
      "Oxnard Airport"
    ],
    "city": [
      "Oxnard",
      "Oxnard",
      "Oxnard"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KOY",
    "translations": [
      "Olga Bay Seaplane Base",
      "Olga Bay Seaplane Base",
      "Olga Bay Seaplane Base"
    ],
    "city": [
      "Olga Bay",
      "Olga Bay",
      "Olga Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "STQ",
    "translations": [
      "St Marys Municipal Airport",
      "St Marys Municipal Airport",
      "St Marys Municipal Airport"
    ],
    "city": [
      "St Marys",
      "St Marys",
      "St Marys"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OZA",
    "translations": [
      "Ozona Municipal Airport",
      "Ozona Municipal Airport",
      "Ozona Municipal Airport"
    ],
    "city": [
      "Ozona",
      "Ozona",
      "Ozona"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OZR",
    "translations": [
      "Cairns AAF (Fort Rucker) Air Field",
      "Cairns AAF (Fort Rucker) Air Field",
      "Cairns AAF (Fort Rucker) Air Field"
    ],
    "city": [
      "Fort Rucker/Ozark",
      "Fort Rucker/Ozark",
      "Fort Rucker/Ozark"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BSQ",
    "translations": [
      "Bisbee Municipal Airport",
      "Bisbee Municipal Airport",
      "Bisbee Municipal Airport"
    ],
    "city": [
      "Bisbee",
      "Bisbee",
      "Bisbee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PXL",
    "translations": [
      "Polacca Airport",
      "Polacca Airport",
      "Polacca Airport"
    ],
    "city": [
      "Polacca",
      "Polacca",
      "Polacca"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GLB",
    "translations": [
      "San Carlos Apache Airport",
      "San Carlos Apache Airport",
      "San Carlos Apache Airport"
    ],
    "city": [
      "Globe",
      "Globe",
      "Globe"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HBK",
    "translations": [
      "Holbrook Municipal Airport",
      "Holbrook Municipal Airport",
      "Holbrook Municipal Airport"
    ],
    "city": [
      "Holbrook",
      "Holbrook",
      "Holbrook"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CWX",
    "translations": [
      "Cochise County Airport",
      "Cochise County Airport",
      "Cochise County Airport"
    ],
    "city": [
      "Willcox",
      "Willcox",
      "Willcox"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CTW",
    "translations": [
      "Cottonwood Airport",
      "Cottonwood Airport",
      "Cottonwood Airport"
    ],
    "city": [
      "Cottonwood",
      "Cottonwood",
      "Cottonwood"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PAE",
    "translations": [
      "Seattle Paine Field International Airport",
      "Seattle Paine Field International Airport",
      "Seattle Paine Field International Airport"
    ],
    "city": [
      "Everett",
      "Everett",
      "Everett"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PAH",
    "translations": [
      "Barkley Regional Airport",
      "Barkley Regional Airport",
      "Barkley Regional Airport"
    ],
    "city": [
      "Paducah",
      "Paducah",
      "Paducah"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PAM",
    "translations": [
      "Tyndall Air Force Base",
      "Tyndall Air Force Base",
      "Tyndall Air Force Base"
    ],
    "city": [
      "Panama City",
      "Panama City",
      "Panama City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PJB",
    "translations": [
      "Payson Airport",
      "Payson Airport",
      "Payson Airport"
    ],
    "city": [
      "Payson",
      "Payson",
      "Payson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PAO",
    "translations": [
      "Palo Alto Airport",
      "Palo Alto Airport",
      "Palo Alto Airport"
    ],
    "city": [
      "Palo Alto",
      "Palo Alto",
      "Palo Alto"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KPB",
    "translations": [
      "Point Baker Seaplane Base",
      "Point Baker Seaplane Base",
      "Point Baker Seaplane Base"
    ],
    "city": [
      "Point Baker",
      "Point Baker",
      "Point Baker"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PBF",
    "translations": [
      "Pine Bluff Regional Airport, Grider Field",
      "Pine Bluff Regional Airport, Grider Field",
      "Pine Bluff Regional Airport, Grider Field"
    ],
    "city": [
      "Pine Bluff",
      "Pine Bluff",
      "Pine Bluff"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PBG",
    "translations": [
      "Plattsburgh International Airport",
      "Plattsburgh International Airport",
      "Plattsburgh International Airport"
    ],
    "city": [
      "Plattsburgh",
      "Plattsburgh",
      "Plattsburgh"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PBI",
    "translations": [
      "Palm Beach International Airport",
      "Palm Beach International Airport",
      "Palm Beach International Airport"
    ],
    "city": [
      "West Palm Beach",
      "West Palm Beach",
      "West Palm Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PVL",
    "translations": [
      "Pike County Airport Hatcher Field",
      "Pike County Airport Hatcher Field",
      "Pike County Airport Hatcher Field"
    ],
    "city": [
      "Pikeville",
      "Pikeville",
      "Pikeville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PCD",
    "translations": [
      "Prairie Du Chien Municipal Airport",
      "Prairie Du Chien Municipal Airport",
      "Prairie Du Chien Municipal Airport"
    ],
    "city": [
      "Prairie Du Chien",
      "Prairie Du Chien",
      "Prairie Du Chien"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PDK",
    "translations": [
      "DeKalb Peachtree Airport",
      "DeKalb Peachtree Airport",
      "DeKalb Peachtree Airport"
    ],
    "city": [
      "Atlanta",
      "Atlanta",
      "Atlanta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PDT",
    "translations": [
      "Eastern Oregon Regional Airport at Pendleton",
      "Eastern Oregon Regional Airport at Pendleton",
      "Eastern Oregon Regional Airport at Pendleton"
    ],
    "city": [
      "Pendleton",
      "Pendleton",
      "Pendleton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PDX",
    "translations": [
      "Portland International Airport",
      "Portland International Airport",
      "Portland International Airport"
    ],
    "city": [
      "Portland",
      "Portland",
      "Portland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PEQ",
    "translations": [
      "Pecos Municipal Airport",
      "Pecos Municipal Airport",
      "Pecos Municipal Airport"
    ],
    "city": [
      "Pecos",
      "Pecos",
      "Pecos"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PFC",
    "translations": [
      "Pacific City State Airport",
      "Pacific City State Airport",
      "Pacific City State Airport"
    ],
    "city": [
      "Pacific City",
      "Pacific City",
      "Pacific City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PGA",
    "translations": [
      "Page Municipal Airport",
      "Page Municipal Airport",
      "Page Municipal Airport"
    ],
    "city": [
      "Page",
      "Page",
      "Page"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PGD",
    "translations": [
      "Punta Gorda Airport",
      "Punta Gorda Airport",
      "Punta Gorda Airport"
    ],
    "city": [
      "Punta Gorda",
      "Punta Gorda",
      "Punta Gorda"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PGR",
    "translations": [
      "Kirk Field",
      "Kirk Field",
      "Kirk Field"
    ],
    "city": [
      "Paragould",
      "Paragould",
      "Paragould"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PGV",
    "translations": [
      "Pitt-Greenville Airport",
      "Pitt-Greenville Airport",
      "Pitt-Greenville Airport"
    ],
    "city": [
      "Greenville",
      "Greenville",
      "Greenville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PHD",
    "translations": [
      "Harry Clever Field",
      "Harry Clever Field",
      "Harry Clever Field"
    ],
    "city": [
      "New Philadelphia",
      "New Philadelphia",
      "New Philadelphia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PHF",
    "translations": [
      "Newport News Williamsburg International Airport",
      "Newport News Williamsburg International Airport",
      "Newport News Williamsburg International Airport"
    ],
    "city": [
      "Newport News",
      "Newport News",
      "Newport News"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ADR",
    "translations": [
      "Robert F Swinnie Airport",
      "Robert F Swinnie Airport",
      "Robert F Swinnie Airport"
    ],
    "city": [
      "Andrews",
      "Andrews",
      "Andrews"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PHK",
    "translations": [
      "Palm Beach County Glades Airport",
      "Palm Beach County Glades Airport",
      "Palm Beach County Glades Airport"
    ],
    "city": [
      "Pahokee",
      "Pahokee",
      "Pahokee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PHL",
    "translations": [
      "Philadelphia International Airport",
      "Philadelphia International Airport",
      "Philadelphia International Airport"
    ],
    "city": [
      "Philadelphia",
      "Philadelphia",
      "Philadelphia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PHN",
    "translations": [
      "St Clair County International Airport",
      "St Clair County International Airport",
      "St Clair County International Airport"
    ],
    "city": [
      "Port Huron",
      "Port Huron",
      "Port Huron"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PHP",
    "translations": [
      "Philip Airport",
      "Philip Airport",
      "Philip Airport"
    ],
    "city": [
      "Philip",
      "Philip",
      "Philip"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PHT",
    "translations": [
      "Henry County Airport",
      "Henry County Airport",
      "Henry County Airport"
    ],
    "city": [
      "Paris",
      "Paris",
      "Paris"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PHX",
    "translations": [
      "Phoenix Sky Harbor International Airport",
      "Phoenix Sky Harbor International Airport",
      "Phoenix Sky Harbor International Airport"
    ],
    "city": [
      "Phoenix",
      "Phoenix",
      "Phoenix"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PIA",
    "translations": [
      "General Wayne A. Downing Peoria International Airport",
      "General Wayne A. Downing Peoria International Airport",
      "General Wayne A. Downing Peoria International Airport"
    ],
    "city": [
      "Peoria",
      "Peoria",
      "Peoria"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PIB",
    "translations": [
      "Hattiesburg Laurel Regional Airport",
      "Hattiesburg Laurel Regional Airport",
      "Hattiesburg Laurel Regional Airport"
    ],
    "city": [
      "Moselle",
      "Moselle",
      "Moselle"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PIE",
    "translations": [
      "St. Petersburg Clearwater International Airport",
      "St. Petersburg Clearwater International Airport",
      "St. Petersburg Clearwater International Airport"
    ],
    "city": [
      "Pinellas Park",
      "Pinellas Park",
      "Pinellas Park"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PIH",
    "translations": [
      "Pocatello Regional Airport",
      "Pocatello Regional Airport",
      "Pocatello Regional Airport"
    ],
    "city": [
      "Pocatello",
      "Pocatello",
      "Pocatello"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PIM",
    "translations": [
      "Harris County Airport",
      "Harris County Airport",
      "Harris County Airport"
    ],
    "city": [
      "Pine Mountain",
      "Pine Mountain",
      "Pine Mountain"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PIR",
    "translations": [
      "Pierre Regional Airport",
      "Pierre Regional Airport",
      "Pierre Regional Airport"
    ],
    "city": [
      "Pierre",
      "Pierre",
      "Pierre"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PIT",
    "translations": [
      "Pittsburgh International Airport",
      "Pittsburgh International Airport",
      "Pittsburgh International Airport"
    ],
    "city": [
      "Pittsburgh",
      "Pittsburgh",
      "Pittsburgh"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PKB",
    "translations": [
      "Mid Ohio Valley Regional Airport",
      "Mid Ohio Valley Regional Airport",
      "Mid Ohio Valley Regional Airport"
    ],
    "city": [
      "Parkersburg (Williamstown)",
      "Parkersburg (Williamstown)",
      "Parkersburg (Williamstown)"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PKD",
    "translations": [
      "Park Rapids Municipal Airport Konshok Field",
      "Park Rapids Municipal Airport Konshok Field",
      "Park Rapids Municipal Airport Konshok Field"
    ],
    "city": [
      "Park Rapids",
      "Park Rapids",
      "Park Rapids"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PKF",
    "translations": [
      "Park Falls Municipal Airport",
      "Park Falls Municipal Airport",
      "Park Falls Municipal Airport"
    ],
    "city": [
      "Park Falls",
      "Park Falls",
      "Park Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KPL",
    "translations": [
      "Kapal Airport",
      "Kapal Airport",
      "Kapal Airport"
    ],
    "city": [
      "Kapal",
      "Kapal",
      "Kapal"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PLK",
    "translations": [
      "M. Graham Clark Downtown Airport",
      "M. Graham Clark Downtown Airport",
      "M. Graham Clark Downtown Airport"
    ],
    "city": [
      "Branson / Hollister",
      "Branson / Hollister",
      "Branson / Hollister"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PLN",
    "translations": [
      "Pellston Regional Airport of Emmet County Airport",
      "Pellston Regional Airport of Emmet County Airport",
      "Pellston Regional Airport of Emmet County Airport"
    ],
    "city": [
      "Pellston",
      "Pellston",
      "Pellston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PLR",
    "translations": [
      "St Clair County Airport",
      "St Clair County Airport",
      "St Clair County Airport"
    ],
    "city": [
      "Pell City",
      "Pell City",
      "Pell City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PMB",
    "translations": [
      "Pembina Municipal Airport",
      "Pembina Municipal Airport",
      "Pembina Municipal Airport"
    ],
    "city": [
      "Pembina",
      "Pembina",
      "Pembina"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PMD",
    "translations": [
      "Palmdale Regional Airport / USAF Plant 42 Airport",
      "Palmdale Regional Airport / USAF Plant 42 Airport",
      "Palmdale Regional Airport / USAF Plant 42 Airport"
    ],
    "city": [
      "Palmdale",
      "Palmdale",
      "Palmdale"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PMH",
    "translations": [
      "Greater Portsmouth Regional Airport",
      "Greater Portsmouth Regional Airport",
      "Greater Portsmouth Regional Airport"
    ],
    "city": [
      "Portsmouth",
      "Portsmouth",
      "Portsmouth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PPM",
    "translations": [
      "Pompano Beach Airpark",
      "Pompano Beach Airpark",
      "Pompano Beach Airpark"
    ],
    "city": [
      "Pompano Beach",
      "Pompano Beach",
      "Pompano Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PWY",
    "translations": [
      "Ralph Wenz Field",
      "Ralph Wenz Field",
      "Ralph Wenz Field"
    ],
    "city": [
      "Pinedale",
      "Pinedale",
      "Pinedale"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PNC",
    "translations": [
      "Ponca City Regional Airport",
      "Ponca City Regional Airport",
      "Ponca City Regional Airport"
    ],
    "city": [
      "Ponca City",
      "Ponca City",
      "Ponca City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PNE",
    "translations": [
      "Northeast Philadelphia Airport",
      "Northeast Philadelphia Airport",
      "Northeast Philadelphia Airport"
    ],
    "city": [
      "Philadelphia",
      "Philadelphia",
      "Philadelphia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PNN",
    "translations": [
      "Princeton Municipal Airport",
      "Princeton Municipal Airport",
      "Princeton Municipal Airport"
    ],
    "city": [
      "Princeton",
      "Princeton",
      "Princeton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PNS",
    "translations": [
      "Pensacola International Airport",
      "Pensacola International Airport",
      "Pensacola International Airport"
    ],
    "city": [
      "Pensacola",
      "Pensacola",
      "Pensacola"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "POB",
    "translations": [
      "Pope Field",
      "Pope Field",
      "Pope Field"
    ],
    "city": [
      "Fort Bragg",
      "Fort Bragg",
      "Fort Bragg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "POC",
    "translations": [
      "Brackett Field",
      "Brackett Field",
      "Brackett Field"
    ],
    "city": [
      "La Verne",
      "La Verne",
      "La Verne"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "POE",
    "translations": [
      "Polk Army Air Field",
      "Polk Army Air Field",
      "Polk Army Air Field"
    ],
    "city": [
      "Fort Polk",
      "Fort Polk",
      "Fort Polk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "POF",
    "translations": [
      "Poplar Bluff Municipal Airport",
      "Poplar Bluff Municipal Airport",
      "Poplar Bluff Municipal Airport"
    ],
    "city": [
      "Poplar Bluff",
      "Poplar Bluff",
      "Poplar Bluff"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "POH",
    "translations": [
      "Pocahontas Municipal Airport",
      "Pocahontas Municipal Airport",
      "Pocahontas Municipal Airport"
    ],
    "city": [
      "Pocahontas",
      "Pocahontas",
      "Pocahontas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "POU",
    "translations": [
      "Dutchess County Airport",
      "Dutchess County Airport",
      "Dutchess County Airport"
    ],
    "city": [
      "Poughkeepsie",
      "Poughkeepsie",
      "Poughkeepsie"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "POY",
    "translations": [
      "Powell Municipal Airport",
      "Powell Municipal Airport",
      "Powell Municipal Airport"
    ],
    "city": [
      "Powell",
      "Powell",
      "Powell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PPA",
    "translations": [
      "Perry Lefors Field",
      "Perry Lefors Field",
      "Perry Lefors Field"
    ],
    "city": [
      "Pampa",
      "Pampa",
      "Pampa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PPF",
    "translations": [
      "Tri-City Airport",
      "Tri-City Airport",
      "Tri-City Airport"
    ],
    "city": [
      "Parsons",
      "Parsons",
      "Parsons"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LPO",
    "translations": [
      "La Porte Municipal Airport",
      "La Porte Municipal Airport",
      "La Porte Municipal Airport"
    ],
    "city": [
      "La Porte",
      "La Porte",
      "La Porte"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PQI",
    "translations": [
      "Presque Isle International Airport",
      "Presque Isle International Airport",
      "Presque Isle International Airport"
    ],
    "city": [
      "Presque Isle",
      "Presque Isle",
      "Presque Isle"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PGL",
    "translations": [
      "Trent Lott International Airport",
      "Trent Lott International Airport",
      "Trent Lott International Airport"
    ],
    "city": [
      "Pascagoula",
      "Pascagoula",
      "Pascagoula"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KPR",
    "translations": [
      "Port Williams Seaplane Base",
      "Port Williams Seaplane Base",
      "Port Williams Seaplane Base"
    ],
    "city": [
      "Port Williams",
      "Port Williams",
      "Port Williams"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PRB",
    "translations": [
      "Paso Robles Municipal Airport",
      "Paso Robles Municipal Airport",
      "Paso Robles Municipal Airport"
    ],
    "city": [
      "Paso Robles",
      "Paso Robles",
      "Paso Robles"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PRC",
    "translations": [
      "Prescott International Airport - Ernest A. Love Field",
      "Prescott International Airport - Ernest A. Love Field",
      "Prescott International Airport - Ernest A. Love Field"
    ],
    "city": [
      "Prescott",
      "Prescott",
      "Prescott"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PRO",
    "translations": [
      "Perry Municipal Airport",
      "Perry Municipal Airport",
      "Perry Municipal Airport"
    ],
    "city": [
      "Perry",
      "Perry",
      "Perry"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PRX",
    "translations": [
      "Cox Field",
      "Cox Field",
      "Cox Field"
    ],
    "city": [
      "Paris",
      "Paris",
      "Paris"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PSB",
    "translations": [
      "Mid-State Regional Airport",
      "Mid-State Regional Airport",
      "Mid-State Regional Airport"
    ],
    "city": [
      "Philipsburg",
      "Philipsburg",
      "Philipsburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PSC",
    "translations": [
      "Tri Cities Airport",
      "Tri Cities Airport",
      "Tri Cities Airport"
    ],
    "city": [
      "Pasco",
      "Pasco",
      "Pasco"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PSF",
    "translations": [
      "Pittsfield Municipal Airport",
      "Pittsfield Municipal Airport",
      "Pittsfield Municipal Airport"
    ],
    "city": [
      "Pittsfield",
      "Pittsfield",
      "Pittsfield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PSK",
    "translations": [
      "New River Valley Airport",
      "New River Valley Airport",
      "New River Valley Airport"
    ],
    "city": [
      "Dublin",
      "Dublin",
      "Dublin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PSM",
    "translations": [
      "Portsmouth International at Pease Airport",
      "Portsmouth International at Pease Airport",
      "Portsmouth International at Pease Airport"
    ],
    "city": [
      "Portsmouth",
      "Portsmouth",
      "Portsmouth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PSN",
    "translations": [
      "Palestine Municipal Airport",
      "Palestine Municipal Airport",
      "Palestine Municipal Airport"
    ],
    "city": [
      "Palestine",
      "Palestine",
      "Palestine"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PGO",
    "translations": [
      "Stevens Field",
      "Stevens Field",
      "Stevens Field"
    ],
    "city": [
      "Pagosa Springs",
      "Pagosa Springs",
      "Pagosa Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PSP",
    "translations": [
      "Palm Springs International Airport",
      "Palm Springs International Airport",
      "Palm Springs International Airport"
    ],
    "city": [
      "Palm Springs",
      "Palm Springs",
      "Palm Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PSX",
    "translations": [
      "Palacios Municipal Airport",
      "Palacios Municipal Airport",
      "Palacios Municipal Airport"
    ],
    "city": [
      "Palacios",
      "Palacios",
      "Palacios"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PTB",
    "translations": [
      "Dinwiddie County Airport",
      "Dinwiddie County Airport",
      "Dinwiddie County Airport"
    ],
    "city": [
      "Petersburg",
      "Petersburg",
      "Petersburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PTK",
    "translations": [
      "Oakland County International Airport",
      "Oakland County International Airport",
      "Oakland County International Airport"
    ],
    "city": [
      "Pontiac",
      "Pontiac",
      "Pontiac"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PTN",
    "translations": [
      "Harry P Williams Memorial Airport",
      "Harry P Williams Memorial Airport",
      "Harry P Williams Memorial Airport"
    ],
    "city": [
      "Patterson",
      "Patterson",
      "Patterson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PTS",
    "translations": [
      "Atkinson Municipal Airport",
      "Atkinson Municipal Airport",
      "Atkinson Municipal Airport"
    ],
    "city": [
      "Pittsburg",
      "Pittsburg",
      "Pittsburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PTT",
    "translations": [
      "Pratt Regional Airport",
      "Pratt Regional Airport",
      "Pratt Regional Airport"
    ],
    "city": [
      "Pratt",
      "Pratt",
      "Pratt"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PTV",
    "translations": [
      "Porterville Municipal Airport",
      "Porterville Municipal Airport",
      "Porterville Municipal Airport"
    ],
    "city": [
      "Porterville",
      "Porterville",
      "Porterville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PTW",
    "translations": [
      "Heritage Field",
      "Heritage Field",
      "Heritage Field"
    ],
    "city": [
      "Pottstown",
      "Pottstown",
      "Pottstown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PUB",
    "translations": [
      "Pueblo Memorial Airport",
      "Pueblo Memorial Airport",
      "Pueblo Memorial Airport"
    ],
    "city": [
      "Pueblo",
      "Pueblo",
      "Pueblo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PUC",
    "translations": [
      "Carbon County Regional Airport / Buck Davis Field",
      "Carbon County Regional Airport / Buck Davis Field",
      "Carbon County Regional Airport / Buck Davis Field"
    ],
    "city": [
      "Price",
      "Price",
      "Price"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PUW",
    "translations": [
      "Pullman-Moscow Regional Airport",
      "Pullman-Moscow Regional Airport",
      "Pullman-Moscow Regional Airport"
    ],
    "city": [
      "Pullman",
      "Pullman",
      "Pullman"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PVC",
    "translations": [
      "Provincetown Municipal Airport",
      "Provincetown Municipal Airport",
      "Provincetown Municipal Airport"
    ],
    "city": [
      "Provincetown",
      "Provincetown",
      "Provincetown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PVD",
    "translations": [
      "Theodore Francis Green State Airport",
      "Theodore Francis Green State Airport",
      "Theodore Francis Green State Airport"
    ],
    "city": [
      "Warwick",
      "Warwick",
      "Warwick"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PVF",
    "translations": [
      "Placerville Airport",
      "Placerville Airport",
      "Placerville Airport"
    ],
    "city": [
      "Placerville",
      "Placerville",
      "Placerville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PVU",
    "translations": [
      "Provo-Utah Lake International Airport",
      "Provo-Utah Lake International Airport",
      "Provo-Utah Lake International Airport"
    ],
    "city": [
      "Provo",
      "Provo",
      "Provo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PVW",
    "translations": [
      "Hale County Airport",
      "Hale County Airport",
      "Hale County Airport"
    ],
    "city": [
      "Plainview",
      "Plainview",
      "Plainview"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PWA",
    "translations": [
      "Wiley Post Airport",
      "Wiley Post Airport",
      "Wiley Post Airport"
    ],
    "city": [
      "Oklahoma City",
      "Oklahoma City",
      "Oklahoma City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PWD",
    "translations": [
      "Sher-Wood Airport",
      "Sher-Wood Airport",
      "Sher-Wood Airport"
    ],
    "city": [
      "Plentywood",
      "Plentywood",
      "Plentywood"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PWK",
    "translations": [
      "Chicago Executive Airport",
      "Chicago Executive Airport",
      "Chicago Executive Airport"
    ],
    "city": [
      "Chicago/Prospect Heights/Wheeling",
      "Chicago/Prospect Heights/Wheeling",
      "Chicago/Prospect Heights/Wheeling"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PWM",
    "translations": [
      "Portland International Jetport",
      "Portland International Jetport",
      "Portland International Jetport"
    ],
    "city": [
      "Portland",
      "Portland",
      "Portland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PWT",
    "translations": [
      "Bremerton National Airport",
      "Bremerton National Airport",
      "Bremerton National Airport"
    ],
    "city": [
      "Bremerton",
      "Bremerton",
      "Bremerton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KPY",
    "translations": [
      "Port Bailey Seaplane Base",
      "Port Bailey Seaplane Base",
      "Port Bailey Seaplane Base"
    ],
    "city": [
      "Port Bailey",
      "Port Bailey",
      "Port Bailey"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PYM",
    "translations": [
      "Plymouth Municipal Airport",
      "Plymouth Municipal Airport",
      "Plymouth Municipal Airport"
    ],
    "city": [
      "Plymouth",
      "Plymouth",
      "Plymouth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JCJ",
    "translations": [
      "Chuja Port Heliport",
      "Chuja Port Heliport",
      "Chuja Port Heliport"
    ],
    "city": [
      "Chuja, Hach’uja-do (Chujado Islands)",
      "Chuja, Hach’uja-do (Chujado Islands)",
      "Chuja, Hach’uja-do (Chujado Islands)"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "RAC",
    "translations": [
      "John H Batten Airport",
      "John H Batten Airport",
      "John H Batten Airport"
    ],
    "city": [
      "Racine",
      "Racine",
      "Racine"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RAL",
    "translations": [
      "Riverside Municipal Airport",
      "Riverside Municipal Airport",
      "Riverside Municipal Airport"
    ],
    "city": [
      "Riverside",
      "Riverside",
      "Riverside"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RAP",
    "translations": [
      "Rapid City Regional Airport",
      "Rapid City Regional Airport",
      "Rapid City Regional Airport"
    ],
    "city": [
      "Rapid City",
      "Rapid City",
      "Rapid City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RBD",
    "translations": [
      "Dallas Executive Airport",
      "Dallas Executive Airport",
      "Dallas Executive Airport"
    ],
    "city": [
      "Dallas",
      "Dallas",
      "Dallas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RBG",
    "translations": [
      "Roseburg Regional Airport",
      "Roseburg Regional Airport",
      "Roseburg Regional Airport"
    ],
    "city": [
      "Roseburg",
      "Roseburg",
      "Roseburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RBL",
    "translations": [
      "Red Bluff Municipal Airport",
      "Red Bluff Municipal Airport",
      "Red Bluff Municipal Airport"
    ],
    "city": [
      "Red Bluff",
      "Red Bluff",
      "Red Bluff"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RBW",
    "translations": [
      "Lowcountry Regional Airport",
      "Lowcountry Regional Airport",
      "Lowcountry Regional Airport"
    ],
    "city": [
      "Walterboro",
      "Walterboro",
      "Walterboro"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RCA",
    "translations": [
      "Ellsworth Air Force Base",
      "Ellsworth Air Force Base",
      "Ellsworth Air Force Base"
    ],
    "city": [
      "Rapid City",
      "Rapid City",
      "Rapid City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RCK",
    "translations": [
      "H H Coffield Regional Airport",
      "H H Coffield Regional Airport",
      "H H Coffield Regional Airport"
    ],
    "city": [
      "Rockdale",
      "Rockdale",
      "Rockdale"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RCR",
    "translations": [
      "Fulton County Airport",
      "Fulton County Airport",
      "Fulton County Airport"
    ],
    "city": [
      "Rochester",
      "Rochester",
      "Rochester"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RCT",
    "translations": [
      "Nartron Field",
      "Nartron Field",
      "Nartron Field"
    ],
    "city": [
      "Reed City",
      "Reed City",
      "Reed City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RDD",
    "translations": [
      "Redding Municipal Airport",
      "Redding Municipal Airport",
      "Redding Municipal Airport"
    ],
    "city": [
      "Redding",
      "Redding",
      "Redding"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RDG",
    "translations": [
      "Reading Regional Airport (Carl A Spaatz Field)",
      "Reading Regional Airport (Carl A Spaatz Field)",
      "Reading Regional Airport (Carl A Spaatz Field)"
    ],
    "city": [
      "Reading",
      "Reading",
      "Reading"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RDM",
    "translations": [
      "Roberts Field",
      "Roberts Field",
      "Roberts Field"
    ],
    "city": [
      "Redmond",
      "Redmond",
      "Redmond"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RDR",
    "translations": [
      "Grand Forks Air Force Base",
      "Grand Forks Air Force Base",
      "Grand Forks Air Force Base"
    ],
    "city": [
      "Grand Forks",
      "Grand Forks",
      "Grand Forks"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RDU",
    "translations": [
      "Raleigh Durham International Airport",
      "Raleigh Durham International Airport",
      "Raleigh Durham International Airport"
    ],
    "city": [
      "Raleigh/Durham",
      "Raleigh/Durham",
      "Raleigh/Durham"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "REO",
    "translations": [
      "Rome State Airport",
      "Rome State Airport",
      "Rome State Airport"
    ],
    "city": [
      "Rome",
      "Rome",
      "Rome"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RFD",
    "translations": [
      "Chicago Rockford International Airport",
      "Chicago Rockford International Airport",
      "Chicago Rockford International Airport"
    ],
    "city": [
      "Chicago/Rockford",
      "Chicago/Rockford",
      "Chicago/Rockford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RFG",
    "translations": [
      "Rooke Field",
      "Rooke Field",
      "Rooke Field"
    ],
    "city": [
      "Refugio",
      "Refugio",
      "Refugio"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RHI",
    "translations": [
      "Rhinelander Oneida County Airport",
      "Rhinelander Oneida County Airport",
      "Rhinelander Oneida County Airport"
    ],
    "city": [
      "Rhinelander",
      "Rhinelander",
      "Rhinelander"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RHV",
    "translations": [
      "Reid-Hillview Airport of Santa Clara County",
      "Reid-Hillview Airport of Santa Clara County",
      "Reid-Hillview Airport of Santa Clara County"
    ],
    "city": [
      "San Jose",
      "San Jose",
      "San Jose"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RIC",
    "translations": [
      "Richmond International Airport",
      "Richmond International Airport",
      "Richmond International Airport"
    ],
    "city": [
      "Richmond",
      "Richmond",
      "Richmond"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RID",
    "translations": [
      "Richmond Municipal Airport",
      "Richmond Municipal Airport",
      "Richmond Municipal Airport"
    ],
    "city": [
      "Richmond",
      "Richmond",
      "Richmond"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RIF",
    "translations": [
      "Richfield Municipal Airport",
      "Richfield Municipal Airport",
      "Richfield Municipal Airport"
    ],
    "city": [
      "Richfield",
      "Richfield",
      "Richfield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RIL",
    "translations": [
      "Garfield County Regional Airport",
      "Garfield County Regional Airport",
      "Garfield County Regional Airport"
    ],
    "city": [
      "Rifle",
      "Rifle",
      "Rifle"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RIR",
    "translations": [
      "Flabob Airport",
      "Flabob Airport",
      "Flabob Airport"
    ],
    "city": [
      "Riverside",
      "Riverside",
      "Riverside"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RIV",
    "translations": [
      "March Air Reserve Base",
      "March Air Reserve Base",
      "March Air Reserve Base"
    ],
    "city": [
      "Riverside",
      "Riverside",
      "Riverside"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RIW",
    "translations": [
      "Central Wyoming Regional Airport",
      "Central Wyoming Regional Airport",
      "Central Wyoming Regional Airport"
    ],
    "city": [
      "Riverton",
      "Riverton",
      "Riverton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RKD",
    "translations": [
      "Knox County Regional Airport",
      "Knox County Regional Airport",
      "Knox County Regional Airport"
    ],
    "city": [
      "Rockland",
      "Rockland",
      "Rockland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RKP",
    "translations": [
      "Aransas County Airport",
      "Aransas County Airport",
      "Aransas County Airport"
    ],
    "city": [
      "Rockport",
      "Rockport",
      "Rockport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RKR",
    "translations": [
      "Robert S Kerr Airport",
      "Robert S Kerr Airport",
      "Robert S Kerr Airport"
    ],
    "city": [
      "Poteau",
      "Poteau",
      "Poteau"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RKS",
    "translations": [
      "Southwest Wyoming Regional Airport",
      "Southwest Wyoming Regional Airport",
      "Southwest Wyoming Regional Airport"
    ],
    "city": [
      "Rock Springs",
      "Rock Springs",
      "Rock Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RKW",
    "translations": [
      "Rockwood Municipal Airport",
      "Rockwood Municipal Airport",
      "Rockwood Municipal Airport"
    ],
    "city": [
      "Rockwood",
      "Rockwood",
      "Rockwood"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RLD",
    "translations": [
      "Richland Airport",
      "Richland Airport",
      "Richland Airport"
    ],
    "city": [
      "Richland",
      "Richland",
      "Richland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RME",
    "translations": [
      "Griffiss International Airport",
      "Griffiss International Airport",
      "Griffiss International Airport"
    ],
    "city": [
      "Rome",
      "Rome",
      "Rome"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RMG",
    "translations": [
      "Richard B Russell Airport",
      "Richard B Russell Airport",
      "Richard B Russell Airport"
    ],
    "city": [
      "Rome",
      "Rome",
      "Rome"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RNC",
    "translations": [
      "Warren County Memorial Airport",
      "Warren County Memorial Airport",
      "Warren County Memorial Airport"
    ],
    "city": [
      "Mc Minnville",
      "Mc Minnville",
      "Mc Minnville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RND",
    "translations": [
      "Randolph Air Force Base",
      "Randolph Air Force Base",
      "Randolph Air Force Base"
    ],
    "city": [
      "Universal City",
      "Universal City",
      "Universal City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RNH",
    "translations": [
      "New Richmond Regional Airport",
      "New Richmond Regional Airport",
      "New Richmond Regional Airport"
    ],
    "city": [
      "New Richmond",
      "New Richmond",
      "New Richmond"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RNO",
    "translations": [
      "Reno Tahoe International Airport",
      "Reno Tahoe International Airport",
      "Reno Tahoe International Airport"
    ],
    "city": [
      "Reno",
      "Reno",
      "Reno"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RNT",
    "translations": [
      "Renton Municipal Airport",
      "Renton Municipal Airport",
      "Renton Municipal Airport"
    ],
    "city": [
      "Renton",
      "Renton",
      "Renton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ROA",
    "translations": [
      "Roanoke–Blacksburg Regional Airport",
      "Roanoke–Blacksburg Regional Airport",
      "Roanoke–Blacksburg Regional Airport"
    ],
    "city": [
      "Roanoke",
      "Roanoke",
      "Roanoke"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ROC",
    "translations": [
      "Frederick Douglass Greater Rochester International Airport",
      "Frederick Douglass Greater Rochester International Airport",
      "Frederick Douglass Greater Rochester International Airport"
    ],
    "city": [
      "Rochester",
      "Rochester",
      "Rochester"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ROG",
    "translations": [
      "Rogers Municipal Airport-Carter Field",
      "Rogers Municipal Airport-Carter Field",
      "Rogers Municipal Airport-Carter Field"
    ],
    "city": [
      "Rogers",
      "Rogers",
      "Rogers"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ROW",
    "translations": [
      "Roswell Air Center Airport",
      "Roswell Air Center Airport",
      "Roswell Air Center Airport"
    ],
    "city": [
      "Roswell",
      "Roswell",
      "Roswell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ROX",
    "translations": [
      "Roseau Municipal Rudy Billberg Field",
      "Roseau Municipal Rudy Billberg Field",
      "Roseau Municipal Rudy Billberg Field"
    ],
    "city": [
      "Roseau",
      "Roseau",
      "Roseau"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RIE",
    "translations": [
      "Rice Lake Regional Airport - Carl's Field",
      "Rice Lake Regional Airport - Carl's Field",
      "Rice Lake Regional Airport - Carl's Field"
    ],
    "city": [
      "Rice Lake",
      "Rice Lake",
      "Rice Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RPX",
    "translations": [
      "Roundup Airport",
      "Roundup Airport",
      "Roundup Airport"
    ],
    "city": [
      "Roundup",
      "Roundup",
      "Roundup"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WBR",
    "translations": [
      "Roben Hood Airport",
      "Roben Hood Airport",
      "Roben Hood Airport"
    ],
    "city": [
      "Big Rapids",
      "Big Rapids",
      "Big Rapids"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RQO",
    "translations": [
      "El Reno Regional Airport",
      "El Reno Regional Airport",
      "El Reno Regional Airport"
    ],
    "city": [
      "El Reno",
      "El Reno",
      "El Reno"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RRL",
    "translations": [
      "Merrill Municipal Airport",
      "Merrill Municipal Airport",
      "Merrill Municipal Airport"
    ],
    "city": [
      "Merrill",
      "Merrill",
      "Merrill"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RRT",
    "translations": [
      "Warroad International Memorial Airport",
      "Warroad International Memorial Airport",
      "Warroad International Memorial Airport"
    ],
    "city": [
      "Warroad",
      "Warroad",
      "Warroad"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RSL",
    "translations": [
      "Russell Municipal Airport",
      "Russell Municipal Airport",
      "Russell Municipal Airport"
    ],
    "city": [
      "Russell",
      "Russell",
      "Russell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RSN",
    "translations": [
      "Ruston Regional Airport",
      "Ruston Regional Airport",
      "Ruston Regional Airport"
    ],
    "city": [
      "Ruston",
      "Ruston",
      "Ruston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RST",
    "translations": [
      "Rochester International Airport",
      "Rochester International Airport",
      "Rochester International Airport"
    ],
    "city": [
      "Rochester",
      "Rochester",
      "Rochester"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RSW",
    "translations": [
      "Southwest Florida International Airport",
      "Southwest Florida International Airport",
      "Southwest Florida International Airport"
    ],
    "city": [
      "Fort Myers",
      "Fort Myers",
      "Fort Myers"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RTN",
    "translations": [
      "Raton Municipal Airport / Crews Field",
      "Raton Municipal Airport / Crews Field",
      "Raton Municipal Airport / Crews Field"
    ],
    "city": [
      "Raton",
      "Raton",
      "Raton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SRW",
    "translations": [
      "Mid-Carolina Regional Airport",
      "Mid-Carolina Regional Airport",
      "Mid-Carolina Regional Airport"
    ],
    "city": [
      "Salisbury",
      "Salisbury",
      "Salisbury"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RUT",
    "translations": [
      "Rutland - Southern Vermont Regional Airport",
      "Rutland - Southern Vermont Regional Airport",
      "Rutland - Southern Vermont Regional Airport"
    ],
    "city": [
      "Rutland",
      "Rutland",
      "Rutland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RED",
    "translations": [
      "Mifflin County Airport",
      "Mifflin County Airport",
      "Mifflin County Airport"
    ],
    "city": [
      "Reedsville",
      "Reedsville",
      "Reedsville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RVS",
    "translations": [
      "Tulsa Riverside Airport",
      "Tulsa Riverside Airport",
      "Tulsa Riverside Airport"
    ],
    "city": [
      "Tulsa",
      "Tulsa",
      "Tulsa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RWF",
    "translations": [
      "Redwood Falls Municipal Airport",
      "Redwood Falls Municipal Airport",
      "Redwood Falls Municipal Airport"
    ],
    "city": [
      "Redwood Falls",
      "Redwood Falls",
      "Redwood Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RWI",
    "translations": [
      "Rocky Mount Wilson Regional Airport",
      "Rocky Mount Wilson Regional Airport",
      "Rocky Mount Wilson Regional Airport"
    ],
    "city": [
      "Rocky Mount",
      "Rocky Mount",
      "Rocky Mount"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RWL",
    "translations": [
      "Rawlins Municipal Airport/Harvey Field",
      "Rawlins Municipal Airport/Harvey Field",
      "Rawlins Municipal Airport/Harvey Field"
    ],
    "city": [
      "Rawlins",
      "Rawlins",
      "Rawlins"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RXE",
    "translations": [
      "Rexburg Madison County Airport",
      "Rexburg Madison County Airport",
      "Rexburg Madison County Airport"
    ],
    "city": [
      "Rexburg",
      "Rexburg",
      "Rexburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RNZ",
    "translations": [
      "Jasper County Airport",
      "Jasper County Airport",
      "Jasper County Airport"
    ],
    "city": [
      "Rensselaer",
      "Rensselaer",
      "Rensselaer"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AHM",
    "translations": [
      "Ashland Municipal Airport Sumner Parker Field",
      "Ashland Municipal Airport Sumner Parker Field",
      "Ashland Municipal Airport Sumner Parker Field"
    ],
    "city": [
      "Ashland",
      "Ashland",
      "Ashland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BDY",
    "translations": [
      "Bandon State Airport",
      "Bandon State Airport",
      "Bandon State Airport"
    ],
    "city": [
      "Bandon",
      "Bandon",
      "Bandon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SUO",
    "translations": [
      "Sunriver Airport",
      "Sunriver Airport",
      "Sunriver Airport"
    ],
    "city": [
      "Sunriver",
      "Sunriver",
      "Sunriver"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MDJ",
    "translations": [
      "Madras Municipal Airport",
      "Madras Municipal Airport",
      "Madras Municipal Airport"
    ],
    "city": [
      "Madras",
      "Madras",
      "Madras"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PRZ",
    "translations": [
      "Prineville Airport",
      "Prineville Airport",
      "Prineville Airport"
    ],
    "city": [
      "Prineville",
      "Prineville",
      "Prineville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SAA",
    "translations": [
      "Shively Field",
      "Shively Field",
      "Shively Field"
    ],
    "city": [
      "Saratoga",
      "Saratoga",
      "Saratoga"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SAC",
    "translations": [
      "Sacramento Executive Airport",
      "Sacramento Executive Airport",
      "Sacramento Executive Airport"
    ],
    "city": [
      "Sacramento",
      "Sacramento",
      "Sacramento"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SAD",
    "translations": [
      "Safford Regional Airport",
      "Safford Regional Airport",
      "Safford Regional Airport"
    ],
    "city": [
      "Safford",
      "Safford",
      "Safford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SAF",
    "translations": [
      "Santa Fe Municipal Airport",
      "Santa Fe Municipal Airport",
      "Santa Fe Municipal Airport"
    ],
    "city": [
      "Santa Fe",
      "Santa Fe",
      "Santa Fe"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SAN",
    "translations": [
      "San Diego International Airport",
      "San Diego International Airport",
      "San Diego International Airport"
    ],
    "city": [
      "San Diego",
      "San Diego",
      "San Diego"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SAR",
    "translations": [
      "Sparta Community Airport - Hunter Field",
      "Sparta Community Airport - Hunter Field",
      "Sparta Community Airport - Hunter Field"
    ],
    "city": [
      "Sparta",
      "Sparta",
      "Sparta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SAS",
    "translations": [
      "Salton Sea Airport",
      "Salton Sea Airport",
      "Salton Sea Airport"
    ],
    "city": [
      "Salton City",
      "Salton City",
      "Salton City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SAT",
    "translations": [
      "San Antonio International Airport",
      "San Antonio International Airport",
      "San Antonio International Airport"
    ],
    "city": [
      "San Antonio",
      "San Antonio",
      "San Antonio"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SAV",
    "translations": [
      "Savannah Hilton Head International Airport",
      "Savannah Hilton Head International Airport",
      "Savannah Hilton Head International Airport"
    ],
    "city": [
      "Savannah",
      "Savannah",
      "Savannah"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MQT",
    "translations": [
      "Marquette/Sawyer International Airport",
      "Marquette/Sawyer International Airport",
      "Marquette/Sawyer International Airport"
    ],
    "city": [
      "Gwinn",
      "Gwinn",
      "Gwinn"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SBA",
    "translations": [
      "Santa Barbara Municipal Airport",
      "Santa Barbara Municipal Airport",
      "Santa Barbara Municipal Airport"
    ],
    "city": [
      "Santa Barbara",
      "Santa Barbara",
      "Santa Barbara"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SBD",
    "translations": [
      "San Bernardino International Airport",
      "San Bernardino International Airport",
      "San Bernardino International Airport"
    ],
    "city": [
      "San Bernardino",
      "San Bernardino",
      "San Bernardino"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SBM",
    "translations": [
      "Sheboygan County Memorial Airport",
      "Sheboygan County Memorial Airport",
      "Sheboygan County Memorial Airport"
    ],
    "city": [
      "Sheboygan",
      "Sheboygan",
      "Sheboygan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SBN",
    "translations": [
      "South Bend Regional Airport",
      "South Bend Regional Airport",
      "South Bend Regional Airport"
    ],
    "city": [
      "South Bend",
      "South Bend",
      "South Bend"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SBP",
    "translations": [
      "San Luis County Regional Airport",
      "San Luis County Regional Airport",
      "San Luis County Regional Airport"
    ],
    "city": [
      "San Luis Obispo",
      "San Luis Obispo",
      "San Luis Obispo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SBS",
    "translations": [
      "Steamboat Springs Bob Adams Field",
      "Steamboat Springs Bob Adams Field",
      "Steamboat Springs Bob Adams Field"
    ],
    "city": [
      "Steamboat Springs",
      "Steamboat Springs",
      "Steamboat Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SBX",
    "translations": [
      "Shelby Airport",
      "Shelby Airport",
      "Shelby Airport"
    ],
    "city": [
      "Shelby",
      "Shelby",
      "Shelby"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SBY",
    "translations": [
      "Salisbury Ocean City Wicomico Regional Airport",
      "Salisbury Ocean City Wicomico Regional Airport",
      "Salisbury Ocean City Wicomico Regional Airport"
    ],
    "city": [
      "Salisbury",
      "Salisbury",
      "Salisbury"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SCB",
    "translations": [
      "Scribner State Airport",
      "Scribner State Airport",
      "Scribner State Airport"
    ],
    "city": [
      "Scribner",
      "Scribner",
      "Scribner"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SCH",
    "translations": [
      "Schenectady County Airport",
      "Schenectady County Airport",
      "Schenectady County Airport"
    ],
    "city": [
      "Schenectady",
      "Schenectady",
      "Schenectady"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SCK",
    "translations": [
      "Stockton Metropolitan Airport",
      "Stockton Metropolitan Airport",
      "Stockton Metropolitan Airport"
    ],
    "city": [
      "Stockton",
      "Stockton",
      "Stockton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SDF",
    "translations": [
      "Louisville Muhammad Ali International Airport",
      "Louisville Muhammad Ali International Airport",
      "Louisville Muhammad Ali International Airport"
    ],
    "city": [
      "Louisville",
      "Louisville",
      "Louisville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SCF",
    "translations": [
      "Scottsdale Airport",
      "Scottsdale Airport",
      "Scottsdale Airport"
    ],
    "city": [
      "Scottsdale",
      "Scottsdale",
      "Scottsdale"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SDM",
    "translations": [
      "Brown Field Municipal Airport",
      "Brown Field Municipal Airport",
      "Brown Field Municipal Airport"
    ],
    "city": [
      "San Diego",
      "San Diego",
      "San Diego"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SDY",
    "translations": [
      "Sidney - Richland Regional Airport",
      "Sidney - Richland Regional Airport",
      "Sidney - Richland Regional Airport"
    ],
    "city": [
      "Sidney",
      "Sidney",
      "Sidney"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SEA",
    "translations": [
      "Seattle–Tacoma International Airport",
      "Seattle–Tacoma International Airport",
      "Seattle–Tacoma International Airport"
    ],
    "city": [
      "Seattle",
      "Seattle",
      "Seattle"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SEE",
    "translations": [
      "Gillespie Field",
      "Gillespie Field",
      "Gillespie Field"
    ],
    "city": [
      "San Diego/El Cajon",
      "San Diego/El Cajon",
      "San Diego/El Cajon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SEF",
    "translations": [
      "Sebring Regional Airport",
      "Sebring Regional Airport",
      "Sebring Regional Airport"
    ],
    "city": [
      "Sebring",
      "Sebring",
      "Sebring"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SEG",
    "translations": [
      "Penn Valley Airport",
      "Penn Valley Airport",
      "Penn Valley Airport"
    ],
    "city": [
      "Selinsgrove",
      "Selinsgrove",
      "Selinsgrove"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SEM",
    "translations": [
      "Craig Field",
      "Craig Field",
      "Craig Field"
    ],
    "city": [
      "Selma",
      "Selma",
      "Selma"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SEP",
    "translations": [
      "Stephenville Clark Regional Airport",
      "Stephenville Clark Regional Airport",
      "Stephenville Clark Regional Airport"
    ],
    "city": [
      "Stephenville",
      "Stephenville",
      "Stephenville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SER",
    "translations": [
      "Freeman Municipal Airport",
      "Freeman Municipal Airport",
      "Freeman Municipal Airport"
    ],
    "city": [
      "Seymour",
      "Seymour",
      "Seymour"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SDX",
    "translations": [
      "Sedona Airport",
      "Sedona Airport",
      "Sedona Airport"
    ],
    "city": [
      "Sedona",
      "Sedona",
      "Sedona"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SFB",
    "translations": [
      "Orlando Sanford International Airport",
      "Orlando Sanford International Airport",
      "Orlando Sanford International Airport"
    ],
    "city": [
      "Orlando",
      "Orlando",
      "Orlando"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SFF",
    "translations": [
      "Felts Field",
      "Felts Field",
      "Felts Field"
    ],
    "city": [
      "Spokane",
      "Spokane",
      "Spokane"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SFM",
    "translations": [
      "Sanford Seacoast Regional Airport",
      "Sanford Seacoast Regional Airport",
      "Sanford Seacoast Regional Airport"
    ],
    "city": [
      "Sanford",
      "Sanford",
      "Sanford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SFO",
    "translations": [
      "San Francisco International Airport",
      "San Francisco International Airport",
      "San Francisco International Airport"
    ],
    "city": [
      "San Francisco",
      "San Francisco",
      "San Francisco"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SFZ",
    "translations": [
      "North Central State Airport",
      "North Central State Airport",
      "North Central State Airport"
    ],
    "city": [
      "Pawtucket",
      "Pawtucket",
      "Pawtucket"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SGF",
    "translations": [
      "Springfield Branson National Airport",
      "Springfield Branson National Airport",
      "Springfield Branson National Airport"
    ],
    "city": [
      "Springfield",
      "Springfield",
      "Springfield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SGH",
    "translations": [
      "Springfield-Beckley Municipal Airport",
      "Springfield-Beckley Municipal Airport",
      "Springfield-Beckley Municipal Airport"
    ],
    "city": [
      "Springfield",
      "Springfield",
      "Springfield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UST",
    "translations": [
      "Northeast Florida Regional Airport",
      "Northeast Florida Regional Airport",
      "Northeast Florida Regional Airport"
    ],
    "city": [
      "St Augustine",
      "St Augustine",
      "St Augustine"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SGR",
    "translations": [
      "Sugar Land Regional Airport",
      "Sugar Land Regional Airport",
      "Sugar Land Regional Airport"
    ],
    "city": [
      "Houston",
      "Houston",
      "Houston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SGT",
    "translations": [
      "Stuttgart Municipal Airport / Carl Humphrey Field",
      "Stuttgart Municipal Airport / Carl Humphrey Field",
      "Stuttgart Municipal Airport / Carl Humphrey Field"
    ],
    "city": [
      "Stuttgart",
      "Stuttgart",
      "Stuttgart"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SGU",
    "translations": [
      "St George Regional Airport",
      "St George Regional Airport",
      "St George Regional Airport"
    ],
    "city": [
      "St George",
      "St George",
      "St George"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SHD",
    "translations": [
      "Shenandoah Valley Regional Airport",
      "Shenandoah Valley Regional Airport",
      "Shenandoah Valley Regional Airport"
    ],
    "city": [
      "Weyers Cave",
      "Weyers Cave",
      "Weyers Cave"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SHN",
    "translations": [
      "Sanderson Field",
      "Sanderson Field",
      "Sanderson Field"
    ],
    "city": [
      "Shelton",
      "Shelton",
      "Shelton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SHR",
    "translations": [
      "Sheridan County Airport",
      "Sheridan County Airport",
      "Sheridan County Airport"
    ],
    "city": [
      "Sheridan",
      "Sheridan",
      "Sheridan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SHV",
    "translations": [
      "Shreveport Regional Airport",
      "Shreveport Regional Airport",
      "Shreveport Regional Airport"
    ],
    "city": [
      "Shreveport",
      "Shreveport",
      "Shreveport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SIK",
    "translations": [
      "Sikeston Memorial Municipal Airport",
      "Sikeston Memorial Municipal Airport",
      "Sikeston Memorial Municipal Airport"
    ],
    "city": [
      "Sikeston",
      "Sikeston",
      "Sikeston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SIV",
    "translations": [
      "Sullivan County Airport",
      "Sullivan County Airport",
      "Sullivan County Airport"
    ],
    "city": [
      "Sullivan",
      "Sullivan",
      "Sullivan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SIY",
    "translations": [
      "Siskiyou County Airport",
      "Siskiyou County Airport",
      "Siskiyou County Airport"
    ],
    "city": [
      "Montague",
      "Montague",
      "Montague"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SJC",
    "translations": [
      "Norman Y. Mineta San Jose International Airport",
      "Norman Y. Mineta San Jose International Airport",
      "Norman Y. Mineta San Jose International Airport"
    ],
    "city": [
      "San Jose",
      "San Jose",
      "San Jose"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SJN",
    "translations": [
      "St Johns Industrial Air Park",
      "St Johns Industrial Air Park",
      "St Johns Industrial Air Park"
    ],
    "city": [
      "St Johns",
      "St Johns",
      "St Johns"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SJT",
    "translations": [
      "San Angelo Regional Mathis Field",
      "San Angelo Regional Mathis Field",
      "San Angelo Regional Mathis Field"
    ],
    "city": [
      "San Angelo",
      "San Angelo",
      "San Angelo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SKA",
    "translations": [
      "Fairchild Air Force Base",
      "Fairchild Air Force Base",
      "Fairchild Air Force Base"
    ],
    "city": [
      "Spokane",
      "Spokane",
      "Spokane"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SKF",
    "translations": [
      "Lackland Air Force Base",
      "Lackland Air Force Base",
      "Lackland Air Force Base"
    ],
    "city": [
      "San Antonio",
      "San Antonio",
      "San Antonio"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TSM",
    "translations": [
      "Taos Regional Airport",
      "Taos Regional Airport",
      "Taos Regional Airport"
    ],
    "city": [
      "Taos",
      "Taos",
      "Taos"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SLB",
    "translations": [
      "Storm Lake Municipal Airport",
      "Storm Lake Municipal Airport",
      "Storm Lake Municipal Airport"
    ],
    "city": [
      "Storm Lake",
      "Storm Lake",
      "Storm Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SLC",
    "translations": [
      "Salt Lake City International Airport",
      "Salt Lake City International Airport",
      "Salt Lake City International Airport"
    ],
    "city": [
      "Salt Lake City",
      "Salt Lake City",
      "Salt Lake City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SLE",
    "translations": [
      "Salem-Willamette Valley Airport/McNary Field",
      "Salem-Willamette Valley Airport/McNary Field",
      "Salem-Willamette Valley Airport/McNary Field"
    ],
    "city": [
      "Salem",
      "Salem",
      "Salem"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SLG",
    "translations": [
      "Smith Field",
      "Smith Field",
      "Smith Field"
    ],
    "city": [
      "Siloam Springs",
      "Siloam Springs",
      "Siloam Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SLK",
    "translations": [
      "Adirondack Regional Airport",
      "Adirondack Regional Airport",
      "Adirondack Regional Airport"
    ],
    "city": [
      "Saranac Lake",
      "Saranac Lake",
      "Saranac Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SLN",
    "translations": [
      "Salina Municipal Airport",
      "Salina Municipal Airport",
      "Salina Municipal Airport"
    ],
    "city": [
      "Salina",
      "Salina",
      "Salina"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SLO",
    "translations": [
      "Salem–Leckrone Airport",
      "Salem–Leckrone Airport",
      "Salem–Leckrone Airport"
    ],
    "city": [
      "Salem",
      "Salem",
      "Salem"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SLR",
    "translations": [
      "Sulphur Springs Municipal Airport",
      "Sulphur Springs Municipal Airport",
      "Sulphur Springs Municipal Airport"
    ],
    "city": [
      "Sulphur Springs",
      "Sulphur Springs",
      "Sulphur Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SMD",
    "translations": [
      "Smith Field",
      "Smith Field",
      "Smith Field"
    ],
    "city": [
      "Fort Wayne",
      "Fort Wayne",
      "Fort Wayne"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SME",
    "translations": [
      "Lake Cumberland Regional Airport",
      "Lake Cumberland Regional Airport",
      "Lake Cumberland Regional Airport"
    ],
    "city": [
      "Somerset",
      "Somerset",
      "Somerset"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SMF",
    "translations": [
      "Sacramento International Airport",
      "Sacramento International Airport",
      "Sacramento International Airport"
    ],
    "city": [
      "Sacramento",
      "Sacramento",
      "Sacramento"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SMN",
    "translations": [
      "Lemhi County Airport",
      "Lemhi County Airport",
      "Lemhi County Airport"
    ],
    "city": [
      "Salmon",
      "Salmon",
      "Salmon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SMO",
    "translations": [
      "Santa Monica Municipal Airport",
      "Santa Monica Municipal Airport",
      "Santa Monica Municipal Airport"
    ],
    "city": [
      "Santa Monica",
      "Santa Monica",
      "Santa Monica"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SUM",
    "translations": [
      "Sumter Airport",
      "Sumter Airport",
      "Sumter Airport"
    ],
    "city": [
      "Sumter",
      "Sumter",
      "Sumter"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SMX",
    "translations": [
      "Santa Maria Public Airport Captain G Allan Hancock Field",
      "Santa Maria Public Airport Captain G Allan Hancock Field",
      "Santa Maria Public Airport Captain G Allan Hancock Field"
    ],
    "city": [
      "Santa Maria",
      "Santa Maria",
      "Santa Maria"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SNA",
    "translations": [
      "John Wayne Orange County International Airport",
      "John Wayne Orange County International Airport",
      "John Wayne Orange County International Airport"
    ],
    "city": [
      "Santa Ana",
      "Santa Ana",
      "Santa Ana"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SNK",
    "translations": [
      "Winston Field",
      "Winston Field",
      "Winston Field"
    ],
    "city": [
      "Snyder",
      "Snyder",
      "Snyder"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SNL",
    "translations": [
      "Shawnee Regional Airport",
      "Shawnee Regional Airport",
      "Shawnee Regional Airport"
    ],
    "city": [
      "Shawnee",
      "Shawnee",
      "Shawnee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SNS",
    "translations": [
      "Salinas Municipal Airport",
      "Salinas Municipal Airport",
      "Salinas Municipal Airport"
    ],
    "city": [
      "Salinas",
      "Salinas",
      "Salinas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SNY",
    "translations": [
      "Sidney Municipal Airport Lloyd W Carr Field",
      "Sidney Municipal Airport Lloyd W Carr Field",
      "Sidney Municipal Airport Lloyd W Carr Field"
    ],
    "city": [
      "Sidney",
      "Sidney",
      "Sidney"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SOP",
    "translations": [
      "Moore County Airport",
      "Moore County Airport",
      "Moore County Airport"
    ],
    "city": [
      "Carthage",
      "Carthage",
      "Carthage"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SOW",
    "translations": [
      "Show Low Regional Airport",
      "Show Low Regional Airport",
      "Show Low Regional Airport"
    ],
    "city": [
      "Show Low",
      "Show Low",
      "Show Low"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SPA",
    "translations": [
      "Spartanburg Downtown Memorial Airport",
      "Spartanburg Downtown Memorial Airport",
      "Spartanburg Downtown Memorial Airport"
    ],
    "city": [
      "Spartanburg",
      "Spartanburg",
      "Spartanburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SPF",
    "translations": [
      "Black Hills Airport-Clyde Ice Field",
      "Black Hills Airport-Clyde Ice Field",
      "Black Hills Airport-Clyde Ice Field"
    ],
    "city": [
      "Spearfish",
      "Spearfish",
      "Spearfish"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SPG",
    "translations": [
      "Albert Whitted Airport",
      "Albert Whitted Airport",
      "Albert Whitted Airport"
    ],
    "city": [
      "St Petersburg",
      "St Petersburg",
      "St Petersburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SPI",
    "translations": [
      "Abraham Lincoln Capital Airport",
      "Abraham Lincoln Capital Airport",
      "Abraham Lincoln Capital Airport"
    ],
    "city": [
      "Springfield",
      "Springfield",
      "Springfield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SPS",
    "translations": [
      "Wichita Falls Municipal Airport / Sheppard Air Force Base",
      "Wichita Falls Municipal Airport / Sheppard Air Force Base",
      "Wichita Falls Municipal Airport / Sheppard Air Force Base"
    ],
    "city": [
      "Wichita Falls",
      "Wichita Falls",
      "Wichita Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SPW",
    "translations": [
      "Spencer Municipal Airport",
      "Spencer Municipal Airport",
      "Spencer Municipal Airport"
    ],
    "city": [
      "Spencer",
      "Spencer",
      "Spencer"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SQI",
    "translations": [
      "Whiteside County Airport - Joseph H Bittorf Field",
      "Whiteside County Airport - Joseph H Bittorf Field",
      "Whiteside County Airport - Joseph H Bittorf Field"
    ],
    "city": [
      "Rock Falls",
      "Rock Falls",
      "Rock Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SQL",
    "translations": [
      "San Carlos Airport",
      "San Carlos Airport",
      "San Carlos Airport"
    ],
    "city": [
      "San Carlos",
      "San Carlos",
      "San Carlos"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SRC",
    "translations": [
      "Searcy Municipal Airport",
      "Searcy Municipal Airport",
      "Searcy Municipal Airport"
    ],
    "city": [
      "Searcy",
      "Searcy",
      "Searcy"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SRQ",
    "translations": [
      "Sarasota Bradenton International Airport",
      "Sarasota Bradenton International Airport",
      "Sarasota Bradenton International Airport"
    ],
    "city": [
      "Sarasota/Bradenton",
      "Sarasota/Bradenton",
      "Sarasota/Bradenton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RUI",
    "translations": [
      "Sierra Blanca Regional Airport",
      "Sierra Blanca Regional Airport",
      "Sierra Blanca Regional Airport"
    ],
    "city": [
      "Alto",
      "Alto",
      "Alto"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SSC",
    "translations": [
      "Shaw Air Force Base",
      "Shaw Air Force Base",
      "Shaw Air Force Base"
    ],
    "city": [
      "Sumter",
      "Sumter",
      "Sumter"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SSF",
    "translations": [
      "Stinson Municipal Airport",
      "Stinson Municipal Airport",
      "Stinson Municipal Airport"
    ],
    "city": [
      "San Antonio",
      "San Antonio",
      "San Antonio"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SSI",
    "translations": [
      "St Simons Island Airport",
      "St Simons Island Airport",
      "St Simons Island Airport"
    ],
    "city": [
      "St Simons Island",
      "St Simons Island",
      "St Simons Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "STC",
    "translations": [
      "Saint Cloud Regional Airport",
      "Saint Cloud Regional Airport",
      "Saint Cloud Regional Airport"
    ],
    "city": [
      "Saint Cloud",
      "Saint Cloud",
      "Saint Cloud"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "STE",
    "translations": [
      "Stevens Point Municipal Airport",
      "Stevens Point Municipal Airport",
      "Stevens Point Municipal Airport"
    ],
    "city": [
      "Stevens Point",
      "Stevens Point",
      "Stevens Point"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "STJ",
    "translations": [
      "Rosecrans Memorial Airport",
      "Rosecrans Memorial Airport",
      "Rosecrans Memorial Airport"
    ],
    "city": [
      "St Joseph",
      "St Joseph",
      "St Joseph"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "STK",
    "translations": [
      "Sterling Municipal Airport",
      "Sterling Municipal Airport",
      "Sterling Municipal Airport"
    ],
    "city": [
      "Sterling",
      "Sterling",
      "Sterling"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "STL",
    "translations": [
      "St. Louis Lambert International Airport",
      "St. Louis Lambert International Airport",
      "St. Louis Lambert International Airport"
    ],
    "city": [
      "St Louis",
      "St Louis",
      "St Louis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "STP",
    "translations": [
      "Saint Paul Downtown Holman Field",
      "Saint Paul Downtown Holman Field",
      "Saint Paul Downtown Holman Field"
    ],
    "city": [
      "Saint Paul",
      "Saint Paul",
      "Saint Paul"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "STS",
    "translations": [
      "Charles M. Schulz Sonoma County Airport",
      "Charles M. Schulz Sonoma County Airport",
      "Charles M. Schulz Sonoma County Airport"
    ],
    "city": [
      "Santa Rosa",
      "Santa Rosa",
      "Santa Rosa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SUA",
    "translations": [
      "Witham Field",
      "Witham Field",
      "Witham Field"
    ],
    "city": [
      "Stuart",
      "Stuart",
      "Stuart"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SUD",
    "translations": [
      "Stroud Municipal Airport",
      "Stroud Municipal Airport",
      "Stroud Municipal Airport"
    ],
    "city": [
      "Stroud",
      "Stroud",
      "Stroud"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SUE",
    "translations": [
      "Door County Cherryland Airport",
      "Door County Cherryland Airport",
      "Door County Cherryland Airport"
    ],
    "city": [
      "Sturgeon Bay",
      "Sturgeon Bay",
      "Sturgeon Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SUN",
    "translations": [
      "Friedman Memorial Airport",
      "Friedman Memorial Airport",
      "Friedman Memorial Airport"
    ],
    "city": [
      "Hailey",
      "Hailey",
      "Hailey"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SUS",
    "translations": [
      "Spirit of St Louis Airport",
      "Spirit of St Louis Airport",
      "Spirit of St Louis Airport"
    ],
    "city": [
      "St Louis",
      "St Louis",
      "St Louis"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SUU",
    "translations": [
      "Travis Air Force Base",
      "Travis Air Force Base",
      "Travis Air Force Base"
    ],
    "city": [
      "Fairfield",
      "Fairfield",
      "Fairfield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SUW",
    "translations": [
      "Richard I Bong Memorial Airport",
      "Richard I Bong Memorial Airport",
      "Richard I Bong Memorial Airport"
    ],
    "city": [
      "Superior",
      "Superior",
      "Superior"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SUX",
    "translations": [
      "Sioux Gateway Airport / Brigadier General Bud Day Field",
      "Sioux Gateway Airport / Brigadier General Bud Day Field",
      "Sioux Gateway Airport / Brigadier General Bud Day Field"
    ],
    "city": [
      "Sioux City",
      "Sioux City",
      "Sioux City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SVC",
    "translations": [
      "Grant County Airport",
      "Grant County Airport",
      "Grant County Airport"
    ],
    "city": [
      "Silver City",
      "Silver City",
      "Silver City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SVE",
    "translations": [
      "Susanville Municipal Airport",
      "Susanville Municipal Airport",
      "Susanville Municipal Airport"
    ],
    "city": [
      "Susanville",
      "Susanville",
      "Susanville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SVH",
    "translations": [
      "Statesville Regional Airport",
      "Statesville Regional Airport",
      "Statesville Regional Airport"
    ],
    "city": [
      "Statesville",
      "Statesville",
      "Statesville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SVN",
    "translations": [
      "Hunter Army Air Field",
      "Hunter Army Air Field",
      "Hunter Army Air Field"
    ],
    "city": [
      "Savannah",
      "Savannah",
      "Savannah"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SWF",
    "translations": [
      "New York Stewart International Airport",
      "New York Stewart International Airport",
      "New York Stewart International Airport"
    ],
    "city": [
      "Newburgh",
      "Newburgh",
      "Newburgh"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SWO",
    "translations": [
      "Stillwater Regional Airport",
      "Stillwater Regional Airport",
      "Stillwater Regional Airport"
    ],
    "city": [
      "Stillwater",
      "Stillwater",
      "Stillwater"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SWW",
    "translations": [
      "Avenger Field",
      "Avenger Field",
      "Avenger Field"
    ],
    "city": [
      "Sweetwater",
      "Sweetwater",
      "Sweetwater"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SYI",
    "translations": [
      "Bomar Field / Shelbyville Municipal Airport",
      "Bomar Field / Shelbyville Municipal Airport",
      "Bomar Field / Shelbyville Municipal Airport"
    ],
    "city": [
      "Shelbyville",
      "Shelbyville",
      "Shelbyville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SYN",
    "translations": [
      "Stanton Airfield",
      "Stanton Airfield",
      "Stanton Airfield"
    ],
    "city": [
      "Dennison",
      "Dennison",
      "Dennison"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SYR",
    "translations": [
      "Syracuse Hancock International Airport",
      "Syracuse Hancock International Airport",
      "Syracuse Hancock International Airport"
    ],
    "city": [
      "Syracuse",
      "Syracuse",
      "Syracuse"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SYV",
    "translations": [
      "Sylvester Airport",
      "Sylvester Airport",
      "Sylvester Airport"
    ],
    "city": [
      "Sylvester",
      "Sylvester",
      "Sylvester"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SZL",
    "translations": [
      "Whiteman Air Force Base",
      "Whiteman Air Force Base",
      "Whiteman Air Force Base"
    ],
    "city": [
      "Knob Noster",
      "Knob Noster",
      "Knob Noster"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SZN",
    "translations": [
      "Santa Cruz Island Airport",
      "Santa Cruz Island Airport",
      "Santa Cruz Island Airport"
    ],
    "city": [
      "Santa Cruz Island",
      "Santa Cruz Island",
      "Santa Cruz Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SZP",
    "translations": [
      "Santa Paula Airport",
      "Santa Paula Airport",
      "Santa Paula Airport"
    ],
    "city": [
      "Santa Paula",
      "Santa Paula",
      "Santa Paula"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TBC",
    "translations": [
      "Tuba City Airport",
      "Tuba City Airport",
      "Tuba City Airport"
    ],
    "city": [
      "Tuba City",
      "Tuba City",
      "Tuba City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TAD",
    "translations": [
      "Perry Stokes Airport",
      "Perry Stokes Airport",
      "Perry Stokes Airport"
    ],
    "city": [
      "Trinidad",
      "Trinidad",
      "Trinidad"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KTB",
    "translations": [
      "Thorne Bay Seaplane Base",
      "Thorne Bay Seaplane Base",
      "Thorne Bay Seaplane Base"
    ],
    "city": [
      "Thorne Bay",
      "Thorne Bay",
      "Thorne Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TBN",
    "translations": [
      "Waynesville-St. Robert Regional Airport-Forney Field",
      "Waynesville-St. Robert Regional Airport-Forney Field",
      "Waynesville-St. Robert Regional Airport-Forney Field"
    ],
    "city": [
      "Fort Leonard Wood",
      "Fort Leonard Wood",
      "Fort Leonard Wood"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TBR",
    "translations": [
      "Statesboro Bulloch County Airport",
      "Statesboro Bulloch County Airport",
      "Statesboro Bulloch County Airport"
    ],
    "city": [
      "Statesboro",
      "Statesboro",
      "Statesboro"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KTC",
    "translations": [
      "Katiola Airport",
      "Katiola Airport",
      "Katiola Airport"
    ],
    "city": [
      "Katiola",
      "Katiola",
      "Katiola"
    ],
    "country": [
      "CI",
      "CI",
      "CI"
    ]
  },
  {
    "iata": "TCC",
    "translations": [
      "Tucumcari Municipal Airport",
      "Tucumcari Municipal Airport",
      "Tucumcari Municipal Airport"
    ],
    "city": [
      "Tucumcari",
      "Tucumcari",
      "Tucumcari"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TCL",
    "translations": [
      "Tuscaloosa National Airport",
      "Tuscaloosa National Airport",
      "Tuscaloosa National Airport"
    ],
    "city": [
      "Tuscaloosa",
      "Tuscaloosa",
      "Tuscaloosa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TCM",
    "translations": [
      "McChord Air Force Base",
      "McChord Air Force Base",
      "McChord Air Force Base"
    ],
    "city": [
      "Tacoma",
      "Tacoma",
      "Tacoma"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TCS",
    "translations": [
      "Truth or Consequences Municipal Airport",
      "Truth or Consequences Municipal Airport",
      "Truth or Consequences Municipal Airport"
    ],
    "city": [
      "Truth or Consequences",
      "Truth or Consequences",
      "Truth or Consequences"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TDO",
    "translations": [
      "Ed Carlson Memorial Field South Lewis County Airport",
      "Ed Carlson Memorial Field South Lewis County Airport",
      "Ed Carlson Memorial Field South Lewis County Airport"
    ],
    "city": [
      "Toledo",
      "Toledo",
      "Toledo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TDW",
    "translations": [
      "Tradewind Airport",
      "Tradewind Airport",
      "Tradewind Airport"
    ],
    "city": [
      "Amarillo",
      "Amarillo",
      "Amarillo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TDZ",
    "translations": [
      "Toledo Executive Airport",
      "Toledo Executive Airport",
      "Toledo Executive Airport"
    ],
    "city": [
      "Toledo",
      "Toledo",
      "Toledo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TEB",
    "translations": [
      "Teterboro Airport",
      "Teterboro Airport",
      "Teterboro Airport"
    ],
    "city": [
      "Teterboro",
      "Teterboro",
      "Teterboro"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TEX",
    "translations": [
      "Telluride Regional Airport",
      "Telluride Regional Airport",
      "Telluride Regional Airport"
    ],
    "city": [
      "Telluride",
      "Telluride",
      "Telluride"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "THA",
    "translations": [
      "Tullahoma Regional Airport William Northern Field",
      "Tullahoma Regional Airport William Northern Field",
      "Tullahoma Regional Airport William Northern Field"
    ],
    "city": [
      "Tullahoma",
      "Tullahoma",
      "Tullahoma"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "THM",
    "translations": [
      "Thompson Falls Airport",
      "Thompson Falls Airport",
      "Thompson Falls Airport"
    ],
    "city": [
      "Thompson Falls",
      "Thompson Falls",
      "Thompson Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "THV",
    "translations": [
      "York Airport",
      "York Airport",
      "York Airport"
    ],
    "city": [
      "Thomasville",
      "Thomasville",
      "Thomasville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TIK",
    "translations": [
      "Tinker Air Force Base",
      "Tinker Air Force Base",
      "Tinker Air Force Base"
    ],
    "city": [
      "Oklahoma City",
      "Oklahoma City",
      "Oklahoma City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TIW",
    "translations": [
      "Tacoma Narrows Airport",
      "Tacoma Narrows Airport",
      "Tacoma Narrows Airport"
    ],
    "city": [
      "Tacoma",
      "Tacoma",
      "Tacoma"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TIX",
    "translations": [
      "Space Coast Regional Airport",
      "Space Coast Regional Airport",
      "Space Coast Regional Airport"
    ],
    "city": [
      "Titusville",
      "Titusville",
      "Titusville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KNT",
    "translations": [
      "Kennett Memorial Airport",
      "Kennett Memorial Airport",
      "Kennett Memorial Airport"
    ],
    "city": [
      "Kennett",
      "Kennett",
      "Kennett"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TLH",
    "translations": [
      "Tallahassee Regional Airport",
      "Tallahassee Regional Airport",
      "Tallahassee Regional Airport"
    ],
    "city": [
      "Tallahassee",
      "Tallahassee",
      "Tallahassee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TLR",
    "translations": [
      "Mefford Field",
      "Mefford Field",
      "Mefford Field"
    ],
    "city": [
      "Tulare",
      "Tulare",
      "Tulare"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TMA",
    "translations": [
      "Henry Tift Myers Airport",
      "Henry Tift Myers Airport",
      "Henry Tift Myers Airport"
    ],
    "city": [
      "Tifton",
      "Tifton",
      "Tifton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TMB",
    "translations": [
      "Miami Executive Airport",
      "Miami Executive Airport",
      "Miami Executive Airport"
    ],
    "city": [
      "Miami",
      "Miami",
      "Miami"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OTK",
    "translations": [
      "Tillamook Airport",
      "Tillamook Airport",
      "Tillamook Airport"
    ],
    "city": [
      "Tillamook",
      "Tillamook",
      "Tillamook"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TNP",
    "translations": [
      "Twentynine Palms Airport",
      "Twentynine Palms Airport",
      "Twentynine Palms Airport"
    ],
    "city": [
      "Twentynine Palms",
      "Twentynine Palms",
      "Twentynine Palms"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TNT",
    "translations": [
      "Dade Collier Training and Transition Airport",
      "Dade Collier Training and Transition Airport",
      "Dade Collier Training and Transition Airport"
    ],
    "city": [
      "Miami",
      "Miami",
      "Miami"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TNU",
    "translations": [
      "Newton Municipal Airport",
      "Newton Municipal Airport",
      "Newton Municipal Airport"
    ],
    "city": [
      "Newton",
      "Newton",
      "Newton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "XSD",
    "translations": [
      "Tonopah Test Range Airport",
      "Tonopah Test Range Airport",
      "Tonopah Test Range Airport"
    ],
    "city": [
      "Tonopah",
      "Tonopah",
      "Tonopah"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TOA",
    "translations": [
      "Zamperini Field",
      "Zamperini Field",
      "Zamperini Field"
    ],
    "city": [
      "Torrance",
      "Torrance",
      "Torrance"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TOC",
    "translations": [
      "Toccoa Airport - R.G. Letourneau Field",
      "Toccoa Airport - R.G. Letourneau Field",
      "Toccoa Airport - R.G. Letourneau Field"
    ],
    "city": [
      "Toccoa",
      "Toccoa",
      "Toccoa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TOI",
    "translations": [
      "Troy Municipal Airport at N Kenneth Campbell Field",
      "Troy Municipal Airport at N Kenneth Campbell Field",
      "Troy Municipal Airport at N Kenneth Campbell Field"
    ],
    "city": [
      "Troy",
      "Troy",
      "Troy"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TOL",
    "translations": [
      "Eugene F. Kranz Toledo Express Airport",
      "Eugene F. Kranz Toledo Express Airport",
      "Eugene F. Kranz Toledo Express Airport"
    ],
    "city": [
      "Toledo",
      "Toledo",
      "Toledo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TOP",
    "translations": [
      "Philip Billard Municipal Airport",
      "Philip Billard Municipal Airport",
      "Philip Billard Municipal Airport"
    ],
    "city": [
      "Topeka",
      "Topeka",
      "Topeka"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TOR",
    "translations": [
      "Torrington Municipal Airport",
      "Torrington Municipal Airport",
      "Torrington Municipal Airport"
    ],
    "city": [
      "Torrington",
      "Torrington",
      "Torrington"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TPA",
    "translations": [
      "Tampa International Airport",
      "Tampa International Airport",
      "Tampa International Airport"
    ],
    "city": [
      "Tampa",
      "Tampa",
      "Tampa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TPF",
    "translations": [
      "Peter O Knight Airport",
      "Peter O Knight Airport",
      "Peter O Knight Airport"
    ],
    "city": [
      "Tampa",
      "Tampa",
      "Tampa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TPH",
    "translations": [
      "Tonopah Airport",
      "Tonopah Airport",
      "Tonopah Airport"
    ],
    "city": [
      "Tonopah",
      "Tonopah",
      "Tonopah"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TPL",
    "translations": [
      "Draughon Miller Central Texas Regional Airport",
      "Draughon Miller Central Texas Regional Airport",
      "Draughon Miller Central Texas Regional Airport"
    ],
    "city": [
      "Temple",
      "Temple",
      "Temple"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TRI",
    "translations": [
      "Tri-Cities Regional TN/VA Airport",
      "Tri-Cities Regional TN/VA Airport",
      "Tri-Cities Regional TN/VA Airport"
    ],
    "city": [
      "Blountville",
      "Blountville",
      "Blountville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TKF",
    "translations": [
      "Truckee Tahoe Airport",
      "Truckee Tahoe Airport",
      "Truckee Tahoe Airport"
    ],
    "city": [
      "Truckee",
      "Truckee",
      "Truckee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TRL",
    "translations": [
      "Terrell Municipal Airport",
      "Terrell Municipal Airport",
      "Terrell Municipal Airport"
    ],
    "city": [
      "Terrell",
      "Terrell",
      "Terrell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TRM",
    "translations": [
      "Jacqueline Cochran Regional Airport",
      "Jacqueline Cochran Regional Airport",
      "Jacqueline Cochran Regional Airport"
    ],
    "city": [
      "Palm Springs",
      "Palm Springs",
      "Palm Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TRX",
    "translations": [
      "Trenton Municipal Airport",
      "Trenton Municipal Airport",
      "Trenton Municipal Airport"
    ],
    "city": [
      "Trenton",
      "Trenton",
      "Trenton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TSP",
    "translations": [
      "Tehachapi Municipal Airport",
      "Tehachapi Municipal Airport",
      "Tehachapi Municipal Airport"
    ],
    "city": [
      "Tehachapi",
      "Tehachapi",
      "Tehachapi"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TTD",
    "translations": [
      "Portland Troutdale Airport",
      "Portland Troutdale Airport",
      "Portland Troutdale Airport"
    ],
    "city": [
      "Portland",
      "Portland",
      "Portland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TTN",
    "translations": [
      "Trenton Mercer Airport",
      "Trenton Mercer Airport",
      "Trenton Mercer Airport"
    ],
    "city": [
      "Ewing Township",
      "Ewing Township",
      "Ewing Township"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TUL",
    "translations": [
      "Tulsa International Airport",
      "Tulsa International Airport",
      "Tulsa International Airport"
    ],
    "city": [
      "Tulsa",
      "Tulsa",
      "Tulsa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TUP",
    "translations": [
      "Tupelo Regional Airport",
      "Tupelo Regional Airport",
      "Tupelo Regional Airport"
    ],
    "city": [
      "Tupelo",
      "Tupelo",
      "Tupelo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TUS",
    "translations": [
      "Tucson International Airport / Morris Air National Guard Base",
      "Tucson International Airport / Morris Air National Guard Base",
      "Tucson International Airport / Morris Air National Guard Base"
    ],
    "city": [
      "Tucson",
      "Tucson",
      "Tucson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TVC",
    "translations": [
      "Cherry Capital Airport",
      "Cherry Capital Airport",
      "Cherry Capital Airport"
    ],
    "city": [
      "Traverse City",
      "Traverse City",
      "Traverse City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TVF",
    "translations": [
      "Thief River Falls Regional Airport",
      "Thief River Falls Regional Airport",
      "Thief River Falls Regional Airport"
    ],
    "city": [
      "Thief River Falls",
      "Thief River Falls",
      "Thief River Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TVI",
    "translations": [
      "Thomasville Regional Airport",
      "Thomasville Regional Airport",
      "Thomasville Regional Airport"
    ],
    "city": [
      "Thomasville",
      "Thomasville",
      "Thomasville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TVL",
    "translations": [
      "Lake Tahoe Airport",
      "Lake Tahoe Airport",
      "Lake Tahoe Airport"
    ],
    "city": [
      "South Lake Tahoe",
      "South Lake Tahoe",
      "South Lake Tahoe"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TWF",
    "translations": [
      "Joslin Field Magic Valley Regional Airport",
      "Joslin Field Magic Valley Regional Airport",
      "Joslin Field Magic Valley Regional Airport"
    ],
    "city": [
      "Twin Falls",
      "Twin Falls",
      "Twin Falls"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TXK",
    "translations": [
      "Texarkana Regional Airport (Webb Field)",
      "Texarkana Regional Airport (Webb Field)",
      "Texarkana Regional Airport (Webb Field)"
    ],
    "city": [
      "Texarkana",
      "Texarkana",
      "Texarkana"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TYZ",
    "translations": [
      "Taylor Airport",
      "Taylor Airport",
      "Taylor Airport"
    ],
    "city": [
      "Taylor",
      "Taylor",
      "Taylor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TYR",
    "translations": [
      "Tyler Pounds Regional Airport",
      "Tyler Pounds Regional Airport",
      "Tyler Pounds Regional Airport"
    ],
    "city": [
      "Tyler",
      "Tyler",
      "Tyler"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TYS",
    "translations": [
      "McGhee Tyson Airport",
      "McGhee Tyson Airport",
      "McGhee Tyson Airport"
    ],
    "city": [
      "Alcoa",
      "Alcoa",
      "Alcoa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BFG",
    "translations": [
      "Bullfrog Basin Airport",
      "Bullfrog Basin Airport",
      "Bullfrog Basin Airport"
    ],
    "city": [
      "Bullfrog",
      "Bullfrog",
      "Bullfrog"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NPH",
    "translations": [
      "J. Randy McKnight Nephi Municipal Airport",
      "J. Randy McKnight Nephi Municipal Airport",
      "J. Randy McKnight Nephi Municipal Airport"
    ],
    "city": [
      "Nephi",
      "Nephi",
      "Nephi"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RVR",
    "translations": [
      "Green River Municipal Airport",
      "Green River Municipal Airport",
      "Green River Municipal Airport"
    ],
    "city": [
      "Green River",
      "Green River",
      "Green River"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PNU",
    "translations": [
      "Panguitch Municipal Airport",
      "Panguitch Municipal Airport",
      "Panguitch Municipal Airport"
    ],
    "city": [
      "Panguitch",
      "Panguitch",
      "Panguitch"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ICS",
    "translations": [
      "Cascade Airport",
      "Cascade Airport",
      "Cascade Airport"
    ],
    "city": [
      "Cascade",
      "Cascade",
      "Cascade"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UBS",
    "translations": [
      "Columbus Lowndes County Airport",
      "Columbus Lowndes County Airport",
      "Columbus Lowndes County Airport"
    ],
    "city": [
      "Columbus",
      "Columbus",
      "Columbus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UCY",
    "translations": [
      "Everett-Stewart Regional Airport",
      "Everett-Stewart Regional Airport",
      "Everett-Stewart Regional Airport"
    ],
    "city": [
      "Union City",
      "Union City",
      "Union City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UDD",
    "translations": [
      "Bermuda Dunes Airport",
      "Bermuda Dunes Airport",
      "Bermuda Dunes Airport"
    ],
    "city": [
      "Bermuda Dunes",
      "Bermuda Dunes",
      "Bermuda Dunes"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UES",
    "translations": [
      "Waukesha County Airport",
      "Waukesha County Airport",
      "Waukesha County Airport"
    ],
    "city": [
      "Waukesha",
      "Waukesha",
      "Waukesha"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UGN",
    "translations": [
      "Waukegan National Airport",
      "Waukegan National Airport",
      "Waukegan National Airport"
    ],
    "city": [
      "Chicago/Waukegan",
      "Chicago/Waukegan",
      "Chicago/Waukegan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UIL",
    "translations": [
      "Quillayute Airport",
      "Quillayute Airport",
      "Quillayute Airport"
    ],
    "city": [
      "Quillayute",
      "Quillayute",
      "Quillayute"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UIN",
    "translations": [
      "Quincy Regional Airport Baldwin Field",
      "Quincy Regional Airport Baldwin Field",
      "Quincy Regional Airport Baldwin Field"
    ],
    "city": [
      "Quincy",
      "Quincy",
      "Quincy"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IKB",
    "translations": [
      "Wilkes County Airport",
      "Wilkes County Airport",
      "Wilkes County Airport"
    ],
    "city": [
      "North Wilkesboro",
      "North Wilkesboro",
      "North Wilkesboro"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UKI",
    "translations": [
      "Ukiah Municipal Airport",
      "Ukiah Municipal Airport",
      "Ukiah Municipal Airport"
    ],
    "city": [
      "Ukiah",
      "Ukiah",
      "Ukiah"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UKT",
    "translations": [
      "Quakertown Airport",
      "Quakertown Airport",
      "Quakertown Airport"
    ],
    "city": [
      "Quakertown",
      "Quakertown",
      "Quakertown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ULM",
    "translations": [
      "New Ulm Municipal Airport",
      "New Ulm Municipal Airport",
      "New Ulm Municipal Airport"
    ],
    "city": [
      "New Ulm",
      "New Ulm",
      "New Ulm"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ATO",
    "translations": [
      "Ohio University Airport",
      "Ohio University Airport",
      "Ohio University Airport"
    ],
    "city": [
      "Albany",
      "Albany",
      "Albany"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UNU",
    "translations": [
      "Dodge County Airport",
      "Dodge County Airport",
      "Dodge County Airport"
    ],
    "city": [
      "Juneau",
      "Juneau",
      "Juneau"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SCE",
    "translations": [
      "State College Regional Airport",
      "State College Regional Airport",
      "State College Regional Airport"
    ],
    "city": [
      "State College",
      "State College",
      "State College"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UOS",
    "translations": [
      "Franklin County Airport",
      "Franklin County Airport",
      "Franklin County Airport"
    ],
    "city": [
      "Sewanee",
      "Sewanee",
      "Sewanee"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UOX",
    "translations": [
      "University Oxford Airport",
      "University Oxford Airport",
      "University Oxford Airport"
    ],
    "city": [
      "Oxford",
      "Oxford",
      "Oxford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KUP",
    "translations": [
      "Kupiano Airport",
      "Kupiano Airport",
      "Kupiano Airport"
    ],
    "city": [
      "Kupiano",
      "Kupiano",
      "Kupiano"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "UTM",
    "translations": [
      "Tunica Municipal Airport",
      "Tunica Municipal Airport",
      "Tunica Municipal Airport"
    ],
    "city": [
      "Tunica",
      "Tunica",
      "Tunica"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HTV",
    "translations": [
      "Huntsville Regional Airport",
      "Huntsville Regional Airport",
      "Huntsville Regional Airport"
    ],
    "city": [
      "Huntsville",
      "Huntsville",
      "Huntsville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NPT",
    "translations": [
      "Newport State Airport",
      "Newport State Airport",
      "Newport State Airport"
    ],
    "city": [
      "Newport",
      "Newport",
      "Newport"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UVA",
    "translations": [
      "Garner Field",
      "Garner Field",
      "Garner Field"
    ],
    "city": [
      "Uvalde",
      "Uvalde",
      "Uvalde"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RKH",
    "translations": [
      "Rock Hill - York County Airport",
      "Rock Hill - York County Airport",
      "Rock Hill - York County Airport"
    ],
    "city": [
      "Rock Hill",
      "Rock Hill",
      "Rock Hill"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VAD",
    "translations": [
      "Moody Air Force Base",
      "Moody Air Force Base",
      "Moody Air Force Base"
    ],
    "city": [
      "Valdosta",
      "Valdosta",
      "Valdosta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LLY",
    "translations": [
      "South Jersey Regional Airport",
      "South Jersey Regional Airport",
      "South Jersey Regional Airport"
    ],
    "city": [
      "Lumberton",
      "Lumberton",
      "Lumberton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VBG",
    "translations": [
      "Vandenberg Space Force Base",
      "Vandenberg Space Force Base",
      "Vandenberg Space Force Base"
    ],
    "city": [
      "Lompoc",
      "Lompoc",
      "Lompoc"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VCT",
    "translations": [
      "Victoria Regional Airport",
      "Victoria Regional Airport",
      "Victoria Regional Airport"
    ],
    "city": [
      "Victoria",
      "Victoria",
      "Victoria"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VCV",
    "translations": [
      "Southern California Logistics Airport",
      "Southern California Logistics Airport",
      "Southern California Logistics Airport"
    ],
    "city": [
      "Victorville",
      "Victorville",
      "Victorville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VDI",
    "translations": [
      "Vidalia Regional Airport",
      "Vidalia Regional Airport",
      "Vidalia Regional Airport"
    ],
    "city": [
      "Vidalia",
      "Vidalia",
      "Vidalia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KVE",
    "translations": [
      "Kitava Airport",
      "Kitava Airport",
      "Kitava Airport"
    ],
    "city": [
      "Kitava Island",
      "Kitava Island",
      "Kitava Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "VEL",
    "translations": [
      "Vernal Regional Airport",
      "Vernal Regional Airport",
      "Vernal Regional Airport"
    ],
    "city": [
      "Vernal",
      "Vernal",
      "Vernal"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VGT",
    "translations": [
      "North Las Vegas Metropolitan International Airport",
      "North Las Vegas Metropolitan International Airport",
      "North Las Vegas Metropolitan International Airport"
    ],
    "city": [
      "Las Vegas",
      "Las Vegas",
      "Las Vegas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VHN",
    "translations": [
      "Culberson County Airport",
      "Culberson County Airport",
      "Culberson County Airport"
    ],
    "city": [
      "Van Horn",
      "Van Horn",
      "Van Horn"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VIH",
    "translations": [
      "Rolla National Airport",
      "Rolla National Airport",
      "Rolla National Airport"
    ],
    "city": [
      "Vichy",
      "Vichy",
      "Vichy"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VIS",
    "translations": [
      "Visalia Municipal Airport",
      "Visalia Municipal Airport",
      "Visalia Municipal Airport"
    ],
    "city": [
      "Visalia",
      "Visalia",
      "Visalia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VJI",
    "translations": [
      "Virginia Highlands Airport",
      "Virginia Highlands Airport",
      "Virginia Highlands Airport"
    ],
    "city": [
      "Abingdon",
      "Abingdon",
      "Abingdon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VKS",
    "translations": [
      "Vicksburg Municipal Airport",
      "Vicksburg Municipal Airport",
      "Vicksburg Municipal Airport"
    ],
    "city": [
      "Vicksburg",
      "Vicksburg",
      "Vicksburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VLA",
    "translations": [
      "Vandalia Municipal Airport",
      "Vandalia Municipal Airport",
      "Vandalia Municipal Airport"
    ],
    "city": [
      "Vandalia",
      "Vandalia",
      "Vandalia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VLD",
    "translations": [
      "Valdosta Regional Airport",
      "Valdosta Regional Airport",
      "Valdosta Regional Airport"
    ],
    "city": [
      "Valdosta",
      "Valdosta",
      "Valdosta"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VNC",
    "translations": [
      "Venice Municipal Airport",
      "Venice Municipal Airport",
      "Venice Municipal Airport"
    ],
    "city": [
      "Venice",
      "Venice",
      "Venice"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VNY",
    "translations": [
      "Van Nuys Airport",
      "Van Nuys Airport",
      "Van Nuys Airport"
    ],
    "city": [
      "Van Nuys",
      "Van Nuys",
      "Van Nuys"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VOK",
    "translations": [
      "Volk Field",
      "Volk Field",
      "Volk Field"
    ],
    "city": [
      "Camp Douglas",
      "Camp Douglas",
      "Camp Douglas"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VPS",
    "translations": [
      "Destin-Fort Walton Beach Airport",
      "Destin-Fort Walton Beach Airport",
      "Destin-Fort Walton Beach Airport"
    ],
    "city": [
      "Valparaiso",
      "Valparaiso",
      "Valparaiso"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VPZ",
    "translations": [
      "Porter County Municipal Airport",
      "Porter County Municipal Airport",
      "Porter County Municipal Airport"
    ],
    "city": [
      "Valparaiso",
      "Valparaiso",
      "Valparaiso"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VQQ",
    "translations": [
      "Cecil Airport",
      "Cecil Airport",
      "Cecil Airport"
    ],
    "city": [
      "Jacksonville",
      "Jacksonville",
      "Jacksonville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VRB",
    "translations": [
      "Vero Beach Regional Airport",
      "Vero Beach Regional Airport",
      "Vero Beach Regional Airport"
    ],
    "city": [
      "Vero Beach",
      "Vero Beach",
      "Vero Beach"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VSF",
    "translations": [
      "Hartness State Airport",
      "Hartness State Airport",
      "Hartness State Airport"
    ],
    "city": [
      "North Springfield",
      "North Springfield",
      "North Springfield"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VTN",
    "translations": [
      "Miller Field",
      "Miller Field",
      "Miller Field"
    ],
    "city": [
      "Valentine",
      "Valentine",
      "Valentine"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VYS",
    "translations": [
      "Illinois Valley Regional Airport Walter A Duncan Field",
      "Illinois Valley Regional Airport Walter A Duncan Field",
      "Illinois Valley Regional Airport Walter A Duncan Field"
    ],
    "city": [
      "Peru",
      "Peru",
      "Peru"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GTY",
    "translations": [
      "Gettysburg Regional Airport",
      "Gettysburg Regional Airport",
      "Gettysburg Regional Airport"
    ],
    "city": [
      "Gettysburg",
      "Gettysburg",
      "Gettysburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SQV",
    "translations": [
      "Sequim Valley Airport",
      "Sequim Valley Airport",
      "Sequim Valley Airport"
    ],
    "city": [
      "Sequim",
      "Sequim",
      "Sequim"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PGC",
    "translations": [
      "Grant County Airport",
      "Grant County Airport",
      "Grant County Airport"
    ],
    "city": [
      "Petersburg",
      "Petersburg",
      "Petersburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WAL",
    "translations": [
      "Wallops Flight Facility Airport",
      "Wallops Flight Facility Airport",
      "Wallops Flight Facility Airport"
    ],
    "city": [
      "Wallops Island",
      "Wallops Island",
      "Wallops Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WAY",
    "translations": [
      "Greene County Airport",
      "Greene County Airport",
      "Greene County Airport"
    ],
    "city": [
      "Waynesburg",
      "Waynesburg",
      "Waynesburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WBW",
    "translations": [
      "Wilkes Barre Wyoming Valley Airport",
      "Wilkes Barre Wyoming Valley Airport",
      "Wilkes Barre Wyoming Valley Airport"
    ],
    "city": [
      "Wilkes-Barre",
      "Wilkes-Barre",
      "Wilkes-Barre"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WDG",
    "translations": [
      "Enid Woodring Regional Airport",
      "Enid Woodring Regional Airport",
      "Enid Woodring Regional Airport"
    ],
    "city": [
      "Enid",
      "Enid",
      "Enid"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WDR",
    "translations": [
      "Barrow County Airport",
      "Barrow County Airport",
      "Barrow County Airport"
    ],
    "city": [
      "Winder",
      "Winder",
      "Winder"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WEA",
    "translations": [
      "Parker County Airport",
      "Parker County Airport",
      "Parker County Airport"
    ],
    "city": [
      "Weatherford",
      "Weatherford",
      "Weatherford"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KWF",
    "translations": [
      "Waterfall Seaplane Base",
      "Waterfall Seaplane Base",
      "Waterfall Seaplane Base"
    ],
    "city": [
      "Waterfall",
      "Waterfall",
      "Waterfall"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WHP",
    "translations": [
      "Whiteman Airport",
      "Whiteman Airport",
      "Whiteman Airport"
    ],
    "city": [
      "Pacoima",
      "Pacoima",
      "Pacoima"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WJF",
    "translations": [
      "General William J Fox Airfield",
      "General William J Fox Airfield",
      "General William J Fox Airfield"
    ],
    "city": [
      "Lancaster",
      "Lancaster",
      "Lancaster"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WLD",
    "translations": [
      "Strother Field",
      "Strother Field",
      "Strother Field"
    ],
    "city": [
      "Winfield / Arkansas City",
      "Winfield / Arkansas City",
      "Winfield / Arkansas City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WLW",
    "translations": [
      "Willows Glenn County Airport",
      "Willows Glenn County Airport",
      "Willows Glenn County Airport"
    ],
    "city": [
      "Willows",
      "Willows",
      "Willows"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WMC",
    "translations": [
      "Winnemucca Municipal Airport",
      "Winnemucca Municipal Airport",
      "Winnemucca Municipal Airport"
    ],
    "city": [
      "Winnemucca",
      "Winnemucca",
      "Winnemucca"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KWP",
    "translations": [
      "West Point Village Seaplane Base",
      "West Point Village Seaplane Base",
      "West Point Village Seaplane Base"
    ],
    "city": [
      "West Point",
      "West Point",
      "West Point"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WRB",
    "translations": [
      "Robins Air Force Base",
      "Robins Air Force Base",
      "Robins Air Force Base"
    ],
    "city": [
      "Warner Robins",
      "Warner Robins",
      "Warner Robins"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WRI",
    "translations": [
      "Mc Guire Air Force Base",
      "Mc Guire Air Force Base",
      "Mc Guire Air Force Base"
    ],
    "city": [
      "Wrightstown",
      "Wrightstown",
      "Wrightstown"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WRL",
    "translations": [
      "Worland Municipal Airport",
      "Worland Municipal Airport",
      "Worland Municipal Airport"
    ],
    "city": [
      "Worland",
      "Worland",
      "Worland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WST",
    "translations": [
      "Westerly State Airport",
      "Westerly State Airport",
      "Westerly State Airport"
    ],
    "city": [
      "Westerly",
      "Westerly",
      "Westerly"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WVI",
    "translations": [
      "Watsonville Municipal Airport",
      "Watsonville Municipal Airport",
      "Watsonville Municipal Airport"
    ],
    "city": [
      "Watsonville",
      "Watsonville",
      "Watsonville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WVL",
    "translations": [
      "Waterville Robert Lafleur Airport",
      "Waterville Robert Lafleur Airport",
      "Waterville Robert Lafleur Airport"
    ],
    "city": [
      "Waterville",
      "Waterville",
      "Waterville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WWD",
    "translations": [
      "Cape May County Airport",
      "Cape May County Airport",
      "Cape May County Airport"
    ],
    "city": [
      "Wildwood",
      "Wildwood",
      "Wildwood"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WWR",
    "translations": [
      "West Woodward Airport",
      "West Woodward Airport",
      "West Woodward Airport"
    ],
    "city": [
      "Woodward",
      "Woodward",
      "Woodward"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KWY",
    "translations": [
      "Kiwayu Airport",
      "Kiwayu Airport",
      "Kiwayu Airport"
    ],
    "city": [
      "Kiwayu",
      "Kiwayu",
      "Kiwayu"
    ],
    "country": [
      "KE",
      "KE",
      "KE"
    ]
  },
  {
    "iata": "WYS",
    "translations": [
      "Yellowstone Airport",
      "Yellowstone Airport",
      "Yellowstone Airport"
    ],
    "city": [
      "West Yellowstone",
      "West Yellowstone",
      "West Yellowstone"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KYO",
    "translations": [
      "Tampa North Aero Park Airport",
      "Tampa North Aero Park Airport",
      "Tampa North Aero Park Airport"
    ],
    "city": [
      "Tampa",
      "Tampa",
      "Tampa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KXA",
    "translations": [
      "Kasaan Seaplane Base",
      "Kasaan Seaplane Base",
      "Kasaan Seaplane Base"
    ],
    "city": [
      "Kasaan",
      "Kasaan",
      "Kasaan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "XNA",
    "translations": [
      "Northwest Arkansas National Airport",
      "Northwest Arkansas National Airport",
      "Northwest Arkansas National Airport"
    ],
    "city": [
      "Fayetteville/Springdale/Rogers",
      "Fayetteville/Springdale/Rogers",
      "Fayetteville/Springdale/Rogers"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "XWA",
    "translations": [
      "Williston Basin International Airport",
      "Williston Basin International Airport",
      "Williston Basin International Airport"
    ],
    "city": [
      "Williston",
      "Williston",
      "Williston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WBK",
    "translations": [
      "West Branch Community Airport",
      "West Branch Community Airport",
      "West Branch Community Airport"
    ],
    "city": [
      "West Branch",
      "West Branch",
      "West Branch"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "YIP",
    "translations": [
      "Willow Run Airport",
      "Willow Run Airport",
      "Willow Run Airport"
    ],
    "city": [
      "Detroit",
      "Detroit",
      "Detroit"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "YKM",
    "translations": [
      "Yakima Air Terminal McAllister Field",
      "Yakima Air Terminal McAllister Field",
      "Yakima Air Terminal McAllister Field"
    ],
    "city": [
      "Yakima",
      "Yakima",
      "Yakima"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "YKN",
    "translations": [
      "Chan Gurney Municipal Airport",
      "Chan Gurney Municipal Airport",
      "Chan Gurney Municipal Airport"
    ],
    "city": [
      "Yankton",
      "Yankton",
      "Yankton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "YNG",
    "translations": [
      "Youngstown Warren Regional Airport",
      "Youngstown Warren Regional Airport",
      "Youngstown Warren Regional Airport"
    ],
    "city": [
      "Youngstown/Warren",
      "Youngstown/Warren",
      "Youngstown/Warren"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ATX",
    "translations": [
      "Atbasar Airport",
      "Atbasar Airport",
      "Atbasar Airport"
    ],
    "city": [
      "Atbasar",
      "Atbasar",
      "Atbasar"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "KZB",
    "translations": [
      "Zachar Bay Seaplane Base",
      "Zachar Bay Seaplane Base",
      "Zachar Bay Seaplane Base"
    ],
    "city": [
      "Zachar Bay",
      "Zachar Bay",
      "Zachar Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ZPH",
    "translations": [
      "Zephyrhills Municipal Airport",
      "Zephyrhills Municipal Airport",
      "Zephyrhills Municipal Airport"
    ],
    "city": [
      "Zephyrhills",
      "Zephyrhills",
      "Zephyrhills"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ZZV",
    "translations": [
      "Zanesville Municipal Airport",
      "Zanesville Municipal Airport",
      "Zanesville Municipal Airport"
    ],
    "city": [
      "Zanesville",
      "Zanesville",
      "Zanesville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PGS",
    "translations": [
      "Grand Canyon Caverns Airport",
      "Grand Canyon Caverns Airport",
      "Grand Canyon Caverns Airport"
    ],
    "city": [
      "Peach Springs",
      "Peach Springs",
      "Peach Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BOR",
    "translations": [
      "Bokeo International Airport",
      "Bokeo International Airport",
      "Bokeo International Airport"
    ],
    "city": [
      "Ton Phueng",
      "Ton Phueng",
      "Ton Phueng"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "LAC",
    "translations": [
      "Layang-Layang Airport",
      "Layang-Layang Airport",
      "Layang-Layang Airport"
    ],
    "city": [
      "Pulau Layang-Layang (Swallow Reef)",
      "Pulau Layang-Layang (Swallow Reef)",
      "Pulau Layang-Layang (Swallow Reef)"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "KFZ",
    "translations": [
      "Kukës International Airport",
      "Kukës International Airport",
      "Kukës International Airport"
    ],
    "city": [
      "Kukës",
      "Kukës",
      "Kukës"
    ],
    "country": [
      "AL",
      "AL",
      "AL"
    ]
  },
  {
    "iata": "TIA",
    "translations": [
      "Tirana International Airport Mother Teresa",
      "Tirana International Airport Mother Teresa",
      "Tirana International Airport Mother Teresa"
    ],
    "city": [
      "Rinas",
      "Rinas",
      "Rinas"
    ],
    "country": [
      "AL",
      "AL",
      "AL"
    ]
  },
  {
    "iata": "BOJ",
    "translations": [
      "Burgas Airport",
      "Burgas Airport",
      "Burgas Airport"
    ],
    "city": [
      "Burgas",
      "Burgas",
      "Burgas"
    ],
    "country": [
      "BG",
      "BG",
      "BG"
    ]
  },
  {
    "iata": "GOZ",
    "translations": [
      "Gorna Oryahovitsa Airport",
      "Gorna Oryahovitsa Airport",
      "Gorna Oryahovitsa Airport"
    ],
    "city": [
      "Gorna Oryahovitsa",
      "Gorna Oryahovitsa",
      "Gorna Oryahovitsa"
    ],
    "country": [
      "BG",
      "BG",
      "BG"
    ]
  },
  {
    "iata": "LBH",
    "translations": [
      "Palm Beach Seaplane Base",
      "Palm Beach Seaplane Base",
      "Palm Beach Seaplane Base"
    ],
    "city": [
      "Sydney",
      "Sydney",
      "Sydney"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LBM",
    "translations": [
      "Luabo Airport",
      "Luabo Airport",
      "Luabo Airport"
    ],
    "city": [
      "Luabo",
      "Luabo",
      "Luabo"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "PDV",
    "translations": [
      "Plovdiv International Airport",
      "Plovdiv International Airport",
      "Plovdiv International Airport"
    ],
    "city": [
      "Plovdiv",
      "Plovdiv",
      "Plovdiv"
    ],
    "country": [
      "BG",
      "BG",
      "BG"
    ]
  },
  {
    "iata": "ROU",
    "translations": [
      "Ruse Airport",
      "Ruse Airport",
      "Ruse Airport"
    ],
    "city": [
      "Shtraklevo",
      "Shtraklevo",
      "Shtraklevo"
    ],
    "country": [
      "BG",
      "BG",
      "BG"
    ]
  },
  {
    "iata": "SOF",
    "translations": [
      "Sofia Airport",
      "Sofia Airport",
      "Sofia Airport"
    ],
    "city": [
      "Sofia",
      "Sofia",
      "Sofia"
    ],
    "country": [
      "BG",
      "BG",
      "BG"
    ]
  },
  {
    "iata": "VAR",
    "translations": [
      "Varna Airport",
      "Varna Airport",
      "Varna Airport"
    ],
    "city": [
      "Varna",
      "Varna",
      "Varna"
    ],
    "country": [
      "BG",
      "BG",
      "BG"
    ]
  },
  {
    "iata": "ECN",
    "translations": [
      "Nicosia (Lefkoşa) Ercan International Airport",
      "Nicosia (Lefkoşa) Ercan International Airport",
      "Nicosia (Lefkoşa) Ercan International Airport"
    ],
    "city": [
      "Tymbou (Kirklar)",
      "Tymbou (Kirklar)",
      "Tymbou (Kirklar)"
    ],
    "country": [
      "CY",
      "CY",
      "CY"
    ]
  },
  {
    "iata": "GEC",
    "translations": [
      "Lefkoniko Airport / Geçitkale Air Base",
      "Lefkoniko Airport / Geçitkale Air Base",
      "Lefkoniko Airport / Geçitkale Air Base"
    ],
    "city": [
      "Lefkoniko (Geçitkale)",
      "Lefkoniko (Geçitkale)",
      "Lefkoniko (Geçitkale)"
    ],
    "country": [
      "CY",
      "CY",
      "CY"
    ]
  },
  {
    "iata": "LCA",
    "translations": [
      "Larnaca International Airport",
      "Larnaca International Airport",
      "Larnaca International Airport"
    ],
    "city": [
      "Larnaca",
      "Larnaca",
      "Larnaca"
    ],
    "country": [
      "CY",
      "CY",
      "CY"
    ]
  },
  {
    "iata": "LCP",
    "translations": [
      "Loncopue Airport",
      "Loncopue Airport",
      "Loncopue Airport"
    ],
    "city": [
      "Loncopue",
      "Loncopue",
      "Loncopue"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "PFO",
    "translations": [
      "Paphos International Airport",
      "Paphos International Airport",
      "Paphos International Airport"
    ],
    "city": [
      "Paphos",
      "Paphos",
      "Paphos"
    ],
    "country": [
      "CY",
      "CY",
      "CY"
    ]
  },
  {
    "iata": "AKT",
    "translations": [
      "RAF Akrotiri",
      "RAF Akrotiri",
      "RAF Akrotiri"
    ],
    "city": [
      "Akrotiri",
      "Akrotiri",
      "Akrotiri"
    ],
    "country": [
      "CY",
      "CY",
      "CY"
    ]
  },
  {
    "iata": "DBV",
    "translations": [
      "Dubrovnik Ruđer Bošković Airport",
      "Dubrovnik Ruđer Bošković Airport",
      "Dubrovnik Ruđer Bošković Airport"
    ],
    "city": [
      "Čilipi",
      "Čilipi",
      "Čilipi"
    ],
    "country": [
      "HR",
      "HR",
      "HR"
    ]
  },
  {
    "iata": "LSZ",
    "translations": [
      "Lošinj Airport",
      "Lošinj Airport",
      "Lošinj Airport"
    ],
    "city": [
      "Mali Lošinj",
      "Mali Lošinj",
      "Mali Lošinj"
    ],
    "country": [
      "HR",
      "HR",
      "HR"
    ]
  },
  {
    "iata": "OSI",
    "translations": [
      "Osijek Airport",
      "Osijek Airport",
      "Osijek Airport"
    ],
    "city": [
      "Klisa",
      "Klisa",
      "Klisa"
    ],
    "country": [
      "HR",
      "HR",
      "HR"
    ]
  },
  {
    "iata": "PUY",
    "translations": [
      "Pula Airport",
      "Pula Airport",
      "Pula Airport"
    ],
    "city": [
      "Pula",
      "Pula",
      "Pula"
    ],
    "country": [
      "HR",
      "HR",
      "HR"
    ]
  },
  {
    "iata": "RJK",
    "translations": [
      "Rijeka Airport",
      "Rijeka Airport",
      "Rijeka Airport"
    ],
    "city": [
      "Omišalj",
      "Omišalj",
      "Omišalj"
    ],
    "country": [
      "HR",
      "HR",
      "HR"
    ]
  },
  {
    "iata": "BWK",
    "translations": [
      "Brač Airport",
      "Brač Airport",
      "Brač Airport"
    ],
    "city": [
      "Gornji Humac",
      "Gornji Humac",
      "Gornji Humac"
    ],
    "country": [
      "HR",
      "HR",
      "HR"
    ]
  },
  {
    "iata": "SPU",
    "translations": [
      "Split Airport",
      "Split Airport",
      "Split Airport"
    ],
    "city": [
      "Kaštel Štafilić",
      "Kaštel Štafilić",
      "Kaštel Štafilić"
    ],
    "country": [
      "HR",
      "HR",
      "HR"
    ]
  },
  {
    "iata": "LDW",
    "translations": [
      "Lansdowne Airport",
      "Lansdowne Airport",
      "Lansdowne Airport"
    ],
    "city": [
      "Lansdowne Station",
      "Lansdowne Station",
      "Lansdowne Station"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ZAG",
    "translations": [
      "Zagreb Franjo Tuđman International Airport",
      "Zagreb Franjo Tuđman International Airport",
      "Zagreb Franjo Tuđman International Airport"
    ],
    "city": [
      "Velika Gorica",
      "Velika Gorica",
      "Velika Gorica"
    ],
    "country": [
      "HR",
      "HR",
      "HR"
    ]
  },
  {
    "iata": "ZAD",
    "translations": [
      "Zadar Airport",
      "Zadar Airport",
      "Zadar Airport"
    ],
    "city": [
      "Zemunik Donji (Zadar)",
      "Zemunik Donji (Zadar)",
      "Zemunik Donji (Zadar)"
    ],
    "country": [
      "HR",
      "HR",
      "HR"
    ]
  },
  {
    "iata": "ABC",
    "translations": [
      "Albacete Airport / Los Llanos Air Base",
      "Albacete Airport / Los Llanos Air Base",
      "Albacete Airport / Los Llanos Air Base"
    ],
    "city": [
      "Albacete",
      "Albacete",
      "Albacete"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "ALC",
    "translations": [
      "Alicante-Elche Miguel Hernández Airport",
      "Alicante-Elche Miguel Hernández Airport",
      "Alicante-Elche Miguel Hernández Airport"
    ],
    "city": [
      "Alicante",
      "Alicante",
      "Alicante"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "LEI",
    "translations": [
      "Almería Airport",
      "Almería Airport",
      "Almería Airport"
    ],
    "city": [
      "Almería",
      "Almería",
      "Almería"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "OVD",
    "translations": [
      "Asturias Airport",
      "Asturias Airport",
      "Asturias Airport"
    ],
    "city": [
      "Ranón",
      "Ranón",
      "Ranón"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "ODB",
    "translations": [
      "Córdoba Airport",
      "Córdoba Airport",
      "Córdoba Airport"
    ],
    "city": [
      "Córdoba",
      "Córdoba",
      "Córdoba"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "BIO",
    "translations": [
      "Bilbao Airport",
      "Bilbao Airport",
      "Bilbao Airport"
    ],
    "city": [
      "Bilbao",
      "Bilbao",
      "Bilbao"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "RGS",
    "translations": [
      "Burgos Airport",
      "Burgos Airport",
      "Burgos Airport"
    ],
    "city": [
      "Burgos",
      "Burgos",
      "Burgos"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "BCN",
    "translations": [
      "Josep Tarradellas Barcelona-El Prat Airport",
      "Josep Tarradellas Barcelona-El Prat Airport",
      "Josep Tarradellas Barcelona-El Prat Airport"
    ],
    "city": [
      "Barcelona",
      "Barcelona",
      "Barcelona"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "BJZ",
    "translations": [
      "Badajoz Airport",
      "Badajoz Airport",
      "Badajoz Airport"
    ],
    "city": [
      "Badajoz",
      "Badajoz",
      "Badajoz"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "CDT",
    "translations": [
      "Castellón-Costa Azahar Airport",
      "Castellón-Costa Azahar Airport",
      "Castellón-Costa Azahar Airport"
    ],
    "city": [
      "Castellón de la Plana",
      "Castellón de la Plana",
      "Castellón de la Plana"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "LCG",
    "translations": [
      "A Coruña Airport",
      "A Coruña Airport",
      "A Coruña Airport"
    ],
    "city": [
      "Culleredo",
      "Culleredo",
      "Culleredo"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "ILD",
    "translations": [
      "Lleida-Alguaire Airport",
      "Lleida-Alguaire Airport",
      "Lleida-Alguaire Airport"
    ],
    "city": [
      "Lleida",
      "Lleida",
      "Lleida"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "GRO",
    "translations": [
      "Girona-Costa Brava Airport",
      "Girona-Costa Brava Airport",
      "Girona-Costa Brava Airport"
    ],
    "city": [
      "Girona",
      "Girona",
      "Girona"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "GRX",
    "translations": [
      "F.G.L. Airport Granada-Jaén Airport",
      "F.G.L. Airport Granada-Jaén Airport",
      "F.G.L. Airport Granada-Jaén Airport"
    ],
    "city": [
      "Granada",
      "Granada",
      "Granada"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "HSK",
    "translations": [
      "Huesca-Pirineos Airport",
      "Huesca-Pirineos Airport",
      "Huesca-Pirineos Airport"
    ],
    "city": [
      "Monflorite/Alcalá del Obispo",
      "Monflorite/Alcalá del Obispo",
      "Monflorite/Alcalá del Obispo"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "IBZ",
    "translations": [
      "Ibiza Airport",
      "Ibiza Airport",
      "Ibiza Airport"
    ],
    "city": [
      "Ibiza (Eivissa)",
      "Ibiza (Eivissa)",
      "Ibiza (Eivissa)"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "XRY",
    "translations": [
      "Jerez Airport",
      "Jerez Airport",
      "Jerez Airport"
    ],
    "city": [
      "Jerez de la Frontera",
      "Jerez de la Frontera",
      "Jerez de la Frontera"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "LEN",
    "translations": [
      "León Int'l Airport",
      "León Int'l Airport",
      "León Int'l Airport"
    ],
    "city": [
      "La Virgen Del Camino",
      "La Virgen Del Camino",
      "La Virgen Del Camino"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "RJL",
    "translations": [
      "Logroño-Agoncillo Airport",
      "Logroño-Agoncillo Airport",
      "Logroño-Agoncillo Airport"
    ],
    "city": [
      "Logroño",
      "Logroño",
      "Logroño"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "MAD",
    "translations": [
      "Adolfo Suárez Madrid–Barajas Airport",
      "Adolfo Suárez Madrid–Barajas Airport",
      "Adolfo Suárez Madrid–Barajas Airport"
    ],
    "city": [
      "Madrid",
      "Madrid",
      "Madrid"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "AGP",
    "translations": [
      "Málaga-Costa del Sol Airport",
      "Málaga-Costa del Sol Airport",
      "Málaga-Costa del Sol Airport"
    ],
    "city": [
      "Málaga",
      "Málaga",
      "Málaga"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "MAH",
    "translations": [
      "Menorca Airport",
      "Menorca Airport",
      "Menorca Airport"
    ],
    "city": [
      "Mahón (Maó)",
      "Mahón (Maó)",
      "Mahón (Maó)"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "RMU",
    "translations": [
      "Región de Murcia International Airport",
      "Región de Murcia International Airport",
      "Región de Murcia International Airport"
    ],
    "city": [
      "Corvera",
      "Corvera",
      "Corvera"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "OZP",
    "translations": [
      "Moron Air Base",
      "Moron Air Base",
      "Moron Air Base"
    ],
    "city": [
      "Morón",
      "Morón",
      "Morón"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "LEO",
    "translations": [
      "Lekoni Airport",
      "Lekoni Airport",
      "Lekoni Airport"
    ],
    "city": [
      "Lekoni",
      "Lekoni",
      "Lekoni"
    ],
    "country": [
      "GA",
      "GA",
      "GA"
    ]
  },
  {
    "iata": "PMI",
    "translations": [
      "Palma de Mallorca Airport",
      "Palma de Mallorca Airport",
      "Palma de Mallorca Airport"
    ],
    "city": [
      "Palma de Mallorca",
      "Palma de Mallorca",
      "Palma de Mallorca"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "PNA",
    "translations": [
      "Pamplona Airport",
      "Pamplona Airport",
      "Pamplona Airport"
    ],
    "city": [
      "Pamplona",
      "Pamplona",
      "Pamplona"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "CQM",
    "translations": [
      "Ciudad Real International Airport",
      "Ciudad Real International Airport",
      "Ciudad Real International Airport"
    ],
    "city": [
      "Ciudad Real",
      "Ciudad Real",
      "Ciudad Real"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "REU",
    "translations": [
      "Reus Airport",
      "Reus Airport",
      "Reus Airport"
    ],
    "city": [
      "Reus",
      "Reus",
      "Reus"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "ROZ",
    "translations": [
      "Rota Naval Station Airport",
      "Rota Naval Station Airport",
      "Rota Naval Station Airport"
    ],
    "city": [
      "Rota",
      "Rota",
      "Rota"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "SLM",
    "translations": [
      "Salamanca Airport",
      "Salamanca Airport",
      "Salamanca Airport"
    ],
    "city": [
      "Salamanca",
      "Salamanca",
      "Salamanca"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "EAS",
    "translations": [
      "San Sebastián Airport",
      "San Sebastián Airport",
      "San Sebastián Airport"
    ],
    "city": [
      "Hondarribia",
      "Hondarribia",
      "Hondarribia"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "SCQ",
    "translations": [
      "Santiago-Rosalía de Castro Airport",
      "Santiago-Rosalía de Castro Airport",
      "Santiago-Rosalía de Castro Airport"
    ],
    "city": [
      "Santiago de Compostela",
      "Santiago de Compostela",
      "Santiago de Compostela"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "LEU",
    "translations": [
      "Pirineus - la Seu d'Urgel Airport",
      "Pirineus - la Seu d'Urgel Airport",
      "Pirineus - la Seu d'Urgel Airport"
    ],
    "city": [
      "La Seu d'Urgell Pyrenees and Andorra",
      "La Seu d'Urgell Pyrenees and Andorra",
      "La Seu d'Urgell Pyrenees and Andorra"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "TEV",
    "translations": [
      "Teruel Airport",
      "Teruel Airport",
      "Teruel Airport"
    ],
    "city": [
      "Teruel",
      "Teruel",
      "Teruel"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "TOJ",
    "translations": [
      "Madrid–Torrejón Airport / Torrejón Air Base",
      "Madrid–Torrejón Airport / Torrejón Air Base",
      "Madrid–Torrejón Airport / Torrejón Air Base"
    ],
    "city": [
      "Madrid",
      "Madrid",
      "Madrid"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "VLC",
    "translations": [
      "Valencia Airport",
      "Valencia Airport",
      "Valencia Airport"
    ],
    "city": [
      "Valencia",
      "Valencia",
      "Valencia"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "VLL",
    "translations": [
      "Valladolid Airport",
      "Valladolid Airport",
      "Valladolid Airport"
    ],
    "city": [
      "Valladolid",
      "Valladolid",
      "Valladolid"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "VIT",
    "translations": [
      "Vitoria Airport",
      "Vitoria Airport",
      "Vitoria Airport"
    ],
    "city": [
      "Alava",
      "Alava",
      "Alava"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "VGO",
    "translations": [
      "Vigo Airport",
      "Vigo Airport",
      "Vigo Airport"
    ],
    "city": [
      "Vigo",
      "Vigo",
      "Vigo"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "SDR",
    "translations": [
      "Seve Ballesteros-Santander Airport",
      "Seve Ballesteros-Santander Airport",
      "Seve Ballesteros-Santander Airport"
    ],
    "city": [
      "Santander",
      "Santander",
      "Santander"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "ZAZ",
    "translations": [
      "Zaragoza Airport",
      "Zaragoza Airport",
      "Zaragoza Airport"
    ],
    "city": [
      "Zaragoza",
      "Zaragoza",
      "Zaragoza"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "SVQ",
    "translations": [
      "Sevilla Airport",
      "Sevilla Airport",
      "Sevilla Airport"
    ],
    "city": [
      "Sevilla",
      "Sevilla",
      "Sevilla"
    ],
    "country": [
      "ES",
      "ES",
      "ES"
    ]
  },
  {
    "iata": "DPE",
    "translations": [
      "Dieppe-Saint-Aubin Airport",
      "Dieppe-Saint-Aubin Airport",
      "Dieppe-Saint-Aubin Airport"
    ],
    "city": [
      "Saint-Aubin-sur-Scie",
      "Saint-Aubin-sur-Scie",
      "Saint-Aubin-sur-Scie"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CQF",
    "translations": [
      "Calais-Dunkerque Airport",
      "Calais-Dunkerque Airport",
      "Calais-Dunkerque Airport"
    ],
    "city": [
      "Marck",
      "Marck",
      "Marck"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "BYF",
    "translations": [
      "Albert-Picardie Airport",
      "Albert-Picardie Airport",
      "Albert-Picardie Airport"
    ],
    "city": [
      "Méaulte, Somme",
      "Méaulte, Somme",
      "Méaulte, Somme"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LTQ",
    "translations": [
      "Le Touquet-Côte d'Opale Airport",
      "Le Touquet-Côte d'Opale Airport",
      "Le Touquet-Côte d'Opale Airport"
    ],
    "city": [
      "Le Touquet-Paris-Plage",
      "Le Touquet-Paris-Plage",
      "Le Touquet-Paris-Plage"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "AGF",
    "translations": [
      "Agen-La Garenne Airport",
      "Agen-La Garenne Airport",
      "Agen-La Garenne Airport"
    ],
    "city": [
      "Agen/La Garenne",
      "Agen/La Garenne",
      "Agen/La Garenne"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "BOD",
    "translations": [
      "Bordeaux-Mérignac Airport",
      "Bordeaux-Mérignac Airport",
      "Bordeaux-Mérignac Airport"
    ],
    "city": [
      "Bordeaux/Mérignac",
      "Bordeaux/Mérignac",
      "Bordeaux/Mérignac"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "EGC",
    "translations": [
      "Bergerac Dordogne Périgord Airport",
      "Bergerac Dordogne Périgord Airport",
      "Bergerac Dordogne Périgord Airport"
    ],
    "city": [
      "Bergerac/Roumanière",
      "Bergerac/Roumanière",
      "Bergerac/Roumanière"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CNG",
    "translations": [
      "Cognac-Châteaubernard (BA 709) Air Base",
      "Cognac-Châteaubernard (BA 709) Air Base",
      "Cognac-Châteaubernard (BA 709) Air Base"
    ],
    "city": [
      "Cognac/Châteaubernard",
      "Cognac/Châteaubernard",
      "Cognac/Châteaubernard"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LRH",
    "translations": [
      "La Rochelle-Île de Ré Airport",
      "La Rochelle-Île de Ré Airport",
      "La Rochelle-Île de Ré Airport"
    ],
    "city": [
      "La Rochelle/Île de Ré",
      "La Rochelle/Île de Ré",
      "La Rochelle/Île de Ré"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "PIS",
    "translations": [
      "Poitiers-Biard Airport",
      "Poitiers-Biard Airport",
      "Poitiers-Biard Airport"
    ],
    "city": [
      "Poitiers/Biard",
      "Poitiers/Biard",
      "Poitiers/Biard"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "MCU",
    "translations": [
      "Montluçon-Guéret Airport",
      "Montluçon-Guéret Airport",
      "Montluçon-Guéret Airport"
    ],
    "city": [
      "Lépaud, Creuse",
      "Lépaud, Creuse",
      "Lépaud, Creuse"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LIG",
    "translations": [
      "Limoges Airport",
      "Limoges Airport",
      "Limoges Airport"
    ],
    "city": [
      "Limoges/Bellegarde",
      "Limoges/Bellegarde",
      "Limoges/Bellegarde"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "NIT",
    "translations": [
      "Niort - Marais Poitevin Airport",
      "Niort - Marais Poitevin Airport",
      "Niort - Marais Poitevin Airport"
    ],
    "city": [
      "Niort/Souché",
      "Niort/Souché",
      "Niort/Souché"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "TLS",
    "translations": [
      "Toulouse-Blagnac Airport",
      "Toulouse-Blagnac Airport",
      "Toulouse-Blagnac Airport"
    ],
    "city": [
      "Toulouse/Blagnac",
      "Toulouse/Blagnac",
      "Toulouse/Blagnac"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "PUF",
    "translations": [
      "Pau Pyrénées Airport",
      "Pau Pyrénées Airport",
      "Pau Pyrénées Airport"
    ],
    "city": [
      "Pau/Pyrénées (Uzein)",
      "Pau/Pyrénées (Uzein)",
      "Pau/Pyrénées (Uzein)"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LDE",
    "translations": [
      "Tarbes-Lourdes-Pyrénées Airport",
      "Tarbes-Lourdes-Pyrénées Airport",
      "Tarbes-Lourdes-Pyrénées Airport"
    ],
    "city": [
      "Tarbes/Lourdes/Pyrénées",
      "Tarbes/Lourdes/Pyrénées",
      "Tarbes/Lourdes/Pyrénées"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "ANG",
    "translations": [
      "Angoulême-Brie-Champniers Airport",
      "Angoulême-Brie-Champniers Airport",
      "Angoulême-Brie-Champniers Airport"
    ],
    "city": [
      "Angoulême/Brie/Champniers",
      "Angoulême/Brie/Champniers",
      "Angoulême/Brie/Champniers"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "PGX",
    "translations": [
      "Périgueux-Bassillac Airport",
      "Périgueux-Bassillac Airport",
      "Périgueux-Bassillac Airport"
    ],
    "city": [
      "Périgueux/Bassillac",
      "Périgueux/Bassillac",
      "Périgueux/Bassillac"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "BIQ",
    "translations": [
      "Biarritz-Anglet-Bayonne Airport",
      "Biarritz-Anglet-Bayonne Airport",
      "Biarritz-Anglet-Bayonne Airport"
    ],
    "city": [
      "Biarritz/Anglet/Bayonne",
      "Biarritz/Anglet/Bayonne",
      "Biarritz/Anglet/Bayonne"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "ZAO",
    "translations": [
      "Aérodrome de Cahors-Lalbenque",
      "Aérodrome de Cahors-Lalbenque",
      "Aérodrome de Cahors-Lalbenque"
    ],
    "city": [
      "Cahors/Lalbenque",
      "Cahors/Lalbenque",
      "Cahors/Lalbenque"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LBI",
    "translations": [
      "Albi-Le Séquestre Airport",
      "Albi-Le Séquestre Airport",
      "Albi-Le Séquestre Airport"
    ],
    "city": [
      "Albi/Le Séquestre",
      "Albi/Le Séquestre",
      "Albi/Le Séquestre"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "DCM",
    "translations": [
      "Castres-Mazamet Airport",
      "Castres-Mazamet Airport",
      "Castres-Mazamet Airport"
    ],
    "city": [
      "Castres/Mazamet",
      "Castres/Mazamet",
      "Castres/Mazamet"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "RDZ",
    "translations": [
      "Rodez–Aveyron Airport",
      "Rodez–Aveyron Airport",
      "Rodez–Aveyron Airport"
    ],
    "city": [
      "Rodez/Marcillac",
      "Rodez/Marcillac",
      "Rodez/Marcillac"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "RYN",
    "translations": [
      "Royan-Médis Airport",
      "Royan-Médis Airport",
      "Royan-Médis Airport"
    ],
    "city": [
      "Royan/Médis",
      "Royan/Médis",
      "Royan/Médis"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "RCO",
    "translations": [
      "Rochefort-Saint-Agnant (BA 721) Airport",
      "Rochefort-Saint-Agnant (BA 721) Airport",
      "Rochefort-Saint-Agnant (BA 721) Airport"
    ],
    "city": [
      "Rochefort/Saint-Agnant",
      "Rochefort/Saint-Agnant",
      "Rochefort/Saint-Agnant"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "BIC",
    "translations": [
      "Aérodrome de Belle Île",
      "Aérodrome de Belle Île",
      "Aérodrome de Belle Île"
    ],
    "city": [
      "Bangor",
      "Bangor",
      "Bangor"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "OUI",
    "translations": [
      "Ouessant Airport",
      "Ouessant Airport",
      "Ouessant Airport"
    ],
    "city": [
      "Ushant",
      "Ushant",
      "Ushant"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "IDY",
    "translations": [
      "Île d'Yeu Airport",
      "Île d'Yeu Airport",
      "Île d'Yeu Airport"
    ],
    "city": [
      "Île d'Yeu",
      "Île d'Yeu",
      "Île d'Yeu"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CMR",
    "translations": [
      "Colmar-Houssen Airport",
      "Colmar-Houssen Airport",
      "Colmar-Houssen Airport"
    ],
    "city": [
      "Colmar, Haut-Rhin",
      "Colmar, Haut-Rhin",
      "Colmar, Haut-Rhin"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "DLE",
    "translations": [
      "Dole-Jura Airport",
      "Dole-Jura Airport",
      "Dole-Jura Airport"
    ],
    "city": [
      "Tavaux, Jura",
      "Tavaux, Jura",
      "Tavaux, Jura"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "MVV",
    "translations": [
      "Megève Altiport",
      "Megève Altiport",
      "Megève Altiport"
    ],
    "city": [
      "Megève",
      "Megève",
      "Megève"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "OBS",
    "translations": [
      "Aubenas-South Ardèche Airport",
      "Aubenas-South Ardèche Airport",
      "Aubenas-South Ardèche Airport"
    ],
    "city": [
      "Lanas, Ardèche",
      "Lanas, Ardèche",
      "Lanas, Ardèche"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LPY",
    "translations": [
      "Le Puy-Loudes Airfield",
      "Le Puy-Loudes Airfield",
      "Le Puy-Loudes Airfield"
    ],
    "city": [
      "Chaspuzac, Haute-Loire",
      "Chaspuzac, Haute-Loire",
      "Chaspuzac, Haute-Loire"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "AHZ",
    "translations": [
      "L'Alpe d'Huez - Henri Giraud Altiport",
      "L'Alpe d'Huez - Henri Giraud Altiport",
      "L'Alpe d'Huez - Henri Giraud Altiport"
    ],
    "city": [
      "Huez, Isère",
      "Huez, Isère",
      "Huez, Isère"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "ETZ",
    "translations": [
      "Metz-Nancy-Lorraine Airport",
      "Metz-Nancy-Lorraine Airport",
      "Metz-Nancy-Lorraine Airport"
    ],
    "city": [
      "Goin",
      "Goin",
      "Goin"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "ANE",
    "translations": [
      "Angers-Loire Airport",
      "Angers-Loire Airport",
      "Angers-Loire Airport"
    ],
    "city": [
      "Marcé, Maine-et-Loire",
      "Marcé, Maine-et-Loire",
      "Marcé, Maine-et-Loire"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "BIA",
    "translations": [
      "Bastia-Poretta Airport",
      "Bastia-Poretta Airport",
      "Bastia-Poretta Airport"
    ],
    "city": [
      "Bastia/Poretta",
      "Bastia/Poretta",
      "Bastia/Poretta"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CLY",
    "translations": [
      "Calvi-Sainte-Catherine Airport",
      "Calvi-Sainte-Catherine Airport",
      "Calvi-Sainte-Catherine Airport"
    ],
    "city": [
      "Calvi/Sainte-Catherine",
      "Calvi/Sainte-Catherine",
      "Calvi/Sainte-Catherine"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "FSC",
    "translations": [
      "Figari Sud-Corse Airport",
      "Figari Sud-Corse Airport",
      "Figari Sud-Corse Airport"
    ],
    "city": [
      "Figari Sud-Corse",
      "Figari Sud-Corse",
      "Figari Sud-Corse"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "AJA",
    "translations": [
      "Ajaccio-Napoléon Bonaparte Airport",
      "Ajaccio-Napoléon Bonaparte Airport",
      "Ajaccio-Napoléon Bonaparte Airport"
    ],
    "city": [
      "Ajaccio/Napoléon Bonaparte",
      "Ajaccio/Napoléon Bonaparte",
      "Ajaccio/Napoléon Bonaparte"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "PRP",
    "translations": [
      "Propriano Airport",
      "Propriano Airport",
      "Propriano Airport"
    ],
    "city": [
      "Propriano",
      "Propriano",
      "Propriano"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "SOZ",
    "translations": [
      "Solenzara (BA 126) Air Base",
      "Solenzara (BA 126) Air Base",
      "Solenzara (BA 126) Air Base"
    ],
    "city": [
      "Solenzara",
      "Solenzara",
      "Solenzara"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "MFX",
    "translations": [
      "Méribel Altiport",
      "Méribel Altiport",
      "Méribel Altiport"
    ],
    "city": [
      "Les Allues",
      "Les Allues",
      "Les Allues"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "AUF",
    "translations": [
      "Auxerre-Branches Airport",
      "Auxerre-Branches Airport",
      "Auxerre-Branches Airport"
    ],
    "city": [
      "Appoigny, Yonne",
      "Appoigny, Yonne",
      "Appoigny, Yonne"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CMF",
    "translations": [
      "Chambéry Savoie Mont Blanc Airport",
      "Chambéry Savoie Mont Blanc Airport",
      "Chambéry Savoie Mont Blanc Airport"
    ],
    "city": [
      "Viviers-du-Lac",
      "Viviers-du-Lac",
      "Viviers-du-Lac"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CFE",
    "translations": [
      "Clermont-Ferrand Auvergne Airport",
      "Clermont-Ferrand Auvergne Airport",
      "Clermont-Ferrand Auvergne Airport"
    ],
    "city": [
      "Aulnat, Puy-de-Dôme",
      "Aulnat, Puy-de-Dôme",
      "Aulnat, Puy-de-Dôme"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "BOU",
    "translations": [
      "Bourges Airport",
      "Bourges Airport",
      "Bourges Airport"
    ],
    "city": [
      "Bourges, Cher",
      "Bourges, Cher",
      "Bourges, Cher"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CVF",
    "translations": [
      "Courchevel Altiport",
      "Courchevel Altiport",
      "Courchevel Altiport"
    ],
    "city": [
      "Saint-Bon",
      "Saint-Bon",
      "Saint-Bon"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LYS",
    "translations": [
      "Lyon Saint-Exupéry Airport",
      "Lyon Saint-Exupéry Airport",
      "Lyon Saint-Exupéry Airport"
    ],
    "city": [
      "Colombier-Saugnieu, Rhône",
      "Colombier-Saugnieu, Rhône",
      "Colombier-Saugnieu, Rhône"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "SYT",
    "translations": [
      "Saint-Yan Airport",
      "Saint-Yan Airport",
      "Saint-Yan Airport"
    ],
    "city": [
      "L'Hôpital-le-Mercier, Saône-et-Loire",
      "L'Hôpital-le-Mercier, Saône-et-Loire",
      "L'Hôpital-le-Mercier, Saône-et-Loire"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "RNE",
    "translations": [
      "Roanne-Renaison Airport",
      "Roanne-Renaison Airport",
      "Roanne-Renaison Airport"
    ],
    "city": [
      "Saint-Léger-sur-Roanne",
      "Saint-Léger-sur-Roanne",
      "Saint-Léger-sur-Roanne"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "NCY",
    "translations": [
      "Annecy Haute-Savoie Mont Blanc Airport",
      "Annecy Haute-Savoie Mont Blanc Airport",
      "Annecy Haute-Savoie Mont Blanc Airport"
    ],
    "city": [
      "Epagny Metz-Tessy",
      "Epagny Metz-Tessy",
      "Epagny Metz-Tessy"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "GNB",
    "translations": [
      "Grenoble Alpes Isère Airport",
      "Grenoble Alpes Isère Airport",
      "Grenoble Alpes Isère Airport"
    ],
    "city": [
      "Saint-Étienne-de-Saint-Geoirs, Isère",
      "Saint-Étienne-de-Saint-Geoirs, Isère",
      "Saint-Étienne-de-Saint-Geoirs, Isère"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "VAF",
    "translations": [
      "Valence-Chabeuil Airport",
      "Valence-Chabeuil Airport",
      "Valence-Chabeuil Airport"
    ],
    "city": [
      "Chabeuil, Drôme",
      "Chabeuil, Drôme",
      "Chabeuil, Drôme"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "VHY",
    "translations": [
      "Vichy-Charmeil Airport",
      "Vichy-Charmeil Airport",
      "Vichy-Charmeil Airport"
    ],
    "city": [
      "Charmeil, Allier",
      "Charmeil, Allier",
      "Charmeil, Allier"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "AUR",
    "translations": [
      "Aurillac Airport",
      "Aurillac Airport",
      "Aurillac Airport"
    ],
    "city": [
      "Aurillac",
      "Aurillac",
      "Aurillac"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CHR",
    "translations": [
      "Châteauroux-Déols Marcel Dassault Airport",
      "Châteauroux-Déols Marcel Dassault Airport",
      "Châteauroux-Déols Marcel Dassault Airport"
    ],
    "city": [
      "Déols, Indre",
      "Déols, Indre",
      "Déols, Indre"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LYN",
    "translations": [
      "Lyon Bron Airport",
      "Lyon Bron Airport",
      "Lyon Bron Airport"
    ],
    "city": [
      "Chassieu, Lyon",
      "Chassieu, Lyon",
      "Chassieu, Lyon"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CEQ",
    "translations": [
      "Cannes-Mandelieu Airport",
      "Cannes-Mandelieu Airport",
      "Cannes-Mandelieu Airport"
    ],
    "city": [
      "Cannes, Alpes-Maritimes",
      "Cannes, Alpes-Maritimes",
      "Cannes, Alpes-Maritimes"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "EBU",
    "translations": [
      "Saint-Étienne-Bouthéon Airport",
      "Saint-Étienne-Bouthéon Airport",
      "Saint-Étienne-Bouthéon Airport"
    ],
    "city": [
      "Andrézieux-Bouthéon, Loire",
      "Andrézieux-Bouthéon, Loire",
      "Andrézieux-Bouthéon, Loire"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CCF",
    "translations": [
      "Carcassonne Airport",
      "Carcassonne Airport",
      "Carcassonne Airport"
    ],
    "city": [
      "Carcassonne/Salvaza",
      "Carcassonne/Salvaza",
      "Carcassonne/Salvaza"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "MRS",
    "translations": [
      "Marseille Provence Airport",
      "Marseille Provence Airport",
      "Marseille Provence Airport"
    ],
    "city": [
      "Marignane, Bouches-du-Rhône",
      "Marignane, Bouches-du-Rhône",
      "Marignane, Bouches-du-Rhône"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "NCE",
    "translations": [
      "Nice-Côte d'Azur Airport",
      "Nice-Côte d'Azur Airport",
      "Nice-Côte d'Azur Airport"
    ],
    "city": [
      "Nice, Alpes-Maritimes",
      "Nice, Alpes-Maritimes",
      "Nice, Alpes-Maritimes"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "PGF",
    "translations": [
      "Perpignan-Rivesaltes (Llabanère) Airport",
      "Perpignan-Rivesaltes (Llabanère) Airport",
      "Perpignan-Rivesaltes (Llabanère) Airport"
    ],
    "city": [
      "Perpignan/Rivesaltes",
      "Perpignan/Rivesaltes",
      "Perpignan/Rivesaltes"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CTT",
    "translations": [
      "Le Castellet Airport",
      "Le Castellet Airport",
      "Le Castellet Airport"
    ],
    "city": [
      "Le Castellet, Var",
      "Le Castellet, Var",
      "Le Castellet, Var"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "BAE",
    "translations": [
      "Barcelonnette - Saint-Pons Airfield",
      "Barcelonnette - Saint-Pons Airfield",
      "Barcelonnette - Saint-Pons Airfield"
    ],
    "city": [
      "Saint-Pons, Alpes-de-Haute-Provence",
      "Saint-Pons, Alpes-de-Haute-Provence",
      "Saint-Pons, Alpes-de-Haute-Provence"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "MPL",
    "translations": [
      "Montpellier-Méditerranée Airport",
      "Montpellier-Méditerranée Airport",
      "Montpellier-Méditerranée Airport"
    ],
    "city": [
      "Montpellier/Méditerranée",
      "Montpellier/Méditerranée",
      "Montpellier/Méditerranée"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "BZR",
    "translations": [
      "Béziers-Vias Airport",
      "Béziers-Vias Airport",
      "Béziers-Vias Airport"
    ],
    "city": [
      "Béziers/Vias",
      "Béziers/Vias",
      "Béziers/Vias"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "AVN",
    "translations": [
      "Avignon-Caumont Airport",
      "Avignon-Caumont Airport",
      "Avignon-Caumont Airport"
    ],
    "city": [
      "Avignon, Vaucluse",
      "Avignon, Vaucluse",
      "Avignon, Vaucluse"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "GAT",
    "translations": [
      "Gap-Tallard Airfield",
      "Gap-Tallard Airfield",
      "Gap-Tallard Airfield"
    ],
    "city": [
      "Tallard, Hautes-Alpes",
      "Tallard, Hautes-Alpes",
      "Tallard, Hautes-Alpes"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "MEN",
    "translations": [
      "Mende-Brenoux Airfield",
      "Mende-Brenoux Airfield",
      "Mende-Brenoux Airfield"
    ],
    "city": [
      "Mende/Brénoux",
      "Mende/Brénoux",
      "Mende/Brénoux"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "SCP",
    "translations": [
      "Mont-Dauphin Saint-Crépin Airfield",
      "Mont-Dauphin Saint-Crépin Airfield",
      "Mont-Dauphin Saint-Crépin Airfield"
    ],
    "city": [
      "Saint-Crépin, Hautes-Alpes",
      "Saint-Crépin, Hautes-Alpes",
      "Saint-Crépin, Hautes-Alpes"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "BVA",
    "translations": [
      "Paris-Beauvais Airport",
      "Paris-Beauvais Airport",
      "Paris-Beauvais Airport"
    ],
    "city": [
      "Tillé",
      "Tillé",
      "Tillé"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "EVX",
    "translations": [
      "Évreux-Fauville (BA 105) Air Base",
      "Évreux-Fauville (BA 105) Air Base",
      "Évreux-Fauville (BA 105) Air Base"
    ],
    "city": [
      "Fauville, Eure",
      "Fauville, Eure",
      "Fauville, Eure"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LEH",
    "translations": [
      "Le Havre-Octeville Airport",
      "Le Havre-Octeville Airport",
      "Le Havre-Octeville Airport"
    ],
    "city": [
      "Le Havre",
      "Le Havre",
      "Le Havre"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "XCR",
    "translations": [
      "Châlons-Vatry Airport",
      "Châlons-Vatry Airport",
      "Châlons-Vatry Airport"
    ],
    "city": [
      "Bussy-Lettrée",
      "Bussy-Lettrée",
      "Bussy-Lettrée"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LSO",
    "translations": [
      "Les Sables-d'Olonne Talmont Airport",
      "Les Sables-d'Olonne Talmont Airport",
      "Les Sables-d'Olonne Talmont Airport"
    ],
    "city": [
      "Les Sables-d'Olonne",
      "Les Sables-d'Olonne",
      "Les Sables-d'Olonne"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "URO",
    "translations": [
      "Rouen Vallée de Seine Airport",
      "Rouen Vallée de Seine Airport",
      "Rouen Vallée de Seine Airport"
    ],
    "city": [
      "Boos",
      "Boos",
      "Boos"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "TUF",
    "translations": [
      "Tours Val de Loire Airport",
      "Tours Val de Loire Airport",
      "Tours Val de Loire Airport"
    ],
    "city": [
      "Tours, Indre-et-Loire",
      "Tours, Indre-et-Loire",
      "Tours, Indre-et-Loire"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CET",
    "translations": [
      "Cholet Le Pontreau Airfield",
      "Cholet Le Pontreau Airfield",
      "Cholet Le Pontreau Airfield"
    ],
    "city": [
      "Cholet/Le Pontreau",
      "Cholet/Le Pontreau",
      "Cholet/Le Pontreau"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LVA",
    "translations": [
      "Laval-Entrammes Airport",
      "Laval-Entrammes Airport",
      "Laval-Entrammes Airport"
    ],
    "city": [
      "Laval, Mayenne",
      "Laval, Mayenne",
      "Laval, Mayenne"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "ORE",
    "translations": [
      "Orléans–Saint-Denis-de-l'Hôtel Airport",
      "Orléans–Saint-Denis-de-l'Hôtel Airport",
      "Orléans–Saint-Denis-de-l'Hôtel Airport"
    ],
    "city": [
      "Saint-Denis-de-l'Hôtel, Loiret",
      "Saint-Denis-de-l'Hôtel, Loiret",
      "Saint-Denis-de-l'Hôtel, Loiret"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LBG",
    "translations": [
      "Paris-Le Bourget Airport",
      "Paris-Le Bourget Airport",
      "Paris-Le Bourget Airport"
    ],
    "city": [
      "Paris (Le Bourget, Seine-Saint-Denis)",
      "Paris (Le Bourget, Seine-Saint-Denis)",
      "Paris (Le Bourget, Seine-Saint-Denis)"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CSF",
    "translations": [
      "Creil Air Base",
      "Creil Air Base",
      "Creil Air Base"
    ],
    "city": [
      "Creil",
      "Creil",
      "Creil"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CDG",
    "translations": [
      "Charles de Gaulle International Airport",
      "Charles de Gaulle International Airport",
      "Charles de Gaulle International Airport"
    ],
    "city": [
      "Paris (Roissy-en-France, Val-d'Oise)",
      "Paris (Roissy-en-France, Val-d'Oise)",
      "Paris (Roissy-en-France, Val-d'Oise)"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "TNF",
    "translations": [
      "Toussus-le-Noble Airport",
      "Toussus-le-Noble Airport",
      "Toussus-le-Noble Airport"
    ],
    "city": [
      "Toussus-le-Noble, Yvelines",
      "Toussus-le-Noble, Yvelines",
      "Toussus-le-Noble, Yvelines"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "ORY",
    "translations": [
      "Paris-Orly Airport",
      "Paris-Orly Airport",
      "Paris-Orly Airport"
    ],
    "city": [
      "Paris (Orly, Val-de-Marne)",
      "Paris (Orly, Val-de-Marne)",
      "Paris (Orly, Val-de-Marne)"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "POX",
    "translations": [
      "Pontoise-Cormeilles Aerodrome",
      "Pontoise-Cormeilles Aerodrome",
      "Pontoise-Cormeilles Aerodrome"
    ],
    "city": [
      "Cormeilles-en-Vexin, Val-d'Oise",
      "Cormeilles-en-Vexin, Val-d'Oise",
      "Cormeilles-en-Vexin, Val-d'Oise"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "VIY",
    "translations": [
      "Vélizy-Villacoublay Air Base",
      "Vélizy-Villacoublay Air Base",
      "Vélizy-Villacoublay Air Base"
    ],
    "city": [
      "Vélizy-Villacoublay, Yvelines",
      "Vélizy-Villacoublay, Yvelines",
      "Vélizy-Villacoublay, Yvelines"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "NVS",
    "translations": [
      "Nevers-Fourchambault Airport",
      "Nevers-Fourchambault Airport",
      "Nevers-Fourchambault Airport"
    ],
    "city": [
      "Marzy, Nièvre",
      "Marzy, Nièvre",
      "Marzy, Nièvre"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LIL",
    "translations": [
      "Lille Airport",
      "Lille Airport",
      "Lille Airport"
    ],
    "city": [
      "Lesquin",
      "Lesquin",
      "Lesquin"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "HZB",
    "translations": [
      "Merville-Calonne Airport",
      "Merville-Calonne Airport",
      "Merville-Calonne Airport"
    ],
    "city": [
      "Merville, Nord",
      "Merville, Nord",
      "Merville, Nord"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "BES",
    "translations": [
      "Brest Bretagne Airport",
      "Brest Bretagne Airport",
      "Brest Bretagne Airport"
    ],
    "city": [
      "Brest/Guipavas",
      "Brest/Guipavas",
      "Brest/Guipavas"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CER",
    "translations": [
      "Cherbourg-Maupertus Airport",
      "Cherbourg-Maupertus Airport",
      "Cherbourg-Maupertus Airport"
    ],
    "city": [
      "Gonneville-Le Theil, Manche",
      "Gonneville-Le Theil, Manche",
      "Gonneville-Le Theil, Manche"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "DNR",
    "translations": [
      "Dinard-Pleurtuit-Saint-Malo Airport",
      "Dinard-Pleurtuit-Saint-Malo Airport",
      "Dinard-Pleurtuit-Saint-Malo Airport"
    ],
    "city": [
      "Pleurtuit, Ille-et-Vilaine",
      "Pleurtuit, Ille-et-Vilaine",
      "Pleurtuit, Ille-et-Vilaine"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LBY",
    "translations": [
      "La Baule-Escoublac Airport",
      "La Baule-Escoublac Airport",
      "La Baule-Escoublac Airport"
    ],
    "city": [
      "La Baule-Escoublac",
      "La Baule-Escoublac",
      "La Baule-Escoublac"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "GFR",
    "translations": [
      "Granville Airport",
      "Granville Airport",
      "Granville Airport"
    ],
    "city": [
      "Bréville-sur-Mer, Manche",
      "Bréville-sur-Mer, Manche",
      "Bréville-sur-Mer, Manche"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "DOL",
    "translations": [
      "Deauville-Normandie Airport",
      "Deauville-Normandie Airport",
      "Deauville-Normandie Airport"
    ],
    "city": [
      "Deauville, Calvados",
      "Deauville, Calvados",
      "Deauville, Calvados"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LRT",
    "translations": [
      "Lorient South Brittany (Bretagne Sud) Airport",
      "Lorient South Brittany (Bretagne Sud) Airport",
      "Lorient South Brittany (Bretagne Sud) Airport"
    ],
    "city": [
      "Lorient/Lann/Bihoué",
      "Lorient/Lann/Bihoué",
      "Lorient/Lann/Bihoué"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "EDM",
    "translations": [
      "La Roche-sur-Yon Airport",
      "La Roche-sur-Yon Airport",
      "La Roche-sur-Yon Airport"
    ],
    "city": [
      "La Roche-sur-Yon/Les Ajoncs",
      "La Roche-sur-Yon/Les Ajoncs",
      "La Roche-sur-Yon/Les Ajoncs"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LDV",
    "translations": [
      "Landivisiau Air Base",
      "Landivisiau Air Base",
      "Landivisiau Air Base"
    ],
    "city": [
      "Landivisiau",
      "Landivisiau",
      "Landivisiau"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "CFR",
    "translations": [
      "Caen-Carpiquet Airport",
      "Caen-Carpiquet Airport",
      "Caen-Carpiquet Airport"
    ],
    "city": [
      "Carpiquet, Calvados",
      "Carpiquet, Calvados",
      "Carpiquet, Calvados"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LME",
    "translations": [
      "Le Mans-Arnage Airport",
      "Le Mans-Arnage Airport",
      "Le Mans-Arnage Airport"
    ],
    "city": [
      "Le Mans, Sarthe",
      "Le Mans, Sarthe",
      "Le Mans, Sarthe"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "RNS",
    "translations": [
      "Rennes-Saint-Jacques Airport",
      "Rennes-Saint-Jacques Airport",
      "Rennes-Saint-Jacques Airport"
    ],
    "city": [
      "Saint-Jacques-de-la-Lande, Ille-et-Vilaine",
      "Saint-Jacques-de-la-Lande, Ille-et-Vilaine",
      "Saint-Jacques-de-la-Lande, Ille-et-Vilaine"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LAI",
    "translations": [
      "Lannion-Côte de Granit Airport",
      "Lannion-Côte de Granit Airport",
      "Lannion-Côte de Granit Airport"
    ],
    "city": [
      "Lannion",
      "Lannion",
      "Lannion"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "UIP",
    "translations": [
      "Quimper-Cornouaille Airport",
      "Quimper-Cornouaille Airport",
      "Quimper-Cornouaille Airport"
    ],
    "city": [
      "Quimper/Pluguffan",
      "Quimper/Pluguffan",
      "Quimper/Pluguffan"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "NTE",
    "translations": [
      "Nantes Atlantique Airport",
      "Nantes Atlantique Airport",
      "Nantes Atlantique Airport"
    ],
    "city": [
      "Nantes",
      "Nantes",
      "Nantes"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "SBK",
    "translations": [
      "Saint-Brieuc-Armor Airport",
      "Saint-Brieuc-Armor Airport",
      "Saint-Brieuc-Armor Airport"
    ],
    "city": [
      "Trémuson, Côtes-d'Armor",
      "Trémuson, Côtes-d'Armor",
      "Trémuson, Côtes-d'Armor"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "MXN",
    "translations": [
      "Morlaix-Ploujean Airport",
      "Morlaix-Ploujean Airport",
      "Morlaix-Ploujean Airport"
    ],
    "city": [
      "Morlaix/Ploujean",
      "Morlaix/Ploujean",
      "Morlaix/Ploujean"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "VNE",
    "translations": [
      "Vannes-Meucon Airport",
      "Vannes-Meucon Airport",
      "Vannes-Meucon Airport"
    ],
    "city": [
      "Vannes/Meucon",
      "Vannes/Meucon",
      "Vannes/Meucon"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "SNR",
    "translations": [
      "Saint-Nazaire-Montoir Airport",
      "Saint-Nazaire-Montoir Airport",
      "Saint-Nazaire-Montoir Airport"
    ],
    "city": [
      "Saint-Nazaire/Montoir",
      "Saint-Nazaire/Montoir",
      "Saint-Nazaire/Montoir"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "BSL",
    "translations": [
      "EuroAirport Basel-Mulhouse-Freiburg",
      "EuroAirport Basel-Mulhouse-Freiburg",
      "EuroAirport Basel-Mulhouse-Freiburg"
    ],
    "city": [
      "Saint-Louis",
      "Saint-Louis",
      "Saint-Louis"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "DIJ",
    "translations": [
      "Dijon-Bourgogne Airport",
      "Dijon-Bourgogne Airport",
      "Dijon-Bourgogne Airport"
    ],
    "city": [
      "Ouges, Côte-d'Or",
      "Ouges, Côte-d'Or",
      "Ouges, Côte-d'Or"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "EPL",
    "translations": [
      "Épinal-Mirecourt Airport",
      "Épinal-Mirecourt Airport",
      "Épinal-Mirecourt Airport"
    ],
    "city": [
      "Juvaincourt, Vosges",
      "Juvaincourt, Vosges",
      "Juvaincourt, Vosges"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "BVE",
    "translations": [
      "Brive-Souillac Airport",
      "Brive-Souillac Airport",
      "Brive-Souillac Airport"
    ],
    "city": [
      "Brive la Gaillarde",
      "Brive la Gaillarde",
      "Brive la Gaillarde"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "ENC",
    "translations": [
      "Nancy-Essey Airport",
      "Nancy-Essey Airport",
      "Nancy-Essey Airport"
    ],
    "city": [
      "Tomblaine, Meurthe-et-Moselle",
      "Tomblaine, Meurthe-et-Moselle",
      "Tomblaine, Meurthe-et-Moselle"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "SXB",
    "translations": [
      "Strasbourg Airport",
      "Strasbourg Airport",
      "Strasbourg Airport"
    ],
    "city": [
      "Strasbourg",
      "Strasbourg",
      "Strasbourg"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "TLN",
    "translations": [
      "Toulon-Hyères Airport",
      "Toulon-Hyères Airport",
      "Toulon-Hyères Airport"
    ],
    "city": [
      "Hyères, Var",
      "Hyères, Var",
      "Hyères, Var"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "FNI",
    "translations": [
      "Nîmes-Arles-Camargue Airport",
      "Nîmes-Arles-Camargue Airport",
      "Nîmes-Arles-Camargue Airport"
    ],
    "city": [
      "Nîmes/Garons",
      "Nîmes/Garons",
      "Nîmes/Garons"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "LTT",
    "translations": [
      "La Môle-Saint-Tropez Airport",
      "La Môle-Saint-Tropez Airport",
      "La Môle-Saint-Tropez Airport"
    ],
    "city": [
      "La Môle, Var",
      "La Môle, Var",
      "La Môle, Var"
    ],
    "country": [
      "France",
      "France",
      "Frankreich"
    ]
  },
  {
    "iata": "MQC",
    "translations": [
      "Miquelon Airport",
      "Miquelon Airport",
      "Miquelon Airport"
    ],
    "city": [
      "Miquelon",
      "Miquelon",
      "Miquelon"
    ],
    "country": [
      "PM",
      "PM",
      "PM"
    ]
  },
  {
    "iata": "FSP",
    "translations": [
      "St Pierre Airport",
      "St Pierre Airport",
      "St Pierre Airport"
    ],
    "city": [
      "Saint-Pierre",
      "Saint-Pierre",
      "Saint-Pierre"
    ],
    "country": [
      "PM",
      "PM",
      "PM"
    ]
  },
  {
    "iata": "PYR",
    "translations": [
      "Andravida Air Base",
      "Andravida Air Base",
      "Andravida Air Base"
    ],
    "city": [
      "Andravida",
      "Andravida",
      "Andravida"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "AXD",
    "translations": [
      "Alexandroupoli Democritus Airport",
      "Alexandroupoli Democritus Airport",
      "Alexandroupoli Democritus Airport"
    ],
    "city": [
      "Alexandroupolis",
      "Alexandroupolis",
      "Alexandroupolis"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "ATH",
    "translations": [
      "Athens Eleftherios Venizelos International Airport",
      "Athens Eleftherios Venizelos International Airport",
      "Athens Eleftherios Venizelos International Airport"
    ],
    "city": [
      "Spata-Artemida",
      "Spata-Artemida",
      "Spata-Artemida"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "VOL",
    "translations": [
      "Nea Anchialos National Airport",
      "Nea Anchialos National Airport",
      "Nea Anchialos National Airport"
    ],
    "city": [
      "Nea Anchialos",
      "Nea Anchialos",
      "Nea Anchialos"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "LGE",
    "translations": [
      "Mulan Airport",
      "Mulan Airport",
      "Mulan Airport"
    ],
    "city": [
      "Lake Gregory",
      "Lake Gregory",
      "Lake Gregory"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "JKH",
    "translations": [
      "Chios Island National Airport",
      "Chios Island National Airport",
      "Chios Island National Airport"
    ],
    "city": [
      "Chios Island",
      "Chios Island",
      "Chios Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "JIK",
    "translations": [
      "Ikaria Airport",
      "Ikaria Airport",
      "Ikaria Airport"
    ],
    "city": [
      "Ikaria Island",
      "Ikaria Island",
      "Ikaria Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "IOA",
    "translations": [
      "Ioannina King Pyrrhus National Airport",
      "Ioannina King Pyrrhus National Airport",
      "Ioannina King Pyrrhus National Airport"
    ],
    "city": [
      "Ioannina",
      "Ioannina",
      "Ioannina"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "HER",
    "translations": [
      "Heraklion International Nikos Kazantzakis Airport",
      "Heraklion International Nikos Kazantzakis Airport",
      "Heraklion International Nikos Kazantzakis Airport"
    ],
    "city": [
      "Heraklion",
      "Heraklion",
      "Heraklion"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "KSO",
    "translations": [
      "Kastoria National Airport Aristotle",
      "Kastoria National Airport Aristotle",
      "Kastoria National Airport Aristotle"
    ],
    "city": [
      "Argos Orestiko",
      "Argos Orestiko",
      "Argos Orestiko"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "KIT",
    "translations": [
      "Kithira Airport",
      "Kithira Airport",
      "Kithira Airport"
    ],
    "city": [
      "Kithira Island",
      "Kithira Island",
      "Kithira Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "EFL",
    "translations": [
      "Kefallinia Airport",
      "Kefallinia Airport",
      "Kefallinia Airport"
    ],
    "city": [
      "Kefallinia Island",
      "Kefallinia Island",
      "Kefallinia Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "KZS",
    "translations": [
      "Kastelorizo Airport",
      "Kastelorizo Airport",
      "Kastelorizo Airport"
    ],
    "city": [
      "Kastelorizo Island",
      "Kastelorizo Island",
      "Kastelorizo Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "KLX",
    "translations": [
      "Kalamata Airport",
      "Kalamata Airport",
      "Kalamata Airport"
    ],
    "city": [
      "Kalamata",
      "Kalamata",
      "Kalamata"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "KGS",
    "translations": [
      "Kos Airport",
      "Kos Airport",
      "Kos Airport"
    ],
    "city": [
      "Kos Island",
      "Kos Island",
      "Kos Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "AOK",
    "translations": [
      "Karpathos Airport",
      "Karpathos Airport",
      "Karpathos Airport"
    ],
    "city": [
      "Karpathos Island",
      "Karpathos Island",
      "Karpathos Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "CFU",
    "translations": [
      "Corfu Ioannis Kapodistrias International Airport",
      "Corfu Ioannis Kapodistrias International Airport",
      "Corfu Ioannis Kapodistrias International Airport"
    ],
    "city": [
      "Kerkyra (Corfu)",
      "Kerkyra (Corfu)",
      "Kerkyra (Corfu)"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "KSJ",
    "translations": [
      "Kasos Airport",
      "Kasos Airport",
      "Kasos Airport"
    ],
    "city": [
      "Kasos Island",
      "Kasos Island",
      "Kasos Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "KVA",
    "translations": [
      "Kavala Alexander the Great International Airport",
      "Kavala Alexander the Great International Airport",
      "Kavala Alexander the Great International Airport"
    ],
    "city": [
      "Kavala",
      "Kavala",
      "Kavala"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "JKL",
    "translations": [
      "Kalymnos Airport",
      "Kalymnos Airport",
      "Kalymnos Airport"
    ],
    "city": [
      "Kalymnos Island",
      "Kalymnos Island",
      "Kalymnos Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "KZI",
    "translations": [
      "Kozani National Airport Filippos",
      "Kozani National Airport Filippos",
      "Kozani National Airport Filippos"
    ],
    "city": [
      "Kozani",
      "Kozani",
      "Kozani"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "LRS",
    "translations": [
      "Leros Airport",
      "Leros Airport",
      "Leros Airport"
    ],
    "city": [
      "Leros Island",
      "Leros Island",
      "Leros Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "LXS",
    "translations": [
      "Limnos Airport",
      "Limnos Airport",
      "Limnos Airport"
    ],
    "city": [
      "Limnos Island",
      "Limnos Island",
      "Limnos Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "LRA",
    "translations": [
      "Larissa Air Base",
      "Larissa Air Base",
      "Larissa Air Base"
    ],
    "city": [
      "Larissa",
      "Larissa",
      "Larissa"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "JMK",
    "translations": [
      "Mykonos Island National Airport",
      "Mykonos Island National Airport",
      "Mykonos Island National Airport"
    ],
    "city": [
      "Mykonos",
      "Mykonos",
      "Mykonos"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "MLO",
    "translations": [
      "Milos Airport",
      "Milos Airport",
      "Milos Airport"
    ],
    "city": [
      "Milos Island",
      "Milos Island",
      "Milos Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "MJT",
    "translations": [
      "Mytilene International Airport",
      "Mytilene International Airport",
      "Mytilene International Airport"
    ],
    "city": [
      "Mytilene",
      "Mytilene",
      "Mytilene"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "JNX",
    "translations": [
      "Naxos Island National Airport",
      "Naxos Island National Airport",
      "Naxos Island National Airport"
    ],
    "city": [
      "Naxos",
      "Naxos",
      "Naxos"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "PAS",
    "translations": [
      "Paros National Airport",
      "Paros National Airport",
      "Paros National Airport"
    ],
    "city": [
      "Paros",
      "Paros",
      "Paros"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "JTY",
    "translations": [
      "Astypalaia Airport",
      "Astypalaia Airport",
      "Astypalaia Airport"
    ],
    "city": [
      "Astypalaia Island",
      "Astypalaia Island",
      "Astypalaia Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "PVK",
    "translations": [
      "Aktion National Airport",
      "Aktion National Airport",
      "Aktion National Airport"
    ],
    "city": [
      "Preveza",
      "Preveza",
      "Preveza"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "RHO",
    "translations": [
      "Diagoras Airport",
      "Diagoras Airport",
      "Diagoras Airport"
    ],
    "city": [
      "Rhodes",
      "Rhodes",
      "Rhodes"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "GPA",
    "translations": [
      "Patras Araxos Agamemnon Airport",
      "Patras Araxos Agamemnon Airport",
      "Patras Araxos Agamemnon Airport"
    ],
    "city": [
      "Patras",
      "Patras",
      "Patras"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "CHQ",
    "translations": [
      "Chania International Airport",
      "Chania International Airport",
      "Chania International Airport"
    ],
    "city": [
      "Souda",
      "Souda",
      "Souda"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "JSI",
    "translations": [
      "Skiathos Island National Airport",
      "Skiathos Island National Airport",
      "Skiathos Island National Airport"
    ],
    "city": [
      "Skiathos",
      "Skiathos",
      "Skiathos"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "SMI",
    "translations": [
      "Samos Airport",
      "Samos Airport",
      "Samos Airport"
    ],
    "city": [
      "Samos Island",
      "Samos Island",
      "Samos Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "JSY",
    "translations": [
      "Syros Airport",
      "Syros Airport",
      "Syros Airport"
    ],
    "city": [
      "Syros Island",
      "Syros Island",
      "Syros Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "SPJ",
    "translations": [
      "Sparti Airfield",
      "Sparti Airfield",
      "Sparti Airfield"
    ],
    "city": [
      "Sparti",
      "Sparti",
      "Sparti"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "JTR",
    "translations": [
      "Santorini Airport",
      "Santorini Airport",
      "Santorini Airport"
    ],
    "city": [
      "Santorini Island",
      "Santorini Island",
      "Santorini Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "JSH",
    "translations": [
      "Sitia Airport",
      "Sitia Airport",
      "Sitia Airport"
    ],
    "city": [
      "Crete Island",
      "Crete Island",
      "Crete Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "SKU",
    "translations": [
      "Skiros Airport",
      "Skiros Airport",
      "Skiros Airport"
    ],
    "city": [
      "Skiros Island",
      "Skiros Island",
      "Skiros Island"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "SKG",
    "translations": [
      "Thessaloniki Macedonia International Airport",
      "Thessaloniki Macedonia International Airport",
      "Thessaloniki Macedonia International Airport"
    ],
    "city": [
      "Thessaloniki",
      "Thessaloniki",
      "Thessaloniki"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "ZTH",
    "translations": [
      "Zakynthos International Airport Dionysios Solomos",
      "Zakynthos International Airport Dionysios Solomos",
      "Zakynthos International Airport Dionysios Solomos"
    ],
    "city": [
      "Zakynthos",
      "Zakynthos",
      "Zakynthos"
    ],
    "country": [
      "GR",
      "GR",
      "GR"
    ]
  },
  {
    "iata": "BUD",
    "translations": [
      "Budapest Liszt Ferenc International Airport",
      "Budapest Liszt Ferenc International Airport",
      "Budapest Liszt Ferenc International Airport"
    ],
    "city": [
      "Budapest",
      "Budapest",
      "Budapest"
    ],
    "country": [
      "HU",
      "HU",
      "HU"
    ]
  },
  {
    "iata": "DEB",
    "translations": [
      "Debrecen International Airport",
      "Debrecen International Airport",
      "Debrecen International Airport"
    ],
    "city": [
      "Debrecen",
      "Debrecen",
      "Debrecen"
    ],
    "country": [
      "HU",
      "HU",
      "HU"
    ]
  },
  {
    "iata": "PEV",
    "translations": [
      "Pécs-Pogány Airport",
      "Pécs-Pogány Airport",
      "Pécs-Pogány Airport"
    ],
    "city": [
      "Pécs",
      "Pécs",
      "Pécs"
    ],
    "country": [
      "HU",
      "HU",
      "HU"
    ]
  },
  {
    "iata": "SOB",
    "translations": [
      "Hévíz–Balaton Airport",
      "Hévíz–Balaton Airport",
      "Hévíz–Balaton Airport"
    ],
    "city": [
      "Sármellék",
      "Sármellék",
      "Sármellék"
    ],
    "country": [
      "HU",
      "HU",
      "HU"
    ]
  },
  {
    "iata": "CRV",
    "translations": [
      "Crotone Sant'Anna Pythagoras Airport",
      "Crotone Sant'Anna Pythagoras Airport",
      "Crotone Sant'Anna Pythagoras Airport"
    ],
    "city": [
      "Isola di Capo Rizzuto (KR)",
      "Isola di Capo Rizzuto (KR)",
      "Isola di Capo Rizzuto (KR)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "BRI",
    "translations": [
      "Bari Karol Wojtyła International Airport",
      "Bari Karol Wojtyła International Airport",
      "Bari Karol Wojtyła International Airport"
    ],
    "city": [
      "Bari",
      "Bari",
      "Bari"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "FOG",
    "translations": [
      "Foggia Gino Lisa Airport",
      "Foggia Gino Lisa Airport",
      "Foggia Gino Lisa Airport"
    ],
    "city": [
      "Foggia (FG)",
      "Foggia (FG)",
      "Foggia (FG)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "TAR",
    "translations": [
      "Taranto-Grottaglie Marcello Arlotta Airport",
      "Taranto-Grottaglie Marcello Arlotta Airport",
      "Taranto-Grottaglie Marcello Arlotta Airport"
    ],
    "city": [
      "Grottaglie",
      "Grottaglie",
      "Grottaglie"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "LCC",
    "translations": [
      "Lecce Galatina Air Base / Galatina Fortunato Cesari Airport",
      "Lecce Galatina Air Base / Galatina Fortunato Cesari Airport",
      "Lecce Galatina Air Base / Galatina Fortunato Cesari Airport"
    ],
    "city": [
      "Galatina (LE)",
      "Galatina (LE)",
      "Galatina (LE)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "PSR",
    "translations": [
      "Abruzzo Airport",
      "Abruzzo Airport",
      "Abruzzo Airport"
    ],
    "city": [
      "Pescara",
      "Pescara",
      "Pescara"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "BDS",
    "translations": [
      "Brindisi Airport",
      "Brindisi Airport",
      "Brindisi Airport"
    ],
    "city": [
      "Brindisi",
      "Brindisi",
      "Brindisi"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "SUF",
    "translations": [
      "Lamezia Terme Sant'Eufemia International Airport",
      "Lamezia Terme Sant'Eufemia International Airport",
      "Lamezia Terme Sant'Eufemia International Airport"
    ],
    "city": [
      "Lamezia Terme (CZ)",
      "Lamezia Terme (CZ)",
      "Lamezia Terme (CZ)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "CIY",
    "translations": [
      "Comiso Airport",
      "Comiso Airport",
      "Comiso Airport"
    ],
    "city": [
      "Comiso",
      "Comiso",
      "Comiso"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "CTA",
    "translations": [
      "Catania-Fontanarossa Airport",
      "Catania-Fontanarossa Airport",
      "Catania-Fontanarossa Airport"
    ],
    "city": [
      "Catania",
      "Catania",
      "Catania"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "LMP",
    "translations": [
      "Lampedusa Airport",
      "Lampedusa Airport",
      "Lampedusa Airport"
    ],
    "city": [
      "Lampedusa",
      "Lampedusa",
      "Lampedusa"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "PNL",
    "translations": [
      "Pantelleria Airport",
      "Pantelleria Airport",
      "Pantelleria Airport"
    ],
    "city": [
      "Pantelleria (TP)",
      "Pantelleria (TP)",
      "Pantelleria (TP)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "PMO",
    "translations": [
      "Falcone–Borsellino Airport",
      "Falcone–Borsellino Airport",
      "Falcone–Borsellino Airport"
    ],
    "city": [
      "Palermo",
      "Palermo",
      "Palermo"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "REG",
    "translations": [
      "Reggio Calabria Airport",
      "Reggio Calabria Airport",
      "Reggio Calabria Airport"
    ],
    "city": [
      "Reggio Calabria",
      "Reggio Calabria",
      "Reggio Calabria"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "TPS",
    "translations": [
      "Vincenzo Florio Airport Trapani-Birgi",
      "Vincenzo Florio Airport Trapani-Birgi",
      "Vincenzo Florio Airport Trapani-Birgi"
    ],
    "city": [
      "Trapani (TP)",
      "Trapani (TP)",
      "Trapani (TP)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "BLX",
    "translations": [
      "Belluno Arturo dell'Oro Airport",
      "Belluno Arturo dell'Oro Airport",
      "Belluno Arturo dell'Oro Airport"
    ],
    "city": [
      "Belluno (BL)",
      "Belluno (BL)",
      "Belluno (BL)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "RAN",
    "translations": [
      "Ravenna Airport",
      "Ravenna Airport",
      "Ravenna Airport"
    ],
    "city": [
      "Ravenna (RA)",
      "Ravenna (RA)",
      "Ravenna (RA)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "AHO",
    "translations": [
      "Alghero-Fertilia Airport",
      "Alghero-Fertilia Airport",
      "Alghero-Fertilia Airport"
    ],
    "city": [
      "Alghero",
      "Alghero",
      "Alghero"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "DCI",
    "translations": [
      "Decimomannu Air Base",
      "Decimomannu Air Base",
      "Decimomannu Air Base"
    ],
    "city": [
      "Decimomannu",
      "Decimomannu",
      "Decimomannu"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "CAG",
    "translations": [
      "Cagliari Elmas Airport",
      "Cagliari Elmas Airport",
      "Cagliari Elmas Airport"
    ],
    "city": [
      "Cagliari",
      "Cagliari",
      "Cagliari"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "OLB",
    "translations": [
      "Olbia Costa Smeralda Airport",
      "Olbia Costa Smeralda Airport",
      "Olbia Costa Smeralda Airport"
    ],
    "city": [
      "Olbia (SS)",
      "Olbia (SS)",
      "Olbia (SS)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "FNU",
    "translations": [
      "Oristano-Fenosu Airport",
      "Oristano-Fenosu Airport",
      "Oristano-Fenosu Airport"
    ],
    "city": [
      "Oristano",
      "Oristano",
      "Oristano"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "MXP",
    "translations": [
      "Milan Malpensa International Airport",
      "Milan Malpensa International Airport",
      "Milan Malpensa International Airport"
    ],
    "city": [
      "Ferno (VA)",
      "Ferno (VA)",
      "Ferno (VA)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "BGY",
    "translations": [
      "Milan Bergamo Airport / Antonio Locatelli Air Base",
      "Milan Bergamo Airport / Antonio Locatelli Air Base",
      "Milan Bergamo Airport / Antonio Locatelli Air Base"
    ],
    "city": [
      "Orio al Serio (BG)",
      "Orio al Serio (BG)",
      "Orio al Serio (BG)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "TRN",
    "translations": [
      "Turin Airport",
      "Turin Airport",
      "Turin Airport"
    ],
    "city": [
      "Caselle Torinese (TO)",
      "Caselle Torinese (TO)",
      "Caselle Torinese (TO)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "GOA",
    "translations": [
      "Genoa Cristoforo Colombo Airport",
      "Genoa Cristoforo Colombo Airport",
      "Genoa Cristoforo Colombo Airport"
    ],
    "city": [
      "Genova (GE)",
      "Genova (GE)",
      "Genova (GE)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "LIN",
    "translations": [
      "Milano Linate Airport",
      "Milano Linate Airport",
      "Milano Linate Airport"
    ],
    "city": [
      "Segrate (MI)",
      "Segrate (MI)",
      "Segrate (MI)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "PMF",
    "translations": [
      "Parma Airport",
      "Parma Airport",
      "Parma Airport"
    ],
    "city": [
      "Parma (PR)",
      "Parma (PR)",
      "Parma (PR)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "AOT",
    "translations": [
      "Aosta Corrado Gex Airport",
      "Aosta Corrado Gex Airport",
      "Aosta Corrado Gex Airport"
    ],
    "city": [
      "Saint-Christophe (AO)",
      "Saint-Christophe (AO)",
      "Saint-Christophe (AO)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "CUF",
    "translations": [
      "Cuneo International Airport",
      "Cuneo International Airport",
      "Cuneo International Airport"
    ],
    "city": [
      "Levaldigi (CN)",
      "Levaldigi (CN)",
      "Levaldigi (CN)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "AVB",
    "translations": [
      "Aviano Air Base",
      "Aviano Air Base",
      "Aviano Air Base"
    ],
    "city": [
      "Aviano (PN)",
      "Aviano (PN)",
      "Aviano (PN)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "BZO",
    "translations": [
      "Bolzano Airport",
      "Bolzano Airport",
      "Bolzano Airport"
    ],
    "city": [
      "Bolzano (BZ)",
      "Bolzano (BZ)",
      "Bolzano (BZ)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "BLQ",
    "translations": [
      "Bologna Guglielmo Marconi Airport",
      "Bologna Guglielmo Marconi Airport",
      "Bologna Guglielmo Marconi Airport"
    ],
    "city": [
      "Bologna",
      "Bologna",
      "Bologna"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "TSF",
    "translations": [
      "Treviso Antonio Canova Airport",
      "Treviso Antonio Canova Airport",
      "Treviso Antonio Canova Airport"
    ],
    "city": [
      "Treviso (TV)",
      "Treviso (TV)",
      "Treviso (TV)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "FRL",
    "translations": [
      "Forlì Luigi Ridolfi Airport",
      "Forlì Luigi Ridolfi Airport",
      "Forlì Luigi Ridolfi Airport"
    ],
    "city": [
      "Forlì (FC)",
      "Forlì (FC)",
      "Forlì (FC)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "VBS",
    "translations": [
      "Brescia Gabriele d'Annunzio Airport",
      "Brescia Gabriele d'Annunzio Airport",
      "Brescia Gabriele d'Annunzio Airport"
    ],
    "city": [
      "Montichiari (BS)",
      "Montichiari (BS)",
      "Montichiari (BS)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "TRS",
    "translations": [
      "Trieste–Friuli Venezia Giulia Airport",
      "Trieste–Friuli Venezia Giulia Airport",
      "Trieste–Friuli Venezia Giulia Airport"
    ],
    "city": [
      "Ronchi dei Legionari (GO)",
      "Ronchi dei Legionari (GO)",
      "Ronchi dei Legionari (GO)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "RMI",
    "translations": [
      "Federico Fellini International Airport",
      "Federico Fellini International Airport",
      "Federico Fellini International Airport"
    ],
    "city": [
      "Rimini (RN)",
      "Rimini (RN)",
      "Rimini (RN)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "VRN",
    "translations": [
      "Verona Villafranca Valerio Catullo Airport",
      "Verona Villafranca Valerio Catullo Airport",
      "Verona Villafranca Valerio Catullo Airport"
    ],
    "city": [
      "Caselle (VR)",
      "Caselle (VR)",
      "Caselle (VR)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "AOI",
    "translations": [
      "Marche Airport",
      "Marche Airport",
      "Marche Airport"
    ],
    "city": [
      "Falconara Marittima (AN)",
      "Falconara Marittima (AN)",
      "Falconara Marittima (AN)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "VCE",
    "translations": [
      "Venice Marco Polo Airport",
      "Venice Marco Polo Airport",
      "Venice Marco Polo Airport"
    ],
    "city": [
      "Venezia (VE)",
      "Venezia (VE)",
      "Venezia (VE)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "CIA",
    "translations": [
      "Ciampino–G. B. Pastine International Airport",
      "Ciampino–G. B. Pastine International Airport",
      "Ciampino–G. B. Pastine International Airport"
    ],
    "city": [
      "Rome",
      "Rome",
      "Rome"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "FCO",
    "translations": [
      "Rome–Fiumicino Leonardo da Vinci International Airport",
      "Rome–Fiumicino Leonardo da Vinci International Airport",
      "Rome–Fiumicino Leonardo da Vinci International Airport"
    ],
    "city": [
      "Rome",
      "Rome",
      "Rome"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "QSR",
    "translations": [
      "Salerno Costa d'Amalfi Airport",
      "Salerno Costa d'Amalfi Airport",
      "Salerno Costa d'Amalfi Airport"
    ],
    "city": [
      "Salerno",
      "Salerno",
      "Salerno"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "EBA",
    "translations": [
      "Marina di Campo Airport",
      "Marina di Campo Airport",
      "Marina di Campo Airport"
    ],
    "city": [
      "Campo nell'Elba (LI)",
      "Campo nell'Elba (LI)",
      "Campo nell'Elba (LI)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "NAP",
    "translations": [
      "Naples International Airport",
      "Naples International Airport",
      "Naples International Airport"
    ],
    "city": [
      "Napoli",
      "Napoli",
      "Napoli"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "PSA",
    "translations": [
      "Pisa International Airport",
      "Pisa International Airport",
      "Pisa International Airport"
    ],
    "city": [
      "Pisa (PI)",
      "Pisa (PI)",
      "Pisa (PI)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "FLR",
    "translations": [
      "Florence Airport, Peretola",
      "Florence Airport, Peretola",
      "Florence Airport, Peretola"
    ],
    "city": [
      "Firenze (FI)",
      "Firenze (FI)",
      "Firenze (FI)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "GRS",
    "translations": [
      "Grosseto Corrado Baccarini Air Base / Grosseto Airport",
      "Grosseto Corrado Baccarini Air Base / Grosseto Airport",
      "Grosseto Corrado Baccarini Air Base / Grosseto Airport"
    ],
    "city": [
      "Grosseto (GR)",
      "Grosseto (GR)",
      "Grosseto (GR)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "PEG",
    "translations": [
      "Perugia San Francesco d'Assisi – Umbria International Airport",
      "Perugia San Francesco d'Assisi – Umbria International Airport",
      "Perugia San Francesco d'Assisi – Umbria International Airport"
    ],
    "city": [
      "Perugia (PG)",
      "Perugia (PG)",
      "Perugia (PG)"
    ],
    "country": [
      "IT",
      "IT",
      "IT"
    ]
  },
  {
    "iata": "LJU",
    "translations": [
      "Ljubljana Jože Pučnik Airport",
      "Ljubljana Jože Pučnik Airport",
      "Ljubljana Jože Pučnik Airport"
    ],
    "city": [
      "Zgornji Brnik",
      "Zgornji Brnik",
      "Zgornji Brnik"
    ],
    "country": [
      "SI",
      "SI",
      "SI"
    ]
  },
  {
    "iata": "MBX",
    "translations": [
      "Maribor Edvard Rusjan Airport",
      "Maribor Edvard Rusjan Airport",
      "Maribor Edvard Rusjan Airport"
    ],
    "city": [
      "Orehova Vas",
      "Orehova Vas",
      "Orehova Vas"
    ],
    "country": [
      "SI",
      "SI",
      "SI"
    ]
  },
  {
    "iata": "POW",
    "translations": [
      "Portorož Airport",
      "Portorož Airport",
      "Portorož Airport"
    ],
    "city": [
      "Sečovlje",
      "Sečovlje",
      "Sečovlje"
    ],
    "country": [
      "SI",
      "SI",
      "SI"
    ]
  },
  {
    "iata": "NUA",
    "translations": [
      "Nuwara Eliya (Lake Gregory) Waterdrome",
      "Nuwara Eliya (Lake Gregory) Waterdrome",
      "Nuwara Eliya (Lake Gregory) Waterdrome"
    ],
    "city": [
      "Nuwara Eliya",
      "Nuwara Eliya",
      "Nuwara Eliya"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "LKC",
    "translations": [
      "Lekana Airport",
      "Lekana Airport",
      "Lekana Airport"
    ],
    "city": [
      "Lekana",
      "Lekana",
      "Lekana"
    ],
    "country": [
      "CG",
      "CG",
      "CG"
    ]
  },
  {
    "iata": "JCL",
    "translations": [
      "České Budějovice South Bohemian Airport",
      "České Budějovice South Bohemian Airport",
      "České Budějovice South Bohemian Airport"
    ],
    "city": [
      "České Budějovice",
      "České Budějovice",
      "České Budějovice"
    ],
    "country": [
      "CZ",
      "CZ",
      "CZ"
    ]
  },
  {
    "iata": "UHE",
    "translations": [
      "Kunovice Airport",
      "Kunovice Airport",
      "Kunovice Airport"
    ],
    "city": [
      "Uherské Hradiště",
      "Uherské Hradiště",
      "Uherské Hradiště"
    ],
    "country": [
      "CZ",
      "CZ",
      "CZ"
    ]
  },
  {
    "iata": "KLV",
    "translations": [
      "Karlovy Vary Airport",
      "Karlovy Vary Airport",
      "Karlovy Vary Airport"
    ],
    "city": [
      "Karlovy Vary",
      "Karlovy Vary",
      "Karlovy Vary"
    ],
    "country": [
      "CZ",
      "CZ",
      "CZ"
    ]
  },
  {
    "iata": "HRA",
    "translations": [
      "Mnichovo Hradiště Airport",
      "Mnichovo Hradiště Airport",
      "Mnichovo Hradiště Airport"
    ],
    "city": [
      "Mnichovo Hradiště",
      "Mnichovo Hradiště",
      "Mnichovo Hradiště"
    ],
    "country": [
      "CZ",
      "CZ",
      "CZ"
    ]
  },
  {
    "iata": "OSR",
    "translations": [
      "Ostrava Leos Janáček Airport",
      "Ostrava Leos Janáček Airport",
      "Ostrava Leos Janáček Airport"
    ],
    "city": [
      "Mošnov",
      "Mošnov",
      "Mošnov"
    ],
    "country": [
      "CZ",
      "CZ",
      "CZ"
    ]
  },
  {
    "iata": "OLO",
    "translations": [
      "Olomouc Airport",
      "Olomouc Airport",
      "Olomouc Airport"
    ],
    "city": [
      "Olomouc",
      "Olomouc",
      "Olomouc"
    ],
    "country": [
      "CZ",
      "CZ",
      "CZ"
    ]
  },
  {
    "iata": "PED",
    "translations": [
      "Pardubice Airport",
      "Pardubice Airport",
      "Pardubice Airport"
    ],
    "city": [
      "Pardubice",
      "Pardubice",
      "Pardubice"
    ],
    "country": [
      "CZ",
      "CZ",
      "CZ"
    ]
  },
  {
    "iata": "PRV",
    "translations": [
      "Přerov Air Base",
      "Přerov Air Base",
      "Přerov Air Base"
    ],
    "city": [
      "Přerov",
      "Přerov",
      "Přerov"
    ],
    "country": [
      "CZ",
      "CZ",
      "CZ"
    ]
  },
  {
    "iata": "PRG",
    "translations": [
      "Václav Havel Airport Prague",
      "Václav Havel Airport Prague",
      "Václav Havel Airport Prague"
    ],
    "city": [
      "Prague",
      "Prague",
      "Prague"
    ],
    "country": [
      "CZ",
      "CZ",
      "CZ"
    ]
  },
  {
    "iata": "BRQ",
    "translations": [
      "Brno-Tuřany Airport",
      "Brno-Tuřany Airport",
      "Brno-Tuřany Airport"
    ],
    "city": [
      "Brno",
      "Brno",
      "Brno"
    ],
    "country": [
      "CZ",
      "CZ",
      "CZ"
    ]
  },
  {
    "iata": "VOD",
    "translations": [
      "Vodochody Airport",
      "Vodochody Airport",
      "Vodochody Airport"
    ],
    "city": [
      "Vodochody",
      "Vodochody",
      "Vodochody"
    ],
    "country": [
      "CZ",
      "CZ",
      "CZ"
    ]
  },
  {
    "iata": "ZBE",
    "translations": [
      "Zábřeh Dolní Benešov Airfield",
      "Zábřeh Dolní Benešov Airfield",
      "Zábřeh Dolní Benešov Airfield"
    ],
    "city": [
      "Dolní Benešov",
      "Dolní Benešov",
      "Dolní Benešov"
    ],
    "country": [
      "CZ",
      "CZ",
      "CZ"
    ]
  },
  {
    "iata": "TLV",
    "translations": [
      "Ben Gurion International Airport",
      "Ben Gurion International Airport",
      "Ben Gurion International Airport"
    ],
    "city": [
      "Tel Aviv",
      "Tel Aviv",
      "Tel Aviv"
    ],
    "country": [
      "IL",
      "IL",
      "IL"
    ]
  },
  {
    "iata": "BEV",
    "translations": [
      "Beersheba (Teyman) Airport",
      "Beersheba (Teyman) Airport",
      "Beersheba (Teyman) Airport"
    ],
    "city": [
      "Beersheba",
      "Beersheba",
      "Beersheba"
    ],
    "country": [
      "IL",
      "IL",
      "IL"
    ]
  },
  {
    "iata": "ETM",
    "translations": [
      "Ramon International Airport",
      "Ramon International Airport",
      "Ramon International Airport"
    ],
    "city": [
      "Eilat",
      "Eilat",
      "Eilat"
    ],
    "country": [
      "IL",
      "IL",
      "IL"
    ]
  },
  {
    "iata": "EIY",
    "translations": [
      "Ein Yahav Airfield",
      "Ein Yahav Airfield",
      "Ein Yahav Airfield"
    ],
    "city": [
      "Sapir",
      "Sapir",
      "Sapir"
    ],
    "country": [
      "IL",
      "IL",
      "IL"
    ]
  },
  {
    "iata": "LLH",
    "translations": [
      "La Lima - Reginaldo Hammer Airport",
      "La Lima - Reginaldo Hammer Airport",
      "La Lima - Reginaldo Hammer Airport"
    ],
    "city": [
      "La Lima",
      "La Lima",
      "La Lima"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "HFA",
    "translations": [
      "Haifa International Airport",
      "Haifa International Airport",
      "Haifa International Airport"
    ],
    "city": [
      "Haifa",
      "Haifa",
      "Haifa"
    ],
    "country": [
      "IL",
      "IL",
      "IL"
    ]
  },
  {
    "iata": "RPN",
    "translations": [
      "Rosh Pina Airport",
      "Rosh Pina Airport",
      "Rosh Pina Airport"
    ],
    "city": [
      "Rosh Pina",
      "Rosh Pina",
      "Rosh Pina"
    ],
    "country": [
      "IL",
      "IL",
      "IL"
    ]
  },
  {
    "iata": "KSW",
    "translations": [
      "Kiryat Shmona Airport",
      "Kiryat Shmona Airport",
      "Kiryat Shmona Airport"
    ],
    "city": [
      "Kiryat Shmona",
      "Kiryat Shmona",
      "Kiryat Shmona"
    ],
    "country": [
      "IL",
      "IL",
      "IL"
    ]
  },
  {
    "iata": "LLL",
    "translations": [
      "Lissadell Airport",
      "Lissadell Airport",
      "Lissadell Airport"
    ],
    "city": [
      "Lissadell Station",
      "Lissadell Station",
      "Lissadell Station"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MTZ",
    "translations": [
      "Bar Yehuda Airfield",
      "Bar Yehuda Airfield",
      "Bar Yehuda Airfield"
    ],
    "city": [
      "Masada",
      "Masada",
      "Masada"
    ],
    "country": [
      "IL",
      "IL",
      "IL"
    ]
  },
  {
    "iata": "VTM",
    "translations": [
      "Nevatim Air Base",
      "Nevatim Air Base",
      "Nevatim Air Base"
    ],
    "city": [
      "Beersheba",
      "Beersheba",
      "Beersheba"
    ],
    "country": [
      "IL",
      "IL",
      "IL"
    ]
  },
  {
    "iata": "VDA",
    "translations": [
      "Ovda Airport",
      "Ovda Airport",
      "Ovda Airport"
    ],
    "city": [
      "Eilat",
      "Eilat",
      "Eilat"
    ],
    "country": [
      "IL",
      "IL",
      "IL"
    ]
  },
  {
    "iata": "MIP",
    "translations": [
      "Ramon Air Base",
      "Ramon Air Base",
      "Ramon Air Base"
    ],
    "city": [
      "Beersheba",
      "Beersheba",
      "Beersheba"
    ],
    "country": [
      "IL",
      "IL",
      "IL"
    ]
  },
  {
    "iata": "YOT",
    "translations": [
      "Yotvata Airfield",
      "Yotvata Airfield",
      "Yotvata Airfield"
    ],
    "city": [
      "Yotvata",
      "Yotvata",
      "Yotvata"
    ],
    "country": [
      "IL",
      "IL",
      "IL"
    ]
  },
  {
    "iata": "GZM",
    "translations": [
      "Xewkija Heliport",
      "Xewkija Heliport",
      "Xewkija Heliport"
    ],
    "city": [
      "Gozo",
      "Gozo",
      "Gozo"
    ],
    "country": [
      "MT",
      "MT",
      "MT"
    ]
  },
  {
    "iata": "MLA",
    "translations": [
      "Malta International Airport",
      "Malta International Airport",
      "Malta International Airport"
    ],
    "city": [
      "Valletta",
      "Valletta",
      "Valletta"
    ],
    "country": [
      "MT",
      "MT",
      "MT"
    ]
  },
  {
    "iata": "LMV",
    "translations": [
      "Madivaru Airport",
      "Madivaru Airport",
      "Madivaru Airport"
    ],
    "city": [
      "Naifaru",
      "Naifaru",
      "Naifaru"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "LMZ",
    "translations": [
      "Palma Airport",
      "Palma Airport",
      "Palma Airport"
    ],
    "city": [
      "Palma",
      "Palma",
      "Palma"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "MCM",
    "translations": [
      "Monaco Heliport",
      "Monaco Heliport",
      "Monaco Heliport"
    ],
    "city": [
      "Fontvieille",
      "Fontvieille",
      "Fontvieille"
    ],
    "country": [
      "MC",
      "MC",
      "MC"
    ]
  },
  {
    "iata": "ANT",
    "translations": [
      "Sankt Anton am Arlberg Heliport",
      "Sankt Anton am Arlberg Heliport",
      "Sankt Anton am Arlberg Heliport"
    ],
    "city": [
      "Sankt Anton am Arlberg",
      "Sankt Anton am Arlberg",
      "Sankt Anton am Arlberg"
    ],
    "country": [
      "AT",
      "AT",
      "AT"
    ]
  },
  {
    "iata": "HOH",
    "translations": [
      "Hohenems-Dornbirn Airfield",
      "Hohenems-Dornbirn Airfield",
      "Hohenems-Dornbirn Airfield"
    ],
    "city": [
      "Hohenems",
      "Hohenems",
      "Hohenems"
    ],
    "country": [
      "AT",
      "AT",
      "AT"
    ]
  },
  {
    "iata": "LOM",
    "translations": [
      "Francisco Primo de Verdad y Ramos Airport",
      "Francisco Primo de Verdad y Ramos Airport",
      "Francisco Primo de Verdad y Ramos Airport"
    ],
    "city": [
      "Lagos de Moreno",
      "Lagos de Moreno",
      "Lagos de Moreno"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "LOR",
    "translations": [
      "Lowe AHP (Fort Rucker) Heliport",
      "Lowe AHP (Fort Rucker) Heliport",
      "Lowe AHP (Fort Rucker) Heliport"
    ],
    "city": [
      "Fort Rucker Ozark",
      "Fort Rucker Ozark",
      "Fort Rucker Ozark"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GRZ",
    "translations": [
      "Graz Airport",
      "Graz Airport",
      "Graz Airport"
    ],
    "city": [
      "Feldkirchen bei Graz",
      "Feldkirchen bei Graz",
      "Feldkirchen bei Graz"
    ],
    "country": [
      "AT",
      "AT",
      "AT"
    ]
  },
  {
    "iata": "INN",
    "translations": [
      "Innsbruck Airport",
      "Innsbruck Airport",
      "Innsbruck Airport"
    ],
    "city": [
      "Innsbruck",
      "Innsbruck",
      "Innsbruck"
    ],
    "country": [
      "AT",
      "AT",
      "AT"
    ]
  },
  {
    "iata": "KLU",
    "translations": [
      "Klagenfurt Airport",
      "Klagenfurt Airport",
      "Klagenfurt Airport"
    ],
    "city": [
      "Klagenfurt am Wörthersee",
      "Klagenfurt am Wörthersee",
      "Klagenfurt am Wörthersee"
    ],
    "country": [
      "AT",
      "AT",
      "AT"
    ]
  },
  {
    "iata": "LNZ",
    "translations": [
      "Linz-Hörsching Airport / Vogler Air Base",
      "Linz-Hörsching Airport / Vogler Air Base",
      "Linz-Hörsching Airport / Vogler Air Base"
    ],
    "city": [
      "Linz",
      "Linz",
      "Linz"
    ],
    "country": [
      "AT",
      "AT",
      "AT"
    ]
  },
  {
    "iata": "SZG",
    "translations": [
      "Salzburg Airport",
      "Salzburg Airport",
      "Salzburg Airport"
    ],
    "city": [
      "Salzburg",
      "Salzburg",
      "Salzburg"
    ],
    "country": [
      "AT",
      "AT",
      "AT"
    ]
  },
  {
    "iata": "VIE",
    "translations": [
      "Vienna International Airport",
      "Vienna International Airport",
      "Vienna International Airport"
    ],
    "city": [
      "Vienna",
      "Vienna",
      "Vienna"
    ],
    "country": [
      "AT",
      "AT",
      "AT"
    ]
  },
  {
    "iata": "SMA",
    "translations": [
      "Santa Maria Airport",
      "Santa Maria Airport",
      "Santa Maria Airport"
    ],
    "city": [
      "Vila do Porto",
      "Vila do Porto",
      "Vila do Porto"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "BGC",
    "translations": [
      "Bragança Airport",
      "Bragança Airport",
      "Bragança Airport"
    ],
    "city": [
      "Bragança",
      "Bragança",
      "Bragança"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "BYJ",
    "translations": [
      "Beja Airport / Airbase",
      "Beja Airport / Airbase",
      "Beja Airport / Airbase"
    ],
    "city": [
      "Beja",
      "Beja",
      "Beja"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "CVU",
    "translations": [
      "Corvo Airport",
      "Corvo Airport",
      "Corvo Airport"
    ],
    "city": [
      "Corvo",
      "Corvo",
      "Corvo"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "CAT",
    "translations": [
      "Cascais Airport",
      "Cascais Airport",
      "Cascais Airport"
    ],
    "city": [
      "Cascais",
      "Cascais",
      "Cascais"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "FLW",
    "translations": [
      "Flores Airport",
      "Flores Airport",
      "Flores Airport"
    ],
    "city": [
      "Santa Cruz das Flores",
      "Santa Cruz das Flores",
      "Santa Cruz das Flores"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "FAO",
    "translations": [
      "Faro Airport",
      "Faro Airport",
      "Faro Airport"
    ],
    "city": [
      "Faro",
      "Faro",
      "Faro"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "GRW",
    "translations": [
      "Graciosa Airport",
      "Graciosa Airport",
      "Graciosa Airport"
    ],
    "city": [
      "Santa Cruz da Graciosa",
      "Santa Cruz da Graciosa",
      "Santa Cruz da Graciosa"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "HOR",
    "translations": [
      "Horta Airport",
      "Horta Airport",
      "Horta Airport"
    ],
    "city": [
      "Horta",
      "Horta",
      "Horta"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "TER",
    "translations": [
      "Lajes Airport",
      "Lajes Airport",
      "Lajes Airport"
    ],
    "city": [
      "Praia da Vitória",
      "Praia da Vitória",
      "Praia da Vitória"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "FNC",
    "translations": [
      "Madeira International Airport Cristiano Ronaldo",
      "Madeira International Airport Cristiano Ronaldo",
      "Madeira International Airport Cristiano Ronaldo"
    ],
    "city": [
      "Funchal",
      "Funchal",
      "Funchal"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "PDL",
    "translations": [
      "João Paulo II Airport",
      "João Paulo II Airport",
      "João Paulo II Airport"
    ],
    "city": [
      "Ponta Delgada",
      "Ponta Delgada",
      "Ponta Delgada"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "PIX",
    "translations": [
      "Pico Airport",
      "Pico Airport",
      "Pico Airport"
    ],
    "city": [
      "Pico Island",
      "Pico Island",
      "Pico Island"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "PRM",
    "translations": [
      "Portimão Airport",
      "Portimão Airport",
      "Portimão Airport"
    ],
    "city": [
      "Portimão",
      "Portimão",
      "Portimão"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "OPO",
    "translations": [
      "Francisco de Sá Carneiro Airport",
      "Francisco de Sá Carneiro Airport",
      "Francisco de Sá Carneiro Airport"
    ],
    "city": [
      "Porto",
      "Porto",
      "Porto"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "PXO",
    "translations": [
      "Porto Santo Airport",
      "Porto Santo Airport",
      "Porto Santo Airport"
    ],
    "city": [
      "Vila Baleira",
      "Vila Baleira",
      "Vila Baleira"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "LIS",
    "translations": [
      "Lisbon Humberto Delgado Airport",
      "Lisbon Humberto Delgado Airport",
      "Lisbon Humberto Delgado Airport"
    ],
    "city": [
      "Lisbon",
      "Lisbon",
      "Lisbon"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "SJZ",
    "translations": [
      "São Jorge Airport",
      "São Jorge Airport",
      "São Jorge Airport"
    ],
    "city": [
      "Velas",
      "Velas",
      "Velas"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "VRL",
    "translations": [
      "Vila Real Airport",
      "Vila Real Airport",
      "Vila Real Airport"
    ],
    "city": [
      "Vila Real",
      "Vila Real",
      "Vila Real"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "VSE",
    "translations": [
      "Aerodromo Goncalves Lobato (Viseu Airport)",
      "Aerodromo Goncalves Lobato (Viseu Airport)",
      "Aerodromo Goncalves Lobato (Viseu Airport)"
    ],
    "city": [
      "Viseu",
      "Viseu",
      "Viseu"
    ],
    "country": [
      "PT",
      "PT",
      "PT"
    ]
  },
  {
    "iata": "BNX",
    "translations": [
      "Banja Luka International Airport",
      "Banja Luka International Airport",
      "Banja Luka International Airport"
    ],
    "city": [
      "Mahovljani",
      "Mahovljani",
      "Mahovljani"
    ],
    "country": [
      "BA",
      "BA",
      "BA"
    ]
  },
  {
    "iata": "OMO",
    "translations": [
      "Mostar International Airport",
      "Mostar International Airport",
      "Mostar International Airport"
    ],
    "city": [
      "Mostar",
      "Mostar",
      "Mostar"
    ],
    "country": [
      "BA",
      "BA",
      "BA"
    ]
  },
  {
    "iata": "SJJ",
    "translations": [
      "Sarajevo International Airport",
      "Sarajevo International Airport",
      "Sarajevo International Airport"
    ],
    "city": [
      "Sarajevo",
      "Sarajevo",
      "Sarajevo"
    ],
    "country": [
      "BA",
      "BA",
      "BA"
    ]
  },
  {
    "iata": "TZL",
    "translations": [
      "Tuzla International Airport",
      "Tuzla International Airport",
      "Tuzla International Airport"
    ],
    "city": [
      "Dubrave Gornje",
      "Dubrave Gornje",
      "Dubrave Gornje"
    ],
    "country": [
      "BA",
      "BA",
      "BA"
    ]
  },
  {
    "iata": "ARW",
    "translations": [
      "Arad International Airport",
      "Arad International Airport",
      "Arad International Airport"
    ],
    "city": [
      "Arad",
      "Arad",
      "Arad"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "BCM",
    "translations": [
      "Bacău George Enescu International  Airport",
      "Bacău George Enescu International  Airport",
      "Bacău George Enescu International  Airport"
    ],
    "city": [
      "Bacău",
      "Bacău",
      "Bacău"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "BAY",
    "translations": [
      "Maramureș International Airport",
      "Maramureș International Airport",
      "Maramureș International Airport"
    ],
    "city": [
      "Tăuții-Măgherăuș",
      "Tăuții-Măgherăuș",
      "Tăuții-Măgherăuș"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "BBU",
    "translations": [
      "Bucharest Băneasa Aurel Vlaicu International Airport",
      "Bucharest Băneasa Aurel Vlaicu International Airport",
      "Bucharest Băneasa Aurel Vlaicu International Airport"
    ],
    "city": [
      "Bucharest",
      "Bucharest",
      "Bucharest"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "GHV",
    "translations": [
      "Brașov-Ghimbav International Airport",
      "Brașov-Ghimbav International Airport",
      "Brașov-Ghimbav International Airport"
    ],
    "city": [
      "Brașov (Ghimbav)",
      "Brașov (Ghimbav)",
      "Brașov (Ghimbav)"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "CND",
    "translations": [
      "Mihail Kogălniceanu International Airport",
      "Mihail Kogălniceanu International Airport",
      "Mihail Kogălniceanu International Airport"
    ],
    "city": [
      "Mihail Kogălniceanu",
      "Mihail Kogălniceanu",
      "Mihail Kogălniceanu"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "CLJ",
    "translations": [
      "Cluj Avram Iancu International Airport",
      "Cluj Avram Iancu International Airport",
      "Cluj Avram Iancu International Airport"
    ],
    "city": [
      "Cluj-Napoca",
      "Cluj-Napoca",
      "Cluj-Napoca"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "CSB",
    "translations": [
      "Caransebeş Airport",
      "Caransebeş Airport",
      "Caransebeş Airport"
    ],
    "city": [
      "Caransebeş",
      "Caransebeş",
      "Caransebeş"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "CRA",
    "translations": [
      "Craiova International Airport",
      "Craiova International Airport",
      "Craiova International Airport"
    ],
    "city": [
      "Craiova",
      "Craiova",
      "Craiova"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "IAS",
    "translations": [
      "Iaşi Airport",
      "Iaşi Airport",
      "Iaşi Airport"
    ],
    "city": [
      "Iaşi",
      "Iaşi",
      "Iaşi"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "OMR",
    "translations": [
      "Oradea International Airport",
      "Oradea International Airport",
      "Oradea International Airport"
    ],
    "city": [
      "Oradea",
      "Oradea",
      "Oradea"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "OTP",
    "translations": [
      "Bucharest Henri Coandă International Airport",
      "Bucharest Henri Coandă International Airport",
      "Bucharest Henri Coandă International Airport"
    ],
    "city": [
      "Otopeni",
      "Otopeni",
      "Otopeni"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "SBZ",
    "translations": [
      "Sibiu International Airport",
      "Sibiu International Airport",
      "Sibiu International Airport"
    ],
    "city": [
      "Sibiu",
      "Sibiu",
      "Sibiu"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "SUJ",
    "translations": [
      "Satu Mare International Airport",
      "Satu Mare International Airport",
      "Satu Mare International Airport"
    ],
    "city": [
      "Satu Mare",
      "Satu Mare",
      "Satu Mare"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "SCV",
    "translations": [
      "Suceava Stefan cel Mare Airport",
      "Suceava Stefan cel Mare Airport",
      "Suceava Stefan cel Mare Airport"
    ],
    "city": [
      "Suceava",
      "Suceava",
      "Suceava"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "TCE",
    "translations": [
      "Tulcea Danube Delta Airport",
      "Tulcea Danube Delta Airport",
      "Tulcea Danube Delta Airport"
    ],
    "city": [
      "Mihail Kogălniceanu",
      "Mihail Kogălniceanu",
      "Mihail Kogălniceanu"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "TGM",
    "translations": [
      "Târgu Mureş Transilvania International Airport",
      "Târgu Mureş Transilvania International Airport",
      "Târgu Mureş Transilvania International Airport"
    ],
    "city": [
      "Recea",
      "Recea",
      "Recea"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "TSR",
    "translations": [
      "Timişoara Traian Vuia Airport",
      "Timişoara Traian Vuia Airport",
      "Timişoara Traian Vuia Airport"
    ],
    "city": [
      "Timişoara",
      "Timişoara",
      "Timişoara"
    ],
    "country": [
      "RO",
      "RO",
      "RO"
    ]
  },
  {
    "iata": "GVA",
    "translations": [
      "Geneva Cointrin International Airport",
      "Geneva Cointrin International Airport",
      "Geneva Cointrin International Airport"
    ],
    "city": [
      "Geneva",
      "Geneva",
      "Geneva"
    ],
    "country": [
      "CH",
      "CH",
      "CH"
    ]
  },
  {
    "iata": "SIR",
    "translations": [
      "Sion Airport",
      "Sion Airport",
      "Sion Airport"
    ],
    "city": [
      "Sion",
      "Sion",
      "Sion"
    ],
    "country": [
      "CH",
      "CH",
      "CH"
    ]
  },
  {
    "iata": "EML",
    "translations": [
      "Emmen Air Base",
      "Emmen Air Base",
      "Emmen Air Base"
    ],
    "city": [
      "Emmen",
      "Emmen",
      "Emmen"
    ],
    "country": [
      "CH",
      "CH",
      "CH"
    ]
  },
  {
    "iata": "VIP",
    "translations": [
      "Payerne Air Base",
      "Payerne Air Base",
      "Payerne Air Base"
    ],
    "city": [
      "Payerne",
      "Payerne",
      "Payerne"
    ],
    "country": [
      "CH",
      "CH",
      "CH"
    ]
  },
  {
    "iata": "LUG",
    "translations": [
      "Lugano Airport",
      "Lugano Airport",
      "Lugano Airport"
    ],
    "city": [
      "Agno",
      "Agno",
      "Agno"
    ],
    "country": [
      "CH",
      "CH",
      "CH"
    ]
  },
  {
    "iata": "BRN",
    "translations": [
      "Bern Airport",
      "Bern Airport",
      "Bern Airport"
    ],
    "city": [
      "Bern",
      "Bern",
      "Bern"
    ],
    "country": [
      "CH",
      "CH",
      "CH"
    ]
  },
  {
    "iata": "BXO",
    "translations": [
      "Buochs Airport",
      "Buochs Airport",
      "Buochs Airport"
    ],
    "city": [
      "Buochs",
      "Buochs",
      "Buochs"
    ],
    "country": [
      "CH",
      "CH",
      "CH"
    ]
  },
  {
    "iata": "ZRH",
    "translations": [
      "Zürich Airport",
      "Zürich Airport",
      "Zürich Airport"
    ],
    "city": [
      "Zurich",
      "Zurich",
      "Zurich"
    ],
    "country": [
      "CH",
      "CH",
      "CH"
    ]
  },
  {
    "iata": "ACH",
    "translations": [
      "Sankt Gallen Altenrhein Airport",
      "Sankt Gallen Altenrhein Airport",
      "Sankt Gallen Altenrhein Airport"
    ],
    "city": [
      "St. Gallen",
      "St. Gallen",
      "St. Gallen"
    ],
    "country": [
      "CH",
      "CH",
      "CH"
    ]
  },
  {
    "iata": "SMV",
    "translations": [
      "Samedan Airport",
      "Samedan Airport",
      "Samedan Airport"
    ],
    "city": [
      "Samedan",
      "Samedan",
      "Samedan"
    ],
    "country": [
      "CH",
      "CH",
      "CH"
    ]
  },
  {
    "iata": "ESB",
    "translations": [
      "Esenboğa International Airport",
      "Esenboğa International Airport",
      "Esenboğa International Airport"
    ],
    "city": [
      "Ankara",
      "Ankara",
      "Ankara"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "ANK",
    "translations": [
      "Etimesgut Air Base",
      "Etimesgut Air Base",
      "Etimesgut Air Base"
    ],
    "city": [
      "Ankara",
      "Ankara",
      "Ankara"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "ADA",
    "translations": [
      "Adana Şakirpaşa Airport",
      "Adana Şakirpaşa Airport",
      "Adana Şakirpaşa Airport"
    ],
    "city": [
      "Seyhan",
      "Seyhan",
      "Seyhan"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "UAB",
    "translations": [
      "İncirlik Air Base",
      "İncirlik Air Base",
      "İncirlik Air Base"
    ],
    "city": [
      "Sarıçam",
      "Sarıçam",
      "Sarıçam"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "AFY",
    "translations": [
      "Afyon Air Base",
      "Afyon Air Base",
      "Afyon Air Base"
    ],
    "city": [
      "Afyonkarahisar",
      "Afyonkarahisar",
      "Afyonkarahisar"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "AYT",
    "translations": [
      "Antalya International Airport",
      "Antalya International Airport",
      "Antalya International Airport"
    ],
    "city": [
      "Antalya",
      "Antalya",
      "Antalya"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "GZT",
    "translations": [
      "Gaziantep International Airport",
      "Gaziantep International Airport",
      "Gaziantep International Airport"
    ],
    "city": [
      "Gaziantep",
      "Gaziantep",
      "Gaziantep"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "KFS",
    "translations": [
      "Kastamonu Airport",
      "Kastamonu Airport",
      "Kastamonu Airport"
    ],
    "city": [
      "Kastamonu",
      "Kastamonu",
      "Kastamonu"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "KYA",
    "translations": [
      "Konya Airport",
      "Konya Airport",
      "Konya Airport"
    ],
    "city": [
      "Konya",
      "Konya",
      "Konya"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "MZH",
    "translations": [
      "Amasya Merzifon Airport",
      "Amasya Merzifon Airport",
      "Amasya Merzifon Airport"
    ],
    "city": [
      "Amasya",
      "Amasya",
      "Amasya"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "VAS",
    "translations": [
      "Sivas Nuri Demirağ Airport",
      "Sivas Nuri Demirağ Airport",
      "Sivas Nuri Demirağ Airport"
    ],
    "city": [
      "Sivas",
      "Sivas",
      "Sivas"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "ONQ",
    "translations": [
      "Zonguldak Çaycuma Airport",
      "Zonguldak Çaycuma Airport",
      "Zonguldak Çaycuma Airport"
    ],
    "city": [
      "Zonguldak",
      "Zonguldak",
      "Zonguldak"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "MLX",
    "translations": [
      "Malatya Erhaç Airport",
      "Malatya Erhaç Airport",
      "Malatya Erhaç Airport"
    ],
    "city": [
      "Malatya",
      "Malatya",
      "Malatya"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "ASR",
    "translations": [
      "Kayseri Erkilet Airport",
      "Kayseri Erkilet Airport",
      "Kayseri Erkilet Airport"
    ],
    "city": [
      "Kayseri",
      "Kayseri",
      "Kayseri"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "TJK",
    "translations": [
      "Tokat Airport",
      "Tokat Airport",
      "Tokat Airport"
    ],
    "city": [
      "Tokat",
      "Tokat",
      "Tokat"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "DNZ",
    "translations": [
      "Çardak Airport",
      "Çardak Airport",
      "Çardak Airport"
    ],
    "city": [
      "Denizli",
      "Denizli",
      "Denizli"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "NAV",
    "translations": [
      "Nevşehir Kapadokya Airport",
      "Nevşehir Kapadokya Airport",
      "Nevşehir Kapadokya Airport"
    ],
    "city": [
      "Nevşehir",
      "Nevşehir",
      "Nevşehir"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "ISL",
    "translations": [
      "İstanbul Atatürk Airport",
      "İstanbul Atatürk Airport",
      "İstanbul Atatürk Airport"
    ],
    "city": [
      "Bakırköy, Istanbul",
      "Bakırköy, Istanbul",
      "Bakırköy, Istanbul"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "CII",
    "translations": [
      "Aydın Çıldır Airport",
      "Aydın Çıldır Airport",
      "Aydın Çıldır Airport"
    ],
    "city": [
      "Aydın",
      "Aydın",
      "Aydın"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "BZI",
    "translations": [
      "Balıkesir Airport",
      "Balıkesir Airport",
      "Balıkesir Airport"
    ],
    "city": [
      "Balıkesir",
      "Balıkesir",
      "Balıkesir"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "BDM",
    "translations": [
      "Bandırma Airport",
      "Bandırma Airport",
      "Bandırma Airport"
    ],
    "city": [
      "Bandırma",
      "Bandırma",
      "Bandırma"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "CKZ",
    "translations": [
      "Çanakkale Airport",
      "Çanakkale Airport",
      "Çanakkale Airport"
    ],
    "city": [
      "Çanakkale",
      "Çanakkale",
      "Çanakkale"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "ESK",
    "translations": [
      "Eskişehir Air Base",
      "Eskişehir Air Base",
      "Eskişehir Air Base"
    ],
    "city": [
      "Eskişehir",
      "Eskişehir",
      "Eskişehir"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "ADB",
    "translations": [
      "Adnan Menderes International Airport",
      "Adnan Menderes International Airport",
      "Adnan Menderes International Airport"
    ],
    "city": [
      "Gaziemir",
      "Gaziemir",
      "Gaziemir"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "IGL",
    "translations": [
      "Çiğli Airbase",
      "Çiğli Airbase",
      "Çiğli Airbase"
    ],
    "city": [
      "Çiğli",
      "Çiğli",
      "Çiğli"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "USQ",
    "translations": [
      "Uşak Airport",
      "Uşak Airport",
      "Uşak Airport"
    ],
    "city": [
      "Uşak",
      "Uşak",
      "Uşak"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "KCO",
    "translations": [
      "Cengiz Topel Airport",
      "Cengiz Topel Airport",
      "Cengiz Topel Airport"
    ],
    "city": [
      "Kartepe",
      "Kartepe",
      "Kartepe"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "YEI",
    "translations": [
      "Bursa Yenişehir Airport",
      "Bursa Yenişehir Airport",
      "Bursa Yenişehir Airport"
    ],
    "city": [
      "Yenişehir",
      "Yenişehir",
      "Yenişehir"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "DLM",
    "translations": [
      "Dalaman International Airport",
      "Dalaman International Airport",
      "Dalaman International Airport"
    ],
    "city": [
      "Dalaman",
      "Dalaman",
      "Dalaman"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "TEQ",
    "translations": [
      "Tekirdağ Çorlu Airport",
      "Tekirdağ Çorlu Airport",
      "Tekirdağ Çorlu Airport"
    ],
    "city": [
      "Çorlu",
      "Çorlu",
      "Çorlu"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "BXN",
    "translations": [
      "Bodrum-Imsık Airport",
      "Bodrum-Imsık Airport",
      "Bodrum-Imsık Airport"
    ],
    "city": [
      "Bodrum",
      "Bodrum",
      "Bodrum"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "AOE",
    "translations": [
      "Anadolu Airport",
      "Anadolu Airport",
      "Anadolu Airport"
    ],
    "city": [
      "Eskişehir",
      "Eskişehir",
      "Eskişehir"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "KZR",
    "translations": [
      "Zafer Airport",
      "Zafer Airport",
      "Zafer Airport"
    ],
    "city": [
      "Altıntaş",
      "Altıntaş",
      "Altıntaş"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "EZS",
    "translations": [
      "Elazığ Airport",
      "Elazığ Airport",
      "Elazığ Airport"
    ],
    "city": [
      "Elazığ",
      "Elazığ",
      "Elazığ"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "OGU",
    "translations": [
      "Ordu–Giresun Airport",
      "Ordu–Giresun Airport",
      "Ordu–Giresun Airport"
    ],
    "city": [
      "Ordu",
      "Ordu",
      "Ordu"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "DIY",
    "translations": [
      "Diyarbakır Airport",
      "Diyarbakır Airport",
      "Diyarbakır Airport"
    ],
    "city": [
      "Diyarbakır",
      "Diyarbakır",
      "Diyarbakır"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "ERC",
    "translations": [
      "Erzincan Airport",
      "Erzincan Airport",
      "Erzincan Airport"
    ],
    "city": [
      "Erzincan",
      "Erzincan",
      "Erzincan"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "ERZ",
    "translations": [
      "Erzurum International Airport",
      "Erzurum International Airport",
      "Erzurum International Airport"
    ],
    "city": [
      "Erzurum",
      "Erzurum",
      "Erzurum"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "KSY",
    "translations": [
      "Kars Airport",
      "Kars Airport",
      "Kars Airport"
    ],
    "city": [
      "Kars",
      "Kars",
      "Kars"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "TZX",
    "translations": [
      "Trabzon International Airport",
      "Trabzon International Airport",
      "Trabzon International Airport"
    ],
    "city": [
      "Trabzon",
      "Trabzon",
      "Trabzon"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "VAN",
    "translations": [
      "Van Ferit Melen Airport",
      "Van Ferit Melen Airport",
      "Van Ferit Melen Airport"
    ],
    "city": [
      "Van",
      "Van",
      "Van"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "BAL",
    "translations": [
      "Batman Airport",
      "Batman Airport",
      "Batman Airport"
    ],
    "city": [
      "Batman",
      "Batman",
      "Batman"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "MSR",
    "translations": [
      "Muş Airport",
      "Muş Airport",
      "Muş Airport"
    ],
    "city": [
      "Muş",
      "Muş",
      "Muş"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "SXZ",
    "translations": [
      "Siirt Airport",
      "Siirt Airport",
      "Siirt Airport"
    ],
    "city": [
      "Siirt",
      "Siirt",
      "Siirt"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "NOP",
    "translations": [
      "Sinop Airport",
      "Sinop Airport",
      "Sinop Airport"
    ],
    "city": [
      "Sinop",
      "Sinop",
      "Sinop"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "KCM",
    "translations": [
      "Kahramanmaraş Airport",
      "Kahramanmaraş Airport",
      "Kahramanmaraş Airport"
    ],
    "city": [
      "Kahramanmaraş",
      "Kahramanmaraş",
      "Kahramanmaraş"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "AJI",
    "translations": [
      "Ağrı Airport",
      "Ağrı Airport",
      "Ağrı Airport"
    ],
    "city": [
      "Ağrı",
      "Ağrı",
      "Ağrı"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "ADF",
    "translations": [
      "Adıyaman Airport",
      "Adıyaman Airport",
      "Adıyaman Airport"
    ],
    "city": [
      "Adıyaman",
      "Adıyaman",
      "Adıyaman"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "MQM",
    "translations": [
      "Mardin Airport",
      "Mardin Airport",
      "Mardin Airport"
    ],
    "city": [
      "Mardin",
      "Mardin",
      "Mardin"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "GNY",
    "translations": [
      "Şanlıurfa GAP Airport",
      "Şanlıurfa GAP Airport",
      "Şanlıurfa GAP Airport"
    ],
    "city": [
      "Şanlıurfa",
      "Şanlıurfa",
      "Şanlıurfa"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "IGD",
    "translations": [
      "Iğdır Airport",
      "Iğdır Airport",
      "Iğdır Airport"
    ],
    "city": [
      "Iğdır",
      "Iğdır",
      "Iğdır"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "BGG",
    "translations": [
      "Bingöl Airport",
      "Bingöl Airport",
      "Bingöl Airport"
    ],
    "city": [
      "Bingöl",
      "Bingöl",
      "Bingöl"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "NKT",
    "translations": [
      "Şırnak Şerafettin Elçi Airport",
      "Şırnak Şerafettin Elçi Airport",
      "Şırnak Şerafettin Elçi Airport"
    ],
    "city": [
      "Şırnak",
      "Şırnak",
      "Şırnak"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "YKO",
    "translations": [
      "Hakkari Yüksekova Airport",
      "Hakkari Yüksekova Airport",
      "Hakkari Yüksekova Airport"
    ],
    "city": [
      "Hakkari",
      "Hakkari",
      "Hakkari"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "HTY",
    "translations": [
      "Hatay Airport",
      "Hatay Airport",
      "Hatay Airport"
    ],
    "city": [
      "Antakya",
      "Antakya",
      "Antakya"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "COV",
    "translations": [
      "Çukurova International Airport",
      "Çukurova International Airport",
      "Çukurova International Airport"
    ],
    "city": [
      "Tarsus",
      "Tarsus",
      "Tarsus"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "LTF",
    "translations": [
      "Leitre Airport",
      "Leitre Airport",
      "Leitre Airport"
    ],
    "city": [
      "Leitre",
      "Leitre",
      "Leitre"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "IZM",
    "translations": [
      "Selçuk Efes Airport",
      "Selçuk Efes Airport",
      "Selçuk Efes Airport"
    ],
    "city": [
      "Selçuk",
      "Selçuk",
      "Selçuk"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "ISE",
    "translations": [
      "Süleyman Demirel International Airport",
      "Süleyman Demirel International Airport",
      "Süleyman Demirel International Airport"
    ],
    "city": [
      "Isparta",
      "Isparta",
      "Isparta"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "EDO",
    "translations": [
      "Balıkesir Koca Seyit Airport",
      "Balıkesir Koca Seyit Airport",
      "Balıkesir Koca Seyit Airport"
    ],
    "city": [
      "Edremit",
      "Edremit",
      "Edremit"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "BJV",
    "translations": [
      "Milas Bodrum International Airport",
      "Milas Bodrum International Airport",
      "Milas Bodrum International Airport"
    ],
    "city": [
      "Bodrum",
      "Bodrum",
      "Bodrum"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "GZP",
    "translations": [
      "Gazipaşa-Alanya Airport",
      "Gazipaşa-Alanya Airport",
      "Gazipaşa-Alanya Airport"
    ],
    "city": [
      "Gazipaşa",
      "Gazipaşa",
      "Gazipaşa"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "SZF",
    "translations": [
      "Samsun-Çarşamba Airport",
      "Samsun-Çarşamba Airport",
      "Samsun-Çarşamba Airport"
    ],
    "city": [
      "Samsun",
      "Samsun",
      "Samsun"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "SAW",
    "translations": [
      "Istanbul Sabiha Gökçen International Airport",
      "Istanbul Sabiha Gökçen International Airport",
      "Istanbul Sabiha Gökçen International Airport"
    ],
    "city": [
      "Pendik, Istanbul",
      "Pendik, Istanbul",
      "Pendik, Istanbul"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "GKD",
    "translations": [
      "Gökçeada Airport",
      "Gökçeada Airport",
      "Gökçeada Airport"
    ],
    "city": [
      "Gökçeada",
      "Gökçeada",
      "Gökçeada"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "IST",
    "translations": [
      "İstanbul Airport",
      "İstanbul Airport",
      "İstanbul Airport"
    ],
    "city": [
      "Arnavutköy, Istanbul",
      "Arnavutköy, Istanbul",
      "Arnavutköy, Istanbul"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "RZV",
    "translations": [
      "Rize–Artvin Airport",
      "Rize–Artvin Airport",
      "Rize–Artvin Airport"
    ],
    "city": [
      "Rize",
      "Rize",
      "Rize"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "BZY",
    "translations": [
      "Bălți International Airport",
      "Bălți International Airport",
      "Bălți International Airport"
    ],
    "city": [
      "Bălți",
      "Bălți",
      "Bălți"
    ],
    "country": [
      "MD",
      "MD",
      "MD"
    ]
  },
  {
    "iata": "RMO",
    "translations": [
      "Chişinău International Airport",
      "Chişinău International Airport",
      "Chişinău International Airport"
    ],
    "city": [
      "Chişinău",
      "Chişinău",
      "Chişinău"
    ],
    "country": [
      "MD",
      "MD",
      "MD"
    ]
  },
  {
    "iata": "LWA",
    "translations": [
      "Lebak Rural Airport",
      "Lebak Rural Airport",
      "Lebak Rural Airport"
    ],
    "city": [
      "Lebak",
      "Lebak",
      "Lebak"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "OHD",
    "translations": [
      "Ohrid St. Paul the Apostle Airport",
      "Ohrid St. Paul the Apostle Airport",
      "Ohrid St. Paul the Apostle Airport"
    ],
    "city": [
      "Ohrid",
      "Ohrid",
      "Ohrid"
    ],
    "country": [
      "MK",
      "MK",
      "MK"
    ]
  },
  {
    "iata": "SKP",
    "translations": [
      "Skopje International Airport",
      "Skopje International Airport",
      "Skopje International Airport"
    ],
    "city": [
      "Ilinden",
      "Ilinden",
      "Ilinden"
    ],
    "country": [
      "MK",
      "MK",
      "MK"
    ]
  },
  {
    "iata": "GIB",
    "translations": [
      "Gibraltar Airport",
      "Gibraltar Airport",
      "Gibraltar Airport"
    ],
    "city": [
      "Gibraltar",
      "Gibraltar",
      "Gibraltar"
    ],
    "country": [
      "GI",
      "GI",
      "GI"
    ]
  },
  {
    "iata": "BCQ",
    "translations": [
      "Brak Airport",
      "Brak Airport",
      "Brak Airport"
    ],
    "city": [
      "Brak",
      "Brak",
      "Brak"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "DNF",
    "translations": [
      "Martuba Air Base",
      "Martuba Air Base",
      "Martuba Air Base"
    ],
    "city": [
      "Martuba",
      "Martuba",
      "Martuba"
    ],
    "country": [
      "LY",
      "LY",
      "LY"
    ]
  },
  {
    "iata": "BEG",
    "translations": [
      "Belgrade Nikola Tesla Airport",
      "Belgrade Nikola Tesla Airport",
      "Belgrade Nikola Tesla Airport"
    ],
    "city": [
      "Belgrade",
      "Belgrade",
      "Belgrade"
    ],
    "country": [
      "RS",
      "RS",
      "RS"
    ]
  },
  {
    "iata": "IVG",
    "translations": [
      "Berane Airport",
      "Berane Airport",
      "Berane Airport"
    ],
    "city": [
      "Berane",
      "Berane",
      "Berane"
    ],
    "country": [
      "ME",
      "ME",
      "ME"
    ]
  },
  {
    "iata": "BJY",
    "translations": [
      "Batajnica Air Base",
      "Batajnica Air Base",
      "Batajnica Air Base"
    ],
    "city": [
      "Zemun",
      "Zemun",
      "Zemun"
    ],
    "country": [
      "RS",
      "RS",
      "RS"
    ]
  },
  {
    "iata": "KVO",
    "translations": [
      "Morava Airport",
      "Morava Airport",
      "Morava Airport"
    ],
    "city": [
      "Kraljevo",
      "Kraljevo",
      "Kraljevo"
    ],
    "country": [
      "RS",
      "RS",
      "RS"
    ]
  },
  {
    "iata": "INI",
    "translations": [
      "Niš Constantine the Great Airport",
      "Niš Constantine the Great Airport",
      "Niš Constantine the Great Airport"
    ],
    "city": [
      "Niš",
      "Niš",
      "Niš"
    ],
    "country": [
      "RS",
      "RS",
      "RS"
    ]
  },
  {
    "iata": "TGD",
    "translations": [
      "Podgorica Airport / Podgorica Golubovci Airbase",
      "Podgorica Airport / Podgorica Golubovci Airbase",
      "Podgorica Airport / Podgorica Golubovci Airbase"
    ],
    "city": [
      "Podgorica",
      "Podgorica",
      "Podgorica"
    ],
    "country": [
      "ME",
      "ME",
      "ME"
    ]
  },
  {
    "iata": "TIV",
    "translations": [
      "Tivat Airport",
      "Tivat Airport",
      "Tivat Airport"
    ],
    "city": [
      "Tivat",
      "Tivat",
      "Tivat"
    ],
    "country": [
      "ME",
      "ME",
      "ME"
    ]
  },
  {
    "iata": "UZC",
    "translations": [
      "Ponikve Airport",
      "Ponikve Airport",
      "Ponikve Airport"
    ],
    "city": [
      "Stapari",
      "Stapari",
      "Stapari"
    ],
    "country": [
      "RS",
      "RS",
      "RS"
    ]
  },
  {
    "iata": "LZG",
    "translations": [
      "Langzhong Gucheng Airport",
      "Langzhong Gucheng Airport",
      "Langzhong Gucheng Airport"
    ],
    "city": [
      "Nanchong (Langzhong)",
      "Nanchong (Langzhong)",
      "Nanchong (Langzhong)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "BTS",
    "translations": [
      "M. R. Štefánik Airport",
      "M. R. Štefánik Airport",
      "M. R. Štefánik Airport"
    ],
    "city": [
      "Bratislava",
      "Bratislava",
      "Bratislava"
    ],
    "country": [
      "SK",
      "SK",
      "SK"
    ]
  },
  {
    "iata": "KSC",
    "translations": [
      "Košice International Airport",
      "Košice International Airport",
      "Košice International Airport"
    ],
    "city": [
      "Košice",
      "Košice",
      "Košice"
    ],
    "country": [
      "SK",
      "SK",
      "SK"
    ]
  },
  {
    "iata": "LUE",
    "translations": [
      "Lučenec Airfield",
      "Lučenec Airfield",
      "Lučenec Airfield"
    ],
    "city": [
      "Lučenec",
      "Lučenec",
      "Lučenec"
    ],
    "country": [
      "SK",
      "SK",
      "SK"
    ]
  },
  {
    "iata": "PZY",
    "translations": [
      "Piešťany Airport",
      "Piešťany Airport",
      "Piešťany Airport"
    ],
    "city": [
      "Piešťany",
      "Piešťany",
      "Piešťany"
    ],
    "country": [
      "SK",
      "SK",
      "SK"
    ]
  },
  {
    "iata": "POV",
    "translations": [
      "Prešov Air Base",
      "Prešov Air Base",
      "Prešov Air Base"
    ],
    "city": [
      "Prešov",
      "Prešov",
      "Prešov"
    ],
    "country": [
      "SK",
      "SK",
      "SK"
    ]
  },
  {
    "iata": "SLD",
    "translations": [
      "Sliač Airport",
      "Sliač Airport",
      "Sliač Airport"
    ],
    "city": [
      "Sliač",
      "Sliač",
      "Sliač"
    ],
    "country": [
      "SK",
      "SK",
      "SK"
    ]
  },
  {
    "iata": "TAT",
    "translations": [
      "Poprad-Tatry Airport",
      "Poprad-Tatry Airport",
      "Poprad-Tatry Airport"
    ],
    "city": [
      "Poprad",
      "Poprad",
      "Poprad"
    ],
    "country": [
      "SK",
      "SK",
      "SK"
    ]
  },
  {
    "iata": "ILZ",
    "translations": [
      "Žilina-Dolný Hričov Airport",
      "Žilina-Dolný Hričov Airport",
      "Žilina-Dolný Hričov Airport"
    ],
    "city": [
      "Dolný Hričov",
      "Dolný Hričov",
      "Dolný Hričov"
    ],
    "country": [
      "SK",
      "SK",
      "SK"
    ]
  },
  {
    "iata": "DRU",
    "translations": [
      "Drummond Airport",
      "Drummond Airport",
      "Drummond Airport"
    ],
    "city": [
      "Drummond",
      "Drummond",
      "Drummond"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GLN",
    "translations": [
      "Guelmim Airport",
      "Guelmim Airport",
      "Guelmim Airport"
    ],
    "city": [
      "Guelmim",
      "Guelmim",
      "Guelmim"
    ],
    "country": [
      "MA",
      "MA",
      "MA"
    ]
  },
  {
    "iata": "UWA",
    "translations": [
      "Ware Airport",
      "Ware Airport",
      "Ware Airport"
    ],
    "city": [
      "Ware",
      "Ware",
      "Ware"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MAP",
    "translations": [
      "Mamai Airport",
      "Mamai Airport",
      "Mamai Airport"
    ],
    "city": [
      "Mamai",
      "Mamai",
      "Mamai"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "GDT",
    "translations": [
      "JAGS McCartney International Airport",
      "JAGS McCartney International Airport",
      "JAGS McCartney International Airport"
    ],
    "city": [
      "Cockburn Town",
      "Cockburn Town",
      "Cockburn Town"
    ],
    "country": [
      "TC",
      "TC",
      "TC"
    ]
  },
  {
    "iata": "MDS",
    "translations": [
      "Middle Caicos Airport",
      "Middle Caicos Airport",
      "Middle Caicos Airport"
    ],
    "city": [
      "Middle Caicos",
      "Middle Caicos",
      "Middle Caicos"
    ],
    "country": [
      "TC",
      "TC",
      "TC"
    ]
  },
  {
    "iata": "NCA",
    "translations": [
      "North Caicos Airport",
      "North Caicos Airport",
      "North Caicos Airport"
    ],
    "city": [
      "North Caicos",
      "North Caicos",
      "North Caicos"
    ],
    "country": [
      "TC",
      "TC",
      "TC"
    ]
  },
  {
    "iata": "PIC",
    "translations": [
      "Pine Cay Airport",
      "Pine Cay Airport",
      "Pine Cay Airport"
    ],
    "city": [
      "Pine Cay",
      "Pine Cay",
      "Pine Cay"
    ],
    "country": [
      "TC",
      "TC",
      "TC"
    ]
  },
  {
    "iata": "PLS",
    "translations": [
      "Providenciales International Airport",
      "Providenciales International Airport",
      "Providenciales International Airport"
    ],
    "city": [
      "Providenciales",
      "Providenciales",
      "Providenciales"
    ],
    "country": [
      "TC",
      "TC",
      "TC"
    ]
  },
  {
    "iata": "XSC",
    "translations": [
      "South Caicos Airport",
      "South Caicos Airport",
      "South Caicos Airport"
    ],
    "city": [
      "South Caicos",
      "South Caicos",
      "South Caicos"
    ],
    "country": [
      "TC",
      "TC",
      "TC"
    ]
  },
  {
    "iata": "SLX",
    "translations": [
      "Salt Cay Airport",
      "Salt Cay Airport",
      "Salt Cay Airport"
    ],
    "city": [
      "Salt Cay",
      "Salt Cay",
      "Salt Cay"
    ],
    "country": [
      "TC",
      "TC",
      "TC"
    ]
  },
  {
    "iata": "BRX",
    "translations": [
      "Maria Montez International Airport",
      "Maria Montez International Airport",
      "Maria Montez International Airport"
    ],
    "city": [
      "Barahona",
      "Barahona",
      "Barahona"
    ],
    "country": [
      "DO",
      "DO",
      "DO"
    ]
  },
  {
    "iata": "CBJ",
    "translations": [
      "Cabo Rojo Airport",
      "Cabo Rojo Airport",
      "Cabo Rojo Airport"
    ],
    "city": [
      "Cabo Rojo",
      "Cabo Rojo",
      "Cabo Rojo"
    ],
    "country": [
      "DO",
      "DO",
      "DO"
    ]
  },
  {
    "iata": "AZS",
    "translations": [
      "Samaná El Catey International Airport",
      "Samaná El Catey International Airport",
      "Samaná El Catey International Airport"
    ],
    "city": [
      "Samana",
      "Samana",
      "Samana"
    ],
    "country": [
      "DO",
      "DO",
      "DO"
    ]
  },
  {
    "iata": "COZ",
    "translations": [
      "Constanza - Expedición 14 de Junio National Airport",
      "Constanza - Expedición 14 de Junio National Airport",
      "Constanza - Expedición 14 de Junio National Airport"
    ],
    "city": [
      "Costanza",
      "Costanza",
      "Costanza"
    ],
    "country": [
      "DO",
      "DO",
      "DO"
    ]
  },
  {
    "iata": "JBQ",
    "translations": [
      "La Isabela International Airport",
      "La Isabela International Airport",
      "La Isabela International Airport"
    ],
    "city": [
      "La Isabela",
      "La Isabela",
      "La Isabela"
    ],
    "country": [
      "DO",
      "DO",
      "DO"
    ]
  },
  {
    "iata": "LRM",
    "translations": [
      "Casa De Campo International Airport",
      "Casa De Campo International Airport",
      "Casa De Campo International Airport"
    ],
    "city": [
      "La Romana",
      "La Romana",
      "La Romana"
    ],
    "country": [
      "DO",
      "DO",
      "DO"
    ]
  },
  {
    "iata": "PUJ",
    "translations": [
      "Punta Cana International Airport",
      "Punta Cana International Airport",
      "Punta Cana International Airport"
    ],
    "city": [
      "Punta Cana",
      "Punta Cana",
      "Punta Cana"
    ],
    "country": [
      "DO",
      "DO",
      "DO"
    ]
  },
  {
    "iata": "POP",
    "translations": [
      "Gregorio Luperon International Airport",
      "Gregorio Luperon International Airport",
      "Gregorio Luperon International Airport"
    ],
    "city": [
      "Puerto Plata",
      "Puerto Plata",
      "Puerto Plata"
    ],
    "country": [
      "DO",
      "DO",
      "DO"
    ]
  },
  {
    "iata": "SDQ",
    "translations": [
      "Las Américas International Airport",
      "Las Américas International Airport",
      "Las Américas International Airport"
    ],
    "city": [
      "Santo Domingo",
      "Santo Domingo",
      "Santo Domingo"
    ],
    "country": [
      "DO",
      "DO",
      "DO"
    ]
  },
  {
    "iata": "STI",
    "translations": [
      "Cibao International Airport",
      "Cibao International Airport",
      "Cibao International Airport"
    ],
    "city": [
      "Santiago",
      "Santiago",
      "Santiago"
    ],
    "country": [
      "DO",
      "DO",
      "DO"
    ]
  },
  {
    "iata": "MDV",
    "translations": [
      "Médouneu Airport",
      "Médouneu Airport",
      "Médouneu Airport"
    ],
    "city": [
      "Médouneu, Gabon",
      "Médouneu, Gabon",
      "Médouneu, Gabon"
    ],
    "country": [
      "GQ",
      "GQ",
      "GQ"
    ]
  },
  {
    "iata": "LIZ",
    "translations": [
      "Loring International Airport",
      "Loring International Airport",
      "Loring International Airport"
    ],
    "city": [
      "Limestone",
      "Limestone",
      "Limestone"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MEF",
    "translations": [
      "Melfi Airport",
      "Melfi Airport",
      "Melfi Airport"
    ],
    "city": [
      "Melfi",
      "Melfi",
      "Melfi"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "NKO",
    "translations": [
      "Ankokoambo Airport",
      "Ankokoambo Airport",
      "Ankokoambo Airport"
    ],
    "city": [
      "Ankokoambo",
      "Ankokoambo",
      "Ankokoambo"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "RLR",
    "translations": [
      "Relais de la Reine Airport",
      "Relais de la Reine Airport",
      "Relais de la Reine Airport"
    ],
    "city": [
      "Isalo",
      "Isalo",
      "Isalo"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "DOA",
    "translations": [
      "Doany Airport",
      "Doany Airport",
      "Doany Airport"
    ],
    "city": [
      "Doany",
      "Doany",
      "Doany"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "CBV",
    "translations": [
      "Coban Airport",
      "Coban Airport",
      "Coban Airport"
    ],
    "city": [
      "Coban",
      "Coban",
      "Coban"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "CMM",
    "translations": [
      "Carmelita Airport",
      "Carmelita Airport",
      "Carmelita Airport"
    ],
    "city": [
      "Carmelita",
      "Carmelita",
      "Carmelita"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "CTF",
    "translations": [
      "Coatepeque Airport",
      "Coatepeque Airport",
      "Coatepeque Airport"
    ],
    "city": [
      "Coatepeque",
      "Coatepeque",
      "Coatepeque"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "GUA",
    "translations": [
      "La Aurora Airport",
      "La Aurora Airport",
      "La Aurora Airport"
    ],
    "city": [
      "Guatemala City",
      "Guatemala City",
      "Guatemala City"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "HUG",
    "translations": [
      "Huehuetenango Airport",
      "Huehuetenango Airport",
      "Huehuetenango Airport"
    ],
    "city": [
      "Huehuetenango",
      "Huehuetenango",
      "Huehuetenango"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "MGI",
    "translations": [
      "National Wildlife Refuge Airport",
      "National Wildlife Refuge Airport",
      "National Wildlife Refuge Airport"
    ],
    "city": [
      "Matagorda Island",
      "Matagorda Island",
      "Matagorda Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MGP",
    "translations": [
      "Manga Airport",
      "Manga Airport",
      "Manga Airport"
    ],
    "city": [
      "Manga Mission",
      "Manga Mission",
      "Manga Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PBR",
    "translations": [
      "Puerto Barrios Airport",
      "Puerto Barrios Airport",
      "Puerto Barrios Airport"
    ],
    "city": [
      "Puerto Barrios",
      "Puerto Barrios",
      "Puerto Barrios"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "PKJ",
    "translations": [
      "Playa Grande Airport",
      "Playa Grande Airport",
      "Playa Grande Airport"
    ],
    "city": [
      "Playa Grande",
      "Playa Grande",
      "Playa Grande"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "PON",
    "translations": [
      "Poptún Airport",
      "Poptún Airport",
      "Poptún Airport"
    ],
    "city": [
      "Poptún",
      "Poptún",
      "Poptún"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "AQB",
    "translations": [
      "Quiché Airport",
      "Quiché Airport",
      "Quiché Airport"
    ],
    "city": [
      "Santa Cruz del Quiché",
      "Santa Cruz del Quiché",
      "Santa Cruz del Quiché"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "AAZ",
    "translations": [
      "Quezaltenango Airport",
      "Quezaltenango Airport",
      "Quezaltenango Airport"
    ],
    "city": [
      "Quezaltenango",
      "Quezaltenango",
      "Quezaltenango"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "RUV",
    "translations": [
      "Rubelsanto Airport",
      "Rubelsanto Airport",
      "Rubelsanto Airport"
    ],
    "city": [
      "Rubelsanto",
      "Rubelsanto",
      "Rubelsanto"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "LCF",
    "translations": [
      "Las Vegas Airport",
      "Las Vegas Airport",
      "Las Vegas Airport"
    ],
    "city": [
      "Rio Dulce",
      "Rio Dulce",
      "Rio Dulce"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "RER",
    "translations": [
      "Retalhuleu Airport",
      "Retalhuleu Airport",
      "Retalhuleu Airport"
    ],
    "city": [
      "Retalhuleu",
      "Retalhuleu",
      "Retalhuleu"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "GSJ",
    "translations": [
      "San José Airport",
      "San José Airport",
      "San José Airport"
    ],
    "city": [
      "Puerto San José",
      "Puerto San José",
      "Puerto San José"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "FRS",
    "translations": [
      "Mundo Maya International Airport",
      "Mundo Maya International Airport",
      "Mundo Maya International Airport"
    ],
    "city": [
      "San Benito",
      "San Benito",
      "San Benito"
    ],
    "country": [
      "GT",
      "GT",
      "GT"
    ]
  },
  {
    "iata": "UJE",
    "translations": [
      "Ujae Atoll Airport",
      "Ujae Atoll Airport",
      "Ujae Atoll Airport"
    ],
    "city": [
      "Ujae Atoll",
      "Ujae Atoll",
      "Ujae Atoll"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "AIM",
    "translations": [
      "Ailuk Airport",
      "Ailuk Airport",
      "Ailuk Airport"
    ],
    "city": [
      "Ailuk Island",
      "Ailuk Island",
      "Ailuk Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "AUL",
    "translations": [
      "Aur Island Airport",
      "Aur Island Airport",
      "Aur Island Airport"
    ],
    "city": [
      "Aur Atoll",
      "Aur Atoll",
      "Aur Atoll"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "BII",
    "translations": [
      "Enyu Airfield",
      "Enyu Airfield",
      "Enyu Airfield"
    ],
    "city": [
      "Bikini Atoll",
      "Bikini Atoll",
      "Bikini Atoll"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "EBN",
    "translations": [
      "Ebadon Airport",
      "Ebadon Airport",
      "Ebadon Airport"
    ],
    "city": [
      "Ebadon Island",
      "Ebadon Island",
      "Ebadon Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "JAT",
    "translations": [
      "Jabot Airport",
      "Jabot Airport",
      "Jabot Airport"
    ],
    "city": [
      "Ailinglapalap Atoll",
      "Ailinglapalap Atoll",
      "Ailinglapalap Atoll"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "JEJ",
    "translations": [
      "Jeh Airport",
      "Jeh Airport",
      "Jeh Airport"
    ],
    "city": [
      "Ailinglapalap Atoll",
      "Ailinglapalap Atoll",
      "Ailinglapalap Atoll"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "LIK",
    "translations": [
      "Likiep Airport",
      "Likiep Airport",
      "Likiep Airport"
    ],
    "city": [
      "Likiep Island",
      "Likiep Island",
      "Likiep Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "LML",
    "translations": [
      "Lae Island Airport",
      "Lae Island Airport",
      "Lae Island Airport"
    ],
    "city": [
      "Lae Island",
      "Lae Island",
      "Lae Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "MAV",
    "translations": [
      "Maloelap Island Airport",
      "Maloelap Island Airport",
      "Maloelap Island Airport"
    ],
    "city": [
      "Maloelap Island",
      "Maloelap Island",
      "Maloelap Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "MJB",
    "translations": [
      "Mejit Atoll Airport",
      "Mejit Atoll Airport",
      "Mejit Atoll Airport"
    ],
    "city": [
      "Mejit Atoll",
      "Mejit Atoll",
      "Mejit Atoll"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "MJE",
    "translations": [
      "Majkin Airport",
      "Majkin Airport",
      "Majkin Airport"
    ],
    "city": [
      "Majkin",
      "Majkin",
      "Majkin"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "NDK",
    "translations": [
      "Namorik Airport",
      "Namorik Airport",
      "Namorik Airport"
    ],
    "city": [
      "Namorik Atoll",
      "Namorik Atoll",
      "Namorik Atoll"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "RNP",
    "translations": [
      "Rongelap Island Airport",
      "Rongelap Island Airport",
      "Rongelap Island Airport"
    ],
    "city": [
      "Rongelap Island",
      "Rongelap Island",
      "Rongelap Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "TIC",
    "translations": [
      "Tinak Airport",
      "Tinak Airport",
      "Tinak Airport"
    ],
    "city": [
      "Arno Atoll",
      "Arno Atoll",
      "Arno Atoll"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "UIT",
    "translations": [
      "Jaluit Airport",
      "Jaluit Airport",
      "Jaluit Airport"
    ],
    "city": [
      "Jabor Jaluit Atoll",
      "Jabor Jaluit Atoll",
      "Jabor Jaluit Atoll"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "WJA",
    "translations": [
      "Woja Airport",
      "Woja Airport",
      "Woja Airport"
    ],
    "city": [
      "Woja",
      "Woja",
      "Woja"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "WTE",
    "translations": [
      "Wotje Airport",
      "Wotje Airport",
      "Wotje Airport"
    ],
    "city": [
      "Wotje",
      "Wotje",
      "Wotje"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "WTO",
    "translations": [
      "Wotho Island Airport",
      "Wotho Island Airport",
      "Wotho Island Airport"
    ],
    "city": [
      "Wotho Island",
      "Wotho Island",
      "Wotho Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "AHS",
    "translations": [
      "Ahuas Airport",
      "Ahuas Airport",
      "Ahuas Airport"
    ],
    "city": [
      "Ahuas",
      "Ahuas",
      "Ahuas"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "BHG",
    "translations": [
      "Brus Laguna Airport",
      "Brus Laguna Airport",
      "Brus Laguna Airport"
    ],
    "city": [
      "Brus Laguna",
      "Brus Laguna",
      "Brus Laguna"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "LUI",
    "translations": [
      "Carta Airport",
      "Carta Airport",
      "Carta Airport"
    ],
    "city": [
      "La Unión",
      "La Unión",
      "La Unión"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "CYL",
    "translations": [
      "Coyoles Airport",
      "Coyoles Airport",
      "Coyoles Airport"
    ],
    "city": [
      "Coyoles",
      "Coyoles",
      "Coyoles"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "CDD",
    "translations": [
      "Cauquira Airport",
      "Cauquira Airport",
      "Cauquira Airport"
    ],
    "city": [
      "Cauquira",
      "Cauquira",
      "Cauquira"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "OAN",
    "translations": [
      "El Arrayán Airport",
      "El Arrayán Airport",
      "El Arrayán Airport"
    ],
    "city": [
      "Olanchito",
      "Olanchito",
      "Olanchito"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "CAA",
    "translations": [
      "El Aguacate Airport",
      "El Aguacate Airport",
      "El Aguacate Airport"
    ],
    "city": [
      "El Aguacate",
      "El Aguacate",
      "El Aguacate"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "GAC",
    "translations": [
      "Celaque Gracias Airport",
      "Celaque Gracias Airport",
      "Celaque Gracias Airport"
    ],
    "city": [
      "Gracias",
      "Gracias",
      "Gracias"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "IRN",
    "translations": [
      "Iriona Airport",
      "Iriona Airport",
      "Iriona Airport"
    ],
    "city": [
      "Iriona",
      "Iriona",
      "Iriona"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "JUT",
    "translations": [
      "Jutigalpa airport",
      "Jutigalpa airport",
      "Jutigalpa airport"
    ],
    "city": [
      "Jutigalpa",
      "Jutigalpa",
      "Jutigalpa"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "LCE",
    "translations": [
      "Goloson International Airport",
      "Goloson International Airport",
      "Goloson International Airport"
    ],
    "city": [
      "La Ceiba",
      "La Ceiba",
      "La Ceiba"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "LEZ",
    "translations": [
      "La Esperanza Airport",
      "La Esperanza Airport",
      "La Esperanza Airport"
    ],
    "city": [
      "La Esperanza",
      "La Esperanza",
      "La Esperanza"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "SAP",
    "translations": [
      "Ramón Villeda Morales International Airport",
      "Ramón Villeda Morales International Airport",
      "Ramón Villeda Morales International Airport"
    ],
    "city": [
      "San Pedro Sula",
      "San Pedro Sula",
      "San Pedro Sula"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "LMH",
    "translations": [
      "Limon Airport",
      "Limon Airport",
      "Limon Airport"
    ],
    "city": [
      "Limón",
      "Limón",
      "Limón"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "MHN",
    "translations": [
      "Hooker County Airport",
      "Hooker County Airport",
      "Hooker County Airport"
    ],
    "city": [
      "Mullen",
      "Mullen",
      "Mullen"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GJA",
    "translations": [
      "La Laguna Airport",
      "La Laguna Airport",
      "La Laguna Airport"
    ],
    "city": [
      "Guanaja",
      "Guanaja",
      "Guanaja"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "PCH",
    "translations": [
      "Palacios Airport",
      "Palacios Airport",
      "Palacios Airport"
    ],
    "city": [
      "Palacios",
      "Palacios",
      "Palacios"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "PEU",
    "translations": [
      "Puerto Lempira Airport",
      "Puerto Lempira Airport",
      "Puerto Lempira Airport"
    ],
    "city": [
      "Puerto Lempira",
      "Puerto Lempira",
      "Puerto Lempira"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "RTB",
    "translations": [
      "Juan Manuel Gálvez International Airport",
      "Juan Manuel Gálvez International Airport",
      "Juan Manuel Gálvez International Airport"
    ],
    "city": [
      "Coxen Hole",
      "Coxen Hole",
      "Coxen Hole"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "RUY",
    "translations": [
      "Rioamarillo Airport",
      "Rioamarillo Airport",
      "Rioamarillo Airport"
    ],
    "city": [
      "Copán Ruinas",
      "Copán Ruinas",
      "Copán Ruinas"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "XPL",
    "translations": [
      "Palmerola International Airport / José Enrique Soto Cano Air Base",
      "Palmerola International Airport / José Enrique Soto Cano Air Base",
      "Palmerola International Airport / José Enrique Soto Cano Air Base"
    ],
    "city": [
      "Palmerola",
      "Palmerola",
      "Palmerola"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "TEA",
    "translations": [
      "Tela Airport",
      "Tela Airport",
      "Tela Airport"
    ],
    "city": [
      "Tela",
      "Tela",
      "Tela"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "TGU",
    "translations": [
      "Toncontín International Airport",
      "Toncontín International Airport",
      "Toncontín International Airport"
    ],
    "city": [
      "Tegucigalpa",
      "Tegucigalpa",
      "Tegucigalpa"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "TJI",
    "translations": [
      "Trujillo Airport",
      "Trujillo Airport",
      "Trujillo Airport"
    ],
    "city": [
      "Trujillo",
      "Trujillo",
      "Trujillo"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "TCF",
    "translations": [
      "Tocoa Airport",
      "Tocoa Airport",
      "Tocoa Airport"
    ],
    "city": [
      "Tocoa",
      "Tocoa",
      "Tocoa"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "SCD",
    "translations": [
      "Sulaco Airport",
      "Sulaco Airport",
      "Sulaco Airport"
    ],
    "city": [
      "Sulaco",
      "Sulaco",
      "Sulaco"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "UII",
    "translations": [
      "Utila Airport",
      "Utila Airport",
      "Utila Airport"
    ],
    "city": [
      "Utila Island",
      "Utila Island",
      "Utila Island"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "ORO",
    "translations": [
      "Yoro Airport",
      "Yoro Airport",
      "Yoro Airport"
    ],
    "city": [
      "Yoro",
      "Yoro",
      "Yoro"
    ],
    "country": [
      "HN",
      "HN",
      "HN"
    ]
  },
  {
    "iata": "MIZ",
    "translations": [
      "Mainoru Airstrip",
      "Mainoru Airstrip",
      "Mainoru Airstrip"
    ],
    "city": [
      "Mainoru",
      "Mainoru",
      "Mainoru"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MJJ",
    "translations": [
      "Moki Airport",
      "Moki Airport",
      "Moki Airport"
    ],
    "city": [
      "Moki",
      "Moki",
      "Moki"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MJS",
    "translations": [
      "Maganja da Costa Airport",
      "Maganja da Costa Airport",
      "Maganja da Costa Airport"
    ],
    "city": [
      "Maganja",
      "Maganja",
      "Maganja"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "OCJ",
    "translations": [
      "Ian Fleming International Airport",
      "Ian Fleming International Airport",
      "Ian Fleming International Airport"
    ],
    "city": [
      "Boscobel",
      "Boscobel",
      "Boscobel"
    ],
    "country": [
      "JM",
      "JM",
      "JM"
    ]
  },
  {
    "iata": "KIN",
    "translations": [
      "Norman Manley International Airport",
      "Norman Manley International Airport",
      "Norman Manley International Airport"
    ],
    "city": [
      "Kingston",
      "Kingston",
      "Kingston"
    ],
    "country": [
      "JM",
      "JM",
      "JM"
    ]
  },
  {
    "iata": "MBJ",
    "translations": [
      "Sangster International Airport",
      "Sangster International Airport",
      "Sangster International Airport"
    ],
    "city": [
      "Montego Bay",
      "Montego Bay",
      "Montego Bay"
    ],
    "country": [
      "JM",
      "JM",
      "JM"
    ]
  },
  {
    "iata": "POT",
    "translations": [
      "Ken Jones Airport",
      "Ken Jones Airport",
      "Ken Jones Airport"
    ],
    "city": [
      "Ken Jones",
      "Ken Jones",
      "Ken Jones"
    ],
    "country": [
      "JM",
      "JM",
      "JM"
    ]
  },
  {
    "iata": "NEG",
    "translations": [
      "Negril Airport",
      "Negril Airport",
      "Negril Airport"
    ],
    "city": [
      "Negril",
      "Negril",
      "Negril"
    ],
    "country": [
      "JM",
      "JM",
      "JM"
    ]
  },
  {
    "iata": "KTP",
    "translations": [
      "Tinson Pen Airport",
      "Tinson Pen Airport",
      "Tinson Pen Airport"
    ],
    "city": [
      "Tinson Pen",
      "Tinson Pen",
      "Tinson Pen"
    ],
    "country": [
      "JM",
      "JM",
      "JM"
    ]
  },
  {
    "iata": "MIJ",
    "translations": [
      "Mili Island Airport",
      "Mili Island Airport",
      "Mili Island Airport"
    ],
    "city": [
      "Mili Island",
      "Mili Island",
      "Mili Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "HEB",
    "translations": [
      "Hinthada Airport",
      "Hinthada Airport",
      "Hinthada Airport"
    ],
    "city": [
      "Hinthada",
      "Hinthada",
      "Hinthada"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "TZM",
    "translations": [
      "Aeródromo de Cupul",
      "Aeródromo de Cupul",
      "Aeródromo de Cupul"
    ],
    "city": [
      "Tizimin",
      "Tizimin",
      "Tizimin"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "ACA",
    "translations": [
      "General Juan N. Álvarez International Airport",
      "General Juan N. Álvarez International Airport",
      "General Juan N. Álvarez International Airport"
    ],
    "city": [
      "Acapulco",
      "Acapulco",
      "Acapulco"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "NTR",
    "translations": [
      "Del Norte International Airport",
      "Del Norte International Airport",
      "Del Norte International Airport"
    ],
    "city": [
      "Monterrey",
      "Monterrey",
      "Monterrey"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "AGU",
    "translations": [
      "Jesús Terán Peredo International Airport",
      "Jesús Terán Peredo International Airport",
      "Jesús Terán Peredo International Airport"
    ],
    "city": [
      "Aguascalientes",
      "Aguascalientes",
      "Aguascalientes"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "HUX",
    "translations": [
      "Bahías de Huatulco International Airport",
      "Bahías de Huatulco International Airport",
      "Bahías de Huatulco International Airport"
    ],
    "city": [
      "Huatulco",
      "Huatulco",
      "Huatulco"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CNA",
    "translations": [
      "Cananea National Airport",
      "Cananea National Airport",
      "Cananea National Airport"
    ],
    "city": [
      "Cananea",
      "Cananea",
      "Cananea"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CVJ",
    "translations": [
      "General Mariano Matamoros International Airport",
      "General Mariano Matamoros International Airport",
      "General Mariano Matamoros International Airport"
    ],
    "city": [
      "Temixco",
      "Temixco",
      "Temixco"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "ACN",
    "translations": [
      "Ciudad Acuña New International Airport",
      "Ciudad Acuña New International Airport",
      "Ciudad Acuña New International Airport"
    ],
    "city": [
      "Ciudad Acuña",
      "Ciudad Acuña",
      "Ciudad Acuña"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CME",
    "translations": [
      "Ciudad del Carmen International Airport",
      "Ciudad del Carmen International Airport",
      "Ciudad del Carmen International Airport"
    ],
    "city": [
      "Ciudad del Carmen",
      "Ciudad del Carmen",
      "Ciudad del Carmen"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "NCG",
    "translations": [
      "Aeropuerto Municipal de Nuevo Casas Grandes",
      "Aeropuerto Municipal de Nuevo Casas Grandes",
      "Aeropuerto Municipal de Nuevo Casas Grandes"
    ],
    "city": [
      "Nuevo Casas Grandes",
      "Nuevo Casas Grandes",
      "Nuevo Casas Grandes"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CUL",
    "translations": [
      "Bachigualato Federal International Airport",
      "Bachigualato Federal International Airport",
      "Bachigualato Federal International Airport"
    ],
    "city": [
      "Culiacán",
      "Culiacán",
      "Culiacán"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CTM",
    "translations": [
      "Chetumal International Airport",
      "Chetumal International Airport",
      "Chetumal International Airport"
    ],
    "city": [
      "Chetumal",
      "Chetumal",
      "Chetumal"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CEN",
    "translations": [
      "Ciudad Obregón International Airport",
      "Ciudad Obregón International Airport",
      "Ciudad Obregón International Airport"
    ],
    "city": [
      "Ciudad Obregón",
      "Ciudad Obregón",
      "Ciudad Obregón"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CJT",
    "translations": [
      "San Antonio Copalar Airport",
      "San Antonio Copalar Airport",
      "San Antonio Copalar Airport"
    ],
    "city": [
      "Comitán",
      "Comitán",
      "Comitán"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CPE",
    "translations": [
      "Ingeniero Alberto Acuña Ongay International Airport",
      "Ingeniero Alberto Acuña Ongay International Airport",
      "Ingeniero Alberto Acuña Ongay International Airport"
    ],
    "city": [
      "Campeche",
      "Campeche",
      "Campeche"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CJS",
    "translations": [
      "Abraham González International Airport",
      "Abraham González International Airport",
      "Abraham González International Airport"
    ],
    "city": [
      "Ciudad Juárez",
      "Ciudad Juárez",
      "Ciudad Juárez"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CZA",
    "translations": [
      "Chichén Itzá International Airport",
      "Chichén Itzá International Airport",
      "Chichén Itzá International Airport"
    ],
    "city": [
      "Tinúm",
      "Tinúm",
      "Tinúm"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CUU",
    "translations": [
      "General Roberto Fierro Villalobos International Airport",
      "General Roberto Fierro Villalobos International Airport",
      "General Roberto Fierro Villalobos International Airport"
    ],
    "city": [
      "Chihuahua",
      "Chihuahua",
      "Chihuahua"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CVM",
    "translations": [
      "General Pedro Jose Mendez International Airport",
      "General Pedro Jose Mendez International Airport",
      "General Pedro Jose Mendez International Airport"
    ],
    "city": [
      "Ciudad Victoria",
      "Ciudad Victoria",
      "Ciudad Victoria"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CYW",
    "translations": [
      "Captain Rogelio Castillo National Airport",
      "Captain Rogelio Castillo National Airport",
      "Captain Rogelio Castillo National Airport"
    ],
    "city": [
      "Celaya",
      "Celaya",
      "Celaya"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CZM",
    "translations": [
      "Cozumel International Airport",
      "Cozumel International Airport",
      "Cozumel International Airport"
    ],
    "city": [
      "Cozumel",
      "Cozumel",
      "Cozumel"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CUA",
    "translations": [
      "Ciudad Constitución National Airport",
      "Ciudad Constitución National Airport",
      "Ciudad Constitución National Airport"
    ],
    "city": [
      "Comondú",
      "Comondú",
      "Comondú"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "MMC",
    "translations": [
      "Ciudad Mante Los Huastecas National Airport",
      "Ciudad Mante Los Huastecas National Airport",
      "Ciudad Mante Los Huastecas National Airport"
    ],
    "city": [
      "Ciudad Mante",
      "Ciudad Mante",
      "Ciudad Mante"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "DGO",
    "translations": [
      "General Guadalupe Victoria International Airport",
      "General Guadalupe Victoria International Airport",
      "General Guadalupe Victoria International Airport"
    ],
    "city": [
      "Durango",
      "Durango",
      "Durango"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "TPQ",
    "translations": [
      "Amado Nervo National Airport",
      "Amado Nervo National Airport",
      "Amado Nervo National Airport"
    ],
    "city": [
      "Tepic",
      "Tepic",
      "Tepic"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "ESE",
    "translations": [
      "Ensenada International Airport / El Ciprés Air Base",
      "Ensenada International Airport / El Ciprés Air Base",
      "Ensenada International Airport / El Ciprés Air Base"
    ],
    "city": [
      "Ensenada",
      "Ensenada",
      "Ensenada"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "GDL",
    "translations": [
      "Guadalajara International Airport",
      "Guadalajara International Airport",
      "Guadalajara International Airport"
    ],
    "city": [
      "Guadalajara",
      "Guadalajara",
      "Guadalajara"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "GYM",
    "translations": [
      "General José María Yáñez International Airport",
      "General José María Yáñez International Airport",
      "General José María Yáñez International Airport"
    ],
    "city": [
      "Guaymas",
      "Guaymas",
      "Guaymas"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "GUB",
    "translations": [
      "Guerrero Negro Airport",
      "Guerrero Negro Airport",
      "Guerrero Negro Airport"
    ],
    "city": [
      "San Quintín",
      "San Quintín",
      "San Quintín"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "TCN",
    "translations": [
      "Tehuacán National Airport",
      "Tehuacán National Airport",
      "Tehuacán National Airport"
    ],
    "city": [
      "Tehuacán",
      "Tehuacán",
      "Tehuacán"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "HMO",
    "translations": [
      "General Ignacio P. Garcia International Airport",
      "General Ignacio P. Garcia International Airport",
      "General Ignacio P. Garcia International Airport"
    ],
    "city": [
      "Hermosillo",
      "Hermosillo",
      "Hermosillo"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CLQ",
    "translations": [
      "Licenciado Miguel de la Madrid International Airport",
      "Licenciado Miguel de la Madrid International Airport",
      "Licenciado Miguel de la Madrid International Airport"
    ],
    "city": [
      "Colima",
      "Colima",
      "Colima"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "ISJ",
    "translations": [
      "Isla Mujeres National Airport",
      "Isla Mujeres National Airport",
      "Isla Mujeres National Airport"
    ],
    "city": [
      "Isla Mujeres",
      "Isla Mujeres",
      "Isla Mujeres"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "SLW",
    "translations": [
      "Plan De Guadalupe International Airport",
      "Plan De Guadalupe International Airport",
      "Plan De Guadalupe International Airport"
    ],
    "city": [
      "Saltillo",
      "Saltillo",
      "Saltillo"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "IZT",
    "translations": [
      "General Antonio Cárdenas Rodríguez National Airport / Ixtepec Air Base",
      "General Antonio Cárdenas Rodríguez National Airport / Ixtepec Air Base",
      "General Antonio Cárdenas Rodríguez National Airport / Ixtepec Air Base"
    ],
    "city": [
      "Ixtepec",
      "Ixtepec",
      "Ixtepec"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "JAL",
    "translations": [
      "El Lencero Airport",
      "El Lencero Airport",
      "El Lencero Airport"
    ],
    "city": [
      "Emiliano Zapata",
      "Emiliano Zapata",
      "Emiliano Zapata"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "AZP",
    "translations": [
      "Jorge Jiménez Cantú National Airport",
      "Jorge Jiménez Cantú National Airport",
      "Jorge Jiménez Cantú National Airport"
    ],
    "city": [
      "Atizapán de Zaragoza",
      "Atizapán de Zaragoza",
      "Atizapán de Zaragoza"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "LZC",
    "translations": [
      "Lázaro Cárdenas Airport",
      "Lázaro Cárdenas Airport",
      "Lázaro Cárdenas Airport"
    ],
    "city": [
      "Lázaro Cárdenas",
      "Lázaro Cárdenas",
      "Lázaro Cárdenas"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "LMM",
    "translations": [
      "Valle del Fuerte International Airport",
      "Valle del Fuerte International Airport",
      "Valle del Fuerte International Airport"
    ],
    "city": [
      "Los Mochis",
      "Los Mochis",
      "Los Mochis"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "BJX",
    "translations": [
      "Del Bajío International Airport",
      "Del Bajío International Airport",
      "Del Bajío International Airport"
    ],
    "city": [
      "Silao",
      "Silao",
      "Silao"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "LAP",
    "translations": [
      "Manuel Márquez de León International Airport",
      "Manuel Márquez de León International Airport",
      "Manuel Márquez de León International Airport"
    ],
    "city": [
      "La Paz",
      "La Paz",
      "La Paz"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "LTO",
    "translations": [
      "Loreto International Airport",
      "Loreto International Airport",
      "Loreto International Airport"
    ],
    "city": [
      "Loreto",
      "Loreto",
      "Loreto"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "MAM",
    "translations": [
      "General Servando Canales International Airport",
      "General Servando Canales International Airport",
      "General Servando Canales International Airport"
    ],
    "city": [
      "Matamoros",
      "Matamoros",
      "Matamoros"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "MID",
    "translations": [
      "Manuel Crescencio Rejón International Airport",
      "Manuel Crescencio Rejón International Airport",
      "Manuel Crescencio Rejón International Airport"
    ],
    "city": [
      "Mérida",
      "Mérida",
      "Mérida"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "MUG",
    "translations": [
      "Mulege Airport",
      "Mulege Airport",
      "Mulege Airport"
    ],
    "city": [
      "Mulege",
      "Mulege",
      "Mulege"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "MXL",
    "translations": [
      "General Rodolfo Sánchez Taboada International Airport",
      "General Rodolfo Sánchez Taboada International Airport",
      "General Rodolfo Sánchez Taboada International Airport"
    ],
    "city": [
      "Mexicali",
      "Mexicali",
      "Mexicali"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "MLM",
    "translations": [
      "General Francisco J. Mujica International Airport",
      "General Francisco J. Mujica International Airport",
      "General Francisco J. Mujica International Airport"
    ],
    "city": [
      "Morelia",
      "Morelia",
      "Morelia"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "MTT",
    "translations": [
      "Minatitlán/Coatzacoalcos International Airport",
      "Minatitlán/Coatzacoalcos International Airport",
      "Minatitlán/Coatzacoalcos International Airport"
    ],
    "city": [
      "Cosoleacaque",
      "Cosoleacaque",
      "Cosoleacaque"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "LOV",
    "translations": [
      "Monclova International Airport",
      "Monclova International Airport",
      "Monclova International Airport"
    ],
    "city": [
      "Monclova",
      "Monclova",
      "Monclova"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "MEX",
    "translations": [
      "Benito Juárez International Airport",
      "Benito Juárez International Airport",
      "Benito Juárez International Airport"
    ],
    "city": [
      "Ciudad de México",
      "Ciudad de México",
      "Ciudad de México"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "MTY",
    "translations": [
      "Monterrey International Airport",
      "Monterrey International Airport",
      "Monterrey International Airport"
    ],
    "city": [
      "Monterrey",
      "Monterrey",
      "Monterrey"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "MZT",
    "translations": [
      "General Rafael Buelna International Airport",
      "General Rafael Buelna International Airport",
      "General Rafael Buelna International Airport"
    ],
    "city": [
      "Mazatlàn",
      "Mazatlàn",
      "Mazatlàn"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "NOG",
    "translations": [
      "Nogales International Airport",
      "Nogales International Airport",
      "Nogales International Airport"
    ],
    "city": [
      "Nogales",
      "Nogales",
      "Nogales"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "NLD",
    "translations": [
      "Quetzalcóatl International Airport",
      "Quetzalcóatl International Airport",
      "Quetzalcóatl International Airport"
    ],
    "city": [
      "Nuevo Laredo",
      "Nuevo Laredo",
      "Nuevo Laredo"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "OAX",
    "translations": [
      "Xoxocotlán International Airport",
      "Xoxocotlán International Airport",
      "Xoxocotlán International Airport"
    ],
    "city": [
      "Oaxaca",
      "Oaxaca",
      "Oaxaca"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "PAZ",
    "translations": [
      "El Tajín National Airport",
      "El Tajín National Airport",
      "El Tajín National Airport"
    ],
    "city": [
      "Poza Rica",
      "Poza Rica",
      "Poza Rica"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "PBC",
    "translations": [
      "Hermanos Serdán International Airport",
      "Hermanos Serdán International Airport",
      "Hermanos Serdán International Airport"
    ],
    "city": [
      "Puebla",
      "Puebla",
      "Puebla"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "PPE",
    "translations": [
      "Mar de Cortés International Airport",
      "Mar de Cortés International Airport",
      "Mar de Cortés International Airport"
    ],
    "city": [
      "Puerto Peñasco",
      "Puerto Peñasco",
      "Puerto Peñasco"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "PDS",
    "translations": [
      "Piedras Negras International Airport",
      "Piedras Negras International Airport",
      "Piedras Negras International Airport"
    ],
    "city": [
      "Piedras Negras",
      "Piedras Negras",
      "Piedras Negras"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "PCO",
    "translations": [
      "Punta Colorada Airport",
      "Punta Colorada Airport",
      "Punta Colorada Airport"
    ],
    "city": [
      "La Ribera",
      "La Ribera",
      "La Ribera"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "UPN",
    "translations": [
      "Uruapan - Licenciado y General Ignacio Lopez Rayon International Airport",
      "Uruapan - Licenciado y General Ignacio Lopez Rayon International Airport",
      "Uruapan - Licenciado y General Ignacio Lopez Rayon International Airport"
    ],
    "city": [
      "Uruapan",
      "Uruapan",
      "Uruapan"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "PQM",
    "translations": [
      "Palenque International Airport",
      "Palenque International Airport",
      "Palenque International Airport"
    ],
    "city": [
      "Palenque",
      "Palenque",
      "Palenque"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "PVR",
    "translations": [
      "Puerto Vallarta International Airport",
      "Puerto Vallarta International Airport",
      "Puerto Vallarta International Airport"
    ],
    "city": [
      "Puerto Vallarta",
      "Puerto Vallarta",
      "Puerto Vallarta"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "PXM",
    "translations": [
      "Puerto Escondido International Airport",
      "Puerto Escondido International Airport",
      "Puerto Escondido International Airport"
    ],
    "city": [
      "Puerto Escondido",
      "Puerto Escondido",
      "Puerto Escondido"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "QRO",
    "translations": [
      "Querétaro Intercontinental Airport",
      "Querétaro Intercontinental Airport",
      "Querétaro Intercontinental Airport"
    ],
    "city": [
      "Querétaro",
      "Querétaro",
      "Querétaro"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "REX",
    "translations": [
      "General Lucio Blanco International Airport",
      "General Lucio Blanco International Airport",
      "General Lucio Blanco International Airport"
    ],
    "city": [
      "Reynosa",
      "Reynosa",
      "Reynosa"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "SJD",
    "translations": [
      "Los Cabos International Airport",
      "Los Cabos International Airport",
      "Los Cabos International Airport"
    ],
    "city": [
      "San José del Cabo",
      "San José del Cabo",
      "San José del Cabo"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "SFH",
    "translations": [
      "San Felipe International Airport",
      "San Felipe International Airport",
      "San Felipe International Airport"
    ],
    "city": [
      "Mexicali",
      "Mexicali",
      "Mexicali"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "NLU",
    "translations": [
      "General Felipe Ángeles International Airport",
      "General Felipe Ángeles International Airport",
      "General Felipe Ángeles International Airport"
    ],
    "city": [
      "Mexico City",
      "Mexico City",
      "Mexico City"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "SLP",
    "translations": [
      "Ponciano Arriaga International Airport",
      "Ponciano Arriaga International Airport",
      "Ponciano Arriaga International Airport"
    ],
    "city": [
      "San Luis Potosí",
      "San Luis Potosí",
      "San Luis Potosí"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "SCX",
    "translations": [
      "Estación Aeronaval de Salina Cruz",
      "Estación Aeronaval de Salina Cruz",
      "Estación Aeronaval de Salina Cruz"
    ],
    "city": [
      "Salina Cruz",
      "Salina Cruz",
      "Salina Cruz"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "TRC",
    "translations": [
      "Francisco Sarabia Tinoco International Airport",
      "Francisco Sarabia Tinoco International Airport",
      "Francisco Sarabia Tinoco International Airport"
    ],
    "city": [
      "Torreón",
      "Torreón",
      "Torreón"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "TGZ",
    "translations": [
      "Angel Albino Corzo International Airport",
      "Angel Albino Corzo International Airport",
      "Angel Albino Corzo International Airport"
    ],
    "city": [
      "Tuxtla Gutiérrez",
      "Tuxtla Gutiérrez",
      "Tuxtla Gutiérrez"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "TIJ",
    "translations": [
      "General Abelardo L. Rodriguez International Airport",
      "General Abelardo L. Rodriguez International Airport",
      "General Abelardo L. Rodriguez International Airport"
    ],
    "city": [
      "Tijuana",
      "Tijuana",
      "Tijuana"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "TQO",
    "translations": [
      "Felipe Carrillo Puerto International Airport",
      "Felipe Carrillo Puerto International Airport",
      "Felipe Carrillo Puerto International Airport"
    ],
    "city": [
      "Tulum",
      "Tulum",
      "Tulum"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "TAM",
    "translations": [
      "General Francisco Javier Mina International Airport",
      "General Francisco Javier Mina International Airport",
      "General Francisco Javier Mina International Airport"
    ],
    "city": [
      "Tampico",
      "Tampico",
      "Tampico"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "TSL",
    "translations": [
      "Tamuín National Airport",
      "Tamuín National Airport",
      "Tamuín National Airport"
    ],
    "city": [
      "Tamuín",
      "Tamuín",
      "Tamuín"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "TLC",
    "translations": [
      "Adolfo López Mateos International Airport",
      "Adolfo López Mateos International Airport",
      "Adolfo López Mateos International Airport"
    ],
    "city": [
      "Toluca",
      "Toluca",
      "Toluca"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "TAP",
    "translations": [
      "Tapachula International Airport",
      "Tapachula International Airport",
      "Tapachula International Airport"
    ],
    "city": [
      "Tapachula",
      "Tapachula",
      "Tapachula"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "TUY",
    "translations": [
      "Base Aeronaval de Tulum",
      "Base Aeronaval de Tulum",
      "Base Aeronaval de Tulum"
    ],
    "city": [
      "Tulum",
      "Tulum",
      "Tulum"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "CUN",
    "translations": [
      "Cancún International Airport",
      "Cancún International Airport",
      "Cancún International Airport"
    ],
    "city": [
      "Cancún",
      "Cancún",
      "Cancún"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "MMV",
    "translations": [
      "Mal Airport",
      "Mal Airport",
      "Mal Airport"
    ],
    "city": [
      "Mal Island",
      "Mal Island",
      "Mal Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "VSA",
    "translations": [
      "Carlos Rovirosa Pérez International Airport",
      "Carlos Rovirosa Pérez International Airport",
      "Carlos Rovirosa Pérez International Airport"
    ],
    "city": [
      "Villahermosa",
      "Villahermosa",
      "Villahermosa"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "VER",
    "translations": [
      "General Heriberto Jara International Airport",
      "General Heriberto Jara International Airport",
      "General Heriberto Jara International Airport"
    ],
    "city": [
      "Veracruz",
      "Veracruz",
      "Veracruz"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "ZCL",
    "translations": [
      "General Leobardo C. Ruiz International Airport",
      "General Leobardo C. Ruiz International Airport",
      "General Leobardo C. Ruiz International Airport"
    ],
    "city": [
      "Zacatecas",
      "Zacatecas",
      "Zacatecas"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "ZIH",
    "translations": [
      "Ixtapa-Zihuatanejo International Airport",
      "Ixtapa-Zihuatanejo International Airport",
      "Ixtapa-Zihuatanejo International Airport"
    ],
    "city": [
      "Ixtapa",
      "Ixtapa",
      "Ixtapa"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "ZMM",
    "translations": [
      "Zamora Airport",
      "Zamora Airport",
      "Zamora Airport"
    ],
    "city": [
      "Zamora",
      "Zamora",
      "Zamora"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "ZLO",
    "translations": [
      "Playa de Oro International Airport",
      "Playa de Oro International Airport",
      "Playa de Oro International Airport"
    ],
    "city": [
      "Manzanillo",
      "Manzanillo",
      "Manzanillo"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "BEF",
    "translations": [
      "Bluefields Airport",
      "Bluefields Airport",
      "Bluefields Airport"
    ],
    "city": [
      "Bluefileds",
      "Bluefileds",
      "Bluefileds"
    ],
    "country": [
      "NI",
      "NI",
      "NI"
    ]
  },
  {
    "iata": "BZA",
    "translations": [
      "San Pedro Airport",
      "San Pedro Airport",
      "San Pedro Airport"
    ],
    "city": [
      "Bonanza",
      "Bonanza",
      "Bonanza"
    ],
    "country": [
      "NI",
      "NI",
      "NI"
    ]
  },
  {
    "iata": "ECI",
    "translations": [
      "Costa Esmeralda Airport",
      "Costa Esmeralda Airport",
      "Costa Esmeralda Airport"
    ],
    "city": [
      "Tola",
      "Tola",
      "Tola"
    ],
    "country": [
      "NI",
      "NI",
      "NI"
    ]
  },
  {
    "iata": "RNI",
    "translations": [
      "Corn Island Airport",
      "Corn Island Airport",
      "Corn Island Airport"
    ],
    "city": [
      "Corn Island",
      "Corn Island",
      "Corn Island"
    ],
    "country": [
      "NI",
      "NI",
      "NI"
    ]
  },
  {
    "iata": "MGA",
    "translations": [
      "Augusto C. Sandino (Managua) International Airport",
      "Augusto C. Sandino (Managua) International Airport",
      "Augusto C. Sandino (Managua) International Airport"
    ],
    "city": [
      "Managua",
      "Managua",
      "Managua"
    ],
    "country": [
      "NI",
      "NI",
      "NI"
    ]
  },
  {
    "iata": "MNP",
    "translations": [
      "Maron Island Airport",
      "Maron Island Airport",
      "Maron Island Airport"
    ],
    "city": [
      "Hermit Islands",
      "Hermit Islands",
      "Hermit Islands"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PUZ",
    "translations": [
      "Puerto Cabezas Airport",
      "Puerto Cabezas Airport",
      "Puerto Cabezas Airport"
    ],
    "city": [
      "Puerto Cabezas",
      "Puerto Cabezas",
      "Puerto Cabezas"
    ],
    "country": [
      "NI",
      "NI",
      "NI"
    ]
  },
  {
    "iata": "RFS",
    "translations": [
      "Rosita Airport",
      "Rosita Airport",
      "Rosita Airport"
    ],
    "city": [
      "La Rosita",
      "La Rosita",
      "La Rosita"
    ],
    "country": [
      "NI",
      "NI",
      "NI"
    ]
  },
  {
    "iata": "NCR",
    "translations": [
      "San Carlos Airport",
      "San Carlos Airport",
      "San Carlos Airport"
    ],
    "city": [
      "San Carlos",
      "San Carlos",
      "San Carlos"
    ],
    "country": [
      "NI",
      "NI",
      "NI"
    ]
  },
  {
    "iata": "SIU",
    "translations": [
      "Siuna",
      "Siuna",
      "Siuna"
    ],
    "city": [
      "Siuna",
      "Siuna",
      "Siuna"
    ],
    "country": [
      "NI",
      "NI",
      "NI"
    ]
  },
  {
    "iata": "WSP",
    "translations": [
      "Waspam Airport",
      "Waspam Airport",
      "Waspam Airport"
    ],
    "city": [
      "Waspam",
      "Waspam",
      "Waspam"
    ],
    "country": [
      "NI",
      "NI",
      "NI"
    ]
  },
  {
    "iata": "MOH",
    "translations": [
      "Maleo Airport",
      "Maleo Airport",
      "Maleo Airport"
    ],
    "city": [
      "Morowali",
      "Morowali",
      "Morowali"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MOS",
    "translations": [
      "Moses Point Airport",
      "Moses Point Airport",
      "Moses Point Airport"
    ],
    "city": [
      "Elim",
      "Elim",
      "Elim"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BOC",
    "translations": [
      "Bocas del Toro International Airport",
      "Bocas del Toro International Airport",
      "Bocas del Toro International Airport"
    ],
    "city": [
      "Isla Colón",
      "Isla Colón",
      "Isla Colón"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "CTD",
    "translations": [
      "Alonso Valderrama Airport",
      "Alonso Valderrama Airport",
      "Alonso Valderrama Airport"
    ],
    "city": [
      "Chitré",
      "Chitré",
      "Chitré"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "CHX",
    "translations": [
      "Changuinola Captain Manuel Niño International Airport",
      "Changuinola Captain Manuel Niño International Airport",
      "Changuinola Captain Manuel Niño International Airport"
    ],
    "city": [
      "Changuinola",
      "Changuinola",
      "Changuinola"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "DAV",
    "translations": [
      "Enrique Malek International Airport",
      "Enrique Malek International Airport",
      "Enrique Malek International Airport"
    ],
    "city": [
      "David",
      "David",
      "David"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "ONX",
    "translations": [
      "Enrique Adolfo Jimenez Airport",
      "Enrique Adolfo Jimenez Airport",
      "Enrique Adolfo Jimenez Airport"
    ],
    "city": [
      "Colón",
      "Colón",
      "Colón"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "BLB",
    "translations": [
      "Panamá Pacífico International Airport",
      "Panamá Pacífico International Airport",
      "Panamá Pacífico International Airport"
    ],
    "city": [
      "Panamá City",
      "Panamá City",
      "Panamá City"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "MPI",
    "translations": [
      "Mamitupu Airport",
      "Mamitupu Airport",
      "Mamitupu Airport"
    ],
    "city": [
      "Mamitupu",
      "Mamitupu",
      "Mamitupu"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "JQE",
    "translations": [
      "Jaqué Airport",
      "Jaqué Airport",
      "Jaqué Airport"
    ],
    "city": [
      "Jaqué",
      "Jaqué",
      "Jaqué"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "PAC",
    "translations": [
      "Marcos A. Gelabert International Airport",
      "Marcos A. Gelabert International Airport",
      "Marcos A. Gelabert International Airport"
    ],
    "city": [
      "Albrook",
      "Albrook",
      "Albrook"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "PUE",
    "translations": [
      "Puerto Obaldía Airport",
      "Puerto Obaldía Airport",
      "Puerto Obaldía Airport"
    ],
    "city": [
      "Puerto Obaldía",
      "Puerto Obaldía",
      "Puerto Obaldía"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "PDM",
    "translations": [
      "Capt. J. Montenegro Airport",
      "Capt. J. Montenegro Airport",
      "Capt. J. Montenegro Airport"
    ],
    "city": [
      "Pedasí",
      "Pedasí",
      "Pedasí"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "SYP",
    "translations": [
      "Ruben Cantu Airport",
      "Ruben Cantu Airport",
      "Ruben Cantu Airport"
    ],
    "city": [
      "Santiago",
      "Santiago",
      "Santiago"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "RIH",
    "translations": [
      "Scarlett Martinez International Airport",
      "Scarlett Martinez International Airport",
      "Scarlett Martinez International Airport"
    ],
    "city": [
      "Río Hato",
      "Río Hato",
      "Río Hato"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "PTY",
    "translations": [
      "Tocumen International Airport",
      "Tocumen International Airport",
      "Tocumen International Airport"
    ],
    "city": [
      "Tocumen",
      "Tocumen",
      "Tocumen"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "PVE",
    "translations": [
      "El Porvenir Airport",
      "El Porvenir Airport",
      "El Porvenir Airport"
    ],
    "city": [
      "El Porvenir",
      "El Porvenir",
      "El Porvenir"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "NBL",
    "translations": [
      "Wannukandi Airport",
      "Wannukandi Airport",
      "Wannukandi Airport"
    ],
    "city": [
      "San Blas",
      "San Blas",
      "San Blas"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "FON",
    "translations": [
      "La Fortuna Arenal Airport",
      "La Fortuna Arenal Airport",
      "La Fortuna Arenal Airport"
    ],
    "city": [
      "La Fortuna",
      "La Fortuna",
      "La Fortuna"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "BAI",
    "translations": [
      "Buenos Aires Airport",
      "Buenos Aires Airport",
      "Buenos Aires Airport"
    ],
    "city": [
      "Punta Arenas",
      "Punta Arenas",
      "Punta Arenas"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "BCL",
    "translations": [
      "Barra del Colorado Airport",
      "Barra del Colorado Airport",
      "Barra del Colorado Airport"
    ],
    "city": [
      "Pococi",
      "Pococi",
      "Pococi"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "TTQ",
    "translations": [
      "Barra del Tortuguero",
      "Barra del Tortuguero",
      "Barra del Tortuguero"
    ],
    "city": [
      "Tortuguero",
      "Tortuguero",
      "Tortuguero"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "OTR",
    "translations": [
      "Coto 47 Airport",
      "Coto 47 Airport",
      "Coto 47 Airport"
    ],
    "city": [
      "Corredores",
      "Corredores",
      "Corredores"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "JAP",
    "translations": [
      "Chacarita Airport",
      "Chacarita Airport",
      "Chacarita Airport"
    ],
    "city": [
      "Puntarenas",
      "Puntarenas",
      "Puntarenas"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "PLD",
    "translations": [
      "Playa Samara/Carrillo Airport",
      "Playa Samara/Carrillo Airport",
      "Playa Samara/Carrillo Airport"
    ],
    "city": [
      "Carrillo",
      "Carrillo",
      "Carrillo"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "DRK",
    "translations": [
      "Drake Bay Airport",
      "Drake Bay Airport",
      "Drake Bay Airport"
    ],
    "city": [
      "Puntarenas",
      "Puntarenas",
      "Puntarenas"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "FMG",
    "translations": [
      "Flamingo Airport",
      "Flamingo Airport",
      "Flamingo Airport"
    ],
    "city": [
      "Brasilito",
      "Brasilito",
      "Brasilito"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "GLF",
    "translations": [
      "Golfito Airport",
      "Golfito Airport",
      "Golfito Airport"
    ],
    "city": [
      "Golfito",
      "Golfito",
      "Golfito"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "GPL",
    "translations": [
      "Guapiles Airport",
      "Guapiles Airport",
      "Guapiles Airport"
    ],
    "city": [
      "Pococi",
      "Pococi",
      "Pococi"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "PBP",
    "translations": [
      "Islita Airport",
      "Islita Airport",
      "Islita Airport"
    ],
    "city": [
      "Nandayure",
      "Nandayure",
      "Nandayure"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "LIR",
    "translations": [
      "Guanacaste Airport",
      "Guanacaste Airport",
      "Guanacaste Airport"
    ],
    "city": [
      "Liberia",
      "Liberia",
      "Liberia"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "LSL",
    "translations": [
      "Los Chiles Airport",
      "Los Chiles Airport",
      "Los Chiles Airport"
    ],
    "city": [
      "Los Chiles",
      "Los Chiles",
      "Los Chiles"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "LIO",
    "translations": [
      "Limon International Airport",
      "Limon International Airport",
      "Limon International Airport"
    ],
    "city": [
      "Puerto Limon",
      "Puerto Limon",
      "Puerto Limon"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "CSC",
    "translations": [
      "Mojica Airport",
      "Mojica Airport",
      "Mojica Airport"
    ],
    "city": [
      "Cañas",
      "Cañas",
      "Cañas"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "NCT",
    "translations": [
      "Guanacaste Airport",
      "Guanacaste Airport",
      "Guanacaste Airport"
    ],
    "city": [
      "Nicoya/Guanacate",
      "Nicoya/Guanacate",
      "Nicoya/Guanacate"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "NOB",
    "translations": [
      "Nosara Airport",
      "Nosara Airport",
      "Nosara Airport"
    ],
    "city": [
      "Nicoya",
      "Nicoya",
      "Nicoya"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "SJO",
    "translations": [
      "Juan Santamaría International Airport",
      "Juan Santamaría International Airport",
      "Juan Santamaría International Airport"
    ],
    "city": [
      "San José (Alajuela)",
      "San José (Alajuela)",
      "San José (Alajuela)"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "PJM",
    "translations": [
      "Puerto Jimenez Airport",
      "Puerto Jimenez Airport",
      "Puerto Jimenez Airport"
    ],
    "city": [
      "Puerto Jimenez",
      "Puerto Jimenez",
      "Puerto Jimenez"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "PMZ",
    "translations": [
      "Palmar Sur Airport",
      "Palmar Sur Airport",
      "Palmar Sur Airport"
    ],
    "city": [
      "Palmar Sur",
      "Palmar Sur",
      "Palmar Sur"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "SYQ",
    "translations": [
      "Tobías Bolaños International Airport",
      "Tobías Bolaños International Airport",
      "Tobías Bolaños International Airport"
    ],
    "city": [
      "San Jose",
      "San Jose",
      "San Jose"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "XQP",
    "translations": [
      "Quepos Managua Airport",
      "Quepos Managua Airport",
      "Quepos Managua Airport"
    ],
    "city": [
      "Quepos",
      "Quepos",
      "Quepos"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "RFR",
    "translations": [
      "Rio Frio / Progreso Airport",
      "Rio Frio / Progreso Airport",
      "Rio Frio / Progreso Airport"
    ],
    "city": [
      "Rio Frio / Progreso",
      "Rio Frio / Progreso",
      "Rio Frio / Progreso"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "IPZ",
    "translations": [
      "San Isidro del General Airport",
      "San Isidro del General Airport",
      "San Isidro del General Airport"
    ],
    "city": [
      "Pérez Zeledón",
      "Pérez Zeledón",
      "Pérez Zeledón"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "TOO",
    "translations": [
      "San Vito de Java Airport",
      "San Vito de Java Airport",
      "San Vito de Java Airport"
    ],
    "city": [
      "Coto Brus",
      "Coto Brus",
      "Coto Brus"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "MRT",
    "translations": [
      "Moroak Airport",
      "Moroak Airport",
      "Moroak Airport"
    ],
    "city": [
      "Moroak",
      "Moroak",
      "Moroak"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TNO",
    "translations": [
      "Tamarindo Airport",
      "Tamarindo Airport",
      "Tamarindo Airport"
    ],
    "city": [
      "Tamarindo",
      "Tamarindo",
      "Tamarindo"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "TMU",
    "translations": [
      "Tambor Airport",
      "Tambor Airport",
      "Tambor Airport"
    ],
    "city": [
      "Nicoya",
      "Nicoya",
      "Nicoya"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "UPL",
    "translations": [
      "Upala Airport",
      "Upala Airport",
      "Upala Airport"
    ],
    "city": [
      "Upala",
      "Upala",
      "Upala"
    ],
    "country": [
      "CR",
      "CR",
      "CR"
    ]
  },
  {
    "iata": "MSB",
    "translations": [
      "Marigot Seaplane Base",
      "Marigot Seaplane Base",
      "Marigot Seaplane Base"
    ],
    "city": [
      "Saint Martin",
      "Saint Martin",
      "Saint Martin"
    ],
    "country": [
      "MF",
      "MF",
      "MF"
    ]
  },
  {
    "iata": "SAL",
    "translations": [
      "Monseñor Óscar Arnulfo Romero International Airport",
      "Monseñor Óscar Arnulfo Romero International Airport",
      "Monseñor Óscar Arnulfo Romero International Airport"
    ],
    "city": [
      "San Salvador (San Luis Talpa)",
      "San Salvador (San Luis Talpa)",
      "San Salvador (San Luis Talpa)"
    ],
    "country": [
      "SV",
      "SV",
      "SV"
    ]
  },
  {
    "iata": "ILS",
    "translations": [
      "Ilopango International Airport",
      "Ilopango International Airport",
      "Ilopango International Airport"
    ],
    "city": [
      "San Salvador",
      "San Salvador",
      "San Salvador"
    ],
    "country": [
      "SV",
      "SV",
      "SV"
    ]
  },
  {
    "iata": "CYA",
    "translations": [
      "Antoine-Simon International Airport",
      "Antoine-Simon International Airport",
      "Antoine-Simon International Airport"
    ],
    "city": [
      "Les Cayes",
      "Les Cayes",
      "Les Cayes"
    ],
    "country": [
      "HT",
      "HT",
      "HT"
    ]
  },
  {
    "iata": "CAP",
    "translations": [
      "Cap Haitien International Airport",
      "Cap Haitien International Airport",
      "Cap Haitien International Airport"
    ],
    "city": [
      "Cap Haitien",
      "Cap Haitien",
      "Cap Haitien"
    ],
    "country": [
      "HT",
      "HT",
      "HT"
    ]
  },
  {
    "iata": "MTX",
    "translations": [
      "Metro Field",
      "Metro Field",
      "Metro Field"
    ],
    "city": [
      "Fairbanks",
      "Fairbanks",
      "Fairbanks"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JAK",
    "translations": [
      "Jacmel Airport",
      "Jacmel Airport",
      "Jacmel Airport"
    ],
    "city": [
      "Jacmel",
      "Jacmel",
      "Jacmel"
    ],
    "country": [
      "HT",
      "HT",
      "HT"
    ]
  },
  {
    "iata": "JEE",
    "translations": [
      "Jérémie Airport",
      "Jérémie Airport",
      "Jérémie Airport"
    ],
    "city": [
      "Carrefour Sanon",
      "Carrefour Sanon",
      "Carrefour Sanon"
    ],
    "country": [
      "HT",
      "HT",
      "HT"
    ]
  },
  {
    "iata": "PAP",
    "translations": [
      "Toussaint Louverture International Airport",
      "Toussaint Louverture International Airport",
      "Toussaint Louverture International Airport"
    ],
    "city": [
      "Port-au-Prince",
      "Port-au-Prince",
      "Port-au-Prince"
    ],
    "country": [
      "HT",
      "HT",
      "HT"
    ]
  },
  {
    "iata": "PAX",
    "translations": [
      "Port-de-Paix Airport",
      "Port-de-Paix Airport",
      "Port-de-Paix Airport"
    ],
    "city": [
      "Port-de-Paix",
      "Port-de-Paix",
      "Port-de-Paix"
    ],
    "country": [
      "HT",
      "HT",
      "HT"
    ]
  },
  {
    "iata": "MTU",
    "translations": [
      "Montepuez Airport",
      "Montepuez Airport",
      "Montepuez Airport"
    ],
    "city": [
      "Montepuez",
      "Montepuez",
      "Montepuez"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "AHG",
    "translations": [
      "Agalega Island Airstrip",
      "Agalega Island Airstrip",
      "Agalega Island Airstrip"
    ],
    "city": [
      "Vingt Cinq",
      "Vingt Cinq",
      "Vingt Cinq"
    ],
    "country": [
      "MU",
      "MU",
      "MU"
    ]
  },
  {
    "iata": "BCA",
    "translations": [
      "Gustavo Rizo Airport",
      "Gustavo Rizo Airport",
      "Gustavo Rizo Airport"
    ],
    "city": [
      "Baracoa",
      "Baracoa",
      "Baracoa"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "BWW",
    "translations": [
      "Las Brujas Airport",
      "Las Brujas Airport",
      "Las Brujas Airport"
    ],
    "city": [
      "Cayo Santa Maria",
      "Cayo Santa Maria",
      "Cayo Santa Maria"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "BYM",
    "translations": [
      "Carlos Manuel de Cespedes Airport",
      "Carlos Manuel de Cespedes Airport",
      "Carlos Manuel de Cespedes Airport"
    ],
    "city": [
      "Bayamo",
      "Bayamo",
      "Bayamo"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "AVI",
    "translations": [
      "Máximo Gómez Airport",
      "Máximo Gómez Airport",
      "Máximo Gómez Airport"
    ],
    "city": [
      "Ciro Redondo",
      "Ciro Redondo",
      "Ciro Redondo"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "CCC",
    "translations": [
      "Jardines Del Rey Airport",
      "Jardines Del Rey Airport",
      "Jardines Del Rey Airport"
    ],
    "city": [
      "Cayo Coco",
      "Cayo Coco",
      "Cayo Coco"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "CFG",
    "translations": [
      "Jaime Gonzalez Airport",
      "Jaime Gonzalez Airport",
      "Jaime Gonzalez Airport"
    ],
    "city": [
      "Cienfuegos",
      "Cienfuegos",
      "Cienfuegos"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "CYO",
    "translations": [
      "Vilo Acuña International Airport",
      "Vilo Acuña International Airport",
      "Vilo Acuña International Airport"
    ],
    "city": [
      "Cayo Largo del Sur",
      "Cayo Largo del Sur",
      "Cayo Largo del Sur"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "CMW",
    "translations": [
      "Ignacio Agramonte International Airport",
      "Ignacio Agramonte International Airport",
      "Ignacio Agramonte International Airport"
    ],
    "city": [
      "Camaguey",
      "Camaguey",
      "Camaguey"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "SCU",
    "translations": [
      "Antonio Maceo International Airport",
      "Antonio Maceo International Airport",
      "Antonio Maceo International Airport"
    ],
    "city": [
      "Santiago",
      "Santiago",
      "Santiago"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "NBW",
    "translations": [
      "Leeward Point Field",
      "Leeward Point Field",
      "Leeward Point Field"
    ],
    "city": [
      "Guantanamo Bay Naval Station",
      "Guantanamo Bay Naval Station",
      "Guantanamo Bay Naval Station"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "GAO",
    "translations": [
      "Mariana Grajales Airport",
      "Mariana Grajales Airport",
      "Mariana Grajales Airport"
    ],
    "city": [
      "Guantánamo",
      "Guantánamo",
      "Guantánamo"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "HAV",
    "translations": [
      "José Martí International Airport",
      "José Martí International Airport",
      "José Martí International Airport"
    ],
    "city": [
      "Havana",
      "Havana",
      "Havana"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "HOG",
    "translations": [
      "Frank Pais International Airport",
      "Frank Pais International Airport",
      "Frank Pais International Airport"
    ],
    "city": [
      "Holguin",
      "Holguin",
      "Holguin"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "VRO",
    "translations": [
      "Kawama Airport",
      "Kawama Airport",
      "Kawama Airport"
    ],
    "city": [
      "Santa Marta",
      "Santa Marta",
      "Santa Marta"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "LCL",
    "translations": [
      "La Coloma Airport",
      "La Coloma Airport",
      "La Coloma Airport"
    ],
    "city": [
      "Pinar del Rio",
      "Pinar del Rio",
      "Pinar del Rio"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "UMA",
    "translations": [
      "Alfredo Noa Díaz Airport",
      "Alfredo Noa Díaz Airport",
      "Alfredo Noa Díaz Airport"
    ],
    "city": [
      "Maisí",
      "Maisí",
      "Maisí"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "MJG",
    "translations": [
      "Mayajigua Airport",
      "Mayajigua Airport",
      "Mayajigua Airport"
    ],
    "city": [
      "Mayajigua",
      "Mayajigua",
      "Mayajigua"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "MOA",
    "translations": [
      "Orestes Acosta Airport",
      "Orestes Acosta Airport",
      "Orestes Acosta Airport"
    ],
    "city": [
      "Moa",
      "Moa",
      "Moa"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "MZO",
    "translations": [
      "Sierra Maestra International Airport",
      "Sierra Maestra International Airport",
      "Sierra Maestra International Airport"
    ],
    "city": [
      "Manzanillo",
      "Manzanillo",
      "Manzanillo"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "GER",
    "translations": [
      "Rafael Cabrera Airport",
      "Rafael Cabrera Airport",
      "Rafael Cabrera Airport"
    ],
    "city": [
      "Nueva Gerona",
      "Nueva Gerona",
      "Nueva Gerona"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "UPB",
    "translations": [
      "Playa Baracoa Airport",
      "Playa Baracoa Airport",
      "Playa Baracoa Airport"
    ],
    "city": [
      "Havana",
      "Havana",
      "Havana"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "SNU",
    "translations": [
      "Abel Santamaria Airport",
      "Abel Santamaria Airport",
      "Abel Santamaria Airport"
    ],
    "city": [
      "Santa Clara",
      "Santa Clara",
      "Santa Clara"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "SNJ",
    "translations": [
      "San Julián Air Base",
      "San Julián Air Base",
      "San Julián Air Base"
    ],
    "city": [
      "Sandino",
      "Sandino",
      "Sandino"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "SZJ",
    "translations": [
      "Siguanea Airport",
      "Siguanea Airport",
      "Siguanea Airport"
    ],
    "city": [
      "Isla de la Juventud",
      "Isla de la Juventud",
      "Isla de la Juventud"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "USS",
    "translations": [
      "Sancti Spiritus Airport",
      "Sancti Spiritus Airport",
      "Sancti Spiritus Airport"
    ],
    "city": [
      "Sancti Spiritus",
      "Sancti Spiritus",
      "Sancti Spiritus"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "TND",
    "translations": [
      "Alberto Delgado Airport",
      "Alberto Delgado Airport",
      "Alberto Delgado Airport"
    ],
    "city": [
      "Trinidad",
      "Trinidad",
      "Trinidad"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "VRA",
    "translations": [
      "Juan Gualberto Gomez International Airport",
      "Juan Gualberto Gomez International Airport",
      "Juan Gualberto Gomez International Airport"
    ],
    "city": [
      "Matanzas",
      "Matanzas",
      "Matanzas"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "VTU",
    "translations": [
      "Hermanos Ameijeiras Airport",
      "Hermanos Ameijeiras Airport",
      "Hermanos Ameijeiras Airport"
    ],
    "city": [
      "Las Tunas",
      "Las Tunas",
      "Las Tunas"
    ],
    "country": [
      "CU",
      "CU",
      "CU"
    ]
  },
  {
    "iata": "FMT",
    "translations": [
      "Faresmaathoda Airport",
      "Faresmaathoda Airport",
      "Faresmaathoda Airport"
    ],
    "city": [
      "Faresmaathodaa",
      "Faresmaathodaa",
      "Faresmaathodaa"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "MUM",
    "translations": [
      "Muli Airport",
      "Muli Airport",
      "Muli Airport"
    ],
    "city": [
      "Muli",
      "Muli",
      "Muli"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "CYB",
    "translations": [
      "Charles Kirkconnell International Airport",
      "Charles Kirkconnell International Airport",
      "Charles Kirkconnell International Airport"
    ],
    "city": [
      "West End",
      "West End",
      "West End"
    ],
    "country": [
      "KY",
      "KY",
      "KY"
    ]
  },
  {
    "iata": "LYB",
    "translations": [
      "Edward Bodden Little Cayman Airfield",
      "Edward Bodden Little Cayman Airfield",
      "Edward Bodden Little Cayman Airfield"
    ],
    "city": [
      "Blossom Village",
      "Blossom Village",
      "Blossom Village"
    ],
    "country": [
      "KY",
      "KY",
      "KY"
    ]
  },
  {
    "iata": "GCM",
    "translations": [
      "Owen Roberts International Airport",
      "Owen Roberts International Airport",
      "Owen Roberts International Airport"
    ],
    "city": [
      "George Town",
      "George Town",
      "George Town"
    ],
    "country": [
      "KY",
      "KY",
      "KY"
    ]
  },
  {
    "iata": "MWR",
    "translations": [
      "Motswari Airport",
      "Motswari Airport",
      "Motswari Airport"
    ],
    "city": [
      "Motswari Private Game Reserve",
      "Motswari Private Game Reserve",
      "Motswari Private Game Reserve"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "MWU",
    "translations": [
      "Mussau Airport",
      "Mussau Airport",
      "Mussau Airport"
    ],
    "city": [
      "Mussau Island",
      "Mussau Island",
      "Mussau Island"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AJS",
    "translations": [
      "Punta Abreojos Airport",
      "Punta Abreojos Airport",
      "Punta Abreojos Airport"
    ],
    "city": [
      "Mulegé",
      "Mulegé",
      "Mulegé"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "AZG",
    "translations": [
      "Apatzingán - Pablo L. Sidar Airport",
      "Apatzingán - Pablo L. Sidar Airport",
      "Apatzingán - Pablo L. Sidar Airport"
    ],
    "city": [
      "Apatzingán",
      "Apatzingán",
      "Apatzingán"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "PCM",
    "translations": [
      "Playa del Carmen National Airport",
      "Playa del Carmen National Airport",
      "Playa del Carmen National Airport"
    ],
    "city": [
      "Playa del Carmen",
      "Playa del Carmen",
      "Playa del Carmen"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "PCV",
    "translations": [
      "Punta Chivato Airport",
      "Punta Chivato Airport",
      "Punta Chivato Airport"
    ],
    "city": [
      "Mulegé",
      "Mulegé",
      "Mulegé"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "SGM",
    "translations": [
      "San Ignacio Airport",
      "San Ignacio Airport",
      "San Ignacio Airport"
    ],
    "city": [
      "Mulegé",
      "Mulegé",
      "Mulegé"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "UAC",
    "translations": [
      "San Luis Río Colorado Airport",
      "San Luis Río Colorado Airport",
      "San Luis Río Colorado Airport"
    ],
    "city": [
      "San Luis Río Colorado",
      "San Luis Río Colorado",
      "San Luis Río Colorado"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "XAL",
    "translations": [
      "Álamos Airport",
      "Álamos Airport",
      "Álamos Airport"
    ],
    "city": [
      "Álamos",
      "Álamos",
      "Álamos"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "MXC",
    "translations": [
      "Monticello Airport",
      "Monticello Airport",
      "Monticello Airport"
    ],
    "city": [
      "Monticello",
      "Monticello",
      "Monticello"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GTK",
    "translations": [
      "Sungai Tekai Airport",
      "Sungai Tekai Airport",
      "Sungai Tekai Airport"
    ],
    "city": [
      "Sungai Tekai",
      "Sungai Tekai",
      "Sungai Tekai"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "LBP",
    "translations": [
      "Long Banga Airport",
      "Long Banga Airport",
      "Long Banga Airport"
    ],
    "city": [
      "Long Banga",
      "Long Banga",
      "Long Banga"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "SPT",
    "translations": [
      "Sipitang Airport",
      "Sipitang Airport",
      "Sipitang Airport"
    ],
    "city": [
      "Sipitang",
      "Sipitang",
      "Sipitang"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "MAY",
    "translations": [
      "Clarence A. Bain Airport",
      "Clarence A. Bain Airport",
      "Clarence A. Bain Airport"
    ],
    "city": [
      "Mangrove Cay",
      "Mangrove Cay",
      "Mangrove Cay"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "ASD",
    "translations": [
      "Andros Town Airport",
      "Andros Town Airport",
      "Andros Town Airport"
    ],
    "city": [
      "Andros Town",
      "Andros Town",
      "Andros Town"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "TZN",
    "translations": [
      "Congo Town Airport",
      "Congo Town Airport",
      "Congo Town Airport"
    ],
    "city": [
      "Andros",
      "Andros",
      "Andros"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "MHH",
    "translations": [
      "Leonard M Thompson International Airport",
      "Leonard M Thompson International Airport",
      "Leonard M Thompson International Airport"
    ],
    "city": [
      "Marsh Harbour",
      "Marsh Harbour",
      "Marsh Harbour"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "SAQ",
    "translations": [
      "San Andros Airport",
      "San Andros Airport",
      "San Andros Airport"
    ],
    "city": [
      "Andros Island",
      "Andros Island",
      "Andros Island"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "AXP",
    "translations": [
      "Spring Point Airport",
      "Spring Point Airport",
      "Spring Point Airport"
    ],
    "city": [
      "Spring Point",
      "Spring Point",
      "Spring Point"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "TCB",
    "translations": [
      "Treasure Cay Airport",
      "Treasure Cay Airport",
      "Treasure Cay Airport"
    ],
    "city": [
      "Treasure Cay",
      "Treasure Cay",
      "Treasure Cay"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "WKR",
    "translations": [
      "Walkers Cay Airport",
      "Walkers Cay Airport",
      "Walkers Cay Airport"
    ],
    "city": [
      "Walkers Cay",
      "Walkers Cay",
      "Walkers Cay"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "CCZ",
    "translations": [
      "Chub Cay Airport",
      "Chub Cay Airport",
      "Chub Cay Airport"
    ],
    "city": [
      "Chub Cay",
      "Chub Cay",
      "Chub Cay"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "GHC",
    "translations": [
      "Great Harbour Cay Airport",
      "Great Harbour Cay Airport",
      "Great Harbour Cay Airport"
    ],
    "city": [
      "Bullocks Harbour",
      "Bullocks Harbour",
      "Bullocks Harbour"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "BIM",
    "translations": [
      "South Bimini Airport",
      "South Bimini Airport",
      "South Bimini Airport"
    ],
    "city": [
      "South Bimini",
      "South Bimini",
      "South Bimini"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "ATC",
    "translations": [
      "Arthur's Town Airport",
      "Arthur's Town Airport",
      "Arthur's Town Airport"
    ],
    "city": [
      "Arthur's Town",
      "Arthur's Town",
      "Arthur's Town"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "TBI",
    "translations": [
      "New Bight Airport",
      "New Bight Airport",
      "New Bight Airport"
    ],
    "city": [
      "Cat Island",
      "Cat Island",
      "Cat Island"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "CXY",
    "translations": [
      "Cat Cay Airport",
      "Cat Cay Airport",
      "Cat Cay Airport"
    ],
    "city": [
      "North Cat Cay",
      "North Cat Cay",
      "North Cat Cay"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "CRI",
    "translations": [
      "Colonel Hill Airport",
      "Colonel Hill Airport",
      "Colonel Hill Airport"
    ],
    "city": [
      "Colonel Hill",
      "Colonel Hill",
      "Colonel Hill"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "PWN",
    "translations": [
      "Pitts Town Airport",
      "Pitts Town Airport",
      "Pitts Town Airport"
    ],
    "city": [
      "Pitts Town",
      "Pitts Town",
      "Pitts Town"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "GGT",
    "translations": [
      "Exuma International Airport",
      "Exuma International Airport",
      "Exuma International Airport"
    ],
    "city": [
      "Moss Town",
      "Moss Town",
      "Moss Town"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "ELH",
    "translations": [
      "North Eleuthera Airport",
      "North Eleuthera Airport",
      "North Eleuthera Airport"
    ],
    "city": [
      "North Eleuthera",
      "North Eleuthera",
      "North Eleuthera"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "GHB",
    "translations": [
      "Governor's Harbour Airport",
      "Governor's Harbour Airport",
      "Governor's Harbour Airport"
    ],
    "city": [
      "Governor's Harbour",
      "Governor's Harbour",
      "Governor's Harbour"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "NMC",
    "translations": [
      "Normans Cay Airport",
      "Normans Cay Airport",
      "Normans Cay Airport"
    ],
    "city": [
      "Normans Cay",
      "Normans Cay",
      "Normans Cay"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "RSD",
    "translations": [
      "Rock Sound Airport",
      "Rock Sound Airport",
      "Rock Sound Airport"
    ],
    "city": [
      "Rock Sound",
      "Rock Sound",
      "Rock Sound"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "TYM",
    "translations": [
      "Staniel Cay Airport",
      "Staniel Cay Airport",
      "Staniel Cay Airport"
    ],
    "city": [
      "Staniel Cay",
      "Staniel Cay",
      "Staniel Cay"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "FPO",
    "translations": [
      "Grand Bahama International Airport",
      "Grand Bahama International Airport",
      "Grand Bahama International Airport"
    ],
    "city": [
      "Freeport",
      "Freeport",
      "Freeport"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "WTD",
    "translations": [
      "West End Airport",
      "West End Airport",
      "West End Airport"
    ],
    "city": [
      "West End",
      "West End",
      "West End"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "IGA",
    "translations": [
      "Inagua Airport",
      "Inagua Airport",
      "Inagua Airport"
    ],
    "city": [
      "Matthew Town",
      "Matthew Town",
      "Matthew Town"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "MYK",
    "translations": [
      "May Creek Airport",
      "May Creek Airport",
      "May Creek Airport"
    ],
    "city": [
      "May Creek",
      "May Creek",
      "May Creek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LGI",
    "translations": [
      "Deadman's Cay Airport",
      "Deadman's Cay Airport",
      "Deadman's Cay Airport"
    ],
    "city": [
      "Deadman's Cay",
      "Deadman's Cay",
      "Deadman's Cay"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "SML",
    "translations": [
      "Stella Maris Airport",
      "Stella Maris Airport",
      "Stella Maris Airport"
    ],
    "city": [
      "Stella Maris",
      "Stella Maris",
      "Stella Maris"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "MYG",
    "translations": [
      "Mayaguana Airport",
      "Mayaguana Airport",
      "Mayaguana Airport"
    ],
    "city": [
      "Abraham Bay Settlement",
      "Abraham Bay Settlement",
      "Abraham Bay Settlement"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "NAS",
    "translations": [
      "Lynden Pindling International Airport",
      "Lynden Pindling International Airport",
      "Lynden Pindling International Airport"
    ],
    "city": [
      "Nassau",
      "Nassau",
      "Nassau"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "DCT",
    "translations": [
      "Duncan Town Airport",
      "Duncan Town Airport",
      "Duncan Town Airport"
    ],
    "city": [
      "Duncan Town",
      "Duncan Town",
      "Duncan Town"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "RCY",
    "translations": [
      "Rum Cay International Airport",
      "Rum Cay International Airport",
      "Rum Cay International Airport"
    ],
    "city": [
      "Port Nelson",
      "Port Nelson",
      "Port Nelson"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "MYS",
    "translations": [
      "Moyale Airport",
      "Moyale Airport",
      "Moyale Airport"
    ],
    "city": [
      "Moyale",
      "Moyale",
      "Moyale"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "ZSA",
    "translations": [
      "San Salvador Airport",
      "San Salvador Airport",
      "San Salvador Airport"
    ],
    "city": [
      "San Salvador",
      "San Salvador",
      "San Salvador"
    ],
    "country": [
      "BS",
      "BS",
      "BS"
    ]
  },
  {
    "iata": "NTC",
    "translations": [
      "Paradise Island Airport",
      "Paradise Island Airport",
      "Paradise Island Airport"
    ],
    "city": [
      "Santa Carolina",
      "Santa Carolina",
      "Santa Carolina"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "TGS",
    "translations": [
      "Chokwé Airport",
      "Chokwé Airport",
      "Chokwé Airport"
    ],
    "city": [
      "Chokwé",
      "Chokwé",
      "Chokwé"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "BZE",
    "translations": [
      "Philip S. W. Goldson International Airport",
      "Philip S. W. Goldson International Airport",
      "Philip S. W. Goldson International Airport"
    ],
    "city": [
      "Belize City",
      "Belize City",
      "Belize City"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "MZE",
    "translations": [
      "Manatee Airport",
      "Manatee Airport",
      "Manatee Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "CYD",
    "translations": [
      "San Ignacio Town (Maya Flats) Airstrip",
      "San Ignacio Town (Maya Flats) Airstrip",
      "San Ignacio Town (Maya Flats) Airstrip"
    ],
    "city": [
      "Maya Flats",
      "Maya Flats",
      "Maya Flats"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "PLJ",
    "translations": [
      "Placencia Airport",
      "Placencia Airport",
      "Placencia Airport"
    ],
    "city": [
      "Placencia",
      "Placencia",
      "Placencia"
    ],
    "country": [
      "BZ",
      "BZ",
      "BZ"
    ]
  },
  {
    "iata": "IMI",
    "translations": [
      "Ine Airport",
      "Ine Airport",
      "Ine Airport"
    ],
    "city": [
      "Arno Atoll",
      "Arno Atoll",
      "Arno Atoll"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "BQI",
    "translations": [
      "Bagani Airport",
      "Bagani Airport",
      "Bagani Airport"
    ],
    "city": [
      "Bagani",
      "Bagani",
      "Bagani"
    ],
    "country": [
      "NA",
      "NA",
      "NA"
    ]
  },
  {
    "iata": "AIT",
    "translations": [
      "Aitutaki Airport",
      "Aitutaki Airport",
      "Aitutaki Airport"
    ],
    "city": [
      "Aitutaki",
      "Aitutaki",
      "Aitutaki"
    ],
    "country": [
      "CK",
      "CK",
      "CK"
    ]
  },
  {
    "iata": "AIU",
    "translations": [
      "Enua Airport",
      "Enua Airport",
      "Enua Airport"
    ],
    "city": [
      "Atiu Island",
      "Atiu Island",
      "Atiu Island"
    ],
    "country": [
      "CK",
      "CK",
      "CK"
    ]
  },
  {
    "iata": "MGS",
    "translations": [
      "Mangaia Island Airport",
      "Mangaia Island Airport",
      "Mangaia Island Airport"
    ],
    "city": [
      "Mangaia Island",
      "Mangaia Island",
      "Mangaia Island"
    ],
    "country": [
      "CK",
      "CK",
      "CK"
    ]
  },
  {
    "iata": "MHX",
    "translations": [
      "Manihiki Island Airport",
      "Manihiki Island Airport",
      "Manihiki Island Airport"
    ],
    "city": [
      "Manihiki Island",
      "Manihiki Island",
      "Manihiki Island"
    ],
    "country": [
      "CK",
      "CK",
      "CK"
    ]
  },
  {
    "iata": "MUK",
    "translations": [
      "Mauke Airport",
      "Mauke Airport",
      "Mauke Airport"
    ],
    "city": [
      "Mauke Island",
      "Mauke Island",
      "Mauke Island"
    ],
    "country": [
      "CK",
      "CK",
      "CK"
    ]
  },
  {
    "iata": "MOI",
    "translations": [
      "Mitiaro Island Airport",
      "Mitiaro Island Airport",
      "Mitiaro Island Airport"
    ],
    "city": [
      "Mitiaro Island",
      "Mitiaro Island",
      "Mitiaro Island"
    ],
    "country": [
      "CK",
      "CK",
      "CK"
    ]
  },
  {
    "iata": "PZK",
    "translations": [
      "Pukapuka Island Airport",
      "Pukapuka Island Airport",
      "Pukapuka Island Airport"
    ],
    "city": [
      "Pukapuka Atoll",
      "Pukapuka Atoll",
      "Pukapuka Atoll"
    ],
    "country": [
      "CK",
      "CK",
      "CK"
    ]
  },
  {
    "iata": "PYE",
    "translations": [
      "Tongareva Airport",
      "Tongareva Airport",
      "Tongareva Airport"
    ],
    "city": [
      "Penrhyn Island",
      "Penrhyn Island",
      "Penrhyn Island"
    ],
    "country": [
      "CK",
      "CK",
      "CK"
    ]
  },
  {
    "iata": "RAR",
    "translations": [
      "Rarotonga International Airport",
      "Rarotonga International Airport",
      "Rarotonga International Airport"
    ],
    "city": [
      "Avarua",
      "Avarua",
      "Avarua"
    ],
    "country": [
      "CK",
      "CK",
      "CK"
    ]
  },
  {
    "iata": "EPG",
    "translations": [
      "Browns Airport",
      "Browns Airport",
      "Browns Airport"
    ],
    "city": [
      "Weeping Water",
      "Weeping Water",
      "Weeping Water"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ICI",
    "translations": [
      "Cicia Airport",
      "Cicia Airport",
      "Cicia Airport"
    ],
    "city": [
      "Cicia",
      "Cicia",
      "Cicia"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "CST",
    "translations": [
      "Castaway Island Seaplane Base",
      "Castaway Island Seaplane Base",
      "Castaway Island Seaplane Base"
    ],
    "city": [
      "Castaway Island",
      "Castaway Island",
      "Castaway Island"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "NAN",
    "translations": [
      "Nadi International Airport",
      "Nadi International Airport",
      "Nadi International Airport"
    ],
    "city": [
      "Nadi",
      "Nadi",
      "Nadi"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "PTF",
    "translations": [
      "Malolo Lailai Island Airport",
      "Malolo Lailai Island Airport",
      "Malolo Lailai Island Airport"
    ],
    "city": [
      "Malolo Lailai Island",
      "Malolo Lailai Island",
      "Malolo Lailai Island"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "RBI",
    "translations": [
      "Rabi Island Airport",
      "Rabi Island Airport",
      "Rabi Island Airport"
    ],
    "city": [
      "Rabi Island",
      "Rabi Island",
      "Rabi Island"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "KDV",
    "translations": [
      "Vunisea Airport",
      "Vunisea Airport",
      "Vunisea Airport"
    ],
    "city": [
      "Vunisea",
      "Vunisea",
      "Vunisea"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "MNF",
    "translations": [
      "Mana Island Airport",
      "Mana Island Airport",
      "Mana Island Airport"
    ],
    "city": [
      "Mana Island",
      "Mana Island",
      "Mana Island"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "MFJ",
    "translations": [
      "Moala Airport",
      "Moala Airport",
      "Moala Airport"
    ],
    "city": [
      "Moala",
      "Moala",
      "Moala"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "SUV",
    "translations": [
      "Nausori International Airport",
      "Nausori International Airport",
      "Nausori International Airport"
    ],
    "city": [
      "Nausori",
      "Nausori",
      "Nausori"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "LEV",
    "translations": [
      "Levuka Airfield",
      "Levuka Airfield",
      "Levuka Airfield"
    ],
    "city": [
      "Bureta",
      "Bureta",
      "Bureta"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "PHR",
    "translations": [
      "Nanuku Airport",
      "Nanuku Airport",
      "Nanuku Airport"
    ],
    "city": [
      "Nanuku Auberge Resort",
      "Nanuku Auberge Resort",
      "Nanuku Auberge Resort"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "NGI",
    "translations": [
      "Ngau Airport",
      "Ngau Airport",
      "Ngau Airport"
    ],
    "city": [
      "Ngau",
      "Ngau",
      "Ngau"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "LUC",
    "translations": [
      "Laucala Island Airport",
      "Laucala Island Airport",
      "Laucala Island Airport"
    ],
    "city": [
      "Laucala Island",
      "Laucala Island",
      "Laucala Island"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "LKB",
    "translations": [
      "Lakeba Island Airport",
      "Lakeba Island Airport",
      "Lakeba Island Airport"
    ],
    "city": [
      "Lakeba Island",
      "Lakeba Island",
      "Lakeba Island"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "LBS",
    "translations": [
      "Labasa Airport",
      "Labasa Airport",
      "Labasa Airport"
    ],
    "city": [
      "Labasa",
      "Labasa",
      "Labasa"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "TVU",
    "translations": [
      "Matei Airport",
      "Matei Airport",
      "Matei Airport"
    ],
    "city": [
      "Matei",
      "Matei",
      "Matei"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "KXF",
    "translations": [
      "Koro Island Airport",
      "Koro Island Airport",
      "Koro Island Airport"
    ],
    "city": [
      "Koro Island",
      "Koro Island",
      "Koro Island"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "RTA",
    "translations": [
      "Rotuma Airport",
      "Rotuma Airport",
      "Rotuma Airport"
    ],
    "city": [
      "Rotuma",
      "Rotuma",
      "Rotuma"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "SVU",
    "translations": [
      "Savusavu Airport",
      "Savusavu Airport",
      "Savusavu Airport"
    ],
    "city": [
      "Savusavu",
      "Savusavu",
      "Savusavu"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "KAY",
    "translations": [
      "Wakaya Island Airport",
      "Wakaya Island Airport",
      "Wakaya Island Airport"
    ],
    "city": [
      "Wakaya Island",
      "Wakaya Island",
      "Wakaya Island"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "ONU",
    "translations": [
      "Ono-i-Lau Airport",
      "Ono-i-Lau Airport",
      "Ono-i-Lau Airport"
    ],
    "city": [
      "Ono-i-Lau",
      "Ono-i-Lau",
      "Ono-i-Lau"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "YAS",
    "translations": [
      "Yasawa Island Airport",
      "Yasawa Island Airport",
      "Yasawa Island Airport"
    ],
    "city": [
      "Yasawa Island",
      "Yasawa Island",
      "Yasawa Island"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "EUA",
    "translations": [
      "Kaufana Airport",
      "Kaufana Airport",
      "Kaufana Airport"
    ],
    "city": [
      "Eua Island",
      "Eua Island",
      "Eua Island"
    ],
    "country": [
      "TO",
      "TO",
      "TO"
    ]
  },
  {
    "iata": "TBU",
    "translations": [
      "Fua'amotu International Airport",
      "Fua'amotu International Airport",
      "Fua'amotu International Airport"
    ],
    "city": [
      "Nuku'alofa",
      "Nuku'alofa",
      "Nuku'alofa"
    ],
    "country": [
      "TO",
      "TO",
      "TO"
    ]
  },
  {
    "iata": "HPA",
    "translations": [
      "Lifuka Island Airport",
      "Lifuka Island Airport",
      "Lifuka Island Airport"
    ],
    "city": [
      "Lifuka",
      "Lifuka",
      "Lifuka"
    ],
    "country": [
      "TO",
      "TO",
      "TO"
    ]
  },
  {
    "iata": "NFO",
    "translations": [
      "Mata'aho Airport",
      "Mata'aho Airport",
      "Mata'aho Airport"
    ],
    "city": [
      "Angaha, Niuafo'ou Island",
      "Angaha, Niuafo'ou Island",
      "Angaha, Niuafo'ou Island"
    ],
    "country": [
      "TO",
      "TO",
      "TO"
    ]
  },
  {
    "iata": "NTT",
    "translations": [
      "Kuini Lavenia Airport",
      "Kuini Lavenia Airport",
      "Kuini Lavenia Airport"
    ],
    "city": [
      "Niuatoputapu",
      "Niuatoputapu",
      "Niuatoputapu"
    ],
    "country": [
      "TO",
      "TO",
      "TO"
    ]
  },
  {
    "iata": "VAV",
    "translations": [
      "Vava'u International Airport",
      "Vava'u International Airport",
      "Vava'u International Airport"
    ],
    "city": [
      "Vava'u Island",
      "Vava'u Island",
      "Vava'u Island"
    ],
    "country": [
      "TO",
      "TO",
      "TO"
    ]
  },
  {
    "iata": "TTL",
    "translations": [
      "Turtle Island Seaplane Base",
      "Turtle Island Seaplane Base",
      "Turtle Island Seaplane Base"
    ],
    "city": [
      "Nanuya Levu Island",
      "Nanuya Levu Island",
      "Nanuya Levu Island"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "VBV",
    "translations": [
      "Vanua Balavu Airport",
      "Vanua Balavu Airport",
      "Vanua Balavu Airport"
    ],
    "city": [
      "Vanua Balavu",
      "Vanua Balavu",
      "Vanua Balavu"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "VTF",
    "translations": [
      "Vatulele Airport",
      "Vatulele Airport",
      "Vatulele Airport"
    ],
    "city": [
      "Vatulele",
      "Vatulele",
      "Vatulele"
    ],
    "country": [
      "FJ",
      "FJ",
      "FJ"
    ]
  },
  {
    "iata": "PHG",
    "translations": [
      "Port Harcourt City Airport / Port Harcourt Air Force Base",
      "Port Harcourt City Airport / Port Harcourt Air Force Base",
      "Port Harcourt City Airport / Port Harcourt Air Force Base"
    ],
    "city": [
      "Port Harcourt",
      "Port Harcourt",
      "Port Harcourt"
    ],
    "country": [
      "NG",
      "NG",
      "NG"
    ]
  },
  {
    "iata": "ABF",
    "translations": [
      "Abaiang Airport",
      "Abaiang Airport",
      "Abaiang Airport"
    ],
    "city": [
      "Abaiang",
      "Abaiang",
      "Abaiang"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "BEZ",
    "translations": [
      "Beru Airport",
      "Beru Airport",
      "Beru Airport"
    ],
    "city": [
      "Beru",
      "Beru",
      "Beru"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "FUN",
    "translations": [
      "Funafuti International Airport",
      "Funafuti International Airport",
      "Funafuti International Airport"
    ],
    "city": [
      "Funafuti",
      "Funafuti",
      "Funafuti"
    ],
    "country": [
      "TV",
      "TV",
      "TV"
    ]
  },
  {
    "iata": "KUC",
    "translations": [
      "Kuria Airport",
      "Kuria Airport",
      "Kuria Airport"
    ],
    "city": [
      "Kuria",
      "Kuria",
      "Kuria"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "MNK",
    "translations": [
      "Maiana Airport",
      "Maiana Airport",
      "Maiana Airport"
    ],
    "city": [
      "Maiana",
      "Maiana",
      "Maiana"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "MZK",
    "translations": [
      "Marakei Airport",
      "Marakei Airport",
      "Marakei Airport"
    ],
    "city": [
      "Marakei",
      "Marakei",
      "Marakei"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "MTK",
    "translations": [
      "Makin Island Airport",
      "Makin Island Airport",
      "Makin Island Airport"
    ],
    "city": [
      "Makin Island",
      "Makin Island",
      "Makin Island"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "NIG",
    "translations": [
      "Nikunau Airport",
      "Nikunau Airport",
      "Nikunau Airport"
    ],
    "city": [
      "Nikunau",
      "Nikunau",
      "Nikunau"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "OOT",
    "translations": [
      "Onotoa Airport",
      "Onotoa Airport",
      "Onotoa Airport"
    ],
    "city": [
      "Onotoa",
      "Onotoa",
      "Onotoa"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "TRW",
    "translations": [
      "Bonriki International Airport",
      "Bonriki International Airport",
      "Bonriki International Airport"
    ],
    "city": [
      "Tarawa",
      "Tarawa",
      "Tarawa"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "AEA",
    "translations": [
      "Abemama Airport",
      "Abemama Airport",
      "Abemama Airport"
    ],
    "city": [
      "Abemama",
      "Abemama",
      "Abemama"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "TBF",
    "translations": [
      "Tabiteuea North Airport",
      "Tabiteuea North Airport",
      "Tabiteuea North Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "TMN",
    "translations": [
      "Tamana Island Airport",
      "Tamana Island Airport",
      "Tamana Island Airport"
    ],
    "city": [
      "Tamana Island",
      "Tamana Island",
      "Tamana Island"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "NON",
    "translations": [
      "Nonouti Airport",
      "Nonouti Airport",
      "Nonouti Airport"
    ],
    "city": [
      "Nonouti",
      "Nonouti",
      "Nonouti"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "AIS",
    "translations": [
      "Arorae Island Airport",
      "Arorae Island Airport",
      "Arorae Island Airport"
    ],
    "city": [
      "Arorae Island",
      "Arorae Island",
      "Arorae Island"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "TSU",
    "translations": [
      "Tabiteuea South Airport",
      "Tabiteuea South Airport",
      "Tabiteuea South Airport"
    ],
    "city": [
      "Tabiteuea South",
      "Tabiteuea South",
      "Tabiteuea South"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "BBG",
    "translations": [
      "Butaritari Airport",
      "Butaritari Airport",
      "Butaritari Airport"
    ],
    "city": [
      "Butaritari",
      "Butaritari",
      "Butaritari"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "AAK",
    "translations": [
      "Aranuka Airport",
      "Aranuka Airport",
      "Aranuka Airport"
    ],
    "city": [
      "Buariki",
      "Buariki",
      "Buariki"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "NIK",
    "translations": [
      "Niokolo-Koba Airport",
      "Niokolo-Koba Airport",
      "Niokolo-Koba Airport"
    ],
    "city": [
      "Niokolo-Koba National Park",
      "Niokolo-Koba National Park",
      "Niokolo-Koba National Park"
    ],
    "country": [
      "SN",
      "SN",
      "SN"
    ]
  },
  {
    "iata": "NIN",
    "translations": [
      "Ninilchik Airport",
      "Ninilchik Airport",
      "Ninilchik Airport"
    ],
    "city": [
      "Ninilchik",
      "Ninilchik",
      "Ninilchik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IUE",
    "translations": [
      "Niue International Airport",
      "Niue International Airport",
      "Niue International Airport"
    ],
    "city": [
      "Alofi",
      "Alofi",
      "Alofi"
    ],
    "country": [
      "NU",
      "NU",
      "NU"
    ]
  },
  {
    "iata": "NJJ",
    "translations": [
      "Nenjiang Melgen Airport",
      "Nenjiang Melgen Airport",
      "Nenjiang Melgen Airport"
    ],
    "city": [
      "Heihe",
      "Heihe",
      "Heihe"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NKD",
    "translations": [
      "Sinak Airport",
      "Sinak Airport",
      "Sinak Airport"
    ],
    "city": [
      "Sinak",
      "Sinak",
      "Sinak"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "NLH",
    "translations": [
      "Ninglang Luguhu Airport",
      "Ninglang Luguhu Airport",
      "Ninglang Luguhu Airport"
    ],
    "city": [
      "Ninglang",
      "Ninglang",
      "Ninglang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "FUT",
    "translations": [
      "Pointe Vele Airport",
      "Pointe Vele Airport",
      "Pointe Vele Airport"
    ],
    "city": [
      "Futuna Island",
      "Futuna Island",
      "Futuna Island"
    ],
    "country": [
      "WF",
      "WF",
      "WF"
    ]
  },
  {
    "iata": "WLS",
    "translations": [
      "Hihifo Airport",
      "Hihifo Airport",
      "Hihifo Airport"
    ],
    "city": [
      "Wallis Island",
      "Wallis Island",
      "Wallis Island"
    ],
    "country": [
      "WF",
      "WF",
      "WF"
    ]
  },
  {
    "iata": "HBB",
    "translations": [
      "Industrial Airpark",
      "Industrial Airpark",
      "Industrial Airpark"
    ],
    "city": [
      "Hobbs",
      "Hobbs",
      "Hobbs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NND",
    "translations": [
      "Nangade Airport",
      "Nangade Airport",
      "Nangade Airport"
    ],
    "city": [
      "Nangade",
      "Nangade",
      "Nangade"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "NOM",
    "translations": [
      "Nomad River Airport",
      "Nomad River Airport",
      "Nomad River Airport"
    ],
    "city": [
      "Nomad River",
      "Nomad River",
      "Nomad River"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "NOO",
    "translations": [
      "Naoro Airport",
      "Naoro Airport",
      "Naoro Airport"
    ],
    "city": [
      "Naoro Vilage",
      "Naoro Vilage",
      "Naoro Vilage"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PHH",
    "translations": [
      "Pokhara International Airport",
      "Pokhara International Airport",
      "Pokhara International Airport"
    ],
    "city": [
      "Pokhara",
      "Pokhara",
      "Pokhara"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "NPG",
    "translations": [
      "Nipa Airport",
      "Nipa Airport",
      "Nipa Airport"
    ],
    "city": [
      "Nipa",
      "Nipa",
      "Nipa"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "NRY",
    "translations": [
      "Newry Airport",
      "Newry Airport",
      "Newry Airport"
    ],
    "city": [
      "Newry",
      "Newry",
      "Newry"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OFU",
    "translations": [
      "Ofu Airport",
      "Ofu Airport",
      "Ofu Airport"
    ],
    "city": [
      "Ofu",
      "Ofu",
      "Ofu"
    ],
    "country": [
      "AS",
      "AS",
      "AS"
    ]
  },
  {
    "iata": "AAU",
    "translations": [
      "Asau Airport",
      "Asau Airport",
      "Asau Airport"
    ],
    "city": [
      "Asau",
      "Asau",
      "Asau"
    ],
    "country": [
      "WS",
      "WS",
      "WS"
    ]
  },
  {
    "iata": "APW",
    "translations": [
      "Faleolo International Airport",
      "Faleolo International Airport",
      "Faleolo International Airport"
    ],
    "city": [
      "Apia",
      "Apia",
      "Apia"
    ],
    "country": [
      "WS",
      "WS",
      "WS"
    ]
  },
  {
    "iata": "FGI",
    "translations": [
      "Fagali'i Airport",
      "Fagali'i Airport",
      "Fagali'i Airport"
    ],
    "city": [
      "Apia",
      "Apia",
      "Apia"
    ],
    "country": [
      "WS",
      "WS",
      "WS"
    ]
  },
  {
    "iata": "FTI",
    "translations": [
      "Fitiuta Airport",
      "Fitiuta Airport",
      "Fitiuta Airport"
    ],
    "city": [
      "Fitiuta Village",
      "Fitiuta Village",
      "Fitiuta Village"
    ],
    "country": [
      "AS",
      "AS",
      "AS"
    ]
  },
  {
    "iata": "MXS",
    "translations": [
      "Maota Airport",
      "Maota Airport",
      "Maota Airport"
    ],
    "city": [
      "Maota",
      "Maota",
      "Maota"
    ],
    "country": [
      "WS",
      "WS",
      "WS"
    ]
  },
  {
    "iata": "PPG",
    "translations": [
      "Pago Pago International Airport",
      "Pago Pago International Airport",
      "Pago Pago International Airport"
    ],
    "city": [
      "Pago Pago",
      "Pago Pago",
      "Pago Pago"
    ],
    "country": [
      "AS",
      "AS",
      "AS"
    ]
  },
  {
    "iata": "PPT",
    "translations": [
      "Faa'a International Airport",
      "Faa'a International Airport",
      "Faa'a International Airport"
    ],
    "city": [
      "Papeete",
      "Papeete",
      "Papeete"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "RMT",
    "translations": [
      "Rimatara Airport",
      "Rimatara Airport",
      "Rimatara Airport"
    ],
    "city": [
      "Rimatara Island",
      "Rimatara Island",
      "Rimatara Island"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "RUR",
    "translations": [
      "Rurutu Airport",
      "Rurutu Airport",
      "Rurutu Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "TUB",
    "translations": [
      "Tubuai Airport",
      "Tubuai Airport",
      "Tubuai Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "RVV",
    "translations": [
      "Raivavae Airport",
      "Raivavae Airport",
      "Raivavae Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "AAA",
    "translations": [
      "Anaa Airport",
      "Anaa Airport",
      "Anaa Airport"
    ],
    "city": [
      "Anaa",
      "Anaa",
      "Anaa"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "FGU",
    "translations": [
      "Fangatau Airport",
      "Fangatau Airport",
      "Fangatau Airport"
    ],
    "city": [
      "Fangatau",
      "Fangatau",
      "Fangatau"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "TIH",
    "translations": [
      "Tikehau Airport",
      "Tikehau Airport",
      "Tikehau Airport"
    ],
    "city": [
      "Tuherahera",
      "Tuherahera",
      "Tuherahera"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "APK",
    "translations": [
      "Apataki Airport",
      "Apataki Airport",
      "Apataki Airport"
    ],
    "city": [
      "Apataki",
      "Apataki",
      "Apataki"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "REA",
    "translations": [
      "Reao Airport",
      "Reao Airport",
      "Reao Airport"
    ],
    "city": [
      "Reao",
      "Reao",
      "Reao"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "FAV",
    "translations": [
      "Fakarava Airport",
      "Fakarava Airport",
      "Fakarava Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "HHZ",
    "translations": [
      "Hikueru Airport",
      "Hikueru Airport",
      "Hikueru Airport"
    ],
    "city": [
      "Hikueru",
      "Hikueru",
      "Hikueru"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "XMH",
    "translations": [
      "Manihi Airport",
      "Manihi Airport",
      "Manihi Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "GMR",
    "translations": [
      "Totegegie Airport",
      "Totegegie Airport",
      "Totegegie Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "KKR",
    "translations": [
      "Kaukura Airport",
      "Kaukura Airport",
      "Kaukura Airport"
    ],
    "city": [
      "Raitahiti",
      "Raitahiti",
      "Raitahiti"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "MKP",
    "translations": [
      "Makemo Airport",
      "Makemo Airport",
      "Makemo Airport"
    ],
    "city": [
      "Makemo",
      "Makemo",
      "Makemo"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "NAU",
    "translations": [
      "Napuka Island Airport",
      "Napuka Island Airport",
      "Napuka Island Airport"
    ],
    "city": [
      "Napuka Island",
      "Napuka Island",
      "Napuka Island"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "TKV",
    "translations": [
      "Tatakoto Airport",
      "Tatakoto Airport",
      "Tatakoto Airport"
    ],
    "city": [
      "Tatakoto",
      "Tatakoto",
      "Tatakoto"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "PKP",
    "translations": [
      "Puka Puka Airport",
      "Puka Puka Airport",
      "Puka Puka Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "PUK",
    "translations": [
      "Pukaruha Airport",
      "Pukaruha Airport",
      "Pukaruha Airport"
    ],
    "city": [
      "Pukaruha",
      "Pukaruha",
      "Pukaruha"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "TKP",
    "translations": [
      "Takapoto Airport",
      "Takapoto Airport",
      "Takapoto Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "AXR",
    "translations": [
      "Arutua Airport",
      "Arutua Airport",
      "Arutua Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "MVT",
    "translations": [
      "Mataiva Airport",
      "Mataiva Airport",
      "Mataiva Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "NUK",
    "translations": [
      "Nukutavake Airport",
      "Nukutavake Airport",
      "Nukutavake Airport"
    ],
    "city": [
      "Nukutavake",
      "Nukutavake",
      "Nukutavake"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "ZTA",
    "translations": [
      "Tureia Airport",
      "Tureia Airport",
      "Tureia Airport"
    ],
    "city": [
      "Tureia",
      "Tureia",
      "Tureia"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "AHE",
    "translations": [
      "Ahe Airport",
      "Ahe Airport",
      "Ahe Airport"
    ],
    "city": [
      "Ahe Atoll",
      "Ahe Atoll",
      "Ahe Atoll"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "KHZ",
    "translations": [
      "Kauehi Airport",
      "Kauehi Airport",
      "Kauehi Airport"
    ],
    "city": [
      "Kauehi",
      "Kauehi",
      "Kauehi"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "FAC",
    "translations": [
      "Faaite Airport",
      "Faaite Airport",
      "Faaite Airport"
    ],
    "city": [
      "Faaite",
      "Faaite",
      "Faaite"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "FHZ",
    "translations": [
      "Fakahina Airport",
      "Fakahina Airport",
      "Fakahina Airport"
    ],
    "city": [
      "Fakahina",
      "Fakahina",
      "Fakahina"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "RKA",
    "translations": [
      "Aratika Nord Airport",
      "Aratika Nord Airport",
      "Aratika Nord Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "TJN",
    "translations": [
      "Takume Airport",
      "Takume Airport",
      "Takume Airport"
    ],
    "city": [
      "Takume",
      "Takume",
      "Takume"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "NIU",
    "translations": [
      "Naiu Airport",
      "Naiu Airport",
      "Naiu Airport"
    ],
    "city": [
      "Naiu Atoll",
      "Naiu Atoll",
      "Naiu Atoll"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "RRR",
    "translations": [
      "Raroia Airport",
      "Raroia Airport",
      "Raroia Airport"
    ],
    "city": [
      "Raroia",
      "Raroia",
      "Raroia"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "TKX",
    "translations": [
      "Takaroa Airport",
      "Takaroa Airport",
      "Takaroa Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "KXU",
    "translations": [
      "Katiu Airport",
      "Katiu Airport",
      "Katiu Airport"
    ],
    "city": [
      "Katiu",
      "Katiu",
      "Katiu"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "NKP",
    "translations": [
      "Nukutepipi Airport",
      "Nukutepipi Airport",
      "Nukutepipi Airport"
    ],
    "city": [
      "Nukutepipi",
      "Nukutepipi",
      "Nukutepipi"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "NHV",
    "translations": [
      "Nuku Hiva Airport",
      "Nuku Hiva Airport",
      "Nuku Hiva Airport"
    ],
    "city": [
      "Nuku Hiva",
      "Nuku Hiva",
      "Nuku Hiva"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "AUQ",
    "translations": [
      "Hiva Oa-Atuona Airport",
      "Hiva Oa-Atuona Airport",
      "Hiva Oa-Atuona Airport"
    ],
    "city": [
      "Hiva Oa Island",
      "Hiva Oa Island",
      "Hiva Oa Island"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "UAP",
    "translations": [
      "Ua Pou Airport",
      "Ua Pou Airport",
      "Ua Pou Airport"
    ],
    "city": [
      "Ua Pou",
      "Ua Pou",
      "Ua Pou"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "UAH",
    "translations": [
      "Ua Huka Airport",
      "Ua Huka Airport",
      "Ua Huka Airport"
    ],
    "city": [
      "Ua Huka",
      "Ua Huka",
      "Ua Huka"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "BOB",
    "translations": [
      "Bora Bora Airport",
      "Bora Bora Airport",
      "Bora Bora Airport"
    ],
    "city": [
      "Motu Mute",
      "Motu Mute",
      "Motu Mute"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "TTI",
    "translations": [
      "Tetiaroa Airport",
      "Tetiaroa Airport",
      "Tetiaroa Airport"
    ],
    "city": [
      "Tetiaroa",
      "Tetiaroa",
      "Tetiaroa"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "RGI",
    "translations": [
      "Rangiroa Airport",
      "Rangiroa Airport",
      "Rangiroa Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "HUH",
    "translations": [
      "Huahine-Fare Airport",
      "Huahine-Fare Airport",
      "Huahine-Fare Airport"
    ],
    "city": [
      "Fare",
      "Fare",
      "Fare"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "MOZ",
    "translations": [
      "Moorea Temae Airport",
      "Moorea Temae Airport",
      "Moorea Temae Airport"
    ],
    "city": [
      "Moorea-Maiao",
      "Moorea-Maiao",
      "Moorea-Maiao"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "HOI",
    "translations": [
      "Hao Airport",
      "Hao Airport",
      "Hao Airport"
    ],
    "city": [
      "Otepa",
      "Otepa",
      "Otepa"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "MAU",
    "translations": [
      "Maupiti Airport",
      "Maupiti Airport",
      "Maupiti Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "RFP",
    "translations": [
      "Raiatea Airport",
      "Raiatea Airport",
      "Raiatea Airport"
    ],
    "city": [
      "Uturoa",
      "Uturoa",
      "Uturoa"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "TPX",
    "translations": [
      "Tupai Airport",
      "Tupai Airport",
      "Tupai Airport"
    ],
    "city": [
      "Tupai Atoll",
      "Tupai Atoll",
      "Tupai Atoll"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "UOA",
    "translations": [
      "Moruroa Airport",
      "Moruroa Airport",
      "Moruroa Airport"
    ],
    "city": [
      "Moruroa Atoll",
      "Moruroa Atoll",
      "Moruroa Atoll"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "VHZ",
    "translations": [
      "Vahitahi Airport",
      "Vahitahi Airport",
      "Vahitahi Airport"
    ],
    "city": [
      "Vahitahi",
      "Vahitahi",
      "Vahitahi"
    ],
    "country": [
      "PF",
      "PF",
      "PF"
    ]
  },
  {
    "iata": "NUF",
    "translations": [
      "Castlereagh Lake Seaplane Base",
      "Castlereagh Lake Seaplane Base",
      "Castlereagh Lake Seaplane Base"
    ],
    "city": [
      "Hatton",
      "Hatton",
      "Hatton"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "UCC",
    "translations": [
      "Yucca Airstrip",
      "Yucca Airstrip",
      "Yucca Airstrip"
    ],
    "city": [
      "Mercury",
      "Mercury",
      "Mercury"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MTV",
    "translations": [
      "Mota Lava Airport",
      "Mota Lava Airport",
      "Mota Lava Airport"
    ],
    "city": [
      "Ablow",
      "Ablow",
      "Ablow"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "SLH",
    "translations": [
      "Sola Airport",
      "Sola Airport",
      "Sola Airport"
    ],
    "city": [
      "Sola",
      "Sola",
      "Sola"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "TOH",
    "translations": [
      "Torres Airstrip",
      "Torres Airstrip",
      "Torres Airstrip"
    ],
    "city": [
      "Loh/Linua",
      "Loh/Linua",
      "Loh/Linua"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "EAE",
    "translations": [
      "Siwo Airport",
      "Siwo Airport",
      "Siwo Airport"
    ],
    "city": [
      "Emae Island",
      "Emae Island",
      "Emae Island"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "CCV",
    "translations": [
      "Craig Cove Airport",
      "Craig Cove Airport",
      "Craig Cove Airport"
    ],
    "city": [
      "Craig Cove",
      "Craig Cove",
      "Craig Cove"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "LOD",
    "translations": [
      "Longana Airport",
      "Longana Airport",
      "Longana Airport"
    ],
    "city": [
      "Longana",
      "Longana",
      "Longana"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "SSR",
    "translations": [
      "Sara Airport",
      "Sara Airport",
      "Sara Airport"
    ],
    "city": [
      "Pentecost Island",
      "Pentecost Island",
      "Pentecost Island"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "PBJ",
    "translations": [
      "Tavie Airport",
      "Tavie Airport",
      "Tavie Airport"
    ],
    "city": [
      "Paama Island",
      "Paama Island",
      "Paama Island"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "LPM",
    "translations": [
      "Lamap Airport",
      "Lamap Airport",
      "Lamap Airport"
    ],
    "city": [
      "Lamap",
      "Lamap",
      "Lamap"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "LNB",
    "translations": [
      "Lamen Bay Airport",
      "Lamen Bay Airport",
      "Lamen Bay Airport"
    ],
    "city": [
      "Lamen Bay",
      "Lamen Bay",
      "Lamen Bay"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "MWF",
    "translations": [
      "Maewo-Naone Airport",
      "Maewo-Naone Airport",
      "Maewo-Naone Airport"
    ],
    "city": [
      "Maewo Island",
      "Maewo Island",
      "Maewo Island"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "LNE",
    "translations": [
      "Lonorore Airport",
      "Lonorore Airport",
      "Lonorore Airport"
    ],
    "city": [
      "Lonorore",
      "Lonorore",
      "Lonorore"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "NUS",
    "translations": [
      "Norsup Airport",
      "Norsup Airport",
      "Norsup Airport"
    ],
    "city": [
      "Norsup",
      "Norsup",
      "Norsup"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "ZGU",
    "translations": [
      "Gaua Island Airport",
      "Gaua Island Airport",
      "Gaua Island Airport"
    ],
    "city": [
      "Gaua Island",
      "Gaua Island",
      "Gaua Island"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "RCL",
    "translations": [
      "Redcliffe Airport",
      "Redcliffe Airport",
      "Redcliffe Airport"
    ],
    "city": [
      "Redcliffe",
      "Redcliffe",
      "Redcliffe"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "SON",
    "translations": [
      "Santo Pekoa International Airport",
      "Santo Pekoa International Airport",
      "Santo Pekoa International Airport"
    ],
    "city": [
      "Luganville",
      "Luganville",
      "Luganville"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "TGH",
    "translations": [
      "Tongoa Airport",
      "Tongoa Airport",
      "Tongoa Airport"
    ],
    "city": [
      "Tongoa Island",
      "Tongoa Island",
      "Tongoa Island"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "ULB",
    "translations": [
      "Uléi Airport",
      "Uléi Airport",
      "Uléi Airport"
    ],
    "city": [
      "Ambrym Island",
      "Ambrym Island",
      "Ambrym Island"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "VLS",
    "translations": [
      "Valesdir Airport",
      "Valesdir Airport",
      "Valesdir Airport"
    ],
    "city": [
      "Epi Island",
      "Epi Island",
      "Epi Island"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "WLH",
    "translations": [
      "Walaha Airport",
      "Walaha Airport",
      "Walaha Airport"
    ],
    "city": [
      "Walaha",
      "Walaha",
      "Walaha"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "SWJ",
    "translations": [
      "Southwest Bay Airport",
      "Southwest Bay Airport",
      "Southwest Bay Airport"
    ],
    "city": [
      "Malekula Island",
      "Malekula Island",
      "Malekula Island"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "OLJ",
    "translations": [
      "North West Santo Airport",
      "North West Santo Airport",
      "North West Santo Airport"
    ],
    "city": [
      "Olpoi",
      "Olpoi",
      "Olpoi"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "AUY",
    "translations": [
      "Aneityum Airport",
      "Aneityum Airport",
      "Aneityum Airport"
    ],
    "city": [
      "Anatom Island",
      "Anatom Island",
      "Anatom Island"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "AWD",
    "translations": [
      "Aniwa Airport",
      "Aniwa Airport",
      "Aniwa Airport"
    ],
    "city": [
      "Aniwa",
      "Aniwa",
      "Aniwa"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "DLY",
    "translations": [
      "Dillon's Bay Airport",
      "Dillon's Bay Airport",
      "Dillon's Bay Airport"
    ],
    "city": [
      "Dillon's Bay",
      "Dillon's Bay",
      "Dillon's Bay"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "FTA",
    "translations": [
      "Futuna Airport",
      "Futuna Airport",
      "Futuna Airport"
    ],
    "city": [
      "Futuna Island",
      "Futuna Island",
      "Futuna Island"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "IPA",
    "translations": [
      "Ipota Airport",
      "Ipota Airport",
      "Ipota Airport"
    ],
    "city": [
      "Ipota",
      "Ipota",
      "Ipota"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "VLI",
    "translations": [
      "Bauerfield International Airport",
      "Bauerfield International Airport",
      "Bauerfield International Airport"
    ],
    "city": [
      "Port Vila",
      "Port Vila",
      "Port Vila"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "TAH",
    "translations": [
      "Whitegrass Airport",
      "Whitegrass Airport",
      "Whitegrass Airport"
    ],
    "city": [
      "Tanna Island",
      "Tanna Island",
      "Tanna Island"
    ],
    "country": [
      "VU",
      "VU",
      "VU"
    ]
  },
  {
    "iata": "NWT",
    "translations": [
      "Nowata Airport",
      "Nowata Airport",
      "Nowata Airport"
    ],
    "city": [
      "Nowata",
      "Nowata",
      "Nowata"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TGJ",
    "translations": [
      "Tiga Airport",
      "Tiga Airport",
      "Tiga Airport"
    ],
    "city": [
      "Tiga",
      "Tiga",
      "Tiga"
    ],
    "country": [
      "NC",
      "NC",
      "NC"
    ]
  },
  {
    "iata": "BMY",
    "translations": [
      "Île Art - Waala Airport",
      "Île Art - Waala Airport",
      "Île Art - Waala Airport"
    ],
    "city": [
      "Waala",
      "Waala",
      "Waala"
    ],
    "country": [
      "NC",
      "NC",
      "NC"
    ]
  },
  {
    "iata": "KNQ",
    "translations": [
      "Koné Airport",
      "Koné Airport",
      "Koné Airport"
    ],
    "city": [
      "Koné",
      "Koné",
      "Koné"
    ],
    "country": [
      "NC",
      "NC",
      "NC"
    ]
  },
  {
    "iata": "ILP",
    "translations": [
      "Île des Pins Airport",
      "Île des Pins Airport",
      "Île des Pins Airport"
    ],
    "city": [
      "Île des Pins",
      "Île des Pins",
      "Île des Pins"
    ],
    "country": [
      "NC",
      "NC",
      "NC"
    ]
  },
  {
    "iata": "KOC",
    "translations": [
      "Koumac Airport",
      "Koumac Airport",
      "Koumac Airport"
    ],
    "city": [
      "Koumac",
      "Koumac",
      "Koumac"
    ],
    "country": [
      "NC",
      "NC",
      "NC"
    ]
  },
  {
    "iata": "LIF",
    "translations": [
      "Lifou Airport",
      "Lifou Airport",
      "Lifou Airport"
    ],
    "city": [
      "Lifou",
      "Lifou",
      "Lifou"
    ],
    "country": [
      "NC",
      "NC",
      "NC"
    ]
  },
  {
    "iata": "GEA",
    "translations": [
      "Nouméa Magenta Airport",
      "Nouméa Magenta Airport",
      "Nouméa Magenta Airport"
    ],
    "city": [
      "Nouméa",
      "Nouméa",
      "Nouméa"
    ],
    "country": [
      "NC",
      "NC",
      "NC"
    ]
  },
  {
    "iata": "PUV",
    "translations": [
      "Poum / Malabou Airport",
      "Poum / Malabou Airport",
      "Poum / Malabou Airport"
    ],
    "city": [
      "Malabou",
      "Malabou",
      "Malabou"
    ],
    "country": [
      "NC",
      "NC",
      "NC"
    ]
  },
  {
    "iata": "PDC",
    "translations": [
      "Mueo Airport",
      "Mueo Airport",
      "Mueo Airport"
    ],
    "city": [
      "Népoui",
      "Népoui",
      "Népoui"
    ],
    "country": [
      "NC",
      "NC",
      "NC"
    ]
  },
  {
    "iata": "MEE",
    "translations": [
      "Maré Airport",
      "Maré Airport",
      "Maré Airport"
    ],
    "city": [
      "Maré",
      "Maré",
      "Maré"
    ],
    "country": [
      "NC",
      "NC",
      "NC"
    ]
  },
  {
    "iata": "TOU",
    "translations": [
      "Touho Airport",
      "Touho Airport",
      "Touho Airport"
    ],
    "city": [
      "Touho",
      "Touho",
      "Touho"
    ],
    "country": [
      "NC",
      "NC",
      "NC"
    ]
  },
  {
    "iata": "UVE",
    "translations": [
      "Ouvéa Airport",
      "Ouvéa Airport",
      "Ouvéa Airport"
    ],
    "city": [
      "Ouvéa",
      "Ouvéa",
      "Ouvéa"
    ],
    "country": [
      "NC",
      "NC",
      "NC"
    ]
  },
  {
    "iata": "NOU",
    "translations": [
      "La Tontouta International Airport",
      "La Tontouta International Airport",
      "La Tontouta International Airport"
    ],
    "city": [
      "Nouméa (La Tontouta)",
      "Nouméa (La Tontouta)",
      "Nouméa (La Tontouta)"
    ],
    "country": [
      "NC",
      "NC",
      "NC"
    ]
  },
  {
    "iata": "FGL",
    "translations": [
      "Fox Glacier Aerodrome",
      "Fox Glacier Aerodrome",
      "Fox Glacier Aerodrome"
    ],
    "city": [
      "Fox Glacier",
      "Fox Glacier",
      "Fox Glacier"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "AKL",
    "translations": [
      "Auckland International Airport",
      "Auckland International Airport",
      "Auckland International Airport"
    ],
    "city": [
      "Auckland",
      "Auckland",
      "Auckland"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "TUO",
    "translations": [
      "Taupo Airport",
      "Taupo Airport",
      "Taupo Airport"
    ],
    "city": [
      "Taupo",
      "Taupo",
      "Taupo"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "AMZ",
    "translations": [
      "Ardmore Airport",
      "Ardmore Airport",
      "Ardmore Airport"
    ],
    "city": [
      "Manurewa",
      "Manurewa",
      "Manurewa"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "ASG",
    "translations": [
      "Ashburton Airport",
      "Ashburton Airport",
      "Ashburton Airport"
    ],
    "city": [
      "Ashburton",
      "Ashburton",
      "Ashburton"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "CHC",
    "translations": [
      "Christchurch International Airport",
      "Christchurch International Airport",
      "Christchurch International Airport"
    ],
    "city": [
      "Christchurch",
      "Christchurch",
      "Christchurch"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "CHT",
    "translations": [
      "Chatham Islands / Tuuta Airport",
      "Chatham Islands / Tuuta Airport",
      "Chatham Islands / Tuuta Airport"
    ],
    "city": [
      "Te One",
      "Te One",
      "Te One"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "CMV",
    "translations": [
      "Coromandel Airport",
      "Coromandel Airport",
      "Coromandel Airport"
    ],
    "city": [
      "Coromandel",
      "Coromandel",
      "Coromandel"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "DGR",
    "translations": [
      "Dargaville Aerodrome",
      "Dargaville Aerodrome",
      "Dargaville Aerodrome"
    ],
    "city": [
      "Dargaville",
      "Dargaville",
      "Dargaville"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "DUD",
    "translations": [
      "Dunedin International Airport",
      "Dunedin International Airport",
      "Dunedin International Airport"
    ],
    "city": [
      "Dunedin",
      "Dunedin",
      "Dunedin"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "WHO",
    "translations": [
      "Franz Josef Aerodrome",
      "Franz Josef Aerodrome",
      "Franz Josef Aerodrome"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "GBZ",
    "translations": [
      "Great Barrier Aerodrome",
      "Great Barrier Aerodrome",
      "Great Barrier Aerodrome"
    ],
    "city": [
      "Claris",
      "Claris",
      "Claris"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "GMN",
    "translations": [
      "Greymouth Airport",
      "Greymouth Airport",
      "Greymouth Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "GIS",
    "translations": [
      "Gisborne Airport",
      "Gisborne Airport",
      "Gisborne Airport"
    ],
    "city": [
      "Gisborne",
      "Gisborne",
      "Gisborne"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "GTN",
    "translations": [
      "Glentanner Airport",
      "Glentanner Airport",
      "Glentanner Airport"
    ],
    "city": [
      "Glentanner Station",
      "Glentanner Station",
      "Glentanner Station"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "HKK",
    "translations": [
      "Hokitika Airfield",
      "Hokitika Airfield",
      "Hokitika Airfield"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "HLZ",
    "translations": [
      "Hamilton International Airport",
      "Hamilton International Airport",
      "Hamilton International Airport"
    ],
    "city": [
      "Hamilton",
      "Hamilton",
      "Hamilton"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "WIK",
    "translations": [
      "Waiheke Island Aerodrome",
      "Waiheke Island Aerodrome",
      "Waiheke Island Aerodrome"
    ],
    "city": [
      "Waiheke Island",
      "Waiheke Island",
      "Waiheke Island"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "KBZ",
    "translations": [
      "Kaikoura Airport",
      "Kaikoura Airport",
      "Kaikoura Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "KKE",
    "translations": [
      "Kerikeri Airport",
      "Kerikeri Airport",
      "Kerikeri Airport"
    ],
    "city": [
      "Kerikeri",
      "Kerikeri",
      "Kerikeri"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "KKO",
    "translations": [
      "Kaikohe Airport",
      "Kaikohe Airport",
      "Kaikohe Airport"
    ],
    "city": [
      "Kaikohe",
      "Kaikohe",
      "Kaikohe"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "KAT",
    "translations": [
      "Kaitaia Airport",
      "Kaitaia Airport",
      "Kaitaia Airport"
    ],
    "city": [
      "Awanui",
      "Awanui",
      "Awanui"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "ALR",
    "translations": [
      "Alexandra Aerodrome",
      "Alexandra Aerodrome",
      "Alexandra Aerodrome"
    ],
    "city": [
      "Alexandra",
      "Alexandra",
      "Alexandra"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "MTA",
    "translations": [
      "Matamata Glider Airport",
      "Matamata Glider Airport",
      "Matamata Glider Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "MHB",
    "translations": [
      "Mechanics Bay Heliport",
      "Mechanics Bay Heliport",
      "Mechanics Bay Heliport"
    ],
    "city": [
      "Auckland City",
      "Auckland City",
      "Auckland City"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "MON",
    "translations": [
      "Mount Cook Airport",
      "Mount Cook Airport",
      "Mount Cook Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "MFN",
    "translations": [
      "Milford Sound Airport",
      "Milford Sound Airport",
      "Milford Sound Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "MZP",
    "translations": [
      "Motueka Airport",
      "Motueka Airport",
      "Motueka Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "TEU",
    "translations": [
      "Manapouri Airport",
      "Manapouri Airport",
      "Manapouri Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "MRO",
    "translations": [
      "Hood Airport",
      "Hood Airport",
      "Hood Airport"
    ],
    "city": [
      "Masterton",
      "Masterton",
      "Masterton"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "NPL",
    "translations": [
      "New Plymouth Airport",
      "New Plymouth Airport",
      "New Plymouth Airport"
    ],
    "city": [
      "New Plymouth",
      "New Plymouth",
      "New Plymouth"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "NPE",
    "translations": [
      "Hawke's Bay Airport",
      "Hawke's Bay Airport",
      "Hawke's Bay Airport"
    ],
    "city": [
      "Napier",
      "Napier",
      "Napier"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "NSN",
    "translations": [
      "Nelson Airport",
      "Nelson Airport",
      "Nelson Airport"
    ],
    "city": [
      "Nelson",
      "Nelson",
      "Nelson"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "IVC",
    "translations": [
      "Invercargill Airport",
      "Invercargill Airport",
      "Invercargill Airport"
    ],
    "city": [
      "Invercargill",
      "Invercargill",
      "Invercargill"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "OHA",
    "translations": [
      "RNZAF Base Ohakea",
      "RNZAF Base Ohakea",
      "RNZAF Base Ohakea"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "OAM",
    "translations": [
      "Oamaru Airport",
      "Oamaru Airport",
      "Oamaru Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "PMR",
    "translations": [
      "Palmerston North Airport",
      "Palmerston North Airport",
      "Palmerston North Airport"
    ],
    "city": [
      "Palmerston North",
      "Palmerston North",
      "Palmerston North"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "PCN",
    "translations": [
      "Picton Aerodrome",
      "Picton Aerodrome",
      "Picton Aerodrome"
    ],
    "city": [
      "Koromiko",
      "Koromiko",
      "Koromiko"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "PPQ",
    "translations": [
      "Paraparaumu Airport",
      "Paraparaumu Airport",
      "Paraparaumu Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "ZQN",
    "translations": [
      "Queenstown International Airport",
      "Queenstown International Airport",
      "Queenstown International Airport"
    ],
    "city": [
      "Queenstown",
      "Queenstown",
      "Queenstown"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "RAG",
    "translations": [
      "Raglan Aerodrome",
      "Raglan Aerodrome",
      "Raglan Aerodrome"
    ],
    "city": [
      "Raglan",
      "Raglan",
      "Raglan"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "SZS",
    "translations": [
      "Ryan's Creek Aerodrome",
      "Ryan's Creek Aerodrome",
      "Ryan's Creek Aerodrome"
    ],
    "city": [
      "Oban",
      "Oban",
      "Oban"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "ROT",
    "translations": [
      "Rotorua Regional Airport",
      "Rotorua Regional Airport",
      "Rotorua Regional Airport"
    ],
    "city": [
      "Rotorua",
      "Rotorua",
      "Rotorua"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "TRG",
    "translations": [
      "Tauranga Airport",
      "Tauranga Airport",
      "Tauranga Airport"
    ],
    "city": [
      "Tauranga",
      "Tauranga",
      "Tauranga"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "TMZ",
    "translations": [
      "Thames Aerodrome",
      "Thames Aerodrome",
      "Thames Aerodrome"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "KTF",
    "translations": [
      "Takaka Airport",
      "Takaka Airport",
      "Takaka Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "TKZ",
    "translations": [
      "Tokoroa Airfield",
      "Tokoroa Airfield",
      "Tokoroa Airfield"
    ],
    "city": [
      "Tokoroa",
      "Tokoroa",
      "Tokoroa"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "THH",
    "translations": [
      "Taharoa Aerodrome",
      "Taharoa Aerodrome",
      "Taharoa Aerodrome"
    ],
    "city": [
      "Taharoa",
      "Taharoa",
      "Taharoa"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "TIU",
    "translations": [
      "Timaru Airport",
      "Timaru Airport",
      "Timaru Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "TWZ",
    "translations": [
      "Pukaki Airport",
      "Pukaki Airport",
      "Pukaki Airport"
    ],
    "city": [
      "Twitzel",
      "Twitzel",
      "Twitzel"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "BHE",
    "translations": [
      "Woodbourne Airport",
      "Woodbourne Airport",
      "Woodbourne Airport"
    ],
    "city": [
      "Blenheim",
      "Blenheim",
      "Blenheim"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "WKA",
    "translations": [
      "Wanaka Airport",
      "Wanaka Airport",
      "Wanaka Airport"
    ],
    "city": [
      "Wanaka",
      "Wanaka",
      "Wanaka"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "WHK",
    "translations": [
      "Whakatane Airport",
      "Whakatane Airport",
      "Whakatane Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "WLG",
    "translations": [
      "Wellington International Airport",
      "Wellington International Airport",
      "Wellington International Airport"
    ],
    "city": [
      "Wellington",
      "Wellington",
      "Wellington"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "WIR",
    "translations": [
      "Wairoa Airport",
      "Wairoa Airport",
      "Wairoa Airport"
    ],
    "city": [
      "Wairoa",
      "Wairoa",
      "Wairoa"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "WRE",
    "translations": [
      "Whangarei Airport",
      "Whangarei Airport",
      "Whangarei Airport"
    ],
    "city": [
      "Whangarei",
      "Whangarei",
      "Whangarei"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "WSZ",
    "translations": [
      "Westport Airport",
      "Westport Airport",
      "Westport Airport"
    ],
    "city": [
      "Westport",
      "Westport",
      "Westport"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "WTZ",
    "translations": [
      "Whitianga Airport",
      "Whitianga Airport",
      "Whitianga Airport"
    ],
    "city": [
      "Whitianga",
      "Whitianga",
      "Whitianga"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "WAG",
    "translations": [
      "Wanganui Airport",
      "Wanganui Airport",
      "Wanganui Airport"
    ],
    "city": [
      "Wanganui",
      "Wanganui",
      "Wanganui"
    ],
    "country": [
      "NZ",
      "NZ",
      "NZ"
    ]
  },
  {
    "iata": "NLN",
    "translations": [
      "Kneeland Airport",
      "Kneeland Airport",
      "Kneeland Airport"
    ],
    "city": [
      "Kneeland",
      "Kneeland",
      "Kneeland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BZF",
    "translations": [
      "Benton Field",
      "Benton Field",
      "Benton Field"
    ],
    "city": [
      "Redding",
      "Redding",
      "Redding"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BIN",
    "translations": [
      "Bamyan Airport",
      "Bamyan Airport",
      "Bamyan Airport"
    ],
    "city": [
      "Bamyan",
      "Bamyan",
      "Bamyan"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "BST",
    "translations": [
      "Bost Airport",
      "Bost Airport",
      "Bost Airport"
    ],
    "city": [
      "Lashkar Gah",
      "Lashkar Gah",
      "Lashkar Gah"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "CCN",
    "translations": [
      "Chaghcharan Airport",
      "Chaghcharan Airport",
      "Chaghcharan Airport"
    ],
    "city": [
      "Chaghcharan",
      "Chaghcharan",
      "Chaghcharan"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "SBF",
    "translations": [
      "Sardeh Band Airport",
      "Sardeh Band Airport",
      "Sardeh Band Airport"
    ],
    "city": [
      "Sardeh Band",
      "Sardeh Band",
      "Sardeh Band"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "DWR",
    "translations": [
      "Dwyer Airport",
      "Dwyer Airport",
      "Dwyer Airport"
    ],
    "city": [
      "Reg",
      "Reg",
      "Reg"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "DAZ",
    "translations": [
      "Darwaz Airport",
      "Darwaz Airport",
      "Darwaz Airport"
    ],
    "city": [
      "Darwaz",
      "Darwaz",
      "Darwaz"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "FAH",
    "translations": [
      "Farah Airport",
      "Farah Airport",
      "Farah Airport"
    ],
    "city": [
      "Farah",
      "Farah",
      "Farah"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "FBD",
    "translations": [
      "Fayzabad Airport",
      "Fayzabad Airport",
      "Fayzabad Airport"
    ],
    "city": [
      "Fayzabad",
      "Fayzabad",
      "Fayzabad"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "GZI",
    "translations": [
      "Ghazni Airport",
      "Ghazni Airport",
      "Ghazni Airport"
    ],
    "city": [
      "Ghazni",
      "Ghazni",
      "Ghazni"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "GRG",
    "translations": [
      "Gardez Airport",
      "Gardez Airport",
      "Gardez Airport"
    ],
    "city": [
      "Gardez",
      "Gardez",
      "Gardez"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "KWH",
    "translations": [
      "Khwahan Airport",
      "Khwahan Airport",
      "Khwahan Airport"
    ],
    "city": [
      "Khwahan",
      "Khwahan",
      "Khwahan"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "HEA",
    "translations": [
      "Herat - Khwaja Abdullah Ansari International Airport",
      "Herat - Khwaja Abdullah Ansari International Airport",
      "Herat - Khwaja Abdullah Ansari International Airport"
    ],
    "city": [
      "Guzara",
      "Guzara",
      "Guzara"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "OAI",
    "translations": [
      "Bagram Airfield",
      "Bagram Airfield",
      "Bagram Airfield"
    ],
    "city": [
      "Bagram",
      "Bagram",
      "Bagram"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "JAA",
    "translations": [
      "Jalalabad Airport",
      "Jalalabad Airport",
      "Jalalabad Airport"
    ],
    "city": [
      "Jalalabad",
      "Jalalabad",
      "Jalalabad"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "KBL",
    "translations": [
      "Kabul International Airport",
      "Kabul International Airport",
      "Kabul International Airport"
    ],
    "city": [
      "Kabul",
      "Kabul",
      "Kabul"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "KDH",
    "translations": [
      "Ahmad Shah Baba International Airport / Kandahar Airfield",
      "Ahmad Shah Baba International Airport / Kandahar Airfield",
      "Ahmad Shah Baba International Airport / Kandahar Airfield"
    ],
    "city": [
      "Khvoshab",
      "Khvoshab",
      "Khvoshab"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "KHT",
    "translations": [
      "Khost International Airport",
      "Khost International Airport",
      "Khost International Airport"
    ],
    "city": [
      "Khost",
      "Khost",
      "Khost"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "MMZ",
    "translations": [
      "Maymana Zahiraddin Faryabi Airport",
      "Maymana Zahiraddin Faryabi Airport",
      "Maymana Zahiraddin Faryabi Airport"
    ],
    "city": [
      "Maymana",
      "Maymana",
      "Maymana"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "MZR",
    "translations": [
      "Mazar-i-Sharif International Airport",
      "Mazar-i-Sharif International Airport",
      "Mazar-i-Sharif International Airport"
    ],
    "city": [
      "Mazar-i-Sharif",
      "Mazar-i-Sharif",
      "Mazar-i-Sharif"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "URN",
    "translations": [
      "Urgun Airport",
      "Urgun Airport",
      "Urgun Airport"
    ],
    "city": [
      "Urgun",
      "Urgun",
      "Urgun"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "LQN",
    "translations": [
      "Qala-i-Naw Airport",
      "Qala-i-Naw Airport",
      "Qala-i-Naw Airport"
    ],
    "city": [
      "Qala-i-Naw",
      "Qala-i-Naw",
      "Qala-i-Naw"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "URZ",
    "translations": [
      "Orūzgān Airport",
      "Orūzgān Airport",
      "Orūzgān Airport"
    ],
    "city": [
      "Orūzgān",
      "Orūzgān",
      "Orūzgān"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "KUR",
    "translations": [
      "Razer Airport",
      "Razer Airport",
      "Razer Airport"
    ],
    "city": [
      "Skazar",
      "Skazar",
      "Skazar"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "OAS",
    "translations": [
      "Sharana Airstrip",
      "Sharana Airstrip",
      "Sharana Airstrip"
    ],
    "city": [
      "Sharana",
      "Sharana",
      "Sharana"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "OAH",
    "translations": [
      "Shindand Air Base",
      "Shindand Air Base",
      "Shindand Air Base"
    ],
    "city": [
      "Shindand",
      "Shindand",
      "Shindand"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "OAA",
    "translations": [
      "Shank Air Base",
      "Shank Air Base",
      "Shank Air Base"
    ],
    "city": [
      "Baraki Barak",
      "Baraki Barak",
      "Baraki Barak"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "OLR",
    "translations": [
      "Salerno Airport",
      "Salerno Airport",
      "Salerno Airport"
    ],
    "city": [
      "Khost",
      "Khost",
      "Khost"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "SGA",
    "translations": [
      "Sheghnan Airport",
      "Sheghnan Airport",
      "Sheghnan Airport"
    ],
    "city": [
      "Shiveh",
      "Shiveh",
      "Shiveh"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "TII",
    "translations": [
      "Tarinkot Airport",
      "Tarinkot Airport",
      "Tarinkot Airport"
    ],
    "city": [
      "Tarinkot",
      "Tarinkot",
      "Tarinkot"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "TQN",
    "translations": [
      "Taleqan Airport",
      "Taleqan Airport",
      "Taleqan Airport"
    ],
    "city": [
      "Taleqan",
      "Taleqan",
      "Taleqan"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "UND",
    "translations": [
      "Kunduz Airport",
      "Kunduz Airport",
      "Kunduz Airport"
    ],
    "city": [
      "Kunduz",
      "Kunduz",
      "Kunduz"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "OAZ",
    "translations": [
      "Camp Shorabak Airfield",
      "Camp Shorabak Airfield",
      "Camp Shorabak Airfield"
    ],
    "city": [
      "Lashkar Gah",
      "Lashkar Gah",
      "Lashkar Gah"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "ZAJ",
    "translations": [
      "Zaranj Airport",
      "Zaranj Airport",
      "Zaranj Airport"
    ],
    "city": [
      "Zaranj",
      "Zaranj",
      "Zaranj"
    ],
    "country": [
      "AF",
      "AF",
      "AF"
    ]
  },
  {
    "iata": "BAH",
    "translations": [
      "Bahrain International Airport",
      "Bahrain International Airport",
      "Bahrain International Airport"
    ],
    "city": [
      "Manama",
      "Manama",
      "Manama"
    ],
    "country": [
      "BH",
      "BH",
      "BH"
    ]
  },
  {
    "iata": "OCS",
    "translations": [
      "Corisco International Airport",
      "Corisco International Airport",
      "Corisco International Airport"
    ],
    "city": [
      "Corisco Island",
      "Corisco Island",
      "Corisco Island"
    ],
    "country": [
      "GQ",
      "GQ",
      "GQ"
    ]
  },
  {
    "iata": "AHB",
    "translations": [
      "Abha International Airport",
      "Abha International Airport",
      "Abha International Airport"
    ],
    "city": [
      "Abha",
      "Abha",
      "Abha"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "HOF",
    "translations": [
      "Al-Ahsa International Airport",
      "Al-Ahsa International Airport",
      "Al-Ahsa International Airport"
    ],
    "city": [
      "Hofuf",
      "Hofuf",
      "Hofuf"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "ULH",
    "translations": [
      "Majeed Bin Abdulaziz Airport",
      "Majeed Bin Abdulaziz Airport",
      "Majeed Bin Abdulaziz Airport"
    ],
    "city": [
      "Al Ula",
      "Al Ula",
      "Al Ula"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "ABT",
    "translations": [
      "King Saud Bin Abdulaziz (Al Baha) Airport",
      "King Saud Bin Abdulaziz (Al Baha) Airport",
      "King Saud Bin Abdulaziz (Al Baha) Airport"
    ],
    "city": [
      "Al-Baha",
      "Al-Baha",
      "Al-Baha"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "BHH",
    "translations": [
      "Bisha Airport",
      "Bisha Airport",
      "Bisha Airport"
    ],
    "city": [
      "Bisha",
      "Bisha",
      "Bisha"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "DMM",
    "translations": [
      "King Fahd International Airport",
      "King Fahd International Airport",
      "King Fahd International Airport"
    ],
    "city": [
      "Ad Dammam",
      "Ad Dammam",
      "Ad Dammam"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "DWD",
    "translations": [
      "King Salman Abdulaziz Airport",
      "King Salman Abdulaziz Airport",
      "King Salman Abdulaziz Airport"
    ],
    "city": [
      "Dawadmi",
      "Dawadmi",
      "Dawadmi"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "DHA",
    "translations": [
      "King Abdulaziz Air Base",
      "King Abdulaziz Air Base",
      "King Abdulaziz Air Base"
    ],
    "city": [
      "Dhahran",
      "Dhahran",
      "Dhahran"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "GIZ",
    "translations": [
      "Jizan Regional Airport / King Abdullah bin Abdulaziz Airport",
      "Jizan Regional Airport / King Abdullah bin Abdulaziz Airport",
      "Jizan Regional Airport / King Abdullah bin Abdulaziz Airport"
    ],
    "city": [
      "Jizan",
      "Jizan",
      "Jizan"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "ELQ",
    "translations": [
      "Gassim Airport",
      "Gassim Airport",
      "Gassim Airport"
    ],
    "city": [
      "Buraidah",
      "Buraidah",
      "Buraidah"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "URY",
    "translations": [
      "Gurayat Domestic Airport",
      "Gurayat Domestic Airport",
      "Gurayat Domestic Airport"
    ],
    "city": [
      "Gurayat",
      "Gurayat",
      "Gurayat"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "HAS",
    "translations": [
      "Ha'il Airport",
      "Ha'il Airport",
      "Ha'il Airport"
    ],
    "city": [
      "Ha'il",
      "Ha'il",
      "Ha'il"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "QJB",
    "translations": [
      "Jubail Airport",
      "Jubail Airport",
      "Jubail Airport"
    ],
    "city": [
      "Jubail",
      "Jubail",
      "Jubail"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "JED",
    "translations": [
      "King Abdulaziz International Airport",
      "King Abdulaziz International Airport",
      "King Abdulaziz International Airport"
    ],
    "city": [
      "Jeddah",
      "Jeddah",
      "Jeddah"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "KMC",
    "translations": [
      "King Khaled Military City Airport",
      "King Khaled Military City Airport",
      "King Khaled Military City Airport"
    ],
    "city": [
      "King Khaled Military City",
      "King Khaled Military City",
      "King Khaled Military City"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "KMX",
    "translations": [
      "King Khalid Air Base",
      "King Khalid Air Base",
      "King Khalid Air Base"
    ],
    "city": [
      "Khamis Mushait",
      "Khamis Mushait",
      "Khamis Mushait"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "MED",
    "translations": [
      "Prince Mohammad Bin Abdulaziz Airport",
      "Prince Mohammad Bin Abdulaziz Airport",
      "Prince Mohammad Bin Abdulaziz Airport"
    ],
    "city": [
      "Medina",
      "Medina",
      "Medina"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "EAM",
    "translations": [
      "Najran Domestic Airport",
      "Najran Domestic Airport",
      "Najran Domestic Airport"
    ],
    "city": [
      "Najran",
      "Najran",
      "Najran"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "NUM",
    "translations": [
      "Neom Bay Airport",
      "Neom Bay Airport",
      "Neom Bay Airport"
    ],
    "city": [
      "Sharma",
      "Sharma",
      "Sharma"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "AQI",
    "translations": [
      "Al Qaisumah/Hafr Al Batin Airport",
      "Al Qaisumah/Hafr Al Batin Airport",
      "Al Qaisumah/Hafr Al Batin Airport"
    ],
    "city": [
      "Qaisumah",
      "Qaisumah",
      "Qaisumah"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "AKH",
    "translations": [
      "Prince Sultan Air Base",
      "Prince Sultan Air Base",
      "Prince Sultan Air Base"
    ],
    "city": [
      "Al Kharj",
      "Al Kharj",
      "Al Kharj"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "RAH",
    "translations": [
      "Rafha Domestic Airport",
      "Rafha Domestic Airport",
      "Rafha Domestic Airport"
    ],
    "city": [
      "Rafha",
      "Rafha",
      "Rafha"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "RUH",
    "translations": [
      "King Khaled International Airport",
      "King Khaled International Airport",
      "King Khaled International Airport"
    ],
    "city": [
      "Riyadh",
      "Riyadh",
      "Riyadh"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "RAE",
    "translations": [
      "Arar Domestic Airport",
      "Arar Domestic Airport",
      "Arar Domestic Airport"
    ],
    "city": [
      "Arar",
      "Arar",
      "Arar"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "SHW",
    "translations": [
      "Sharurah Domestic Airport",
      "Sharurah Domestic Airport",
      "Sharurah Domestic Airport"
    ],
    "city": [
      "Sharurah",
      "Sharurah",
      "Sharurah"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "AJF",
    "translations": [
      "Al-Jawf Domestic Airport",
      "Al-Jawf Domestic Airport",
      "Al-Jawf Domestic Airport"
    ],
    "city": [
      "Al-Jawf",
      "Al-Jawf",
      "Al-Jawf"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "SLF",
    "translations": [
      "As-Sulayyil Airport",
      "As-Sulayyil Airport",
      "As-Sulayyil Airport"
    ],
    "city": [
      "As-Sulayyil",
      "As-Sulayyil",
      "As-Sulayyil"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "TUU",
    "translations": [
      "Tabuk Airport",
      "Tabuk Airport",
      "Tabuk Airport"
    ],
    "city": [
      "Tabuk",
      "Tabuk",
      "Tabuk"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "TIF",
    "translations": [
      "Ta’if Regional Airport",
      "Ta’if Regional Airport",
      "Ta’if Regional Airport"
    ],
    "city": [
      "Ta’if",
      "Ta’if",
      "Ta’if"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "TUI",
    "translations": [
      "Turaif Domestic Airport",
      "Turaif Domestic Airport",
      "Turaif Domestic Airport"
    ],
    "city": [
      "Turaif",
      "Turaif",
      "Turaif"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "WAE",
    "translations": [
      "Wadi Al Dawasir Domestic Airport",
      "Wadi Al Dawasir Domestic Airport",
      "Wadi Al Dawasir Domestic Airport"
    ],
    "city": [
      "Wadi Al Dawasir",
      "Wadi Al Dawasir",
      "Wadi Al Dawasir"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "EJH",
    "translations": [
      "Al Wajh Domestic Airport",
      "Al Wajh Domestic Airport",
      "Al Wajh Domestic Airport"
    ],
    "city": [
      "Al Wajh",
      "Al Wajh",
      "Al Wajh"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "YNB",
    "translations": [
      "Prince Abdul Mohsin bin Abdulaziz International Airport / Yanbu Airport",
      "Prince Abdul Mohsin bin Abdulaziz International Airport / Yanbu Airport",
      "Prince Abdul Mohsin bin Abdulaziz International Airport / Yanbu Airport"
    ],
    "city": [
      "Yanbu",
      "Yanbu",
      "Yanbu"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "ZUL",
    "translations": [
      "Zilfi Airport",
      "Zilfi Airport",
      "Zilfi Airport"
    ],
    "city": [
      "Zilfi",
      "Zilfi",
      "Zilfi"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "OGM",
    "translations": [
      "Ogobsucum Airport",
      "Ogobsucum Airport",
      "Ogobsucum Airport"
    ],
    "city": [
      "Ustupu",
      "Ustupu",
      "Ustupu"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "IAQ",
    "translations": [
      "Bahregan Airport",
      "Bahregan Airport",
      "Bahregan Airport"
    ],
    "city": [
      "Imam Hassan",
      "Imam Hassan",
      "Imam Hassan"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "ABD",
    "translations": [
      "Abadan Airport",
      "Abadan Airport",
      "Abadan Airport"
    ],
    "city": [
      "Abadan",
      "Abadan",
      "Abadan"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "DEF",
    "translations": [
      "Dezful Airport",
      "Dezful Airport",
      "Dezful Airport"
    ],
    "city": [
      "Dezful",
      "Dezful",
      "Dezful"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "AKW",
    "translations": [
      "Aghajari Airport",
      "Aghajari Airport",
      "Aghajari Airport"
    ],
    "city": [
      "Aghajari",
      "Aghajari",
      "Aghajari"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "GCH",
    "translations": [
      "Gachsaran Airport",
      "Gachsaran Airport",
      "Gachsaran Airport"
    ],
    "city": [
      "Gachsaran",
      "Gachsaran",
      "Gachsaran"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "QMJ",
    "translations": [
      "Shahid Asiyaee Airport",
      "Shahid Asiyaee Airport",
      "Shahid Asiyaee Airport"
    ],
    "city": [
      "Masjed Soleyman",
      "Masjed Soleyman",
      "Masjed Soleyman"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "OMI",
    "translations": [
      "Omidiyeh Airport",
      "Omidiyeh Airport",
      "Omidiyeh Airport"
    ],
    "city": [
      "Omidiyeh",
      "Omidiyeh",
      "Omidiyeh"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "MRX",
    "translations": [
      "Mahshahr Airport",
      "Mahshahr Airport",
      "Mahshahr Airport"
    ],
    "city": [
      "Mahshahr",
      "Mahshahr",
      "Mahshahr"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "AWZ",
    "translations": [
      "Lieutenant General Qasem Soleimani International Airport",
      "Lieutenant General Qasem Soleimani International Airport",
      "Lieutenant General Qasem Soleimani International Airport"
    ],
    "city": [
      "Ahvaz",
      "Ahvaz",
      "Ahvaz"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "AEU",
    "translations": [
      "Abu Musa Island Airport",
      "Abu Musa Island Airport",
      "Abu Musa Island Airport"
    ],
    "city": [
      "Abu Musa",
      "Abu Musa",
      "Abu Musa"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "BUZ",
    "translations": [
      "Bushehr Airport",
      "Bushehr Airport",
      "Bushehr Airport"
    ],
    "city": [
      "Bushehr",
      "Bushehr",
      "Bushehr"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "KNR",
    "translations": [
      "Jam Airport",
      "Jam Airport",
      "Jam Airport"
    ],
    "city": [
      "Jam",
      "Jam",
      "Jam"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "KIH",
    "translations": [
      "Kish International Airport",
      "Kish International Airport",
      "Kish International Airport"
    ],
    "city": [
      "Kish Island",
      "Kish Island",
      "Kish Island"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "BDH",
    "translations": [
      "Bandar Lengeh International Airport",
      "Bandar Lengeh International Airport",
      "Bandar Lengeh International Airport"
    ],
    "city": [
      "Bandar Lengeh",
      "Bandar Lengeh",
      "Bandar Lengeh"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "PGU",
    "translations": [
      "Persian Gulf International Airport",
      "Persian Gulf International Airport",
      "Persian Gulf International Airport"
    ],
    "city": [
      "Khiyaroo",
      "Khiyaroo",
      "Khiyaroo"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "KHK",
    "translations": [
      "Khark Airport",
      "Khark Airport",
      "Khark Airport"
    ],
    "city": [
      "Khark",
      "Khark",
      "Khark"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "SXI",
    "translations": [
      "Siri Airport",
      "Siri Airport",
      "Siri Airport"
    ],
    "city": [
      "Siri",
      "Siri",
      "Siri"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "LVP",
    "translations": [
      "Lavan Airport",
      "Lavan Airport",
      "Lavan Airport"
    ],
    "city": [
      "Lavan Airport",
      "Lavan Airport",
      "Lavan Airport"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "KSH",
    "translations": [
      "Shahid Ashrafi Esfahani Airport",
      "Shahid Ashrafi Esfahani Airport",
      "Shahid Ashrafi Esfahani Airport"
    ],
    "city": [
      "Kermanshah",
      "Kermanshah",
      "Kermanshah"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "IIL",
    "translations": [
      "Ilam Airport",
      "Ilam Airport",
      "Ilam Airport"
    ],
    "city": [
      "Ilam",
      "Ilam",
      "Ilam"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "KHD",
    "translations": [
      "Khoram Abad Airport",
      "Khoram Abad Airport",
      "Khoram Abad Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "SDG",
    "translations": [
      "Sanandaj Airport",
      "Sanandaj Airport",
      "Sanandaj Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "IFH",
    "translations": [
      "Hesa Airport",
      "Hesa Airport",
      "Hesa Airport"
    ],
    "city": [
      "Hesa",
      "Hesa",
      "Hesa"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "KKS",
    "translations": [
      "Kashan Airport",
      "Kashan Airport",
      "Kashan Airport"
    ],
    "city": [
      "Kashan",
      "Kashan",
      "Kashan"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "IFN",
    "translations": [
      "Isfahan Shahid Beheshti International Airport",
      "Isfahan Shahid Beheshti International Airport",
      "Isfahan Shahid Beheshti International Airport"
    ],
    "city": [
      "Isfahan",
      "Isfahan",
      "Isfahan"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "CQD",
    "translations": [
      "Shahrekord Airport",
      "Shahrekord Airport",
      "Shahrekord Airport"
    ],
    "city": [
      "Shahrekord",
      "Shahrekord",
      "Shahrekord"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "RAS",
    "translations": [
      "Sardar-e-Jangal Airport",
      "Sardar-e-Jangal Airport",
      "Sardar-e-Jangal Airport"
    ],
    "city": [
      "Rasht",
      "Rasht",
      "Rasht"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "HDM",
    "translations": [
      "Hamadan Airport",
      "Hamadan Airport",
      "Hamadan Airport"
    ],
    "city": [
      "Hamadan",
      "Hamadan",
      "Hamadan"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "AJK",
    "translations": [
      "Arak Airport",
      "Arak Airport",
      "Arak Airport"
    ],
    "city": [
      "Araak",
      "Araak",
      "Araak"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "NUJ",
    "translations": [
      "Nojeh Air Base",
      "Nojeh Air Base",
      "Nojeh Air Base"
    ],
    "city": [
      "Amirabad",
      "Amirabad",
      "Amirabad"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "IKA",
    "translations": [
      "Imam Khomeini International Airport",
      "Imam Khomeini International Airport",
      "Imam Khomeini International Airport"
    ],
    "city": [
      "Tehran",
      "Tehran",
      "Tehran"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "THR",
    "translations": [
      "Mehrabad International Airport",
      "Mehrabad International Airport",
      "Mehrabad International Airport"
    ],
    "city": [
      "Tehran",
      "Tehran",
      "Tehran"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "GZW",
    "translations": [
      "Qazvin Airport",
      "Qazvin Airport",
      "Qazvin Airport"
    ],
    "city": [
      "Qazvin",
      "Qazvin",
      "Qazvin"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "PYK",
    "translations": [
      "Payam Karaj International Airport",
      "Payam Karaj International Airport",
      "Payam Karaj International Airport"
    ],
    "city": [
      "Karaj",
      "Karaj",
      "Karaj"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "SNX",
    "translations": [
      "Semnan Municipal Airport",
      "Semnan Municipal Airport",
      "Semnan Municipal Airport"
    ],
    "city": [
      "Semnan",
      "Semnan",
      "Semnan"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "BND",
    "translations": [
      "Bandar Abbas International Airport",
      "Bandar Abbas International Airport",
      "Bandar Abbas International Airport"
    ],
    "city": [
      "Bandar Abbas",
      "Bandar Abbas",
      "Bandar Abbas"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "JYR",
    "translations": [
      "Jiroft Airport",
      "Jiroft Airport",
      "Jiroft Airport"
    ],
    "city": [
      "Jiroft",
      "Jiroft",
      "Jiroft"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "KER",
    "translations": [
      "Ayatollah Hashemi Rafsanjani International Airport",
      "Ayatollah Hashemi Rafsanjani International Airport",
      "Ayatollah Hashemi Rafsanjani International Airport"
    ],
    "city": [
      "Kerman",
      "Kerman",
      "Kerman"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "BXR",
    "translations": [
      "Bam Airport",
      "Bam Airport",
      "Bam Airport"
    ],
    "city": [
      "Bam",
      "Bam",
      "Bam"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "HDR",
    "translations": [
      "Havadarya Airport",
      "Havadarya Airport",
      "Havadarya Airport"
    ],
    "city": [
      "Bandar Abbas",
      "Bandar Abbas",
      "Bandar Abbas"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "GSM",
    "translations": [
      "Qeshm Dayrestan International Airport",
      "Qeshm Dayrestan International Airport",
      "Qeshm Dayrestan International Airport"
    ],
    "city": [
      "Dayrestan",
      "Dayrestan",
      "Dayrestan"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "RJN",
    "translations": [
      "Rafsanjan Airport",
      "Rafsanjan Airport",
      "Rafsanjan Airport"
    ],
    "city": [
      "Rafsanjan",
      "Rafsanjan",
      "Rafsanjan"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "SYJ",
    "translations": [
      "Sirjan Airport",
      "Sirjan Airport",
      "Sirjan Airport"
    ],
    "city": [
      "Sirjan",
      "Sirjan",
      "Sirjan"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "XBJ",
    "translations": [
      "Birjand International Airport",
      "Birjand International Airport",
      "Birjand International Airport"
    ],
    "city": [
      "Birjand",
      "Birjand",
      "Birjand"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "CKT",
    "translations": [
      "Sarakhs Airport",
      "Sarakhs Airport",
      "Sarakhs Airport"
    ],
    "city": [
      "Sarakhs",
      "Sarakhs",
      "Sarakhs"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "RUD",
    "translations": [
      "Shahrud International Airport",
      "Shahrud International Airport",
      "Shahrud International Airport"
    ],
    "city": [
      "Shahrud",
      "Shahrud",
      "Shahrud"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "MHD",
    "translations": [
      "Mashhad International Airport",
      "Mashhad International Airport",
      "Mashhad International Airport"
    ],
    "city": [
      "Mashhad",
      "Mashhad",
      "Mashhad"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "BJB",
    "translations": [
      "Bojnord Airport",
      "Bojnord Airport",
      "Bojnord Airport"
    ],
    "city": [
      "Bojnord",
      "Bojnord",
      "Bojnord"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "AFZ",
    "translations": [
      "Sabzevar National Airport",
      "Sabzevar National Airport",
      "Sabzevar National Airport"
    ],
    "city": [
      "Sabzevar",
      "Sabzevar",
      "Sabzevar"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "TCX",
    "translations": [
      "Tabas Airport",
      "Tabas Airport",
      "Tabas Airport"
    ],
    "city": [
      "Tabas",
      "Tabas",
      "Tabas"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "KLM",
    "translations": [
      "Kalaleh Airport",
      "Kalaleh Airport",
      "Kalaleh Airport"
    ],
    "city": [
      "Kalaleh",
      "Kalaleh",
      "Kalaleh"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "GBT",
    "translations": [
      "Gorgan Airport",
      "Gorgan Airport",
      "Gorgan Airport"
    ],
    "city": [
      "Gorgan",
      "Gorgan",
      "Gorgan"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "BSM",
    "translations": [
      "Bishe Kola Air Base",
      "Bishe Kola Air Base",
      "Bishe Kola Air Base"
    ],
    "city": [
      "Amol",
      "Amol",
      "Amol"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "NSH",
    "translations": [
      "Nowshahr Airport",
      "Nowshahr Airport",
      "Nowshahr Airport"
    ],
    "city": [
      "Nowshahr",
      "Nowshahr",
      "Nowshahr"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "RZR",
    "translations": [
      "Ramsar Airport",
      "Ramsar Airport",
      "Ramsar Airport"
    ],
    "city": [
      "Ramsar",
      "Ramsar",
      "Ramsar"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "SRY",
    "translations": [
      "Sari Dasht-e Naz International Airport",
      "Sari Dasht-e Naz International Airport",
      "Sari Dasht-e Naz International Airport"
    ],
    "city": [
      "Sari",
      "Sari",
      "Sari"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "FAZ",
    "translations": [
      "Fasa Airport",
      "Fasa Airport",
      "Fasa Airport"
    ],
    "city": [
      "Fasa",
      "Fasa",
      "Fasa"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "JAR",
    "translations": [
      "Jahrom Airport",
      "Jahrom Airport",
      "Jahrom Airport"
    ],
    "city": [
      "Jahrom",
      "Jahrom",
      "Jahrom"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "LRR",
    "translations": [
      "Lar Airport",
      "Lar Airport",
      "Lar Airport"
    ],
    "city": [
      "Lar",
      "Lar",
      "Lar"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "LFM",
    "translations": [
      "Lamerd Airport",
      "Lamerd Airport",
      "Lamerd Airport"
    ],
    "city": [
      "Lamerd",
      "Lamerd",
      "Lamerd"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "SYZ",
    "translations": [
      "Shiraz Shahid Dastghaib International Airport",
      "Shiraz Shahid Dastghaib International Airport",
      "Shiraz Shahid Dastghaib International Airport"
    ],
    "city": [
      "Shiraz",
      "Shiraz",
      "Shiraz"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "YES",
    "translations": [
      "Yasuj Airport",
      "Yasuj Airport",
      "Yasuj Airport"
    ],
    "city": [
      "Yasuj",
      "Yasuj",
      "Yasuj"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "KHA",
    "translations": [
      "Khaneh Airport",
      "Khaneh Airport",
      "Khaneh Airport"
    ],
    "city": [
      "Khaneh",
      "Khaneh",
      "Khaneh"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "KHY",
    "translations": [
      "Khoy Airport",
      "Khoy Airport",
      "Khoy Airport"
    ],
    "city": [
      "Khoy",
      "Khoy",
      "Khoy"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "ADU",
    "translations": [
      "Ardabil Airport",
      "Ardabil Airport",
      "Ardabil Airport"
    ],
    "city": [
      "Ardabil",
      "Ardabil",
      "Ardabil"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "ACP",
    "translations": [
      "Sahand Airport",
      "Sahand Airport",
      "Sahand Airport"
    ],
    "city": [
      "Maragheh",
      "Maragheh",
      "Maragheh"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "PFQ",
    "translations": [
      "Parsabad-Moghan Airport",
      "Parsabad-Moghan Airport",
      "Parsabad-Moghan Airport"
    ],
    "city": [
      "Parsabad",
      "Parsabad",
      "Parsabad"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "OMH",
    "translations": [
      "Urmia Airport",
      "Urmia Airport",
      "Urmia Airport"
    ],
    "city": [
      "Urmia",
      "Urmia",
      "Urmia"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "TBZ",
    "translations": [
      "Tabriz International Airport",
      "Tabriz International Airport",
      "Tabriz International Airport"
    ],
    "city": [
      "Tabriz",
      "Tabriz",
      "Tabriz"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "IMQ",
    "translations": [
      "Maku National Airport",
      "Maku National Airport",
      "Maku National Airport"
    ],
    "city": [
      "Showt",
      "Showt",
      "Showt"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "JWN",
    "translations": [
      "Zanjan Airport",
      "Zanjan Airport",
      "Zanjan Airport"
    ],
    "city": [
      "Zanjan",
      "Zanjan",
      "Zanjan"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "AZD",
    "translations": [
      "Shahid Sadooghi Airport",
      "Shahid Sadooghi Airport",
      "Shahid Sadooghi Airport"
    ],
    "city": [
      "Yazd",
      "Yazd",
      "Yazd"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "ACZ",
    "translations": [
      "Zabol Airport",
      "Zabol Airport",
      "Zabol Airport"
    ],
    "city": [
      "Zabol",
      "Zabol",
      "Zabol"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "ZBR",
    "translations": [
      "Chabahar Konarak International Airport",
      "Chabahar Konarak International Airport",
      "Chabahar Konarak International Airport"
    ],
    "city": [
      "Konarak",
      "Konarak",
      "Konarak"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "ZAH",
    "translations": [
      "Zahedan International Airport",
      "Zahedan International Airport",
      "Zahedan International Airport"
    ],
    "city": [
      "Zahedan",
      "Zahedan",
      "Zahedan"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "IHR",
    "translations": [
      "Iranshahr Airport",
      "Iranshahr Airport",
      "Iranshahr Airport"
    ],
    "city": [
      "Iranshahr",
      "Iranshahr",
      "Iranshahr"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "JSK",
    "translations": [
      "Jask Airport",
      "Jask Airport",
      "Jask Airport"
    ],
    "city": [
      "Bandar-e-Jask",
      "Bandar-e-Jask",
      "Bandar-e-Jask"
    ],
    "country": [
      "IR",
      "IR",
      "IR"
    ]
  },
  {
    "iata": "AMM",
    "translations": [
      "Queen Alia International Airport",
      "Queen Alia International Airport",
      "Queen Alia International Airport"
    ],
    "city": [
      "Amman",
      "Amman",
      "Amman"
    ],
    "country": [
      "JO",
      "JO",
      "JO"
    ]
  },
  {
    "iata": "ADJ",
    "translations": [
      "Amman Civil (Marka International) Airport",
      "Amman Civil (Marka International) Airport",
      "Amman Civil (Marka International) Airport"
    ],
    "city": [
      "Amman",
      "Amman",
      "Amman"
    ],
    "country": [
      "JO",
      "JO",
      "JO"
    ]
  },
  {
    "iata": "AQJ",
    "translations": [
      "Aqaba King Hussein International Airport",
      "Aqaba King Hussein International Airport",
      "Aqaba King Hussein International Airport"
    ],
    "city": [
      "Aqaba",
      "Aqaba",
      "Aqaba"
    ],
    "country": [
      "JO",
      "JO",
      "JO"
    ]
  },
  {
    "iata": "OMF",
    "translations": [
      "King Hussein Air College",
      "King Hussein Air College",
      "King Hussein Air College"
    ],
    "city": [
      "Mafraq",
      "Mafraq",
      "Mafraq"
    ],
    "country": [
      "JO",
      "JO",
      "JO"
    ]
  },
  {
    "iata": "XIJ",
    "translations": [
      "Ahmed Al Jaber Air Base",
      "Ahmed Al Jaber Air Base",
      "Ahmed Al Jaber Air Base"
    ],
    "city": [
      "Ahmed Al Jaber AB",
      "Ahmed Al Jaber AB",
      "Ahmed Al Jaber AB"
    ],
    "country": [
      "KW",
      "KW",
      "KW"
    ]
  },
  {
    "iata": "KWI",
    "translations": [
      "Kuwait International Airport",
      "Kuwait International Airport",
      "Kuwait International Airport"
    ],
    "city": [
      "Kuwait City",
      "Kuwait City",
      "Kuwait City"
    ],
    "country": [
      "KW",
      "KW",
      "KW"
    ]
  },
  {
    "iata": "BEY",
    "translations": [
      "Beirut Rafic Hariri International Airport",
      "Beirut Rafic Hariri International Airport",
      "Beirut Rafic Hariri International Airport"
    ],
    "city": [
      "Beirut",
      "Beirut",
      "Beirut"
    ],
    "country": [
      "LB",
      "LB",
      "LB"
    ]
  },
  {
    "iata": "OLH",
    "translations": [
      "Old Harbor Airport",
      "Old Harbor Airport",
      "Old Harbor Airport"
    ],
    "city": [
      "Old Harbor",
      "Old Harbor",
      "Old Harbor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KYE",
    "translations": [
      "Rene Mouawad Air Base / Kleyate Airport",
      "Rene Mouawad Air Base / Kleyate Airport",
      "Rene Mouawad Air Base / Kleyate Airport"
    ],
    "city": [
      "Tripoli",
      "Tripoli",
      "Tripoli"
    ],
    "country": [
      "LB",
      "LB",
      "LB"
    ]
  },
  {
    "iata": "BYB",
    "translations": [
      "Dibba Airport",
      "Dibba Airport",
      "Dibba Airport"
    ],
    "city": [
      "Dibba al Baya",
      "Dibba al Baya",
      "Dibba al Baya"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "AOM",
    "translations": [
      "Adam Airport",
      "Adam Airport",
      "Adam Airport"
    ],
    "city": [
      "Adam",
      "Adam",
      "Adam"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "DQM",
    "translations": [
      "Duqm International Airport",
      "Duqm International Airport",
      "Duqm International Airport"
    ],
    "city": [
      "Duqm",
      "Duqm",
      "Duqm"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "MNH",
    "translations": [
      "Mussanah Airport",
      "Mussanah Airport",
      "Mussanah Airport"
    ],
    "city": [
      "Al Masna'ah",
      "Al Masna'ah",
      "Al Masna'ah"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "AUH",
    "translations": [
      "Zayed International Airport",
      "Zayed International Airport",
      "Zayed International Airport"
    ],
    "city": [
      "Abu Dhabi",
      "Abu Dhabi",
      "Abu Dhabi"
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "AZI",
    "translations": [
      "Al Bateen Executive Airport",
      "Al Bateen Executive Airport",
      "Al Bateen Executive Airport"
    ],
    "city": [
      "Abu Dhabi",
      "Abu Dhabi",
      "Abu Dhabi"
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "AAN",
    "translations": [
      "Al Ain International Airport",
      "Al Ain International Airport",
      "Al Ain International Airport"
    ],
    "city": [
      "Al Ain",
      "Al Ain",
      "Al Ain"
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "DHF",
    "translations": [
      "Al Dhafra Air Base",
      "Al Dhafra Air Base",
      "Al Dhafra Air Base"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "XSB",
    "translations": [
      "Sir Bani Yas Airport",
      "Sir Bani Yas Airport",
      "Sir Bani Yas Airport"
    ],
    "city": [
      "Sir Bani Yas",
      "Sir Bani Yas",
      "Sir Bani Yas"
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "DXB",
    "translations": [
      "Dubai International Airport",
      "Dubai International Airport",
      "Dubai International Airport"
    ],
    "city": [
      "Dubai",
      "Dubai",
      "Dubai"
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "ZDY",
    "translations": [
      "Delma Airport",
      "Delma Airport",
      "Delma Airport"
    ],
    "city": [
      "Delma Island",
      "Delma Island",
      "Delma Island"
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "NHD",
    "translations": [
      "Al Minhad Air Base",
      "Al Minhad Air Base",
      "Al Minhad Air Base"
    ],
    "city": [
      "Dubai",
      "Dubai",
      "Dubai"
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "DWC",
    "translations": [
      "Al Maktoum International Airport",
      "Al Maktoum International Airport",
      "Al Maktoum International Airport"
    ],
    "city": [
      "Jebel Ali",
      "Jebel Ali",
      "Jebel Ali"
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "FJR",
    "translations": [
      "Fujairah International Airport",
      "Fujairah International Airport",
      "Fujairah International Airport"
    ],
    "city": [
      "Fujairah",
      "Fujairah",
      "Fujairah"
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "RKT",
    "translations": [
      "Ras Al Khaimah International Airport",
      "Ras Al Khaimah International Airport",
      "Ras Al Khaimah International Airport"
    ],
    "city": [
      "Ras Al Khaimah",
      "Ras Al Khaimah",
      "Ras Al Khaimah"
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "SHJ",
    "translations": [
      "Sharjah International Airport",
      "Sharjah International Airport",
      "Sharjah International Airport"
    ],
    "city": [
      "Sharjah",
      "Sharjah",
      "Sharjah"
    ],
    "country": [
      "AE",
      "AE",
      "AE"
    ]
  },
  {
    "iata": "OMY",
    "translations": [
      "Preah Vinhear Airport",
      "Preah Vinhear Airport",
      "Preah Vinhear Airport"
    ],
    "city": [
      "Tbeng Meanchey",
      "Tbeng Meanchey",
      "Tbeng Meanchey"
    ],
    "country": [
      "KH",
      "KH",
      "KH"
    ]
  },
  {
    "iata": "RMB",
    "translations": [
      "Buraimi Airport",
      "Buraimi Airport",
      "Buraimi Airport"
    ],
    "city": [
      "Buraimi",
      "Buraimi",
      "Buraimi"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "FAU",
    "translations": [
      "Fahud Airport",
      "Fahud Airport",
      "Fahud Airport"
    ],
    "city": [
      "Fahud",
      "Fahud",
      "Fahud"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "RNM",
    "translations": [
      "Qarn Alam Airport",
      "Qarn Alam Airport",
      "Qarn Alam Airport"
    ],
    "city": [
      "Ghaba",
      "Ghaba",
      "Ghaba"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "JNJ",
    "translations": [
      "Ja'Aluni Airport",
      "Ja'Aluni Airport",
      "Ja'Aluni Airport"
    ],
    "city": [
      "Duqm",
      "Duqm",
      "Duqm"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "KHS",
    "translations": [
      "Khasab Airport",
      "Khasab Airport",
      "Khasab Airport"
    ],
    "city": [
      "Khasab",
      "Khasab",
      "Khasab"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "LKW",
    "translations": [
      "Lekhwair Airport",
      "Lekhwair Airport",
      "Lekhwair Airport"
    ],
    "city": [
      "Lekhwair",
      "Lekhwair",
      "Lekhwair"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "MSH",
    "translations": [
      "RAFO Masirah",
      "RAFO Masirah",
      "RAFO Masirah"
    ],
    "city": [
      "Masirah",
      "Masirah",
      "Masirah"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "MCT",
    "translations": [
      "Muscat International Airport",
      "Muscat International Airport",
      "Muscat International Airport"
    ],
    "city": [
      "Muscat",
      "Muscat",
      "Muscat"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "OMM",
    "translations": [
      "Marmul Airport",
      "Marmul Airport",
      "Marmul Airport"
    ],
    "city": [
      "Marmul",
      "Marmul",
      "Marmul"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "SLL",
    "translations": [
      "Salalah Airport",
      "Salalah Airport",
      "Salalah Airport"
    ],
    "city": [
      "Salalah",
      "Salalah",
      "Salalah"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "OHS",
    "translations": [
      "Sohar Airport",
      "Sohar Airport",
      "Sohar Airport"
    ],
    "city": [
      "Sohar",
      "Sohar",
      "Sohar"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "TTH",
    "translations": [
      "Thumrait Air Base",
      "Thumrait Air Base",
      "Thumrait Air Base"
    ],
    "city": [
      "Thumrait",
      "Thumrait",
      "Thumrait"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "DDU",
    "translations": [
      "Dadu West Airport",
      "Dadu West Airport",
      "Dadu West Airport"
    ],
    "city": [
      "Dadu",
      "Dadu",
      "Dadu"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "BHW",
    "translations": [
      "Bhagatanwala Airport",
      "Bhagatanwala Airport",
      "Bhagatanwala Airport"
    ],
    "city": [
      "Bhagatanwala",
      "Bhagatanwala",
      "Bhagatanwala"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "BNP",
    "translations": [
      "Bannu Airport",
      "Bannu Airport",
      "Bannu Airport"
    ],
    "city": [
      "Bannu",
      "Bannu",
      "Bannu"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "WGB",
    "translations": [
      "Bahawalnagar Airport",
      "Bahawalnagar Airport",
      "Bahawalnagar Airport"
    ],
    "city": [
      "Bahawalnagar",
      "Bahawalnagar",
      "Bahawalnagar"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "BHV",
    "translations": [
      "Bahawalpur Airport",
      "Bahawalpur Airport",
      "Bahawalpur Airport"
    ],
    "city": [
      "Bahawalpur",
      "Bahawalpur",
      "Bahawalpur"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "CJL",
    "translations": [
      "Chitral Airport",
      "Chitral Airport",
      "Chitral Airport"
    ],
    "city": [
      "Chitral",
      "Chitral",
      "Chitral"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "CHB",
    "translations": [
      "Chilas Airport",
      "Chilas Airport",
      "Chilas Airport"
    ],
    "city": [
      "Chilas",
      "Chilas",
      "Chilas"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "DBA",
    "translations": [
      "Dalbandin Airport",
      "Dalbandin Airport",
      "Dalbandin Airport"
    ],
    "city": [
      "Dalbandin",
      "Dalbandin",
      "Dalbandin"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "DEA",
    "translations": [
      "Dera Ghazi Khan Airport",
      "Dera Ghazi Khan Airport",
      "Dera Ghazi Khan Airport"
    ],
    "city": [
      "Dera Ghazi Khan",
      "Dera Ghazi Khan",
      "Dera Ghazi Khan"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "DSK",
    "translations": [
      "Dera Ismael Khan Airport",
      "Dera Ismael Khan Airport",
      "Dera Ismael Khan Airport"
    ],
    "city": [
      "Dera Ismael Khan",
      "Dera Ismael Khan",
      "Dera Ismael Khan"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "LYP",
    "translations": [
      "Faisalabad International Airport",
      "Faisalabad International Airport",
      "Faisalabad International Airport"
    ],
    "city": [
      "Faisalabad",
      "Faisalabad",
      "Faisalabad"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "GWD",
    "translations": [
      "New Gwadar International Airport",
      "New Gwadar International Airport",
      "New Gwadar International Airport"
    ],
    "city": [
      "Gurandani",
      "Gurandani",
      "Gurandani"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "GIL",
    "translations": [
      "Gilgit Airport",
      "Gilgit Airport",
      "Gilgit Airport"
    ],
    "city": [
      "Gilgit",
      "Gilgit",
      "Gilgit"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "ISB",
    "translations": [
      "Islamabad International Airport",
      "Islamabad International Airport",
      "Islamabad International Airport"
    ],
    "city": [
      "Attock",
      "Attock",
      "Attock"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "JAG",
    "translations": [
      "Shahbaz Air Base",
      "Shahbaz Air Base",
      "Shahbaz Air Base"
    ],
    "city": [
      "Jacobabad",
      "Jacobabad",
      "Jacobabad"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "KHI",
    "translations": [
      "Jinnah International Airport",
      "Jinnah International Airport",
      "Jinnah International Airport"
    ],
    "city": [
      "Karachi",
      "Karachi",
      "Karachi"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "HDD",
    "translations": [
      "Hyderabad Airport",
      "Hyderabad Airport",
      "Hyderabad Airport"
    ],
    "city": [
      "Hyderabad",
      "Hyderabad",
      "Hyderabad"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "KDD",
    "translations": [
      "Khuzdar Airport",
      "Khuzdar Airport",
      "Khuzdar Airport"
    ],
    "city": [
      "Khuzdar",
      "Khuzdar",
      "Khuzdar"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "OHT",
    "translations": [
      "Kohat Airport",
      "Kohat Airport",
      "Kohat Airport"
    ],
    "city": [
      "Kohat",
      "Kohat",
      "Kohat"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "LHE",
    "translations": [
      "Allama Iqbal International Airport",
      "Allama Iqbal International Airport",
      "Allama Iqbal International Airport"
    ],
    "city": [
      "Lahore",
      "Lahore",
      "Lahore"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "LRG",
    "translations": [
      "Loralai Airport",
      "Loralai Airport",
      "Loralai Airport"
    ],
    "city": [
      "Loralai",
      "Loralai",
      "Loralai"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "XJM",
    "translations": [
      "Mangla Airport",
      "Mangla Airport",
      "Mangla Airport"
    ],
    "city": [
      "Mangla",
      "Mangla",
      "Mangla"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "MFG",
    "translations": [
      "Muzaffarabad Airport",
      "Muzaffarabad Airport",
      "Muzaffarabad Airport"
    ],
    "city": [
      "Muzaffarabad",
      "Muzaffarabad",
      "Muzaffarabad"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "MWD",
    "translations": [
      "Mianwali Air Base",
      "Mianwali Air Base",
      "Mianwali Air Base"
    ],
    "city": [
      "Mianwali",
      "Mianwali",
      "Mianwali"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "MJD",
    "translations": [
      "Moenjodaro Airport",
      "Moenjodaro Airport",
      "Moenjodaro Airport"
    ],
    "city": [
      "Moenjodaro",
      "Moenjodaro",
      "Moenjodaro"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "MPD",
    "translations": [
      "Sindhri Tharparkar Airport",
      "Sindhri Tharparkar Airport",
      "Sindhri Tharparkar Airport"
    ],
    "city": [
      "Sindhri",
      "Sindhri",
      "Sindhri"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "ATG",
    "translations": [
      "Minhas Air Base",
      "Minhas Air Base",
      "Minhas Air Base"
    ],
    "city": [
      "Kamra",
      "Kamra",
      "Kamra"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "MUX",
    "translations": [
      "Multan International Airport",
      "Multan International Airport",
      "Multan International Airport"
    ],
    "city": [
      "Multan",
      "Multan",
      "Multan"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "WNS",
    "translations": [
      "Shaheed Benazirabad Airport",
      "Shaheed Benazirabad Airport",
      "Shaheed Benazirabad Airport"
    ],
    "city": [
      "Nawabashah",
      "Nawabashah",
      "Nawabashah"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "ORW",
    "translations": [
      "Ormara Airport",
      "Ormara Airport",
      "Ormara Airport"
    ],
    "city": [
      "Ormara Raik",
      "Ormara Raik",
      "Ormara Raik"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "PAJ",
    "translations": [
      "Parachinar Airport",
      "Parachinar Airport",
      "Parachinar Airport"
    ],
    "city": [
      "Parachinar",
      "Parachinar",
      "Parachinar"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "PJG",
    "translations": [
      "Panjgur Airport",
      "Panjgur Airport",
      "Panjgur Airport"
    ],
    "city": [
      "Panjgur",
      "Panjgur",
      "Panjgur"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "PSI",
    "translations": [
      "Pasni Airport",
      "Pasni Airport",
      "Pasni Airport"
    ],
    "city": [
      "Pasni",
      "Pasni",
      "Pasni"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "PEW",
    "translations": [
      "Peshawar International Airport",
      "Peshawar International Airport",
      "Peshawar International Airport"
    ],
    "city": [
      "Peshawar",
      "Peshawar",
      "Peshawar"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "UET",
    "translations": [
      "Quetta International Airport",
      "Quetta International Airport",
      "Quetta International Airport"
    ],
    "city": [
      "Quetta",
      "Quetta",
      "Quetta"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "RYK",
    "translations": [
      "Shaikh Zaid Airport",
      "Shaikh Zaid Airport",
      "Shaikh Zaid Airport"
    ],
    "city": [
      "Rahim Yar Khan",
      "Rahim Yar Khan",
      "Rahim Yar Khan"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "RAZ",
    "translations": [
      "Rawalakot Airport",
      "Rawalakot Airport",
      "Rawalakot Airport"
    ],
    "city": [
      "Rawalakot",
      "Rawalakot",
      "Rawalakot"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "SBQ",
    "translations": [
      "Sibi Airport",
      "Sibi Airport",
      "Sibi Airport"
    ],
    "city": [
      "Sibi",
      "Sibi",
      "Sibi"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "KDU",
    "translations": [
      "Skardu Airport",
      "Skardu Airport",
      "Skardu Airport"
    ],
    "city": [
      "Skardu",
      "Skardu",
      "Skardu"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "SKZ",
    "translations": [
      "Sukkur Airport",
      "Sukkur Airport",
      "Sukkur Airport"
    ],
    "city": [
      "Mirpur Khas",
      "Mirpur Khas",
      "Mirpur Khas"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "SYW",
    "translations": [
      "Sehwan Sharif Airport",
      "Sehwan Sharif Airport",
      "Sehwan Sharif Airport"
    ],
    "city": [
      "Sehwan Sharif",
      "Sehwan Sharif",
      "Sehwan Sharif"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "SGI",
    "translations": [
      "Mushaf Air Base",
      "Mushaf Air Base",
      "Mushaf Air Base"
    ],
    "city": [
      "Sargodha",
      "Sargodha",
      "Sargodha"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "SDT",
    "translations": [
      "Saidu Sharif Airport",
      "Saidu Sharif Airport",
      "Saidu Sharif Airport"
    ],
    "city": [
      "Saidu Sharif",
      "Saidu Sharif",
      "Saidu Sharif"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "SKT",
    "translations": [
      "Sialkot International Airport",
      "Sialkot International Airport",
      "Sialkot International Airport"
    ],
    "city": [
      "Sialkot",
      "Sialkot",
      "Sialkot"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "SUL",
    "translations": [
      "Sui Airport",
      "Sui Airport",
      "Sui Airport"
    ],
    "city": [
      "Sui",
      "Sui",
      "Sui"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "RZS",
    "translations": [
      "Sawan Airport",
      "Sawan Airport",
      "Sawan Airport"
    ],
    "city": [
      "Sawan Gas Field",
      "Sawan Gas Field",
      "Sawan Gas Field"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "TLB",
    "translations": [
      "Tarbela Dam Airport",
      "Tarbela Dam Airport",
      "Tarbela Dam Airport"
    ],
    "city": [
      "Tarbela",
      "Tarbela",
      "Tarbela"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "BDN",
    "translations": [
      "Talhar Airport",
      "Talhar Airport",
      "Talhar Airport"
    ],
    "city": [
      "Badin",
      "Badin",
      "Badin"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "TFT",
    "translations": [
      "Taftan Airport",
      "Taftan Airport",
      "Taftan Airport"
    ],
    "city": [
      "Taftan",
      "Taftan",
      "Taftan"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "TUK",
    "translations": [
      "Turbat International Airport",
      "Turbat International Airport",
      "Turbat International Airport"
    ],
    "city": [
      "Turbat",
      "Turbat",
      "Turbat"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "WAF",
    "translations": [
      "Wana Airport",
      "Wana Airport",
      "Wana Airport"
    ],
    "city": [
      "Waana",
      "Waana",
      "Waana"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "PZH",
    "translations": [
      "Zhob Airport",
      "Zhob Airport",
      "Zhob Airport"
    ],
    "city": [
      "Fort Sandeman",
      "Fort Sandeman",
      "Fort Sandeman"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "IQA",
    "translations": [
      "Al Asad Air Base",
      "Al Asad Air Base",
      "Al Asad Air Base"
    ],
    "city": [
      "Hīt",
      "Hīt",
      "Hīt"
    ],
    "country": [
      "IQ",
      "IQ",
      "IQ"
    ]
  },
  {
    "iata": "TQD",
    "translations": [
      "Al Taqaddum Air Base",
      "Al Taqaddum Air Base",
      "Al Taqaddum Air Base"
    ],
    "city": [
      "Al Habbaniyah",
      "Al Habbaniyah",
      "Al Habbaniyah"
    ],
    "country": [
      "IQ",
      "IQ",
      "IQ"
    ]
  },
  {
    "iata": "BMN",
    "translations": [
      "Bamarni Airport",
      "Bamarni Airport",
      "Bamarni Airport"
    ],
    "city": [
      "Bamarni",
      "Bamarni",
      "Bamarni"
    ],
    "country": [
      "IQ",
      "IQ",
      "IQ"
    ]
  },
  {
    "iata": "BGW",
    "translations": [
      "Baghdad International Airport / New Al Muthana Air Base",
      "Baghdad International Airport / New Al Muthana Air Base",
      "Baghdad International Airport / New Al Muthana Air Base"
    ],
    "city": [
      "Baghdad",
      "Baghdad",
      "Baghdad"
    ],
    "country": [
      "IQ",
      "IQ",
      "IQ"
    ]
  },
  {
    "iata": "OSM",
    "translations": [
      "Mosul International Airport",
      "Mosul International Airport",
      "Mosul International Airport"
    ],
    "city": [
      "Mosul",
      "Mosul",
      "Mosul"
    ],
    "country": [
      "IQ",
      "IQ",
      "IQ"
    ]
  },
  {
    "iata": "EBL",
    "translations": [
      "Erbil International Airport",
      "Erbil International Airport",
      "Erbil International Airport"
    ],
    "city": [
      "Arbil",
      "Arbil",
      "Arbil"
    ],
    "country": [
      "IQ",
      "IQ",
      "IQ"
    ]
  },
  {
    "iata": "ORI",
    "translations": [
      "Port Lions Airport",
      "Port Lions Airport",
      "Port Lions Airport"
    ],
    "city": [
      "Port Lions",
      "Port Lions",
      "Port Lions"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KIK",
    "translations": [
      "Kirkuk Air Base",
      "Kirkuk Air Base",
      "Kirkuk Air Base"
    ],
    "city": [
      "Kirkuk",
      "Kirkuk",
      "Kirkuk"
    ],
    "country": [
      "IQ",
      "IQ",
      "IQ"
    ]
  },
  {
    "iata": "BSR",
    "translations": [
      "Basra International Airport",
      "Basra International Airport",
      "Basra International Airport"
    ],
    "city": [
      "Basra",
      "Basra",
      "Basra"
    ],
    "country": [
      "IQ",
      "IQ",
      "IQ"
    ]
  },
  {
    "iata": "NJF",
    "translations": [
      "Al Najaf International Airport",
      "Al Najaf International Airport",
      "Al Najaf International Airport"
    ],
    "city": [
      "Najaf",
      "Najaf",
      "Najaf"
    ],
    "country": [
      "IQ",
      "IQ",
      "IQ"
    ]
  },
  {
    "iata": "RQW",
    "translations": [
      "Qayyarah West Airport",
      "Qayyarah West Airport",
      "Qayyarah West Airport"
    ],
    "city": [
      "Qayyarah",
      "Qayyarah",
      "Qayyarah"
    ],
    "country": [
      "IQ",
      "IQ",
      "IQ"
    ]
  },
  {
    "iata": "ISU",
    "translations": [
      "Sulaymaniyah International Airport",
      "Sulaymaniyah International Airport",
      "Sulaymaniyah International Airport"
    ],
    "city": [
      "Sulaymaniyah",
      "Sulaymaniyah",
      "Sulaymaniyah"
    ],
    "country": [
      "IQ",
      "IQ",
      "IQ"
    ]
  },
  {
    "iata": "XNH",
    "translations": [
      "Ali Air Base",
      "Ali Air Base",
      "Ali Air Base"
    ],
    "city": [
      "Nasiriyah",
      "Nasiriyah",
      "Nasiriyah"
    ],
    "country": [
      "IQ",
      "IQ",
      "IQ"
    ]
  },
  {
    "iata": "ALP",
    "translations": [
      "Aleppo International Airport",
      "Aleppo International Airport",
      "Aleppo International Airport"
    ],
    "city": [
      "Aleppo",
      "Aleppo",
      "Aleppo"
    ],
    "country": [
      "SY",
      "SY",
      "SY"
    ]
  },
  {
    "iata": "DAM",
    "translations": [
      "Damascus International Airport",
      "Damascus International Airport",
      "Damascus International Airport"
    ],
    "city": [
      "Damascus",
      "Damascus",
      "Damascus"
    ],
    "country": [
      "SY",
      "SY",
      "SY"
    ]
  },
  {
    "iata": "DEZ",
    "translations": [
      "Deir ez-Zor Airport",
      "Deir ez-Zor Airport",
      "Deir ez-Zor Airport"
    ],
    "city": [
      "Deir ez-Zor",
      "Deir ez-Zor",
      "Deir ez-Zor"
    ],
    "country": [
      "SY",
      "SY",
      "SY"
    ]
  },
  {
    "iata": "KAC",
    "translations": [
      "Qamishli Airport",
      "Qamishli Airport",
      "Qamishli Airport"
    ],
    "city": [
      "Qamishly",
      "Qamishly",
      "Qamishly"
    ],
    "country": [
      "SY",
      "SY",
      "SY"
    ]
  },
  {
    "iata": "LTK",
    "translations": [
      "Hmeimim Air Base",
      "Hmeimim Air Base",
      "Hmeimim Air Base"
    ],
    "city": [
      "Latakia",
      "Latakia",
      "Latakia"
    ],
    "country": [
      "SY",
      "SY",
      "SY"
    ]
  },
  {
    "iata": "PMS",
    "translations": [
      "Palmyra Airport",
      "Palmyra Airport",
      "Palmyra Airport"
    ],
    "city": [
      "Tadmur",
      "Tadmur",
      "Tadmur"
    ],
    "country": [
      "SY",
      "SY",
      "SY"
    ]
  },
  {
    "iata": "DIA",
    "translations": [
      "Doha International Airport",
      "Doha International Airport",
      "Doha International Airport"
    ],
    "city": [
      "Doha",
      "Doha",
      "Doha"
    ],
    "country": [
      "QA",
      "QA",
      "QA"
    ]
  },
  {
    "iata": "XJD",
    "translations": [
      "Al Udeid Air Base",
      "Al Udeid Air Base",
      "Al Udeid Air Base"
    ],
    "city": [
      "Ar Rayyan",
      "Ar Rayyan",
      "Ar Rayyan"
    ],
    "country": [
      "QA",
      "QA",
      "QA"
    ]
  },
  {
    "iata": "DOH",
    "translations": [
      "Hamad International Airport",
      "Hamad International Airport",
      "Hamad International Airport"
    ],
    "city": [
      "Doha",
      "Doha",
      "Doha"
    ],
    "country": [
      "QA",
      "QA",
      "QA"
    ]
  },
  {
    "iata": "OTT",
    "translations": [
      "Andre Maggi Airport",
      "Andre Maggi Airport",
      "Andre Maggi Airport"
    ],
    "city": [
      "Cotriguaçu",
      "Cotriguaçu",
      "Cotriguaçu"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "OUM",
    "translations": [
      "Oum Hadjer Airport",
      "Oum Hadjer Airport",
      "Oum Hadjer Airport"
    ],
    "city": [
      "Oum Hadjer",
      "Oum Hadjer",
      "Oum Hadjer"
    ],
    "country": [
      "TD",
      "TD",
      "TD"
    ]
  },
  {
    "iata": "OXO",
    "translations": [
      "Orientos Airport",
      "Orientos Airport",
      "Orientos Airport"
    ],
    "city": [
      "Orientos",
      "Orientos",
      "Orientos"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ADE",
    "translations": [
      "Aden International Airport",
      "Aden International Airport",
      "Aden International Airport"
    ],
    "city": [
      "Aden",
      "Aden",
      "Aden"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "EAB",
    "translations": [
      "Abs Airport",
      "Abs Airport",
      "Abs Airport"
    ],
    "city": [
      "Abs",
      "Abs",
      "Abs"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "AXK",
    "translations": [
      "Ataq Airport",
      "Ataq Airport",
      "Ataq Airport"
    ],
    "city": [
      "Ataq",
      "Ataq",
      "Ataq"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "BYD",
    "translations": [
      "Al-Bayda Airport",
      "Al-Bayda Airport",
      "Al-Bayda Airport"
    ],
    "city": [
      "Al-Bayda",
      "Al-Bayda",
      "Al-Bayda"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "BHN",
    "translations": [
      "Beihan Airport",
      "Beihan Airport",
      "Beihan Airport"
    ],
    "city": [
      "Beihan",
      "Beihan",
      "Beihan"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "BUK",
    "translations": [
      "Al-Bough Airport",
      "Al-Bough Airport",
      "Al-Bough Airport"
    ],
    "city": [
      "Al-Bough",
      "Al-Bough",
      "Al-Bough"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "AAY",
    "translations": [
      "Al Ghaydah International Airport",
      "Al Ghaydah International Airport",
      "Al Ghaydah International Airport"
    ],
    "city": [
      "Al Ghaydah",
      "Al Ghaydah",
      "Al Ghaydah"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "KAM",
    "translations": [
      "Kamaran Airport",
      "Kamaran Airport",
      "Kamaran Airport"
    ],
    "city": [
      "Kamaran",
      "Kamaran",
      "Kamaran"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "MYN",
    "translations": [
      "Marib Airport",
      "Marib Airport",
      "Marib Airport"
    ],
    "city": [
      "Marib",
      "Marib",
      "Marib"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "UKR",
    "translations": [
      "Mukeiras Airport",
      "Mukeiras Airport",
      "Mukeiras Airport"
    ],
    "city": [
      "Mukayras",
      "Mukayras",
      "Mukayras"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "IHN",
    "translations": [
      "Qishn Airport",
      "Qishn Airport",
      "Qishn Airport"
    ],
    "city": [
      "Qishn",
      "Qishn",
      "Qishn"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "RIY",
    "translations": [
      "Riyan Mukalla International Airport",
      "Riyan Mukalla International Airport",
      "Riyan Mukalla International Airport"
    ],
    "city": [
      "Riyan",
      "Riyan",
      "Riyan"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "SYE",
    "translations": [
      "Sadah Airport",
      "Sadah Airport",
      "Sadah Airport"
    ],
    "city": [
      "Sa'dah",
      "Sa'dah",
      "Sa'dah"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "SAH",
    "translations": [
      "Sanaa International Airport",
      "Sanaa International Airport",
      "Sanaa International Airport"
    ],
    "city": [
      "Sanaa",
      "Sanaa",
      "Sanaa"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "SCT",
    "translations": [
      "Socotra International Airport",
      "Socotra International Airport",
      "Socotra International Airport"
    ],
    "city": [
      "Mori",
      "Mori",
      "Mori"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "GXF",
    "translations": [
      "Seiyun Hadhramaut International Airport",
      "Seiyun Hadhramaut International Airport",
      "Seiyun Hadhramaut International Airport"
    ],
    "city": [
      "Seiyun",
      "Seiyun",
      "Seiyun"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "TAI",
    "translations": [
      "Ta'izz International Airport",
      "Ta'izz International Airport",
      "Ta'izz International Airport"
    ],
    "city": [
      "Ta'izz",
      "Ta'izz",
      "Ta'izz"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "ACU",
    "translations": [
      "Achutupu Airport",
      "Achutupu Airport",
      "Achutupu Airport"
    ],
    "city": [
      "Mamitupu",
      "Mamitupu",
      "Mamitupu"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "AIL",
    "translations": [
      "Ailigandí Airport",
      "Ailigandí Airport",
      "Ailigandí Airport"
    ],
    "city": [
      "Isla Lorenzo Bello",
      "Isla Lorenzo Bello",
      "Isla Lorenzo Bello"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "CTE",
    "translations": [
      "Cartí Airport",
      "Cartí Airport",
      "Cartí Airport"
    ],
    "city": [
      "Cartí Islands",
      "Cartí Islands",
      "Cartí Islands"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "MPP",
    "translations": [
      "Mulatupo Airport",
      "Mulatupo Airport",
      "Mulatupo Airport"
    ],
    "city": [
      "Mulatupo",
      "Mulatupo",
      "Mulatupo"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "PYC",
    "translations": [
      "Playón Chico Airport",
      "Playón Chico Airport",
      "Playón Chico Airport"
    ],
    "city": [
      "Ukupseni",
      "Ukupseni",
      "Ukupseni"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "NMG",
    "translations": [
      "San Miguel Airport",
      "San Miguel Airport",
      "San Miguel Airport"
    ],
    "city": [
      "Isla del Rey",
      "Isla del Rey",
      "Isla del Rey"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "TUW",
    "translations": [
      "Tubualá Airport",
      "Tubualá Airport",
      "Tubualá Airport"
    ],
    "city": [
      "Coetupo",
      "Coetupo",
      "Coetupo"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "PYV",
    "translations": [
      "Yaviza Airport",
      "Yaviza Airport",
      "Yaviza Airport"
    ],
    "city": [
      "Yaviza",
      "Yaviza",
      "Yaviza"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "AML",
    "translations": [
      "Puerto Armuelles Airport",
      "Puerto Armuelles Airport",
      "Puerto Armuelles Airport"
    ],
    "city": [
      "Puerto Armuelles",
      "Puerto Armuelles",
      "Puerto Armuelles"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "BFQ",
    "translations": [
      "Bahia Piña Airport",
      "Bahia Piña Airport",
      "Bahia Piña Airport"
    ],
    "city": [
      "Puerto Piña",
      "Puerto Piña",
      "Puerto Piña"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "ELE",
    "translations": [
      "EL Real Airport",
      "EL Real Airport",
      "EL Real Airport"
    ],
    "city": [
      "El Real de Santa María",
      "El Real de Santa María",
      "El Real de Santa María"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "OTD",
    "translations": [
      "Raul Arias Espinoza Airport",
      "Raul Arias Espinoza Airport",
      "Raul Arias Espinoza Airport"
    ],
    "city": [
      "Contadora Island",
      "Contadora Island",
      "Contadora Island"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "SAX",
    "translations": [
      "Sambú Airport",
      "Sambú Airport",
      "Sambú Airport"
    ],
    "city": [
      "Boca de Sábalo",
      "Boca de Sábalo",
      "Boca de Sábalo"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "AKB",
    "translations": [
      "Atka Airport",
      "Atka Airport",
      "Atka Airport"
    ],
    "city": [
      "Atka",
      "Atka",
      "Atka"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PML",
    "translations": [
      "Port Moller Airport",
      "Port Moller Airport",
      "Port Moller Airport"
    ],
    "city": [
      "Cold Bay",
      "Cold Bay",
      "Cold Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PTD",
    "translations": [
      "Port Alexander Seaplane Base",
      "Port Alexander Seaplane Base",
      "Port Alexander Seaplane Base"
    ],
    "city": [
      "Port Alexander",
      "Port Alexander",
      "Port Alexander"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PAQ",
    "translations": [
      "Warren \"Bud\" Woods Palmer Municipal Airport",
      "Warren \"Bud\" Woods Palmer Municipal Airport",
      "Warren \"Bud\" Woods Palmer Municipal Airport"
    ],
    "city": [
      "Palmer",
      "Palmer",
      "Palmer"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ATU",
    "translations": [
      "Casco Cove Coast Guard Station",
      "Casco Cove Coast Guard Station",
      "Casco Cove Coast Guard Station"
    ],
    "city": [
      "Attu",
      "Attu",
      "Attu"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BTI",
    "translations": [
      "Barter Island Long Range Radar Station Airport",
      "Barter Island Long Range Radar Station Airport",
      "Barter Island Long Range Radar Station Airport"
    ],
    "city": [
      "Barter Island",
      "Barter Island",
      "Barter Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BET",
    "translations": [
      "Bethel Airport",
      "Bethel Airport",
      "Bethel Airport"
    ],
    "city": [
      "Bethel",
      "Bethel",
      "Bethel"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BVU",
    "translations": [
      "Beluga Airport",
      "Beluga Airport",
      "Beluga Airport"
    ],
    "city": [
      "Beluga",
      "Beluga",
      "Beluga"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BIG",
    "translations": [
      "Allen Army Airfield",
      "Allen Army Airfield",
      "Allen Army Airfield"
    ],
    "city": [
      "Delta Junction Ft Greely",
      "Delta Junction Ft Greely",
      "Delta Junction Ft Greely"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BKC",
    "translations": [
      "Buckland Airport",
      "Buckland Airport",
      "Buckland Airport"
    ],
    "city": [
      "Buckland",
      "Buckland",
      "Buckland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BMX",
    "translations": [
      "Big Mountain Airport",
      "Big Mountain Airport",
      "Big Mountain Airport"
    ],
    "city": [
      "Big Mountain",
      "Big Mountain",
      "Big Mountain"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BRW",
    "translations": [
      "Wiley Post Will Rogers Memorial Airport",
      "Wiley Post Will Rogers Memorial Airport",
      "Wiley Post Will Rogers Memorial Airport"
    ],
    "city": [
      "Utqiaġvik",
      "Utqiaġvik",
      "Utqiaġvik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BTT",
    "translations": [
      "Bettles Airport",
      "Bettles Airport",
      "Bettles Airport"
    ],
    "city": [
      "Bettles",
      "Bettles",
      "Bettles"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CDB",
    "translations": [
      "Cold Bay Airport",
      "Cold Bay Airport",
      "Cold Bay Airport"
    ],
    "city": [
      "Cold Bay",
      "Cold Bay",
      "Cold Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CEM",
    "translations": [
      "Central Airport",
      "Central Airport",
      "Central Airport"
    ],
    "city": [
      "Central",
      "Central",
      "Central"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CIK",
    "translations": [
      "Chalkyitsik Airport",
      "Chalkyitsik Airport",
      "Chalkyitsik Airport"
    ],
    "city": [
      "Chalkyitsik",
      "Chalkyitsik",
      "Chalkyitsik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CYF",
    "translations": [
      "Chefornak Airport",
      "Chefornak Airport",
      "Chefornak Airport"
    ],
    "city": [
      "Chefornak",
      "Chefornak",
      "Chefornak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SCM",
    "translations": [
      "Scammon Bay Airport",
      "Scammon Bay Airport",
      "Scammon Bay Airport"
    ],
    "city": [
      "Scammon Bay",
      "Scammon Bay",
      "Scammon Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IRC",
    "translations": [
      "Circle City (New) Airport",
      "Circle City (New) Airport",
      "Circle City (New) Airport"
    ],
    "city": [
      "Circle",
      "Circle",
      "Circle"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WSF",
    "translations": [
      "Cape Sarichef Airport",
      "Cape Sarichef Airport",
      "Cape Sarichef Airport"
    ],
    "city": [
      "Cape Sarichef",
      "Cape Sarichef",
      "Cape Sarichef"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CDV",
    "translations": [
      "Merle K (Mudhole) Smith Airport",
      "Merle K (Mudhole) Smith Airport",
      "Merle K (Mudhole) Smith Airport"
    ],
    "city": [
      "Cordova",
      "Cordova",
      "Cordova"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CXF",
    "translations": [
      "Coldfoot Airport",
      "Coldfoot Airport",
      "Coldfoot Airport"
    ],
    "city": [
      "Coldfoot",
      "Coldfoot",
      "Coldfoot"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CYT",
    "translations": [
      "Yakataga Airport",
      "Yakataga Airport",
      "Yakataga Airport"
    ],
    "city": [
      "Yakataga",
      "Yakataga",
      "Yakataga"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CZF",
    "translations": [
      "Cape Romanzof LRRS Airport",
      "Cape Romanzof LRRS Airport",
      "Cape Romanzof LRRS Airport"
    ],
    "city": [
      "Cape Romanzof",
      "Cape Romanzof",
      "Cape Romanzof"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DRG",
    "translations": [
      "Deering Airport",
      "Deering Airport",
      "Deering Airport"
    ],
    "city": [
      "Deering",
      "Deering",
      "Deering"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RDB",
    "translations": [
      "Red Dog Airport",
      "Red Dog Airport",
      "Red Dog Airport"
    ],
    "city": [
      "Red Dog",
      "Red Dog",
      "Red Dog"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ADK",
    "translations": [
      "Adak Airport",
      "Adak Airport",
      "Adak Airport"
    ],
    "city": [
      "Adak",
      "Adak",
      "Adak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DLG",
    "translations": [
      "Dillingham Airport",
      "Dillingham Airport",
      "Dillingham Airport"
    ],
    "city": [
      "Dillingham",
      "Dillingham",
      "Dillingham"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MLL",
    "translations": [
      "Marshall Don Hunter Sr Airport",
      "Marshall Don Hunter Sr Airport",
      "Marshall Don Hunter Sr Airport"
    ],
    "city": [
      "Marshall",
      "Marshall",
      "Marshall"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ADQ",
    "translations": [
      "Kodiak Airport",
      "Kodiak Airport",
      "Kodiak Airport"
    ],
    "city": [
      "Kodiak",
      "Kodiak",
      "Kodiak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DUT",
    "translations": [
      "Tom Madsen (Dutch Harbor) Airport",
      "Tom Madsen (Dutch Harbor) Airport",
      "Tom Madsen (Dutch Harbor) Airport"
    ],
    "city": [
      "Unalaska",
      "Unalaska",
      "Unalaska"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KKH",
    "translations": [
      "Kongiganak Airport",
      "Kongiganak Airport",
      "Kongiganak Airport"
    ],
    "city": [
      "Kongiganak",
      "Kongiganak",
      "Kongiganak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EDF",
    "translations": [
      "Elmendorf Air Force Base",
      "Elmendorf Air Force Base",
      "Elmendorf Air Force Base"
    ],
    "city": [
      "Anchorage",
      "Anchorage",
      "Anchorage"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EEK",
    "translations": [
      "Eek Airport",
      "Eek Airport",
      "Eek Airport"
    ],
    "city": [
      "Eek",
      "Eek",
      "Eek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EAA",
    "translations": [
      "Eagle Airport",
      "Eagle Airport",
      "Eagle Airport"
    ],
    "city": [
      "Eagle",
      "Eagle",
      "Eagle"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EHM",
    "translations": [
      "Cape Newenham LRRS Airport",
      "Cape Newenham LRRS Airport",
      "Cape Newenham LRRS Airport"
    ],
    "city": [
      "Cape Newenham",
      "Cape Newenham",
      "Cape Newenham"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EIL",
    "translations": [
      "Eielson Air Force Base",
      "Eielson Air Force Base",
      "Eielson Air Force Base"
    ],
    "city": [
      "Fairbanks",
      "Fairbanks",
      "Fairbanks"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ELV",
    "translations": [
      "Elfin Cove Seaplane Base",
      "Elfin Cove Seaplane Base",
      "Elfin Cove Seaplane Base"
    ],
    "city": [
      "Elfin Cove",
      "Elfin Cove",
      "Elfin Cove"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EMK",
    "translations": [
      "Emmonak Airport",
      "Emmonak Airport",
      "Emmonak Airport"
    ],
    "city": [
      "Emmonak",
      "Emmonak",
      "Emmonak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ENA",
    "translations": [
      "Kenai Municipal Airport",
      "Kenai Municipal Airport",
      "Kenai Municipal Airport"
    ],
    "city": [
      "Kenai",
      "Kenai",
      "Kenai"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WWT",
    "translations": [
      "Mertarvik Airport",
      "Mertarvik Airport",
      "Mertarvik Airport"
    ],
    "city": [
      "Mertarvik",
      "Mertarvik",
      "Mertarvik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FAI",
    "translations": [
      "Fairbanks International Airport",
      "Fairbanks International Airport",
      "Fairbanks International Airport"
    ],
    "city": [
      "Fairbanks",
      "Fairbanks",
      "Fairbanks"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FBK",
    "translations": [
      "Ladd Army Airfield",
      "Ladd Army Airfield",
      "Ladd Army Airfield"
    ],
    "city": [
      "Fairbanks",
      "Fairbanks",
      "Fairbanks"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ABL",
    "translations": [
      "Ambler Airport",
      "Ambler Airport",
      "Ambler Airport"
    ],
    "city": [
      "Ambler",
      "Ambler",
      "Ambler"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FRN",
    "translations": [
      "Bryant Army Airfield",
      "Bryant Army Airfield",
      "Bryant Army Airfield"
    ],
    "city": [
      "Fort Richardson",
      "Fort Richardson",
      "Fort Richardson"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NIB",
    "translations": [
      "Nikolai Airport",
      "Nikolai Airport",
      "Nikolai Airport"
    ],
    "city": [
      "Nikolai",
      "Nikolai",
      "Nikolai"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GAL",
    "translations": [
      "Edward G. Pitka Sr Airport",
      "Edward G. Pitka Sr Airport",
      "Edward G. Pitka Sr Airport"
    ],
    "city": [
      "Galena",
      "Galena",
      "Galena"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GBH",
    "translations": [
      "Galbraith Lake Airport",
      "Galbraith Lake Airport",
      "Galbraith Lake Airport"
    ],
    "city": [
      "Galbraith Lake",
      "Galbraith Lake",
      "Galbraith Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KWK",
    "translations": [
      "Kwigillingok Airport",
      "Kwigillingok Airport",
      "Kwigillingok Airport"
    ],
    "city": [
      "Kwigillingok",
      "Kwigillingok",
      "Kwigillingok"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SHG",
    "translations": [
      "Shungnak Airport",
      "Shungnak Airport",
      "Shungnak Airport"
    ],
    "city": [
      "Shungnak",
      "Shungnak",
      "Shungnak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GKN",
    "translations": [
      "Gulkana Airport",
      "Gulkana Airport",
      "Gulkana Airport"
    ],
    "city": [
      "Gulkana",
      "Gulkana",
      "Gulkana"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GLV",
    "translations": [
      "Golovin Airport",
      "Golovin Airport",
      "Golovin Airport"
    ],
    "city": [
      "Golovin",
      "Golovin",
      "Golovin"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GAM",
    "translations": [
      "Gambell Airport",
      "Gambell Airport",
      "Gambell Airport"
    ],
    "city": [
      "Gambell",
      "Gambell",
      "Gambell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AGN",
    "translations": [
      "Angoon Seaplane Base",
      "Angoon Seaplane Base",
      "Angoon Seaplane Base"
    ],
    "city": [
      "Angoon",
      "Angoon",
      "Angoon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BGQ",
    "translations": [
      "Big Lake Airport",
      "Big Lake Airport",
      "Big Lake Airport"
    ],
    "city": [
      "Big Lake",
      "Big Lake",
      "Big Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GST",
    "translations": [
      "Gustavus Airport",
      "Gustavus Airport",
      "Gustavus Airport"
    ],
    "city": [
      "Gustavus",
      "Gustavus",
      "Gustavus"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NME",
    "translations": [
      "Nightmute Airport",
      "Nightmute Airport",
      "Nightmute Airport"
    ],
    "city": [
      "Nightmute",
      "Nightmute",
      "Nightmute"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SGY",
    "translations": [
      "Skagway Airport",
      "Skagway Airport",
      "Skagway Airport"
    ],
    "city": [
      "Skagway",
      "Skagway",
      "Skagway"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GMT",
    "translations": [
      "Granite Mountain Air Station",
      "Granite Mountain Air Station",
      "Granite Mountain Air Station"
    ],
    "city": [
      "Granite Mountain",
      "Granite Mountain",
      "Granite Mountain"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HCR",
    "translations": [
      "Holy Cross Airport",
      "Holy Cross Airport",
      "Holy Cross Airport"
    ],
    "city": [
      "Holy Cross",
      "Holy Cross",
      "Holy Cross"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HSL",
    "translations": [
      "Huslia Airport",
      "Huslia Airport",
      "Huslia Airport"
    ],
    "city": [
      "Huslia",
      "Huslia",
      "Huslia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HNS",
    "translations": [
      "Haines Airport",
      "Haines Airport",
      "Haines Airport"
    ],
    "city": [
      "Haines",
      "Haines",
      "Haines"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HOM",
    "translations": [
      "Homer Airport",
      "Homer Airport",
      "Homer Airport"
    ],
    "city": [
      "Homer",
      "Homer",
      "Homer"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HPB",
    "translations": [
      "Hooper Bay Airport",
      "Hooper Bay Airport",
      "Hooper Bay Airport"
    ],
    "city": [
      "Hooper Bay",
      "Hooper Bay",
      "Hooper Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HUS",
    "translations": [
      "Hughes Airport",
      "Hughes Airport",
      "Hughes Airport"
    ],
    "city": [
      "Hughes",
      "Hughes",
      "Hughes"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SHX",
    "translations": [
      "Shageluk Airport",
      "Shageluk Airport",
      "Shageluk Airport"
    ],
    "city": [
      "Shageluk",
      "Shageluk",
      "Shageluk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HYG",
    "translations": [
      "Hydaburg Seaplane Base",
      "Hydaburg Seaplane Base",
      "Hydaburg Seaplane Base"
    ],
    "city": [
      "Hydaburg",
      "Hydaburg",
      "Hydaburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IGG",
    "translations": [
      "Igiugig Airport",
      "Igiugig Airport",
      "Igiugig Airport"
    ],
    "city": [
      "Igiugig",
      "Igiugig",
      "Igiugig"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "EGX",
    "translations": [
      "Egegik Airport",
      "Egegik Airport",
      "Egegik Airport"
    ],
    "city": [
      "Egegik",
      "Egegik",
      "Egegik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IAN",
    "translations": [
      "Bob Baker Memorial Airport",
      "Bob Baker Memorial Airport",
      "Bob Baker Memorial Airport"
    ],
    "city": [
      "Kiana",
      "Kiana",
      "Kiana"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ILI",
    "translations": [
      "Iliamna Airport",
      "Iliamna Airport",
      "Iliamna Airport"
    ],
    "city": [
      "Iliamna",
      "Iliamna",
      "Iliamna"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UTO",
    "translations": [
      "Indian Mountain LRRS Airport",
      "Indian Mountain LRRS Airport",
      "Indian Mountain LRRS Airport"
    ],
    "city": [
      "Utopia Creek",
      "Utopia Creek",
      "Utopia Creek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MCL",
    "translations": [
      "Denali National Park Airport",
      "Denali National Park Airport",
      "Denali National Park Airport"
    ],
    "city": [
      "Denali Park",
      "Denali Park",
      "Denali Park"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WAA",
    "translations": [
      "Wales Airport",
      "Wales Airport",
      "Wales Airport"
    ],
    "city": [
      "Wales",
      "Wales",
      "Wales"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KCG",
    "translations": [
      "Chignik Airport",
      "Chignik Airport",
      "Chignik Airport"
    ],
    "city": [
      "Chignik",
      "Chignik",
      "Chignik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JNU",
    "translations": [
      "Juneau International Airport",
      "Juneau International Airport",
      "Juneau International Airport"
    ],
    "city": [
      "Juneau",
      "Juneau",
      "Juneau"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KGK",
    "translations": [
      "Koliganek Airport",
      "Koliganek Airport",
      "Koliganek Airport"
    ],
    "city": [
      "Koliganek",
      "Koliganek",
      "Koliganek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KDK",
    "translations": [
      "Kodiak Municipal Airport",
      "Kodiak Municipal Airport",
      "Kodiak Municipal Airport"
    ],
    "city": [
      "Kodiak",
      "Kodiak",
      "Kodiak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KFP",
    "translations": [
      "False Pass Airport",
      "False Pass Airport",
      "False Pass Airport"
    ],
    "city": [
      "False Pass",
      "False Pass",
      "False Pass"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AKK",
    "translations": [
      "Akhiok Airport",
      "Akhiok Airport",
      "Akhiok Airport"
    ],
    "city": [
      "Akhiok",
      "Akhiok",
      "Akhiok"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KPN",
    "translations": [
      "Kipnuk Airport",
      "Kipnuk Airport",
      "Kipnuk Airport"
    ],
    "city": [
      "Kipnuk",
      "Kipnuk",
      "Kipnuk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KKA",
    "translations": [
      "Koyuk Alfred Adams Airport",
      "Koyuk Alfred Adams Airport",
      "Koyuk Alfred Adams Airport"
    ],
    "city": [
      "Koyuk",
      "Koyuk",
      "Koyuk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LKK",
    "translations": [
      "Kulik Lake Airport",
      "Kulik Lake Airport",
      "Kulik Lake Airport"
    ],
    "city": [
      "Kulik Lake",
      "Kulik Lake",
      "Kulik Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AKN",
    "translations": [
      "King Salmon Airport",
      "King Salmon Airport",
      "King Salmon Airport"
    ],
    "city": [
      "King Salmon",
      "King Salmon",
      "King Salmon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "IKO",
    "translations": [
      "Nikolski Air Station",
      "Nikolski Air Station",
      "Nikolski Air Station"
    ],
    "city": [
      "Nikolski",
      "Nikolski",
      "Nikolski"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AKP",
    "translations": [
      "Anaktuvuk Pass Airport",
      "Anaktuvuk Pass Airport",
      "Anaktuvuk Pass Airport"
    ],
    "city": [
      "Anaktuvuk Pass",
      "Anaktuvuk Pass",
      "Anaktuvuk Pass"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KTN",
    "translations": [
      "Ketchikan International Airport",
      "Ketchikan International Airport",
      "Ketchikan International Airport"
    ],
    "city": [
      "Ketchikan",
      "Ketchikan",
      "Ketchikan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UUK",
    "translations": [
      "Ugnu-Kuparuk Airport",
      "Ugnu-Kuparuk Airport",
      "Ugnu-Kuparuk Airport"
    ],
    "city": [
      "Kuparuk",
      "Kuparuk",
      "Kuparuk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KAL",
    "translations": [
      "Kaltag Airport",
      "Kaltag Airport",
      "Kaltag Airport"
    ],
    "city": [
      "Kaltag",
      "Kaltag",
      "Kaltag"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KLW",
    "translations": [
      "Klawock Airport",
      "Klawock Airport",
      "Klawock Airport"
    ],
    "city": [
      "Klawock",
      "Klawock",
      "Klawock"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KYK",
    "translations": [
      "Karluk Airport",
      "Karluk Airport",
      "Karluk Airport"
    ],
    "city": [
      "Karluk",
      "Karluk",
      "Karluk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KLN",
    "translations": [
      "Larsen Bay Airport",
      "Larsen Bay Airport",
      "Larsen Bay Airport"
    ],
    "city": [
      "Larsen Bay",
      "Larsen Bay",
      "Larsen Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KLG",
    "translations": [
      "Kalskag Airport",
      "Kalskag Airport",
      "Kalskag Airport"
    ],
    "city": [
      "Kalskag",
      "Kalskag",
      "Kalskag"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PTA",
    "translations": [
      "Port Alsworth Airport",
      "Port Alsworth Airport",
      "Port Alsworth Airport"
    ],
    "city": [
      "Port Alsworth",
      "Port Alsworth",
      "Port Alsworth"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LNI",
    "translations": [
      "Point Lonely Short Range Radar Site Airfield",
      "Point Lonely Short Range Radar Site Airfield",
      "Point Lonely Short Range Radar Site Airfield"
    ],
    "city": [
      "Point Lonely",
      "Point Lonely",
      "Point Lonely"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WCR",
    "translations": [
      "Chandalar Lake Airport",
      "Chandalar Lake Airport",
      "Chandalar Lake Airport"
    ],
    "city": [
      "Chandalar Lake",
      "Chandalar Lake",
      "Chandalar Lake"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LUR",
    "translations": [
      "Cape Lisburne LRRS Airport",
      "Cape Lisburne LRRS Airport",
      "Cape Lisburne LRRS Airport"
    ],
    "city": [
      "Cape Lisburne",
      "Cape Lisburne",
      "Cape Lisburne"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KMO",
    "translations": [
      "Manokotak Airport",
      "Manokotak Airport",
      "Manokotak Airport"
    ],
    "city": [
      "Manokotak",
      "Manokotak",
      "Manokotak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MCG",
    "translations": [
      "McGrath Airport",
      "McGrath Airport",
      "McGrath Airport"
    ],
    "city": [
      "McGrath",
      "McGrath",
      "McGrath"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MDO",
    "translations": [
      "Middleton Island Airport",
      "Middleton Island Airport",
      "Middleton Island Airport"
    ],
    "city": [
      "Middleton Island",
      "Middleton Island",
      "Middleton Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LMA",
    "translations": [
      "Minchumina Airport",
      "Minchumina Airport",
      "Minchumina Airport"
    ],
    "city": [
      "Minchumina",
      "Minchumina",
      "Minchumina"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SMK",
    "translations": [
      "St Michael Airport",
      "St Michael Airport",
      "St Michael Airport"
    ],
    "city": [
      "St Michael",
      "St Michael",
      "St Michael"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MLY",
    "translations": [
      "Manley Hot Springs Airport",
      "Manley Hot Springs Airport",
      "Manley Hot Springs Airport"
    ],
    "city": [
      "Manley Hot Springs",
      "Manley Hot Springs",
      "Manley Hot Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MTM",
    "translations": [
      "Metlakatla Seaplane Base",
      "Metlakatla Seaplane Base",
      "Metlakatla Seaplane Base"
    ],
    "city": [
      "Metlakatla",
      "Metlakatla",
      "Metlakatla"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MOU",
    "translations": [
      "Mountain Village Airport",
      "Mountain Village Airport",
      "Mountain Village Airport"
    ],
    "city": [
      "Mountain Village",
      "Mountain Village",
      "Mountain Village"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MRI",
    "translations": [
      "Merrill Field",
      "Merrill Field",
      "Merrill Field"
    ],
    "city": [
      "Anchorage",
      "Anchorage",
      "Anchorage"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MXY",
    "translations": [
      "Mc Carthy Airport",
      "Mc Carthy Airport",
      "Mc Carthy Airport"
    ],
    "city": [
      "Mccarthy",
      "Mccarthy",
      "Mccarthy"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MYU",
    "translations": [
      "Mekoryuk Airport",
      "Mekoryuk Airport",
      "Mekoryuk Airport"
    ],
    "city": [
      "Mekoryuk",
      "Mekoryuk",
      "Mekoryuk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WNA",
    "translations": [
      "Napakiak Airport",
      "Napakiak Airport",
      "Napakiak Airport"
    ],
    "city": [
      "Napakiak",
      "Napakiak",
      "Napakiak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ANC",
    "translations": [
      "Ted Stevens Anchorage International Airport",
      "Ted Stevens Anchorage International Airport",
      "Ted Stevens Anchorage International Airport"
    ],
    "city": [
      "Anchorage",
      "Anchorage",
      "Anchorage"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ANI",
    "translations": [
      "Aniak Airport",
      "Aniak Airport",
      "Aniak Airport"
    ],
    "city": [
      "Aniak",
      "Aniak",
      "Aniak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ENN",
    "translations": [
      "Nenana Municipal Airport",
      "Nenana Municipal Airport",
      "Nenana Municipal Airport"
    ],
    "city": [
      "Nenana",
      "Nenana",
      "Nenana"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NNL",
    "translations": [
      "Nondalton Airport",
      "Nondalton Airport",
      "Nondalton Airport"
    ],
    "city": [
      "Nondalton",
      "Nondalton",
      "Nondalton"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FNR",
    "translations": [
      "Funter Bay Seaplane Base",
      "Funter Bay Seaplane Base",
      "Funter Bay Seaplane Base"
    ],
    "city": [
      "Funter Bay",
      "Funter Bay",
      "Funter Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ANN",
    "translations": [
      "Annette Island Airport",
      "Annette Island Airport",
      "Annette Island Airport"
    ],
    "city": [
      "Metlakatla",
      "Metlakatla",
      "Metlakatla"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NUL",
    "translations": [
      "Nulato Airport",
      "Nulato Airport",
      "Nulato Airport"
    ],
    "city": [
      "Nulato",
      "Nulato",
      "Nulato"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ANV",
    "translations": [
      "Anvik Airport",
      "Anvik Airport",
      "Anvik Airport"
    ],
    "city": [
      "Anvik",
      "Anvik",
      "Anvik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KNW",
    "translations": [
      "New Stuyahok Airport",
      "New Stuyahok Airport",
      "New Stuyahok Airport"
    ],
    "city": [
      "New Stuyahok",
      "New Stuyahok",
      "New Stuyahok"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OBU",
    "translations": [
      "Kobuk Airport",
      "Kobuk Airport",
      "Kobuk Airport"
    ],
    "city": [
      "Kobuk",
      "Kobuk",
      "Kobuk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PCA",
    "translations": [
      "Portage Creek Airport",
      "Portage Creek Airport",
      "Portage Creek Airport"
    ],
    "city": [
      "Portage Creek",
      "Portage Creek",
      "Portage Creek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HNH",
    "translations": [
      "Hoonah Airport",
      "Hoonah Airport",
      "Hoonah Airport"
    ],
    "city": [
      "Hoonah",
      "Hoonah",
      "Hoonah"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OME",
    "translations": [
      "Nome Airport",
      "Nome Airport",
      "Nome Airport"
    ],
    "city": [
      "Nome",
      "Nome",
      "Nome"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OOK",
    "translations": [
      "Toksook Bay Airport",
      "Toksook Bay Airport",
      "Toksook Bay Airport"
    ],
    "city": [
      "Toksook Bay",
      "Toksook Bay",
      "Toksook Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ORT",
    "translations": [
      "Northway Airport",
      "Northway Airport",
      "Northway Airport"
    ],
    "city": [
      "Northway",
      "Northway",
      "Northway"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OTZ",
    "translations": [
      "Ralph Wien Memorial Airport",
      "Ralph Wien Memorial Airport",
      "Ralph Wien Memorial Airport"
    ],
    "city": [
      "Kotzebue",
      "Kotzebue",
      "Kotzebue"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NLG",
    "translations": [
      "Nelson Lagoon Airport",
      "Nelson Lagoon Airport",
      "Nelson Lagoon Airport"
    ],
    "city": [
      "Nelson Lagoon",
      "Nelson Lagoon",
      "Nelson Lagoon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "STG",
    "translations": [
      "St George Airport",
      "St George Airport",
      "St George Airport"
    ],
    "city": [
      "St George",
      "St George",
      "St George"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KPC",
    "translations": [
      "Port Clarence Coast Guard Station",
      "Port Clarence Coast Guard Station",
      "Port Clarence Coast Guard Station"
    ],
    "city": [
      "Port Clarence",
      "Port Clarence",
      "Port Clarence"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KPV",
    "translations": [
      "Perryville Airport",
      "Perryville Airport",
      "Perryville Airport"
    ],
    "city": [
      "Perryville",
      "Perryville",
      "Perryville"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PSG",
    "translations": [
      "Petersburg James A Johnson Airport",
      "Petersburg James A Johnson Airport",
      "Petersburg James A Johnson Airport"
    ],
    "city": [
      "Petersburg",
      "Petersburg",
      "Petersburg"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PTH",
    "translations": [
      "Port Heiden Airport",
      "Port Heiden Airport",
      "Port Heiden Airport"
    ],
    "city": [
      "Port Heiden",
      "Port Heiden",
      "Port Heiden"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PKA",
    "translations": [
      "Napaskiak Airport",
      "Napaskiak Airport",
      "Napaskiak Airport"
    ],
    "city": [
      "Napaskiak",
      "Napaskiak",
      "Napaskiak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PTU",
    "translations": [
      "Platinum Airport",
      "Platinum Airport",
      "Platinum Airport"
    ],
    "city": [
      "Platinum",
      "Platinum",
      "Platinum"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PIP",
    "translations": [
      "Pilot Point Airport",
      "Pilot Point Airport",
      "Pilot Point Airport"
    ],
    "city": [
      "Pilot Point",
      "Pilot Point",
      "Pilot Point"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PHO",
    "translations": [
      "Point Hope Airport",
      "Point Hope Airport",
      "Point Hope Airport"
    ],
    "city": [
      "Point Hope",
      "Point Hope",
      "Point Hope"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PPC",
    "translations": [
      "Prospect Creek Airport",
      "Prospect Creek Airport",
      "Prospect Creek Airport"
    ],
    "city": [
      "Prospect Creek",
      "Prospect Creek",
      "Prospect Creek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KWN",
    "translations": [
      "Quinhagak Airport",
      "Quinhagak Airport",
      "Quinhagak Airport"
    ],
    "city": [
      "Quinhagak",
      "Quinhagak",
      "Quinhagak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NUI",
    "translations": [
      "Nuiqsut Airport",
      "Nuiqsut Airport",
      "Nuiqsut Airport"
    ],
    "city": [
      "Nuiqsut",
      "Nuiqsut",
      "Nuiqsut"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ARC",
    "translations": [
      "Arctic Village Airport",
      "Arctic Village Airport",
      "Arctic Village Airport"
    ],
    "city": [
      "Arctic Village",
      "Arctic Village",
      "Arctic Village"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RSH",
    "translations": [
      "Russian Mission Airport",
      "Russian Mission Airport",
      "Russian Mission Airport"
    ],
    "city": [
      "Russian Mission",
      "Russian Mission",
      "Russian Mission"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RBY",
    "translations": [
      "Ruby Airport",
      "Ruby Airport",
      "Ruby Airport"
    ],
    "city": [
      "Ruby",
      "Ruby",
      "Ruby"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SVA",
    "translations": [
      "Savoonga Airport",
      "Savoonga Airport",
      "Savoonga Airport"
    ],
    "city": [
      "Savoonga",
      "Savoonga",
      "Savoonga"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SCC",
    "translations": [
      "Deadhorse Airport",
      "Deadhorse Airport",
      "Deadhorse Airport"
    ],
    "city": [
      "Deadhorse",
      "Deadhorse",
      "Deadhorse"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SDP",
    "translations": [
      "Sand Point Airport",
      "Sand Point Airport",
      "Sand Point Airport"
    ],
    "city": [
      "Sand Point",
      "Sand Point",
      "Sand Point"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SHH",
    "translations": [
      "Shishmaref Airport",
      "Shishmaref Airport",
      "Shishmaref Airport"
    ],
    "city": [
      "Shishmaref",
      "Shishmaref",
      "Shishmaref"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SIT",
    "translations": [
      "Sitka Rocky Gutierrez Airport",
      "Sitka Rocky Gutierrez Airport",
      "Sitka Rocky Gutierrez Airport"
    ],
    "city": [
      "Sitka",
      "Sitka",
      "Sitka"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WLK",
    "translations": [
      "Selawik Airport",
      "Selawik Airport",
      "Selawik Airport"
    ],
    "city": [
      "Selawik",
      "Selawik",
      "Selawik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SLQ",
    "translations": [
      "Sleetmute Airport",
      "Sleetmute Airport",
      "Sleetmute Airport"
    ],
    "city": [
      "Sleetmute",
      "Sleetmute",
      "Sleetmute"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KSM",
    "translations": [
      "St Mary's Airport",
      "St Mary's Airport",
      "St Mary's Airport"
    ],
    "city": [
      "St Mary's",
      "St Mary's",
      "St Mary's"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SNP",
    "translations": [
      "St Paul Island Airport",
      "St Paul Island Airport",
      "St Paul Island Airport"
    ],
    "city": [
      "St Paul Island",
      "St Paul Island",
      "St Paul Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SOV",
    "translations": [
      "Seldovia Airport",
      "Seldovia Airport",
      "Seldovia Airport"
    ],
    "city": [
      "Seldovia",
      "Seldovia",
      "Seldovia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SMU",
    "translations": [
      "Sheep Mountain Airport",
      "Sheep Mountain Airport",
      "Sheep Mountain Airport"
    ],
    "city": [
      "Sheep Mountain",
      "Sheep Mountain",
      "Sheep Mountain"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UMM",
    "translations": [
      "Summit Airport",
      "Summit Airport",
      "Summit Airport"
    ],
    "city": [
      "Cantwell",
      "Cantwell",
      "Cantwell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SVW",
    "translations": [
      "Sparrevohn LRRS Airport",
      "Sparrevohn LRRS Airport",
      "Sparrevohn LRRS Airport"
    ],
    "city": [
      "Sparrevohn",
      "Sparrevohn",
      "Sparrevohn"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SKW",
    "translations": [
      "Skwentna Airport",
      "Skwentna Airport",
      "Skwentna Airport"
    ],
    "city": [
      "Skwentna",
      "Skwentna",
      "Skwentna"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SXQ",
    "translations": [
      "Soldotna Airport",
      "Soldotna Airport",
      "Soldotna Airport"
    ],
    "city": [
      "Soldotna",
      "Soldotna",
      "Soldotna"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SYA",
    "translations": [
      "Eareckson Air Station",
      "Eareckson Air Station",
      "Eareckson Air Station"
    ],
    "city": [
      "Shemya",
      "Shemya",
      "Shemya"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TAL",
    "translations": [
      "Ralph M Calhoun Memorial Airport",
      "Ralph M Calhoun Memorial Airport",
      "Ralph M Calhoun Memorial Airport"
    ],
    "city": [
      "Tanana",
      "Tanana",
      "Tanana"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TNC",
    "translations": [
      "Tin City Long Range Radar Station Airport",
      "Tin City Long Range Radar Station Airport",
      "Tin City Long Range Radar Station Airport"
    ],
    "city": [
      "Tin City",
      "Tin City",
      "Tin City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TLA",
    "translations": [
      "Teller Airport",
      "Teller Airport",
      "Teller Airport"
    ],
    "city": [
      "Teller",
      "Teller",
      "Teller"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TOG",
    "translations": [
      "Togiak Airport",
      "Togiak Airport",
      "Togiak Airport"
    ],
    "city": [
      "Togiak Village",
      "Togiak Village",
      "Togiak Village"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TKA",
    "translations": [
      "Talkeetna Airport",
      "Talkeetna Airport",
      "Talkeetna Airport"
    ],
    "city": [
      "Talkeetna",
      "Talkeetna",
      "Talkeetna"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TLJ",
    "translations": [
      "Tatalina LRRS Airport",
      "Tatalina LRRS Airport",
      "Tatalina LRRS Airport"
    ],
    "city": [
      "Takotna",
      "Takotna",
      "Takotna"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ATK",
    "translations": [
      "Atqasuk Edward Burnell Sr Memorial Airport",
      "Atqasuk Edward Burnell Sr Memorial Airport",
      "Atqasuk Edward Burnell Sr Memorial Airport"
    ],
    "city": [
      "Atqasuk",
      "Atqasuk",
      "Atqasuk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AUK",
    "translations": [
      "Alakanuk Airport",
      "Alakanuk Airport",
      "Alakanuk Airport"
    ],
    "city": [
      "Alakanuk",
      "Alakanuk",
      "Alakanuk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UMT",
    "translations": [
      "Umiat Airport",
      "Umiat Airport",
      "Umiat Airport"
    ],
    "city": [
      "Umiat",
      "Umiat",
      "Umiat"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UNK",
    "translations": [
      "Unalakleet Airport",
      "Unalakleet Airport",
      "Unalakleet Airport"
    ],
    "city": [
      "Unalakleet",
      "Unalakleet",
      "Unalakleet"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WOW",
    "translations": [
      "Willow Airport",
      "Willow Airport",
      "Willow Airport"
    ],
    "city": [
      "Willow",
      "Willow",
      "Willow"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KQA",
    "translations": [
      "Akutan Airport",
      "Akutan Airport",
      "Akutan Airport"
    ],
    "city": [
      "Akutan",
      "Akutan",
      "Akutan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VAK",
    "translations": [
      "Chevak Airport",
      "Chevak Airport",
      "Chevak Airport"
    ],
    "city": [
      "Chevak",
      "Chevak",
      "Chevak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KVC",
    "translations": [
      "King Cove Airport",
      "King Cove Airport",
      "King Cove Airport"
    ],
    "city": [
      "King Cove",
      "King Cove",
      "King Cove"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VDZ",
    "translations": [
      "Valdez Pioneer Field",
      "Valdez Pioneer Field",
      "Valdez Pioneer Field"
    ],
    "city": [
      "Valdez",
      "Valdez",
      "Valdez"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "VEE",
    "translations": [
      "Venetie Airport",
      "Venetie Airport",
      "Venetie Airport"
    ],
    "city": [
      "Venetie",
      "Venetie",
      "Venetie"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KVL",
    "translations": [
      "Kivalina Airport",
      "Kivalina Airport",
      "Kivalina Airport"
    ],
    "city": [
      "Kivalina",
      "Kivalina",
      "Kivalina"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WBQ",
    "translations": [
      "Beaver Airport",
      "Beaver Airport",
      "Beaver Airport"
    ],
    "city": [
      "Beaver",
      "Beaver",
      "Beaver"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SWD",
    "translations": [
      "Seward Airport",
      "Seward Airport",
      "Seward Airport"
    ],
    "city": [
      "Seward",
      "Seward",
      "Seward"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WRG",
    "translations": [
      "Wrangell Airport",
      "Wrangell Airport",
      "Wrangell Airport"
    ],
    "city": [
      "Wrangell",
      "Wrangell",
      "Wrangell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AIN",
    "translations": [
      "Wainwright Airport",
      "Wainwright Airport",
      "Wainwright Airport"
    ],
    "city": [
      "Wainwright",
      "Wainwright",
      "Wainwright"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WMO",
    "translations": [
      "White Mountain Airport",
      "White Mountain Airport",
      "White Mountain Airport"
    ],
    "city": [
      "White Mountain",
      "White Mountain",
      "White Mountain"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WTK",
    "translations": [
      "Noatak Airport",
      "Noatak Airport",
      "Noatak Airport"
    ],
    "city": [
      "Noatak",
      "Noatak",
      "Noatak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WWA",
    "translations": [
      "Wasilla Airport",
      "Wasilla Airport",
      "Wasilla Airport"
    ],
    "city": [
      "Wasilla",
      "Wasilla",
      "Wasilla"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "YAK",
    "translations": [
      "Yakutat Airport",
      "Yakutat Airport",
      "Yakutat Airport"
    ],
    "city": [
      "Yakutat",
      "Yakutat",
      "Yakutat"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CIS",
    "translations": [
      "Canton Island Airport",
      "Canton Island Airport",
      "Canton Island Airport"
    ],
    "city": [
      "Abariringa",
      "Abariringa",
      "Abariringa"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "PCQ",
    "translations": [
      "Boun Neau Airport",
      "Boun Neau Airport",
      "Boun Neau Airport"
    ],
    "city": [
      "Phongsaly",
      "Phongsaly",
      "Phongsaly"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "PDR",
    "translations": [
      "Presidente José Sarney Airport",
      "Presidente José Sarney Airport",
      "Presidente José Sarney Airport"
    ],
    "city": [
      "Presidente Dutra",
      "Presidente Dutra",
      "Presidente Dutra"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PTL",
    "translations": [
      "Walter Braedt Segú Airport",
      "Walter Braedt Segú Airport",
      "Walter Braedt Segú Airport"
    ],
    "city": [
      "Máncora",
      "Máncora",
      "Máncora"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "BLP",
    "translations": [
      "Huallaga Airport",
      "Huallaga Airport",
      "Huallaga Airport"
    ],
    "city": [
      "Bellavista",
      "Bellavista",
      "Bellavista"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "PEB",
    "translations": [
      "Pebane Airport",
      "Pebane Airport",
      "Pebane Airport"
    ],
    "city": [
      "Pebane",
      "Pebane",
      "Pebane"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "PEC",
    "translations": [
      "Pelican Seaplane Base",
      "Pelican Seaplane Base",
      "Pelican Seaplane Base"
    ],
    "city": [
      "Pelican",
      "Pelican",
      "Pelican"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AKI",
    "translations": [
      "Akiak Airport",
      "Akiak Airport",
      "Akiak Airport"
    ],
    "city": [
      "Akiak",
      "Akiak",
      "Akiak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AET",
    "translations": [
      "Allakaket Airport",
      "Allakaket Airport",
      "Allakaket Airport"
    ],
    "city": [
      "Allakaket",
      "Allakaket",
      "Allakaket"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NCN",
    "translations": [
      "Chenega Bay Airport",
      "Chenega Bay Airport",
      "Chenega Bay Airport"
    ],
    "city": [
      "Chenega",
      "Chenega",
      "Chenega"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CLP",
    "translations": [
      "Clarks Point Airport",
      "Clarks Point Airport",
      "Clarks Point Airport"
    ],
    "city": [
      "Clarks Point",
      "Clarks Point",
      "Clarks Point"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ELI",
    "translations": [
      "Elim Airport",
      "Elim Airport",
      "Elim Airport"
    ],
    "city": [
      "Elim",
      "Elim",
      "Elim"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KUK",
    "translations": [
      "Kasigluk Airport",
      "Kasigluk Airport",
      "Kasigluk Airport"
    ],
    "city": [
      "Kasigluk",
      "Kasigluk",
      "Kasigluk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KNK",
    "translations": [
      "Kokhanok Airport",
      "Kokhanok Airport",
      "Kokhanok Airport"
    ],
    "city": [
      "Kokhanok",
      "Kokhanok",
      "Kokhanok"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KOT",
    "translations": [
      "Kotlik Airport",
      "Kotlik Airport",
      "Kotlik Airport"
    ],
    "city": [
      "Kotlik",
      "Kotlik",
      "Kotlik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KTS",
    "translations": [
      "Brevig Mission Airport",
      "Brevig Mission Airport",
      "Brevig Mission Airport"
    ],
    "city": [
      "Brevig Mission",
      "Brevig Mission",
      "Brevig Mission"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KYU",
    "translations": [
      "Koyukuk Airport",
      "Koyukuk Airport",
      "Koyukuk Airport"
    ],
    "city": [
      "Koyukuk",
      "Koyukuk",
      "Koyukuk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KWT",
    "translations": [
      "Kwethluk Airport",
      "Kwethluk Airport",
      "Kwethluk Airport"
    ],
    "city": [
      "Kwethluk",
      "Kwethluk",
      "Kwethluk"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ORV",
    "translations": [
      "Robert (Bob) Curtis Memorial Airport",
      "Robert (Bob) Curtis Memorial Airport",
      "Robert (Bob) Curtis Memorial Airport"
    ],
    "city": [
      "Noorvik",
      "Noorvik",
      "Noorvik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SKK",
    "translations": [
      "Shaktoolik Airport",
      "Shaktoolik Airport",
      "Shaktoolik Airport"
    ],
    "city": [
      "Shaktoolik",
      "Shaktoolik",
      "Shaktoolik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TKJ",
    "translations": [
      "Tok Junction Airport",
      "Tok Junction Airport",
      "Tok Junction Airport"
    ],
    "city": [
      "Tok",
      "Tok",
      "Tok"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WSN",
    "translations": [
      "South Naknek Number 2 Airport",
      "South Naknek Number 2 Airport",
      "South Naknek Number 2 Airport"
    ],
    "city": [
      "South Naknek",
      "South Naknek",
      "South Naknek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FYU",
    "translations": [
      "Fort Yukon Airport",
      "Fort Yukon Airport",
      "Fort Yukon Airport"
    ],
    "city": [
      "Fort Yukon",
      "Fort Yukon",
      "Fort Yukon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CPN",
    "translations": [
      "Cape Rodney Airport",
      "Cape Rodney Airport",
      "Cape Rodney Airport"
    ],
    "city": [
      "Cape Rodney",
      "Cape Rodney",
      "Cape Rodney"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "ESA",
    "translations": [
      "Esa'ala Airport",
      "Esa'ala Airport",
      "Esa'ala Airport"
    ],
    "city": [
      "Esa'ala",
      "Esa'ala",
      "Esa'ala"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MZN",
    "translations": [
      "Minj Airport",
      "Minj Airport",
      "Minj Airport"
    ],
    "city": [
      "Minj",
      "Minj",
      "Minj"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "SMP",
    "translations": [
      "Stockholm Landing Strip",
      "Stockholm Landing Strip",
      "Stockholm Landing Strip"
    ],
    "city": [
      "Stockholm",
      "Stockholm",
      "Stockholm"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BRH",
    "translations": [
      "Brahman Airstrip",
      "Brahman Airstrip",
      "Brahman Airstrip"
    ],
    "city": [
      "Brahman Mission",
      "Brahman Mission",
      "Brahman Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "BIJ",
    "translations": [
      "Biliau Airport",
      "Biliau Airport",
      "Biliau Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TAJ",
    "translations": [
      "Tadji Airport",
      "Tadji Airport",
      "Tadji Airport"
    ],
    "city": [
      "Aitape",
      "Aitape",
      "Aitape"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "IHU",
    "translations": [
      "Ihu Airport",
      "Ihu Airport",
      "Ihu Airport"
    ],
    "city": [
      "Ihu",
      "Ihu",
      "Ihu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "JAQ",
    "translations": [
      "Jacquinot Bay Airport",
      "Jacquinot Bay Airport",
      "Jacquinot Bay Airport"
    ],
    "city": [
      "Jacquinot Bay",
      "Jacquinot Bay",
      "Jacquinot Bay"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KUY",
    "translations": [
      "Kamusi Airport",
      "Kamusi Airport",
      "Kamusi Airport"
    ],
    "city": [
      "Kamusi",
      "Kamusi",
      "Kamusi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "LMY",
    "translations": [
      "Lake Murray Airport",
      "Lake Murray Airport",
      "Lake Murray Airport"
    ],
    "city": [
      "Lake Murray",
      "Lake Murray",
      "Lake Murray"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "ULE",
    "translations": [
      "Sule Airport",
      "Sule Airport",
      "Sule Airport"
    ],
    "city": [
      "Sule",
      "Sule",
      "Sule"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PGE",
    "translations": [
      "Yegepa Airport",
      "Yegepa Airport",
      "Yegepa Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PGM",
    "translations": [
      "Port Graham Airport",
      "Port Graham Airport",
      "Port Graham Airport"
    ],
    "city": [
      "Port Graham",
      "Port Graham",
      "Port Graham"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ROP",
    "translations": [
      "Rota International Airport",
      "Rota International Airport",
      "Rota International Airport"
    ],
    "city": [
      "Rota Island",
      "Rota Island",
      "Rota Island"
    ],
    "country": [
      "MP",
      "MP",
      "MP"
    ]
  },
  {
    "iata": "SPN",
    "translations": [
      "Saipan International Airport",
      "Saipan International Airport",
      "Saipan International Airport"
    ],
    "city": [
      "I Fadang, Saipan",
      "I Fadang, Saipan",
      "I Fadang, Saipan"
    ],
    "country": [
      "MP",
      "MP",
      "MP"
    ]
  },
  {
    "iata": "UAM",
    "translations": [
      "Andersen Air Force Base",
      "Andersen Air Force Base",
      "Andersen Air Force Base"
    ],
    "city": [
      "Yigo",
      "Yigo",
      "Yigo"
    ],
    "country": [
      "GU",
      "GU",
      "GU"
    ]
  },
  {
    "iata": "GUM",
    "translations": [
      "Antonio B. Won Pat International Airport",
      "Antonio B. Won Pat International Airport",
      "Antonio B. Won Pat International Airport"
    ],
    "city": [
      "Hagåtña",
      "Hagåtña",
      "Hagåtña"
    ],
    "country": [
      "GU",
      "GU",
      "GU"
    ]
  },
  {
    "iata": "TIQ",
    "translations": [
      "Tinian International Airport",
      "Tinian International Airport",
      "Tinian International Airport"
    ],
    "city": [
      "Tinian Island",
      "Tinian Island",
      "Tinian Island"
    ],
    "country": [
      "MP",
      "MP",
      "MP"
    ]
  },
  {
    "iata": "TGB",
    "translations": [
      "Tagbita Airstrip",
      "Tagbita Airstrip",
      "Tagbita Airstrip"
    ],
    "city": [
      "Rizal",
      "Rizal",
      "Rizal"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "BKH",
    "translations": [
      "Barking Sands Airport",
      "Barking Sands Airport",
      "Barking Sands Airport"
    ],
    "city": [
      "Kekaha",
      "Kekaha",
      "Kekaha"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HDH",
    "translations": [
      "Kawaihapai Airfield",
      "Kawaihapai Airfield",
      "Kawaihapai Airfield"
    ],
    "city": [
      "Mokuleia",
      "Mokuleia",
      "Mokuleia"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HHI",
    "translations": [
      "Wheeler Army Airfield",
      "Wheeler Army Airfield",
      "Wheeler Army Airfield"
    ],
    "city": [
      "Wahiawa",
      "Wahiawa",
      "Wahiawa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HNM",
    "translations": [
      "Hana Airport",
      "Hana Airport",
      "Hana Airport"
    ],
    "city": [
      "Hana",
      "Hana",
      "Hana"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HIK",
    "translations": [
      "Hickam Air Force Base",
      "Hickam Air Force Base",
      "Hickam Air Force Base"
    ],
    "city": [
      "Honolulu",
      "Honolulu",
      "Honolulu"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JHM",
    "translations": [
      "Kapalua Airport",
      "Kapalua Airport",
      "Kapalua Airport"
    ],
    "city": [
      "Lahaina",
      "Lahaina",
      "Lahaina"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JRF",
    "translations": [
      "Kalaeloa Airport",
      "Kalaeloa Airport",
      "Kalaeloa Airport"
    ],
    "city": [
      "Kapolei",
      "Kapolei",
      "Kapolei"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KOA",
    "translations": [
      "Ellison Onizuka Kona International Airport at Keahole",
      "Ellison Onizuka Kona International Airport at Keahole",
      "Ellison Onizuka Kona International Airport at Keahole"
    ],
    "city": [
      "Kailua-Kona",
      "Kailua-Kona",
      "Kailua-Kona"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LIH",
    "translations": [
      "Lihue Airport",
      "Lihue Airport",
      "Lihue Airport"
    ],
    "city": [
      "Lihue",
      "Lihue",
      "Lihue"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LUP",
    "translations": [
      "Kalaupapa Airport",
      "Kalaupapa Airport",
      "Kalaupapa Airport"
    ],
    "city": [
      "Kalaupapa",
      "Kalaupapa",
      "Kalaupapa"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MKK",
    "translations": [
      "Molokai Airport",
      "Molokai Airport",
      "Molokai Airport"
    ],
    "city": [
      "Kaunakakai",
      "Kaunakakai",
      "Kaunakakai"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MUE",
    "translations": [
      "Waimea Kohala Airport",
      "Waimea Kohala Airport",
      "Waimea Kohala Airport"
    ],
    "city": [
      "Waimea (Kamuela)",
      "Waimea (Kamuela)",
      "Waimea (Kamuela)"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "NGF",
    "translations": [
      "Kaneohe Bay MCAS (Marion E. Carl Field) Airport",
      "Kaneohe Bay MCAS (Marion E. Carl Field) Airport",
      "Kaneohe Bay MCAS (Marion E. Carl Field) Airport"
    ],
    "city": [
      "Kaneohe",
      "Kaneohe",
      "Kaneohe"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HNL",
    "translations": [
      "Daniel K Inouye International Airport",
      "Daniel K Inouye International Airport",
      "Daniel K Inouye International Airport"
    ],
    "city": [
      "Honolulu, Oahu",
      "Honolulu, Oahu",
      "Honolulu, Oahu"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LNY",
    "translations": [
      "Lanai Airport",
      "Lanai Airport",
      "Lanai Airport"
    ],
    "city": [
      "Lanai City",
      "Lanai City",
      "Lanai City"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OGG",
    "translations": [
      "Kahului International Airport",
      "Kahului International Airport",
      "Kahului International Airport"
    ],
    "city": [
      "Kahului",
      "Kahului",
      "Kahului"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PAK",
    "translations": [
      "Port Allen Airport",
      "Port Allen Airport",
      "Port Allen Airport"
    ],
    "city": [
      "Hanapepe",
      "Hanapepe",
      "Hanapepe"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BSF",
    "translations": [
      "Bradshaw Army Airfield",
      "Bradshaw Army Airfield",
      "Bradshaw Army Airfield"
    ],
    "city": [
      "Waimea (Kamuela)",
      "Waimea (Kamuela)",
      "Waimea (Kamuela)"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ITO",
    "translations": [
      "Hilo International Airport",
      "Hilo International Airport",
      "Hilo International Airport"
    ],
    "city": [
      "Hilo",
      "Hilo",
      "Hilo"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UPP",
    "translations": [
      "Upolu Airport",
      "Upolu Airport",
      "Upolu Airport"
    ],
    "city": [
      "Hawi",
      "Hawi",
      "Hawi"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BHC",
    "translations": [
      "Bhurban Heliport",
      "Bhurban Heliport",
      "Bhurban Heliport"
    ],
    "city": [
      "Bhurban",
      "Bhurban",
      "Bhurban"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "CWP",
    "translations": [
      "Campbellpore Airport",
      "Campbellpore Airport",
      "Campbellpore Airport"
    ],
    "city": [
      "Campbellpore",
      "Campbellpore",
      "Campbellpore"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "GRT",
    "translations": [
      "Gujrat Airport",
      "Gujrat Airport",
      "Gujrat Airport"
    ],
    "city": [
      "Gujrat",
      "Gujrat",
      "Gujrat"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "KCF",
    "translations": [
      "Kadanwari Airport",
      "Kadanwari Airport",
      "Kadanwari Airport"
    ],
    "city": [
      "Kadanwari",
      "Kadanwari",
      "Kadanwari"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "REQ",
    "translations": [
      "Reko Diq Airport",
      "Reko Diq Airport",
      "Reko Diq Airport"
    ],
    "city": [
      "Chagai",
      "Chagai",
      "Chagai"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "ENT",
    "translations": [
      "Eniwetok Airport",
      "Eniwetok Airport",
      "Eniwetok Airport"
    ],
    "city": [
      "Eniwetok Atoll",
      "Eniwetok Atoll",
      "Eniwetok Atoll"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "MAJ",
    "translations": [
      "Marshall Islands International Airport",
      "Marshall Islands International Airport",
      "Marshall Islands International Airport"
    ],
    "city": [
      "Majuro Atoll",
      "Majuro Atoll",
      "Majuro Atoll"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "KWA",
    "translations": [
      "Bucholz Army Air Field",
      "Bucholz Army Air Field",
      "Bucholz Army Air Field"
    ],
    "city": [
      "Kwajalein",
      "Kwajalein",
      "Kwajalein"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "CXI",
    "translations": [
      "Cassidy International Airport",
      "Cassidy International Airport",
      "Cassidy International Airport"
    ],
    "city": [
      "Kiritimati",
      "Kiritimati",
      "Kiritimati"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "TNV",
    "translations": [
      "Tabuaeran Island Airport",
      "Tabuaeran Island Airport",
      "Tabuaeran Island Airport"
    ],
    "city": [
      "Tabuaeran Island",
      "Tabuaeran Island",
      "Tabuaeran Island"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "TNQ",
    "translations": [
      "Washington Island Airstrip",
      "Washington Island Airstrip",
      "Washington Island Airstrip"
    ],
    "city": [
      "Teraina",
      "Teraina",
      "Teraina"
    ],
    "country": [
      "KI",
      "KI",
      "KI"
    ]
  },
  {
    "iata": "MDY",
    "translations": [
      "Henderson Field",
      "Henderson Field",
      "Henderson Field"
    ],
    "city": [
      "Sand Island",
      "Sand Island",
      "Sand Island"
    ],
    "country": [
      "UM",
      "UM",
      "UM"
    ]
  },
  {
    "iata": "PIZ",
    "translations": [
      "Point Lay LRRS Airport",
      "Point Lay LRRS Airport",
      "Point Lay LRRS Airport"
    ],
    "city": [
      "Point Lay",
      "Point Lay",
      "Point Lay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PPX",
    "translations": [
      "Param Airport",
      "Param Airport",
      "Param Airport"
    ],
    "city": [
      "Nepesi",
      "Nepesi",
      "Nepesi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "PQD",
    "translations": [
      "Passikudah Helipad",
      "Passikudah Helipad",
      "Passikudah Helipad"
    ],
    "city": [
      "Batticaloa",
      "Batticaloa",
      "Batticaloa"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "HUC",
    "translations": [
      "Dr Hermenegildo Ortiz Quinones Airport",
      "Dr Hermenegildo Ortiz Quinones Airport",
      "Dr Hermenegildo Ortiz Quinones Airport"
    ],
    "city": [
      "Humacao",
      "Humacao",
      "Humacao"
    ],
    "country": [
      "PR",
      "PR",
      "PR"
    ]
  },
  {
    "iata": "XSO",
    "translations": [
      "Siocon Airport",
      "Siocon Airport",
      "Siocon Airport"
    ],
    "city": [
      "Siocon",
      "Siocon",
      "Siocon"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "TKK",
    "translations": [
      "Chuuk International Airport",
      "Chuuk International Airport",
      "Chuuk International Airport"
    ],
    "city": [
      "Weno Island",
      "Weno Island",
      "Weno Island"
    ],
    "country": [
      "FM",
      "FM",
      "FM"
    ]
  },
  {
    "iata": "PNI",
    "translations": [
      "Pohnpei International Airport",
      "Pohnpei International Airport",
      "Pohnpei International Airport"
    ],
    "city": [
      "Pohnpei Island",
      "Pohnpei Island",
      "Pohnpei Island"
    ],
    "country": [
      "FM",
      "FM",
      "FM"
    ]
  },
  {
    "iata": "ROR",
    "translations": [
      "Babelthuap Airport",
      "Babelthuap Airport",
      "Babelthuap Airport"
    ],
    "city": [
      "Babelthuap Island",
      "Babelthuap Island",
      "Babelthuap Island"
    ],
    "country": [
      "PW",
      "PW",
      "PW"
    ]
  },
  {
    "iata": "KSA",
    "translations": [
      "Kosrae International Airport",
      "Kosrae International Airport",
      "Kosrae International Airport"
    ],
    "city": [
      "Okat",
      "Okat",
      "Okat"
    ],
    "country": [
      "FM",
      "FM",
      "FM"
    ]
  },
  {
    "iata": "YAP",
    "translations": [
      "Yap International Airport",
      "Yap International Airport",
      "Yap International Airport"
    ],
    "city": [
      "Yap Island",
      "Yap Island",
      "Yap Island"
    ],
    "country": [
      "FM",
      "FM",
      "FM"
    ]
  },
  {
    "iata": "PUA",
    "translations": [
      "Puas Airport",
      "Puas Airport",
      "Puas Airport"
    ],
    "city": [
      "Puas Mission",
      "Puas Mission",
      "Puas Mission"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "AWK",
    "translations": [
      "Wake Island Airfield",
      "Wake Island Airfield",
      "Wake Island Airfield"
    ],
    "city": [
      "Wake Island",
      "Wake Island",
      "Wake Island"
    ],
    "country": [
      "UM",
      "UM",
      "UM"
    ]
  },
  {
    "iata": "PWR",
    "translations": [
      "Port Walter Seaplane Base",
      "Port Walter Seaplane Base",
      "Port Walter Seaplane Base"
    ],
    "city": [
      "Port Walter",
      "Port Walter",
      "Port Walter"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PBT",
    "translations": [
      "Aeródromo de Puerto Leda",
      "Aeródromo de Puerto Leda",
      "Aeródromo de Puerto Leda"
    ],
    "city": [
      "Puerto Leda",
      "Puerto Leda",
      "Puerto Leda"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "PCJ",
    "translations": [
      "Aeródromo de Puerto La Victoria",
      "Aeródromo de Puerto La Victoria",
      "Aeródromo de Puerto La Victoria"
    ],
    "city": [
      "Puerto La Victoria",
      "Puerto La Victoria",
      "Puerto La Victoria"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "PYL",
    "translations": [
      "Perry Island Seaplane Base",
      "Perry Island Seaplane Base",
      "Perry Island Seaplane Base"
    ],
    "city": [
      "Perry Island",
      "Perry Island",
      "Perry Island"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KIO",
    "translations": [
      "Kili Airport",
      "Kili Airport",
      "Kili Airport"
    ],
    "city": [
      "Kili Island",
      "Kili Island",
      "Kili Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "QFX",
    "translations": [
      "Igaliku Heliport",
      "Igaliku Heliport",
      "Igaliku Heliport"
    ],
    "city": [
      "Igaliku",
      "Igaliku",
      "Igaliku"
    ],
    "country": [
      "GL",
      "GL",
      "GL"
    ]
  },
  {
    "iata": "QJP",
    "translations": [
      "Pocheon (G-217) Airport",
      "Pocheon (G-217) Airport",
      "Pocheon (G-217) Airport"
    ],
    "city": [
      "Pocheon",
      "Pocheon",
      "Pocheon"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "RAA",
    "translations": [
      "Rakanda Airport",
      "Rakanda Airport",
      "Rakanda Airport"
    ],
    "city": [
      "Rakanda",
      "Rakanda",
      "Rakanda"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "RAW",
    "translations": [
      "Arawa Airport",
      "Arawa Airport",
      "Arawa Airport"
    ],
    "city": [
      "Arawa",
      "Arawa",
      "Arawa"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "KNH",
    "translations": [
      "Kinmen Airport",
      "Kinmen Airport",
      "Kinmen Airport"
    ],
    "city": [
      "Shang-I",
      "Shang-I",
      "Shang-I"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "CMJ",
    "translations": [
      "Qimei Airport",
      "Qimei Airport",
      "Qimei Airport"
    ],
    "city": [
      "Qimei",
      "Qimei",
      "Qimei"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "LZN",
    "translations": [
      "Matsu Nangan Airport",
      "Matsu Nangan Airport",
      "Matsu Nangan Airport"
    ],
    "city": [
      "Matsu (Nangan)",
      "Matsu (Nangan)",
      "Matsu (Nangan)"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "TTT",
    "translations": [
      "Taitung Airport",
      "Taitung Airport",
      "Taitung Airport"
    ],
    "city": [
      "Taitung City",
      "Taitung City",
      "Taitung City"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "GNI",
    "translations": [
      "Lüdao Airport",
      "Lüdao Airport",
      "Lüdao Airport"
    ],
    "city": [
      "Lüdao",
      "Lüdao",
      "Lüdao"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "KHH",
    "translations": [
      "Kaohsiung International Airport",
      "Kaohsiung International Airport",
      "Kaohsiung International Airport"
    ],
    "city": [
      "Kaohsiung (Xiaogang)",
      "Kaohsiung (Xiaogang)",
      "Kaohsiung (Xiaogang)"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "CYI",
    "translations": [
      "Chiayi Airport",
      "Chiayi Airport",
      "Chiayi Airport"
    ],
    "city": [
      "Shuishang",
      "Shuishang",
      "Shuishang"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "HCN",
    "translations": [
      "Hengchun Airport",
      "Hengchun Airport",
      "Hengchun Airport"
    ],
    "city": [
      "Hengchun",
      "Hengchun",
      "Hengchun"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "DSX",
    "translations": [
      "Dongsha Island (Pratas Island) Airport",
      "Dongsha Island (Pratas Island) Airport",
      "Dongsha Island (Pratas Island) Airport"
    ],
    "city": [
      "Kaohsiung (Cijin - Pratas Island)",
      "Kaohsiung (Cijin - Pratas Island)",
      "Kaohsiung (Cijin - Pratas Island)"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "KYD",
    "translations": [
      "Lanyu Airport",
      "Lanyu Airport",
      "Lanyu Airport"
    ],
    "city": [
      "Orchid Island",
      "Orchid Island",
      "Orchid Island"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "RMQ",
    "translations": [
      "Taichung International Airport / Ching Chuang Kang Air Base",
      "Taichung International Airport / Ching Chuang Kang Air Base",
      "Taichung International Airport / Ching Chuang Kang Air Base"
    ],
    "city": [
      "Taichung (Qingshui)",
      "Taichung (Qingshui)",
      "Taichung (Qingshui)"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "MFK",
    "translations": [
      "Matsu Beigan Airport",
      "Matsu Beigan Airport",
      "Matsu Beigan Airport"
    ],
    "city": [
      "Matsu (Beigan)",
      "Matsu (Beigan)",
      "Matsu (Beigan)"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "TNN",
    "translations": [
      "Tainan International Airport / Tainan Air Base",
      "Tainan International Airport / Tainan Air Base",
      "Tainan International Airport / Tainan Air Base"
    ],
    "city": [
      "Tainan (Rende)",
      "Tainan (Rende)",
      "Tainan (Rende)"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "HSZ",
    "translations": [
      "Hsinchu Air Base",
      "Hsinchu Air Base",
      "Hsinchu Air Base"
    ],
    "city": [
      "Hsinchu City",
      "Hsinchu City",
      "Hsinchu City"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "MZG",
    "translations": [
      "Penghu Magong Airport",
      "Penghu Magong Airport",
      "Penghu Magong Airport"
    ],
    "city": [
      "Huxi",
      "Huxi",
      "Huxi"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "PIF",
    "translations": [
      "Pingtung Air Force Base North",
      "Pingtung Air Force Base North",
      "Pingtung Air Force Base North"
    ],
    "city": [
      "Pingtung",
      "Pingtung",
      "Pingtung"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "TSA",
    "translations": [
      "Taipei Songshan Airport",
      "Taipei Songshan Airport",
      "Taipei Songshan Airport"
    ],
    "city": [
      "Taipei (Songshan)",
      "Taipei (Songshan)",
      "Taipei (Songshan)"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "TPE",
    "translations": [
      "Taiwan Taoyuan International Airport",
      "Taiwan Taoyuan International Airport",
      "Taiwan Taoyuan International Airport"
    ],
    "city": [
      "Taoyuan",
      "Taoyuan",
      "Taoyuan"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "WOT",
    "translations": [
      "Wang'an Airport",
      "Wang'an Airport",
      "Wang'an Airport"
    ],
    "city": [
      "Wang'an",
      "Wang'an",
      "Wang'an"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "HUN",
    "translations": [
      "Hualien Airport",
      "Hualien Airport",
      "Hualien Airport"
    ],
    "city": [
      "Hualien City",
      "Hualien City",
      "Hualien City"
    ],
    "country": [
      "TW",
      "TW",
      "TW"
    ]
  },
  {
    "iata": "RDV",
    "translations": [
      "Red Devil Airport",
      "Red Devil Airport",
      "Red Devil Airport"
    ],
    "city": [
      "Red Devil",
      "Red Devil",
      "Red Devil"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RHT",
    "translations": [
      "Alxa Right Banner Badanjilin Airport",
      "Alxa Right Banner Badanjilin Airport",
      "Alxa Right Banner Badanjilin Airport"
    ],
    "city": [
      "Badanjilin",
      "Badanjilin",
      "Badanjilin"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NRT",
    "translations": [
      "Narita International Airport",
      "Narita International Airport",
      "Narita International Airport"
    ],
    "city": [
      "Narita",
      "Narita",
      "Narita"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "MMJ",
    "translations": [
      "Shinshu-Matsumoto Airport",
      "Shinshu-Matsumoto Airport",
      "Shinshu-Matsumoto Airport"
    ],
    "city": [
      "Matsumoto",
      "Matsumoto",
      "Matsumoto"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "IBR",
    "translations": [
      "Ibaraki Airport / JASDF Hyakuri Air Base",
      "Ibaraki Airport / JASDF Hyakuri Air Base",
      "Ibaraki Airport / JASDF Hyakuri Air Base"
    ],
    "city": [
      "Omitama",
      "Omitama",
      "Omitama"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "MUS",
    "translations": [
      "JMSDF Minami Torishima Air Base",
      "JMSDF Minami Torishima Air Base",
      "JMSDF Minami Torishima Air Base"
    ],
    "city": [
      "Ogasawara",
      "Ogasawara",
      "Ogasawara"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "IWO",
    "translations": [
      "Ioto (Iwo Jima) Airbase",
      "Ioto (Iwo Jima) Airbase",
      "Ioto (Iwo Jima) Airbase"
    ],
    "city": [
      "Ogasawara",
      "Ogasawara",
      "Ogasawara"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "KIX",
    "translations": [
      "Kansai International Airport",
      "Kansai International Airport",
      "Kansai International Airport"
    ],
    "city": [
      "Osaka",
      "Osaka",
      "Osaka"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "SHM",
    "translations": [
      "Nanki Shirahama Airport",
      "Nanki Shirahama Airport",
      "Nanki Shirahama Airport"
    ],
    "city": [
      "Shirahama",
      "Shirahama",
      "Shirahama"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "UKB",
    "translations": [
      "Kobe Airport",
      "Kobe Airport",
      "Kobe Airport"
    ],
    "city": [
      "Kobe",
      "Kobe",
      "Kobe"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "HIW",
    "translations": [
      "Hiroshima Heliport",
      "Hiroshima Heliport",
      "Hiroshima Heliport"
    ],
    "city": [
      "Hiroshima",
      "Hiroshima",
      "Hiroshima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "TJH",
    "translations": [
      "Konotori Tajima Airport",
      "Konotori Tajima Airport",
      "Konotori Tajima Airport"
    ],
    "city": [
      "Toyooka",
      "Toyooka",
      "Toyooka"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "OBO",
    "translations": [
      "Tokachi-Obihiro Airport",
      "Tokachi-Obihiro Airport",
      "Tokachi-Obihiro Airport"
    ],
    "city": [
      "Obihiro",
      "Obihiro",
      "Obihiro"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "CTS",
    "translations": [
      "New Chitose Airport",
      "New Chitose Airport",
      "New Chitose Airport"
    ],
    "city": [
      "Sapporo",
      "Sapporo",
      "Sapporo"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "HKD",
    "translations": [
      "Hakodate Airport",
      "Hakodate Airport",
      "Hakodate Airport"
    ],
    "city": [
      "Hakodate",
      "Hakodate",
      "Hakodate"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "KUH",
    "translations": [
      "Kushiro Airport",
      "Kushiro Airport",
      "Kushiro Airport"
    ],
    "city": [
      "Kushiro",
      "Kushiro",
      "Kushiro"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "MMB",
    "translations": [
      "Memanbetsu Airport",
      "Memanbetsu Airport",
      "Memanbetsu Airport"
    ],
    "city": [
      "Ōzora",
      "Ōzora",
      "Ōzora"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "SHB",
    "translations": [
      "Nakashibetsu Airport",
      "Nakashibetsu Airport",
      "Nakashibetsu Airport"
    ],
    "city": [
      "Nakashibetsu",
      "Nakashibetsu",
      "Nakashibetsu"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "OKD",
    "translations": [
      "Sapporo Okadama Airport",
      "Sapporo Okadama Airport",
      "Sapporo Okadama Airport"
    ],
    "city": [
      "Sapporo",
      "Sapporo",
      "Sapporo"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "RBJ",
    "translations": [
      "Rebun Airport",
      "Rebun Airport",
      "Rebun Airport"
    ],
    "city": [
      "Rebun",
      "Rebun",
      "Rebun"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "WKJ",
    "translations": [
      "Wakkanai Airport",
      "Wakkanai Airport",
      "Wakkanai Airport"
    ],
    "city": [
      "Wakkanai",
      "Wakkanai",
      "Wakkanai"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "AXJ",
    "translations": [
      "Amakusa Airport",
      "Amakusa Airport",
      "Amakusa Airport"
    ],
    "city": [
      "Amakusa",
      "Amakusa",
      "Amakusa"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "IKI",
    "translations": [
      "Iki Airport",
      "Iki Airport",
      "Iki Airport"
    ],
    "city": [
      "Iki",
      "Iki",
      "Iki"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "UBJ",
    "translations": [
      "Yamaguchi Ube Airport",
      "Yamaguchi Ube Airport",
      "Yamaguchi Ube Airport"
    ],
    "city": [
      "Ube",
      "Ube",
      "Ube"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "TSJ",
    "translations": [
      "Tsushima Airport",
      "Tsushima Airport",
      "Tsushima Airport"
    ],
    "city": [
      "Tsushima",
      "Tsushima",
      "Tsushima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "OMJ",
    "translations": [
      "JMSDF Omura Air Base",
      "JMSDF Omura Air Base",
      "JMSDF Omura Air Base"
    ],
    "city": [
      "Nagasaki",
      "Nagasaki",
      "Nagasaki"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "MBE",
    "translations": [
      "Monbetsu Airport",
      "Monbetsu Airport",
      "Monbetsu Airport"
    ],
    "city": [
      "Monbetsu",
      "Monbetsu",
      "Monbetsu"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "AKJ",
    "translations": [
      "Asahikawa Airport",
      "Asahikawa Airport",
      "Asahikawa Airport"
    ],
    "city": [
      "Higashikagura",
      "Higashikagura",
      "Higashikagura"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "OIR",
    "translations": [
      "Okushiri Airport",
      "Okushiri Airport",
      "Okushiri Airport"
    ],
    "city": [
      "Okushiri Island",
      "Okushiri Island",
      "Okushiri Island"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "RIS",
    "translations": [
      "Rishiri Airport",
      "Rishiri Airport",
      "Rishiri Airport"
    ],
    "city": [
      "Rishiri",
      "Rishiri",
      "Rishiri"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "KUM",
    "translations": [
      "Yakushima Airport",
      "Yakushima Airport",
      "Yakushima Airport"
    ],
    "city": [
      "Yakushima",
      "Yakushima",
      "Yakushima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "FUJ",
    "translations": [
      "Fukue Airport",
      "Fukue Airport",
      "Fukue Airport"
    ],
    "city": [
      "Goto",
      "Goto",
      "Goto"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "FUK",
    "translations": [
      "Fukuoka Airport",
      "Fukuoka Airport",
      "Fukuoka Airport"
    ],
    "city": [
      "Fukuoka",
      "Fukuoka",
      "Fukuoka"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "TNE",
    "translations": [
      "New Tanegashima Airport",
      "New Tanegashima Airport",
      "New Tanegashima Airport"
    ],
    "city": [
      "Tanegashima",
      "Tanegashima",
      "Tanegashima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "KOJ",
    "translations": [
      "Kagoshima Airport",
      "Kagoshima Airport",
      "Kagoshima Airport"
    ],
    "city": [
      "Kagoshima",
      "Kagoshima",
      "Kagoshima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "KMI",
    "translations": [
      "Miyazaki Airport",
      "Miyazaki Airport",
      "Miyazaki Airport"
    ],
    "city": [
      "Miyazaki",
      "Miyazaki",
      "Miyazaki"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "OIT",
    "translations": [
      "Oita Airport",
      "Oita Airport",
      "Oita Airport"
    ],
    "city": [
      "Oita",
      "Oita",
      "Oita"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "KKJ",
    "translations": [
      "Kitakyushu Airport",
      "Kitakyushu Airport",
      "Kitakyushu Airport"
    ],
    "city": [
      "Kitakyushu",
      "Kitakyushu",
      "Kitakyushu"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "HSG",
    "translations": [
      "Saga Airport",
      "Saga Airport",
      "Saga Airport"
    ],
    "city": [
      "Saga",
      "Saga",
      "Saga"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "KMJ",
    "translations": [
      "Kumamoto Airport",
      "Kumamoto Airport",
      "Kumamoto Airport"
    ],
    "city": [
      "Kumamoto",
      "Kumamoto",
      "Kumamoto"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "NGS",
    "translations": [
      "Nagasaki Airport",
      "Nagasaki Airport",
      "Nagasaki Airport"
    ],
    "city": [
      "Nagasaki",
      "Nagasaki",
      "Nagasaki"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "NGO",
    "translations": [
      "Chubu Centrair International Airport",
      "Chubu Centrair International Airport",
      "Chubu Centrair International Airport"
    ],
    "city": [
      "Tokoname",
      "Tokoname",
      "Tokoname"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "ASJ",
    "translations": [
      "Amami Airport",
      "Amami Airport",
      "Amami Airport"
    ],
    "city": [
      "Amami",
      "Amami",
      "Amami"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "OKE",
    "translations": [
      "Okinoerabu Airport",
      "Okinoerabu Airport",
      "Okinoerabu Airport"
    ],
    "city": [
      "Wadomari",
      "Wadomari",
      "Wadomari"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "KKX",
    "translations": [
      "Kikai Airport",
      "Kikai Airport",
      "Kikai Airport"
    ],
    "city": [
      "Kikai",
      "Kikai",
      "Kikai"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "TKN",
    "translations": [
      "Tokunoshima Airport",
      "Tokunoshima Airport",
      "Tokunoshima Airport"
    ],
    "city": [
      "Amagi",
      "Amagi",
      "Amagi"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "NKM",
    "translations": [
      "Nagoya Airport / JASDF Komaki Air Base",
      "Nagoya Airport / JASDF Komaki Air Base",
      "Nagoya Airport / JASDF Komaki Air Base"
    ],
    "city": [
      "Nagoya",
      "Nagoya",
      "Nagoya"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "FKJ",
    "translations": [
      "Fukui Airport",
      "Fukui Airport",
      "Fukui Airport"
    ],
    "city": [
      "Fukui",
      "Fukui",
      "Fukui"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "QGU",
    "translations": [
      "Gifu Airport",
      "Gifu Airport",
      "Gifu Airport"
    ],
    "city": [
      "Gifu",
      "Gifu",
      "Gifu"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "KMQ",
    "translations": [
      "Komatsu Airport / JASDF Komatsu Air Base",
      "Komatsu Airport / JASDF Komatsu Air Base",
      "Komatsu Airport / JASDF Komatsu Air Base"
    ],
    "city": [
      "Kanazawa",
      "Kanazawa",
      "Kanazawa"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "OKI",
    "translations": [
      "Oki Global Geopark Airport",
      "Oki Global Geopark Airport",
      "Oki Global Geopark Airport"
    ],
    "city": [
      "Okinoshima",
      "Okinoshima",
      "Okinoshima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "FSZ",
    "translations": [
      "Mount Fuji Shizuoka Airport",
      "Mount Fuji Shizuoka Airport",
      "Mount Fuji Shizuoka Airport"
    ],
    "city": [
      "Makinohara / Shimada",
      "Makinohara / Shimada",
      "Makinohara / Shimada"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "TOY",
    "translations": [
      "Toyama Airport",
      "Toyama Airport",
      "Toyama Airport"
    ],
    "city": [
      "Toyama",
      "Toyama",
      "Toyama"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "NTQ",
    "translations": [
      "Noto Satoyama Airport",
      "Noto Satoyama Airport",
      "Noto Satoyama Airport"
    ],
    "city": [
      "Wajima",
      "Wajima",
      "Wajima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "HIJ",
    "translations": [
      "Hiroshima Airport",
      "Hiroshima Airport",
      "Hiroshima Airport"
    ],
    "city": [
      "Hiroshima",
      "Hiroshima",
      "Hiroshima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "OKJ",
    "translations": [
      "Okayama Momotaro Airport",
      "Okayama Momotaro Airport",
      "Okayama Momotaro Airport"
    ],
    "city": [
      "Okayama",
      "Okayama",
      "Okayama"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "IZO",
    "translations": [
      "Izumo Enmusubi Airport",
      "Izumo Enmusubi Airport",
      "Izumo Enmusubi Airport"
    ],
    "city": [
      "Izumo",
      "Izumo",
      "Izumo"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "YGJ",
    "translations": [
      "Yonago Kitaro Airport / JASDF Miho Air Base",
      "Yonago Kitaro Airport / JASDF Miho Air Base",
      "Yonago Kitaro Airport / JASDF Miho Air Base"
    ],
    "city": [
      "Yonago",
      "Yonago",
      "Yonago"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "IWK",
    "translations": [
      "Iwakuni Kintaikyo Airport / Marine Corps Air Station Iwakuni",
      "Iwakuni Kintaikyo Airport / Marine Corps Air Station Iwakuni",
      "Iwakuni Kintaikyo Airport / Marine Corps Air Station Iwakuni"
    ],
    "city": [
      "Iwakuni",
      "Iwakuni",
      "Iwakuni"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "KCZ",
    "translations": [
      "Kochi Ryoma Airport",
      "Kochi Ryoma Airport",
      "Kochi Ryoma Airport"
    ],
    "city": [
      "Nankoku",
      "Nankoku",
      "Nankoku"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "MYJ",
    "translations": [
      "Matsuyama Airport",
      "Matsuyama Airport",
      "Matsuyama Airport"
    ],
    "city": [
      "Matsuyama",
      "Matsuyama",
      "Matsuyama"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "ITM",
    "translations": [
      "Osaka International Airport",
      "Osaka International Airport",
      "Osaka International Airport"
    ],
    "city": [
      "Osaka",
      "Osaka",
      "Osaka"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "TTJ",
    "translations": [
      "Tottori Sand Dunes Conan Airport",
      "Tottori Sand Dunes Conan Airport",
      "Tottori Sand Dunes Conan Airport"
    ],
    "city": [
      "Tottori",
      "Tottori",
      "Tottori"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "TKS",
    "translations": [
      "Tokushima Awaodori Airport / JMSDF Tokushima Air Base",
      "Tokushima Awaodori Airport / JMSDF Tokushima Air Base",
      "Tokushima Awaodori Airport / JMSDF Tokushima Air Base"
    ],
    "city": [
      "Tokushima",
      "Tokushima",
      "Tokushima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "TAK",
    "translations": [
      "Takamatsu Airport",
      "Takamatsu Airport",
      "Takamatsu Airport"
    ],
    "city": [
      "Takamatsu",
      "Takamatsu",
      "Takamatsu"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "IWJ",
    "translations": [
      "Iwami Airport",
      "Iwami Airport",
      "Iwami Airport"
    ],
    "city": [
      "Masuda",
      "Masuda",
      "Masuda"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "AOJ",
    "translations": [
      "Aomori Airport",
      "Aomori Airport",
      "Aomori Airport"
    ],
    "city": [
      "Aomori",
      "Aomori",
      "Aomori"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "GAJ",
    "translations": [
      "Yamagata Airport",
      "Yamagata Airport",
      "Yamagata Airport"
    ],
    "city": [
      "Higashine",
      "Higashine",
      "Higashine"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "SDS",
    "translations": [
      "Sado Airport",
      "Sado Airport",
      "Sado Airport"
    ],
    "city": [
      "Sado",
      "Sado",
      "Sado"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "FKS",
    "translations": [
      "Fukushima Airport",
      "Fukushima Airport",
      "Fukushima Airport"
    ],
    "city": [
      "Sukagawa",
      "Sukagawa",
      "Sukagawa"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "HHE",
    "translations": [
      "JMSDF Hachinohe Air Base / Hachinohe Airport",
      "JMSDF Hachinohe Air Base / Hachinohe Airport",
      "JMSDF Hachinohe Air Base / Hachinohe Airport"
    ],
    "city": [
      "Hachinohe",
      "Hachinohe",
      "Hachinohe"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "HNA",
    "translations": [
      "Iwate Hanamaki Airport",
      "Iwate Hanamaki Airport",
      "Iwate Hanamaki Airport"
    ],
    "city": [
      "Hanamaki",
      "Hanamaki",
      "Hanamaki"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "AXT",
    "translations": [
      "Akita Airport",
      "Akita Airport",
      "Akita Airport"
    ],
    "city": [
      "Akita",
      "Akita",
      "Akita"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "MSJ",
    "translations": [
      "Misawa Airport / Misawa Air Base",
      "Misawa Airport / Misawa Air Base",
      "Misawa Airport / Misawa Air Base"
    ],
    "city": [
      "Misawa",
      "Misawa",
      "Misawa"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "KIJ",
    "translations": [
      "Niigata Airport",
      "Niigata Airport",
      "Niigata Airport"
    ],
    "city": [
      "Niigata",
      "Niigata",
      "Niigata"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "ONJ",
    "translations": [
      "Odate Noshiro Airport",
      "Odate Noshiro Airport",
      "Odate Noshiro Airport"
    ],
    "city": [
      "Kitaakita",
      "Kitaakita",
      "Kitaakita"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "SDJ",
    "translations": [
      "Sendai Airport",
      "Sendai Airport",
      "Sendai Airport"
    ],
    "city": [
      "Natori",
      "Natori",
      "Natori"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "SYO",
    "translations": [
      "Shonai Airport",
      "Shonai Airport",
      "Shonai Airport"
    ],
    "city": [
      "Shonai",
      "Shonai",
      "Shonai"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "NJA",
    "translations": [
      "JMSDF Atsugi Air Base / Naval Air Facility Atsugi",
      "JMSDF Atsugi Air Base / Naval Air Facility Atsugi",
      "JMSDF Atsugi Air Base / Naval Air Facility Atsugi"
    ],
    "city": [
      "Ayase / Yamato",
      "Ayase / Yamato",
      "Ayase / Yamato"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "HAC",
    "translations": [
      "Hachijojima Airport",
      "Hachijojima Airport",
      "Hachijojima Airport"
    ],
    "city": [
      "Hachijojima",
      "Hachijojima",
      "Hachijojima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "OIM",
    "translations": [
      "Oshima Airport",
      "Oshima Airport",
      "Oshima Airport"
    ],
    "city": [
      "Izu Oshima",
      "Izu Oshima",
      "Izu Oshima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "MYE",
    "translations": [
      "Miyakejima Airport",
      "Miyakejima Airport",
      "Miyakejima Airport"
    ],
    "city": [
      "Miyakejima",
      "Miyakejima",
      "Miyakejima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "HND",
    "translations": [
      "Tokyo Haneda International Airport",
      "Tokyo Haneda International Airport",
      "Tokyo Haneda International Airport"
    ],
    "city": [
      "Tokyo",
      "Tokyo",
      "Tokyo"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "OKO",
    "translations": [
      "Yokota Air Base",
      "Yokota Air Base",
      "Yokota Air Base"
    ],
    "city": [
      "Fussa",
      "Fussa",
      "Fussa"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "MWX",
    "translations": [
      "Muan International Airport",
      "Muan International Airport",
      "Muan International Airport"
    ],
    "city": [
      "Muan (Piseo-ri)",
      "Muan (Piseo-ri)",
      "Muan (Piseo-ri)"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "KWJ",
    "translations": [
      "Gwangju Airport",
      "Gwangju Airport",
      "Gwangju Airport"
    ],
    "city": [
      "Gwangju",
      "Gwangju",
      "Gwangju"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "KUV",
    "translations": [
      "Gunsan Airport / Gunsan Air Base",
      "Gunsan Airport / Gunsan Air Base",
      "Gunsan Airport / Gunsan Air Base"
    ],
    "city": [
      "Gunsan",
      "Gunsan",
      "Gunsan"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "CHN",
    "translations": [
      "Jeonju (G 703) Air Base",
      "Jeonju (G 703) Air Base",
      "Jeonju (G 703) Air Base"
    ],
    "city": [
      "Jeonju",
      "Jeonju",
      "Jeonju"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "RSU",
    "translations": [
      "Yeosu Airport",
      "Yeosu Airport",
      "Yeosu Airport"
    ],
    "city": [
      "Yeosu",
      "Yeosu",
      "Yeosu"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "KAG",
    "translations": [
      "Gangneung Airport (K-18)",
      "Gangneung Airport (K-18)",
      "Gangneung Airport (K-18)"
    ],
    "city": [
      "Gangneung",
      "Gangneung",
      "Gangneung"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "WJU",
    "translations": [
      "Wonju Airport / Hoengseong Air Base (K-38/K-46)",
      "Wonju Airport / Hoengseong Air Base (K-38/K-46)",
      "Wonju Airport / Hoengseong Air Base (K-38/K-46)"
    ],
    "city": [
      "Wonju",
      "Wonju",
      "Wonju"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "YNY",
    "translations": [
      "Yangyang International Airport",
      "Yangyang International Airport",
      "Yangyang International Airport"
    ],
    "city": [
      "Gonghang-ro",
      "Gonghang-ro",
      "Gonghang-ro"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "CJU",
    "translations": [
      "Jeju International Airport",
      "Jeju International Airport",
      "Jeju International Airport"
    ],
    "city": [
      "Jeju City",
      "Jeju City",
      "Jeju City"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "JDG",
    "translations": [
      "Jeongseok Airport",
      "Jeongseok Airport",
      "Jeongseok Airport"
    ],
    "city": [
      "Jeju Island",
      "Jeju Island",
      "Jeju Island"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "CHF",
    "translations": [
      "Jinhae Air Base",
      "Jinhae Air Base",
      "Jinhae Air Base"
    ],
    "city": [
      "Jinhae",
      "Jinhae",
      "Jinhae"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "PUS",
    "translations": [
      "Gimhae International Airport",
      "Gimhae International Airport",
      "Gimhae International Airport"
    ],
    "city": [
      "Busan",
      "Busan",
      "Busan"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "HIN",
    "translations": [
      "Sacheon Airport / Sacheon Air Base",
      "Sacheon Airport / Sacheon Air Base",
      "Sacheon Airport / Sacheon Air Base"
    ],
    "city": [
      "Sacheon",
      "Sacheon",
      "Sacheon"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "USN",
    "translations": [
      "Ulsan Airport",
      "Ulsan Airport",
      "Ulsan Airport"
    ],
    "city": [
      "Ulsan",
      "Ulsan",
      "Ulsan"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "ICN",
    "translations": [
      "Incheon International Airport",
      "Incheon International Airport",
      "Incheon International Airport"
    ],
    "city": [
      "Seoul",
      "Seoul",
      "Seoul"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "SSN",
    "translations": [
      "Seoul Air Base (K-16)",
      "Seoul Air Base (K-16)",
      "Seoul Air Base (K-16)"
    ],
    "city": [
      "Seongnam",
      "Seongnam",
      "Seongnam"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "OSN",
    "translations": [
      "Osan Air Base",
      "Osan Air Base",
      "Osan Air Base"
    ],
    "city": [
      "Pyeongtaek",
      "Pyeongtaek",
      "Pyeongtaek"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "GMP",
    "translations": [
      "Gimpo International Airport",
      "Gimpo International Airport",
      "Gimpo International Airport"
    ],
    "city": [
      "Seoul",
      "Seoul",
      "Seoul"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "SWU",
    "translations": [
      "Suwon Airport",
      "Suwon Airport",
      "Suwon Airport"
    ],
    "city": [
      "Suwon",
      "Suwon",
      "Suwon"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "QDY",
    "translations": [
      "Taean Airport",
      "Taean Airport",
      "Taean Airport"
    ],
    "city": [
      "Taean",
      "Taean",
      "Taean"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "KPO",
    "translations": [
      "Pohang Airport (G-815/K-3)",
      "Pohang Airport (G-815/K-3)",
      "Pohang Airport (G-815/K-3)"
    ],
    "city": [
      "Pohang",
      "Pohang",
      "Pohang"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "JWO",
    "translations": [
      "Jungwon Air Base/Chungju Airport",
      "Jungwon Air Base/Chungju Airport",
      "Jungwon Air Base/Chungju Airport"
    ],
    "city": [
      "Gimseang-ro",
      "Gimseang-ro",
      "Gimseang-ro"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "UJN",
    "translations": [
      "Uljin Airport",
      "Uljin Airport",
      "Uljin Airport"
    ],
    "city": [
      "Bongsan-ri, Uljin",
      "Bongsan-ri, Uljin",
      "Bongsan-ri, Uljin"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "TAE",
    "translations": [
      "Daegu Airport",
      "Daegu Airport",
      "Daegu Airport"
    ],
    "city": [
      "Daegu",
      "Daegu",
      "Daegu"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "HMY",
    "translations": [
      "Seosan Air Base",
      "Seosan Air Base",
      "Seosan Air Base"
    ],
    "city": [
      "Seosan",
      "Seosan",
      "Seosan"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "CJJ",
    "translations": [
      "Cheongju International Airport/Cheongju Air Base (K-59/G-513)",
      "Cheongju International Airport/Cheongju Air Base (K-59/G-513)",
      "Cheongju International Airport/Cheongju Air Base (K-59/G-513)"
    ],
    "city": [
      "Cheongju",
      "Cheongju",
      "Cheongju"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "YEC",
    "translations": [
      "Yecheon Airbase",
      "Yecheon Airbase",
      "Yecheon Airbase"
    ],
    "city": [
      "Yecheon-ri",
      "Yecheon-ri",
      "Yecheon-ri"
    ],
    "country": [
      "KR",
      "KR",
      "KR"
    ]
  },
  {
    "iata": "RKY",
    "translations": [
      "Rokeby Airport",
      "Rokeby Airport",
      "Rokeby Airport"
    ],
    "city": [
      "Rokeby",
      "Rokeby",
      "Rokeby"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RLP",
    "translations": [
      "Rosella Plains Airport",
      "Rosella Plains Airport",
      "Rosella Plains Airport"
    ],
    "city": [
      "Rosella Plains",
      "Rosella Plains",
      "Rosella Plains"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RMP",
    "translations": [
      "Rampart Airport",
      "Rampart Airport",
      "Rampart Airport"
    ],
    "city": [
      "Rampart",
      "Rampart",
      "Rampart"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "OKA",
    "translations": [
      "Naha Airport / JASDF Naha Air Base",
      "Naha Airport / JASDF Naha Air Base",
      "Naha Airport / JASDF Naha Air Base"
    ],
    "city": [
      "Naha",
      "Naha",
      "Naha"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "DNA",
    "translations": [
      "Kadena Air Base",
      "Kadena Air Base",
      "Kadena Air Base"
    ],
    "city": [
      "Okinawa",
      "Okinawa",
      "Okinawa"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "ISG",
    "translations": [
      "New Ishigaki Airport",
      "New Ishigaki Airport",
      "New Ishigaki Airport"
    ],
    "city": [
      "Ishigaki",
      "Ishigaki",
      "Ishigaki"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "UEO",
    "translations": [
      "Kumejima Airport",
      "Kumejima Airport",
      "Kumejima Airport"
    ],
    "city": [
      "Kumejima",
      "Kumejima",
      "Kumejima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "KJP",
    "translations": [
      "Kerama Airport",
      "Kerama Airport",
      "Kerama Airport"
    ],
    "city": [
      "Zamami",
      "Zamami",
      "Zamami"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "MMD",
    "translations": [
      "Minamidaito Airport",
      "Minamidaito Airport",
      "Minamidaito Airport"
    ],
    "city": [
      "Minamidaito",
      "Minamidaito",
      "Minamidaito"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "MMY",
    "translations": [
      "Miyako Airport",
      "Miyako Airport",
      "Miyako Airport"
    ],
    "city": [
      "Miyakojima",
      "Miyakojima",
      "Miyakojima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "AGJ",
    "translations": [
      "Aguni Airport",
      "Aguni Airport",
      "Aguni Airport"
    ],
    "city": [
      "Aguni",
      "Aguni",
      "Aguni"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "IEJ",
    "translations": [
      "Iejima Airport",
      "Iejima Airport",
      "Iejima Airport"
    ],
    "city": [
      "Ie",
      "Ie",
      "Ie"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "HTR",
    "translations": [
      "Hateruma Airport",
      "Hateruma Airport",
      "Hateruma Airport"
    ],
    "city": [
      "Taketomi",
      "Taketomi",
      "Taketomi"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "KTD",
    "translations": [
      "Kitadaito Airport",
      "Kitadaito Airport",
      "Kitadaito Airport"
    ],
    "city": [
      "Kitadaitōjima",
      "Kitadaitōjima",
      "Kitadaitōjima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "SHI",
    "translations": [
      "Shimojishima Airport",
      "Shimojishima Airport",
      "Shimojishima Airport"
    ],
    "city": [
      "Miyakojima",
      "Miyakojima",
      "Miyakojima"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "TRA",
    "translations": [
      "Tarama Airport",
      "Tarama Airport",
      "Tarama Airport"
    ],
    "city": [
      "Tarama",
      "Tarama",
      "Tarama"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "RNJ",
    "translations": [
      "Yoron Airport",
      "Yoron Airport",
      "Yoron Airport"
    ],
    "city": [
      "Yoron",
      "Yoron",
      "Yoron"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "OGN",
    "translations": [
      "Yonaguni Airport",
      "Yonaguni Airport",
      "Yonaguni Airport"
    ],
    "city": [
      "Yonaguni",
      "Yonaguni",
      "Yonaguni"
    ],
    "country": [
      "JP",
      "JP",
      "JP"
    ]
  },
  {
    "iata": "ENI",
    "translations": [
      "El Nido Airport",
      "El Nido Airport",
      "El Nido Airport"
    ],
    "city": [
      "El Nido",
      "El Nido",
      "El Nido"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "SFS",
    "translations": [
      "Subic Bay International Airport / Naval Air Station Cubi Point",
      "Subic Bay International Airport / Naval Air Station Cubi Point",
      "Subic Bay International Airport / Naval Air Station Cubi Point"
    ],
    "city": [
      "Olongapo",
      "Olongapo",
      "Olongapo"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "CRK",
    "translations": [
      "Clark International Airport / Clark Air Base",
      "Clark International Airport / Clark Air Base",
      "Clark International Airport / Clark Air Base"
    ],
    "city": [
      "Mabalacat",
      "Mabalacat",
      "Mabalacat"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "BSI",
    "translations": [
      "Balesin Island Airport",
      "Balesin Island Airport",
      "Balesin Island Airport"
    ],
    "city": [
      "Balesin",
      "Balesin",
      "Balesin"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "LLC",
    "translations": [
      "Cagayan North International Airport",
      "Cagayan North International Airport",
      "Cagayan North International Airport"
    ],
    "city": [
      "Lal-lo",
      "Lal-lo",
      "Lal-lo"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "LAO",
    "translations": [
      "Laoag International Airport",
      "Laoag International Airport",
      "Laoag International Airport"
    ],
    "city": [
      "Laoag City",
      "Laoag City",
      "Laoag City"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "DRP",
    "translations": [
      "Bicol International Airport",
      "Bicol International Airport",
      "Bicol International Airport"
    ],
    "city": [
      "Legazpi",
      "Legazpi",
      "Legazpi"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "MNL",
    "translations": [
      "Ninoy Aquino International Airport",
      "Ninoy Aquino International Airport",
      "Ninoy Aquino International Airport"
    ],
    "city": [
      "Manila (Pasay)",
      "Manila (Pasay)",
      "Manila (Pasay)"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "CYU",
    "translations": [
      "Cuyo Airport",
      "Cuyo Airport",
      "Cuyo Airport"
    ],
    "city": [
      "Cuyo",
      "Cuyo",
      "Cuyo"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "SGL",
    "translations": [
      "Danilo Atienza Air Base",
      "Danilo Atienza Air Base",
      "Danilo Atienza Air Base"
    ],
    "city": [
      "Cavite",
      "Cavite",
      "Cavite"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "LBX",
    "translations": [
      "Lubang Airport",
      "Lubang Airport",
      "Lubang Airport"
    ],
    "city": [
      "Lubang",
      "Lubang",
      "Lubang"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "AAV",
    "translations": [
      "Allah Valley Airport",
      "Allah Valley Airport",
      "Allah Valley Airport"
    ],
    "city": [
      "Surallah",
      "Surallah",
      "Surallah"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "CBO",
    "translations": [
      "Cotabato (Awang) Airport",
      "Cotabato (Awang) Airport",
      "Cotabato (Awang) Airport"
    ],
    "city": [
      "Datu Odin Sinsuat",
      "Datu Odin Sinsuat",
      "Datu Odin Sinsuat"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "DVO",
    "translations": [
      "Francisco Bangoy International Airport",
      "Francisco Bangoy International Airport",
      "Francisco Bangoy International Airport"
    ],
    "city": [
      "Davao",
      "Davao",
      "Davao"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "BXU",
    "translations": [
      "Bancasi Airport",
      "Bancasi Airport",
      "Bancasi Airport"
    ],
    "city": [
      "Butuan",
      "Butuan",
      "Butuan"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "BPH",
    "translations": [
      "Bislig Airport",
      "Bislig Airport",
      "Bislig Airport"
    ],
    "city": [
      "Bislig",
      "Bislig",
      "Bislig"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "DPL",
    "translations": [
      "Dipolog Airport",
      "Dipolog Airport",
      "Dipolog Airport"
    ],
    "city": [
      "Dipolog",
      "Dipolog",
      "Dipolog"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "CGM",
    "translations": [
      "Camiguin Airport",
      "Camiguin Airport",
      "Camiguin Airport"
    ],
    "city": [
      "Mambajao",
      "Mambajao",
      "Mambajao"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "IGN",
    "translations": [
      "Maria Cristina (Iligan) Airport",
      "Maria Cristina (Iligan) Airport",
      "Maria Cristina (Iligan) Airport"
    ],
    "city": [
      "Balo-i",
      "Balo-i",
      "Balo-i"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "JOL",
    "translations": [
      "Jolo Airport",
      "Jolo Airport",
      "Jolo Airport"
    ],
    "city": [
      "Jolo",
      "Jolo",
      "Jolo"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "MLP",
    "translations": [
      "Malabang Airport",
      "Malabang Airport",
      "Malabang Airport"
    ],
    "city": [
      "Malabang",
      "Malabang",
      "Malabang"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "TWT",
    "translations": [
      "Sanga Sanga Airport",
      "Sanga Sanga Airport",
      "Sanga Sanga Airport"
    ],
    "city": [
      "Bongao",
      "Bongao",
      "Bongao"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "OZC",
    "translations": [
      "Labo Airport",
      "Labo Airport",
      "Labo Airport"
    ],
    "city": [
      "Ozamiz",
      "Ozamiz",
      "Ozamiz"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "PAG",
    "translations": [
      "Pagadian Airport",
      "Pagadian Airport",
      "Pagadian Airport"
    ],
    "city": [
      "Pagadian",
      "Pagadian",
      "Pagadian"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "MXI",
    "translations": [
      "Mati National Airport",
      "Mati National Airport",
      "Mati National Airport"
    ],
    "city": [
      "Mati",
      "Mati",
      "Mati"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "GES",
    "translations": [
      "General Santos International Airport",
      "General Santos International Airport",
      "General Santos International Airport"
    ],
    "city": [
      "General Santos",
      "General Santos",
      "General Santos"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "SUG",
    "translations": [
      "Surigao Airport",
      "Surigao Airport",
      "Surigao Airport"
    ],
    "city": [
      "Surigao City",
      "Surigao City",
      "Surigao City"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "CDY",
    "translations": [
      "Cagayan de Sulu Airport",
      "Cagayan de Sulu Airport",
      "Cagayan de Sulu Airport"
    ],
    "city": [
      "Mapun",
      "Mapun",
      "Mapun"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "IPE",
    "translations": [
      "Ipil Airport",
      "Ipil Airport",
      "Ipil Airport"
    ],
    "city": [
      "Ipil",
      "Ipil",
      "Ipil"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "TDG",
    "translations": [
      "Tandag Airport",
      "Tandag Airport",
      "Tandag Airport"
    ],
    "city": [
      "Tandag",
      "Tandag",
      "Tandag"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "CGY",
    "translations": [
      "Laguindingan International Airport",
      "Laguindingan International Airport",
      "Laguindingan International Airport"
    ],
    "city": [
      "Laguindingan",
      "Laguindingan",
      "Laguindingan"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "ZAM",
    "translations": [
      "Zamboanga International Airport",
      "Zamboanga International Airport",
      "Zamboanga International Airport"
    ],
    "city": [
      "Zamboanga",
      "Zamboanga",
      "Zamboanga"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "IAO",
    "translations": [
      "Siargao Airport",
      "Siargao Airport",
      "Siargao Airport"
    ],
    "city": [
      "Del Carmen",
      "Del Carmen",
      "Del Carmen"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "RZP",
    "translations": [
      "Cesar Lim Rodriguez (Taytay-Sandoval) Airport",
      "Cesar Lim Rodriguez (Taytay-Sandoval) Airport",
      "Cesar Lim Rodriguez (Taytay-Sandoval) Airport"
    ],
    "city": [
      "Taytay",
      "Taytay",
      "Taytay"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "TAG",
    "translations": [
      "Bohol-Panglao International Airport",
      "Bohol-Panglao International Airport",
      "Bohol-Panglao International Airport"
    ],
    "city": [
      "Panglao",
      "Panglao",
      "Panglao"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "SWL",
    "translations": [
      "San Vicente Airport",
      "San Vicente Airport",
      "San Vicente Airport"
    ],
    "city": [
      "San Vicente",
      "San Vicente",
      "San Vicente"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "BAG",
    "translations": [
      "Loakan Airport",
      "Loakan Airport",
      "Loakan Airport"
    ],
    "city": [
      "Baguio",
      "Baguio",
      "Baguio"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "DTE",
    "translations": [
      "Daet Airport",
      "Daet Airport",
      "Daet Airport"
    ],
    "city": [
      "Daet",
      "Daet",
      "Daet"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "SJI",
    "translations": [
      "San Jose Airport",
      "San Jose Airport",
      "San Jose Airport"
    ],
    "city": [
      "San Jose",
      "San Jose",
      "San Jose"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "MBO",
    "translations": [
      "Mamburao Airport",
      "Mamburao Airport",
      "Mamburao Airport"
    ],
    "city": [
      "Mamburao",
      "Mamburao",
      "Mamburao"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "WNP",
    "translations": [
      "Naga Airport",
      "Naga Airport",
      "Naga Airport"
    ],
    "city": [
      "Naga",
      "Naga",
      "Naga"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "BSO",
    "translations": [
      "Basco Airport",
      "Basco Airport",
      "Basco Airport"
    ],
    "city": [
      "Basco",
      "Basco",
      "Basco"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "BQA",
    "translations": [
      "Dr Juan C Angara Airport",
      "Dr Juan C Angara Airport",
      "Dr Juan C Angara Airport"
    ],
    "city": [
      "Baler",
      "Baler",
      "Baler"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "SFE",
    "translations": [
      "San Fernando Airport",
      "San Fernando Airport",
      "San Fernando Airport"
    ],
    "city": [
      "San Fernando",
      "San Fernando",
      "San Fernando"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "TUG",
    "translations": [
      "Tuguegarao Airport",
      "Tuguegarao Airport",
      "Tuguegarao Airport"
    ],
    "city": [
      "Tuguegarao City",
      "Tuguegarao City",
      "Tuguegarao City"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "VRC",
    "translations": [
      "Virac Airport",
      "Virac Airport",
      "Virac Airport"
    ],
    "city": [
      "Virac",
      "Virac",
      "Virac"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "MRQ",
    "translations": [
      "Marinduque Airport",
      "Marinduque Airport",
      "Marinduque Airport"
    ],
    "city": [
      "Gasan",
      "Gasan",
      "Gasan"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "CYZ",
    "translations": [
      "Cauayan Airport",
      "Cauayan Airport",
      "Cauayan Airport"
    ],
    "city": [
      "Cauayan City",
      "Cauayan City",
      "Cauayan City"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "RPV",
    "translations": [
      "Roper Valley Airport",
      "Roper Valley Airport",
      "Roper Valley Airport"
    ],
    "city": [
      "Roper Valley",
      "Roper Valley",
      "Roper Valley"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TAC",
    "translations": [
      "Daniel Z. Romualdez Airport",
      "Daniel Z. Romualdez Airport",
      "Daniel Z. Romualdez Airport"
    ],
    "city": [
      "Tacloban City",
      "Tacloban City",
      "Tacloban City"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "BCD",
    "translations": [
      "Bacolod-Silay Airport",
      "Bacolod-Silay Airport",
      "Bacolod-Silay Airport"
    ],
    "city": [
      "Bacolod City",
      "Bacolod City",
      "Bacolod City"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "CYP",
    "translations": [
      "Calbayog Airport",
      "Calbayog Airport",
      "Calbayog Airport"
    ],
    "city": [
      "Calbayog City",
      "Calbayog City",
      "Calbayog City"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "DGT",
    "translations": [
      "Sibulan Airport",
      "Sibulan Airport",
      "Sibulan Airport"
    ],
    "city": [
      "Dumaguete City",
      "Dumaguete City",
      "Dumaguete City"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "MPH",
    "translations": [
      "Godofredo P. Ramos Airport",
      "Godofredo P. Ramos Airport",
      "Godofredo P. Ramos Airport"
    ],
    "city": [
      "Caticlan",
      "Caticlan",
      "Caticlan"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "CRM",
    "translations": [
      "Catarman National Airport",
      "Catarman National Airport",
      "Catarman National Airport"
    ],
    "city": [
      "Catarman",
      "Catarman",
      "Catarman"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "ILO",
    "translations": [
      "Iloilo International Airport",
      "Iloilo International Airport",
      "Iloilo International Airport"
    ],
    "city": [
      "Cabatuan",
      "Cabatuan",
      "Cabatuan"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "MBT",
    "translations": [
      "Moises R. Espinosa Airport",
      "Moises R. Espinosa Airport",
      "Moises R. Espinosa Airport"
    ],
    "city": [
      "Masbate",
      "Masbate",
      "Masbate"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "KLO",
    "translations": [
      "Kalibo International Airport",
      "Kalibo International Airport",
      "Kalibo International Airport"
    ],
    "city": [
      "Kalibo",
      "Kalibo",
      "Kalibo"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "CEB",
    "translations": [
      "Mactan Cebu International Airport",
      "Mactan Cebu International Airport",
      "Mactan Cebu International Airport"
    ],
    "city": [
      "Lapu-Lapu City",
      "Lapu-Lapu City",
      "Lapu-Lapu City"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "OMC",
    "translations": [
      "Ormoc Airport",
      "Ormoc Airport",
      "Ormoc Airport"
    ],
    "city": [
      "Ormoc City",
      "Ormoc City",
      "Ormoc City"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "PPS",
    "translations": [
      "Puerto Princesa International Airport / PAF Antonio Bautista Air Base",
      "Puerto Princesa International Airport / PAF Antonio Bautista Air Base",
      "Puerto Princesa International Airport / PAF Antonio Bautista Air Base"
    ],
    "city": [
      "Puerto Princesa",
      "Puerto Princesa",
      "Puerto Princesa"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "RXS",
    "translations": [
      "Roxas Airport",
      "Roxas Airport",
      "Roxas Airport"
    ],
    "city": [
      "Roxas City",
      "Roxas City",
      "Roxas City"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "EUQ",
    "translations": [
      "Evelio Javier Airport",
      "Evelio Javier Airport",
      "Evelio Javier Airport"
    ],
    "city": [
      "San Jose",
      "San Jose",
      "San Jose"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "TBH",
    "translations": [
      "Tugdan Airport",
      "Tugdan Airport",
      "Tugdan Airport"
    ],
    "city": [
      "Tablas Island",
      "Tablas Island",
      "Tablas Island"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "USU",
    "translations": [
      "Francisco B. Reyes (Busuanga) Airport",
      "Francisco B. Reyes (Busuanga) Airport",
      "Francisco B. Reyes (Busuanga) Airport"
    ],
    "city": [
      "Coron",
      "Coron",
      "Coron"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "BPA",
    "translations": [
      "Borongan Airport",
      "Borongan Airport",
      "Borongan Airport"
    ],
    "city": [
      "Borongan City",
      "Borongan City",
      "Borongan City"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "RRM",
    "translations": [
      "Marromeu Airport",
      "Marromeu Airport",
      "Marromeu Airport"
    ],
    "city": [
      "Marromeu",
      "Marromeu",
      "Marromeu"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "RSE",
    "translations": [
      "Rose Bay Seaplane Base",
      "Rose Bay Seaplane Base",
      "Rose Bay Seaplane Base"
    ],
    "city": [
      "Sydney",
      "Sydney",
      "Sydney"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RSI",
    "translations": [
      "Red Sea International Airport",
      "Red Sea International Airport",
      "Red Sea International Airport"
    ],
    "city": [
      "Hanak",
      "Hanak",
      "Hanak"
    ],
    "country": [
      "SA",
      "SA",
      "SA"
    ]
  },
  {
    "iata": "TKM",
    "translations": [
      "Taksimo Airport",
      "Taksimo Airport",
      "Taksimo Airport"
    ],
    "city": [
      "Taksimo",
      "Taksimo",
      "Taksimo"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NOI",
    "translations": [
      "Krymsk Air Base",
      "Krymsk Air Base",
      "Krymsk Air Base"
    ],
    "city": [
      "Krymsk",
      "Krymsk",
      "Krymsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "MJY",
    "translations": [
      "Motygino Airport",
      "Motygino Airport",
      "Motygino Airport"
    ],
    "city": [
      "Motygino",
      "Motygino",
      "Motygino"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "UHS",
    "translations": [
      "Aleksandrovsk-Sakhalinskiy Airport",
      "Aleksandrovsk-Sakhalinskiy Airport",
      "Aleksandrovsk-Sakhalinskiy Airport"
    ],
    "city": [
      "Aleksandrovsk-Sakhalinskiy",
      "Aleksandrovsk-Sakhalinskiy",
      "Aleksandrovsk-Sakhalinskiy"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KVK",
    "translations": [
      "Kirovsk-Apatity Airport",
      "Kirovsk-Apatity Airport",
      "Kirovsk-Apatity Airport"
    ],
    "city": [
      "Apatity",
      "Apatity",
      "Apatity"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "TYA",
    "translations": [
      "Klokovo Air Base",
      "Klokovo Air Base",
      "Klokovo Air Base"
    ],
    "city": [
      "Tula",
      "Tula",
      "Tula"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "LNX",
    "translations": [
      "Smolensk North Airport",
      "Smolensk North Airport",
      "Smolensk North Airport"
    ],
    "city": [
      "Smolensk",
      "Smolensk",
      "Smolensk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "EIK",
    "translations": [
      "Yeysk Airport",
      "Yeysk Airport",
      "Yeysk Airport"
    ],
    "city": [
      "Yeysk",
      "Yeysk",
      "Yeysk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "RUU",
    "translations": [
      "Ruti Airport",
      "Ruti Airport",
      "Ruti Airport"
    ],
    "city": [
      "Kawbenaberi",
      "Kawbenaberi",
      "Kawbenaberi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "RVC",
    "translations": [
      "River Cess Airport and Heliport",
      "River Cess Airport and Heliport",
      "River Cess Airport and Heliport"
    ],
    "city": [
      "River Cess",
      "River Cess",
      "River Cess"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "LPS",
    "translations": [
      "Lopez Island Airport",
      "Lopez Island Airport",
      "Lopez Island Airport"
    ],
    "city": [
      "Lopez",
      "Lopez",
      "Lopez"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KEH",
    "translations": [
      "Kenmore Air Harbor LLC Seaplane Base",
      "Kenmore Air Harbor LLC Seaplane Base",
      "Kenmore Air Harbor LLC Seaplane Base"
    ],
    "city": [
      "Kenmore",
      "Kenmore",
      "Kenmore"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MJR",
    "translations": [
      "Miramar Airport",
      "Miramar Airport",
      "Miramar Airport"
    ],
    "city": [
      "Miramar",
      "Miramar",
      "Miramar"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "COC",
    "translations": [
      "Comodoro Pierrestegui Airport",
      "Comodoro Pierrestegui Airport",
      "Comodoro Pierrestegui Airport"
    ],
    "city": [
      "Concordia",
      "Concordia",
      "Concordia"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "GHU",
    "translations": [
      "Gualeguaychu Airport",
      "Gualeguaychu Airport",
      "Gualeguaychu Airport"
    ],
    "city": [
      "Gualeguaychu",
      "Gualeguaychu",
      "Gualeguaychu"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "PRA",
    "translations": [
      "General Urquiza Airport",
      "General Urquiza Airport",
      "General Urquiza Airport"
    ],
    "city": [
      "Parana",
      "Parana",
      "Parana"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "ROS",
    "translations": [
      "Rosario Islas Malvinas International Airport",
      "Rosario Islas Malvinas International Airport",
      "Rosario Islas Malvinas International Airport"
    ],
    "city": [
      "Rosario",
      "Rosario",
      "Rosario"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "SFN",
    "translations": [
      "Sauce Viejo Airport",
      "Sauce Viejo Airport",
      "Sauce Viejo Airport"
    ],
    "city": [
      "Santa Fe",
      "Santa Fe",
      "Santa Fe"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "AEP",
    "translations": [
      "Jorge Newbery Airpark",
      "Jorge Newbery Airpark",
      "Jorge Newbery Airpark"
    ],
    "city": [
      "Buenos Aires",
      "Buenos Aires",
      "Buenos Aires"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "LCM",
    "translations": [
      "La Cumbre Airport",
      "La Cumbre Airport",
      "La Cumbre Airport"
    ],
    "city": [
      "La Cumbre",
      "La Cumbre",
      "La Cumbre"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "COR",
    "translations": [
      "Ingeniero Ambrosio Taravella Airport",
      "Ingeniero Ambrosio Taravella Airport",
      "Ingeniero Ambrosio Taravella Airport"
    ],
    "city": [
      "Cordoba",
      "Cordoba",
      "Cordoba"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "LPG",
    "translations": [
      "La Plata Airport",
      "La Plata Airport",
      "La Plata Airport"
    ],
    "city": [
      "La Plata",
      "La Plata",
      "La Plata"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "EPA",
    "translations": [
      "El Palomar Airport",
      "El Palomar Airport",
      "El Palomar Airport"
    ],
    "city": [
      "El Palomar",
      "El Palomar",
      "El Palomar"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "EZE",
    "translations": [
      "Minister Pistarini International Airport",
      "Minister Pistarini International Airport",
      "Minister Pistarini International Airport"
    ],
    "city": [
      "Buenos Aires (Ezeiza)",
      "Buenos Aires (Ezeiza)",
      "Buenos Aires (Ezeiza)"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "RAF",
    "translations": [
      "Rafaela Airport",
      "Rafaela Airport",
      "Rafaela Airport"
    ],
    "city": [
      "Rafaela",
      "Rafaela",
      "Rafaela"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "NCJ",
    "translations": [
      "Sunchales Aeroclub Airport",
      "Sunchales Aeroclub Airport",
      "Sunchales Aeroclub Airport"
    ],
    "city": [
      "Sunchales",
      "Sunchales",
      "Sunchales"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "HOS",
    "translations": [
      "Chos Malal Airport",
      "Chos Malal Airport",
      "Chos Malal Airport"
    ],
    "city": [
      "Chos Malal",
      "Chos Malal",
      "Chos Malal"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "CVH",
    "translations": [
      "Caviahue Airport",
      "Caviahue Airport",
      "Caviahue Airport"
    ],
    "city": [
      "Lafontaine",
      "Lafontaine",
      "Lafontaine"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "GNR",
    "translations": [
      "Dr. Arturo H. Illia Airport",
      "Dr. Arturo H. Illia Airport",
      "Dr. Arturo H. Illia Airport"
    ],
    "city": [
      "General Roca",
      "General Roca",
      "General Roca"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "RDS",
    "translations": [
      "Rincon De Los Sauces Airport",
      "Rincon De Los Sauces Airport",
      "Rincon De Los Sauces Airport"
    ],
    "city": [
      "Rincon de los Sauces",
      "Rincon de los Sauces",
      "Rincon de los Sauces"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "APZ",
    "translations": [
      "Zapala Airport",
      "Zapala Airport",
      "Zapala Airport"
    ],
    "city": [
      "Zapala",
      "Zapala",
      "Zapala"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "SAM",
    "translations": [
      "Salamo Airport",
      "Salamo Airport",
      "Salamo Airport"
    ],
    "city": [
      "Salamo",
      "Salamo",
      "Salamo"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "MDZ",
    "translations": [
      "El Plumerillo Airport",
      "El Plumerillo Airport",
      "El Plumerillo Airport"
    ],
    "city": [
      "Mendoza",
      "Mendoza",
      "Mendoza"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "LGS",
    "translations": [
      "Comodoro D.R. Salomón Airport",
      "Comodoro D.R. Salomón Airport",
      "Comodoro D.R. Salomón Airport"
    ],
    "city": [
      "Malargue",
      "Malargue",
      "Malargue"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "AFA",
    "translations": [
      "Suboficial Ay Santiago Germano Airport",
      "Suboficial Ay Santiago Germano Airport",
      "Suboficial Ay Santiago Germano Airport"
    ],
    "city": [
      "San Rafael",
      "San Rafael",
      "San Rafael"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "CTC",
    "translations": [
      "Coronel Felipe Varela International Airport",
      "Coronel Felipe Varela International Airport",
      "Coronel Felipe Varela International Airport"
    ],
    "city": [
      "Catamarca",
      "Catamarca",
      "Catamarca"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "SDE",
    "translations": [
      "Vicecomodoro Angel D. La Paz Aragonés Airport",
      "Vicecomodoro Angel D. La Paz Aragonés Airport",
      "Vicecomodoro Angel D. La Paz Aragonés Airport"
    ],
    "city": [
      "Santiago del Estero",
      "Santiago del Estero",
      "Santiago del Estero"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "IRJ",
    "translations": [
      "Capitan V A Almonacid Airport",
      "Capitan V A Almonacid Airport",
      "Capitan V A Almonacid Airport"
    ],
    "city": [
      "La Rioja",
      "La Rioja",
      "La Rioja"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "RHD",
    "translations": [
      "Termas de Río Hondo international Airport",
      "Termas de Río Hondo international Airport",
      "Termas de Río Hondo international Airport"
    ],
    "city": [
      "Termas de Río Hondo",
      "Termas de Río Hondo",
      "Termas de Río Hondo"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "TUC",
    "translations": [
      "Teniente Benjamin Matienzo Airport",
      "Teniente Benjamin Matienzo Airport",
      "Teniente Benjamin Matienzo Airport"
    ],
    "city": [
      "San Miguel de Tucumán",
      "San Miguel de Tucumán",
      "San Miguel de Tucumán"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "UAQ",
    "translations": [
      "Domingo Faustino Sarmiento Airport",
      "Domingo Faustino Sarmiento Airport",
      "Domingo Faustino Sarmiento Airport"
    ],
    "city": [
      "San Juan",
      "San Juan",
      "San Juan"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "CRR",
    "translations": [
      "Ceres Airport",
      "Ceres Airport",
      "Ceres Airport"
    ],
    "city": [
      "Ceres",
      "Ceres",
      "Ceres"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "RCU",
    "translations": [
      "Area De Material Airport",
      "Area De Material Airport",
      "Area De Material Airport"
    ],
    "city": [
      "Rio Cuarto",
      "Rio Cuarto",
      "Rio Cuarto"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "VDR",
    "translations": [
      "Villa Dolores Airport",
      "Villa Dolores Airport",
      "Villa Dolores Airport"
    ],
    "city": [
      "Villa Dolores",
      "Villa Dolores",
      "Villa Dolores"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "VME",
    "translations": [
      "Villa Reynolds Airport",
      "Villa Reynolds Airport",
      "Villa Reynolds Airport"
    ],
    "city": [
      "Villa Mercedes",
      "Villa Mercedes",
      "Villa Mercedes"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "RLO",
    "translations": [
      "Valle Del Conlara International Airport",
      "Valle Del Conlara International Airport",
      "Valle Del Conlara International Airport"
    ],
    "city": [
      "Merlo",
      "Merlo",
      "Merlo"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "LUQ",
    "translations": [
      "Brigadier Mayor D Cesar Raul Ojeda Airport",
      "Brigadier Mayor D Cesar Raul Ojeda Airport",
      "Brigadier Mayor D Cesar Raul Ojeda Airport"
    ],
    "city": [
      "San Luis",
      "San Luis",
      "San Luis"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "CNQ",
    "translations": [
      "Corrientes Airport",
      "Corrientes Airport",
      "Corrientes Airport"
    ],
    "city": [
      "Corrientes",
      "Corrientes",
      "Corrientes"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "RES",
    "translations": [
      "Resistencia International Airport",
      "Resistencia International Airport",
      "Resistencia International Airport"
    ],
    "city": [
      "Resistencia",
      "Resistencia",
      "Resistencia"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "FMA",
    "translations": [
      "Formosa National Airport",
      "Formosa National Airport",
      "Formosa National Airport"
    ],
    "city": [
      "Formosa",
      "Formosa",
      "Formosa"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "IGR",
    "translations": [
      "Cataratas Del Iguazú International Airport",
      "Cataratas Del Iguazú International Airport",
      "Cataratas Del Iguazú International Airport"
    ],
    "city": [
      "Puerto Iguazu",
      "Puerto Iguazu",
      "Puerto Iguazu"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "AOL",
    "translations": [
      "Paso De Los Libres Airport",
      "Paso De Los Libres Airport",
      "Paso De Los Libres Airport"
    ],
    "city": [
      "Paso de los Libres",
      "Paso de los Libres",
      "Paso de los Libres"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "MCS",
    "translations": [
      "Monte Caseros Airport",
      "Monte Caseros Airport",
      "Monte Caseros Airport"
    ],
    "city": [
      "Monte Caseros",
      "Monte Caseros",
      "Monte Caseros"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "PSS",
    "translations": [
      "Libertador Gral D Jose De San Martin Airport",
      "Libertador Gral D Jose De San Martin Airport",
      "Libertador Gral D Jose De San Martin Airport"
    ],
    "city": [
      "Posadas",
      "Posadas",
      "Posadas"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "PRQ",
    "translations": [
      "Termal Airport",
      "Termal Airport",
      "Termal Airport"
    ],
    "city": [
      "Presidencia Roque Sáenz Peña",
      "Presidencia Roque Sáenz Peña",
      "Presidencia Roque Sáenz Peña"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "SLA",
    "translations": [
      "Martin Miguel De Guemes International Airport",
      "Martin Miguel De Guemes International Airport",
      "Martin Miguel De Guemes International Airport"
    ],
    "city": [
      "Salta",
      "Salta",
      "Salta"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "JUJ",
    "translations": [
      "Gobernador Horacio Guzman International Airport",
      "Gobernador Horacio Guzman International Airport",
      "Gobernador Horacio Guzman International Airport"
    ],
    "city": [
      "San Salvador de Jujuy",
      "San Salvador de Jujuy",
      "San Salvador de Jujuy"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "ORA",
    "translations": [
      "Orán Airport",
      "Orán Airport",
      "Orán Airport"
    ],
    "city": [
      "Orán",
      "Orán",
      "Orán"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "TTG",
    "translations": [
      "General Enrique Mosconi Airport",
      "General Enrique Mosconi Airport",
      "General Enrique Mosconi Airport"
    ],
    "city": [
      "Tartagal",
      "Tartagal",
      "Tartagal"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "CLX",
    "translations": [
      "Aeródromo de Clorinda",
      "Aeródromo de Clorinda",
      "Aeródromo de Clorinda"
    ],
    "city": [
      "Clorinda",
      "Clorinda",
      "Clorinda"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "ELO",
    "translations": [
      "El Dorado Airport",
      "El Dorado Airport",
      "El Dorado Airport"
    ],
    "city": [
      "El Dorado",
      "El Dorado",
      "El Dorado"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "OYA",
    "translations": [
      "Goya Airport",
      "Goya Airport",
      "Goya Airport"
    ],
    "city": [
      "Goya",
      "Goya",
      "Goya"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "LLS",
    "translations": [
      "Alferez Armando Rodriguez Airport",
      "Alferez Armando Rodriguez Airport",
      "Alferez Armando Rodriguez Airport"
    ],
    "city": [
      "Las Lomitas",
      "Las Lomitas",
      "Las Lomitas"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "MDX",
    "translations": [
      "Mercedes Airport",
      "Mercedes Airport",
      "Mercedes Airport"
    ],
    "city": [
      "Mercedes",
      "Mercedes",
      "Mercedes"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "RCQ",
    "translations": [
      "Reconquista Airport",
      "Reconquista Airport",
      "Reconquista Airport"
    ],
    "city": [
      "Reconquista",
      "Reconquista",
      "Reconquista"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "UZU",
    "translations": [
      "Curuzu Cuatia Airport",
      "Curuzu Cuatia Airport",
      "Curuzu Cuatia Airport"
    ],
    "city": [
      "Curuzu Cuatia",
      "Curuzu Cuatia",
      "Curuzu Cuatia"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "EHL",
    "translations": [
      "El Bolsón Airfield",
      "El Bolsón Airfield",
      "El Bolsón Airfield"
    ],
    "city": [
      "El Bolsón",
      "El Bolsón",
      "El Bolsón"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "CRD",
    "translations": [
      "General E. Mosconi Airport",
      "General E. Mosconi Airport",
      "General E. Mosconi Airport"
    ],
    "city": [
      "Comodoro Rivadavia",
      "Comodoro Rivadavia",
      "Comodoro Rivadavia"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "EMX",
    "translations": [
      "El Maitén Airport",
      "El Maitén Airport",
      "El Maitén Airport"
    ],
    "city": [
      "El Maitén",
      "El Maitén",
      "El Maitén"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "EQS",
    "translations": [
      "Esquel Brigadier Antonio Parodi International Airport",
      "Esquel Brigadier Antonio Parodi International Airport",
      "Esquel Brigadier Antonio Parodi International Airport"
    ],
    "city": [
      "Esquel",
      "Esquel",
      "Esquel"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "LHS",
    "translations": [
      "Las Heras Airport",
      "Las Heras Airport",
      "Las Heras Airport"
    ],
    "city": [
      "Las Heras",
      "Las Heras",
      "Las Heras"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "IGB",
    "translations": [
      "Ingeniero Jacobacci - Captain H R Bordón Airport",
      "Ingeniero Jacobacci - Captain H R Bordón Airport",
      "Ingeniero Jacobacci - Captain H R Bordón Airport"
    ],
    "city": [
      "Ingeniero Jacobacci",
      "Ingeniero Jacobacci",
      "Ingeniero Jacobacci"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "OLN",
    "translations": [
      "Lago Musters Airport",
      "Lago Musters Airport",
      "Lago Musters Airport"
    ],
    "city": [
      "Sarmiento",
      "Sarmiento",
      "Sarmiento"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "OES",
    "translations": [
      "Antoine de Saint Exupéry Airport",
      "Antoine de Saint Exupéry Airport",
      "Antoine de Saint Exupéry Airport"
    ],
    "city": [
      "San Antonio Oeste",
      "San Antonio Oeste",
      "San Antonio Oeste"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "MQD",
    "translations": [
      "Maquinchao Airport",
      "Maquinchao Airport",
      "Maquinchao Airport"
    ],
    "city": [
      "Maquinchao",
      "Maquinchao",
      "Maquinchao"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "ARR",
    "translations": [
      "D. Casimiro Szlapelis Airport",
      "D. Casimiro Szlapelis Airport",
      "D. Casimiro Szlapelis Airport"
    ],
    "city": [
      "Alto Rio Senguerr",
      "Alto Rio Senguerr",
      "Alto Rio Senguerr"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "SGV",
    "translations": [
      "Sierra Grande Airport",
      "Sierra Grande Airport",
      "Sierra Grande Airport"
    ],
    "city": [
      "Sierra Grande",
      "Sierra Grande",
      "Sierra Grande"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "REL",
    "translations": [
      "Almirante Marco Andres Zar Airport",
      "Almirante Marco Andres Zar Airport",
      "Almirante Marco Andres Zar Airport"
    ],
    "city": [
      "Rawson",
      "Rawson",
      "Rawson"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "VDM",
    "translations": [
      "Gobernador Castello Airport",
      "Gobernador Castello Airport",
      "Gobernador Castello Airport"
    ],
    "city": [
      "Viedma / Carmen de Patagones",
      "Viedma / Carmen de Patagones",
      "Viedma / Carmen de Patagones"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "PMY",
    "translations": [
      "El Tehuelche Airport",
      "El Tehuelche Airport",
      "El Tehuelche Airport"
    ],
    "city": [
      "Puerto Madryn",
      "Puerto Madryn",
      "Puerto Madryn"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "FTE",
    "translations": [
      "El Calafate - Commander Armando Tola International Airport",
      "El Calafate - Commander Armando Tola International Airport",
      "El Calafate - Commander Armando Tola International Airport"
    ],
    "city": [
      "El Calafate",
      "El Calafate",
      "El Calafate"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "PUD",
    "translations": [
      "Puerto Deseado Airport",
      "Puerto Deseado Airport",
      "Puerto Deseado Airport"
    ],
    "city": [
      "Puerto Deseado",
      "Puerto Deseado",
      "Puerto Deseado"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "RGA",
    "translations": [
      "Gobernador Ramón Trejo Noel International Airport",
      "Gobernador Ramón Trejo Noel International Airport",
      "Gobernador Ramón Trejo Noel International Airport"
    ],
    "city": [
      "Rio Grande",
      "Rio Grande",
      "Rio Grande"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "RGL",
    "translations": [
      "Piloto Civil N. Fernández Airport",
      "Piloto Civil N. Fernández Airport",
      "Piloto Civil N. Fernández Airport"
    ],
    "city": [
      "Rio Gallegos",
      "Rio Gallegos",
      "Rio Gallegos"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "USH",
    "translations": [
      "Ushuaia - Malvinas Argentinas International Airport",
      "Ushuaia - Malvinas Argentinas International Airport",
      "Ushuaia - Malvinas Argentinas International Airport"
    ],
    "city": [
      "Ushuaia",
      "Ushuaia",
      "Ushuaia"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "ULA",
    "translations": [
      "Capitan D Daniel Vazquez Airport",
      "Capitan D Daniel Vazquez Airport",
      "Capitan D Daniel Vazquez Airport"
    ],
    "city": [
      "San Julian",
      "San Julian",
      "San Julian"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "ROY",
    "translations": [
      "Rio Mayo Airport",
      "Rio Mayo Airport",
      "Rio Mayo Airport"
    ],
    "city": [
      "Rio Mayo",
      "Rio Mayo",
      "Rio Mayo"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "PMQ",
    "translations": [
      "Perito Moreno Jalil Hamer Airport",
      "Perito Moreno Jalil Hamer Airport",
      "Perito Moreno Jalil Hamer Airport"
    ],
    "city": [
      "Perito Moreno",
      "Perito Moreno",
      "Perito Moreno"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "GGS",
    "translations": [
      "Gobernador Gregores Airport",
      "Gobernador Gregores Airport",
      "Gobernador Gregores Airport"
    ],
    "city": [
      "Gobernador Gregores",
      "Gobernador Gregores",
      "Gobernador Gregores"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "JSM",
    "translations": [
      "Jose De San Martin Airport",
      "Jose De San Martin Airport",
      "Jose De San Martin Airport"
    ],
    "city": [
      "Chubut",
      "Chubut",
      "Chubut"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "RYO",
    "translations": [
      "28 de Noviembre Airport",
      "28 de Noviembre Airport",
      "28 de Noviembre Airport"
    ],
    "city": [
      "Rio Turbio",
      "Rio Turbio",
      "Rio Turbio"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "RZA",
    "translations": [
      "Santa Cruz Airport",
      "Santa Cruz Airport",
      "Santa Cruz Airport"
    ],
    "city": [
      "Puerto Santa Cruz",
      "Puerto Santa Cruz",
      "Puerto Santa Cruz"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "BHI",
    "translations": [
      "Comandante Espora Airport",
      "Comandante Espora Airport",
      "Comandante Espora Airport"
    ],
    "city": [
      "Bahía Blanca",
      "Bahía Blanca",
      "Bahía Blanca"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "CSZ",
    "translations": [
      "Brigadier D.H.E. Ruiz Airport",
      "Brigadier D.H.E. Ruiz Airport",
      "Brigadier D.H.E. Ruiz Airport"
    ],
    "city": [
      "Coronel Suarez",
      "Coronel Suarez",
      "Coronel Suarez"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "OVR",
    "translations": [
      "Olavarria Airport",
      "Olavarria Airport",
      "Olavarria Airport"
    ],
    "city": [
      "Olavarria",
      "Olavarria",
      "Olavarria"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "GPO",
    "translations": [
      "General Pico Airport",
      "General Pico Airport",
      "General Pico Airport"
    ],
    "city": [
      "General Pico",
      "General Pico",
      "General Pico"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "OYO",
    "translations": [
      "Tres Arroyos Airport",
      "Tres Arroyos Airport",
      "Tres Arroyos Airport"
    ],
    "city": [
      "Tres Arroyos",
      "Tres Arroyos",
      "Tres Arroyos"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "SST",
    "translations": [
      "Santa Teresita Airport",
      "Santa Teresita Airport",
      "Santa Teresita Airport"
    ],
    "city": [
      "Santa Teresita",
      "Santa Teresita",
      "Santa Teresita"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "MDQ",
    "translations": [
      "Ástor Piazzola International Airport",
      "Ástor Piazzola International Airport",
      "Ástor Piazzola International Airport"
    ],
    "city": [
      "Mar del Plata",
      "Mar del Plata",
      "Mar del Plata"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "NQN",
    "translations": [
      "Presidente Peron Airport",
      "Presidente Peron Airport",
      "Presidente Peron Airport"
    ],
    "city": [
      "Neuquen",
      "Neuquen",
      "Neuquen"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "NEC",
    "translations": [
      "Necochea Airport",
      "Necochea Airport",
      "Necochea Airport"
    ],
    "city": [
      "Necochea",
      "Necochea",
      "Necochea"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "PEH",
    "translations": [
      "Comodoro Pedro Zanni Airport",
      "Comodoro Pedro Zanni Airport",
      "Comodoro Pedro Zanni Airport"
    ],
    "city": [
      "Pehuajó",
      "Pehuajó",
      "Pehuajó"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "RSA",
    "translations": [
      "Santa Rosa Airport",
      "Santa Rosa Airport",
      "Santa Rosa Airport"
    ],
    "city": [
      "Santa Rosa",
      "Santa Rosa",
      "Santa Rosa"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "BRC",
    "translations": [
      "San Carlos de Bariloche Airport",
      "San Carlos de Bariloche Airport",
      "San Carlos de Bariloche Airport"
    ],
    "city": [
      "San Carlos de Bariloche",
      "San Carlos de Bariloche",
      "San Carlos de Bariloche"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "TDL",
    "translations": [
      "Héroes de Malvinas Airport",
      "Héroes de Malvinas Airport",
      "Héroes de Malvinas Airport"
    ],
    "city": [
      "Tandil",
      "Tandil",
      "Tandil"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "VLG",
    "translations": [
      "Villa Gesell Airport",
      "Villa Gesell Airport",
      "Villa Gesell Airport"
    ],
    "city": [
      "Villa Gesell",
      "Villa Gesell",
      "Villa Gesell"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "CUT",
    "translations": [
      "Cutral-Co Airport",
      "Cutral-Co Airport",
      "Cutral-Co Airport"
    ],
    "city": [
      "Cutral-Co",
      "Cutral-Co",
      "Cutral-Co"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "CPC",
    "translations": [
      "Aviador C. Campos Airport",
      "Aviador C. Campos Airport",
      "Aviador C. Campos Airport"
    ],
    "city": [
      "Chapelco/San Martin de los Andes",
      "Chapelco/San Martin de los Andes",
      "Chapelco/San Martin de los Andes"
    ],
    "country": [
      "AR",
      "AR",
      "AR"
    ]
  },
  {
    "iata": "VIU",
    "translations": [
      "Viru Harbour Airstrip",
      "Viru Harbour Airstrip",
      "Viru Harbour Airstrip"
    ],
    "city": [
      "Viru",
      "Viru",
      "Viru"
    ],
    "country": [
      "SB",
      "SB",
      "SB"
    ]
  },
  {
    "iata": "CDJ",
    "translations": [
      "Conceição do Araguaia Airport",
      "Conceição do Araguaia Airport",
      "Conceição do Araguaia Airport"
    ],
    "city": [
      "Conceição do Araguaia",
      "Conceição do Araguaia",
      "Conceição do Araguaia"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ARX",
    "translations": [
      "Aracati Dragão do Mar Regional Airport",
      "Aracati Dragão do Mar Regional Airport",
      "Aracati Dragão do Mar Regional Airport"
    ],
    "city": [
      "Aracati",
      "Aracati",
      "Aracati"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JTC",
    "translations": [
      "Bauru/Arealva–Moussa Nakhal Tobias State Airport",
      "Bauru/Arealva–Moussa Nakhal Tobias State Airport",
      "Bauru/Arealva–Moussa Nakhal Tobias State Airport"
    ],
    "city": [
      "Bauru",
      "Bauru",
      "Bauru"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "AQA",
    "translations": [
      "Araraquara Airport",
      "Araraquara Airport",
      "Araraquara Airport"
    ],
    "city": [
      "Araraquara",
      "Araraquara",
      "Araraquara"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "AJU",
    "translations": [
      "Aracaju - Santa Maria International Airport",
      "Aracaju - Santa Maria International Airport",
      "Aracaju - Santa Maria International Airport"
    ],
    "city": [
      "Aracaju",
      "Aracaju",
      "Aracaju"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "AFL",
    "translations": [
      "Piloto Osvaldo Marques Dias Airport",
      "Piloto Osvaldo Marques Dias Airport",
      "Piloto Osvaldo Marques Dias Airport"
    ],
    "city": [
      "Alta Floresta",
      "Alta Floresta",
      "Alta Floresta"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ARU",
    "translations": [
      "Araçatuba Airport",
      "Araçatuba Airport",
      "Araçatuba Airport"
    ],
    "city": [
      "Araçatuba",
      "Araçatuba",
      "Araçatuba"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "AAX",
    "translations": [
      "Romeu Zema Airport",
      "Romeu Zema Airport",
      "Romeu Zema Airport"
    ],
    "city": [
      "Araxá",
      "Araxá",
      "Araxá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BEL",
    "translations": [
      "Val de Cans/Júlio Cezar Ribeiro International Airport",
      "Val de Cans/Júlio Cezar Ribeiro International Airport",
      "Val de Cans/Júlio Cezar Ribeiro International Airport"
    ],
    "city": [
      "Belém",
      "Belém",
      "Belém"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BGX",
    "translations": [
      "Comandante Gustavo Kraemer Airport",
      "Comandante Gustavo Kraemer Airport",
      "Comandante Gustavo Kraemer Airport"
    ],
    "city": [
      "Bagé",
      "Bagé",
      "Bagé"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PLU",
    "translations": [
      "Pampulha - Carlos Drummond de Andrade Airport",
      "Pampulha - Carlos Drummond de Andrade Airport",
      "Pampulha - Carlos Drummond de Andrade Airport"
    ],
    "city": [
      "Belo Horizonte",
      "Belo Horizonte",
      "Belo Horizonte"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BFH",
    "translations": [
      "Bacacheri Airport",
      "Bacacheri Airport",
      "Bacacheri Airport"
    ],
    "city": [
      "Curitiba",
      "Curitiba",
      "Curitiba"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BJP",
    "translations": [
      "Estadual Arthur Siqueira Airport",
      "Estadual Arthur Siqueira Airport",
      "Estadual Arthur Siqueira Airport"
    ],
    "city": [
      "Bragança Paulista",
      "Bragança Paulista",
      "Bragança Paulista"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BSB",
    "translations": [
      "Presidente Juscelino Kubitschek International Airport",
      "Presidente Juscelino Kubitschek International Airport",
      "Presidente Juscelino Kubitschek International Airport"
    ],
    "city": [
      "Brasília",
      "Brasília",
      "Brasília"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BAT",
    "translations": [
      "Chafei Amsei Airport",
      "Chafei Amsei Airport",
      "Chafei Amsei Airport"
    ],
    "city": [
      "Barretos",
      "Barretos",
      "Barretos"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BVB",
    "translations": [
      "Atlas Brasil Cantanhede Airport",
      "Atlas Brasil Cantanhede Airport",
      "Atlas Brasil Cantanhede Airport"
    ],
    "city": [
      "Boa Vista",
      "Boa Vista",
      "Boa Vista"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BPG",
    "translations": [
      "Barra do Garças Airport",
      "Barra do Garças Airport",
      "Barra do Garças Airport"
    ],
    "city": [
      "Barra do Garças",
      "Barra do Garças",
      "Barra do Garças"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BZC",
    "translations": [
      "Umberto Modiano Airport",
      "Umberto Modiano Airport",
      "Umberto Modiano Airport"
    ],
    "city": [
      "Cabo Frio",
      "Cabo Frio",
      "Cabo Frio"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CAC",
    "translations": [
      "Coronel Adalberto Mendes da Silva Airport",
      "Coronel Adalberto Mendes da Silva Airport",
      "Coronel Adalberto Mendes da Silva Airport"
    ],
    "city": [
      "Cascavel",
      "Cascavel",
      "Cascavel"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CFB",
    "translations": [
      "Cabo Frio Airport",
      "Cabo Frio Airport",
      "Cabo Frio Airport"
    ],
    "city": [
      "Cabo Frio",
      "Cabo Frio",
      "Cabo Frio"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CFC",
    "translations": [
      "Doctor Carlos Alberto da Costa Neves Airport",
      "Doctor Carlos Alberto da Costa Neves Airport",
      "Doctor Carlos Alberto da Costa Neves Airport"
    ],
    "city": [
      "Caçador",
      "Caçador",
      "Caçador"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CNF",
    "translations": [
      "Tancredo Neves International Airport",
      "Tancredo Neves International Airport",
      "Tancredo Neves International Airport"
    ],
    "city": [
      "Belo Horizonte",
      "Belo Horizonte",
      "Belo Horizonte"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CGR",
    "translations": [
      "Campo Grande Airport",
      "Campo Grande Airport",
      "Campo Grande Airport"
    ],
    "city": [
      "Campo Grande",
      "Campo Grande",
      "Campo Grande"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "XAP",
    "translations": [
      "Serafin Enoss Bertaso Airport",
      "Serafin Enoss Bertaso Airport",
      "Serafin Enoss Bertaso Airport"
    ],
    "city": [
      "Chapecó",
      "Chapecó",
      "Chapecó"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CLN",
    "translations": [
      "Brig. Lysias Augusto Rodrigues Airport",
      "Brig. Lysias Augusto Rodrigues Airport",
      "Brig. Lysias Augusto Rodrigues Airport"
    ],
    "city": [
      "Carolina",
      "Carolina",
      "Carolina"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CKS",
    "translations": [
      "Carajás Airport",
      "Carajás Airport",
      "Carajás Airport"
    ],
    "city": [
      "Parauapebas",
      "Parauapebas",
      "Parauapebas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CCM",
    "translations": [
      "Forquilhinha - Criciúma  Airport",
      "Forquilhinha - Criciúma  Airport",
      "Forquilhinha - Criciúma  Airport"
    ],
    "city": [
      "Criciúma",
      "Criciúma",
      "Criciúma"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CLV",
    "translations": [
      "Nelson Ribeiro Guimarães Airport",
      "Nelson Ribeiro Guimarães Airport",
      "Nelson Ribeiro Guimarães Airport"
    ],
    "city": [
      "Caldas Novas",
      "Caldas Novas",
      "Caldas Novas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "QNS",
    "translations": [
      "Canoas Air Force Base",
      "Canoas Air Force Base",
      "Canoas Air Force Base"
    ],
    "city": [
      "Porto Alegre",
      "Porto Alegre",
      "Porto Alegre"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CAW",
    "translations": [
      "Bartolomeu Lisandro Airport",
      "Bartolomeu Lisandro Airport",
      "Bartolomeu Lisandro Airport"
    ],
    "city": [
      "Campos dos Goytacazes",
      "Campos dos Goytacazes",
      "Campos dos Goytacazes"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CMG",
    "translations": [
      "Corumbá International Airport",
      "Corumbá International Airport",
      "Corumbá International Airport"
    ],
    "city": [
      "Corumbá",
      "Corumbá",
      "Corumbá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CWB",
    "translations": [
      "Afonso Pena Airport",
      "Afonso Pena Airport",
      "Afonso Pena Airport"
    ],
    "city": [
      "Curitiba",
      "Curitiba",
      "Curitiba"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CRQ",
    "translations": [
      "Caravelas Airport",
      "Caravelas Airport",
      "Caravelas Airport"
    ],
    "city": [
      "Caravelas",
      "Caravelas",
      "Caravelas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CXJ",
    "translations": [
      "Hugo Cantergiani Regional Airport",
      "Hugo Cantergiani Regional Airport",
      "Hugo Cantergiani Regional Airport"
    ],
    "city": [
      "Caxias Do Sul",
      "Caxias Do Sul",
      "Caxias Do Sul"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CGB",
    "translations": [
      "Marechal Rondon Airport",
      "Marechal Rondon Airport",
      "Marechal Rondon Airport"
    ],
    "city": [
      "Cuiabá",
      "Cuiabá",
      "Cuiabá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CZS",
    "translations": [
      "Cruzeiro do Sul Airport",
      "Cruzeiro do Sul Airport",
      "Cruzeiro do Sul Airport"
    ],
    "city": [
      "Cruzeiro Do Sul",
      "Cruzeiro Do Sul",
      "Cruzeiro Do Sul"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BYO",
    "translations": [
      "Bonito Airport",
      "Bonito Airport",
      "Bonito Airport"
    ],
    "city": [
      "Bonito",
      "Bonito",
      "Bonito"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PPB",
    "translations": [
      "Presidente Prudente Airport",
      "Presidente Prudente Airport",
      "Presidente Prudente Airport"
    ],
    "city": [
      "Presidente Prudente",
      "Presidente Prudente",
      "Presidente Prudente"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "DOU",
    "translations": [
      "Dourados Airport",
      "Dourados Airport",
      "Dourados Airport"
    ],
    "city": [
      "Dourados",
      "Dourados",
      "Dourados"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MAO",
    "translations": [
      "Eduardo Gomes International Airport",
      "Eduardo Gomes International Airport",
      "Eduardo Gomes International Airport"
    ],
    "city": [
      "Manaus",
      "Manaus",
      "Manaus"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JCR",
    "translations": [
      "Jacareacanga Airport",
      "Jacareacanga Airport",
      "Jacareacanga Airport"
    ],
    "city": [
      "Jacareacanga",
      "Jacareacanga",
      "Jacareacanga"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "IGU",
    "translations": [
      "Cataratas International Airport",
      "Cataratas International Airport",
      "Cataratas International Airport"
    ],
    "city": [
      "Foz do Iguaçu",
      "Foz do Iguaçu",
      "Foz do Iguaçu"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "FLN",
    "translations": [
      "Hercílio Luz International Airport",
      "Hercílio Luz International Airport",
      "Hercílio Luz International Airport"
    ],
    "city": [
      "Florianópolis",
      "Florianópolis",
      "Florianópolis"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "FEN",
    "translations": [
      "Fernando de Noronha Airport",
      "Fernando de Noronha Airport",
      "Fernando de Noronha Airport"
    ],
    "city": [
      "Fernando de Noronha",
      "Fernando de Noronha",
      "Fernando de Noronha"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "FOR",
    "translations": [
      "Pinto Martins International Airport",
      "Pinto Martins International Airport",
      "Pinto Martins International Airport"
    ],
    "city": [
      "Fortaleza",
      "Fortaleza",
      "Fortaleza"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GIG",
    "translations": [
      "Rio Galeão – Tom Jobim International Airport",
      "Rio Galeão – Tom Jobim International Airport",
      "Rio Galeão – Tom Jobim International Airport"
    ],
    "city": [
      "Rio De Janeiro",
      "Rio De Janeiro",
      "Rio De Janeiro"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GJM",
    "translations": [
      "Guajará-Mirim Airport",
      "Guajará-Mirim Airport",
      "Guajará-Mirim Airport"
    ],
    "city": [
      "Guajará-Mirim",
      "Guajará-Mirim",
      "Guajará-Mirim"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GYN",
    "translations": [
      "Santa Genoveva Airport",
      "Santa Genoveva Airport",
      "Santa Genoveva Airport"
    ],
    "city": [
      "Goiânia",
      "Goiânia",
      "Goiânia"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GRU",
    "translations": [
      "Guarulhos - Governador André Franco Montoro International Airport",
      "Guarulhos - Governador André Franco Montoro International Airport",
      "Guarulhos - Governador André Franco Montoro International Airport"
    ],
    "city": [
      "São Paulo",
      "São Paulo",
      "São Paulo"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GPB",
    "translations": [
      "Tancredo Thomas de Faria Airport",
      "Tancredo Thomas de Faria Airport",
      "Tancredo Thomas de Faria Airport"
    ],
    "city": [
      "Guarapuava",
      "Guarapuava",
      "Guarapuava"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GVR",
    "translations": [
      "Coronel Altino Machado Airport",
      "Coronel Altino Machado Airport",
      "Coronel Altino Machado Airport"
    ],
    "city": [
      "Governador Valadares",
      "Governador Valadares",
      "Governador Valadares"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GUJ",
    "translations": [
      "Edu Chaves Field",
      "Edu Chaves Field",
      "Edu Chaves Field"
    ],
    "city": [
      "Guaratinguetá",
      "Guaratinguetá",
      "Guaratinguetá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ATM",
    "translations": [
      "Altamira Interstate Airport",
      "Altamira Interstate Airport",
      "Altamira Interstate Airport"
    ],
    "city": [
      "Altamira",
      "Altamira",
      "Altamira"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ITA",
    "translations": [
      "Itacoatiara Airport",
      "Itacoatiara Airport",
      "Itacoatiara Airport"
    ],
    "city": [
      "Itacoatiara",
      "Itacoatiara",
      "Itacoatiara"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ITB",
    "translations": [
      "Itaituba Airport",
      "Itaituba Airport",
      "Itaituba Airport"
    ],
    "city": [
      "Itaituba",
      "Itaituba",
      "Itaituba"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "IOS",
    "translations": [
      "Bahia - Jorge Amado Airport",
      "Bahia - Jorge Amado Airport",
      "Bahia - Jorge Amado Airport"
    ],
    "city": [
      "Ilhéus",
      "Ilhéus",
      "Ilhéus"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "IPN",
    "translations": [
      "Usiminas Airport",
      "Usiminas Airport",
      "Usiminas Airport"
    ],
    "city": [
      "Ipatinga",
      "Ipatinga",
      "Ipatinga"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ITR",
    "translations": [
      "Francisco Vilela do Amaral Airport",
      "Francisco Vilela do Amaral Airport",
      "Francisco Vilela do Amaral Airport"
    ],
    "city": [
      "Itumbiara",
      "Itumbiara",
      "Itumbiara"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "IMP",
    "translations": [
      "Prefeito Renato Moreira Airport",
      "Prefeito Renato Moreira Airport",
      "Prefeito Renato Moreira Airport"
    ],
    "city": [
      "Imperatriz",
      "Imperatriz",
      "Imperatriz"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JJG",
    "translations": [
      "Humberto Ghizzo Bortoluzzi Regional Airport",
      "Humberto Ghizzo Bortoluzzi Regional Airport",
      "Humberto Ghizzo Bortoluzzi Regional Airport"
    ],
    "city": [
      "Jaguaruna",
      "Jaguaruna",
      "Jaguaruna"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "QDV",
    "translations": [
      "Comte. Rolim Adolfo Amaro–Jundiaí State Airport",
      "Comte. Rolim Adolfo Amaro–Jundiaí State Airport",
      "Comte. Rolim Adolfo Amaro–Jundiaí State Airport"
    ],
    "city": [
      "Jundiaí",
      "Jundiaí",
      "Jundiaí"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JJD",
    "translations": [
      "Comandante Ariston Pessoa Airport",
      "Comandante Ariston Pessoa Airport",
      "Comandante Ariston Pessoa Airport"
    ],
    "city": [
      "Cruz",
      "Cruz",
      "Cruz"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JDF",
    "translations": [
      "Francisco de Assis Airport",
      "Francisco de Assis Airport",
      "Francisco de Assis Airport"
    ],
    "city": [
      "Juiz de Fora",
      "Juiz de Fora",
      "Juiz de Fora"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JHF",
    "translations": [
      "São Paulo Catarina Executive Airport",
      "São Paulo Catarina Executive Airport",
      "São Paulo Catarina Executive Airport"
    ],
    "city": [
      "São Roque",
      "São Roque",
      "São Roque"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JPR",
    "translations": [
      "Ji-Paraná Airport",
      "Ji-Paraná Airport",
      "Ji-Paraná Airport"
    ],
    "city": [
      "Ji-Paraná",
      "Ji-Paraná",
      "Ji-Paraná"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JPA",
    "translations": [
      "Presidente Castro Pinto International Airport",
      "Presidente Castro Pinto International Airport",
      "Presidente Castro Pinto International Airport"
    ],
    "city": [
      "João Pessoa",
      "João Pessoa",
      "João Pessoa"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "RRJ",
    "translations": [
      "Jacarepaguá - Roberto Marinho Airport",
      "Jacarepaguá - Roberto Marinho Airport",
      "Jacarepaguá - Roberto Marinho Airport"
    ],
    "city": [
      "Rio De Janeiro",
      "Rio De Janeiro",
      "Rio De Janeiro"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JDO",
    "translations": [
      "Orlando Bezerra de Menezes Airport",
      "Orlando Bezerra de Menezes Airport",
      "Orlando Bezerra de Menezes Airport"
    ],
    "city": [
      "Juazeiro do Norte",
      "Juazeiro do Norte",
      "Juazeiro do Norte"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JOI",
    "translations": [
      "Lauro Carneiro de Loyola Airport",
      "Lauro Carneiro de Loyola Airport",
      "Lauro Carneiro de Loyola Airport"
    ],
    "city": [
      "Joinville",
      "Joinville",
      "Joinville"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CPV",
    "translations": [
      "Presidente João Suassuna Airport",
      "Presidente João Suassuna Airport",
      "Presidente João Suassuna Airport"
    ],
    "city": [
      "Campina Grande",
      "Campina Grande",
      "Campina Grande"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "VCP",
    "translations": [
      "Viracopos International Airport",
      "Viracopos International Airport",
      "Viracopos International Airport"
    ],
    "city": [
      "Campinas",
      "Campinas",
      "Campinas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "LEC",
    "translations": [
      "Coronel Horácio de Mattos Airport",
      "Coronel Horácio de Mattos Airport",
      "Coronel Horácio de Mattos Airport"
    ],
    "city": [
      "Lençóis",
      "Lençóis",
      "Lençóis"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "LAJ",
    "translations": [
      "Lages Airport",
      "Lages Airport",
      "Lages Airport"
    ],
    "city": [
      "Lages",
      "Lages",
      "Lages"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "LIP",
    "translations": [
      "Lins Airport",
      "Lins Airport",
      "Lins Airport"
    ],
    "city": [
      "Lins",
      "Lins",
      "Lins"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "LDB",
    "translations": [
      "Governor José Richa Airport",
      "Governor José Richa Airport",
      "Governor José Richa Airport"
    ],
    "city": [
      "Londrina",
      "Londrina",
      "Londrina"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "LAZ",
    "translations": [
      "Bom Jesus da Lapa Airport",
      "Bom Jesus da Lapa Airport",
      "Bom Jesus da Lapa Airport"
    ],
    "city": [
      "Bom Jesus da Lapa",
      "Bom Jesus da Lapa",
      "Bom Jesus da Lapa"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MAB",
    "translations": [
      "João Correa da Rocha Airport",
      "João Correa da Rocha Airport",
      "João Correa da Rocha Airport"
    ],
    "city": [
      "Marabá",
      "Marabá",
      "Marabá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MQH",
    "translations": [
      "Minaçu Airport",
      "Minaçu Airport",
      "Minaçu Airport"
    ],
    "city": [
      "Minaçu",
      "Minaçu",
      "Minaçu"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MEU",
    "translations": [
      "Monte Dourado - Serra do Areão Airport",
      "Monte Dourado - Serra do Areão Airport",
      "Monte Dourado - Serra do Areão Airport"
    ],
    "city": [
      "Almeirim",
      "Almeirim",
      "Almeirim"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MEA",
    "translations": [
      "Macaé Benedito Lacerda Airport",
      "Macaé Benedito Lacerda Airport",
      "Macaé Benedito Lacerda Airport"
    ],
    "city": [
      "Macaé",
      "Macaé",
      "Macaé"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MGF",
    "translations": [
      "Regional de Maringá - Sílvio Name Júnior Airport",
      "Regional de Maringá - Sílvio Name Júnior Airport",
      "Regional de Maringá - Sílvio Name Júnior Airport"
    ],
    "city": [
      "Maringá",
      "Maringá",
      "Maringá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MOC",
    "translations": [
      "Mário Ribeiro Airport",
      "Mário Ribeiro Airport",
      "Mário Ribeiro Airport"
    ],
    "city": [
      "Montes Claros",
      "Montes Claros",
      "Montes Claros"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MII",
    "translations": [
      "Frank Miloye Milenkowichi–Marília State Airport",
      "Frank Miloye Milenkowichi–Marília State Airport",
      "Frank Miloye Milenkowichi–Marília State Airport"
    ],
    "city": [
      "Marília",
      "Marília",
      "Marília"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PLL",
    "translations": [
      "Ponta Pelada Airport / Manaus Air Base",
      "Ponta Pelada Airport / Manaus Air Base",
      "Ponta Pelada Airport / Manaus Air Base"
    ],
    "city": [
      "Manaus",
      "Manaus",
      "Manaus"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MCZ",
    "translations": [
      "Zumbi dos Palmares Airport",
      "Zumbi dos Palmares Airport",
      "Zumbi dos Palmares Airport"
    ],
    "city": [
      "Maceió",
      "Maceió",
      "Maceió"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MCP",
    "translations": [
      "Macapá - Alberto Alcolumbre International Airport",
      "Macapá - Alberto Alcolumbre International Airport",
      "Macapá - Alberto Alcolumbre International Airport"
    ],
    "city": [
      "Macapá",
      "Macapá",
      "Macapá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MVF",
    "translations": [
      "Dix-Sept Rosado Airport",
      "Dix-Sept Rosado Airport",
      "Dix-Sept Rosado Airport"
    ],
    "city": [
      "Mossoró",
      "Mossoró",
      "Mossoró"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "RTE",
    "translations": [
      "Campo de Marte Airport",
      "Campo de Marte Airport",
      "Campo de Marte Airport"
    ],
    "city": [
      "São Paulo",
      "São Paulo",
      "São Paulo"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MNX",
    "translations": [
      "Manicoré Airport",
      "Manicoré Airport",
      "Manicoré Airport"
    ],
    "city": [
      "Manicoré",
      "Manicoré",
      "Manicoré"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "NVT",
    "translations": [
      "Ministro Victor Konder International Airport",
      "Ministro Victor Konder International Airport",
      "Ministro Victor Konder International Airport"
    ],
    "city": [
      "Navegantes",
      "Navegantes",
      "Navegantes"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GEL",
    "translations": [
      "Santo Ângelo Airport",
      "Santo Ângelo Airport",
      "Santo Ângelo Airport"
    ],
    "city": [
      "Santo Ângelo",
      "Santo Ângelo",
      "Santo Ângelo"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "OYK",
    "translations": [
      "Oiapoque Airport",
      "Oiapoque Airport",
      "Oiapoque Airport"
    ],
    "city": [
      "Oiapoque",
      "Oiapoque",
      "Oiapoque"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "POA",
    "translations": [
      "Salgado Filho International Airport",
      "Salgado Filho International Airport",
      "Salgado Filho International Airport"
    ],
    "city": [
      "Porto Alegre",
      "Porto Alegre",
      "Porto Alegre"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PHB",
    "translations": [
      "Parnaíba - Prefeito Doutor João Silva Filho International Airport",
      "Parnaíba - Prefeito Doutor João Silva Filho International Airport",
      "Parnaíba - Prefeito Doutor João Silva Filho International Airport"
    ],
    "city": [
      "Parnaíba",
      "Parnaíba",
      "Parnaíba"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "POO",
    "translations": [
      "Poços de Caldas - Embaixador Walther Moreira Salles Airport",
      "Poços de Caldas - Embaixador Walther Moreira Salles Airport",
      "Poços de Caldas - Embaixador Walther Moreira Salles Airport"
    ],
    "city": [
      "Poços De Caldas",
      "Poços De Caldas",
      "Poços De Caldas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PFB",
    "translations": [
      "Lauro Kurtz Airport",
      "Lauro Kurtz Airport",
      "Lauro Kurtz Airport"
    ],
    "city": [
      "Passo Fundo",
      "Passo Fundo",
      "Passo Fundo"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PGZ",
    "translations": [
      "Ponta Grossa Airport - Comandante Antonio Amilton Beraldo",
      "Ponta Grossa Airport - Comandante Antonio Amilton Beraldo",
      "Ponta Grossa Airport - Comandante Antonio Amilton Beraldo"
    ],
    "city": [
      "Ponta Grossa",
      "Ponta Grossa",
      "Ponta Grossa"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PMW",
    "translations": [
      "Brigadeiro Lysias Rodrigues Airport",
      "Brigadeiro Lysias Rodrigues Airport",
      "Brigadeiro Lysias Rodrigues Airport"
    ],
    "city": [
      "Palmas",
      "Palmas",
      "Palmas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PET",
    "translations": [
      "João Simões Lopes Neto International Airport",
      "João Simões Lopes Neto International Airport",
      "João Simões Lopes Neto International Airport"
    ],
    "city": [
      "Pelotas",
      "Pelotas",
      "Pelotas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PNZ",
    "translations": [
      "Senador Nilo Coelho Airport",
      "Senador Nilo Coelho Airport",
      "Senador Nilo Coelho Airport"
    ],
    "city": [
      "Petrolina",
      "Petrolina",
      "Petrolina"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PNB",
    "translations": [
      "Porto Nacional Airport",
      "Porto Nacional Airport",
      "Porto Nacional Airport"
    ],
    "city": [
      "Porto Nacional",
      "Porto Nacional",
      "Porto Nacional"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PTO",
    "translations": [
      "Juvenal Loureiro Cardoso Airport",
      "Juvenal Loureiro Cardoso Airport",
      "Juvenal Loureiro Cardoso Airport"
    ],
    "city": [
      "Pato Branco",
      "Pato Branco",
      "Pato Branco"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PMG",
    "translations": [
      "Ponta Porã Airport",
      "Ponta Porã Airport",
      "Ponta Porã Airport"
    ],
    "city": [
      "Ponta Porã",
      "Ponta Porã",
      "Ponta Porã"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BPS",
    "translations": [
      "Porto Seguro Airport",
      "Porto Seguro Airport",
      "Porto Seguro Airport"
    ],
    "city": [
      "Porto Seguro",
      "Porto Seguro",
      "Porto Seguro"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PVH",
    "translations": [
      "Governador Jorge Teixeira de Oliveira Airport",
      "Governador Jorge Teixeira de Oliveira Airport",
      "Governador Jorge Teixeira de Oliveira Airport"
    ],
    "city": [
      "Porto Velho",
      "Porto Velho",
      "Porto Velho"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "RBR",
    "translations": [
      "Rio Branco-Plácido de Castro International Airport",
      "Rio Branco-Plácido de Castro International Airport",
      "Rio Branco-Plácido de Castro International Airport"
    ],
    "city": [
      "Rio Branco",
      "Rio Branco",
      "Rio Branco"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ROO",
    "translations": [
      "Maestro Marinho Franco Airport",
      "Maestro Marinho Franco Airport",
      "Maestro Marinho Franco Airport"
    ],
    "city": [
      "Rondonópolis",
      "Rondonópolis",
      "Rondonópolis"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "REC",
    "translations": [
      "Recife/Guararapes - Gilberto Freyre International Airport",
      "Recife/Guararapes - Gilberto Freyre International Airport",
      "Recife/Guararapes - Gilberto Freyre International Airport"
    ],
    "city": [
      "Recife",
      "Recife",
      "Recife"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SDU",
    "translations": [
      "Santos Dumont Airport",
      "Santos Dumont Airport",
      "Santos Dumont Airport"
    ],
    "city": [
      "Rio de Janeiro",
      "Rio de Janeiro",
      "Rio de Janeiro"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "RAO",
    "translations": [
      "Leite Lopes Airport",
      "Leite Lopes Airport",
      "Leite Lopes Airport"
    ],
    "city": [
      "Ribeirão Preto",
      "Ribeirão Preto",
      "Ribeirão Preto"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BRB",
    "translations": [
      "Barreirinhas National Airport",
      "Barreirinhas National Airport",
      "Barreirinhas National Airport"
    ],
    "city": [
      "Barreirinhas",
      "Barreirinhas",
      "Barreirinhas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SNZ",
    "translations": [
      "Santa Cruz Air Force Base",
      "Santa Cruz Air Force Base",
      "Santa Cruz Air Force Base"
    ],
    "city": [
      "Rio de Janeiro",
      "Rio de Janeiro",
      "Rio de Janeiro"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "NAT",
    "translations": [
      "São Gonçalo do Amarante - Governador Aluízio Alves International Airport",
      "São Gonçalo do Amarante - Governador Aluízio Alves International Airport",
      "São Gonçalo do Amarante - Governador Aluízio Alves International Airport"
    ],
    "city": [
      "Natal",
      "Natal",
      "Natal"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "OPS",
    "translations": [
      "Presidente João Batista Figueiredo Airport",
      "Presidente João Batista Figueiredo Airport",
      "Presidente João Batista Figueiredo Airport"
    ],
    "city": [
      "Sinop",
      "Sinop",
      "Sinop"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SJK",
    "translations": [
      "Professor Urbano Ernesto Stumpf Airport",
      "Professor Urbano Ernesto Stumpf Airport",
      "Professor Urbano Ernesto Stumpf Airport"
    ],
    "city": [
      "São José Dos Campos",
      "São José Dos Campos",
      "São José Dos Campos"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SLZ",
    "translations": [
      "Marechal Cunha Machado International Airport",
      "Marechal Cunha Machado International Airport",
      "Marechal Cunha Machado International Airport"
    ],
    "city": [
      "São Luís",
      "São Luís",
      "São Luís"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "RIA",
    "translations": [
      "Santa Maria Airport",
      "Santa Maria Airport",
      "Santa Maria Airport"
    ],
    "city": [
      "Santa Maria",
      "Santa Maria",
      "Santa Maria"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "STM",
    "translations": [
      "Santarém - Maestro Wilson Fonseca International Airport",
      "Santarém - Maestro Wilson Fonseca International Airport",
      "Santarém - Maestro Wilson Fonseca International Airport"
    ],
    "city": [
      "Santarém",
      "Santarém",
      "Santarém"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SMT",
    "translations": [
      "Adolino Bedin Regional Airport",
      "Adolino Bedin Regional Airport",
      "Adolino Bedin Regional Airport"
    ],
    "city": [
      "Sorriso",
      "Sorriso",
      "Sorriso"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CGH",
    "translations": [
      "Congonhas Airport",
      "Congonhas Airport",
      "Congonhas Airport"
    ],
    "city": [
      "São Paulo",
      "São Paulo",
      "São Paulo"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SJP",
    "translations": [
      "Prof. Eribelto Manoel Reino State Airport",
      "Prof. Eribelto Manoel Reino State Airport",
      "Prof. Eribelto Manoel Reino State Airport"
    ],
    "city": [
      "São José do Rio Preto",
      "São José do Rio Preto",
      "São José do Rio Preto"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SSZ",
    "translations": [
      "Santos Nero Moura Air Base / Guarujá Airport",
      "Santos Nero Moura Air Base / Guarujá Airport",
      "Santos Nero Moura Air Base / Guarujá Airport"
    ],
    "city": [
      "Guarujá",
      "Guarujá",
      "Guarujá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SSA",
    "translations": [
      "Deputado Luiz Eduardo Magalhães International Airport",
      "Deputado Luiz Eduardo Magalhães International Airport",
      "Deputado Luiz Eduardo Magalhães International Airport"
    ],
    "city": [
      "Salvador",
      "Salvador",
      "Salvador"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TMT",
    "translations": [
      "Trombetas Airport",
      "Trombetas Airport",
      "Trombetas Airport"
    ],
    "city": [
      "Oriximiná",
      "Oriximiná",
      "Oriximiná"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "UNA",
    "translations": [
      "Una-Comandatuba Airport",
      "Una-Comandatuba Airport",
      "Una-Comandatuba Airport"
    ],
    "city": [
      "Una",
      "Una",
      "Una"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TOW",
    "translations": [
      "Toledo - Luiz Dalcanale Filho Municipal Airport",
      "Toledo - Luiz Dalcanale Filho Municipal Airport",
      "Toledo - Luiz Dalcanale Filho Municipal Airport"
    ],
    "city": [
      "Toledo",
      "Toledo",
      "Toledo"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "THE",
    "translations": [
      "Senador Petrônio Portela Airport",
      "Senador Petrônio Portela Airport",
      "Senador Petrônio Portela Airport"
    ],
    "city": [
      "Teresina",
      "Teresina",
      "Teresina"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TFF",
    "translations": [
      "Tefé Airport",
      "Tefé Airport",
      "Tefé Airport"
    ],
    "city": [
      "Tefé",
      "Tefé",
      "Tefé"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TJL",
    "translations": [
      "Plínio Alarcom Airport",
      "Plínio Alarcom Airport",
      "Plínio Alarcom Airport"
    ],
    "city": [
      "Três Lagoas",
      "Três Lagoas",
      "Três Lagoas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TRQ",
    "translations": [
      "Tarauacá Airport",
      "Tarauacá Airport",
      "Tarauacá Airport"
    ],
    "city": [
      "Tarauacá",
      "Tarauacá",
      "Tarauacá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TEC",
    "translations": [
      "Telêmaco Borba Airport",
      "Telêmaco Borba Airport",
      "Telêmaco Borba Airport"
    ],
    "city": [
      "Telêmaco Borba",
      "Telêmaco Borba",
      "Telêmaco Borba"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TSQ",
    "translations": [
      "Torres Airport",
      "Torres Airport",
      "Torres Airport"
    ],
    "city": [
      "Torres",
      "Torres",
      "Torres"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TBT",
    "translations": [
      "Tabatinga Airport",
      "Tabatinga Airport",
      "Tabatinga Airport"
    ],
    "city": [
      "Tabatinga",
      "Tabatinga",
      "Tabatinga"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TUR",
    "translations": [
      "Tucuruí Airport",
      "Tucuruí Airport",
      "Tucuruí Airport"
    ],
    "city": [
      "Tucuruí",
      "Tucuruí",
      "Tucuruí"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SJL",
    "translations": [
      "São Gabriel da Cachoeira Airport",
      "São Gabriel da Cachoeira Airport",
      "São Gabriel da Cachoeira Airport"
    ],
    "city": [
      "São Gabriel da Cachoeira",
      "São Gabriel da Cachoeira",
      "São Gabriel da Cachoeira"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PAV",
    "translations": [
      "Paulo Afonso Airport",
      "Paulo Afonso Airport",
      "Paulo Afonso Airport"
    ],
    "city": [
      "Paulo Afonso",
      "Paulo Afonso",
      "Paulo Afonso"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "URG",
    "translations": [
      "Rubem Berta Airport",
      "Rubem Berta Airport",
      "Rubem Berta Airport"
    ],
    "city": [
      "Uruguaiana",
      "Uruguaiana",
      "Uruguaiana"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "UDI",
    "translations": [
      "Ten. Cel. Aviador César Bombonato Airport",
      "Ten. Cel. Aviador César Bombonato Airport",
      "Ten. Cel. Aviador César Bombonato Airport"
    ],
    "city": [
      "Uberlândia",
      "Uberlândia",
      "Uberlândia"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "UBA",
    "translations": [
      "Mário de Almeida Franco Airport",
      "Mário de Almeida Franco Airport",
      "Mário de Almeida Franco Airport"
    ],
    "city": [
      "Uberaba",
      "Uberaba",
      "Uberaba"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "RPU",
    "translations": [
      "Urucu Airport",
      "Urucu Airport",
      "Urucu Airport"
    ],
    "city": [
      "Urucu",
      "Urucu",
      "Urucu"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "VAG",
    "translations": [
      "Major Brigadeiro Trompowsky Airport",
      "Major Brigadeiro Trompowsky Airport",
      "Major Brigadeiro Trompowsky Airport"
    ],
    "city": [
      "Varginha",
      "Varginha",
      "Varginha"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BVH",
    "translations": [
      "Brigadeiro Camarão Airport",
      "Brigadeiro Camarão Airport",
      "Brigadeiro Camarão Airport"
    ],
    "city": [
      "Vilhena",
      "Vilhena",
      "Vilhena"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "VIX",
    "translations": [
      "Eurico de Aguiar Salles Airport",
      "Eurico de Aguiar Salles Airport",
      "Eurico de Aguiar Salles Airport"
    ],
    "city": [
      "Vitória",
      "Vitória",
      "Vitória"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "QPS",
    "translations": [
      "Campo Fontenelle",
      "Campo Fontenelle",
      "Campo Fontenelle"
    ],
    "city": [
      "Pirassununga",
      "Pirassununga",
      "Pirassununga"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "IZA",
    "translations": [
      "Presidente Itamar Franco Airport",
      "Presidente Itamar Franco Airport",
      "Presidente Itamar Franco Airport"
    ],
    "city": [
      "Juiz de Fora",
      "Juiz de Fora",
      "Juiz de Fora"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ZUD",
    "translations": [
      "Pupelde Airport",
      "Pupelde Airport",
      "Pupelde Airport"
    ],
    "city": [
      "Ancud",
      "Ancud",
      "Ancud"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "LOB",
    "translations": [
      "San Rafael Airport",
      "San Rafael Airport",
      "San Rafael Airport"
    ],
    "city": [
      "Los Andes",
      "Los Andes",
      "Los Andes"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "WAP",
    "translations": [
      "Alto Palena Airport",
      "Alto Palena Airport",
      "Alto Palena Airport"
    ],
    "city": [
      "Palena",
      "Palena",
      "Palena"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "ARI",
    "translations": [
      "Chacalluta Airport",
      "Chacalluta Airport",
      "Chacalluta Airport"
    ],
    "city": [
      "Arica",
      "Arica",
      "Arica"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "WPA",
    "translations": [
      "Cabo Juan Román Airfield",
      "Cabo Juan Román Airfield",
      "Cabo Juan Román Airfield"
    ],
    "city": [
      "Puerto Aysén",
      "Puerto Aysén",
      "Puerto Aysén"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "CPO",
    "translations": [
      "Desierto de Atacama Airport",
      "Desierto de Atacama Airport",
      "Desierto de Atacama Airport"
    ],
    "city": [
      "Copiapo",
      "Copiapo",
      "Copiapo"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "BBA",
    "translations": [
      "Balmaceda Airport",
      "Balmaceda Airport",
      "Balmaceda Airport"
    ],
    "city": [
      "Balmaceda",
      "Balmaceda",
      "Balmaceda"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "TOQ",
    "translations": [
      "Barriles Airport",
      "Barriles Airport",
      "Barriles Airport"
    ],
    "city": [
      "Tocopilla",
      "Tocopilla",
      "Tocopilla"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "DPB",
    "translations": [
      "Pampa Guanaco Airport",
      "Pampa Guanaco Airport",
      "Pampa Guanaco Airport"
    ],
    "city": [
      "Bahia Inutil",
      "Bahia Inutil",
      "Bahia Inutil"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "CCH",
    "translations": [
      "Chile Chico Airport",
      "Chile Chico Airport",
      "Chile Chico Airport"
    ],
    "city": [
      "Chile Chico",
      "Chile Chico",
      "Chile Chico"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "CJC",
    "translations": [
      "El Loa Airport",
      "El Loa Airport",
      "El Loa Airport"
    ],
    "city": [
      "Calama",
      "Calama",
      "Calama"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "YAI",
    "translations": [
      "Gral. Bernardo O´Higgins Airport",
      "Gral. Bernardo O´Higgins Airport",
      "Gral. Bernardo O´Higgins Airport"
    ],
    "city": [
      "Chillan",
      "Chillan",
      "Chillan"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "PUQ",
    "translations": [
      "President Carlos Ibañez del Campo International Airport",
      "President Carlos Ibañez del Campo International Airport",
      "President Carlos Ibañez del Campo International Airport"
    ],
    "city": [
      "Punta Arenas",
      "Punta Arenas",
      "Punta Arenas"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "COW",
    "translations": [
      "Tambillos Airport",
      "Tambillos Airport",
      "Tambillos Airport"
    ],
    "city": [
      "Coquimbo",
      "Coquimbo",
      "Coquimbo"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "GXQ",
    "translations": [
      "Teniente Vidal Airport",
      "Teniente Vidal Airport",
      "Teniente Vidal Airport"
    ],
    "city": [
      "Coyhaique",
      "Coyhaique",
      "Coyhaique"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "IQQ",
    "translations": [
      "Diego Aracena Airport",
      "Diego Aracena Airport",
      "Diego Aracena Airport"
    ],
    "city": [
      "Iquique",
      "Iquique",
      "Iquique"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "SCL",
    "translations": [
      "Comodoro Arturo Merino Benítez International Airport",
      "Comodoro Arturo Merino Benítez International Airport",
      "Comodoro Arturo Merino Benítez International Airport"
    ],
    "city": [
      "Santiago",
      "Santiago",
      "Santiago"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "ESR",
    "translations": [
      "Ricardo García Posada Airport",
      "Ricardo García Posada Airport",
      "Ricardo García Posada Airport"
    ],
    "city": [
      "El Salvador",
      "El Salvador",
      "El Salvador"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "FRT",
    "translations": [
      "El Avellano Airport",
      "El Avellano Airport",
      "El Avellano Airport"
    ],
    "city": [
      "Frutillar",
      "Frutillar",
      "Frutillar"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "ANF",
    "translations": [
      "Andrés Sabella Gálvez International Airport",
      "Andrés Sabella Gálvez International Airport",
      "Andrés Sabella Gálvez International Airport"
    ],
    "city": [
      "Antofagasta",
      "Antofagasta",
      "Antofagasta"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "WPR",
    "translations": [
      "Captain Fuentes Martinez Airport",
      "Captain Fuentes Martinez Airport",
      "Captain Fuentes Martinez Airport"
    ],
    "city": [
      "Porvenir",
      "Porvenir",
      "Porvenir"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "FFU",
    "translations": [
      "Futaleufú Airport",
      "Futaleufú Airport",
      "Futaleufú Airport"
    ],
    "city": [
      "Futaleufu",
      "Futaleufu",
      "Futaleufu"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "UGL",
    "translations": [
      "Union Glacier Blue-Ice Runway",
      "Union Glacier Blue-Ice Runway",
      "Union Glacier Blue-Ice Runway"
    ],
    "city": [
      "Union Glacier",
      "Union Glacier",
      "Union Glacier"
    ],
    "country": [
      "AQ",
      "AQ",
      "AQ"
    ]
  },
  {
    "iata": "LSQ",
    "translations": [
      "María Dolores Airport",
      "María Dolores Airport",
      "María Dolores Airport"
    ],
    "city": [
      "Los Angeles",
      "Los Angeles",
      "Los Angeles"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "WPU",
    "translations": [
      "Guardia Marina Zañartu Airport",
      "Guardia Marina Zañartu Airport",
      "Guardia Marina Zañartu Airport"
    ],
    "city": [
      "Puerto Williams",
      "Puerto Williams",
      "Puerto Williams"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "LGR",
    "translations": [
      "Cochrane Airport",
      "Cochrane Airport",
      "Cochrane Airport"
    ],
    "city": [
      "Cochrane",
      "Cochrane",
      "Cochrane"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "CCP",
    "translations": [
      "Carriel Sur Airport",
      "Carriel Sur Airport",
      "Carriel Sur Airport"
    ],
    "city": [
      "Concepcion",
      "Concepcion",
      "Concepcion"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "IPC",
    "translations": [
      "Mataveri Airport",
      "Mataveri Airport",
      "Mataveri Airport"
    ],
    "city": [
      "Isla De Pascua",
      "Isla De Pascua",
      "Isla De Pascua"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "ZOS",
    "translations": [
      "Cañal Bajo Carlos Hott Siebert Airport",
      "Cañal Bajo Carlos Hott Siebert Airport",
      "Cañal Bajo Carlos Hott Siebert Airport"
    ],
    "city": [
      "Osorno",
      "Osorno",
      "Osorno"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "CPP",
    "translations": [
      "Coposa Airport",
      "Coposa Airport",
      "Coposa Airport"
    ],
    "city": [
      "Pica",
      "Pica",
      "Pica"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "VLR",
    "translations": [
      "Vallenar Airport",
      "Vallenar Airport",
      "Vallenar Airport"
    ],
    "city": [
      "Vallenar",
      "Vallenar",
      "Vallenar"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "ZLR",
    "translations": [
      "Municipal de Linares Airport",
      "Municipal de Linares Airport",
      "Municipal de Linares Airport"
    ],
    "city": [
      "Linares",
      "Linares",
      "Linares"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "PNT",
    "translations": [
      "Lieutenant Julio Gallardo Airport",
      "Lieutenant Julio Gallardo Airport",
      "Lieutenant Julio Gallardo Airport"
    ],
    "city": [
      "Puerto Natales",
      "Puerto Natales",
      "Puerto Natales"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "OVL",
    "translations": [
      "El Tuqui Airport",
      "El Tuqui Airport",
      "El Tuqui Airport"
    ],
    "city": [
      "Ovalle",
      "Ovalle",
      "Ovalle"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "ZPC",
    "translations": [
      "Pucón Airport",
      "Pucón Airport",
      "Pucón Airport"
    ],
    "city": [
      "Pucon",
      "Pucon",
      "Pucon"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "MHC",
    "translations": [
      "Mocopulli Airport",
      "Mocopulli Airport",
      "Mocopulli Airport"
    ],
    "city": [
      "Dalcahue",
      "Dalcahue",
      "Dalcahue"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "PUX",
    "translations": [
      "El Mirador Airport",
      "El Mirador Airport",
      "El Mirador Airport"
    ],
    "city": [
      "Puerto Varas",
      "Puerto Varas",
      "Puerto Varas"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "ZCO",
    "translations": [
      "La Araucanía Airport",
      "La Araucanía Airport",
      "La Araucanía Airport"
    ],
    "city": [
      "Temuco",
      "Temuco",
      "Temuco"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "CNR",
    "translations": [
      "Chañaral Airport",
      "Chañaral Airport",
      "Chañaral Airport"
    ],
    "city": [
      "Chañaral",
      "Chañaral",
      "Chañaral"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "VAP",
    "translations": [
      "Rodelillo Airport",
      "Rodelillo Airport",
      "Rodelillo Airport"
    ],
    "city": [
      "Viña Del Mar",
      "Viña Del Mar",
      "Viña Del Mar"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "TNM",
    "translations": [
      "Teniente Rodolfo Marsh Martin Airport",
      "Teniente Rodolfo Marsh Martin Airport",
      "Teniente Rodolfo Marsh Martin Airport"
    ],
    "city": [
      "Villa Las Estrellas",
      "Villa Las Estrellas",
      "Villa Las Estrellas"
    ],
    "country": [
      "AQ",
      "AQ",
      "AQ"
    ]
  },
  {
    "iata": "SMB",
    "translations": [
      "Franco Bianco Airport",
      "Franco Bianco Airport",
      "Franco Bianco Airport"
    ],
    "city": [
      "Cerro Sombrero",
      "Cerro Sombrero",
      "Cerro Sombrero"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "LSC",
    "translations": [
      "La Florida Airport",
      "La Florida Airport",
      "La Florida Airport"
    ],
    "city": [
      "La Serena-Coquimbo",
      "La Serena-Coquimbo",
      "La Serena-Coquimbo"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "SSD",
    "translations": [
      "Víctor Lafón Airport",
      "Víctor Lafón Airport",
      "Víctor Lafón Airport"
    ],
    "city": [
      "San Felipe",
      "San Felipe",
      "San Felipe"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "WCA",
    "translations": [
      "Gamboa Airport",
      "Gamboa Airport",
      "Gamboa Airport"
    ],
    "city": [
      "Castro",
      "Castro",
      "Castro"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "PZS",
    "translations": [
      "Maquehue Airport",
      "Maquehue Airport",
      "Maquehue Airport"
    ],
    "city": [
      "Temuco",
      "Temuco",
      "Temuco"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "PMC",
    "translations": [
      "El Tepual Airport",
      "El Tepual Airport",
      "El Tepual Airport"
    ],
    "city": [
      "Puerto Montt",
      "Puerto Montt",
      "Puerto Montt"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "TLX",
    "translations": [
      "Panguilemo Airport",
      "Panguilemo Airport",
      "Panguilemo Airport"
    ],
    "city": [
      "Talca",
      "Talca",
      "Talca"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "WCH",
    "translations": [
      "Nuevo Chaitén Airport",
      "Nuevo Chaitén Airport",
      "Nuevo Chaitén Airport"
    ],
    "city": [
      "Chaitén",
      "Chaitén",
      "Chaitén"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "ZIC",
    "translations": [
      "Victoria Airport",
      "Victoria Airport",
      "Victoria Airport"
    ],
    "city": [
      "Victoria",
      "Victoria",
      "Victoria"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "TTC",
    "translations": [
      "Las Breas Airport",
      "Las Breas Airport",
      "Las Breas Airport"
    ],
    "city": [
      "Taltal",
      "Taltal",
      "Taltal"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "ZAL",
    "translations": [
      "Pichoy Airport",
      "Pichoy Airport",
      "Pichoy Airport"
    ],
    "city": [
      "Valdivia",
      "Valdivia",
      "Valdivia"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "KNA",
    "translations": [
      "Viña del Mar Airport",
      "Viña del Mar Airport",
      "Viña del Mar Airport"
    ],
    "city": [
      "Viña del Mar",
      "Viña del Mar",
      "Viña del Mar"
    ],
    "country": [
      "CL",
      "CL",
      "CL"
    ]
  },
  {
    "iata": "BVM",
    "translations": [
      "Belmonte Airport",
      "Belmonte Airport",
      "Belmonte Airport"
    ],
    "city": [
      "Belmonte",
      "Belmonte",
      "Belmonte"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GDR",
    "translations": [
      "Angra dos Reis Airport",
      "Angra dos Reis Airport",
      "Angra dos Reis Airport"
    ],
    "city": [
      "Angra dos Reis",
      "Angra dos Reis",
      "Angra dos Reis"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "OLC",
    "translations": [
      "Senadora Eunice Micheles Airport",
      "Senadora Eunice Micheles Airport",
      "Senadora Eunice Micheles Airport"
    ],
    "city": [
      "São Paulo De Olivença",
      "São Paulo De Olivença",
      "São Paulo De Olivença"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SOD",
    "translations": [
      "Sorocaba Airport",
      "Sorocaba Airport",
      "Sorocaba Airport"
    ],
    "city": [
      "Sorocaba",
      "Sorocaba",
      "Sorocaba"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JTN",
    "translations": [
      "Itanhaém Airport",
      "Itanhaém Airport",
      "Itanhaém Airport"
    ],
    "city": [
      "Itanhaém",
      "Itanhaém",
      "Itanhaém"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "FEC",
    "translations": [
      "João Durval Carneiro Airport",
      "João Durval Carneiro Airport",
      "João Durval Carneiro Airport"
    ],
    "city": [
      "Feira de Santana",
      "Feira de Santana",
      "Feira de Santana"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JLS",
    "translations": [
      "Jales Airport",
      "Jales Airport",
      "Jales Airport"
    ],
    "city": [
      "Jales",
      "Jales",
      "Jales"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PBA",
    "translations": [
      "Fábio Perini Airport",
      "Fábio Perini Airport",
      "Fábio Perini Airport"
    ],
    "city": [
      "Cairu",
      "Cairu",
      "Cairu"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JMR",
    "translations": [
      "Maricá Airport",
      "Maricá Airport",
      "Maricá Airport"
    ],
    "city": [
      "Maricá",
      "Maricá",
      "Maricá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "NVM",
    "translations": [
      "Brigadeiro Eduardo Gomes Airport",
      "Brigadeiro Eduardo Gomes Airport",
      "Brigadeiro Eduardo Gomes Airport"
    ],
    "city": [
      "Nova Mutum",
      "Nova Mutum",
      "Nova Mutum"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "OUS",
    "translations": [
      "Jornalista Benedito Pimentel Airport",
      "Jornalista Benedito Pimentel Airport",
      "Jornalista Benedito Pimentel Airport"
    ],
    "city": [
      "Ourinhos",
      "Ourinhos",
      "Ourinhos"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "OIA",
    "translations": [
      "Ourilândia do Norte Airport",
      "Ourilândia do Norte Airport",
      "Ourilândia do Norte Airport"
    ],
    "city": [
      "Ourilândia do Norte",
      "Ourilândia do Norte",
      "Ourilândia do Norte"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "REZ",
    "translations": [
      "Resende Airport",
      "Resende Airport",
      "Resende Airport"
    ],
    "city": [
      "Resende",
      "Resende",
      "Resende"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "QSC",
    "translations": [
      "Mário Pereira Lopes–São Carlos Airport",
      "Mário Pereira Lopes–São Carlos Airport",
      "Mário Pereira Lopes–São Carlos Airport"
    ],
    "city": [
      "São Carlos",
      "São Carlos",
      "São Carlos"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JPY",
    "translations": [
      "Paraty Airport",
      "Paraty Airport",
      "Paraty Airport"
    ],
    "city": [
      "Paraty",
      "Paraty",
      "Paraty"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "UBT",
    "translations": [
      "Ubatuba Gastão Madeira State Airport",
      "Ubatuba Gastão Madeira State Airport",
      "Ubatuba Gastão Madeira State Airport"
    ],
    "city": [
      "Ubatuba",
      "Ubatuba",
      "Ubatuba"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ITP",
    "translations": [
      "Itaperuna Airport",
      "Itaperuna Airport",
      "Itaperuna Airport"
    ],
    "city": [
      "Itaperuna",
      "Itaperuna",
      "Itaperuna"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "VOT",
    "translations": [
      "Domingos Pignatari Airport",
      "Domingos Pignatari Airport",
      "Domingos Pignatari Airport"
    ],
    "city": [
      "Votuporanga",
      "Votuporanga",
      "Votuporanga"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JTA",
    "translations": [
      "Pedro Teixeira Castelo Airport",
      "Pedro Teixeira Castelo Airport",
      "Pedro Teixeira Castelo Airport"
    ],
    "city": [
      "Tauá",
      "Tauá",
      "Tauá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ATF",
    "translations": [
      "Chachoán Regional Airport",
      "Chachoán Regional Airport",
      "Chachoán Regional Airport"
    ],
    "city": [
      "Ambato",
      "Ambato",
      "Ambato"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "OCC",
    "translations": [
      "Francisco De Orellana Airport",
      "Francisco De Orellana Airport",
      "Francisco De Orellana Airport"
    ],
    "city": [
      "Coca",
      "Coca",
      "Coca"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "CUE",
    "translations": [
      "Mariscal Lamar Airport",
      "Mariscal Lamar Airport",
      "Mariscal Lamar Airport"
    ],
    "city": [
      "Cuenca",
      "Cuenca",
      "Cuenca"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "GPS",
    "translations": [
      "Seymour Galapagos Ecological Airport",
      "Seymour Galapagos Ecological Airport",
      "Seymour Galapagos Ecological Airport"
    ],
    "city": [
      "Isla Baltra",
      "Isla Baltra",
      "Isla Baltra"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "GYE",
    "translations": [
      "José Joaquín de Olmedo International Airport",
      "José Joaquín de Olmedo International Airport",
      "José Joaquín de Olmedo International Airport"
    ],
    "city": [
      "Guayaquil",
      "Guayaquil",
      "Guayaquil"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "IBB",
    "translations": [
      "General Villamil Airport",
      "General Villamil Airport",
      "General Villamil Airport"
    ],
    "city": [
      "Puerto Villamil",
      "Puerto Villamil",
      "Puerto Villamil"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "TNW",
    "translations": [
      "Jumandy Airport",
      "Jumandy Airport",
      "Jumandy Airport"
    ],
    "city": [
      "Ahuano",
      "Ahuano",
      "Ahuano"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "JIP",
    "translations": [
      "Jipijapa Airport",
      "Jipijapa Airport",
      "Jipijapa Airport"
    ],
    "city": [
      "Jipijapa",
      "Jipijapa",
      "Jipijapa"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "LTX",
    "translations": [
      "Cotopaxi International Airport",
      "Cotopaxi International Airport",
      "Cotopaxi International Airport"
    ],
    "city": [
      "Latacunga",
      "Latacunga",
      "Latacunga"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "MRR",
    "translations": [
      "Jose Maria Velasco Ibarra Airport",
      "Jose Maria Velasco Ibarra Airport",
      "Jose Maria Velasco Ibarra Airport"
    ],
    "city": [
      "Macará",
      "Macará",
      "Macará"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "XMS",
    "translations": [
      "Coronel E Carvajal Airport",
      "Coronel E Carvajal Airport",
      "Coronel E Carvajal Airport"
    ],
    "city": [
      "Macas",
      "Macas",
      "Macas"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "MEC",
    "translations": [
      "Eloy Alfaro International Airport",
      "Eloy Alfaro International Airport",
      "Eloy Alfaro International Airport"
    ],
    "city": [
      "Manta",
      "Manta",
      "Manta"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "LGQ",
    "translations": [
      "Nueva Loja Airport",
      "Nueva Loja Airport",
      "Nueva Loja Airport"
    ],
    "city": [
      "Lago Agrio",
      "Lago Agrio",
      "Lago Agrio"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "PYO",
    "translations": [
      "Putumayo Airport",
      "Putumayo Airport",
      "Putumayo Airport"
    ],
    "city": [
      "Puerto Putumayo",
      "Puerto Putumayo",
      "Puerto Putumayo"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "PVO",
    "translations": [
      "Reales Tamarindos Airport",
      "Reales Tamarindos Airport",
      "Reales Tamarindos Airport"
    ],
    "city": [
      "Portoviejo",
      "Portoviejo",
      "Portoviejo"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "UIO",
    "translations": [
      "Mariscal Sucre International Airport",
      "Mariscal Sucre International Airport",
      "Mariscal Sucre International Airport"
    ],
    "city": [
      "Quito",
      "Quito",
      "Quito"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "ETR",
    "translations": [
      "Santa Rosa - Artillery Colonel Victor Larrea International Airport",
      "Santa Rosa - Artillery Colonel Victor Larrea International Airport",
      "Santa Rosa - Artillery Colonel Victor Larrea International Airport"
    ],
    "city": [
      "Santa Rosa",
      "Santa Rosa",
      "Santa Rosa"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "SNC",
    "translations": [
      "General Ulpiano Paez Airport",
      "General Ulpiano Paez Airport",
      "General Ulpiano Paez Airport"
    ],
    "city": [
      "Salinas",
      "Salinas",
      "Salinas"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "SUQ",
    "translations": [
      "Sucúa Airport",
      "Sucúa Airport",
      "Sucúa Airport"
    ],
    "city": [
      "Sucúa",
      "Sucúa",
      "Sucúa"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "PTZ",
    "translations": [
      "Rio Amazonas Airport",
      "Rio Amazonas Airport",
      "Rio Amazonas Airport"
    ],
    "city": [
      "Shell Mera",
      "Shell Mera",
      "Shell Mera"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "SCY",
    "translations": [
      "San Cristóbal Airport",
      "San Cristóbal Airport",
      "San Cristóbal Airport"
    ],
    "city": [
      "Puerto Baquerizo Moreno",
      "Puerto Baquerizo Moreno",
      "Puerto Baquerizo Moreno"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "BHA",
    "translations": [
      "Los Perales Airport",
      "Los Perales Airport",
      "Los Perales Airport"
    ],
    "city": [
      "Bahía de Caraquez",
      "Bahía de Caraquez",
      "Bahía de Caraquez"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "TSC",
    "translations": [
      "Taisha Airport",
      "Taisha Airport",
      "Taisha Airport"
    ],
    "city": [
      "Taisha",
      "Taisha",
      "Taisha"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "TPN",
    "translations": [
      "Tiputini Airport",
      "Tiputini Airport",
      "Tiputini Airport"
    ],
    "city": [
      "Tiputini",
      "Tiputini",
      "Tiputini"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "LOH",
    "translations": [
      "Ciudad de Catamayo Airport",
      "Ciudad de Catamayo Airport",
      "Ciudad de Catamayo Airport"
    ],
    "city": [
      "La Toma (Catamayo)",
      "La Toma (Catamayo)",
      "La Toma (Catamayo)"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "ESM",
    "translations": [
      "Carlos Concha Torres International Airport",
      "Carlos Concha Torres International Airport",
      "Carlos Concha Torres International Airport"
    ],
    "city": [
      "Tachina",
      "Tachina",
      "Tachina"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "TPC",
    "translations": [
      "Tarapoa Airport",
      "Tarapoa Airport",
      "Tarapoa Airport"
    ],
    "city": [
      "Tarapoa",
      "Tarapoa",
      "Tarapoa"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "TUA",
    "translations": [
      "Lieutenant Colonel Luis A. Mantilla International Airport",
      "Lieutenant Colonel Luis A. Mantilla International Airport",
      "Lieutenant Colonel Luis A. Mantilla International Airport"
    ],
    "city": [
      "Tulcán",
      "Tulcán",
      "Tulcán"
    ],
    "country": [
      "EC",
      "EC",
      "EC"
    ]
  },
  {
    "iata": "PSY",
    "translations": [
      "Port Stanley Airport",
      "Port Stanley Airport",
      "Port Stanley Airport"
    ],
    "city": [
      "Stanley",
      "Stanley",
      "Stanley"
    ],
    "country": [
      "FK",
      "FK",
      "FK"
    ]
  },
  {
    "iata": "ASU",
    "translations": [
      "Aeropuerto Internacional Silvio Pettirossi",
      "Aeropuerto Internacional Silvio Pettirossi",
      "Aeropuerto Internacional Silvio Pettirossi"
    ],
    "city": [
      "Asunción",
      "Asunción",
      "Asunción"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "AYO",
    "translations": [
      "Aeropuerto Nacional Juan de Ayolas",
      "Aeropuerto Nacional Juan de Ayolas",
      "Aeropuerto Nacional Juan de Ayolas"
    ],
    "city": [
      "Ayolas",
      "Ayolas",
      "Ayolas"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "BFA",
    "translations": [
      "Bahía Negra Airport",
      "Bahía Negra Airport",
      "Bahía Negra Airport"
    ],
    "city": [
      "Bahía Negra",
      "Bahía Negra",
      "Bahía Negra"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "CIO",
    "translations": [
      "Aeropuerto Nacional Tte. Cnel. Carmelo Peralta",
      "Aeropuerto Nacional Tte. Cnel. Carmelo Peralta",
      "Aeropuerto Nacional Tte. Cnel. Carmelo Peralta"
    ],
    "city": [
      "Concepción",
      "Concepción",
      "Concepción"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "ENO",
    "translations": [
      "Aeropuerto Internacional Tte. Amín Ayub González",
      "Aeropuerto Internacional Tte. Amín Ayub González",
      "Aeropuerto Internacional Tte. Amín Ayub González"
    ],
    "city": [
      "Encarnación",
      "Encarnación",
      "Encarnación"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "AGT",
    "translations": [
      "Aeropuerto Internacional Guaraní",
      "Aeropuerto Internacional Guaraní",
      "Aeropuerto Internacional Guaraní"
    ],
    "city": [
      "Ciudad del Este",
      "Ciudad del Este",
      "Ciudad del Este"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "FLM",
    "translations": [
      "Aeródromo de Filadelfia",
      "Aeródromo de Filadelfia",
      "Aeródromo de Filadelfia"
    ],
    "city": [
      "Filadelfia",
      "Filadelfia",
      "Filadelfia"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "ESG",
    "translations": [
      "Aeropuerto Internacional Dr. Luis Maria Argaña",
      "Aeropuerto Internacional Dr. Luis Maria Argaña",
      "Aeropuerto Internacional Dr. Luis Maria Argaña"
    ],
    "city": [
      "Mariscal Estigarribia",
      "Mariscal Estigarribia",
      "Mariscal Estigarribia"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "OLK",
    "translations": [
      "Aeródromo de Fuerte",
      "Aeródromo de Fuerte",
      "Aeródromo de Fuerte"
    ],
    "city": [
      "Fuerte Olimpo",
      "Fuerte Olimpo",
      "Fuerte Olimpo"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "PIL",
    "translations": [
      "Aeródromo Don Carlos Miguel Gimenez",
      "Aeródromo Don Carlos Miguel Gimenez",
      "Aeródromo Don Carlos Miguel Gimenez"
    ],
    "city": [
      "Pilar",
      "Pilar",
      "Pilar"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "PJC",
    "translations": [
      "Aeropuerto Nacional Dr. Augusto Roberto Fuster",
      "Aeropuerto Nacional Dr. Augusto Roberto Fuster",
      "Aeropuerto Nacional Dr. Augusto Roberto Fuster"
    ],
    "city": [
      "Pedro Juan Caballero",
      "Pedro Juan Caballero",
      "Pedro Juan Caballero"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "SIC",
    "translations": [
      "San José Island Airport",
      "San José Island Airport",
      "San José Island Airport"
    ],
    "city": [
      "Las Perlas",
      "Las Perlas",
      "Las Perlas"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "ITJ",
    "translations": [
      "Campo Comandantes Airport",
      "Campo Comandantes Airport",
      "Campo Comandantes Airport"
    ],
    "city": [
      "Itajaí",
      "Itajaí",
      "Itajaí"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "LVR",
    "translations": [
      "Municipal Bom Futuro Airport",
      "Municipal Bom Futuro Airport",
      "Municipal Bom Futuro Airport"
    ],
    "city": [
      "Lucas do Rio Verde",
      "Lucas do Rio Verde",
      "Lucas do Rio Verde"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SFV",
    "translations": [
      "Fazenda Trêz Irmãos Airport",
      "Fazenda Trêz Irmãos Airport",
      "Fazenda Trêz Irmãos Airport"
    ],
    "city": [
      "Santa Fé Do Sul",
      "Santa Fé Do Sul",
      "Santa Fé Do Sul"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "FRC",
    "translations": [
      "Tenente Lund Pressoto Airport",
      "Tenente Lund Pressoto Airport",
      "Tenente Lund Pressoto Airport"
    ],
    "city": [
      "Franca",
      "Franca",
      "Franca"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MUU",
    "translations": [
      "Barra Grande Airport",
      "Barra Grande Airport",
      "Barra Grande Airport"
    ],
    "city": [
      "Maraú",
      "Maraú",
      "Maraú"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JUA",
    "translations": [
      "Inácio Luís do Nascimento Airport",
      "Inácio Luís do Nascimento Airport",
      "Inácio Luís do Nascimento Airport"
    ],
    "city": [
      "Juara",
      "Juara",
      "Juara"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SJF",
    "translations": [
      "Cruz Bay Seaplane Base",
      "Cruz Bay Seaplane Base",
      "Cruz Bay Seaplane Base"
    ],
    "city": [
      "Cruz Bay",
      "Cruz Bay",
      "Cruz Bay"
    ],
    "country": [
      "VI",
      "VI",
      "VI"
    ]
  },
  {
    "iata": "CFO",
    "translations": [
      "Confresa Airport",
      "Confresa Airport",
      "Confresa Airport"
    ],
    "city": [
      "Confresa",
      "Confresa",
      "Confresa"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "NPR",
    "translations": [
      "Novo Progresso Airport",
      "Novo Progresso Airport",
      "Novo Progresso Airport"
    ],
    "city": [
      "Novo Progresso",
      "Novo Progresso",
      "Novo Progresso"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "AQM",
    "translations": [
      "Ariquemes Airport",
      "Ariquemes Airport",
      "Ariquemes Airport"
    ],
    "city": [
      "Ariquemes",
      "Ariquemes",
      "Ariquemes"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JRT",
    "translations": [
      "Juruti Airport",
      "Juruti Airport",
      "Juruti Airport"
    ],
    "city": [
      "Juruti",
      "Juruti",
      "Juruti"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "RIG",
    "translations": [
      "Rio Grande Regional Airport",
      "Rio Grande Regional Airport",
      "Rio Grande Regional Airport"
    ],
    "city": [
      "Rio Grande",
      "Rio Grande",
      "Rio Grande"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ARS",
    "translations": [
      "Aragarças Airport",
      "Aragarças Airport",
      "Aragarças Airport"
    ],
    "city": [
      "Aragarças",
      "Aragarças",
      "Aragarças"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ECO",
    "translations": [
      "El Encanto Airport",
      "El Encanto Airport",
      "El Encanto Airport"
    ],
    "city": [
      "El Encanto",
      "El Encanto",
      "El Encanto"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MIX",
    "translations": [
      "Miriti Parana Airport",
      "Miriti Parana Airport",
      "Miriti Parana Airport"
    ],
    "city": [
      "Mirití-Paraná",
      "Mirití-Paraná",
      "Mirití-Paraná"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ARO",
    "translations": [
      "Arboletes Airport",
      "Arboletes Airport",
      "Arboletes Airport"
    ],
    "city": [
      "Arboletes",
      "Arboletes",
      "Arboletes"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ULS",
    "translations": [
      "Mulatos Airport",
      "Mulatos Airport",
      "Mulatos Airport"
    ],
    "city": [
      "Mulatos",
      "Mulatos",
      "Mulatos"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SJR",
    "translations": [
      "San Juan De Uraba Airport",
      "San Juan De Uraba Airport",
      "San Juan De Uraba Airport"
    ],
    "city": [
      "San Juan De Uraba",
      "San Juan De Uraba",
      "San Juan De Uraba"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "NPU",
    "translations": [
      "San Pedro Airport",
      "San Pedro Airport",
      "San Pedro Airport"
    ],
    "city": [
      "San Pedro de Urabá",
      "San Pedro de Urabá",
      "San Pedro de Urabá"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PCC",
    "translations": [
      "Puerto Rico Airport",
      "Puerto Rico Airport",
      "Puerto Rico Airport"
    ],
    "city": [
      "Puerto Rico",
      "Puerto Rico",
      "Puerto Rico"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SQF",
    "translations": [
      "Solano Airport",
      "Solano Airport",
      "Solano Airport"
    ],
    "city": [
      "Solano",
      "Solano",
      "Solano"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "AYI",
    "translations": [
      "Yari Airport",
      "Yari Airport",
      "Yari Airport"
    ],
    "city": [
      "Yari",
      "Yari",
      "Yari"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CUI",
    "translations": [
      "Currillo Airport",
      "Currillo Airport",
      "Currillo Airport"
    ],
    "city": [
      "Currillo",
      "Currillo",
      "Currillo"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MOY",
    "translations": [
      "Monterrey Airport",
      "Monterrey Airport",
      "Monterrey Airport"
    ],
    "city": [
      "Monterrey",
      "Monterrey",
      "Monterrey"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "NUH",
    "translations": [
      "Nunchia Airport",
      "Nunchia Airport",
      "Nunchia Airport"
    ],
    "city": [
      "Nunchia",
      "Nunchia",
      "Nunchia"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "EUO",
    "translations": [
      "Paratebueno Airport",
      "Paratebueno Airport",
      "Paratebueno Airport"
    ],
    "city": [
      "Paratebueno",
      "Paratebueno",
      "Paratebueno"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PRE",
    "translations": [
      "Pore Airport",
      "Pore Airport",
      "Pore Airport"
    ],
    "city": [
      "Pore",
      "Pore",
      "Pore"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SQE",
    "translations": [
      "San Luis De Palenque Airport",
      "San Luis De Palenque Airport",
      "San Luis De Palenque Airport"
    ],
    "city": [
      "San Luis De Palenque",
      "San Luis De Palenque",
      "San Luis De Palenque"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "TTM",
    "translations": [
      "Tablón De Tamara Airport",
      "Tablón De Tamara Airport",
      "Tablón De Tamara Airport"
    ],
    "city": [
      "Tablón De Tamara",
      "Tablón De Tamara",
      "Tablón De Tamara"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "LMX",
    "translations": [
      "Lopez de Micay Airport",
      "Lopez de Micay Airport",
      "Lopez de Micay Airport"
    ],
    "city": [
      "Micay",
      "Micay",
      "Micay"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "AYC",
    "translations": [
      "Ayacucho Airport",
      "Ayacucho Airport",
      "Ayacucho Airport"
    ],
    "city": [
      "Ayacucho",
      "Ayacucho",
      "Ayacucho"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "GRA",
    "translations": [
      "Gamarra Airport",
      "Gamarra Airport",
      "Gamarra Airport"
    ],
    "city": [
      "Puerto Mosquito",
      "Puerto Mosquito",
      "Puerto Mosquito"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "DZI",
    "translations": [
      "Las Flores Airport",
      "Las Flores Airport",
      "Las Flores Airport"
    ],
    "city": [
      "Codazzi",
      "Codazzi",
      "Codazzi"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SJH",
    "translations": [
      "San Juan Del César Airport",
      "San Juan Del César Airport",
      "San Juan Del César Airport"
    ],
    "city": [
      "San Juan Del César",
      "San Juan Del César",
      "San Juan Del César"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PZR",
    "translations": [
      "Pizarro Airport",
      "Pizarro Airport",
      "Pizarro Airport"
    ],
    "city": [
      "Bajo Baudó",
      "Bajo Baudó",
      "Bajo Baudó"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "UNC",
    "translations": [
      "Unguía Airport",
      "Unguía Airport",
      "Unguía Airport"
    ],
    "city": [
      "Unguía",
      "Unguía",
      "Unguía"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "AYA",
    "translations": [
      "Ayapel Airport",
      "Ayapel Airport",
      "Ayapel Airport"
    ],
    "city": [
      "Ayapel",
      "Ayapel",
      "Ayapel"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SCA",
    "translations": [
      "Santa Catalina Airport",
      "Santa Catalina Airport",
      "Santa Catalina Airport"
    ],
    "city": [
      "Santa Catalina",
      "Santa Catalina",
      "Santa Catalina"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MND",
    "translations": [
      "Medina Airport",
      "Medina Airport",
      "Medina Airport"
    ],
    "city": [
      "Medina",
      "Medina",
      "Medina"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "NAD",
    "translations": [
      "Macanal Airport",
      "Macanal Airport",
      "Macanal Airport"
    ],
    "city": [
      "Macanal",
      "Macanal",
      "Macanal"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "GCA",
    "translations": [
      "Guacamayas Airport",
      "Guacamayas Airport",
      "Guacamayas Airport"
    ],
    "city": [
      "Guacamayas",
      "Guacamayas",
      "Guacamayas"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SRO",
    "translations": [
      "Santana Ramos Airport",
      "Santana Ramos Airport",
      "Santana Ramos Airport"
    ],
    "city": [
      "Santana Ramos",
      "Santana Ramos",
      "Santana Ramos"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "IVO",
    "translations": [
      "Chivolo Airport",
      "Chivolo Airport",
      "Chivolo Airport"
    ],
    "city": [
      "Chivolo",
      "Chivolo",
      "Chivolo"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "GAA",
    "translations": [
      "Guamal Airport",
      "Guamal Airport",
      "Guamal Airport"
    ],
    "city": [
      "Guamal",
      "Guamal",
      "Guamal"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "BAC",
    "translations": [
      "Barranca De Upia Airport",
      "Barranca De Upia Airport",
      "Barranca De Upia Airport"
    ],
    "city": [
      "Barranca De Upia",
      "Barranca De Upia",
      "Barranca De Upia"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CJD",
    "translations": [
      "Candilejas Airport",
      "Candilejas Airport",
      "Candilejas Airport"
    ],
    "city": [
      "Candilejas",
      "Candilejas",
      "Candilejas"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CQT",
    "translations": [
      "Caquetania Airport",
      "Caquetania Airport",
      "Caquetania Airport"
    ],
    "city": [
      "Caquetania",
      "Caquetania",
      "Caquetania"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ELJ",
    "translations": [
      "El Recreo Airport",
      "El Recreo Airport",
      "El Recreo Airport"
    ],
    "city": [
      "Ruperto Polania",
      "Ruperto Polania",
      "Ruperto Polania"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MSK",
    "translations": [
      "Morelia Airport",
      "Morelia Airport",
      "Morelia Airport"
    ],
    "city": [
      "Puerto Gaitán",
      "Puerto Gaitán",
      "Puerto Gaitán"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SOH",
    "translations": [
      "Solita Airport",
      "Solita Airport",
      "Solita Airport"
    ],
    "city": [
      "Solita",
      "Solita",
      "Solita"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MQR",
    "translations": [
      "Mosquera Airport",
      "Mosquera Airport",
      "Mosquera Airport"
    ],
    "city": [
      "Mosquera",
      "Mosquera",
      "Mosquera"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PYN",
    "translations": [
      "Payán Airport",
      "Payán Airport",
      "Payán Airport"
    ],
    "city": [
      "Payán",
      "Payán",
      "Payán"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ISD",
    "translations": [
      "Santa Bárbara Airport",
      "Santa Bárbara Airport",
      "Santa Bárbara Airport"
    ],
    "city": [
      "Iscuandé",
      "Iscuandé",
      "Iscuandé"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "AZT",
    "translations": [
      "Zapatoca Airport",
      "Zapatoca Airport",
      "Zapatoca Airport"
    ],
    "city": [
      "Zapatoca",
      "Zapatoca",
      "Zapatoca"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "HRR",
    "translations": [
      "Herrera Airport",
      "Herrera Airport",
      "Herrera Airport"
    ],
    "city": [
      "Campiña",
      "Campiña",
      "Campiña"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PLA",
    "translations": [
      "Planadas Airport",
      "Planadas Airport",
      "Planadas Airport"
    ],
    "city": [
      "Planadas",
      "Planadas",
      "Planadas"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SQB",
    "translations": [
      "Santa Ana Airport",
      "Santa Ana Airport",
      "Santa Ana Airport"
    ],
    "city": [
      "Piedras",
      "Piedras",
      "Piedras"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ARF",
    "translations": [
      "Acaricuara Airport",
      "Acaricuara Airport",
      "Acaricuara Airport"
    ],
    "city": [
      "Acaricuara",
      "Acaricuara",
      "Acaricuara"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MFB",
    "translations": [
      "Monfort Airport",
      "Monfort Airport",
      "Monfort Airport"
    ],
    "city": [
      "Monfort",
      "Monfort",
      "Monfort"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MHF",
    "translations": [
      "Morichal Airport",
      "Morichal Airport",
      "Morichal Airport"
    ],
    "city": [
      "Morichal",
      "Morichal",
      "Morichal"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "VAB",
    "translations": [
      "Yavarate Airport",
      "Yavarate Airport",
      "Yavarate Airport"
    ],
    "city": [
      "Yavarate",
      "Yavarate",
      "Yavarate"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CSR",
    "translations": [
      "Casuarito Airport",
      "Casuarito Airport",
      "Casuarito Airport"
    ],
    "city": [
      "Casuarito",
      "Casuarito",
      "Casuarito"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "GMC",
    "translations": [
      "Guerima Airport",
      "Guerima Airport",
      "Guerima Airport"
    ],
    "city": [
      "Puerto Carreño",
      "Puerto Carreño",
      "Puerto Carreño"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ACR",
    "translations": [
      "Araracuara Airport",
      "Araracuara Airport",
      "Araracuara Airport"
    ],
    "city": [
      "Araracuara",
      "Araracuara",
      "Araracuara"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ACD",
    "translations": [
      "Alcides Fernández Airport",
      "Alcides Fernández Airport",
      "Alcides Fernández Airport"
    ],
    "city": [
      "Acandí",
      "Acandí",
      "Acandí"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "HAY",
    "translations": [
      "Hacaritama Airport",
      "Hacaritama Airport",
      "Hacaritama Airport"
    ],
    "city": [
      "Aguachica",
      "Aguachica",
      "Aguachica"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "AFI",
    "translations": [
      "Amalfi Airport",
      "Amalfi Airport",
      "Amalfi Airport"
    ],
    "city": [
      "Amalfi",
      "Amalfi",
      "Amalfi"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "API",
    "translations": [
      "Gomez Nino Apiay Air Base",
      "Gomez Nino Apiay Air Base",
      "Gomez Nino Apiay Air Base"
    ],
    "city": [
      "Apiay",
      "Apiay",
      "Apiay"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "AXM",
    "translations": [
      "El Eden Airport",
      "El Eden Airport",
      "El Eden Airport"
    ],
    "city": [
      "Armenia",
      "Armenia",
      "Armenia"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PUU",
    "translations": [
      "Tres De Mayo Airport",
      "Tres De Mayo Airport",
      "Tres De Mayo Airport"
    ],
    "city": [
      "Puerto Asís",
      "Puerto Asís",
      "Puerto Asís"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ARQ",
    "translations": [
      "El Troncal Airport",
      "El Troncal Airport",
      "El Troncal Airport"
    ],
    "city": [
      "Arauquita",
      "Arauquita",
      "Arauquita"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ELB",
    "translations": [
      "Las Flores Airport",
      "Las Flores Airport",
      "Las Flores Airport"
    ],
    "city": [
      "El Banco",
      "El Banco",
      "El Banco"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "BGA",
    "translations": [
      "Palonegro Airport",
      "Palonegro Airport",
      "Palonegro Airport"
    ],
    "city": [
      "Bucaramanga",
      "Bucaramanga",
      "Bucaramanga"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "NBB",
    "translations": [
      "Barranco Minas Airport",
      "Barranco Minas Airport",
      "Barranco Minas Airport"
    ],
    "city": [
      "Barranco Minas",
      "Barranco Minas",
      "Barranco Minas"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "BOG",
    "translations": [
      "El Dorado International Airport",
      "El Dorado International Airport",
      "El Dorado International Airport"
    ],
    "city": [
      "Bogota",
      "Bogota",
      "Bogota"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "BAQ",
    "translations": [
      "Ernesto Cortissoz International Airport",
      "Ernesto Cortissoz International Airport",
      "Ernesto Cortissoz International Airport"
    ],
    "city": [
      "Barranquilla",
      "Barranquilla",
      "Barranquilla"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "BSC",
    "translations": [
      "José Celestino Mutis Airport",
      "José Celestino Mutis Airport",
      "José Celestino Mutis Airport"
    ],
    "city": [
      "Bahía Solano",
      "Bahía Solano",
      "Bahía Solano"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "BUN",
    "translations": [
      "Gerardo Tobar López Airport",
      "Gerardo Tobar López Airport",
      "Gerardo Tobar López Airport"
    ],
    "city": [
      "Buenaventura",
      "Buenaventura",
      "Buenaventura"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CPB",
    "translations": [
      "Capurganá Airport",
      "Capurganá Airport",
      "Capurganá Airport"
    ],
    "city": [
      "Acandí",
      "Acandí",
      "Acandí"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CUC",
    "translations": [
      "Camilo Daza International Airport",
      "Camilo Daza International Airport",
      "Camilo Daza International Airport"
    ],
    "city": [
      "Cúcuta",
      "Cúcuta",
      "Cúcuta"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "COG",
    "translations": [
      "Mandinga Airport",
      "Mandinga Airport",
      "Mandinga Airport"
    ],
    "city": [
      "Condoto",
      "Condoto",
      "Condoto"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CTG",
    "translations": [
      "Rafael Nuñez International Airport",
      "Rafael Nuñez International Airport",
      "Rafael Nuñez International Airport"
    ],
    "city": [
      "Cartagena",
      "Cartagena",
      "Cartagena"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CCO",
    "translations": [
      "Carimagua Airport",
      "Carimagua Airport",
      "Carimagua Airport"
    ],
    "city": [
      "Puerto López",
      "Puerto López",
      "Puerto López"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CLO",
    "translations": [
      "Alfonso Bonilla Aragon International Airport",
      "Alfonso Bonilla Aragon International Airport",
      "Alfonso Bonilla Aragon International Airport"
    ],
    "city": [
      "Cali",
      "Cali",
      "Cali"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CIM",
    "translations": [
      "Cimitarra Airport",
      "Cimitarra Airport",
      "Cimitarra Airport"
    ],
    "city": [
      "Cimitarra",
      "Cimitarra",
      "Cimitarra"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "RAV",
    "translations": [
      "Cravo Norte Airport",
      "Cravo Norte Airport",
      "Cravo Norte Airport"
    ],
    "city": [
      "Cravo Norte",
      "Cravo Norte",
      "Cravo Norte"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "TCO",
    "translations": [
      "La Florida Airport",
      "La Florida Airport",
      "La Florida Airport"
    ],
    "city": [
      "Tumaco",
      "Tumaco",
      "Tumaco"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "BHF",
    "translations": [
      "Cupica Airport",
      "Cupica Airport",
      "Cupica Airport"
    ],
    "city": [
      "Bahía Solano",
      "Bahía Solano",
      "Bahía Solano"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CUO",
    "translations": [
      "Carurú Airport",
      "Carurú Airport",
      "Carurú Airport"
    ],
    "city": [
      "Carurú",
      "Carurú",
      "Carurú"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CAQ",
    "translations": [
      "Juan H White Airport",
      "Juan H White Airport",
      "Juan H White Airport"
    ],
    "city": [
      "Caucasia",
      "Caucasia",
      "Caucasia"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CVE",
    "translations": [
      "Coveñas Airport",
      "Coveñas Airport",
      "Coveñas Airport"
    ],
    "city": [
      "Coveñas",
      "Coveñas",
      "Coveñas"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CZU",
    "translations": [
      "Las Brujas Airport",
      "Las Brujas Airport",
      "Las Brujas Airport"
    ],
    "city": [
      "Corozal",
      "Corozal",
      "Corozal"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "EBG",
    "translations": [
      "El Bagre Airport",
      "El Bagre Airport",
      "El Bagre Airport"
    ],
    "city": [
      "El Bagre",
      "El Bagre",
      "El Bagre"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ECR",
    "translations": [
      "El Charco Airport",
      "El Charco Airport",
      "El Charco Airport"
    ],
    "city": [
      "El Charco",
      "El Charco",
      "El Charco"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "EJA",
    "translations": [
      "Yariguíes Airport",
      "Yariguíes Airport",
      "Yariguíes Airport"
    ],
    "city": [
      "Barrancabermeja",
      "Barrancabermeja",
      "Barrancabermeja"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "FLA",
    "translations": [
      "Gustavo Artunduaga Paredes Airport",
      "Gustavo Artunduaga Paredes Airport",
      "Gustavo Artunduaga Paredes Airport"
    ],
    "city": [
      "Florencia",
      "Florencia",
      "Florencia"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "FDA",
    "translations": [
      "Fundación Airport",
      "Fundación Airport",
      "Fundación Airport"
    ],
    "city": [
      "Fundación",
      "Fundación",
      "Fundación"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "LGT",
    "translations": [
      "La Gaviota Airport",
      "La Gaviota Airport",
      "La Gaviota Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "GIR",
    "translations": [
      "Santiago Vila Airport",
      "Santiago Vila Airport",
      "Santiago Vila Airport"
    ],
    "city": [
      "Girardot",
      "Girardot",
      "Girardot"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CRC",
    "translations": [
      "Santa Ana Airport",
      "Santa Ana Airport",
      "Santa Ana Airport"
    ],
    "city": [
      "Cartago",
      "Cartago",
      "Cartago"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "GPI",
    "translations": [
      "Juan Casiano Airport",
      "Juan Casiano Airport",
      "Juan Casiano Airport"
    ],
    "city": [
      "Guapi",
      "Guapi",
      "Guapi"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "CPL",
    "translations": [
      "General Navas Pardo Airport",
      "General Navas Pardo Airport",
      "General Navas Pardo Airport"
    ],
    "city": [
      "Chaparral",
      "Chaparral",
      "Chaparral"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "HTZ",
    "translations": [
      "Hato Corozal Airport",
      "Hato Corozal Airport",
      "Hato Corozal Airport"
    ],
    "city": [
      "Hato Corozal",
      "Hato Corozal",
      "Hato Corozal"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "IBE",
    "translations": [
      "Perales Airport",
      "Perales Airport",
      "Perales Airport"
    ],
    "city": [
      "Ibagué",
      "Ibagué",
      "Ibagué"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "IGO",
    "translations": [
      "Jaime Ortiz Betancourt Airport",
      "Jaime Ortiz Betancourt Airport",
      "Jaime Ortiz Betancourt Airport"
    ],
    "city": [
      "Chigorodó",
      "Chigorodó",
      "Chigorodó"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "LPE",
    "translations": [
      "La Primavera Airport",
      "La Primavera Airport",
      "La Primavera Airport"
    ],
    "city": [
      "La Primavera",
      "La Primavera",
      "La Primavera"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "IPI",
    "translations": [
      "San Luis Airport",
      "San Luis Airport",
      "San Luis Airport"
    ],
    "city": [
      "Ipiales",
      "Ipiales",
      "Ipiales"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "JUO",
    "translations": [
      "Juradó Airport",
      "Juradó Airport",
      "Juradó Airport"
    ],
    "city": [
      "Juradó",
      "Juradó",
      "Juradó"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "APO",
    "translations": [
      "Antonio Roldán Betancur Airport",
      "Antonio Roldán Betancur Airport",
      "Antonio Roldán Betancur Airport"
    ],
    "city": [
      "Carepa",
      "Carepa",
      "Carepa"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "LQM",
    "translations": [
      "Caucaya Airport",
      "Caucaya Airport",
      "Caucaya Airport"
    ],
    "city": [
      "Puerto Leguízamo",
      "Puerto Leguízamo",
      "Puerto Leguízamo"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MCJ",
    "translations": [
      "Jorge Isaac Airport",
      "Jorge Isaac Airport",
      "Jorge Isaac Airport"
    ],
    "city": [
      "La Mina-Maicao",
      "La Mina-Maicao",
      "La Mina-Maicao"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "LPD",
    "translations": [
      "La Pedrera Airport",
      "La Pedrera Airport",
      "La Pedrera Airport"
    ],
    "city": [
      "La Pedrera",
      "La Pedrera",
      "La Pedrera"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "LET",
    "translations": [
      "Alfredo Vásquez Cobo International Airport",
      "Alfredo Vásquez Cobo International Airport",
      "Alfredo Vásquez Cobo International Airport"
    ],
    "city": [
      "Leticia",
      "Leticia",
      "Leticia"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "TBD",
    "translations": [
      "Timbiqui Airport",
      "Timbiqui Airport",
      "Timbiqui Airport"
    ],
    "city": [
      "Timbiqui",
      "Timbiqui",
      "Timbiqui"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "EOH",
    "translations": [
      "Enrique Olaya Herrera Airport",
      "Enrique Olaya Herrera Airport",
      "Enrique Olaya Herrera Airport"
    ],
    "city": [
      "Medellín",
      "Medellín",
      "Medellín"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MFS",
    "translations": [
      "Miraflores Airport",
      "Miraflores Airport",
      "Miraflores Airport"
    ],
    "city": [
      "Miraflores",
      "Miraflores",
      "Miraflores"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MGN",
    "translations": [
      "Baracoa Airport",
      "Baracoa Airport",
      "Baracoa Airport"
    ],
    "city": [
      "Magangué",
      "Magangué",
      "Magangué"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MTB",
    "translations": [
      "Montelibano Airport",
      "Montelibano Airport",
      "Montelibano Airport"
    ],
    "city": [
      "Montelíbano",
      "Montelíbano",
      "Montelíbano"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MMP",
    "translations": [
      "San Bernardo Airport",
      "San Bernardo Airport",
      "San Bernardo Airport"
    ],
    "city": [
      "Santa Cruz de Mompóx",
      "Santa Cruz de Mompóx",
      "Santa Cruz de Mompóx"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MTR",
    "translations": [
      "Los Garzones Airport",
      "Los Garzones Airport",
      "Los Garzones Airport"
    ],
    "city": [
      "Montería",
      "Montería",
      "Montería"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MVP",
    "translations": [
      "Fabio Alberto Leon Bentley Airport",
      "Fabio Alberto Leon Bentley Airport",
      "Fabio Alberto Leon Bentley Airport"
    ],
    "city": [
      "Mitú",
      "Mitú",
      "Mitú"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MZL",
    "translations": [
      "La Nubia Airport",
      "La Nubia Airport",
      "La Nubia Airport"
    ],
    "city": [
      "Manizales",
      "Manizales",
      "Manizales"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "LMC",
    "translations": [
      "La Macarena Airport",
      "La Macarena Airport",
      "La Macarena Airport"
    ],
    "city": [
      "La Macarena",
      "La Macarena",
      "La Macarena"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "NCI",
    "translations": [
      "Necocli Airport",
      "Necocli Airport",
      "Necocli Airport"
    ],
    "city": [
      "Necocli",
      "Necocli",
      "Necocli"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "NQU",
    "translations": [
      "Reyes Murillo Airport",
      "Reyes Murillo Airport",
      "Reyes Murillo Airport"
    ],
    "city": [
      "Nuquí",
      "Nuquí",
      "Nuquí"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "NVA",
    "translations": [
      "Benito Salas Airport",
      "Benito Salas Airport",
      "Benito Salas Airport"
    ],
    "city": [
      "Neiva",
      "Neiva",
      "Neiva"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "OCV",
    "translations": [
      "Aguas Claras Airport",
      "Aguas Claras Airport",
      "Aguas Claras Airport"
    ],
    "city": [
      "Ocaña",
      "Ocaña",
      "Ocaña"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ORC",
    "translations": [
      "Orocue Airport",
      "Orocue Airport",
      "Orocue Airport"
    ],
    "city": [
      "Orocue",
      "Orocue",
      "Orocue"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "OTU",
    "translations": [
      "Otu Airport",
      "Otu Airport",
      "Otu Airport"
    ],
    "city": [
      "Remedios",
      "Remedios",
      "Remedios"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "RON",
    "translations": [
      "Juan Jose Rondon Airport",
      "Juan Jose Rondon Airport",
      "Juan Jose Rondon Airport"
    ],
    "city": [
      "Paipa",
      "Paipa",
      "Paipa"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PCR",
    "translations": [
      "German Olano Airport",
      "German Olano Airport",
      "German Olano Airport"
    ],
    "city": [
      "Puerto Carreño",
      "Puerto Carreño",
      "Puerto Carreño"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PDA",
    "translations": [
      "Obando Cesar Gaviria Trujillo Airport",
      "Obando Cesar Gaviria Trujillo Airport",
      "Obando Cesar Gaviria Trujillo Airport"
    ],
    "city": [
      "Puerto Inírida",
      "Puerto Inírida",
      "Puerto Inírida"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PEI",
    "translations": [
      "Matecaña International Airport",
      "Matecaña International Airport",
      "Matecaña International Airport"
    ],
    "city": [
      "Pereira",
      "Pereira",
      "Pereira"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PTX",
    "translations": [
      "Pitalito Airport",
      "Pitalito Airport",
      "Pitalito Airport"
    ],
    "city": [
      "Pitalito",
      "Pitalito",
      "Pitalito"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PLT",
    "translations": [
      "Plato Airport",
      "Plato Airport",
      "Plato Airport"
    ],
    "city": [
      "Plato",
      "Plato",
      "Plato"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "NAR",
    "translations": [
      "Puerto Nare Airport",
      "Puerto Nare Airport",
      "Puerto Nare Airport"
    ],
    "city": [
      "Armenia",
      "Armenia",
      "Armenia"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PPN",
    "translations": [
      "Guillermo León Valencia Airport",
      "Guillermo León Valencia Airport",
      "Guillermo León Valencia Airport"
    ],
    "city": [
      "Popayán",
      "Popayán",
      "Popayán"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PAL",
    "translations": [
      "German Olano Air Base",
      "German Olano Air Base",
      "German Olano Air Base"
    ],
    "city": [
      "La Dorada",
      "La Dorada",
      "La Dorada"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PBE",
    "translations": [
      "Puerto Berrio Airport",
      "Puerto Berrio Airport",
      "Puerto Berrio Airport"
    ],
    "city": [
      "Puerto Berrio",
      "Puerto Berrio",
      "Puerto Berrio"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PSO",
    "translations": [
      "Antonio Nariño Airport",
      "Antonio Nariño Airport",
      "Antonio Nariño Airport"
    ],
    "city": [
      "Chachagüí",
      "Chachagüí",
      "Chachagüí"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PVA",
    "translations": [
      "El Embrujo Airport",
      "El Embrujo Airport",
      "El Embrujo Airport"
    ],
    "city": [
      "Providencia",
      "Providencia",
      "Providencia"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PZA",
    "translations": [
      "Paz De Ariporo Airport",
      "Paz De Ariporo Airport",
      "Paz De Ariporo Airport"
    ],
    "city": [
      "Paz De Ariporo",
      "Paz De Ariporo",
      "Paz De Ariporo"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MQU",
    "translations": [
      "Mariquita Airport",
      "Mariquita Airport",
      "Mariquita Airport"
    ],
    "city": [
      "Mariquita",
      "Mariquita",
      "Mariquita"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "TCD",
    "translations": [
      "Tarapacá Airport",
      "Tarapacá Airport",
      "Tarapacá Airport"
    ],
    "city": [
      "Tarapacá",
      "Tarapacá",
      "Tarapacá"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MDE",
    "translations": [
      "Jose Maria Córdova International Airport",
      "Jose Maria Córdova International Airport",
      "Jose Maria Córdova International Airport"
    ],
    "city": [
      "Medellín",
      "Medellín",
      "Medellín"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "RCH",
    "translations": [
      "Almirante Padilla Airport",
      "Almirante Padilla Airport",
      "Almirante Padilla Airport"
    ],
    "city": [
      "Riohacha",
      "Riohacha",
      "Riohacha"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SNT",
    "translations": [
      "Las Cruces Airport",
      "Las Cruces Airport",
      "Las Cruces Airport"
    ],
    "city": [
      "Sabana de Torres",
      "Sabana de Torres",
      "Sabana de Torres"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "RVE",
    "translations": [
      "Los Colonizadores Airport",
      "Los Colonizadores Airport",
      "Los Colonizadores Airport"
    ],
    "city": [
      "Saravena",
      "Saravena",
      "Saravena"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SJE",
    "translations": [
      "Jorge E. Gonzalez Torres Airport",
      "Jorge E. Gonzalez Torres Airport",
      "Jorge E. Gonzalez Torres Airport"
    ],
    "city": [
      "San José Del Guaviare",
      "San José Del Guaviare",
      "San José Del Guaviare"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SSL",
    "translations": [
      "Santa Rosalia Airport",
      "Santa Rosalia Airport",
      "Santa Rosalia Airport"
    ],
    "city": [
      "Santa Rosalia",
      "Santa Rosalia",
      "Santa Rosalia"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SMR",
    "translations": [
      "Simón Bolívar International Airport",
      "Simón Bolívar International Airport",
      "Simón Bolívar International Airport"
    ],
    "city": [
      "Santa Marta",
      "Santa Marta",
      "Santa Marta"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SOX",
    "translations": [
      "Alberto Lleras Camargo Airport",
      "Alberto Lleras Camargo Airport",
      "Alberto Lleras Camargo Airport"
    ],
    "city": [
      "Sogamoso",
      "Sogamoso",
      "Sogamoso"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ADZ",
    "translations": [
      "Gustavo Rojas Pinilla International Airport",
      "Gustavo Rojas Pinilla International Airport",
      "Gustavo Rojas Pinilla International Airport"
    ],
    "city": [
      "San Andrés",
      "San Andrés",
      "San Andrés"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SRS",
    "translations": [
      "San Marcos Airport",
      "San Marcos Airport",
      "San Marcos Airport"
    ],
    "city": [
      "San Marcos",
      "San Marcos",
      "San Marcos"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "SVI",
    "translations": [
      "Eduardo Falla Solano Airport",
      "Eduardo Falla Solano Airport",
      "Eduardo Falla Solano Airport"
    ],
    "city": [
      "San Vicente Del Caguán",
      "San Vicente Del Caguán",
      "San Vicente Del Caguán"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "TAU",
    "translations": [
      "Tauramena Airport",
      "Tauramena Airport",
      "Tauramena Airport"
    ],
    "city": [
      "Tauramena",
      "Tauramena",
      "Tauramena"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "TIB",
    "translations": [
      "Tibú Airport",
      "Tibú Airport",
      "Tibú Airport"
    ],
    "city": [
      "Tibú",
      "Tibú",
      "Tibú"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "TDA",
    "translations": [
      "Trinidad Airport",
      "Trinidad Airport",
      "Trinidad Airport"
    ],
    "city": [
      "Trinidad",
      "Trinidad",
      "Trinidad"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "TLU",
    "translations": [
      "Golfo de Morrosquillo Airport",
      "Golfo de Morrosquillo Airport",
      "Golfo de Morrosquillo Airport"
    ],
    "city": [
      "Santiago de Tolú",
      "Santiago de Tolú",
      "Santiago de Tolú"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "TME",
    "translations": [
      "Gustavo Vargas Airport",
      "Gustavo Vargas Airport",
      "Gustavo Vargas Airport"
    ],
    "city": [
      "Tame",
      "Tame",
      "Tame"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "TQS",
    "translations": [
      "Captain Ernesto Esguerra Cubides Air Base",
      "Captain Ernesto Esguerra Cubides Air Base",
      "Captain Ernesto Esguerra Cubides Air Base"
    ],
    "city": [
      "Tres Esquinas",
      "Tres Esquinas",
      "Tres Esquinas"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "TRB",
    "translations": [
      "Gonzalo Mejía Airport",
      "Gonzalo Mejía Airport",
      "Gonzalo Mejía Airport"
    ],
    "city": [
      "Turbo",
      "Turbo",
      "Turbo"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "URI",
    "translations": [
      "Uribe Airport",
      "Uribe Airport",
      "Uribe Airport"
    ],
    "city": [
      "La Uribe",
      "La Uribe",
      "La Uribe"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "AUC",
    "translations": [
      "Santiago Perez Airport",
      "Santiago Perez Airport",
      "Santiago Perez Airport"
    ],
    "city": [
      "Arauca",
      "Arauca",
      "Arauca"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "UIB",
    "translations": [
      "El Caraño Airport",
      "El Caraño Airport",
      "El Caraño Airport"
    ],
    "city": [
      "Quibdó",
      "Quibdó",
      "Quibdó"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "ULQ",
    "translations": [
      "Heriberto Gíl Martínez Airport",
      "Heriberto Gíl Martínez Airport",
      "Heriberto Gíl Martínez Airport"
    ],
    "city": [
      "Tuluá",
      "Tuluá",
      "Tuluá"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "URR",
    "translations": [
      "Urrao Airport",
      "Urrao Airport",
      "Urrao Airport"
    ],
    "city": [
      "Urrao",
      "Urrao",
      "Urrao"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "VGZ",
    "translations": [
      "Villa Garzón Airport",
      "Villa Garzón Airport",
      "Villa Garzón Airport"
    ],
    "city": [
      "Villa Garzón",
      "Villa Garzón",
      "Villa Garzón"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "PYA",
    "translations": [
      "Velásquez Airport",
      "Velásquez Airport",
      "Velásquez Airport"
    ],
    "city": [
      "Puerto Boyacá",
      "Puerto Boyacá",
      "Puerto Boyacá"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "VUP",
    "translations": [
      "Alfonso López Pumarejo Airport",
      "Alfonso López Pumarejo Airport",
      "Alfonso López Pumarejo Airport"
    ],
    "city": [
      "Valledupar",
      "Valledupar",
      "Valledupar"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "VVC",
    "translations": [
      "Vanguardia Airport",
      "Vanguardia Airport",
      "Vanguardia Airport"
    ],
    "city": [
      "Villavicencio",
      "Villavicencio",
      "Villavicencio"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "AYG",
    "translations": [
      "Yaguara Airport",
      "Yaguara Airport",
      "Yaguara Airport"
    ],
    "city": [
      "San Vicente Del Caguán",
      "San Vicente Del Caguán",
      "San Vicente Del Caguán"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "EYP",
    "translations": [
      "El Alcaravan - Yopal Airport",
      "El Alcaravan - Yopal Airport",
      "El Alcaravan - Yopal Airport"
    ],
    "city": [
      "Yopal",
      "Yopal",
      "Yopal"
    ],
    "country": [
      "CO",
      "CO",
      "CO"
    ]
  },
  {
    "iata": "MHW",
    "translations": [
      "Monteagudo Airport",
      "Monteagudo Airport",
      "Monteagudo Airport"
    ],
    "city": [
      "El Bañado",
      "El Bañado",
      "El Bañado"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "SRE",
    "translations": [
      "Alcantarí Airport",
      "Alcantarí Airport",
      "Alcantarí Airport"
    ],
    "city": [
      "Yamparaez",
      "Yamparaez",
      "Yamparaez"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "APB",
    "translations": [
      "Apolo Airport",
      "Apolo Airport",
      "Apolo Airport"
    ],
    "city": [
      "Apolo",
      "Apolo",
      "Apolo"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "ASC",
    "translations": [
      "Ascención de Guarayos Airport",
      "Ascención de Guarayos Airport",
      "Ascención de Guarayos Airport"
    ],
    "city": [
      "Ascensión de Guarayos",
      "Ascensión de Guarayos",
      "Ascensión de Guarayos"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "BJO",
    "translations": [
      "Bermejo Airport",
      "Bermejo Airport",
      "Bermejo Airport"
    ],
    "city": [
      "Bermejo",
      "Bermejo",
      "Bermejo"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "CAM",
    "translations": [
      "Camiri Airport",
      "Camiri Airport",
      "Camiri Airport"
    ],
    "city": [
      "Camiri",
      "Camiri",
      "Camiri"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "CBB",
    "translations": [
      "Jorge Wilsterman International Airport",
      "Jorge Wilsterman International Airport",
      "Jorge Wilsterman International Airport"
    ],
    "city": [
      "Cochabamba",
      "Cochabamba",
      "Cochabamba"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "CIJ",
    "translations": [
      "Capitán Aníbal Arab Airport",
      "Capitán Aníbal Arab Airport",
      "Capitán Aníbal Arab Airport"
    ],
    "city": [
      "Cobija",
      "Cobija",
      "Cobija"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "CEP",
    "translations": [
      "Concepción Airport",
      "Concepción Airport",
      "Concepción Airport"
    ],
    "city": [
      "Concepción",
      "Concepción",
      "Concepción"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "SRZ",
    "translations": [
      "El Trompillo Airport",
      "El Trompillo Airport",
      "El Trompillo Airport"
    ],
    "city": [
      "Santa Cruz",
      "Santa Cruz",
      "Santa Cruz"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "GYA",
    "translations": [
      "Guayaramerín Airport",
      "Guayaramerín Airport",
      "Guayaramerín Airport"
    ],
    "city": [
      "Guayaramerín",
      "Guayaramerín",
      "Guayaramerín"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "CCA",
    "translations": [
      "Chimore Airport",
      "Chimore Airport",
      "Chimore Airport"
    ],
    "city": [
      "Chimore",
      "Chimore",
      "Chimore"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "BVK",
    "translations": [
      "Huacaraje Airport",
      "Huacaraje Airport",
      "Huacaraje Airport"
    ],
    "city": [
      "Itenes",
      "Itenes",
      "Itenes"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "SJS",
    "translations": [
      "San José De Chiquitos Airport",
      "San José De Chiquitos Airport",
      "San José De Chiquitos Airport"
    ],
    "city": [
      "San José de Chiquitos",
      "San José de Chiquitos",
      "San José de Chiquitos"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "SJB",
    "translations": [
      "San Joaquín Airport",
      "San Joaquín Airport",
      "San Joaquín Airport"
    ],
    "city": [
      "San Joaquín",
      "San Joaquín",
      "San Joaquín"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "SJV",
    "translations": [
      "San Javier Airport",
      "San Javier Airport",
      "San Javier Airport"
    ],
    "city": [
      "San Javier",
      "San Javier",
      "San Javier"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "LPB",
    "translations": [
      "El Alto International Airport",
      "El Alto International Airport",
      "El Alto International Airport"
    ],
    "city": [
      "La Paz / El Alto",
      "La Paz / El Alto",
      "La Paz / El Alto"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "MGD",
    "translations": [
      "Magdalena Airport",
      "Magdalena Airport",
      "Magdalena Airport"
    ],
    "city": [
      "Magdalena",
      "Magdalena",
      "Magdalena"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "ORU",
    "translations": [
      "Juan Mendoza Airport",
      "Juan Mendoza Airport",
      "Juan Mendoza Airport"
    ],
    "city": [
      "Oruro",
      "Oruro",
      "Oruro"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "POI",
    "translations": [
      "Capitan Nicolas Rojas Airport",
      "Capitan Nicolas Rojas Airport",
      "Capitan Nicolas Rojas Airport"
    ],
    "city": [
      "Potosí",
      "Potosí",
      "Potosí"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "PUR",
    "translations": [
      "Puerto Rico Airport",
      "Puerto Rico Airport",
      "Puerto Rico Airport"
    ],
    "city": [
      "Puerto Rico/Manuripi",
      "Puerto Rico/Manuripi",
      "Puerto Rico/Manuripi"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "PSZ",
    "translations": [
      "Capitán Av. Salvador Ogaya G. airport",
      "Capitán Av. Salvador Ogaya G. airport",
      "Capitán Av. Salvador Ogaya G. airport"
    ],
    "city": [
      "Puerto Suárez",
      "Puerto Suárez",
      "Puerto Suárez"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "SRD",
    "translations": [
      "San Ramón Airport",
      "San Ramón Airport",
      "San Ramón Airport"
    ],
    "city": [
      "San Ramón / Mamoré",
      "San Ramón / Mamoré",
      "San Ramón / Mamoré"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "RBO",
    "translations": [
      "Roboré Airport",
      "Roboré Airport",
      "Roboré Airport"
    ],
    "city": [
      "Roboré",
      "Roboré",
      "Roboré"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "RIB",
    "translations": [
      "Capitán Av. Selin Zeitun Lopez Airport",
      "Capitán Av. Selin Zeitun Lopez Airport",
      "Capitán Av. Selin Zeitun Lopez Airport"
    ],
    "city": [
      "Riberalta",
      "Riberalta",
      "Riberalta"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "RBQ",
    "translations": [
      "Rurrenabaque Airport",
      "Rurrenabaque Airport",
      "Rurrenabaque Airport"
    ],
    "city": [
      "Rurrenabaque",
      "Rurrenabaque",
      "Rurrenabaque"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "REY",
    "translations": [
      "Reyes Airport",
      "Reyes Airport",
      "Reyes Airport"
    ],
    "city": [
      "Reyes",
      "Reyes",
      "Reyes"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "SBL",
    "translations": [
      "Santa Ana Del Yacuma Airport",
      "Santa Ana Del Yacuma Airport",
      "Santa Ana Del Yacuma Airport"
    ],
    "city": [
      "Santa Ana del Yacuma",
      "Santa Ana del Yacuma",
      "Santa Ana del Yacuma"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "SRJ",
    "translations": [
      "Capitán Av. German Quiroga G. Airport",
      "Capitán Av. German Quiroga G. Airport",
      "Capitán Av. German Quiroga G. Airport"
    ],
    "city": [
      "San Borja",
      "San Borja",
      "San Borja"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "SNG",
    "translations": [
      "Capitán Av. Juan Cochamanidis S. Airport",
      "Capitán Av. Juan Cochamanidis S. Airport",
      "Capitán Av. Juan Cochamanidis S. Airport"
    ],
    "city": [
      "San Ignacio de Velasco",
      "San Ignacio de Velasco",
      "San Ignacio de Velasco"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "SNM",
    "translations": [
      "San Ignacio de Moxos Airport",
      "San Ignacio de Moxos Airport",
      "San Ignacio de Moxos Airport"
    ],
    "city": [
      "San Ignacio de Moxos",
      "San Ignacio de Moxos",
      "San Ignacio de Moxos"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "SRB",
    "translations": [
      "Santa Rosa De Yacuma Airport",
      "Santa Rosa De Yacuma Airport",
      "Santa Rosa De Yacuma Airport"
    ],
    "city": [
      "Santa Rosa",
      "Santa Rosa",
      "Santa Rosa"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "MQK",
    "translations": [
      "San Matías Airport",
      "San Matías Airport",
      "San Matías Airport"
    ],
    "city": [
      "San Matías",
      "San Matías",
      "San Matías"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "TJA",
    "translations": [
      "Capitan Oriel Lea Plaza Airport",
      "Capitan Oriel Lea Plaza Airport",
      "Capitan Oriel Lea Plaza Airport"
    ],
    "city": [
      "Tarija",
      "Tarija",
      "Tarija"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "TDD",
    "translations": [
      "Teniente Av. Jorge Henrich Arauz Airport",
      "Teniente Av. Jorge Henrich Arauz Airport",
      "Teniente Av. Jorge Henrich Arauz Airport"
    ],
    "city": [
      "Trinidad",
      "Trinidad",
      "Trinidad"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "UYU",
    "translations": [
      "Uyuni Joya Andina Airport",
      "Uyuni Joya Andina Airport",
      "Uyuni Joya Andina Airport"
    ],
    "city": [
      "Quijarro",
      "Quijarro",
      "Quijarro"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "VAH",
    "translations": [
      "Capitán Av. Vidal Villagomez Toledo Airport",
      "Capitán Av. Vidal Villagomez Toledo Airport",
      "Capitán Av. Vidal Villagomez Toledo Airport"
    ],
    "city": [
      "Vallegrande",
      "Vallegrande",
      "Vallegrande"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "VLM",
    "translations": [
      "Teniente Coronel Rafael Pabón Airport",
      "Teniente Coronel Rafael Pabón Airport",
      "Teniente Coronel Rafael Pabón Airport"
    ],
    "city": [
      "Villamontes",
      "Villamontes",
      "Villamontes"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "VVI",
    "translations": [
      "Viru Viru International Airport",
      "Viru Viru International Airport",
      "Viru Viru International Airport"
    ],
    "city": [
      "Santa Cruz",
      "Santa Cruz",
      "Santa Cruz"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "BYC",
    "translations": [
      "Yacuiba Airport",
      "Yacuiba Airport",
      "Yacuiba Airport"
    ],
    "city": [
      "Yacuíba",
      "Yacuíba",
      "Yacuíba"
    ],
    "country": [
      "BO",
      "BO",
      "BO"
    ]
  },
  {
    "iata": "ABN",
    "translations": [
      "Albina Airport",
      "Albina Airport",
      "Albina Airport"
    ],
    "city": [
      "Albina",
      "Albina",
      "Albina"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "AAJ",
    "translations": [
      "Cayana Airstrip",
      "Cayana Airstrip",
      "Cayana Airstrip"
    ],
    "city": [
      "Awaradam",
      "Awaradam",
      "Awaradam"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "TOT",
    "translations": [
      "Totness Airport",
      "Totness Airport",
      "Totness Airport"
    ],
    "city": [
      "Totness",
      "Totness",
      "Totness"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "DRJ",
    "translations": [
      "Drietabbetje Airport",
      "Drietabbetje Airport",
      "Drietabbetje Airport"
    ],
    "city": [
      "Drietabbetje",
      "Drietabbetje",
      "Drietabbetje"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "LDO",
    "translations": [
      "Ladouanie Airport",
      "Ladouanie Airport",
      "Ladouanie Airport"
    ],
    "city": [
      "Aurora",
      "Aurora",
      "Aurora"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "PBM",
    "translations": [
      "Johan Adolf Pengel International Airport",
      "Johan Adolf Pengel International Airport",
      "Johan Adolf Pengel International Airport"
    ],
    "city": [
      "Zandery",
      "Zandery",
      "Zandery"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "MOJ",
    "translations": [
      "Moengo Airstrip",
      "Moengo Airstrip",
      "Moengo Airstrip"
    ],
    "city": [
      "Moengo",
      "Moengo",
      "Moengo"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "ICK",
    "translations": [
      "Nieuw Nickerie - Major Henk Fernandes Airport",
      "Nieuw Nickerie - Major Henk Fernandes Airport",
      "Nieuw Nickerie - Major Henk Fernandes Airport"
    ],
    "city": [
      "Nieuw Nickerie",
      "Nieuw Nickerie",
      "Nieuw Nickerie"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "OEM",
    "translations": [
      "Vincent Fayks Airport",
      "Vincent Fayks Airport",
      "Vincent Fayks Airport"
    ],
    "city": [
      "Paloemeu",
      "Paloemeu",
      "Paloemeu"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "SMZ",
    "translations": [
      "Stoelmanseiland Airport",
      "Stoelmanseiland Airport",
      "Stoelmanseiland Airport"
    ],
    "city": [
      "Stoelmanseiland",
      "Stoelmanseiland",
      "Stoelmanseiland"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "KCB",
    "translations": [
      "Tepoe Airstrip",
      "Tepoe Airstrip",
      "Tepoe Airstrip"
    ],
    "city": [
      "Kasikasima",
      "Kasikasima",
      "Kasikasima"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "AGI",
    "translations": [
      "Wageningen Airstrip",
      "Wageningen Airstrip",
      "Wageningen Airstrip"
    ],
    "city": [
      "Wageningen",
      "Wageningen",
      "Wageningen"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "WSO",
    "translations": [
      "Washabo Airport",
      "Washabo Airport",
      "Washabo Airport"
    ],
    "city": [
      "Washabo",
      "Washabo",
      "Washabo"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "ORG",
    "translations": [
      "Zorg en Hoop Airport",
      "Zorg en Hoop Airport",
      "Zorg en Hoop Airport"
    ],
    "city": [
      "Paramaribo",
      "Paramaribo",
      "Paramaribo"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "JSO",
    "translations": [
      "Dr. Luciano de Arruda Coelho Regional Airport",
      "Dr. Luciano de Arruda Coelho Regional Airport",
      "Dr. Luciano de Arruda Coelho Regional Airport"
    ],
    "city": [
      "Sobral",
      "Sobral",
      "Sobral"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JAW",
    "translations": [
      "Araripina Airport",
      "Araripina Airport",
      "Araripina Airport"
    ],
    "city": [
      "Araripina",
      "Araripina",
      "Araripina"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "APQ",
    "translations": [
      "Arapiraca Airport",
      "Arapiraca Airport",
      "Arapiraca Airport"
    ],
    "city": [
      "Arapiraca",
      "Arapiraca",
      "Arapiraca"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "AMJ",
    "translations": [
      "Cirilo Queiróz Airport",
      "Cirilo Queiróz Airport",
      "Cirilo Queiróz Airport"
    ],
    "city": [
      "Almenara",
      "Almenara",
      "Almenara"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "AIF",
    "translations": [
      "Marcelo Pires Halzhausen Airport",
      "Marcelo Pires Halzhausen Airport",
      "Marcelo Pires Halzhausen Airport"
    ],
    "city": [
      "Assis",
      "Assis",
      "Assis"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BDC",
    "translations": [
      "Barra do Corda Airport",
      "Barra do Corda Airport",
      "Barra do Corda Airport"
    ],
    "city": [
      "Barra do Corda",
      "Barra do Corda",
      "Barra do Corda"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BRA",
    "translations": [
      "Dom Ricardo Weberberger Airport",
      "Dom Ricardo Weberberger Airport",
      "Dom Ricardo Weberberger Airport"
    ],
    "city": [
      "Barreiras",
      "Barreiras",
      "Barreiras"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BSS",
    "translations": [
      "Balsas Airport",
      "Balsas Airport",
      "Balsas Airport"
    ],
    "city": [
      "Balsas",
      "Balsas",
      "Balsas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BQQ",
    "translations": [
      "Barra Airport",
      "Barra Airport",
      "Barra Airport"
    ],
    "city": [
      "Barra",
      "Barra",
      "Barra"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MXQ",
    "translations": [
      "Lorenzo Airport",
      "Lorenzo Airport",
      "Lorenzo Airport"
    ],
    "city": [
      "Cairu",
      "Cairu",
      "Cairu"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "EEA",
    "translations": [
      "Planalto Serrano Regional Airport",
      "Planalto Serrano Regional Airport",
      "Planalto Serrano Regional Airport"
    ],
    "city": [
      "Correia Pinto",
      "Correia Pinto",
      "Correia Pinto"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "QCH",
    "translations": [
      "Colatina Airport",
      "Colatina Airport",
      "Colatina Airport"
    ],
    "city": [
      "Colatina",
      "Colatina",
      "Colatina"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "RDC",
    "translations": [
      "Redenção Airport",
      "Redenção Airport",
      "Redenção Airport"
    ],
    "city": [
      "Redenção",
      "Redenção",
      "Redenção"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "DTI",
    "translations": [
      "Diamantina Airport",
      "Diamantina Airport",
      "Diamantina Airport"
    ],
    "city": [
      "Diamantina",
      "Diamantina",
      "Diamantina"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "DIQ",
    "translations": [
      "Brigadeiro Cabral Airport",
      "Brigadeiro Cabral Airport",
      "Brigadeiro Cabral Airport"
    ],
    "city": [
      "Divinópolis",
      "Divinópolis",
      "Divinópolis"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JPE",
    "translations": [
      "Nagib Demachki Airport",
      "Nagib Demachki Airport",
      "Nagib Demachki Airport"
    ],
    "city": [
      "Paragominas",
      "Paragominas",
      "Paragominas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CNV",
    "translations": [
      "Sócrates Rezende Airport",
      "Sócrates Rezende Airport",
      "Sócrates Rezende Airport"
    ],
    "city": [
      "Canavieiras",
      "Canavieiras",
      "Canavieiras"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "VCC",
    "translations": [
      "Vacaria Airport",
      "Vacaria Airport",
      "Vacaria Airport"
    ],
    "city": [
      "Vacaria",
      "Vacaria",
      "Vacaria"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SXX",
    "translations": [
      "São Félix do Xingu Airport",
      "São Félix do Xingu Airport",
      "São Félix do Xingu Airport"
    ],
    "city": [
      "São Félix do Xingu",
      "São Félix do Xingu",
      "São Félix do Xingu"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GUZ",
    "translations": [
      "Guarapari Airport",
      "Guarapari Airport",
      "Guarapari Airport"
    ],
    "city": [
      "Guarapari",
      "Guarapari",
      "Guarapari"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GDP",
    "translations": [
      "Guadalupe Airport",
      "Guadalupe Airport",
      "Guadalupe Airport"
    ],
    "city": [
      "Guadalupe",
      "Guadalupe",
      "Guadalupe"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GNM",
    "translations": [
      "Guanambi Airport",
      "Guanambi Airport",
      "Guanambi Airport"
    ],
    "city": [
      "Guanambi",
      "Guanambi",
      "Guanambi"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "QGP",
    "translations": [
      "Garanhuns Airport",
      "Garanhuns Airport",
      "Garanhuns Airport"
    ],
    "city": [
      "Garanhuns",
      "Garanhuns",
      "Garanhuns"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SET",
    "translations": [
      "Santa Magalhães Airport",
      "Santa Magalhães Airport",
      "Santa Magalhães Airport"
    ],
    "city": [
      "Serra Talhada",
      "Serra Talhada",
      "Serra Talhada"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "IRE",
    "translations": [
      "Irecê Airport",
      "Irecê Airport",
      "Irecê Airport"
    ],
    "city": [
      "Irecê",
      "Irecê",
      "Irecê"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "QIG",
    "translations": [
      "Iguatu Airport",
      "Iguatu Airport",
      "Iguatu Airport"
    ],
    "city": [
      "Iguatu",
      "Iguatu",
      "Iguatu"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "QIT",
    "translations": [
      "Itapetinga Airport",
      "Itapetinga Airport",
      "Itapetinga Airport"
    ],
    "city": [
      "Itapetinga",
      "Itapetinga",
      "Itapetinga"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "IPU",
    "translations": [
      "Ipiaú Airport",
      "Ipiaú Airport",
      "Ipiaú Airport"
    ],
    "city": [
      "Ipiaú",
      "Ipiaú",
      "Ipiaú"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JCM",
    "translations": [
      "Jacobina Airport",
      "Jacobina Airport",
      "Jacobina Airport"
    ],
    "city": [
      "Jacobina",
      "Jacobina",
      "Jacobina"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JEQ",
    "translations": [
      "Jequié Airport",
      "Jequié Airport",
      "Jequié Airport"
    ],
    "city": [
      "Jequié",
      "Jequié",
      "Jequié"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JMA",
    "translations": [
      "Aeroporto Elias Breder Airport",
      "Aeroporto Elias Breder Airport",
      "Aeroporto Elias Breder Airport"
    ],
    "city": [
      "Manhuaçu",
      "Manhuaçu",
      "Manhuaçu"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JNA",
    "translations": [
      "Januária Airport",
      "Januária Airport",
      "Januária Airport"
    ],
    "city": [
      "Januária",
      "Januária",
      "Januária"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JDR",
    "translations": [
      "Prefeito Octávio de Almeida Neves Airport",
      "Prefeito Octávio de Almeida Neves Airport",
      "Prefeito Octávio de Almeida Neves Airport"
    ],
    "city": [
      "São João Del Rei",
      "São João Del Rei",
      "São João Del Rei"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CDI",
    "translations": [
      "Cachoeiro do Itapemirim - Raimundo de Andrade Airport",
      "Cachoeiro do Itapemirim - Raimundo de Andrade Airport",
      "Cachoeiro do Itapemirim - Raimundo de Andrade Airport"
    ],
    "city": [
      "Cachoeiro do Itapemirim",
      "Cachoeiro do Itapemirim",
      "Cachoeiro do Itapemirim"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "QCP",
    "translations": [
      "Currais Novos Airport",
      "Currais Novos Airport",
      "Currais Novos Airport"
    ],
    "city": [
      "Currais Novos",
      "Currais Novos",
      "Currais Novos"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "LHN",
    "translations": [
      "Linhares Municipal Airport",
      "Linhares Municipal Airport",
      "Linhares Municipal Airport"
    ],
    "city": [
      "Linhares",
      "Linhares",
      "Linhares"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SSO",
    "translations": [
      "São Lourenço Airport",
      "São Lourenço Airport",
      "São Lourenço Airport"
    ],
    "city": [
      "São Lourenço",
      "São Lourenço",
      "São Lourenço"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MTE",
    "translations": [
      "Monte Alegre Airport",
      "Monte Alegre Airport",
      "Monte Alegre Airport"
    ],
    "city": [
      "Monte Alegre",
      "Monte Alegre",
      "Monte Alegre"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MVS",
    "translations": [
      "Mucuri Airport",
      "Mucuri Airport",
      "Mucuri Airport"
    ],
    "city": [
      "Mucuri",
      "Mucuri",
      "Mucuri"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SBJ",
    "translations": [
      "São Mateus - Ernesto Bonomo Airport",
      "São Mateus - Ernesto Bonomo Airport",
      "São Mateus - Ernesto Bonomo Airport"
    ],
    "city": [
      "São Mateus",
      "São Mateus",
      "São Mateus"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PTQ",
    "translations": [
      "Porto de Moz Airport",
      "Porto de Moz Airport",
      "Porto de Moz Airport"
    ],
    "city": [
      "Porto De Moz",
      "Porto De Moz",
      "Porto De Moz"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "NNU",
    "translations": [
      "Nanuque Airport",
      "Nanuque Airport",
      "Nanuque Airport"
    ],
    "city": [
      "Nanuque",
      "Nanuque",
      "Nanuque"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PSW",
    "translations": [
      "Municipal José Figueiredo Airport",
      "Municipal José Figueiredo Airport",
      "Municipal José Figueiredo Airport"
    ],
    "city": [
      "Passos",
      "Passos",
      "Passos"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "FEJ",
    "translations": [
      "Feijó Airport",
      "Feijó Airport",
      "Feijó Airport"
    ],
    "city": [
      "Feijó",
      "Feijó",
      "Feijó"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ORX",
    "translations": [
      "Oriximiná Airport",
      "Oriximiná Airport",
      "Oriximiná Airport"
    ],
    "city": [
      "Oriximiná",
      "Oriximiná",
      "Oriximiná"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PCS",
    "translations": [
      "Picos Airport",
      "Picos Airport",
      "Picos Airport"
    ],
    "city": [
      "Picos",
      "Picos",
      "Picos"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "POJ",
    "translations": [
      "Patos de Minas Airport",
      "Patos de Minas Airport",
      "Patos de Minas Airport"
    ],
    "city": [
      "Patos de Minas",
      "Patos de Minas",
      "Patos de Minas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PIV",
    "translations": [
      "Pirapora Airport",
      "Pirapora Airport",
      "Pirapora Airport"
    ],
    "city": [
      "Pirapora",
      "Pirapora",
      "Pirapora"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SNQ",
    "translations": [
      "San Quintín Military Airstrip",
      "San Quintín Military Airstrip",
      "San Quintín Military Airstrip"
    ],
    "city": [
      "San Quintín",
      "San Quintín",
      "San Quintín"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "FLB",
    "translations": [
      "Cangapara Airport",
      "Cangapara Airport",
      "Cangapara Airport"
    ],
    "city": [
      "Floriano",
      "Floriano",
      "Floriano"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CHD",
    "translations": [
      "Mucugê Airport",
      "Mucugê Airport",
      "Mucugê Airport"
    ],
    "city": [
      "Mucugê",
      "Mucugê",
      "Mucugê"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PDF",
    "translations": [
      "Prado Airport",
      "Prado Airport",
      "Prado Airport"
    ],
    "city": [
      "Prado",
      "Prado",
      "Prado"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CAU",
    "translations": [
      "Caruaru Airport",
      "Caruaru Airport",
      "Caruaru Airport"
    ],
    "city": [
      "Caruaru",
      "Caruaru",
      "Caruaru"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "OPP",
    "translations": [
      "Salinópolis Airport",
      "Salinópolis Airport",
      "Salinópolis Airport"
    ],
    "city": [
      "Salinópolis",
      "Salinópolis",
      "Salinópolis"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SFK",
    "translations": [
      "Soure Airport",
      "Soure Airport",
      "Soure Airport"
    ],
    "city": [
      "Soure",
      "Soure",
      "Soure"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TXF",
    "translations": [
      "9 de Maio - Teixeira de Freitas Airport",
      "9 de Maio - Teixeira de Freitas Airport",
      "9 de Maio - Teixeira de Freitas Airport"
    ],
    "city": [
      "Teixeira de Freitas",
      "Teixeira de Freitas",
      "Teixeira de Freitas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "OBI",
    "translations": [
      "Óbidos Municipal Airport",
      "Óbidos Municipal Airport",
      "Óbidos Municipal Airport"
    ],
    "city": [
      "Óbidos",
      "Óbidos",
      "Óbidos"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TFL",
    "translations": [
      "Juscelino Kubitscheck Airport",
      "Juscelino Kubitscheck Airport",
      "Juscelino Kubitscheck Airport"
    ],
    "city": [
      "Teófilo Otoni",
      "Teófilo Otoni",
      "Teófilo Otoni"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JPO",
    "translations": [
      "Aeroporto Brigadeiro Firmino Ayres",
      "Aeroporto Brigadeiro Firmino Ayres",
      "Aeroporto Brigadeiro Firmino Ayres"
    ],
    "city": [
      "Patos",
      "Patos",
      "Patos"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "AIY",
    "translations": [
      "Araçuaí Airport",
      "Araçuaí Airport",
      "Araçuaí Airport"
    ],
    "city": [
      "Araçuaí",
      "Araçuaí",
      "Araçuaí"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "VAL",
    "translations": [
      "Valença Airport",
      "Valença Airport",
      "Valença Airport"
    ],
    "city": [
      "Valença",
      "Valença",
      "Valença"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BVS",
    "translations": [
      "Breves Airport",
      "Breves Airport",
      "Breves Airport"
    ],
    "city": [
      "Breves",
      "Breves",
      "Breves"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CMC",
    "translations": [
      "Camocim - Pinto Martins Airport",
      "Camocim - Pinto Martins Airport",
      "Camocim - Pinto Martins Airport"
    ],
    "city": [
      "Camocim",
      "Camocim",
      "Camocim"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JCS",
    "translations": [
      "Crateús Airport",
      "Crateús Airport",
      "Crateús Airport"
    ],
    "city": [
      "Crateús",
      "Crateús",
      "Crateús"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GGF",
    "translations": [
      "Almeirim Airport",
      "Almeirim Airport",
      "Almeirim Airport"
    ],
    "city": [
      "Almeirim",
      "Almeirim",
      "Almeirim"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PHI",
    "translations": [
      "Pinheiro Airport",
      "Pinheiro Airport",
      "Pinheiro Airport"
    ],
    "city": [
      "Pinheiro",
      "Pinheiro",
      "Pinheiro"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GMS",
    "translations": [
      "Antônio Guerreiro Airport",
      "Antônio Guerreiro Airport",
      "Antônio Guerreiro Airport"
    ],
    "city": [
      "Guimarães",
      "Guimarães",
      "Guimarães"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PPY",
    "translations": [
      "Pouso Alegre Airport",
      "Pouso Alegre Airport",
      "Pouso Alegre Airport"
    ],
    "city": [
      "Pouso Alegre",
      "Pouso Alegre",
      "Pouso Alegre"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PYT",
    "translations": [
      "Pedro Rabelo de Souza Airport",
      "Pedro Rabelo de Souza Airport",
      "Pedro Rabelo de Souza Airport"
    ],
    "city": [
      "Paracatu",
      "Paracatu",
      "Paracatu"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ITE",
    "translations": [
      "Ituberá Airport",
      "Ituberá Airport",
      "Ituberá Airport"
    ],
    "city": [
      "Ituberá",
      "Ituberá",
      "Ituberá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "LKR",
    "translations": [
      "Las Khorey Airport",
      "Las Khorey Airport",
      "Las Khorey Airport"
    ],
    "city": [
      "Las Khorey",
      "Las Khorey",
      "Las Khorey"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "GUO",
    "translations": [
      "Guriel Airport",
      "Guriel Airport",
      "Guriel Airport"
    ],
    "city": [
      "Guriel",
      "Guriel",
      "Guriel"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "BXX",
    "translations": [
      "Borama Airport",
      "Borama Airport",
      "Borama Airport"
    ],
    "city": [
      "Borama",
      "Borama",
      "Borama"
    ],
    "country": [
      "SO",
      "SO",
      "SO"
    ]
  },
  {
    "iata": "SOA",
    "translations": [
      "Sóc Trăng Airport",
      "Sóc Trăng Airport",
      "Sóc Trăng Airport"
    ],
    "city": [
      "Sóc Trăng",
      "Sóc Trăng",
      "Sóc Trăng"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "CAY",
    "translations": [
      "Cayenne – Félix Eboué Airport",
      "Cayenne – Félix Eboué Airport",
      "Cayenne – Félix Eboué Airport"
    ],
    "city": [
      "Matoury",
      "Matoury",
      "Matoury"
    ],
    "country": [
      "GF",
      "GF",
      "GF"
    ]
  },
  {
    "iata": "GSI",
    "translations": [
      "Grand-Santi Airport",
      "Grand-Santi Airport",
      "Grand-Santi Airport"
    ],
    "city": [
      "Grand-Santi",
      "Grand-Santi",
      "Grand-Santi"
    ],
    "country": [
      "GF",
      "GF",
      "GF"
    ]
  },
  {
    "iata": "MPY",
    "translations": [
      "Maripasoula Airport",
      "Maripasoula Airport",
      "Maripasoula Airport"
    ],
    "city": [
      "Maripasoula",
      "Maripasoula",
      "Maripasoula"
    ],
    "country": [
      "GF",
      "GF",
      "GF"
    ]
  },
  {
    "iata": "OYP",
    "translations": [
      "Saint-Georges-de-l'Oyapock Airport",
      "Saint-Georges-de-l'Oyapock Airport",
      "Saint-Georges-de-l'Oyapock Airport"
    ],
    "city": [
      "Saint-Georges-de-l'Oyapock",
      "Saint-Georges-de-l'Oyapock",
      "Saint-Georges-de-l'Oyapock"
    ],
    "country": [
      "GF",
      "GF",
      "GF"
    ]
  },
  {
    "iata": "LDX",
    "translations": [
      "Saint-Laurent-du-Maroni Airport",
      "Saint-Laurent-du-Maroni Airport",
      "Saint-Laurent-du-Maroni Airport"
    ],
    "city": [
      "Saint-Laurent-du-Maroni",
      "Saint-Laurent-du-Maroni",
      "Saint-Laurent-du-Maroni"
    ],
    "country": [
      "GF",
      "GF",
      "GF"
    ]
  },
  {
    "iata": "REI",
    "translations": [
      "Régina Airport",
      "Régina Airport",
      "Régina Airport"
    ],
    "city": [
      "Régina",
      "Régina",
      "Régina"
    ],
    "country": [
      "GF",
      "GF",
      "GF"
    ]
  },
  {
    "iata": "XAU",
    "translations": [
      "Saül Airport",
      "Saül Airport",
      "Saül Airport"
    ],
    "city": [
      "Saül",
      "Saül",
      "Saül"
    ],
    "country": [
      "GF",
      "GF",
      "GF"
    ]
  },
  {
    "iata": "SOR",
    "translations": [
      "Al Thaurah Airport",
      "Al Thaurah Airport",
      "Al Thaurah Airport"
    ],
    "city": [
      "T2",
      "T2",
      "T2"
    ],
    "country": [
      "SY",
      "SY",
      "SY"
    ]
  },
  {
    "iata": "ALD",
    "translations": [
      "Alerta Airport",
      "Alerta Airport",
      "Alerta Airport"
    ],
    "city": [
      "Fortaleza",
      "Fortaleza",
      "Fortaleza"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "AOP",
    "translations": [
      "Alferez FAP Alfredo Vladimir Sara Bauer Airport",
      "Alferez FAP Alfredo Vladimir Sara Bauer Airport",
      "Alferez FAP Alfredo Vladimir Sara Bauer Airport"
    ],
    "city": [
      "Andoas",
      "Andoas",
      "Andoas"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "AYX",
    "translations": [
      "Teniente General Gerardo Pérez Pinedo Airport",
      "Teniente General Gerardo Pérez Pinedo Airport",
      "Teniente General Gerardo Pérez Pinedo Airport"
    ],
    "city": [
      "Atalaya",
      "Atalaya",
      "Atalaya"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "MBP",
    "translations": [
      "Moyobamba Airport",
      "Moyobamba Airport",
      "Moyobamba Airport"
    ],
    "city": [
      "Moyobamba",
      "Moyobamba",
      "Moyobamba"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "IBP",
    "translations": [
      "Iberia Airport",
      "Iberia Airport",
      "Iberia Airport"
    ],
    "city": [
      "Iberia",
      "Iberia",
      "Iberia"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "PCL",
    "translations": [
      "Cap FAP David Abenzur Rengifo International Airport",
      "Cap FAP David Abenzur Rengifo International Airport",
      "Cap FAP David Abenzur Rengifo International Airport"
    ],
    "city": [
      "Pucallpa",
      "Pucallpa",
      "Pucallpa"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "TDP",
    "translations": [
      "Trompeteros Airport",
      "Trompeteros Airport",
      "Trompeteros Airport"
    ],
    "city": [
      "Corrientes",
      "Corrientes",
      "Corrientes"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "CHM",
    "translations": [
      "FAP Lieutenant Jaime Andres de Montreuil Morales Airport",
      "FAP Lieutenant Jaime Andres de Montreuil Morales Airport",
      "FAP Lieutenant Jaime Andres de Montreuil Morales Airport"
    ],
    "city": [
      "Chimbote",
      "Chimbote",
      "Chimbote"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "CGL",
    "translations": [
      "Chagual Airport",
      "Chagual Airport",
      "Chagual Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "TGI",
    "translations": [
      "Tingo Maria Airport",
      "Tingo Maria Airport",
      "Tingo Maria Airport"
    ],
    "city": [
      "Tingo Maria",
      "Tingo Maria",
      "Tingo Maria"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "CIX",
    "translations": [
      "Air Force Captain Jose A Quinones Gonzales International Airport",
      "Air Force Captain Jose A Quinones Gonzales International Airport",
      "Air Force Captain Jose A Quinones Gonzales International Airport"
    ],
    "city": [
      "Chiclayo",
      "Chiclayo",
      "Chiclayo"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "AYP",
    "translations": [
      "Air Force Colonel Alfredo Mendivil Duarte Airport",
      "Air Force Colonel Alfredo Mendivil Duarte Airport",
      "Air Force Colonel Alfredo Mendivil Duarte Airport"
    ],
    "city": [
      "Ayacucho",
      "Ayacucho",
      "Ayacucho"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "ANS",
    "translations": [
      "Andahuaylas Airport",
      "Andahuaylas Airport",
      "Andahuaylas Airport"
    ],
    "city": [
      "Andahuaylas",
      "Andahuaylas",
      "Andahuaylas"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "ATA",
    "translations": [
      "Comandante FAP German Arias Graziani Airport",
      "Comandante FAP German Arias Graziani Airport",
      "Comandante FAP German Arias Graziani Airport"
    ],
    "city": [
      "Anta",
      "Anta",
      "Anta"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "UMI",
    "translations": [
      "Quincemil Air Base",
      "Quincemil Air Base",
      "Quincemil Air Base"
    ],
    "city": [
      "Quince Mil",
      "Quince Mil",
      "Quince Mil"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "LIM",
    "translations": [
      "Jorge Chávez International Airport",
      "Jorge Chávez International Airport",
      "Jorge Chávez International Airport"
    ],
    "city": [
      "Lima",
      "Lima",
      "Lima"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "UCZ",
    "translations": [
      "Uchiza Airport",
      "Uchiza Airport",
      "Uchiza Airport"
    ],
    "city": [
      "Uchiza",
      "Uchiza",
      "Uchiza"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "RIJ",
    "translations": [
      "Juan Simons Vela Airport",
      "Juan Simons Vela Airport",
      "Juan Simons Vela Airport"
    ],
    "city": [
      "Rioja",
      "Rioja",
      "Rioja"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "JAE",
    "translations": [
      "Shumba Airport",
      "Shumba Airport",
      "Shumba Airport"
    ],
    "city": [
      "Jaén",
      "Jaén",
      "Jaén"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "JJI",
    "translations": [
      "Juanjui Airport",
      "Juanjui Airport",
      "Juanjui Airport"
    ],
    "city": [
      "Juanjuí",
      "Juanjuí",
      "Juanjuí"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "JAU",
    "translations": [
      "Francisco Carle Airport",
      "Francisco Carle Airport",
      "Francisco Carle Airport"
    ],
    "city": [
      "Jauja",
      "Jauja",
      "Jauja"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "JUL",
    "translations": [
      "Inca Manco Capac International Airport",
      "Inca Manco Capac International Airport",
      "Inca Manco Capac International Airport"
    ],
    "city": [
      "Juliaca",
      "Juliaca",
      "Juliaca"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "SJA",
    "translations": [
      "San Juan de Marcona Airport",
      "San Juan de Marcona Airport",
      "San Juan de Marcona Airport"
    ],
    "city": [
      "San Juan de Marcona",
      "San Juan de Marcona",
      "San Juan de Marcona"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "CJA",
    "translations": [
      "Mayor General FAP Armando Revoredo Iglesias Airport",
      "Mayor General FAP Armando Revoredo Iglesias Airport",
      "Mayor General FAP Armando Revoredo Iglesias Airport"
    ],
    "city": [
      "Cajamarca",
      "Cajamarca",
      "Cajamarca"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "RIM",
    "translations": [
      "San Nicolas Airport",
      "San Nicolas Airport",
      "San Nicolas Airport"
    ],
    "city": [
      "Rodriguez de Mendoza",
      "Rodriguez de Mendoza",
      "Rodriguez de Mendoza"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "ILQ",
    "translations": [
      "General Jorge Fernandez Maldon Airport",
      "General Jorge Fernandez Maldon Airport",
      "General Jorge Fernandez Maldon Airport"
    ],
    "city": [
      "Ilo",
      "Ilo",
      "Ilo"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "TBP",
    "translations": [
      "Captain Pedro Canga Rodríguez International Airport",
      "Captain Pedro Canga Rodríguez International Airport",
      "Captain Pedro Canga Rodríguez International Airport"
    ],
    "city": [
      "Tumbes",
      "Tumbes",
      "Tumbes"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "MZA",
    "translations": [
      "Mayor PNP Nancy Flores Paucar Airport",
      "Mayor PNP Nancy Flores Paucar Airport",
      "Mayor PNP Nancy Flores Paucar Airport"
    ],
    "city": [
      "Mazamari",
      "Mazamari",
      "Mazamari"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "YMS",
    "translations": [
      "Moises Benzaquen Rengifo Airport",
      "Moises Benzaquen Rengifo Airport",
      "Moises Benzaquen Rengifo Airport"
    ],
    "city": [
      "Yurimaguas",
      "Yurimaguas",
      "Yurimaguas"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "HUU",
    "translations": [
      "Alferez Fap David Figueroa Fernandini Airport",
      "Alferez Fap David Figueroa Fernandini Airport",
      "Alferez Fap David Figueroa Fernandini Airport"
    ],
    "city": [
      "Huánuco",
      "Huánuco",
      "Huánuco"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "SQU",
    "translations": [
      "Saposoa Airport",
      "Saposoa Airport",
      "Saposoa Airport"
    ],
    "city": [
      "Plaza Saposoa",
      "Plaza Saposoa",
      "Plaza Saposoa"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "CHH",
    "translations": [
      "Chachapoyas Airport",
      "Chachapoyas Airport",
      "Chachapoyas Airport"
    ],
    "city": [
      "Chachapoyas",
      "Chachapoyas",
      "Chachapoyas"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "IQT",
    "translations": [
      "Coronel FAP Francisco Secada Vignetta International Airport",
      "Coronel FAP Francisco Secada Vignetta International Airport",
      "Coronel FAP Francisco Secada Vignetta International Airport"
    ],
    "city": [
      "Iquitos",
      "Iquitos",
      "Iquitos"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "AQP",
    "translations": [
      "Rodríguez Ballón International Airport",
      "Rodríguez Ballón International Airport",
      "Rodríguez Ballón International Airport"
    ],
    "city": [
      "Arequipa",
      "Arequipa",
      "Arequipa"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "TRU",
    "translations": [
      "Capitan FAP Carlos Martinez De Pinillos International Airport",
      "Capitan FAP Carlos Martinez De Pinillos International Airport",
      "Capitan FAP Carlos Martinez De Pinillos International Airport"
    ],
    "city": [
      "Trujillo",
      "Trujillo",
      "Trujillo"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "PIO",
    "translations": [
      "Captain Renán Elías Olivera International Airport",
      "Captain Renán Elías Olivera International Airport",
      "Captain Renán Elías Olivera International Airport"
    ],
    "city": [
      "Pisco",
      "Pisco",
      "Pisco"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "TPP",
    "translations": [
      "Cadete FAP Guillermo Del Castillo Paredes Airport",
      "Cadete FAP Guillermo Del Castillo Paredes Airport",
      "Cadete FAP Guillermo Del Castillo Paredes Airport"
    ],
    "city": [
      "Tarapoto",
      "Tarapoto",
      "Tarapoto"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "SYC",
    "translations": [
      "Shiringayoc Airport",
      "Shiringayoc Airport",
      "Shiringayoc Airport"
    ],
    "city": [
      "Shiringayoc",
      "Shiringayoc",
      "Shiringayoc"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "TCQ",
    "translations": [
      "Coronel FAP Carlos Ciriani Santa Rosa International Airport",
      "Coronel FAP Carlos Ciriani Santa Rosa International Airport",
      "Coronel FAP Carlos Ciriani Santa Rosa International Airport"
    ],
    "city": [
      "Tacna",
      "Tacna",
      "Tacna"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "PEM",
    "translations": [
      "Padre Aldamiz International Airport",
      "Padre Aldamiz International Airport",
      "Padre Aldamiz International Airport"
    ],
    "city": [
      "Puerto Maldonado",
      "Puerto Maldonado",
      "Puerto Maldonado"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "PIU",
    "translations": [
      "Capitán FAP Guillermo Concha Iberico International Airport",
      "Capitán FAP Guillermo Concha Iberico International Airport",
      "Capitán FAP Guillermo Concha Iberico International Airport"
    ],
    "city": [
      "Piura",
      "Piura",
      "Piura"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "TYL",
    "translations": [
      "Captain Victor Montes Arias International Airport",
      "Captain Victor Montes Arias International Airport",
      "Captain Victor Montes Arias International Airport"
    ],
    "city": [
      "Talara",
      "Talara",
      "Talara"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "NZC",
    "translations": [
      "Maria Reiche Neuman Airport",
      "Maria Reiche Neuman Airport",
      "Maria Reiche Neuman Airport"
    ],
    "city": [
      "Nazca",
      "Nazca",
      "Nazca"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "CUZ",
    "translations": [
      "Alejandro Velasco Astete International Airport",
      "Alejandro Velasco Astete International Airport",
      "Alejandro Velasco Astete International Airport"
    ],
    "city": [
      "Cusco",
      "Cusco",
      "Cusco"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "EAX",
    "translations": [
      "Eduard Alexander Gummels Airport",
      "Eduard Alexander Gummels Airport",
      "Eduard Alexander Gummels Airport"
    ],
    "city": [
      "Kwatta",
      "Kwatta",
      "Kwatta"
    ],
    "country": [
      "SR",
      "SR",
      "SR"
    ]
  },
  {
    "iata": "SRL",
    "translations": [
      "Palo Verde Airport",
      "Palo Verde Airport",
      "Palo Verde Airport"
    ],
    "city": [
      "Mulegé",
      "Mulegé",
      "Mulegé"
    ],
    "country": [
      "MX",
      "MX",
      "MX"
    ]
  },
  {
    "iata": "SRM",
    "translations": [
      "Sandringham Airport",
      "Sandringham Airport",
      "Sandringham Airport"
    ],
    "city": [
      "Sandringham Station",
      "Sandringham Station",
      "Sandringham Station"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SRV",
    "translations": [
      "Stony River 2 Airport",
      "Stony River 2 Airport",
      "Stony River 2 Airport"
    ],
    "city": [
      "Stony River",
      "Stony River",
      "Stony River"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CZB",
    "translations": [
      "Carlos Ruhl Airport",
      "Carlos Ruhl Airport",
      "Carlos Ruhl Airport"
    ],
    "city": [
      "Cruz Alta",
      "Cruz Alta",
      "Cruz Alta"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "APU",
    "translations": [
      "Captain João Busse Airport",
      "Captain João Busse Airport",
      "Captain João Busse Airport"
    ],
    "city": [
      "Apucarana",
      "Apucarana",
      "Apucarana"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BGV",
    "translations": [
      "Aeroclube de Bento Gonçalves Airport",
      "Aeroclube de Bento Gonçalves Airport",
      "Aeroclube de Bento Gonçalves Airport"
    ],
    "city": [
      "Bento Gonçalves",
      "Bento Gonçalves",
      "Bento Gonçalves"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BNU",
    "translations": [
      "Blumenau Airport",
      "Blumenau Airport",
      "Blumenau Airport"
    ],
    "city": [
      "Blumenau",
      "Blumenau",
      "Blumenau"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CCI",
    "translations": [
      "Olavo Cecco Rigon Airport",
      "Olavo Cecco Rigon Airport",
      "Olavo Cecco Rigon Airport"
    ],
    "city": [
      "Concórdia",
      "Concórdia",
      "Concórdia"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CSS",
    "translations": [
      "Cassilândia Airport",
      "Cassilândia Airport",
      "Cassilândia Airport"
    ],
    "city": [
      "Cassilândia",
      "Cassilândia",
      "Cassilândia"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CEL",
    "translations": [
      "Canela Airport",
      "Canela Airport",
      "Canela Airport"
    ],
    "city": [
      "Canela",
      "Canela",
      "Canela"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CKO",
    "translations": [
      "Cornélio Procópio Airport",
      "Cornélio Procópio Airport",
      "Cornélio Procópio Airport"
    ],
    "city": [
      "Cornélio Procópio",
      "Cornélio Procópio",
      "Cornélio Procópio"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GGH",
    "translations": [
      "Engenheiro Gastão de Mesquita Filho Airport",
      "Engenheiro Gastão de Mesquita Filho Airport",
      "Engenheiro Gastão de Mesquita Filho Airport"
    ],
    "city": [
      "Cianorte",
      "Cianorte",
      "Cianorte"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ERM",
    "translations": [
      "Erechim Airport",
      "Erechim Airport",
      "Erechim Airport"
    ],
    "city": [
      "Erechim",
      "Erechim",
      "Erechim"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "FBE",
    "translations": [
      "Paulo Abdala Airport",
      "Paulo Abdala Airport",
      "Paulo Abdala Airport"
    ],
    "city": [
      "Francisco Beltrão",
      "Francisco Beltrão",
      "Francisco Beltrão"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GGJ",
    "translations": [
      "Guaíra Airport",
      "Guaíra Airport",
      "Guaíra Airport"
    ],
    "city": [
      "Guaíra",
      "Guaíra",
      "Guaíra"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "HRZ",
    "translations": [
      "Walter Bündchen Airport",
      "Walter Bündchen Airport",
      "Walter Bündchen Airport"
    ],
    "city": [
      "Horizontina",
      "Horizontina",
      "Horizontina"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "IJU",
    "translations": [
      "João Batista Bos Filho Airport",
      "João Batista Bos Filho Airport",
      "João Batista Bos Filho Airport"
    ],
    "city": [
      "Ijuí",
      "Ijuí",
      "Ijuí"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ITQ",
    "translations": [
      "Itaqui Airport",
      "Itaqui Airport",
      "Itaqui Airport"
    ],
    "city": [
      "Itaqui",
      "Itaqui",
      "Itaqui"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JCB",
    "translations": [
      "Santa Terezinha Airport",
      "Santa Terezinha Airport",
      "Santa Terezinha Airport"
    ],
    "city": [
      "Joaçaba",
      "Joaçaba",
      "Joaçaba"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CBW",
    "translations": [
      "Campo Mourão Airport",
      "Campo Mourão Airport",
      "Campo Mourão Airport"
    ],
    "city": [
      "Campo Mourão",
      "Campo Mourão",
      "Campo Mourão"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "QDB",
    "translations": [
      "Cachoeira do Sul Airport",
      "Cachoeira do Sul Airport",
      "Cachoeira do Sul Airport"
    ],
    "city": [
      "Cachoeira Do Sul",
      "Cachoeira Do Sul",
      "Cachoeira Do Sul"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "OAL",
    "translations": [
      "Cacoal Airport",
      "Cacoal Airport",
      "Cacoal Airport"
    ],
    "city": [
      "Cacoal",
      "Cacoal",
      "Cacoal"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "LOI",
    "translations": [
      "Helmuth Baungarten Airport",
      "Helmuth Baungarten Airport",
      "Helmuth Baungarten Airport"
    ],
    "city": [
      "Lontras",
      "Lontras",
      "Lontras"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ALQ",
    "translations": [
      "Alegrete Novo Airport",
      "Alegrete Novo Airport",
      "Alegrete Novo Airport"
    ],
    "city": [
      "Alegrete",
      "Alegrete",
      "Alegrete"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "QGF",
    "translations": [
      "Montenegro Airport",
      "Montenegro Airport",
      "Montenegro Airport"
    ],
    "city": [
      "Montenegro",
      "Montenegro",
      "Montenegro"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "QHV",
    "translations": [
      "Novo Hamburgo Airport",
      "Novo Hamburgo Airport",
      "Novo Hamburgo Airport"
    ],
    "city": [
      "Novo Hamburgo",
      "Novo Hamburgo",
      "Novo Hamburgo"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SQX",
    "translations": [
      "São Miguel do Oeste Hélio Wasum Airport",
      "São Miguel do Oeste Hélio Wasum Airport",
      "São Miguel do Oeste Hélio Wasum Airport"
    ],
    "city": [
      "São Miguel do Oeste",
      "São Miguel do Oeste",
      "São Miguel do Oeste"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "APX",
    "translations": [
      "Arapongas Airport",
      "Arapongas Airport",
      "Arapongas Airport"
    ],
    "city": [
      "Arapongas",
      "Arapongas",
      "Arapongas"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "VRZ",
    "translations": [
      "Padre Israel Airport",
      "Padre Israel Airport",
      "Padre Israel Airport"
    ],
    "city": [
      "Lavras",
      "Lavras",
      "Lavras"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "AIR",
    "translations": [
      "Aripuanã Airport",
      "Aripuanã Airport",
      "Aripuanã Airport"
    ],
    "city": [
      "Aripuanã",
      "Aripuanã",
      "Aripuanã"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PNG",
    "translations": [
      "Paranaguá Airport",
      "Paranaguá Airport",
      "Paranaguá Airport"
    ],
    "city": [
      "Paranaguá",
      "Paranaguá",
      "Paranaguá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PVI",
    "translations": [
      "Paranavaí Airport",
      "Paranavaí Airport",
      "Paranavaí Airport"
    ],
    "city": [
      "Paranavaí",
      "Paranavaí",
      "Paranavaí"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PBB",
    "translations": [
      "Paranaíba Airport",
      "Paranaíba Airport",
      "Paranaíba Airport"
    ],
    "city": [
      "Paranaíba",
      "Paranaíba",
      "Paranaíba"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SQY",
    "translations": [
      "São Lourenço do Sul Airport",
      "São Lourenço do Sul Airport",
      "São Lourenço do Sul Airport"
    ],
    "city": [
      "São Lourenço Do Sul",
      "São Lourenço Do Sul",
      "São Lourenço Do Sul"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SSS",
    "translations": [
      "Siassi Airport",
      "Siassi Airport",
      "Siassi Airport"
    ],
    "city": [
      "Siassi",
      "Siassi",
      "Siassi"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "JBS",
    "translations": [
      "São Borja Airport",
      "São Borja Airport",
      "São Borja Airport"
    ],
    "city": [
      "São Borja",
      "São Borja",
      "São Borja"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CSU",
    "translations": [
      "Santa Cruz do Sul Airport",
      "Santa Cruz do Sul Airport",
      "Santa Cruz do Sul Airport"
    ],
    "city": [
      "Santa Cruz Do Sul",
      "Santa Cruz Do Sul",
      "Santa Cruz Do Sul"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "UMU",
    "translations": [
      "Orlando de Carvalho Airport",
      "Orlando de Carvalho Airport",
      "Orlando de Carvalho Airport"
    ],
    "city": [
      "Umuarama",
      "Umuarama",
      "Umuarama"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ZFU",
    "translations": [
      "Unifly Heliport",
      "Unifly Heliport",
      "Unifly Heliport"
    ],
    "city": [
      "Arujá",
      "Arujá",
      "Arujá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "UVI",
    "translations": [
      "José Cleto Airport",
      "José Cleto Airport",
      "José Cleto Airport"
    ],
    "city": [
      "União da Vitória",
      "União da Vitória",
      "União da Vitória"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "VIA",
    "translations": [
      "Videira Airport",
      "Videira Airport",
      "Videira Airport"
    ],
    "city": [
      "Videira",
      "Videira",
      "Videira"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BMS",
    "translations": [
      "Sócrates Mariani Bittencourt Airport",
      "Sócrates Mariani Bittencourt Airport",
      "Sócrates Mariani Bittencourt Airport"
    ],
    "city": [
      "Brumado",
      "Brumado",
      "Brumado"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "AXE",
    "translations": [
      "Xanxerê Airport",
      "Xanxerê Airport",
      "Xanxerê Airport"
    ],
    "city": [
      "Xanxerê",
      "Xanxerê",
      "Xanxerê"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SRA",
    "translations": [
      "Luis Alberto Lehr Airport",
      "Luis Alberto Lehr Airport",
      "Luis Alberto Lehr Airport"
    ],
    "city": [
      "Santa Rosa",
      "Santa Rosa",
      "Santa Rosa"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ATI",
    "translations": [
      "Artigas International Airport",
      "Artigas International Airport",
      "Artigas International Airport"
    ],
    "city": [
      "Artigas",
      "Artigas",
      "Artigas"
    ],
    "country": [
      "UY",
      "UY",
      "UY"
    ]
  },
  {
    "iata": "BUV",
    "translations": [
      "Placeres Airport",
      "Placeres Airport",
      "Placeres Airport"
    ],
    "city": [
      "Bella Union",
      "Bella Union",
      "Bella Union"
    ],
    "country": [
      "UY",
      "UY",
      "UY"
    ]
  },
  {
    "iata": "CYR",
    "translations": [
      "Colonia Laguna de Los Patos International Airport",
      "Colonia Laguna de Los Patos International Airport",
      "Colonia Laguna de Los Patos International Airport"
    ],
    "city": [
      "Colonia del Sacramento",
      "Colonia del Sacramento",
      "Colonia del Sacramento"
    ],
    "country": [
      "UY",
      "UY",
      "UY"
    ]
  },
  {
    "iata": "DZO",
    "translations": [
      "Santa Bernardina International Airport",
      "Santa Bernardina International Airport",
      "Santa Bernardina International Airport"
    ],
    "city": [
      "Durazno",
      "Durazno",
      "Durazno"
    ],
    "country": [
      "UY",
      "UY",
      "UY"
    ]
  },
  {
    "iata": "PDP",
    "translations": [
      "Capitan Corbeta CA Curbelo International Airport",
      "Capitan Corbeta CA Curbelo International Airport",
      "Capitan Corbeta CA Curbelo International Airport"
    ],
    "city": [
      "Punta del Este",
      "Punta del Este",
      "Punta del Este"
    ],
    "country": [
      "UY",
      "UY",
      "UY"
    ]
  },
  {
    "iata": "MLZ",
    "translations": [
      "Cerro Largo International Airport",
      "Cerro Largo International Airport",
      "Cerro Largo International Airport"
    ],
    "city": [
      "Melo",
      "Melo",
      "Melo"
    ],
    "country": [
      "UY",
      "UY",
      "UY"
    ]
  },
  {
    "iata": "MVD",
    "translations": [
      "Carrasco General Cesáreo L. Berisso International Airport",
      "Carrasco General Cesáreo L. Berisso International Airport",
      "Carrasco General Cesáreo L. Berisso International Airport"
    ],
    "city": [
      "Ciudad de la Costa",
      "Ciudad de la Costa",
      "Ciudad de la Costa"
    ],
    "country": [
      "UY",
      "UY",
      "UY"
    ]
  },
  {
    "iata": "PDU",
    "translations": [
      "Tydeo Larre Borges Airport",
      "Tydeo Larre Borges Airport",
      "Tydeo Larre Borges Airport"
    ],
    "city": [
      "Paysandú",
      "Paysandú",
      "Paysandú"
    ],
    "country": [
      "UY",
      "UY",
      "UY"
    ]
  },
  {
    "iata": "RVY",
    "translations": [
      "Presidente General Don Oscar D. Gestido International Airport",
      "Presidente General Don Oscar D. Gestido International Airport",
      "Presidente General Don Oscar D. Gestido International Airport"
    ],
    "city": [
      "Rivera",
      "Rivera",
      "Rivera"
    ],
    "country": [
      "UY",
      "UY",
      "UY"
    ]
  },
  {
    "iata": "STY",
    "translations": [
      "Nueva Hesperides International Airport",
      "Nueva Hesperides International Airport",
      "Nueva Hesperides International Airport"
    ],
    "city": [
      "Salto",
      "Salto",
      "Salto"
    ],
    "country": [
      "UY",
      "UY",
      "UY"
    ]
  },
  {
    "iata": "TAW",
    "translations": [
      "Tacuarembo Airport",
      "Tacuarembo Airport",
      "Tacuarembo Airport"
    ],
    "city": [
      "Tacuarembo",
      "Tacuarembo",
      "Tacuarembo"
    ],
    "country": [
      "UY",
      "UY",
      "UY"
    ]
  },
  {
    "iata": "TYT",
    "translations": [
      "Treinta y Tres Airport",
      "Treinta y Tres Airport",
      "Treinta y Tres Airport"
    ],
    "city": [
      "Treinta y Tres",
      "Treinta y Tres",
      "Treinta y Tres"
    ],
    "country": [
      "UY",
      "UY",
      "UY"
    ]
  },
  {
    "iata": "VCH",
    "translations": [
      "Vichadero Airport",
      "Vichadero Airport",
      "Vichadero Airport"
    ],
    "city": [
      "Vichadero",
      "Vichadero",
      "Vichadero"
    ],
    "country": [
      "UY",
      "UY",
      "UY"
    ]
  },
  {
    "iata": "AGV",
    "translations": [
      "Oswaldo Guevara Mujica Airport",
      "Oswaldo Guevara Mujica Airport",
      "Oswaldo Guevara Mujica Airport"
    ],
    "city": [
      "Acarigua",
      "Acarigua",
      "Acarigua"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "AAO",
    "translations": [
      "Anaco Airport",
      "Anaco Airport",
      "Anaco Airport"
    ],
    "city": [
      "Anaco",
      "Anaco",
      "Anaco"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "LPJ",
    "translations": [
      "Armando Schwarck Airport",
      "Armando Schwarck Airport",
      "Armando Schwarck Airport"
    ],
    "city": [
      "Guayabal",
      "Guayabal",
      "Guayabal"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "BLA",
    "translations": [
      "General José Antonio Anzoategui International Airport",
      "General José Antonio Anzoategui International Airport",
      "General José Antonio Anzoategui International Airport"
    ],
    "city": [
      "Barcelona",
      "Barcelona",
      "Barcelona"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "BNS",
    "translations": [
      "Barinas Airport",
      "Barinas Airport",
      "Barinas Airport"
    ],
    "city": [
      "Barinas",
      "Barinas",
      "Barinas"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "BRM",
    "translations": [
      "Barquisimeto International Airport",
      "Barquisimeto International Airport",
      "Barquisimeto International Airport"
    ],
    "city": [
      "Barquisimeto",
      "Barquisimeto",
      "Barquisimeto"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "MYC",
    "translations": [
      "Escuela Mariscal Sucre Airport",
      "Escuela Mariscal Sucre Airport",
      "Escuela Mariscal Sucre Airport"
    ],
    "city": [
      "Maracay",
      "Maracay",
      "Maracay"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "CBL",
    "translations": [
      "General Tomas de Heres Airport",
      "General Tomas de Heres Airport",
      "General Tomas de Heres Airport"
    ],
    "city": [
      "Ciudad Bolivar",
      "Ciudad Bolivar",
      "Ciudad Bolivar"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "CXA",
    "translations": [
      "Caicara del Orinoco Airport",
      "Caicara del Orinoco Airport",
      "Caicara del Orinoco Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "ZRZ",
    "translations": [
      "Zaraza Airport",
      "Zaraza Airport",
      "Zaraza Airport"
    ],
    "city": [
      "Zaraza",
      "Zaraza",
      "Zaraza"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "CUV",
    "translations": [
      "Casigua El Cubo Airport",
      "Casigua El Cubo Airport",
      "Casigua El Cubo Airport"
    ],
    "city": [
      "Casigua El Cubo",
      "Casigua El Cubo",
      "Casigua El Cubo"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "CLZ",
    "translations": [
      "Calabozo Airport",
      "Calabozo Airport",
      "Calabozo Airport"
    ],
    "city": [
      "Guarico",
      "Guarico",
      "Guarico"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "CAJ",
    "translations": [
      "Canaima Airport",
      "Canaima Airport",
      "Canaima Airport"
    ],
    "city": [
      "Canaima",
      "Canaima",
      "Canaima"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "CUP",
    "translations": [
      "General Francisco Bermúdez Airport",
      "General Francisco Bermúdez Airport",
      "General Francisco Bermúdez Airport"
    ],
    "city": [
      "Carúpano",
      "Carúpano",
      "Carúpano"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "CZE",
    "translations": [
      "José Leonardo Chirinos Airport",
      "José Leonardo Chirinos Airport",
      "José Leonardo Chirinos Airport"
    ],
    "city": [
      "Coro",
      "Coro",
      "Coro"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "CUM",
    "translations": [
      "Cumaná (Antonio José de Sucre) Airport",
      "Cumaná (Antonio José de Sucre) Airport",
      "Cumaná (Antonio José de Sucre) Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "PPZ",
    "translations": [
      "Puerto Paez Airport",
      "Puerto Paez Airport",
      "Puerto Paez Airport"
    ],
    "city": [
      "Puerto Paez",
      "Puerto Paez",
      "Puerto Paez"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "EOR",
    "translations": [
      "El Dorado Airport",
      "El Dorado Airport",
      "El Dorado Airport"
    ],
    "city": [
      "Bolivar",
      "Bolivar",
      "Bolivar"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "EOZ",
    "translations": [
      "Elorza Airport",
      "Elorza Airport",
      "Elorza Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "GDO",
    "translations": [
      "Guasdualito Airport",
      "Guasdualito Airport",
      "Guasdualito Airport"
    ],
    "city": [
      "Guasdualito",
      "Guasdualito",
      "Guasdualito"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "GUI",
    "translations": [
      "Guiria Airport",
      "Guiria Airport",
      "Guiria Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "GUQ",
    "translations": [
      "Guanare Airport",
      "Guanare Airport",
      "Guanare Airport"
    ],
    "city": [
      "Guanare",
      "Guanare",
      "Guanare"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "HGE",
    "translations": [
      "Higuerote Airport",
      "Higuerote Airport",
      "Higuerote Airport"
    ],
    "city": [
      "Higuerote",
      "Higuerote",
      "Higuerote"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "ICA",
    "translations": [
      "Icabarú Airport",
      "Icabarú Airport",
      "Icabarú Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "ICC",
    "translations": [
      "Andrés Miguel Salazar Marcano Airport",
      "Andrés Miguel Salazar Marcano Airport",
      "Andrés Miguel Salazar Marcano Airport"
    ],
    "city": [
      "Isla de Coche",
      "Isla de Coche",
      "Isla de Coche"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "LSP",
    "translations": [
      "Josefa Camejo International Airport",
      "Josefa Camejo International Airport",
      "Josefa Camejo International Airport"
    ],
    "city": [
      "Paraguaná",
      "Paraguaná",
      "Paraguaná"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "KAV",
    "translations": [
      "Kavanayen Airport",
      "Kavanayen Airport",
      "Kavanayen Airport"
    ],
    "city": [
      "Kavanayén",
      "Kavanayén",
      "Kavanayén"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "KTV",
    "translations": [
      "Kamarata Airport",
      "Kamarata Airport",
      "Kamarata Airport"
    ],
    "city": [
      "Kamarata",
      "Kamarata",
      "Kamarata"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "LFR",
    "translations": [
      "La Fria Airport",
      "La Fria Airport",
      "La Fria Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "MAR",
    "translations": [
      "La Chinita International Airport",
      "La Chinita International Airport",
      "La Chinita International Airport"
    ],
    "city": [
      "Maracaibo",
      "Maracaibo",
      "Maracaibo"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "MRD",
    "translations": [
      "Alberto Carnevalli Airport",
      "Alberto Carnevalli Airport",
      "Alberto Carnevalli Airport"
    ],
    "city": [
      "Mérida",
      "Mérida",
      "Mérida"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "PMV",
    "translations": [
      "Del Caribe Santiago Mariño International Airport",
      "Del Caribe Santiago Mariño International Airport",
      "Del Caribe Santiago Mariño International Airport"
    ],
    "city": [
      "Isla Margarita",
      "Isla Margarita",
      "Isla Margarita"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "CCS",
    "translations": [
      "Maiquetía Simón Bolívar International Airport",
      "Maiquetía Simón Bolívar International Airport",
      "Maiquetía Simón Bolívar International Airport"
    ],
    "city": [
      "Maiquetía",
      "Maiquetía",
      "Maiquetía"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "MUN",
    "translations": [
      "José Tadeo Monagas International Airport",
      "José Tadeo Monagas International Airport",
      "José Tadeo Monagas International Airport"
    ],
    "city": [
      "Maturín",
      "Maturín",
      "Maturín"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "CBS",
    "translations": [
      "Oro Negro Airport",
      "Oro Negro Airport",
      "Oro Negro Airport"
    ],
    "city": [
      "Cabimas",
      "Cabimas",
      "Cabimas"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "PYH",
    "translations": [
      "Cacique Aramare Airport",
      "Cacique Aramare Airport",
      "Cacique Aramare Airport"
    ],
    "city": [
      "Puerto Ayacucho",
      "Puerto Ayacucho",
      "Puerto Ayacucho"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "PBL",
    "translations": [
      "General Bartolome Salom International Airport",
      "General Bartolome Salom International Airport",
      "General Bartolome Salom International Airport"
    ],
    "city": [
      "Puerto Cabello",
      "Puerto Cabello",
      "Puerto Cabello"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "PDZ",
    "translations": [
      "Pedernales Airport",
      "Pedernales Airport",
      "Pedernales Airport"
    ],
    "city": [
      "Capure",
      "Capure",
      "Capure"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "PPH",
    "translations": [
      "Perai-Tepuy Airport",
      "Perai-Tepuy Airport",
      "Perai-Tepuy Airport"
    ],
    "city": [
      "Parai-tepuí",
      "Parai-tepuí",
      "Parai-tepuí"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "SCI",
    "translations": [
      "Paramillo Airport",
      "Paramillo Airport",
      "Paramillo Airport"
    ],
    "city": [
      "San Cristóbal",
      "San Cristóbal",
      "San Cristóbal"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "PZO",
    "translations": [
      "General Manuel Carlos Piar International Airport",
      "General Manuel Carlos Piar International Airport",
      "General Manuel Carlos Piar International Airport"
    ],
    "city": [
      "Puerto Ordaz-Ciudad Guayana",
      "Puerto Ordaz-Ciudad Guayana",
      "Puerto Ordaz-Ciudad Guayana"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "PTM",
    "translations": [
      "Palmarito Airport",
      "Palmarito Airport",
      "Palmarito Airport"
    ],
    "city": [
      "Palmarito",
      "Palmarito",
      "Palmarito"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "LRV",
    "translations": [
      "Los Roques Airport",
      "Los Roques Airport",
      "Los Roques Airport"
    ],
    "city": [
      "Gran Roque Island",
      "Gran Roque Island",
      "Gran Roque Island"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "SVS",
    "translations": [
      "Stevens Village Airport",
      "Stevens Village Airport",
      "Stevens Village Airport"
    ],
    "city": [
      "Stevens Village",
      "Stevens Village",
      "Stevens Village"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SVZ",
    "translations": [
      "San Antonio Del Tachira Airport",
      "San Antonio Del Tachira Airport",
      "San Antonio Del Tachira Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "SBB",
    "translations": [
      "Santa Bárbara de Barinas Airport",
      "Santa Bárbara de Barinas Airport",
      "Santa Bárbara de Barinas Airport"
    ],
    "city": [
      "Santa Bárbara",
      "Santa Bárbara",
      "Santa Bárbara"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "SNV",
    "translations": [
      "Santa Elena de Uairen Airport",
      "Santa Elena de Uairen Airport",
      "Santa Elena de Uairen Airport"
    ],
    "city": [
      "Santa Elena de Uairén",
      "Santa Elena de Uairén",
      "Santa Elena de Uairén"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "STD",
    "translations": [
      "Mayor Buenaventura Vivas International Airport",
      "Mayor Buenaventura Vivas International Airport",
      "Mayor Buenaventura Vivas International Airport"
    ],
    "city": [
      "Santo Domingo",
      "Santo Domingo",
      "Santo Domingo"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "SNF",
    "translations": [
      "Sub Teniente Nestor Arias Airport",
      "Sub Teniente Nestor Arias Airport",
      "Sub Teniente Nestor Arias Airport"
    ],
    "city": [
      "San Felipe",
      "San Felipe",
      "San Felipe"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "SFD",
    "translations": [
      "San Fernando de Apure Las Flecheras National Airport",
      "San Fernando de Apure Las Flecheras National Airport",
      "San Fernando de Apure Las Flecheras National Airport"
    ],
    "city": [
      "San Fernando de Apure",
      "San Fernando de Apure",
      "San Fernando de Apure"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "SOM",
    "translations": [
      "San Tomé Airport",
      "San Tomé Airport",
      "San Tomé Airport"
    ],
    "city": [
      "El Tigre",
      "El Tigre",
      "El Tigre"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "STB",
    "translations": [
      "Miguel Urdaneta Fernández Airport",
      "Miguel Urdaneta Fernández Airport",
      "Miguel Urdaneta Fernández Airport"
    ],
    "city": [
      "San Carlos del Zulia",
      "San Carlos del Zulia",
      "San Carlos del Zulia"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "TUV",
    "translations": [
      "Tucupita Airport",
      "Tucupita Airport",
      "Tucupita Airport"
    ],
    "city": [
      "Tucupita",
      "Tucupita",
      "Tucupita"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "TMO",
    "translations": [
      "Tumeremo Airport",
      "Tumeremo Airport",
      "Tumeremo Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "URM",
    "translations": [
      "Uriman Airport",
      "Uriman Airport",
      "Uriman Airport"
    ],
    "city": [
      "Urimán",
      "Urimán",
      "Urimán"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "WOK",
    "translations": [
      "Uon Quen Airport",
      "Uon Quen Airport",
      "Uon Quen Airport"
    ],
    "city": [
      "Uonquén",
      "Uonquén",
      "Uonquén"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "VLN",
    "translations": [
      "Arturo Michelena International Airport",
      "Arturo Michelena International Airport",
      "Arturo Michelena International Airport"
    ],
    "city": [
      "Valencia",
      "Valencia",
      "Valencia"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "VIG",
    "translations": [
      "Juan Pablo Pérez Alfonso Airport",
      "Juan Pablo Pérez Alfonso Airport",
      "Juan Pablo Pérez Alfonso Airport"
    ],
    "city": [
      "El Vigía",
      "El Vigía",
      "El Vigía"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "VLV",
    "translations": [
      "Dr. Antonio Nicolás Briceño Airport",
      "Dr. Antonio Nicolás Briceño Airport",
      "Dr. Antonio Nicolás Briceño Airport"
    ],
    "city": [
      "Valera",
      "Valera",
      "Valera"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "VDP",
    "translations": [
      "Valle de La Pascua Airport",
      "Valle de La Pascua Airport",
      "Valle de La Pascua Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "BAZ",
    "translations": [
      "Barcelos Airport",
      "Barcelos Airport",
      "Barcelos Airport"
    ],
    "city": [
      "Barcelos",
      "Barcelos",
      "Barcelos"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JSB",
    "translations": [
      "Walfrido Salmito de Almeida Airport",
      "Walfrido Salmito de Almeida Airport",
      "Walfrido Salmito de Almeida Airport"
    ],
    "city": [
      "São Benedito",
      "São Benedito",
      "São Benedito"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "LCB",
    "translations": [
      "André Antônio Maggi Airport",
      "André Antônio Maggi Airport",
      "André Antônio Maggi Airport"
    ],
    "city": [
      "Pontes e Lacerda",
      "Pontes e Lacerda",
      "Pontes e Lacerda"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "RBB",
    "translations": [
      "Borba Airport",
      "Borba Airport",
      "Borba Airport"
    ],
    "city": [
      "Borba",
      "Borba",
      "Borba"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CAF",
    "translations": [
      "Carauari Airport",
      "Carauari Airport",
      "Carauari Airport"
    ],
    "city": [
      "Carauari",
      "Carauari",
      "Carauari"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CQS",
    "translations": [
      "Costa Marques Airport",
      "Costa Marques Airport",
      "Costa Marques Airport"
    ],
    "city": [
      "Costa Marques",
      "Costa Marques",
      "Costa Marques"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "DMT",
    "translations": [
      "Diamantino Airport",
      "Diamantino Airport",
      "Diamantino Airport"
    ],
    "city": [
      "Diamantino",
      "Diamantino",
      "Diamantino"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "DNO",
    "translations": [
      "Dianópolis Airport",
      "Dianópolis Airport",
      "Dianópolis Airport"
    ],
    "city": [
      "Dianópolis",
      "Dianópolis",
      "Dianópolis"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ERN",
    "translations": [
      "Eirunepé Airport",
      "Eirunepé Airport",
      "Eirunepé Airport"
    ],
    "city": [
      "Eirunepé",
      "Eirunepé",
      "Eirunepé"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CQA",
    "translations": [
      "Canarana Airport",
      "Canarana Airport",
      "Canarana Airport"
    ],
    "city": [
      "Canarana",
      "Canarana",
      "Canarana"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SXO",
    "translations": [
      "São Félix do Araguaia Airport",
      "São Félix do Araguaia Airport",
      "São Félix do Araguaia Airport"
    ],
    "city": [
      "São Félix Do Araguaia",
      "São Félix Do Araguaia",
      "São Félix Do Araguaia"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GRP",
    "translations": [
      "Gurupi Airport",
      "Gurupi Airport",
      "Gurupi Airport"
    ],
    "city": [
      "Gurupi",
      "Gurupi",
      "Gurupi"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "AUX",
    "translations": [
      "Araguaína Airport",
      "Araguaína Airport",
      "Araguaína Airport"
    ],
    "city": [
      "Araguaína",
      "Araguaína",
      "Araguaína"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "GGB",
    "translations": [
      "Frederico Carlos Müller Airport",
      "Frederico Carlos Müller Airport",
      "Frederico Carlos Müller Airport"
    ],
    "city": [
      "Água Boa",
      "Água Boa",
      "Água Boa"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "HUW",
    "translations": [
      "Humaitá Airport",
      "Humaitá Airport",
      "Humaitá Airport"
    ],
    "city": [
      "Humaitá",
      "Humaitá",
      "Humaitá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "IPG",
    "translations": [
      "Ipiranga Airport",
      "Ipiranga Airport",
      "Ipiranga Airport"
    ],
    "city": [
      "Santo Antônio do Içá",
      "Santo Antônio do Içá",
      "Santo Antônio do Içá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "IDO",
    "translations": [
      "Santa Izabel do Morro Airport",
      "Santa Izabel do Morro Airport",
      "Santa Izabel do Morro Airport"
    ],
    "city": [
      "Cristalândia",
      "Cristalândia",
      "Cristalândia"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JIA",
    "translations": [
      "Juína Airport",
      "Juína Airport",
      "Juína Airport"
    ],
    "city": [
      "Juína",
      "Juína",
      "Juína"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "JTI",
    "translations": [
      "Jataí Airport",
      "Jataí Airport",
      "Jataí Airport"
    ],
    "city": [
      "Jataí",
      "Jataí",
      "Jataí"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CCX",
    "translations": [
      "Cáceres Airport",
      "Cáceres Airport",
      "Cáceres Airport"
    ],
    "city": [
      "Cáceres",
      "Cáceres",
      "Cáceres"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "CIZ",
    "translations": [
      "Coari Airport",
      "Coari Airport",
      "Coari Airport"
    ],
    "city": [
      "Coari",
      "Coari",
      "Coari"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "NSR",
    "translations": [
      "Serra da Capivara Airport",
      "Serra da Capivara Airport",
      "Serra da Capivara Airport"
    ],
    "city": [
      "São Raimundo Nonato",
      "São Raimundo Nonato",
      "São Raimundo Nonato"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TLZ",
    "translations": [
      "Catalão Airport",
      "Catalão Airport",
      "Catalão Airport"
    ],
    "city": [
      "Catalão",
      "Catalão",
      "Catalão"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "LBR",
    "translations": [
      "Lábrea Airport",
      "Lábrea Airport",
      "Lábrea Airport"
    ],
    "city": [
      "Lábrea",
      "Lábrea",
      "Lábrea"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "RVD",
    "translations": [
      "General Leite de Castro Airport",
      "General Leite de Castro Airport",
      "General Leite de Castro Airport"
    ],
    "city": [
      "Rio Verde",
      "Rio Verde",
      "Rio Verde"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MBZ",
    "translations": [
      "Maués Airport",
      "Maués Airport",
      "Maués Airport"
    ],
    "city": [
      "Maués",
      "Maués",
      "Maués"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "NVP",
    "translations": [
      "Novo Aripuanã Airport",
      "Novo Aripuanã Airport",
      "Novo Aripuanã Airport"
    ],
    "city": [
      "Novo Aripuanã",
      "Novo Aripuanã",
      "Novo Aripuanã"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "BCR",
    "translations": [
      "Novo Campo Airport",
      "Novo Campo Airport",
      "Novo Campo Airport"
    ],
    "city": [
      "Boca do Acre",
      "Boca do Acre",
      "Boca do Acre"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "NQL",
    "translations": [
      "Niquelândia Airport",
      "Niquelândia Airport",
      "Niquelândia Airport"
    ],
    "city": [
      "Niquelândia",
      "Niquelândia",
      "Niquelândia"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "APS",
    "translations": [
      "Anápolis Airport",
      "Anápolis Airport",
      "Anápolis Airport"
    ],
    "city": [
      "Anápolis",
      "Anápolis",
      "Anápolis"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "FBA",
    "translations": [
      "Fonte Boa Airport",
      "Fonte Boa Airport",
      "Fonte Boa Airport"
    ],
    "city": [
      "Fonte Boa",
      "Fonte Boa",
      "Fonte Boa"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PIN",
    "translations": [
      "Parintins Airport",
      "Parintins Airport",
      "Parintins Airport"
    ],
    "city": [
      "Parintins",
      "Parintins",
      "Parintins"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PBQ",
    "translations": [
      "Pimenta Bueno Airport",
      "Pimenta Bueno Airport",
      "Pimenta Bueno Airport"
    ],
    "city": [
      "Pimenta Bueno",
      "Pimenta Bueno",
      "Pimenta Bueno"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "PBX",
    "translations": [
      "Fazenda Piraguassu Airport",
      "Fazenda Piraguassu Airport",
      "Fazenda Piraguassu Airport"
    ],
    "city": [
      "Porto Alegre do Norte",
      "Porto Alegre do Norte",
      "Porto Alegre do Norte"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "IRZ",
    "translations": [
      "Tapuruquara Airport",
      "Tapuruquara Airport",
      "Tapuruquara Airport"
    ],
    "city": [
      "Santa Isabel Do Rio Negro",
      "Santa Isabel Do Rio Negro",
      "Santa Isabel Do Rio Negro"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "TGQ",
    "translations": [
      "Tangará da Serra Airport",
      "Tangará da Serra Airport",
      "Tangará da Serra Airport"
    ],
    "city": [
      "Tangará da Serra",
      "Tangará da Serra",
      "Tangará da Serra"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "AZL",
    "translations": [
      "Fazenda Tucunaré Airport",
      "Fazenda Tucunaré Airport",
      "Fazenda Tucunaré Airport"
    ],
    "city": [
      "Sapezal",
      "Sapezal",
      "Sapezal"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "QHN",
    "translations": [
      "Taguatinga Airport",
      "Taguatinga Airport",
      "Taguatinga Airport"
    ],
    "city": [
      "Taguatinga",
      "Taguatinga",
      "Taguatinga"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SQM",
    "translations": [
      "São Miguel do Araguaia Airport",
      "São Miguel do Araguaia Airport",
      "São Miguel do Araguaia Airport"
    ],
    "city": [
      "São Miguel Do Araguaia",
      "São Miguel Do Araguaia",
      "São Miguel Do Araguaia"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "VLP",
    "translations": [
      "Vila Rica Airport",
      "Vila Rica Airport",
      "Vila Rica Airport"
    ],
    "city": [
      "Vila Rica",
      "Vila Rica",
      "Vila Rica"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "MBK",
    "translations": [
      "Orlando Villas Boas Regional Airport",
      "Orlando Villas Boas Regional Airport",
      "Orlando Villas Boas Regional Airport"
    ],
    "city": [
      "Matupá",
      "Matupá",
      "Matupá"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "NOK",
    "translations": [
      "Xavantina Airport",
      "Xavantina Airport",
      "Xavantina Airport"
    ],
    "city": [
      "Nova Xavantina",
      "Nova Xavantina",
      "Nova Xavantina"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "IUP",
    "translations": [
      "Apuí Airport",
      "Apuí Airport",
      "Apuí Airport"
    ],
    "city": [
      "Apuí",
      "Apuí",
      "Apuí"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SWZ",
    "translations": [
      "Western Sydney International (Nancy Bird Walton) Airport",
      "Western Sydney International (Nancy Bird Walton) Airport",
      "Western Sydney International (Nancy Bird Walton) Airport"
    ],
    "city": [
      "Sydney (Badgerys Creek)",
      "Sydney (Badgerys Creek)",
      "Sydney (Badgerys Creek)"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ITI",
    "translations": [
      "Fazenda Americana Airport",
      "Fazenda Americana Airport",
      "Fazenda Americana Airport"
    ],
    "city": [
      "Itambacuri",
      "Itambacuri",
      "Itambacuri"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "SXP",
    "translations": [
      "Nunam Iqua Airport",
      "Nunam Iqua Airport",
      "Nunam Iqua Airport"
    ],
    "city": [
      "Nunam Iqua",
      "Nunam Iqua",
      "Nunam Iqua"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AHL",
    "translations": [
      "Aishalton Airport",
      "Aishalton Airport",
      "Aishalton Airport"
    ],
    "city": [
      "Aishalton",
      "Aishalton",
      "Aishalton"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "NAI",
    "translations": [
      "Annai Airport",
      "Annai Airport",
      "Annai Airport"
    ],
    "city": [
      "Annai",
      "Annai",
      "Annai"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "SYB",
    "translations": [
      "Seal Bay Seaplane Base",
      "Seal Bay Seaplane Base",
      "Seal Bay Seaplane Base"
    ],
    "city": [
      "Seal Bay",
      "Seal Bay",
      "Seal Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BMJ",
    "translations": [
      "Baramita Airport",
      "Baramita Airport",
      "Baramita Airport"
    ],
    "city": [
      "Baramita",
      "Baramita",
      "Baramita"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "GFO",
    "translations": [
      "Bartica A Airport",
      "Bartica A Airport",
      "Bartica A Airport"
    ],
    "city": [
      "Bartica",
      "Bartica",
      "Bartica"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "GEO",
    "translations": [
      "Cheddi Jagan International Airport",
      "Cheddi Jagan International Airport",
      "Cheddi Jagan International Airport"
    ],
    "city": [
      "Georgetown",
      "Georgetown",
      "Georgetown"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "SYF",
    "translations": [
      "Silva Bay Seaplane Base",
      "Silva Bay Seaplane Base",
      "Silva Bay Seaplane Base"
    ],
    "city": [
      "Gabriola Island",
      "Gabriola Island",
      "Gabriola Island"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "OGL",
    "translations": [
      "Eugene F. Correira International Airport",
      "Eugene F. Correira International Airport",
      "Eugene F. Correira International Airport"
    ],
    "city": [
      "Ogle",
      "Ogle",
      "Ogle"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "IMB",
    "translations": [
      "Imbaimadai Airport",
      "Imbaimadai Airport",
      "Imbaimadai Airport"
    ],
    "city": [
      "Imbaimadai",
      "Imbaimadai",
      "Imbaimadai"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "KAI",
    "translations": [
      "Kaieteur International Airport",
      "Kaieteur International Airport",
      "Kaieteur International Airport"
    ],
    "city": [
      "Kaieteur Falls",
      "Kaieteur Falls",
      "Kaieteur Falls"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "KAR",
    "translations": [
      "Kamarang Airport",
      "Kamarang Airport",
      "Kamarang Airport"
    ],
    "city": [
      "Kamarang",
      "Kamarang",
      "Kamarang"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "KRM",
    "translations": [
      "Karanambo Airport",
      "Karanambo Airport",
      "Karanambo Airport"
    ],
    "city": [
      "Karanambo",
      "Karanambo",
      "Karanambo"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "KRG",
    "translations": [
      "Karasabai Airport",
      "Karasabai Airport",
      "Karasabai Airport"
    ],
    "city": [
      "Karasabai",
      "Karasabai",
      "Karasabai"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "KTO",
    "translations": [
      "Kato Airport",
      "Kato Airport",
      "Kato Airport"
    ],
    "city": [
      "Kato",
      "Kato",
      "Kato"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "KKG",
    "translations": [
      "Konawaruk Airport",
      "Konawaruk Airport",
      "Konawaruk Airport"
    ],
    "city": [
      "Konawaruk",
      "Konawaruk",
      "Konawaruk"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "SYL",
    "translations": [
      "Roberts Army Heliport",
      "Roberts Army Heliport",
      "Roberts Army Heliport"
    ],
    "city": [
      "Camp Roberts/San Miguel",
      "Camp Roberts/San Miguel",
      "Camp Roberts/San Miguel"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LUB",
    "translations": [
      "Lumid Pau Airport",
      "Lumid Pau Airport",
      "Lumid Pau Airport"
    ],
    "city": [
      "Lumid Pau",
      "Lumid Pau",
      "Lumid Pau"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "LTM",
    "translations": [
      "Lethem Airport",
      "Lethem Airport",
      "Lethem Airport"
    ],
    "city": [
      "Lethem",
      "Lethem",
      "Lethem"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "USI",
    "translations": [
      "Mabaruma Airport",
      "Mabaruma Airport",
      "Mabaruma Airport"
    ],
    "city": [
      "Mabaruma",
      "Mabaruma",
      "Mabaruma"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "MHA",
    "translations": [
      "Mahdia Airport",
      "Mahdia Airport",
      "Mahdia Airport"
    ],
    "city": [
      "Mahdia",
      "Mahdia",
      "Mahdia"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "VEG",
    "translations": [
      "Maikwak Airport",
      "Maikwak Airport",
      "Maikwak Airport"
    ],
    "city": [
      "Maikwak",
      "Maikwak",
      "Maikwak"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "MYM",
    "translations": [
      "Monkey Mountain Airport",
      "Monkey Mountain Airport",
      "Monkey Mountain Airport"
    ],
    "city": [
      "Monkey Mountain",
      "Monkey Mountain",
      "Monkey Mountain"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "MWJ",
    "translations": [
      "Matthews Ridge Airport",
      "Matthews Ridge Airport",
      "Matthews Ridge Airport"
    ],
    "city": [
      "Matthews Ridge",
      "Matthews Ridge",
      "Matthews Ridge"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "QSX",
    "translations": [
      "New Amsterdam Airport",
      "New Amsterdam Airport",
      "New Amsterdam Airport"
    ],
    "city": [
      "New Amsterdam",
      "New Amsterdam",
      "New Amsterdam"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "ORJ",
    "translations": [
      "Orinduik Airport",
      "Orinduik Airport",
      "Orinduik Airport"
    ],
    "city": [
      "Orinduik",
      "Orinduik",
      "Orinduik"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "PKM",
    "translations": [
      "Port Kaituma Airport",
      "Port Kaituma Airport",
      "Port Kaituma Airport"
    ],
    "city": [
      "Port Kaituma",
      "Port Kaituma",
      "Port Kaituma"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "PIQ",
    "translations": [
      "Pipillipai Airport",
      "Pipillipai Airport",
      "Pipillipai Airport"
    ],
    "city": [
      "Pipillipai",
      "Pipillipai",
      "Pipillipai"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "PMT",
    "translations": [
      "Paramakatoi Airport",
      "Paramakatoi Airport",
      "Paramakatoi Airport"
    ],
    "city": [
      "Paramakatoi",
      "Paramakatoi",
      "Paramakatoi"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "PRR",
    "translations": [
      "Paruima Airport",
      "Paruima Airport",
      "Paruima Airport"
    ],
    "city": [
      "Paruima",
      "Paruima",
      "Paruima"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "SDC",
    "translations": [
      "Sand Creek Airport",
      "Sand Creek Airport",
      "Sand Creek Airport"
    ],
    "city": [
      "Sand Creek",
      "Sand Creek",
      "Sand Creek"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "SKM",
    "translations": [
      "Skeldon Airport",
      "Skeldon Airport",
      "Skeldon Airport"
    ],
    "city": [
      "Skeldon",
      "Skeldon",
      "Skeldon"
    ],
    "country": [
      "GY",
      "GY",
      "GY"
    ]
  },
  {
    "iata": "ANU",
    "translations": [
      "V C Bird International Airport",
      "V C Bird International Airport",
      "V C Bird International Airport"
    ],
    "city": [
      "Osbourn",
      "Osbourn",
      "Osbourn"
    ],
    "country": [
      "AG",
      "AG",
      "AG"
    ]
  },
  {
    "iata": "BBQ",
    "translations": [
      "Codrington Airport",
      "Codrington Airport",
      "Codrington Airport"
    ],
    "city": [
      "Codrington",
      "Codrington",
      "Codrington"
    ],
    "country": [
      "AG",
      "AG",
      "AG"
    ]
  },
  {
    "iata": "BGI",
    "translations": [
      "Grantley Adams International Airport",
      "Grantley Adams International Airport",
      "Grantley Adams International Airport"
    ],
    "city": [
      "Bridgetown",
      "Bridgetown",
      "Bridgetown"
    ],
    "country": [
      "BB",
      "BB",
      "BB"
    ]
  },
  {
    "iata": "TBV",
    "translations": [
      "Tabal Airstrip",
      "Tabal Airstrip",
      "Tabal Airstrip"
    ],
    "city": [
      "Tabal Island",
      "Tabal Island",
      "Tabal Island"
    ],
    "country": [
      "MH",
      "MH",
      "MH"
    ]
  },
  {
    "iata": "TCT",
    "translations": [
      "Takotna Airport",
      "Takotna Airport",
      "Takotna Airport"
    ],
    "city": [
      "Takotna",
      "Takotna",
      "Takotna"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "DCF",
    "translations": [
      "Canefield Airport",
      "Canefield Airport",
      "Canefield Airport"
    ],
    "city": [
      "Canefield",
      "Canefield",
      "Canefield"
    ],
    "country": [
      "DM",
      "DM",
      "DM"
    ]
  },
  {
    "iata": "DOM",
    "translations": [
      "Douglas-Charles Airport",
      "Douglas-Charles Airport",
      "Douglas-Charles Airport"
    ],
    "city": [
      "Marigot",
      "Marigot",
      "Marigot"
    ],
    "country": [
      "DM",
      "DM",
      "DM"
    ]
  },
  {
    "iata": "DSD",
    "translations": [
      "La Désirade Airport",
      "La Désirade Airport",
      "La Désirade Airport"
    ],
    "city": [
      "Grande Anse",
      "Grande Anse",
      "Grande Anse"
    ],
    "country": [
      "GP",
      "GP",
      "GP"
    ]
  },
  {
    "iata": "BBR",
    "translations": [
      "Basse-Terre Baillif Airport",
      "Basse-Terre Baillif Airport",
      "Basse-Terre Baillif Airport"
    ],
    "city": [
      "Basse-Terre",
      "Basse-Terre",
      "Basse-Terre"
    ],
    "country": [
      "GP",
      "GP",
      "GP"
    ]
  },
  {
    "iata": "SFC",
    "translations": [
      "St-François Airport",
      "St-François Airport",
      "St-François Airport"
    ],
    "city": [
      "St-François",
      "St-François",
      "St-François"
    ],
    "country": [
      "GP",
      "GP",
      "GP"
    ]
  },
  {
    "iata": "FDF",
    "translations": [
      "Martinique Aimé Césaire International Airport",
      "Martinique Aimé Césaire International Airport",
      "Martinique Aimé Césaire International Airport"
    ],
    "city": [
      "Fort-de-France",
      "Fort-de-France",
      "Fort-de-France"
    ],
    "country": [
      "MQ",
      "MQ",
      "MQ"
    ]
  },
  {
    "iata": "SFG",
    "translations": [
      "Grand Case-l'Espérance Airport",
      "Grand Case-l'Espérance Airport",
      "Grand Case-l'Espérance Airport"
    ],
    "city": [
      "Grand Case",
      "Grand Case",
      "Grand Case"
    ],
    "country": [
      "MF",
      "MF",
      "MF"
    ]
  },
  {
    "iata": "SBH",
    "translations": [
      "Saint Barthélemy - Gustaf III Airport",
      "Saint Barthélemy - Gustaf III Airport",
      "Saint Barthélemy - Gustaf III Airport"
    ],
    "city": [
      "Gustavia",
      "Gustavia",
      "Gustavia"
    ],
    "country": [
      "BL",
      "BL",
      "BL"
    ]
  },
  {
    "iata": "GBJ",
    "translations": [
      "Marie-Galante Airport",
      "Marie-Galante Airport",
      "Marie-Galante Airport"
    ],
    "city": [
      "Grand-Bourg",
      "Grand-Bourg",
      "Grand-Bourg"
    ],
    "country": [
      "GP",
      "GP",
      "GP"
    ]
  },
  {
    "iata": "PTP",
    "translations": [
      "Guadeloupe - Maryse Condé International Airport",
      "Guadeloupe - Maryse Condé International Airport",
      "Guadeloupe - Maryse Condé International Airport"
    ],
    "city": [
      "Pointe-à-Pitre",
      "Pointe-à-Pitre",
      "Pointe-à-Pitre"
    ],
    "country": [
      "GP",
      "GP",
      "GP"
    ]
  },
  {
    "iata": "LSS",
    "translations": [
      "Terre-de-Haut Airport",
      "Terre-de-Haut Airport",
      "Terre-de-Haut Airport"
    ],
    "city": [
      "Les Saintes",
      "Les Saintes",
      "Les Saintes"
    ],
    "country": [
      "GP",
      "GP",
      "GP"
    ]
  },
  {
    "iata": "GND",
    "translations": [
      "Maurice Bishop International Airport",
      "Maurice Bishop International Airport",
      "Maurice Bishop International Airport"
    ],
    "city": [
      "Saint George's",
      "Saint George's",
      "Saint George's"
    ],
    "country": [
      "GD",
      "GD",
      "GD"
    ]
  },
  {
    "iata": "CRU",
    "translations": [
      "Lauriston Airport",
      "Lauriston Airport",
      "Lauriston Airport"
    ],
    "city": [
      "Carriacou Island",
      "Carriacou Island",
      "Carriacou Island"
    ],
    "country": [
      "GD",
      "GD",
      "GD"
    ]
  },
  {
    "iata": "THW",
    "translations": [
      "Trincomalee Harbor Waterdrome",
      "Trincomalee Harbor Waterdrome",
      "Trincomalee Harbor Waterdrome"
    ],
    "city": [
      "Trincomalee",
      "Trincomalee",
      "Trincomalee"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "STT",
    "translations": [
      "Cyril E. King Airport",
      "Cyril E. King Airport",
      "Cyril E. King Airport"
    ],
    "city": [
      "Charlotte Amalie",
      "Charlotte Amalie",
      "Charlotte Amalie"
    ],
    "country": [
      "VI",
      "VI",
      "VI"
    ]
  },
  {
    "iata": "STX",
    "translations": [
      "Henry E Rohlsen Airport",
      "Henry E Rohlsen Airport",
      "Henry E Rohlsen Airport"
    ],
    "city": [
      "Christiansted",
      "Christiansted",
      "Christiansted"
    ],
    "country": [
      "VI",
      "VI",
      "VI"
    ]
  },
  {
    "iata": "ARE",
    "translations": [
      "Antonio Nery Juarbe Pol Airport",
      "Antonio Nery Juarbe Pol Airport",
      "Antonio Nery Juarbe Pol Airport"
    ],
    "city": [
      "Arecibo",
      "Arecibo",
      "Arecibo"
    ],
    "country": [
      "PR",
      "PR",
      "PR"
    ]
  },
  {
    "iata": "BQN",
    "translations": [
      "Rafael Hernández International Airport",
      "Rafael Hernández International Airport",
      "Rafael Hernández International Airport"
    ],
    "city": [
      "Aguadilla",
      "Aguadilla",
      "Aguadilla"
    ],
    "country": [
      "PR",
      "PR",
      "PR"
    ]
  },
  {
    "iata": "TJC",
    "translations": [
      "Ticantiquí Airport",
      "Ticantiquí Airport",
      "Ticantiquí Airport"
    ],
    "city": [
      "Ticantiquí",
      "Ticantiquí",
      "Ticantiquí"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "CPX",
    "translations": [
      "Benjamin Rivera Noriega Airport",
      "Benjamin Rivera Noriega Airport",
      "Benjamin Rivera Noriega Airport"
    ],
    "city": [
      "Culebra",
      "Culebra",
      "Culebra"
    ],
    "country": [
      "PR",
      "PR",
      "PR"
    ]
  },
  {
    "iata": "SIG",
    "translations": [
      "Fernando Luis Ribas Dominicci Airport",
      "Fernando Luis Ribas Dominicci Airport",
      "Fernando Luis Ribas Dominicci Airport"
    ],
    "city": [
      "San Juan",
      "San Juan",
      "San Juan"
    ],
    "country": [
      "PR",
      "PR",
      "PR"
    ]
  },
  {
    "iata": "MAZ",
    "translations": [
      "Eugenio Maria De Hostos Airport",
      "Eugenio Maria De Hostos Airport",
      "Eugenio Maria De Hostos Airport"
    ],
    "city": [
      "Mayaguez",
      "Mayaguez",
      "Mayaguez"
    ],
    "country": [
      "PR",
      "PR",
      "PR"
    ]
  },
  {
    "iata": "PSE",
    "translations": [
      "Mercedita Airport",
      "Mercedita Airport",
      "Mercedita Airport"
    ],
    "city": [
      "Ponce",
      "Ponce",
      "Ponce"
    ],
    "country": [
      "PR",
      "PR",
      "PR"
    ]
  },
  {
    "iata": "NRR",
    "translations": [
      "José Aponte de la Torre Airport",
      "José Aponte de la Torre Airport",
      "José Aponte de la Torre Airport"
    ],
    "city": [
      "Ceiba",
      "Ceiba",
      "Ceiba"
    ],
    "country": [
      "PR",
      "PR",
      "PR"
    ]
  },
  {
    "iata": "SJU",
    "translations": [
      "Luis Munoz Marin International Airport",
      "Luis Munoz Marin International Airport",
      "Luis Munoz Marin International Airport"
    ],
    "city": [
      "San Juan",
      "San Juan",
      "San Juan"
    ],
    "country": [
      "PR",
      "PR",
      "PR"
    ]
  },
  {
    "iata": "VQS",
    "translations": [
      "Antonio Rivera Rodriguez Airport",
      "Antonio Rivera Rodriguez Airport",
      "Antonio Rivera Rodriguez Airport"
    ],
    "city": [
      "Vieques",
      "Vieques",
      "Vieques"
    ],
    "country": [
      "PR",
      "PR",
      "PR"
    ]
  },
  {
    "iata": "TKE",
    "translations": [
      "Tenakee Seaplane Base",
      "Tenakee Seaplane Base",
      "Tenakee Seaplane Base"
    ],
    "city": [
      "Tenakee Springs",
      "Tenakee Springs",
      "Tenakee Springs"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TKL",
    "translations": [
      "Taku Lodge Seaplane Base",
      "Taku Lodge Seaplane Base",
      "Taku Lodge Seaplane Base"
    ],
    "city": [
      "Taku Lodge",
      "Taku Lodge",
      "Taku Lodge"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SKB",
    "translations": [
      "Robert L. Bradshaw International Airport",
      "Robert L. Bradshaw International Airport",
      "Robert L. Bradshaw International Airport"
    ],
    "city": [
      "Basseterre",
      "Basseterre",
      "Basseterre"
    ],
    "country": [
      "KN",
      "KN",
      "KN"
    ]
  },
  {
    "iata": "NEV",
    "translations": [
      "Vance W. Amory International Airport",
      "Vance W. Amory International Airport",
      "Vance W. Amory International Airport"
    ],
    "city": [
      "Charlestown",
      "Charlestown",
      "Charlestown"
    ],
    "country": [
      "KN",
      "KN",
      "KN"
    ]
  },
  {
    "iata": "SLU",
    "translations": [
      "George F. L. Charles Airport",
      "George F. L. Charles Airport",
      "George F. L. Charles Airport"
    ],
    "city": [
      "Castries",
      "Castries",
      "Castries"
    ],
    "country": [
      "LC",
      "LC",
      "LC"
    ]
  },
  {
    "iata": "UVF",
    "translations": [
      "Hewanorra International Airport",
      "Hewanorra International Airport",
      "Hewanorra International Airport"
    ],
    "city": [
      "Vieux Fort",
      "Vieux Fort",
      "Vieux Fort"
    ],
    "country": [
      "LC",
      "LC",
      "LC"
    ]
  },
  {
    "iata": "TLT",
    "translations": [
      "Tuluksak Airport",
      "Tuluksak Airport",
      "Tuluksak Airport"
    ],
    "city": [
      "Tuluksak",
      "Tuluksak",
      "Tuluksak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "AUA",
    "translations": [
      "Queen Beatrix International Airport",
      "Queen Beatrix International Airport",
      "Queen Beatrix International Airport"
    ],
    "city": [
      "Oranjestad",
      "Oranjestad",
      "Oranjestad"
    ],
    "country": [
      "AW",
      "AW",
      "AW"
    ]
  },
  {
    "iata": "BON",
    "translations": [
      "Flamingo International Airport",
      "Flamingo International Airport",
      "Flamingo International Airport"
    ],
    "city": [
      "Kralendijk",
      "Kralendijk",
      "Kralendijk"
    ],
    "country": [
      "BQ",
      "BQ",
      "BQ"
    ]
  },
  {
    "iata": "CUR",
    "translations": [
      "Hato International Airport",
      "Hato International Airport",
      "Hato International Airport"
    ],
    "city": [
      "Willemstad",
      "Willemstad",
      "Willemstad"
    ],
    "country": [
      "CW",
      "CW",
      "CW"
    ]
  },
  {
    "iata": "EUX",
    "translations": [
      "F. D. Roosevelt Airport",
      "F. D. Roosevelt Airport",
      "F. D. Roosevelt Airport"
    ],
    "city": [
      "Oranjestad",
      "Oranjestad",
      "Oranjestad"
    ],
    "country": [
      "BQ",
      "BQ",
      "BQ"
    ]
  },
  {
    "iata": "SXM",
    "translations": [
      "Princess Juliana International Airport",
      "Princess Juliana International Airport",
      "Princess Juliana International Airport"
    ],
    "city": [
      "Sint Maarten",
      "Sint Maarten",
      "Sint Maarten"
    ],
    "country": [
      "SX",
      "SX",
      "SX"
    ]
  },
  {
    "iata": "SAB",
    "translations": [
      "Juancho E. Yrausquin Airport",
      "Juancho E. Yrausquin Airport",
      "Juancho E. Yrausquin Airport"
    ],
    "city": [
      "Zion's Hill",
      "Zion's Hill",
      "Zion's Hill"
    ],
    "country": [
      "BQ",
      "BQ",
      "BQ"
    ]
  },
  {
    "iata": "TOK",
    "translations": [
      "Torokina Airport",
      "Torokina Airport",
      "Torokina Airport"
    ],
    "city": [
      "Torokina",
      "Torokina",
      "Torokina"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TOV",
    "translations": [
      "Tortola West End Seaplane Base",
      "Tortola West End Seaplane Base",
      "Tortola West End Seaplane Base"
    ],
    "city": [
      "Tortola",
      "Tortola",
      "Tortola"
    ],
    "country": [
      "VG",
      "VG",
      "VG"
    ]
  },
  {
    "iata": "TPT",
    "translations": [
      "Tapeta Airport",
      "Tapeta Airport",
      "Tapeta Airport"
    ],
    "city": [
      "Tapeta",
      "Tapeta",
      "Tapeta"
    ],
    "country": [
      "LR",
      "LR",
      "LR"
    ]
  },
  {
    "iata": "AXA",
    "translations": [
      "Clayton J Lloyd International Airport",
      "Clayton J Lloyd International Airport",
      "Clayton J Lloyd International Airport"
    ],
    "city": [
      "The Valley",
      "The Valley",
      "The Valley"
    ],
    "country": [
      "AI",
      "AI",
      "AI"
    ]
  },
  {
    "iata": "XXX",
    "translations": [
      "Serik Bus Station Helipad",
      "Serik Bus Station Helipad",
      "Serik Bus Station Helipad"
    ],
    "city": [
      "Serik",
      "Serik",
      "Serik"
    ],
    "country": [
      "TR",
      "TR",
      "TR"
    ]
  },
  {
    "iata": "MNI",
    "translations": [
      "John A. Osborne Airport",
      "John A. Osborne Airport",
      "John A. Osborne Airport"
    ],
    "city": [
      "Gerald's Park",
      "Gerald's Park",
      "Gerald's Park"
    ],
    "country": [
      "MS",
      "MS",
      "MS"
    ]
  },
  {
    "iata": "TSG",
    "translations": [
      "Tanacross Airport",
      "Tanacross Airport",
      "Tanacross Airport"
    ],
    "city": [
      "Tanacross",
      "Tanacross",
      "Tanacross"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TSI",
    "translations": [
      "Tsile Tsile Airport",
      "Tsile Tsile Airport",
      "Tsile Tsile Airport"
    ],
    "city": [
      "Tsile Tsile",
      "Tsile Tsile",
      "Tsile Tsile"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "TAB",
    "translations": [
      "A.N.R. Robinson International Airport",
      "A.N.R. Robinson International Airport",
      "A.N.R. Robinson International Airport"
    ],
    "city": [
      "Scarborough",
      "Scarborough",
      "Scarborough"
    ],
    "country": [
      "TT",
      "TT",
      "TT"
    ]
  },
  {
    "iata": "POS",
    "translations": [
      "Piarco International Airport",
      "Piarco International Airport",
      "Piarco International Airport"
    ],
    "city": [
      "Port of Spain",
      "Port of Spain",
      "Port of Spain"
    ],
    "country": [
      "TT",
      "TT",
      "TT"
    ]
  },
  {
    "iata": "TTW",
    "translations": [
      "Tissa Tank Waterdrome",
      "Tissa Tank Waterdrome",
      "Tissa Tank Waterdrome"
    ],
    "city": [
      "Tissamaharama",
      "Tissamaharama",
      "Tissamaharama"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "TUJ",
    "translations": [
      "Tum Airport",
      "Tum Airport",
      "Tum Airport"
    ],
    "city": [
      "Tum",
      "Tum",
      "Tum"
    ],
    "country": [
      "ET",
      "ET",
      "ET"
    ]
  },
  {
    "iata": "NGD",
    "translations": [
      "Captain Auguste George Airport",
      "Captain Auguste George Airport",
      "Captain Auguste George Airport"
    ],
    "city": [
      "Anegada",
      "Anegada",
      "Anegada"
    ],
    "country": [
      "VG",
      "VG",
      "VG"
    ]
  },
  {
    "iata": "EIS",
    "translations": [
      "Terrance B. Lettsome International Airport",
      "Terrance B. Lettsome International Airport",
      "Terrance B. Lettsome International Airport"
    ],
    "city": [
      "Beef Island",
      "Beef Island",
      "Beef Island"
    ],
    "country": [
      "VG",
      "VG",
      "VG"
    ]
  },
  {
    "iata": "VIJ",
    "translations": [
      "Virgin Gorda Airport",
      "Virgin Gorda Airport",
      "Virgin Gorda Airport"
    ],
    "city": [
      "Spanish Town",
      "Spanish Town",
      "Spanish Town"
    ],
    "country": [
      "VG",
      "VG",
      "VG"
    ]
  },
  {
    "iata": "SVD",
    "translations": [
      "Argyle International Airport",
      "Argyle International Airport",
      "Argyle International Airport"
    ],
    "city": [
      "Kingstown",
      "Kingstown",
      "Kingstown"
    ],
    "country": [
      "VC",
      "VC",
      "VC"
    ]
  },
  {
    "iata": "BQU",
    "translations": [
      "J F Mitchell Airport",
      "J F Mitchell Airport",
      "J F Mitchell Airport"
    ],
    "city": [
      "Bequia",
      "Bequia",
      "Bequia"
    ],
    "country": [
      "VC",
      "VC",
      "VC"
    ]
  },
  {
    "iata": "CIW",
    "translations": [
      "Canouan Airport",
      "Canouan Airport",
      "Canouan Airport"
    ],
    "city": [
      "Canouan",
      "Canouan",
      "Canouan"
    ],
    "country": [
      "VC",
      "VC",
      "VC"
    ]
  },
  {
    "iata": "MQS",
    "translations": [
      "Mustique Airport",
      "Mustique Airport",
      "Mustique Airport"
    ],
    "city": [
      "Lovell",
      "Lovell",
      "Lovell"
    ],
    "country": [
      "VC",
      "VC",
      "VC"
    ]
  },
  {
    "iata": "UNI",
    "translations": [
      "Union Island International Airport",
      "Union Island International Airport",
      "Union Island International Airport"
    ],
    "city": [
      "Union Island",
      "Union Island",
      "Union Island"
    ],
    "country": [
      "VC",
      "VC",
      "VC"
    ]
  },
  {
    "iata": "TWC",
    "translations": [
      "Tumxuk Tangwangcheng Airport",
      "Tumxuk Tangwangcheng Airport",
      "Tumxuk Tangwangcheng Airport"
    ],
    "city": [
      "Tumxuk",
      "Tumxuk",
      "Tumxuk"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TWH",
    "translations": [
      "Two Harbors Amphibious Terminal",
      "Two Harbors Amphibious Terminal",
      "Two Harbors Amphibious Terminal"
    ],
    "city": [
      "Two Harbors",
      "Two Harbors",
      "Two Harbors"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BDA",
    "translations": [
      "L.F. Wade International Airport",
      "L.F. Wade International Airport",
      "L.F. Wade International Airport"
    ],
    "city": [
      "Hamilton",
      "Hamilton",
      "Hamilton"
    ],
    "country": [
      "BM",
      "BM",
      "BM"
    ]
  },
  {
    "iata": "TYE",
    "translations": [
      "Tyonek Airport",
      "Tyonek Airport",
      "Tyonek Airport"
    ],
    "city": [
      "Tyonek",
      "Tyonek",
      "Tyonek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "GIT",
    "translations": [
      "Mchauru Airport",
      "Mchauru Airport",
      "Mchauru Airport"
    ],
    "city": [
      "Geita",
      "Geita",
      "Geita"
    ],
    "country": [
      "TZ",
      "TZ",
      "TZ"
    ]
  },
  {
    "iata": "TZO",
    "translations": [
      "Tsimiroro Airport",
      "Tsimiroro Airport",
      "Tsimiroro Airport"
    ],
    "city": [
      "Ankisatra",
      "Ankisatra",
      "Ankisatra"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "DBS",
    "translations": [
      "Dubois Municipal Airport",
      "Dubois Municipal Airport",
      "Dubois Municipal Airport"
    ],
    "city": [
      "Dubois",
      "Dubois",
      "Dubois"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "MXR",
    "translations": [
      "Myrhorod Air Base",
      "Myrhorod Air Base",
      "Myrhorod Air Base"
    ],
    "city": [
      "Myrhorod",
      "Myrhorod",
      "Myrhorod"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "KHU",
    "translations": [
      "Kakhnovka Airfield",
      "Kakhnovka Airfield",
      "Kakhnovka Airfield"
    ],
    "city": [
      "Kremenchuk",
      "Kremenchuk",
      "Kremenchuk"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "KCP",
    "translations": [
      "Kam'yanets'-Podil's'kyi Airfield",
      "Kam'yanets'-Podil's'kyi Airfield",
      "Kam'yanets'-Podil's'kyi Airfield"
    ],
    "city": [
      "Kamyan'ka",
      "Kamyan'ka",
      "Kamyan'ka"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "ALA",
    "translations": [
      "Almaty International Airport",
      "Almaty International Airport",
      "Almaty International Airport"
    ],
    "city": [
      "Almaty",
      "Almaty",
      "Almaty"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "BXH",
    "translations": [
      "Balkhash Airport",
      "Balkhash Airport",
      "Balkhash Airport"
    ],
    "city": [
      "Balkhash",
      "Balkhash",
      "Balkhash"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "USJ",
    "translations": [
      "Usharal Airport",
      "Usharal Airport",
      "Usharal Airport"
    ],
    "city": [
      "Usharal",
      "Usharal",
      "Usharal"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "BXJ",
    "translations": [
      "Boralday Airport",
      "Boralday Airport",
      "Boralday Airport"
    ],
    "city": [
      "Boralday",
      "Boralday",
      "Boralday"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "TDK",
    "translations": [
      "Taldykorgan Airport",
      "Taldykorgan Airport",
      "Taldykorgan Airport"
    ],
    "city": [
      "Taldykorgan",
      "Taldykorgan",
      "Taldykorgan"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "NQZ",
    "translations": [
      "Nursultan Nazarbayev International Airport",
      "Nursultan Nazarbayev International Airport",
      "Nursultan Nazarbayev International Airport"
    ],
    "city": [
      "Astana",
      "Astana",
      "Astana"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "KOV",
    "translations": [
      "Kokshetau Airport",
      "Kokshetau Airport",
      "Kokshetau Airport"
    ],
    "city": [
      "Kokshetau",
      "Kokshetau",
      "Kokshetau"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "PPK",
    "translations": [
      "Petropavl Airport",
      "Petropavl Airport",
      "Petropavl Airport"
    ],
    "city": [
      "Petropavl",
      "Petropavl",
      "Petropavl"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "DMB",
    "translations": [
      "Taraz Airport",
      "Taraz Airport",
      "Taraz Airport"
    ],
    "city": [
      "Taraz",
      "Taraz",
      "Taraz"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "FRU",
    "translations": [
      "Manas International Airport",
      "Manas International Airport",
      "Manas International Airport"
    ],
    "city": [
      "Bishkek",
      "Bishkek",
      "Bishkek"
    ],
    "country": [
      "KG",
      "KG",
      "KG"
    ]
  },
  {
    "iata": "OSS",
    "translations": [
      "Osh Airport",
      "Osh Airport",
      "Osh Airport"
    ],
    "city": [
      "Osh",
      "Osh",
      "Osh"
    ],
    "country": [
      "KG",
      "KG",
      "KG"
    ]
  },
  {
    "iata": "IKG",
    "translations": [
      "Karakol Airport",
      "Karakol Airport",
      "Karakol Airport"
    ],
    "city": [
      "Karakol",
      "Karakol",
      "Karakol"
    ],
    "country": [
      "KG",
      "KG",
      "KG"
    ]
  },
  {
    "iata": "CIT",
    "translations": [
      "Shymkent Airport",
      "Shymkent Airport",
      "Shymkent Airport"
    ],
    "city": [
      "Shymkent",
      "Shymkent",
      "Shymkent"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "HSA",
    "translations": [
      "Hazrat Sultan International Airport",
      "Hazrat Sultan International Airport",
      "Hazrat Sultan International Airport"
    ],
    "city": [
      "Turkıstan",
      "Turkıstan",
      "Turkıstan"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "DZN",
    "translations": [
      "Zhezkazgan National Airport",
      "Zhezkazgan National Airport",
      "Zhezkazgan National Airport"
    ],
    "city": [
      "Zhezkazgan",
      "Zhezkazgan",
      "Zhezkazgan"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "KGF",
    "translations": [
      "Sary-Arka Airport",
      "Sary-Arka Airport",
      "Sary-Arka Airport"
    ],
    "city": [
      "Karaganda",
      "Karaganda",
      "Karaganda"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "BXY",
    "translations": [
      "Baikonur Krayniy Airport",
      "Baikonur Krayniy Airport",
      "Baikonur Krayniy Airport"
    ],
    "city": [
      "Baikonur",
      "Baikonur",
      "Baikonur"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "KZO",
    "translations": [
      "Kyzylorda Airport",
      "Kyzylorda Airport",
      "Kyzylorda Airport"
    ],
    "city": [
      "Kyzylorda",
      "Kyzylorda",
      "Kyzylorda"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "URA",
    "translations": [
      "Uralsk Airport",
      "Uralsk Airport",
      "Uralsk Airport"
    ],
    "city": [
      "Uralsk",
      "Uralsk",
      "Uralsk"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "EKB",
    "translations": [
      "Ekibastuz Airport",
      "Ekibastuz Airport",
      "Ekibastuz Airport"
    ],
    "city": [
      "Ekibastuz",
      "Ekibastuz",
      "Ekibastuz"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "UKK",
    "translations": [
      "Ust-Kamenogorsk Airport",
      "Ust-Kamenogorsk Airport",
      "Ust-Kamenogorsk Airport"
    ],
    "city": [
      "Ust-Kamenogorsk (Oskemen)",
      "Ust-Kamenogorsk (Oskemen)",
      "Ust-Kamenogorsk (Oskemen)"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "PWQ",
    "translations": [
      "Pavlodar Airport",
      "Pavlodar Airport",
      "Pavlodar Airport"
    ],
    "city": [
      "Pavlodar",
      "Pavlodar",
      "Pavlodar"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "PLX",
    "translations": [
      "Semey Airport",
      "Semey Airport",
      "Semey Airport"
    ],
    "city": [
      "Semey",
      "Semey",
      "Semey"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "SZI",
    "translations": [
      "Zaysan Airport",
      "Zaysan Airport",
      "Zaysan Airport"
    ],
    "city": [
      "Zaysan",
      "Zaysan",
      "Zaysan"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "SCO",
    "translations": [
      "Aktau Airport",
      "Aktau Airport",
      "Aktau Airport"
    ],
    "city": [
      "Aktau",
      "Aktau",
      "Aktau"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "GUW",
    "translations": [
      "Atyrau International Airport",
      "Atyrau International Airport",
      "Atyrau International Airport"
    ],
    "city": [
      "Atyrau",
      "Atyrau",
      "Atyrau"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "AKX",
    "translations": [
      "Aktobe Airport",
      "Aktobe Airport",
      "Aktobe Airport"
    ],
    "city": [
      "Aktobe",
      "Aktobe",
      "Aktobe"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "AYK",
    "translations": [
      "Arkalyk North Airport",
      "Arkalyk North Airport",
      "Arkalyk North Airport"
    ],
    "city": [
      "Arkalyk",
      "Arkalyk",
      "Arkalyk"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "KSN",
    "translations": [
      "Kostanay West Airport",
      "Kostanay West Airport",
      "Kostanay West Airport"
    ],
    "city": [
      "Kostanay",
      "Kostanay",
      "Kostanay"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "GYD",
    "translations": [
      "Heydar Aliyev International Airport",
      "Heydar Aliyev International Airport",
      "Heydar Aliyev International Airport"
    ],
    "city": [
      "Baku",
      "Baku",
      "Baku"
    ],
    "country": [
      "AZ",
      "AZ",
      "AZ"
    ]
  },
  {
    "iata": "FZL",
    "translations": [
      "Fuzuli International Airport",
      "Fuzuli International Airport",
      "Fuzuli International Airport"
    ],
    "city": [
      "Fuzuli",
      "Fuzuli",
      "Fuzuli"
    ],
    "country": [
      "AZ",
      "AZ",
      "AZ"
    ]
  },
  {
    "iata": "GNJ",
    "translations": [
      "Ganja International Airport",
      "Ganja International Airport",
      "Ganja International Airport"
    ],
    "city": [
      "Ganja",
      "Ganja",
      "Ganja"
    ],
    "country": [
      "AZ",
      "AZ",
      "AZ"
    ]
  },
  {
    "iata": "LLK",
    "translations": [
      "Lankaran International Airport",
      "Lankaran International Airport",
      "Lankaran International Airport"
    ],
    "city": [
      "Lankaran",
      "Lankaran",
      "Lankaran"
    ],
    "country": [
      "AZ",
      "AZ",
      "AZ"
    ]
  },
  {
    "iata": "NAJ",
    "translations": [
      "Nakhchivan Airport",
      "Nakhchivan Airport",
      "Nakhchivan Airport"
    ],
    "city": [
      "Nakhchivan",
      "Nakhchivan",
      "Nakhchivan"
    ],
    "country": [
      "AZ",
      "AZ",
      "AZ"
    ]
  },
  {
    "iata": "GBB",
    "translations": [
      "Gabala International Airport",
      "Gabala International Airport",
      "Gabala International Airport"
    ],
    "city": [
      "Gabala",
      "Gabala",
      "Gabala"
    ],
    "country": [
      "AZ",
      "AZ",
      "AZ"
    ]
  },
  {
    "iata": "ZTU",
    "translations": [
      "Zaqatala International Airport",
      "Zaqatala International Airport",
      "Zaqatala International Airport"
    ],
    "city": [
      "Zaqatala",
      "Zaqatala",
      "Zaqatala"
    ],
    "country": [
      "AZ",
      "AZ",
      "AZ"
    ]
  },
  {
    "iata": "ZZE",
    "translations": [
      "Zangilan International Airport",
      "Zangilan International Airport",
      "Zangilan International Airport"
    ],
    "city": [
      "Zangilan",
      "Zangilan",
      "Zangilan"
    ],
    "country": [
      "AZ",
      "AZ",
      "AZ"
    ]
  },
  {
    "iata": "YLV",
    "translations": [
      "Yevlakh Airport",
      "Yevlakh Airport",
      "Yevlakh Airport"
    ],
    "city": [
      "Yevlakh",
      "Yevlakh",
      "Yevlakh"
    ],
    "country": [
      "AZ",
      "AZ",
      "AZ"
    ]
  },
  {
    "iata": "IKU",
    "translations": [
      "Issyk-Kul International Airport",
      "Issyk-Kul International Airport",
      "Issyk-Kul International Airport"
    ],
    "city": [
      "Tamchy",
      "Tamchy",
      "Tamchy"
    ],
    "country": [
      "KG",
      "KG",
      "KG"
    ]
  },
  {
    "iata": "LWN",
    "translations": [
      "Shirak International Airport",
      "Shirak International Airport",
      "Shirak International Airport"
    ],
    "city": [
      "Gyumri",
      "Gyumri",
      "Gyumri"
    ],
    "country": [
      "AM",
      "AM",
      "AM"
    ]
  },
  {
    "iata": "EVN",
    "translations": [
      "Zvartnots International Airport",
      "Zvartnots International Airport",
      "Zvartnots International Airport"
    ],
    "city": [
      "Yerevan",
      "Yerevan",
      "Yerevan"
    ],
    "country": [
      "AM",
      "AM",
      "AM"
    ]
  },
  {
    "iata": "BQJ",
    "translations": [
      "Batagay Airport",
      "Batagay Airport",
      "Batagay Airport"
    ],
    "city": [
      "Batagay",
      "Batagay",
      "Batagay"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SUK",
    "translations": [
      "Sakkyryr Airport",
      "Sakkyryr Airport",
      "Sakkyryr Airport"
    ],
    "city": [
      "Batagay-Alyta",
      "Batagay-Alyta",
      "Batagay-Alyta"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "UKG",
    "translations": [
      "Ust-Kuyga Airport",
      "Ust-Kuyga Airport",
      "Ust-Kuyga Airport"
    ],
    "city": [
      "Ust-Kuyga",
      "Ust-Kuyga",
      "Ust-Kuyga"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "TLK",
    "translations": [
      "Talakan Airport",
      "Talakan Airport",
      "Talakan Airport"
    ],
    "city": [
      "Talakan Oil Field",
      "Talakan Oil Field",
      "Talakan Oil Field"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ADH",
    "translations": [
      "Aldan Airport",
      "Aldan Airport",
      "Aldan Airport"
    ],
    "city": [
      "Aldan",
      "Aldan",
      "Aldan"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "YKS",
    "translations": [
      "Yakutsk Airport",
      "Yakutsk Airport",
      "Yakutsk Airport"
    ],
    "city": [
      "Yakutsk",
      "Yakutsk",
      "Yakutsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NER",
    "translations": [
      "Chulman Airport",
      "Chulman Airport",
      "Chulman Airport"
    ],
    "city": [
      "Neryungri",
      "Neryungri",
      "Neryungri"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "MQJ",
    "translations": [
      "Moma Airport",
      "Moma Airport",
      "Moma Airport"
    ],
    "city": [
      "Khonuu",
      "Khonuu",
      "Khonuu"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KDY",
    "translations": [
      "Typliy Klyuch Airport",
      "Typliy Klyuch Airport",
      "Typliy Klyuch Airport"
    ],
    "city": [
      "Khandyga",
      "Khandyga",
      "Khandyga"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "GYG",
    "translations": [
      "Magan Airport",
      "Magan Airport",
      "Magan Airport"
    ],
    "city": [
      "Magan",
      "Magan",
      "Magan"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "OLZ",
    "translations": [
      "Olyokminsk Airport",
      "Olyokminsk Airport",
      "Olyokminsk Airport"
    ],
    "city": [
      "Olyokminsk",
      "Olyokminsk",
      "Olyokminsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "USR",
    "translations": [
      "Ust-Nera Airport",
      "Ust-Nera Airport",
      "Ust-Nera Airport"
    ],
    "city": [
      "Ust-Nera",
      "Ust-Nera",
      "Ust-Nera"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "UMS",
    "translations": [
      "Ust-Maya Airport",
      "Ust-Maya Airport",
      "Ust-Maya Airport"
    ],
    "city": [
      "Ust-Maya",
      "Ust-Maya",
      "Ust-Maya"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "VHV",
    "translations": [
      "Verkhnevilyuisk Airport",
      "Verkhnevilyuisk Airport",
      "Verkhnevilyuisk Airport"
    ],
    "city": [
      "Verkhnevilyuisk",
      "Verkhnevilyuisk",
      "Verkhnevilyuisk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NYR",
    "translations": [
      "Nyurba Airport",
      "Nyurba Airport",
      "Nyurba Airport"
    ],
    "city": [
      "Nyurba",
      "Nyurba",
      "Nyurba"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SUY",
    "translations": [
      "Suntar Airport",
      "Suntar Airport",
      "Suntar Airport"
    ],
    "city": [
      "Suntar",
      "Suntar",
      "Suntar"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "VYI",
    "translations": [
      "Vilyuisk Airport",
      "Vilyuisk Airport",
      "Vilyuisk Airport"
    ],
    "city": [
      "Vilyuisk",
      "Vilyuisk",
      "Vilyuisk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ULK",
    "translations": [
      "Lensk Airport",
      "Lensk Airport",
      "Lensk Airport"
    ],
    "city": [
      "Lensk",
      "Lensk",
      "Lensk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ONK",
    "translations": [
      "Olenyok Airport",
      "Olenyok Airport",
      "Olenyok Airport"
    ],
    "city": [
      "Olenyok",
      "Olenyok",
      "Olenyok"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "PYJ",
    "translations": [
      "Polyarny Airport",
      "Polyarny Airport",
      "Polyarny Airport"
    ],
    "city": [
      "Yakutia",
      "Yakutia",
      "Yakutia"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "MJZ",
    "translations": [
      "Mirny Airport",
      "Mirny Airport",
      "Mirny Airport"
    ],
    "city": [
      "Mirny",
      "Mirny",
      "Mirny"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SYS",
    "translations": [
      "Saskylakh Airport",
      "Saskylakh Airport",
      "Saskylakh Airport"
    ],
    "city": [
      "Saskylakh",
      "Saskylakh",
      "Saskylakh"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BGN",
    "translations": [
      "Belaya Gora Airport",
      "Belaya Gora Airport",
      "Belaya Gora Airport"
    ],
    "city": [
      "Belaya Gora",
      "Belaya Gora",
      "Belaya Gora"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SEK",
    "translations": [
      "Srednekolymsk Airport",
      "Srednekolymsk Airport",
      "Srednekolymsk Airport"
    ],
    "city": [
      "Srednekolymsk",
      "Srednekolymsk",
      "Srednekolymsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "CKH",
    "translations": [
      "Chokurdakh Airport",
      "Chokurdakh Airport",
      "Chokurdakh Airport"
    ],
    "city": [
      "Chokurdah",
      "Chokurdah",
      "Chokurdah"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "CYX",
    "translations": [
      "Cherskiy Airport",
      "Cherskiy Airport",
      "Cherskiy Airport"
    ],
    "city": [
      "Cherskiy",
      "Cherskiy",
      "Cherskiy"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "IKS",
    "translations": [
      "Tiksi Airport",
      "Tiksi Airport",
      "Tiksi Airport"
    ],
    "city": [
      "Tiksi",
      "Tiksi",
      "Tiksi"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ZKP",
    "translations": [
      "Zyryanka Airport",
      "Zyryanka Airport",
      "Zyryanka Airport"
    ],
    "city": [
      "Zyryanka",
      "Zyryanka",
      "Zyryanka"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ZIX",
    "translations": [
      "Zhigansk Airport",
      "Zhigansk Airport",
      "Zhigansk Airport"
    ],
    "city": [
      "Zhigansk",
      "Zhigansk",
      "Zhigansk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KXO",
    "translations": [
      "Kisoro Airport",
      "Kisoro Airport",
      "Kisoro Airport"
    ],
    "city": [
      "Kisoro",
      "Kisoro",
      "Kisoro"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "KHX",
    "translations": [
      "Savannah Airstrip",
      "Savannah Airstrip",
      "Savannah Airstrip"
    ],
    "city": [
      "Kihihi",
      "Kihihi",
      "Kihihi"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "OYG",
    "translations": [
      "Moyo Airport",
      "Moyo Airport",
      "Moyo Airport"
    ],
    "city": [
      "Moyo",
      "Moyo",
      "Moyo"
    ],
    "country": [
      "UG",
      "UG",
      "UG"
    ]
  },
  {
    "iata": "UGB",
    "translations": [
      "Ugashik Bay Airport",
      "Ugashik Bay Airport",
      "Ugashik Bay Airport"
    ],
    "city": [
      "Pilot Point",
      "Pilot Point",
      "Pilot Point"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KUT",
    "translations": [
      "David the Builder Kutaisi International Airport",
      "David the Builder Kutaisi International Airport",
      "David the Builder Kutaisi International Airport"
    ],
    "city": [
      "Kopitnari",
      "Kopitnari",
      "Kopitnari"
    ],
    "country": [
      "GE",
      "GE",
      "GE"
    ]
  },
  {
    "iata": "BUS",
    "translations": [
      "Batumi International Airport",
      "Batumi International Airport",
      "Batumi International Airport"
    ],
    "city": [
      "Batumi",
      "Batumi",
      "Batumi"
    ],
    "country": [
      "GE",
      "GE",
      "GE"
    ]
  },
  {
    "iata": "SUI",
    "translations": [
      "Sukhumi Babushara /  Vladislav Ardzinba International Airport",
      "Sukhumi Babushara /  Vladislav Ardzinba International Airport",
      "Sukhumi Babushara /  Vladislav Ardzinba International Airport"
    ],
    "city": [
      "Sukhumi",
      "Sukhumi",
      "Sukhumi"
    ],
    "country": [
      "GE",
      "GE",
      "GE"
    ]
  },
  {
    "iata": "TBS",
    "translations": [
      "Tbilisi International Airport",
      "Tbilisi International Airport",
      "Tbilisi International Airport"
    ],
    "city": [
      "Tbilisi",
      "Tbilisi",
      "Tbilisi"
    ],
    "country": [
      "GE",
      "GE",
      "GE"
    ]
  },
  {
    "iata": "BQS",
    "translations": [
      "Ignatyevo Airport",
      "Ignatyevo Airport",
      "Ignatyevo Airport"
    ],
    "city": [
      "Blagoveschensk",
      "Blagoveschensk",
      "Blagoveschensk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "EYA",
    "translations": [
      "Zeya Airport",
      "Zeya Airport",
      "Zeya Airport"
    ],
    "city": [
      "Zeya",
      "Zeya",
      "Zeya"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "TYD",
    "translations": [
      "Tynda Airport",
      "Tynda Airport",
      "Tynda Airport"
    ],
    "city": [
      "Tynda",
      "Tynda",
      "Tynda"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KHV",
    "translations": [
      "Khabarovsk Novy Airport",
      "Khabarovsk Novy Airport",
      "Khabarovsk Novy Airport"
    ],
    "city": [
      "Khabarovsk",
      "Khabarovsk",
      "Khabarovsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KXK",
    "translations": [
      "Komsomolsk-on-Amur Airport",
      "Komsomolsk-on-Amur Airport",
      "Komsomolsk-on-Amur Airport"
    ],
    "city": [
      "Komsomolsk-on-Amur",
      "Komsomolsk-on-Amur",
      "Komsomolsk-on-Amur"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "GVN",
    "translations": [
      "Sovetskaya Gavan (Maygatka) Airport",
      "Sovetskaya Gavan (Maygatka) Airport",
      "Sovetskaya Gavan (Maygatka) Airport"
    ],
    "city": [
      "Sovetskaya Gavan",
      "Sovetskaya Gavan",
      "Sovetskaya Gavan"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "DYR",
    "translations": [
      "Ugolny Yuri Ryktheu Airport",
      "Ugolny Yuri Ryktheu Airport",
      "Ugolny Yuri Ryktheu Airport"
    ],
    "city": [
      "Anadyr",
      "Anadyr",
      "Anadyr"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "PVS",
    "translations": [
      "Provideniya Bay Airport",
      "Provideniya Bay Airport",
      "Provideniya Bay Airport"
    ],
    "city": [
      "Chukotka",
      "Chukotka",
      "Chukotka"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KPW",
    "translations": [
      "Keperveem Airport",
      "Keperveem Airport",
      "Keperveem Airport"
    ],
    "city": [
      "Keperveem",
      "Keperveem",
      "Keperveem"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "GDX",
    "translations": [
      "Sokol Airport",
      "Sokol Airport",
      "Sokol Airport"
    ],
    "city": [
      "Magadan",
      "Magadan",
      "Magadan"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KVM",
    "translations": [
      "Markovo Airport",
      "Markovo Airport",
      "Markovo Airport"
    ],
    "city": [
      "Markovo",
      "Markovo",
      "Markovo"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "PWE",
    "translations": [
      "Pevek Airport",
      "Pevek Airport",
      "Pevek Airport"
    ],
    "city": [
      "Apapelgino",
      "Apapelgino",
      "Apapelgino"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SWV",
    "translations": [
      "Severo-Evensk Airport",
      "Severo-Evensk Airport",
      "Severo-Evensk Airport"
    ],
    "city": [
      "Evensk",
      "Evensk",
      "Evensk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BQG",
    "translations": [
      "Bogorodskoye Airport",
      "Bogorodskoye Airport",
      "Bogorodskoye Airport"
    ],
    "city": [
      "Bogorodskoye",
      "Bogorodskoye",
      "Bogorodskoye"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NLI",
    "translations": [
      "Nikolayevsk-na-Amure Airport",
      "Nikolayevsk-na-Amure Airport",
      "Nikolayevsk-na-Amure Airport"
    ],
    "city": [
      "Nikolayevsk-na-Amure Airport",
      "Nikolayevsk-na-Amure Airport",
      "Nikolayevsk-na-Amure Airport"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "OHO",
    "translations": [
      "Okhotsk Airport",
      "Okhotsk Airport",
      "Okhotsk Airport"
    ],
    "city": [
      "Okhotsk",
      "Okhotsk",
      "Okhotsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "PKC",
    "translations": [
      "Yelizovo Airport",
      "Yelizovo Airport",
      "Yelizovo Airport"
    ],
    "city": [
      "Petropavlovsk-Kamchatsky",
      "Petropavlovsk-Kamchatsky",
      "Petropavlovsk-Kamchatsky"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BVV",
    "translations": [
      "Burevestnik Airport",
      "Burevestnik Airport",
      "Burevestnik Airport"
    ],
    "city": [
      "Kurilsk",
      "Kurilsk",
      "Kurilsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "OHH",
    "translations": [
      "Okha Airport",
      "Okha Airport",
      "Okha Airport"
    ],
    "city": [
      "Okha",
      "Okha",
      "Okha"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ITU",
    "translations": [
      "Iturup Airport",
      "Iturup Airport",
      "Iturup Airport"
    ],
    "city": [
      "Kurilsk",
      "Kurilsk",
      "Kurilsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "EKS",
    "translations": [
      "Shakhtyorsk Airport",
      "Shakhtyorsk Airport",
      "Shakhtyorsk Airport"
    ],
    "city": [
      "Shakhtyorsk",
      "Shakhtyorsk",
      "Shakhtyorsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "DEE",
    "translations": [
      "Yuzhno-Kurilsk Mendeleyevo Airport",
      "Yuzhno-Kurilsk Mendeleyevo Airport",
      "Yuzhno-Kurilsk Mendeleyevo Airport"
    ],
    "city": [
      "Yuzhno-Kurilsk",
      "Yuzhno-Kurilsk",
      "Yuzhno-Kurilsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NGK",
    "translations": [
      "Nogliki Airport",
      "Nogliki Airport",
      "Nogliki Airport"
    ],
    "city": [
      "Nogliki",
      "Nogliki",
      "Nogliki"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ZZO",
    "translations": [
      "Zonalnoye Airport",
      "Zonalnoye Airport",
      "Zonalnoye Airport"
    ],
    "city": [
      "Tymovskoye",
      "Tymovskoye",
      "Tymovskoye"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "UUS",
    "translations": [
      "Yuzhno-Sakhalinsk Airport",
      "Yuzhno-Sakhalinsk Airport",
      "Yuzhno-Sakhalinsk Airport"
    ],
    "city": [
      "Yuzhno-Sakhalinsk",
      "Yuzhno-Sakhalinsk",
      "Yuzhno-Sakhalinsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "AEM",
    "translations": [
      "Amgu Airport",
      "Amgu Airport",
      "Amgu Airport"
    ],
    "city": [
      "Amgu",
      "Amgu",
      "Amgu"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ETL",
    "translations": [
      "Svetlaya Airport",
      "Svetlaya Airport",
      "Svetlaya Airport"
    ],
    "city": [
      "Svetlaya",
      "Svetlaya",
      "Svetlaya"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "EDN",
    "translations": [
      "Yedinka Airport",
      "Yedinka Airport",
      "Yedinka Airport"
    ],
    "city": [
      "Yedinka",
      "Yedinka",
      "Yedinka"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KVR",
    "translations": [
      "Kavalerovo Airport",
      "Kavalerovo Airport",
      "Kavalerovo Airport"
    ],
    "city": [
      "Kavalerovo",
      "Kavalerovo",
      "Kavalerovo"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "TLY",
    "translations": [
      "Plastun Airport",
      "Plastun Airport",
      "Plastun Airport"
    ],
    "city": [
      "Plastun",
      "Plastun",
      "Plastun"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NEI",
    "translations": [
      "Terney Airport",
      "Terney Airport",
      "Terney Airport"
    ],
    "city": [
      "Terney",
      "Terney",
      "Terney"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "VVO",
    "translations": [
      "Vladivostok International Airport",
      "Vladivostok International Airport",
      "Vladivostok International Airport"
    ],
    "city": [
      "Artyom",
      "Artyom",
      "Artyom"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "HTA",
    "translations": [
      "Chita-Kadala International Airport",
      "Chita-Kadala International Airport",
      "Chita-Kadala International Airport"
    ],
    "city": [
      "Chita",
      "Chita",
      "Chita"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "CZR",
    "translations": [
      "Chara Airport",
      "Chara Airport",
      "Chara Airport"
    ],
    "city": [
      "Chara",
      "Chara",
      "Chara"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BTK",
    "translations": [
      "Bratsk Airport",
      "Bratsk Airport",
      "Bratsk Airport"
    ],
    "city": [
      "Bratsk",
      "Bratsk",
      "Bratsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "UIK",
    "translations": [
      "Ust-Ilimsk Airport",
      "Ust-Ilimsk Airport",
      "Ust-Ilimsk Airport"
    ],
    "city": [
      "Ust-Ilimsk",
      "Ust-Ilimsk",
      "Ust-Ilimsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "IKT",
    "translations": [
      "Irkutsk International Airport",
      "Irkutsk International Airport",
      "Irkutsk International Airport"
    ],
    "city": [
      "Irkutsk",
      "Irkutsk",
      "Irkutsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ODO",
    "translations": [
      "Bodaybo Airport",
      "Bodaybo Airport",
      "Bodaybo Airport"
    ],
    "city": [
      "Bodaybo",
      "Bodaybo",
      "Bodaybo"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ERG",
    "translations": [
      "Yerbogachen Airport",
      "Yerbogachen Airport",
      "Yerbogachen Airport"
    ],
    "city": [
      "Erbogachen",
      "Erbogachen",
      "Erbogachen"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KCK",
    "translations": [
      "Kirensk Airport",
      "Kirensk Airport",
      "Kirensk Airport"
    ],
    "city": [
      "Kirensk",
      "Kirensk",
      "Kirensk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "RZH",
    "translations": [
      "Preobrazheniye Airport",
      "Preobrazheniye Airport",
      "Preobrazheniye Airport"
    ],
    "city": [
      "Preobrazheniye",
      "Preobrazheniye",
      "Preobrazheniye"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "UKX",
    "translations": [
      "Ust-Kut Airport",
      "Ust-Kut Airport",
      "Ust-Kut Airport"
    ],
    "city": [
      "Ust-Kut",
      "Ust-Kut",
      "Ust-Kut"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NZG",
    "translations": [
      "Nizhneangarsk International Airport",
      "Nizhneangarsk International Airport",
      "Nizhneangarsk International Airport"
    ],
    "city": [
      "Nizhneangarsk",
      "Nizhneangarsk",
      "Nizhneangarsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "UUD",
    "translations": [
      "Baikal International Airport",
      "Baikal International Airport",
      "Baikal International Airport"
    ],
    "city": [
      "Ulan Ude",
      "Ulan Ude",
      "Ulan Ude"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KBP",
    "translations": [
      "Boryspil International Airport",
      "Boryspil International Airport",
      "Boryspil International Airport"
    ],
    "city": [
      "Boryspil",
      "Boryspil",
      "Boryspil"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "KRQ",
    "translations": [
      "Kramatorsk Airport",
      "Kramatorsk Airport",
      "Kramatorsk Airport"
    ],
    "city": [
      "Kramatorsk",
      "Kramatorsk",
      "Kramatorsk"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "MPW",
    "translations": [
      "Mariupol International Airport",
      "Mariupol International Airport",
      "Mariupol International Airport"
    ],
    "city": [
      "Mariupol",
      "Mariupol",
      "Mariupol"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "ERD",
    "translations": [
      "Berdyansk Airport",
      "Berdyansk Airport",
      "Berdyansk Airport"
    ],
    "city": [
      "Berdyansk",
      "Berdyansk",
      "Berdyansk"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "DNK",
    "translations": [
      "Dnipro International Airport",
      "Dnipro International Airport",
      "Dnipro International Airport"
    ],
    "city": [
      "Dnipro",
      "Dnipro",
      "Dnipro"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "OZH",
    "translations": [
      "Zaporizhzhia International Airport",
      "Zaporizhzhia International Airport",
      "Zaporizhzhia International Airport"
    ],
    "city": [
      "Zaporizhia",
      "Zaporizhia",
      "Zaporizhia"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "KWG",
    "translations": [
      "Kryvyi Rih International Airport",
      "Kryvyi Rih International Airport",
      "Kryvyi Rih International Airport"
    ],
    "city": [
      "Kryvyi Rih",
      "Kryvyi Rih",
      "Kryvyi Rih"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "UKS",
    "translations": [
      "Sevastopol International Airport / Belbek Air Base",
      "Sevastopol International Airport / Belbek Air Base",
      "Sevastopol International Airport / Belbek Air Base"
    ],
    "city": [
      "Sevastopol",
      "Sevastopol",
      "Sevastopol"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "SIP",
    "translations": [
      "Simferopol International Airport",
      "Simferopol International Airport",
      "Simferopol International Airport"
    ],
    "city": [
      "Simferopol",
      "Simferopol",
      "Simferopol"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "KHC",
    "translations": [
      "Kerch Airport",
      "Kerch Airport",
      "Kerch Airport"
    ],
    "city": [
      "Kerch",
      "Kerch",
      "Kerch"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "UKH",
    "translations": [
      "Mukhaizna Airport",
      "Mukhaizna Airport",
      "Mukhaizna Airport"
    ],
    "city": [
      "Mukhaizna Oil Field",
      "Mukhaizna Oil Field",
      "Mukhaizna Oil Field"
    ],
    "country": [
      "OM",
      "OM",
      "OM"
    ]
  },
  {
    "iata": "HRK",
    "translations": [
      "Kharkiv International Airport",
      "Kharkiv International Airport",
      "Kharkiv International Airport"
    ],
    "city": [
      "Kharkiv",
      "Kharkiv",
      "Kharkiv"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "PLV",
    "translations": [
      "Suprunovka Airport",
      "Suprunovka Airport",
      "Suprunovka Airport"
    ],
    "city": [
      "Poltava",
      "Poltava",
      "Poltava"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "UMY",
    "translations": [
      "Sumy Airport",
      "Sumy Airport",
      "Sumy Airport"
    ],
    "city": [
      "Sumy",
      "Sumy",
      "Sumy"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "CKC",
    "translations": [
      "Cherkasy International Airport",
      "Cherkasy International Airport",
      "Cherkasy International Airport"
    ],
    "city": [
      "Cherkasy",
      "Cherkasy",
      "Cherkasy"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "KGO",
    "translations": [
      "Kirovograd Airport",
      "Kirovograd Airport",
      "Kirovograd Airport"
    ],
    "city": [
      "Kirovograd",
      "Kirovograd",
      "Kirovograd"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "IEV",
    "translations": [
      "Ihor Sikorsky Kyiv International Airport (Zhuliany)",
      "Ihor Sikorsky Kyiv International Airport (Zhuliany)",
      "Ihor Sikorsky Kyiv International Airport (Zhuliany)"
    ],
    "city": [
      "Kyiv",
      "Kyiv",
      "Kyiv"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "ZTR",
    "translations": [
      "Zhytomyr Airport",
      "Zhytomyr Airport",
      "Zhytomyr Airport"
    ],
    "city": [
      "Zhytomyr",
      "Zhytomyr",
      "Zhytomyr"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "UCK",
    "translations": [
      "Lutsk Airport",
      "Lutsk Airport",
      "Lutsk Airport"
    ],
    "city": [
      "Lutsk",
      "Lutsk",
      "Lutsk"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "HMJ",
    "translations": [
      "Khmelnytskyi Airport",
      "Khmelnytskyi Airport",
      "Khmelnytskyi Airport"
    ],
    "city": [
      "Khmelnytskyi",
      "Khmelnytskyi",
      "Khmelnytskyi"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "IFO",
    "translations": [
      "Ivano-Frankivsk International Airport",
      "Ivano-Frankivsk International Airport",
      "Ivano-Frankivsk International Airport"
    ],
    "city": [
      "Ivano-Frankivsk",
      "Ivano-Frankivsk",
      "Ivano-Frankivsk"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "LWO",
    "translations": [
      "Lviv International Airport",
      "Lviv International Airport",
      "Lviv International Airport"
    ],
    "city": [
      "Lviv",
      "Lviv",
      "Lviv"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "CWC",
    "translations": [
      "Chernivtsi International Airport",
      "Chernivtsi International Airport",
      "Chernivtsi International Airport"
    ],
    "city": [
      "Chernivtsi",
      "Chernivtsi",
      "Chernivtsi"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "RWN",
    "translations": [
      "Rivne International Airport",
      "Rivne International Airport",
      "Rivne International Airport"
    ],
    "city": [
      "Rivne",
      "Rivne",
      "Rivne"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "TNL",
    "translations": [
      "Ternopil International Airport",
      "Ternopil International Airport",
      "Ternopil International Airport"
    ],
    "city": [
      "Ternopil",
      "Ternopil",
      "Ternopil"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "UDJ",
    "translations": [
      "Uzhhorod International Airport",
      "Uzhhorod International Airport",
      "Uzhhorod International Airport"
    ],
    "city": [
      "Uzhhorod",
      "Uzhhorod",
      "Uzhhorod"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "KHE",
    "translations": [
      "Kherson International Airport",
      "Kherson International Airport",
      "Kherson International Airport"
    ],
    "city": [
      "Kherson",
      "Kherson",
      "Kherson"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "NLV",
    "translations": [
      "Mykolaiv International Airport",
      "Mykolaiv International Airport",
      "Mykolaiv International Airport"
    ],
    "city": [
      "Nikolayev",
      "Nikolayev",
      "Nikolayev"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "ODS",
    "translations": [
      "Odessa International Airport",
      "Odessa International Airport",
      "Odessa International Airport"
    ],
    "city": [
      "Odessa",
      "Odessa",
      "Odessa"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "VIN",
    "translations": [
      "Vinnytsia/Gavyryshivka International Airport",
      "Vinnytsia/Gavyryshivka International Airport",
      "Vinnytsia/Gavyryshivka International Airport"
    ],
    "city": [
      "Vinnitsa",
      "Vinnitsa",
      "Vinnitsa"
    ],
    "country": [
      "UA",
      "UA",
      "UA"
    ]
  },
  {
    "iata": "ARH",
    "translations": [
      "Talagi Airport",
      "Talagi Airport",
      "Talagi Airport"
    ],
    "city": [
      "Archangelsk",
      "Archangelsk",
      "Archangelsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "VKV",
    "translations": [
      "Vaskovo Airport",
      "Vaskovo Airport",
      "Vaskovo Airport"
    ],
    "city": [
      "Arkhangelsk",
      "Arkhangelsk",
      "Arkhangelsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "LDG",
    "translations": [
      "Leshukonskoye Airport",
      "Leshukonskoye Airport",
      "Leshukonskoye Airport"
    ],
    "city": [
      "Leshukonskoye",
      "Leshukonskoye",
      "Leshukonskoye"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NNM",
    "translations": [
      "Naryan Mar Airport",
      "Naryan Mar Airport",
      "Naryan Mar Airport"
    ],
    "city": [
      "Naryan Mar",
      "Naryan Mar",
      "Naryan Mar"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "CSH",
    "translations": [
      "Solovki Airport",
      "Solovki Airport",
      "Solovki Airport"
    ],
    "city": [
      "Solovetsky Islands",
      "Solovetsky Islands",
      "Solovetsky Islands"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "AMV",
    "translations": [
      "Amderma Airport",
      "Amderma Airport",
      "Amderma Airport"
    ],
    "city": [
      "Amderma",
      "Amderma",
      "Amderma"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "VRI",
    "translations": [
      "Varandey Airport",
      "Varandey Airport",
      "Varandey Airport"
    ],
    "city": [
      "Varandey",
      "Varandey",
      "Varandey"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KSZ",
    "translations": [
      "Kotlas Airport",
      "Kotlas Airport",
      "Kotlas Airport"
    ],
    "city": [
      "Kotlas",
      "Kotlas",
      "Kotlas"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "LED",
    "translations": [
      "Pulkovo Airport",
      "Pulkovo Airport",
      "Pulkovo Airport"
    ],
    "city": [
      "St. Petersburg",
      "St. Petersburg",
      "St. Petersburg"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "MMK",
    "translations": [
      "Murmansk Airport",
      "Murmansk Airport",
      "Murmansk Airport"
    ],
    "city": [
      "Murmansk",
      "Murmansk",
      "Murmansk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "PKV",
    "translations": [
      "Pskov Airport",
      "Pskov Airport",
      "Pskov Airport"
    ],
    "city": [
      "Pskov",
      "Pskov",
      "Pskov"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "PES",
    "translations": [
      "Petrozavodsk Airport",
      "Petrozavodsk Airport",
      "Petrozavodsk Airport"
    ],
    "city": [
      "Petrozavodsk",
      "Petrozavodsk",
      "Petrozavodsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "CEE",
    "translations": [
      "Cherepovets Airport",
      "Cherepovets Airport",
      "Cherepovets Airport"
    ],
    "city": [
      "Cherepovets",
      "Cherepovets",
      "Cherepovets"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "VUS",
    "translations": [
      "Velikiy Ustyug Airport",
      "Velikiy Ustyug Airport",
      "Velikiy Ustyug Airport"
    ],
    "city": [
      "Velikiy Ustyug",
      "Velikiy Ustyug",
      "Velikiy Ustyug"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "VGD",
    "translations": [
      "Vologda Airport",
      "Vologda Airport",
      "Vologda Airport"
    ],
    "city": [
      "Vologda",
      "Vologda",
      "Vologda"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BQT",
    "translations": [
      "Brest Airport",
      "Brest Airport",
      "Brest Airport"
    ],
    "city": [
      "Brest",
      "Brest",
      "Brest"
    ],
    "country": [
      "BY",
      "BY",
      "BY"
    ]
  },
  {
    "iata": "GME",
    "translations": [
      "Gomel Airport",
      "Gomel Airport",
      "Gomel Airport"
    ],
    "city": [
      "Gomel",
      "Gomel",
      "Gomel"
    ],
    "country": [
      "BY",
      "BY",
      "BY"
    ]
  },
  {
    "iata": "VTB",
    "translations": [
      "Vitebsk Vostochny Airport",
      "Vitebsk Vostochny Airport",
      "Vitebsk Vostochny Airport"
    ],
    "city": [
      "Vitebsk",
      "Vitebsk",
      "Vitebsk"
    ],
    "country": [
      "BY",
      "BY",
      "BY"
    ]
  },
  {
    "iata": "KGD",
    "translations": [
      "Khrabrovo Airport",
      "Khrabrovo Airport",
      "Khrabrovo Airport"
    ],
    "city": [
      "Kaliningrad",
      "Kaliningrad",
      "Kaliningrad"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "GNA",
    "translations": [
      "Hrodna Airport",
      "Hrodna Airport",
      "Hrodna Airport"
    ],
    "city": [
      "Hrodna",
      "Hrodna",
      "Hrodna"
    ],
    "country": [
      "BY",
      "BY",
      "BY"
    ]
  },
  {
    "iata": "MSQ",
    "translations": [
      "Minsk National Airport",
      "Minsk National Airport",
      "Minsk National Airport"
    ],
    "city": [
      "Minsk",
      "Minsk",
      "Minsk"
    ],
    "country": [
      "BY",
      "BY",
      "BY"
    ]
  },
  {
    "iata": "MVQ",
    "translations": [
      "Mogilev Airport",
      "Mogilev Airport",
      "Mogilev Airport"
    ],
    "city": [
      "Mogilev",
      "Mogilev",
      "Mogilev"
    ],
    "country": [
      "BY",
      "BY",
      "BY"
    ]
  },
  {
    "iata": "ABA",
    "translations": [
      "Abakan International Airport",
      "Abakan International Airport",
      "Abakan International Airport"
    ],
    "city": [
      "Abakan",
      "Abakan",
      "Abakan"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BAX",
    "translations": [
      "Barnaul Airport",
      "Barnaul Airport",
      "Barnaul Airport"
    ],
    "city": [
      "Barnaul",
      "Barnaul",
      "Barnaul"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "RGK",
    "translations": [
      "Gorno-Altaysk Airport",
      "Gorno-Altaysk Airport",
      "Gorno-Altaysk Airport"
    ],
    "city": [
      "Gorno-Altaysk",
      "Gorno-Altaysk",
      "Gorno-Altaysk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KEJ",
    "translations": [
      "Kemerovo Airport",
      "Kemerovo Airport",
      "Kemerovo Airport"
    ],
    "city": [
      "Kemerovo",
      "Kemerovo",
      "Kemerovo"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BKA",
    "translations": [
      "Baykit Airport",
      "Baykit Airport",
      "Baykit Airport"
    ],
    "city": [
      "Baykit",
      "Baykit",
      "Baykit"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "EIE",
    "translations": [
      "Yeniseysk Airport",
      "Yeniseysk Airport",
      "Yeniseysk Airport"
    ],
    "city": [
      "Yeniseysk",
      "Yeniseysk",
      "Yeniseysk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "YAE",
    "translations": [
      "Yartsevo Airport",
      "Yartsevo Airport",
      "Yartsevo Airport"
    ],
    "city": [
      "Yartsevo",
      "Yartsevo",
      "Yartsevo"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "TGP",
    "translations": [
      "Podkamennaya Tunguska Airport",
      "Podkamennaya Tunguska Airport",
      "Podkamennaya Tunguska Airport"
    ],
    "city": [
      "Bor",
      "Bor",
      "Bor"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "VEO",
    "translations": [
      "Severo-Yeniseysk Airport",
      "Severo-Yeniseysk Airport",
      "Severo-Yeniseysk Airport"
    ],
    "city": [
      "Severo-Yeniseysk",
      "Severo-Yeniseysk",
      "Severo-Yeniseysk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "GOY",
    "translations": [
      "Tura Mountain Airport",
      "Tura Mountain Airport",
      "Tura Mountain Airport"
    ],
    "city": [
      "Tura",
      "Tura",
      "Tura"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "VAQ",
    "translations": [
      "Vanavara Airport",
      "Vanavara Airport",
      "Vanavara Airport"
    ],
    "city": [
      "Vanavara",
      "Vanavara",
      "Vanavara"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BGS",
    "translations": [
      "Boguchany Airport",
      "Boguchany Airport",
      "Boguchany Airport"
    ],
    "city": [
      "Boguchany",
      "Boguchany",
      "Boguchany"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KNY",
    "translations": [
      "Kodinsk Airport",
      "Kodinsk Airport",
      "Kodinsk Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KJA",
    "translations": [
      "Krasnoyarsk International Airport",
      "Krasnoyarsk International Airport",
      "Krasnoyarsk International Airport"
    ],
    "city": [
      "Krasnoyarsk",
      "Krasnoyarsk",
      "Krasnoyarsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KCY",
    "translations": [
      "Krasnoyarsk Cheremshanka Airport",
      "Krasnoyarsk Cheremshanka Airport",
      "Krasnoyarsk Cheremshanka Airport"
    ],
    "city": [
      "Krasnoyarsk",
      "Krasnoyarsk",
      "Krasnoyarsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ACS",
    "translations": [
      "Achinsk Airport",
      "Achinsk Airport",
      "Achinsk Airport"
    ],
    "city": [
      "Achinsk",
      "Achinsk",
      "Achinsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KYZ",
    "translations": [
      "Kyzyl Airport",
      "Kyzyl Airport",
      "Kyzyl Airport"
    ],
    "city": [
      "Kyzyl",
      "Kyzyl",
      "Kyzyl"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "OVB",
    "translations": [
      "Novosibirsk Tolmachevo Airport",
      "Novosibirsk Tolmachevo Airport",
      "Novosibirsk Tolmachevo Airport"
    ],
    "city": [
      "Novosibirsk",
      "Novosibirsk",
      "Novosibirsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "OMS",
    "translations": [
      "Omsk Central Airport",
      "Omsk Central Airport",
      "Omsk Central Airport"
    ],
    "city": [
      "Omsk",
      "Omsk",
      "Omsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SWT",
    "translations": [
      "Strezhevoy Airport",
      "Strezhevoy Airport",
      "Strezhevoy Airport"
    ],
    "city": [
      "Strezhevoy",
      "Strezhevoy",
      "Strezhevoy"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "TOF",
    "translations": [
      "Bogashevo Airport",
      "Bogashevo Airport",
      "Bogashevo Airport"
    ],
    "city": [
      "Tomsk",
      "Tomsk",
      "Tomsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NOZ",
    "translations": [
      "Spichenkovo Airport",
      "Spichenkovo Airport",
      "Spichenkovo Airport"
    ],
    "city": [
      "Novokuznetsk",
      "Novokuznetsk",
      "Novokuznetsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "DKS",
    "translations": [
      "Dikson Airport",
      "Dikson Airport",
      "Dikson Airport"
    ],
    "city": [
      "Dikson",
      "Dikson",
      "Dikson"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "HTG",
    "translations": [
      "Khatanga Airport",
      "Khatanga Airport",
      "Khatanga Airport"
    ],
    "city": [
      "Khatanga",
      "Khatanga",
      "Khatanga"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SES",
    "translations": [
      "Svetlogorsk Airport",
      "Svetlogorsk Airport",
      "Svetlogorsk Airport"
    ],
    "city": [
      "Svetlogorsk",
      "Svetlogorsk",
      "Svetlogorsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "IAA",
    "translations": [
      "Igarka Airport",
      "Igarka Airport",
      "Igarka Airport"
    ],
    "city": [
      "Igarka",
      "Igarka",
      "Igarka"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NSK",
    "translations": [
      "Norilsk-Alykel Airport",
      "Norilsk-Alykel Airport",
      "Norilsk-Alykel Airport"
    ],
    "city": [
      "Norilsk",
      "Norilsk",
      "Norilsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "THX",
    "translations": [
      "Turukhansk Airport",
      "Turukhansk Airport",
      "Turukhansk Airport"
    ],
    "city": [
      "Turukhansk",
      "Turukhansk",
      "Turukhansk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "AAQ",
    "translations": [
      "Anapa Vityazevo Airport",
      "Anapa Vityazevo Airport",
      "Anapa Vityazevo Airport"
    ],
    "city": [
      "Krasnyi Kurgan",
      "Krasnyi Kurgan",
      "Krasnyi Kurgan"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "GDZ",
    "translations": [
      "Gelendzhik Airport",
      "Gelendzhik Airport",
      "Gelendzhik Airport"
    ],
    "city": [
      "Gelendzhik",
      "Gelendzhik",
      "Gelendzhik"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KRR",
    "translations": [
      "Krasnodar Pashkovsky International Airport",
      "Krasnodar Pashkovsky International Airport",
      "Krasnodar Pashkovsky International Airport"
    ],
    "city": [
      "Krasnodar",
      "Krasnodar",
      "Krasnodar"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "GRV",
    "translations": [
      "Grozny Airport",
      "Grozny Airport",
      "Grozny Airport"
    ],
    "city": [
      "Grozny",
      "Grozny",
      "Grozny"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "MCX",
    "translations": [
      "Makhachkala Uytash International Airport",
      "Makhachkala Uytash International Airport",
      "Makhachkala Uytash International Airport"
    ],
    "city": [
      "Makhachkala",
      "Makhachkala",
      "Makhachkala"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "MRV",
    "translations": [
      "Mineralnyye Vody Airport",
      "Mineralnyye Vody Airport",
      "Mineralnyye Vody Airport"
    ],
    "city": [
      "Mineralnyye Vody",
      "Mineralnyye Vody",
      "Mineralnyye Vody"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NAL",
    "translations": [
      "Nalchik Airport",
      "Nalchik Airport",
      "Nalchik Airport"
    ],
    "city": [
      "Nalchik",
      "Nalchik",
      "Nalchik"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "OGZ",
    "translations": [
      "Vladikavkaz Beslan International Airport",
      "Vladikavkaz Beslan International Airport",
      "Vladikavkaz Beslan International Airport"
    ],
    "city": [
      "Beslan",
      "Beslan",
      "Beslan"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "IGT",
    "translations": [
      "Magas Airport",
      "Magas Airport",
      "Magas Airport"
    ],
    "city": [
      "Sunzha",
      "Sunzha",
      "Sunzha"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "STW",
    "translations": [
      "Stavropol Shpakovskoye Airport",
      "Stavropol Shpakovskoye Airport",
      "Stavropol Shpakovskoye Airport"
    ],
    "city": [
      "Stavropol",
      "Stavropol",
      "Stavropol"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ROV",
    "translations": [
      "Platov International Airport",
      "Platov International Airport",
      "Platov International Airport"
    ],
    "city": [
      "Rostov-on-Don",
      "Rostov-on-Don",
      "Rostov-on-Don"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "TGK",
    "translations": [
      "Taganrog Yuzhny Airport",
      "Taganrog Yuzhny Airport",
      "Taganrog Yuzhny Airport"
    ],
    "city": [
      "Taganrog",
      "Taganrog",
      "Taganrog"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "AER",
    "translations": [
      "Sochi International Airport",
      "Sochi International Airport",
      "Sochi International Airport"
    ],
    "city": [
      "Sochi",
      "Sochi",
      "Sochi"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ASF",
    "translations": [
      "Astrakhan Narimanovo Boris M. Kustodiev International Airport",
      "Astrakhan Narimanovo Boris M. Kustodiev International Airport",
      "Astrakhan Narimanovo Boris M. Kustodiev International Airport"
    ],
    "city": [
      "Astrakhan",
      "Astrakhan",
      "Astrakhan"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ESL",
    "translations": [
      "Elista Airport",
      "Elista Airport",
      "Elista Airport"
    ],
    "city": [
      "Elista",
      "Elista",
      "Elista"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "VOG",
    "translations": [
      "Volgograd International Airport",
      "Volgograd International Airport",
      "Volgograd International Airport"
    ],
    "city": [
      "Volgograd",
      "Volgograd",
      "Volgograd"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BNH",
    "translations": [
      "Cape Air Seaplanes on Boston Harbor Seaplane Base",
      "Cape Air Seaplanes on Boston Harbor Seaplane Base",
      "Cape Air Seaplanes on Boston Harbor Seaplane Base"
    ],
    "city": [
      "Boston",
      "Boston",
      "Boston"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RTL",
    "translations": [
      "Spirit Lake Municipal Airport",
      "Spirit Lake Municipal Airport",
      "Spirit Lake Municipal Airport"
    ],
    "city": [
      "Okoboji",
      "Okoboji",
      "Okoboji"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "FWL",
    "translations": [
      "Farewell Airport",
      "Farewell Airport",
      "Farewell Airport"
    ],
    "city": [
      "Farewell",
      "Farewell",
      "Farewell"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CRO",
    "translations": [
      "Corcoran Airport",
      "Corcoran Airport",
      "Corcoran Airport"
    ],
    "city": [
      "Corcoran",
      "Corcoran",
      "Corcoran"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HLM",
    "translations": [
      "Park Township Airport",
      "Park Township Airport",
      "Park Township Airport"
    ],
    "city": [
      "Holland",
      "Holland",
      "Holland"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "PQS",
    "translations": [
      "Pilot Station Airport",
      "Pilot Station Airport",
      "Pilot Station Airport"
    ],
    "city": [
      "Pilot Station",
      "Pilot Station",
      "Pilot Station"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CEK",
    "translations": [
      "Chelyabinsk Balandino Airport",
      "Chelyabinsk Balandino Airport",
      "Chelyabinsk Balandino Airport"
    ],
    "city": [
      "Chelyabinsk",
      "Chelyabinsk",
      "Chelyabinsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "MQF",
    "translations": [
      "Magnitogorsk International Airport",
      "Magnitogorsk International Airport",
      "Magnitogorsk International Airport"
    ],
    "city": [
      "Magnitogorsk",
      "Magnitogorsk",
      "Magnitogorsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SBT",
    "translations": [
      "Sabetta International Airport",
      "Sabetta International Airport",
      "Sabetta International Airport"
    ],
    "city": [
      "Sabetta",
      "Sabetta",
      "Sabetta"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BVJ",
    "translations": [
      "Bovanenkovo Airport",
      "Bovanenkovo Airport",
      "Bovanenkovo Airport"
    ],
    "city": [
      "Bovanenkovo",
      "Bovanenkovo",
      "Bovanenkovo"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SLY",
    "translations": [
      "Salekhard Airport",
      "Salekhard Airport",
      "Salekhard Airport"
    ],
    "city": [
      "Salekhard",
      "Salekhard",
      "Salekhard"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "YMK",
    "translations": [
      "Mys Kamenny Airport",
      "Mys Kamenny Airport",
      "Mys Kamenny Airport"
    ],
    "city": [
      "Mys Kamennyi",
      "Mys Kamennyi",
      "Mys Kamennyi"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KKQ",
    "translations": [
      "Krasnoselkup Airport",
      "Krasnoselkup Airport",
      "Krasnoselkup Airport"
    ],
    "city": [
      "Krasnoselkup",
      "Krasnoselkup",
      "Krasnoselkup"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "TQL",
    "translations": [
      "Tarko-Sale Airport",
      "Tarko-Sale Airport",
      "Tarko-Sale Airport"
    ],
    "city": [
      "Tarko-Sale",
      "Tarko-Sale",
      "Tarko-Sale"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "UEN",
    "translations": [
      "Urengoy Airport",
      "Urengoy Airport",
      "Urengoy Airport"
    ],
    "city": [
      "Urengoy",
      "Urengoy",
      "Urengoy"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "EZV",
    "translations": [
      "Berezovo Airport",
      "Berezovo Airport",
      "Berezovo Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "HMA",
    "translations": [
      "Khanty Mansiysk Airport",
      "Khanty Mansiysk Airport",
      "Khanty Mansiysk Airport"
    ],
    "city": [
      "Khanty-Mansiysk",
      "Khanty-Mansiysk",
      "Khanty-Mansiysk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "IRM",
    "translations": [
      "Igrim Airport",
      "Igrim Airport",
      "Igrim Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KXD",
    "translations": [
      "Kondinskoye Airport",
      "Kondinskoye Airport",
      "Kondinskoye Airport"
    ],
    "city": [
      "Kondinskoye",
      "Kondinskoye",
      "Kondinskoye"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NYA",
    "translations": [
      "Nyagan Airport",
      "Nyagan Airport",
      "Nyagan Airport"
    ],
    "city": [
      "Nyagan",
      "Nyagan",
      "Nyagan"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "EYK",
    "translations": [
      "Beloyarskiy Airport",
      "Beloyarskiy Airport",
      "Beloyarskiy Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "OVS",
    "translations": [
      "Sovetskiy Airport",
      "Sovetskiy Airport",
      "Sovetskiy Airport"
    ],
    "city": [
      "Sovetskiy",
      "Sovetskiy",
      "Sovetskiy"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "URJ",
    "translations": [
      "Uray Airport",
      "Uray Airport",
      "Uray Airport"
    ],
    "city": [
      "Uray",
      "Uray",
      "Uray"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "IJK",
    "translations": [
      "Izhevsk Airport",
      "Izhevsk Airport",
      "Izhevsk Airport"
    ],
    "city": [
      "Izhevsk",
      "Izhevsk",
      "Izhevsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KVX",
    "translations": [
      "Pobedilovo Airport",
      "Pobedilovo Airport",
      "Pobedilovo Airport"
    ],
    "city": [
      "Kirov",
      "Kirov",
      "Kirov"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NYM",
    "translations": [
      "Nadym Airport",
      "Nadym Airport",
      "Nadym Airport"
    ],
    "city": [
      "Nadym",
      "Nadym",
      "Nadym"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NUX",
    "translations": [
      "Novy Urengoy Airport",
      "Novy Urengoy Airport",
      "Novy Urengoy Airport"
    ],
    "city": [
      "Novy Urengoy",
      "Novy Urengoy",
      "Novy Urengoy"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NJC",
    "translations": [
      "Nizhnevartovsk Airport",
      "Nizhnevartovsk Airport",
      "Nizhnevartovsk Airport"
    ],
    "city": [
      "Nizhnevartovsk",
      "Nizhnevartovsk",
      "Nizhnevartovsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "PEE",
    "translations": [
      "Perm International Airport",
      "Perm International Airport",
      "Perm International Airport"
    ],
    "city": [
      "Perm",
      "Perm",
      "Perm"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KGP",
    "translations": [
      "Kogalym International Airport",
      "Kogalym International Airport",
      "Kogalym International Airport"
    ],
    "city": [
      "Kogalym",
      "Kogalym",
      "Kogalym"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NFG",
    "translations": [
      "Nefteyugansk Airport",
      "Nefteyugansk Airport",
      "Nefteyugansk Airport"
    ],
    "city": [
      "Nefteyugansk",
      "Nefteyugansk",
      "Nefteyugansk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NOJ",
    "translations": [
      "Noyabrsk Airport",
      "Noyabrsk Airport",
      "Noyabrsk Airport"
    ],
    "city": [
      "Noyabrsk",
      "Noyabrsk",
      "Noyabrsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SGC",
    "translations": [
      "Surgut Airport",
      "Surgut Airport",
      "Surgut Airport"
    ],
    "city": [
      "Surgut",
      "Surgut",
      "Surgut"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SVX",
    "translations": [
      "Koltsovo Airport",
      "Koltsovo Airport",
      "Koltsovo Airport"
    ],
    "city": [
      "Yekaterinburg",
      "Yekaterinburg",
      "Yekaterinburg"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "RMZ",
    "translations": [
      "Remezov Airport",
      "Remezov Airport",
      "Remezov Airport"
    ],
    "city": [
      "Tobolsk",
      "Tobolsk",
      "Tobolsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "TOX",
    "translations": [
      "Tobolsk Airport",
      "Tobolsk Airport",
      "Tobolsk Airport"
    ],
    "city": [
      "Tobolsk",
      "Tobolsk",
      "Tobolsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "TJM",
    "translations": [
      "Roshchino International Airport",
      "Roshchino International Airport",
      "Roshchino International Airport"
    ],
    "city": [
      "Tyumen",
      "Tyumen",
      "Tyumen"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KRO",
    "translations": [
      "Kurgan Airport",
      "Kurgan Airport",
      "Kurgan Airport"
    ],
    "city": [
      "Kurgan",
      "Kurgan",
      "Kurgan"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BKN",
    "translations": [
      "Balkanabat Airport",
      "Balkanabat Airport",
      "Balkanabat Airport"
    ],
    "city": [
      "Balkanabat",
      "Balkanabat",
      "Balkanabat"
    ],
    "country": [
      "TM",
      "TM",
      "TM"
    ]
  },
  {
    "iata": "GMV",
    "translations": [
      "Monument Valley Airport",
      "Monument Valley Airport",
      "Monument Valley Airport"
    ],
    "city": [
      "Oljato-Monument Valley",
      "Oljato-Monument Valley",
      "Oljato-Monument Valley"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ASB",
    "translations": [
      "Ashgabat International Airport",
      "Ashgabat International Airport",
      "Ashgabat International Airport"
    ],
    "city": [
      "Ashgabat",
      "Ashgabat",
      "Ashgabat"
    ],
    "country": [
      "TM",
      "TM",
      "TM"
    ]
  },
  {
    "iata": "KEA",
    "translations": [
      "Kerki Airport",
      "Kerki Airport",
      "Kerki Airport"
    ],
    "city": [
      "Kerki",
      "Kerki",
      "Kerki"
    ],
    "country": [
      "TM",
      "TM",
      "TM"
    ]
  },
  {
    "iata": "KRW",
    "translations": [
      "Turkmenbashi International Airport",
      "Turkmenbashi International Airport",
      "Turkmenbashi International Airport"
    ],
    "city": [
      "Turkmenbashi",
      "Turkmenbashi",
      "Turkmenbashi"
    ],
    "country": [
      "TM",
      "TM",
      "TM"
    ]
  },
  {
    "iata": "MYP",
    "translations": [
      "Mary International Airport",
      "Mary International Airport",
      "Mary International Airport"
    ],
    "city": [
      "Mary",
      "Mary",
      "Mary"
    ],
    "country": [
      "TM",
      "TM",
      "TM"
    ]
  },
  {
    "iata": "TAZ",
    "translations": [
      "Daşoguz Airport",
      "Daşoguz Airport",
      "Daşoguz Airport"
    ],
    "city": [
      "Daşoguz",
      "Daşoguz",
      "Daşoguz"
    ],
    "country": [
      "TM",
      "TM",
      "TM"
    ]
  },
  {
    "iata": "CRZ",
    "translations": [
      "Türkmenabat International Airport",
      "Türkmenabat International Airport",
      "Türkmenabat International Airport"
    ],
    "city": [
      "Türkmenabat",
      "Türkmenabat",
      "Türkmenabat"
    ],
    "country": [
      "TM",
      "TM",
      "TM"
    ]
  },
  {
    "iata": "DYU",
    "translations": [
      "Dushanbe International Airport",
      "Dushanbe International Airport",
      "Dushanbe International Airport"
    ],
    "city": [
      "Dushanbe",
      "Dushanbe",
      "Dushanbe"
    ],
    "country": [
      "TJ",
      "TJ",
      "TJ"
    ]
  },
  {
    "iata": "TJU",
    "translations": [
      "Kulob Airport",
      "Kulob Airport",
      "Kulob Airport"
    ],
    "city": [
      "Kulyab",
      "Kulyab",
      "Kulyab"
    ],
    "country": [
      "TJ",
      "TJ",
      "TJ"
    ]
  },
  {
    "iata": "LBD",
    "translations": [
      "Khujand Airport",
      "Khujand Airport",
      "Khujand Airport"
    ],
    "city": [
      "Khujand",
      "Khujand",
      "Khujand"
    ],
    "country": [
      "TJ",
      "TJ",
      "TJ"
    ]
  },
  {
    "iata": "KQT",
    "translations": [
      "Qurghonteppa International Airport",
      "Qurghonteppa International Airport",
      "Qurghonteppa International Airport"
    ],
    "city": [
      "Kurgan-Tyube",
      "Kurgan-Tyube",
      "Kurgan-Tyube"
    ],
    "country": [
      "TJ",
      "TJ",
      "TJ"
    ]
  },
  {
    "iata": "NMA",
    "translations": [
      "Namangan Airport",
      "Namangan Airport",
      "Namangan Airport"
    ],
    "city": [
      "Namangan",
      "Namangan",
      "Namangan"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "AZN",
    "translations": [
      "Andizhan Airport",
      "Andizhan Airport",
      "Andizhan Airport"
    ],
    "city": [
      "Andizhan",
      "Andizhan",
      "Andizhan"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "FEG",
    "translations": [
      "Fergana International Airport",
      "Fergana International Airport",
      "Fergana International Airport"
    ],
    "city": [
      "Fergana",
      "Fergana",
      "Fergana"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "OQN",
    "translations": [
      "Kokand Airport",
      "Kokand Airport",
      "Kokand Airport"
    ],
    "city": [
      "Kokand",
      "Kokand",
      "Kokand"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "MOK",
    "translations": [
      "Muynak Airport",
      "Muynak Airport",
      "Muynak Airport"
    ],
    "city": [
      "Muynak",
      "Muynak",
      "Muynak"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "NCU",
    "translations": [
      "Nukus Airport",
      "Nukus Airport",
      "Nukus Airport"
    ],
    "city": [
      "Nukus",
      "Nukus",
      "Nukus"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "UGC",
    "translations": [
      "Urgench Airport",
      "Urgench Airport",
      "Urgench Airport"
    ],
    "city": [
      "Urgench",
      "Urgench",
      "Urgench"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "NVI",
    "translations": [
      "Navoi Airport",
      "Navoi Airport",
      "Navoi Airport"
    ],
    "city": [
      "Navoi",
      "Navoi",
      "Navoi"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "BHK",
    "translations": [
      "Bukhara International Airport",
      "Bukhara International Airport",
      "Bukhara International Airport"
    ],
    "city": [
      "Bukhara",
      "Bukhara",
      "Bukhara"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "KSQ",
    "translations": [
      "Karshi Airport",
      "Karshi Airport",
      "Karshi Airport"
    ],
    "city": [
      "Karshi",
      "Karshi",
      "Karshi"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "AFS",
    "translations": [
      "Sugraly Airport",
      "Sugraly Airport",
      "Sugraly Airport"
    ],
    "city": [
      "Zarafshan",
      "Zarafshan",
      "Zarafshan"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "SKD",
    "translations": [
      "Samarkand Airport",
      "Samarkand Airport",
      "Samarkand Airport"
    ],
    "city": [
      "Samarkand",
      "Samarkand",
      "Samarkand"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "TMJ",
    "translations": [
      "Termez Airport",
      "Termez Airport",
      "Termez Airport"
    ],
    "city": [
      "Termez",
      "Termez",
      "Termez"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "TAS",
    "translations": [
      "Tashkent International Airport",
      "Tashkent International Airport",
      "Tashkent International Airport"
    ],
    "city": [
      "Tashkent",
      "Tashkent",
      "Tashkent"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "OMN",
    "translations": [
      "Zomin Airport",
      "Zomin Airport",
      "Zomin Airport"
    ],
    "city": [
      "Zaamin",
      "Zaamin",
      "Zaamin"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "UTU",
    "translations": [
      "Ustupu Airport",
      "Ustupu Airport",
      "Ustupu Airport"
    ],
    "city": [
      "Ustupu",
      "Ustupu",
      "Ustupu"
    ],
    "country": [
      "PA",
      "PA",
      "PA"
    ]
  },
  {
    "iata": "KMW",
    "translations": [
      "Kostroma Sokerkino Airport",
      "Kostroma Sokerkino Airport",
      "Kostroma Sokerkino Airport"
    ],
    "city": [
      "Kostroma",
      "Kostroma",
      "Kostroma"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KLF",
    "translations": [
      "Grabtsevo Airport",
      "Grabtsevo Airport",
      "Grabtsevo Airport"
    ],
    "city": [
      "Kaluga",
      "Kaluga",
      "Kaluga"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "IWA",
    "translations": [
      "Ivanovo South Airport",
      "Ivanovo South Airport",
      "Ivanovo South Airport"
    ],
    "city": [
      "Ivanovo",
      "Ivanovo",
      "Ivanovo"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "RYB",
    "translations": [
      "Staroselye Airport",
      "Staroselye Airport",
      "Staroselye Airport"
    ],
    "city": [
      "Rybinsk",
      "Rybinsk",
      "Rybinsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BZK",
    "translations": [
      "Bryansk Airport",
      "Bryansk Airport",
      "Bryansk Airport"
    ],
    "city": [
      "Bryansk",
      "Bryansk",
      "Bryansk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ZIA",
    "translations": [
      "Zhukovsky International Airport",
      "Zhukovsky International Airport",
      "Zhukovsky International Airport"
    ],
    "city": [
      "Moscow",
      "Moscow",
      "Moscow"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "DME",
    "translations": [
      "Domodedovo International Airport",
      "Domodedovo International Airport",
      "Domodedovo International Airport"
    ],
    "city": [
      "Moscow",
      "Moscow",
      "Moscow"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "IAR",
    "translations": [
      "Tunoshna Airport",
      "Tunoshna Airport",
      "Tunoshna Airport"
    ],
    "city": [
      "Tunoshna",
      "Tunoshna",
      "Tunoshna"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SVO",
    "translations": [
      "Sheremetyevo International Airport",
      "Sheremetyevo International Airport",
      "Sheremetyevo International Airport"
    ],
    "city": [
      "Moscow",
      "Moscow",
      "Moscow"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KLD",
    "translations": [
      "Migalovo Air Base",
      "Migalovo Air Base",
      "Migalovo Air Base"
    ],
    "city": [
      "Tver",
      "Tver",
      "Tver"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "OSF",
    "translations": [
      "Ostafyevo International Airport",
      "Ostafyevo International Airport",
      "Ostafyevo International Airport"
    ],
    "city": [
      "Moscow",
      "Moscow",
      "Moscow"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "CKL",
    "translations": [
      "Chkalovskiy Air Base",
      "Chkalovskiy Air Base",
      "Chkalovskiy Air Base"
    ],
    "city": [
      "Moscow",
      "Moscow",
      "Moscow"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "EGO",
    "translations": [
      "Belgorod International Airport",
      "Belgorod International Airport",
      "Belgorod International Airport"
    ],
    "city": [
      "Belgorod",
      "Belgorod",
      "Belgorod"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "URS",
    "translations": [
      "Kursk East Airport",
      "Kursk East Airport",
      "Kursk East Airport"
    ],
    "city": [
      "Kursk",
      "Kursk",
      "Kursk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "LPK",
    "translations": [
      "Lipetsk Airport",
      "Lipetsk Airport",
      "Lipetsk Airport"
    ],
    "city": [
      "Lipetsk",
      "Lipetsk",
      "Lipetsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "VOZ",
    "translations": [
      "Voronezh International Airport",
      "Voronezh International Airport",
      "Voronezh International Airport"
    ],
    "city": [
      "Voronezh",
      "Voronezh",
      "Voronezh"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "TBW",
    "translations": [
      "Donskoye Airport",
      "Donskoye Airport",
      "Donskoye Airport"
    ],
    "city": [
      "Tambov",
      "Tambov",
      "Tambov"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "UUU",
    "translations": [
      "Manumu Airport",
      "Manumu Airport",
      "Manumu Airport"
    ],
    "city": [
      "Manumu",
      "Manumu",
      "Manumu"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "VKO",
    "translations": [
      "Vnukovo International Airport",
      "Vnukovo International Airport",
      "Vnukovo International Airport"
    ],
    "city": [
      "Moscow",
      "Moscow",
      "Moscow"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "UCT",
    "translations": [
      "Ukhta Airport",
      "Ukhta Airport",
      "Ukhta Airport"
    ],
    "city": [
      "Ukhta",
      "Ukhta",
      "Ukhta"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "INA",
    "translations": [
      "Inta Airport",
      "Inta Airport",
      "Inta Airport"
    ],
    "city": [
      "Inta",
      "Inta",
      "Inta"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "PEX",
    "translations": [
      "Pechora Airport",
      "Pechora Airport",
      "Pechora Airport"
    ],
    "city": [
      "Pechora",
      "Pechora",
      "Pechora"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "USK",
    "translations": [
      "Usinsk Airport",
      "Usinsk Airport",
      "Usinsk Airport"
    ],
    "city": [
      "Usinsk",
      "Usinsk",
      "Usinsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "VKT",
    "translations": [
      "Vorkuta Airport",
      "Vorkuta Airport",
      "Vorkuta Airport"
    ],
    "city": [
      "Vorkuta",
      "Vorkuta",
      "Vorkuta"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "UTS",
    "translations": [
      "Ust-Tsylma Airport",
      "Ust-Tsylma Airport",
      "Ust-Tsylma Airport"
    ],
    "city": [
      "Ust-Tsylma",
      "Ust-Tsylma",
      "Ust-Tsylma"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SCW",
    "translations": [
      "Syktyvkar Airport",
      "Syktyvkar Airport",
      "Syktyvkar Airport"
    ],
    "city": [
      "Syktyvkar",
      "Syktyvkar",
      "Syktyvkar"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "GOJ",
    "translations": [
      "Nizhny Novgorod / Strigino International Airport",
      "Nizhny Novgorod / Strigino International Airport",
      "Nizhny Novgorod / Strigino International Airport"
    ],
    "city": [
      "Nizhny Novgorod",
      "Nizhny Novgorod",
      "Nizhny Novgorod"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "UUA",
    "translations": [
      "Bugulma Airport",
      "Bugulma Airport",
      "Bugulma Airport"
    ],
    "city": [
      "Bugulma",
      "Bugulma",
      "Bugulma"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KZN",
    "translations": [
      "Kazan International Airport",
      "Kazan International Airport",
      "Kazan International Airport"
    ],
    "city": [
      "Kazan",
      "Kazan",
      "Kazan"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "NBC",
    "translations": [
      "Begishevo Airport",
      "Begishevo Airport",
      "Begishevo Airport"
    ],
    "city": [
      "Nizhnekamsk",
      "Nizhnekamsk",
      "Nizhnekamsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "JOK",
    "translations": [
      "Yoshkar-Ola Airport",
      "Yoshkar-Ola Airport",
      "Yoshkar-Ola Airport"
    ],
    "city": [
      "Yoshkar-Ola",
      "Yoshkar-Ola",
      "Yoshkar-Ola"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "CSY",
    "translations": [
      "Cheboksary Airport",
      "Cheboksary Airport",
      "Cheboksary Airport"
    ],
    "city": [
      "Cheboksary",
      "Cheboksary",
      "Cheboksary"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ULV",
    "translations": [
      "Ulyanovsk Baratayevka Airport",
      "Ulyanovsk Baratayevka Airport",
      "Ulyanovsk Baratayevka Airport"
    ],
    "city": [
      "Ulyanovsk",
      "Ulyanovsk",
      "Ulyanovsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "ULY",
    "translations": [
      "Ulyanovsk East Airport",
      "Ulyanovsk East Airport",
      "Ulyanovsk East Airport"
    ],
    "city": [
      "Cherdakly",
      "Cherdakly",
      "Cherdakly"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "REN",
    "translations": [
      "Orenburg Central Airport",
      "Orenburg Central Airport",
      "Orenburg Central Airport"
    ],
    "city": [
      "Orenburg",
      "Orenburg",
      "Orenburg"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "OSW",
    "translations": [
      "Orsk Airport",
      "Orsk Airport",
      "Orsk Airport"
    ],
    "city": [
      "Orsk",
      "Orsk",
      "Orsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "PEZ",
    "translations": [
      "Penza Airport",
      "Penza Airport",
      "Penza Airport"
    ],
    "city": [
      "Penza",
      "Penza",
      "Penza"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "SKX",
    "translations": [
      "Saransk Airport",
      "Saransk Airport",
      "Saransk Airport"
    ],
    "city": [
      "Saransk",
      "Saransk",
      "Saransk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BWO",
    "translations": [
      "Balakovo Airport",
      "Balakovo Airport",
      "Balakovo Airport"
    ],
    "city": [
      "Balakovo",
      "Balakovo",
      "Balakovo"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "GSV",
    "translations": [
      "Gagarin International Airport",
      "Gagarin International Airport",
      "Gagarin International Airport"
    ],
    "city": [
      "Saratov",
      "Saratov",
      "Saratov"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "BCX",
    "translations": [
      "Beloretsk Airport",
      "Beloretsk Airport",
      "Beloretsk Airport"
    ],
    "city": [
      "Beloretsk",
      "Beloretsk",
      "Beloretsk"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "OKT",
    "translations": [
      "Oktyabrskiy Airport",
      "Oktyabrskiy Airport",
      "Oktyabrskiy Airport"
    ],
    "city": [
      "Kzyl-Yar",
      "Kzyl-Yar",
      "Kzyl-Yar"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "UFA",
    "translations": [
      "Ufa International Airport",
      "Ufa International Airport",
      "Ufa International Airport"
    ],
    "city": [
      "Ufa",
      "Ufa",
      "Ufa"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "KUF",
    "translations": [
      "Kurumoch International Airport",
      "Kurumoch International Airport",
      "Kurumoch International Airport"
    ],
    "city": [
      "Samara",
      "Samara",
      "Samara"
    ],
    "country": [
      "RU",
      "RU",
      "RU"
    ]
  },
  {
    "iata": "RBZ",
    "translations": [
      "Shahrisabz Southwest Airport",
      "Shahrisabz Southwest Airport",
      "Shahrisabz Southwest Airport"
    ],
    "city": [
      "Shahrisabz",
      "Shahrisabz",
      "Shahrisabz"
    ],
    "country": [
      "UZ",
      "UZ",
      "UZ"
    ]
  },
  {
    "iata": "UZM",
    "translations": [
      "Hope Bay Aerodrome",
      "Hope Bay Aerodrome",
      "Hope Bay Aerodrome"
    ],
    "city": [
      "Hope Bay",
      "Hope Bay",
      "Hope Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "UZR",
    "translations": [
      "Urzhar Airport",
      "Urzhar Airport",
      "Urzhar Airport"
    ],
    "city": [
      "Urzhar",
      "Urzhar",
      "Urzhar"
    ],
    "country": [
      "KZ",
      "KZ",
      "KZ"
    ]
  },
  {
    "iata": "REW",
    "translations": [
      "Rewa Airport, Chorhata, REWA",
      "Rewa Airport, Chorhata, REWA",
      "Rewa Airport, Chorhata, REWA"
    ],
    "city": [
      "Rewa",
      "Rewa",
      "Rewa"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "DIU",
    "translations": [
      "Diu Airport",
      "Diu Airport",
      "Diu Airport"
    ],
    "city": [
      "Diu",
      "Diu",
      "Diu"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "GDB",
    "translations": [
      "Gondia Airport",
      "Gondia Airport",
      "Gondia Airport"
    ],
    "city": [
      "Gondia",
      "Gondia",
      "Gondia"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "AMD",
    "translations": [
      "Sardar Vallabh Bhai Patel International Airport",
      "Sardar Vallabh Bhai Patel International Airport",
      "Sardar Vallabh Bhai Patel International Airport"
    ],
    "city": [
      "Ahmedabad",
      "Ahmedabad",
      "Ahmedabad"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "AKD",
    "translations": [
      "Akola Airport",
      "Akola Airport",
      "Akola Airport"
    ],
    "city": [
      "Akola",
      "Akola",
      "Akola"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXU",
    "translations": [
      "Aurangabad Airport",
      "Aurangabad Airport",
      "Aurangabad Airport"
    ],
    "city": [
      "Aurangabad",
      "Aurangabad",
      "Aurangabad"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "BOM",
    "translations": [
      "Chhatrapati Shivaji International Airport",
      "Chhatrapati Shivaji International Airport",
      "Chhatrapati Shivaji International Airport"
    ],
    "city": [
      "Mumbai",
      "Mumbai",
      "Mumbai"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "BHJ",
    "translations": [
      "Bhuj Airport",
      "Bhuj Airport",
      "Bhuj Airport"
    ],
    "city": [
      "Bhuj",
      "Bhuj",
      "Bhuj"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXG",
    "translations": [
      "Belagavi Airport",
      "Belagavi Airport",
      "Belagavi Airport"
    ],
    "city": [
      "Belgaum",
      "Belgaum",
      "Belgaum"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "BDQ",
    "translations": [
      "Vadodara Airport",
      "Vadodara Airport",
      "Vadodara Airport"
    ],
    "city": [
      "Vadodara",
      "Vadodara",
      "Vadodara"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "BHO",
    "translations": [
      "Raja Bhoj International Airport",
      "Raja Bhoj International Airport",
      "Raja Bhoj International Airport"
    ],
    "city": [
      "Bhopal",
      "Bhopal",
      "Bhopal"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "BHU",
    "translations": [
      "Bhavnagar Airport",
      "Bhavnagar Airport",
      "Bhavnagar Airport"
    ],
    "city": [
      "Bhavnagar",
      "Bhavnagar",
      "Bhavnagar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "NMB",
    "translations": [
      "Daman Airport",
      "Daman Airport",
      "Daman Airport"
    ],
    "city": [
      "Daman",
      "Daman",
      "Daman"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "GUX",
    "translations": [
      "Guna Airport",
      "Guna Airport",
      "Guna Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "HBX",
    "translations": [
      "Hubli Airport",
      "Hubli Airport",
      "Hubli Airport"
    ],
    "city": [
      "Hubli",
      "Hubli",
      "Hubli"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "HSR",
    "translations": [
      "Rajkot International Airport",
      "Rajkot International Airport",
      "Rajkot International Airport"
    ],
    "city": [
      "Rajkot",
      "Rajkot",
      "Rajkot"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IDR",
    "translations": [
      "Devi Ahilyabai Holkar Airport",
      "Devi Ahilyabai Holkar Airport",
      "Devi Ahilyabai Holkar Airport"
    ],
    "city": [
      "Indore",
      "Indore",
      "Indore"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "JLR",
    "translations": [
      "Jabalpur Airport",
      "Jabalpur Airport",
      "Jabalpur Airport"
    ],
    "city": [
      "Jabalpur",
      "Jabalpur",
      "Jabalpur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "JLG",
    "translations": [
      "Jalgaon Airport",
      "Jalgaon Airport",
      "Jalgaon Airport"
    ],
    "city": [
      "Jalgaon",
      "Jalgaon",
      "Jalgaon"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "JGA",
    "translations": [
      "Jamnagar Airport",
      "Jamnagar Airport",
      "Jamnagar Airport"
    ],
    "city": [
      "Jamnagar",
      "Jamnagar",
      "Jamnagar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXY",
    "translations": [
      "Kandla Airport",
      "Kandla Airport",
      "Kandla Airport"
    ],
    "city": [
      "Kandla",
      "Kandla",
      "Kandla"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "HJR",
    "translations": [
      "Khajuraho Airport",
      "Khajuraho Airport",
      "Khajuraho Airport"
    ],
    "city": [
      "Khajuraho",
      "Khajuraho",
      "Khajuraho"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "KLH",
    "translations": [
      "Kolhapur Airport",
      "Kolhapur Airport",
      "Kolhapur Airport"
    ],
    "city": [
      "Kolhapur",
      "Kolhapur",
      "Kolhapur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXK",
    "translations": [
      "Keshod Airport",
      "Keshod Airport",
      "Keshod Airport"
    ],
    "city": [
      "Keshod",
      "Keshod",
      "Keshod"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "LTU",
    "translations": [
      "Murod Kond Airport",
      "Murod Kond Airport",
      "Murod Kond Airport"
    ],
    "city": [
      "Latur",
      "Latur",
      "Latur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "NDC",
    "translations": [
      "Nanded Airport",
      "Nanded Airport",
      "Nanded Airport"
    ],
    "city": [
      "Nanded",
      "Nanded",
      "Nanded"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "NAG",
    "translations": [
      "Dr. Babasaheb Ambedkar International Airport",
      "Dr. Babasaheb Ambedkar International Airport",
      "Dr. Babasaheb Ambedkar International Airport"
    ],
    "city": [
      "Nagpur",
      "Nagpur",
      "Nagpur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "ISK",
    "translations": [
      "Nashik Airport",
      "Nashik Airport",
      "Nashik Airport"
    ],
    "city": [
      "Nasik",
      "Nasik",
      "Nasik"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "PNQ",
    "translations": [
      "Pune Airport / Lohagaon Air Force Station",
      "Pune Airport / Lohagaon Air Force Station",
      "Pune Airport / Lohagaon Air Force Station"
    ],
    "city": [
      "Pune",
      "Pune",
      "Pune"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "PBD",
    "translations": [
      "Porbandar Airport",
      "Porbandar Airport",
      "Porbandar Airport"
    ],
    "city": [
      "Porbandar",
      "Porbandar",
      "Porbandar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "RTC",
    "translations": [
      "Ratnagiri Airport",
      "Ratnagiri Airport",
      "Ratnagiri Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "RAJ",
    "translations": [
      "Rajkot Airport",
      "Rajkot Airport",
      "Rajkot Airport"
    ],
    "city": [
      "Rajkot",
      "Rajkot",
      "Rajkot"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "RPR",
    "translations": [
      "Swami Vivekananda Airport",
      "Swami Vivekananda Airport",
      "Swami Vivekananda Airport"
    ],
    "city": [
      "Raipur",
      "Raipur",
      "Raipur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "SAG",
    "translations": [
      "Shirdi Airport",
      "Shirdi Airport",
      "Shirdi Airport"
    ],
    "city": [
      "Kakadi",
      "Kakadi",
      "Kakadi"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "SSE",
    "translations": [
      "Solapur Airport",
      "Solapur Airport",
      "Solapur Airport"
    ],
    "city": [
      "Solapur",
      "Solapur",
      "Solapur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "STV",
    "translations": [
      "Surat Airport",
      "Surat Airport",
      "Surat Airport"
    ],
    "city": [
      "Surat",
      "Surat",
      "Surat"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "UDR",
    "translations": [
      "Maharana Pratap Airport",
      "Maharana Pratap Airport",
      "Maharana Pratap Airport"
    ],
    "city": [
      "Udaipur",
      "Udaipur",
      "Udaipur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "CMB",
    "translations": [
      "Bandaranaike International Colombo Airport",
      "Bandaranaike International Colombo Airport",
      "Bandaranaike International Colombo Airport"
    ],
    "city": [
      "Colombo",
      "Colombo",
      "Colombo"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "ACJ",
    "translations": [
      "Anuradhapura Airport",
      "Anuradhapura Airport",
      "Anuradhapura Airport"
    ],
    "city": [
      "Anuradhapura",
      "Anuradhapura",
      "Anuradhapura"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "BTC",
    "translations": [
      "Batticaloa Airport",
      "Batticaloa Airport",
      "Batticaloa Airport"
    ],
    "city": [
      "Batticaloa",
      "Batticaloa",
      "Batticaloa"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "RML",
    "translations": [
      "Colombo Ratmalana Airport",
      "Colombo Ratmalana Airport",
      "Colombo Ratmalana Airport"
    ],
    "city": [
      "Colombo",
      "Colombo",
      "Colombo"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "ADP",
    "translations": [
      "Ampara Airport",
      "Ampara Airport",
      "Ampara Airport"
    ],
    "city": [
      "Ampara",
      "Ampara",
      "Ampara"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "HIM",
    "translations": [
      "Hingurakgoda Air Force Base",
      "Hingurakgoda Air Force Base",
      "Hingurakgoda Air Force Base"
    ],
    "city": [
      "Polonnaruwa Town",
      "Polonnaruwa Town",
      "Polonnaruwa Town"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "JAF",
    "translations": [
      "Jaffna International Airport",
      "Jaffna International Airport",
      "Jaffna International Airport"
    ],
    "city": [
      "Jaffna",
      "Jaffna",
      "Jaffna"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "KCT",
    "translations": [
      "Koggala Airport",
      "Koggala Airport",
      "Koggala Airport"
    ],
    "city": [
      "Galle",
      "Galle",
      "Galle"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "KTY",
    "translations": [
      "Katukurunda Air Force Base",
      "Katukurunda Air Force Base",
      "Katukurunda Air Force Base"
    ],
    "city": [
      "Kalutara",
      "Kalutara",
      "Kalutara"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "GIU",
    "translations": [
      "Sigiriya Air Force Base",
      "Sigiriya Air Force Base",
      "Sigiriya Air Force Base"
    ],
    "city": [
      "Sigiriya",
      "Sigiriya",
      "Sigiriya"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "TRR",
    "translations": [
      "China Bay Airport",
      "China Bay Airport",
      "China Bay Airport"
    ],
    "city": [
      "Trincomalee",
      "Trincomalee",
      "Trincomalee"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "WRZ",
    "translations": [
      "Weerawila Airport",
      "Weerawila Airport",
      "Weerawila Airport"
    ],
    "city": [
      "Weerawila",
      "Weerawila",
      "Weerawila"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "HRI",
    "translations": [
      "Mattala Rajapaksa International Airport",
      "Mattala Rajapaksa International Airport",
      "Mattala Rajapaksa International Airport"
    ],
    "city": [
      "Mattala",
      "Mattala",
      "Mattala"
    ],
    "country": [
      "LK",
      "LK",
      "LK"
    ]
  },
  {
    "iata": "BBM",
    "translations": [
      "Battambang Airport",
      "Battambang Airport",
      "Battambang Airport"
    ],
    "city": [
      "Battambang",
      "Battambang",
      "Battambang"
    ],
    "country": [
      "KH",
      "KH",
      "KH"
    ]
  },
  {
    "iata": "KZC",
    "translations": [
      "Kampong Chhnang Airport",
      "Kampong Chhnang Airport",
      "Kampong Chhnang Airport"
    ],
    "city": [
      "Kampong Chhnang",
      "Kampong Chhnang",
      "Kampong Chhnang"
    ],
    "country": [
      "KH",
      "KH",
      "KH"
    ]
  },
  {
    "iata": "KKZ",
    "translations": [
      "Koh Kong Airport",
      "Koh Kong Airport",
      "Koh Kong Airport"
    ],
    "city": [
      "Krong Khemara Phoumin",
      "Krong Khemara Phoumin",
      "Krong Khemara Phoumin"
    ],
    "country": [
      "KH",
      "KH",
      "KH"
    ]
  },
  {
    "iata": "MWV",
    "translations": [
      "Mondulkiri Airport",
      "Mondulkiri Airport",
      "Mondulkiri Airport"
    ],
    "city": [
      "Sen Monorom",
      "Sen Monorom",
      "Sen Monorom"
    ],
    "country": [
      "KH",
      "KH",
      "KH"
    ]
  },
  {
    "iata": "PNH",
    "translations": [
      "Phnom Penh International Airport",
      "Phnom Penh International Airport",
      "Phnom Penh International Airport"
    ],
    "city": [
      "Phnom Penh (Pou Senchey)",
      "Phnom Penh (Pou Senchey)",
      "Phnom Penh (Pou Senchey)"
    ],
    "country": [
      "KH",
      "KH",
      "KH"
    ]
  },
  {
    "iata": "RBE",
    "translations": [
      "Ratanakiri Airport",
      "Ratanakiri Airport",
      "Ratanakiri Airport"
    ],
    "city": [
      "Ratanakiri",
      "Ratanakiri",
      "Ratanakiri"
    ],
    "country": [
      "KH",
      "KH",
      "KH"
    ]
  },
  {
    "iata": "SAI",
    "translations": [
      "Siem Reap-Angkor International Airport",
      "Siem Reap-Angkor International Airport",
      "Siem Reap-Angkor International Airport"
    ],
    "city": [
      "Siem Reap",
      "Siem Reap",
      "Siem Reap"
    ],
    "country": [
      "KH",
      "KH",
      "KH"
    ]
  },
  {
    "iata": "TNX",
    "translations": [
      "Stung Treng Airport",
      "Stung Treng Airport",
      "Stung Treng Airport"
    ],
    "city": [
      "Stung Treng",
      "Stung Treng",
      "Stung Treng"
    ],
    "country": [
      "KH",
      "KH",
      "KH"
    ]
  },
  {
    "iata": "KOS",
    "translations": [
      "Sihanoukville International Airport",
      "Sihanoukville International Airport",
      "Sihanoukville International Airport"
    ],
    "city": [
      "Preah Sihanouk",
      "Preah Sihanouk",
      "Preah Sihanouk"
    ],
    "country": [
      "KH",
      "KH",
      "KH"
    ]
  },
  {
    "iata": "KZD",
    "translations": [
      "Krakor Airport",
      "Krakor Airport",
      "Krakor Airport"
    ],
    "city": [
      "Krakor",
      "Krakor",
      "Krakor"
    ],
    "country": [
      "KH",
      "KH",
      "KH"
    ]
  },
  {
    "iata": "LGY",
    "translations": [
      "Lagunillas Airport",
      "Lagunillas Airport",
      "Lagunillas Airport"
    ],
    "city": [
      "Lagunillas",
      "Lagunillas",
      "Lagunillas"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "SFX",
    "translations": [
      "Macagua Airport",
      "Macagua Airport",
      "Macagua Airport"
    ],
    "city": [
      "Ciudad Guayana",
      "Ciudad Guayana",
      "Ciudad Guayana"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "SVV",
    "translations": [
      "San Salvador de Paul Airport",
      "San Salvador de Paul Airport",
      "San Salvador de Paul Airport"
    ],
    "city": [
      "San Salvador de Paul",
      "San Salvador de Paul",
      "San Salvador de Paul"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "ELX",
    "translations": [
      "El Tigre Airport",
      "El Tigre Airport",
      "El Tigre Airport"
    ],
    "city": [
      "El Tigre",
      "El Tigre",
      "El Tigre"
    ],
    "country": [
      "VE",
      "VE",
      "VE"
    ]
  },
  {
    "iata": "AZH",
    "translations": [
      "Azamgarh Airport",
      "Azamgarh Airport",
      "Azamgarh Airport"
    ],
    "city": [
      "Azamgarh",
      "Azamgarh",
      "Azamgarh"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXV",
    "translations": [
      "Along Airport",
      "Along Airport",
      "Along Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXA",
    "translations": [
      "Agartala - Maharaja Bir Bikram Airport",
      "Agartala - Maharaja Bir Bikram Airport",
      "Agartala - Maharaja Bir Bikram Airport"
    ],
    "city": [
      "Agartala",
      "Agartala",
      "Agartala"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXB",
    "translations": [
      "Bagdogra Airport",
      "Bagdogra Airport",
      "Bagdogra Airport"
    ],
    "city": [
      "Siliguri",
      "Siliguri",
      "Siliguri"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "RGH",
    "translations": [
      "Balurghat Airport",
      "Balurghat Airport",
      "Balurghat Airport"
    ],
    "city": [
      "Balurghat",
      "Balurghat",
      "Balurghat"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "SHL",
    "translations": [
      "Shillong Airport",
      "Shillong Airport",
      "Shillong Airport"
    ],
    "city": [
      "Shillong",
      "Shillong",
      "Shillong"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "VNS",
    "translations": [
      "Lal Bahadur Shastri Airport",
      "Lal Bahadur Shastri Airport",
      "Lal Bahadur Shastri Airport"
    ],
    "city": [
      "Varanasi",
      "Varanasi",
      "Varanasi"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "BBI",
    "translations": [
      "Biju Patnaik Airport",
      "Biju Patnaik Airport",
      "Biju Patnaik Airport"
    ],
    "city": [
      "Bhubaneswar",
      "Bhubaneswar",
      "Bhubaneswar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "PAB",
    "translations": [
      "Bilaspur Airport",
      "Bilaspur Airport",
      "Bilaspur Airport"
    ],
    "city": [
      "Bilaspur",
      "Bilaspur",
      "Bilaspur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "CCU",
    "translations": [
      "Netaji Subhash Chandra Bose International Airport",
      "Netaji Subhash Chandra Bose International Airport",
      "Netaji Subhash Chandra Bose International Airport"
    ],
    "city": [
      "Kolkata",
      "Kolkata",
      "Kolkata"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "COH",
    "translations": [
      "Cooch Behar Airport",
      "Cooch Behar Airport",
      "Cooch Behar Airport"
    ],
    "city": [
      "Cooch Behar",
      "Cooch Behar",
      "Cooch Behar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "CWK",
    "translations": [
      "Chitrakoot Airport",
      "Chitrakoot Airport",
      "Chitrakoot Airport"
    ],
    "city": [
      "Chitrakoot",
      "Chitrakoot",
      "Chitrakoot"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "DBD",
    "translations": [
      "Dhanbad Airport",
      "Dhanbad Airport",
      "Dhanbad Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "RDP",
    "translations": [
      "Kazi Nazrul Islam Airport",
      "Kazi Nazrul Islam Airport",
      "Kazi Nazrul Islam Airport"
    ],
    "city": [
      "Durgapur",
      "Durgapur",
      "Durgapur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "DBR",
    "translations": [
      "Darbhanga Airport",
      "Darbhanga Airport",
      "Darbhanga Airport"
    ],
    "city": [
      "Darbhanga",
      "Darbhanga",
      "Darbhanga"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "DGH",
    "translations": [
      "Deoghar Airport",
      "Deoghar Airport",
      "Deoghar Airport"
    ],
    "city": [
      "Deoghar",
      "Deoghar",
      "Deoghar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "DEP",
    "translations": [
      "Daporijo Airport",
      "Daporijo Airport",
      "Daporijo Airport"
    ],
    "city": [
      "Daporijo",
      "Daporijo",
      "Daporijo"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "GOP",
    "translations": [
      "Gorakhpur Airport",
      "Gorakhpur Airport",
      "Gorakhpur Airport"
    ],
    "city": [
      "Gorakhpur",
      "Gorakhpur",
      "Gorakhpur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "GAU",
    "translations": [
      "Lokpriya Gopinath Bordoloi International Airport",
      "Lokpriya Gopinath Bordoloi International Airport",
      "Lokpriya Gopinath Bordoloi International Airport"
    ],
    "city": [
      "Guwahati",
      "Guwahati",
      "Guwahati"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "GAY",
    "translations": [
      "Gaya Airport",
      "Gaya Airport",
      "Gaya Airport"
    ],
    "city": [
      "Gaya",
      "Gaya",
      "Gaya"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IMF",
    "translations": [
      "Imphal Airport",
      "Imphal Airport",
      "Imphal Airport"
    ],
    "city": [
      "Imphal",
      "Imphal",
      "Imphal"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "JRG",
    "translations": [
      "Jharsuguda Airport",
      "Jharsuguda Airport",
      "Jharsuguda Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "PYB",
    "translations": [
      "Jeypore Airport",
      "Jeypore Airport",
      "Jeypore Airport"
    ],
    "city": [
      "Jeypore",
      "Jeypore",
      "Jeypore"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXW",
    "translations": [
      "Sonari Airport",
      "Sonari Airport",
      "Sonari Airport"
    ],
    "city": [
      "Jamshedpur",
      "Jamshedpur",
      "Jamshedpur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "JRH",
    "translations": [
      "Jorhat Airport",
      "Jorhat Airport",
      "Jorhat Airport"
    ],
    "city": [
      "Jorhat",
      "Jorhat",
      "Jorhat"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "KBK",
    "translations": [
      "Kushinagar International Airport",
      "Kushinagar International Airport",
      "Kushinagar International Airport"
    ],
    "city": [
      "Kushinagar",
      "Kushinagar",
      "Kushinagar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXQ",
    "translations": [
      "Kamalpur Airport",
      "Kamalpur Airport",
      "Kamalpur Airport"
    ],
    "city": [
      "Manik Bhandar",
      "Manik Bhandar",
      "Manik Bhandar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXH",
    "translations": [
      "Kailashahar Airport",
      "Kailashahar Airport",
      "Kailashahar Airport"
    ],
    "city": [
      "Kailashahar",
      "Kailashahar",
      "Kailashahar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXS",
    "translations": [
      "Silchar Airport",
      "Silchar Airport",
      "Silchar Airport"
    ],
    "city": [
      "Silchar",
      "Silchar",
      "Silchar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXN",
    "translations": [
      "Khowai Airport",
      "Khowai Airport",
      "Khowai Airport"
    ],
    "city": [
      "Khowai",
      "Khowai",
      "Khowai"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "AJL",
    "translations": [
      "Lengpui Airport",
      "Lengpui Airport",
      "Lengpui Airport"
    ],
    "city": [
      "Aizawl (Lengpui)",
      "Aizawl (Lengpui)",
      "Aizawl (Lengpui)"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXI",
    "translations": [
      "Lilabari North Lakhimpur Airport",
      "Lilabari North Lakhimpur Airport",
      "Lilabari North Lakhimpur Airport"
    ],
    "city": [
      "Lilabari",
      "Lilabari",
      "Lilabari"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "LDA",
    "translations": [
      "Malda Airport",
      "Malda Airport",
      "Malda Airport"
    ],
    "city": [
      "Malda",
      "Malda",
      "Malda"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "DIB",
    "translations": [
      "Dibrugarh Airport",
      "Dibrugarh Airport",
      "Dibrugarh Airport"
    ],
    "city": [
      "Dibrugarh",
      "Dibrugarh",
      "Dibrugarh"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "DMU",
    "translations": [
      "Dimapur Airport",
      "Dimapur Airport",
      "Dimapur Airport"
    ],
    "city": [
      "Dimapur",
      "Dimapur",
      "Dimapur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "MZU",
    "translations": [
      "Muzaffarpur Airport",
      "Muzaffarpur Airport",
      "Muzaffarpur Airport"
    ],
    "city": [
      "Muzaffarpur",
      "Muzaffarpur",
      "Muzaffarpur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXT",
    "translations": [
      "Pasighat Airport",
      "Pasighat Airport",
      "Pasighat Airport"
    ],
    "city": [
      "Pasighat",
      "Pasighat",
      "Pasighat"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "PAT",
    "translations": [
      "Jay Prakash Narayan Airport",
      "Jay Prakash Narayan Airport",
      "Jay Prakash Narayan Airport"
    ],
    "city": [
      "Patna",
      "Patna",
      "Patna"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXR",
    "translations": [
      "Birsa Munda Airport",
      "Birsa Munda Airport",
      "Birsa Munda Airport"
    ],
    "city": [
      "Ranchi",
      "Ranchi",
      "Ranchi"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "RRK",
    "translations": [
      "Rourkela Airport",
      "Rourkela Airport",
      "Rourkela Airport"
    ],
    "city": [
      "Rourkela",
      "Rourkela",
      "Rourkela"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "RUP",
    "translations": [
      "Rupsi Airport",
      "Rupsi Airport",
      "Rupsi Airport"
    ],
    "city": [
      "Rupsi",
      "Rupsi",
      "Rupsi"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "TEI",
    "translations": [
      "Tezu Airport",
      "Tezu Airport",
      "Tezu Airport"
    ],
    "city": [
      "Tezu",
      "Tezu",
      "Tezu"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "TEZ",
    "translations": [
      "Tezpur Airport",
      "Tezpur Airport",
      "Tezpur Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "VTZ",
    "translations": [
      "Visakhapatnam Airport",
      "Visakhapatnam Airport",
      "Visakhapatnam Airport"
    ],
    "city": [
      "Visakhapatnam",
      "Visakhapatnam",
      "Visakhapatnam"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "ZER",
    "translations": [
      "Ziro Airport",
      "Ziro Airport",
      "Ziro Airport"
    ],
    "city": [
      "Ziro",
      "Ziro",
      "Ziro"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "RAD",
    "translations": [
      "Road Town Seaplane Base",
      "Road Town Seaplane Base",
      "Road Town Seaplane Base"
    ],
    "city": [
      "Tortola",
      "Tortola",
      "Tortola"
    ],
    "country": [
      "VG",
      "VG",
      "VG"
    ]
  },
  {
    "iata": "BZL",
    "translations": [
      "Barisal Airport",
      "Barisal Airport",
      "Barisal Airport"
    ],
    "city": [
      "Barisal",
      "Barisal",
      "Barisal"
    ],
    "country": [
      "BD",
      "BD",
      "BD"
    ]
  },
  {
    "iata": "CXB",
    "translations": [
      "Cox's Bazar Airport",
      "Cox's Bazar Airport",
      "Cox's Bazar Airport"
    ],
    "city": [
      "Cox's Bazar",
      "Cox's Bazar",
      "Cox's Bazar"
    ],
    "country": [
      "BD",
      "BD",
      "BD"
    ]
  },
  {
    "iata": "CLA",
    "translations": [
      "Comilla Airport",
      "Comilla Airport",
      "Comilla Airport"
    ],
    "city": [
      "Comilla",
      "Comilla",
      "Comilla"
    ],
    "country": [
      "BD",
      "BD",
      "BD"
    ]
  },
  {
    "iata": "CGP",
    "translations": [
      "Shah Amanat International Airport",
      "Shah Amanat International Airport",
      "Shah Amanat International Airport"
    ],
    "city": [
      "Chattogram (Chittagong)",
      "Chattogram (Chittagong)",
      "Chattogram (Chittagong)"
    ],
    "country": [
      "BD",
      "BD",
      "BD"
    ]
  },
  {
    "iata": "DAC",
    "translations": [
      "Hazrat Shahjalal International Airport",
      "Hazrat Shahjalal International Airport",
      "Hazrat Shahjalal International Airport"
    ],
    "city": [
      "Dhaka",
      "Dhaka",
      "Dhaka"
    ],
    "country": [
      "BD",
      "BD",
      "BD"
    ]
  },
  {
    "iata": "IRD",
    "translations": [
      "Ishurdi Airport",
      "Ishurdi Airport",
      "Ishurdi Airport"
    ],
    "city": [
      "Ishurdi",
      "Ishurdi",
      "Ishurdi"
    ],
    "country": [
      "BD",
      "BD",
      "BD"
    ]
  },
  {
    "iata": "JSR",
    "translations": [
      "Jessore Airport",
      "Jessore Airport",
      "Jessore Airport"
    ],
    "city": [
      "Jashore (Jessore)",
      "Jashore (Jessore)",
      "Jashore (Jessore)"
    ],
    "country": [
      "BD",
      "BD",
      "BD"
    ]
  },
  {
    "iata": "RJH",
    "translations": [
      "Shah Mokhdum Airport",
      "Shah Mokhdum Airport",
      "Shah Mokhdum Airport"
    ],
    "city": [
      "Rajshahi",
      "Rajshahi",
      "Rajshahi"
    ],
    "country": [
      "BD",
      "BD",
      "BD"
    ]
  },
  {
    "iata": "SPD",
    "translations": [
      "Saidpur Airport",
      "Saidpur Airport",
      "Saidpur Airport"
    ],
    "city": [
      "Saidpur",
      "Saidpur",
      "Saidpur"
    ],
    "country": [
      "BD",
      "BD",
      "BD"
    ]
  },
  {
    "iata": "TKR",
    "translations": [
      "Thakurgaon Airport",
      "Thakurgaon Airport",
      "Thakurgaon Airport"
    ],
    "city": [
      "Thakurgaon",
      "Thakurgaon",
      "Thakurgaon"
    ],
    "country": [
      "BD",
      "BD",
      "BD"
    ]
  },
  {
    "iata": "ZHM",
    "translations": [
      "Shamshernagar Airport",
      "Shamshernagar Airport",
      "Shamshernagar Airport"
    ],
    "city": [
      "Shamshernagar",
      "Shamshernagar",
      "Shamshernagar"
    ],
    "country": [
      "BD",
      "BD",
      "BD"
    ]
  },
  {
    "iata": "ZYL",
    "translations": [
      "Osmany International Airport",
      "Osmany International Airport",
      "Osmany International Airport"
    ],
    "city": [
      "Sylhet",
      "Sylhet",
      "Sylhet"
    ],
    "country": [
      "BD",
      "BD",
      "BD"
    ]
  },
  {
    "iata": "HKG",
    "translations": [
      "Hong Kong International Airport",
      "Hong Kong International Airport",
      "Hong Kong International Airport"
    ],
    "city": [
      "Hong Kong",
      "Hong Kong",
      "Hong Kong"
    ],
    "country": [
      "HK",
      "HK",
      "HK"
    ]
  },
  {
    "iata": "HHP",
    "translations": [
      "Shun Tak Heliport",
      "Shun Tak Heliport",
      "Shun Tak Heliport"
    ],
    "city": [
      "Central and Western",
      "Central and Western",
      "Central and Western"
    ],
    "country": [
      "HK",
      "HK",
      "HK"
    ]
  },
  {
    "iata": "SPB",
    "translations": [
      "Charlotte Amalie Harbor Seaplane Base",
      "Charlotte Amalie Harbor Seaplane Base",
      "Charlotte Amalie Harbor Seaplane Base"
    ],
    "city": [
      "Charlotte Amalie",
      "Charlotte Amalie",
      "Charlotte Amalie"
    ],
    "country": [
      "VI",
      "VI",
      "VI"
    ]
  },
  {
    "iata": "SSB",
    "translations": [
      "Christiansted Harbor Seaplane Base",
      "Christiansted Harbor Seaplane Base",
      "Christiansted Harbor Seaplane Base"
    ],
    "city": [
      "Christiansted",
      "Christiansted",
      "Christiansted"
    ],
    "country": [
      "VI",
      "VI",
      "VI"
    ]
  },
  {
    "iata": "AGR",
    "translations": [
      "Agra Airport / Agra Air Force Station",
      "Agra Airport / Agra Air Force Station",
      "Agra Airport / Agra Air Force Station"
    ],
    "city": [
      "Agra",
      "Agra",
      "Agra"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "HRH",
    "translations": [
      "Aligarh Airport",
      "Aligarh Airport",
      "Aligarh Airport"
    ],
    "city": [
      "Aligarh",
      "Aligarh",
      "Aligarh"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXD",
    "translations": [
      "Prayagraj Airport",
      "Prayagraj Airport",
      "Prayagraj Airport"
    ],
    "city": [
      "Allahabad",
      "Allahabad",
      "Allahabad"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "ATQ",
    "translations": [
      "Sri Guru Ram Dass Jee International Airport",
      "Sri Guru Ram Dass Jee International Airport",
      "Sri Guru Ram Dass Jee International Airport"
    ],
    "city": [
      "Amritsar",
      "Amritsar",
      "Amritsar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "AIP",
    "translations": [
      "Adampur Airport",
      "Adampur Airport",
      "Adampur Airport"
    ],
    "city": [
      "Adampur",
      "Adampur",
      "Adampur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "BKB",
    "translations": [
      "Nal Airport",
      "Nal Airport",
      "Nal Airport"
    ],
    "city": [
      "Bikaner",
      "Bikaner",
      "Bikaner"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "KUU",
    "translations": [
      "Kullu Manali Airport",
      "Kullu Manali Airport",
      "Kullu Manali Airport"
    ],
    "city": [
      "Bhuntar",
      "Bhuntar",
      "Bhuntar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "BUP",
    "translations": [
      "Bhatinda Air Force Station",
      "Bhatinda Air Force Station",
      "Bhatinda Air Force Station"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "BEK",
    "translations": [
      "Bareilly Air Force Station",
      "Bareilly Air Force Station",
      "Bareilly Air Force Station"
    ],
    "city": [
      "Bareilly",
      "Bareilly",
      "Bareilly"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXC",
    "translations": [
      "Chandigarh International Airport",
      "Chandigarh International Airport",
      "Chandigarh International Airport"
    ],
    "city": [
      "Chandigarh",
      "Chandigarh",
      "Chandigarh"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "KNU",
    "translations": [
      "Kanpur Airport",
      "Kanpur Airport",
      "Kanpur Airport"
    ],
    "city": [
      "Kanpur",
      "Kanpur",
      "Kanpur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "DED",
    "translations": [
      "Dehradun Jolly Grant Airport",
      "Dehradun Jolly Grant Airport",
      "Dehradun Jolly Grant Airport"
    ],
    "city": [
      "Dehradun (Jauligrant)",
      "Dehradun (Jauligrant)",
      "Dehradun (Jauligrant)"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "DEL",
    "translations": [
      "Indira Gandhi International Airport",
      "Indira Gandhi International Airport",
      "Indira Gandhi International Airport"
    ],
    "city": [
      "New Delhi",
      "New Delhi",
      "New Delhi"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "HDO",
    "translations": [
      "Hindon Airport / Hindon Air Force Station",
      "Hindon Airport / Hindon Air Force Station",
      "Hindon Airport / Hindon Air Force Station"
    ],
    "city": [
      "Ghaziabad",
      "Ghaziabad",
      "Ghaziabad"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "DHM",
    "translations": [
      "Kangra Airport",
      "Kangra Airport",
      "Kangra Airport"
    ],
    "city": [
      "Kangra",
      "Kangra",
      "Kangra"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "GWL",
    "translations": [
      "Gwalior Airport",
      "Gwalior Airport",
      "Gwalior Airport"
    ],
    "city": [
      "Gwalior",
      "Gwalior",
      "Gwalior"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "HSS",
    "translations": [
      "Hisar Airport",
      "Hisar Airport",
      "Hisar Airport"
    ],
    "city": [
      "Hisar",
      "Hisar",
      "Hisar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "JDH",
    "translations": [
      "Jodhpur Airport",
      "Jodhpur Airport",
      "Jodhpur Airport"
    ],
    "city": [
      "Jodhpur",
      "Jodhpur",
      "Jodhpur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "JAI",
    "translations": [
      "Jaipur International Airport",
      "Jaipur International Airport",
      "Jaipur International Airport"
    ],
    "city": [
      "Jaipur",
      "Jaipur",
      "Jaipur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "JSA",
    "translations": [
      "Jaisalmer Airport",
      "Jaisalmer Airport",
      "Jaisalmer Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXJ",
    "translations": [
      "Jammu Airport",
      "Jammu Airport",
      "Jammu Airport"
    ],
    "city": [
      "Jammu",
      "Jammu",
      "Jammu"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "KQH",
    "translations": [
      "Kishangarh Airport Ajmer",
      "Kishangarh Airport Ajmer",
      "Kishangarh Airport Ajmer"
    ],
    "city": [
      "Ajmer (Kishangarh)",
      "Ajmer (Kishangarh)",
      "Ajmer (Kishangarh)"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "KTU",
    "translations": [
      "Kota Airport",
      "Kota Airport",
      "Kota Airport"
    ],
    "city": [
      "Kota",
      "Kota",
      "Kota"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "LUH",
    "translations": [
      "Ludhiana Airport",
      "Ludhiana Airport",
      "Ludhiana Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXL",
    "translations": [
      "Leh Kushok Bakula Rimpochee Airport",
      "Leh Kushok Bakula Rimpochee Airport",
      "Leh Kushok Bakula Rimpochee Airport"
    ],
    "city": [
      "Leh",
      "Leh",
      "Leh"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "LKO",
    "translations": [
      "Chaudhary Charan Singh International Airport",
      "Chaudhary Charan Singh International Airport",
      "Chaudhary Charan Singh International Airport"
    ],
    "city": [
      "Lucknow",
      "Lucknow",
      "Lucknow"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "MZS",
    "translations": [
      "Moradabad Airport",
      "Moradabad Airport",
      "Moradabad Airport"
    ],
    "city": [
      "Moradabad",
      "Moradabad",
      "Moradabad"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXP",
    "translations": [
      "Pathankot Airport",
      "Pathankot Airport",
      "Pathankot Airport"
    ],
    "city": [
      "Pathankot",
      "Pathankot",
      "Pathankot"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "PGH",
    "translations": [
      "Pantnagar Airport",
      "Pantnagar Airport",
      "Pantnagar Airport"
    ],
    "city": [
      "Pantnagar",
      "Pantnagar",
      "Pantnagar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "SLV",
    "translations": [
      "Shimla Airport",
      "Shimla Airport",
      "Shimla Airport"
    ],
    "city": [
      "Jubbarhatti",
      "Jubbarhatti",
      "Jubbarhatti"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "SWN",
    "translations": [
      "Sarsawa Air Force Station",
      "Sarsawa Air Force Station",
      "Sarsawa Air Force Station"
    ],
    "city": [
      "Sherpur Naqeebpur",
      "Sherpur Naqeebpur",
      "Sherpur Naqeebpur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "SXR",
    "translations": [
      "Sheikh ul Alam International Airport",
      "Sheikh ul Alam International Airport",
      "Sheikh ul Alam International Airport"
    ],
    "city": [
      "Srinagar",
      "Srinagar",
      "Srinagar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "TNI",
    "translations": [
      "Satna Airport",
      "Satna Airport",
      "Satna Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "VSV",
    "translations": [
      "Shravasti Airport",
      "Shravasti Airport",
      "Shravasti Airport"
    ],
    "city": [
      "Shravasti",
      "Shravasti",
      "Shravasti"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "VIV",
    "translations": [
      "Vivigani Airfield",
      "Vivigani Airfield",
      "Vivigani Airfield"
    ],
    "city": [
      "Vivigani",
      "Vivigani",
      "Vivigani"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "VJQ",
    "translations": [
      "Gurue Airport",
      "Gurue Airport",
      "Gurue Airport"
    ],
    "city": [
      "Gurue",
      "Gurue",
      "Gurue"
    ],
    "country": [
      "MZ",
      "MZ",
      "MZ"
    ]
  },
  {
    "iata": "AOU",
    "translations": [
      "Attopeu Airport",
      "Attopeu Airport",
      "Attopeu Airport"
    ],
    "city": [
      "Attopeu",
      "Attopeu",
      "Attopeu"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "HOE",
    "translations": [
      "Ban Huoeisay Airport",
      "Ban Huoeisay Airport",
      "Ban Huoeisay Airport"
    ],
    "city": [
      "Huay Xai",
      "Huay Xai",
      "Huay Xai"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "LPQ",
    "translations": [
      "Luang Phabang International Airport",
      "Luang Phabang International Airport",
      "Luang Phabang International Airport"
    ],
    "city": [
      "Luang Phabang",
      "Luang Phabang",
      "Luang Phabang"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "LXG",
    "translations": [
      "Luang Namtha Airport",
      "Luang Namtha Airport",
      "Luang Namtha Airport"
    ],
    "city": [
      "Luang Namtha",
      "Luang Namtha",
      "Luang Namtha"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "ODY",
    "translations": [
      "Oudomsay Airport",
      "Oudomsay Airport",
      "Oudomsay Airport"
    ],
    "city": [
      "Oudomsay",
      "Oudomsay",
      "Oudomsay"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "PKZ",
    "translations": [
      "Pakse International Airport",
      "Pakse International Airport",
      "Pakse International Airport"
    ],
    "city": [
      "Pakse",
      "Pakse",
      "Pakse"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "ZBY",
    "translations": [
      "Sayaboury Airport",
      "Sayaboury Airport",
      "Sayaboury Airport"
    ],
    "city": [
      "Sainyabuli",
      "Sainyabuli",
      "Sainyabuli"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "ZVK",
    "translations": [
      "Savannakhet Airport",
      "Savannakhet Airport",
      "Savannakhet Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "NEU",
    "translations": [
      "Sam Neua Airport",
      "Sam Neua Airport",
      "Sam Neua Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "VNA",
    "translations": [
      "Salavan Airport",
      "Salavan Airport",
      "Salavan Airport"
    ],
    "city": [
      "Salavan",
      "Salavan",
      "Salavan"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "THK",
    "translations": [
      "Thakhek Airport",
      "Thakhek Airport",
      "Thakhek Airport"
    ],
    "city": [
      "Thakhek",
      "Thakhek",
      "Thakhek"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "VTE",
    "translations": [
      "Wattay International Airport",
      "Wattay International Airport",
      "Wattay International Airport"
    ],
    "city": [
      "Vientiane",
      "Vientiane",
      "Vientiane"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "XKH",
    "translations": [
      "Xieng Khouang Airport",
      "Xieng Khouang Airport",
      "Xieng Khouang Airport"
    ],
    "city": [
      "Xieng Khouang",
      "Xieng Khouang",
      "Xieng Khouang"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "XIE",
    "translations": [
      "Xienglom Airport",
      "Xienglom Airport",
      "Xienglom Airport"
    ],
    "city": [
      "Xienglom",
      "Xienglom",
      "Xienglom"
    ],
    "country": [
      "LA",
      "LA",
      "LA"
    ]
  },
  {
    "iata": "VMI",
    "translations": [
      "Aeropuerto Nacional Doctor Juan Plate",
      "Aeropuerto Nacional Doctor Juan Plate",
      "Aeropuerto Nacional Doctor Juan Plate"
    ],
    "city": [
      "Puerto Vallemi",
      "Puerto Vallemi",
      "Puerto Vallemi"
    ],
    "country": [
      "PY",
      "PY",
      "PY"
    ]
  },
  {
    "iata": "MFM",
    "translations": [
      "Macau International Airport",
      "Macau International Airport",
      "Macau International Airport"
    ],
    "city": [
      "Nossa Senhora do Carmo",
      "Nossa Senhora do Carmo",
      "Nossa Senhora do Carmo"
    ],
    "country": [
      "MO",
      "MO",
      "MO"
    ]
  },
  {
    "iata": "PHU",
    "translations": [
      "Phu Giao Airport",
      "Phu Giao Airport",
      "Phu Giao Airport"
    ],
    "city": [
      "Phu Giao",
      "Phu Giao",
      "Phu Giao"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "BJH",
    "translations": [
      "Bajhang Airport",
      "Bajhang Airport",
      "Bajhang Airport"
    ],
    "city": [
      "Bajhang",
      "Bajhang",
      "Bajhang"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "BHP",
    "translations": [
      "Bhojpur Airport",
      "Bhojpur Airport",
      "Bhojpur Airport"
    ],
    "city": [
      "Bhojpur",
      "Bhojpur",
      "Bhojpur"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "BGL",
    "translations": [
      "Baglung Airport",
      "Baglung Airport",
      "Baglung Airport"
    ],
    "city": [
      "Baglung",
      "Baglung",
      "Baglung"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "BHR",
    "translations": [
      "Bharatpur Airport",
      "Bharatpur Airport",
      "Bharatpur Airport"
    ],
    "city": [
      "Bharatpur",
      "Bharatpur",
      "Bharatpur"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "BJU",
    "translations": [
      "Bajura Airport",
      "Bajura Airport",
      "Bajura Airport"
    ],
    "city": [
      "Bajura",
      "Bajura",
      "Bajura"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "BIT",
    "translations": [
      "Baitadi Airport",
      "Baitadi Airport",
      "Baitadi Airport"
    ],
    "city": [
      "Baitadi",
      "Baitadi",
      "Baitadi"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "BWA",
    "translations": [
      "Gautam Buddha International Airport",
      "Gautam Buddha International Airport",
      "Gautam Buddha International Airport"
    ],
    "city": [
      "Siddharthanagar (Bhairahawa)",
      "Siddharthanagar (Bhairahawa)",
      "Siddharthanagar (Bhairahawa)"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "BDP",
    "translations": [
      "Bhadrapur Airport",
      "Bhadrapur Airport",
      "Bhadrapur Airport"
    ],
    "city": [
      "Bhadrapur",
      "Bhadrapur",
      "Bhadrapur"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "DNP",
    "translations": [
      "Tulsipur Airport",
      "Tulsipur Airport",
      "Tulsipur Airport"
    ],
    "city": [
      "Dang",
      "Dang",
      "Dang"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "DHI",
    "translations": [
      "Dhangarhi Airport",
      "Dhangarhi Airport",
      "Dhangarhi Airport"
    ],
    "city": [
      "Dhangarhi",
      "Dhangarhi",
      "Dhangarhi"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "DAP",
    "translations": [
      "Darchula Airport",
      "Darchula Airport",
      "Darchula Airport"
    ],
    "city": [
      "Darchula",
      "Darchula",
      "Darchula"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "DOP",
    "translations": [
      "Dolpa Airport",
      "Dolpa Airport",
      "Dolpa Airport"
    ],
    "city": [
      "Dolpa",
      "Dolpa",
      "Dolpa"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "SIH",
    "translations": [
      "Silgadi Doti Airport",
      "Silgadi Doti Airport",
      "Silgadi Doti Airport"
    ],
    "city": [
      "Silgadi Doti",
      "Silgadi Doti",
      "Silgadi Doti"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "GKH",
    "translations": [
      "Palungtar Airport",
      "Palungtar Airport",
      "Palungtar Airport"
    ],
    "city": [
      "Gorkha",
      "Gorkha",
      "Gorkha"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "JIR",
    "translations": [
      "Jiri Airport",
      "Jiri Airport",
      "Jiri Airport"
    ],
    "city": [
      "Jiri",
      "Jiri",
      "Jiri"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "JUM",
    "translations": [
      "Jumla Airport",
      "Jumla Airport",
      "Jumla Airport"
    ],
    "city": [
      "Jumla",
      "Jumla",
      "Jumla"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "JKR",
    "translations": [
      "Janakpur Airport",
      "Janakpur Airport",
      "Janakpur Airport"
    ],
    "city": [
      "Janakpur",
      "Janakpur",
      "Janakpur"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "JMO",
    "translations": [
      "Jomsom Airport",
      "Jomsom Airport",
      "Jomsom Airport"
    ],
    "city": [
      "Jomsom",
      "Jomsom",
      "Jomsom"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "KTM",
    "translations": [
      "Tribhuvan International Airport",
      "Tribhuvan International Airport",
      "Tribhuvan International Airport"
    ],
    "city": [
      "Kathmandu",
      "Kathmandu",
      "Kathmandu"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "LDN",
    "translations": [
      "Lamidanda Airport",
      "Lamidanda Airport",
      "Lamidanda Airport"
    ],
    "city": [
      "Lamidanda",
      "Lamidanda",
      "Lamidanda"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "LUA",
    "translations": [
      "Lukla Airport",
      "Lukla Airport",
      "Lukla Airport"
    ],
    "city": [
      "Lukla",
      "Lukla",
      "Lukla"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "LTG",
    "translations": [
      "Langtang Airport",
      "Langtang Airport",
      "Langtang Airport"
    ],
    "city": [
      "Langtang",
      "Langtang",
      "Langtang"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "NGX",
    "translations": [
      "Manang Airport",
      "Manang Airport",
      "Manang Airport"
    ],
    "city": [
      "Ngawal",
      "Ngawal",
      "Ngawal"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "MEY",
    "translations": [
      "Meghauli Airport",
      "Meghauli Airport",
      "Meghauli Airport"
    ],
    "city": [
      "Meghauli",
      "Meghauli",
      "Meghauli"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "XMG",
    "translations": [
      "Mahendranagar Airport",
      "Mahendranagar Airport",
      "Mahendranagar Airport"
    ],
    "city": [
      "Mahendranagar",
      "Mahendranagar",
      "Mahendranagar"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "KEP",
    "translations": [
      "Nepalgunj Airport",
      "Nepalgunj Airport",
      "Nepalgunj Airport"
    ],
    "city": [
      "Nepalgunj",
      "Nepalgunj",
      "Nepalgunj"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "PKR",
    "translations": [
      "Pokhara Airport",
      "Pokhara Airport",
      "Pokhara Airport"
    ],
    "city": [
      "Pokhara",
      "Pokhara",
      "Pokhara"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "PPL",
    "translations": [
      "Phaplu Airport",
      "Phaplu Airport",
      "Phaplu Airport"
    ],
    "city": [
      "Phaplu",
      "Phaplu",
      "Phaplu"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "RJB",
    "translations": [
      "Rajbiraj Airport",
      "Rajbiraj Airport",
      "Rajbiraj Airport"
    ],
    "city": [
      "Rajbiraj",
      "Rajbiraj",
      "Rajbiraj"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "RHP",
    "translations": [
      "Ramechhap Airport",
      "Ramechhap Airport",
      "Ramechhap Airport"
    ],
    "city": [
      "Ramechhap",
      "Ramechhap",
      "Ramechhap"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "RUK",
    "translations": [
      "Rukum Chaurjahari Airport",
      "Rukum Chaurjahari Airport",
      "Rukum Chaurjahari Airport"
    ],
    "city": [
      "Rukumkot",
      "Rukumkot",
      "Rukumkot"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "RPA",
    "translations": [
      "Rolpa Airport",
      "Rolpa Airport",
      "Rolpa Airport"
    ],
    "city": [
      "Rolpa",
      "Rolpa",
      "Rolpa"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "RUM",
    "translations": [
      "Rumjatar Airport",
      "Rumjatar Airport",
      "Rumjatar Airport"
    ],
    "city": [
      "Rumjatar",
      "Rumjatar",
      "Rumjatar"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "SYH",
    "translations": [
      "Syangboche Airport",
      "Syangboche Airport",
      "Syangboche Airport"
    ],
    "city": [
      "Namche Bazaar",
      "Namche Bazaar",
      "Namche Bazaar"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "SIF",
    "translations": [
      "Simara Airport",
      "Simara Airport",
      "Simara Airport"
    ],
    "city": [
      "Simara",
      "Simara",
      "Simara"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "SKH",
    "translations": [
      "Surkhet Airport",
      "Surkhet Airport",
      "Surkhet Airport"
    ],
    "city": [
      "Surkhet",
      "Surkhet",
      "Surkhet"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "FEB",
    "translations": [
      "Sanfebagar Airport",
      "Sanfebagar Airport",
      "Sanfebagar Airport"
    ],
    "city": [
      "Sanfebagar",
      "Sanfebagar",
      "Sanfebagar"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "IMK",
    "translations": [
      "Simikot Airport",
      "Simikot Airport",
      "Simikot Airport"
    ],
    "city": [
      "Simikot",
      "Simikot",
      "Simikot"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "TPJ",
    "translations": [
      "Taplejung Airport",
      "Taplejung Airport",
      "Taplejung Airport"
    ],
    "city": [
      "Taplejung",
      "Taplejung",
      "Taplejung"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "TPU",
    "translations": [
      "Tikapur Airport",
      "Tikapur Airport",
      "Tikapur Airport"
    ],
    "city": [
      "Tikapur",
      "Tikapur",
      "Tikapur"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "TMI",
    "translations": [
      "Tumling Tar Airport",
      "Tumling Tar Airport",
      "Tumling Tar Airport"
    ],
    "city": [
      "Tumling Tar",
      "Tumling Tar",
      "Tumling Tar"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "BIR",
    "translations": [
      "Biratnagar Airport",
      "Biratnagar Airport",
      "Biratnagar Airport"
    ],
    "city": [
      "Biratnagar",
      "Biratnagar",
      "Biratnagar"
    ],
    "country": [
      "NP",
      "NP",
      "NP"
    ]
  },
  {
    "iata": "AGX",
    "translations": [
      "Agatti Airport",
      "Agatti Airport",
      "Agatti Airport"
    ],
    "city": [
      "Agatti",
      "Agatti",
      "Agatti"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "BEP",
    "translations": [
      "Bellary Airport",
      "Bellary Airport",
      "Bellary Airport"
    ],
    "city": [
      "Bellary",
      "Bellary",
      "Bellary"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "BLR",
    "translations": [
      "Kempegowda International Airport",
      "Kempegowda International Airport",
      "Kempegowda International Airport"
    ],
    "city": [
      "Bangalore",
      "Bangalore",
      "Bangalore"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXX",
    "translations": [
      "Bidar Airport / Bidar Air Force Station",
      "Bidar Airport / Bidar Air Force Station",
      "Bidar Airport / Bidar Air Force Station"
    ],
    "city": [
      "Bidar",
      "Bidar",
      "Bidar"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "VGA",
    "translations": [
      "Vijayawada Airport",
      "Vijayawada Airport",
      "Vijayawada Airport"
    ],
    "city": [
      "Gannavaram",
      "Gannavaram",
      "Gannavaram"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "CJB",
    "translations": [
      "Coimbatore International Airport",
      "Coimbatore International Airport",
      "Coimbatore International Airport"
    ],
    "city": [
      "Coimbatore",
      "Coimbatore",
      "Coimbatore"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "COK",
    "translations": [
      "Cochin International Airport",
      "Cochin International Airport",
      "Cochin International Airport"
    ],
    "city": [
      "Kochi",
      "Kochi",
      "Kochi"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "CCJ",
    "translations": [
      "Calicut International Airport",
      "Calicut International Airport",
      "Calicut International Airport"
    ],
    "city": [
      "Calicut",
      "Calicut",
      "Calicut"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "CDP",
    "translations": [
      "Kadapa Airport",
      "Kadapa Airport",
      "Kadapa Airport"
    ],
    "city": [
      "Kadapa",
      "Kadapa",
      "Kadapa"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "CBD",
    "translations": [
      "Car Nicobar Air Force Base",
      "Car Nicobar Air Force Base",
      "Car Nicobar Air Force Base"
    ],
    "city": [
      "IAF Camp",
      "IAF Camp",
      "IAF Camp"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "GOX",
    "translations": [
      "Manohar International Airport",
      "Manohar International Airport",
      "Manohar International Airport"
    ],
    "city": [
      "Mopa",
      "Mopa",
      "Mopa"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "GBI",
    "translations": [
      "Kalaburagi Airport",
      "Kalaburagi Airport",
      "Kalaburagi Airport"
    ],
    "city": [
      "Kalaburagi",
      "Kalaburagi",
      "Kalaburagi"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "GOI",
    "translations": [
      "Dabolim Airport",
      "Dabolim Airport",
      "Dabolim Airport"
    ],
    "city": [
      "Vasco da Gama",
      "Vasco da Gama",
      "Vasco da Gama"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "HYD",
    "translations": [
      "Rajiv Gandhi International Airport",
      "Rajiv Gandhi International Airport",
      "Rajiv Gandhi International Airport"
    ],
    "city": [
      "Hyderabad",
      "Hyderabad",
      "Hyderabad"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "BPM",
    "translations": [
      "Begumpet Airport",
      "Begumpet Airport",
      "Begumpet Airport"
    ],
    "city": [
      "Hyderabad",
      "Hyderabad",
      "Hyderabad"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "VDY",
    "translations": [
      "Jindal Vijaynagar Airport",
      "Jindal Vijaynagar Airport",
      "Jindal Vijaynagar Airport"
    ],
    "city": [
      "Toranagallu",
      "Toranagallu",
      "Toranagallu"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "CNN",
    "translations": [
      "Kannur International Airport",
      "Kannur International Airport",
      "Kannur International Airport"
    ],
    "city": [
      "Kannur",
      "Kannur",
      "Kannur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "KJB",
    "translations": [
      "Kurnool Airport",
      "Kurnool Airport",
      "Kurnool Airport"
    ],
    "city": [
      "Orvakal",
      "Orvakal",
      "Orvakal"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXM",
    "translations": [
      "Madurai Airport",
      "Madurai Airport",
      "Madurai Airport"
    ],
    "city": [
      "Madurai",
      "Madurai",
      "Madurai"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXE",
    "translations": [
      "Mangalore International Airport",
      "Mangalore International Airport",
      "Mangalore International Airport"
    ],
    "city": [
      "Mangalore",
      "Mangalore",
      "Mangalore"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "MAA",
    "translations": [
      "Chennai International Airport",
      "Chennai International Airport",
      "Chennai International Airport"
    ],
    "city": [
      "Chennai",
      "Chennai",
      "Chennai"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "MYQ",
    "translations": [
      "Mysore Airport",
      "Mysore Airport",
      "Mysore Airport"
    ],
    "city": [
      "Mysore",
      "Mysore",
      "Mysore"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "NVY",
    "translations": [
      "Neyveli Airport",
      "Neyveli Airport",
      "Neyveli Airport"
    ],
    "city": [
      "Neyveli",
      "Neyveli",
      "Neyveli"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "IXZ",
    "translations": [
      "Veer Savarkar International Airport / INS Utkrosh",
      "Veer Savarkar International Airport / INS Utkrosh",
      "Veer Savarkar International Airport / INS Utkrosh"
    ],
    "city": [
      "Port Blair",
      "Port Blair",
      "Port Blair"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "PNY",
    "translations": [
      "Pondicherry Airport",
      "Pondicherry Airport",
      "Pondicherry Airport"
    ],
    "city": [
      "Puducherry (Pondicherry)",
      "Puducherry (Pondicherry)",
      "Puducherry (Pondicherry)"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "PUT",
    "translations": [
      "Sri Sathya Sai Airport",
      "Sri Sathya Sai Airport",
      "Sri Sathya Sai Airport"
    ],
    "city": [
      "Puttaparthi",
      "Puttaparthi",
      "Puttaparthi"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "RMD",
    "translations": [
      "Basanth Nagar Airport",
      "Basanth Nagar Airport",
      "Basanth Nagar Airport"
    ],
    "city": [
      "Ramagundam",
      "Ramagundam",
      "Ramagundam"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "RJA",
    "translations": [
      "Rajahmundry Airport",
      "Rajahmundry Airport",
      "Rajahmundry Airport"
    ],
    "city": [
      "Madhurapudi",
      "Madhurapudi",
      "Madhurapudi"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "SXV",
    "translations": [
      "Salem Airport",
      "Salem Airport",
      "Salem Airport"
    ],
    "city": [
      "Salem",
      "Salem",
      "Salem"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "TJV",
    "translations": [
      "Thanjavur Air Force Station",
      "Thanjavur Air Force Station",
      "Thanjavur Air Force Station"
    ],
    "city": [
      "Thanjavur",
      "Thanjavur",
      "Thanjavur"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "TCR",
    "translations": [
      "Tuticorin Airport",
      "Tuticorin Airport",
      "Tuticorin Airport"
    ],
    "city": [
      "Vagaikulam",
      "Vagaikulam",
      "Vagaikulam"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "TIR",
    "translations": [
      "Tirupati Airport",
      "Tirupati Airport",
      "Tirupati Airport"
    ],
    "city": [
      "Tirupati",
      "Tirupati",
      "Tirupati"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "TRZ",
    "translations": [
      "Tiruchirappalli International Airport",
      "Tiruchirappalli International Airport",
      "Tiruchirappalli International Airport"
    ],
    "city": [
      "Tiruchirappalli",
      "Tiruchirappalli",
      "Tiruchirappalli"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "TRV",
    "translations": [
      "Thiruvananthapuram International Airport",
      "Thiruvananthapuram International Airport",
      "Thiruvananthapuram International Airport"
    ],
    "city": [
      "Thiruvananthapuram",
      "Thiruvananthapuram",
      "Thiruvananthapuram"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "WGC",
    "translations": [
      "Warangal Airport",
      "Warangal Airport",
      "Warangal Airport"
    ],
    "city": [
      "Warangal",
      "Warangal",
      "Warangal"
    ],
    "country": [
      "IN",
      "IN",
      "IN"
    ]
  },
  {
    "iata": "BUT",
    "translations": [
      "Bathpalathang Airport",
      "Bathpalathang Airport",
      "Bathpalathang Airport"
    ],
    "city": [
      "Jakar",
      "Jakar",
      "Jakar"
    ],
    "country": [
      "BT",
      "BT",
      "BT"
    ]
  },
  {
    "iata": "GLU",
    "translations": [
      "Gelephu Airport",
      "Gelephu Airport",
      "Gelephu Airport"
    ],
    "city": [
      "Gelephu",
      "Gelephu",
      "Gelephu"
    ],
    "country": [
      "BT",
      "BT",
      "BT"
    ]
  },
  {
    "iata": "PBH",
    "translations": [
      "Paro International Airport",
      "Paro International Airport",
      "Paro International Airport"
    ],
    "city": [
      "Paro",
      "Paro",
      "Paro"
    ],
    "country": [
      "BT",
      "BT",
      "BT"
    ]
  },
  {
    "iata": "YON",
    "translations": [
      "Yongphulla Airport",
      "Yongphulla Airport",
      "Yongphulla Airport"
    ],
    "city": [
      "Yongphulla",
      "Yongphulla",
      "Yongphulla"
    ],
    "country": [
      "BT",
      "BT",
      "BT"
    ]
  },
  {
    "iata": "HRF",
    "translations": [
      "Hoarafushi Airport",
      "Hoarafushi Airport",
      "Hoarafushi Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "HDK",
    "translations": [
      "Kulhudhuffushi Airport",
      "Kulhudhuffushi Airport",
      "Kulhudhuffushi Airport"
    ],
    "city": [
      "Kulhudhuffushi",
      "Kulhudhuffushi",
      "Kulhudhuffushi"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "NMF",
    "translations": [
      "Maafaru International Airport",
      "Maafaru International Airport",
      "Maafaru International Airport"
    ],
    "city": [
      "Noonu Atoll",
      "Noonu Atoll",
      "Noonu Atoll"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "IFU",
    "translations": [
      "Ifuru Airport",
      "Ifuru Airport",
      "Ifuru Airport"
    ],
    "city": [
      "Ifuru Island",
      "Ifuru Island",
      "Ifuru Island"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "DRV",
    "translations": [
      "Dharavandhoo Airport",
      "Dharavandhoo Airport",
      "Dharavandhoo Airport"
    ],
    "city": [
      "Baa Atoll",
      "Baa Atoll",
      "Baa Atoll"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "FVM",
    "translations": [
      "Fuvahmulah Airport",
      "Fuvahmulah Airport",
      "Fuvahmulah Airport"
    ],
    "city": [
      "Fuvahmulah Island",
      "Fuvahmulah Island",
      "Fuvahmulah Island"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "GAN",
    "translations": [
      "Gan International Airport",
      "Gan International Airport",
      "Gan International Airport"
    ],
    "city": [
      "Gan",
      "Gan",
      "Gan"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "HAQ",
    "translations": [
      "Hanimaadhoo Airport",
      "Hanimaadhoo Airport",
      "Hanimaadhoo Airport"
    ],
    "city": [
      "Haa Dhaalu Atoll",
      "Haa Dhaalu Atoll",
      "Haa Dhaalu Atoll"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "KDO",
    "translations": [
      "Kadhdhoo Airport",
      "Kadhdhoo Airport",
      "Kadhdhoo Airport"
    ],
    "city": [
      "Kadhdhoo",
      "Kadhdhoo",
      "Kadhdhoo"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "MLE",
    "translations": [
      "Malé International Airport",
      "Malé International Airport",
      "Malé International Airport"
    ],
    "city": [
      "Malé",
      "Malé",
      "Malé"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "GKK",
    "translations": [
      "Kooddoo Airport",
      "Kooddoo Airport",
      "Kooddoo Airport"
    ],
    "city": [
      "Huvadhu Atoll",
      "Huvadhu Atoll",
      "Huvadhu Atoll"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "KDM",
    "translations": [
      "Kaadedhdhoo Airport",
      "Kaadedhdhoo Airport",
      "Kaadedhdhoo Airport"
    ],
    "city": [
      "Huvadhu Atoll",
      "Huvadhu Atoll",
      "Huvadhu Atoll"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "DDD",
    "translations": [
      "Dhaalu Atoll Airport",
      "Dhaalu Atoll Airport",
      "Dhaalu Atoll Airport"
    ],
    "city": [
      "Kudahuvadhoo",
      "Kudahuvadhoo",
      "Kudahuvadhoo"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "VAM",
    "translations": [
      "Villa International Airport Maamigili",
      "Villa International Airport Maamigili",
      "Villa International Airport Maamigili"
    ],
    "city": [
      "Maamigili",
      "Maamigili",
      "Maamigili"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "TMF",
    "translations": [
      "Thimarafushi Airport",
      "Thimarafushi Airport",
      "Thimarafushi Airport"
    ],
    "city": [
      "Thimarafushi",
      "Thimarafushi",
      "Thimarafushi"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "RUL",
    "translations": [
      "Maavaarulaa Airport",
      "Maavaarulaa Airport",
      "Maavaarulaa Airport"
    ],
    "city": [
      "Maavaarulu",
      "Maavaarulu",
      "Maavaarulu"
    ],
    "country": [
      "MV",
      "MV",
      "MV"
    ]
  },
  {
    "iata": "DMK",
    "translations": [
      "Don Mueang International Airport",
      "Don Mueang International Airport",
      "Don Mueang International Airport"
    ],
    "city": [
      "Bangkok",
      "Bangkok",
      "Bangkok"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "KDT",
    "translations": [
      "Kamphaeng Saen Airport",
      "Kamphaeng Saen Airport",
      "Kamphaeng Saen Airport"
    ],
    "city": [
      "Nakhon Pathom",
      "Nakhon Pathom",
      "Nakhon Pathom"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "KKM",
    "translations": [
      "Khok Kathiam Airport",
      "Khok Kathiam Airport",
      "Khok Kathiam Airport"
    ],
    "city": [
      "Lop Buri",
      "Lop Buri",
      "Lop Buri"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "TDX",
    "translations": [
      "Trat Airport",
      "Trat Airport",
      "Trat Airport"
    ],
    "city": [
      "Laem Ngop",
      "Laem Ngop",
      "Laem Ngop"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "BKK",
    "translations": [
      "Suvarnabhumi Airport",
      "Suvarnabhumi Airport",
      "Suvarnabhumi Airport"
    ],
    "city": [
      "Bangkok",
      "Bangkok",
      "Bangkok"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "UTP",
    "translations": [
      "U-Tapao International Airport",
      "U-Tapao International Airport",
      "U-Tapao International Airport"
    ],
    "city": [
      "Rayong",
      "Rayong",
      "Rayong"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "CNX",
    "translations": [
      "Chiang Mai International Airport",
      "Chiang Mai International Airport",
      "Chiang Mai International Airport"
    ],
    "city": [
      "Chiang Mai",
      "Chiang Mai",
      "Chiang Mai"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "HGN",
    "translations": [
      "Mae Hong Son Airport",
      "Mae Hong Son Airport",
      "Mae Hong Son Airport"
    ],
    "city": [
      "Mae Hong Son",
      "Mae Hong Son",
      "Mae Hong Son"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "PYY",
    "translations": [
      "Pai Airport",
      "Pai Airport",
      "Pai Airport"
    ],
    "city": [
      "Pai",
      "Pai",
      "Pai"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "LPT",
    "translations": [
      "Lampang Airport",
      "Lampang Airport",
      "Lampang Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "NNT",
    "translations": [
      "Nan Airport",
      "Nan Airport",
      "Nan Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "PRH",
    "translations": [
      "Phrae Airport",
      "Phrae Airport",
      "Phrae Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "CEI",
    "translations": [
      "Mae Fah Luang - Chiang Rai International Airport",
      "Mae Fah Luang - Chiang Rai International Airport",
      "Mae Fah Luang - Chiang Rai International Airport"
    ],
    "city": [
      "Chiang Rai",
      "Chiang Rai",
      "Chiang Rai"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "PHY",
    "translations": [
      "Phetchabun Airport",
      "Phetchabun Airport",
      "Phetchabun Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "HHQ",
    "translations": [
      "Hua Hin Airport",
      "Hua Hin Airport",
      "Hua Hin Airport"
    ],
    "city": [
      "Hua Hin",
      "Hua Hin",
      "Hua Hin"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "TKH",
    "translations": [
      "Takhli Airport",
      "Takhli Airport",
      "Takhli Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "MAQ",
    "translations": [
      "Mae Sot Airport",
      "Mae Sot Airport",
      "Mae Sot Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "THS",
    "translations": [
      "Sukhothai Airport",
      "Sukhothai Airport",
      "Sukhothai Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "PHS",
    "translations": [
      "Phitsanulok Airport",
      "Phitsanulok Airport",
      "Phitsanulok Airport"
    ],
    "city": [
      "Phitsanulok",
      "Phitsanulok",
      "Phitsanulok"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "TKT",
    "translations": [
      "Tak Airport",
      "Tak Airport",
      "Tak Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "UTR",
    "translations": [
      "Uttaradit Airport",
      "Uttaradit Airport",
      "Uttaradit Airport"
    ],
    "city": [
      "Uttaradit",
      "Uttaradit",
      "Uttaradit"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "URT",
    "translations": [
      "Surat Thani Airport",
      "Surat Thani Airport",
      "Surat Thani Airport"
    ],
    "city": [
      "Surat Thani",
      "Surat Thani",
      "Surat Thani"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "NAW",
    "translations": [
      "Narathiwat Airport",
      "Narathiwat Airport",
      "Narathiwat Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "CJM",
    "translations": [
      "Chumphon Airport",
      "Chumphon Airport",
      "Chumphon Airport"
    ],
    "city": [
      "Chumphon",
      "Chumphon",
      "Chumphon"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "NST",
    "translations": [
      "Nakhon Si Thammarat Airport",
      "Nakhon Si Thammarat Airport",
      "Nakhon Si Thammarat Airport"
    ],
    "city": [
      "Nakhon Si Thammarat",
      "Nakhon Si Thammarat",
      "Nakhon Si Thammarat"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "KBV",
    "translations": [
      "Krabi Airport",
      "Krabi Airport",
      "Krabi Airport"
    ],
    "city": [
      "Krabi",
      "Krabi",
      "Krabi"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "SGZ",
    "translations": [
      "Songkhla Airport",
      "Songkhla Airport",
      "Songkhla Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "PAN",
    "translations": [
      "Pattani Airport",
      "Pattani Airport",
      "Pattani Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "USM",
    "translations": [
      "Samui Airport",
      "Samui Airport",
      "Samui Airport"
    ],
    "city": [
      "Na Thon (Ko Samui Island)",
      "Na Thon (Ko Samui Island)",
      "Na Thon (Ko Samui Island)"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "HKT",
    "translations": [
      "Phuket International Airport",
      "Phuket International Airport",
      "Phuket International Airport"
    ],
    "city": [
      "Phuket",
      "Phuket",
      "Phuket"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "UNN",
    "translations": [
      "Ranong Airport",
      "Ranong Airport",
      "Ranong Airport"
    ],
    "city": [
      "Ranong",
      "Ranong",
      "Ranong"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "HDY",
    "translations": [
      "Hat Yai International Airport",
      "Hat Yai International Airport",
      "Hat Yai International Airport"
    ],
    "city": [
      "Hat Yai",
      "Hat Yai",
      "Hat Yai"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "TST",
    "translations": [
      "Trang Airport",
      "Trang Airport",
      "Trang Airport"
    ],
    "city": [
      "Trang",
      "Trang",
      "Trang"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "UTH",
    "translations": [
      "Udon Thani Airport",
      "Udon Thani Airport",
      "Udon Thani Airport"
    ],
    "city": [
      "Udon Thani",
      "Udon Thani",
      "Udon Thani"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "SNO",
    "translations": [
      "Sakon Nakhon Airport",
      "Sakon Nakhon Airport",
      "Sakon Nakhon Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "PXR",
    "translations": [
      "Surin Airport",
      "Surin Airport",
      "Surin Airport"
    ],
    "city": [
      "Surin",
      "Surin",
      "Surin"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "KKC",
    "translations": [
      "Khon Kaen Airport",
      "Khon Kaen Airport",
      "Khon Kaen Airport"
    ],
    "city": [
      "Khon Kaen",
      "Khon Kaen",
      "Khon Kaen"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "LOE",
    "translations": [
      "Loei Airport",
      "Loei Airport",
      "Loei Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "BFV",
    "translations": [
      "Buri Ram Airport",
      "Buri Ram Airport",
      "Buri Ram Airport"
    ],
    "city": [
      "Buriram",
      "Buriram",
      "Buriram"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "NAK",
    "translations": [
      "Nakhon Ratchasima Airport",
      "Nakhon Ratchasima Airport",
      "Nakhon Ratchasima Airport"
    ],
    "city": [
      "Chaloem Phra Kiat",
      "Chaloem Phra Kiat",
      "Chaloem Phra Kiat"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "UBP",
    "translations": [
      "Ubon Ratchathani Airport",
      "Ubon Ratchathani Airport",
      "Ubon Ratchathani Airport"
    ],
    "city": [
      "Ubon Ratchathani",
      "Ubon Ratchathani",
      "Ubon Ratchathani"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "ROI",
    "translations": [
      "Roi Et Airport",
      "Roi Et Airport",
      "Roi Et Airport"
    ],
    "city": [
      "Roi Et",
      "Roi Et",
      "Roi Et"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "KOP",
    "translations": [
      "Nakhon Phanom Airport",
      "Nakhon Phanom Airport",
      "Nakhon Phanom Airport"
    ],
    "city": [
      "Nakhon Phanom",
      "Nakhon Phanom",
      "Nakhon Phanom"
    ],
    "country": [
      "TH",
      "TH",
      "TH"
    ]
  },
  {
    "iata": "VUU",
    "translations": [
      "Mvuu Camp Airport",
      "Mvuu Camp Airport",
      "Mvuu Camp Airport"
    ],
    "city": [
      "Liwonde National Park",
      "Liwonde National Park",
      "Liwonde National Park"
    ],
    "country": [
      "MW",
      "MW",
      "MW"
    ]
  },
  {
    "iata": "BMV",
    "translations": [
      "Buon Ma Thuot Airport",
      "Buon Ma Thuot Airport",
      "Buon Ma Thuot Airport"
    ],
    "city": [
      "Buon Ma Thuot",
      "Buon Ma Thuot",
      "Buon Ma Thuot"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "VCL",
    "translations": [
      "Chu Lai Airport",
      "Chu Lai Airport",
      "Chu Lai Airport"
    ],
    "city": [
      "Tam Nghĩa",
      "Tam Nghĩa",
      "Tam Nghĩa"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "HPH",
    "translations": [
      "Cat Bi International Airport",
      "Cat Bi International Airport",
      "Cat Bi International Airport"
    ],
    "city": [
      "Haiphong (Hai An)",
      "Haiphong (Hai An)",
      "Haiphong (Hai An)"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "CAH",
    "translations": [
      "Cà Mau Airport",
      "Cà Mau Airport",
      "Cà Mau Airport"
    ],
    "city": [
      "Ca Mau City",
      "Ca Mau City",
      "Ca Mau City"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "CXR",
    "translations": [
      "Cam Ranh International Airport / Cam Ranh Air Base",
      "Cam Ranh International Airport / Cam Ranh Air Base",
      "Cam Ranh International Airport / Cam Ranh Air Base"
    ],
    "city": [
      "Cam Ranh",
      "Cam Ranh",
      "Cam Ranh"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "VCS",
    "translations": [
      "Con Dao Airport",
      "Con Dao Airport",
      "Con Dao Airport"
    ],
    "city": [
      "Con Dao",
      "Con Dao",
      "Con Dao"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "VCA",
    "translations": [
      "Can Tho International Airport",
      "Can Tho International Airport",
      "Can Tho International Airport"
    ],
    "city": [
      "Can Tho",
      "Can Tho",
      "Can Tho"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "DIN",
    "translations": [
      "Dien Bien Phu Airport",
      "Dien Bien Phu Airport",
      "Dien Bien Phu Airport"
    ],
    "city": [
      "Dien Bien Phu",
      "Dien Bien Phu",
      "Dien Bien Phu"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "VDH",
    "translations": [
      "Dong Hoi Airport",
      "Dong Hoi Airport",
      "Dong Hoi Airport"
    ],
    "city": [
      "Dong Hoi",
      "Dong Hoi",
      "Dong Hoi"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "DLI",
    "translations": [
      "Lien Khuong Airport",
      "Lien Khuong Airport",
      "Lien Khuong Airport"
    ],
    "city": [
      "Da Lat",
      "Da Lat",
      "Da Lat"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "DAD",
    "translations": [
      "Da Nang International Airport",
      "Da Nang International Airport",
      "Da Nang International Airport"
    ],
    "city": [
      "Da Nang",
      "Da Nang",
      "Da Nang"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "VVN",
    "translations": [
      "Las Malvinas/Echarate Airport",
      "Las Malvinas/Echarate Airport",
      "Las Malvinas/Echarate Airport"
    ],
    "city": [
      "Las Malvinas",
      "Las Malvinas",
      "Las Malvinas"
    ],
    "country": [
      "PE",
      "PE",
      "PE"
    ]
  },
  {
    "iata": "HAN",
    "translations": [
      "Noi Bai International Airport",
      "Noi Bai International Airport",
      "Noi Bai International Airport"
    ],
    "city": [
      "Hanoi (Soc Son)",
      "Hanoi (Soc Son)",
      "Hanoi (Soc Son)"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "SQH",
    "translations": [
      "Na San Airport",
      "Na San Airport",
      "Na San Airport"
    ],
    "city": [
      "Mai Son",
      "Mai Son",
      "Mai Son"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "HUI",
    "translations": [
      "Phu Bai International Airport",
      "Phu Bai International Airport",
      "Phu Bai International Airport"
    ],
    "city": [
      "Huế",
      "Huế",
      "Huế"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "UIH",
    "translations": [
      "Phu Cat Airport",
      "Phu Cat Airport",
      "Phu Cat Airport"
    ],
    "city": [
      "Quy Nohn",
      "Quy Nohn",
      "Quy Nohn"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "PXU",
    "translations": [
      "Pleiku Airport",
      "Pleiku Airport",
      "Pleiku Airport"
    ],
    "city": [
      "Pleiku",
      "Pleiku",
      "Pleiku"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "PQC",
    "translations": [
      "Phu Quoc International Airport",
      "Phu Quoc International Airport",
      "Phu Quoc International Airport"
    ],
    "city": [
      "Phu Quoc Island",
      "Phu Quoc Island",
      "Phu Quoc Island"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "PHA",
    "translations": [
      "Phan Rang Airport",
      "Phan Rang Airport",
      "Phan Rang Airport"
    ],
    "city": [
      "Phan Rang",
      "Phan Rang",
      "Phan Rang"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "VKG",
    "translations": [
      "Rach Gia Airport",
      "Rach Gia Airport",
      "Rach Gia Airport"
    ],
    "city": [
      "Rach Gia",
      "Rach Gia",
      "Rach Gia"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "TBB",
    "translations": [
      "Dong Tac Airport",
      "Dong Tac Airport",
      "Dong Tac Airport"
    ],
    "city": [
      "Tuy Hoa",
      "Tuy Hoa",
      "Tuy Hoa"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "SGN",
    "translations": [
      "Tan Son Nhat International Airport",
      "Tan Son Nhat International Airport",
      "Tan Son Nhat International Airport"
    ],
    "city": [
      "Ho Chi Minh City",
      "Ho Chi Minh City",
      "Ho Chi Minh City"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "THD",
    "translations": [
      "Tho Xuan Airport",
      "Tho Xuan Airport",
      "Tho Xuan Airport"
    ],
    "city": [
      "Thanh Hóa",
      "Thanh Hóa",
      "Thanh Hóa"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "VDO",
    "translations": [
      "Van Don International Airport",
      "Van Don International Airport",
      "Van Don International Airport"
    ],
    "city": [
      "Van Don",
      "Van Don",
      "Van Don"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "VII",
    "translations": [
      "Vinh Airport",
      "Vinh Airport",
      "Vinh Airport"
    ],
    "city": [
      "Vinh",
      "Vinh",
      "Vinh"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "VTG",
    "translations": [
      "Vung Tau Airport",
      "Vung Tau Airport",
      "Vung Tau Airport"
    ],
    "city": [
      "Vũng Tàu",
      "Vũng Tàu",
      "Vũng Tàu"
    ],
    "country": [
      "VN",
      "VN",
      "VN"
    ]
  },
  {
    "iata": "VBA",
    "translations": [
      "Ann Airport",
      "Ann Airport",
      "Ann Airport"
    ],
    "city": [
      "Aeng",
      "Aeng",
      "Aeng"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "NYU",
    "translations": [
      "Bagan Airport",
      "Bagan Airport",
      "Bagan Airport"
    ],
    "city": [
      "Nyaung U",
      "Nyaung U",
      "Nyaung U"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "BMO",
    "translations": [
      "Banmaw Airport",
      "Banmaw Airport",
      "Banmaw Airport"
    ],
    "city": [
      "Banmaw",
      "Banmaw",
      "Banmaw"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "VBP",
    "translations": [
      "Bokpyinn Airport",
      "Bokpyinn Airport",
      "Bokpyinn Airport"
    ],
    "city": [
      "Bokpyinn",
      "Bokpyinn",
      "Bokpyinn"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "VBC",
    "translations": [
      "Chanmyathazi Airport",
      "Chanmyathazi Airport",
      "Chanmyathazi Airport"
    ],
    "city": [
      "Mandalay",
      "Mandalay",
      "Mandalay"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "TVY",
    "translations": [
      "Dawei Airport",
      "Dawei Airport",
      "Dawei Airport"
    ],
    "city": [
      "Dawei",
      "Dawei",
      "Dawei"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "SRU",
    "translations": [
      "Surbung Airport",
      "Surbung Airport",
      "Surbung Airport"
    ],
    "city": [
      "Falam",
      "Falam",
      "Falam"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "GAW",
    "translations": [
      "Gangaw Airport",
      "Gangaw Airport",
      "Gangaw Airport"
    ],
    "city": [
      "Gangaw",
      "Gangaw",
      "Gangaw"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "GWA",
    "translations": [
      "Gwa Airport",
      "Gwa Airport",
      "Gwa Airport"
    ],
    "city": [
      "Gwa",
      "Gwa",
      "Gwa"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "HEH",
    "translations": [
      "Heho Airport",
      "Heho Airport",
      "Heho Airport"
    ],
    "city": [
      "Kalaw Township",
      "Kalaw Township",
      "Kalaw Township"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "HOX",
    "translations": [
      "Hommalinn Airport",
      "Hommalinn Airport",
      "Hommalinn Airport"
    ],
    "city": [
      "Hommalinn",
      "Hommalinn",
      "Hommalinn"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "TIO",
    "translations": [
      "Tilin Airport",
      "Tilin Airport",
      "Tilin Airport"
    ],
    "city": [
      "Tilin",
      "Tilin",
      "Tilin"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "KET",
    "translations": [
      "Kengtung Airport",
      "Kengtung Airport",
      "Kengtung Airport"
    ],
    "city": [
      "Kengtung",
      "Kengtung",
      "Kengtung"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "KHM",
    "translations": [
      "Kanti Airport",
      "Kanti Airport",
      "Kanti Airport"
    ],
    "city": [
      "Kanti",
      "Kanti",
      "Kanti"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "KMV",
    "translations": [
      "Kalay Airport",
      "Kalay Airport",
      "Kalay Airport"
    ],
    "city": [
      "Kalemyo",
      "Kalemyo",
      "Kalemyo"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "KYP",
    "translations": [
      "Kyaukpyu Airport",
      "Kyaukpyu Airport",
      "Kyaukpyu Airport"
    ],
    "city": [
      "Kyaukpyu",
      "Kyaukpyu",
      "Kyaukpyu"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "KAW",
    "translations": [
      "Kawthoung Airport",
      "Kawthoung Airport",
      "Kawthoung Airport"
    ],
    "city": [
      "Kawthoung",
      "Kawthoung",
      "Kawthoung"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "KYT",
    "translations": [
      "Kyauktu Airport",
      "Kyauktu Airport",
      "Kyauktu Airport"
    ],
    "city": [
      "Kyauktu",
      "Kyauktu",
      "Kyauktu"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "LIW",
    "translations": [
      "Loikaw Airport",
      "Loikaw Airport",
      "Loikaw Airport"
    ],
    "city": [
      "Loikaw",
      "Loikaw",
      "Loikaw"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "LSH",
    "translations": [
      "Lashio Airport",
      "Lashio Airport",
      "Lashio Airport"
    ],
    "city": [
      "Lashio",
      "Lashio",
      "Lashio"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "MDL",
    "translations": [
      "Mandalay International Airport",
      "Mandalay International Airport",
      "Mandalay International Airport"
    ],
    "city": [
      "Mandalay",
      "Mandalay",
      "Mandalay"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "MGZ",
    "translations": [
      "Myeik Airport",
      "Myeik Airport",
      "Myeik Airport"
    ],
    "city": [
      "Mkeik",
      "Mkeik",
      "Mkeik"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "MYT",
    "translations": [
      "Myitkyina Airport",
      "Myitkyina Airport",
      "Myitkyina Airport"
    ],
    "city": [
      "Myitkyina",
      "Myitkyina",
      "Myitkyina"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "MNU",
    "translations": [
      "Mawlamyine Airport",
      "Mawlamyine Airport",
      "Mawlamyine Airport"
    ],
    "city": [
      "Mawlamyine",
      "Mawlamyine",
      "Mawlamyine"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "MGU",
    "translations": [
      "Manaung Airport",
      "Manaung Airport",
      "Manaung Airport"
    ],
    "city": [
      "Manaung",
      "Manaung",
      "Manaung"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "MOE",
    "translations": [
      "Momeik Airport",
      "Momeik Airport",
      "Momeik Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "MOG",
    "translations": [
      "Mong Hsat Airport",
      "Mong Hsat Airport",
      "Mong Hsat Airport"
    ],
    "city": [
      "Mong Hsat",
      "Mong Hsat",
      "Mong Hsat"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "MGK",
    "translations": [
      "Mong Tong Airport",
      "Mong Tong Airport",
      "Mong Tong Airport"
    ],
    "city": [
      "Mong Tong",
      "Mong Tong",
      "Mong Tong"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "MWQ",
    "translations": [
      "Magway Airport",
      "Magway Airport",
      "Magway Airport"
    ],
    "city": [
      "Magway",
      "Magway",
      "Magway"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "NYW",
    "translations": [
      "Monywar Airport",
      "Monywar Airport",
      "Monywar Airport"
    ],
    "city": [
      "Monywar",
      "Monywar",
      "Monywar"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "NMS",
    "translations": [
      "Namsang Airport",
      "Namsang Airport",
      "Namsang Airport"
    ],
    "city": [
      "Namsang",
      "Namsang",
      "Namsang"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "NYT",
    "translations": [
      "Nay Pyi Taw International Airport",
      "Nay Pyi Taw International Airport",
      "Nay Pyi Taw International Airport"
    ],
    "city": [
      "Pyinmana",
      "Pyinmana",
      "Pyinmana"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "NMT",
    "translations": [
      "Namtu Airport",
      "Namtu Airport",
      "Namtu Airport"
    ],
    "city": [
      "Namtu",
      "Namtu",
      "Namtu"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "PAA",
    "translations": [
      "Hpa-N Airport",
      "Hpa-N Airport",
      "Hpa-N Airport"
    ],
    "city": [
      "Hpa-N",
      "Hpa-N",
      "Hpa-N"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "PAU",
    "translations": [
      "Pauk Airport",
      "Pauk Airport",
      "Pauk Airport"
    ],
    "city": [
      "Pauk",
      "Pauk",
      "Pauk"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "BSX",
    "translations": [
      "Pathein Airport",
      "Pathein Airport",
      "Pathein Airport"
    ],
    "city": [
      "Pathein",
      "Pathein",
      "Pathein"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "PPU",
    "translations": [
      "Hpapun Airport",
      "Hpapun Airport",
      "Hpapun Airport"
    ],
    "city": [
      "Pa Pun",
      "Pa Pun",
      "Pa Pun"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "PBU",
    "translations": [
      "Putao Airport",
      "Putao Airport",
      "Putao Airport"
    ],
    "city": [
      "Putao",
      "Putao",
      "Putao"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "PKK",
    "translations": [
      "Pakhokku Airport",
      "Pakhokku Airport",
      "Pakhokku Airport"
    ],
    "city": [
      "Pakhokku",
      "Pakhokku",
      "Pakhokku"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "PRU",
    "translations": [
      "Pyay Airport",
      "Pyay Airport",
      "Pyay Airport"
    ],
    "city": [
      "Pye",
      "Pye",
      "Pye"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "AKY",
    "translations": [
      "Sittwe Airport",
      "Sittwe Airport",
      "Sittwe Airport"
    ],
    "city": [
      "Sittwe",
      "Sittwe",
      "Sittwe"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "SNW",
    "translations": [
      "Thandwe Airport",
      "Thandwe Airport",
      "Thandwe Airport"
    ],
    "city": [
      "Thandwe",
      "Thandwe",
      "Thandwe"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "THL",
    "translations": [
      "Tachileik Airport",
      "Tachileik Airport",
      "Tachileik Airport"
    ],
    "city": [
      "Tachileik",
      "Tachileik",
      "Tachileik"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "XYE",
    "translations": [
      "Ye Airport",
      "Ye Airport",
      "Ye Airport"
    ],
    "city": [
      "Ye",
      "Ye",
      "Ye"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "RGN",
    "translations": [
      "Yangon International Airport",
      "Yangon International Airport",
      "Yangon International Airport"
    ],
    "city": [
      "Yangon",
      "Yangon",
      "Yangon"
    ],
    "country": [
      "MM",
      "MM",
      "MM"
    ]
  },
  {
    "iata": "FBS",
    "translations": [
      "Friday Harbor Seaplane Base",
      "Friday Harbor Seaplane Base",
      "Friday Harbor Seaplane Base"
    ],
    "city": [
      "Friday Harbor",
      "Friday Harbor",
      "Friday Harbor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RSJ",
    "translations": [
      "Rosario Seaplane Base",
      "Rosario Seaplane Base",
      "Rosario Seaplane Base"
    ],
    "city": [
      "Rosario",
      "Rosario",
      "Rosario"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "LKE",
    "translations": [
      "Kenmore Air Harbor Seaplane Base",
      "Kenmore Air Harbor Seaplane Base",
      "Kenmore Air Harbor Seaplane Base"
    ],
    "city": [
      "Seattle",
      "Seattle",
      "Seattle"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "RCE",
    "translations": [
      "Roche Harbor Airport",
      "Roche Harbor Airport",
      "Roche Harbor Airport"
    ],
    "city": [
      "Roche Harbor",
      "Roche Harbor",
      "Roche Harbor"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "TQQ",
    "translations": [
      "Maranggo Airport",
      "Maranggo Airport",
      "Maranggo Airport"
    ],
    "city": [
      "Waha-Tomea Island",
      "Waha-Tomea Island",
      "Waha-Tomea Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "WSX",
    "translations": [
      "Westsound/WSX Seaplane Base",
      "Westsound/WSX Seaplane Base",
      "Westsound/WSX Seaplane Base"
    ],
    "city": [
      "West Sound",
      "West Sound",
      "West Sound"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UPG",
    "translations": [
      "Hasanuddin International Airport",
      "Hasanuddin International Airport",
      "Hasanuddin International Airport"
    ],
    "city": [
      "Ujung Pandang",
      "Ujung Pandang",
      "Ujung Pandang"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BIK",
    "translations": [
      "Frans Kaisiepo Airport",
      "Frans Kaisiepo Airport",
      "Frans Kaisiepo Airport"
    ],
    "city": [
      "Biak",
      "Biak",
      "Biak"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "ONI",
    "translations": [
      "Moanamani Airport",
      "Moanamani Airport",
      "Moanamani Airport"
    ],
    "city": [
      "Moanamani",
      "Moanamani",
      "Moanamani"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "FOO",
    "translations": [
      "Kornasoren Airport",
      "Kornasoren Airport",
      "Kornasoren Airport"
    ],
    "city": [
      "Kornasoren",
      "Kornasoren",
      "Kornasoren"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "WET",
    "translations": [
      "Deiyai / Waghete Baru Airport",
      "Deiyai / Waghete Baru Airport",
      "Deiyai / Waghete Baru Airport"
    ],
    "city": [
      "Tigi",
      "Tigi",
      "Tigi"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "NBX",
    "translations": [
      "Douw Aturure Airport",
      "Douw Aturure Airport",
      "Douw Aturure Airport"
    ],
    "city": [
      "Nabire",
      "Nabire",
      "Nabire"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KBF",
    "translations": [
      "Karubaga Airport",
      "Karubaga Airport",
      "Karubaga Airport"
    ],
    "city": [
      "Karubaga",
      "Karubaga",
      "Karubaga"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "ILA",
    "translations": [
      "Ilaga Airport",
      "Ilaga Airport",
      "Ilaga Airport"
    ],
    "city": [
      "Ilaga",
      "Ilaga",
      "Ilaga"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KOX",
    "translations": [
      "Kokonao Airport",
      "Kokonao Airport",
      "Kokonao Airport"
    ],
    "city": [
      "Kokonao",
      "Kokonao",
      "Kokonao"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "ZRI",
    "translations": [
      "Stevanus Rumbewas Airport",
      "Stevanus Rumbewas Airport",
      "Stevanus Rumbewas Airport"
    ],
    "city": [
      "Serui",
      "Serui",
      "Serui"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TIM",
    "translations": [
      "Mozes Kilangin Airport",
      "Mozes Kilangin Airport",
      "Mozes Kilangin Airport"
    ],
    "city": [
      "Timika",
      "Timika",
      "Timika"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "EWI",
    "translations": [
      "Enarotali Airport",
      "Enarotali Airport",
      "Enarotali Airport"
    ],
    "city": [
      "Enarotali",
      "Enarotali",
      "Enarotali"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "WAD",
    "translations": [
      "Andriamena Airport",
      "Andriamena Airport",
      "Andriamena Airport"
    ],
    "city": [
      "Andriamena",
      "Andriamena",
      "Andriamena"
    ],
    "country": [
      "MG",
      "MG",
      "MG"
    ]
  },
  {
    "iata": "BMU",
    "translations": [
      "Sultan Muhammad Salahuddin Airport",
      "Sultan Muhammad Salahuddin Airport",
      "Sultan Muhammad Salahuddin Airport"
    ],
    "city": [
      "Palibelo, Bima",
      "Palibelo, Bima",
      "Palibelo, Bima"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "DPS",
    "translations": [
      "Denpasar I Gusti Ngurah Rai International Airport",
      "Denpasar I Gusti Ngurah Rai International Airport",
      "Denpasar I Gusti Ngurah Rai International Airport"
    ],
    "city": [
      "Kuta, Badung",
      "Kuta, Badung",
      "Kuta, Badung"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LOP",
    "translations": [
      "Lombok International Airport",
      "Lombok International Airport",
      "Lombok International Airport"
    ],
    "city": [
      "Mataram (Pujut, Lombok Tengah)",
      "Mataram (Pujut, Lombok Tengah)",
      "Mataram (Pujut, Lombok Tengah)"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SWQ",
    "translations": [
      "Sultan Muhammad Kaharuddin III Airport",
      "Sultan Muhammad Kaharuddin III Airport",
      "Sultan Muhammad Kaharuddin III Airport"
    ],
    "city": [
      "Sumbawa Besar",
      "Sumbawa Besar",
      "Sumbawa Besar"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TMC",
    "translations": [
      "Tambolaka Airport",
      "Tambolaka Airport",
      "Tambolaka Airport"
    ],
    "city": [
      "Radamata",
      "Radamata",
      "Radamata"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LYK",
    "translations": [
      "Lunyuk Airport",
      "Lunyuk Airport",
      "Lunyuk Airport"
    ],
    "city": [
      "Lunyuk",
      "Lunyuk",
      "Lunyuk"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "WGP",
    "translations": [
      "Umbu Mehang Kunda Airport",
      "Umbu Mehang Kunda Airport",
      "Umbu Mehang Kunda Airport"
    ],
    "city": [
      "Waingapu-Sumba Island",
      "Waingapu-Sumba Island",
      "Waingapu-Sumba Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BWX",
    "translations": [
      "Banyuwangi Airport",
      "Banyuwangi Airport",
      "Banyuwangi Airport"
    ],
    "city": [
      "Rogojampi, Banyuwangi",
      "Rogojampi, Banyuwangi",
      "Rogojampi, Banyuwangi"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TTE",
    "translations": [
      "Sultan Babullah Airport",
      "Sultan Babullah Airport",
      "Sultan Babullah Airport"
    ],
    "city": [
      "Sango",
      "Sango",
      "Sango"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SQN",
    "translations": [
      "Emalamo Sanana Airport",
      "Emalamo Sanana Airport",
      "Emalamo Sanana Airport"
    ],
    "city": [
      "Sanana",
      "Sanana",
      "Sanana"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "OTI",
    "translations": [
      "Pitu Airport",
      "Pitu Airport",
      "Pitu Airport"
    ],
    "city": [
      "Gotalalamo-Morotai Island",
      "Gotalalamo-Morotai Island",
      "Gotalalamo-Morotai Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TRT",
    "translations": [
      "Toraja Airport",
      "Toraja Airport",
      "Toraja Airport"
    ],
    "city": [
      "Toraja",
      "Toraja",
      "Toraja"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LLO",
    "translations": [
      "Bua - Palopo Lagaligo Airport",
      "Bua - Palopo Lagaligo Airport",
      "Bua - Palopo Lagaligo Airport"
    ],
    "city": [
      "Palopo",
      "Palopo",
      "Palopo"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PLW",
    "translations": [
      "Mutiara - SIS Al-Jufrie Airport",
      "Mutiara - SIS Al-Jufrie Airport",
      "Mutiara - SIS Al-Jufrie Airport"
    ],
    "city": [
      "Palu",
      "Palu",
      "Palu"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MJU",
    "translations": [
      "Tampa Padang Airport",
      "Tampa Padang Airport",
      "Tampa Padang Airport"
    ],
    "city": [
      "Mamuju",
      "Mamuju",
      "Mamuju"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TLI",
    "translations": [
      "Sultan Bantilan Airport",
      "Sultan Bantilan Airport",
      "Sultan Bantilan Airport"
    ],
    "city": [
      "Toli Toli-Celebes Island",
      "Toli Toli-Celebes Island",
      "Toli Toli-Celebes Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MXB",
    "translations": [
      "Andi Jemma Airport",
      "Andi Jemma Airport",
      "Andi Jemma Airport"
    ],
    "city": [
      "Masamba",
      "Masamba",
      "Masamba"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PSJ",
    "translations": [
      "Kasiguncu Airport",
      "Kasiguncu Airport",
      "Kasiguncu Airport"
    ],
    "city": [
      "Poso-Celebes Island",
      "Poso-Celebes Island",
      "Poso-Celebes Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "OJU",
    "translations": [
      "Tanjung Api Airport",
      "Tanjung Api Airport",
      "Tanjung Api Airport"
    ],
    "city": [
      "Tojo Una-Una",
      "Tojo Una-Una",
      "Tojo Una-Una"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LUW",
    "translations": [
      "Syukuran Aminuddin Amir Airport",
      "Syukuran Aminuddin Amir Airport",
      "Syukuran Aminuddin Amir Airport"
    ],
    "city": [
      "Luwok",
      "Luwok",
      "Luwok"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "HMS",
    "translations": [
      "Haji Muhammad Sidik Airport",
      "Haji Muhammad Sidik Airport",
      "Haji Muhammad Sidik Airport"
    ],
    "city": [
      "Muara Teweh",
      "Muara Teweh",
      "Muara Teweh"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KLP",
    "translations": [
      "Seruyan Kuala Pembuang Airport",
      "Seruyan Kuala Pembuang Airport",
      "Seruyan Kuala Pembuang Airport"
    ],
    "city": [
      "Seruyan",
      "Seruyan",
      "Seruyan"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PKY",
    "translations": [
      "Tjilik Riwut Airport",
      "Tjilik Riwut Airport",
      "Tjilik Riwut Airport"
    ],
    "city": [
      "Palangkaraya",
      "Palangkaraya",
      "Palangkaraya"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "YIA",
    "translations": [
      "Yogyakarta International Airport",
      "Yogyakarta International Airport",
      "Yogyakarta International Airport"
    ],
    "city": [
      "Yogyakarta",
      "Yogyakarta",
      "Yogyakarta"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "CXP",
    "translations": [
      "Tunggul Wulung Airport",
      "Tunggul Wulung Airport",
      "Tunggul Wulung Airport"
    ],
    "city": [
      "Cilacap",
      "Cilacap",
      "Cilacap"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PWL",
    "translations": [
      "Jenderal Besar Soedirman Airport",
      "Jenderal Besar Soedirman Airport",
      "Jenderal Besar Soedirman Airport"
    ],
    "city": [
      "Purwokerto-Java Island",
      "Purwokerto-Java Island",
      "Purwokerto-Java Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KWB",
    "translations": [
      "Dewadaru Airport",
      "Dewadaru Airport",
      "Dewadaru Airport"
    ],
    "city": [
      "Karimunjawa",
      "Karimunjawa",
      "Karimunjawa"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BUI",
    "translations": [
      "Bokondini Airport",
      "Bokondini Airport",
      "Bokondini Airport"
    ],
    "city": [
      "Bokondini",
      "Bokondini",
      "Bokondini"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "DRH",
    "translations": [
      "Dabra Airport",
      "Dabra Airport",
      "Dabra Airport"
    ],
    "city": [
      "Dabra",
      "Dabra",
      "Dabra"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BXM",
    "translations": [
      "Batom Airport",
      "Batom Airport",
      "Batom Airport"
    ],
    "city": [
      "Batom",
      "Batom",
      "Batom"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "ZRM",
    "translations": [
      "Mararena Sarmi Airport",
      "Mararena Sarmi Airport",
      "Mararena Sarmi Airport"
    ],
    "city": [
      "Sarmi",
      "Sarmi",
      "Sarmi"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "DJJ",
    "translations": [
      "Dortheys Hiyo Eluay International Airport",
      "Dortheys Hiyo Eluay International Airport",
      "Dortheys Hiyo Eluay International Airport"
    ],
    "city": [
      "Sentani",
      "Sentani",
      "Sentani"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LHI",
    "translations": [
      "Lereh Airport",
      "Lereh Airport",
      "Lereh Airport"
    ],
    "city": [
      "Lereh-Papua Island",
      "Lereh-Papua Island",
      "Lereh-Papua Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LII",
    "translations": [
      "Mulia Airport",
      "Mulia Airport",
      "Mulia Airport"
    ],
    "city": [
      "Mulia-Papua Island",
      "Mulia-Papua Island",
      "Mulia-Papua Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "OKL",
    "translations": [
      "Oksibil Airport",
      "Oksibil Airport",
      "Oksibil Airport"
    ],
    "city": [
      "Oksibil",
      "Oksibil",
      "Oksibil"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SEH",
    "translations": [
      "Senggeh Airport",
      "Senggeh Airport",
      "Senggeh Airport"
    ],
    "city": [
      "Senggeh",
      "Senggeh",
      "Senggeh"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MDP",
    "translations": [
      "Mindiptana Airport",
      "Mindiptana Airport",
      "Mindiptana Airport"
    ],
    "city": [
      "Mindiptana-Papua Island",
      "Mindiptana-Papua Island",
      "Mindiptana-Papua Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BXD",
    "translations": [
      "Bade Airport",
      "Bade Airport",
      "Bade Airport"
    ],
    "city": [
      "Bade",
      "Bade",
      "Bade"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MKQ",
    "translations": [
      "Mopah International Airport",
      "Mopah International Airport",
      "Mopah International Airport"
    ],
    "city": [
      "Merauke",
      "Merauke",
      "Merauke"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KCD",
    "translations": [
      "Kamur Airport",
      "Kamur Airport",
      "Kamur Airport"
    ],
    "city": [
      "Kamur",
      "Kamur",
      "Kamur"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "OKQ",
    "translations": [
      "Okaba Airport",
      "Okaba Airport",
      "Okaba Airport"
    ],
    "city": [
      "Okaba",
      "Okaba",
      "Okaba"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KEI",
    "translations": [
      "Kepi Airport",
      "Kepi Airport",
      "Kepi Airport"
    ],
    "city": [
      "Kepi",
      "Kepi",
      "Kepi"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "ZEG",
    "translations": [
      "Senggo Airport",
      "Senggo Airport",
      "Senggo Airport"
    ],
    "city": [
      "Senggo-Papua Island",
      "Senggo-Papua Island",
      "Senggo-Papua Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TMH",
    "translations": [
      "Tanah Merah Airport",
      "Tanah Merah Airport",
      "Tanah Merah Airport"
    ],
    "city": [
      "Tanah Merah",
      "Tanah Merah",
      "Tanah Merah"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "GHS",
    "translations": [
      "Melalan Airport",
      "Melalan Airport",
      "Melalan Airport"
    ],
    "city": [
      "Melak-Borneo Island",
      "Melak-Borneo Island",
      "Melak-Borneo Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TJS",
    "translations": [
      "Tanjung Harapan Airport",
      "Tanjung Harapan Airport",
      "Tanjung Harapan Airport"
    ],
    "city": [
      "Tanjung Selor-Borneo Island",
      "Tanjung Selor-Borneo Island",
      "Tanjung Selor-Borneo Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "DTD",
    "translations": [
      "Datadawai Airport",
      "Datadawai Airport",
      "Datadawai Airport"
    ],
    "city": [
      "Datadawai-Borneo Island",
      "Datadawai-Borneo Island",
      "Datadawai-Borneo Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BPN",
    "translations": [
      "Sultan Aji Muhammad Sulaiman Sepinggan International Airport",
      "Sultan Aji Muhammad Sulaiman Sepinggan International Airport",
      "Sultan Aji Muhammad Sulaiman Sepinggan International Airport"
    ],
    "city": [
      "Balikpapan",
      "Balikpapan",
      "Balikpapan"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TRK",
    "translations": [
      "Juwata International Airport / Suharnoko Harbani AFB",
      "Juwata International Airport / Suharnoko Harbani AFB",
      "Juwata International Airport / Suharnoko Harbani AFB"
    ],
    "city": [
      "Tarakan",
      "Tarakan",
      "Tarakan"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "AAP",
    "translations": [
      "Aji Pangeran Tumenggung Pranoto International Airport",
      "Aji Pangeran Tumenggung Pranoto International Airport",
      "Aji Pangeran Tumenggung Pranoto International Airport"
    ],
    "city": [
      "Samarinda",
      "Samarinda",
      "Samarinda"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BYQ",
    "translations": [
      "Bunyu Airport",
      "Bunyu Airport",
      "Bunyu Airport"
    ],
    "city": [
      "Bunju Island",
      "Bunju Island",
      "Bunju Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "GLX",
    "translations": [
      "Gamarmalamo Airport",
      "Gamarmalamo Airport",
      "Gamarmalamo Airport"
    ],
    "city": [
      "Galela-Celebes Island",
      "Galela-Celebes Island",
      "Galela-Celebes Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PGQ",
    "translations": [
      "Buli Airport",
      "Buli Airport",
      "Buli Airport"
    ],
    "city": [
      "Pekaulang",
      "Pekaulang",
      "Pekaulang"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "GTO",
    "translations": [
      "Jalaluddin Airport",
      "Jalaluddin Airport",
      "Jalaluddin Airport"
    ],
    "city": [
      "Gorontalo-Celebes Island",
      "Gorontalo-Celebes Island",
      "Gorontalo-Celebes Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "NAH",
    "translations": [
      "Naha Airport",
      "Naha Airport",
      "Naha Airport"
    ],
    "city": [
      "Tabukan Utara, Sangihe Islands",
      "Tabukan Utara, Sangihe Islands",
      "Tabukan Utara, Sangihe Islands"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LKM",
    "translations": [
      "Bolaang Mongondow Airport",
      "Bolaang Mongondow Airport",
      "Bolaang Mongondow Airport"
    ],
    "city": [
      "Lolak",
      "Lolak",
      "Lolak"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "GEB",
    "translations": [
      "Gebe Airport",
      "Gebe Airport",
      "Gebe Airport"
    ],
    "city": [
      "Gebe Island",
      "Gebe Island",
      "Gebe Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KAZ",
    "translations": [
      "Kuabang Airport",
      "Kuabang Airport",
      "Kuabang Airport"
    ],
    "city": [
      "Kao-Celebes Island",
      "Kao-Celebes Island",
      "Kao-Celebes Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MDC",
    "translations": [
      "Sam Ratulangi Airport",
      "Sam Ratulangi Airport",
      "Sam Ratulangi Airport"
    ],
    "city": [
      "Manado",
      "Manado",
      "Manado"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MNA",
    "translations": [
      "Melangguane Airport",
      "Melangguane Airport",
      "Melangguane Airport"
    ],
    "city": [
      "Karakelong Island",
      "Karakelong Island",
      "Karakelong Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BRG",
    "translations": [
      "Siau/Sitaro Airport",
      "Siau/Sitaro Airport",
      "Siau/Sitaro Airport"
    ],
    "city": [
      "Balirangen",
      "Balirangen",
      "Balirangen"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MWS",
    "translations": [
      "Indonesia Morowali Industrial Park (IMIP) Airport",
      "Indonesia Morowali Industrial Park (IMIP) Airport",
      "Indonesia Morowali Industrial Park (IMIP) Airport"
    ],
    "city": [
      "Morowali",
      "Morowali",
      "Morowali"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "IAX",
    "translations": [
      "Miangas Airport",
      "Miangas Airport",
      "Miangas Airport"
    ],
    "city": [
      "Miangas",
      "Miangas",
      "Miangas"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "UOL",
    "translations": [
      "Buol - Pogogul Airport",
      "Buol - Pogogul Airport",
      "Buol - Pogogul Airport"
    ],
    "city": [
      "Buol-Celebes Island",
      "Buol-Celebes Island",
      "Buol-Celebes Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "WAN",
    "translations": [
      "Waverney Airport",
      "Waverney Airport",
      "Waverney Airport"
    ],
    "city": [
      "Waverney",
      "Waverney",
      "Waverney"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BTW",
    "translations": [
      "Bersujud Airport",
      "Bersujud Airport",
      "Bersujud Airport"
    ],
    "city": [
      "Batu Licin",
      "Batu Licin",
      "Batu Licin"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PKN",
    "translations": [
      "Iskandar Airport",
      "Iskandar Airport",
      "Iskandar Airport"
    ],
    "city": [
      "Pangkalanbun",
      "Pangkalanbun",
      "Pangkalanbun"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KBU",
    "translations": [
      "Gusti Syamsir Alam Airport",
      "Gusti Syamsir Alam Airport",
      "Gusti Syamsir Alam Airport"
    ],
    "city": [
      "Stagen",
      "Stagen",
      "Stagen"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TJG",
    "translations": [
      "Warukin Airport",
      "Warukin Airport",
      "Warukin Airport"
    ],
    "city": [
      "Tanta-Tabalong",
      "Tanta-Tabalong",
      "Tanta-Tabalong"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BDJ",
    "translations": [
      "Syamsudin Noor International Airport",
      "Syamsudin Noor International Airport",
      "Syamsudin Noor International Airport"
    ],
    "city": [
      "Landasan Ulin",
      "Landasan Ulin",
      "Landasan Ulin"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SMQ",
    "translations": [
      "Sampit (Hasan) Airport",
      "Sampit (Hasan) Airport",
      "Sampit (Hasan) Airport"
    ],
    "city": [
      "Sampit",
      "Sampit",
      "Sampit"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TBM",
    "translations": [
      "Tumbang Samba Airport",
      "Tumbang Samba Airport",
      "Tumbang Samba Airport"
    ],
    "city": [
      "Tumbang Samba-Borneo Island",
      "Tumbang Samba-Borneo Island",
      "Tumbang Samba-Borneo Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "AHI",
    "translations": [
      "Amahai Airport",
      "Amahai Airport",
      "Amahai Airport"
    ],
    "city": [
      "Amahai",
      "Amahai",
      "Amahai"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "NDA",
    "translations": [
      "Bandanaira Airport",
      "Bandanaira Airport",
      "Bandanaira Airport"
    ],
    "city": [
      "Bandanaira",
      "Bandanaira",
      "Bandanaira"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "DOB",
    "translations": [
      "Rar Gwamar Airport",
      "Rar Gwamar Airport",
      "Rar Gwamar Airport"
    ],
    "city": [
      "Dobo-Warmar Island",
      "Dobo-Warmar Island",
      "Dobo-Warmar Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MAL",
    "translations": [
      "Mangole Airport, Falabisahaya",
      "Mangole Airport, Falabisahaya",
      "Mangole Airport, Falabisahaya"
    ],
    "city": [
      "Mangole Island",
      "Mangole Island",
      "Mangole Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LUV",
    "translations": [
      "Karel Sadsuitubun Airport",
      "Karel Sadsuitubun Airport",
      "Karel Sadsuitubun Airport"
    ],
    "city": [
      "Langgur",
      "Langgur",
      "Langgur"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "NRE",
    "translations": [
      "Namrole Airport",
      "Namrole Airport",
      "Namrole Airport"
    ],
    "city": [
      "Namrole",
      "Namrole",
      "Namrole"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LAH",
    "translations": [
      "Oesman Sadik Airport",
      "Oesman Sadik Airport",
      "Oesman Sadik Airport"
    ],
    "city": [
      "Labuha-Halmahera Island",
      "Labuha-Halmahera Island",
      "Labuha-Halmahera Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BJK",
    "translations": [
      "Benjina Airport",
      "Benjina Airport",
      "Benjina Airport"
    ],
    "city": [
      "Maikoor Island",
      "Maikoor Island",
      "Maikoor Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "NAM",
    "translations": [
      "Namniwel Airport",
      "Namniwel Airport",
      "Namniwel Airport"
    ],
    "city": [
      "Namniwel",
      "Namniwel",
      "Namniwel"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "AMQ",
    "translations": [
      "Pattimura International Airport",
      "Pattimura International Airport",
      "Pattimura International Airport"
    ],
    "city": [
      "Ambon",
      "Ambon",
      "Ambon"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TAX",
    "translations": [
      "Taliabu Island Airport",
      "Taliabu Island Airport",
      "Taliabu Island Airport"
    ],
    "city": [
      "Tikong-Taliabu Island",
      "Tikong-Taliabu Island",
      "Tikong-Taliabu Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "WBA",
    "translations": [
      "Wahai Airport",
      "Wahai Airport",
      "Wahai Airport"
    ],
    "city": [
      "Wahai",
      "Wahai",
      "Wahai"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "RTU",
    "translations": [
      "Maratua Airport",
      "Maratua Airport",
      "Maratua Airport"
    ],
    "city": [
      "Maratua",
      "Maratua",
      "Maratua"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LNU",
    "translations": [
      "Robert Atty Bessing",
      "Robert Atty Bessing",
      "Robert Atty Bessing"
    ],
    "city": [
      "Malinau",
      "Malinau",
      "Malinau"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BEJ",
    "translations": [
      "Kalimarau Airport",
      "Kalimarau Airport",
      "Kalimarau Airport"
    ],
    "city": [
      "Tanjung Redeb - Borneo Island",
      "Tanjung Redeb - Borneo Island",
      "Tanjung Redeb - Borneo Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MLG",
    "translations": [
      "Abdul Rachman Saleh Airport",
      "Abdul Rachman Saleh Airport",
      "Abdul Rachman Saleh Airport"
    ],
    "city": [
      "Malang",
      "Malang",
      "Malang"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "CPF",
    "translations": [
      "Ngloram Airport",
      "Ngloram Airport",
      "Ngloram Airport"
    ],
    "city": [
      "Blora",
      "Blora",
      "Blora"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "JBB",
    "translations": [
      "Notohadinegoro Airport",
      "Notohadinegoro Airport",
      "Notohadinegoro Airport"
    ],
    "city": [
      "Jember",
      "Jember",
      "Jember"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "JOG",
    "translations": [
      "Adisutjipto Airport",
      "Adisutjipto Airport",
      "Adisutjipto Airport"
    ],
    "city": [
      "Yogyakarta",
      "Yogyakarta",
      "Yogyakarta"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SOC",
    "translations": [
      "Adisumarmo Airport",
      "Adisumarmo Airport",
      "Adisumarmo Airport"
    ],
    "city": [
      "Surakarta",
      "Surakarta",
      "Surakarta"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SUB",
    "translations": [
      "Juanda International Airport",
      "Juanda International Airport",
      "Juanda International Airport"
    ],
    "city": [
      "Surabaya",
      "Surabaya",
      "Surabaya"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SRG",
    "translations": [
      "Achmad Yani Airport",
      "Achmad Yani Airport",
      "Achmad Yani Airport"
    ],
    "city": [
      "Semarang",
      "Semarang",
      "Semarang"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SUP",
    "translations": [
      "Trunojoyo Airport",
      "Trunojoyo Airport",
      "Trunojoyo Airport"
    ],
    "city": [
      "Sumenep",
      "Sumenep",
      "Sumenep"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BXW",
    "translations": [
      "Harun Thohir Airport",
      "Harun Thohir Airport",
      "Harun Thohir Airport"
    ],
    "city": [
      "Bawean",
      "Bawean",
      "Bawean"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "AYW",
    "translations": [
      "Ayawasi Airport",
      "Ayawasi Airport",
      "Ayawasi Airport"
    ],
    "city": [
      "Ayawasi",
      "Ayawasi",
      "Ayawasi"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "NTI",
    "translations": [
      "Stenkol Airport",
      "Stenkol Airport",
      "Stenkol Airport"
    ],
    "city": [
      "Bintuni",
      "Bintuni",
      "Bintuni"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "RSK",
    "translations": [
      "Abresso Airport",
      "Abresso Airport",
      "Abresso Airport"
    ],
    "city": [
      "Ransiki-Papua Island",
      "Ransiki-Papua Island",
      "Ransiki-Papua Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KEQ",
    "translations": [
      "Kebar Airport",
      "Kebar Airport",
      "Kebar Airport"
    ],
    "city": [
      "Kebar",
      "Kebar",
      "Kebar"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "FKQ",
    "translations": [
      "Fakfak Airport",
      "Fakfak Airport",
      "Fakfak Airport"
    ],
    "city": [
      "Fakfak",
      "Fakfak",
      "Fakfak"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "INX",
    "translations": [
      "Inanwatan Airport",
      "Inanwatan Airport",
      "Inanwatan Airport"
    ],
    "city": [
      "Inanwatan",
      "Inanwatan",
      "Inanwatan"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KNG",
    "translations": [
      "Kaimana Airport",
      "Kaimana Airport",
      "Kaimana Airport"
    ],
    "city": [
      "Kaimana",
      "Kaimana",
      "Kaimana"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "RDE",
    "translations": [
      "Merdey Airport",
      "Merdey Airport",
      "Merdey Airport"
    ],
    "city": [
      "Merdei-Papua Island",
      "Merdei-Papua Island",
      "Merdei-Papua Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "RJM",
    "translations": [
      "Marinda Airport",
      "Marinda Airport",
      "Marinda Airport"
    ],
    "city": [
      "Waisai",
      "Waisai",
      "Waisai"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BXB",
    "translations": [
      "Babo Airport",
      "Babo Airport",
      "Babo Airport"
    ],
    "city": [
      "Babo",
      "Babo",
      "Babo"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MKW",
    "translations": [
      "Rendani Airport",
      "Rendani Airport",
      "Rendani Airport"
    ],
    "city": [
      "Manokwari",
      "Manokwari",
      "Manokwari"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SOQ",
    "translations": [
      "Domine Eduard Osok Airport",
      "Domine Eduard Osok Airport",
      "Domine Eduard Osok Airport"
    ],
    "city": [
      "Sorong",
      "Sorong",
      "Sorong"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TXM",
    "translations": [
      "Teminabuan Airport",
      "Teminabuan Airport",
      "Teminabuan Airport"
    ],
    "city": [
      "Atinjoe",
      "Atinjoe",
      "Atinjoe"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KBX",
    "translations": [
      "Kambuaya Airport",
      "Kambuaya Airport",
      "Kambuaya Airport"
    ],
    "city": [
      "Kambuaya-Papua Island",
      "Kambuaya-Papua Island",
      "Kambuaya-Papua Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "WSR",
    "translations": [
      "Wasior Airport",
      "Wasior Airport",
      "Wasior Airport"
    ],
    "city": [
      "Wasior",
      "Wasior",
      "Wasior"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "ABU",
    "translations": [
      "AA Bere Tallo (Haliwen) Airport",
      "AA Bere Tallo (Haliwen) Airport",
      "AA Bere Tallo (Haliwen) Airport"
    ],
    "city": [
      "Atambua",
      "Atambua",
      "Atambua"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BJW",
    "translations": [
      "Bajawa Soa (Turelelo) Airport",
      "Bajawa Soa (Turelelo) Airport",
      "Bajawa Soa (Turelelo) Airport"
    ],
    "city": [
      "Soa, Ngada",
      "Soa, Ngada",
      "Soa, Ngada"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MOF",
    "translations": [
      "Frans Xavier Seda Airport",
      "Frans Xavier Seda Airport",
      "Frans Xavier Seda Airport"
    ],
    "city": [
      "Waioti",
      "Waioti",
      "Waioti"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "ENE",
    "translations": [
      "H. Hasan Aroeboesman (Ende) Airport",
      "H. Hasan Aroeboesman (Ende) Airport",
      "H. Hasan Aroeboesman (Ende) Airport"
    ],
    "city": [
      "Ende",
      "Ende",
      "Ende"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "RTG",
    "translations": [
      "Frans Sales Lega Airport",
      "Frans Sales Lega Airport",
      "Frans Sales Lega Airport"
    ],
    "city": [
      "Satar Tacik, Manggarai",
      "Satar Tacik, Manggarai",
      "Satar Tacik, Manggarai"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LKA",
    "translations": [
      "Larantuka Gewayentana Airport",
      "Larantuka Gewayentana Airport",
      "Larantuka Gewayentana Airport"
    ],
    "city": [
      "Tiwatobi",
      "Tiwatobi",
      "Tiwatobi"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "ARD",
    "translations": [
      "Alor Island - Mali Airport",
      "Alor Island - Mali Airport",
      "Alor Island - Mali Airport"
    ],
    "city": [
      "Kabola",
      "Kabola",
      "Kabola"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LBJ",
    "translations": [
      "Komodo Airport",
      "Komodo Airport",
      "Komodo Airport"
    ],
    "city": [
      "Labuan Bajo, Manggarai Barat",
      "Labuan Bajo, Manggarai Barat",
      "Labuan Bajo, Manggarai Barat"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "RTI",
    "translations": [
      "David Constantijn Saudale Airport",
      "David Constantijn Saudale Airport",
      "David Constantijn Saudale Airport"
    ],
    "city": [
      "Ba'a - Rote Island",
      "Ba'a - Rote Island",
      "Ba'a - Rote Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SAU",
    "translations": [
      "Sabu-Tardanu Airport",
      "Sabu-Tardanu Airport",
      "Sabu-Tardanu Airport"
    ],
    "city": [
      "Sabu-Sawu Island",
      "Sabu-Sawu Island",
      "Sabu-Sawu Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KOE",
    "translations": [
      "El Tari Airport",
      "El Tari Airport",
      "El Tari Airport"
    ],
    "city": [
      "Kupang",
      "Kupang",
      "Kupang"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LWE",
    "translations": [
      "Wonopito Airport",
      "Wonopito Airport",
      "Wonopito Airport"
    ],
    "city": [
      "Lewoleba",
      "Lewoleba",
      "Lewoleba"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "WMX",
    "translations": [
      "Wamena Airport",
      "Wamena Airport",
      "Wamena Airport"
    ],
    "city": [
      "Wamena",
      "Wamena",
      "Wamena"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BUW",
    "translations": [
      "Betoambari Airport",
      "Betoambari Airport",
      "Betoambari Airport"
    ],
    "city": [
      "Bau Bau",
      "Bau Bau",
      "Bau Bau"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "WNI",
    "translations": [
      "Matahora Airport",
      "Matahora Airport",
      "Matahora Airport"
    ],
    "city": [
      "Wangi-wangi Island",
      "Wangi-wangi Island",
      "Wangi-wangi Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KSR",
    "translations": [
      "Selayar - Haji Aroeppala Airport",
      "Selayar - Haji Aroeppala Airport",
      "Selayar - Haji Aroeppala Airport"
    ],
    "city": [
      "Benteng",
      "Benteng",
      "Benteng"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "APD",
    "translations": [
      "Arung Palakka Airport",
      "Arung Palakka Airport",
      "Arung Palakka Airport"
    ],
    "city": [
      "Bone",
      "Bone",
      "Bone"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KXB",
    "translations": [
      "Sangia Nibandera Airport",
      "Sangia Nibandera Airport",
      "Sangia Nibandera Airport"
    ],
    "city": [
      "Kolaka",
      "Kolaka",
      "Kolaka"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "RAQ",
    "translations": [
      "Sugimanuru Airport",
      "Sugimanuru Airport",
      "Sugimanuru Airport"
    ],
    "city": [
      "Raha",
      "Raha",
      "Raha"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SQR",
    "translations": [
      "Soroako Airport",
      "Soroako Airport",
      "Soroako Airport"
    ],
    "city": [
      "Soroako",
      "Soroako",
      "Soroako"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TTR",
    "translations": [
      "Pongtiku Airport",
      "Pongtiku Airport",
      "Pongtiku Airport"
    ],
    "city": [
      "Makale",
      "Makale",
      "Makale"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KDI",
    "translations": [
      "Haluoleo Airport",
      "Haluoleo Airport",
      "Haluoleo Airport"
    ],
    "city": [
      "Kendari",
      "Kendari",
      "Kendari"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "WBB",
    "translations": [
      "Stebbins Airport",
      "Stebbins Airport",
      "Stebbins Airport"
    ],
    "city": [
      "Stebbins",
      "Stebbins",
      "Stebbins"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BTU",
    "translations": [
      "Bintulu Airport",
      "Bintulu Airport",
      "Bintulu Airport"
    ],
    "city": [
      "Bintulu",
      "Bintulu",
      "Bintulu"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "BLG",
    "translations": [
      "Belaga Airport",
      "Belaga Airport",
      "Belaga Airport"
    ],
    "city": [
      "Belaga",
      "Belaga",
      "Belaga"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "LSM",
    "translations": [
      "Long Semado Airport",
      "Long Semado Airport",
      "Long Semado Airport"
    ],
    "city": [
      "Long Semado",
      "Long Semado",
      "Long Semado"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "LGL",
    "translations": [
      "Long Lellang Airport",
      "Long Lellang Airport",
      "Long Lellang Airport"
    ],
    "city": [
      "Long Datih",
      "Long Datih",
      "Long Datih"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "KCH",
    "translations": [
      "Kuching International Airport",
      "Kuching International Airport",
      "Kuching International Airport"
    ],
    "city": [
      "Kuching",
      "Kuching",
      "Kuching"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "ODN",
    "translations": [
      "Long Seridan Airport",
      "Long Seridan Airport",
      "Long Seridan Airport"
    ],
    "city": [
      "Long Seridan",
      "Long Seridan",
      "Long Seridan"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "LMN",
    "translations": [
      "Limbang Airport",
      "Limbang Airport",
      "Limbang Airport"
    ],
    "city": [
      "Limbang",
      "Limbang",
      "Limbang"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "MKM",
    "translations": [
      "Mukah Airport",
      "Mukah Airport",
      "Mukah Airport"
    ],
    "city": [
      "Mukah",
      "Mukah",
      "Mukah"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "LKH",
    "translations": [
      "Long Akah Airport",
      "Long Akah Airport",
      "Long Akah Airport"
    ],
    "city": [
      "Long Akah",
      "Long Akah",
      "Long Akah"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "MUR",
    "translations": [
      "Marudi Airport",
      "Marudi Airport",
      "Marudi Airport"
    ],
    "city": [
      "Marudi",
      "Marudi",
      "Marudi"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "BSE",
    "translations": [
      "Sematan Airport",
      "Sematan Airport",
      "Sematan Airport"
    ],
    "city": [
      "Sematan",
      "Sematan",
      "Sematan"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "KPI",
    "translations": [
      "Kapit Airport",
      "Kapit Airport",
      "Kapit Airport"
    ],
    "city": [
      "Kapit",
      "Kapit",
      "Kapit"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "BKM",
    "translations": [
      "Bakalalan Airport",
      "Bakalalan Airport",
      "Bakalalan Airport"
    ],
    "city": [
      "Bakalalan",
      "Bakalalan",
      "Bakalalan"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "MYY",
    "translations": [
      "Miri Airport",
      "Miri Airport",
      "Miri Airport"
    ],
    "city": [
      "Miri",
      "Miri",
      "Miri"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "SBW",
    "translations": [
      "Sibu Airport",
      "Sibu Airport",
      "Sibu Airport"
    ],
    "city": [
      "Sibu",
      "Sibu",
      "Sibu"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "LSU",
    "translations": [
      "Long Sukang Airport",
      "Long Sukang Airport",
      "Long Sukang Airport"
    ],
    "city": [
      "Long Sukang",
      "Long Sukang",
      "Long Sukang"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "LWY",
    "translations": [
      "Lawas Airport",
      "Lawas Airport",
      "Lawas Airport"
    ],
    "city": [
      "Lawas",
      "Lawas",
      "Lawas"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "BBN",
    "translations": [
      "Bario Airport",
      "Bario Airport",
      "Bario Airport"
    ],
    "city": [
      "Bario",
      "Bario",
      "Bario"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "SMM",
    "translations": [
      "Semporna Airport",
      "Semporna Airport",
      "Semporna Airport"
    ],
    "city": [
      "Semporna",
      "Semporna",
      "Semporna"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "LDU",
    "translations": [
      "Lahad Datu Airport",
      "Lahad Datu Airport",
      "Lahad Datu Airport"
    ],
    "city": [
      "Lahad Datu",
      "Lahad Datu",
      "Lahad Datu"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "TEL",
    "translations": [
      "Telupid Airport",
      "Telupid Airport",
      "Telupid Airport"
    ],
    "city": [
      "Telupid",
      "Telupid",
      "Telupid"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "KGU",
    "translations": [
      "Keningau Airport",
      "Keningau Airport",
      "Keningau Airport"
    ],
    "city": [
      "Keningau",
      "Keningau",
      "Keningau"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "SXS",
    "translations": [
      "Sahabat [Sahabat 16] Airport",
      "Sahabat [Sahabat 16] Airport",
      "Sahabat [Sahabat 16] Airport"
    ],
    "city": [
      "Sahabat",
      "Sahabat",
      "Sahabat"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "BKI",
    "translations": [
      "Kota Kinabalu International Airport",
      "Kota Kinabalu International Airport",
      "Kota Kinabalu International Airport"
    ],
    "city": [
      "Kota Kinabalu",
      "Kota Kinabalu",
      "Kota Kinabalu"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "LBU",
    "translations": [
      "Labuan Airport",
      "Labuan Airport",
      "Labuan Airport"
    ],
    "city": [
      "Labuan",
      "Labuan",
      "Labuan"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "TMG",
    "translations": [
      "Tomanggong Airport",
      "Tomanggong Airport",
      "Tomanggong Airport"
    ],
    "city": [
      "Tomanggong",
      "Tomanggong",
      "Tomanggong"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "GSA",
    "translations": [
      "Long Pasia Airport",
      "Long Pasia Airport",
      "Long Pasia Airport"
    ],
    "city": [
      "Long Miau",
      "Long Miau",
      "Long Miau"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "SPE",
    "translations": [
      "Sepulot Airport",
      "Sepulot Airport",
      "Sepulot Airport"
    ],
    "city": [
      "Sepulot",
      "Sepulot",
      "Sepulot"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "PAY",
    "translations": [
      "Pamol Airport",
      "Pamol Airport",
      "Pamol Airport"
    ],
    "city": [
      "Pamol",
      "Pamol",
      "Pamol"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "RNU",
    "translations": [
      "Ranau Airport",
      "Ranau Airport",
      "Ranau Airport"
    ],
    "city": [
      "Ranau",
      "Ranau",
      "Ranau"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "SDK",
    "translations": [
      "Sandakan Airport",
      "Sandakan Airport",
      "Sandakan Airport"
    ],
    "city": [
      "Sandakan",
      "Sandakan",
      "Sandakan"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "KUD",
    "translations": [
      "Kudat Airport",
      "Kudat Airport",
      "Kudat Airport"
    ],
    "city": [
      "Kudat",
      "Kudat",
      "Kudat"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "TWU",
    "translations": [
      "Tawau Airport",
      "Tawau Airport",
      "Tawau Airport"
    ],
    "city": [
      "Tawau",
      "Tawau",
      "Tawau"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "MZV",
    "translations": [
      "Mulu Airport",
      "Mulu Airport",
      "Mulu Airport"
    ],
    "city": [
      "Mulu",
      "Mulu",
      "Mulu"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "BWN",
    "translations": [
      "Brunei International Airport",
      "Brunei International Airport",
      "Brunei International Airport"
    ],
    "city": [
      "Bandar Seri Begawan",
      "Bandar Seri Begawan",
      "Bandar Seri Begawan"
    ],
    "country": [
      "BN",
      "BN",
      "BN"
    ]
  },
  {
    "iata": "TGC",
    "translations": [
      "Tanjung Manis Airport",
      "Tanjung Manis Airport",
      "Tanjung Manis Airport"
    ],
    "city": [
      "Belawai",
      "Belawai",
      "Belawai"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "WDA",
    "translations": [
      "Al Ain Airport Ain District, Shabwah Governorate, Yemen",
      "Al Ain Airport Ain District, Shabwah Governorate, Yemen",
      "Al Ain Airport Ain District, Shabwah Governorate, Yemen"
    ],
    "city": [
      "Ain District",
      "Ain District",
      "Ain District"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "WED",
    "translations": [
      "Wedau Airport",
      "Wedau Airport",
      "Wedau Airport"
    ],
    "city": [
      "Wedau",
      "Wedau",
      "Wedau"
    ],
    "country": [
      "PG",
      "PG",
      "PG"
    ]
  },
  {
    "iata": "WHL",
    "translations": [
      "Welshpool Airport",
      "Welshpool Airport",
      "Welshpool Airport"
    ],
    "city": [
      "Welshpool",
      "Welshpool",
      "Welshpool"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PKU",
    "translations": [
      "Sultan Syarif Kasim II International Airport / Roesmin Nurjadin AFB",
      "Sultan Syarif Kasim II International Airport / Roesmin Nurjadin AFB",
      "Sultan Syarif Kasim II International Airport / Roesmin Nurjadin AFB"
    ],
    "city": [
      "Pekanbaru",
      "Pekanbaru",
      "Pekanbaru"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "DUM",
    "translations": [
      "Pinang Kampai Airport",
      "Pinang Kampai Airport",
      "Pinang Kampai Airport"
    ],
    "city": [
      "Dumai",
      "Dumai",
      "Dumai"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "RGT",
    "translations": [
      "Japura Airport",
      "Japura Airport",
      "Japura Airport"
    ],
    "city": [
      "Rengat-Sumatra Island",
      "Rengat-Sumatra Island",
      "Rengat-Sumatra Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SEQ",
    "translations": [
      "Sungai Pakning Bengkalis Airport",
      "Sungai Pakning Bengkalis Airport",
      "Sungai Pakning Bengkalis Airport"
    ],
    "city": [
      "Bengkalis-Sumatra Island",
      "Bengkalis-Sumatra Island",
      "Bengkalis-Sumatra Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TJB",
    "translations": [
      "Raja Haji Abdullah Airport",
      "Raja Haji Abdullah Airport",
      "Raja Haji Abdullah Airport"
    ],
    "city": [
      "Tanjung Balai-Karinmunbesar Island",
      "Tanjung Balai-Karinmunbesar Island",
      "Tanjung Balai-Karinmunbesar Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KJT",
    "translations": [
      "Kertajati International Airport",
      "Kertajati International Airport",
      "Kertajati International Airport"
    ],
    "city": [
      "Kertajati",
      "Kertajati",
      "Kertajati"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "RTO",
    "translations": [
      "Budiarto Airport",
      "Budiarto Airport",
      "Budiarto Airport"
    ],
    "city": [
      "Tangerang-Java Island",
      "Tangerang-Java Island",
      "Tangerang-Java Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BDO",
    "translations": [
      "Husein Sastranegara International Airport",
      "Husein Sastranegara International Airport",
      "Husein Sastranegara International Airport"
    ],
    "city": [
      "Bandung",
      "Bandung",
      "Bandung"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "CBN",
    "translations": [
      "Penggung Airport",
      "Penggung Airport",
      "Penggung Airport"
    ],
    "city": [
      "Cirebon-Java Island",
      "Cirebon-Java Island",
      "Cirebon-Java Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TSY",
    "translations": [
      "Cibeureum Airport",
      "Cibeureum Airport",
      "Cibeureum Airport"
    ],
    "city": [
      "Tasikmalaya-Java Island",
      "Tasikmalaya-Java Island",
      "Tasikmalaya-Java Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "CJN",
    "translations": [
      "Nusawiru Airport",
      "Nusawiru Airport",
      "Nusawiru Airport"
    ],
    "city": [
      "Cijulang",
      "Cijulang",
      "Cijulang"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TBX",
    "translations": [
      "Tambelan Airport",
      "Tambelan Airport",
      "Tambelan Airport"
    ],
    "city": [
      "Tambelan",
      "Tambelan",
      "Tambelan"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BTH",
    "translations": [
      "Hang Nadim International Airport",
      "Hang Nadim International Airport",
      "Hang Nadim International Airport"
    ],
    "city": [
      "Batam",
      "Batam",
      "Batam"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PPR",
    "translations": [
      "Tuanku Tambusai Airport",
      "Tuanku Tambusai Airport",
      "Tuanku Tambusai Airport"
    ],
    "city": [
      "Pasir Pengarayan",
      "Pasir Pengarayan",
      "Pasir Pengarayan"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LMU",
    "translations": [
      "Letung Airport",
      "Letung Airport",
      "Letung Airport"
    ],
    "city": [
      "Bukit Padi",
      "Bukit Padi",
      "Bukit Padi"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MWK",
    "translations": [
      "Matak Airport",
      "Matak Airport",
      "Matak Airport"
    ],
    "city": [
      "Palmatak",
      "Palmatak",
      "Palmatak"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TNJ",
    "translations": [
      "Raja Haji Fisabilillah International Airport",
      "Raja Haji Fisabilillah International Airport",
      "Raja Haji Fisabilillah International Airport"
    ],
    "city": [
      "Tanjung Pinang-Bintan Island",
      "Tanjung Pinang-Bintan Island",
      "Tanjung Pinang-Bintan Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SIQ",
    "translations": [
      "Dabo Airport",
      "Dabo Airport",
      "Dabo Airport"
    ],
    "city": [
      "Pasirkuning-Singkep Island",
      "Pasirkuning-Singkep Island",
      "Pasirkuning-Singkep Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MPC",
    "translations": [
      "Muko Muko Airport",
      "Muko Muko Airport",
      "Muko Muko Airport"
    ],
    "city": [
      "Muko Muko",
      "Muko Muko",
      "Muko Muko"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "HLP",
    "translations": [
      "Halim Perdanakusuma International Airport",
      "Halim Perdanakusuma International Airport",
      "Halim Perdanakusuma International Airport"
    ],
    "city": [
      "Jakarta",
      "Jakarta",
      "Jakarta"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PCB",
    "translations": [
      "Pondok Cabe Air Base",
      "Pondok Cabe Air Base",
      "Pondok Cabe Air Base"
    ],
    "city": [
      "Jakarta",
      "Jakarta",
      "Jakarta"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "CGK",
    "translations": [
      "Soekarno-Hatta International Airport",
      "Soekarno-Hatta International Airport",
      "Soekarno-Hatta International Airport"
    ],
    "city": [
      "Jakarta",
      "Jakarta",
      "Jakarta"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TKG",
    "translations": [
      "Radin Inten II International Airport",
      "Radin Inten II International Airport",
      "Radin Inten II International Airport"
    ],
    "city": [
      "Bandar Lampung",
      "Bandar Lampung",
      "Bandar Lampung"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TFY",
    "translations": [
      "Muhammad Taufiq Kiemas Airport",
      "Muhammad Taufiq Kiemas Airport",
      "Muhammad Taufiq Kiemas Airport"
    ],
    "city": [
      "Krui",
      "Krui",
      "Krui"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LSW",
    "translations": [
      "Malikus Saleh Airport",
      "Malikus Saleh Airport",
      "Malikus Saleh Airport"
    ],
    "city": [
      "Lhok Seumawe-Sumatra Island",
      "Lhok Seumawe-Sumatra Island",
      "Lhok Seumawe-Sumatra Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "GNS",
    "translations": [
      "Binaka Airport",
      "Binaka Airport",
      "Binaka Airport"
    ],
    "city": [
      "Gunungsitoli",
      "Gunungsitoli",
      "Gunungsitoli"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "AEG",
    "translations": [
      "Aek Godang Airport",
      "Aek Godang Airport",
      "Aek Godang Airport"
    ],
    "city": [
      "Padang Sidempuan",
      "Padang Sidempuan",
      "Padang Sidempuan"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "JHN",
    "translations": [
      "Jenderal Besar Abdul Haris Nasution Airport",
      "Jenderal Besar Abdul Haris Nasution Airport",
      "Jenderal Besar Abdul Haris Nasution Airport"
    ],
    "city": [
      "Mandailing",
      "Mandailing",
      "Mandailing"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MES",
    "translations": [
      "Soewondo Air Force Base",
      "Soewondo Air Force Base",
      "Soewondo Air Force Base"
    ],
    "city": [
      "Medan",
      "Medan",
      "Medan"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KNO",
    "translations": [
      "Kualanamu International Airport",
      "Kualanamu International Airport",
      "Kualanamu International Airport"
    ],
    "city": [
      "Beringin",
      "Beringin",
      "Beringin"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "DTB",
    "translations": [
      "Silangit Airport",
      "Silangit Airport",
      "Silangit Airport"
    ],
    "city": [
      "Siborong-Borong",
      "Siborong-Borong",
      "Siborong-Borong"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SIW",
    "translations": [
      "Sibisa Airport",
      "Sibisa Airport",
      "Sibisa Airport"
    ],
    "city": [
      "Parapat-Sumatra Island",
      "Parapat-Sumatra Island",
      "Parapat-Sumatra Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "FLZ",
    "translations": [
      "Dr. Ferdinand Lumban Tobing Airport",
      "Dr. Ferdinand Lumban Tobing Airport",
      "Dr. Ferdinand Lumban Tobing Airport"
    ],
    "city": [
      "Sibolga (Pinangsori)",
      "Sibolga (Pinangsori)",
      "Sibolga (Pinangsori)"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LSR",
    "translations": [
      "Alas Leuser Airport",
      "Alas Leuser Airport",
      "Alas Leuser Airport"
    ],
    "city": [
      "Kutacane",
      "Kutacane",
      "Kutacane"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TJQ",
    "translations": [
      "H A S Hanandjoeddin International Airport",
      "H A S Hanandjoeddin International Airport",
      "H A S Hanandjoeddin International Airport"
    ],
    "city": [
      "Tanjung Pandan",
      "Tanjung Pandan",
      "Tanjung Pandan"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "NPO",
    "translations": [
      "Nanga Pinoh Airport",
      "Nanga Pinoh Airport",
      "Nanga Pinoh Airport"
    ],
    "city": [
      "Nanga Pinoh-Borneo Island",
      "Nanga Pinoh-Borneo Island",
      "Nanga Pinoh-Borneo Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "KTG",
    "translations": [
      "Rahadi Osman Airport",
      "Rahadi Osman Airport",
      "Rahadi Osman Airport"
    ],
    "city": [
      "Ketapang",
      "Ketapang",
      "Ketapang"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "NTX",
    "translations": [
      "Ranai Airport",
      "Ranai Airport",
      "Ranai Airport"
    ],
    "city": [
      "Ranai-Natuna Besar Island",
      "Ranai-Natuna Besar Island",
      "Ranai-Natuna Besar Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PNK",
    "translations": [
      "Supadio Airport",
      "Supadio Airport",
      "Supadio Airport"
    ],
    "city": [
      "Pontianak",
      "Pontianak",
      "Pontianak"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PSU",
    "translations": [
      "Pangsuma Airport",
      "Pangsuma Airport",
      "Pangsuma Airport"
    ],
    "city": [
      "Putussibau-Borneo Island",
      "Putussibau-Borneo Island",
      "Putussibau-Borneo Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SQG",
    "translations": [
      "Tebelian Airport",
      "Tebelian Airport",
      "Tebelian Airport"
    ],
    "city": [
      "Sintang",
      "Sintang",
      "Sintang"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "DJB",
    "translations": [
      "Sultan Thaha Airport",
      "Sultan Thaha Airport",
      "Sultan Thaha Airport"
    ],
    "city": [
      "Jambi",
      "Jambi",
      "Jambi"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LLJ",
    "translations": [
      "Silampari Airport",
      "Silampari Airport",
      "Silampari Airport"
    ],
    "city": [
      "Lubuk Linggau",
      "Lubuk Linggau",
      "Lubuk Linggau"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BUU",
    "translations": [
      "Muara Bungo Airport",
      "Muara Bungo Airport",
      "Muara Bungo Airport"
    ],
    "city": [
      "Muara Bungo",
      "Muara Bungo",
      "Muara Bungo"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PGK",
    "translations": [
      "Depati Amir Airport",
      "Depati Amir Airport",
      "Depati Amir Airport"
    ],
    "city": [
      "Pangkal Pinang",
      "Pangkal Pinang",
      "Pangkal Pinang"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BKS",
    "translations": [
      "Fatmawati Soekarno Airport",
      "Fatmawati Soekarno Airport",
      "Fatmawati Soekarno Airport"
    ],
    "city": [
      "Bengkulu",
      "Bengkulu",
      "Bengkulu"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PLM",
    "translations": [
      "Sultan Mahmud Badaruddin II Airport",
      "Sultan Mahmud Badaruddin II Airport",
      "Sultan Mahmud Badaruddin II Airport"
    ],
    "city": [
      "Palembang",
      "Palembang",
      "Palembang"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PDO",
    "translations": [
      "Pendopo Airport",
      "Pendopo Airport",
      "Pendopo Airport"
    ],
    "city": [
      "Talang Gudang-Sumatra Island",
      "Talang Gudang-Sumatra Island",
      "Talang Gudang-Sumatra Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PDG",
    "translations": [
      "Minangkabau International Airport",
      "Minangkabau International Airport",
      "Minangkabau International Airport"
    ],
    "city": [
      "Padang (Katapiang)",
      "Padang (Katapiang)",
      "Padang (Katapiang)"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "PXA",
    "translations": [
      "Atung Bungsu Airport",
      "Atung Bungsu Airport",
      "Atung Bungsu Airport"
    ],
    "city": [
      "Bentayan",
      "Bentayan",
      "Bentayan"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TPK",
    "translations": [
      "Teuku Cut Ali Airport",
      "Teuku Cut Ali Airport",
      "Teuku Cut Ali Airport"
    ],
    "city": [
      "Tapaktuan",
      "Tapaktuan",
      "Tapaktuan"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "MEQ",
    "translations": [
      "Cut Nyak Dhien Airport",
      "Cut Nyak Dhien Airport",
      "Cut Nyak Dhien Airport"
    ],
    "city": [
      "Kuala Pesisir",
      "Kuala Pesisir",
      "Kuala Pesisir"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LKI",
    "translations": [
      "Lasikin Airport",
      "Lasikin Airport",
      "Lasikin Airport"
    ],
    "city": [
      "Lubang",
      "Lubang",
      "Lubang"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TXE",
    "translations": [
      "Rembele Airport",
      "Rembele Airport",
      "Rembele Airport"
    ],
    "city": [
      "Takengon",
      "Takengon",
      "Takengon"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LSX",
    "translations": [
      "Lhok Sukon Airport",
      "Lhok Sukon Airport",
      "Lhok Sukon Airport"
    ],
    "city": [
      "Lhok Sukon-Sumatra Island",
      "Lhok Sukon-Sumatra Island",
      "Lhok Sukon-Sumatra Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SBG",
    "translations": [
      "Maimun Saleh Airport",
      "Maimun Saleh Airport",
      "Maimun Saleh Airport"
    ],
    "city": [
      "Sabang",
      "Sabang",
      "Sabang"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BTJ",
    "translations": [
      "Sultan Iskandar Muda International Airport",
      "Sultan Iskandar Muda International Airport",
      "Sultan Iskandar Muda International Airport"
    ],
    "city": [
      "Banda Aceh",
      "Banda Aceh",
      "Banda Aceh"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "SXT",
    "translations": [
      "Sungai Tiang Airport",
      "Sungai Tiang Airport",
      "Sungai Tiang Airport"
    ],
    "city": [
      "Taman Negara",
      "Taman Negara",
      "Taman Negara"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "MEP",
    "translations": [
      "Mersing Airport",
      "Mersing Airport",
      "Mersing Airport"
    ],
    "city": [
      "Mersing",
      "Mersing",
      "Mersing"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "SWY",
    "translations": [
      "Sitiawan Airport",
      "Sitiawan Airport",
      "Sitiawan Airport"
    ],
    "city": [
      "Sitiawan",
      "Sitiawan",
      "Sitiawan"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "TPG",
    "translations": [
      "Taiping (Tekah) Airport",
      "Taiping (Tekah) Airport",
      "Taiping (Tekah) Airport"
    ],
    "city": [
      "Taiping",
      "Taiping",
      "Taiping"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "TOD",
    "translations": [
      "Tioman Airport",
      "Tioman Airport",
      "Tioman Airport"
    ],
    "city": [
      "Tioman Island",
      "Tioman Island",
      "Tioman Island"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "AOR",
    "translations": [
      "Sultan Abdul Halim Airport",
      "Sultan Abdul Halim Airport",
      "Sultan Abdul Halim Airport"
    ],
    "city": [
      "Alor Satar",
      "Alor Satar",
      "Alor Satar"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "BWH",
    "translations": [
      "RMAF Butterworth Air Base",
      "RMAF Butterworth Air Base",
      "RMAF Butterworth Air Base"
    ],
    "city": [
      "Butterworth",
      "Butterworth",
      "Butterworth"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "KBR",
    "translations": [
      "Sultan Ismail Petra Airport",
      "Sultan Ismail Petra Airport",
      "Sultan Ismail Petra Airport"
    ],
    "city": [
      "Kota Baharu",
      "Kota Baharu",
      "Kota Baharu"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "KUA",
    "translations": [
      "Kuantan Airport",
      "Kuantan Airport",
      "Kuantan Airport"
    ],
    "city": [
      "Kuantan",
      "Kuantan",
      "Kuantan"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "KTE",
    "translations": [
      "Kerteh Airport",
      "Kerteh Airport",
      "Kerteh Airport"
    ],
    "city": [
      "Kerteh",
      "Kerteh",
      "Kerteh"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "IPH",
    "translations": [
      "Sultan Azlan Shah Airport",
      "Sultan Azlan Shah Airport",
      "Sultan Azlan Shah Airport"
    ],
    "city": [
      "Ipoh",
      "Ipoh",
      "Ipoh"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "JHB",
    "translations": [
      "Senai International Airport",
      "Senai International Airport",
      "Senai International Airport"
    ],
    "city": [
      "Johor Bahru",
      "Johor Bahru",
      "Johor Bahru"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "KUL",
    "translations": [
      "Kuala Lumpur International Airport",
      "Kuala Lumpur International Airport",
      "Kuala Lumpur International Airport"
    ],
    "city": [
      "Sepang",
      "Sepang",
      "Sepang"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "LGK",
    "translations": [
      "Langkawi International Airport",
      "Langkawi International Airport",
      "Langkawi International Airport"
    ],
    "city": [
      "Langkawi",
      "Langkawi",
      "Langkawi"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "MKZ",
    "translations": [
      "Malacca International Airport",
      "Malacca International Airport",
      "Malacca International Airport"
    ],
    "city": [
      "Malacca",
      "Malacca",
      "Malacca"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "TGG",
    "translations": [
      "Sultan Mahmud Airport",
      "Sultan Mahmud Airport",
      "Sultan Mahmud Airport"
    ],
    "city": [
      "Kuala Terengganu",
      "Kuala Terengganu",
      "Kuala Terengganu"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "PEN",
    "translations": [
      "Penang International Airport",
      "Penang International Airport",
      "Penang International Airport"
    ],
    "city": [
      "Penang",
      "Penang",
      "Penang"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "PKG",
    "translations": [
      "Pulau Pangkor Airport",
      "Pulau Pangkor Airport",
      "Pulau Pangkor Airport"
    ],
    "city": [
      "Pangkor Island",
      "Pangkor Island",
      "Pangkor Island"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "RDN",
    "translations": [
      "LTS Pulau Redang Airport",
      "LTS Pulau Redang Airport",
      "LTS Pulau Redang Airport"
    ],
    "city": [
      "Redang",
      "Redang",
      "Redang"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "SZB",
    "translations": [
      "Sultan Abdul Aziz Shah International Airport",
      "Sultan Abdul Aziz Shah International Airport",
      "Sultan Abdul Aziz Shah International Airport"
    ],
    "city": [
      "Subang",
      "Subang",
      "Subang"
    ],
    "country": [
      "MY",
      "MY",
      "MY"
    ]
  },
  {
    "iata": "DTR",
    "translations": [
      "Decatur Shores Airport",
      "Decatur Shores Airport",
      "Decatur Shores Airport"
    ],
    "city": [
      "Decatur",
      "Decatur",
      "Decatur"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "SXK",
    "translations": [
      "Mathilda Batlayeri Airport",
      "Mathilda Batlayeri Airport",
      "Mathilda Batlayeri Airport"
    ],
    "city": [
      "Saumlaki-Yamdena Island",
      "Saumlaki-Yamdena Island",
      "Saumlaki-Yamdena Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "AUT",
    "translations": [
      "Atauro Airport",
      "Atauro Airport",
      "Atauro Airport"
    ],
    "city": [
      "Vila",
      "Vila",
      "Vila"
    ],
    "country": [
      "TL",
      "TL",
      "TL"
    ]
  },
  {
    "iata": "UAI",
    "translations": [
      "Suai Airport",
      "Suai Airport",
      "Suai Airport"
    ],
    "city": [
      "Suai",
      "Suai",
      "Suai"
    ],
    "country": [
      "TL",
      "TL",
      "TL"
    ]
  },
  {
    "iata": "DIL",
    "translations": [
      "Presidente Nicolau Lobato International Airport",
      "Presidente Nicolau Lobato International Airport",
      "Presidente Nicolau Lobato International Airport"
    ],
    "city": [
      "Dili",
      "Dili",
      "Dili"
    ],
    "country": [
      "TL",
      "TL",
      "TL"
    ]
  },
  {
    "iata": "BCH",
    "translations": [
      "Cakung Airport",
      "Cakung Airport",
      "Cakung Airport"
    ],
    "city": [
      "Baucau",
      "Baucau",
      "Baucau"
    ],
    "country": [
      "TL",
      "TL",
      "TL"
    ]
  },
  {
    "iata": "MPT",
    "translations": [
      "Maliana Airport",
      "Maliana Airport",
      "Maliana Airport"
    ],
    "city": [
      "Maliana",
      "Maliana",
      "Maliana"
    ],
    "country": [
      "TL",
      "TL",
      "TL"
    ]
  },
  {
    "iata": "OEC",
    "translations": [
      "Rota Do Sândalo Oecusse Airport",
      "Rota Do Sândalo Oecusse Airport",
      "Rota Do Sândalo Oecusse Airport"
    ],
    "city": [
      "Oecussi-Ambeno",
      "Oecussi-Ambeno",
      "Oecussi-Ambeno"
    ],
    "country": [
      "TL",
      "TL",
      "TL"
    ]
  },
  {
    "iata": "VIQ",
    "translations": [
      "Viqueque Airport",
      "Viqueque Airport",
      "Viqueque Airport"
    ],
    "city": [
      "Viqueque",
      "Viqueque",
      "Viqueque"
    ],
    "country": [
      "TL",
      "TL",
      "TL"
    ]
  },
  {
    "iata": "SGQ",
    "translations": [
      "Sanggata/Sangkimah Airport",
      "Sanggata/Sangkimah Airport",
      "Sanggata/Sangkimah Airport"
    ],
    "city": [
      "Sanggata/Sangkimah",
      "Sanggata/Sangkimah",
      "Sanggata/Sangkimah"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LBW",
    "translations": [
      "Yuvai Semaring Airport",
      "Yuvai Semaring Airport",
      "Yuvai Semaring Airport"
    ],
    "city": [
      "Long Bawan",
      "Long Bawan",
      "Long Bawan"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "BXT",
    "translations": [
      "LNG Badak Airport",
      "LNG Badak Airport",
      "LNG Badak Airport"
    ],
    "city": [
      "Bontang-Borneo Island",
      "Bontang-Borneo Island",
      "Bontang-Borneo Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "NNX",
    "translations": [
      "Nunukan Airport",
      "Nunukan Airport",
      "Nunukan Airport"
    ],
    "city": [
      "Nunukan-Nunukan Island",
      "Nunukan-Nunukan Island",
      "Nunukan-Nunukan Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "TNB",
    "translations": [
      "Tanah Grogot Airport",
      "Tanah Grogot Airport",
      "Tanah Grogot Airport"
    ],
    "city": [
      "Tanah Grogot",
      "Tanah Grogot",
      "Tanah Grogot"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "LPU",
    "translations": [
      "Long Apung Airport",
      "Long Apung Airport",
      "Long Apung Airport"
    ],
    "city": [
      "Long Apung-Borneo Island",
      "Long Apung-Borneo Island",
      "Long Apung-Borneo Island"
    ],
    "country": [
      "ID",
      "ID",
      "ID"
    ]
  },
  {
    "iata": "QPG",
    "translations": [
      "Paya Lebar Air Base",
      "Paya Lebar Air Base",
      "Paya Lebar Air Base"
    ],
    "city": [
      "Paya Lebar",
      "Paya Lebar",
      "Paya Lebar"
    ],
    "country": [
      "SG",
      "SG",
      "SG"
    ]
  },
  {
    "iata": "TGA",
    "translations": [
      "Tengah Air Base",
      "Tengah Air Base",
      "Tengah Air Base"
    ],
    "city": [
      "Western Water Catchment",
      "Western Water Catchment",
      "Western Water Catchment"
    ],
    "country": [
      "SG",
      "SG",
      "SG"
    ]
  },
  {
    "iata": "WSB",
    "translations": [
      "Steamboat Bay Seaplane Base",
      "Steamboat Bay Seaplane Base",
      "Steamboat Bay Seaplane Base"
    ],
    "city": [
      "Steamboat Bay",
      "Steamboat Bay",
      "Steamboat Bay"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "UGI",
    "translations": [
      "San Juan /Uganik/ Seaplane Base",
      "San Juan /Uganik/ Seaplane Base",
      "San Juan /Uganik/ Seaplane Base"
    ],
    "city": [
      "San Juan",
      "San Juan",
      "San Juan"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WSM",
    "translations": [
      "Wiseman Airport",
      "Wiseman Airport",
      "Wiseman Airport"
    ],
    "city": [
      "Wiseman",
      "Wiseman",
      "Wiseman"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "XSP",
    "translations": [
      "Seletar Airport",
      "Seletar Airport",
      "Seletar Airport"
    ],
    "city": [
      "Seletar",
      "Seletar",
      "Seletar"
    ],
    "country": [
      "SG",
      "SG",
      "SG"
    ]
  },
  {
    "iata": "SIN",
    "translations": [
      "Singapore Changi Airport",
      "Singapore Changi Airport",
      "Singapore Changi Airport"
    ],
    "city": [
      "Singapore",
      "Singapore",
      "Singapore"
    ],
    "country": [
      "SG",
      "SG",
      "SG"
    ]
  },
  {
    "iata": "GWV",
    "translations": [
      "Glendale Fokker Field",
      "Glendale Fokker Field",
      "Glendale Fokker Field"
    ],
    "city": [
      "Glendale",
      "Glendale",
      "Glendale"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "WZQ",
    "translations": [
      "Urad Middle Banner Airport",
      "Urad Middle Banner Airport",
      "Urad Middle Banner Airport"
    ],
    "city": [
      "Urad Middle Banner",
      "Urad Middle Banner",
      "Urad Middle Banner"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "MPB",
    "translations": [
      "Miami Seaplane Base",
      "Miami Seaplane Base",
      "Miami Seaplane Base"
    ],
    "city": [
      "Miami",
      "Miami",
      "Miami"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "XBB",
    "translations": [
      "Blubber Bay Seaplane Base",
      "Blubber Bay Seaplane Base",
      "Blubber Bay Seaplane Base"
    ],
    "city": [
      "Blubber Bay",
      "Blubber Bay",
      "Blubber Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XIG",
    "translations": [
      "Xinguara Municipal Airport",
      "Xinguara Municipal Airport",
      "Xinguara Municipal Airport"
    ],
    "city": [
      "Xinguara",
      "Xinguara",
      "Xinguara"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "XMA",
    "translations": [
      "Maramag Airport",
      "Maramag Airport",
      "Maramag Airport"
    ],
    "city": [
      "Maramag",
      "Maramag",
      "Maramag"
    ],
    "country": [
      "PH",
      "PH",
      "PH"
    ]
  },
  {
    "iata": "XRQ",
    "translations": [
      "New Barag Right Banner Baogede Airport",
      "New Barag Right Banner Baogede Airport",
      "New Barag Right Banner Baogede Airport"
    ],
    "city": [
      "New Barag Right Banner",
      "New Barag Right Banner",
      "New Barag Right Banner"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "XZM",
    "translations": [
      "Macau Heliport at Outer Harbour Ferry Terminal",
      "Macau Heliport at Outer Harbour Ferry Terminal",
      "Macau Heliport at Outer Harbour Ferry Terminal"
    ],
    "city": [
      "Sé",
      "Sé",
      "Sé"
    ],
    "country": [
      "MO",
      "MO",
      "MO"
    ]
  },
  {
    "iata": "UKN",
    "translations": [
      "Waukon Municipal Airport",
      "Waukon Municipal Airport",
      "Waukon Municipal Airport"
    ],
    "city": [
      "Waukon",
      "Waukon",
      "Waukon"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ALH",
    "translations": [
      "Albany Airport",
      "Albany Airport",
      "Albany Airport"
    ],
    "city": [
      "Albany",
      "Albany",
      "Albany"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ABG",
    "translations": [
      "Abingdon Downs Airport",
      "Abingdon Downs Airport",
      "Abingdon Downs Airport"
    ],
    "city": [
      "Abingdon Downs",
      "Abingdon Downs",
      "Abingdon Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AWN",
    "translations": [
      "Alton Downs Airport",
      "Alton Downs Airport",
      "Alton Downs Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AUD",
    "translations": [
      "Augustus Downs Airport",
      "Augustus Downs Airport",
      "Augustus Downs Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YAJ",
    "translations": [
      "Lyall Harbour Seaplane Base",
      "Lyall Harbour Seaplane Base",
      "Lyall Harbour Seaplane Base"
    ],
    "city": [
      "Saturna Island",
      "Saturna Island",
      "Saturna Island"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "MRP",
    "translations": [
      "Marla Airport",
      "Marla Airport",
      "Marla Airport"
    ],
    "city": [
      "Marla",
      "Marla",
      "Marla"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AXL",
    "translations": [
      "Alexandria Homestead Airport",
      "Alexandria Homestead Airport",
      "Alexandria Homestead Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AXC",
    "translations": [
      "Aramac Airport",
      "Aramac Airport",
      "Aramac Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ADO",
    "translations": [
      "Andamooka Airport",
      "Andamooka Airport",
      "Andamooka Airport"
    ],
    "city": [
      "Andamooka",
      "Andamooka",
      "Andamooka"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AMX",
    "translations": [
      "Ammaroo Airport",
      "Ammaroo Airport",
      "Ammaroo Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AMT",
    "translations": [
      "Amata Airport",
      "Amata Airport",
      "Amata Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WLP",
    "translations": [
      "West Angelas Airport",
      "West Angelas Airport",
      "West Angelas Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AYL",
    "translations": [
      "Anthony Lagoon Airport",
      "Anthony Lagoon Airport",
      "Anthony Lagoon Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ABH",
    "translations": [
      "Alpha Airport",
      "Alpha Airport",
      "Alpha Airport"
    ],
    "city": [
      "Alpha",
      "Alpha",
      "Alpha"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YAQ",
    "translations": [
      "Maple Bay Seaplane Base",
      "Maple Bay Seaplane Base",
      "Maple Bay Seaplane Base"
    ],
    "city": [
      "Maple Bay",
      "Maple Bay",
      "Maple Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ARY",
    "translations": [
      "Ararat Airport",
      "Ararat Airport",
      "Ararat Airport"
    ],
    "city": [
      "Ararat",
      "Ararat",
      "Ararat"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GYL",
    "translations": [
      "Argyle Airport",
      "Argyle Airport",
      "Argyle Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ARM",
    "translations": [
      "Armidale Airport",
      "Armidale Airport",
      "Armidale Airport"
    ],
    "city": [
      "Armidale",
      "Armidale",
      "Armidale"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AAB",
    "translations": [
      "Arrabury Airport",
      "Arrabury Airport",
      "Arrabury Airport"
    ],
    "city": [
      "Tanbar",
      "Tanbar",
      "Tanbar"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AUU",
    "translations": [
      "Aurukun Airport",
      "Aurukun Airport",
      "Aurukun Airport"
    ],
    "city": [
      "Aurukun",
      "Aurukun",
      "Aurukun"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AWP",
    "translations": [
      "Austral Downs Airport",
      "Austral Downs Airport",
      "Austral Downs Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AVG",
    "translations": [
      "Auvergne Airport",
      "Auvergne Airport",
      "Auvergne Airport"
    ],
    "city": [
      "Auvergne Station",
      "Auvergne Station",
      "Auvergne Station"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AYQ",
    "translations": [
      "Ayers Rock Connellan Airport",
      "Ayers Rock Connellan Airport",
      "Ayers Rock Connellan Airport"
    ],
    "city": [
      "Yulara",
      "Yulara",
      "Yulara"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AYR",
    "translations": [
      "Ayr Airport",
      "Ayr Airport",
      "Ayr Airport"
    ],
    "city": [
      "Ayr",
      "Ayr",
      "Ayr"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MBN",
    "translations": [
      "Mount Barnett Airport",
      "Mount Barnett Airport",
      "Mount Barnett Airport"
    ],
    "city": [
      "Wunaamin Miliwundi Ranges",
      "Wunaamin Miliwundi Ranges",
      "Wunaamin Miliwundi Ranges"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BCI",
    "translations": [
      "Barcaldine Airport",
      "Barcaldine Airport",
      "Barcaldine Airport"
    ],
    "city": [
      "Barcaldine",
      "Barcaldine",
      "Barcaldine"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ASP",
    "translations": [
      "Alice Springs Airport",
      "Alice Springs Airport",
      "Alice Springs Airport"
    ],
    "city": [
      "Alice Springs",
      "Alice Springs",
      "Alice Springs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BDD",
    "translations": [
      "Badu Island Airport",
      "Badu Island Airport",
      "Badu Island Airport"
    ],
    "city": [
      "Badu Island",
      "Badu Island",
      "Badu Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BKP",
    "translations": [
      "Barkly Downs Airport",
      "Barkly Downs Airport",
      "Barkly Downs Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BNE",
    "translations": [
      "Brisbane International Airport",
      "Brisbane International Airport",
      "Brisbane International Airport"
    ],
    "city": [
      "Brisbane",
      "Brisbane",
      "Brisbane"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OOL",
    "translations": [
      "Gold Coast Airport",
      "Gold Coast Airport",
      "Gold Coast Airport"
    ],
    "city": [
      "Gold Coast",
      "Gold Coast",
      "Gold Coast"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BKQ",
    "translations": [
      "Blackall Airport",
      "Blackall Airport",
      "Blackall Airport"
    ],
    "city": [
      "Blackall",
      "Blackall",
      "Blackall"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CNS",
    "translations": [
      "Cairns International Airport",
      "Cairns International Airport",
      "Cairns International Airport"
    ],
    "city": [
      "Cairns",
      "Cairns",
      "Cairns"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CTL",
    "translations": [
      "Charleville Airport",
      "Charleville Airport",
      "Charleville Airport"
    ],
    "city": [
      "Charleville",
      "Charleville",
      "Charleville"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BDW",
    "translations": [
      "Bedford Downs Airport",
      "Bedford Downs Airport",
      "Bedford Downs Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BXG",
    "translations": [
      "Bendigo Airport",
      "Bendigo Airport",
      "Bendigo Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BVI",
    "translations": [
      "Birdsville Airport",
      "Birdsville Airport",
      "Birdsville Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BXF",
    "translations": [
      "Bellburn Airstrip",
      "Bellburn Airstrip",
      "Bellburn Airstrip"
    ],
    "city": [
      "Pumululu National Park",
      "Pumululu National Park",
      "Pumululu National Park"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BTX",
    "translations": [
      "Betoota Airport",
      "Betoota Airport",
      "Betoota Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BEE",
    "translations": [
      "Beagle Bay Airport",
      "Beagle Bay Airport",
      "Beagle Bay Airport"
    ],
    "city": [
      "Dampier Peninsula",
      "Dampier Peninsula",
      "Dampier Peninsula"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OCM",
    "translations": [
      "Boolgeeda",
      "Boolgeeda",
      "Boolgeeda"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BQW",
    "translations": [
      "Balgo Hill Airport",
      "Balgo Hill Airport",
      "Balgo Hill Airport"
    ],
    "city": [
      "Balgo",
      "Balgo",
      "Balgo"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YBH",
    "translations": [
      "Bull Harbour Water Aerodrome",
      "Bull Harbour Water Aerodrome",
      "Bull Harbour Water Aerodrome"
    ],
    "city": [
      "Bull Harbour",
      "Bull Harbour",
      "Bull Harbour"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "BHQ",
    "translations": [
      "Broken Hill Airport",
      "Broken Hill Airport",
      "Broken Hill Airport"
    ],
    "city": [
      "Broken Hill",
      "Broken Hill",
      "Broken Hill"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HTI",
    "translations": [
      "Hamilton Island Airport",
      "Hamilton Island Airport",
      "Hamilton Island Airport"
    ],
    "city": [
      "Hamilton Island",
      "Hamilton Island",
      "Hamilton Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BEU",
    "translations": [
      "Bedourie Airport",
      "Bedourie Airport",
      "Bedourie Airport"
    ],
    "city": [
      "Bedourie",
      "Bedourie",
      "Bedourie"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BIW",
    "translations": [
      "Billiluna Airport",
      "Billiluna Airport",
      "Billiluna Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BZP",
    "translations": [
      "Bizant Airport",
      "Bizant Airport",
      "Bizant Airport"
    ],
    "city": [
      "Lakefield National Park",
      "Lakefield National Park",
      "Lakefield National Park"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YBJ",
    "translations": [
      "Baie-Johan-Beetz Water Aerodrome",
      "Baie-Johan-Beetz Water Aerodrome",
      "Baie-Johan-Beetz Water Aerodrome"
    ],
    "city": [
      "Baie-Johan-Beetz",
      "Baie-Johan-Beetz",
      "Baie-Johan-Beetz"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "BRK",
    "translations": [
      "Bourke Airport",
      "Bourke Airport",
      "Bourke Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BUC",
    "translations": [
      "Burketown Airport",
      "Burketown Airport",
      "Burketown Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BLN",
    "translations": [
      "Benalla Airport",
      "Benalla Airport",
      "Benalla Airport"
    ],
    "city": [
      "Benalla",
      "Benalla",
      "Benalla"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LCN",
    "translations": [
      "Balcanoona Airport",
      "Balcanoona Airport",
      "Balcanoona Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ZBL",
    "translations": [
      "Biloela Airport",
      "Biloela Airport",
      "Biloela Airport"
    ],
    "city": [
      "Biloela",
      "Biloela",
      "Biloela"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BLS",
    "translations": [
      "Bollon Airport",
      "Bollon Airport",
      "Bollon Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BQB",
    "translations": [
      "Busselton Margaret River Regional Airport",
      "Busselton Margaret River Regional Airport",
      "Busselton Margaret River Regional Airport"
    ],
    "city": [
      "Busselton",
      "Busselton",
      "Busselton"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ISA",
    "translations": [
      "Mount Isa Airport",
      "Mount Isa Airport",
      "Mount Isa Airport"
    ],
    "city": [
      "Mount Isa",
      "Mount Isa",
      "Mount Isa"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BFC",
    "translations": [
      "Bloomfield River Airport",
      "Bloomfield River Airport",
      "Bloomfield River Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MKY",
    "translations": [
      "Mackay Airport",
      "Mackay Airport",
      "Mackay Airport"
    ],
    "city": [
      "Mackay",
      "Mackay",
      "Mackay"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BNK",
    "translations": [
      "Ballina Byron Gateway Airport",
      "Ballina Byron Gateway Airport",
      "Ballina Byron Gateway Airport"
    ],
    "city": [
      "Ballina",
      "Ballina",
      "Ballina"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BSJ",
    "translations": [
      "Bairnsdale Airport",
      "Bairnsdale Airport",
      "Bairnsdale Airport"
    ],
    "city": [
      "Bairnsdale",
      "Bairnsdale",
      "Bairnsdale"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GIC",
    "translations": [
      "Boigu Island Airport",
      "Boigu Island Airport",
      "Boigu Island Airport"
    ],
    "city": [
      "Boigu Island",
      "Boigu Island",
      "Boigu Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OKY",
    "translations": [
      "Oakey Army Aviation Centre",
      "Oakey Army Aviation Centre",
      "Oakey Army Aviation Centre"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BQL",
    "translations": [
      "Boulia Airport",
      "Boulia Airport",
      "Boulia Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BMP",
    "translations": [
      "Brampton Island Airport",
      "Brampton Island Airport",
      "Brampton Island Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KAH",
    "translations": [
      "Melbourne Heliport, Batman Park",
      "Melbourne Heliport, Batman Park",
      "Melbourne Heliport, Batman Park"
    ],
    "city": [
      "Melbourne",
      "Melbourne",
      "Melbourne"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PPP",
    "translations": [
      "Proserpine Whitsunday Coast Airport",
      "Proserpine Whitsunday Coast Airport",
      "Proserpine Whitsunday Coast Airport"
    ],
    "city": [
      "Proserpine",
      "Proserpine",
      "Proserpine"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YBQ",
    "translations": [
      "Telegraph Harbour Seaplane Base",
      "Telegraph Harbour Seaplane Base",
      "Telegraph Harbour Seaplane Base"
    ],
    "city": [
      "Thetis Island",
      "Thetis Island",
      "Thetis Island"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ROK",
    "translations": [
      "Rockhampton Airport",
      "Rockhampton Airport",
      "Rockhampton Airport"
    ],
    "city": [
      "Rockhampton",
      "Rockhampton",
      "Rockhampton"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BOX",
    "translations": [
      "Borroloola Airport",
      "Borroloola Airport",
      "Borroloola Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BME",
    "translations": [
      "Broome International Airport",
      "Broome International Airport",
      "Broome International Airport"
    ],
    "city": [
      "Broome",
      "Broome",
      "Broome"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BZD",
    "translations": [
      "Balranald Airport",
      "Balranald Airport",
      "Balranald Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BTD",
    "translations": [
      "Brunette Downs Airport",
      "Brunette Downs Airport",
      "Brunette Downs Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BWQ",
    "translations": [
      "Brewarrina Airport",
      "Brewarrina Airport",
      "Brewarrina Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BYP",
    "translations": [
      "Barimunya Airport",
      "Barimunya Airport",
      "Barimunya Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MCY",
    "translations": [
      "Sunshine Coast Airport",
      "Sunshine Coast Airport",
      "Sunshine Coast Airport"
    ],
    "city": [
      "Maroochydore",
      "Maroochydore",
      "Maroochydore"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BHS",
    "translations": [
      "Bathurst Airport",
      "Bathurst Airport",
      "Bathurst Airport"
    ],
    "city": [
      "Bathurst",
      "Bathurst",
      "Bathurst"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BRT",
    "translations": [
      "Bathurst Island Airport",
      "Bathurst Island Airport",
      "Bathurst Island Airport"
    ],
    "city": [
      "Wurrumiyanga",
      "Wurrumiyanga",
      "Wurrumiyanga"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TSV",
    "translations": [
      "Townsville Airport / RAAF Base Townsville",
      "Townsville Airport / RAAF Base Townsville",
      "Townsville Airport / RAAF Base Townsville"
    ],
    "city": [
      "Townsville",
      "Townsville",
      "Townsville"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BLT",
    "translations": [
      "Blackwater Airport",
      "Blackwater Airport",
      "Blackwater Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BVW",
    "translations": [
      "Batavia Downs Airport",
      "Batavia Downs Airport",
      "Batavia Downs Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BDB",
    "translations": [
      "Bundaberg Airport",
      "Bundaberg Airport",
      "Bundaberg Airport"
    ],
    "city": [
      "Bundaberg",
      "Bundaberg",
      "Bundaberg"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BUY",
    "translations": [
      "Bunbury Airport",
      "Bunbury Airport",
      "Bunbury Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BIP",
    "translations": [
      "Bulimba Airport",
      "Bulimba Airport",
      "Bulimba Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ZBO",
    "translations": [
      "Bowen Airport",
      "Bowen Airport",
      "Bowen Airport"
    ],
    "city": [
      "Bowen",
      "Bowen",
      "Bowen"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WEI",
    "translations": [
      "Weipa Airport",
      "Weipa Airport",
      "Weipa Airport"
    ],
    "city": [
      "Weipa",
      "Weipa",
      "Weipa"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BCK",
    "translations": [
      "Bolwarra Airport",
      "Bolwarra Airport",
      "Bolwarra Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WTB",
    "translations": [
      "Toowoomba Wellcamp Airport",
      "Toowoomba Wellcamp Airport",
      "Toowoomba Wellcamp Airport"
    ],
    "city": [
      "Toowoomba",
      "Toowoomba",
      "Toowoomba"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BWB",
    "translations": [
      "Barrow Island Airport",
      "Barrow Island Airport",
      "Barrow Island Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BVZ",
    "translations": [
      "Beverley Springs Airport",
      "Beverley Springs Airport",
      "Beverley Springs Airport"
    ],
    "city": [
      "Wunaamin Miliwundi Ranges",
      "Wunaamin Miliwundi Ranges",
      "Wunaamin Miliwundi Ranges"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CTR",
    "translations": [
      "Cattle Creek Airport",
      "Cattle Creek Airport",
      "Cattle Creek Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CGV",
    "translations": [
      "Caiguna Airport",
      "Caiguna Airport",
      "Caiguna Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CLH",
    "translations": [
      "Coolah Airport",
      "Coolah Airport",
      "Coolah Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CVQ",
    "translations": [
      "Carnarvon Airport",
      "Carnarvon Airport",
      "Carnarvon Airport"
    ],
    "city": [
      "Carnarvon",
      "Carnarvon",
      "Carnarvon"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CSI",
    "translations": [
      "Casino Airport",
      "Casino Airport",
      "Casino Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CAZ",
    "translations": [
      "Cobar Airport",
      "Cobar Airport",
      "Cobar Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "COJ",
    "translations": [
      "Coonabarabran Airport",
      "Coonabarabran Airport",
      "Coonabarabran Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CBY",
    "translations": [
      "Canobie Airport",
      "Canobie Airport",
      "Canobie Airport"
    ],
    "city": [
      "Canobie",
      "Canobie",
      "Canobie"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CBI",
    "translations": [
      "Cape Barren Island Airport",
      "Cape Barren Island Airport",
      "Cape Barren Island Airport"
    ],
    "city": [
      "Cape Barren Island",
      "Cape Barren Island",
      "Cape Barren Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CPD",
    "translations": [
      "Coober Pedy Airport",
      "Coober Pedy Airport",
      "Coober Pedy Airport"
    ],
    "city": [
      "Coober Pedy",
      "Coober Pedy",
      "Coober Pedy"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CRB",
    "translations": [
      "Collarenebri Airport",
      "Collarenebri Airport",
      "Collarenebri Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CCL",
    "translations": [
      "Chinchilla Airport",
      "Chinchilla Airport",
      "Chinchilla Airport"
    ],
    "city": [
      "Chinchilla",
      "Chinchilla",
      "Chinchilla"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CNC",
    "translations": [
      "Coconut Island Airport",
      "Coconut Island Airport",
      "Coconut Island Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CNJ",
    "translations": [
      "Cloncurry Airport",
      "Cloncurry Airport",
      "Cloncurry Airport"
    ],
    "city": [
      "Cloncurry",
      "Cloncurry",
      "Cloncurry"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CBX",
    "translations": [
      "Condobolin Airport",
      "Condobolin Airport",
      "Condobolin Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CUD",
    "translations": [
      "Caloundra Airport",
      "Caloundra Airport",
      "Caloundra Airport"
    ],
    "city": [
      "Caloundra",
      "Caloundra",
      "Caloundra"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CED",
    "translations": [
      "Ceduna Airport",
      "Ceduna Airport",
      "Ceduna Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CVC",
    "translations": [
      "Cleve Airport",
      "Cleve Airport",
      "Cleve Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YCF",
    "translations": [
      "Cortes Bay Water Aerodrome",
      "Cortes Bay Water Aerodrome",
      "Cortes Bay Water Aerodrome"
    ],
    "city": [
      "Cortes Bay",
      "Cortes Bay",
      "Cortes Bay"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "CFI",
    "translations": [
      "Camfield Airport",
      "Camfield Airport",
      "Camfield Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CFH",
    "translations": [
      "Clifton Hills Airport",
      "Clifton Hills Airport",
      "Clifton Hills Airport"
    ],
    "city": [
      "Clifton Hills",
      "Clifton Hills",
      "Clifton Hills"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CQP",
    "translations": [
      "Cape Flattery Airport",
      "Cape Flattery Airport",
      "Cape Flattery Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CFS",
    "translations": [
      "Coffs Harbour Airport",
      "Coffs Harbour Airport",
      "Coffs Harbour Airport"
    ],
    "city": [
      "Coffs Harbour",
      "Coffs Harbour",
      "Coffs Harbour"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LLG",
    "translations": [
      "Chillagoe Airport",
      "Chillagoe Airport",
      "Chillagoe Airport"
    ],
    "city": [
      "Chillagoe",
      "Chillagoe",
      "Chillagoe"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CRH",
    "translations": [
      "Cherrabah Airport",
      "Cherrabah Airport",
      "Cherrabah Airport"
    ],
    "city": [
      "Cherrabah Homestead Resort",
      "Cherrabah Homestead Resort",
      "Cherrabah Homestead Resort"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CKW",
    "translations": [
      "Christmas Creek Airport",
      "Christmas Creek Airport",
      "Christmas Creek Airport"
    ],
    "city": [
      "Christmas Creek Mine",
      "Christmas Creek Mine",
      "Christmas Creek Mine"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CXT",
    "translations": [
      "Charters Towers Airport",
      "Charters Towers Airport",
      "Charters Towers Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DCN",
    "translations": [
      "RAAF Base Curtin",
      "RAAF Base Curtin",
      "RAAF Base Curtin"
    ],
    "city": [
      "Derby",
      "Derby",
      "Derby"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CKI",
    "translations": [
      "Croker Island Airport",
      "Croker Island Airport",
      "Croker Island Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CTN",
    "translations": [
      "Cooktown Airport",
      "Cooktown Airport",
      "Cooktown Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CMQ",
    "translations": [
      "Clermont Airport",
      "Clermont Airport",
      "Clermont Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CMA",
    "translations": [
      "Cunnamulla Airport",
      "Cunnamulla Airport",
      "Cunnamulla Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CML",
    "translations": [
      "Camooweal Airport",
      "Camooweal Airport",
      "Camooweal Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NIF",
    "translations": [
      "Camp Nifty Airport",
      "Camp Nifty Airport",
      "Camp Nifty Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CES",
    "translations": [
      "Cessnock Airport",
      "Cessnock Airport",
      "Cessnock Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CNB",
    "translations": [
      "Coonamble Airport",
      "Coonamble Airport",
      "Coonamble Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ODL",
    "translations": [
      "Cordillo Downs Airport",
      "Cordillo Downs Airport",
      "Cordillo Downs Airport"
    ],
    "city": [
      "Cordillo Downs",
      "Cordillo Downs",
      "Cordillo Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CUQ",
    "translations": [
      "Coen Airport",
      "Coen Airport",
      "Coen Airport"
    ],
    "city": [
      "Coen",
      "Coen",
      "Coen"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CIE",
    "translations": [
      "Collie Airport",
      "Collie Airport",
      "Collie Airport"
    ],
    "city": [
      "Collie",
      "Collie",
      "Collie"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OOM",
    "translations": [
      "Cooma Snowy Mountains Airport",
      "Cooma Snowy Mountains Airport",
      "Cooma Snowy Mountains Airport"
    ],
    "city": [
      "Cooma",
      "Cooma",
      "Cooma"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CDA",
    "translations": [
      "Cooinda Airport",
      "Cooinda Airport",
      "Cooinda Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CWW",
    "translations": [
      "Corowa Airport",
      "Corowa Airport",
      "Corowa Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CFP",
    "translations": [
      "Carpentaria Downs Airport",
      "Carpentaria Downs Airport",
      "Carpentaria Downs Airport"
    ],
    "city": [
      "Carpentaria Downs",
      "Carpentaria Downs",
      "Carpentaria Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CYG",
    "translations": [
      "Corryong Airport",
      "Corryong Airport",
      "Corryong Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CXQ",
    "translations": [
      "Christmas Creek Station Airport",
      "Christmas Creek Station Airport",
      "Christmas Creek Station Airport"
    ],
    "city": [
      "Wangkat Jungka",
      "Wangkat Jungka",
      "Wangkat Jungka"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CDQ",
    "translations": [
      "Croydon Airport",
      "Croydon Airport",
      "Croydon Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KCE",
    "translations": [
      "Collinsville Airport",
      "Collinsville Airport",
      "Collinsville Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CMD",
    "translations": [
      "Cootamundra Airport",
      "Cootamundra Airport",
      "Cootamundra Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CUG",
    "translations": [
      "Cudal Airport",
      "Cudal Airport",
      "Cudal Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CUY",
    "translations": [
      "Cue Airport",
      "Cue Airport",
      "Cue Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CJF",
    "translations": [
      "Coondewanna Airport",
      "Coondewanna Airport",
      "Coondewanna Airport"
    ],
    "city": [
      "Coondewanna",
      "Coondewanna",
      "Coondewanna"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CWR",
    "translations": [
      "Cowarie Airport",
      "Cowarie Airport",
      "Cowarie Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CCW",
    "translations": [
      "Cowell Airport",
      "Cowell Airport",
      "Cowell Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CWT",
    "translations": [
      "Cowra Airport",
      "Cowra Airport",
      "Cowra Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "COY",
    "translations": [
      "Coolawanyah Airport",
      "Coolawanyah Airport",
      "Coolawanyah Airport"
    ],
    "city": [
      "Coolawanyah Station",
      "Coolawanyah Station",
      "Coolawanyah Station"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DJR",
    "translations": [
      "Dajarra Airport",
      "Dajarra Airport",
      "Dajarra Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DBY",
    "translations": [
      "Dalby Airport",
      "Dalby Airport",
      "Dalby Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DRN",
    "translations": [
      "Dirranbandi Airport",
      "Dirranbandi Airport",
      "Dirranbandi Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DNB",
    "translations": [
      "Dunbar Airport",
      "Dunbar Airport",
      "Dunbar Airport"
    ],
    "city": [
      "Maramie",
      "Maramie",
      "Maramie"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DRB",
    "translations": [
      "Derby Airport",
      "Derby Airport",
      "Derby Airport"
    ],
    "city": [
      "Derby",
      "Derby",
      "Derby"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DFP",
    "translations": [
      "Drumduff Airport",
      "Drumduff Airport",
      "Drumduff Airport"
    ],
    "city": [
      "Palmer",
      "Palmer",
      "Palmer"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DDI",
    "translations": [
      "Daydream Island Helipad",
      "Daydream Island Helipad",
      "Daydream Island Helipad"
    ],
    "city": [
      "Whitsundays",
      "Whitsundays",
      "Whitsundays"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DGD",
    "translations": [
      "Dalgaranga Gold Mine Airport",
      "Dalgaranga Gold Mine Airport",
      "Dalgaranga Gold Mine Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DNG",
    "translations": [
      "Doongan Airport",
      "Doongan Airport",
      "Doongan Airport"
    ],
    "city": [
      "Drysdale River",
      "Drysdale River",
      "Drysdale River"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DXD",
    "translations": [
      "Dixie Airport",
      "Dixie Airport",
      "Dixie Airport"
    ],
    "city": [
      "New Dixie",
      "New Dixie",
      "New Dixie"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DKI",
    "translations": [
      "Dunk Island Airport",
      "Dunk Island Airport",
      "Dunk Island Airport"
    ],
    "city": [
      "Dunk Island",
      "Dunk Island",
      "Dunk Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DLK",
    "translations": [
      "Dulkaninna Airport",
      "Dulkaninna Airport",
      "Dulkaninna Airport"
    ],
    "city": [
      "Dulkaninna",
      "Dulkaninna",
      "Dulkaninna"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DNQ",
    "translations": [
      "Deniliquin Airport",
      "Deniliquin Airport",
      "Deniliquin Airport"
    ],
    "city": [
      "Deniliquin",
      "Deniliquin",
      "Deniliquin"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DDN",
    "translations": [
      "Delta Downs Airport",
      "Delta Downs Airport",
      "Delta Downs Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DLV",
    "translations": [
      "Delissaville Airport",
      "Delissaville Airport",
      "Delissaville Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DYW",
    "translations": [
      "Daly Waters Airport",
      "Daly Waters Airport",
      "Daly Waters Airport"
    ],
    "city": [
      "Daly Waters",
      "Daly Waters",
      "Daly Waters"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DMD",
    "translations": [
      "Doomadgee Airport",
      "Doomadgee Airport",
      "Doomadgee Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DVR",
    "translations": [
      "Daly River Airport",
      "Daly River Airport",
      "Daly River Airport"
    ],
    "city": [
      "Nauiyu",
      "Nauiyu",
      "Nauiyu"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NLF",
    "translations": [
      "Darnley Island Airport",
      "Darnley Island Airport",
      "Darnley Island Airport"
    ],
    "city": [
      "Darnley Island",
      "Darnley Island",
      "Darnley Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DRD",
    "translations": [
      "Dorunda Airport",
      "Dorunda Airport",
      "Dorunda Airport"
    ],
    "city": [
      "Dorunda Outstation",
      "Dorunda Outstation",
      "Dorunda Outstation"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DVP",
    "translations": [
      "Davenport Downs Airport",
      "Davenport Downs Airport",
      "Davenport Downs Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DPO",
    "translations": [
      "Devonport Airport",
      "Devonport Airport",
      "Devonport Airport"
    ],
    "city": [
      "Devonport",
      "Devonport",
      "Devonport"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DOX",
    "translations": [
      "Dongara Airport",
      "Dongara Airport",
      "Dongara Airport"
    ],
    "city": [
      "Port Denison",
      "Port Denison",
      "Port Denison"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DRY",
    "translations": [
      "Drysdale River Airport",
      "Drysdale River Airport",
      "Drysdale River Airport"
    ],
    "city": [
      "Drysdale River",
      "Drysdale River",
      "Drysdale River"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DHD",
    "translations": [
      "Durham Downs Airport",
      "Durham Downs Airport",
      "Durham Downs Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DRR",
    "translations": [
      "Durrie Airport",
      "Durrie Airport",
      "Durrie Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SRR",
    "translations": [
      "Dunwich Airport",
      "Dunwich Airport",
      "Dunwich Airport"
    ],
    "city": [
      "North Stradbroke Island",
      "North Stradbroke Island",
      "North Stradbroke Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DKV",
    "translations": [
      "Docker River Airport",
      "Docker River Airport",
      "Docker River Airport"
    ],
    "city": [
      "Kaltukatjara",
      "Kaltukatjara",
      "Kaltukatjara"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DYA",
    "translations": [
      "Dysart Airport",
      "Dysart Airport",
      "Dysart Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RXA",
    "translations": [
      "Ar Rawdah Airport",
      "Ar Rawdah Airport",
      "Ar Rawdah Airport"
    ],
    "city": [
      "Ar Rawdah",
      "Ar Rawdah",
      "Ar Rawdah"
    ],
    "country": [
      "YE",
      "YE",
      "YE"
    ]
  },
  {
    "iata": "ECH",
    "translations": [
      "Echuca Airport",
      "Echuca Airport",
      "Echuca Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "EUC",
    "translations": [
      "Eucla Airport",
      "Eucla Airport",
      "Eucla Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ETD",
    "translations": [
      "Etadunna Airport",
      "Etadunna Airport",
      "Etadunna Airport"
    ],
    "city": [
      "Etadunna",
      "Etadunna",
      "Etadunna"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ENB",
    "translations": [
      "Eneabba Airport",
      "Eneabba Airport",
      "Eneabba Airport"
    ],
    "city": [
      "Eneabba",
      "Eneabba",
      "Eneabba"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "EIH",
    "translations": [
      "Einasleigh Airport",
      "Einasleigh Airport",
      "Einasleigh Airport"
    ],
    "city": [
      "Einasleigh",
      "Einasleigh",
      "Einasleigh"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ELC",
    "translations": [
      "Elcho Island Airport",
      "Elcho Island Airport",
      "Elcho Island Airport"
    ],
    "city": [
      "Elcho Island",
      "Elcho Island",
      "Elcho Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "EKD",
    "translations": [
      "Elkedra Airport",
      "Elkedra Airport",
      "Elkedra Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "EMD",
    "translations": [
      "Emerald Airport",
      "Emerald Airport",
      "Emerald Airport"
    ],
    "city": [
      "Emerald",
      "Emerald",
      "Emerald"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "EDD",
    "translations": [
      "Erldunda Airport",
      "Erldunda Airport",
      "Erldunda Airport"
    ],
    "city": [
      "Ghan",
      "Ghan",
      "Ghan"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ERB",
    "translations": [
      "Ernabella Airport",
      "Ernabella Airport",
      "Ernabella Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ERQ",
    "translations": [
      "Elrose Airport",
      "Elrose Airport",
      "Elrose Airport"
    ],
    "city": [
      "Elrose Mine",
      "Elrose Mine",
      "Elrose Mine"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "EPR",
    "translations": [
      "Esperance Airport",
      "Esperance Airport",
      "Esperance Airport"
    ],
    "city": [
      "Esperance",
      "Esperance",
      "Esperance"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "EVD",
    "translations": [
      "Eva Downs Airport",
      "Eva Downs Airport",
      "Eva Downs Airport"
    ],
    "city": [
      "Eva Downs",
      "Eva Downs",
      "Eva Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "EVH",
    "translations": [
      "Evans Head Aerodrome",
      "Evans Head Aerodrome",
      "Evans Head Aerodrome"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WHB",
    "translations": [
      "Eliwana",
      "Eliwana",
      "Eliwana"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "EXM",
    "translations": [
      "Exmouth Airport",
      "Exmouth Airport",
      "Exmouth Airport"
    ],
    "city": [
      "Exmouth",
      "Exmouth",
      "Exmouth"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "FRB",
    "translations": [
      "Forbes Airport",
      "Forbes Airport",
      "Forbes Airport"
    ],
    "city": [
      "Forbes",
      "Forbes",
      "Forbes"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KFE",
    "translations": [
      "Fortescue - Dave Forrest Aerodrome",
      "Fortescue - Dave Forrest Aerodrome",
      "Fortescue - Dave Forrest Aerodrome"
    ],
    "city": [
      "Cloudbreak Village",
      "Cloudbreak Village",
      "Cloudbreak Village"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "FLY",
    "translations": [
      "Finley Airport",
      "Finley Airport",
      "Finley Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "FLS",
    "translations": [
      "Flinders Island Airport",
      "Flinders Island Airport",
      "Flinders Island Airport"
    ],
    "city": [
      "Whitemark",
      "Whitemark",
      "Whitemark"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "FVL",
    "translations": [
      "Flora Valley Airport",
      "Flora Valley Airport",
      "Flora Valley Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "FIK",
    "translations": [
      "Finke Airport",
      "Finke Airport",
      "Finke Airport"
    ],
    "city": [
      "Finke",
      "Finke",
      "Finke"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "FOS",
    "translations": [
      "Forrest Airport",
      "Forrest Airport",
      "Forrest Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "FVR",
    "translations": [
      "Oombulgurri Airport",
      "Oombulgurri Airport",
      "Oombulgurri Airport"
    ],
    "city": [
      "Oombulgurri",
      "Oombulgurri",
      "Oombulgurri"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "FOT",
    "translations": [
      "Forster (Wallis Is) Airport",
      "Forster (Wallis Is) Airport",
      "Forster (Wallis Is) Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "JFM",
    "translations": [
      "Fremantle Heliport",
      "Fremantle Heliport",
      "Fremantle Heliport"
    ],
    "city": [
      "Fremantle",
      "Fremantle",
      "Fremantle"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "FIZ",
    "translations": [
      "Fitzroy Crossing Airport",
      "Fitzroy Crossing Airport",
      "Fitzroy Crossing Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YGA",
    "translations": [
      "Yongchuan Da'an General Airport",
      "Yongchuan Da'an General Airport",
      "Yongchuan Da'an General Airport"
    ],
    "city": [
      "Chongqing",
      "Chongqing",
      "Chongqing"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "GBP",
    "translations": [
      "Gamboola Airport",
      "Gamboola Airport",
      "Gamboola Airport"
    ],
    "city": [
      "Gamboola",
      "Gamboola",
      "Gamboola"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GAH",
    "translations": [
      "Gayndah Airport",
      "Gayndah Airport",
      "Gayndah Airport"
    ],
    "city": [
      "Gayndah",
      "Gayndah",
      "Gayndah"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GBL",
    "translations": [
      "South Goulburn Is Airport",
      "South Goulburn Is Airport",
      "South Goulburn Is Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GUH",
    "translations": [
      "Gunnedah Airport",
      "Gunnedah Airport",
      "Gunnedah Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GOO",
    "translations": [
      "Goondiwindi Airport",
      "Goondiwindi Airport",
      "Goondiwindi Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GDD",
    "translations": [
      "Gordon Downs Airport",
      "Gordon Downs Airport",
      "Gordon Downs Airport"
    ],
    "city": [
      "Gordon Downs",
      "Gordon Downs",
      "Gordon Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GGD",
    "translations": [
      "Gregory Downs Airport",
      "Gregory Downs Airport",
      "Gregory Downs Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YGE",
    "translations": [
      "Gorge Harbour Seaplane Base",
      "Gorge Harbour Seaplane Base",
      "Gorge Harbour Seaplane Base"
    ],
    "city": [
      "Gorge Harbour",
      "Gorge Harbour",
      "Gorge Harbour"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "GET",
    "translations": [
      "Geraldton Airport",
      "Geraldton Airport",
      "Geraldton Airport"
    ],
    "city": [
      "Moonyoonooka",
      "Moonyoonooka",
      "Moonyoonooka"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GFN",
    "translations": [
      "Clarence Valley Regional Airport",
      "Clarence Valley Regional Airport",
      "Clarence Valley Regional Airport"
    ],
    "city": [
      "Grafton",
      "Grafton",
      "Grafton"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GBW",
    "translations": [
      "Ginbata Airport",
      "Ginbata Airport",
      "Ginbata Airport"
    ],
    "city": [
      "Ginbata",
      "Ginbata",
      "Ginbata"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GBV",
    "translations": [
      "Gibb River Airport",
      "Gibb River Airport",
      "Gibb River Airport"
    ],
    "city": [
      "Gibb",
      "Gibb",
      "Gibb"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GKL",
    "translations": [
      "Great Keppel Is Airport",
      "Great Keppel Is Airport",
      "Great Keppel Is Airport"
    ],
    "city": [
      "Great Keppel Island",
      "Great Keppel Island",
      "Great Keppel Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GLT",
    "translations": [
      "Gladstone Airport",
      "Gladstone Airport",
      "Gladstone Airport"
    ],
    "city": [
      "Gladstone",
      "Gladstone",
      "Gladstone"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GUL",
    "translations": [
      "Goulburn Airport",
      "Goulburn Airport",
      "Goulburn Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GLG",
    "translations": [
      "Glengyle Airport",
      "Glengyle Airport",
      "Glengyle Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GLI",
    "translations": [
      "Glen Innes Airport",
      "Glen Innes Airport",
      "Glen Innes Airport"
    ],
    "city": [
      "Glen Innes",
      "Glen Innes",
      "Glen Innes"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GLM",
    "translations": [
      "Glenormiston Airport",
      "Glenormiston Airport",
      "Glenormiston Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YGN",
    "translations": [
      "Greenway Sound Seaplane Base",
      "Greenway Sound Seaplane Base",
      "Greenway Sound Seaplane Base"
    ],
    "city": [
      "Broughton Island",
      "Broughton Island",
      "Broughton Island"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "GFE",
    "translations": [
      "Grenfell Airport",
      "Grenfell Airport",
      "Grenfell Airport"
    ],
    "city": [
      "Grenfell",
      "Grenfell",
      "Grenfell"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GVP",
    "translations": [
      "Greenvale Airport",
      "Greenvale Airport",
      "Greenvale Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GPD",
    "translations": [
      "Mount Gordon Airport",
      "Mount Gordon Airport",
      "Mount Gordon Airport"
    ],
    "city": [
      "Mount Gordon Mine",
      "Mount Gordon Mine",
      "Mount Gordon Mine"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GPN",
    "translations": [
      "Garden Point Airport",
      "Garden Point Airport",
      "Garden Point Airport"
    ],
    "city": [
      "Pirlangimpi",
      "Pirlangimpi",
      "Pirlangimpi"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GSC",
    "translations": [
      "Gascoyne Junction Airport",
      "Gascoyne Junction Airport",
      "Gascoyne Junction Airport"
    ],
    "city": [
      "Gascoyne Junction",
      "Gascoyne Junction",
      "Gascoyne Junction"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GTE",
    "translations": [
      "Groote Eylandt Airport",
      "Groote Eylandt Airport",
      "Groote Eylandt Airport"
    ],
    "city": [
      "Groote Eylandt",
      "Groote Eylandt",
      "Groote Eylandt"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GFF",
    "translations": [
      "Griffith Airport",
      "Griffith Airport",
      "Griffith Airport"
    ],
    "city": [
      "Griffith",
      "Griffith",
      "Griffith"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GTT",
    "translations": [
      "Georgetown Airport",
      "Georgetown Airport",
      "Georgetown Airport"
    ],
    "city": [
      "Georgetown",
      "Georgetown",
      "Georgetown"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GEE",
    "translations": [
      "George Town Airport",
      "George Town Airport",
      "George Town Airport"
    ],
    "city": [
      "George Town",
      "George Town",
      "George Town"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GYP",
    "translations": [
      "Gympie Airport",
      "Gympie Airport",
      "Gympie Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HWK",
    "translations": [
      "Wilpena Pound Airport",
      "Wilpena Pound Airport",
      "Wilpena Pound Airport"
    ],
    "city": [
      "Hawker",
      "Hawker",
      "Hawker"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HXX",
    "translations": [
      "Hay Airport",
      "Hay Airport",
      "Hay Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HVB",
    "translations": [
      "Hervey Bay Airport",
      "Hervey Bay Airport",
      "Hervey Bay Airport"
    ],
    "city": [
      "Hervey Bay",
      "Hervey Bay",
      "Hervey Bay"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HUB",
    "translations": [
      "Humbert River Airport",
      "Humbert River Airport",
      "Humbert River Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HRY",
    "translations": [
      "Henbury Airport",
      "Henbury Airport",
      "Henbury Airport"
    ],
    "city": [
      "Ghan",
      "Ghan",
      "Ghan"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HIP",
    "translations": [
      "Headingly Airport",
      "Headingly Airport",
      "Headingly Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HIG",
    "translations": [
      "Highbury Airport",
      "Highbury Airport",
      "Highbury Airport"
    ],
    "city": [
      "Highbury",
      "Highbury",
      "Highbury"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HID",
    "translations": [
      "Horn Island Airport",
      "Horn Island Airport",
      "Horn Island Airport"
    ],
    "city": [
      "Horn",
      "Horn",
      "Horn"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HLL",
    "translations": [
      "Hillside Airport",
      "Hillside Airport",
      "Hillside Airport"
    ],
    "city": [
      "Hillside",
      "Hillside",
      "Hillside"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HCQ",
    "translations": [
      "Halls Creek Airport",
      "Halls Creek Airport",
      "Halls Creek Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HMG",
    "translations": [
      "Hermannsburg Airport",
      "Hermannsburg Airport",
      "Hermannsburg Airport"
    ],
    "city": [
      "Hermannsburg (Ntaria)",
      "Hermannsburg (Ntaria)",
      "Hermannsburg (Ntaria)"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HLT",
    "translations": [
      "Hamilton Airport",
      "Hamilton Airport",
      "Hamilton Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HOK",
    "translations": [
      "Hooker Creek Airport",
      "Hooker Creek Airport",
      "Hooker Creek Airport"
    ],
    "city": [
      "Lajamanu",
      "Lajamanu",
      "Lajamanu"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MHU",
    "translations": [
      "Mount Hotham Airport",
      "Mount Hotham Airport",
      "Mount Hotham Airport"
    ],
    "city": [
      "Mount Hotham",
      "Mount Hotham",
      "Mount Hotham"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HAP",
    "translations": [
      "Happy Bay Helipad",
      "Happy Bay Helipad",
      "Happy Bay Helipad"
    ],
    "city": [
      "Long Island",
      "Long Island",
      "Long Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HTU",
    "translations": [
      "Hopetoun Airport",
      "Hopetoun Airport",
      "Hopetoun Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HPE",
    "translations": [
      "Hope Vale Airport",
      "Hope Vale Airport",
      "Hope Vale Airport"
    ],
    "city": [
      "Hope Vale",
      "Hope Vale",
      "Hope Vale"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HSM",
    "translations": [
      "Horsham Airport",
      "Horsham Airport",
      "Horsham Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HAT",
    "translations": [
      "Heathlands Airport",
      "Heathlands Airport",
      "Heathlands Airport"
    ],
    "city": [
      "Shelburne",
      "Shelburne",
      "Shelburne"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HGD",
    "translations": [
      "Hughenden Airport",
      "Hughenden Airport",
      "Hughenden Airport"
    ],
    "city": [
      "Hughenden",
      "Hughenden",
      "Hughenden"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "IBM",
    "translations": [
      "Iron Bridge Mine Airport",
      "Iron Bridge Mine Airport",
      "Iron Bridge Mine Airport"
    ],
    "city": [
      "Japal Camp",
      "Japal Camp",
      "Japal Camp"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "IDK",
    "translations": [
      "Indulkana Airport",
      "Indulkana Airport",
      "Indulkana Airport"
    ],
    "city": [
      "Indulkana",
      "Indulkana",
      "Indulkana"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "IFL",
    "translations": [
      "Innisfail Airport",
      "Innisfail Airport",
      "Innisfail Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "IFF",
    "translations": [
      "Iffley Airport",
      "Iffley Airport",
      "Iffley Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "IGH",
    "translations": [
      "Ingham Airport",
      "Ingham Airport",
      "Ingham Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "IKP",
    "translations": [
      "Inkerman Airport",
      "Inkerman Airport",
      "Inkerman Airport"
    ],
    "city": [
      "Inkerman",
      "Inkerman",
      "Inkerman"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "INJ",
    "translations": [
      "Injune Airport",
      "Injune Airport",
      "Injune Airport"
    ],
    "city": [
      "Injune",
      "Injune",
      "Injune"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "INM",
    "translations": [
      "Innamincka Airport",
      "Innamincka Airport",
      "Innamincka Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "IVW",
    "translations": [
      "Inverway Airport",
      "Inverway Airport",
      "Inverway Airport"
    ],
    "city": [
      "Inverway",
      "Inverway",
      "Inverway"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ISI",
    "translations": [
      "Isisford Airport",
      "Isisford Airport",
      "Isisford Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "IVR",
    "translations": [
      "Inverell Airport",
      "Inverell Airport",
      "Inverell Airport"
    ],
    "city": [
      "Inverell",
      "Inverell",
      "Inverell"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "JAB",
    "translations": [
      "Jabiru Airport",
      "Jabiru Airport",
      "Jabiru Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "JUN",
    "translations": [
      "Jundah Airport",
      "Jundah Airport",
      "Jundah Airport"
    ],
    "city": [
      "Jundah",
      "Jundah",
      "Jundah"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "JCK",
    "translations": [
      "Julia Creek Airport",
      "Julia Creek Airport",
      "Julia Creek Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "JUR",
    "translations": [
      "Jurien Bay Airport",
      "Jurien Bay Airport",
      "Jurien Bay Airport"
    ],
    "city": [
      "Jurien Bay",
      "Jurien Bay",
      "Jurien Bay"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "UBU",
    "translations": [
      "Kalumburu Airport",
      "Kalumburu Airport",
      "Kalumburu Airport"
    ],
    "city": [
      "Kalumburu",
      "Kalumburu",
      "Kalumburu"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KQR",
    "translations": [
      "Karara Airport",
      "Karara Airport",
      "Karara Airport"
    ],
    "city": [
      "Karara",
      "Karara",
      "Karara"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KYB",
    "translations": [
      "Ken's Bore airport",
      "Ken's Bore airport",
      "Ken's Bore airport"
    ],
    "city": [
      "Ken's Bore",
      "Ken's Bore",
      "Ken's Bore"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KDB",
    "translations": [
      "Kambalda Airport",
      "Kambalda Airport",
      "Kambalda Airport"
    ],
    "city": [
      "Kambalda West",
      "Kambalda West",
      "Kambalda West"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KAX",
    "translations": [
      "Kalbarri Airport",
      "Kalbarri Airport",
      "Kalbarri Airport"
    ],
    "city": [
      "Kalbarri",
      "Kalbarri",
      "Kalbarri"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KBY",
    "translations": [
      "Streaky Bay Airport",
      "Streaky Bay Airport",
      "Streaky Bay Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KBJ",
    "translations": [
      "Kings Canyon Airport",
      "Kings Canyon Airport",
      "Kings Canyon Airport"
    ],
    "city": [
      "Petermann",
      "Petermann",
      "Petermann"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KCS",
    "translations": [
      "Kings Creek Airport",
      "Kings Creek Airport",
      "Kings Creek Airport"
    ],
    "city": [
      "Petermann",
      "Petermann",
      "Petermann"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OOD",
    "translations": [
      "Koodaideri Mine Airport",
      "Koodaideri Mine Airport",
      "Koodaideri Mine Airport"
    ],
    "city": [
      "Koodaideri Mine",
      "Koodaideri Mine",
      "Koodaideri Mine"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KRA",
    "translations": [
      "Kerang Airport",
      "Kerang Airport",
      "Kerang Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KNS",
    "translations": [
      "King Island Airport",
      "King Island Airport",
      "King Island Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KBB",
    "translations": [
      "Kirkimbie Station Airport",
      "Kirkimbie Station Airport",
      "Kirkimbie Station Airport"
    ],
    "city": [
      "Kirkimbie",
      "Kirkimbie",
      "Kirkimbie"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KFG",
    "translations": [
      "Kalkgurung Airport",
      "Kalkgurung Airport",
      "Kalkgurung Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KOH",
    "translations": [
      "Koolatah Airport",
      "Koolatah Airport",
      "Koolatah Airport"
    ],
    "city": [
      "Maramie",
      "Maramie",
      "Maramie"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KKP",
    "translations": [
      "Koolburra Airport",
      "Koolburra Airport",
      "Koolburra Airport"
    ],
    "city": [
      "Koolburra",
      "Koolburra",
      "Koolburra"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KCI",
    "translations": [
      "Koolan Central Airport",
      "Koolan Central Airport",
      "Koolan Central Airport"
    ],
    "city": [
      "Koolan Island",
      "Koolan Island",
      "Koolan Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KRB",
    "translations": [
      "Karumba Airport",
      "Karumba Airport",
      "Karumba Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KML",
    "translations": [
      "Kamileroi Airport",
      "Kamileroi Airport",
      "Kamileroi Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KPS",
    "translations": [
      "Kempsey Airport",
      "Kempsey Airport",
      "Kempsey Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KNI",
    "translations": [
      "Katanning Airport",
      "Katanning Airport",
      "Katanning Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KWM",
    "translations": [
      "Kowanyama Airport",
      "Kowanyama Airport",
      "Kowanyama Airport"
    ],
    "city": [
      "Kowanyama",
      "Kowanyama",
      "Kowanyama"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KPP",
    "translations": [
      "Kalpowar Airport",
      "Kalpowar Airport",
      "Kalpowar Airport"
    ],
    "city": [
      "Kalpower",
      "Kalpower",
      "Kalpower"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KGY",
    "translations": [
      "Kingaroy Airport",
      "Kingaroy Airport",
      "Kingaroy Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KGC",
    "translations": [
      "Kingscote Airport",
      "Kingscote Airport",
      "Kingscote Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YKT",
    "translations": [
      "Klemtu Water Aerodrome",
      "Klemtu Water Aerodrome",
      "Klemtu Water Aerodrome"
    ],
    "city": [
      "Klemtu",
      "Klemtu",
      "Klemtu"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "KUG",
    "translations": [
      "Kubin Island Airport",
      "Kubin Island Airport",
      "Kubin Island Airport"
    ],
    "city": [
      "Kubin Island",
      "Kubin Island",
      "Kubin Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KRD",
    "translations": [
      "Kurundi Airport",
      "Kurundi Airport",
      "Kurundi Airport"
    ],
    "city": [
      "Kurundi Station",
      "Kurundi Station",
      "Kurundi Station"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LWH",
    "translations": [
      "Lawn Hill Airport",
      "Lawn Hill Airport",
      "Lawn Hill Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LGH",
    "translations": [
      "Leigh Creek Airport",
      "Leigh Creek Airport",
      "Leigh Creek Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LNO",
    "translations": [
      "Leonora Airport",
      "Leonora Airport",
      "Leonora Airport"
    ],
    "city": [
      "Leonora",
      "Leonora",
      "Leonora"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LEL",
    "translations": [
      "Lake Evella Airport",
      "Lake Evella Airport",
      "Lake Evella Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LFP",
    "translations": [
      "Lakefield Airport",
      "Lakefield Airport",
      "Lakefield Airport"
    ],
    "city": [
      "Lakefield",
      "Lakefield",
      "Lakefield"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LDH",
    "translations": [
      "Lord Howe Island Airport",
      "Lord Howe Island Airport",
      "Lord Howe Island Airport"
    ],
    "city": [
      "Lord Howe Island",
      "Lord Howe Island",
      "Lord Howe Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "IRG",
    "translations": [
      "Lockhart River Airport",
      "Lockhart River Airport",
      "Lockhart River Airport"
    ],
    "city": [
      "Lockhart River",
      "Lockhart River",
      "Lockhart River"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LTP",
    "translations": [
      "Lyndhurst Airport",
      "Lyndhurst Airport",
      "Lyndhurst Airport"
    ],
    "city": [
      "Lyndhurst",
      "Lyndhurst",
      "Lyndhurst"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LIB",
    "translations": [
      "Limbunya Airport",
      "Limbunya Airport",
      "Limbunya Airport"
    ],
    "city": [
      "Limbunya",
      "Limbunya",
      "Limbunya"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LDC",
    "translations": [
      "Lindeman Island Airport",
      "Lindeman Island Airport",
      "Lindeman Island Airport"
    ],
    "city": [
      "Lindeman Island",
      "Lindeman Island",
      "Lindeman Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LSY",
    "translations": [
      "Lismore Airport",
      "Lismore Airport",
      "Lismore Airport"
    ],
    "city": [
      "Lismore",
      "Lismore",
      "Lismore"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LNH",
    "translations": [
      "Lake Nash Airport",
      "Lake Nash Airport",
      "Lake Nash Airport"
    ],
    "city": [
      "Alpurrurulam",
      "Alpurrurulam",
      "Alpurrurulam"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BBL",
    "translations": [
      "Ballera Airport",
      "Ballera Airport",
      "Ballera Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BEO",
    "translations": [
      "Lake Macquarie Airport",
      "Lake Macquarie Airport",
      "Lake Macquarie Airport"
    ],
    "city": [
      "City of Lake Macquarie",
      "City of Lake Macquarie",
      "City of Lake Macquarie"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LKD",
    "translations": [
      "Lakeland Airport",
      "Lakeland Airport",
      "Lakeland Airport"
    ],
    "city": [
      "Lakeland Downs",
      "Lakeland Downs",
      "Lakeland Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LOC",
    "translations": [
      "Lock Airport",
      "Lock Airport",
      "Lock Airport"
    ],
    "city": [
      "Lock",
      "Lock",
      "Lock"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LOA",
    "translations": [
      "Lorraine Airport",
      "Lorraine Airport",
      "Lorraine Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LTV",
    "translations": [
      "Lotus Vale Airport",
      "Lotus Vale Airport",
      "Lotus Vale Airport"
    ],
    "city": [
      "Lotus Vale",
      "Lotus Vale",
      "Lotus Vale"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YLP",
    "translations": [
      "Mingan Airport",
      "Mingan Airport",
      "Mingan Airport"
    ],
    "city": [
      "Longue-Pointe-de-Mingan",
      "Longue-Pointe-de-Mingan",
      "Longue-Pointe-de-Mingan"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "LUU",
    "translations": [
      "Laura Airport",
      "Laura Airport",
      "Laura Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LHG",
    "translations": [
      "Lightning Ridge Airport",
      "Lightning Ridge Airport",
      "Lightning Ridge Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LRE",
    "translations": [
      "Longreach Airport",
      "Longreach Airport",
      "Longreach Airport"
    ],
    "city": [
      "Longreach",
      "Longreach",
      "Longreach"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LUT",
    "translations": [
      "New Laura Airport",
      "New Laura Airport",
      "New Laura Airport"
    ],
    "city": [
      "Laura Station",
      "Laura Station",
      "Laura Station"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LER",
    "translations": [
      "Leinster Airport",
      "Leinster Airport",
      "Leinster Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LVO",
    "translations": [
      "Laverton Airport",
      "Laverton Airport",
      "Laverton Airport"
    ],
    "city": [
      "Laverton",
      "Laverton",
      "Laverton"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TGN",
    "translations": [
      "Latrobe Valley Airport",
      "Latrobe Valley Airport",
      "Latrobe Valley Airport"
    ],
    "city": [
      "Morwell",
      "Morwell",
      "Morwell"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LZR",
    "translations": [
      "Lizard Island Airport",
      "Lizard Island Airport",
      "Lizard Island Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "UBB",
    "translations": [
      "Mabuiag Island Airport",
      "Mabuiag Island Airport",
      "Mabuiag Island Airport"
    ],
    "city": [
      "Mabuiag Island",
      "Mabuiag Island",
      "Mabuiag Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MYI",
    "translations": [
      "Murray Island Airport",
      "Murray Island Airport",
      "Murray Island Airport"
    ],
    "city": [
      "Murray Island",
      "Murray Island",
      "Murray Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "AVV",
    "translations": [
      "Avalon Airport",
      "Avalon Airport",
      "Avalon Airport"
    ],
    "city": [
      "Lara",
      "Lara",
      "Lara"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ABX",
    "translations": [
      "Albury Airport",
      "Albury Airport",
      "Albury Airport"
    ],
    "city": [
      "East Albury",
      "East Albury",
      "East Albury"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MRG",
    "translations": [
      "Mareeba Airport",
      "Mareeba Airport",
      "Mareeba Airport"
    ],
    "city": [
      "Mareeba",
      "Mareeba",
      "Mareeba"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MBB",
    "translations": [
      "Marble Bar Airport",
      "Marble Bar Airport",
      "Marble Bar Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "XMC",
    "translations": [
      "Mallacoota Airport",
      "Mallacoota Airport",
      "Mallacoota Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MFP",
    "translations": [
      "Manners Creek Airport",
      "Manners Creek Airport",
      "Manners Creek Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MLR",
    "translations": [
      "Millicent Airport",
      "Millicent Airport",
      "Millicent Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DGE",
    "translations": [
      "Mudgee Airport",
      "Mudgee Airport",
      "Mudgee Airport"
    ],
    "city": [
      "Mudgee",
      "Mudgee",
      "Mudgee"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MQA",
    "translations": [
      "Mandora Airport",
      "Mandora Airport",
      "Mandora Airport"
    ],
    "city": [
      "Eighty Mile Beach",
      "Eighty Mile Beach",
      "Eighty Mile Beach"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MNW",
    "translations": [
      "Macdonald Downs Airport",
      "Macdonald Downs Airport",
      "Macdonald Downs Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MKR",
    "translations": [
      "Meekatharra Airport",
      "Meekatharra Airport",
      "Meekatharra Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MEB",
    "translations": [
      "Melbourne Essendon Airport",
      "Melbourne Essendon Airport",
      "Melbourne Essendon Airport"
    ],
    "city": [
      "Essendon Fields",
      "Essendon Fields",
      "Essendon Fields"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MIM",
    "translations": [
      "Merimbula Airport",
      "Merimbula Airport",
      "Merimbula Airport"
    ],
    "city": [
      "Merimbula",
      "Merimbula",
      "Merimbula"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MLV",
    "translations": [
      "Merluna Airport",
      "Merluna Airport",
      "Merluna Airport"
    ],
    "city": [
      "Merluna",
      "Merluna",
      "Merluna"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MGT",
    "translations": [
      "Milingimbi Airport",
      "Milingimbi Airport",
      "Milingimbi Airport"
    ],
    "city": [
      "Milingimbi Island",
      "Milingimbi Island",
      "Milingimbi Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MNG",
    "translations": [
      "Maningrida Airport",
      "Maningrida Airport",
      "Maningrida Airport"
    ],
    "city": [
      "Maningrida",
      "Maningrida",
      "Maningrida"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GSN",
    "translations": [
      "Mount Gunson Airport",
      "Mount Gunson Airport",
      "Mount Gunson Airport"
    ],
    "city": [
      "Mount Gunson",
      "Mount Gunson",
      "Mount Gunson"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MGV",
    "translations": [
      "Margaret River (Station) Airport",
      "Margaret River (Station) Airport",
      "Margaret River (Station) Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MQZ",
    "translations": [
      "Margaret River Airport",
      "Margaret River Airport",
      "Margaret River Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MVU",
    "translations": [
      "Musgrave Airport",
      "Musgrave Airport",
      "Musgrave Airport"
    ],
    "city": [
      "Musgrave",
      "Musgrave",
      "Musgrave"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HBA",
    "translations": [
      "Hobart International Airport",
      "Hobart International Airport",
      "Hobart International Airport"
    ],
    "city": [
      "Hobart (Cambridge)",
      "Hobart (Cambridge)",
      "Hobart (Cambridge)"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MHO",
    "translations": [
      "Mount House Airport",
      "Mount House Airport",
      "Mount House Airport"
    ],
    "city": [
      "Wunaamin Miliwundi Ranges",
      "Wunaamin Miliwundi Ranges",
      "Wunaamin Miliwundi Ranges"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MCV",
    "translations": [
      "McArthur River Mine Airport",
      "McArthur River Mine Airport",
      "McArthur River Mine Airport"
    ],
    "city": [
      "McArthur River Mine",
      "McArthur River Mine",
      "McArthur River Mine"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MQL",
    "translations": [
      "Mildura Airport",
      "Mildura Airport",
      "Mildura Airport"
    ],
    "city": [
      "Mildura",
      "Mildura",
      "Mildura"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "XML",
    "translations": [
      "Minlaton Airport",
      "Minlaton Airport",
      "Minlaton Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MIH",
    "translations": [
      "Mitchell Plateau Airport",
      "Mitchell Plateau Airport",
      "Mitchell Plateau Airport"
    ],
    "city": [
      "Mitchell Plateau",
      "Mitchell Plateau",
      "Mitchell Plateau"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MWY",
    "translations": [
      "Miranda Downs Airport",
      "Miranda Downs Airport",
      "Miranda Downs Airport"
    ],
    "city": [
      "Miranda Downs",
      "Miranda Downs",
      "Miranda Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MTQ",
    "translations": [
      "Mitchell Airport",
      "Mitchell Airport",
      "Mitchell Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MJP",
    "translations": [
      "Manjimup Airport",
      "Manjimup Airport",
      "Manjimup Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WLE",
    "translations": [
      "Miles Airport",
      "Miles Airport",
      "Miles Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LST",
    "translations": [
      "Launceston Airport",
      "Launceston Airport",
      "Launceston Airport"
    ],
    "city": [
      "Launceston (Western Junction)",
      "Launceston (Western Junction)",
      "Launceston (Western Junction)"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MBW",
    "translations": [
      "Melbourne Moorabbin Airport",
      "Melbourne Moorabbin Airport",
      "Melbourne Moorabbin Airport"
    ],
    "city": [
      "Melbourne",
      "Melbourne",
      "Melbourne"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WUI",
    "translations": [
      "Murrin Murrin Airport",
      "Murrin Murrin Airport",
      "Murrin Murrin Airport"
    ],
    "city": [
      "Murrin Murrin",
      "Murrin Murrin",
      "Murrin Murrin"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MEL",
    "translations": [
      "Melbourne Airport",
      "Melbourne Airport",
      "Melbourne Airport"
    ],
    "city": [
      "Melbourne",
      "Melbourne",
      "Melbourne"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MMM",
    "translations": [
      "Middlemount Airport",
      "Middlemount Airport",
      "Middlemount Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MTL",
    "translations": [
      "Maitland Airport",
      "Maitland Airport",
      "Maitland Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WME",
    "translations": [
      "Mount Keith Airport",
      "Mount Keith Airport",
      "Mount Keith Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ONR",
    "translations": [
      "Monkira Airport",
      "Monkira Airport",
      "Monkira Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MSF",
    "translations": [
      "Mount Swan Airport",
      "Mount Swan Airport",
      "Mount Swan Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OXY",
    "translations": [
      "Morney Airport",
      "Morney Airport",
      "Morney Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MMG",
    "translations": [
      "Mount Magnet Airport",
      "Mount Magnet Airport",
      "Mount Magnet Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OOR",
    "translations": [
      "Mooraberree Airport",
      "Mooraberree Airport",
      "Mooraberree Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MRZ",
    "translations": [
      "Moree Airport",
      "Moree Airport",
      "Moree Airport"
    ],
    "city": [
      "Moree",
      "Moree",
      "Moree"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MET",
    "translations": [
      "Moreton Airport",
      "Moreton Airport",
      "Moreton Airport"
    ],
    "city": [
      "Moreton",
      "Moreton",
      "Moreton"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MIN",
    "translations": [
      "Minnipa Airport",
      "Minnipa Airport",
      "Minnipa Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MQE",
    "translations": [
      "Marqua Airport",
      "Marqua Airport",
      "Marqua Airport"
    ],
    "city": [
      "Marqua",
      "Marqua",
      "Marqua"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MOV",
    "translations": [
      "Moranbah Airport",
      "Moranbah Airport",
      "Moranbah Airport"
    ],
    "city": [
      "Moranbah",
      "Moranbah",
      "Moranbah"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RRE",
    "translations": [
      "Marree Airport",
      "Marree Airport",
      "Marree Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MWB",
    "translations": [
      "Morawa Airport",
      "Morawa Airport",
      "Morawa Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MYA",
    "translations": [
      "Moruya Airport",
      "Moruya Airport",
      "Moruya Airport"
    ],
    "city": [
      "Moruya",
      "Moruya",
      "Moruya"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MTD",
    "translations": [
      "Mount Sanford Station Airport",
      "Mount Sanford Station Airport",
      "Mount Sanford Station Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MIY",
    "translations": [
      "Mittebah Airport",
      "Mittebah Airport",
      "Mittebah Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "UTB",
    "translations": [
      "Muttaburra Airport",
      "Muttaburra Airport",
      "Muttaburra Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MGB",
    "translations": [
      "Mount Gambier Airport",
      "Mount Gambier Airport",
      "Mount Gambier Airport"
    ],
    "city": [
      "Mount Gambier",
      "Mount Gambier",
      "Mount Gambier"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ONG",
    "translations": [
      "Mornington Island Airport",
      "Mornington Island Airport",
      "Mornington Island Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MNQ",
    "translations": [
      "Monto Airport",
      "Monto Airport",
      "Monto Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MUQ",
    "translations": [
      "Muccan Station Airport",
      "Muccan Station Airport",
      "Muccan Station Airport"
    ],
    "city": [
      "Muccan Station",
      "Muccan Station",
      "Muccan Station"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MNE",
    "translations": [
      "Mungeranie Airport",
      "Mungeranie Airport",
      "Mungeranie Airport"
    ],
    "city": [
      "Mungeranie",
      "Mungeranie",
      "Mungeranie"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MVK",
    "translations": [
      "Mulka Airport",
      "Mulka Airport",
      "Mulka Airport"
    ],
    "city": [
      "Mulka",
      "Mulka",
      "Mulka"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MUP",
    "translations": [
      "Mulga Park Airport",
      "Mulga Park Airport",
      "Mulga Park Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MNV",
    "translations": [
      "Mount Valley Airport",
      "Mount Valley Airport",
      "Mount Valley Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MXU",
    "translations": [
      "Mullewa Airport",
      "Mullewa Airport",
      "Mullewa Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MWT",
    "translations": [
      "Moolawatana Airport",
      "Moolawatana Airport",
      "Moolawatana Airport"
    ],
    "city": [
      "Moolawatana Station",
      "Moolawatana Station",
      "Moolawatana Station"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MXD",
    "translations": [
      "Marion Downs Airport",
      "Marion Downs Airport",
      "Marion Downs Airport"
    ],
    "city": [
      "Marion Downs",
      "Marion Downs",
      "Marion Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MBH",
    "translations": [
      "Maryborough Airport",
      "Maryborough Airport",
      "Maryborough Airport"
    ],
    "city": [
      "Maryborough",
      "Maryborough",
      "Maryborough"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MYO",
    "translations": [
      "Myroodan Station Airport",
      "Myroodan Station Airport",
      "Myroodan Station Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RTY",
    "translations": [
      "Merty Merty Airport",
      "Merty Merty Airport",
      "Merty Merty Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NMR",
    "translations": [
      "Nappa Merrie Airport",
      "Nappa Merrie Airport",
      "Nappa Merrie Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NRA",
    "translations": [
      "Narrandera Airport",
      "Narrandera Airport",
      "Narrandera Airport"
    ],
    "city": [
      "Narrandera",
      "Narrandera",
      "Narrandera"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NAA",
    "translations": [
      "Narrabri Airport",
      "Narrabri Airport",
      "Narrabri Airport"
    ],
    "city": [
      "Narrabri",
      "Narrabri",
      "Narrabri"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RPM",
    "translations": [
      "Ngukurr Airport",
      "Ngukurr Airport",
      "Ngukurr Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NBH",
    "translations": [
      "Nambucca Heads Airport",
      "Nambucca Heads Airport",
      "Nambucca Heads Airport"
    ],
    "city": [
      "Nambucca Heads",
      "Nambucca Heads",
      "Nambucca Heads"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NLS",
    "translations": [
      "Nicholson Airport",
      "Nicholson Airport",
      "Nicholson Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NKB",
    "translations": [
      "Noonkanbah Airport",
      "Noonkanbah Airport",
      "Noonkanbah Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NMP",
    "translations": [
      "New Moon Airport",
      "New Moon Airport",
      "New Moon Airport"
    ],
    "city": [
      "Basalt",
      "Basalt",
      "Basalt"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NPP",
    "translations": [
      "Napperby Airport",
      "Napperby Airport",
      "Napperby Airport"
    ],
    "city": [
      "Napperby",
      "Napperby",
      "Napperby"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ABM",
    "translations": [
      "Northern Peninsula Airport",
      "Northern Peninsula Airport",
      "Northern Peninsula Airport"
    ],
    "city": [
      "Bamaga",
      "Bamaga",
      "Bamaga"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NAC",
    "translations": [
      "Naracoorte Airport",
      "Naracoorte Airport",
      "Naracoorte Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NRG",
    "translations": [
      "Narrogin Airport",
      "Narrogin Airport",
      "Narrogin Airport"
    ],
    "city": [
      "Narrogin",
      "Narrogin",
      "Narrogin"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "QRM",
    "translations": [
      "Narromine Airport",
      "Narromine Airport",
      "Narromine Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RVT",
    "translations": [
      "Ravensthorpe Airport",
      "Ravensthorpe Airport",
      "Ravensthorpe Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NSV",
    "translations": [
      "Noosa Airport",
      "Noosa Airport",
      "Noosa Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NSM",
    "translations": [
      "Norseman Aerodrome",
      "Norseman Aerodrome",
      "Norseman Aerodrome"
    ],
    "city": [
      "Norseman",
      "Norseman",
      "Norseman"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NTN",
    "translations": [
      "Normanton Airport",
      "Normanton Airport",
      "Normanton Airport"
    ],
    "city": [
      "Normanton",
      "Normanton",
      "Normanton"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NUR",
    "translations": [
      "Nullabor Motel Airport",
      "Nullabor Motel Airport",
      "Nullabor Motel Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NLL",
    "translations": [
      "Nullagine Airport",
      "Nullagine Airport",
      "Nullagine Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NUB",
    "translations": [
      "Numbulwar Airport",
      "Numbulwar Airport",
      "Numbulwar Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "UTD",
    "translations": [
      "Nutwood Downs Airport",
      "Nutwood Downs Airport",
      "Nutwood Downs Airport"
    ],
    "city": [
      "Nutwood Downs",
      "Nutwood Downs",
      "Nutwood Downs"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ZNE",
    "translations": [
      "Newman Airport",
      "Newman Airport",
      "Newman Airport"
    ],
    "city": [
      "Newman",
      "Newman",
      "Newman"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NYN",
    "translations": [
      "Nyngan Airport",
      "Nyngan Airport",
      "Nyngan Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OPI",
    "translations": [
      "Oenpelli Airport",
      "Oenpelli Airport",
      "Oenpelli Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YOI",
    "translations": [
      "Opinaca Aerodrome",
      "Opinaca Aerodrome",
      "Opinaca Aerodrome"
    ],
    "city": [
      "Éléonore Mine",
      "Éléonore Mine",
      "Éléonore Mine"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "XCO",
    "translations": [
      "Colac Airport",
      "Colac Airport",
      "Colac Airport"
    ],
    "city": [
      "Colac Otway Shire",
      "Colac Otway Shire",
      "Colac Otway Shire"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OLP",
    "translations": [
      "Olympic Dam Airport",
      "Olympic Dam Airport",
      "Olympic Dam Airport"
    ],
    "city": [
      "Olympic Dam",
      "Olympic Dam",
      "Olympic Dam"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ONS",
    "translations": [
      "Onslow Airport",
      "Onslow Airport",
      "Onslow Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ODD",
    "translations": [
      "Oodnadatta Airport",
      "Oodnadatta Airport",
      "Oodnadatta Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MOO",
    "translations": [
      "Moomba Airport",
      "Moomba Airport",
      "Moomba Airport"
    ],
    "city": [
      "Moomba",
      "Moomba",
      "Moomba"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RBS",
    "translations": [
      "Orbost Airport",
      "Orbost Airport",
      "Orbost Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OKB",
    "translations": [
      "Orchid Beach Airport",
      "Orchid Beach Airport",
      "Orchid Beach Airport"
    ],
    "city": [
      "Orchid Beach",
      "Orchid Beach",
      "Orchid Beach"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OAG",
    "translations": [
      "Orange Airport",
      "Orange Airport",
      "Orange Airport"
    ],
    "city": [
      "Orange",
      "Orange",
      "Orange"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ODR",
    "translations": [
      "Ord River Airport",
      "Ord River Airport",
      "Ord River Airport"
    ],
    "city": [
      "Ord River",
      "Ord River",
      "Ord River"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OSO",
    "translations": [
      "Osborne Mine Airport",
      "Osborne Mine Airport",
      "Osborne Mine Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OYN",
    "translations": [
      "Ouyen Airport",
      "Ouyen Airport",
      "Ouyen Airport"
    ],
    "city": [
      "Ouyen",
      "Ouyen",
      "Ouyen"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ADL",
    "translations": [
      "Adelaide International Airport",
      "Adelaide International Airport",
      "Adelaide International Airport"
    ],
    "city": [
      "Adelaide",
      "Adelaide",
      "Adelaide"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PUG",
    "translations": [
      "Port Augusta Airport",
      "Port Augusta Airport",
      "Port Augusta Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PMK",
    "translations": [
      "Palm Island Airport",
      "Palm Island Airport",
      "Palm Island Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PBO",
    "translations": [
      "Paraburdoo Airport",
      "Paraburdoo Airport",
      "Paraburdoo Airport"
    ],
    "city": [
      "Paraburdoo",
      "Paraburdoo",
      "Paraburdoo"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CCK",
    "translations": [
      "Cocos (Keeling) Islands Airport",
      "Cocos (Keeling) Islands Airport",
      "Cocos (Keeling) Islands Airport"
    ],
    "city": [
      "West Island",
      "West Island",
      "West Island"
    ],
    "country": [
      "CC",
      "CC",
      "CC"
    ]
  },
  {
    "iata": "PDN",
    "translations": [
      "Parndana Airport",
      "Parndana Airport",
      "Parndana Airport"
    ],
    "city": [
      "Kangaroo Island",
      "Kangaroo Island",
      "Kangaroo Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PDE",
    "translations": [
      "Pandie Pandie Airport",
      "Pandie Pandie Airport",
      "Pandie Pandie Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DRW",
    "translations": [
      "Darwin International Airport / RAAF Darwin",
      "Darwin International Airport / RAAF Darwin",
      "Darwin International Airport / RAAF Darwin"
    ],
    "city": [
      "Darwin",
      "Darwin",
      "Darwin"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PRD",
    "translations": [
      "Pardoo Airport",
      "Pardoo Airport",
      "Pardoo Airport"
    ],
    "city": [
      "Pardoo",
      "Pardoo",
      "Pardoo"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GOV",
    "translations": [
      "Gove Airport",
      "Gove Airport",
      "Gove Airport"
    ],
    "city": [
      "Nhulunbuy",
      "Nhulunbuy",
      "Nhulunbuy"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PPI",
    "translations": [
      "Port Pirie Airport",
      "Port Pirie Airport",
      "Port Pirie Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "JAD",
    "translations": [
      "Perth Jandakot Airport",
      "Perth Jandakot Airport",
      "Perth Jandakot Airport"
    ],
    "city": [
      "Perth",
      "Perth",
      "Perth"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KTA",
    "translations": [
      "Karratha Airport",
      "Karratha Airport",
      "Karratha Airport"
    ],
    "city": [
      "Karratha",
      "Karratha",
      "Karratha"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KGI",
    "translations": [
      "Kalgoorlie Boulder Airport",
      "Kalgoorlie Boulder Airport",
      "Kalgoorlie Boulder Airport"
    ],
    "city": [
      "Broadwood",
      "Broadwood",
      "Broadwood"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PKE",
    "translations": [
      "Parkes Airport",
      "Parkes Airport",
      "Parkes Airport"
    ],
    "city": [
      "Parkes",
      "Parkes",
      "Parkes"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PKT",
    "translations": [
      "Port Keats Airport",
      "Port Keats Airport",
      "Port Keats Airport"
    ],
    "city": [
      "Wadeye",
      "Wadeye",
      "Wadeye"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KNX",
    "translations": [
      "East Kimberley Regional (Kununurra) Airport",
      "East Kimberley Regional (Kununurra) Airport",
      "East Kimberley Regional (Kununurra) Airport"
    ],
    "city": [
      "Kununurra",
      "Kununurra",
      "Kununurra"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PLO",
    "translations": [
      "Port Lincoln Airport",
      "Port Lincoln Airport",
      "Port Lincoln Airport"
    ],
    "city": [
      "Port Lincoln",
      "Port Lincoln",
      "Port Lincoln"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "LEA",
    "translations": [
      "Learmonth Airport",
      "Learmonth Airport",
      "Learmonth Airport"
    ],
    "city": [
      "Exmouth",
      "Exmouth",
      "Exmouth"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PXH",
    "translations": [
      "Prominent Hill Airport",
      "Prominent Hill Airport",
      "Prominent Hill Airport"
    ],
    "city": [
      "Mount Eba",
      "Mount Eba",
      "Mount Eba"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "EDR",
    "translations": [
      "Pormpuraaw Airport",
      "Pormpuraaw Airport",
      "Pormpuraaw Airport"
    ],
    "city": [
      "Pormpuraaw",
      "Pormpuraaw",
      "Pormpuraaw"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PQQ",
    "translations": [
      "Port Macquarie Airport",
      "Port Macquarie Airport",
      "Port Macquarie Airport"
    ],
    "city": [
      "Port Macquarie",
      "Port Macquarie",
      "Port Macquarie"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PEY",
    "translations": [
      "Penong Airport",
      "Penong Airport",
      "Penong Airport"
    ],
    "city": [
      "Penong",
      "Penong",
      "Penong"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PTJ",
    "translations": [
      "Portland Airport",
      "Portland Airport",
      "Portland Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MBF",
    "translations": [
      "Porepunkah Airport",
      "Porepunkah Airport",
      "Porepunkah Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PHE",
    "translations": [
      "Port Hedland International Airport",
      "Port Hedland International Airport",
      "Port Hedland International Airport"
    ],
    "city": [
      "Port Hedland",
      "Port Hedland",
      "Port Hedland"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PER",
    "translations": [
      "Perth International Airport",
      "Perth International Airport",
      "Perth International Airport"
    ],
    "city": [
      "Perth",
      "Perth",
      "Perth"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PEA",
    "translations": [
      "Penneshaw Airport",
      "Penneshaw Airport",
      "Penneshaw Airport"
    ],
    "city": [
      "Ironstone",
      "Ironstone",
      "Ironstone"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KTR",
    "translations": [
      "Tindal Airport",
      "Tindal Airport",
      "Tindal Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "UMR",
    "translations": [
      "Woomera Airfield",
      "Woomera Airfield",
      "Woomera Airfield"
    ],
    "city": [
      "Woomera",
      "Woomera",
      "Woomera"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "XCH",
    "translations": [
      "Christmas Island Airport",
      "Christmas Island Airport",
      "Christmas Island Airport"
    ],
    "city": [
      "Flying Fish Cove",
      "Flying Fish Cove",
      "Flying Fish Cove"
    ],
    "country": [
      "CX",
      "CX",
      "CX"
    ]
  },
  {
    "iata": "UIR",
    "translations": [
      "Quirindi Airport",
      "Quirindi Airport",
      "Quirindi Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YQJ",
    "translations": [
      "April Point Seaplane Base",
      "April Point Seaplane Base",
      "April Point Seaplane Base"
    ],
    "city": [
      "Quadra Island",
      "Quadra Island",
      "Quadra Island"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "ULP",
    "translations": [
      "Quilpie Airport",
      "Quilpie Airport",
      "Quilpie Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "UEE",
    "translations": [
      "Queenstown Airport",
      "Queenstown Airport",
      "Queenstown Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RRV",
    "translations": [
      "Robinson River Airport",
      "Robinson River Airport",
      "Robinson River Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YRC",
    "translations": [
      "Refuge Cove Seaplane Base",
      "Refuge Cove Seaplane Base",
      "Refuge Cove Seaplane Base"
    ],
    "city": [
      "Desolation Sound",
      "Desolation Sound",
      "Desolation Sound"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "YRD",
    "translations": [
      "Dean River Airport",
      "Dean River Airport",
      "Dean River Airport"
    ],
    "city": [
      "Kimsquit Valley",
      "Kimsquit Valley",
      "Kimsquit Valley"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "RMK",
    "translations": [
      "Renmark Airport",
      "Renmark Airport",
      "Renmark Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RCM",
    "translations": [
      "Richmond Airport",
      "Richmond Airport",
      "Richmond Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RAM",
    "translations": [
      "Ramingining Airport",
      "Ramingining Airport",
      "Ramingining Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ROH",
    "translations": [
      "Robinhood Airport",
      "Robinhood Airport",
      "Robinhood Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RBU",
    "translations": [
      "Roebourne Airport",
      "Roebourne Airport",
      "Roebourne Airport"
    ],
    "city": [
      "Roebourne",
      "Roebourne",
      "Roebourne"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RBC",
    "translations": [
      "Robinvale Airport",
      "Robinvale Airport",
      "Robinvale Airport"
    ],
    "city": [
      "Robinvale",
      "Robinvale",
      "Robinvale"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RMA",
    "translations": [
      "Roma Airport",
      "Roma Airport",
      "Roma Airport"
    ],
    "city": [
      "Roma",
      "Roma",
      "Roma"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RPB",
    "translations": [
      "Roper Bar Airport",
      "Roper Bar Airport",
      "Roper Bar Airport"
    ],
    "city": [
      "Roper Bar",
      "Roper Bar",
      "Roper Bar"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RSB",
    "translations": [
      "Roseberth Airport",
      "Roseberth Airport",
      "Roseberth Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RTS",
    "translations": [
      "Rottnest Island Airport",
      "Rottnest Island Airport",
      "Rottnest Island Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RTP",
    "translations": [
      "Rutland Plains Airport",
      "Rutland Plains Airport",
      "Rutland Plains Airport"
    ],
    "city": [
      "Yagoonya",
      "Yagoonya",
      "Yagoonya"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "RHL",
    "translations": [
      "Roy Hill Station Airport",
      "Roy Hill Station Airport",
      "Roy Hill Station Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NDS",
    "translations": [
      "Sandstone Airport",
      "Sandstone Airport",
      "Sandstone Airport"
    ],
    "city": [
      "Sandstone",
      "Sandstone",
      "Sandstone"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BWU",
    "translations": [
      "Sydney Bankstown Airport",
      "Sydney Bankstown Airport",
      "Sydney Bankstown Airport"
    ],
    "city": [
      "Sydney",
      "Sydney",
      "Sydney"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CBR",
    "translations": [
      "Canberra Airport",
      "Canberra Airport",
      "Canberra Airport"
    ],
    "city": [
      "Canberra",
      "Canberra",
      "Canberra"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WCD",
    "translations": [
      "Carosue Dam Airport",
      "Carosue Dam Airport",
      "Carosue Dam Airport"
    ],
    "city": [
      "Cundeelee",
      "Cundeelee",
      "Cundeelee"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CDU",
    "translations": [
      "Camden Airport",
      "Camden Airport",
      "Camden Airport"
    ],
    "city": [
      "Cobbitty",
      "Cobbitty",
      "Cobbitty"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NSO",
    "translations": [
      "Scone Airport",
      "Scone Airport",
      "Scone Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SQC",
    "translations": [
      "Southern Cross Airport",
      "Southern Cross Airport",
      "Southern Cross Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "DBO",
    "translations": [
      "Dubbo City Regional Airport",
      "Dubbo City Regional Airport",
      "Dubbo City Regional Airport"
    ],
    "city": [
      "Dubbo",
      "Dubbo",
      "Dubbo"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SGO",
    "translations": [
      "St George Airport",
      "St George Airport",
      "St George Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SIX",
    "translations": [
      "Singleton Airport",
      "Singleton Airport",
      "Singleton Airport"
    ],
    "city": [
      "Singleton",
      "Singleton",
      "Singleton"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ZGL",
    "translations": [
      "South Galway Airport",
      "South Galway Airport",
      "South Galway Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SGP",
    "translations": [
      "Shay Gap Airport",
      "Shay Gap Airport",
      "Shay Gap Airport"
    ],
    "city": [
      "Shay Gap",
      "Shay Gap",
      "Shay Gap"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MJK",
    "translations": [
      "Shark Bay Airport",
      "Shark Bay Airport",
      "Shark Bay Airport"
    ],
    "city": [
      "Denham",
      "Denham",
      "Denham"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WOL",
    "translations": [
      "Shellharbour Airport",
      "Shellharbour Airport",
      "Shellharbour Airport"
    ],
    "city": [
      "Albion Park Rail",
      "Albion Park Rail",
      "Albion Park Rail"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WSY",
    "translations": [
      "Shute Harbour/Whitsunday Airport",
      "Shute Harbour/Whitsunday Airport",
      "Shute Harbour/Whitsunday Airport"
    ],
    "city": [
      "Shute Harbour",
      "Shute Harbour",
      "Shute Harbour"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SHT",
    "translations": [
      "Shepparton Airport",
      "Shepparton Airport",
      "Shepparton Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SBR",
    "translations": [
      "Saibai Island Airport",
      "Saibai Island Airport",
      "Saibai Island Airport"
    ],
    "city": [
      "Saibai Island",
      "Saibai Island",
      "Saibai Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GOS",
    "translations": [
      "Somersby Airstrip",
      "Somersby Airstrip",
      "Somersby Airstrip"
    ],
    "city": [
      "Gosford",
      "Gosford",
      "Gosford"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SIO",
    "translations": [
      "Smithton Airport",
      "Smithton Airport",
      "Smithton Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SOI",
    "translations": [
      "South Molle Island Helipad",
      "South Molle Island Helipad",
      "South Molle Island Helipad"
    ],
    "city": [
      "South Molle Island Resort",
      "South Molle Island Resort",
      "South Molle Island Resort"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SHU",
    "translations": [
      "Smith Point Airport",
      "Smith Point Airport",
      "Smith Point Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "STH",
    "translations": [
      "Strathmore Airport",
      "Strathmore Airport",
      "Strathmore Airport"
    ],
    "city": [
      "Strathmore",
      "Strathmore",
      "Strathmore"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SNB",
    "translations": [
      "Snake Bay Airport",
      "Snake Bay Airport",
      "Snake Bay Airport"
    ],
    "city": [
      "Milikapiti",
      "Milikapiti",
      "Milikapiti"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NLK",
    "translations": [
      "Norfolk Island International Airport",
      "Norfolk Island International Airport",
      "Norfolk Island International Airport"
    ],
    "city": [
      "Burnt Pine",
      "Burnt Pine",
      "Burnt Pine"
    ],
    "country": [
      "NF",
      "NF",
      "NF"
    ]
  },
  {
    "iata": "NOA",
    "translations": [
      "Naval Air Station Nowra - HMAS Albatross",
      "Naval Air Station Nowra - HMAS Albatross",
      "Naval Air Station Nowra - HMAS Albatross"
    ],
    "city": [
      "Nowra Hill",
      "Nowra Hill",
      "Nowra Hill"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SLJ",
    "translations": [
      "Solomon Airport",
      "Solomon Airport",
      "Solomon Airport"
    ],
    "city": [
      "Karijini National Park",
      "Karijini National Park",
      "Karijini National Park"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SNH",
    "translations": [
      "Stanthorpe Airport",
      "Stanthorpe Airport",
      "Stanthorpe Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SCG",
    "translations": [
      "Spring Creek Airport",
      "Spring Creek Airport",
      "Spring Creek Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SHQ",
    "translations": [
      "Southport Airport",
      "Southport Airport",
      "Southport Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KSV",
    "translations": [
      "Springvale Airport",
      "Springvale Airport",
      "Springvale Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "XRH",
    "translations": [
      "RAAF Base Richmond",
      "RAAF Base Richmond",
      "RAAF Base Richmond"
    ],
    "city": [
      "Richmond",
      "Richmond",
      "Richmond"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SRN",
    "translations": [
      "Strahan Airport",
      "Strahan Airport",
      "Strahan Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SYD",
    "translations": [
      "Sydney Kingsford Smith International Airport",
      "Sydney Kingsford Smith International Airport",
      "Sydney Kingsford Smith International Airport"
    ],
    "city": [
      "Sydney (Mascot)",
      "Sydney (Mascot)",
      "Sydney (Mascot)"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "HLS",
    "translations": [
      "St Helens Airport",
      "St Helens Airport",
      "St Helens Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "STF",
    "translations": [
      "Stephens Island Seaplane Base",
      "Stephens Island Seaplane Base",
      "Stephens Island Seaplane Base"
    ],
    "city": [
      "Stephens Island",
      "Stephens Island",
      "Stephens Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TMW",
    "translations": [
      "Tamworth Airport",
      "Tamworth Airport",
      "Tamworth Airport"
    ],
    "city": [
      "Tamworth",
      "Tamworth",
      "Tamworth"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SSP",
    "translations": [
      "Silver Plains Airport",
      "Silver Plains Airport",
      "Silver Plains Airport"
    ],
    "city": [
      "Silver Plains",
      "Silver Plains",
      "Silver Plains"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WGA",
    "translations": [
      "Wagga Wagga Airport",
      "Wagga Wagga Airport",
      "Wagga Wagga Airport"
    ],
    "city": [
      "Forest Hill",
      "Forest Hill",
      "Forest Hill"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SWH",
    "translations": [
      "Swan Hill Airport",
      "Swan Hill Airport",
      "Swan Hill Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SWC",
    "translations": [
      "Stawell Airport",
      "Stawell Airport",
      "Stawell Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "XTR",
    "translations": [
      "Tara Airport",
      "Tara Airport",
      "Tara Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TBL",
    "translations": [
      "Tableland Homestead Airport",
      "Tableland Homestead Airport",
      "Tableland Homestead Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "XTO",
    "translations": [
      "Taroom Airport",
      "Taroom Airport",
      "Taroom Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TAQ",
    "translations": [
      "Tarcoola Airport",
      "Tarcoola Airport",
      "Tarcoola Airport"
    ],
    "city": [
      "Tarcoola",
      "Tarcoola",
      "Tarcoola"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TBK",
    "translations": [
      "Timber Creek Airport",
      "Timber Creek Airport",
      "Timber Creek Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TDR",
    "translations": [
      "Theodore Airport",
      "Theodore Airport",
      "Theodore Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TQP",
    "translations": [
      "Trepell Airport",
      "Trepell Airport",
      "Trepell Airport"
    ],
    "city": [
      "Trepell",
      "Trepell",
      "Trepell"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TEF",
    "translations": [
      "Telfer Airport",
      "Telfer Airport",
      "Telfer Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TEM",
    "translations": [
      "Temora Airport",
      "Temora Airport",
      "Temora Airport"
    ],
    "city": [
      "Temora",
      "Temora",
      "Temora"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TAN",
    "translations": [
      "Tangalooma Airport",
      "Tangalooma Airport",
      "Tangalooma Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "XTG",
    "translations": [
      "Thargomindah Airport",
      "Thargomindah Airport",
      "Thargomindah Airport"
    ],
    "city": [
      "Thargomindah",
      "Thargomindah",
      "Thargomindah"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GTS",
    "translations": [
      "The Granites Airport",
      "The Granites Airport",
      "The Granites Airport"
    ],
    "city": [
      "The Granites Gold Mine",
      "The Granites Gold Mine",
      "The Granites Gold Mine"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TDN",
    "translations": [
      "Theda Station Airport",
      "Theda Station Airport",
      "Theda Station Airport"
    ],
    "city": [
      "Drysdale River",
      "Drysdale River",
      "Drysdale River"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TYG",
    "translations": [
      "Thylungra Airport",
      "Thylungra Airport",
      "Thylungra Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TYB",
    "translations": [
      "Tibooburra Airport",
      "Tibooburra Airport",
      "Tibooburra Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TKY",
    "translations": [
      "Turkey Creek Airport",
      "Turkey Creek Airport",
      "Turkey Creek Airport"
    ],
    "city": [
      "Turkey Creek",
      "Turkey Creek",
      "Turkey Creek"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "PHQ",
    "translations": [
      "The Monument Airport",
      "The Monument Airport",
      "The Monument Airport"
    ],
    "city": [
      "Phosphate Hill",
      "Phosphate Hill",
      "Phosphate Hill"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TPR",
    "translations": [
      "Tom Price Airport",
      "Tom Price Airport",
      "Tom Price Airport"
    ],
    "city": [
      "Tom Price",
      "Tom Price",
      "Tom Price"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TUM",
    "translations": [
      "Tumut Aerodrome",
      "Tumut Aerodrome",
      "Tumut Aerodrome"
    ],
    "city": [
      "Tumut",
      "Tumut",
      "Tumut"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TYP",
    "translations": [
      "Tobermorey Airport",
      "Tobermorey Airport",
      "Tobermorey Airport"
    ],
    "city": [
      "Tobermorey",
      "Tobermorey",
      "Tobermorey"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TXR",
    "translations": [
      "Tanbar Airport",
      "Tanbar Airport",
      "Tanbar Airport"
    ],
    "city": [
      "Tanbar Station",
      "Tanbar Station",
      "Tanbar Station"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "THG",
    "translations": [
      "Thangool Airport",
      "Thangool Airport",
      "Thangool Airport"
    ],
    "city": [
      "Biloela",
      "Biloela",
      "Biloela"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TCA",
    "translations": [
      "Tennant Creek Airport",
      "Tennant Creek Airport",
      "Tennant Creek Airport"
    ],
    "city": [
      "Tennant Creek",
      "Tennant Creek",
      "Tennant Creek"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TCW",
    "translations": [
      "Tocumwal Airport",
      "Tocumwal Airport",
      "Tocumwal Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TRO",
    "translations": [
      "Taree Airport",
      "Taree Airport",
      "Taree Airport"
    ],
    "city": [
      "Taree",
      "Taree",
      "Taree"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TTX",
    "translations": [
      "Truscott-Mungalalu Airport",
      "Truscott-Mungalalu Airport",
      "Truscott-Mungalalu Airport"
    ],
    "city": [
      "Anjo Peninsula",
      "Anjo Peninsula",
      "Anjo Peninsula"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "TWB",
    "translations": [
      "Toowoomba Airport",
      "Toowoomba Airport",
      "Toowoomba Airport"
    ],
    "city": [
      "Toowoomba",
      "Toowoomba",
      "Toowoomba"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "UDA",
    "translations": [
      "Undara Airport",
      "Undara Airport",
      "Undara Airport"
    ],
    "city": [
      "Undara",
      "Undara",
      "Undara"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "CZY",
    "translations": [
      "Cluny Airport",
      "Cluny Airport",
      "Cluny Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "USL",
    "translations": [
      "Useless Loop Airport",
      "Useless Loop Airport",
      "Useless Loop Airport"
    ],
    "city": [
      "Useless Loop",
      "Useless Loop",
      "Useless Loop"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "VCD",
    "translations": [
      "Victoria River Downs Airport",
      "Victoria River Downs Airport",
      "Victoria River Downs Airport"
    ],
    "city": [
      "Victoria River",
      "Victoria River",
      "Victoria River"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "VNR",
    "translations": [
      "Vanrook Station Airport",
      "Vanrook Station Airport",
      "Vanrook Station Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WAU",
    "translations": [
      "Wauchope Airport",
      "Wauchope Airport",
      "Wauchope Airport"
    ],
    "city": [
      "Wauchope",
      "Wauchope",
      "Wauchope"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WLA",
    "translations": [
      "Wallal Downs Airport",
      "Wallal Downs Airport",
      "Wallal Downs Airport"
    ],
    "city": [
      "Eighty Mile Beach",
      "Eighty Mile Beach",
      "Eighty Mile Beach"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WAV",
    "translations": [
      "Wave Hill Airport",
      "Wave Hill Airport",
      "Wave Hill Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WMB",
    "translations": [
      "Warrnambool Airport",
      "Warrnambool Airport",
      "Warrnambool Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SYU",
    "translations": [
      "Warraber Island Airport",
      "Warraber Island Airport",
      "Warraber Island Airport"
    ],
    "city": [
      "Sue Islet",
      "Sue Islet",
      "Sue Islet"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WIO",
    "translations": [
      "Wilcannia Airport",
      "Wilcannia Airport",
      "Wilcannia Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WLC",
    "translations": [
      "Walcha Airport",
      "Walcha Airport",
      "Walcha Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WAZ",
    "translations": [
      "Warwick Airport",
      "Warwick Airport",
      "Warwick Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WND",
    "translations": [
      "Windarra Airport",
      "Windarra Airport",
      "Windarra Airport"
    ],
    "city": [
      "Laverton",
      "Laverton",
      "Laverton"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WRN",
    "translations": [
      "Windarling Airport",
      "Windarling Airport",
      "Windarling Airport"
    ],
    "city": [
      "Windarling Mine",
      "Windarling Mine",
      "Windarling Mine"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WNR",
    "translations": [
      "Windorah Airport",
      "Windorah Airport",
      "Windorah Airport"
    ],
    "city": [
      "Windorah",
      "Windorah",
      "Windorah"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WON",
    "translations": [
      "Wondoola Airport",
      "Wondoola Airport",
      "Wondoola Airport"
    ],
    "city": [
      "Wondoola",
      "Wondoola",
      "Wondoola"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "MFL",
    "translations": [
      "Mount Full Stop Airport",
      "Mount Full Stop Airport",
      "Mount Full Stop Airport"
    ],
    "city": [
      "Wando Vale",
      "Wando Vale",
      "Wando Vale"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "GYB",
    "translations": [
      "Port Hedland/Wodgina Airport",
      "Port Hedland/Wodgina Airport",
      "Port Hedland/Wodgina Airport"
    ],
    "city": [
      "Wodgina",
      "Wodgina",
      "Wodgina"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WGT",
    "translations": [
      "Wangaratta Airport",
      "Wangaratta Airport",
      "Wangaratta Airport"
    ],
    "city": [
      "Laceby",
      "Laceby",
      "Laceby"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WYA",
    "translations": [
      "Whyalla Airport",
      "Whyalla Airport",
      "Whyalla Airport"
    ],
    "city": [
      "Whyalla",
      "Whyalla",
      "Whyalla"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WIT",
    "translations": [
      "Wittenoom Airport",
      "Wittenoom Airport",
      "Wittenoom Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WKB",
    "translations": [
      "Warracknabeal Airport",
      "Warracknabeal Airport",
      "Warracknabeal Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WGE",
    "translations": [
      "Walgett Airport",
      "Walgett Airport",
      "Walgett Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NTL",
    "translations": [
      "Newcastle Airport",
      "Newcastle Airport",
      "Newcastle Airport"
    ],
    "city": [
      "Williamtown",
      "Williamtown",
      "Williamtown"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WUN",
    "translations": [
      "Wiluna Airport",
      "Wiluna Airport",
      "Wiluna Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WPK",
    "translations": [
      "Wrotham Park Airport",
      "Wrotham Park Airport",
      "Wrotham Park Airport"
    ],
    "city": [
      "Wrotham Park",
      "Wrotham Park",
      "Wrotham Park"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WDI",
    "translations": [
      "Wondai Airport",
      "Wondai Airport",
      "Wondai Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WLL",
    "translations": [
      "Wollogorang Airport",
      "Wollogorang Airport",
      "Wollogorang Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "SXE",
    "translations": [
      "West Sale Airport",
      "West Sale Airport",
      "West Sale Airport"
    ],
    "city": [
      "Sale",
      "Sale",
      "Sale"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WLO",
    "translations": [
      "Waterloo Airport",
      "Waterloo Airport",
      "Waterloo Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WIN",
    "translations": [
      "Winton Airport",
      "Winton Airport",
      "Winton Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WUD",
    "translations": [
      "Wudinna Airport",
      "Wudinna Airport",
      "Wudinna Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WEW",
    "translations": [
      "Wee Waa Airport",
      "Wee Waa Airport",
      "Wee Waa Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WRW",
    "translations": [
      "Warrawagine Airport",
      "Warrawagine Airport",
      "Warrawagine Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WWI",
    "translations": [
      "Woodie Woodie Airport",
      "Woodie Woodie Airport",
      "Woodie Woodie Airport"
    ],
    "city": [
      "Woodie Woodie",
      "Woodie Woodie",
      "Woodie Woodie"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WWY",
    "translations": [
      "West Wyalong Airport",
      "West Wyalong Airport",
      "West Wyalong Airport"
    ],
    "city": [
      "West Wyalong",
      "West Wyalong",
      "West Wyalong"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "WYN",
    "translations": [
      "Wyndham Airport",
      "Wyndham Airport",
      "Wyndham Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "BWT",
    "translations": [
      "Wynyard Airport",
      "Wynyard Airport",
      "Wynyard Airport"
    ],
    "city": [
      "Burnie",
      "Burnie",
      "Burnie"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YLG",
    "translations": [
      "Yalgoo Airport",
      "Yalgoo Airport",
      "Yalgoo Airport"
    ],
    "city": [
      "Yalgoo",
      "Yalgoo",
      "Yalgoo"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "OKR",
    "translations": [
      "Yorke Island Airport",
      "Yorke Island Airport",
      "Yorke Island Airport"
    ],
    "city": [
      "Yorke Island",
      "Yorke Island",
      "Yorke Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KYF",
    "translations": [
      "Yeelirrie Airport",
      "Yeelirrie Airport",
      "Yeelirrie Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "XMY",
    "translations": [
      "Yam Island Airport",
      "Yam Island Airport",
      "Yam Island Airport"
    ],
    "city": [
      "Yam Island",
      "Yam Island",
      "Yam Island"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "YUE",
    "translations": [
      "Yuendumu Airport",
      "Yuendumu Airport",
      "Yuendumu Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "NGA",
    "translations": [
      "Young Airport",
      "Young Airport",
      "Young Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "ORR",
    "translations": [
      "Yorketown Airport",
      "Yorketown Airport",
      "Yorketown Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KYI",
    "translations": [
      "Yalata Mission Airport",
      "Yalata Mission Airport",
      "Yalata Mission Airport"
    ],
    "city": [
      "Yalata Mission",
      "Yalata Mission",
      "Yalata Mission"
    ],
    "country": [
      "AU",
      "AU",
      "AU"
    ]
  },
  {
    "iata": "KKI",
    "translations": [
      "Akiachak Airport",
      "Akiachak Airport",
      "Akiachak Airport"
    ],
    "city": [
      "Akiachak",
      "Akiachak",
      "Akiachak"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "BCC",
    "translations": [
      "Bear Creek 3 Airport",
      "Bear Creek 3 Airport",
      "Bear Creek 3 Airport"
    ],
    "city": [
      "Bear Creek",
      "Bear Creek",
      "Bear Creek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "JBT",
    "translations": [
      "Bethel Seaplane Base",
      "Bethel Seaplane Base",
      "Bethel Seaplane Base"
    ],
    "city": [
      "Bethel",
      "Bethel",
      "Bethel"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CZP",
    "translations": [
      "Cape Pole Seaplane Base",
      "Cape Pole Seaplane Base",
      "Cape Pole Seaplane Base"
    ],
    "city": [
      "Cape Pole",
      "Cape Pole",
      "Cape Pole"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KBW",
    "translations": [
      "Chignik Bay Seaplane Base",
      "Chignik Bay Seaplane Base",
      "Chignik Bay Seaplane Base"
    ],
    "city": [
      "Chignik",
      "Chignik",
      "Chignik"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "KBC",
    "translations": [
      "Birch Creek Airport",
      "Birch Creek Airport",
      "Birch Creek Airport"
    ],
    "city": [
      "Birch Creek",
      "Birch Creek",
      "Birch Creek"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "CZC",
    "translations": [
      "Copper Center 2 Airport",
      "Copper Center 2 Airport",
      "Copper Center 2 Airport"
    ],
    "city": [
      "Copper Center",
      "Copper Center",
      "Copper Center"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "HPR",
    "translations": [
      "Pretoria Central Heliport",
      "Pretoria Central Heliport",
      "Pretoria Central Heliport"
    ],
    "city": [
      "Pretoria",
      "Pretoria",
      "Pretoria"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "TDT",
    "translations": [
      "Tanda Tula Airport",
      "Tanda Tula Airport",
      "Tanda Tula Airport"
    ],
    "city": [
      "Timbavati",
      "Timbavati",
      "Timbavati"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "HZV",
    "translations": [
      "Hazyview Airport",
      "Hazyview Airport",
      "Hazyview Airport"
    ],
    "city": [
      "Hazyview",
      "Hazyview",
      "Hazyview"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "KHO",
    "translations": [
      "Khoka Moya Airport",
      "Khoka Moya Airport",
      "Khoka Moya Airport"
    ],
    "city": [
      "Khoka Moya",
      "Khoka Moya",
      "Khoka Moya"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "MBM",
    "translations": [
      "Mkambati Airport",
      "Mkambati Airport",
      "Mkambati Airport"
    ],
    "city": [
      "Mkambati",
      "Mkambati",
      "Mkambati"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "INY",
    "translations": [
      "Inyati Airport",
      "Inyati Airport",
      "Inyati Airport"
    ],
    "city": [
      "Inyati",
      "Inyati",
      "Inyati"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "TSD",
    "translations": [
      "Tshipise Airport",
      "Tshipise Airport",
      "Tshipise Airport"
    ],
    "city": [
      "Tshipise",
      "Tshipise",
      "Tshipise"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "SSX",
    "translations": [
      "Singita Safari Lodge Airport",
      "Singita Safari Lodge Airport",
      "Singita Safari Lodge Airport"
    ],
    "city": [
      "Singita Safari Lodge",
      "Singita Safari Lodge",
      "Singita Safari Lodge"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "KIG",
    "translations": [
      "Koingnaas Airport",
      "Koingnaas Airport",
      "Koingnaas Airport"
    ],
    "city": [
      "Koingnaas",
      "Koingnaas",
      "Koingnaas"
    ],
    "country": [
      "ZA",
      "ZA",
      "ZA"
    ]
  },
  {
    "iata": "PEK",
    "translations": [
      "Beijing Capital International Airport",
      "Beijing Capital International Airport",
      "Beijing Capital International Airport"
    ],
    "city": [
      "Beijing",
      "Beijing",
      "Beijing"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "PKX",
    "translations": [
      "Beijing Daxing International Airport",
      "Beijing Daxing International Airport",
      "Beijing Daxing International Airport"
    ],
    "city": [
      "Beijing",
      "Beijing",
      "Beijing"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CDE",
    "translations": [
      "Chengde Puning Airport",
      "Chengde Puning Airport",
      "Chengde Puning Airport"
    ],
    "city": [
      "Chengde",
      "Chengde",
      "Chengde"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CIF",
    "translations": [
      "Chifeng Yulong Airport",
      "Chifeng Yulong Airport",
      "Chifeng Yulong Airport"
    ],
    "city": [
      "Chifeng",
      "Chifeng",
      "Chifeng"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CIH",
    "translations": [
      "Changzhi Wangcun Airport",
      "Changzhi Wangcun Airport",
      "Changzhi Wangcun Airport"
    ],
    "city": [
      "Changzhi",
      "Changzhi",
      "Changzhi"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "BPE",
    "translations": [
      "Qinhuangdao Beidaihe Airport",
      "Qinhuangdao Beidaihe Airport",
      "Qinhuangdao Beidaihe Airport"
    ],
    "city": [
      "Qinhuangdao (Changli)",
      "Qinhuangdao (Changli)",
      "Qinhuangdao (Changli)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DSN",
    "translations": [
      "Ordos Ejin Horo Airport",
      "Ordos Ejin Horo Airport",
      "Ordos Ejin Horo Airport"
    ],
    "city": [
      "Ordos",
      "Ordos",
      "Ordos"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DAT",
    "translations": [
      "Datong Yungang Airport",
      "Datong Yungang Airport",
      "Datong Yungang Airport"
    ],
    "city": [
      "Datong",
      "Datong",
      "Datong"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ERL",
    "translations": [
      "Erenhot Saiwusu International Airport",
      "Erenhot Saiwusu International Airport",
      "Erenhot Saiwusu International Airport"
    ],
    "city": [
      "Erenhot",
      "Erenhot",
      "Erenhot"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YIE",
    "translations": [
      "Arxan Yi'ershi Airport",
      "Arxan Yi'ershi Airport",
      "Arxan Yi'ershi Airport"
    ],
    "city": [
      "Arxan",
      "Arxan",
      "Arxan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HDG",
    "translations": [
      "Handan Airport",
      "Handan Airport",
      "Handan Airport"
    ],
    "city": [
      "Handan",
      "Handan",
      "Handan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HET",
    "translations": [
      "Hohhot Baita International Airport",
      "Hohhot Baita International Airport",
      "Hohhot Baita International Airport"
    ],
    "city": [
      "Hohhot",
      "Hohhot",
      "Hohhot"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HUO",
    "translations": [
      "Holingol Huolinhe Airport",
      "Holingol Huolinhe Airport",
      "Holingol Huolinhe Airport"
    ],
    "city": [
      "Holingol",
      "Holingol",
      "Holingol"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HLD",
    "translations": [
      "Hulunbuir Hailar Airport",
      "Hulunbuir Hailar Airport",
      "Hulunbuir Hailar Airport"
    ],
    "city": [
      "Hailar",
      "Hailar",
      "Hailar"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LFQ",
    "translations": [
      "Linfen Yaodu Airport",
      "Linfen Yaodu Airport",
      "Linfen Yaodu Airport"
    ],
    "city": [
      "Linfen (Yaodu)",
      "Linfen (Yaodu)",
      "Linfen (Yaodu)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LLV",
    "translations": [
      "Lüliang Dawu Airport",
      "Lüliang Dawu Airport",
      "Lüliang Dawu Airport"
    ],
    "city": [
      "Lüliang",
      "Lüliang",
      "Lüliang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NZH",
    "translations": [
      "Manzhouli Xijiao Airport",
      "Manzhouli Xijiao Airport",
      "Manzhouli Xijiao Airport"
    ],
    "city": [
      "Manzhouli",
      "Manzhouli",
      "Manzhouli"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "BAV",
    "translations": [
      "Baotou Donghe Airport",
      "Baotou Donghe Airport",
      "Baotou Donghe Airport"
    ],
    "city": [
      "Baotou",
      "Baotou",
      "Baotou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SZH",
    "translations": [
      "Shuozhou Zirun Airport",
      "Shuozhou Zirun Airport",
      "Shuozhou Zirun Airport"
    ],
    "city": [
      "Shuozhou",
      "Shuozhou",
      "Shuozhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SJW",
    "translations": [
      "Shijiazhuang Zhengding International Airport",
      "Shijiazhuang Zhengding International Airport",
      "Shijiazhuang Zhengding International Airport"
    ],
    "city": [
      "Shijiazhuang",
      "Shijiazhuang",
      "Shijiazhuang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TSN",
    "translations": [
      "Tianjin Binhai International Airport",
      "Tianjin Binhai International Airport",
      "Tianjin Binhai International Airport"
    ],
    "city": [
      "Tianjin",
      "Tianjin",
      "Tianjin"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TGO",
    "translations": [
      "Tongliao Airport",
      "Tongliao Airport",
      "Tongliao Airport"
    ],
    "city": [
      "Tongliao",
      "Tongliao",
      "Tongliao"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "UCB",
    "translations": [
      "Ulanqab Jining Airport",
      "Ulanqab Jining Airport",
      "Ulanqab Jining Airport"
    ],
    "city": [
      "Ulanqab",
      "Ulanqab",
      "Ulanqab"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WUA",
    "translations": [
      "Wuhai Airport",
      "Wuhai Airport",
      "Wuhai Airport"
    ],
    "city": [
      "Wuhai",
      "Wuhai",
      "Wuhai"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HLH",
    "translations": [
      "Ulanhot Yilelite Airport",
      "Ulanhot Yilelite Airport",
      "Ulanhot Yilelite Airport"
    ],
    "city": [
      "Ulanhot",
      "Ulanhot",
      "Ulanhot"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "XIL",
    "translations": [
      "Xilinhot Airport",
      "Xilinhot Airport",
      "Xilinhot Airport"
    ],
    "city": [
      "Xilinhot",
      "Xilinhot",
      "Xilinhot"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "XNT",
    "translations": [
      "Xingtai Dalian Airport",
      "Xingtai Dalian Airport",
      "Xingtai Dalian Airport"
    ],
    "city": [
      "Xingtai",
      "Xingtai",
      "Xingtai"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WUT",
    "translations": [
      "Xinzhou Wutaishan Airport",
      "Xinzhou Wutaishan Airport",
      "Xinzhou Wutaishan Airport"
    ],
    "city": [
      "Xinzhou",
      "Xinzhou",
      "Xinzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YCU",
    "translations": [
      "Yuncheng Zhangxiao Airport",
      "Yuncheng Zhangxiao Airport",
      "Yuncheng Zhangxiao Airport"
    ],
    "city": [
      "Yuncheng (Yanhu)",
      "Yuncheng (Yanhu)",
      "Yuncheng (Yanhu)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TYN",
    "translations": [
      "Taiyuan Wusu International Airport",
      "Taiyuan Wusu International Airport",
      "Taiyuan Wusu International Airport"
    ],
    "city": [
      "Taiyuan",
      "Taiyuan",
      "Taiyuan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "RLK",
    "translations": [
      "Bayannur Tianjitai Airport",
      "Bayannur Tianjitai Airport",
      "Bayannur Tianjitai Airport"
    ],
    "city": [
      "Bavannur",
      "Bavannur",
      "Bavannur"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ZQZ",
    "translations": [
      "Zhangjiakou Ningyuan Airport",
      "Zhangjiakou Ningyuan Airport",
      "Zhangjiakou Ningyuan Airport"
    ],
    "city": [
      "Zhangjiakou",
      "Zhangjiakou",
      "Zhangjiakou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NZL",
    "translations": [
      "Zhalantun Genghis Khan Airport",
      "Zhalantun Genghis Khan Airport",
      "Zhalantun Genghis Khan Airport"
    ],
    "city": [
      "Zhalantun",
      "Zhalantun",
      "Zhalantun"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ZDM",
    "translations": [
      "Ramallah Heliport",
      "Ramallah Heliport",
      "Ramallah Heliport"
    ],
    "city": [
      "Ramallah",
      "Ramallah",
      "Ramallah"
    ],
    "country": [
      "PS",
      "PS",
      "PS"
    ]
  },
  {
    "iata": "BHY",
    "translations": [
      "Beihai Fucheng Airport",
      "Beihai Fucheng Airport",
      "Beihai Fucheng Airport"
    ],
    "city": [
      "Beihai (Yinhai)",
      "Beihai (Yinhai)",
      "Beihai (Yinhai)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "AEB",
    "translations": [
      "Baise (Bose) Bama Airport",
      "Baise (Bose) Bama Airport",
      "Baise (Bose) Bama Airport"
    ],
    "city": [
      "Baise (Tianyang)",
      "Baise (Tianyang)",
      "Baise (Tianyang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CGD",
    "translations": [
      "Changde Taohuayuan Airport",
      "Changde Taohuayuan Airport",
      "Changde Taohuayuan Airport"
    ],
    "city": [
      "Changde (Dingcheng)",
      "Changde (Dingcheng)",
      "Changde (Dingcheng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HJJ",
    "translations": [
      "Huaihua Zhijiang Airport",
      "Huaihua Zhijiang Airport",
      "Huaihua Zhijiang Airport"
    ],
    "city": [
      "Huaihua",
      "Huaihua",
      "Huaihua"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HCZ",
    "translations": [
      "Chenzhou Beihu Airport",
      "Chenzhou Beihu Airport",
      "Chenzhou Beihu Airport"
    ],
    "city": [
      "Chenzhou",
      "Chenzhou",
      "Chenzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DYG",
    "translations": [
      "Zhangjiajie Hehua International Airport",
      "Zhangjiajie Hehua International Airport",
      "Zhangjiajie Hehua International Airport"
    ],
    "city": [
      "Zhangjiajie (Yongding)",
      "Zhangjiajie (Yongding)",
      "Zhangjiajie (Yongding)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "FUO",
    "translations": [
      "Foshan Shadi Airport",
      "Foshan Shadi Airport",
      "Foshan Shadi Airport"
    ],
    "city": [
      "Foshan (Nanhai)",
      "Foshan (Nanhai)",
      "Foshan (Nanhai)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CAN",
    "translations": [
      "Guangzhou Baiyun International Airport",
      "Guangzhou Baiyun International Airport",
      "Guangzhou Baiyun International Airport"
    ],
    "city": [
      "Guangzhou (Huadu)",
      "Guangzhou (Huadu)",
      "Guangzhou (Huadu)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CSX",
    "translations": [
      "Changsha Huanghua International Airport",
      "Changsha Huanghua International Airport",
      "Changsha Huanghua International Airport"
    ],
    "city": [
      "Changsha (Changsha)",
      "Changsha (Changsha)",
      "Changsha (Changsha)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HCJ",
    "translations": [
      "Hechi Jinchengjiang Airport",
      "Hechi Jinchengjiang Airport",
      "Hechi Jinchengjiang Airport"
    ],
    "city": [
      "Hechi (Jinchengjiang)",
      "Hechi (Jinchengjiang)",
      "Hechi (Jinchengjiang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HNY",
    "translations": [
      "Hengyang Nanyue Airport",
      "Hengyang Nanyue Airport",
      "Hengyang Nanyue Airport"
    ],
    "city": [
      "Hengyang",
      "Hengyang",
      "Hengyang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HUZ",
    "translations": [
      "Huizhou Pingtan Airport",
      "Huizhou Pingtan Airport",
      "Huizhou Pingtan Airport"
    ],
    "city": [
      "Huizhou (Pingtan)",
      "Huizhou (Pingtan)",
      "Huizhou (Pingtan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "KWL",
    "translations": [
      "Guilin Liangjiang International Airport",
      "Guilin Liangjiang International Airport",
      "Guilin Liangjiang International Airport"
    ],
    "city": [
      "Guilin (Lingui)",
      "Guilin (Lingui)",
      "Guilin (Lingui)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LLF",
    "translations": [
      "Yongzhou Lingling Airport",
      "Yongzhou Lingling Airport",
      "Yongzhou Lingling Airport"
    ],
    "city": [
      "Yongzhou",
      "Yongzhou",
      "Yongzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "MXZ",
    "translations": [
      "Meizhou Meixian Changgangji International Airport",
      "Meizhou Meixian Changgangji International Airport",
      "Meizhou Meixian Changgangji International Airport"
    ],
    "city": [
      "Meizhou (Meixian)",
      "Meizhou (Meixian)",
      "Meizhou (Meixian)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NNG",
    "translations": [
      "Nanning Wuxu Airport",
      "Nanning Wuxu Airport",
      "Nanning Wuxu Airport"
    ],
    "city": [
      "Nanning (Jiangnan)",
      "Nanning (Jiangnan)",
      "Nanning (Jiangnan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SWA",
    "translations": [
      "Jieyang Chaoshan International Airport",
      "Jieyang Chaoshan International Airport",
      "Jieyang Chaoshan International Airport"
    ],
    "city": [
      "Jieyang (Rongcheng)",
      "Jieyang (Rongcheng)",
      "Jieyang (Rongcheng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ZUH",
    "translations": [
      "Zhuhai Jinwan Airport",
      "Zhuhai Jinwan Airport",
      "Zhuhai Jinwan Airport"
    ],
    "city": [
      "Zhuhai (Jinwan)",
      "Zhuhai (Jinwan)",
      "Zhuhai (Jinwan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WGN",
    "translations": [
      "Shaoyang Wugang Airport",
      "Shaoyang Wugang Airport",
      "Shaoyang Wugang Airport"
    ],
    "city": [
      "Shaoyang (Wugang)",
      "Shaoyang (Wugang)",
      "Shaoyang (Wugang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SZX",
    "translations": [
      "Shenzhen Bao'an International Airport",
      "Shenzhen Bao'an International Airport",
      "Shenzhen Bao'an International Airport"
    ],
    "city": [
      "Shenzhen (Bao'an)",
      "Shenzhen (Bao'an)",
      "Shenzhen (Bao'an)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WUZ",
    "translations": [
      "Wuzhou Xijiang Airport",
      "Wuzhou Xijiang Airport",
      "Wuzhou Xijiang Airport"
    ],
    "city": [
      "Tangbu",
      "Tangbu",
      "Tangbu"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "XIN",
    "translations": [
      "Xingning Air Base",
      "Xingning Air Base",
      "Xingning Air Base"
    ],
    "city": [
      "Meizhou (Xingning)",
      "Meizhou (Xingning)",
      "Meizhou (Xingning)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DXJ",
    "translations": [
      "Xiangxi Biancheng Airport",
      "Xiangxi Biancheng Airport",
      "Xiangxi Biancheng Airport"
    ],
    "city": [
      "Xiangxi",
      "Xiangxi",
      "Xiangxi"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YLX",
    "translations": [
      "Yulin Fumian Airport",
      "Yulin Fumian Airport",
      "Yulin Fumian Airport"
    ],
    "city": [
      "Yùlín",
      "Yùlín",
      "Yùlín"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YYA",
    "translations": [
      "Yueyang Sanhe Airport",
      "Yueyang Sanhe Airport",
      "Yueyang Sanhe Airport"
    ],
    "city": [
      "Yueyang (Yueyanglou)",
      "Yueyang (Yueyanglou)",
      "Yueyang (Yueyanglou)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LZH",
    "translations": [
      "Liuzhou Bailian Airport / Bailian Air Base",
      "Liuzhou Bailian Airport / Bailian Air Base",
      "Liuzhou Bailian Airport / Bailian Air Base"
    ],
    "city": [
      "Liuzhou (Liujiang)",
      "Liuzhou (Liujiang)",
      "Liuzhou (Liujiang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ZHA",
    "translations": [
      "Zhanjiang Wuchuan Airport",
      "Zhanjiang Wuchuan Airport",
      "Zhanjiang Wuchuan Airport"
    ],
    "city": [
      "Zhanjiang",
      "Zhanjiang",
      "Zhanjiang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "AYN",
    "translations": [
      "Anyang Yindu Airport",
      "Anyang Yindu Airport",
      "Anyang Yindu Airport"
    ],
    "city": [
      "Anyang",
      "Anyang",
      "Anyang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CGO",
    "translations": [
      "Zhengzhou Xinzheng International Airport",
      "Zhengzhou Xinzheng International Airport",
      "Zhengzhou Xinzheng International Airport"
    ],
    "city": [
      "Zhengzhou",
      "Zhengzhou",
      "Zhengzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "EHU",
    "translations": [
      "Ezhou Huahu Airport",
      "Ezhou Huahu Airport",
      "Ezhou Huahu Airport"
    ],
    "city": [
      "Ezhou",
      "Ezhou",
      "Ezhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ENH",
    "translations": [
      "Enshi Xujiaping Airport",
      "Enshi Xujiaping Airport",
      "Enshi Xujiaping Airport"
    ],
    "city": [
      "Enshi (Enshi)",
      "Enshi (Enshi)",
      "Enshi (Enshi)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LHK",
    "translations": [
      "Guangzhou MR Air Base / Guanghua Airport",
      "Guangzhou MR Air Base / Guanghua Airport",
      "Guangzhou MR Air Base / Guanghua Airport"
    ],
    "city": [
      "Xiangyang (Laohekou)",
      "Xiangyang (Laohekou)",
      "Xiangyang (Laohekou)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WUH",
    "translations": [
      "Wuhan Tianhe International Airport",
      "Wuhan Tianhe International Airport",
      "Wuhan Tianhe International Airport"
    ],
    "city": [
      "Wuhan (Huangpi)",
      "Wuhan (Huangpi)",
      "Wuhan (Huangpi)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SHS",
    "translations": [
      "Jingzhou Shashi Airport",
      "Jingzhou Shashi Airport",
      "Jingzhou Shashi Airport"
    ],
    "city": [
      "Jingzhou (Shashi)",
      "Jingzhou (Shashi)",
      "Jingzhou (Shashi)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LYA",
    "translations": [
      "Luoyang Beijiao Airport",
      "Luoyang Beijiao Airport",
      "Luoyang Beijiao Airport"
    ],
    "city": [
      "Luoyang (Laocheng)",
      "Luoyang (Laocheng)",
      "Luoyang (Laocheng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NNY",
    "translations": [
      "Nanyang Jiangying Airport",
      "Nanyang Jiangying Airport",
      "Nanyang Jiangying Airport"
    ],
    "city": [
      "Nanyang (Wancheng)",
      "Nanyang (Wancheng)",
      "Nanyang (Wancheng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HQQ",
    "translations": [
      "Anyang Hongqiqu Airport",
      "Anyang Hongqiqu Airport",
      "Anyang Hongqiqu Airport"
    ],
    "city": [
      "Anyang",
      "Anyang",
      "Anyang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HPG",
    "translations": [
      "Shennongjia Hongping Airport",
      "Shennongjia Hongping Airport",
      "Shennongjia Hongping Airport"
    ],
    "city": [
      "Shennongjia (Hongping)",
      "Shennongjia (Hongping)",
      "Shennongjia (Hongping)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WDS",
    "translations": [
      "Shiyan Wudangshan Airport",
      "Shiyan Wudangshan Airport",
      "Shiyan Wudangshan Airport"
    ],
    "city": [
      "Shiyan (Maojian)",
      "Shiyan (Maojian)",
      "Shiyan (Maojian)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "XFN",
    "translations": [
      "Xiangyang Liuji Airport",
      "Xiangyang Liuji Airport",
      "Xiangyang Liuji Airport"
    ],
    "city": [
      "Xiangyang (Xiangzhou)",
      "Xiangyang (Xiangzhou)",
      "Xiangyang (Xiangzhou)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "XAI",
    "translations": [
      "Xinyang Minggang Airport",
      "Xinyang Minggang Airport",
      "Xinyang Minggang Airport"
    ],
    "city": [
      "Xinyang",
      "Xinyang",
      "Xinyang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YIH",
    "translations": [
      "Yichang Sanxia Airport",
      "Yichang Sanxia Airport",
      "Yichang Sanxia Airport"
    ],
    "city": [
      "Yichang (Xiaoting)",
      "Yichang (Xiaoting)",
      "Yichang (Xiaoting)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ZIZ",
    "translations": [
      "Zamzama Heliport",
      "Zamzama Heliport",
      "Zamzama Heliport"
    ],
    "city": [
      "Zamzama Gas Field",
      "Zamzama Gas Field",
      "Zamzama Gas Field"
    ],
    "country": [
      "PK",
      "PK",
      "PK"
    ]
  },
  {
    "iata": "HAK",
    "translations": [
      "Haikou Meilan International Airport",
      "Haikou Meilan International Airport",
      "Haikou Meilan International Airport"
    ],
    "city": [
      "Haikou (Meilan)",
      "Haikou (Meilan)",
      "Haikou (Meilan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "BAR",
    "translations": [
      "Qionghai Bo'ao Airport",
      "Qionghai Bo'ao Airport",
      "Qionghai Bo'ao Airport"
    ],
    "city": [
      "Qionghai (Basuo)",
      "Qionghai (Basuo)",
      "Qionghai (Basuo)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SYX",
    "translations": [
      "Sanya Phoenix International Airport",
      "Sanya Phoenix International Airport",
      "Sanya Phoenix International Airport"
    ],
    "city": [
      "Sanya (Tianya)",
      "Sanya (Tianya)",
      "Sanya (Tianya)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "RGO",
    "translations": [
      "Orang (Chongjin) Airport",
      "Orang (Chongjin) Airport",
      "Orang (Chongjin) Airport"
    ],
    "city": [
      "Hoemun-ri",
      "Hoemun-ri",
      "Hoemun-ri"
    ],
    "country": [
      "KP",
      "KP",
      "KP"
    ]
  },
  {
    "iata": "FNJ",
    "translations": [
      "Pyongyang Sunan International Airport",
      "Pyongyang Sunan International Airport",
      "Pyongyang Sunan International Airport"
    ],
    "city": [
      "Pyongyang",
      "Pyongyang",
      "Pyongyang"
    ],
    "country": [
      "KP",
      "KP",
      "KP"
    ]
  },
  {
    "iata": "DSO",
    "translations": [
      "Sondok Airport",
      "Sondok Airport",
      "Sondok Airport"
    ],
    "city": [
      "Sŏndŏng-ni",
      "Sŏndŏng-ni",
      "Sŏndŏng-ni"
    ],
    "country": [
      "KP",
      "KP",
      "KP"
    ]
  },
  {
    "iata": "YJS",
    "translations": [
      "Samjiyŏn Airport",
      "Samjiyŏn Airport",
      "Samjiyŏn Airport"
    ],
    "city": [
      "Samjiyŏn",
      "Samjiyŏn",
      "Samjiyŏn"
    ],
    "country": [
      "KP",
      "KP",
      "KP"
    ]
  },
  {
    "iata": "UJU",
    "translations": [
      "Uiju Airport",
      "Uiju Airport",
      "Uiju Airport"
    ],
    "city": [
      "Uiju",
      "Uiju",
      "Uiju"
    ],
    "country": [
      "KP",
      "KP",
      "KP"
    ]
  },
  {
    "iata": "WOS",
    "translations": [
      "Wonsan Kalma International Airport",
      "Wonsan Kalma International Airport",
      "Wonsan Kalma International Airport"
    ],
    "city": [
      "Wonsan",
      "Wonsan",
      "Wonsan"
    ],
    "country": [
      "KP",
      "KP",
      "KP"
    ]
  },
  {
    "iata": "AKA",
    "translations": [
      "Ankang Fuqiang Airport",
      "Ankang Fuqiang Airport",
      "Ankang Fuqiang Airport"
    ],
    "city": [
      "Ankang (Hanbin)",
      "Ankang (Hanbin)",
      "Ankang (Hanbin)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DNH",
    "translations": [
      "Dunhuang Mogao International Airport",
      "Dunhuang Mogao International Airport",
      "Dunhuang Mogao International Airport"
    ],
    "city": [
      "Dunhuang",
      "Dunhuang",
      "Dunhuang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HXD",
    "translations": [
      "Delingha Airport",
      "Delingha Airport",
      "Delingha Airport"
    ],
    "city": [
      "Delingha",
      "Delingha",
      "Delingha"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "GMQ",
    "translations": [
      "Golog Maqên Airport",
      "Golog Maqên Airport",
      "Golog Maqên Airport"
    ],
    "city": [
      "Golog (Maqên)",
      "Golog (Maqên)",
      "Golog (Maqên)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "GOQ",
    "translations": [
      "Golmud Airport",
      "Golmud Airport",
      "Golmud Airport"
    ],
    "city": [
      "Golmud",
      "Golmud",
      "Golmud"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "GYU",
    "translations": [
      "Guyuan Liupanshan Airport",
      "Guyuan Liupanshan Airport",
      "Guyuan Liupanshan Airport"
    ],
    "city": [
      "Guyuan (Yuanzhou)",
      "Guyuan (Yuanzhou)",
      "Guyuan (Yuanzhou)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HBQ",
    "translations": [
      "Haibei Qilian Airport",
      "Haibei Qilian Airport",
      "Haibei Qilian Airport"
    ],
    "city": [
      "Haibei (Qilian)",
      "Haibei (Qilian)",
      "Haibei (Qilian)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HTT",
    "translations": [
      "Huatugou Airport",
      "Huatugou Airport",
      "Huatugou Airport"
    ],
    "city": [
      "Mengnai",
      "Mengnai",
      "Mengnai"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HZG",
    "translations": [
      "Hanzhong Chenggu Airport",
      "Hanzhong Chenggu Airport",
      "Hanzhong Chenggu Airport"
    ],
    "city": [
      "Hanzhong (Chenggu)",
      "Hanzhong (Chenggu)",
      "Hanzhong (Chenggu)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "INC",
    "translations": [
      "Yinchuan Hedong International Airport",
      "Yinchuan Hedong International Airport",
      "Yinchuan Hedong International Airport"
    ],
    "city": [
      "Yinchuan",
      "Yinchuan",
      "Yinchuan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JIC",
    "translations": [
      "Jinchang Jinchuan Airport",
      "Jinchang Jinchuan Airport",
      "Jinchang Jinchuan Airport"
    ],
    "city": [
      "Jinchang",
      "Jinchang",
      "Jinchang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JGN",
    "translations": [
      "Jiayuguan Airport",
      "Jiayuguan Airport",
      "Jiayuguan Airport"
    ],
    "city": [
      "Jiayuguan",
      "Jiayuguan",
      "Jiayuguan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LHW",
    "translations": [
      "Lanzhou Zhongchuan International Airport",
      "Lanzhou Zhongchuan International Airport",
      "Lanzhou Zhongchuan International Airport"
    ],
    "city": [
      "Lanzhou (Yongdeng)",
      "Lanzhou (Yongdeng)",
      "Lanzhou (Yongdeng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LNL",
    "translations": [
      "Longnan Chengzhou Airport",
      "Longnan Chengzhou Airport",
      "Longnan Chengzhou Airport"
    ],
    "city": [
      "Longnan (Cheng)",
      "Longnan (Cheng)",
      "Longnan (Cheng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "IQN",
    "translations": [
      "Qingyang Xifeng Airport",
      "Qingyang Xifeng Airport",
      "Qingyang Xifeng Airport"
    ],
    "city": [
      "Qingyang (Xifeng)",
      "Qingyang (Xifeng)",
      "Qingyang (Xifeng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SIA",
    "translations": [
      "Xi'an Xiguan Airport",
      "Xi'an Xiguan Airport",
      "Xi'an Xiguan Airport"
    ],
    "city": [
      "Xi'an (Baqiao)",
      "Xi'an (Baqiao)",
      "Xi'an (Baqiao)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "THQ",
    "translations": [
      "Tianshui Maijishan Airport",
      "Tianshui Maijishan Airport",
      "Tianshui Maijishan Airport"
    ],
    "city": [
      "Tianshui (Maiji)",
      "Tianshui (Maiji)",
      "Tianshui (Maiji)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "GXH",
    "translations": [
      "Gannan Xiahe Airport",
      "Gannan Xiahe Airport",
      "Gannan Xiahe Airport"
    ],
    "city": [
      "Gannan (Xiahe)",
      "Gannan (Xiahe)",
      "Gannan (Xiahe)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "XNN",
    "translations": [
      "Xining Caojiabao International Airport",
      "Xining Caojiabao International Airport",
      "Xining Caojiabao International Airport"
    ],
    "city": [
      "Haidong (Huzhu Tu Autonomous County)",
      "Haidong (Huzhu Tu Autonomous County)",
      "Haidong (Huzhu Tu Autonomous County)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "XIY",
    "translations": [
      "Xi'an Xianyang International Airport",
      "Xi'an Xianyang International Airport",
      "Xi'an Xianyang International Airport"
    ],
    "city": [
      "Xianyang (Weicheng)",
      "Xianyang (Weicheng)",
      "Xianyang (Weicheng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ENY",
    "translations": [
      "Yan'an Nanniwan Airport",
      "Yan'an Nanniwan Airport",
      "Yan'an Nanniwan Airport"
    ],
    "city": [
      "Yan'an (Baota)",
      "Yan'an (Baota)",
      "Yan'an (Baota)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "UYN",
    "translations": [
      "Yulin Yuyang Airport",
      "Yulin Yuyang Airport",
      "Yulin Yuyang Airport"
    ],
    "city": [
      "Yulin",
      "Yulin",
      "Yulin"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YUS",
    "translations": [
      "Yushu Batang Airport",
      "Yushu Batang Airport",
      "Yushu Batang Airport"
    ],
    "city": [
      "Yushu (Batang)",
      "Yushu (Batang)",
      "Yushu (Batang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ZHY",
    "translations": [
      "Zhongwei Shapotou Airport",
      "Zhongwei Shapotou Airport",
      "Zhongwei Shapotou Airport"
    ],
    "city": [
      "Zhongwei (Shapotou)",
      "Zhongwei (Shapotou)",
      "Zhongwei (Shapotou)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YZY",
    "translations": [
      "Zhangye Ganzhou Airport",
      "Zhangye Ganzhou Airport",
      "Zhangye Ganzhou Airport"
    ],
    "city": [
      "Zhangye (Ganzhou)",
      "Zhangye (Ganzhou)",
      "Zhangye (Ganzhou)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "UMB",
    "translations": [
      "Kalumbila Airport",
      "Kalumbila Airport",
      "Kalumbila Airport"
    ],
    "city": [
      "Kalumbila",
      "Kalumbila",
      "Kalumbila"
    ],
    "country": [
      "ZM",
      "ZM",
      "ZM"
    ]
  },
  {
    "iata": "AVK",
    "translations": [
      "Arvaikheer Airport",
      "Arvaikheer Airport",
      "Arvaikheer Airport"
    ],
    "city": [
      "Arvaikheer",
      "Arvaikheer",
      "Arvaikheer"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "LTI",
    "translations": [
      "Altai Airport",
      "Altai Airport",
      "Altai Airport"
    ],
    "city": [
      "Altai",
      "Altai",
      "Altai"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "BYN",
    "translations": [
      "Bayankhongor Airport",
      "Bayankhongor Airport",
      "Bayankhongor Airport"
    ],
    "city": [
      "Bayankhongor",
      "Bayankhongor",
      "Bayankhongor"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "UGA",
    "translations": [
      "Bulgan Airport",
      "Bulgan Airport",
      "Bulgan Airport"
    ],
    "city": [
      "Bulgan",
      "Bulgan",
      "Bulgan"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "UGT",
    "translations": [
      "Bulagtai Resort Airport",
      "Bulagtai Resort Airport",
      "Bulagtai Resort Airport"
    ],
    "city": [
      "Khankhongor",
      "Khankhongor",
      "Khankhongor"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "HBU",
    "translations": [
      "Bulgan Sum Airport",
      "Bulgan Sum Airport",
      "Bulgan Sum Airport"
    ],
    "city": [
      "Bulgan",
      "Bulgan",
      "Bulgan"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "UUN",
    "translations": [
      "Baruun Urt Airport",
      "Baruun Urt Airport",
      "Baruun Urt Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "COQ",
    "translations": [
      "Choibalsan Airport",
      "Choibalsan Airport",
      "Choibalsan Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "UBN",
    "translations": [
      "Ulaanbaatar Chinggis Khaan International Airport",
      "Ulaanbaatar Chinggis Khaan International Airport",
      "Ulaanbaatar Chinggis Khaan International Airport"
    ],
    "city": [
      "Ulaanbaatar (Sergelen)",
      "Ulaanbaatar (Sergelen)",
      "Ulaanbaatar (Sergelen)"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "ZMD",
    "translations": [
      "Sena Madureira Airport",
      "Sena Madureira Airport",
      "Sena Madureira Airport"
    ],
    "city": [
      "Sena Madureira",
      "Sena Madureira",
      "Sena Madureira"
    ],
    "country": [
      "BR",
      "BR",
      "BR"
    ]
  },
  {
    "iata": "ULZ",
    "translations": [
      "Donoi Airport",
      "Donoi Airport",
      "Donoi Airport"
    ],
    "city": [
      "Uliastai",
      "Uliastai",
      "Uliastai"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "DLZ",
    "translations": [
      "Dalanzadgad Airport",
      "Dalanzadgad Airport",
      "Dalanzadgad Airport"
    ],
    "city": [
      "Dalanzadgad",
      "Dalanzadgad",
      "Dalanzadgad"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "HTM",
    "translations": [
      "Khatgal Airport",
      "Khatgal Airport",
      "Khatgal Airport"
    ],
    "city": [
      "Hatgal",
      "Hatgal",
      "Hatgal"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "KHR",
    "translations": [
      "Kharkhorin Airport",
      "Kharkhorin Airport",
      "Kharkhorin Airport"
    ],
    "city": [
      "",
      "",
      ""
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "HJT",
    "translations": [
      "Khujirt Airport",
      "Khujirt Airport",
      "Khujirt Airport"
    ],
    "city": [
      "Khujirt",
      "Khujirt",
      "Khujirt"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "HVD",
    "translations": [
      "Khovd Airport",
      "Khovd Airport",
      "Khovd Airport"
    ],
    "city": [
      "Khovd",
      "Khovd",
      "Khovd"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "MXW",
    "translations": [
      "Mandalgobi Airport",
      "Mandalgobi Airport",
      "Mandalgobi Airport"
    ],
    "city": [
      "Mandalgobi",
      "Mandalgobi",
      "Mandalgobi"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "MXV",
    "translations": [
      "Mörön Airport",
      "Mörön Airport",
      "Mörön Airport"
    ],
    "city": [
      "Mörön",
      "Mörön",
      "Mörön"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "TSZ",
    "translations": [
      "Tsetserleg Airport",
      "Tsetserleg Airport",
      "Tsetserleg Airport"
    ],
    "city": [
      "Tsetserleg",
      "Tsetserleg",
      "Tsetserleg"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "TNZ",
    "translations": [
      "Tosontsengel Airport",
      "Tosontsengel Airport",
      "Tosontsengel Airport"
    ],
    "city": [
      "Tosontsengel",
      "Tosontsengel",
      "Tosontsengel"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "ULN",
    "translations": [
      "Buyant-Ukhaa International Airport",
      "Buyant-Ukhaa International Airport",
      "Buyant-Ukhaa International Airport"
    ],
    "city": [
      "Ulaanbaatar",
      "Ulaanbaatar",
      "Ulaanbaatar"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "ULO",
    "translations": [
      "Ulaangom Airport",
      "Ulaangom Airport",
      "Ulaangom Airport"
    ],
    "city": [
      "Ulaangom",
      "Ulaangom",
      "Ulaangom"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "UNR",
    "translations": [
      "Öndörkhaan Airport",
      "Öndörkhaan Airport",
      "Öndörkhaan Airport"
    ],
    "city": [
      "Öndörkhaan",
      "Öndörkhaan",
      "Öndörkhaan"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "ULG",
    "translations": [
      "Ölgii Mongolei Airport",
      "Ölgii Mongolei Airport",
      "Ölgii Mongolei Airport"
    ],
    "city": [
      "Ölgii",
      "Ölgii",
      "Ölgii"
    ],
    "country": [
      "MN",
      "MN",
      "MN"
    ]
  },
  {
    "iata": "ZNC",
    "translations": [
      "Nyac Airport",
      "Nyac Airport",
      "Nyac Airport"
    ],
    "city": [
      "Nyac",
      "Nyac",
      "Nyac"
    ],
    "country": [
      "United States",
      "États-Unis",
      "Vereinigte Staaten"
    ]
  },
  {
    "iata": "ZNU",
    "translations": [
      "Namu Water Aerodrome",
      "Namu Water Aerodrome",
      "Namu Water Aerodrome"
    ],
    "city": [
      "Namu",
      "Namu",
      "Namu"
    ],
    "country": [
      "CA",
      "CA",
      "CA"
    ]
  },
  {
    "iata": "BSD",
    "translations": [
      "Baoshan Yunrui Airport",
      "Baoshan Yunrui Airport",
      "Baoshan Yunrui Airport"
    ],
    "city": [
      "Baoshan (Longyang)",
      "Baoshan (Longyang)",
      "Baoshan (Longyang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CWJ",
    "translations": [
      "Cangyuan Washan Airport",
      "Cangyuan Washan Airport",
      "Cangyuan Washan Airport"
    ],
    "city": [
      "Lincang (Cangyuan)",
      "Lincang (Cangyuan)",
      "Lincang (Cangyuan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DLU",
    "translations": [
      "Dali Fengyi Airport",
      "Dali Fengyi Airport",
      "Dali Fengyi Airport"
    ],
    "city": [
      "Dali (Xiaguan)",
      "Dali (Xiaguan)",
      "Dali (Xiaguan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DIG",
    "translations": [
      "Diqing Shangri-La Airport",
      "Diqing Shangri-La Airport",
      "Diqing Shangri-La Airport"
    ],
    "city": [
      "Diqing (Shangri-La)",
      "Diqing (Shangri-La)",
      "Diqing (Shangri-La)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JHG",
    "translations": [
      "Xishuangbanna Gasa International Airport",
      "Xishuangbanna Gasa International Airport",
      "Xishuangbanna Gasa International Airport"
    ],
    "city": [
      "Jinghong (Gasa)",
      "Jinghong (Gasa)",
      "Jinghong (Gasa)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JMJ",
    "translations": [
      "Lancang Jingmai Airport",
      "Lancang Jingmai Airport",
      "Lancang Jingmai Airport"
    ],
    "city": [
      "Pu'er (Lancang)",
      "Pu'er (Lancang)",
      "Pu'er (Lancang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LNJ",
    "translations": [
      "Lincang Boshang Airport",
      "Lincang Boshang Airport",
      "Lincang Boshang Airport"
    ],
    "city": [
      "Lincang",
      "Lincang",
      "Lincang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LJG",
    "translations": [
      "Lijiang Sanyi International Airport",
      "Lijiang Sanyi International Airport",
      "Lijiang Sanyi International Airport"
    ],
    "city": [
      "Lijiang (Gucheng)",
      "Lijiang (Gucheng)",
      "Lijiang (Gucheng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LUM",
    "translations": [
      "Dehong Mangshi Airport",
      "Dehong Mangshi Airport",
      "Dehong Mangshi Airport"
    ],
    "city": [
      "Dehong (Mangshi)",
      "Dehong (Mangshi)",
      "Dehong (Mangshi)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "KMG",
    "translations": [
      "Kunming Changshui International Airport",
      "Kunming Changshui International Airport",
      "Kunming Changshui International Airport"
    ],
    "city": [
      "Kunming",
      "Kunming",
      "Kunming"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SYM",
    "translations": [
      "Pu'er Simao Airport",
      "Pu'er Simao Airport",
      "Pu'er Simao Airport"
    ],
    "city": [
      "Pu'er",
      "Pu'er",
      "Pu'er"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WNH",
    "translations": [
      "Wenshan Puzhehei Airport",
      "Wenshan Puzhehei Airport",
      "Wenshan Puzhehei Airport"
    ],
    "city": [
      "Wenshan",
      "Wenshan",
      "Wenshan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YUA",
    "translations": [
      "Yuanmou Air Base",
      "Yuanmou Air Base",
      "Yuanmou Air Base"
    ],
    "city": [
      "Chuxiong (Yuanmou)",
      "Chuxiong (Yuanmou)",
      "Chuxiong (Yuanmou)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ZAT",
    "translations": [
      "Zhaotong Airport",
      "Zhaotong Airport",
      "Zhaotong Airport"
    ],
    "city": [
      "Zhaotong (Zhaoyang)",
      "Zhaotong (Zhaoyang)",
      "Zhaotong (Zhaoyang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "XMN",
    "translations": [
      "Xiamen Gaoqi International Airport",
      "Xiamen Gaoqi International Airport",
      "Xiamen Gaoqi International Airport"
    ],
    "city": [
      "Xiamen",
      "Xiamen",
      "Xiamen"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "AQG",
    "translations": [
      "Anqing Tianzhushan Airport / Anqing North Air Base",
      "Anqing Tianzhushan Airport / Anqing North Air Base",
      "Anqing Tianzhushan Airport / Anqing North Air Base"
    ],
    "city": [
      "Anqing",
      "Anqing",
      "Anqing"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "BFU",
    "translations": [
      "Bengbu Tenghu Airport",
      "Bengbu Tenghu Airport",
      "Bengbu Tenghu Airport"
    ],
    "city": [
      "Bengbu",
      "Bengbu",
      "Bengbu"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CZX",
    "translations": [
      "Changzhou Benniu International Airport",
      "Changzhou Benniu International Airport",
      "Changzhou Benniu International Airport"
    ],
    "city": [
      "Changzhou",
      "Changzhou",
      "Changzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "KHN",
    "translations": [
      "Nanchang Changbei International Airport",
      "Nanchang Changbei International Airport",
      "Nanchang Changbei International Airport"
    ],
    "city": [
      "Nanchang",
      "Nanchang",
      "Nanchang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "AZJ",
    "translations": [
      "Zhenjiang Dalu Airport",
      "Zhenjiang Dalu Airport",
      "Zhenjiang Dalu Airport"
    ],
    "city": [
      "Zhenjiang",
      "Zhenjiang",
      "Zhenjiang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DOY",
    "translations": [
      "Dongying Shengli Airport",
      "Dongying Shengli Airport",
      "Dongying Shengli Airport"
    ],
    "city": [
      "Dongying (Kenli)",
      "Dongying (Kenli)",
      "Dongying (Kenli)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "FUG",
    "translations": [
      "Fuyang Xiguan Airport",
      "Fuyang Xiguan Airport",
      "Fuyang Xiguan Airport"
    ],
    "city": [
      "Yingzhou, Fuyang",
      "Yingzhou, Fuyang",
      "Yingzhou, Fuyang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "FOC",
    "translations": [
      "Fuzhou Changle International Airport",
      "Fuzhou Changle International Airport",
      "Fuzhou Changle International Airport"
    ],
    "city": [
      "Fuzhou (Changle)",
      "Fuzhou (Changle)",
      "Fuzhou (Changle)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "KOW",
    "translations": [
      "Ganzhou Huangjin Airport",
      "Ganzhou Huangjin Airport",
      "Ganzhou Huangjin Airport"
    ],
    "city": [
      "Ganzhou",
      "Ganzhou",
      "Ganzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HGH",
    "translations": [
      "Hangzhou Xiaoshan International Airport",
      "Hangzhou Xiaoshan International Airport",
      "Hangzhou Xiaoshan International Airport"
    ],
    "city": [
      "Hangzhou",
      "Hangzhou",
      "Hangzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HZA",
    "translations": [
      "Heze Mudan Airport",
      "Heze Mudan Airport",
      "Heze Mudan Airport"
    ],
    "city": [
      "Heze (Dingtao)",
      "Heze (Dingtao)",
      "Heze (Dingtao)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JDZ",
    "translations": [
      "Jingdezhen Luojia Airport",
      "Jingdezhen Luojia Airport",
      "Jingdezhen Luojia Airport"
    ],
    "city": [
      "Jingdezhen",
      "Jingdezhen",
      "Jingdezhen"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JNG",
    "translations": [
      "Jining Da'an Airport",
      "Jining Da'an Airport",
      "Jining Da'an Airport"
    ],
    "city": [
      "Jining",
      "Jining",
      "Jining"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JIU",
    "translations": [
      "Jiujiang Lushan Airport",
      "Jiujiang Lushan Airport",
      "Jiujiang Lushan Airport"
    ],
    "city": [
      "Jiujiang",
      "Jiujiang",
      "Jiujiang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TNA",
    "translations": [
      "Jinan Yaoqiang International Airport",
      "Jinan Yaoqiang International Airport",
      "Jinan Yaoqiang International Airport"
    ],
    "city": [
      "Jinan (Licheng)",
      "Jinan (Licheng)",
      "Jinan (Licheng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JUZ",
    "translations": [
      "Quzhou Airport",
      "Quzhou Airport",
      "Quzhou Airport"
    ],
    "city": [
      "Quzhou (Kezheng)",
      "Quzhou (Kezheng)",
      "Quzhou (Kezheng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LYG",
    "translations": [
      "Lianyungang Huaguoshan International Airport",
      "Lianyungang Huaguoshan International Airport",
      "Lianyungang Huaguoshan International Airport"
    ],
    "city": [
      "Lianyungang",
      "Lianyungang",
      "Lianyungang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LCX",
    "translations": [
      "Liancheng Guanzhishan Airport",
      "Liancheng Guanzhishan Airport",
      "Liancheng Guanzhishan Airport"
    ],
    "city": [
      "Longyan (Liancheng)",
      "Longyan (Liancheng)",
      "Longyan (Liancheng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HYN",
    "translations": [
      "Taizhou Luqiao Airport",
      "Taizhou Luqiao Airport",
      "Taizhou Luqiao Airport"
    ],
    "city": [
      "Taizhou (Luqiao)",
      "Taizhou (Luqiao)",
      "Taizhou (Luqiao)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LYI",
    "translations": [
      "Linyi Qiyang Airport",
      "Linyi Qiyang Airport",
      "Linyi Qiyang Airport"
    ],
    "city": [
      "Linyi (Hedong)",
      "Linyi (Hedong)",
      "Linyi (Hedong)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NGB",
    "translations": [
      "Ningbo Lishe International Airport",
      "Ningbo Lishe International Airport",
      "Ningbo Lishe International Airport"
    ],
    "city": [
      "Ningbo",
      "Ningbo",
      "Ningbo"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NKG",
    "translations": [
      "Nanjing Lukou International Airport",
      "Nanjing Lukou International Airport",
      "Nanjing Lukou International Airport"
    ],
    "city": [
      "Nanjing",
      "Nanjing",
      "Nanjing"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NTG",
    "translations": [
      "Nantong Xingdong International Airport",
      "Nantong Xingdong International Airport",
      "Nantong Xingdong International Airport"
    ],
    "city": [
      "Nantong (Tongzhou)",
      "Nantong (Tongzhou)",
      "Nantong (Tongzhou)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HFE",
    "translations": [
      "Hefei Xinqiao International Airport",
      "Hefei Xinqiao International Airport",
      "Hefei Xinqiao International Airport"
    ],
    "city": [
      "Hefei",
      "Hefei",
      "Hefei"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "PVG",
    "translations": [
      "Shanghai Pudong International Airport",
      "Shanghai Pudong International Airport",
      "Shanghai Pudong International Airport"
    ],
    "city": [
      "Shanghai (Pudong)",
      "Shanghai (Pudong)",
      "Shanghai (Pudong)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TAO",
    "translations": [
      "Qingdao Jiaodong International Airport",
      "Qingdao Jiaodong International Airport",
      "Qingdao Jiaodong International Airport"
    ],
    "city": [
      "Qingdao (Jiaozhou)",
      "Qingdao (Jiaozhou)",
      "Qingdao (Jiaozhou)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JJN",
    "translations": [
      "Quanzhou Jinjiang International Airport",
      "Quanzhou Jinjiang International Airport",
      "Quanzhou Jinjiang International Airport"
    ],
    "city": [
      "Quanzhou",
      "Quanzhou",
      "Quanzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "RUG",
    "translations": [
      "Rugao Air Base",
      "Rugao Air Base",
      "Rugao Air Base"
    ],
    "city": [
      "Rugao (Nantong)",
      "Rugao (Nantong)",
      "Rugao (Nantong)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "RIZ",
    "translations": [
      "Rizhao Shanzihe Airport",
      "Rizhao Shanzihe Airport",
      "Rizhao Shanzihe Airport"
    ],
    "city": [
      "Rizhao (Donggang)",
      "Rizhao (Donggang)",
      "Rizhao (Donggang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HIA",
    "translations": [
      "Huai'an Lianshui International Airport",
      "Huai'an Lianshui International Airport",
      "Huai'an Lianshui International Airport"
    ],
    "city": [
      "Huai'an",
      "Huai'an",
      "Huai'an"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SQJ",
    "translations": [
      "Sanming Shaxian Airport",
      "Sanming Shaxian Airport",
      "Sanming Shaxian Airport"
    ],
    "city": [
      "Sanming (Sha)",
      "Sanming (Sha)",
      "Sanming (Sha)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SQD",
    "translations": [
      "Shangrao Sanqingshan Airport",
      "Shangrao Sanqingshan Airport",
      "Shangrao Sanqingshan Airport"
    ],
    "city": [
      "Shangrao (Hengfeng)",
      "Shangrao (Hengfeng)",
      "Shangrao (Hengfeng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SHA",
    "translations": [
      "Shanghai Hongqiao International Airport",
      "Shanghai Hongqiao International Airport",
      "Shanghai Hongqiao International Airport"
    ],
    "city": [
      "Shanghai (Minhang)",
      "Shanghai (Minhang)",
      "Shanghai (Minhang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SZV",
    "translations": [
      "Suzhou Guangfu Airport",
      "Suzhou Guangfu Airport",
      "Suzhou Guangfu Airport"
    ],
    "city": [
      "Suzhou",
      "Suzhou",
      "Suzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TXN",
    "translations": [
      "Tunxi International Airport",
      "Tunxi International Airport",
      "Tunxi International Airport"
    ],
    "city": [
      "Huangshan",
      "Huangshan",
      "Huangshan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WHA",
    "translations": [
      "Wuhu Xuanzhou Airport",
      "Wuhu Xuanzhou Airport",
      "Wuhu Xuanzhou Airport"
    ],
    "city": [
      "Wuhu",
      "Wuhu",
      "Wuhu"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WEF",
    "translations": [
      "Weifang Nanyuan Airport",
      "Weifang Nanyuan Airport",
      "Weifang Nanyuan Airport"
    ],
    "city": [
      "Weifang (Kuiwen)",
      "Weifang (Kuiwen)",
      "Weifang (Kuiwen)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WEH",
    "translations": [
      "Weihai Dashuibo Airport",
      "Weihai Dashuibo Airport",
      "Weihai Dashuibo Airport"
    ],
    "city": [
      "Weihai",
      "Weihai",
      "Weihai"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WHU",
    "translations": [
      "Wuhu Wanli Airport / Wuhu Air Base",
      "Wuhu Wanli Airport / Wuhu Air Base",
      "Wuhu Wanli Airport / Wuhu Air Base"
    ],
    "city": [
      "Wuhu",
      "Wuhu",
      "Wuhu"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WUX",
    "translations": [
      "Sunan Shuofang International Airport",
      "Sunan Shuofang International Airport",
      "Sunan Shuofang International Airport"
    ],
    "city": [
      "Wuxi",
      "Wuxi",
      "Wuxi"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WUS",
    "translations": [
      "Nanping Wuyishan Airport",
      "Nanping Wuyishan Airport",
      "Nanping Wuyishan Airport"
    ],
    "city": [
      "Wuyishan",
      "Wuyishan",
      "Wuyishan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WNZ",
    "translations": [
      "Wenzhou Longwan International Airport",
      "Wenzhou Longwan International Airport",
      "Wenzhou Longwan International Airport"
    ],
    "city": [
      "Wenzhou (Longwan)",
      "Wenzhou (Longwan)",
      "Wenzhou (Longwan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "XUZ",
    "translations": [
      "Xuzhou Guanyin International Airport",
      "Xuzhou Guanyin International Airport",
      "Xuzhou Guanyin International Airport"
    ],
    "city": [
      "Xuzhou",
      "Xuzhou",
      "Xuzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YTY",
    "translations": [
      "Yangzhou Taizhou Airport",
      "Yangzhou Taizhou Airport",
      "Yangzhou Taizhou Airport"
    ],
    "city": [
      "Yangzhou",
      "Yangzhou",
      "Yangzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YIC",
    "translations": [
      "Yichun Mingyueshan Airport",
      "Yichun Mingyueshan Airport",
      "Yichun Mingyueshan Airport"
    ],
    "city": [
      "Yichun",
      "Yichun",
      "Yichun"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YNZ",
    "translations": [
      "Yancheng Nanyang International Airport",
      "Yancheng Nanyang International Airport",
      "Yancheng Nanyang International Airport"
    ],
    "city": [
      "Yancheng (Tinghu)",
      "Yancheng (Tinghu)",
      "Yancheng (Tinghu)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YNT",
    "translations": [
      "Yantai Penglai International Airport",
      "Yantai Penglai International Airport",
      "Yantai Penglai International Airport"
    ],
    "city": [
      "Yantai",
      "Yantai",
      "Yantai"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YIW",
    "translations": [
      "Yiwu Airport",
      "Yiwu Airport",
      "Yiwu Airport"
    ],
    "city": [
      "Jinhua (Yiwu)",
      "Jinhua (Yiwu)",
      "Jinhua (Yiwu)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HSN",
    "translations": [
      "Zhoushan Putuoshan Airport",
      "Zhoushan Putuoshan Airport",
      "Zhoushan Putuoshan Airport"
    ],
    "city": [
      "Zhoushan",
      "Zhoushan",
      "Zhoushan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NGQ",
    "translations": [
      "Ngari Gunsa Airport",
      "Ngari Gunsa Airport",
      "Ngari Gunsa Airport"
    ],
    "city": [
      "Shiquanhe",
      "Shiquanhe",
      "Shiquanhe"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "AVA",
    "translations": [
      "Anshun Huangguoshu Airport",
      "Anshun Huangguoshu Airport",
      "Anshun Huangguoshu Airport"
    ],
    "city": [
      "Anshun (Xixiu)",
      "Anshun (Xixiu)",
      "Anshun (Xixiu)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "BCJ",
    "translations": [
      "Beichuan Yongchang Airport",
      "Beichuan Yongchang Airport",
      "Beichuan Yongchang Airport"
    ],
    "city": [
      "Mianyang",
      "Mianyang",
      "Mianyang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "BPX",
    "translations": [
      "Qamdo Bangda Airport",
      "Qamdo Bangda Airport",
      "Qamdo Bangda Airport"
    ],
    "city": [
      "Bangda",
      "Bangda",
      "Bangda"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "BFJ",
    "translations": [
      "Bijie Feixiong Airport",
      "Bijie Feixiong Airport",
      "Bijie Feixiong Airport"
    ],
    "city": [
      "Bijie",
      "Bijie",
      "Bijie"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CKG",
    "translations": [
      "Chongqing Jiangbei International Airport",
      "Chongqing Jiangbei International Airport",
      "Chongqing Jiangbei International Airport"
    ],
    "city": [
      "Chongqing",
      "Chongqing",
      "Chongqing"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DZH",
    "translations": [
      "Dazhou Jinya Airport",
      "Dazhou Jinya Airport",
      "Dazhou Jinya Airport"
    ],
    "city": [
      "Dazhou (Dachuan)",
      "Dazhou (Dachuan)",
      "Dazhou (Dachuan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DCY",
    "translations": [
      "Daocheng Yading Airport",
      "Daocheng Yading Airport",
      "Daocheng Yading Airport"
    ],
    "city": [
      "Garzê (Daocheng)",
      "Garzê (Daocheng)",
      "Garzê (Daocheng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DAX",
    "translations": [
      "Dachuan Airport",
      "Dachuan Airport",
      "Dachuan Airport"
    ],
    "city": [
      "Dazhou (Daxian)",
      "Dazhou (Daxian)",
      "Dazhou (Daxian)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DZU",
    "translations": [
      "Dazu Air Base",
      "Dazu Air Base",
      "Dazu Air Base"
    ],
    "city": [
      "Dazu",
      "Dazu",
      "Dazu"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "GHN",
    "translations": [
      "Guanghan Airport",
      "Guanghan Airport",
      "Guanghan Airport"
    ],
    "city": [
      "Deyang (Guanghan)",
      "Deyang (Guanghan)",
      "Deyang (Guanghan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "GYS",
    "translations": [
      "Guangyuan Panlong Airport",
      "Guangyuan Panlong Airport",
      "Guangyuan Panlong Airport"
    ],
    "city": [
      "Guangyuan (Lizhou)",
      "Guangyuan (Lizhou)",
      "Guangyuan (Lizhou)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "KWE",
    "translations": [
      "Guiyang Longdongbao International Airport",
      "Guiyang Longdongbao International Airport",
      "Guiyang Longdongbao International Airport"
    ],
    "city": [
      "Guiyang (Nanming)",
      "Guiyang (Nanming)",
      "Guiyang (Nanming)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "GZG",
    "translations": [
      "Garze Gesar Airport",
      "Garze Gesar Airport",
      "Garze Gesar Airport"
    ],
    "city": [
      "Garzê (Garzê)",
      "Garzê (Garzê)",
      "Garzê (Garzê)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "AHJ",
    "translations": [
      "Hongyuan Airport",
      "Hongyuan Airport",
      "Hongyuan Airport"
    ],
    "city": [
      "Ngawa (Hongyuan)",
      "Ngawa (Hongyuan)",
      "Ngawa (Hongyuan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JZH",
    "translations": [
      "Jiuzhai Huanglong Airport",
      "Jiuzhai Huanglong Airport",
      "Jiuzhai Huanglong Airport"
    ],
    "city": [
      "Ngawa (Songpan)",
      "Ngawa (Songpan)",
      "Ngawa (Songpan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "KGT",
    "translations": [
      "Kangding Airport",
      "Kangding Airport",
      "Kangding Airport"
    ],
    "city": [
      "Garzê (Kangding)",
      "Garzê (Kangding)",
      "Garzê (Kangding)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "KJH",
    "translations": [
      "Kaili Huangping Airport",
      "Kaili Huangping Airport",
      "Kaili Huangping Airport"
    ],
    "city": [
      "Kaili  (Huangping)",
      "Kaili  (Huangping)",
      "Kaili  (Huangping)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LLB",
    "translations": [
      "Libo Airport",
      "Libo Airport",
      "Libo Airport"
    ],
    "city": [
      "Qiannan (Libo)",
      "Qiannan (Libo)",
      "Qiannan (Libo)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LIA",
    "translations": [
      "Liangping Airport",
      "Liangping Airport",
      "Liangping Airport"
    ],
    "city": [
      "Liangping",
      "Liangping",
      "Liangping"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LXA",
    "translations": [
      "Lhasa Gonggar Airport",
      "Lhasa Gonggar Airport",
      "Lhasa Gonggar Airport"
    ],
    "city": [
      "Shannan (Gonggar)",
      "Shannan (Gonggar)",
      "Shannan (Gonggar)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LZO",
    "translations": [
      "Luzhou Yunlong Airport",
      "Luzhou Yunlong Airport",
      "Luzhou Yunlong Airport"
    ],
    "city": [
      "Luzhou (Yunlong)",
      "Luzhou (Yunlong)",
      "Luzhou (Yunlong)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WMT",
    "translations": [
      "Zunyi Maotai Airport",
      "Zunyi Maotai Airport",
      "Zunyi Maotai Airport"
    ],
    "city": [
      "Zunyi",
      "Zunyi",
      "Zunyi"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "MIG",
    "translations": [
      "Mianyang Nanjiao Airport",
      "Mianyang Nanjiao Airport",
      "Mianyang Nanjiao Airport"
    ],
    "city": [
      "Mianyang (Fucheng)",
      "Mianyang (Fucheng)",
      "Mianyang (Fucheng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NAO",
    "translations": [
      "Nanchong Gaoping Airport",
      "Nanchong Gaoping Airport",
      "Nanchong Gaoping Airport"
    ],
    "city": [
      "Nanchong (Gaoping)",
      "Nanchong (Gaoping)",
      "Nanchong (Gaoping)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HZH",
    "translations": [
      "Liping Airport",
      "Liping Airport",
      "Liping Airport"
    ],
    "city": [
      "Liping",
      "Liping",
      "Liping"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LZY",
    "translations": [
      "Nyingchi Mainling Airport",
      "Nyingchi Mainling Airport",
      "Nyingchi Mainling Airport"
    ],
    "city": [
      "Nyingchi (Mainling)",
      "Nyingchi (Mainling)",
      "Nyingchi (Mainling)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LPF",
    "translations": [
      "Liupanshui Yuezhao Airport",
      "Liupanshui Yuezhao Airport",
      "Liupanshui Yuezhao Airport"
    ],
    "city": [
      "Liupanshui (Zhongshan)",
      "Liupanshui (Zhongshan)",
      "Liupanshui (Zhongshan)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JIQ",
    "translations": [
      "Qianjiang Wulingshan Airport",
      "Qianjiang Wulingshan Airport",
      "Qianjiang Wulingshan Airport"
    ],
    "city": [
      "Qianjiang",
      "Qianjiang",
      "Qianjiang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "RKZ",
    "translations": [
      "Xigaze Peace Airport / Shigatse Air Base",
      "Xigaze Peace Airport / Shigatse Air Base",
      "Xigaze Peace Airport / Shigatse Air Base"
    ],
    "city": [
      "Xigazê (Samzhubzê)",
      "Xigazê (Samzhubzê)",
      "Xigazê (Samzhubzê)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LGZ",
    "translations": [
      "Shannan Longzi Airport",
      "Shannan Longzi Airport",
      "Shannan Longzi Airport"
    ],
    "city": [
      "Shannan",
      "Shannan",
      "Shannan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TCZ",
    "translations": [
      "Tengchong Tuofeng Airport",
      "Tengchong Tuofeng Airport",
      "Tengchong Tuofeng Airport"
    ],
    "city": [
      "Baoshan (Tengchong)",
      "Baoshan (Tengchong)",
      "Baoshan (Tengchong)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TFU",
    "translations": [
      "Chengdu Tianfu International Airport",
      "Chengdu Tianfu International Airport",
      "Chengdu Tianfu International Airport"
    ],
    "city": [
      "Chengdu (Jianyang)",
      "Chengdu (Jianyang)",
      "Chengdu (Jianyang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TEN",
    "translations": [
      "Tongren Fenghuang Airport",
      "Tongren Fenghuang Airport",
      "Tongren Fenghuang Airport"
    ],
    "city": [
      "Tongren (Daxing)",
      "Tongren (Daxing)",
      "Tongren (Daxing)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CTU",
    "translations": [
      "Chengdu Shuangliu International Airport",
      "Chengdu Shuangliu International Airport",
      "Chengdu Shuangliu International Airport"
    ],
    "city": [
      "Chengdu (Shuangliu)",
      "Chengdu (Shuangliu)",
      "Chengdu (Shuangliu)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CQW",
    "translations": [
      "Chongqing Xiannüshan Airport",
      "Chongqing Xiannüshan Airport",
      "Chongqing Xiannüshan Airport"
    ],
    "city": [
      "Wulong",
      "Wulong",
      "Wulong"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WSK",
    "translations": [
      "Chongqing Wushan Airport",
      "Chongqing Wushan Airport",
      "Chongqing Wushan Airport"
    ],
    "city": [
      "Wushan",
      "Wushan",
      "Wushan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "WXN",
    "translations": [
      "Wanzhou Wuqiao Airport",
      "Wanzhou Wuqiao Airport",
      "Wanzhou Wuqiao Airport"
    ],
    "city": [
      "Wanzhou",
      "Wanzhou",
      "Wanzhou"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "XIC",
    "translations": [
      "Xichang Qingshan Airport",
      "Xichang Qingshan Airport",
      "Xichang Qingshan Airport"
    ],
    "city": [
      "Liangshan (Xichang)",
      "Liangshan (Xichang)",
      "Liangshan (Xichang)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YBP",
    "translations": [
      "Yibin Wuliangye Airport",
      "Yibin Wuliangye Airport",
      "Yibin Wuliangye Airport"
    ],
    "city": [
      "Yibin (Cuiping)",
      "Yibin (Cuiping)",
      "Yibin (Cuiping)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ACX",
    "translations": [
      "Xingyi Wanfenglin Airport",
      "Xingyi Wanfenglin Airport",
      "Xingyi Wanfenglin Airport"
    ],
    "city": [
      "Xingyi",
      "Xingyi",
      "Xingyi"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "PZI",
    "translations": [
      "Panzhihua Bao'anying Airport",
      "Panzhihua Bao'anying Airport",
      "Panzhihua Bao'anying Airport"
    ],
    "city": [
      "Panzhihua (Renhe)",
      "Panzhihua (Renhe)",
      "Panzhihua (Renhe)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ZYI",
    "translations": [
      "Zunyi Xinzhou Airport",
      "Zunyi Xinzhou Airport",
      "Zunyi Xinzhou Airport"
    ],
    "city": [
      "Zunyi",
      "Zunyi",
      "Zunyi"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "AKU",
    "translations": [
      "Aksu Hongqipo Airport",
      "Aksu Hongqipo Airport",
      "Aksu Hongqipo Airport"
    ],
    "city": [
      "Aksu (Onsu)",
      "Aksu (Onsu)",
      "Aksu (Onsu)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "ACF",
    "translations": [
      "Aral Tarim Airport",
      "Aral Tarim Airport",
      "Aral Tarim Airport"
    ],
    "city": [
      "Aral",
      "Aral",
      "Aral"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "AAT",
    "translations": [
      "Altay Xuedu Airport",
      "Altay Xuedu Airport",
      "Altay Xuedu Airport"
    ],
    "city": [
      "Altay",
      "Altay",
      "Altay"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "BPL",
    "translations": [
      "Bole Alashankou Airport",
      "Bole Alashankou Airport",
      "Bole Alashankou Airport"
    ],
    "city": [
      "Bole",
      "Bole",
      "Bole"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "IQM",
    "translations": [
      "Qiemo Yudu Airport",
      "Qiemo Yudu Airport",
      "Qiemo Yudu Airport"
    ],
    "city": [
      "Qiemo",
      "Qiemo",
      "Qiemo"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "FYN",
    "translations": [
      "Fuyun Koktokay Airport",
      "Fuyun Koktokay Airport",
      "Fuyun Koktokay Airport"
    ],
    "city": [
      "Fuyun",
      "Fuyun",
      "Fuyun"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HMI",
    "translations": [
      "Hami Airport",
      "Hami Airport",
      "Hami Airport"
    ],
    "city": [
      "Hami",
      "Hami",
      "Hami"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SHF",
    "translations": [
      "Shihezi Huayuan Airport",
      "Shihezi Huayuan Airport",
      "Shihezi Huayuan Airport"
    ],
    "city": [
      "Shihezi",
      "Shihezi",
      "Shihezi"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "KCA",
    "translations": [
      "Kuqa Qiuci Airport",
      "Kuqa Qiuci Airport",
      "Kuqa Qiuci Airport"
    ],
    "city": [
      "Kuqa",
      "Kuqa",
      "Kuqa"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "KRL",
    "translations": [
      "Korla Licheng Airport",
      "Korla Licheng Airport",
      "Korla Licheng Airport"
    ],
    "city": [
      "Korla",
      "Korla",
      "Korla"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "KRY",
    "translations": [
      "Karamay Airport",
      "Karamay Airport",
      "Karamay Airport"
    ],
    "city": [
      "Karamay",
      "Karamay",
      "Karamay"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "KJI",
    "translations": [
      "Burqin Kanas Airport",
      "Burqin Kanas Airport",
      "Burqin Kanas Airport"
    ],
    "city": [
      "Burqin",
      "Burqin",
      "Burqin"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NLT",
    "translations": [
      "Xinyuan Nalati Airport",
      "Xinyuan Nalati Airport",
      "Xinyuan Nalati Airport"
    ],
    "city": [
      "Xinyuan",
      "Xinyuan",
      "Xinyuan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "RQA",
    "translations": [
      "Ruoqiang Loulan Airport",
      "Ruoqiang Loulan Airport",
      "Ruoqiang Loulan Airport"
    ],
    "city": [
      "Ruoqiang Town",
      "Ruoqiang Town",
      "Ruoqiang Town"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "QSZ",
    "translations": [
      "Shache Airport",
      "Shache Airport",
      "Shache Airport"
    ],
    "city": [
      "Shache",
      "Shache",
      "Shache"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "KHG",
    "translations": [
      "Kashgar Laining International Airport",
      "Kashgar Laining International Airport",
      "Kashgar Laining International Airport"
    ],
    "city": [
      "Kashgar",
      "Kashgar",
      "Kashgar"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SXJ",
    "translations": [
      "Shanshan Airport",
      "Shanshan Airport",
      "Shanshan Airport"
    ],
    "city": [
      "Shanshan",
      "Shanshan",
      "Shanshan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TCG",
    "translations": [
      "Tacheng Qianquan Airport",
      "Tacheng Qianquan Airport",
      "Tacheng Qianquan Airport"
    ],
    "city": [
      "Tacheng",
      "Tacheng",
      "Tacheng"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TLQ",
    "translations": [
      "Turpan Jiaohe Airport",
      "Turpan Jiaohe Airport",
      "Turpan Jiaohe Airport"
    ],
    "city": [
      "Turpan",
      "Turpan",
      "Turpan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HTN",
    "translations": [
      "Hotan Airport",
      "Hotan Airport",
      "Hotan Airport"
    ],
    "city": [
      "Hotan",
      "Hotan",
      "Hotan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "URC",
    "translations": [
      "Ürümqi Tianshan International Airport",
      "Ürümqi Tianshan International Airport",
      "Ürümqi Tianshan International Airport"
    ],
    "city": [
      "Ürümqi",
      "Ürümqi",
      "Ürümqi"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YIN",
    "translations": [
      "Yining Airport",
      "Yining Airport",
      "Yining Airport"
    ],
    "city": [
      "Ili (Yining / Ghulja)",
      "Ili (Yining / Ghulja)",
      "Ili (Yining / Ghulja)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YTW",
    "translations": [
      "Yutian Wanfang Airport",
      "Yutian Wanfang Airport",
      "Yutian Wanfang Airport"
    ],
    "city": [
      "Hotan (Yutian)",
      "Hotan (Yutian)",
      "Hotan (Yutian)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "AOG",
    "translations": [
      "Anshan Teng'ao Airport / Anshan Air Base",
      "Anshan Teng'ao Airport / Anshan Air Base",
      "Anshan Teng'ao Airport / Anshan Air Base"
    ],
    "city": [
      "Anshan",
      "Anshan",
      "Anshan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DBC",
    "translations": [
      "Baicheng Chang'an Airport",
      "Baicheng Chang'an Airport",
      "Baicheng Chang'an Airport"
    ],
    "city": [
      "Baicheng",
      "Baicheng",
      "Baicheng"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NBS",
    "translations": [
      "Changbaishan Airport",
      "Changbaishan Airport",
      "Changbaishan Airport"
    ],
    "city": [
      "Baishan",
      "Baishan",
      "Baishan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CGQ",
    "translations": [
      "Changchun Longjia International Airport",
      "Changchun Longjia International Airport",
      "Changchun Longjia International Airport"
    ],
    "city": [
      "Changchun",
      "Changchun",
      "Changchun"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CNI",
    "translations": [
      "Changhai Airport",
      "Changhai Airport",
      "Changhai Airport"
    ],
    "city": [
      "Dalian (Changhai)",
      "Dalian (Changhai)",
      "Dalian (Changhai)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "CHG",
    "translations": [
      "Chaoyang Airport",
      "Chaoyang Airport",
      "Chaoyang Airport"
    ],
    "city": [
      "Shuangta, Chaoyang",
      "Shuangta, Chaoyang",
      "Shuangta, Chaoyang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DDG",
    "translations": [
      "Dandong Langtou Airport",
      "Dandong Langtou Airport",
      "Dandong Langtou Airport"
    ],
    "city": [
      "Dandong (Zhenxing)",
      "Dandong (Zhenxing)",
      "Dandong (Zhenxing)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DQA",
    "translations": [
      "Daqing Sartu Airport",
      "Daqing Sartu Airport",
      "Daqing Sartu Airport"
    ],
    "city": [
      "Daqing",
      "Daqing",
      "Daqing"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DTU",
    "translations": [
      "Wudalianchi Dedu Airport",
      "Wudalianchi Dedu Airport",
      "Wudalianchi Dedu Airport"
    ],
    "city": [
      "Heihe",
      "Heihe",
      "Heihe"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "FYJ",
    "translations": [
      "Fuyuan Dongji Airport",
      "Fuyuan Dongji Airport",
      "Fuyuan Dongji Airport"
    ],
    "city": [
      "Fuyuan",
      "Fuyuan",
      "Fuyuan"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HRB",
    "translations": [
      "Harbin Taiping International Airport",
      "Harbin Taiping International Airport",
      "Harbin Taiping International Airport"
    ],
    "city": [
      "Harbin",
      "Harbin",
      "Harbin"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HEK",
    "translations": [
      "Heihe Aihui Airport",
      "Heihe Aihui Airport",
      "Heihe Aihui Airport"
    ],
    "city": [
      "Heihe",
      "Heihe",
      "Heihe"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JGD",
    "translations": [
      "Daxing'anling Elunchun Airport",
      "Daxing'anling Elunchun Airport",
      "Daxing'anling Elunchun Airport"
    ],
    "city": [
      "Jiagedaqi",
      "Jiagedaqi",
      "Jiagedaqi"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JIL",
    "translations": [
      "Jilin Ertaizi Airport",
      "Jilin Ertaizi Airport",
      "Jilin Ertaizi Airport"
    ],
    "city": [
      "Jilin",
      "Jilin",
      "Jilin"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JMU",
    "translations": [
      "Jiamusi Dongjiao Airport",
      "Jiamusi Dongjiao Airport",
      "Jiamusi Dongjiao Airport"
    ],
    "city": [
      "Jiamusi",
      "Jiamusi",
      "Jiamusi"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JSJ",
    "translations": [
      "Jiansanjiang Shidi Airport",
      "Jiansanjiang Shidi Airport",
      "Jiansanjiang Shidi Airport"
    ],
    "city": [
      "Jiansanjiang",
      "Jiansanjiang",
      "Jiansanjiang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JXA",
    "translations": [
      "Jixi Xingkaihu Airport",
      "Jixi Xingkaihu Airport",
      "Jixi Xingkaihu Airport"
    ],
    "city": [
      "Jixi",
      "Jixi",
      "Jixi"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "JNZ",
    "translations": [
      "Jinzhou Bay Airport",
      "Jinzhou Bay Airport",
      "Jinzhou Bay Airport"
    ],
    "city": [
      "Jinzhou (Linghai)",
      "Jinzhou (Linghai)",
      "Jinzhou (Linghai)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "LDS",
    "translations": [
      "Yichun Lindu Airport",
      "Yichun Lindu Airport",
      "Yichun Lindu Airport"
    ],
    "city": [
      "Yichun",
      "Yichun",
      "Yichun"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "MDG",
    "translations": [
      "Mudanjiang Hailang International Airport",
      "Mudanjiang Hailang International Airport",
      "Mudanjiang Hailang International Airport"
    ],
    "city": [
      "Mudanjiang",
      "Mudanjiang",
      "Mudanjiang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "OHE",
    "translations": [
      "Mohe Gulian Airport",
      "Mohe Gulian Airport",
      "Mohe Gulian Airport"
    ],
    "city": [
      "Mohe",
      "Mohe",
      "Mohe"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "NDG",
    "translations": [
      "Qiqihar Sanjiazi Airport",
      "Qiqihar Sanjiazi Airport",
      "Qiqihar Sanjiazi Airport"
    ],
    "city": [
      "Qiqihar",
      "Qiqihar",
      "Qiqihar"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "HSF",
    "translations": [
      "Suifenhe Dongning Airport",
      "Suifenhe Dongning Airport",
      "Suifenhe Dongning Airport"
    ],
    "city": [
      "Suifenhe",
      "Suifenhe",
      "Suifenhe"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YSQ",
    "translations": [
      "Songyuan Chaganhu Airport",
      "Songyuan Chaganhu Airport",
      "Songyuan Chaganhu Airport"
    ],
    "city": [
      "Qian Gorlos Mongol Autonomous County",
      "Qian Gorlos Mongol Autonomous County",
      "Qian Gorlos Mongol Autonomous County"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "DLC",
    "translations": [
      "Dalian Zhoushuizi International Airport",
      "Dalian Zhoushuizi International Airport",
      "Dalian Zhoushuizi International Airport"
    ],
    "city": [
      "Dalian (Ganjingzi)",
      "Dalian (Ganjingzi)",
      "Dalian (Ganjingzi)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "TNH",
    "translations": [
      "Tonghua Sanyuanpu Airport",
      "Tonghua Sanyuanpu Airport",
      "Tonghua Sanyuanpu Airport"
    ],
    "city": [
      "Tonghua",
      "Tonghua",
      "Tonghua"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "SHE",
    "translations": [
      "Shenyang Taoxian International Airport",
      "Shenyang Taoxian International Airport",
      "Shenyang Taoxian International Airport"
    ],
    "city": [
      "Hunnan, Shenyang",
      "Hunnan, Shenyang",
      "Hunnan, Shenyang"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "XEN",
    "translations": [
      "Xingcheng Air Base",
      "Xingcheng Air Base",
      "Xingcheng Air Base"
    ],
    "city": [
      "Huludao (Xingcheng)",
      "Huludao (Xingcheng)",
      "Huludao (Xingcheng)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YNJ",
    "translations": [
      "Yanji Chaoyangchuan Airport",
      "Yanji Chaoyangchuan Airport",
      "Yanji Chaoyangchuan Airport"
    ],
    "city": [
      "Yanji",
      "Yanji",
      "Yanji"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  },
  {
    "iata": "YKH",
    "translations": [
      "Yingkou Lanqi Airport",
      "Yingkou Lanqi Airport",
      "Yingkou Lanqi Airport"
    ],
    "city": [
      "Yingkou (Laobian)",
      "Yingkou (Laobian)",
      "Yingkou (Laobian)"
    ],
    "country": [
      "CN",
      "CN",
      "CN"
    ]
  }
];
